(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec3ee"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec3ee"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iFI1t", function(module, exports) {
'use strict';

var $deOGU = parcelRequire("deOGU");

var $eNRkB = parcelRequire("eNRkB");

var $goSny = parcelRequire("goSny");

var $ki4AF = parcelRequire("ki4AF");
parcelRequire("gvdkG");
var $d97e3454a3aa6d51$var$ArrayPrototype = Array.prototype;
var $d97e3454a3aa6d51$var$DOMIterables = {
    DOMTokenList: true,
    NodeList: true
};
module.exports = function(it) {
    var own = it.forEach;
    return it === $d97e3454a3aa6d51$var$ArrayPrototype || $goSny($d97e3454a3aa6d51$var$ArrayPrototype, it) && own === $d97e3454a3aa6d51$var$ArrayPrototype.forEach || $eNRkB($d97e3454a3aa6d51$var$DOMIterables, $deOGU(it)) ? $ki4AF : own;
};

});
parcelRegister("deOGU", function(module, exports) {
'use strict';

var $1ganw = parcelRequire("1ganw");

var $dhqq1 = parcelRequire("dhqq1");

var $8GC9A = parcelRequire("8GC9A");

var $jMgf3 = parcelRequire("jMgf3");
var $9a33e75811ae3f53$var$TO_STRING_TAG = $jMgf3('toStringTag');
var $9a33e75811ae3f53$var$$Object = Object;
// ES3 wrong here
var $9a33e75811ae3f53$var$CORRECT_ARGUMENTS = $8GC9A(function() {
    return arguments;
}()) === 'Arguments';
// fallback for IE11 Script Access Denied error
var $9a33e75811ae3f53$var$tryGet = function tryGet(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
module.exports = $1ganw ? $8GC9A : function(it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = $9a33e75811ae3f53$var$tryGet(O = $9a33e75811ae3f53$var$$Object(it), $9a33e75811ae3f53$var$TO_STRING_TAG)) == 'string' ? tag : $9a33e75811ae3f53$var$CORRECT_ARGUMENTS ? $8GC9A(O) : (result = $8GC9A(O)) === 'Object' && $dhqq1(O.callee) ? 'Arguments' : result;
};

});
parcelRegister("1ganw", function(module, exports) {
'use strict';

var $jMgf3 = parcelRequire("jMgf3");
var $0eaf560545712b92$var$TO_STRING_TAG = $jMgf3('toStringTag');
var $0eaf560545712b92$var$test = {};
$0eaf560545712b92$var$test[$0eaf560545712b92$var$TO_STRING_TAG] = 'z';
module.exports = String($0eaf560545712b92$var$test) === '[object z]';

});
parcelRegister("jMgf3", function(module, exports) {
'use strict';

var $7bT0n = parcelRequire("7bT0n");

var $enPFE = parcelRequire("enPFE");

var $eNRkB = parcelRequire("eNRkB");

var $1mpAQ = parcelRequire("1mpAQ");

var $aKZdM = parcelRequire("aKZdM");

var $ane2c = parcelRequire("ane2c");
var $e65f1947e29ebd8e$var$Symbol = $7bT0n.Symbol;
var $e65f1947e29ebd8e$var$WellKnownSymbolsStore = $enPFE('wks');
var $e65f1947e29ebd8e$var$createWellKnownSymbol = $ane2c ? $e65f1947e29ebd8e$var$Symbol['for'] || $e65f1947e29ebd8e$var$Symbol : $e65f1947e29ebd8e$var$Symbol && $e65f1947e29ebd8e$var$Symbol.withoutSetter || $1mpAQ;
module.exports = function(name) {
    if (!$eNRkB($e65f1947e29ebd8e$var$WellKnownSymbolsStore, name)) $e65f1947e29ebd8e$var$WellKnownSymbolsStore[name] = $aKZdM && $eNRkB($e65f1947e29ebd8e$var$Symbol, name) ? $e65f1947e29ebd8e$var$Symbol[name] : $e65f1947e29ebd8e$var$createWellKnownSymbol('Symbol.' + name);
    return $e65f1947e29ebd8e$var$WellKnownSymbolsStore[name];
};

});
parcelRegister("7bT0n", function(module, exports) {

var $2bfPH = parcelRequire("2bfPH");
'use strict';
var $53c43a5872ff5de8$var$check = function check(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports = // eslint-disable-next-line es/no-global-this -- safe
$53c43a5872ff5de8$var$check((typeof globalThis === "undefined" ? "undefined" : (0, $2bfPH._)(globalThis)) == 'object' && globalThis) || $53c43a5872ff5de8$var$check((typeof window === "undefined" ? "undefined" : (0, $2bfPH._)(window)) == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
$53c43a5872ff5de8$var$check((typeof self === "undefined" ? "undefined" : (0, $2bfPH._)(self)) == 'object' && self) || $53c43a5872ff5de8$var$check((typeof $parcel$global === "undefined" ? "undefined" : (0, $2bfPH._)($parcel$global)) == 'object' && $parcel$global) || $53c43a5872ff5de8$var$check((0, $2bfPH._)(undefined) == 'object' && undefined) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function('return this')();

});
parcelRegister("2bfPH", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1968e3edfc5cfc11$export$71511d61b312f219; });
function $1968e3edfc5cfc11$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});


parcelRegister("enPFE", function(module, exports) {
'use strict';

var $10Mpp = parcelRequire("10Mpp");
module.exports = function(key, value) {
    return $10Mpp[key] || ($10Mpp[key] = value || {});
};

});
parcelRegister("10Mpp", function(module, exports) {
'use strict';

var $fhkpi = parcelRequire("fhkpi");

var $7bT0n = parcelRequire("7bT0n");

var $eW2Cy = parcelRequire("eW2Cy");
var $0bcb5787b5710e64$var$SHARED = '__core-js_shared__';
var $0bcb5787b5710e64$var$store = module.exports = $7bT0n[$0bcb5787b5710e64$var$SHARED] || $eW2Cy($0bcb5787b5710e64$var$SHARED, {});
($0bcb5787b5710e64$var$store.versions || ($0bcb5787b5710e64$var$store.versions = [])).push({
    version: '3.46.0',
    mode: $fhkpi ? 'pure' : 'global',
    copyright: "\xa9 2014-2025 Denis Pushkarev (zloirock.ru), 2025 CoreJS Company (core-js.io)",
    license: 'https://github.com/zloirock/core-js/blob/v3.46.0/LICENSE',
    source: 'https://github.com/zloirock/core-js'
});

});
parcelRegister("fhkpi", function(module, exports) {
'use strict';
module.exports = true;

});

parcelRegister("eW2Cy", function(module, exports) {
'use strict';

var $7bT0n = parcelRequire("7bT0n");
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $adf883ee121fd157$var$defineProperty = Object.defineProperty;
module.exports = function(key, value) {
    try {
        $adf883ee121fd157$var$defineProperty($7bT0n, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $7bT0n[key] = value;
    }
    return value;
};

});



parcelRegister("eNRkB", function(module, exports) {
'use strict';

var $a7J4S = parcelRequire("a7J4S");

var $2zGhC = parcelRequire("2zGhC");
var $ac6f02c376cdc92e$var$hasOwnProperty = $a7J4S({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
    return $ac6f02c376cdc92e$var$hasOwnProperty($2zGhC(it), key);
};

});
parcelRegister("a7J4S", function(module, exports) {
'use strict';

var $aajsy = parcelRequire("aajsy");
var $75ed864abae0ae41$var$FunctionPrototype = Function.prototype;
var $75ed864abae0ae41$var$call = $75ed864abae0ae41$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var $75ed864abae0ae41$var$uncurryThisWithBind = $aajsy && $75ed864abae0ae41$var$FunctionPrototype.bind.bind($75ed864abae0ae41$var$call, $75ed864abae0ae41$var$call);
module.exports = $aajsy ? $75ed864abae0ae41$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $75ed864abae0ae41$var$call.apply(fn, arguments);
    };
};

});
parcelRegister("aajsy", function(module, exports) {
'use strict';

var $lLFjY = parcelRequire("lLFjY");
module.exports = !$lLFjY(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != 'function' || test.hasOwnProperty('prototype');
});

});
parcelRegister("lLFjY", function(module, exports) {
'use strict';
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};

});



parcelRegister("2zGhC", function(module, exports) {
'use strict';

var $fgGOS = parcelRequire("fgGOS");
var $1dffa63910d2e6e9$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function(argument) {
    return $1dffa63910d2e6e9$var$$Object($fgGOS(argument));
};

});
parcelRegister("fgGOS", function(module, exports) {
'use strict';

var $aYBgg = parcelRequire("aYBgg");
var $b1d990b74a9052c9$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function(it) {
    if ($aYBgg(it)) throw new $b1d990b74a9052c9$var$$TypeError("Can't call method on " + it);
    return it;
};

});
parcelRegister("aYBgg", function(module, exports) {
'use strict';
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function(it) {
    return it === null || it === undefined;
};

});




parcelRegister("1mpAQ", function(module, exports) {
'use strict';

var $a7J4S = parcelRequire("a7J4S");
var $0fdbb2d273075861$var$id = 0;
var $0fdbb2d273075861$var$postfix = Math.random();
var $0fdbb2d273075861$var$toString = $a7J4S(1.1.toString);
module.exports = function(key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + $0fdbb2d273075861$var$toString(++$0fdbb2d273075861$var$id + $0fdbb2d273075861$var$postfix, 36);
};

});

parcelRegister("aKZdM", function(module, exports) {
'use strict';

var $hymGt = parcelRequire("hymGt");

var $lLFjY = parcelRequire("lLFjY");

var $7bT0n = parcelRequire("7bT0n");
var $7d4db08563d40321$var$$String = $7bT0n.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !$lLFjY(function() {
    var symbol = Symbol('symbol detection');
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$7d4db08563d40321$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $hymGt && $hymGt < 41;
});

});
parcelRegister("hymGt", function(module, exports) {
'use strict';

var $7bT0n = parcelRequire("7bT0n");

var $7y4D2 = parcelRequire("7y4D2");
var $cc77353791c23b77$var$process = $7bT0n.process;
var $cc77353791c23b77$var$Deno = $7bT0n.Deno;
var $cc77353791c23b77$var$versions = $cc77353791c23b77$var$process && $cc77353791c23b77$var$process.versions || $cc77353791c23b77$var$Deno && $cc77353791c23b77$var$Deno.version;
var $cc77353791c23b77$var$v8 = $cc77353791c23b77$var$versions && $cc77353791c23b77$var$versions.v8;
var $cc77353791c23b77$var$match, $cc77353791c23b77$var$version;
if ($cc77353791c23b77$var$v8) {
    $cc77353791c23b77$var$match = $cc77353791c23b77$var$v8.split('.');
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $cc77353791c23b77$var$version = $cc77353791c23b77$var$match[0] > 0 && $cc77353791c23b77$var$match[0] < 4 ? 1 : +($cc77353791c23b77$var$match[0] + $cc77353791c23b77$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$cc77353791c23b77$var$version && $7y4D2) {
    $cc77353791c23b77$var$match = $7y4D2.match(/Edge\/(\d+)/);
    if (!$cc77353791c23b77$var$match || $cc77353791c23b77$var$match[1] >= 74) {
        $cc77353791c23b77$var$match = $7y4D2.match(/Chrome\/(\d+)/);
        if ($cc77353791c23b77$var$match) $cc77353791c23b77$var$version = +$cc77353791c23b77$var$match[1];
    }
}
module.exports = $cc77353791c23b77$var$version;

});
parcelRegister("7y4D2", function(module, exports) {
'use strict';

var $7bT0n = parcelRequire("7bT0n");
var $57ef4c86a816ff44$var$navigator = $7bT0n.navigator;
var $57ef4c86a816ff44$var$userAgent = $57ef4c86a816ff44$var$navigator && $57ef4c86a816ff44$var$navigator.userAgent;
module.exports = $57ef4c86a816ff44$var$userAgent ? String($57ef4c86a816ff44$var$userAgent) : '';

});



parcelRegister("ane2c", function(module, exports) {

var $2bfPH = parcelRequire("2bfPH");
'use strict';

var $aKZdM = parcelRequire("aKZdM");
module.exports = $aKZdM && !Symbol.sham && (0, $2bfPH._)(Symbol.iterator) == 'symbol';

});



parcelRegister("dhqq1", function(module, exports) {

var $2bfPH = parcelRequire("2bfPH");
'use strict';
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $9ab15b190c5d9a71$var$documentAll = (typeof document === "undefined" ? "undefined" : (0, $2bfPH._)(document)) == 'object' && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
module.exports = typeof $9ab15b190c5d9a71$var$documentAll == 'undefined' && $9ab15b190c5d9a71$var$documentAll !== undefined ? function(argument) {
    return typeof argument == 'function' || argument === $9ab15b190c5d9a71$var$documentAll;
} : function(argument) {
    return typeof argument == 'function';
};

});

parcelRegister("8GC9A", function(module, exports) {
'use strict';

var $a7J4S = parcelRequire("a7J4S");
var $652fd77827e17417$var$toString = $a7J4S({}.toString);
var $652fd77827e17417$var$stringSlice = $a7J4S(''.slice);
module.exports = function(it) {
    return $652fd77827e17417$var$stringSlice($652fd77827e17417$var$toString(it), 8, -1);
};

});


parcelRegister("goSny", function(module, exports) {
'use strict';

var $a7J4S = parcelRequire("a7J4S");
module.exports = $a7J4S({}.isPrototypeOf);

});

parcelRegister("ki4AF", function(module, exports) {
'use strict';

var $9dwlD = parcelRequire("9dwlD");
module.exports = $9dwlD;

});
parcelRegister("9dwlD", function(module, exports) {
'use strict';
parcelRequire("48Kzp");

var $gdkJ6 = parcelRequire("gdkJ6");
module.exports = $gdkJ6('Array', 'forEach');

});
parcelRegister("48Kzp", function(module, exports) {
'use strict';

var $4lEVJ = parcelRequire("4lEVJ");

var $eSPB9 = parcelRequire("eSPB9");
// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
$4lEVJ({
    target: 'Array',
    proto: true,
    forced: [].forEach !== $eSPB9
}, {
    forEach: $eSPB9
});

});
parcelRegister("4lEVJ", function(module, exports) {

var $2bfPH = parcelRequire("2bfPH");
'use strict';

var $7bT0n = parcelRequire("7bT0n");

var $e09lc = parcelRequire("e09lc");

var $cwspJ = parcelRequire("cwspJ");

var $dhqq1 = parcelRequire("dhqq1");

var $6cFF8 = parcelRequire("6cFF8");
var $32a8df7d5c2bfc57$require$getOwnPropertyDescriptor = $6cFF8.f;

var $gDx8T = parcelRequire("gDx8T");

var $aYgYj = parcelRequire("aYgYj");

var $bRGXy = parcelRequire("bRGXy");

var $eJtbB = parcelRequire("eJtbB");

var $eNRkB = parcelRequire("eNRkB");

var $32a8df7d5c2bfc57$var$wrapConstructor = function wrapConstructor(NativeConstructor) {
    var Wrapper = function Wrapper1(a, b, c) {
        if (this instanceof Wrapper) {
            switch(arguments.length){
                case 0:
                    return new NativeConstructor();
                case 1:
                    return new NativeConstructor(a);
                case 2:
                    return new NativeConstructor(a, b);
            }
            return new NativeConstructor(a, b, c);
        }
        return $e09lc(NativeConstructor, this, arguments);
    };
    Wrapper.prototype = NativeConstructor.prototype;
    return Wrapper;
};
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ module.exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var PROTO = options.proto;
    var nativeSource = GLOBAL ? $7bT0n : STATIC ? $7bT0n[TARGET] : $7bT0n[TARGET] && $7bT0n[TARGET].prototype;
    var target = GLOBAL ? $aYgYj : $aYgYj[TARGET] || $eJtbB($aYgYj, TARGET, {})[TARGET];
    var targetPrototype = target.prototype;
    var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
    var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;
    for(key in source){
        FORCED = $gDx8T(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contains in native
        USE_NATIVE = !FORCED && nativeSource && $eNRkB(nativeSource, key);
        targetProperty = target[key];
        if (USE_NATIVE) {
            if (options.dontCallGetSet) {
                descriptor = $32a8df7d5c2bfc57$require$getOwnPropertyDescriptor(nativeSource, key);
                nativeProperty = descriptor && descriptor.value;
            } else nativeProperty = nativeSource[key];
        }
        // export native or implementation
        sourceProperty = USE_NATIVE && nativeProperty ? nativeProperty : source[key];
        if (!FORCED && !PROTO && (typeof targetProperty === "undefined" ? "undefined" : (0, $2bfPH._)(targetProperty)) == (typeof sourceProperty === "undefined" ? "undefined" : (0, $2bfPH._)(sourceProperty))) continue;
        // bind methods to global for calling from export context
        if (options.bind && USE_NATIVE) resultProperty = $bRGXy(sourceProperty, $7bT0n);
        else if (options.wrap && USE_NATIVE) resultProperty = $32a8df7d5c2bfc57$var$wrapConstructor(sourceProperty);
        else if (PROTO && $dhqq1(sourceProperty)) resultProperty = $cwspJ(sourceProperty);
        else resultProperty = sourceProperty;
        // add a flag to not completely full polyfills
        if (options.sham || sourceProperty && sourceProperty.sham || targetProperty && targetProperty.sham) $eJtbB(resultProperty, 'sham', true);
        $eJtbB(target, key, resultProperty);
        if (PROTO) {
            VIRTUAL_PROTOTYPE = TARGET + 'Prototype';
            if (!$eNRkB($aYgYj, VIRTUAL_PROTOTYPE)) $eJtbB($aYgYj, VIRTUAL_PROTOTYPE, {});
            // export virtual prototype methods
            $eJtbB($aYgYj[VIRTUAL_PROTOTYPE], key, sourceProperty);
            // export real prototype methods
            if (options.real && targetPrototype && (FORCED || !targetPrototype[key])) $eJtbB(targetPrototype, key, sourceProperty);
        }
    }
};

});
parcelRegister("e09lc", function(module, exports) {

var $2bfPH = parcelRequire("2bfPH");
'use strict';

var $aajsy = parcelRequire("aajsy");
var $a3184fac6c19b340$var$FunctionPrototype = Function.prototype;
var $a3184fac6c19b340$var$apply = $a3184fac6c19b340$var$FunctionPrototype.apply;
var $a3184fac6c19b340$var$call = $a3184fac6c19b340$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
module.exports = (typeof Reflect === "undefined" ? "undefined" : (0, $2bfPH._)(Reflect)) == 'object' && Reflect.apply || ($aajsy ? $a3184fac6c19b340$var$call.bind($a3184fac6c19b340$var$apply) : function() {
    return $a3184fac6c19b340$var$call.apply($a3184fac6c19b340$var$apply, arguments);
});

});

parcelRegister("cwspJ", function(module, exports) {
'use strict';

var $8GC9A = parcelRequire("8GC9A");

var $a7J4S = parcelRequire("a7J4S");
module.exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($8GC9A(fn) === 'Function') return $a7J4S(fn);
};

});

parcelRegister("6cFF8", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $48442e5cb6ed71f8$export$2d1720544b23b823; }, function (v) { return $48442e5cb6ed71f8$export$2d1720544b23b823 = v; });
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $48442e5cb6ed71f8$export$2d1720544b23b823;
'use strict';

var $gd9M7 = parcelRequire("gd9M7");

var $jNLWX = parcelRequire("jNLWX");

var $8Ek3m = parcelRequire("8Ek3m");

var $hPKB8 = parcelRequire("hPKB8");

var $813PX = parcelRequire("813PX");

var $5hmHe = parcelRequire("5hmHe");

var $eNRkB = parcelRequire("eNRkB");

var $6aYbp = parcelRequire("6aYbp");
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $48442e5cb6ed71f8$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$48442e5cb6ed71f8$export$2d1720544b23b823 = $gd9M7 ? $48442e5cb6ed71f8$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $813PX(O);
    P = $5hmHe(P);
    if ($6aYbp) try {
        return $48442e5cb6ed71f8$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($eNRkB(O, P)) return $hPKB8(!$jNLWX($8Ek3m.f, O, P), O[P]);
};

});
parcelRegister("gd9M7", function(module, exports) {
'use strict';

var $lLFjY = parcelRequire("lLFjY");
// Detect IE8's incomplete defineProperty implementation
module.exports = !$lLFjY(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function get() {
            return 7;
        }
    })[1] !== 7;
});

});

parcelRegister("jNLWX", function(module, exports) {
'use strict';

var $aajsy = parcelRequire("aajsy");
var $e6a7c9cada346b66$var$call = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
module.exports = $aajsy ? $e6a7c9cada346b66$var$call.bind($e6a7c9cada346b66$var$call) : function() {
    return $e6a7c9cada346b66$var$call.apply($e6a7c9cada346b66$var$call, arguments);
};

});

parcelRegister("8Ek3m", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $64c19d5091fccd53$export$2d1720544b23b823; }, function (v) { return $64c19d5091fccd53$export$2d1720544b23b823 = v; });
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $64c19d5091fccd53$export$2d1720544b23b823;
'use strict';
var $64c19d5091fccd53$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $64c19d5091fccd53$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $64c19d5091fccd53$var$NASHORN_BUG = $64c19d5091fccd53$var$getOwnPropertyDescriptor && !$64c19d5091fccd53$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$64c19d5091fccd53$export$2d1720544b23b823 = $64c19d5091fccd53$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $64c19d5091fccd53$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $64c19d5091fccd53$var$$propertyIsEnumerable;

});

parcelRegister("hPKB8", function(module, exports) {
'use strict';
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});

parcelRegister("813PX", function(module, exports) {
'use strict';

var $9gkn9 = parcelRequire("9gkn9");

var $fgGOS = parcelRequire("fgGOS");
module.exports = function(it) {
    return $9gkn9($fgGOS(it));
};

});
parcelRegister("9gkn9", function(module, exports) {
'use strict';

var $a7J4S = parcelRequire("a7J4S");

var $lLFjY = parcelRequire("lLFjY");

var $8GC9A = parcelRequire("8GC9A");
var $6be5693c0b1c185d$var$$Object = Object;
var $6be5693c0b1c185d$var$split = $a7J4S(''.split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = $lLFjY(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$6be5693c0b1c185d$var$$Object('z').propertyIsEnumerable(0);
}) ? function(it) {
    return $8GC9A(it) === 'String' ? $6be5693c0b1c185d$var$split(it, '') : $6be5693c0b1c185d$var$$Object(it);
} : $6be5693c0b1c185d$var$$Object;

});


parcelRegister("5hmHe", function(module, exports) {
'use strict';

var $dkuSX = parcelRequire("dkuSX");

var $dhvej = parcelRequire("dhvej");
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function(argument) {
    var key = $dkuSX(argument, 'string');
    return $dhvej(key) ? key : key + '';
};

});
parcelRegister("dkuSX", function(module, exports) {
'use strict';

var $jNLWX = parcelRequire("jNLWX");

var $b89GE = parcelRequire("b89GE");

var $dhvej = parcelRequire("dhvej");

var $idEjk = parcelRequire("idEjk");

var $dOGK1 = parcelRequire("dOGK1");

var $jMgf3 = parcelRequire("jMgf3");
var $9b4519cb7b52847e$var$$TypeError = TypeError;
var $9b4519cb7b52847e$var$TO_PRIMITIVE = $jMgf3('toPrimitive');
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function(input, pref) {
    if (!$b89GE(input) || $dhvej(input)) return input;
    var exoticToPrim = $idEjk(input, $9b4519cb7b52847e$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = $jNLWX(exoticToPrim, input, pref);
        if (!$b89GE(result) || $dhvej(result)) return result;
        throw new $9b4519cb7b52847e$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = 'number';
    return $dOGK1(input, pref);
};

});
parcelRegister("b89GE", function(module, exports) {

var $2bfPH = parcelRequire("2bfPH");
'use strict';

var $dhqq1 = parcelRequire("dhqq1");
module.exports = function(it) {
    return (typeof it === "undefined" ? "undefined" : (0, $2bfPH._)(it)) == 'object' ? it !== null : $dhqq1(it);
};

});

parcelRegister("dhvej", function(module, exports) {

var $2bfPH = parcelRequire("2bfPH");
'use strict';

var $f9yE9 = parcelRequire("f9yE9");

var $dhqq1 = parcelRequire("dhqq1");

var $goSny = parcelRequire("goSny");

var $ane2c = parcelRequire("ane2c");
var $9ab5168127e3358c$var$$Object = Object;
module.exports = $ane2c ? function(it) {
    return (typeof it === "undefined" ? "undefined" : (0, $2bfPH._)(it)) == 'symbol';
} : function(it) {
    var $Symbol = $f9yE9('Symbol');
    return $dhqq1($Symbol) && $goSny($Symbol.prototype, $9ab5168127e3358c$var$$Object(it));
};

});
parcelRegister("f9yE9", function(module, exports) {
'use strict';

var $aYgYj = parcelRequire("aYgYj");

var $7bT0n = parcelRequire("7bT0n");

var $dhqq1 = parcelRequire("dhqq1");
var $b082925dd33b7438$var$aFunction = function aFunction(variable) {
    return $dhqq1(variable) ? variable : undefined;
};
module.exports = function(namespace, method) {
    return arguments.length < 2 ? $b082925dd33b7438$var$aFunction($aYgYj[namespace]) || $b082925dd33b7438$var$aFunction($7bT0n[namespace]) : $aYgYj[namespace] && $aYgYj[namespace][method] || $7bT0n[namespace] && $7bT0n[namespace][method];
};

});
parcelRegister("aYgYj", function(module, exports) {
'use strict';
module.exports = {};

});



parcelRegister("idEjk", function(module, exports) {
'use strict';

var $6nUOM = parcelRequire("6nUOM");

var $aYBgg = parcelRequire("aYBgg");
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function(V, P) {
    var func = V[P];
    return $aYBgg(func) ? undefined : $6nUOM(func);
};

});
parcelRegister("6nUOM", function(module, exports) {
'use strict';

var $dhqq1 = parcelRequire("dhqq1");

var $awEhk = parcelRequire("awEhk");
var $4a60f6f556d26d1a$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
module.exports = function(argument) {
    if ($dhqq1(argument)) return argument;
    throw new $4a60f6f556d26d1a$var$$TypeError($awEhk(argument) + ' is not a function');
};

});
parcelRegister("awEhk", function(module, exports) {
'use strict';
var $7a9c2309241dafe5$var$$String = String;
module.exports = function(argument) {
    try {
        return $7a9c2309241dafe5$var$$String(argument);
    } catch (error) {
        return 'Object';
    }
};

});



parcelRegister("dOGK1", function(module, exports) {
'use strict';

var $jNLWX = parcelRequire("jNLWX");

var $dhqq1 = parcelRequire("dhqq1");

var $b89GE = parcelRequire("b89GE");
var $a0f119671308e694$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function(input, pref) {
    var fn, val;
    if (pref === 'string' && $dhqq1(fn = input.toString) && !$b89GE(val = $jNLWX(fn, input))) return val;
    if ($dhqq1(fn = input.valueOf) && !$b89GE(val = $jNLWX(fn, input))) return val;
    if (pref !== 'string' && $dhqq1(fn = input.toString) && !$b89GE(val = $jNLWX(fn, input))) return val;
    throw new $a0f119671308e694$var$$TypeError("Can't convert object to primitive value");
};

});



parcelRegister("6aYbp", function(module, exports) {
'use strict';

var $gd9M7 = parcelRequire("gd9M7");

var $lLFjY = parcelRequire("lLFjY");

var $kpUiR = parcelRequire("kpUiR");
// Thanks to IE8 for its funny defineProperty
module.exports = !$gd9M7 && !$lLFjY(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($kpUiR('div'), 'a', {
        get: function get() {
            return 7;
        }
    }).a !== 7;
});

});
parcelRegister("kpUiR", function(module, exports) {
'use strict';

var $7bT0n = parcelRequire("7bT0n");

var $b89GE = parcelRequire("b89GE");
var $edd1d115e20f5992$var$document = $7bT0n.document;
// typeof document.createElement is 'object' in old IE
var $edd1d115e20f5992$var$EXISTS = $b89GE($edd1d115e20f5992$var$document) && $b89GE($edd1d115e20f5992$var$document.createElement);
module.exports = function(it) {
    return $edd1d115e20f5992$var$EXISTS ? $edd1d115e20f5992$var$document.createElement(it) : {};
};

});



parcelRegister("gDx8T", function(module, exports) {
'use strict';

var $lLFjY = parcelRequire("lLFjY");

var $dhqq1 = parcelRequire("dhqq1");
var $c1c9ff3eca2a7d79$var$replacement = /#|\.prototype\./;
var $c1c9ff3eca2a7d79$var$isForced = function isForced(feature, detection) {
    var value = $c1c9ff3eca2a7d79$var$data[$c1c9ff3eca2a7d79$var$normalize(feature)];
    return value === $c1c9ff3eca2a7d79$var$POLYFILL ? true : value === $c1c9ff3eca2a7d79$var$NATIVE ? false : $dhqq1(detection) ? $lLFjY(detection) : !!detection;
};
var $c1c9ff3eca2a7d79$var$normalize = $c1c9ff3eca2a7d79$var$isForced.normalize = function normalize(string) {
    return String(string).replace($c1c9ff3eca2a7d79$var$replacement, '.').toLowerCase();
};
var $c1c9ff3eca2a7d79$var$data = $c1c9ff3eca2a7d79$var$isForced.data = {};
var $c1c9ff3eca2a7d79$var$NATIVE = $c1c9ff3eca2a7d79$var$isForced.NATIVE = 'N';
var $c1c9ff3eca2a7d79$var$POLYFILL = $c1c9ff3eca2a7d79$var$isForced.POLYFILL = 'P';
module.exports = $c1c9ff3eca2a7d79$var$isForced;

});

parcelRegister("bRGXy", function(module, exports) {
'use strict';

var $cwspJ = parcelRequire("cwspJ");

var $6nUOM = parcelRequire("6nUOM");

var $aajsy = parcelRequire("aajsy");
var $8a35f7d641b80dcc$var$bind = $cwspJ($cwspJ.bind);
// optional / simple context binding
module.exports = function(fn, that) {
    $6nUOM(fn);
    return that === undefined ? fn : $aajsy ? $8a35f7d641b80dcc$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};

});

parcelRegister("eJtbB", function(module, exports) {
'use strict';

var $gd9M7 = parcelRequire("gd9M7");

var $1VaAS = parcelRequire("1VaAS");

var $hPKB8 = parcelRequire("hPKB8");
module.exports = $gd9M7 ? function(object, key, value) {
    return $1VaAS.f(object, key, $hPKB8(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("1VaAS", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $1663550b97b92d3a$export$2d1720544b23b823; }, function (v) { return $1663550b97b92d3a$export$2d1720544b23b823 = v; });
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $1663550b97b92d3a$export$2d1720544b23b823;
'use strict';

var $gd9M7 = parcelRequire("gd9M7");

var $6aYbp = parcelRequire("6aYbp");

var $knQWp = parcelRequire("knQWp");

var $2TVT5 = parcelRequire("2TVT5");

var $5hmHe = parcelRequire("5hmHe");
var $1663550b97b92d3a$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $1663550b97b92d3a$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $1663550b97b92d3a$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $1663550b97b92d3a$var$ENUMERABLE = 'enumerable';
var $1663550b97b92d3a$var$CONFIGURABLE = 'configurable';
var $1663550b97b92d3a$var$WRITABLE = 'writable';
$1663550b97b92d3a$export$2d1720544b23b823 = $gd9M7 ? $knQWp ? function defineProperty(O, P, Attributes) {
    $2TVT5(O);
    P = $5hmHe(P);
    $2TVT5(Attributes);
    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && $1663550b97b92d3a$var$WRITABLE in Attributes && !Attributes[$1663550b97b92d3a$var$WRITABLE]) {
        var current = $1663550b97b92d3a$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$1663550b97b92d3a$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $1663550b97b92d3a$var$CONFIGURABLE in Attributes ? Attributes[$1663550b97b92d3a$var$CONFIGURABLE] : current[$1663550b97b92d3a$var$CONFIGURABLE],
                enumerable: $1663550b97b92d3a$var$ENUMERABLE in Attributes ? Attributes[$1663550b97b92d3a$var$ENUMERABLE] : current[$1663550b97b92d3a$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $1663550b97b92d3a$var$$defineProperty(O, P, Attributes);
} : $1663550b97b92d3a$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $2TVT5(O);
    P = $5hmHe(P);
    $2TVT5(Attributes);
    if ($6aYbp) try {
        return $1663550b97b92d3a$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw new $1663550b97b92d3a$var$$TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("knQWp", function(module, exports) {
'use strict';

var $gd9M7 = parcelRequire("gd9M7");

var $lLFjY = parcelRequire("lLFjY");
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = $gd9M7 && $lLFjY(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, 'prototype', {
        value: 42,
        writable: false
    }).prototype !== 42;
});

});

parcelRegister("2TVT5", function(module, exports) {
'use strict';

var $b89GE = parcelRequire("b89GE");
var $21cd9f118a981ac3$var$$String = String;
var $21cd9f118a981ac3$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
module.exports = function(argument) {
    if ($b89GE(argument)) return argument;
    throw new $21cd9f118a981ac3$var$$TypeError($21cd9f118a981ac3$var$$String(argument) + ' is not an object');
};

});




parcelRegister("eSPB9", function(module, exports) {
'use strict';

var $4yKYN = parcelRequire("4yKYN");
var $ad5e2225d94d35e6$require$$forEach = $4yKYN.forEach;

var $9p2uv = parcelRequire("9p2uv");
var $ad5e2225d94d35e6$var$STRICT_METHOD = $9p2uv('forEach');
// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !$ad5e2225d94d35e6$var$STRICT_METHOD ? function forEach(callbackfn /* , thisArg */ ) {
    return $ad5e2225d94d35e6$require$$forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;

});
parcelRegister("4yKYN", function(module, exports) {
'use strict';

var $bRGXy = parcelRequire("bRGXy");

var $a7J4S = parcelRequire("a7J4S");

var $9gkn9 = parcelRequire("9gkn9");

var $2zGhC = parcelRequire("2zGhC");

var $9oxvq = parcelRequire("9oxvq");

var $3vEKb = parcelRequire("3vEKb");
var $351ec797410b2378$var$push = $a7J4S([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $351ec797410b2378$var$createMethod = function createMethod(TYPE) {
    var IS_MAP = TYPE === 1;
    var IS_FILTER = TYPE === 2;
    var IS_SOME = TYPE === 3;
    var IS_EVERY = TYPE === 4;
    var IS_FIND_INDEX = TYPE === 6;
    var IS_FILTER_REJECT = TYPE === 7;
    var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $2zGhC($this);
        var self = $9gkn9(O);
        var length = $9oxvq(self);
        var boundFunction = $bRGXy(callbackfn, that);
        var index = 0;
        var create = specificCreate || $3vEKb;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            value = self[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $351ec797410b2378$var$push(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $351ec797410b2378$var$push(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
module.exports = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $351ec797410b2378$var$createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $351ec797410b2378$var$createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $351ec797410b2378$var$createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $351ec797410b2378$var$createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $351ec797410b2378$var$createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $351ec797410b2378$var$createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $351ec797410b2378$var$createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $351ec797410b2378$var$createMethod(7)
};

});
parcelRegister("9oxvq", function(module, exports) {
'use strict';

var $dDdnp = parcelRequire("dDdnp");
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function(obj) {
    return $dDdnp(obj.length);
};

});
parcelRegister("dDdnp", function(module, exports) {
'use strict';

var $kzYyV = parcelRequire("kzYyV");
var $9ec94b2e78a1d6d0$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function(argument) {
    var len = $kzYyV(argument);
    return len > 0 ? $9ec94b2e78a1d6d0$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

});
parcelRegister("kzYyV", function(module, exports) {
'use strict';

var $cU12n = parcelRequire("cU12n");
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $cU12n(number);
};

});
parcelRegister("cU12n", function(module, exports) {
'use strict';
var $026c92a94e31968c$var$ceil = Math.ceil;
var $026c92a94e31968c$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $026c92a94e31968c$var$floor : $026c92a94e31968c$var$ceil)(n);
};

});




parcelRegister("3vEKb", function(module, exports) {
'use strict';

var $6XC2A = parcelRequire("6XC2A");
// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function(originalArray, length) {
    return new ($6XC2A(originalArray))(length === 0 ? 0 : length);
};

});
parcelRegister("6XC2A", function(module, exports) {
'use strict';

var $7fGqM = parcelRequire("7fGqM");

var $gCj4y = parcelRequire("gCj4y");

var $b89GE = parcelRequire("b89GE");

var $jMgf3 = parcelRequire("jMgf3");
var $5115c2d5d294cc4d$var$SPECIES = $jMgf3('species');
var $5115c2d5d294cc4d$var$$Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function(originalArray) {
    var C;
    if ($7fGqM(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($gCj4y(C) && (C === $5115c2d5d294cc4d$var$$Array || $7fGqM(C.prototype))) C = undefined;
        else if ($b89GE(C)) {
            C = C[$5115c2d5d294cc4d$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $5115c2d5d294cc4d$var$$Array : C;
};

});
parcelRegister("7fGqM", function(module, exports) {
'use strict';

var $8GC9A = parcelRequire("8GC9A");
// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
    return $8GC9A(argument) === 'Array';
};

});

parcelRegister("gCj4y", function(module, exports) {
'use strict';

var $a7J4S = parcelRequire("a7J4S");

var $lLFjY = parcelRequire("lLFjY");

var $dhqq1 = parcelRequire("dhqq1");

var $deOGU = parcelRequire("deOGU");

var $f9yE9 = parcelRequire("f9yE9");

var $9sUKX = parcelRequire("9sUKX");
var $c18efd56c1ed5fd8$var$noop = function noop() {};
var $c18efd56c1ed5fd8$var$construct = $f9yE9('Reflect', 'construct');
var $c18efd56c1ed5fd8$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $c18efd56c1ed5fd8$var$exec = $a7J4S($c18efd56c1ed5fd8$var$constructorRegExp.exec);
var $c18efd56c1ed5fd8$var$INCORRECT_TO_STRING = !$c18efd56c1ed5fd8$var$constructorRegExp.test($c18efd56c1ed5fd8$var$noop);
var $c18efd56c1ed5fd8$var$isConstructorModern = function isConstructor(argument) {
    if (!$dhqq1(argument)) return false;
    try {
        $c18efd56c1ed5fd8$var$construct($c18efd56c1ed5fd8$var$noop, [], argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $c18efd56c1ed5fd8$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$dhqq1(argument)) return false;
    switch($deOGU(argument)){
        case 'AsyncFunction':
        case 'GeneratorFunction':
        case 'AsyncGeneratorFunction':
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $c18efd56c1ed5fd8$var$INCORRECT_TO_STRING || !!$c18efd56c1ed5fd8$var$exec($c18efd56c1ed5fd8$var$constructorRegExp, $9sUKX(argument));
    } catch (error) {
        return true;
    }
};
$c18efd56c1ed5fd8$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !$c18efd56c1ed5fd8$var$construct || $lLFjY(function() {
    var called;
    return $c18efd56c1ed5fd8$var$isConstructorModern($c18efd56c1ed5fd8$var$isConstructorModern.call) || !$c18efd56c1ed5fd8$var$isConstructorModern(Object) || !$c18efd56c1ed5fd8$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $c18efd56c1ed5fd8$var$isConstructorLegacy : $c18efd56c1ed5fd8$var$isConstructorModern;

});
parcelRegister("9sUKX", function(module, exports) {
'use strict';

var $a7J4S = parcelRequire("a7J4S");

var $dhqq1 = parcelRequire("dhqq1");

var $10Mpp = parcelRequire("10Mpp");
var $6e42c13ccce40525$var$functionToString = $a7J4S(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$dhqq1($10Mpp.inspectSource)) $10Mpp.inspectSource = function(it) {
    return $6e42c13ccce40525$var$functionToString(it);
};
module.exports = $10Mpp.inspectSource;

});





parcelRegister("9p2uv", function(module, exports) {
'use strict';

var $lLFjY = parcelRequire("lLFjY");
module.exports = function(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && $lLFjY(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};

});



parcelRegister("gdkJ6", function(module, exports) {
'use strict';

var $7bT0n = parcelRequire("7bT0n");

var $aYgYj = parcelRequire("aYgYj");
module.exports = function(CONSTRUCTOR, METHOD) {
    var Namespace = $aYgYj[CONSTRUCTOR + 'Prototype'];
    var pureMethod = Namespace && Namespace[METHOD];
    if (pureMethod) return pureMethod;
    var NativeConstructor = $7bT0n[CONSTRUCTOR];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    return NativePrototype && NativePrototype[METHOD];
};

});



parcelRegister("gvdkG", function(module, exports) {
// empty

});


parcelRegister("5WNjD", function(module, exports) {
'use strict';

var $2CmFF = parcelRequire("2CmFF");
module.exports = $2CmFF;

});
parcelRegister("2CmFF", function(module, exports) {
'use strict';
parcelRequire("i2KhA");
parcelRequire("dxpYi");

var $aYgYj = parcelRequire("aYgYj");
module.exports = $aYgYj.Array.from;

});
parcelRegister("i2KhA", function(module, exports) {
'use strict';

var $01u2P = parcelRequire("01u2P");
var $d22c50a9467e84a0$require$charAt = $01u2P.charAt;

var $dkJsu = parcelRequire("dkJsu");

var $4eLp1 = parcelRequire("4eLp1");

var $5Taks = parcelRequire("5Taks");

var $4yOyj = parcelRequire("4yOyj");
var $d22c50a9467e84a0$var$STRING_ITERATOR = 'String Iterator';
var $d22c50a9467e84a0$var$setInternalState = $4eLp1.set;
var $d22c50a9467e84a0$var$getInternalState = $4eLp1.getterFor($d22c50a9467e84a0$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$5Taks(String, 'String', function(iterated) {
    $d22c50a9467e84a0$var$setInternalState(this, {
        type: $d22c50a9467e84a0$var$STRING_ITERATOR,
        string: $dkJsu(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $d22c50a9467e84a0$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $4yOyj(undefined, true);
    point = $d22c50a9467e84a0$require$charAt(string, index);
    state.index += point.length;
    return $4yOyj(point, false);
});

});
parcelRegister("01u2P", function(module, exports) {
'use strict';

var $a7J4S = parcelRequire("a7J4S");

var $kzYyV = parcelRequire("kzYyV");

var $dkJsu = parcelRequire("dkJsu");

var $fgGOS = parcelRequire("fgGOS");
var $0047665e2e147994$var$charAt = $a7J4S(''.charAt);
var $0047665e2e147994$var$charCodeAt = $a7J4S(''.charCodeAt);
var $0047665e2e147994$var$stringSlice = $a7J4S(''.slice);
var $0047665e2e147994$var$createMethod = function createMethod(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $dkJsu($fgGOS($this));
        var position = $kzYyV(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
        first = $0047665e2e147994$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $0047665e2e147994$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $0047665e2e147994$var$charAt(S, position) : first : CONVERT_TO_STRING ? $0047665e2e147994$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
module.exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $0047665e2e147994$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $0047665e2e147994$var$createMethod(true)
};

});
parcelRegister("dkJsu", function(module, exports) {
'use strict';

var $deOGU = parcelRequire("deOGU");
var $9b5067b72a4d13ec$var$$String = String;
module.exports = function(argument) {
    if ($deOGU(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
    return $9b5067b72a4d13ec$var$$String(argument);
};

});


parcelRegister("4eLp1", function(module, exports) {
'use strict';

var $l12Ms = parcelRequire("l12Ms");

var $7bT0n = parcelRequire("7bT0n");

var $b89GE = parcelRequire("b89GE");

var $eJtbB = parcelRequire("eJtbB");

var $eNRkB = parcelRequire("eNRkB");

var $10Mpp = parcelRequire("10Mpp");

var $71r2P = parcelRequire("71r2P");

var $aBOKs = parcelRequire("aBOKs");
var $315d3d61aee3d782$var$OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var $315d3d61aee3d782$var$TypeError = $7bT0n.TypeError;
var $315d3d61aee3d782$var$WeakMap = $7bT0n.WeakMap;
var $315d3d61aee3d782$var$set, $315d3d61aee3d782$var$get, $315d3d61aee3d782$var$has;
var $315d3d61aee3d782$var$enforce = function enforce(it) {
    return $315d3d61aee3d782$var$has(it) ? $315d3d61aee3d782$var$get(it) : $315d3d61aee3d782$var$set(it, {});
};
var $315d3d61aee3d782$var$getterFor = function getterFor(TYPE) {
    return function(it) {
        var state;
        if (!$b89GE(it) || (state = $315d3d61aee3d782$var$get(it)).type !== TYPE) throw new $315d3d61aee3d782$var$TypeError('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if ($l12Ms || $10Mpp.state) {
    var $315d3d61aee3d782$var$store = $10Mpp.state || ($10Mpp.state = new $315d3d61aee3d782$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $315d3d61aee3d782$var$store.get = $315d3d61aee3d782$var$store.get;
    $315d3d61aee3d782$var$store.has = $315d3d61aee3d782$var$store.has;
    $315d3d61aee3d782$var$store.set = $315d3d61aee3d782$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $315d3d61aee3d782$var$set = function set(it, metadata) {
        if ($315d3d61aee3d782$var$store.has(it)) throw new $315d3d61aee3d782$var$TypeError($315d3d61aee3d782$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $315d3d61aee3d782$var$store.set(it, metadata);
        return metadata;
    };
    $315d3d61aee3d782$var$get = function get(it) {
        return $315d3d61aee3d782$var$store.get(it) || {};
    };
    $315d3d61aee3d782$var$has = function has(it) {
        return $315d3d61aee3d782$var$store.has(it);
    };
} else {
    var $315d3d61aee3d782$var$STATE = $71r2P('state');
    $aBOKs[$315d3d61aee3d782$var$STATE] = true;
    $315d3d61aee3d782$var$set = function set(it, metadata) {
        if ($eNRkB(it, $315d3d61aee3d782$var$STATE)) throw new $315d3d61aee3d782$var$TypeError($315d3d61aee3d782$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $eJtbB(it, $315d3d61aee3d782$var$STATE, metadata);
        return metadata;
    };
    $315d3d61aee3d782$var$get = function get(it) {
        return $eNRkB(it, $315d3d61aee3d782$var$STATE) ? it[$315d3d61aee3d782$var$STATE] : {};
    };
    $315d3d61aee3d782$var$has = function has(it) {
        return $eNRkB(it, $315d3d61aee3d782$var$STATE);
    };
}
module.exports = {
    set: $315d3d61aee3d782$var$set,
    get: $315d3d61aee3d782$var$get,
    has: $315d3d61aee3d782$var$has,
    enforce: $315d3d61aee3d782$var$enforce,
    getterFor: $315d3d61aee3d782$var$getterFor
};

});
parcelRegister("l12Ms", function(module, exports) {
'use strict';

var $7bT0n = parcelRequire("7bT0n");

var $dhqq1 = parcelRequire("dhqq1");
var $03f2c590fd66856a$var$WeakMap = $7bT0n.WeakMap;
module.exports = $dhqq1($03f2c590fd66856a$var$WeakMap) && /native code/.test(String($03f2c590fd66856a$var$WeakMap));

});

parcelRegister("71r2P", function(module, exports) {
'use strict';

var $enPFE = parcelRequire("enPFE");

var $1mpAQ = parcelRequire("1mpAQ");
var $51cd9adfbbe6f1a8$var$keys = $enPFE('keys');
module.exports = function(key) {
    return $51cd9adfbbe6f1a8$var$keys[key] || ($51cd9adfbbe6f1a8$var$keys[key] = $1mpAQ(key));
};

});

parcelRegister("aBOKs", function(module, exports) {
'use strict';
module.exports = {};

});


parcelRegister("5Taks", function(module, exports) {
'use strict';

var $4lEVJ = parcelRequire("4lEVJ");

var $jNLWX = parcelRequire("jNLWX");

var $fhkpi = parcelRequire("fhkpi");

var $f5iOX = parcelRequire("f5iOX");

var $dhqq1 = parcelRequire("dhqq1");

var $9PKjp = parcelRequire("9PKjp");

var $3papg = parcelRequire("3papg");

var $bhvMV = parcelRequire("bhvMV");

var $02Gfw = parcelRequire("02Gfw");

var $eJtbB = parcelRequire("eJtbB");

var $eMkcr = parcelRequire("eMkcr");

var $jMgf3 = parcelRequire("jMgf3");

var $8lEBM = parcelRequire("8lEBM");

var $kBSNI = parcelRequire("kBSNI");
var $449a19eeb5e065d3$var$PROPER_FUNCTION_NAME = $f5iOX.PROPER;
var $449a19eeb5e065d3$var$CONFIGURABLE_FUNCTION_NAME = $f5iOX.CONFIGURABLE;
var $449a19eeb5e065d3$var$IteratorPrototype = $kBSNI.IteratorPrototype;
var $449a19eeb5e065d3$var$BUGGY_SAFARI_ITERATORS = $kBSNI.BUGGY_SAFARI_ITERATORS;
var $449a19eeb5e065d3$var$ITERATOR = $jMgf3('iterator');
var $449a19eeb5e065d3$var$KEYS = 'keys';
var $449a19eeb5e065d3$var$VALUES = 'values';
var $449a19eeb5e065d3$var$ENTRIES = 'entries';
var $449a19eeb5e065d3$var$returnThis = function returnThis() {
    return this;
};
module.exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $9PKjp(IteratorConstructor, NAME, next);
    var getIterationMethod = function getIterationMethod(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$449a19eeb5e065d3$var$BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $449a19eeb5e065d3$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $449a19eeb5e065d3$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $449a19eeb5e065d3$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + ' Iterator';
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$449a19eeb5e065d3$var$ITERATOR] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$449a19eeb5e065d3$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $3papg(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$fhkpi && $3papg(CurrentIteratorPrototype) !== $449a19eeb5e065d3$var$IteratorPrototype) {
                if ($bhvMV) $bhvMV(CurrentIteratorPrototype, $449a19eeb5e065d3$var$IteratorPrototype);
                else if (!$dhqq1(CurrentIteratorPrototype[$449a19eeb5e065d3$var$ITERATOR])) $eMkcr(CurrentIteratorPrototype, $449a19eeb5e065d3$var$ITERATOR, $449a19eeb5e065d3$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $02Gfw(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($fhkpi) $8lEBM[TO_STRING_TAG] = $449a19eeb5e065d3$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($449a19eeb5e065d3$var$PROPER_FUNCTION_NAME && DEFAULT === $449a19eeb5e065d3$var$VALUES && nativeIterator && nativeIterator.name !== $449a19eeb5e065d3$var$VALUES) {
        if (!$fhkpi && $449a19eeb5e065d3$var$CONFIGURABLE_FUNCTION_NAME) $eJtbB(IterablePrototype, 'name', $449a19eeb5e065d3$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $jNLWX(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($449a19eeb5e065d3$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($449a19eeb5e065d3$var$KEYS),
            entries: getIterationMethod($449a19eeb5e065d3$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($449a19eeb5e065d3$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $eMkcr(IterablePrototype, KEY, methods[KEY]);
        } else $4lEVJ({
            target: NAME,
            proto: true,
            forced: $449a19eeb5e065d3$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$fhkpi || FORCED) && IterablePrototype[$449a19eeb5e065d3$var$ITERATOR] !== defaultIterator) $eMkcr(IterablePrototype, $449a19eeb5e065d3$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $8lEBM[NAME] = defaultIterator;
    return methods;
};

});
parcelRegister("f5iOX", function(module, exports) {
'use strict';

var $gd9M7 = parcelRequire("gd9M7");

var $eNRkB = parcelRequire("eNRkB");
var $afb5ec16058cb7d0$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $afb5ec16058cb7d0$var$getDescriptor = $gd9M7 && Object.getOwnPropertyDescriptor;
var $afb5ec16058cb7d0$var$EXISTS = $eNRkB($afb5ec16058cb7d0$var$FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var $afb5ec16058cb7d0$var$PROPER = $afb5ec16058cb7d0$var$EXISTS && (function something() {}).name === 'something';
var $afb5ec16058cb7d0$var$CONFIGURABLE = $afb5ec16058cb7d0$var$EXISTS && (!$gd9M7 || $gd9M7 && $afb5ec16058cb7d0$var$getDescriptor($afb5ec16058cb7d0$var$FunctionPrototype, 'name').configurable);
module.exports = {
    EXISTS: $afb5ec16058cb7d0$var$EXISTS,
    PROPER: $afb5ec16058cb7d0$var$PROPER,
    CONFIGURABLE: $afb5ec16058cb7d0$var$CONFIGURABLE
};

});

parcelRegister("9PKjp", function(module, exports) {
'use strict';

var $kBSNI = parcelRequire("kBSNI");
var $728ccd11ac20482e$require$IteratorPrototype = $kBSNI.IteratorPrototype;

var $eSuVM = parcelRequire("eSuVM");

var $hPKB8 = parcelRequire("hPKB8");

var $02Gfw = parcelRequire("02Gfw");

var $8lEBM = parcelRequire("8lEBM");
var $728ccd11ac20482e$var$returnThis = function returnThis() {
    return this;
};
module.exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + ' Iterator';
    IteratorConstructor.prototype = $eSuVM($728ccd11ac20482e$require$IteratorPrototype, {
        next: $hPKB8(+!ENUMERABLE_NEXT, next)
    });
    $02Gfw(IteratorConstructor, TO_STRING_TAG, false, true);
    $8lEBM[TO_STRING_TAG] = $728ccd11ac20482e$var$returnThis;
    return IteratorConstructor;
};

});
parcelRegister("kBSNI", function(module, exports) {
'use strict';

var $lLFjY = parcelRequire("lLFjY");

var $dhqq1 = parcelRequire("dhqq1");

var $b89GE = parcelRequire("b89GE");

var $eSuVM = parcelRequire("eSuVM");

var $3papg = parcelRequire("3papg");

var $eMkcr = parcelRequire("eMkcr");

var $jMgf3 = parcelRequire("jMgf3");

var $fhkpi = parcelRequire("fhkpi");
var $f011c5a8aa1b502a$var$ITERATOR = $jMgf3('iterator');
var $f011c5a8aa1b502a$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $f011c5a8aa1b502a$var$IteratorPrototype, $f011c5a8aa1b502a$var$PrototypeOfArrayIteratorPrototype, $f011c5a8aa1b502a$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $f011c5a8aa1b502a$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!('next' in $f011c5a8aa1b502a$var$arrayIterator)) $f011c5a8aa1b502a$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $f011c5a8aa1b502a$var$PrototypeOfArrayIteratorPrototype = $3papg($3papg($f011c5a8aa1b502a$var$arrayIterator));
        if ($f011c5a8aa1b502a$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $f011c5a8aa1b502a$var$IteratorPrototype = $f011c5a8aa1b502a$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $f011c5a8aa1b502a$var$NEW_ITERATOR_PROTOTYPE = !$b89GE($f011c5a8aa1b502a$var$IteratorPrototype) || $lLFjY(function() {
    var test = {};
    // FF44- legacy iterators case
    return $f011c5a8aa1b502a$var$IteratorPrototype[$f011c5a8aa1b502a$var$ITERATOR].call(test) !== test;
});
if ($f011c5a8aa1b502a$var$NEW_ITERATOR_PROTOTYPE) $f011c5a8aa1b502a$var$IteratorPrototype = {};
else if ($fhkpi) $f011c5a8aa1b502a$var$IteratorPrototype = $eSuVM($f011c5a8aa1b502a$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$dhqq1($f011c5a8aa1b502a$var$IteratorPrototype[$f011c5a8aa1b502a$var$ITERATOR])) $eMkcr($f011c5a8aa1b502a$var$IteratorPrototype, $f011c5a8aa1b502a$var$ITERATOR, function() {
    return this;
});
module.exports = {
    IteratorPrototype: $f011c5a8aa1b502a$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $f011c5a8aa1b502a$var$BUGGY_SAFARI_ITERATORS
};

});
parcelRegister("eSuVM", function(module, exports) {
'use strict';

var $2TVT5 = parcelRequire("2TVT5");

var $glY8r = parcelRequire("glY8r");

var $eLYHb = parcelRequire("eLYHb");

var $aBOKs = parcelRequire("aBOKs");

var $gTWwZ = parcelRequire("gTWwZ");

var $kpUiR = parcelRequire("kpUiR");

var $71r2P = parcelRequire("71r2P");
var $ad4e1a172879c713$var$GT = '>';
var $ad4e1a172879c713$var$LT = '<';
var $ad4e1a172879c713$var$PROTOTYPE = 'prototype';
var $ad4e1a172879c713$var$SCRIPT = 'script';
var $ad4e1a172879c713$var$IE_PROTO = $71r2P('IE_PROTO');
var $ad4e1a172879c713$var$EmptyConstructor = function EmptyConstructor() {};
var $ad4e1a172879c713$var$scriptTag = function scriptTag(content) {
    return $ad4e1a172879c713$var$LT + $ad4e1a172879c713$var$SCRIPT + $ad4e1a172879c713$var$GT + content + $ad4e1a172879c713$var$LT + '/' + $ad4e1a172879c713$var$SCRIPT + $ad4e1a172879c713$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $ad4e1a172879c713$var$NullProtoObjectViaActiveX = function NullProtoObjectViaActiveX(activeXDocument) {
    activeXDocument.write($ad4e1a172879c713$var$scriptTag(''));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    // eslint-disable-next-line no-useless-assignment -- avoid memory leak
    activeXDocument = null;
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $ad4e1a172879c713$var$NullProtoObjectViaIFrame = function NullProtoObjectViaIFrame() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $kpUiR('iframe');
    var JS = 'java' + $ad4e1a172879c713$var$SCRIPT + ':';
    var iframeDocument;
    iframe.style.display = 'none';
    $gTWwZ.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($ad4e1a172879c713$var$scriptTag('document.F=Object'));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $ad4e1a172879c713$var$activeXDocument;
var $ad4e1a172879c713$var$NullProtoObject = function NullProtoObject1() {
    try {
        $ad4e1a172879c713$var$activeXDocument = new ActiveXObject('htmlfile');
    } catch (error) {}
    $ad4e1a172879c713$var$NullProtoObject = typeof document != 'undefined' ? document.domain && $ad4e1a172879c713$var$activeXDocument ? $ad4e1a172879c713$var$NullProtoObjectViaActiveX($ad4e1a172879c713$var$activeXDocument) // old IE
     : $ad4e1a172879c713$var$NullProtoObjectViaIFrame() : $ad4e1a172879c713$var$NullProtoObjectViaActiveX($ad4e1a172879c713$var$activeXDocument); // WSH
    var length = $eLYHb.length;
    while(length--)delete $ad4e1a172879c713$var$NullProtoObject[$ad4e1a172879c713$var$PROTOTYPE][$eLYHb[length]];
    return $ad4e1a172879c713$var$NullProtoObject();
};
$aBOKs[$ad4e1a172879c713$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $ad4e1a172879c713$var$EmptyConstructor[$ad4e1a172879c713$var$PROTOTYPE] = $2TVT5(O);
        result = new $ad4e1a172879c713$var$EmptyConstructor();
        $ad4e1a172879c713$var$EmptyConstructor[$ad4e1a172879c713$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$ad4e1a172879c713$var$IE_PROTO] = O;
    } else result = $ad4e1a172879c713$var$NullProtoObject();
    return Properties === undefined ? result : $glY8r.f(result, Properties);
};

});
parcelRegister("glY8r", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $be7d411a482e6b13$export$2d1720544b23b823; }, function (v) { return $be7d411a482e6b13$export$2d1720544b23b823 = v; });
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $be7d411a482e6b13$export$2d1720544b23b823;
'use strict';

var $gd9M7 = parcelRequire("gd9M7");

var $knQWp = parcelRequire("knQWp");

var $1VaAS = parcelRequire("1VaAS");

var $2TVT5 = parcelRequire("2TVT5");

var $813PX = parcelRequire("813PX");

var $hb2zb = parcelRequire("hb2zb");
$be7d411a482e6b13$export$2d1720544b23b823 = $gd9M7 && !$knQWp ? Object.defineProperties : function defineProperties(O, Properties) {
    $2TVT5(O);
    var props = $813PX(Properties);
    var keys = $hb2zb(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$1VaAS.f(O, key = keys[index++], props[key]);
    return O;
};

});
parcelRegister("hb2zb", function(module, exports) {
'use strict';

var $4ZlKt = parcelRequire("4ZlKt");

var $eLYHb = parcelRequire("eLYHb");
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
    return $4ZlKt(O, $eLYHb);
};

});
parcelRegister("4ZlKt", function(module, exports) {
'use strict';

var $a7J4S = parcelRequire("a7J4S");

var $eNRkB = parcelRequire("eNRkB");

var $813PX = parcelRequire("813PX");

var $85gaR = parcelRequire("85gaR");
var $3a1dbac0f758630f$require$indexOf = $85gaR.indexOf;

var $aBOKs = parcelRequire("aBOKs");
var $3a1dbac0f758630f$var$push = $a7J4S([].push);
module.exports = function(object, names) {
    var O = $813PX(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$eNRkB($aBOKs, key) && $eNRkB(O, key) && $3a1dbac0f758630f$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($eNRkB(O, key = names[i++])) ~$3a1dbac0f758630f$require$indexOf(result, key) || $3a1dbac0f758630f$var$push(result, key);
    return result;
};

});
parcelRegister("85gaR", function(module, exports) {
'use strict';

var $813PX = parcelRequire("813PX");

var $42BY2 = parcelRequire("42BY2");

var $9oxvq = parcelRequire("9oxvq");
// `Array.prototype.{ indexOf, includes }` methods implementation
var $5e2b5630f663f49c$var$createMethod = function createMethod(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $813PX($this);
        var length = $9oxvq(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $42BY2(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
module.exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $5e2b5630f663f49c$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $5e2b5630f663f49c$var$createMethod(false)
};

});
parcelRegister("42BY2", function(module, exports) {
'use strict';

var $kzYyV = parcelRequire("kzYyV");
var $2f14cce0a72b82eb$var$max = Math.max;
var $2f14cce0a72b82eb$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function(index, length) {
    var integer = $kzYyV(index);
    return integer < 0 ? $2f14cce0a72b82eb$var$max(integer + length, 0) : $2f14cce0a72b82eb$var$min(integer, length);
};

});



parcelRegister("eLYHb", function(module, exports) {
'use strict';
// IE8- don't enum bug keys
module.exports = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];

});



parcelRegister("gTWwZ", function(module, exports) {
'use strict';

var $f9yE9 = parcelRequire("f9yE9");
module.exports = $f9yE9('document', 'documentElement');

});


parcelRegister("3papg", function(module, exports) {
'use strict';

var $eNRkB = parcelRequire("eNRkB");

var $dhqq1 = parcelRequire("dhqq1");

var $2zGhC = parcelRequire("2zGhC");

var $71r2P = parcelRequire("71r2P");

var $lkFvL = parcelRequire("lkFvL");
var $27abc76d8a4ceafd$var$IE_PROTO = $71r2P('IE_PROTO');
var $27abc76d8a4ceafd$var$$Object = Object;
var $27abc76d8a4ceafd$var$ObjectPrototype = $27abc76d8a4ceafd$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = $lkFvL ? $27abc76d8a4ceafd$var$$Object.getPrototypeOf : function(O) {
    var object = $2zGhC(O);
    if ($eNRkB(object, $27abc76d8a4ceafd$var$IE_PROTO)) return object[$27abc76d8a4ceafd$var$IE_PROTO];
    var constructor = object.constructor;
    if ($dhqq1(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $27abc76d8a4ceafd$var$$Object ? $27abc76d8a4ceafd$var$ObjectPrototype : null;
};

});
parcelRegister("lkFvL", function(module, exports) {
'use strict';

var $lLFjY = parcelRequire("lLFjY");
module.exports = !$lLFjY(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});

});


parcelRegister("eMkcr", function(module, exports) {
'use strict';

var $eJtbB = parcelRequire("eJtbB");
module.exports = function(target, key, value, options) {
    if (options && options.enumerable) target[key] = value;
    else $eJtbB(target, key, value);
    return target;
};

});


parcelRegister("02Gfw", function(module, exports) {
'use strict';

var $1ganw = parcelRequire("1ganw");

var $1VaAS = parcelRequire("1VaAS");
var $0080f5dda2395b2f$require$defineProperty = $1VaAS.f;

var $eJtbB = parcelRequire("eJtbB");

var $eNRkB = parcelRequire("eNRkB");

var $bB6aO = parcelRequire("bB6aO");

var $jMgf3 = parcelRequire("jMgf3");
var $0080f5dda2395b2f$var$TO_STRING_TAG = $jMgf3('toStringTag');
module.exports = function(it, TAG, STATIC, SET_METHOD) {
    var target = STATIC ? it : it && it.prototype;
    if (target) {
        if (!$eNRkB(target, $0080f5dda2395b2f$var$TO_STRING_TAG)) $0080f5dda2395b2f$require$defineProperty(target, $0080f5dda2395b2f$var$TO_STRING_TAG, {
            configurable: true,
            value: TAG
        });
        if (SET_METHOD && !$1ganw) $eJtbB(target, 'toString', $bB6aO);
    }
};

});
parcelRegister("bB6aO", function(module, exports) {
'use strict';

var $1ganw = parcelRequire("1ganw");

var $deOGU = parcelRequire("deOGU");
// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = $1ganw ? ({}).toString : function toString() {
    return '[object ' + $deOGU(this) + ']';
};

});


parcelRegister("8lEBM", function(module, exports) {
'use strict';
module.exports = {};

});


parcelRegister("bhvMV", function(module, exports) {
'use strict';

var $alRT5 = parcelRequire("alRT5");

var $b89GE = parcelRequire("b89GE");

var $fgGOS = parcelRequire("fgGOS");

var $1ybfM = parcelRequire("1ybfM");
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $alRT5(Object.prototype, '__proto__', 'set');
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $fgGOS(O);
        $1ybfM(proto);
        if (!$b89GE(O)) return O;
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);

});
parcelRegister("alRT5", function(module, exports) {
'use strict';

var $a7J4S = parcelRequire("a7J4S");

var $6nUOM = parcelRequire("6nUOM");
module.exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $a7J4S($6nUOM(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};

});

parcelRegister("1ybfM", function(module, exports) {
'use strict';

var $2P0td = parcelRequire("2P0td");
var $1211b2282e794e68$var$$String = String;
var $1211b2282e794e68$var$$TypeError = TypeError;
module.exports = function(argument) {
    if ($2P0td(argument)) return argument;
    throw new $1211b2282e794e68$var$$TypeError("Can't set " + $1211b2282e794e68$var$$String(argument) + ' as a prototype');
};

});
parcelRegister("2P0td", function(module, exports) {
'use strict';

var $b89GE = parcelRequire("b89GE");
module.exports = function(argument) {
    return $b89GE(argument) || argument === null;
};

});




parcelRegister("4yOyj", function(module, exports) {
'use strict';
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};

});


parcelRegister("dxpYi", function(module, exports) {
'use strict';

var $4lEVJ = parcelRequire("4lEVJ");

var $2qOG7 = parcelRequire("2qOG7");

var $cplUt = parcelRequire("cplUt");
var $9db280d44ba1111f$var$INCORRECT_ITERATION = !$cplUt(function(iterable) {
    // eslint-disable-next-line es/no-array-from -- required for testing
    Array.from(iterable);
});
// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$4lEVJ({
    target: 'Array',
    stat: true,
    forced: $9db280d44ba1111f$var$INCORRECT_ITERATION
}, {
    from: $2qOG7
});

});
parcelRegister("2qOG7", function(module, exports) {
'use strict';

var $bRGXy = parcelRequire("bRGXy");

var $jNLWX = parcelRequire("jNLWX");

var $2zGhC = parcelRequire("2zGhC");

var $dUkZh = parcelRequire("dUkZh");

var $cPzbH = parcelRequire("cPzbH");

var $gCj4y = parcelRequire("gCj4y");

var $9oxvq = parcelRequire("9oxvq");

var $62K9T = parcelRequire("62K9T");

var $34Mm3 = parcelRequire("34Mm3");

var $exUnz = parcelRequire("exUnz");
var $1c5552220a84e189$var$$Array = Array;
// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
    var O = $2zGhC(arrayLike);
    var IS_CONSTRUCTOR = $gCj4y(this);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    if (mapping) mapfn = $bRGXy(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
    var iteratorMethod = $exUnz(O);
    var index = 0;
    var length, result, step, iterator, next, value;
    // if the target is not iterable or it's an array with the default iterator - use a simple case
    if (iteratorMethod && !(this === $1c5552220a84e189$var$$Array && $cPzbH(iteratorMethod))) {
        result = IS_CONSTRUCTOR ? new this() : [];
        iterator = $34Mm3(O, iteratorMethod);
        next = iterator.next;
        for(; !(step = $jNLWX(next, iterator)).done; index++){
            value = mapping ? $dUkZh(iterator, mapfn, [
                step.value,
                index
            ], true) : step.value;
            $62K9T(result, index, value);
        }
    } else {
        length = $9oxvq(O);
        result = IS_CONSTRUCTOR ? new this(length) : $1c5552220a84e189$var$$Array(length);
        for(; length > index; index++){
            value = mapping ? mapfn(O[index], index) : O[index];
            $62K9T(result, index, value);
        }
    }
    result.length = index;
    return result;
};

});
parcelRegister("dUkZh", function(module, exports) {
'use strict';

var $2TVT5 = parcelRequire("2TVT5");

var $6qgRn = parcelRequire("6qgRn");
// call something on iterator step with safe closing on error
module.exports = function(iterator, fn, value, ENTRIES) {
    try {
        return ENTRIES ? fn($2TVT5(value)[0], value[1]) : fn(value);
    } catch (error) {
        $6qgRn(iterator, 'throw', error);
    }
};

});
parcelRegister("6qgRn", function(module, exports) {
'use strict';

var $jNLWX = parcelRequire("jNLWX");

var $2TVT5 = parcelRequire("2TVT5");

var $idEjk = parcelRequire("idEjk");
module.exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $2TVT5(iterator);
    try {
        innerResult = $idEjk(iterator, 'return');
        if (!innerResult) {
            if (kind === 'throw') throw value;
            return value;
        }
        innerResult = $jNLWX(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === 'throw') throw value;
    if (innerError) throw innerResult;
    $2TVT5(innerResult);
    return value;
};

});


parcelRegister("cPzbH", function(module, exports) {
'use strict';

var $jMgf3 = parcelRequire("jMgf3");

var $8lEBM = parcelRequire("8lEBM");
var $95758b04d9ce0e11$var$ITERATOR = $jMgf3('iterator');
var $95758b04d9ce0e11$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
module.exports = function(it) {
    return it !== undefined && ($8lEBM.Array === it || $95758b04d9ce0e11$var$ArrayPrototype[$95758b04d9ce0e11$var$ITERATOR] === it);
};

});

parcelRegister("62K9T", function(module, exports) {
'use strict';

var $gd9M7 = parcelRequire("gd9M7");

var $1VaAS = parcelRequire("1VaAS");

var $hPKB8 = parcelRequire("hPKB8");
module.exports = function(object, key, value) {
    if ($gd9M7) $1VaAS.f(object, key, $hPKB8(0, value));
    else object[key] = value;
};

});

parcelRegister("34Mm3", function(module, exports) {
'use strict';

var $jNLWX = parcelRequire("jNLWX");

var $6nUOM = parcelRequire("6nUOM");

var $2TVT5 = parcelRequire("2TVT5");

var $awEhk = parcelRequire("awEhk");

var $exUnz = parcelRequire("exUnz");
var $23d7410a929ed653$var$$TypeError = TypeError;
module.exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $exUnz(argument) : usingIterator;
    if ($6nUOM(iteratorMethod)) return $2TVT5($jNLWX(iteratorMethod, argument));
    throw new $23d7410a929ed653$var$$TypeError($awEhk(argument) + ' is not iterable');
};

});
parcelRegister("exUnz", function(module, exports) {
'use strict';

var $deOGU = parcelRequire("deOGU");

var $idEjk = parcelRequire("idEjk");

var $aYBgg = parcelRequire("aYBgg");

var $8lEBM = parcelRequire("8lEBM");

var $jMgf3 = parcelRequire("jMgf3");
var $a96fe178c489c20e$var$ITERATOR = $jMgf3('iterator');
module.exports = function(it) {
    if (!$aYBgg(it)) return $idEjk(it, $a96fe178c489c20e$var$ITERATOR) || $idEjk(it, '@@iterator') || $8lEBM[$deOGU(it)];
};

});



parcelRegister("cplUt", function(module, exports) {
'use strict';

var $jMgf3 = parcelRequire("jMgf3");
var $9088d0ab9e4b8e3f$var$ITERATOR = $jMgf3('iterator');
var $9088d0ab9e4b8e3f$var$SAFE_CLOSING = false;
try {
    var $9088d0ab9e4b8e3f$var$called = 0;
    var $9088d0ab9e4b8e3f$var$iteratorWithReturn = {
        next: function next() {
            return {
                done: !!$9088d0ab9e4b8e3f$var$called++
            };
        },
        'return': function() {
            $9088d0ab9e4b8e3f$var$SAFE_CLOSING = true;
        }
    };
    $9088d0ab9e4b8e3f$var$iteratorWithReturn[$9088d0ab9e4b8e3f$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($9088d0ab9e4b8e3f$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
module.exports = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !$9088d0ab9e4b8e3f$var$SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$9088d0ab9e4b8e3f$var$ITERATOR] = function() {
            return {
                next: function next() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};

});




parcelRegister("avNV9", function(module, exports) {
'use strict';

var $gQ0Wl = parcelRequire("gQ0Wl");
module.exports = $gQ0Wl;

});
parcelRegister("gQ0Wl", function(module, exports) {
'use strict';

var $goSny = parcelRequire("goSny");

var $1otar = parcelRequire("1otar");
var $c4223b544cde7487$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.sort;
    return it === $c4223b544cde7487$var$ArrayPrototype || $goSny($c4223b544cde7487$var$ArrayPrototype, it) && own === $c4223b544cde7487$var$ArrayPrototype.sort ? $1otar : own;
};

});
parcelRegister("1otar", function(module, exports) {
'use strict';
parcelRequire("dunsB");

var $gdkJ6 = parcelRequire("gdkJ6");
module.exports = $gdkJ6('Array', 'sort');

});
parcelRegister("dunsB", function(module, exports) {
'use strict';

var $4lEVJ = parcelRequire("4lEVJ");

var $a7J4S = parcelRequire("a7J4S");

var $6nUOM = parcelRequire("6nUOM");

var $2zGhC = parcelRequire("2zGhC");

var $9oxvq = parcelRequire("9oxvq");

var $8MmEm = parcelRequire("8MmEm");

var $dkJsu = parcelRequire("dkJsu");

var $lLFjY = parcelRequire("lLFjY");

var $5kxs7 = parcelRequire("5kxs7");

var $9p2uv = parcelRequire("9p2uv");

var $eqhn2 = parcelRequire("eqhn2");

var $dvhqr = parcelRequire("dvhqr");

var $hymGt = parcelRequire("hymGt");

var $jzDfp = parcelRequire("jzDfp");
var $9d204669db8dea8a$var$test = [];
var $9d204669db8dea8a$var$nativeSort = $a7J4S($9d204669db8dea8a$var$test.sort);
var $9d204669db8dea8a$var$push = $a7J4S($9d204669db8dea8a$var$test.push);
// IE8-
var $9d204669db8dea8a$var$FAILS_ON_UNDEFINED = $lLFjY(function() {
    $9d204669db8dea8a$var$test.sort(undefined);
});
// V8 bug
var $9d204669db8dea8a$var$FAILS_ON_NULL = $lLFjY(function() {
    $9d204669db8dea8a$var$test.sort(null);
});
// Old WebKit
var $9d204669db8dea8a$var$STRICT_METHOD = $9p2uv('sort');
var $9d204669db8dea8a$var$STABLE_SORT = !$lLFjY(function() {
    // feature detection can be too slow, so check engines versions
    if ($hymGt) return $hymGt < 70;
    if ($eqhn2 && $eqhn2 > 3) return;
    if ($dvhqr) return true;
    if ($jzDfp) return $jzDfp < 603;
    var result = '';
    var code, chr, value, index;
    // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
    for(code = 65; code < 76; code++){
        chr = String.fromCharCode(code);
        switch(code){
            case 66:
            case 69:
            case 70:
            case 72:
                value = 3;
                break;
            case 68:
            case 71:
                value = 4;
                break;
            default:
                value = 2;
        }
        for(index = 0; index < 47; index++)$9d204669db8dea8a$var$test.push({
            k: chr + index,
            v: value
        });
    }
    $9d204669db8dea8a$var$test.sort(function(a, b) {
        return b.v - a.v;
    });
    for(index = 0; index < $9d204669db8dea8a$var$test.length; index++){
        chr = $9d204669db8dea8a$var$test[index].k.charAt(0);
        if (result.charAt(result.length - 1) !== chr) result += chr;
    }
    return result !== 'DGBEFHACIJK';
});
var $9d204669db8dea8a$var$FORCED = $9d204669db8dea8a$var$FAILS_ON_UNDEFINED || !$9d204669db8dea8a$var$FAILS_ON_NULL || !$9d204669db8dea8a$var$STRICT_METHOD || !$9d204669db8dea8a$var$STABLE_SORT;
var $9d204669db8dea8a$var$getSortCompare = function getSortCompare(comparefn) {
    return function(x, y) {
        if (y === undefined) return -1;
        if (x === undefined) return 1;
        if (comparefn !== undefined) return +comparefn(x, y) || 0;
        return $dkJsu(x) > $dkJsu(y) ? 1 : -1;
    };
};
// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$4lEVJ({
    target: 'Array',
    proto: true,
    forced: $9d204669db8dea8a$var$FORCED
}, {
    sort: function sort(comparefn) {
        if (comparefn !== undefined) $6nUOM(comparefn);
        var array = $2zGhC(this);
        if ($9d204669db8dea8a$var$STABLE_SORT) return comparefn === undefined ? $9d204669db8dea8a$var$nativeSort(array) : $9d204669db8dea8a$var$nativeSort(array, comparefn);
        var items = [];
        var arrayLength = $9oxvq(array);
        var itemsLength, index;
        for(index = 0; index < arrayLength; index++)if (index in array) $9d204669db8dea8a$var$push(items, array[index]);
        $5kxs7(items, $9d204669db8dea8a$var$getSortCompare(comparefn));
        itemsLength = $9oxvq(items);
        index = 0;
        while(index < itemsLength)array[index] = items[index++];
        while(index < arrayLength)$8MmEm(array, index++);
        return array;
    }
});

});
parcelRegister("8MmEm", function(module, exports) {
'use strict';

var $awEhk = parcelRequire("awEhk");
var $66446043c46ba766$var$$TypeError = TypeError;
module.exports = function(O, P) {
    if (!delete O[P]) throw new $66446043c46ba766$var$$TypeError('Cannot delete property ' + $awEhk(P) + ' of ' + $awEhk(O));
};

});

parcelRegister("5kxs7", function(module, exports) {
'use strict';

var $7D1nL = parcelRequire("7D1nL");
var $3e18c50193ba30c4$var$floor = Math.floor;
var $3e18c50193ba30c4$var$sort = function sort1(array, comparefn) {
    var length = array.length;
    if (length < 8) {
        // insertion sort
        var i = 1;
        var element, j;
        while(i < length){
            j = i;
            element = array[i];
            while(j && comparefn(array[j - 1], element) > 0)array[j] = array[--j];
            if (j !== i++) array[j] = element;
        }
    } else {
        // merge sort
        var middle = $3e18c50193ba30c4$var$floor(length / 2);
        var left = $3e18c50193ba30c4$var$sort($7D1nL(array, 0, middle), comparefn);
        var right = $3e18c50193ba30c4$var$sort($7D1nL(array, middle), comparefn);
        var llength = left.length;
        var rlength = right.length;
        var lindex = 0;
        var rindex = 0;
        while(lindex < llength || rindex < rlength)array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
    }
    return array;
};
module.exports = $3e18c50193ba30c4$var$sort;

});
parcelRegister("7D1nL", function(module, exports) {
'use strict';

var $a7J4S = parcelRequire("a7J4S");
module.exports = $a7J4S([].slice);

});


parcelRegister("eqhn2", function(module, exports) {
'use strict';

var $7y4D2 = parcelRequire("7y4D2");
var $a800f7d9928490ed$var$firefox = $7y4D2.match(/firefox\/(\d+)/i);
module.exports = !!$a800f7d9928490ed$var$firefox && +$a800f7d9928490ed$var$firefox[1];

});

parcelRegister("dvhqr", function(module, exports) {
'use strict';

var $7y4D2 = parcelRequire("7y4D2");
module.exports = /MSIE|Trident/.test($7y4D2);

});

parcelRegister("jzDfp", function(module, exports) {
'use strict';

var $7y4D2 = parcelRequire("7y4D2");
var $e3ffbaf82db4324f$var$webkit = $7y4D2.match(/AppleWebKit\/(\d+)\./);
module.exports = !!$e3ffbaf82db4324f$var$webkit && +$e3ffbaf82db4324f$var$webkit[1];

});





parcelRegister("fJZFI", function(module, exports) {
'use strict';

var $isFmn = parcelRequire("isFmn");
module.exports = $isFmn;

});
parcelRegister("isFmn", function(module, exports) {
'use strict';

var $goSny = parcelRequire("goSny");

var $chdIG = parcelRequire("chdIG");
var $d70aecbac1578153$var$StringPrototype = String.prototype;
module.exports = function(it) {
    var own = it.startsWith;
    return typeof it == 'string' || it === $d70aecbac1578153$var$StringPrototype || $goSny($d70aecbac1578153$var$StringPrototype, it) && own === $d70aecbac1578153$var$StringPrototype.startsWith ? $chdIG : own;
};

});
parcelRegister("chdIG", function(module, exports) {
'use strict';
parcelRequire("kqPJj");

var $gdkJ6 = parcelRequire("gdkJ6");
module.exports = $gdkJ6('String', 'startsWith');

});
parcelRegister("kqPJj", function(module, exports) {
'use strict';

var $4lEVJ = parcelRequire("4lEVJ");

var $cwspJ = parcelRequire("cwspJ");

var $6cFF8 = parcelRequire("6cFF8");
var $edfe5cd8bbd6ba9a$require$getOwnPropertyDescriptor = $6cFF8.f;

var $dDdnp = parcelRequire("dDdnp");

var $dkJsu = parcelRequire("dkJsu");

var $adYou = parcelRequire("adYou");

var $fgGOS = parcelRequire("fgGOS");

var $ciQB3 = parcelRequire("ciQB3");

var $fhkpi = parcelRequire("fhkpi");
var $edfe5cd8bbd6ba9a$var$stringSlice = $cwspJ(''.slice);
var $edfe5cd8bbd6ba9a$var$min = Math.min;
var $edfe5cd8bbd6ba9a$var$CORRECT_IS_REGEXP_LOGIC = $ciQB3('startsWith');
// https://github.com/zloirock/core-js/pull/702
var $edfe5cd8bbd6ba9a$var$MDN_POLYFILL_BUG = !$fhkpi && !$edfe5cd8bbd6ba9a$var$CORRECT_IS_REGEXP_LOGIC && !!function() {
    var descriptor = $edfe5cd8bbd6ba9a$require$getOwnPropertyDescriptor(String.prototype, 'startsWith');
    return descriptor && !descriptor.writable;
}();
// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$4lEVJ({
    target: 'String',
    proto: true,
    forced: !$edfe5cd8bbd6ba9a$var$MDN_POLYFILL_BUG && !$edfe5cd8bbd6ba9a$var$CORRECT_IS_REGEXP_LOGIC
}, {
    startsWith: function startsWith(searchString /* , position = 0 */ ) {
        var that = $dkJsu($fgGOS(this));
        $adYou(searchString);
        var index = $dDdnp($edfe5cd8bbd6ba9a$var$min(arguments.length > 1 ? arguments[1] : undefined, that.length));
        var search = $dkJsu(searchString);
        return $edfe5cd8bbd6ba9a$var$stringSlice(that, index, index + search.length) === search;
    }
});

});
parcelRegister("adYou", function(module, exports) {
'use strict';

var $hQpX1 = parcelRequire("hQpX1");
var $7719f7434385b836$var$$TypeError = TypeError;
module.exports = function(it) {
    if ($hQpX1(it)) throw new $7719f7434385b836$var$$TypeError("The method doesn't accept regular expressions");
    return it;
};

});
parcelRegister("hQpX1", function(module, exports) {
'use strict';

var $b89GE = parcelRequire("b89GE");

var $8GC9A = parcelRequire("8GC9A");

var $jMgf3 = parcelRequire("jMgf3");
var $cfdb6c56d842eade$var$MATCH = $jMgf3('match');
// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function(it) {
    var isRegExp;
    return $b89GE(it) && ((isRegExp = it[$cfdb6c56d842eade$var$MATCH]) !== undefined ? !!isRegExp : $8GC9A(it) === 'RegExp');
};

});


parcelRegister("ciQB3", function(module, exports) {
'use strict';

var $jMgf3 = parcelRequire("jMgf3");
var $8f4ff713164bdf98$var$MATCH = $jMgf3('match');
module.exports = function(METHOD_NAME) {
    var regexp = /./;
    try {
        '/./'[METHOD_NAME](regexp);
    } catch (error1) {
        try {
            regexp[$8f4ff713164bdf98$var$MATCH] = false;
            return '/./'[METHOD_NAME](regexp);
        } catch (error2) {}
    }
    return false;
};

});





parcelRegister("iN4iX", function(module, exports) {
'use strict';

var $dE1fu = parcelRequire("dE1fu");
module.exports = $dE1fu;

});
parcelRegister("dE1fu", function(module, exports) {
'use strict';
parcelRequire("i6kQ1");
parcelRequire("eW0xv");

var $aYgYj = parcelRequire("aYgYj");

var $e09lc = parcelRequire("e09lc");
// eslint-disable-next-line es/no-json -- safe
if (!$aYgYj.JSON) $aYgYj.JSON = {
    stringify: JSON.stringify
};
// eslint-disable-next-line no-unused-vars -- required for `.length`
module.exports = function stringify(it, replacer, space) {
    return $e09lc($aYgYj.JSON.stringify, null, arguments);
};

});
parcelRegister("i6kQ1", function(module, exports) {
'use strict';

var $4lEVJ = parcelRequire("4lEVJ");

var $jNLWX = parcelRequire("jNLWX");

var $2zGhC = parcelRequire("2zGhC");

var $dkuSX = parcelRequire("dkuSX");

var $72HVe = parcelRequire("72HVe");

var $8GC9A = parcelRequire("8GC9A");

var $lLFjY = parcelRequire("lLFjY");
var $d2d8f38a75269871$var$FORCED = $lLFjY(function() {
    return new Date(NaN).toJSON() !== null || $jNLWX(Date.prototype.toJSON, {
        toISOString: function toISOString() {
            return 1;
        }
    }) !== 1;
});
// `Date.prototype.toJSON` method
// https://tc39.es/ecma262/#sec-date.prototype.tojson
$4lEVJ({
    target: 'Date',
    proto: true,
    forced: $d2d8f38a75269871$var$FORCED
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    toJSON: function toJSON(key) {
        var O = $2zGhC(this);
        var pv = $dkuSX(O, 'number');
        return typeof pv == 'number' && !isFinite(pv) ? null : !('toISOString' in O) && $8GC9A(O) === 'Date' ? $jNLWX($72HVe, O) : O.toISOString();
    }
});

});
parcelRegister("72HVe", function(module, exports) {
'use strict';

var $a7J4S = parcelRequire("a7J4S");

var $lLFjY = parcelRequire("lLFjY");

var $cGeRK = parcelRequire("cGeRK");
var $520aca51f26698fe$require$padStart = $cGeRK.start;
var $520aca51f26698fe$var$$RangeError = RangeError;
var $520aca51f26698fe$var$$isFinite = isFinite;
var $520aca51f26698fe$var$abs = Math.abs;
var $520aca51f26698fe$var$DatePrototype = Date.prototype;
var $520aca51f26698fe$var$nativeDateToISOString = $520aca51f26698fe$var$DatePrototype.toISOString;
var $520aca51f26698fe$var$thisTimeValue = $a7J4S($520aca51f26698fe$var$DatePrototype.getTime);
var $520aca51f26698fe$var$getUTCDate = $a7J4S($520aca51f26698fe$var$DatePrototype.getUTCDate);
var $520aca51f26698fe$var$getUTCFullYear = $a7J4S($520aca51f26698fe$var$DatePrototype.getUTCFullYear);
var $520aca51f26698fe$var$getUTCHours = $a7J4S($520aca51f26698fe$var$DatePrototype.getUTCHours);
var $520aca51f26698fe$var$getUTCMilliseconds = $a7J4S($520aca51f26698fe$var$DatePrototype.getUTCMilliseconds);
var $520aca51f26698fe$var$getUTCMinutes = $a7J4S($520aca51f26698fe$var$DatePrototype.getUTCMinutes);
var $520aca51f26698fe$var$getUTCMonth = $a7J4S($520aca51f26698fe$var$DatePrototype.getUTCMonth);
var $520aca51f26698fe$var$getUTCSeconds = $a7J4S($520aca51f26698fe$var$DatePrototype.getUTCSeconds);
// `Date.prototype.toISOString` method implementation
// https://tc39.es/ecma262/#sec-date.prototype.toisostring
// PhantomJS / old WebKit fails here:
module.exports = $lLFjY(function() {
    return $520aca51f26698fe$var$nativeDateToISOString.call(new Date(-50000000000000 - 1)) !== '0385-07-25T07:06:39.999Z';
}) || !$lLFjY(function() {
    $520aca51f26698fe$var$nativeDateToISOString.call(new Date(NaN));
}) ? function toISOString() {
    if (!$520aca51f26698fe$var$$isFinite($520aca51f26698fe$var$thisTimeValue(this))) throw new $520aca51f26698fe$var$$RangeError('Invalid time value');
    var date = this;
    var year = $520aca51f26698fe$var$getUTCFullYear(date);
    var milliseconds = $520aca51f26698fe$var$getUTCMilliseconds(date);
    var sign = year < 0 ? '-' : year > 9999 ? '+' : '';
    return sign + $520aca51f26698fe$require$padStart($520aca51f26698fe$var$abs(year), sign ? 6 : 4, 0) + '-' + $520aca51f26698fe$require$padStart($520aca51f26698fe$var$getUTCMonth(date) + 1, 2, 0) + '-' + $520aca51f26698fe$require$padStart($520aca51f26698fe$var$getUTCDate(date), 2, 0) + 'T' + $520aca51f26698fe$require$padStart($520aca51f26698fe$var$getUTCHours(date), 2, 0) + ':' + $520aca51f26698fe$require$padStart($520aca51f26698fe$var$getUTCMinutes(date), 2, 0) + ':' + $520aca51f26698fe$require$padStart($520aca51f26698fe$var$getUTCSeconds(date), 2, 0) + '.' + $520aca51f26698fe$require$padStart(milliseconds, 3, 0) + 'Z';
} : $520aca51f26698fe$var$nativeDateToISOString;

});
parcelRegister("cGeRK", function(module, exports) {
'use strict';

var $a7J4S = parcelRequire("a7J4S");

var $dDdnp = parcelRequire("dDdnp");

var $dkJsu = parcelRequire("dkJsu");

var $1WA6o = parcelRequire("1WA6o");

var $fgGOS = parcelRequire("fgGOS");
var $93b4f055175c4a36$var$repeat = $a7J4S($1WA6o);
var $93b4f055175c4a36$var$stringSlice = $a7J4S(''.slice);
var $93b4f055175c4a36$var$ceil = Math.ceil;
// `String.prototype.{ padStart, padEnd }` methods implementation
var $93b4f055175c4a36$var$createMethod = function createMethod(IS_END) {
    return function($this, maxLength, fillString) {
        var S = $dkJsu($fgGOS($this));
        var intMaxLength = $dDdnp(maxLength);
        var stringLength = S.length;
        var fillStr = fillString === undefined ? ' ' : $dkJsu(fillString);
        var fillLen, stringFiller;
        if (intMaxLength <= stringLength || fillStr === '') return S;
        fillLen = intMaxLength - stringLength;
        stringFiller = $93b4f055175c4a36$var$repeat(fillStr, $93b4f055175c4a36$var$ceil(fillLen / fillStr.length));
        if (stringFiller.length > fillLen) stringFiller = $93b4f055175c4a36$var$stringSlice(stringFiller, 0, fillLen);
        return IS_END ? S + stringFiller : stringFiller + S;
    };
};
module.exports = {
    // `String.prototype.padStart` method
    // https://tc39.es/ecma262/#sec-string.prototype.padstart
    start: $93b4f055175c4a36$var$createMethod(false),
    // `String.prototype.padEnd` method
    // https://tc39.es/ecma262/#sec-string.prototype.padend
    end: $93b4f055175c4a36$var$createMethod(true)
};

});
parcelRegister("1WA6o", function(module, exports) {
'use strict';

var $kzYyV = parcelRequire("kzYyV");

var $dkJsu = parcelRequire("dkJsu");

var $fgGOS = parcelRequire("fgGOS");
var $16a73656a9dc75a5$var$$RangeError = RangeError;
// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
module.exports = function repeat(count) {
    var str = $dkJsu($fgGOS(this));
    var result = '';
    var n = $kzYyV(count);
    if (n < 0 || n === Infinity) throw new $16a73656a9dc75a5$var$$RangeError('Wrong number of repetitions');
    for(; n > 0; (n >>>= 1) && (str += str))if (n & 1) result += str;
    return result;
};

});




parcelRegister("eW0xv", function(module, exports) {
'use strict';

var $4lEVJ = parcelRequire("4lEVJ");

var $f9yE9 = parcelRequire("f9yE9");

var $e09lc = parcelRequire("e09lc");

var $jNLWX = parcelRequire("jNLWX");

var $a7J4S = parcelRequire("a7J4S");

var $lLFjY = parcelRequire("lLFjY");

var $dhqq1 = parcelRequire("dhqq1");

var $dhvej = parcelRequire("dhvej");

var $7D1nL = parcelRequire("7D1nL");

var $4CzJ8 = parcelRequire("4CzJ8");

var $aKZdM = parcelRequire("aKZdM");
var $adf6e692feb2b673$var$$String = String;
var $adf6e692feb2b673$var$$stringify = $f9yE9('JSON', 'stringify');
var $adf6e692feb2b673$var$exec = $a7J4S(/./.exec);
var $adf6e692feb2b673$var$charAt = $a7J4S(''.charAt);
var $adf6e692feb2b673$var$charCodeAt = $a7J4S(''.charCodeAt);
var $adf6e692feb2b673$var$replace = $a7J4S(''.replace);
var $adf6e692feb2b673$var$numberToString = $a7J4S(1.1.toString);
var $adf6e692feb2b673$var$tester = /[\uD800-\uDFFF]/g;
var $adf6e692feb2b673$var$low = /^[\uD800-\uDBFF]$/;
var $adf6e692feb2b673$var$hi = /^[\uDC00-\uDFFF]$/;
var $adf6e692feb2b673$var$WRONG_SYMBOLS_CONVERSION = !$aKZdM || $lLFjY(function() {
    var symbol = $f9yE9('Symbol')('stringify detection');
    // MS Edge converts symbol values to JSON as {}
    return $adf6e692feb2b673$var$$stringify([
        symbol
    ]) !== '[null]' || $adf6e692feb2b673$var$$stringify({
        a: symbol
    }) !== '{}' || $adf6e692feb2b673$var$$stringify(Object(symbol)) !== '{}';
});
// https://github.com/tc39/proposal-well-formed-stringify
var $adf6e692feb2b673$var$ILL_FORMED_UNICODE = $lLFjY(function() {
    return $adf6e692feb2b673$var$$stringify('\uDF06\uD834') !== '"\\udf06\\ud834"' || $adf6e692feb2b673$var$$stringify('\uDEAD') !== '"\\udead"';
});
var $adf6e692feb2b673$var$stringifyWithSymbolsFix = function stringifyWithSymbolsFix(it, replacer) {
    var args = $7D1nL(arguments);
    var $replacer = $4CzJ8(replacer);
    if (!$dhqq1($replacer) && (it === undefined || $dhvej(it))) return; // IE8 returns string on undefined
    args[1] = function(key, value) {
        // some old implementations (like WebKit) could pass numbers as keys
        if ($dhqq1($replacer)) value = $jNLWX($replacer, this, $adf6e692feb2b673$var$$String(key), value);
        if (!$dhvej(value)) return value;
    };
    return $e09lc($adf6e692feb2b673$var$$stringify, null, args);
};
var $adf6e692feb2b673$var$fixIllFormed = function fixIllFormed(match, offset, string) {
    var prev = $adf6e692feb2b673$var$charAt(string, offset - 1);
    var next = $adf6e692feb2b673$var$charAt(string, offset + 1);
    if ($adf6e692feb2b673$var$exec($adf6e692feb2b673$var$low, match) && !$adf6e692feb2b673$var$exec($adf6e692feb2b673$var$hi, next) || $adf6e692feb2b673$var$exec($adf6e692feb2b673$var$hi, match) && !$adf6e692feb2b673$var$exec($adf6e692feb2b673$var$low, prev)) return '\\u' + $adf6e692feb2b673$var$numberToString($adf6e692feb2b673$var$charCodeAt(match, 0), 16);
    return match;
};
if ($adf6e692feb2b673$var$$stringify) // `JSON.stringify` method
// https://tc39.es/ecma262/#sec-json.stringify
$4lEVJ({
    target: 'JSON',
    stat: true,
    arity: 3,
    forced: $adf6e692feb2b673$var$WRONG_SYMBOLS_CONVERSION || $adf6e692feb2b673$var$ILL_FORMED_UNICODE
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
        var args = $7D1nL(arguments);
        var result = $e09lc($adf6e692feb2b673$var$WRONG_SYMBOLS_CONVERSION ? $adf6e692feb2b673$var$stringifyWithSymbolsFix : $adf6e692feb2b673$var$$stringify, null, args);
        return $adf6e692feb2b673$var$ILL_FORMED_UNICODE && typeof result == 'string' ? $adf6e692feb2b673$var$replace(result, $adf6e692feb2b673$var$tester, $adf6e692feb2b673$var$fixIllFormed) : result;
    }
});

});
parcelRegister("4CzJ8", function(module, exports) {
'use strict';

var $a7J4S = parcelRequire("a7J4S");

var $7fGqM = parcelRequire("7fGqM");

var $dhqq1 = parcelRequire("dhqq1");

var $8GC9A = parcelRequire("8GC9A");

var $dkJsu = parcelRequire("dkJsu");
var $35d66cae568e22d9$var$push = $a7J4S([].push);
module.exports = function(replacer) {
    if ($dhqq1(replacer)) return replacer;
    if (!$7fGqM(replacer)) return;
    var rawLength = replacer.length;
    var keys = [];
    for(var i = 0; i < rawLength; i++){
        var element = replacer[i];
        if (typeof element == 'string') $35d66cae568e22d9$var$push(keys, element);
        else if (typeof element == 'number' || $8GC9A(element) === 'Number' || $8GC9A(element) === 'String') $35d66cae568e22d9$var$push(keys, $dkJsu(element));
    }
    var keysLength = keys.length;
    var root = true;
    return function(key, value) {
        if (root) {
            root = false;
            return value;
        }
        if ($7fGqM(this)) return value;
        for(var j = 0; j < keysLength; j++)if (keys[j] === key) return value;
    };
};

});




parcelRegister("Sohz8", function(module, exports) {
'use strict';

var $h8GX6 = parcelRequire("h8GX6");
parcelRequire("4grrK");
module.exports = $h8GX6;

});
parcelRegister("h8GX6", function(module, exports) {
'use strict';
parcelRequire("252bY");
parcelRequire("fV846");
parcelRequire("iggdM");
parcelRequire("9kCvN");

var $aYgYj = parcelRequire("aYgYj");
module.exports = $aYgYj.URLSearchParams;

});
parcelRegister("252bY", function(module, exports) {
'use strict';
parcelRequire("kcIrU");

});
parcelRegister("kcIrU", function(module, exports) {
'use strict';
parcelRequire("9TgNi");
parcelRequire("eUrnB");

var $4lEVJ = parcelRequire("4lEVJ");

var $7bT0n = parcelRequire("7bT0n");

var $fRoIi = parcelRequire("fRoIi");

var $f9yE9 = parcelRequire("f9yE9");

var $jNLWX = parcelRequire("jNLWX");

var $a7J4S = parcelRequire("a7J4S");

var $gd9M7 = parcelRequire("gd9M7");

var $ci2Pl = parcelRequire("ci2Pl");

var $eMkcr = parcelRequire("eMkcr");

var $cQd9a = parcelRequire("cQd9a");

var $9Nahj = parcelRequire("9Nahj");

var $02Gfw = parcelRequire("02Gfw");

var $9PKjp = parcelRequire("9PKjp");

var $4eLp1 = parcelRequire("4eLp1");

var $fCtNa = parcelRequire("fCtNa");

var $dhqq1 = parcelRequire("dhqq1");

var $eNRkB = parcelRequire("eNRkB");

var $bRGXy = parcelRequire("bRGXy");

var $deOGU = parcelRequire("deOGU");

var $2TVT5 = parcelRequire("2TVT5");

var $b89GE = parcelRequire("b89GE");

var $dkJsu = parcelRequire("dkJsu");

var $eSuVM = parcelRequire("eSuVM");

var $hPKB8 = parcelRequire("hPKB8");

var $34Mm3 = parcelRequire("34Mm3");

var $exUnz = parcelRequire("exUnz");

var $4yOyj = parcelRequire("4yOyj");

var $2QlrD = parcelRequire("2QlrD");

var $jMgf3 = parcelRequire("jMgf3");

var $5kxs7 = parcelRequire("5kxs7");
var $eb5768557a0316c3$var$ITERATOR = $jMgf3('iterator');
var $eb5768557a0316c3$var$URL_SEARCH_PARAMS = 'URLSearchParams';
var $eb5768557a0316c3$var$URL_SEARCH_PARAMS_ITERATOR = $eb5768557a0316c3$var$URL_SEARCH_PARAMS + 'Iterator';
var $eb5768557a0316c3$var$setInternalState = $4eLp1.set;
var $eb5768557a0316c3$var$getInternalParamsState = $4eLp1.getterFor($eb5768557a0316c3$var$URL_SEARCH_PARAMS);
var $eb5768557a0316c3$var$getInternalIteratorState = $4eLp1.getterFor($eb5768557a0316c3$var$URL_SEARCH_PARAMS_ITERATOR);
var $eb5768557a0316c3$var$nativeFetch = $fRoIi('fetch');
var $eb5768557a0316c3$var$NativeRequest = $fRoIi('Request');
var $eb5768557a0316c3$var$Headers = $fRoIi('Headers');
var $eb5768557a0316c3$var$RequestPrototype = $eb5768557a0316c3$var$NativeRequest && $eb5768557a0316c3$var$NativeRequest.prototype;
var $eb5768557a0316c3$var$HeadersPrototype = $eb5768557a0316c3$var$Headers && $eb5768557a0316c3$var$Headers.prototype;
var $eb5768557a0316c3$var$TypeError = $7bT0n.TypeError;
var $eb5768557a0316c3$var$encodeURIComponent = $7bT0n.encodeURIComponent;
var $eb5768557a0316c3$var$fromCharCode = String.fromCharCode;
var $eb5768557a0316c3$var$fromCodePoint = $f9yE9('String', 'fromCodePoint');
var $eb5768557a0316c3$var$$parseInt = parseInt;
var $eb5768557a0316c3$var$charAt = $a7J4S(''.charAt);
var $eb5768557a0316c3$var$join = $a7J4S([].join);
var $eb5768557a0316c3$var$push = $a7J4S([].push);
var $eb5768557a0316c3$var$replace = $a7J4S(''.replace);
var $eb5768557a0316c3$var$shift = $a7J4S([].shift);
var $eb5768557a0316c3$var$splice = $a7J4S([].splice);
var $eb5768557a0316c3$var$split = $a7J4S(''.split);
var $eb5768557a0316c3$var$stringSlice = $a7J4S(''.slice);
var $eb5768557a0316c3$var$exec = $a7J4S(/./.exec);
var $eb5768557a0316c3$var$plus = /\+/g;
var $eb5768557a0316c3$var$FALLBACK_REPLACER = '\uFFFD';
var $eb5768557a0316c3$var$VALID_HEX = /^[0-9a-f]+$/i;
var $eb5768557a0316c3$var$parseHexOctet = function parseHexOctet(string, start) {
    var substr = $eb5768557a0316c3$var$stringSlice(string, start, start + 2);
    if (!$eb5768557a0316c3$var$exec($eb5768557a0316c3$var$VALID_HEX, substr)) return NaN;
    return $eb5768557a0316c3$var$$parseInt(substr, 16);
};
var $eb5768557a0316c3$var$getLeadingOnes = function getLeadingOnes(octet) {
    var count = 0;
    for(var mask = 0x80; mask > 0 && (octet & mask) !== 0; mask >>= 1)count++;
    return count;
};
var $eb5768557a0316c3$var$utf8Decode = function utf8Decode(octets) {
    var codePoint = null;
    switch(octets.length){
        case 1:
            codePoint = octets[0];
            break;
        case 2:
            codePoint = (octets[0] & 0x1F) << 6 | octets[1] & 0x3F;
            break;
        case 3:
            codePoint = (octets[0] & 0x0F) << 12 | (octets[1] & 0x3F) << 6 | octets[2] & 0x3F;
            break;
        case 4:
            codePoint = (octets[0] & 0x07) << 18 | (octets[1] & 0x3F) << 12 | (octets[2] & 0x3F) << 6 | octets[3] & 0x3F;
            break;
    }
    return codePoint > 0x10FFFF ? null : codePoint;
};
var $eb5768557a0316c3$var$decode = function decode(input) {
    input = $eb5768557a0316c3$var$replace(input, $eb5768557a0316c3$var$plus, ' ');
    var length = input.length;
    var result = '';
    var i = 0;
    while(i < length){
        var decodedChar = $eb5768557a0316c3$var$charAt(input, i);
        if (decodedChar === '%') {
            if ($eb5768557a0316c3$var$charAt(input, i + 1) === '%' || i + 3 > length) {
                result += '%';
                i++;
                continue;
            }
            var octet = $eb5768557a0316c3$var$parseHexOctet(input, i + 1);
            // eslint-disable-next-line no-self-compare -- NaN check
            if (octet !== octet) {
                result += decodedChar;
                i++;
                continue;
            }
            i += 2;
            var byteSequenceLength = $eb5768557a0316c3$var$getLeadingOnes(octet);
            if (byteSequenceLength === 0) decodedChar = $eb5768557a0316c3$var$fromCharCode(octet);
            else {
                if (byteSequenceLength === 1 || byteSequenceLength > 4) {
                    result += $eb5768557a0316c3$var$FALLBACK_REPLACER;
                    i++;
                    continue;
                }
                var octets = [
                    octet
                ];
                var sequenceIndex = 1;
                while(sequenceIndex < byteSequenceLength){
                    i++;
                    if (i + 3 > length || $eb5768557a0316c3$var$charAt(input, i) !== '%') break;
                    var nextByte = $eb5768557a0316c3$var$parseHexOctet(input, i + 1);
                    // eslint-disable-next-line no-self-compare -- NaN check
                    if (nextByte !== nextByte) {
                        i += 3;
                        break;
                    }
                    if (nextByte > 191 || nextByte < 128) break;
                    $eb5768557a0316c3$var$push(octets, nextByte);
                    i += 2;
                    sequenceIndex++;
                }
                if (octets.length !== byteSequenceLength) {
                    result += $eb5768557a0316c3$var$FALLBACK_REPLACER;
                    continue;
                }
                var codePoint = $eb5768557a0316c3$var$utf8Decode(octets);
                if (codePoint === null) result += $eb5768557a0316c3$var$FALLBACK_REPLACER;
                else decodedChar = $eb5768557a0316c3$var$fromCodePoint(codePoint);
            }
        }
        result += decodedChar;
        i++;
    }
    return result;
};
var $eb5768557a0316c3$var$find = /[!'()~]|%20/g;
var $eb5768557a0316c3$var$replacements = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+'
};
var $eb5768557a0316c3$var$replacer = function replacer(match) {
    return $eb5768557a0316c3$var$replacements[match];
};
var $eb5768557a0316c3$var$serialize = function serialize(it) {
    return $eb5768557a0316c3$var$replace($eb5768557a0316c3$var$encodeURIComponent(it), $eb5768557a0316c3$var$find, $eb5768557a0316c3$var$replacer);
};
var $eb5768557a0316c3$var$URLSearchParamsIterator = $9PKjp(function Iterator(params, kind) {
    $eb5768557a0316c3$var$setInternalState(this, {
        type: $eb5768557a0316c3$var$URL_SEARCH_PARAMS_ITERATOR,
        target: $eb5768557a0316c3$var$getInternalParamsState(params).entries,
        index: 0,
        kind: kind
    });
}, $eb5768557a0316c3$var$URL_SEARCH_PARAMS, function next() {
    var state = $eb5768557a0316c3$var$getInternalIteratorState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = null;
        return $4yOyj(undefined, true);
    }
    var entry = target[index];
    switch(state.kind){
        case 'keys':
            return $4yOyj(entry.key, false);
        case 'values':
            return $4yOyj(entry.value, false);
    }
    return $4yOyj([
        entry.key,
        entry.value
    ], false);
}, true);
var $eb5768557a0316c3$var$URLSearchParamsState = function URLSearchParamsState(init) {
    this.entries = [];
    this.url = null;
    if (init !== undefined) {
        if ($b89GE(init)) this.parseObject(init);
        else this.parseQuery(typeof init == 'string' ? $eb5768557a0316c3$var$charAt(init, 0) === '?' ? $eb5768557a0316c3$var$stringSlice(init, 1) : init : $dkJsu(init));
    }
};
$eb5768557a0316c3$var$URLSearchParamsState.prototype = {
    type: $eb5768557a0316c3$var$URL_SEARCH_PARAMS,
    bindURL: function bindURL(url) {
        this.url = url;
        this.update();
    },
    parseObject: function parseObject(object) {
        var entries = this.entries;
        var iteratorMethod = $exUnz(object);
        var iterator, next, step, entryIterator, entryNext, first, second;
        if (iteratorMethod) {
            iterator = $34Mm3(object, iteratorMethod);
            next = iterator.next;
            while(!(step = $jNLWX(next, iterator)).done){
                entryIterator = $34Mm3($2TVT5(step.value));
                entryNext = entryIterator.next;
                if ((first = $jNLWX(entryNext, entryIterator)).done || (second = $jNLWX(entryNext, entryIterator)).done || !$jNLWX(entryNext, entryIterator).done) throw new $eb5768557a0316c3$var$TypeError('Expected sequence with length 2');
                $eb5768557a0316c3$var$push(entries, {
                    key: $dkJsu(first.value),
                    value: $dkJsu(second.value)
                });
            }
        } else for(var key in object)if ($eNRkB(object, key)) $eb5768557a0316c3$var$push(entries, {
            key: key,
            value: $dkJsu(object[key])
        });
    },
    parseQuery: function parseQuery(query) {
        if (query) {
            var entries = this.entries;
            var attributes = $eb5768557a0316c3$var$split(query, '&');
            var index = 0;
            var attribute, entry;
            while(index < attributes.length){
                attribute = attributes[index++];
                if (attribute.length) {
                    entry = $eb5768557a0316c3$var$split(attribute, '=');
                    $eb5768557a0316c3$var$push(entries, {
                        key: $eb5768557a0316c3$var$decode($eb5768557a0316c3$var$shift(entry)),
                        value: $eb5768557a0316c3$var$decode($eb5768557a0316c3$var$join(entry, '='))
                    });
                }
            }
        }
    },
    serialize: function serialize1() {
        var entries = this.entries;
        var result = [];
        var index = 0;
        var entry;
        while(index < entries.length){
            entry = entries[index++];
            $eb5768557a0316c3$var$push(result, $eb5768557a0316c3$var$serialize(entry.key) + '=' + $eb5768557a0316c3$var$serialize(entry.value));
        }
        return $eb5768557a0316c3$var$join(result, '&');
    },
    update: function update() {
        this.entries.length = 0;
        this.parseQuery(this.url.query);
    },
    updateURL: function updateURL() {
        if (this.url) this.url.update();
    }
};
// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var $eb5768557a0316c3$var$URLSearchParamsConstructor = function URLSearchParams() {
    $fCtNa(this, $eb5768557a0316c3$var$URLSearchParamsPrototype);
    var init = arguments.length > 0 ? arguments[0] : undefined;
    var state = $eb5768557a0316c3$var$setInternalState(this, new $eb5768557a0316c3$var$URLSearchParamsState(init));
    if (!$gd9M7) this.size = state.entries.length;
};
var $eb5768557a0316c3$var$URLSearchParamsPrototype = $eb5768557a0316c3$var$URLSearchParamsConstructor.prototype;
$9Nahj($eb5768557a0316c3$var$URLSearchParamsPrototype, {
    // `URLSearchParams.prototype.append` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-append
    append: function append(name, value) {
        var state = $eb5768557a0316c3$var$getInternalParamsState(this);
        $2QlrD(arguments.length, 2);
        $eb5768557a0316c3$var$push(state.entries, {
            key: $dkJsu(name),
            value: $dkJsu(value)
        });
        if (!$gd9M7) this.length++;
        state.updateURL();
    },
    // `URLSearchParams.prototype.delete` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
    'delete': function(name /* , value */ ) {
        var state = $eb5768557a0316c3$var$getInternalParamsState(this);
        var length = $2QlrD(arguments.length, 1);
        var entries = state.entries;
        var key = $dkJsu(name);
        var $value = length < 2 ? undefined : arguments[1];
        var value = $value === undefined ? $value : $dkJsu($value);
        var index = 0;
        while(index < entries.length){
            var entry = entries[index];
            if (entry.key === key && (value === undefined || entry.value === value)) {
                $eb5768557a0316c3$var$splice(entries, index, 1);
                if (value !== undefined) break;
            } else index++;
        }
        if (!$gd9M7) this.size = entries.length;
        state.updateURL();
    },
    // `URLSearchParams.prototype.get` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-get
    get: function get(name) {
        var entries = $eb5768557a0316c3$var$getInternalParamsState(this).entries;
        $2QlrD(arguments.length, 1);
        var key = $dkJsu(name);
        var index = 0;
        for(; index < entries.length; index++){
            if (entries[index].key === key) return entries[index].value;
        }
        return null;
    },
    // `URLSearchParams.prototype.getAll` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
    getAll: function getAll(name) {
        var entries = $eb5768557a0316c3$var$getInternalParamsState(this).entries;
        $2QlrD(arguments.length, 1);
        var key = $dkJsu(name);
        var result = [];
        var index = 0;
        for(; index < entries.length; index++)if (entries[index].key === key) $eb5768557a0316c3$var$push(result, entries[index].value);
        return result;
    },
    // `URLSearchParams.prototype.has` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-has
    has: function has(name /* , value */ ) {
        var entries = $eb5768557a0316c3$var$getInternalParamsState(this).entries;
        var length = $2QlrD(arguments.length, 1);
        var key = $dkJsu(name);
        var $value = length < 2 ? undefined : arguments[1];
        var value = $value === undefined ? $value : $dkJsu($value);
        var index = 0;
        while(index < entries.length){
            var entry = entries[index++];
            if (entry.key === key && (value === undefined || entry.value === value)) return true;
        }
        return false;
    },
    // `URLSearchParams.prototype.set` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-set
    set: function set(name, value) {
        var state = $eb5768557a0316c3$var$getInternalParamsState(this);
        $2QlrD(arguments.length, 1);
        var entries = state.entries;
        var found = false;
        var key = $dkJsu(name);
        var val = $dkJsu(value);
        var index = 0;
        var entry;
        for(; index < entries.length; index++){
            entry = entries[index];
            if (entry.key === key) {
                if (found) $eb5768557a0316c3$var$splice(entries, index--, 1);
                else {
                    found = true;
                    entry.value = val;
                }
            }
        }
        if (!found) $eb5768557a0316c3$var$push(entries, {
            key: key,
            value: val
        });
        if (!$gd9M7) this.size = entries.length;
        state.updateURL();
    },
    // `URLSearchParams.prototype.sort` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
    sort: function sort() {
        var state = $eb5768557a0316c3$var$getInternalParamsState(this);
        $5kxs7(state.entries, function(a, b) {
            return a.key > b.key ? 1 : -1;
        });
        state.updateURL();
    },
    // `URLSearchParams.prototype.forEach` method
    forEach: function forEach(callback /* , thisArg */ ) {
        var entries = $eb5768557a0316c3$var$getInternalParamsState(this).entries;
        var boundFunction = $bRGXy(callback, arguments.length > 1 ? arguments[1] : undefined);
        var index = 0;
        var entry;
        while(index < entries.length){
            entry = entries[index++];
            boundFunction(entry.value, entry.key, this);
        }
    },
    // `URLSearchParams.prototype.keys` method
    keys: function keys() {
        return new $eb5768557a0316c3$var$URLSearchParamsIterator(this, 'keys');
    },
    // `URLSearchParams.prototype.values` method
    values: function values() {
        return new $eb5768557a0316c3$var$URLSearchParamsIterator(this, 'values');
    },
    // `URLSearchParams.prototype.entries` method
    entries: function entries() {
        return new $eb5768557a0316c3$var$URLSearchParamsIterator(this, 'entries');
    }
}, {
    enumerable: true
});
// `URLSearchParams.prototype[@@iterator]` method
$eMkcr($eb5768557a0316c3$var$URLSearchParamsPrototype, $eb5768557a0316c3$var$ITERATOR, $eb5768557a0316c3$var$URLSearchParamsPrototype.entries, {
    name: 'entries'
});
// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
$eMkcr($eb5768557a0316c3$var$URLSearchParamsPrototype, 'toString', function toString() {
    return $eb5768557a0316c3$var$getInternalParamsState(this).serialize();
}, {
    enumerable: true
});
// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if ($gd9M7) $cQd9a($eb5768557a0316c3$var$URLSearchParamsPrototype, 'size', {
    get: function size() {
        return $eb5768557a0316c3$var$getInternalParamsState(this).entries.length;
    },
    configurable: true,
    enumerable: true
});
$02Gfw($eb5768557a0316c3$var$URLSearchParamsConstructor, $eb5768557a0316c3$var$URL_SEARCH_PARAMS);
$4lEVJ({
    global: true,
    constructor: true,
    forced: !$ci2Pl
}, {
    URLSearchParams: $eb5768557a0316c3$var$URLSearchParamsConstructor
});
// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!$ci2Pl && $dhqq1($eb5768557a0316c3$var$Headers)) {
    var $eb5768557a0316c3$var$headersHas = $a7J4S($eb5768557a0316c3$var$HeadersPrototype.has);
    var $eb5768557a0316c3$var$headersSet = $a7J4S($eb5768557a0316c3$var$HeadersPrototype.set);
    var $eb5768557a0316c3$var$wrapRequestOptions = function wrapRequestOptions(init) {
        if ($b89GE(init)) {
            var body = init.body;
            var headers;
            if ($deOGU(body) === $eb5768557a0316c3$var$URL_SEARCH_PARAMS) {
                headers = init.headers ? new $eb5768557a0316c3$var$Headers(init.headers) : new $eb5768557a0316c3$var$Headers();
                if (!$eb5768557a0316c3$var$headersHas(headers, 'content-type')) $eb5768557a0316c3$var$headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                return $eSuVM(init, {
                    body: $hPKB8(0, $dkJsu(body)),
                    headers: $hPKB8(0, headers)
                });
            }
        }
        return init;
    };
    if ($dhqq1($eb5768557a0316c3$var$nativeFetch)) $4lEVJ({
        global: true,
        enumerable: true,
        dontCallGetSet: true,
        forced: true
    }, {
        fetch: function fetch(input /* , init */ ) {
            return $eb5768557a0316c3$var$nativeFetch(input, arguments.length > 1 ? $eb5768557a0316c3$var$wrapRequestOptions(arguments[1]) : {});
        }
    });
    if ($dhqq1($eb5768557a0316c3$var$NativeRequest)) {
        var $eb5768557a0316c3$var$RequestConstructor = function Request(input /* , init */ ) {
            $fCtNa(this, $eb5768557a0316c3$var$RequestPrototype);
            return new $eb5768557a0316c3$var$NativeRequest(input, arguments.length > 1 ? $eb5768557a0316c3$var$wrapRequestOptions(arguments[1]) : {});
        };
        $eb5768557a0316c3$var$RequestPrototype.constructor = $eb5768557a0316c3$var$RequestConstructor;
        $eb5768557a0316c3$var$RequestConstructor.prototype = $eb5768557a0316c3$var$RequestPrototype;
        $4lEVJ({
            global: true,
            constructor: true,
            dontCallGetSet: true,
            forced: true
        }, {
            Request: $eb5768557a0316c3$var$RequestConstructor
        });
    }
}
module.exports = {
    URLSearchParams: $eb5768557a0316c3$var$URLSearchParamsConstructor,
    getState: $eb5768557a0316c3$var$getInternalParamsState
};

});
parcelRegister("9TgNi", function(module, exports) {
'use strict';

var $813PX = parcelRequire("813PX");

var $lJZNu = parcelRequire("lJZNu");

var $8lEBM = parcelRequire("8lEBM");

var $4eLp1 = parcelRequire("4eLp1");

var $1VaAS = parcelRequire("1VaAS");
var $733647149e3d80b3$require$defineProperty = $1VaAS.f;

var $5Taks = parcelRequire("5Taks");

var $4yOyj = parcelRequire("4yOyj");

var $fhkpi = parcelRequire("fhkpi");

var $gd9M7 = parcelRequire("gd9M7");
var $733647149e3d80b3$var$ARRAY_ITERATOR = 'Array Iterator';
var $733647149e3d80b3$var$setInternalState = $4eLp1.set;
var $733647149e3d80b3$var$getInternalState = $4eLp1.getterFor($733647149e3d80b3$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = $5Taks(Array, 'Array', function(iterated, kind) {
    $733647149e3d80b3$var$setInternalState(this, {
        type: $733647149e3d80b3$var$ARRAY_ITERATOR,
        target: $813PX(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $733647149e3d80b3$var$getInternalState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = null;
        return $4yOyj(undefined, true);
    }
    switch(state.kind){
        case 'keys':
            return $4yOyj(index, false);
        case 'values':
            return $4yOyj(target[index], false);
    }
    return $4yOyj([
        index,
        target[index]
    ], false);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $733647149e3d80b3$var$values = $8lEBM.Arguments = $8lEBM.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$lJZNu('keys');
$lJZNu('values');
$lJZNu('entries');
// V8 ~ Chrome 45- bug
if (!$fhkpi && $gd9M7 && $733647149e3d80b3$var$values.name !== 'values') try {
    $733647149e3d80b3$require$defineProperty($733647149e3d80b3$var$values, 'name', {
        value: 'values'
    });
} catch (error) {}

});
parcelRegister("lJZNu", function(module, exports) {
'use strict';
module.exports = function() {};

});


parcelRegister("eUrnB", function(module, exports) {
'use strict';

var $4lEVJ = parcelRequire("4lEVJ");

var $a7J4S = parcelRequire("a7J4S");

var $42BY2 = parcelRequire("42BY2");
var $adab88aed31dad96$var$$RangeError = RangeError;
var $adab88aed31dad96$var$fromCharCode = String.fromCharCode;
// eslint-disable-next-line es/no-string-fromcodepoint -- required for testing
var $adab88aed31dad96$var$$fromCodePoint = String.fromCodePoint;
var $adab88aed31dad96$var$join = $a7J4S([].join);
// length should be 1, old FF problem
var $adab88aed31dad96$var$INCORRECT_LENGTH = !!$adab88aed31dad96$var$$fromCodePoint && $adab88aed31dad96$var$$fromCodePoint.length !== 1;
// `String.fromCodePoint` method
// https://tc39.es/ecma262/#sec-string.fromcodepoint
$4lEVJ({
    target: 'String',
    stat: true,
    arity: 1,
    forced: $adab88aed31dad96$var$INCORRECT_LENGTH
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    fromCodePoint: function fromCodePoint(x) {
        var elements = [];
        var length = arguments.length;
        var i = 0;
        var code;
        while(length > i){
            code = +arguments[i++];
            if ($42BY2(code, 0x10FFFF) !== code) throw new $adab88aed31dad96$var$$RangeError(code + ' is not a valid code point');
            elements[i] = code < 0x10000 ? $adab88aed31dad96$var$fromCharCode(code) : $adab88aed31dad96$var$fromCharCode(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00);
        }
        return $adab88aed31dad96$var$join(elements, '');
    }
});

});

parcelRegister("fRoIi", function(module, exports) {
'use strict';

var $7bT0n = parcelRequire("7bT0n");

var $gd9M7 = parcelRequire("gd9M7");
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $b8bef9d60f70ed78$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Avoid NodeJS experimental warning
module.exports = function(name) {
    if (!$gd9M7) return $7bT0n[name];
    var descriptor = $b8bef9d60f70ed78$var$getOwnPropertyDescriptor($7bT0n, name);
    return descriptor && descriptor.value;
};

});

parcelRegister("ci2Pl", function(module, exports) {
'use strict';

var $lLFjY = parcelRequire("lLFjY");

var $jMgf3 = parcelRequire("jMgf3");

var $gd9M7 = parcelRequire("gd9M7");

var $fhkpi = parcelRequire("fhkpi");
var $8f295bdcb626c5bf$var$ITERATOR = $jMgf3('iterator');
module.exports = !$lLFjY(function() {
    // eslint-disable-next-line unicorn/relative-url-style -- required for testing
    var url = new URL('b?a=1&b=2&c=3', 'https://a');
    var params = url.searchParams;
    var params2 = new URLSearchParams('a=1&a=2&b=3');
    var result = '';
    url.pathname = 'c%20d';
    params.forEach(function(value, key) {
        params['delete']('b');
        result += key + value;
    });
    params2['delete']('a', 2);
    // `undefined` case is a Chromium 117 bug
    // https://bugs.chromium.org/p/v8/issues/detail?id=14222
    params2['delete']('b', undefined);
    return $fhkpi && (!url.toJSON || !params2.has('a', 1) || params2.has('a', 2) || !params2.has('a', undefined) || params2.has('b')) || !params.size && ($fhkpi || !$gd9M7) || !params.sort || url.href !== 'https://a/c%20d?a=1&c=3' || params.get('c') !== '3' || String(new URLSearchParams('?a=1')) !== 'a=1' || !params[$8f295bdcb626c5bf$var$ITERATOR] || new URL('https://a@b').username !== 'a' || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b' || new URL("https://\u0442\u0435\u0441\u0442").host !== 'xn--e1aybc' || new URL("https://a#\u0431").hash !== '#%D0%B1' || result !== 'a1c3' || new URL('https://x', undefined).host !== 'x';
});

});

parcelRegister("cQd9a", function(module, exports) {
'use strict';

var $1VaAS = parcelRequire("1VaAS");
module.exports = function(target, name, descriptor) {
    return $1VaAS.f(target, name, descriptor);
};

});

parcelRegister("9Nahj", function(module, exports) {
'use strict';

var $eMkcr = parcelRequire("eMkcr");
module.exports = function(target, src, options) {
    for(var key in src)if (options && options.unsafe && target[key]) target[key] = src[key];
    else $eMkcr(target, key, src[key], options);
    return target;
};

});

parcelRegister("fCtNa", function(module, exports) {
'use strict';

var $goSny = parcelRequire("goSny");
var $b5f183b88fbbd158$var$$TypeError = TypeError;
module.exports = function(it, Prototype) {
    if ($goSny(Prototype, it)) return it;
    throw new $b5f183b88fbbd158$var$$TypeError('Incorrect invocation');
};

});

parcelRegister("2QlrD", function(module, exports) {
'use strict';
var $212112943e339a02$var$$TypeError = TypeError;
module.exports = function(passed, required) {
    if (passed < required) throw new $212112943e339a02$var$$TypeError('Not enough arguments');
    return passed;
};

});



parcelRegister("fV846", function(module, exports) {
// empty

});

parcelRegister("iggdM", function(module, exports) {
// empty

});

parcelRegister("9kCvN", function(module, exports) {
// empty

});


parcelRegister("4grrK", function(module, exports) {
'use strict';
parcelRequire("9TgNi");

var $2Ez4E = parcelRequire("2Ez4E");

var $7bT0n = parcelRequire("7bT0n");

var $02Gfw = parcelRequire("02Gfw");

var $8lEBM = parcelRequire("8lEBM");
for(var $31adf2619da0551d$var$COLLECTION_NAME in $2Ez4E){
    $02Gfw($7bT0n[$31adf2619da0551d$var$COLLECTION_NAME], $31adf2619da0551d$var$COLLECTION_NAME);
    $8lEBM[$31adf2619da0551d$var$COLLECTION_NAME] = $8lEBM.Array;
}

});
parcelRegister("2Ez4E", function(module, exports) {
'use strict';
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};

});



parcelRegister("aQ3l1", function(module, exports) {
'use strict';

var $97Cgm = parcelRequire("97Cgm");
module.exports = $97Cgm;

});
parcelRegister("97Cgm", function(module, exports) {
'use strict';

var $goSny = parcelRequire("goSny");

var $5Wm7i = parcelRequire("5Wm7i");

var $d20uh = parcelRequire("d20uh");
var $6a4272b2e3988e7e$var$ArrayPrototype = Array.prototype;
var $6a4272b2e3988e7e$var$StringPrototype = String.prototype;
module.exports = function(it) {
    var own = it.includes;
    if (it === $6a4272b2e3988e7e$var$ArrayPrototype || $goSny($6a4272b2e3988e7e$var$ArrayPrototype, it) && own === $6a4272b2e3988e7e$var$ArrayPrototype.includes) return $5Wm7i;
    if (typeof it == 'string' || it === $6a4272b2e3988e7e$var$StringPrototype || $goSny($6a4272b2e3988e7e$var$StringPrototype, it) && own === $6a4272b2e3988e7e$var$StringPrototype.includes) return $d20uh;
    return own;
};

});
parcelRegister("5Wm7i", function(module, exports) {
'use strict';
parcelRequire("6NVPn");

var $gdkJ6 = parcelRequire("gdkJ6");
module.exports = $gdkJ6('Array', 'includes');

});
parcelRegister("6NVPn", function(module, exports) {
'use strict';

var $4lEVJ = parcelRequire("4lEVJ");

var $85gaR = parcelRequire("85gaR");
var $4f442d0bfef5045e$require$$includes = $85gaR.includes;

var $lLFjY = parcelRequire("lLFjY");

var $lJZNu = parcelRequire("lJZNu");
// FF99+ bug
var $4f442d0bfef5045e$var$BROKEN_ON_SPARSE = $lLFjY(function() {
    // eslint-disable-next-line es/no-array-prototype-includes -- detection
    return !Array(1).includes();
});
// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$4lEVJ({
    target: 'Array',
    proto: true,
    forced: $4f442d0bfef5045e$var$BROKEN_ON_SPARSE
}, {
    includes: function includes(el /* , fromIndex = 0 */ ) {
        return $4f442d0bfef5045e$require$$includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$lJZNu('includes');

});


parcelRegister("d20uh", function(module, exports) {
'use strict';
parcelRequire("beMdZ");

var $gdkJ6 = parcelRequire("gdkJ6");
module.exports = $gdkJ6('String', 'includes');

});
parcelRegister("beMdZ", function(module, exports) {
'use strict';

var $4lEVJ = parcelRequire("4lEVJ");

var $a7J4S = parcelRequire("a7J4S");

var $adYou = parcelRequire("adYou");

var $fgGOS = parcelRequire("fgGOS");

var $dkJsu = parcelRequire("dkJsu");

var $ciQB3 = parcelRequire("ciQB3");
var $82e668efd84a1d66$var$stringIndexOf = $a7J4S(''.indexOf);
// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$4lEVJ({
    target: 'String',
    proto: true,
    forced: !$ciQB3('includes')
}, {
    includes: function includes(searchString /* , position = 0 */ ) {
        return !!~$82e668efd84a1d66$var$stringIndexOf($dkJsu($fgGOS(this)), $dkJsu($adYou(searchString)), arguments.length > 1 ? arguments[1] : undefined);
    }
});

});




parcelRegister("a1Gfq", function(module, exports) {
'use strict';

var $jrAia = parcelRequire("jrAia");
module.exports = $jrAia;

});
parcelRegister("jrAia", function(module, exports) {
'use strict';

var $goSny = parcelRequire("goSny");

var $7Jxom = parcelRequire("7Jxom");
var $e27cb0cc95d53a92$var$StringPrototype = String.prototype;
module.exports = function(it) {
    var own = it.trim;
    return typeof it == 'string' || it === $e27cb0cc95d53a92$var$StringPrototype || $goSny($e27cb0cc95d53a92$var$StringPrototype, it) && own === $e27cb0cc95d53a92$var$StringPrototype.trim ? $7Jxom : own;
};

});
parcelRegister("7Jxom", function(module, exports) {
'use strict';
parcelRequire("dknpr");

var $gdkJ6 = parcelRequire("gdkJ6");
module.exports = $gdkJ6('String', 'trim');

});
parcelRegister("dknpr", function(module, exports) {
'use strict';

var $4lEVJ = parcelRequire("4lEVJ");

var $1U5XR = parcelRequire("1U5XR");
var $9b3f4d3c350bc8b7$require$$trim = $1U5XR.trim;

var $lU7vB = parcelRequire("lU7vB");
// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$4lEVJ({
    target: 'String',
    proto: true,
    forced: $lU7vB('trim')
}, {
    trim: function trim() {
        return $9b3f4d3c350bc8b7$require$$trim(this);
    }
});

});
parcelRegister("1U5XR", function(module, exports) {
'use strict';

var $a7J4S = parcelRequire("a7J4S");

var $fgGOS = parcelRequire("fgGOS");

var $dkJsu = parcelRequire("dkJsu");

var $4LbtL = parcelRequire("4LbtL");
var $162fa5d5967f8920$var$replace = $a7J4S(''.replace);
var $162fa5d5967f8920$var$ltrim = RegExp('^[' + $4LbtL + ']+');
var $162fa5d5967f8920$var$rtrim = RegExp('(^|[^' + $4LbtL + '])[' + $4LbtL + ']+$');
// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var $162fa5d5967f8920$var$createMethod = function createMethod(TYPE) {
    return function($this) {
        var string = $dkJsu($fgGOS($this));
        if (TYPE & 1) string = $162fa5d5967f8920$var$replace(string, $162fa5d5967f8920$var$ltrim, '');
        if (TYPE & 2) string = $162fa5d5967f8920$var$replace(string, $162fa5d5967f8920$var$rtrim, '$1');
        return string;
    };
};
module.exports = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: $162fa5d5967f8920$var$createMethod(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: $162fa5d5967f8920$var$createMethod(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: $162fa5d5967f8920$var$createMethod(3)
};

});
parcelRegister("4LbtL", function(module, exports) {
'use strict';
// a string of all valid unicode whitespaces
module.exports = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";

});


parcelRegister("lU7vB", function(module, exports) {
'use strict';

var $f5iOX = parcelRequire("f5iOX");
var $ff24a6fe1ec373a2$require$PROPER_FUNCTION_NAME = $f5iOX.PROPER;

var $lLFjY = parcelRequire("lLFjY");

var $4LbtL = parcelRequire("4LbtL");
var $ff24a6fe1ec373a2$var$non = '\u200B\u0085\u180E';
// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function(METHOD_NAME) {
    return $lLFjY(function() {
        return !!$4LbtL[METHOD_NAME]() || $ff24a6fe1ec373a2$var$non[METHOD_NAME]() !== $ff24a6fe1ec373a2$var$non || $ff24a6fe1ec373a2$require$PROPER_FUNCTION_NAME && $4LbtL[METHOD_NAME].name !== METHOD_NAME;
    });
};

});





parcelRegister("iBHH7", function(module, exports) {
'use strict';

var $sqykI = parcelRequire("sqykI");
module.exports = $sqykI;

});
parcelRegister("sqykI", function(module, exports) {
'use strict';

var $goSny = parcelRequire("goSny");

var $fAaYS = parcelRequire("fAaYS");
var $0557367708d21253$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.map;
    return it === $0557367708d21253$var$ArrayPrototype || $goSny($0557367708d21253$var$ArrayPrototype, it) && own === $0557367708d21253$var$ArrayPrototype.map ? $fAaYS : own;
};

});
parcelRegister("fAaYS", function(module, exports) {
'use strict';
parcelRequire("6HUrQ");

var $gdkJ6 = parcelRequire("gdkJ6");
module.exports = $gdkJ6('Array', 'map');

});
parcelRegister("6HUrQ", function(module, exports) {
'use strict';

var $4lEVJ = parcelRequire("4lEVJ");

var $4yKYN = parcelRequire("4yKYN");
var $4e228ba8e475dd56$require$$map = $4yKYN.map;

var $8PTri = parcelRequire("8PTri");
var $4e228ba8e475dd56$var$HAS_SPECIES_SUPPORT = $8PTri('map');
// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$4lEVJ({
    target: 'Array',
    proto: true,
    forced: !$4e228ba8e475dd56$var$HAS_SPECIES_SUPPORT
}, {
    map: function map(callbackfn /* , thisArg */ ) {
        return $4e228ba8e475dd56$require$$map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

});
parcelRegister("8PTri", function(module, exports) {
'use strict';

var $lLFjY = parcelRequire("lLFjY");

var $jMgf3 = parcelRequire("jMgf3");

var $hymGt = parcelRequire("hymGt");
var $66ee173a36f1871a$var$SPECIES = $jMgf3('species');
module.exports = function(METHOD_NAME) {
    // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/677
    return $hymGt >= 51 || !$lLFjY(function() {
        var array = [];
        var constructor = array.constructor = {};
        constructor[$66ee173a36f1871a$var$SPECIES] = function() {
            return {
                foo: 1
            };
        };
        return array[METHOD_NAME](Boolean).foo !== 1;
    });
};

});





parcelRegister("d9pBi", function(module, exports) {
'use strict';

var $axPW7 = parcelRequire("axPW7");
module.exports = $axPW7;

});
parcelRegister("axPW7", function(module, exports) {
'use strict';

var $goSny = parcelRequire("goSny");

var $fgRqj = parcelRequire("fgRqj");
var $7ad545ea308ee35e$var$StringPrototype = String.prototype;
module.exports = function(it) {
    var own = it.padStart;
    return typeof it == 'string' || it === $7ad545ea308ee35e$var$StringPrototype || $goSny($7ad545ea308ee35e$var$StringPrototype, it) && own === $7ad545ea308ee35e$var$StringPrototype.padStart ? $fgRqj : own;
};

});
parcelRegister("fgRqj", function(module, exports) {
'use strict';
parcelRequire("gYr7v");

var $gdkJ6 = parcelRequire("gdkJ6");
module.exports = $gdkJ6('String', 'padStart');

});
parcelRegister("gYr7v", function(module, exports) {
'use strict';

var $4lEVJ = parcelRequire("4lEVJ");

var $cGeRK = parcelRequire("cGeRK");
var $c5b7496a7797e083$require$$padStart = $cGeRK.start;

var $l1yMW = parcelRequire("l1yMW");
// `String.prototype.padStart` method
// https://tc39.es/ecma262/#sec-string.prototype.padstart
$4lEVJ({
    target: 'String',
    proto: true,
    forced: $l1yMW
}, {
    padStart: function padStart(maxLength /* , fillString = ' ' */ ) {
        return $c5b7496a7797e083$require$$padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
    }
});

});
parcelRegister("l1yMW", function(module, exports) {
'use strict';

var $7y4D2 = parcelRequire("7y4D2");
module.exports = /Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test($7y4D2);

});





parcelRegister("gbqmo", function(module, exports) {
'use strict';

var $k6pgW = parcelRequire("k6pgW");
module.exports = $k6pgW;

});
parcelRegister("k6pgW", function(module, exports) {
'use strict';

var $goSny = parcelRequire("goSny");

var $iYUsv = parcelRequire("iYUsv");
var $ea27f8b6feb67603$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.slice;
    return it === $ea27f8b6feb67603$var$ArrayPrototype || $goSny($ea27f8b6feb67603$var$ArrayPrototype, it) && own === $ea27f8b6feb67603$var$ArrayPrototype.slice ? $iYUsv : own;
};

});
parcelRegister("iYUsv", function(module, exports) {
'use strict';
parcelRequire("kHdFg");

var $gdkJ6 = parcelRequire("gdkJ6");
module.exports = $gdkJ6('Array', 'slice');

});
parcelRegister("kHdFg", function(module, exports) {
'use strict';

var $4lEVJ = parcelRequire("4lEVJ");

var $7fGqM = parcelRequire("7fGqM");

var $gCj4y = parcelRequire("gCj4y");

var $b89GE = parcelRequire("b89GE");

var $42BY2 = parcelRequire("42BY2");

var $9oxvq = parcelRequire("9oxvq");

var $813PX = parcelRequire("813PX");

var $62K9T = parcelRequire("62K9T");

var $jMgf3 = parcelRequire("jMgf3");

var $8PTri = parcelRequire("8PTri");

var $7D1nL = parcelRequire("7D1nL");
var $f1126c466e9bf63f$var$HAS_SPECIES_SUPPORT = $8PTri('slice');
var $f1126c466e9bf63f$var$SPECIES = $jMgf3('species');
var $f1126c466e9bf63f$var$$Array = Array;
var $f1126c466e9bf63f$var$max = Math.max;
// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$4lEVJ({
    target: 'Array',
    proto: true,
    forced: !$f1126c466e9bf63f$var$HAS_SPECIES_SUPPORT
}, {
    slice: function slice(start, end) {
        var O = $813PX(this);
        var length = $9oxvq(O);
        var k = $42BY2(start, length);
        var fin = $42BY2(end === undefined ? length : end, length);
        // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
        var Constructor, result, n;
        if ($7fGqM(O)) {
            Constructor = O.constructor;
            // cross-realm fallback
            if ($gCj4y(Constructor) && (Constructor === $f1126c466e9bf63f$var$$Array || $7fGqM(Constructor.prototype))) Constructor = undefined;
            else if ($b89GE(Constructor)) {
                Constructor = Constructor[$f1126c466e9bf63f$var$SPECIES];
                if (Constructor === null) Constructor = undefined;
            }
            if (Constructor === $f1126c466e9bf63f$var$$Array || Constructor === undefined) return $7D1nL(O, k, fin);
        }
        result = new (Constructor === undefined ? $f1126c466e9bf63f$var$$Array : Constructor)($f1126c466e9bf63f$var$max(fin - k, 0));
        for(n = 0; k < fin; k++, n++)if (k in O) $62K9T(result, n, O[k]);
        result.length = n;
        return result;
    }
});

});




parcelRegister("d21fN", function(module, exports) {
'use strict';

var $2HHIJ = parcelRequire("2HHIJ");
module.exports = $2HHIJ;

});
parcelRegister("2HHIJ", function(module, exports) {
'use strict';

var $goSny = parcelRequire("goSny");

var $dYH6M = parcelRequire("dYH6M");
var $1f8182e8dc6820d9$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.find;
    return it === $1f8182e8dc6820d9$var$ArrayPrototype || $goSny($1f8182e8dc6820d9$var$ArrayPrototype, it) && own === $1f8182e8dc6820d9$var$ArrayPrototype.find ? $dYH6M : own;
};

});
parcelRegister("dYH6M", function(module, exports) {
'use strict';
parcelRequire("gMPyG");

var $gdkJ6 = parcelRequire("gdkJ6");
module.exports = $gdkJ6('Array', 'find');

});
parcelRegister("gMPyG", function(module, exports) {
'use strict';

var $4lEVJ = parcelRequire("4lEVJ");

var $4yKYN = parcelRequire("4yKYN");
var $c3891f75dc05331b$require$$find = $4yKYN.find;

var $lJZNu = parcelRequire("lJZNu");
var $c3891f75dc05331b$var$FIND = 'find';
var $c3891f75dc05331b$var$SKIPS_HOLES = true;
// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-find -- testing
if ($c3891f75dc05331b$var$FIND in []) Array(1)[$c3891f75dc05331b$var$FIND](function() {
    $c3891f75dc05331b$var$SKIPS_HOLES = false;
});
// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$4lEVJ({
    target: 'Array',
    proto: true,
    forced: $c3891f75dc05331b$var$SKIPS_HOLES
}, {
    find: function find(callbackfn /* , that = undefined */ ) {
        return $c3891f75dc05331b$require$$find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$lJZNu($c3891f75dc05331b$var$FIND);

});




parcelRegister("jhB9V", function(module, exports) {
'use strict';
parcelRequire("35UHQ");

var $aYgYj = parcelRequire("aYgYj");
module.exports = $aYgYj.setTimeout;

});
parcelRegister("35UHQ", function(module, exports) {
'use strict';
parcelRequire("2DRNb");
parcelRequire("h3BRM");

});
parcelRegister("2DRNb", function(module, exports) {
'use strict';

var $4lEVJ = parcelRequire("4lEVJ");

var $7bT0n = parcelRequire("7bT0n");

var $a2ABA = parcelRequire("a2ABA");
var $1ec8f350cf2e20b9$var$setInterval = $a2ABA($7bT0n.setInterval, true);
// Bun / IE9- setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
$4lEVJ({
    global: true,
    bind: true,
    forced: $7bT0n.setInterval !== $1ec8f350cf2e20b9$var$setInterval
}, {
    setInterval: $1ec8f350cf2e20b9$var$setInterval
});

});
parcelRegister("a2ABA", function(module, exports) {
'use strict';

var $7bT0n = parcelRequire("7bT0n");

var $e09lc = parcelRequire("e09lc");

var $dhqq1 = parcelRequire("dhqq1");

var $9JFrs = parcelRequire("9JFrs");

var $7y4D2 = parcelRequire("7y4D2");

var $7D1nL = parcelRequire("7D1nL");

var $2QlrD = parcelRequire("2QlrD");
var $74f67c534ae71d34$var$Function = $7bT0n.Function;
// dirty IE9- and Bun 0.3.0- checks
var $74f67c534ae71d34$var$WRAP = /MSIE .\./.test($7y4D2) || $9JFrs === 'BUN' && function() {
    var version = $7bT0n.Bun.version.split('.');
    return version.length < 3 || version[0] === '0' && (version[1] < 3 || version[1] === '3' && version[2] === '0');
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
module.exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $74f67c534ae71d34$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $2QlrD(arguments.length, 1) > firstParamIndex;
        var fn = $dhqq1(handler) ? handler : $74f67c534ae71d34$var$Function(handler);
        var params = boundArgs ? $7D1nL(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function callback() {
            $e09lc(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};

});
parcelRegister("9JFrs", function(module, exports) {

var $2bfPH = parcelRequire("2bfPH");
'use strict';

var $7bT0n = parcelRequire("7bT0n");

var $7y4D2 = parcelRequire("7y4D2");

var $8GC9A = parcelRequire("8GC9A");
var $71687682517e80f6$var$userAgentStartsWith = function userAgentStartsWith(string) {
    return $7y4D2.slice(0, string.length) === string;
};
module.exports = function() {
    if ($71687682517e80f6$var$userAgentStartsWith('Bun/')) return 'BUN';
    if ($71687682517e80f6$var$userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
    if ($71687682517e80f6$var$userAgentStartsWith('Deno/')) return 'DENO';
    if ($71687682517e80f6$var$userAgentStartsWith('Node.js/')) return 'NODE';
    if ($7bT0n.Bun && typeof Bun.version == 'string') return 'BUN';
    if ($7bT0n.Deno && (0, $2bfPH._)(Deno.version) == 'object') return 'DENO';
    if ($8GC9A($7bT0n.process) === 'process') return 'NODE';
    if ($7bT0n.window && $7bT0n.document) return 'BROWSER';
    return 'REST';
}();

});



parcelRegister("h3BRM", function(module, exports) {
'use strict';

var $4lEVJ = parcelRequire("4lEVJ");

var $7bT0n = parcelRequire("7bT0n");

var $a2ABA = parcelRequire("a2ABA");
var $c6b016f9755a04a8$var$setTimeout = $a2ABA($7bT0n.setTimeout, true);
// Bun / IE9- setTimeout additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
$4lEVJ({
    global: true,
    bind: true,
    forced: $7bT0n.setTimeout !== $c6b016f9755a04a8$var$setTimeout
}, {
    setTimeout: $c6b016f9755a04a8$var$setTimeout
});

});



parcelRegister("7qWrq", function(module, exports) {
'use strict';

var $13F1h = parcelRequire("13F1h");
module.exports = $13F1h;

});
parcelRegister("13F1h", function(module, exports) {
'use strict';

var $goSny = parcelRequire("goSny");

var $jiibD = parcelRequire("jiibD");
var $0c55e3e2812edfcc$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.some;
    return it === $0c55e3e2812edfcc$var$ArrayPrototype || $goSny($0c55e3e2812edfcc$var$ArrayPrototype, it) && own === $0c55e3e2812edfcc$var$ArrayPrototype.some ? $jiibD : own;
};

});
parcelRegister("jiibD", function(module, exports) {
'use strict';
parcelRequire("79RMB");

var $gdkJ6 = parcelRequire("gdkJ6");
module.exports = $gdkJ6('Array', 'some');

});
parcelRegister("79RMB", function(module, exports) {
'use strict';

var $4lEVJ = parcelRequire("4lEVJ");

var $4yKYN = parcelRequire("4yKYN");
var $536317d8b643ec6f$require$$some = $4yKYN.some;

var $9p2uv = parcelRequire("9p2uv");
var $536317d8b643ec6f$var$STRICT_METHOD = $9p2uv('some');
// `Array.prototype.some` method
// https://tc39.es/ecma262/#sec-array.prototype.some
$4lEVJ({
    target: 'Array',
    proto: true,
    forced: !$536317d8b643ec6f$var$STRICT_METHOD
}, {
    some: function some(callbackfn /* , thisArg */ ) {
        return $536317d8b643ec6f$require$$some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

});




parcelRegister("hYDwd", function(module, exports) {
'use strict';

var $6i4co = parcelRequire("6i4co");
module.exports = $6i4co;

});
parcelRegister("6i4co", function(module, exports) {
'use strict';

var $goSny = parcelRequire("goSny");

var $cRweQ = parcelRequire("cRweQ");
var $4947ae4f65121745$var$FunctionPrototype = Function.prototype;
module.exports = function(it) {
    var own = it.bind;
    return it === $4947ae4f65121745$var$FunctionPrototype || $goSny($4947ae4f65121745$var$FunctionPrototype, it) && own === $4947ae4f65121745$var$FunctionPrototype.bind ? $cRweQ : own;
};

});
parcelRegister("cRweQ", function(module, exports) {
'use strict';
parcelRequire("lTDts");

var $gdkJ6 = parcelRequire("gdkJ6");
module.exports = $gdkJ6('Function', 'bind');

});
parcelRegister("lTDts", function(module, exports) {
'use strict';

var $4lEVJ = parcelRequire("4lEVJ");

var $l0Zpc = parcelRequire("l0Zpc");
// `Function.prototype.bind` method
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
$4lEVJ({
    target: 'Function',
    proto: true,
    forced: Function.bind !== $l0Zpc
}, {
    bind: $l0Zpc
});

});
parcelRegister("l0Zpc", function(module, exports) {
'use strict';

var $a7J4S = parcelRequire("a7J4S");

var $6nUOM = parcelRequire("6nUOM");

var $b89GE = parcelRequire("b89GE");

var $eNRkB = parcelRequire("eNRkB");

var $7D1nL = parcelRequire("7D1nL");

var $aajsy = parcelRequire("aajsy");
var $f4c93ae7c0836085$var$$Function = Function;
var $f4c93ae7c0836085$var$concat = $a7J4S([].concat);
var $f4c93ae7c0836085$var$join = $a7J4S([].join);
var $f4c93ae7c0836085$var$factories = {};
var $f4c93ae7c0836085$var$construct = function construct(C, argsLength, args) {
    if (!$eNRkB($f4c93ae7c0836085$var$factories, argsLength)) {
        var list = [];
        var i = 0;
        for(; i < argsLength; i++)list[i] = 'a[' + i + ']';
        $f4c93ae7c0836085$var$factories[argsLength] = $f4c93ae7c0836085$var$$Function('C,a', 'return new C(' + $f4c93ae7c0836085$var$join(list, ',') + ')');
    }
    return $f4c93ae7c0836085$var$factories[argsLength](C, args);
};
// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
module.exports = $aajsy ? $f4c93ae7c0836085$var$$Function.bind : function bind(that /* , ...args */ ) {
    var F = $6nUOM(this);
    var Prototype = F.prototype;
    var partArgs = $7D1nL(arguments, 1);
    var boundFunction = function bound() {
        var args = $f4c93ae7c0836085$var$concat(partArgs, $7D1nL(arguments));
        return this instanceof boundFunction ? $f4c93ae7c0836085$var$construct(F, args.length, args) : F.apply(that, args);
    };
    if ($b89GE(Prototype)) boundFunction.prototype = Prototype;
    return boundFunction;
};

});





parcelRegister("gPyTW", function(module, exports) {
'use strict';

var $cmywj = parcelRequire("cmywj");
module.exports = $cmywj;

});
parcelRegister("cmywj", function(module, exports) {
'use strict';

var $goSny = parcelRequire("goSny");

var $eP6WE = parcelRequire("eP6WE");
var $9002511215eebf7c$var$StringPrototype = String.prototype;
module.exports = function(it) {
    var own = it.endsWith;
    return typeof it == 'string' || it === $9002511215eebf7c$var$StringPrototype || $goSny($9002511215eebf7c$var$StringPrototype, it) && own === $9002511215eebf7c$var$StringPrototype.endsWith ? $eP6WE : own;
};

});
parcelRegister("eP6WE", function(module, exports) {
'use strict';
parcelRequire("8El0s");

var $gdkJ6 = parcelRequire("gdkJ6");
module.exports = $gdkJ6('String', 'endsWith');

});
parcelRegister("8El0s", function(module, exports) {
'use strict';

var $4lEVJ = parcelRequire("4lEVJ");

var $cwspJ = parcelRequire("cwspJ");

var $6cFF8 = parcelRequire("6cFF8");
var $64c25a994c0cb7c2$require$getOwnPropertyDescriptor = $6cFF8.f;

var $dDdnp = parcelRequire("dDdnp");

var $dkJsu = parcelRequire("dkJsu");

var $adYou = parcelRequire("adYou");

var $fgGOS = parcelRequire("fgGOS");

var $ciQB3 = parcelRequire("ciQB3");

var $fhkpi = parcelRequire("fhkpi");
var $64c25a994c0cb7c2$var$slice = $cwspJ(''.slice);
var $64c25a994c0cb7c2$var$min = Math.min;
var $64c25a994c0cb7c2$var$CORRECT_IS_REGEXP_LOGIC = $ciQB3('endsWith');
// https://github.com/zloirock/core-js/pull/702
var $64c25a994c0cb7c2$var$MDN_POLYFILL_BUG = !$fhkpi && !$64c25a994c0cb7c2$var$CORRECT_IS_REGEXP_LOGIC && !!function() {
    var descriptor = $64c25a994c0cb7c2$require$getOwnPropertyDescriptor(String.prototype, 'endsWith');
    return descriptor && !descriptor.writable;
}();
// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
$4lEVJ({
    target: 'String',
    proto: true,
    forced: !$64c25a994c0cb7c2$var$MDN_POLYFILL_BUG && !$64c25a994c0cb7c2$var$CORRECT_IS_REGEXP_LOGIC
}, {
    endsWith: function endsWith(searchString /* , endPosition = @length */ ) {
        var that = $dkJsu($fgGOS(this));
        $adYou(searchString);
        var endPosition = arguments.length > 1 ? arguments[1] : undefined;
        var len = that.length;
        var end = endPosition === undefined ? len : $64c25a994c0cb7c2$var$min($dDdnp(endPosition), len);
        var search = $dkJsu(searchString);
        return $64c25a994c0cb7c2$var$slice(that, end - search.length, end) === search;
    }
});

});




parcelRegister("hjdi2", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $c99e851ac523f341$export$a143d493d941bafc; }, function (v) { return $c99e851ac523f341$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $c99e851ac523f341$export$e4cf37d7f6fb9e0a; }, function (v) { return $c99e851ac523f341$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $c99e851ac523f341$export$f99ded8fe4b79145; }, function (v) { return $c99e851ac523f341$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $c99e851ac523f341$export$599f31c3813fae4d; }, function (v) { return $c99e851ac523f341$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $2bfPH = parcelRequire("2bfPH");
var $c99e851ac523f341$export$a143d493d941bafc;
var $c99e851ac523f341$export$e4cf37d7f6fb9e0a;
var $c99e851ac523f341$export$f99ded8fe4b79145;
var $c99e851ac523f341$export$599f31c3813fae4d;
'use strict';

var $7bkuE = parcelRequire("7bkuE");

var $a7qB7 = parcelRequire("a7qB7");
var $c99e851ac523f341$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : null;
$c99e851ac523f341$export$a143d493d941bafc = $c99e851ac523f341$var$Buffer;
$c99e851ac523f341$export$e4cf37d7f6fb9e0a = $c99e851ac523f341$var$SlowBuffer;
$c99e851ac523f341$export$f99ded8fe4b79145 = 50;
var $c99e851ac523f341$var$K_MAX_LENGTH = 0x7fffffff;
$c99e851ac523f341$export$599f31c3813fae4d = $c99e851ac523f341$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $c99e851ac523f341$var$Buffer.TYPED_ARRAY_SUPPORT = $c99e851ac523f341$var$typedArraySupport();
if (!$c99e851ac523f341$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $c99e851ac523f341$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($c99e851ac523f341$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$c99e851ac523f341$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($c99e851ac523f341$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$c99e851ac523f341$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $c99e851ac523f341$var$createBuffer(length) {
    if (length > $c99e851ac523f341$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $c99e851ac523f341$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $c99e851ac523f341$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $c99e851ac523f341$var$allocUnsafe(arg);
    }
    return $c99e851ac523f341$var$from(arg, encodingOrOffset, length);
}
$c99e851ac523f341$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $c99e851ac523f341$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $c99e851ac523f341$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $c99e851ac523f341$var$fromArrayLike(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)));
    if ($c99e851ac523f341$var$isInstance(value, ArrayBuffer) || value && $c99e851ac523f341$var$isInstance(value.buffer, ArrayBuffer)) return $c99e851ac523f341$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($c99e851ac523f341$var$isInstance(value, SharedArrayBuffer) || value && $c99e851ac523f341$var$isInstance(value.buffer, SharedArrayBuffer))) return $c99e851ac523f341$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $c99e851ac523f341$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $c99e851ac523f341$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $c99e851ac523f341$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $c99e851ac523f341$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $c99e851ac523f341$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($c99e851ac523f341$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($c99e851ac523f341$var$Buffer, Uint8Array);
function $c99e851ac523f341$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $c99e851ac523f341$var$alloc(size, fill, encoding) {
    $c99e851ac523f341$var$assertSize(size);
    if (size <= 0) return $c99e851ac523f341$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string' ? $c99e851ac523f341$var$createBuffer(size).fill(fill, encoding) : $c99e851ac523f341$var$createBuffer(size).fill(fill);
    return $c99e851ac523f341$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $c99e851ac523f341$var$Buffer.alloc = function(size, fill, encoding) {
    return $c99e851ac523f341$var$alloc(size, fill, encoding);
};
function $c99e851ac523f341$var$allocUnsafe(size) {
    $c99e851ac523f341$var$assertSize(size);
    return $c99e851ac523f341$var$createBuffer(size < 0 ? 0 : $c99e851ac523f341$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $c99e851ac523f341$var$Buffer.allocUnsafe = function(size) {
    return $c99e851ac523f341$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $c99e851ac523f341$var$Buffer.allocUnsafeSlow = function(size) {
    return $c99e851ac523f341$var$allocUnsafe(size);
};
function $c99e851ac523f341$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$c99e851ac523f341$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $c99e851ac523f341$var$byteLength(string, encoding) | 0;
    var buf = $c99e851ac523f341$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $c99e851ac523f341$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $c99e851ac523f341$var$checked(array.length) | 0;
    var buf = $c99e851ac523f341$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $c99e851ac523f341$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $c99e851ac523f341$var$Buffer.prototype);
    return buf;
}
function $c99e851ac523f341$var$fromObject(obj) {
    if ($c99e851ac523f341$var$Buffer.isBuffer(obj)) {
        var len = $c99e851ac523f341$var$checked(obj.length) | 0;
        var buf = $c99e851ac523f341$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $c99e851ac523f341$var$numberIsNaN(obj.length)) return $c99e851ac523f341$var$createBuffer(0);
        return $c99e851ac523f341$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $c99e851ac523f341$var$fromArrayLike(obj.data);
}
function $c99e851ac523f341$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $c99e851ac523f341$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $c99e851ac523f341$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $c99e851ac523f341$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $c99e851ac523f341$var$Buffer.alloc(+length);
}
$c99e851ac523f341$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $c99e851ac523f341$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$c99e851ac523f341$var$Buffer.compare = function compare(a, b) {
    if ($c99e851ac523f341$var$isInstance(a, Uint8Array)) a = $c99e851ac523f341$var$Buffer.from(a, a.offset, a.byteLength);
    if ($c99e851ac523f341$var$isInstance(b, Uint8Array)) b = $c99e851ac523f341$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$c99e851ac523f341$var$Buffer.isBuffer(a) || !$c99e851ac523f341$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$c99e851ac523f341$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$c99e851ac523f341$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $c99e851ac523f341$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $c99e851ac523f341$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($c99e851ac523f341$var$isInstance(buf, Uint8Array)) buf = $c99e851ac523f341$var$Buffer.from(buf);
        if (!$c99e851ac523f341$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $c99e851ac523f341$var$byteLength(string, encoding) {
    if ($c99e851ac523f341$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $c99e851ac523f341$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $2bfPH._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $c99e851ac523f341$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $c99e851ac523f341$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $c99e851ac523f341$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$c99e851ac523f341$var$Buffer.byteLength = $c99e851ac523f341$var$byteLength;
function $c99e851ac523f341$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $c99e851ac523f341$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $c99e851ac523f341$var$utf8Slice(this, start, end);
        case 'ascii':
            return $c99e851ac523f341$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $c99e851ac523f341$var$latin1Slice(this, start, end);
        case 'base64':
            return $c99e851ac523f341$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $c99e851ac523f341$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$c99e851ac523f341$var$Buffer.prototype._isBuffer = true;
function $c99e851ac523f341$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$c99e851ac523f341$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$c99e851ac523f341$var$swap(this, i, i + 1);
    return this;
};
$c99e851ac523f341$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $c99e851ac523f341$var$swap(this, i, i + 3);
        $c99e851ac523f341$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$c99e851ac523f341$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $c99e851ac523f341$var$swap(this, i, i + 7);
        $c99e851ac523f341$var$swap(this, i + 1, i + 6);
        $c99e851ac523f341$var$swap(this, i + 2, i + 5);
        $c99e851ac523f341$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$c99e851ac523f341$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $c99e851ac523f341$var$utf8Slice(this, 0, length);
    return $c99e851ac523f341$var$slowToString.apply(this, arguments);
};
$c99e851ac523f341$var$Buffer.prototype.toLocaleString = $c99e851ac523f341$var$Buffer.prototype.toString;
$c99e851ac523f341$var$Buffer.prototype.equals = function equals(b) {
    if (!$c99e851ac523f341$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $c99e851ac523f341$var$Buffer.compare(this, b) === 0;
};
$c99e851ac523f341$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $c99e851ac523f341$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($c99e851ac523f341$var$customInspectSymbol) $c99e851ac523f341$var$Buffer.prototype[$c99e851ac523f341$var$customInspectSymbol] = $c99e851ac523f341$var$Buffer.prototype.inspect;
$c99e851ac523f341$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($c99e851ac523f341$var$isInstance(target, Uint8Array)) target = $c99e851ac523f341$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$c99e851ac523f341$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $2bfPH._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $c99e851ac523f341$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($c99e851ac523f341$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $c99e851ac523f341$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($c99e851ac523f341$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $c99e851ac523f341$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $c99e851ac523f341$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $c99e851ac523f341$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$c99e851ac523f341$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$c99e851ac523f341$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $c99e851ac523f341$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$c99e851ac523f341$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $c99e851ac523f341$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $c99e851ac523f341$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($c99e851ac523f341$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $c99e851ac523f341$var$utf8Write(buf, string, offset, length) {
    return $c99e851ac523f341$var$blitBuffer($c99e851ac523f341$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $c99e851ac523f341$var$asciiWrite(buf, string, offset, length) {
    return $c99e851ac523f341$var$blitBuffer($c99e851ac523f341$var$asciiToBytes(string), buf, offset, length);
}
function $c99e851ac523f341$var$latin1Write(buf, string, offset, length) {
    return $c99e851ac523f341$var$asciiWrite(buf, string, offset, length);
}
function $c99e851ac523f341$var$base64Write(buf, string, offset, length) {
    return $c99e851ac523f341$var$blitBuffer($c99e851ac523f341$var$base64ToBytes(string), buf, offset, length);
}
function $c99e851ac523f341$var$ucs2Write(buf, string, offset, length) {
    return $c99e851ac523f341$var$blitBuffer($c99e851ac523f341$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$c99e851ac523f341$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $c99e851ac523f341$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $c99e851ac523f341$var$utf8Write(this, string, offset, length);
        case 'ascii':
            return $c99e851ac523f341$var$asciiWrite(this, string, offset, length);
        case 'latin1':
        case 'binary':
            return $c99e851ac523f341$var$latin1Write(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $c99e851ac523f341$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $c99e851ac523f341$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$c99e851ac523f341$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $c99e851ac523f341$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $7bkuE.fromByteArray(buf);
    else return $7bkuE.fromByteArray(buf.slice(start, end));
}
function $c99e851ac523f341$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $c99e851ac523f341$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $c99e851ac523f341$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $c99e851ac523f341$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $c99e851ac523f341$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $c99e851ac523f341$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $c99e851ac523f341$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $c99e851ac523f341$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $c99e851ac523f341$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $c99e851ac523f341$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $c99e851ac523f341$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$c99e851ac523f341$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $c99e851ac523f341$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $c99e851ac523f341$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$c99e851ac523f341$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c99e851ac523f341$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$c99e851ac523f341$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c99e851ac523f341$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$c99e851ac523f341$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c99e851ac523f341$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$c99e851ac523f341$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c99e851ac523f341$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$c99e851ac523f341$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c99e851ac523f341$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$c99e851ac523f341$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c99e851ac523f341$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$c99e851ac523f341$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c99e851ac523f341$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$c99e851ac523f341$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c99e851ac523f341$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c99e851ac523f341$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c99e851ac523f341$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c99e851ac523f341$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c99e851ac523f341$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$c99e851ac523f341$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c99e851ac523f341$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c99e851ac523f341$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c99e851ac523f341$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c99e851ac523f341$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c99e851ac523f341$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$c99e851ac523f341$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c99e851ac523f341$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$c99e851ac523f341$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c99e851ac523f341$var$checkOffset(offset, 4, this.length);
    return $a7qB7.read(this, offset, true, 23, 4);
};
$c99e851ac523f341$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c99e851ac523f341$var$checkOffset(offset, 4, this.length);
    return $a7qB7.read(this, offset, false, 23, 4);
};
$c99e851ac523f341$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c99e851ac523f341$var$checkOffset(offset, 8, this.length);
    return $a7qB7.read(this, offset, true, 52, 8);
};
$c99e851ac523f341$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c99e851ac523f341$var$checkOffset(offset, 8, this.length);
    return $a7qB7.read(this, offset, false, 52, 8);
};
function $c99e851ac523f341$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$c99e851ac523f341$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$c99e851ac523f341$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c99e851ac523f341$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c99e851ac523f341$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c99e851ac523f341$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c99e851ac523f341$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c99e851ac523f341$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$c99e851ac523f341$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c99e851ac523f341$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c99e851ac523f341$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c99e851ac523f341$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c99e851ac523f341$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c99e851ac523f341$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$c99e851ac523f341$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c99e851ac523f341$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$c99e851ac523f341$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $c99e851ac523f341$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c99e851ac523f341$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $c99e851ac523f341$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c99e851ac523f341$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c99e851ac523f341$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$c99e851ac523f341$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c99e851ac523f341$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c99e851ac523f341$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c99e851ac523f341$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c99e851ac523f341$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c99e851ac523f341$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$c99e851ac523f341$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c99e851ac523f341$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $c99e851ac523f341$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $c99e851ac523f341$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c99e851ac523f341$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $a7qB7.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$c99e851ac523f341$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $c99e851ac523f341$var$writeFloat(this, value, offset, true, noAssert);
};
$c99e851ac523f341$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $c99e851ac523f341$var$writeFloat(this, value, offset, false, noAssert);
};
function $c99e851ac523f341$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c99e851ac523f341$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $a7qB7.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$c99e851ac523f341$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $c99e851ac523f341$var$writeDouble(this, value, offset, true, noAssert);
};
$c99e851ac523f341$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $c99e851ac523f341$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$c99e851ac523f341$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$c99e851ac523f341$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(var i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$c99e851ac523f341$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$c99e851ac523f341$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $c99e851ac523f341$var$Buffer.isBuffer(val) ? val : $c99e851ac523f341$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $c99e851ac523f341$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $c99e851ac523f341$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($c99e851ac523f341$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $c99e851ac523f341$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $c99e851ac523f341$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $c99e851ac523f341$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $c99e851ac523f341$var$base64ToBytes(str) {
    return $7bkuE.toByteArray($c99e851ac523f341$var$base64clean(str));
}
function $c99e851ac523f341$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $c99e851ac523f341$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $c99e851ac523f341$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $c99e851ac523f341$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("7bkuE", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $53a9750dd0d7a050$export$d622b2ad8d90c771; }, function (v) { return $53a9750dd0d7a050$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $53a9750dd0d7a050$export$6100ba28696e12de; }, function (v) { return $53a9750dd0d7a050$export$6100ba28696e12de = v; });
var $53a9750dd0d7a050$export$a48f0734ac7c2329;
var $53a9750dd0d7a050$export$d622b2ad8d90c771;
var $53a9750dd0d7a050$export$6100ba28696e12de;
'use strict';
$53a9750dd0d7a050$export$a48f0734ac7c2329 = $53a9750dd0d7a050$var$byteLength;
$53a9750dd0d7a050$export$d622b2ad8d90c771 = $53a9750dd0d7a050$var$toByteArray;
$53a9750dd0d7a050$export$6100ba28696e12de = $53a9750dd0d7a050$var$fromByteArray;
var $53a9750dd0d7a050$var$lookup = [];
var $53a9750dd0d7a050$var$revLookup = [];
var $53a9750dd0d7a050$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $53a9750dd0d7a050$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $53a9750dd0d7a050$var$i = 0, $53a9750dd0d7a050$var$len = $53a9750dd0d7a050$var$code.length; $53a9750dd0d7a050$var$i < $53a9750dd0d7a050$var$len; ++$53a9750dd0d7a050$var$i){
    $53a9750dd0d7a050$var$lookup[$53a9750dd0d7a050$var$i] = $53a9750dd0d7a050$var$code[$53a9750dd0d7a050$var$i];
    $53a9750dd0d7a050$var$revLookup[$53a9750dd0d7a050$var$code.charCodeAt($53a9750dd0d7a050$var$i)] = $53a9750dd0d7a050$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$53a9750dd0d7a050$var$revLookup['-'.charCodeAt(0)] = 62;
$53a9750dd0d7a050$var$revLookup['_'.charCodeAt(0)] = 63;
function $53a9750dd0d7a050$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $53a9750dd0d7a050$var$byteLength(b64) {
    var lens = $53a9750dd0d7a050$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $53a9750dd0d7a050$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $53a9750dd0d7a050$var$toByteArray(b64) {
    var tmp;
    var lens = $53a9750dd0d7a050$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $53a9750dd0d7a050$var$Arr($53a9750dd0d7a050$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $53a9750dd0d7a050$var$revLookup[b64.charCodeAt(i)] << 18 | $53a9750dd0d7a050$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $53a9750dd0d7a050$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $53a9750dd0d7a050$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $53a9750dd0d7a050$var$revLookup[b64.charCodeAt(i)] << 2 | $53a9750dd0d7a050$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $53a9750dd0d7a050$var$revLookup[b64.charCodeAt(i)] << 10 | $53a9750dd0d7a050$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $53a9750dd0d7a050$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $53a9750dd0d7a050$var$tripletToBase64(num) {
    return $53a9750dd0d7a050$var$lookup[num >> 18 & 0x3F] + $53a9750dd0d7a050$var$lookup[num >> 12 & 0x3F] + $53a9750dd0d7a050$var$lookup[num >> 6 & 0x3F] + $53a9750dd0d7a050$var$lookup[num & 0x3F];
}
function $53a9750dd0d7a050$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($53a9750dd0d7a050$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $53a9750dd0d7a050$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($53a9750dd0d7a050$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($53a9750dd0d7a050$var$lookup[tmp >> 2] + $53a9750dd0d7a050$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($53a9750dd0d7a050$var$lookup[tmp >> 10] + $53a9750dd0d7a050$var$lookup[tmp >> 4 & 0x3F] + $53a9750dd0d7a050$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("a7qB7", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $75df308e5e1fdcd7$export$aafa59e2e03f2942; }, function (v) { return $75df308e5e1fdcd7$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $75df308e5e1fdcd7$export$68d8715fc104d294; }, function (v) { return $75df308e5e1fdcd7$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $75df308e5e1fdcd7$export$aafa59e2e03f2942;
var $75df308e5e1fdcd7$export$68d8715fc104d294;
$75df308e5e1fdcd7$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$75df308e5e1fdcd7$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("eMmTl", function(module, exports) {
'use strict';

var $lS3cS = parcelRequire("lS3cS");
module.exports = $lS3cS;

});
parcelRegister("lS3cS", function(module, exports) {
'use strict';

parcelRequire("6oPHj");
parcelRequire("7IVkR");
parcelRequire("3C0s3");
parcelRequire("1EP7d");

var $aYgYj = parcelRequire("aYgYj");
module.exports = $aYgYj.URL;

});
parcelRegister("6oPHj", function(module, exports) {
'use strict';
parcelRequire("7aC9k");

});
parcelRegister("7aC9k", function(module, exports) {

var $2bfPH = parcelRequire("2bfPH");
'use strict';
parcelRequire("i2KhA");

var $4lEVJ = parcelRequire("4lEVJ");

var $gd9M7 = parcelRequire("gd9M7");

var $ci2Pl = parcelRequire("ci2Pl");

var $7bT0n = parcelRequire("7bT0n");

var $bRGXy = parcelRequire("bRGXy");

var $a7J4S = parcelRequire("a7J4S");

var $eMkcr = parcelRequire("eMkcr");

var $cQd9a = parcelRequire("cQd9a");

var $fCtNa = parcelRequire("fCtNa");

var $eNRkB = parcelRequire("eNRkB");

var $jtoAf = parcelRequire("jtoAf");

var $2qOG7 = parcelRequire("2qOG7");

var $7D1nL = parcelRequire("7D1nL");

var $01u2P = parcelRequire("01u2P");
var $53870f43a0cf96ea$require$codeAt = $01u2P.codeAt;

var $4IqE6 = parcelRequire("4IqE6");

var $dkJsu = parcelRequire("dkJsu");

var $02Gfw = parcelRequire("02Gfw");

var $2QlrD = parcelRequire("2QlrD");

var $kcIrU = parcelRequire("kcIrU");

var $4eLp1 = parcelRequire("4eLp1");
var $53870f43a0cf96ea$var$setInternalState = $4eLp1.set;
var $53870f43a0cf96ea$var$getInternalURLState = $4eLp1.getterFor('URL');
var $53870f43a0cf96ea$var$URLSearchParams = $kcIrU.URLSearchParams;
var $53870f43a0cf96ea$var$getInternalSearchParamsState = $kcIrU.getState;
var $53870f43a0cf96ea$var$NativeURL = $7bT0n.URL;
var $53870f43a0cf96ea$var$TypeError = $7bT0n.TypeError;
var $53870f43a0cf96ea$var$parseInt = $7bT0n.parseInt;
var $53870f43a0cf96ea$var$floor = Math.floor;
var $53870f43a0cf96ea$var$pow = Math.pow;
var $53870f43a0cf96ea$var$charAt = $a7J4S(''.charAt);
var $53870f43a0cf96ea$var$exec = $a7J4S(/./.exec);
var $53870f43a0cf96ea$var$join = $a7J4S([].join);
var $53870f43a0cf96ea$var$numberToString = $a7J4S(1.1.toString);
var $53870f43a0cf96ea$var$pop = $a7J4S([].pop);
var $53870f43a0cf96ea$var$push = $a7J4S([].push);
var $53870f43a0cf96ea$var$replace = $a7J4S(''.replace);
var $53870f43a0cf96ea$var$shift = $a7J4S([].shift);
var $53870f43a0cf96ea$var$split = $a7J4S(''.split);
var $53870f43a0cf96ea$var$stringSlice = $a7J4S(''.slice);
var $53870f43a0cf96ea$var$toLowerCase = $a7J4S(''.toLowerCase);
var $53870f43a0cf96ea$var$unshift = $a7J4S([].unshift);
var $53870f43a0cf96ea$var$INVALID_AUTHORITY = 'Invalid authority';
var $53870f43a0cf96ea$var$INVALID_SCHEME = 'Invalid scheme';
var $53870f43a0cf96ea$var$INVALID_HOST = 'Invalid host';
var $53870f43a0cf96ea$var$INVALID_PORT = 'Invalid port';
var $53870f43a0cf96ea$var$ALPHA = /[a-z]/i;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var $53870f43a0cf96ea$var$ALPHANUMERIC = /[\d+-.a-z]/i;
var $53870f43a0cf96ea$var$DIGIT = /\d/;
var $53870f43a0cf96ea$var$HEX_START = /^0x/i;
var $53870f43a0cf96ea$var$OCT = /^[0-7]+$/;
var $53870f43a0cf96ea$var$DEC = /^\d+$/;
var $53870f43a0cf96ea$var$HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */ var $53870f43a0cf96ea$var$FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var $53870f43a0cf96ea$var$FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var $53870f43a0cf96ea$var$LEADING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+/;
var $53870f43a0cf96ea$var$TRAILING_C0_CONTROL_OR_SPACE = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/;
var $53870f43a0cf96ea$var$TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */ // eslint-disable-next-line no-unassigned-vars -- expected `undefined` value
var $53870f43a0cf96ea$var$EOF;
// https://url.spec.whatwg.org/#ipv4-number-parser
var $53870f43a0cf96ea$var$parseIPv4 = function parseIPv4(input) {
    var parts = $53870f43a0cf96ea$var$split(input, '.');
    var partsLength, numbers, index, part, radix, number, ipv4;
    if (parts.length && parts[parts.length - 1] === '') parts.length--;
    partsLength = parts.length;
    if (partsLength > 4) return input;
    numbers = [];
    for(index = 0; index < partsLength; index++){
        part = parts[index];
        if (part === '') return input;
        radix = 10;
        if (part.length > 1 && $53870f43a0cf96ea$var$charAt(part, 0) === '0') {
            radix = $53870f43a0cf96ea$var$exec($53870f43a0cf96ea$var$HEX_START, part) ? 16 : 8;
            part = $53870f43a0cf96ea$var$stringSlice(part, radix === 8 ? 1 : 2);
        }
        if (part === '') number = 0;
        else {
            if (!$53870f43a0cf96ea$var$exec(radix === 10 ? $53870f43a0cf96ea$var$DEC : radix === 8 ? $53870f43a0cf96ea$var$OCT : $53870f43a0cf96ea$var$HEX, part)) return input;
            number = $53870f43a0cf96ea$var$parseInt(part, radix);
        }
        $53870f43a0cf96ea$var$push(numbers, number);
    }
    for(index = 0; index < partsLength; index++){
        number = numbers[index];
        if (index === partsLength - 1) {
            if (number >= $53870f43a0cf96ea$var$pow(256, 5 - partsLength)) return null;
        } else if (number > 255) return null;
    }
    ipv4 = $53870f43a0cf96ea$var$pop(numbers);
    for(index = 0; index < numbers.length; index++)ipv4 += numbers[index] * $53870f43a0cf96ea$var$pow(256, 3 - index);
    return ipv4;
};
// https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO
var $53870f43a0cf96ea$var$parseIPv6 = function parseIPv6(input) {
    var address = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    var pieceIndex = 0;
    var compress = null;
    var pointer = 0;
    var value, length, numbersSeen, ipv4Piece, number, swaps, swap;
    var chr = function chr() {
        return $53870f43a0cf96ea$var$charAt(input, pointer);
    };
    if (chr() === ':') {
        if ($53870f43a0cf96ea$var$charAt(input, 1) !== ':') return;
        pointer += 2;
        pieceIndex++;
        compress = pieceIndex;
    }
    while(chr()){
        if (pieceIndex === 8) return;
        if (chr() === ':') {
            if (compress !== null) return;
            pointer++;
            pieceIndex++;
            compress = pieceIndex;
            continue;
        }
        value = length = 0;
        while(length < 4 && $53870f43a0cf96ea$var$exec($53870f43a0cf96ea$var$HEX, chr())){
            value = value * 16 + $53870f43a0cf96ea$var$parseInt(chr(), 16);
            pointer++;
            length++;
        }
        if (chr() === '.') {
            if (length === 0) return;
            pointer -= length;
            if (pieceIndex > 6) return;
            numbersSeen = 0;
            while(chr()){
                ipv4Piece = null;
                if (numbersSeen > 0) {
                    if (chr() === '.' && numbersSeen < 4) pointer++;
                    else return;
                }
                if (!$53870f43a0cf96ea$var$exec($53870f43a0cf96ea$var$DIGIT, chr())) return;
                while($53870f43a0cf96ea$var$exec($53870f43a0cf96ea$var$DIGIT, chr())){
                    number = $53870f43a0cf96ea$var$parseInt(chr(), 10);
                    if (ipv4Piece === null) ipv4Piece = number;
                    else if (ipv4Piece === 0) return;
                    else ipv4Piece = ipv4Piece * 10 + number;
                    if (ipv4Piece > 255) return;
                    pointer++;
                }
                address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
                numbersSeen++;
                if (numbersSeen === 2 || numbersSeen === 4) pieceIndex++;
            }
            if (numbersSeen !== 4) return;
            break;
        } else if (chr() === ':') {
            pointer++;
            if (!chr()) return;
        } else if (chr()) return;
        address[pieceIndex++] = value;
    }
    if (compress !== null) {
        swaps = pieceIndex - compress;
        pieceIndex = 7;
        while(pieceIndex !== 0 && swaps > 0){
            swap = address[pieceIndex];
            address[pieceIndex--] = address[compress + swaps - 1];
            address[compress + --swaps] = swap;
        }
    } else if (pieceIndex !== 8) return;
    return address;
};
var $53870f43a0cf96ea$var$findLongestZeroSequence = function findLongestZeroSequence(ipv6) {
    var maxIndex = null;
    var maxLength = 1;
    var currStart = null;
    var currLength = 0;
    var index = 0;
    for(; index < 8; index++)if (ipv6[index] !== 0) {
        if (currLength > maxLength) {
            maxIndex = currStart;
            maxLength = currLength;
        }
        currStart = null;
        currLength = 0;
    } else {
        if (currStart === null) currStart = index;
        ++currLength;
    }
    return currLength > maxLength ? currStart : maxIndex;
};
// https://url.spec.whatwg.org/#host-serializing
var $53870f43a0cf96ea$var$serializeHost = function serializeHost(host) {
    var result, index, compress, ignore0;
    // ipv4
    if (typeof host == 'number') {
        result = [];
        for(index = 0; index < 4; index++){
            $53870f43a0cf96ea$var$unshift(result, host % 256);
            host = $53870f43a0cf96ea$var$floor(host / 256);
        }
        return $53870f43a0cf96ea$var$join(result, '.');
    }
    // ipv6
    if ((typeof host === "undefined" ? "undefined" : (0, $2bfPH._)(host)) == 'object') {
        result = '';
        compress = $53870f43a0cf96ea$var$findLongestZeroSequence(host);
        for(index = 0; index < 8; index++){
            if (ignore0 && host[index] === 0) continue;
            if (ignore0) ignore0 = false;
            if (compress === index) {
                result += index ? ':' : '::';
                ignore0 = true;
            } else {
                result += $53870f43a0cf96ea$var$numberToString(host[index], 16);
                if (index < 7) result += ':';
            }
        }
        return '[' + result + ']';
    }
    return host;
};
var $53870f43a0cf96ea$var$C0ControlPercentEncodeSet = {};
var $53870f43a0cf96ea$var$fragmentPercentEncodeSet = $jtoAf({}, $53870f43a0cf96ea$var$C0ControlPercentEncodeSet, {
    ' ': 1,
    '"': 1,
    '<': 1,
    '>': 1,
    '`': 1
});
var $53870f43a0cf96ea$var$pathPercentEncodeSet = $jtoAf({}, $53870f43a0cf96ea$var$fragmentPercentEncodeSet, {
    '#': 1,
    '?': 1,
    '{': 1,
    '}': 1
});
var $53870f43a0cf96ea$var$userinfoPercentEncodeSet = $jtoAf({}, $53870f43a0cf96ea$var$pathPercentEncodeSet, {
    '/': 1,
    ':': 1,
    ';': 1,
    '=': 1,
    '@': 1,
    '[': 1,
    '\\': 1,
    ']': 1,
    '^': 1,
    '|': 1
});
var $53870f43a0cf96ea$var$percentEncode = function percentEncode(chr, set) {
    var code = $53870f43a0cf96ea$require$codeAt(chr, 0);
    return code > 0x20 && code < 0x7F && !$eNRkB(set, chr) ? chr : encodeURIComponent(chr);
};
// https://url.spec.whatwg.org/#special-scheme
var $53870f43a0cf96ea$var$specialSchemes = {
    ftp: 21,
    file: null,
    http: 80,
    https: 443,
    ws: 80,
    wss: 443
};
// https://url.spec.whatwg.org/#windows-drive-letter
var $53870f43a0cf96ea$var$isWindowsDriveLetter = function isWindowsDriveLetter(string, normalized) {
    var second;
    return string.length === 2 && $53870f43a0cf96ea$var$exec($53870f43a0cf96ea$var$ALPHA, $53870f43a0cf96ea$var$charAt(string, 0)) && ((second = $53870f43a0cf96ea$var$charAt(string, 1)) === ':' || !normalized && second === '|');
};
// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
var $53870f43a0cf96ea$var$startsWithWindowsDriveLetter = function startsWithWindowsDriveLetter(string) {
    var third;
    return string.length > 1 && $53870f43a0cf96ea$var$isWindowsDriveLetter($53870f43a0cf96ea$var$stringSlice(string, 0, 2)) && (string.length === 2 || (third = $53870f43a0cf96ea$var$charAt(string, 2)) === '/' || third === '\\' || third === '?' || third === '#');
};
// https://url.spec.whatwg.org/#single-dot-path-segment
var $53870f43a0cf96ea$var$isSingleDot = function isSingleDot(segment) {
    return segment === '.' || $53870f43a0cf96ea$var$toLowerCase(segment) === '%2e';
};
// https://url.spec.whatwg.org/#double-dot-path-segment
var $53870f43a0cf96ea$var$isDoubleDot = function isDoubleDot(segment) {
    segment = $53870f43a0cf96ea$var$toLowerCase(segment);
    return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};
// States:
var $53870f43a0cf96ea$var$SCHEME_START = {};
var $53870f43a0cf96ea$var$SCHEME = {};
var $53870f43a0cf96ea$var$NO_SCHEME = {};
var $53870f43a0cf96ea$var$SPECIAL_RELATIVE_OR_AUTHORITY = {};
var $53870f43a0cf96ea$var$PATH_OR_AUTHORITY = {};
var $53870f43a0cf96ea$var$RELATIVE = {};
var $53870f43a0cf96ea$var$RELATIVE_SLASH = {};
var $53870f43a0cf96ea$var$SPECIAL_AUTHORITY_SLASHES = {};
var $53870f43a0cf96ea$var$SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var $53870f43a0cf96ea$var$AUTHORITY = {};
var $53870f43a0cf96ea$var$HOST = {};
var $53870f43a0cf96ea$var$HOSTNAME = {};
var $53870f43a0cf96ea$var$PORT = {};
var $53870f43a0cf96ea$var$FILE = {};
var $53870f43a0cf96ea$var$FILE_SLASH = {};
var $53870f43a0cf96ea$var$FILE_HOST = {};
var $53870f43a0cf96ea$var$PATH_START = {};
var $53870f43a0cf96ea$var$PATH = {};
var $53870f43a0cf96ea$var$CANNOT_BE_A_BASE_URL_PATH = {};
var $53870f43a0cf96ea$var$QUERY = {};
var $53870f43a0cf96ea$var$FRAGMENT = {};
var $53870f43a0cf96ea$var$URLState = function URLState1(url, isBase, base) {
    var urlString = $dkJsu(url);
    var baseState, failure, searchParams;
    if (isBase) {
        failure = this.parse(urlString);
        if (failure) throw new $53870f43a0cf96ea$var$TypeError(failure);
        this.searchParams = null;
    } else {
        if (base !== undefined) baseState = new $53870f43a0cf96ea$var$URLState(base, true);
        failure = this.parse(urlString, null, baseState);
        if (failure) throw new $53870f43a0cf96ea$var$TypeError(failure);
        searchParams = $53870f43a0cf96ea$var$getInternalSearchParamsState(new $53870f43a0cf96ea$var$URLSearchParams());
        searchParams.bindURL(this);
        this.searchParams = searchParams;
    }
};
$53870f43a0cf96ea$var$URLState.prototype = {
    type: 'URL',
    // https://url.spec.whatwg.org/#url-parsing
    // eslint-disable-next-line max-statements -- TODO
    parse: function parse(input, stateOverride, base) {
        var url = this;
        var state = stateOverride || $53870f43a0cf96ea$var$SCHEME_START;
        var pointer = 0;
        var buffer = '';
        var seenAt = false;
        var seenBracket = false;
        var seenPasswordToken = false;
        var codePoints, chr, bufferCodePoints, failure;
        input = $dkJsu(input);
        if (!stateOverride) {
            url.scheme = '';
            url.username = '';
            url.password = '';
            url.host = null;
            url.port = null;
            url.path = [];
            url.query = null;
            url.fragment = null;
            url.cannotBeABaseURL = false;
            input = $53870f43a0cf96ea$var$replace(input, $53870f43a0cf96ea$var$LEADING_C0_CONTROL_OR_SPACE, '');
            input = $53870f43a0cf96ea$var$replace(input, $53870f43a0cf96ea$var$TRAILING_C0_CONTROL_OR_SPACE, '$1');
        }
        input = $53870f43a0cf96ea$var$replace(input, $53870f43a0cf96ea$var$TAB_AND_NEW_LINE, '');
        codePoints = $2qOG7(input);
        while(pointer <= codePoints.length){
            chr = codePoints[pointer];
            switch(state){
                case $53870f43a0cf96ea$var$SCHEME_START:
                    if (chr && $53870f43a0cf96ea$var$exec($53870f43a0cf96ea$var$ALPHA, chr)) {
                        buffer += $53870f43a0cf96ea$var$toLowerCase(chr);
                        state = $53870f43a0cf96ea$var$SCHEME;
                    } else if (!stateOverride) {
                        state = $53870f43a0cf96ea$var$NO_SCHEME;
                        continue;
                    } else return $53870f43a0cf96ea$var$INVALID_SCHEME;
                    break;
                case $53870f43a0cf96ea$var$SCHEME:
                    if (chr && ($53870f43a0cf96ea$var$exec($53870f43a0cf96ea$var$ALPHANUMERIC, chr) || chr === '+' || chr === '-' || chr === '.')) buffer += $53870f43a0cf96ea$var$toLowerCase(chr);
                    else if (chr === ':') {
                        if (stateOverride && (url.isSpecial() !== $eNRkB($53870f43a0cf96ea$var$specialSchemes, buffer) || buffer === 'file' && (url.includesCredentials() || url.port !== null) || url.scheme === 'file' && !url.host)) return;
                        url.scheme = buffer;
                        if (stateOverride) {
                            if (url.isSpecial() && $53870f43a0cf96ea$var$specialSchemes[url.scheme] === url.port) url.port = null;
                            return;
                        }
                        buffer = '';
                        if (url.scheme === 'file') state = $53870f43a0cf96ea$var$FILE;
                        else if (url.isSpecial() && base && base.scheme === url.scheme) state = $53870f43a0cf96ea$var$SPECIAL_RELATIVE_OR_AUTHORITY;
                        else if (url.isSpecial()) state = $53870f43a0cf96ea$var$SPECIAL_AUTHORITY_SLASHES;
                        else if (codePoints[pointer + 1] === '/') {
                            state = $53870f43a0cf96ea$var$PATH_OR_AUTHORITY;
                            pointer++;
                        } else {
                            url.cannotBeABaseURL = true;
                            $53870f43a0cf96ea$var$push(url.path, '');
                            state = $53870f43a0cf96ea$var$CANNOT_BE_A_BASE_URL_PATH;
                        }
                    } else if (!stateOverride) {
                        buffer = '';
                        state = $53870f43a0cf96ea$var$NO_SCHEME;
                        pointer = 0;
                        continue;
                    } else return $53870f43a0cf96ea$var$INVALID_SCHEME;
                    break;
                case $53870f43a0cf96ea$var$NO_SCHEME:
                    if (!base || base.cannotBeABaseURL && chr !== '#') return $53870f43a0cf96ea$var$INVALID_SCHEME;
                    if (base.cannotBeABaseURL && chr === '#') {
                        url.scheme = base.scheme;
                        url.path = $7D1nL(base.path);
                        url.query = base.query;
                        url.fragment = '';
                        url.cannotBeABaseURL = true;
                        state = $53870f43a0cf96ea$var$FRAGMENT;
                        break;
                    }
                    state = base.scheme === 'file' ? $53870f43a0cf96ea$var$FILE : $53870f43a0cf96ea$var$RELATIVE;
                    continue;
                case $53870f43a0cf96ea$var$SPECIAL_RELATIVE_OR_AUTHORITY:
                    if (chr === '/' && codePoints[pointer + 1] === '/') {
                        state = $53870f43a0cf96ea$var$SPECIAL_AUTHORITY_IGNORE_SLASHES;
                        pointer++;
                    } else {
                        state = $53870f43a0cf96ea$var$RELATIVE;
                        continue;
                    }
                    break;
                case $53870f43a0cf96ea$var$PATH_OR_AUTHORITY:
                    if (chr === '/') {
                        state = $53870f43a0cf96ea$var$AUTHORITY;
                        break;
                    } else {
                        state = $53870f43a0cf96ea$var$PATH;
                        continue;
                    }
                case $53870f43a0cf96ea$var$RELATIVE:
                    url.scheme = base.scheme;
                    if (chr === $53870f43a0cf96ea$var$EOF) {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $7D1nL(base.path);
                        url.query = base.query;
                    } else if (chr === '/' || chr === '\\' && url.isSpecial()) state = $53870f43a0cf96ea$var$RELATIVE_SLASH;
                    else if (chr === '?') {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $7D1nL(base.path);
                        url.query = '';
                        state = $53870f43a0cf96ea$var$QUERY;
                    } else if (chr === '#') {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $7D1nL(base.path);
                        url.query = base.query;
                        url.fragment = '';
                        state = $53870f43a0cf96ea$var$FRAGMENT;
                    } else {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $7D1nL(base.path);
                        url.path.length--;
                        state = $53870f43a0cf96ea$var$PATH;
                        continue;
                    }
                    break;
                case $53870f43a0cf96ea$var$RELATIVE_SLASH:
                    if (url.isSpecial() && (chr === '/' || chr === '\\')) state = $53870f43a0cf96ea$var$SPECIAL_AUTHORITY_IGNORE_SLASHES;
                    else if (chr === '/') state = $53870f43a0cf96ea$var$AUTHORITY;
                    else {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        state = $53870f43a0cf96ea$var$PATH;
                        continue;
                    }
                    break;
                case $53870f43a0cf96ea$var$SPECIAL_AUTHORITY_SLASHES:
                    state = $53870f43a0cf96ea$var$SPECIAL_AUTHORITY_IGNORE_SLASHES;
                    if (chr !== '/' || $53870f43a0cf96ea$var$charAt(buffer, pointer + 1) !== '/') continue;
                    pointer++;
                    break;
                case $53870f43a0cf96ea$var$SPECIAL_AUTHORITY_IGNORE_SLASHES:
                    if (chr !== '/' && chr !== '\\') {
                        state = $53870f43a0cf96ea$var$AUTHORITY;
                        continue;
                    }
                    break;
                case $53870f43a0cf96ea$var$AUTHORITY:
                    if (chr === '@') {
                        if (seenAt) buffer = '%40' + buffer;
                        seenAt = true;
                        bufferCodePoints = $2qOG7(buffer);
                        for(var i = 0; i < bufferCodePoints.length; i++){
                            var codePoint = bufferCodePoints[i];
                            if (codePoint === ':' && !seenPasswordToken) {
                                seenPasswordToken = true;
                                continue;
                            }
                            var encodedCodePoints = $53870f43a0cf96ea$var$percentEncode(codePoint, $53870f43a0cf96ea$var$userinfoPercentEncodeSet);
                            if (seenPasswordToken) url.password += encodedCodePoints;
                            else url.username += encodedCodePoints;
                        }
                        buffer = '';
                    } else if (chr === $53870f43a0cf96ea$var$EOF || chr === '/' || chr === '?' || chr === '#' || chr === '\\' && url.isSpecial()) {
                        if (seenAt && buffer === '') return $53870f43a0cf96ea$var$INVALID_AUTHORITY;
                        pointer -= $2qOG7(buffer).length + 1;
                        buffer = '';
                        state = $53870f43a0cf96ea$var$HOST;
                    } else buffer += chr;
                    break;
                case $53870f43a0cf96ea$var$HOST:
                case $53870f43a0cf96ea$var$HOSTNAME:
                    if (stateOverride && url.scheme === 'file') {
                        state = $53870f43a0cf96ea$var$FILE_HOST;
                        continue;
                    } else if (chr === ':' && !seenBracket) {
                        if (buffer === '') return $53870f43a0cf96ea$var$INVALID_HOST;
                        failure = url.parseHost(buffer);
                        if (failure) return failure;
                        buffer = '';
                        state = $53870f43a0cf96ea$var$PORT;
                        if (stateOverride === $53870f43a0cf96ea$var$HOSTNAME) return;
                    } else if (chr === $53870f43a0cf96ea$var$EOF || chr === '/' || chr === '?' || chr === '#' || chr === '\\' && url.isSpecial()) {
                        if (url.isSpecial() && buffer === '') return $53870f43a0cf96ea$var$INVALID_HOST;
                        if (stateOverride && buffer === '' && (url.includesCredentials() || url.port !== null)) return;
                        failure = url.parseHost(buffer);
                        if (failure) return failure;
                        buffer = '';
                        state = $53870f43a0cf96ea$var$PATH_START;
                        if (stateOverride) return;
                        continue;
                    } else {
                        if (chr === '[') seenBracket = true;
                        else if (chr === ']') seenBracket = false;
                        buffer += chr;
                    }
                    break;
                case $53870f43a0cf96ea$var$PORT:
                    if ($53870f43a0cf96ea$var$exec($53870f43a0cf96ea$var$DIGIT, chr)) buffer += chr;
                    else if (chr === $53870f43a0cf96ea$var$EOF || chr === '/' || chr === '?' || chr === '#' || chr === '\\' && url.isSpecial() || stateOverride) {
                        if (buffer !== '') {
                            var port = $53870f43a0cf96ea$var$parseInt(buffer, 10);
                            if (port > 0xFFFF) return $53870f43a0cf96ea$var$INVALID_PORT;
                            url.port = url.isSpecial() && port === $53870f43a0cf96ea$var$specialSchemes[url.scheme] ? null : port;
                            buffer = '';
                        }
                        if (stateOverride) return;
                        state = $53870f43a0cf96ea$var$PATH_START;
                        continue;
                    } else return $53870f43a0cf96ea$var$INVALID_PORT;
                    break;
                case $53870f43a0cf96ea$var$FILE:
                    url.scheme = 'file';
                    if (chr === '/' || chr === '\\') state = $53870f43a0cf96ea$var$FILE_SLASH;
                    else if (base && base.scheme === 'file') switch(chr){
                        case $53870f43a0cf96ea$var$EOF:
                            url.host = base.host;
                            url.path = $7D1nL(base.path);
                            url.query = base.query;
                            break;
                        case '?':
                            url.host = base.host;
                            url.path = $7D1nL(base.path);
                            url.query = '';
                            state = $53870f43a0cf96ea$var$QUERY;
                            break;
                        case '#':
                            url.host = base.host;
                            url.path = $7D1nL(base.path);
                            url.query = base.query;
                            url.fragment = '';
                            state = $53870f43a0cf96ea$var$FRAGMENT;
                            break;
                        default:
                            if (!$53870f43a0cf96ea$var$startsWithWindowsDriveLetter($53870f43a0cf96ea$var$join($7D1nL(codePoints, pointer), ''))) {
                                url.host = base.host;
                                url.path = $7D1nL(base.path);
                                url.shortenPath();
                            }
                            state = $53870f43a0cf96ea$var$PATH;
                            continue;
                    }
                    else {
                        state = $53870f43a0cf96ea$var$PATH;
                        continue;
                    }
                    break;
                case $53870f43a0cf96ea$var$FILE_SLASH:
                    if (chr === '/' || chr === '\\') {
                        state = $53870f43a0cf96ea$var$FILE_HOST;
                        break;
                    }
                    if (base && base.scheme === 'file' && !$53870f43a0cf96ea$var$startsWithWindowsDriveLetter($53870f43a0cf96ea$var$join($7D1nL(codePoints, pointer), ''))) {
                        if ($53870f43a0cf96ea$var$isWindowsDriveLetter(base.path[0], true)) $53870f43a0cf96ea$var$push(url.path, base.path[0]);
                        else url.host = base.host;
                    }
                    state = $53870f43a0cf96ea$var$PATH;
                    continue;
                case $53870f43a0cf96ea$var$FILE_HOST:
                    if (chr === $53870f43a0cf96ea$var$EOF || chr === '/' || chr === '\\' || chr === '?' || chr === '#') {
                        if (!stateOverride && $53870f43a0cf96ea$var$isWindowsDriveLetter(buffer)) state = $53870f43a0cf96ea$var$PATH;
                        else if (buffer === '') {
                            url.host = '';
                            if (stateOverride) return;
                            state = $53870f43a0cf96ea$var$PATH_START;
                        } else {
                            failure = url.parseHost(buffer);
                            if (failure) return failure;
                            if (url.host === 'localhost') url.host = '';
                            if (stateOverride) return;
                            buffer = '';
                            state = $53870f43a0cf96ea$var$PATH_START;
                        }
                        continue;
                    } else buffer += chr;
                    break;
                case $53870f43a0cf96ea$var$PATH_START:
                    if (url.isSpecial()) {
                        state = $53870f43a0cf96ea$var$PATH;
                        if (chr !== '/' && chr !== '\\') continue;
                    } else if (!stateOverride && chr === '?') {
                        url.query = '';
                        state = $53870f43a0cf96ea$var$QUERY;
                    } else if (!stateOverride && chr === '#') {
                        url.fragment = '';
                        state = $53870f43a0cf96ea$var$FRAGMENT;
                    } else if (chr !== $53870f43a0cf96ea$var$EOF) {
                        state = $53870f43a0cf96ea$var$PATH;
                        if (chr !== '/') continue;
                    }
                    break;
                case $53870f43a0cf96ea$var$PATH:
                    if (chr === $53870f43a0cf96ea$var$EOF || chr === '/' || chr === '\\' && url.isSpecial() || !stateOverride && (chr === '?' || chr === '#')) {
                        if ($53870f43a0cf96ea$var$isDoubleDot(buffer)) {
                            url.shortenPath();
                            if (chr !== '/' && !(chr === '\\' && url.isSpecial())) $53870f43a0cf96ea$var$push(url.path, '');
                        } else if ($53870f43a0cf96ea$var$isSingleDot(buffer)) {
                            if (chr !== '/' && !(chr === '\\' && url.isSpecial())) $53870f43a0cf96ea$var$push(url.path, '');
                        } else {
                            if (url.scheme === 'file' && !url.path.length && $53870f43a0cf96ea$var$isWindowsDriveLetter(buffer)) {
                                if (url.host) url.host = '';
                                buffer = $53870f43a0cf96ea$var$charAt(buffer, 0) + ':'; // normalize windows drive letter
                            }
                            $53870f43a0cf96ea$var$push(url.path, buffer);
                        }
                        buffer = '';
                        if (url.scheme === 'file' && (chr === $53870f43a0cf96ea$var$EOF || chr === '?' || chr === '#')) while(url.path.length > 1 && url.path[0] === '')$53870f43a0cf96ea$var$shift(url.path);
                        if (chr === '?') {
                            url.query = '';
                            state = $53870f43a0cf96ea$var$QUERY;
                        } else if (chr === '#') {
                            url.fragment = '';
                            state = $53870f43a0cf96ea$var$FRAGMENT;
                        }
                    } else buffer += $53870f43a0cf96ea$var$percentEncode(chr, $53870f43a0cf96ea$var$pathPercentEncodeSet);
                    break;
                case $53870f43a0cf96ea$var$CANNOT_BE_A_BASE_URL_PATH:
                    if (chr === '?') {
                        url.query = '';
                        state = $53870f43a0cf96ea$var$QUERY;
                    } else if (chr === '#') {
                        url.fragment = '';
                        state = $53870f43a0cf96ea$var$FRAGMENT;
                    } else if (chr !== $53870f43a0cf96ea$var$EOF) url.path[0] += $53870f43a0cf96ea$var$percentEncode(chr, $53870f43a0cf96ea$var$C0ControlPercentEncodeSet);
                    break;
                case $53870f43a0cf96ea$var$QUERY:
                    if (!stateOverride && chr === '#') {
                        url.fragment = '';
                        state = $53870f43a0cf96ea$var$FRAGMENT;
                    } else if (chr !== $53870f43a0cf96ea$var$EOF) {
                        if (chr === "'" && url.isSpecial()) url.query += '%27';
                        else if (chr === '#') url.query += '%23';
                        else url.query += $53870f43a0cf96ea$var$percentEncode(chr, $53870f43a0cf96ea$var$C0ControlPercentEncodeSet);
                    }
                    break;
                case $53870f43a0cf96ea$var$FRAGMENT:
                    if (chr !== $53870f43a0cf96ea$var$EOF) url.fragment += $53870f43a0cf96ea$var$percentEncode(chr, $53870f43a0cf96ea$var$fragmentPercentEncodeSet);
                    break;
            }
            pointer++;
        }
    },
    // https://url.spec.whatwg.org/#host-parsing
    parseHost: function parseHost(input) {
        var result, codePoints, index;
        if ($53870f43a0cf96ea$var$charAt(input, 0) === '[') {
            if ($53870f43a0cf96ea$var$charAt(input, input.length - 1) !== ']') return $53870f43a0cf96ea$var$INVALID_HOST;
            result = $53870f43a0cf96ea$var$parseIPv6($53870f43a0cf96ea$var$stringSlice(input, 1, -1));
            if (!result) return $53870f43a0cf96ea$var$INVALID_HOST;
            this.host = result;
        // opaque host
        } else if (!this.isSpecial()) {
            if ($53870f43a0cf96ea$var$exec($53870f43a0cf96ea$var$FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return $53870f43a0cf96ea$var$INVALID_HOST;
            result = '';
            codePoints = $2qOG7(input);
            for(index = 0; index < codePoints.length; index++)result += $53870f43a0cf96ea$var$percentEncode(codePoints[index], $53870f43a0cf96ea$var$C0ControlPercentEncodeSet);
            this.host = result;
        } else {
            input = $4IqE6(input);
            if ($53870f43a0cf96ea$var$exec($53870f43a0cf96ea$var$FORBIDDEN_HOST_CODE_POINT, input)) return $53870f43a0cf96ea$var$INVALID_HOST;
            result = $53870f43a0cf96ea$var$parseIPv4(input);
            if (result === null) return $53870f43a0cf96ea$var$INVALID_HOST;
            this.host = result;
        }
    },
    // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
    cannotHaveUsernamePasswordPort: function cannotHaveUsernamePasswordPort() {
        return !this.host || this.cannotBeABaseURL || this.scheme === 'file';
    },
    // https://url.spec.whatwg.org/#include-credentials
    includesCredentials: function includesCredentials() {
        return this.username !== '' || this.password !== '';
    },
    // https://url.spec.whatwg.org/#is-special
    isSpecial: function isSpecial() {
        return $eNRkB($53870f43a0cf96ea$var$specialSchemes, this.scheme);
    },
    // https://url.spec.whatwg.org/#shorten-a-urls-path
    shortenPath: function shortenPath() {
        var path = this.path;
        var pathSize = path.length;
        if (pathSize && (this.scheme !== 'file' || pathSize !== 1 || !$53870f43a0cf96ea$var$isWindowsDriveLetter(path[0], true))) path.length--;
    },
    // https://url.spec.whatwg.org/#concept-url-serializer
    serialize: function serialize() {
        var url = this;
        var scheme = url.scheme;
        var username = url.username;
        var password = url.password;
        var host = url.host;
        var port = url.port;
        var path = url.path;
        var query = url.query;
        var fragment = url.fragment;
        var output = scheme + ':';
        if (host !== null) {
            output += '//';
            if (url.includesCredentials()) output += username + (password ? ':' + password : '') + '@';
            output += $53870f43a0cf96ea$var$serializeHost(host);
            if (port !== null) output += ':' + port;
        } else if (scheme === 'file') output += '//';
        output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + $53870f43a0cf96ea$var$join(path, '/') : '';
        if (query !== null) output += '?' + query;
        if (fragment !== null) output += '#' + fragment;
        return output;
    },
    // https://url.spec.whatwg.org/#dom-url-href
    setHref: function setHref(href) {
        var failure = this.parse(href);
        if (failure) throw new $53870f43a0cf96ea$var$TypeError(failure);
        this.searchParams.update();
    },
    // https://url.spec.whatwg.org/#dom-url-origin
    getOrigin: function getOrigin() {
        var scheme = this.scheme;
        var port = this.port;
        if (scheme === 'blob') try {
            return new $53870f43a0cf96ea$var$URLConstructor(scheme.path[0]).origin;
        } catch (error) {
            return 'null';
        }
        if (scheme === 'file' || !this.isSpecial()) return 'null';
        return scheme + '://' + $53870f43a0cf96ea$var$serializeHost(this.host) + (port !== null ? ':' + port : '');
    },
    // https://url.spec.whatwg.org/#dom-url-protocol
    getProtocol: function getProtocol() {
        return this.scheme + ':';
    },
    setProtocol: function setProtocol(protocol) {
        this.parse($dkJsu(protocol) + ':', $53870f43a0cf96ea$var$SCHEME_START);
    },
    // https://url.spec.whatwg.org/#dom-url-username
    getUsername: function getUsername() {
        return this.username;
    },
    setUsername: function setUsername(username) {
        var codePoints = $2qOG7($dkJsu(username));
        if (this.cannotHaveUsernamePasswordPort()) return;
        this.username = '';
        for(var i = 0; i < codePoints.length; i++)this.username += $53870f43a0cf96ea$var$percentEncode(codePoints[i], $53870f43a0cf96ea$var$userinfoPercentEncodeSet);
    },
    // https://url.spec.whatwg.org/#dom-url-password
    getPassword: function getPassword() {
        return this.password;
    },
    setPassword: function setPassword(password) {
        var codePoints = $2qOG7($dkJsu(password));
        if (this.cannotHaveUsernamePasswordPort()) return;
        this.password = '';
        for(var i = 0; i < codePoints.length; i++)this.password += $53870f43a0cf96ea$var$percentEncode(codePoints[i], $53870f43a0cf96ea$var$userinfoPercentEncodeSet);
    },
    // https://url.spec.whatwg.org/#dom-url-host
    getHost: function getHost() {
        var host = this.host;
        var port = this.port;
        return host === null ? '' : port === null ? $53870f43a0cf96ea$var$serializeHost(host) : $53870f43a0cf96ea$var$serializeHost(host) + ':' + port;
    },
    setHost: function setHost(host) {
        if (this.cannotBeABaseURL) return;
        this.parse(host, $53870f43a0cf96ea$var$HOST);
    },
    // https://url.spec.whatwg.org/#dom-url-hostname
    getHostname: function getHostname() {
        var host = this.host;
        return host === null ? '' : $53870f43a0cf96ea$var$serializeHost(host);
    },
    setHostname: function setHostname(hostname) {
        if (this.cannotBeABaseURL) return;
        this.parse(hostname, $53870f43a0cf96ea$var$HOSTNAME);
    },
    // https://url.spec.whatwg.org/#dom-url-port
    getPort: function getPort() {
        var port = this.port;
        return port === null ? '' : $dkJsu(port);
    },
    setPort: function setPort(port) {
        if (this.cannotHaveUsernamePasswordPort()) return;
        port = $dkJsu(port);
        if (port === '') this.port = null;
        else this.parse(port, $53870f43a0cf96ea$var$PORT);
    },
    // https://url.spec.whatwg.org/#dom-url-pathname
    getPathname: function getPathname() {
        var path = this.path;
        return this.cannotBeABaseURL ? path[0] : path.length ? '/' + $53870f43a0cf96ea$var$join(path, '/') : '';
    },
    setPathname: function setPathname(pathname) {
        if (this.cannotBeABaseURL) return;
        this.path = [];
        this.parse(pathname, $53870f43a0cf96ea$var$PATH_START);
    },
    // https://url.spec.whatwg.org/#dom-url-search
    getSearch: function getSearch() {
        var query = this.query;
        return query ? '?' + query : '';
    },
    setSearch: function setSearch(search) {
        search = $dkJsu(search);
        if (search === '') this.query = null;
        else {
            if ($53870f43a0cf96ea$var$charAt(search, 0) === '?') search = $53870f43a0cf96ea$var$stringSlice(search, 1);
            this.query = '';
            this.parse(search, $53870f43a0cf96ea$var$QUERY);
        }
        this.searchParams.update();
    },
    // https://url.spec.whatwg.org/#dom-url-searchparams
    getSearchParams: function getSearchParams() {
        return this.searchParams.facade;
    },
    // https://url.spec.whatwg.org/#dom-url-hash
    getHash: function getHash() {
        var fragment = this.fragment;
        return fragment ? '#' + fragment : '';
    },
    setHash: function setHash(hash) {
        hash = $dkJsu(hash);
        if (hash === '') {
            this.fragment = null;
            return;
        }
        if ($53870f43a0cf96ea$var$charAt(hash, 0) === '#') hash = $53870f43a0cf96ea$var$stringSlice(hash, 1);
        this.fragment = '';
        this.parse(hash, $53870f43a0cf96ea$var$FRAGMENT);
    },
    update: function update() {
        this.query = this.searchParams.serialize() || null;
    }
};
// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var $53870f43a0cf96ea$var$URLConstructor = function URL(url /* , base */ ) {
    var that = $fCtNa(this, $53870f43a0cf96ea$var$URLPrototype);
    var base = $2QlrD(arguments.length, 1) > 1 ? arguments[1] : undefined;
    var state = $53870f43a0cf96ea$var$setInternalState(that, new $53870f43a0cf96ea$var$URLState(url, false, base));
    if (!$gd9M7) {
        that.href = state.serialize();
        that.origin = state.getOrigin();
        that.protocol = state.getProtocol();
        that.username = state.getUsername();
        that.password = state.getPassword();
        that.host = state.getHost();
        that.hostname = state.getHostname();
        that.port = state.getPort();
        that.pathname = state.getPathname();
        that.search = state.getSearch();
        that.searchParams = state.getSearchParams();
        that.hash = state.getHash();
    }
};
var $53870f43a0cf96ea$var$URLPrototype = $53870f43a0cf96ea$var$URLConstructor.prototype;
var $53870f43a0cf96ea$var$accessorDescriptor = function accessorDescriptor(getter, setter) {
    return {
        get: function get() {
            return $53870f43a0cf96ea$var$getInternalURLState(this)[getter]();
        },
        set: setter && function(value) {
            return $53870f43a0cf96ea$var$getInternalURLState(this)[setter](value);
        },
        configurable: true,
        enumerable: true
    };
};
if ($gd9M7) {
    // `URL.prototype.href` accessors pair
    // https://url.spec.whatwg.org/#dom-url-href
    $cQd9a($53870f43a0cf96ea$var$URLPrototype, 'href', $53870f43a0cf96ea$var$accessorDescriptor('serialize', 'setHref'));
    // `URL.prototype.origin` getter
    // https://url.spec.whatwg.org/#dom-url-origin
    $cQd9a($53870f43a0cf96ea$var$URLPrototype, 'origin', $53870f43a0cf96ea$var$accessorDescriptor('getOrigin'));
    // `URL.prototype.protocol` accessors pair
    // https://url.spec.whatwg.org/#dom-url-protocol
    $cQd9a($53870f43a0cf96ea$var$URLPrototype, 'protocol', $53870f43a0cf96ea$var$accessorDescriptor('getProtocol', 'setProtocol'));
    // `URL.prototype.username` accessors pair
    // https://url.spec.whatwg.org/#dom-url-username
    $cQd9a($53870f43a0cf96ea$var$URLPrototype, 'username', $53870f43a0cf96ea$var$accessorDescriptor('getUsername', 'setUsername'));
    // `URL.prototype.password` accessors pair
    // https://url.spec.whatwg.org/#dom-url-password
    $cQd9a($53870f43a0cf96ea$var$URLPrototype, 'password', $53870f43a0cf96ea$var$accessorDescriptor('getPassword', 'setPassword'));
    // `URL.prototype.host` accessors pair
    // https://url.spec.whatwg.org/#dom-url-host
    $cQd9a($53870f43a0cf96ea$var$URLPrototype, 'host', $53870f43a0cf96ea$var$accessorDescriptor('getHost', 'setHost'));
    // `URL.prototype.hostname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hostname
    $cQd9a($53870f43a0cf96ea$var$URLPrototype, 'hostname', $53870f43a0cf96ea$var$accessorDescriptor('getHostname', 'setHostname'));
    // `URL.prototype.port` accessors pair
    // https://url.spec.whatwg.org/#dom-url-port
    $cQd9a($53870f43a0cf96ea$var$URLPrototype, 'port', $53870f43a0cf96ea$var$accessorDescriptor('getPort', 'setPort'));
    // `URL.prototype.pathname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-pathname
    $cQd9a($53870f43a0cf96ea$var$URLPrototype, 'pathname', $53870f43a0cf96ea$var$accessorDescriptor('getPathname', 'setPathname'));
    // `URL.prototype.search` accessors pair
    // https://url.spec.whatwg.org/#dom-url-search
    $cQd9a($53870f43a0cf96ea$var$URLPrototype, 'search', $53870f43a0cf96ea$var$accessorDescriptor('getSearch', 'setSearch'));
    // `URL.prototype.searchParams` getter
    // https://url.spec.whatwg.org/#dom-url-searchparams
    $cQd9a($53870f43a0cf96ea$var$URLPrototype, 'searchParams', $53870f43a0cf96ea$var$accessorDescriptor('getSearchParams'));
    // `URL.prototype.hash` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hash
    $cQd9a($53870f43a0cf96ea$var$URLPrototype, 'hash', $53870f43a0cf96ea$var$accessorDescriptor('getHash', 'setHash'));
}
// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$eMkcr($53870f43a0cf96ea$var$URLPrototype, 'toJSON', function toJSON() {
    return $53870f43a0cf96ea$var$getInternalURLState(this).serialize();
}, {
    enumerable: true
});
// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
$eMkcr($53870f43a0cf96ea$var$URLPrototype, 'toString', function toString() {
    return $53870f43a0cf96ea$var$getInternalURLState(this).serialize();
}, {
    enumerable: true
});
if ($53870f43a0cf96ea$var$NativeURL) {
    var $53870f43a0cf96ea$var$nativeCreateObjectURL = $53870f43a0cf96ea$var$NativeURL.createObjectURL;
    var $53870f43a0cf96ea$var$nativeRevokeObjectURL = $53870f43a0cf96ea$var$NativeURL.revokeObjectURL;
    // `URL.createObjectURL` method
    // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
    if ($53870f43a0cf96ea$var$nativeCreateObjectURL) $eMkcr($53870f43a0cf96ea$var$URLConstructor, 'createObjectURL', $bRGXy($53870f43a0cf96ea$var$nativeCreateObjectURL, $53870f43a0cf96ea$var$NativeURL));
    // `URL.revokeObjectURL` method
    // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
    if ($53870f43a0cf96ea$var$nativeRevokeObjectURL) $eMkcr($53870f43a0cf96ea$var$URLConstructor, 'revokeObjectURL', $bRGXy($53870f43a0cf96ea$var$nativeRevokeObjectURL, $53870f43a0cf96ea$var$NativeURL));
}
$02Gfw($53870f43a0cf96ea$var$URLConstructor, 'URL');
$4lEVJ({
    global: true,
    constructor: true,
    forced: !$ci2Pl,
    sham: !$gd9M7
}, {
    URL: $53870f43a0cf96ea$var$URLConstructor
});

});
parcelRegister("jtoAf", function(module, exports) {
'use strict';

var $gd9M7 = parcelRequire("gd9M7");

var $a7J4S = parcelRequire("a7J4S");

var $jNLWX = parcelRequire("jNLWX");

var $lLFjY = parcelRequire("lLFjY");

var $hb2zb = parcelRequire("hb2zb");

var $eIQB7 = parcelRequire("eIQB7");

var $8Ek3m = parcelRequire("8Ek3m");

var $2zGhC = parcelRequire("2zGhC");

var $9gkn9 = parcelRequire("9gkn9");
// eslint-disable-next-line es/no-object-assign -- safe
var $e2d3cb8c8a3f6818$var$$assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var $e2d3cb8c8a3f6818$var$defineProperty = Object.defineProperty;
var $e2d3cb8c8a3f6818$var$concat = $a7J4S([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$e2d3cb8c8a3f6818$var$$assign || $lLFjY(function() {
    // should have correct order of operations (Edge bug)
    if ($gd9M7 && $e2d3cb8c8a3f6818$var$$assign({
        b: 1
    }, $e2d3cb8c8a3f6818$var$$assign($e2d3cb8c8a3f6818$var$defineProperty({}, 'a', {
        enumerable: true,
        get: function get() {
            $e2d3cb8c8a3f6818$var$defineProperty(this, 'b', {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es/no-symbol -- safe
    var symbol = Symbol('assign detection');
    var alphabet = 'abcdefghijklmnopqrst';
    A[symbol] = 7;
    // eslint-disable-next-line es/no-array-prototype-foreach -- safe
    alphabet.split('').forEach(function(chr) {
        B[chr] = chr;
    });
    return $e2d3cb8c8a3f6818$var$$assign({}, A)[symbol] !== 7 || $hb2zb($e2d3cb8c8a3f6818$var$$assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) {
    var T = $2zGhC(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $eIQB7.f;
    var propertyIsEnumerable = $8Ek3m.f;
    while(argumentsLength > index){
        var S = $9gkn9(arguments[index++]);
        var keys = getOwnPropertySymbols ? $e2d3cb8c8a3f6818$var$concat($hb2zb(S), getOwnPropertySymbols(S)) : $hb2zb(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$gd9M7 || $jNLWX(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $e2d3cb8c8a3f6818$var$$assign;

});
parcelRegister("eIQB7", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $ab7df98d3db1cc86$export$2d1720544b23b823; }, function (v) { return $ab7df98d3db1cc86$export$2d1720544b23b823 = v; });
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $ab7df98d3db1cc86$export$2d1720544b23b823;
'use strict';
$ab7df98d3db1cc86$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});


parcelRegister("4IqE6", function(module, exports) {
'use strict';

var $a7J4S = parcelRequire("a7J4S");
var $36eff0c930aa16c9$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var $36eff0c930aa16c9$var$base = 36;
var $36eff0c930aa16c9$var$tMin = 1;
var $36eff0c930aa16c9$var$tMax = 26;
var $36eff0c930aa16c9$var$skew = 38;
var $36eff0c930aa16c9$var$damp = 700;
var $36eff0c930aa16c9$var$initialBias = 72;
var $36eff0c930aa16c9$var$initialN = 128; // 0x80
var $36eff0c930aa16c9$var$delimiter = '-'; // '\x2D'
var $36eff0c930aa16c9$var$regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var $36eff0c930aa16c9$var$regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var $36eff0c930aa16c9$var$OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var $36eff0c930aa16c9$var$baseMinusTMin = $36eff0c930aa16c9$var$base - $36eff0c930aa16c9$var$tMin;
var $36eff0c930aa16c9$var$$RangeError = RangeError;
var $36eff0c930aa16c9$var$exec = $a7J4S($36eff0c930aa16c9$var$regexSeparators.exec);
var $36eff0c930aa16c9$var$floor = Math.floor;
var $36eff0c930aa16c9$var$fromCharCode = String.fromCharCode;
var $36eff0c930aa16c9$var$charCodeAt = $a7J4S(''.charCodeAt);
var $36eff0c930aa16c9$var$join = $a7J4S([].join);
var $36eff0c930aa16c9$var$push = $a7J4S([].push);
var $36eff0c930aa16c9$var$replace = $a7J4S(''.replace);
var $36eff0c930aa16c9$var$split = $a7J4S(''.split);
var $36eff0c930aa16c9$var$toLowerCase = $a7J4S(''.toLowerCase);
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */ var $36eff0c930aa16c9$var$ucs2decode = function ucs2decode(string) {
    var output = [];
    var counter = 0;
    var length = string.length;
    while(counter < length){
        var value = $36eff0c930aa16c9$var$charCodeAt(string, counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            var extra = $36eff0c930aa16c9$var$charCodeAt(string, counter++);
            if ((extra & 0xFC00) === 0xDC00) $36eff0c930aa16c9$var$push(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                $36eff0c930aa16c9$var$push(output, value);
                counter--;
            }
        } else $36eff0c930aa16c9$var$push(output, value);
    }
    return output;
};
/**
 * Converts a digit/integer into a basic code point.
 */ var $36eff0c930aa16c9$var$digitToBasic = function digitToBasic(digit) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */ var $36eff0c930aa16c9$var$adapt = function adapt(delta, numPoints, firstTime) {
    var k = 0;
    delta = firstTime ? $36eff0c930aa16c9$var$floor(delta / $36eff0c930aa16c9$var$damp) : delta >> 1;
    delta += $36eff0c930aa16c9$var$floor(delta / numPoints);
    while(delta > $36eff0c930aa16c9$var$baseMinusTMin * $36eff0c930aa16c9$var$tMax >> 1){
        delta = $36eff0c930aa16c9$var$floor(delta / $36eff0c930aa16c9$var$baseMinusTMin);
        k += $36eff0c930aa16c9$var$base;
    }
    return $36eff0c930aa16c9$var$floor(k + ($36eff0c930aa16c9$var$baseMinusTMin + 1) * delta / (delta + $36eff0c930aa16c9$var$skew));
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */ var $36eff0c930aa16c9$var$encode = function encode(input) {
    var output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $36eff0c930aa16c9$var$ucs2decode(input);
    // Cache the length.
    var inputLength = input.length;
    // Initialize the state.
    var n = $36eff0c930aa16c9$var$initialN;
    var delta = 0;
    var bias = $36eff0c930aa16c9$var$initialBias;
    var i, currentValue;
    // Handle the basic code points.
    for(i = 0; i < input.length; i++){
        currentValue = input[i];
        if (currentValue < 0x80) $36eff0c930aa16c9$var$push(output, $36eff0c930aa16c9$var$fromCharCode(currentValue));
    }
    var basicLength = output.length; // number of basic code points.
    var handledCPCount = basicLength; // number of code points that have been handled;
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) $36eff0c930aa16c9$var$push(output, $36eff0c930aa16c9$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next larger one:
        var m = $36eff0c930aa16c9$var$maxInt;
        for(i = 0; i < input.length; i++){
            currentValue = input[i];
            if (currentValue >= n && currentValue < m) m = currentValue;
        }
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
        var handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $36eff0c930aa16c9$var$floor(($36eff0c930aa16c9$var$maxInt - delta) / handledCPCountPlusOne)) throw new $36eff0c930aa16c9$var$$RangeError($36eff0c930aa16c9$var$OVERFLOW_ERROR);
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for(i = 0; i < input.length; i++){
            currentValue = input[i];
            if (currentValue < n && ++delta > $36eff0c930aa16c9$var$maxInt) throw new $36eff0c930aa16c9$var$$RangeError($36eff0c930aa16c9$var$OVERFLOW_ERROR);
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                var q = delta;
                var k = $36eff0c930aa16c9$var$base;
                while(true){
                    var t = k <= bias ? $36eff0c930aa16c9$var$tMin : k >= bias + $36eff0c930aa16c9$var$tMax ? $36eff0c930aa16c9$var$tMax : k - bias;
                    if (q < t) break;
                    var qMinusT = q - t;
                    var baseMinusT = $36eff0c930aa16c9$var$base - t;
                    $36eff0c930aa16c9$var$push(output, $36eff0c930aa16c9$var$fromCharCode($36eff0c930aa16c9$var$digitToBasic(t + qMinusT % baseMinusT)));
                    q = $36eff0c930aa16c9$var$floor(qMinusT / baseMinusT);
                    k += $36eff0c930aa16c9$var$base;
                }
                $36eff0c930aa16c9$var$push(output, $36eff0c930aa16c9$var$fromCharCode($36eff0c930aa16c9$var$digitToBasic(q)));
                bias = $36eff0c930aa16c9$var$adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                handledCPCount++;
            }
        }
        delta++;
        n++;
    }
    return $36eff0c930aa16c9$var$join(output, '');
};
module.exports = function(input) {
    var encoded = [];
    var labels = $36eff0c930aa16c9$var$split($36eff0c930aa16c9$var$replace($36eff0c930aa16c9$var$toLowerCase(input), $36eff0c930aa16c9$var$regexSeparators, '\u002E'), '.');
    var i, label;
    for(i = 0; i < labels.length; i++){
        label = labels[i];
        $36eff0c930aa16c9$var$push(encoded, $36eff0c930aa16c9$var$exec($36eff0c930aa16c9$var$regexNonASCII, label) ? 'xn--' + $36eff0c930aa16c9$var$encode(label) : label);
    }
    return $36eff0c930aa16c9$var$join(encoded, '.');
};

});



parcelRegister("7IVkR", function(module, exports) {
'use strict';

var $4lEVJ = parcelRequire("4lEVJ");

var $f9yE9 = parcelRequire("f9yE9");

var $lLFjY = parcelRequire("lLFjY");

var $2QlrD = parcelRequire("2QlrD");

var $dkJsu = parcelRequire("dkJsu");

var $ci2Pl = parcelRequire("ci2Pl");
var $59f91e1711fb5154$var$URL = $f9yE9('URL');
// https://github.com/nodejs/node/issues/47505
// https://github.com/denoland/deno/issues/18893
var $59f91e1711fb5154$var$THROWS_WITHOUT_ARGUMENTS = $ci2Pl && $lLFjY(function() {
    $59f91e1711fb5154$var$URL.canParse();
});
// Bun ~ 1.0.30 bug
// https://github.com/oven-sh/bun/issues/9250
var $59f91e1711fb5154$var$WRONG_ARITY = $lLFjY(function() {
    return $59f91e1711fb5154$var$URL.canParse.length !== 1;
});
// `URL.canParse` method
// https://url.spec.whatwg.org/#dom-url-canparse
$4lEVJ({
    target: 'URL',
    stat: true,
    forced: !$59f91e1711fb5154$var$THROWS_WITHOUT_ARGUMENTS || $59f91e1711fb5154$var$WRONG_ARITY
}, {
    canParse: function canParse(url) {
        var length = $2QlrD(arguments.length, 1);
        var urlString = $dkJsu(url);
        var base = length < 2 || arguments[1] === undefined ? undefined : $dkJsu(arguments[1]);
        try {
            return new $59f91e1711fb5154$var$URL(urlString, base), true;
        } catch (error) {
            return false;
        }
    }
});

});

parcelRegister("3C0s3", function(module, exports) {
'use strict';

var $4lEVJ = parcelRequire("4lEVJ");

var $f9yE9 = parcelRequire("f9yE9");

var $2QlrD = parcelRequire("2QlrD");

var $dkJsu = parcelRequire("dkJsu");

var $ci2Pl = parcelRequire("ci2Pl");
var $2a15456050616f61$var$URL = $f9yE9('URL');
// `URL.parse` method
// https://url.spec.whatwg.org/#dom-url-canparse
$4lEVJ({
    target: 'URL',
    stat: true,
    forced: !$ci2Pl
}, {
    parse: function parse(url) {
        var length = $2QlrD(arguments.length, 1);
        var urlString = $dkJsu(url);
        var base = length < 2 || arguments[1] === undefined ? undefined : $dkJsu(arguments[1]);
        try {
            return new $2a15456050616f61$var$URL(urlString, base);
        } catch (error) {
            return null;
        }
    }
});

});

parcelRegister("1EP7d", function(module, exports) {
// empty

});



parcelRegister("3x1R5", function(module, exports) {
module.exports = {
    A: "ie",
    B: "edge",
    C: "firefox",
    D: "chrome",
    E: "safari",
    F: "opera",
    G: "ios_saf",
    H: "op_mini",
    I: "android",
    J: "bb",
    K: "op_mob",
    L: "and_chr",
    M: "and_ff",
    N: "ie_mob",
    O: "and_uc",
    P: "samsung",
    Q: "and_qq",
    R: "baidu",
    S: "kaios"
};

});

parcelRegister("k2mMc", function(module, exports) {
module.exports = {
    "0": "116",
    "1": "117",
    "2": "118",
    "3": "119",
    "4": "120",
    "5": "121",
    "6": "122",
    "7": "123",
    "8": "124",
    "9": "125",
    A: "10",
    B: "11",
    C: "12",
    D: "7",
    E: "8",
    F: "9",
    G: "15",
    H: "80",
    I: "151",
    J: "4",
    K: "27",
    L: "6",
    M: "13",
    N: "14",
    O: "16",
    P: "17",
    Q: "18",
    R: "79",
    S: "81",
    T: "83",
    U: "84",
    V: "85",
    W: "86",
    X: "87",
    Y: "88",
    Z: "89",
    a: "90",
    b: "91",
    c: "92",
    d: "93",
    e: "94",
    f: "95",
    g: "96",
    h: "97",
    i: "98",
    j: "99",
    k: "100",
    l: "101",
    m: "102",
    n: "103",
    o: "104",
    p: "105",
    q: "106",
    r: "107",
    s: "108",
    t: "109",
    u: "110",
    v: "111",
    w: "112",
    x: "113",
    y: "114",
    z: "115",
    AB: "126",
    BB: "127",
    CB: "131",
    DB: "20",
    EB: "21",
    FB: "22",
    GB: "23",
    HB: "24",
    IB: "25",
    JB: "26",
    KB: "28",
    LB: "29",
    MB: "30",
    NB: "128",
    OB: "129",
    PB: "130",
    QB: "132",
    RB: "133",
    SB: "134",
    TB: "135",
    UB: "136",
    VB: "137",
    WB: "138",
    XB: "139",
    YB: "140",
    ZB: "141",
    aB: "142",
    bB: "143",
    cB: "144",
    dB: "145",
    eB: "146",
    fB: "147",
    gB: "148",
    hB: "149",
    iB: "150",
    jB: "5",
    kB: "19",
    lB: "31",
    mB: "32",
    nB: "33",
    oB: "34",
    pB: "35",
    qB: "36",
    rB: "37",
    sB: "38",
    tB: "39",
    uB: "40",
    vB: "41",
    wB: "42",
    xB: "43",
    yB: "44",
    zB: "45",
    "0B": "46",
    "1B": "47",
    "2B": "48",
    "3B": "49",
    "4B": "50",
    "5B": "51",
    "6B": "52",
    "7B": "53",
    "8B": "54",
    "9B": "55",
    AC: "56",
    BC: "57",
    CC: "58",
    DC: "60",
    EC: "62",
    FC: "63",
    GC: "64",
    HC: "65",
    IC: "66",
    JC: "67",
    KC: "68",
    LC: "69",
    MC: "70",
    NC: "71",
    OC: "72",
    PC: "73",
    QC: "74",
    RC: "75",
    SC: "76",
    TC: "77",
    UC: "78",
    VC: "153",
    WC: "11.1",
    XC: "12.1",
    YC: "15.5",
    ZC: "16.0",
    aC: "17.0",
    bC: "18.0",
    cC: "3",
    dC: "59",
    eC: "61",
    fC: "82",
    gC: "152",
    hC: "154",
    iC: "3.2",
    jC: "10.1",
    kC: "15.2-15.3",
    lC: "15.4",
    mC: "16.1",
    nC: "16.2",
    oC: "16.3",
    pC: "16.4",
    qC: "16.5",
    rC: "17.1",
    sC: "17.2",
    tC: "17.3",
    uC: "17.4",
    vC: "17.5",
    wC: "18.1",
    xC: "18.2",
    yC: "18.3",
    zC: "18.4",
    "0C": "18.5-18.7",
    "1C": "26.0",
    "2C": "26.1",
    "3C": "26.2",
    "4C": "26.3",
    "5C": "26.4",
    "6C": "26.5",
    "7C": "26.6",
    "8C": "11.5",
    "9C": "4.2-4.3",
    AD: "5.5",
    BD: "2",
    CD: "155",
    DD: "156",
    ED: "157",
    FD: "3.5",
    GD: "3.6",
    HD: "3.1",
    ID: "5.1",
    JD: "6.1",
    KD: "7.1",
    LD: "9.1",
    MD: "13.1",
    ND: "14.1",
    OD: "15.1",
    PD: "15.6",
    QD: "16.6",
    RD: "17.6",
    SD: "TP",
    TD: "9.5-9.6",
    UD: "10.0-10.1",
    VD: "10.5",
    WD: "10.6",
    XD: "11.6",
    YD: "4.0-4.1",
    ZD: "5.0-5.1",
    aD: "6.0-6.1",
    bD: "7.0-7.1",
    cD: "8.1-8.4",
    dD: "9.0-9.2",
    eD: "9.3",
    fD: "10.0-10.2",
    gD: "10.3",
    hD: "11.0-11.2",
    iD: "11.3-11.4",
    jD: "12.0-12.1",
    kD: "12.2-12.5",
    lD: "13.0-13.1",
    mD: "13.2",
    nD: "13.3",
    oD: "13.4-13.7",
    pD: "14.0-14.4",
    qD: "14.5-14.8",
    rD: "15.0-15.1",
    sD: "15.6-15.8",
    tD: "16.6-16.7",
    uD: "17.6-17.7",
    vD: "all",
    wD: "2.1",
    xD: "2.2",
    yD: "2.3",
    zD: "4.1",
    "0D": "4.4",
    "1D": "4.4.3-4.4.4",
    "2D": "5.0-5.4",
    "3D": "6.2-6.4",
    "4D": "7.2-7.4",
    "5D": "8.2",
    "6D": "9.2",
    "7D": "11.1-11.2",
    "8D": "12.0",
    "9D": "13.0",
    AE: "14.0",
    BE: "15.0",
    CE: "19.0",
    DE: "14.9",
    EE: "13.52",
    FE: "2.5",
    GE: "3.0-3.1"
};

});

parcelRegister("kUXlT", function(module, exports) {

var $6zk1M = parcelRequire("6zk1M");

var $9HfAZ = parcelRequire("9HfAZ");
var $f3a713b21df2faa8$require$list = $9HfAZ.list;
/**
 * Throw special error, to tell beniary,
 * that this error is from Autoprefixer.
 */ module.exports.error = function(text) {
    var err = new Error(text);
    err.autoprefixer = true;
    throw err;
};
/**
 * Return array, that doesn’t contain duplicates.
 */ module.exports.uniq = function(array) {
    return (0, $6zk1M._)(new Set(array));
};
/**
 * Return "-webkit-" on "-webkit- old"
 */ module.exports.removeNote = function(string) {
    if (!string.includes(' ')) return string;
    return string.split(' ')[0];
};
/**
 * Escape RegExp symbols
 */ module.exports.escapeRegexp = function(string) {
    return string.replace(/[$()*+-.?[\\\]^{|}]/g, '\\$&');
};
/**
 * Return regexp to check, that CSS string contain word
 */ module.exports.regexp = function(word) {
    var escape = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    if (escape) word = this.escapeRegexp(word);
    return new RegExp("(^|[\\s,(])(".concat(word, "($|[\\s(,]))"), 'gi');
};
/**
 * Change comma list
 */ module.exports.editList = function(value, callback) {
    var origin = $f3a713b21df2faa8$require$list.comma(value);
    var changed = callback(origin, []);
    if (origin === changed) return value;
    var join = value.match(/,\s*/);
    join = join ? join[0] : ', ';
    return changed.join(join);
};
/**
 * Split the selector into parts.
 * It returns 3 level deep array because selectors can be comma
 * separated (1), space separated (2), and combined (3)
 * @param {String} selector selector string
 * @return {Array<Array<Array>>} 3 level deep array of split selector
 * @see utils.test.js for examples
 */ module.exports.splitSelector = function(selector) {
    return $f3a713b21df2faa8$require$list.comma(selector).map(function(i) {
        return $f3a713b21df2faa8$require$list.space(i).map(function(k) {
            return k.split(/(?=\.|#)/g);
        });
    });
};
/**
 * Return true if a given value only contains numbers.
 * @param {*} value
 * @returns {boolean}
 */ module.exports.isPureNumber = function(value) {
    if (typeof value === 'number') return true;
    if (typeof value === 'string') return /^[0-9]+$/.test(value);
    return false;
};

});
parcelRegister("6zk1M", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4c858c0d999a5b9b$export$71511d61b312f219; });

var $lltIQ = parcelRequire("lltIQ");

var $faXM9 = parcelRequire("faXM9");

var $hMl05 = parcelRequire("hMl05");

var $isiou = parcelRequire("isiou");
function $4c858c0d999a5b9b$export$71511d61b312f219(arr) {
    return (0, $lltIQ._)(arr) || (0, $faXM9._)(arr) || (0, $isiou._)(arr) || (0, $hMl05._)();
}

});
parcelRegister("lltIQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f8a29d58f287cd3d$export$71511d61b312f219; });

var $azbvf = parcelRequire("azbvf");
function $f8a29d58f287cd3d$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $azbvf._)(arr);
}

});
parcelRegister("azbvf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7b161889ca248e24$export$71511d61b312f219; });
function $7b161889ca248e24$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("faXM9", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b0c62864eda90b51$export$71511d61b312f219; });
function $b0c62864eda90b51$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("hMl05", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cf17359bdd687909$export$71511d61b312f219; });
function $cf17359bdd687909$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("isiou", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d6f91c356a8197fd$export$71511d61b312f219; });

var $azbvf = parcelRequire("azbvf");
function $d6f91c356a8197fd$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $azbvf._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $azbvf._)(o, minLen);
}

});


parcelRegister("9HfAZ", function(module, exports) {

var $6zk1M = parcelRequire("6zk1M");
'use strict';

var $kAGiU = parcelRequire("kAGiU");

var $7lbcT = parcelRequire("7lbcT");

var $97P0p = parcelRequire("97P0p");

var $kyruP = parcelRequire("kyruP");

var $3MpJA = parcelRequire("3MpJA");

var $juIUa = parcelRequire("juIUa");

var $czT62 = parcelRequire("czT62");

var $cdX05 = parcelRequire("cdX05");

var $k6evn = parcelRequire("k6evn");

var $3XYS5 = parcelRequire("3XYS5");

var $i6IAv = parcelRequire("i6IAv");

var $2ZjIU = parcelRequire("2ZjIU");

var $1jdCW = parcelRequire("1jdCW");

var $4EyWg = parcelRequire("4EyWg");

var $kw7YN = parcelRequire("kw7YN");

var $faiIs = parcelRequire("faiIs");

var $6WwiZ = parcelRequire("6WwiZ");

var $9Jalz = parcelRequire("9Jalz");
function $70f43a2825a33710$var$postcss() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++){
        plugins[_key] = arguments[_key];
    }
    if (plugins.length === 1 && Array.isArray(plugins[0])) plugins = plugins[0];
    return new $1jdCW(plugins);
}
$70f43a2825a33710$var$postcss.plugin = function plugin(name, initializer) {
    var warningPrinted = false;
    function creator() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        // eslint-disable-next-line no-console
        if (console && console.warn && !warningPrinted) {
            warningPrinted = true;
            // eslint-disable-next-line no-console
            console.warn(name + ': postcss.plugin was deprecated. Migration guide:\n' + 'https://evilmartians.com/chronicles/postcss-8-plugin-migration');
        }
        var transformer = initializer.apply(void 0, (0, $6zk1M._)(args));
        transformer.postcssPlugin = name;
        transformer.postcssVersion = new $1jdCW().version;
        return transformer;
    }
    var cache;
    Object.defineProperty(creator, 'postcss', {
        get: function() {
            if (!cache) cache = creator();
            return cache;
        }
    });
    creator.process = function(css, processOpts, pluginOpts) {
        return $70f43a2825a33710$var$postcss([
            creator(pluginOpts)
        ]).process(css, processOpts);
    };
    return creator;
};
$70f43a2825a33710$var$postcss.stringify = $6WwiZ;
$70f43a2825a33710$var$postcss.parse = $2ZjIU;
$70f43a2825a33710$var$postcss.fromJSON = $czT62;
$70f43a2825a33710$var$postcss.list = $3XYS5;
$70f43a2825a33710$var$postcss.comment = function(defaults) {
    return new $7lbcT(defaults);
};
$70f43a2825a33710$var$postcss.atRule = function(defaults) {
    return new $kAGiU(defaults);
};
$70f43a2825a33710$var$postcss.decl = function(defaults) {
    return new $3MpJA(defaults);
};
$70f43a2825a33710$var$postcss.rule = function(defaults) {
    return new $faiIs(defaults);
};
$70f43a2825a33710$var$postcss.root = function(defaults) {
    return new $kw7YN(defaults);
};
$70f43a2825a33710$var$postcss.document = function(defaults) {
    return new $juIUa(defaults);
};
$70f43a2825a33710$var$postcss.CssSyntaxError = $kyruP;
$70f43a2825a33710$var$postcss.Declaration = $3MpJA;
$70f43a2825a33710$var$postcss.Container = $97P0p;
$70f43a2825a33710$var$postcss.Processor = $1jdCW;
$70f43a2825a33710$var$postcss.Document = $juIUa;
$70f43a2825a33710$var$postcss.Comment = $7lbcT;
$70f43a2825a33710$var$postcss.Warning = $9Jalz;
$70f43a2825a33710$var$postcss.AtRule = $kAGiU;
$70f43a2825a33710$var$postcss.Result = $4EyWg;
$70f43a2825a33710$var$postcss.Input = $cdX05;
$70f43a2825a33710$var$postcss.Rule = $faiIs;
$70f43a2825a33710$var$postcss.Root = $kw7YN;
$70f43a2825a33710$var$postcss.Node = $i6IAv;
$k6evn.registerPostcss($70f43a2825a33710$var$postcss);
module.exports = $70f43a2825a33710$var$postcss;
$70f43a2825a33710$var$postcss.default = $70f43a2825a33710$var$postcss;

});
parcelRegister("kAGiU", function(module, exports) {

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $6zk1M = parcelRequire("6zk1M");
'use strict';

var $97P0p = parcelRequire("97P0p");
var $efd7fc21c106250c$var$AtRule = /*#__PURE__*/ function(Container) {
    (0, $NBk0Y._)(AtRule, Container);
    function AtRule(defaults) {
        (0, $gd0sY._)(this, AtRule);
        var _this;
        _this = (0, $8xMIM._)(this, AtRule, [
            defaults
        ]);
        _this.type = 'atrule';
        return _this;
    }
    (0, $7cSld._)(AtRule, [
        {
            key: "append",
            value: function append() {
                for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++){
                    children[_key] = arguments[_key];
                }
                var _$_get;
                if (!this.proxyOf.nodes) this.nodes = [];
                return (_$_get = (0, $bl6Nv._)((0, $7GsX9._)(AtRule.prototype), "append", this)).call.apply(_$_get, [
                    this
                ].concat((0, $6zk1M._)(children)));
            }
        },
        {
            key: "prepend",
            value: function prepend() {
                for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++){
                    children[_key] = arguments[_key];
                }
                var _$_get;
                if (!this.proxyOf.nodes) this.nodes = [];
                return (_$_get = (0, $bl6Nv._)((0, $7GsX9._)(AtRule.prototype), "prepend", this)).call.apply(_$_get, [
                    this
                ].concat((0, $6zk1M._)(children)));
            }
        }
    ]);
    return AtRule;
}($97P0p);
module.exports = $efd7fc21c106250c$var$AtRule;
$efd7fc21c106250c$var$AtRule.default = $efd7fc21c106250c$var$AtRule;
$97P0p.registerAtRule($efd7fc21c106250c$var$AtRule);

});
parcelRegister("8xMIM", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $638732d3362fdd56$export$71511d61b312f219; });

var $7GsX9 = parcelRequire("7GsX9");

var $jf0Y3 = parcelRequire("jf0Y3");

var $cRssL = parcelRequire("cRssL");
function $638732d3362fdd56$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $7GsX9._)(derived);
    return (0, $cRssL._)(_this, (0, $jf0Y3._)() ? Reflect.construct(derived, args || [], (0, $7GsX9._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("7GsX9", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5982ea1ba8b4c6e7$export$71511d61b312f219; });
function $5982ea1ba8b4c6e7$export$71511d61b312f219(o) {
    $5982ea1ba8b4c6e7$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5982ea1ba8b4c6e7$export$71511d61b312f219(o);
}

});

parcelRegister("jf0Y3", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e0202b2b0021476d$export$71511d61b312f219; });
function $e0202b2b0021476d$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($e0202b2b0021476d$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("cRssL", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $95d08371c2c4ef4e$export$71511d61b312f219; });

var $krJqD = parcelRequire("krJqD");

var $2bfPH = parcelRequire("2bfPH");
function $95d08371c2c4ef4e$export$71511d61b312f219(self, call) {
    if (call && ((0, $2bfPH._)(call) === "object" || typeof call === "function")) return call;
    return (0, $krJqD._)(self);
}

});
parcelRegister("krJqD", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ee29917471fa094f$export$71511d61b312f219; });
function $ee29917471fa094f$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("gd0sY", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bcce38db0d2b4516$export$71511d61b312f219; });
function $bcce38db0d2b4516$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("7cSld", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $53f3ce6e74f6aaad$export$71511d61b312f219; });
function $53f3ce6e74f6aaad$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $53f3ce6e74f6aaad$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $53f3ce6e74f6aaad$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $53f3ce6e74f6aaad$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("bl6Nv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8416edbc60627768$export$71511d61b312f219; });

var $IfauD = parcelRequire("IfauD");
function $8416edbc60627768$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $8416edbc60627768$export$71511d61b312f219 = Reflect.get;
    else $8416edbc60627768$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $IfauD._)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $8416edbc60627768$export$71511d61b312f219(target, property, receiver || target);
}

});
parcelRegister("IfauD", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $084fe045bf653bf9$export$71511d61b312f219; });

var $7GsX9 = parcelRequire("7GsX9");
function $084fe045bf653bf9$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $7GsX9._)(object);
        if (object === null) break;
    }
    return object;
}

});


parcelRegister("NBk0Y", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0951870dac564cbc$export$71511d61b312f219; });

var $9dlnr = parcelRequire("9dlnr");
function $0951870dac564cbc$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $9dlnr._)(subClass, superClass);
}

});
parcelRegister("9dlnr", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6b55e905aa672e6c$export$71511d61b312f219; });
function $6b55e905aa672e6c$export$71511d61b312f219(o, p) {
    $6b55e905aa672e6c$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6b55e905aa672e6c$export$71511d61b312f219(o, p);
}

});


parcelRegister("97P0p", function(module, exports) {

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $NBk0Y = parcelRequire("NBk0Y");

var $6zk1M = parcelRequire("6zk1M");

var $dHaQg = parcelRequire("dHaQg");
'use strict';

var $7lbcT = parcelRequire("7lbcT");

var $3MpJA = parcelRequire("3MpJA");

var $i6IAv = parcelRequire("i6IAv");

var $187Aq = parcelRequire("187Aq");
var $6a4c5527c5028463$var$isClean = $187Aq.isClean, $6a4c5527c5028463$var$my = $187Aq.my;
var $6a4c5527c5028463$var$AtRule, $6a4c5527c5028463$var$parse, $6a4c5527c5028463$var$Root, $6a4c5527c5028463$var$Rule;
function $6a4c5527c5028463$var$cleanSource(nodes) {
    var stack = nodes.slice();
    while(stack.length > 0){
        var node = stack.pop();
        delete node.source;
        if (node.nodes) {
            node.nodes = node.nodes.slice();
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = node.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var i = _step.value;
                    stack.push(i);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }
    return nodes.slice();
}
function $6a4c5527c5028463$var$markTreeDirty(node) {
    var stack = [
        node
    ];
    while(stack.length > 0){
        var next = stack.pop();
        next[$6a4c5527c5028463$var$isClean] = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (next.proxyOf.nodes) try {
            for(var _iterator = next.proxyOf.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var i = _step.value;
                stack.push(i);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
}
var $6a4c5527c5028463$var$Container = /*#__PURE__*/ function(Node1) {
    (0, $NBk0Y._)(Container, Node1);
    function Container() {
        (0, $gd0sY._)(this, Container);
        return (0, $8xMIM._)(this, Container, arguments);
    }
    (0, $7cSld._)(Container, [
        {
            key: "first",
            get: function get() {
                if (!this.proxyOf.nodes) return undefined;
                return this.proxyOf.nodes[0];
            }
        },
        {
            key: "last",
            get: function get() {
                if (!this.proxyOf.nodes) return undefined;
                return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
            }
        },
        {
            key: "append",
            value: function append() {
                for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++){
                    children[_key] = arguments[_key];
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var child = _step.value;
                        var nodes = this.normalize(child, this.last);
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = nodes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var node = _step1.value;
                                this.proxyOf.nodes.push(node);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.markDirty();
                return this;
            }
        },
        {
            key: "cleanRaws",
            value: function cleanRaws(keepBetween) {
                var stack = [
                    this
                ];
                while(stack.length > 0){
                    var node = stack.pop();
                    if (node !== this && node.cleanRaws !== Container.prototype.cleanRaws) {
                        // Subclass with own logic; let it handle its subtree
                        node.cleanRaws(keepBetween);
                        continue;
                    }
                    $i6IAv.prototype.cleanRaws.call(node, keepBetween);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (node.nodes) try {
                        for(var _iterator = node.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var child = _step.value;
                            stack.push(child);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }
        },
        {
            key: "each",
            value: function each(callback) {
                if (!this.proxyOf.nodes) return undefined;
                var iterator = this.getIterator();
                var index, result;
                while(this.indexes[iterator] < this.proxyOf.nodes.length){
                    index = this.indexes[iterator];
                    result = callback(this.proxyOf.nodes[index], index);
                    if (result === false) break;
                    this.indexes[iterator] += 1;
                }
                delete this.indexes[iterator];
                return result;
            }
        },
        {
            key: "every",
            value: function every(condition) {
                return this.nodes.every(condition);
            }
        },
        {
            key: "getIterator",
            value: function getIterator() {
                if (!this.lastEach) this.lastEach = 0;
                if (!this.indexes) this.indexes = {};
                this.lastEach += 1;
                var iterator = this.lastEach;
                this.indexes[iterator] = 0;
                return iterator;
            }
        },
        {
            key: "getProxyProcessor",
            value: function getProxyProcessor() {
                return {
                    get: function(node, prop) {
                        if (prop === 'proxyOf') return node;
                        else if (!node[prop]) return node[prop];
                        else if (prop === 'each' || typeof prop === 'string' && prop.startsWith('walk')) return function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            var _node;
                            return (_node = node)[prop].apply(_node, (0, $6zk1M._)(args.map(function(i) {
                                if (typeof i === 'function') return function(child, index) {
                                    return i(child.toProxy(), index);
                                };
                                else return i;
                            })));
                        };
                        else if (prop === 'every' || prop === 'some') return function(cb) {
                            return node[prop](function(child) {
                                for(var _len = arguments.length, other = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                                    other[_key - 1] = arguments[_key];
                                }
                                return cb.apply(void 0, [
                                    child.toProxy()
                                ].concat((0, $6zk1M._)(other)));
                            });
                        };
                        else if (prop === 'root') return function() {
                            return node.root().toProxy();
                        };
                        else if (prop === 'nodes') return node.nodes.map(function(i) {
                            return i.toProxy();
                        });
                        else if (prop === 'first' || prop === 'last') return node[prop].toProxy();
                        else return node[prop];
                    },
                    set: function(node, prop, value) {
                        if (node[prop] === value) return true;
                        node[prop] = value;
                        if (prop === 'name' || prop === 'params' || prop === 'selector') node.markDirty();
                        return true;
                    }
                };
            }
        },
        {
            key: "index",
            value: function index(child) {
                if (typeof child === 'number') return child;
                if (child.proxyOf) child = child.proxyOf;
                return this.proxyOf.nodes.indexOf(child);
            }
        },
        {
            key: "insertAfter",
            value: function insertAfter(exist, add) {
                var existIndex = this.index(exist);
                var nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
                existIndex = this.index(exist);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        this.proxyOf.nodes.splice(existIndex + 1, 0, node);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var index;
                for(var id in this.indexes){
                    index = this.indexes[id];
                    if (existIndex < index) this.indexes[id] = index + nodes.length;
                }
                this.markDirty();
                return this;
            }
        },
        {
            key: "insertBefore",
            value: function insertBefore(exist, add) {
                var existIndex = this.index(exist);
                var type = existIndex === 0 ? 'prepend' : false;
                var nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
                existIndex = this.index(exist);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        this.proxyOf.nodes.splice(existIndex, 0, node);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var index;
                for(var id in this.indexes){
                    index = this.indexes[id];
                    if (existIndex <= index) this.indexes[id] = index + nodes.length;
                }
                this.markDirty();
                return this;
            }
        },
        {
            key: "normalize",
            value: function normalize(nodes, sample) {
                var _this = this;
                if (typeof nodes === 'string') nodes = $6a4c5527c5028463$var$cleanSource($6a4c5527c5028463$var$parse(nodes).nodes);
                else if (typeof nodes === 'undefined') nodes = [];
                else if (Array.isArray(nodes)) {
                    nodes = nodes.slice(0);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var i = _step.value;
                            if (i.parent) i.parent.removeChild(i, 'ignore');
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                } else if (nodes.type === 'root' && this.type !== 'document') {
                    nodes = nodes.nodes.slice(0);
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = nodes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var i1 = _step1.value;
                            if (i1.parent) i1.parent.removeChild(i1, 'ignore');
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                } else if (nodes.type) nodes = [
                    nodes
                ];
                else if (nodes.prop) {
                    if (typeof nodes.value === 'undefined') throw new Error('Value field is missed in node creation');
                    else if (typeof nodes.value !== 'string') nodes.value = String(nodes.value);
                    nodes = [
                        new $3MpJA(nodes)
                    ];
                } else if (nodes.selector || nodes.selectors) nodes = [
                    new $6a4c5527c5028463$var$Rule(nodes)
                ];
                else if (nodes.name) nodes = [
                    new $6a4c5527c5028463$var$AtRule(nodes)
                ];
                else if (nodes.text) nodes = [
                    new $7lbcT(nodes)
                ];
                else throw new Error('Unknown node type in node creation');
                var processed = nodes.map(function(i) {
                    /* c8 ignore next */ if (!i[$6a4c5527c5028463$var$my]) Container.rebuild(i);
                    i = i.proxyOf;
                    if (i.parent) i.parent.removeChild(i);
                    if (i[$6a4c5527c5028463$var$isClean]) $6a4c5527c5028463$var$markTreeDirty(i);
                    if (!i.raws) i.raws = {};
                    if (typeof i.raws.before === 'undefined') {
                        if (sample && typeof sample.raws.before !== 'undefined') i.raws.before = sample.raws.before.replace(/\S/g, '');
                    }
                    i.parent = _this.proxyOf;
                    return i;
                });
                return processed;
            }
        },
        {
            key: "prepend",
            value: function prepend() {
                for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++){
                    children[_key] = arguments[_key];
                }
                children = children.reverse();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var child = _step.value;
                        var nodes = this.normalize(child, this.first, 'prepend').reverse();
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = nodes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var node = _step1.value;
                                this.proxyOf.nodes.unshift(node);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        for(var id in this.indexes)this.indexes[id] = this.indexes[id] + nodes.length;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.markDirty();
                return this;
            }
        },
        {
            key: "push",
            value: function push(child) {
                child.parent = this;
                this.proxyOf.nodes.push(child);
                return this;
            }
        },
        {
            key: "removeAll",
            value: function removeAll() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.proxyOf.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        node.parent = undefined;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.proxyOf.nodes = [];
                this.markDirty();
                return this;
            }
        },
        {
            key: "removeChild",
            value: function removeChild(child) {
                child = this.index(child);
                this.proxyOf.nodes[child].parent = undefined;
                this.proxyOf.nodes.splice(child, 1);
                var index;
                for(var id in this.indexes){
                    index = this.indexes[id];
                    if (index >= child) this.indexes[id] = index - 1;
                }
                this.markDirty();
                return this;
            }
        },
        {
            key: "replaceValues",
            value: function replaceValues(pattern, opts, callback) {
                if (!callback) {
                    callback = opts;
                    opts = {};
                }
                this.walkDecls(function(decl) {
                    if (opts.props && !opts.props.includes(decl.prop)) return;
                    if (opts.fast && !decl.value.includes(opts.fast)) return;
                    decl.value = decl.value.replace(pattern, callback);
                });
                this.markDirty();
                return this;
            }
        },
        {
            key: "some",
            value: function some(condition) {
                return this.nodes.some(condition);
            }
        },
        {
            key: "walk",
            value: function walk(callback) {
                if (!this.proxyOf.nodes) return undefined;
                // An explicit stack instead of recursive `each()` calls to survive
                // deeply nested trees. Each frame keeps a live `indexes` slot, so
                // insertion and removal during the walk behave like `each()`: the
                // slot stays at the current child until its subtree is finished.
                var stack = [
                    {
                        iterator: this.getIterator(),
                        node: this.proxyOf
                    }
                ];
                while(stack.length > 0){
                    var _stack_ = stack[stack.length - 1], iterator = _stack_.iterator, node = _stack_.node;
                    var index = node.indexes[iterator];
                    if (index >= node.proxyOf.nodes.length) {
                        delete node.indexes[iterator];
                        stack.pop();
                        var parent = stack[stack.length - 1];
                        // Finish the parent’s step for the child subtree we just left
                        if (parent) parent.node.indexes[parent.iterator] += 1;
                        continue;
                    }
                    var child = node.proxyOf.nodes[index];
                    var result = void 0;
                    try {
                        result = callback(child, index);
                    } catch (e) {
                        throw child.addToError(e);
                    }
                    if (result === false) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = stack[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var opened = _step.value;
                                delete opened.node.indexes[opened.iterator];
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return false;
                    }
                    if (child.walk && child.proxyOf.nodes) stack.push({
                        iterator: child.getIterator(),
                        node: child
                    });
                    else node.indexes[iterator] += 1;
                }
                return undefined;
            }
        },
        {
            key: "walkAtRules",
            value: function walkAtRules(name, callback) {
                if (!callback) {
                    callback = name;
                    return this.walk(function(child, i) {
                        if (child.type === 'atrule') return callback(child, i);
                    });
                }
                if (name instanceof RegExp) return this.walk(function(child, i) {
                    if (child.type === 'atrule' && name.test(child.name)) return callback(child, i);
                });
                return this.walk(function(child, i) {
                    if (child.type === 'atrule' && child.name === name) return callback(child, i);
                });
            }
        },
        {
            key: "walkComments",
            value: function walkComments(callback) {
                return this.walk(function(child, i) {
                    if (child.type === 'comment') return callback(child, i);
                });
            }
        },
        {
            key: "walkDecls",
            value: function walkDecls(prop, callback) {
                if (!callback) {
                    callback = prop;
                    return this.walk(function(child, i) {
                        if (child.type === 'decl') return callback(child, i);
                    });
                }
                if (prop instanceof RegExp) return this.walk(function(child, i) {
                    if (child.type === 'decl' && prop.test(child.prop)) return callback(child, i);
                });
                return this.walk(function(child, i) {
                    if (child.type === 'decl' && child.prop === prop) return callback(child, i);
                });
            }
        },
        {
            key: "walkRules",
            value: function walkRules(selector, callback) {
                if (!callback) {
                    callback = selector;
                    return this.walk(function(child, i) {
                        if (child.type === 'rule') return callback(child, i);
                    });
                }
                if (selector instanceof RegExp) return this.walk(function(child, i) {
                    if (child.type === 'rule' && selector.test(child.selector)) return callback(child, i);
                });
                return this.walk(function(child, i) {
                    if (child.type === 'rule' && child.selector === selector) return callback(child, i);
                });
            }
        }
    ]);
    return Container;
}((0, $dHaQg._)($i6IAv));
$6a4c5527c5028463$var$Container.registerParse = function(dependant) {
    $6a4c5527c5028463$var$parse = dependant;
};
$6a4c5527c5028463$var$Container.registerRule = function(dependant) {
    $6a4c5527c5028463$var$Rule = dependant;
};
$6a4c5527c5028463$var$Container.registerAtRule = function(dependant) {
    $6a4c5527c5028463$var$AtRule = dependant;
};
$6a4c5527c5028463$var$Container.registerRoot = function(dependant) {
    $6a4c5527c5028463$var$Root = dependant;
};
module.exports = $6a4c5527c5028463$var$Container;
$6a4c5527c5028463$var$Container.default = $6a4c5527c5028463$var$Container;
/* c8 ignore start */ $6a4c5527c5028463$var$Container.rebuild = function(node) {
    var stack = [
        node
    ];
    while(stack.length > 0){
        var next = stack.pop();
        if (next.type === 'atrule') Object.setPrototypeOf(next, $6a4c5527c5028463$var$AtRule.prototype);
        else if (next.type === 'rule') Object.setPrototypeOf(next, $6a4c5527c5028463$var$Rule.prototype);
        else if (next.type === 'decl') Object.setPrototypeOf(next, $3MpJA.prototype);
        else if (next.type === 'comment') Object.setPrototypeOf(next, $7lbcT.prototype);
        else if (next.type === 'root') Object.setPrototypeOf(next, $6a4c5527c5028463$var$Root.prototype);
        next[$6a4c5527c5028463$var$my] = true;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (next.nodes) try {
            for(var _iterator = next.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                stack.push(child);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
} /* c8 ignore stop */ ;

});
parcelRegister("dHaQg", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9f87b386401b733e$export$71511d61b312f219; });

var $i3yDq = parcelRequire("i3yDq");

var $7GsX9 = parcelRequire("7GsX9");

var $BtLVK = parcelRequire("BtLVK");

var $9dlnr = parcelRequire("9dlnr");
function $9f87b386401b733e$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $9f87b386401b733e$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $BtLVK._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $i3yDq._)(Class, arguments, (0, $7GsX9._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $9dlnr._)(Wrapper, Class);
    };
    return $9f87b386401b733e$export$71511d61b312f219(Class);
}

});
parcelRegister("i3yDq", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d2535f9282d6afd9$export$71511d61b312f219; });

var $jf0Y3 = parcelRequire("jf0Y3");

var $9dlnr = parcelRequire("9dlnr");
function $d2535f9282d6afd9$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $jf0Y3._)()) $d2535f9282d6afd9$export$71511d61b312f219 = Reflect.construct;
    else $d2535f9282d6afd9$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $9dlnr._)(instance, Class.prototype);
        return instance;
    };
    return $d2535f9282d6afd9$export$71511d61b312f219.apply(null, arguments);
}

});

parcelRegister("BtLVK", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $070a8cede0f67609$export$71511d61b312f219; });
function $070a8cede0f67609$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("7lbcT", function(module, exports) {

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $NBk0Y = parcelRequire("NBk0Y");

var $dHaQg = parcelRequire("dHaQg");
'use strict';

var $i6IAv = parcelRequire("i6IAv");
var $55833006e242ed2c$var$Comment = /*#__PURE__*/ function(Node) {
    (0, $NBk0Y._)(Comment, Node);
    function Comment(defaults) {
        (0, $gd0sY._)(this, Comment);
        var _this;
        _this = (0, $8xMIM._)(this, Comment, [
            defaults
        ]);
        _this.type = 'comment';
        return _this;
    }
    return Comment;
}((0, $dHaQg._)($i6IAv));
module.exports = $55833006e242ed2c$var$Comment;
$55833006e242ed2c$var$Comment.default = $55833006e242ed2c$var$Comment;

});
parcelRegister("i6IAv", function(module, exports) {

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $21h22 = parcelRequire("21h22");

var $6zk1M = parcelRequire("6zk1M");

var $2bfPH = parcelRequire("2bfPH");
'use strict';

var $kyruP = parcelRequire("kyruP");

var $frsxx = parcelRequire("frsxx");

var $6WwiZ = parcelRequire("6WwiZ");

var $187Aq = parcelRequire("187Aq");
var $d2eb5fbc94041c9c$var$isClean = $187Aq.isClean, $d2eb5fbc94041c9c$var$my = $187Aq.my;
function $d2eb5fbc94041c9c$var$cloneNode(obj, parent) {
    var cloned = new obj.constructor();
    // An explicit stack instead of recursive calls to survive deeply
    // nested trees. Each entry is [source, its clone, clone's parent].
    var stack = [
        [
            obj,
            cloned,
            parent
        ]
    ];
    while(stack.length > 0){
        var _stack_pop = (0, $21h22._)(stack.pop(), 3), source = _stack_pop[0], target = _stack_pop[1], targetParent = _stack_pop[2];
        for(var i in source){
            if (!Object.prototype.hasOwnProperty.call(source, i)) continue;
            if (i === 'proxyCache') continue;
            var value = source[i];
            var type = typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value);
            if (i === 'parent' && type === 'object') {
                if (targetParent) target[i] = targetParent;
            } else if (i === 'source') target[i] = value;
            else if (Array.isArray(value)) {
                var children = [];
                target[i] = children;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var j = _step.value;
                        var childClone = new j.constructor();
                        children.push(childClone);
                        stack.push([
                            j,
                            childClone,
                            target
                        ]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            } else {
                if (type === 'object' && value !== null) {
                    var valueClone = new value.constructor();
                    stack.push([
                        value,
                        valueClone,
                        undefined
                    ]);
                    value = valueClone;
                }
                target[i] = value;
            }
        }
    }
    return cloned;
}
function $d2eb5fbc94041c9c$var$sourceOffset(inputCSS, position) {
    // Not all custom syntaxes support `offset` in `source.start` and `source.end`
    if (position && typeof position.offset !== 'undefined') return position.offset;
    var column = 1;
    var line = 1;
    var offset = 0;
    for(var i = 0; i < inputCSS.length; i++){
        if (line === position.line && column === position.column) {
            offset = i;
            break;
        }
        if (inputCSS[i] === '\n') {
            column = 1;
            line += 1;
        } else column += 1;
    }
    return offset;
}
var $d2eb5fbc94041c9c$var$Node = /*#__PURE__*/ function() {
    function Node() {
        var defaults = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $gd0sY._)(this, Node);
        this.raws = {};
        this[$d2eb5fbc94041c9c$var$isClean] = false;
        this[$d2eb5fbc94041c9c$var$my] = true;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.keys(defaults)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var name = _step.value;
                if (name === '__proto__') continue;
                if (name === 'nodes') {
                    this.nodes = [];
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = defaults[name][Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var node = _step1.value;
                            // Clone only nodes that already belong to another tree, so passing a
                            // freshly created (parent-less) node adopts that instance instead of
                            // a copy and keeps the caller's reference usable. See #1987.
                            if (typeof node.clone === 'function' && node.parent) this.append(node.clone());
                            else this.append(node);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                } else this[name] = defaults[name];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    (0, $7cSld._)(Node, [
        {
            key: "proxyOf",
            get: function get() {
                return this;
            }
        },
        {
            key: "addToError",
            value: function addToError(error) {
                error.postcssNode = this;
                if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
                    var s = this.source;
                    error.stack = error.stack.replace(/\n\s{4}at /, "$&".concat(s.input.from, ":").concat(s.start.line, ":").concat(s.start.column, "$&"));
                }
                return error;
            }
        },
        {
            key: "after",
            value: function after(add) {
                this.parent.insertAfter(this, add);
                return this;
            }
        },
        {
            key: "assign",
            value: function assign() {
                var overrides = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                for(var name in overrides)this[name] = overrides[name];
                return this;
            }
        },
        {
            key: "before",
            value: function before(add) {
                this.parent.insertBefore(this, add);
                return this;
            }
        },
        {
            key: "cleanRaws",
            value: function cleanRaws(keepBetween) {
                delete this.raws.before;
                delete this.raws.after;
                if (!keepBetween) delete this.raws.between;
            }
        },
        {
            key: "clone",
            value: function clone() {
                var overrides = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var cloned = $d2eb5fbc94041c9c$var$cloneNode(this);
                for(var name in overrides)cloned[name] = overrides[name];
                return cloned;
            }
        },
        {
            key: "cloneAfter",
            value: function cloneAfter() {
                var overrides = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var cloned = this.clone(overrides);
                this.parent.insertAfter(this, cloned);
                return cloned;
            }
        },
        {
            key: "cloneBefore",
            value: function cloneBefore() {
                var overrides = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var cloned = this.clone(overrides);
                this.parent.insertBefore(this, cloned);
                return cloned;
            }
        },
        {
            key: "error",
            value: function error(message) {
                var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (this.source) {
                    var _this_rangeBy = this.rangeBy(opts), end = _this_rangeBy.end, start = _this_rangeBy.start;
                    return this.source.input.error(message, {
                        column: start.column,
                        line: start.line
                    }, {
                        column: end.column,
                        line: end.line
                    }, opts);
                }
                return new $kyruP(message);
            }
        },
        {
            key: "getProxyProcessor",
            value: function getProxyProcessor() {
                return {
                    get: function(node, prop) {
                        if (prop === 'proxyOf') return node;
                        else if (prop === 'root') return function() {
                            return node.root().toProxy();
                        };
                        else return node[prop];
                    },
                    set: function(node, prop, value) {
                        if (node[prop] === value) return true;
                        node[prop] = value;
                        if (prop === 'prop' || prop === 'value' || prop === 'name' || prop === 'params' || prop === 'important' || /* c8 ignore next */ prop === 'text') node.markDirty();
                        return true;
                    }
                };
            }
        },
        {
            /* c8 ignore next 3 */ key: "markClean",
            value: function markClean() {
                this[$d2eb5fbc94041c9c$var$isClean] = true;
            }
        },
        {
            key: "markDirty",
            value: function markDirty() {
                if (this[$d2eb5fbc94041c9c$var$isClean]) {
                    this[$d2eb5fbc94041c9c$var$isClean] = false;
                    var next = this;
                    while(next = next.parent)next[$d2eb5fbc94041c9c$var$isClean] = false;
                }
            }
        },
        {
            key: "next",
            value: function next() {
                if (!this.parent) return undefined;
                var index = this.parent.index(this);
                return this.parent.nodes[index + 1];
            }
        },
        {
            key: "positionBy",
            value: function positionBy() {
                var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var inputString = 'document' in this.source.input ? this.source.input.document : this.source.input.css;
                var pos = {
                    column: this.source.start.column,
                    line: this.source.start.line,
                    offset: $d2eb5fbc94041c9c$var$sourceOffset(inputString, this.source.start)
                };
                if (opts.index) pos = this.positionInside(opts.index);
                else if (opts.word) {
                    var stringRepresentation = inputString.slice($d2eb5fbc94041c9c$var$sourceOffset(inputString, this.source.start), $d2eb5fbc94041c9c$var$sourceOffset(inputString, this.source.end));
                    var index = stringRepresentation.indexOf(opts.word);
                    if (index !== -1) pos = this.positionInside(index);
                }
                return pos;
            }
        },
        {
            key: "positionInside",
            value: function positionInside(index) {
                var column = this.source.start.column;
                var line = this.source.start.line;
                var inputString = 'document' in this.source.input ? this.source.input.document : this.source.input.css;
                var offset = $d2eb5fbc94041c9c$var$sourceOffset(inputString, this.source.start);
                var end = offset + index;
                for(var i = offset; i < end; i++)if (inputString[i] === '\n') {
                    column = 1;
                    line += 1;
                } else column += 1;
                return {
                    column: column,
                    line: line,
                    offset: end
                };
            }
        },
        {
            key: "prev",
            value: function prev() {
                if (!this.parent) return undefined;
                var index = this.parent.index(this);
                return this.parent.nodes[index - 1];
            }
        },
        {
            key: "rangeBy",
            value: function rangeBy() {
                var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var inputString = 'document' in this.source.input ? this.source.input.document : this.source.input.css;
                var start = {
                    column: this.source.start.column,
                    line: this.source.start.line,
                    offset: $d2eb5fbc94041c9c$var$sourceOffset(inputString, this.source.start)
                };
                var end = this.source.end ? {
                    column: this.source.end.column + 1,
                    line: this.source.end.line,
                    offset: typeof this.source.end.offset === 'number' ? this.source.end.offset : // the `sourceOffset(... , this.source.end)` returns an inclusive offset.
                    // So, we add 1 to convert it to exclusive.
                    $d2eb5fbc94041c9c$var$sourceOffset(inputString, this.source.end) + 1
                } : {
                    column: start.column + 1,
                    line: start.line,
                    offset: start.offset + 1
                };
                if (opts.word) {
                    var stringRepresentation = inputString.slice($d2eb5fbc94041c9c$var$sourceOffset(inputString, this.source.start), $d2eb5fbc94041c9c$var$sourceOffset(inputString, this.source.end));
                    var index = stringRepresentation.indexOf(opts.word);
                    if (index !== -1) {
                        start = this.positionInside(index);
                        end = this.positionInside(index + opts.word.length);
                    }
                } else {
                    if (opts.start) start = {
                        column: opts.start.column,
                        line: opts.start.line,
                        offset: $d2eb5fbc94041c9c$var$sourceOffset(inputString, opts.start)
                    };
                    else if (typeof opts.index === 'number') start = this.positionInside(opts.index);
                    if (opts.end) end = {
                        column: opts.end.column,
                        line: opts.end.line,
                        offset: $d2eb5fbc94041c9c$var$sourceOffset(inputString, opts.end)
                    };
                    else if (typeof opts.endIndex === 'number') end = this.positionInside(opts.endIndex);
                    else if (typeof opts.index === 'number') end = this.positionInside(opts.index + 1);
                }
                if (end.line < start.line || end.line === start.line && end.column <= start.column) end = {
                    column: start.column + 1,
                    line: start.line,
                    offset: start.offset + 1
                };
                return {
                    end: end,
                    start: start
                };
            }
        },
        {
            key: "raw",
            value: function raw(prop, defaultType) {
                var str = new $frsxx();
                return str.raw(this, prop, defaultType);
            }
        },
        {
            key: "remove",
            value: function remove() {
                if (this.parent) this.parent.removeChild(this);
                this.parent = undefined;
                return this;
            }
        },
        {
            key: "replaceWith",
            value: function replaceWith() {
                for(var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++){
                    nodes[_key] = arguments[_key];
                }
                if (this.parent) {
                    var bookmark = this;
                    var foundSelf = false;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var node = _step.value;
                            if (node === this) foundSelf = true;
                            else if (foundSelf) {
                                this.parent.insertAfter(bookmark, node);
                                bookmark = node;
                            } else this.parent.insertBefore(bookmark, node);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (!foundSelf) this.remove();
                }
                return this;
            }
        },
        {
            key: "root",
            value: function root() {
                var result = this;
                while(result.parent && result.parent.type !== 'document')result = result.parent;
                return result;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(_, inputs) {
                var emitInputs = inputs == null;
                inputs = inputs || new Map();
                // A worklist instead of recursive `toJSON()` calls to survive deeply
                // nested trees. Each entry converts one node and writes the result
                // into the already converted parent by [holder, key].
                var holderOfRoot = [];
                var queue = [
                    [
                        this,
                        holderOfRoot,
                        0
                    ]
                ];
                for(var step = 0; step < queue.length; step++){
                    var _queue_step = (0, $21h22._)(queue[step], 3), node = _queue_step[0], holder = _queue_step[1], key = _queue_step[2];
                    var fixed = {};
                    holder[key] = fixed;
                    for(var name in node){
                        if (!Object.prototype.hasOwnProperty.call(node, name)) continue;
                        if (name === 'parent' || name === 'proxyCache') continue;
                        var value = node[name];
                        if (Array.isArray(value)) {
                            var fixedArray = [];
                            fixed[name] = fixedArray;
                            for(var i = 0; i < value.length; i++){
                                var item = value[i];
                                if ((typeof item === "undefined" ? "undefined" : (0, $2bfPH._)(item)) === 'object' && item.toJSON) {
                                    if (item.toJSON === Node.prototype.toJSON) queue.push([
                                        item,
                                        fixedArray,
                                        i
                                    ]);
                                    else fixedArray[i] = item.toJSON(null, inputs);
                                } else fixedArray[i] = item;
                            }
                        } else if ((typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) === 'object' && value.toJSON) {
                            if (value.toJSON === Node.prototype.toJSON) queue.push([
                                value,
                                fixed,
                                name
                            ]);
                            else fixed[name] = value.toJSON(null, inputs);
                        } else if (name === 'source') {
                            if (value == null) continue;
                            var inputId = inputs.get(value.input);
                            if (inputId == null) {
                                inputId = inputs.size;
                                inputs.set(value.input, inputId);
                            }
                            fixed[name] = {
                                end: value.end,
                                inputId: inputId,
                                start: value.start
                            };
                        } else fixed[name] = value;
                    }
                }
                var fixed1 = holderOfRoot[0];
                if (emitInputs) fixed1.inputs = (0, $6zk1M._)(inputs.keys()).map(function(input) {
                    return input.toJSON();
                });
                return fixed1;
            }
        },
        {
            key: "toProxy",
            value: function toProxy() {
                if (!this.proxyCache) this.proxyCache = new Proxy(this, this.getProxyProcessor());
                return this.proxyCache;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var stringifier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $6WwiZ;
                if (stringifier.stringify) stringifier = stringifier.stringify;
                var result = '';
                stringifier(this, function(i) {
                    result += i;
                });
                return result;
            }
        },
        {
            key: "warn",
            value: function warn(result, text) {
                var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var data = {
                    node: this
                };
                for(var i in opts)data[i] = opts[i];
                return result.warn(text, data);
            }
        }
    ]);
    return Node;
}();
module.exports = $d2eb5fbc94041c9c$var$Node;
$d2eb5fbc94041c9c$var$Node.default = $d2eb5fbc94041c9c$var$Node;

});
parcelRegister("21h22", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1788e2ed61915b1e$export$71511d61b312f219; });

var $cMcR0 = parcelRequire("cMcR0");

var $dSjL4 = parcelRequire("dSjL4");

var $3HRhO = parcelRequire("3HRhO");

var $isiou = parcelRequire("isiou");
function $1788e2ed61915b1e$export$71511d61b312f219(arr, i) {
    return (0, $cMcR0._)(arr) || (0, $dSjL4._)(arr, i) || (0, $isiou._)(arr, i) || (0, $3HRhO._)();
}

});
parcelRegister("cMcR0", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $94d3f045916e0583$export$71511d61b312f219; });
function $94d3f045916e0583$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("dSjL4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a19fa517098223d7$export$71511d61b312f219; });
function $a19fa517098223d7$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("3HRhO", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2b2eb8ca3633154b$export$71511d61b312f219; });
function $2b2eb8ca3633154b$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("kyruP", function(module, exports) {

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $NBk0Y = parcelRequire("NBk0Y");

var $dHaQg = parcelRequire("dHaQg");
'use strict';

var $eSZyB = parcelRequire("eSZyB");

var $BMbiM = parcelRequire("BMbiM");
var $ef6c4fce4245ca75$var$CssSyntaxError = /*#__PURE__*/ function(Error1) {
    (0, $NBk0Y._)(CssSyntaxError, Error1);
    function CssSyntaxError(message, line, column, source, file, plugin) {
        (0, $gd0sY._)(this, CssSyntaxError);
        var _this;
        _this = (0, $8xMIM._)(this, CssSyntaxError, [
            message
        ]);
        _this.name = 'CssSyntaxError';
        _this.reason = message;
        if (file) _this.file = file;
        if (source) _this.source = source;
        if (plugin) _this.plugin = plugin;
        if (typeof line !== 'undefined' && typeof column !== 'undefined') {
            if (typeof line === 'number') {
                _this.line = line;
                _this.column = column;
            } else {
                _this.line = line.line;
                _this.column = line.column;
                _this.endLine = column.line;
                _this.endColumn = column.column;
            }
        }
        _this.setMessage();
        if (Error.captureStackTrace) Error.captureStackTrace(_this, CssSyntaxError);
        return _this;
    }
    (0, $7cSld._)(CssSyntaxError, [
        {
            key: "setMessage",
            value: function setMessage() {
                this.message = this.plugin ? this.plugin + ': ' : '';
                this.message += this.file ? this.file : '<css input>';
                if (typeof this.line !== 'undefined') this.message += ':' + this.line + ':' + this.column;
                this.message += ': ' + this.reason;
            }
        },
        {
            key: "showSourceCode",
            value: function showSourceCode(color) {
                var _this = this;
                if (!this.source) return '';
                var css = this.source;
                if (color == null) color = $eSZyB.isColorSupported;
                var aside = function(text) {
                    return text;
                };
                var mark = function(text) {
                    return text;
                };
                var highlight = function(text) {
                    return text;
                };
                if (color) {
                    var _pico_createColors = $eSZyB.createColors(true), bold = _pico_createColors.bold, gray = _pico_createColors.gray, red = _pico_createColors.red;
                    mark = function(text) {
                        return bold(red(text));
                    };
                    aside = function(text) {
                        return gray(text);
                    };
                    if ($BMbiM) highlight = function(text) {
                        return $BMbiM(text);
                    };
                }
                var lines = css.split(/\r?\n/);
                var start = Math.max(this.line - 3, 0);
                var end = Math.min(this.line + 2, lines.length);
                var maxWidth = String(end).length;
                return lines.slice(start, end).map(function(line, index) {
                    var number = start + 1 + index;
                    var gutter = ' ' + (' ' + number).slice(-maxWidth) + ' | ';
                    if (number === _this.line) {
                        if (line.length > 160) {
                            var padding = 20;
                            var subLineStart = Math.max(0, _this.column - padding);
                            var subLineEnd = Math.max(_this.column + padding, _this.endColumn + padding);
                            var subLine = line.slice(subLineStart, subLineEnd);
                            var spacing = aside(gutter.replace(/\d/g, ' ')) + line.slice(0, Math.min(_this.column - 1, padding - 1)).replace(/[^\t]/g, ' ');
                            return mark('>') + aside(gutter) + highlight(subLine) + '\n ' + spacing + mark('^');
                        }
                        var spacing1 = aside(gutter.replace(/\d/g, ' ')) + line.slice(0, _this.column - 1).replace(/[^\t]/g, ' ');
                        return mark('>') + aside(gutter) + highlight(line) + '\n ' + spacing1 + mark('^');
                    }
                    return ' ' + aside(gutter) + highlight(line);
                }).join('\n');
            }
        },
        {
            key: "toString",
            value: function toString() {
                var code = this.showSourceCode();
                if (code) code = '\n\n' + code + '\n';
                return this.name + ': ' + this.message + code;
            }
        }
    ]);
    return CssSyntaxError;
}((0, $dHaQg._)(Error));
module.exports = $ef6c4fce4245ca75$var$CssSyntaxError;
$ef6c4fce4245ca75$var$CssSyntaxError.default = $ef6c4fce4245ca75$var$CssSyntaxError;

});
parcelRegister("eSZyB", function(module, exports) {
var $ad65dbd07a99fcf1$var$x = String;
var $ad65dbd07a99fcf1$var$create = function create() {
    return {
        isColorSupported: false,
        reset: $ad65dbd07a99fcf1$var$x,
        bold: $ad65dbd07a99fcf1$var$x,
        dim: $ad65dbd07a99fcf1$var$x,
        italic: $ad65dbd07a99fcf1$var$x,
        underline: $ad65dbd07a99fcf1$var$x,
        inverse: $ad65dbd07a99fcf1$var$x,
        hidden: $ad65dbd07a99fcf1$var$x,
        strikethrough: $ad65dbd07a99fcf1$var$x,
        black: $ad65dbd07a99fcf1$var$x,
        red: $ad65dbd07a99fcf1$var$x,
        green: $ad65dbd07a99fcf1$var$x,
        yellow: $ad65dbd07a99fcf1$var$x,
        blue: $ad65dbd07a99fcf1$var$x,
        magenta: $ad65dbd07a99fcf1$var$x,
        cyan: $ad65dbd07a99fcf1$var$x,
        white: $ad65dbd07a99fcf1$var$x,
        gray: $ad65dbd07a99fcf1$var$x,
        bgBlack: $ad65dbd07a99fcf1$var$x,
        bgRed: $ad65dbd07a99fcf1$var$x,
        bgGreen: $ad65dbd07a99fcf1$var$x,
        bgYellow: $ad65dbd07a99fcf1$var$x,
        bgBlue: $ad65dbd07a99fcf1$var$x,
        bgMagenta: $ad65dbd07a99fcf1$var$x,
        bgCyan: $ad65dbd07a99fcf1$var$x,
        bgWhite: $ad65dbd07a99fcf1$var$x,
        blackBright: $ad65dbd07a99fcf1$var$x,
        redBright: $ad65dbd07a99fcf1$var$x,
        greenBright: $ad65dbd07a99fcf1$var$x,
        yellowBright: $ad65dbd07a99fcf1$var$x,
        blueBright: $ad65dbd07a99fcf1$var$x,
        magentaBright: $ad65dbd07a99fcf1$var$x,
        cyanBright: $ad65dbd07a99fcf1$var$x,
        whiteBright: $ad65dbd07a99fcf1$var$x,
        bgBlackBright: $ad65dbd07a99fcf1$var$x,
        bgRedBright: $ad65dbd07a99fcf1$var$x,
        bgGreenBright: $ad65dbd07a99fcf1$var$x,
        bgYellowBright: $ad65dbd07a99fcf1$var$x,
        bgBlueBright: $ad65dbd07a99fcf1$var$x,
        bgMagentaBright: $ad65dbd07a99fcf1$var$x,
        bgCyanBright: $ad65dbd07a99fcf1$var$x,
        bgWhiteBright: $ad65dbd07a99fcf1$var$x
    };
};
module.exports = $ad65dbd07a99fcf1$var$create();
module.exports.createColors = $ad65dbd07a99fcf1$var$create;

});

parcelRegister("BMbiM", function(module, exports) {
"use strict";

});


parcelRegister("frsxx", function(module, exports) {

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");
'use strict';
// Characters that end an at-rule name, mirroring RE_AT_END in the tokenizer.
// Params starting with anything else need a space to stay separate tokens.
var $b3df840da8354e81$var$AT_NAME_END = /[\t\n\f\r "#'()/;[\\\]{}]/;
var $b3df840da8354e81$var$DEFAULT_RAW = {
    after: '\n',
    beforeClose: '\n',
    beforeComment: '\n',
    beforeDecl: '\n',
    beforeOpen: ' ',
    beforeRule: '\n',
    colon: ': ',
    commentLeft: ' ',
    commentRight: ' ',
    emptyBody: '',
    indent: '    ',
    semicolon: false
};
function $b3df840da8354e81$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}
function $b3df840da8354e81$var$atruleStart(str, node) {
    var name = '@' + node.name;
    var params = node.params ? str.rawValue(node, 'params') : '';
    var afterName = node.raws.afterName;
    if (typeof afterName === 'undefined') afterName = params ? ' ' : '';
    else if (afterName === '' && params && !$b3df840da8354e81$var$AT_NAME_END.test(params[0])) afterName = ' ';
    return name + afterName + params;
}
// `*--x` is not a custom property: the parser checks the first token, and the
// `*`/`_` hack prefix moves from `prop` into `before` only after that. A free
// semicolon in front of the declaration also ends up in `before`.
function $b3df840da8354e81$var$isCustomProperty(node) {
    if (!node.prop.startsWith('--')) return false;
    var before = node.raws.before;
    return typeof before === 'undefined' || !/[^\s;]$/.test(before);
}
function $b3df840da8354e81$var$pushBody(str, stack, node) {
    var nodes = node.nodes;
    var last = nodes.length - 1;
    while(last > 0){
        if (nodes[last].type !== 'comment') break;
        last -= 1;
    }
    var semicolon = str.raw(node, 'semicolon');
    var isDocument = node.type === 'document';
    for(var i = nodes.length - 1; i >= 0; i--){
        var child = nodes[i];
        var childSemicolon = last !== i || semicolon;
        // A childless at-rule or a custom property declaration that still has
        // following siblings must be terminated. Without the semicolon those
        // trailing comments are folded into the at-rule's prelude or the custom
        // property's value and disappear when the output is re-parsed.
        if (!childSemicolon && i < nodes.length - 1 && (child.type === 'atrule' && !child.nodes || child.type === 'decl' && $b3df840da8354e81$var$isCustomProperty(child))) childSemicolon = true;
        stack.push({
            document: isDocument,
            node: child,
            semicolon: childSemicolon
        });
    }
}
function $b3df840da8354e81$var$pushBlock(str, stack, node, start) {
    var between = str.raw(node, 'between', 'beforeOpen');
    str.builder(start + between + '{', node, 'start');
    var hasNodes = node.nodes && node.nodes.length;
    var close = function() {
        var after = hasNodes ? str.raw(node, 'after') : str.raw(node, 'after', 'emptyBody');
        if (after) str.builder(after);
        str.builder('}', node, 'end');
        if (node.type === 'rule' && node.raws.ownSemicolon) str.builder(node.raws.ownSemicolon, node, 'end');
    };
    if (hasNodes) {
        stack.push(close);
        $b3df840da8354e81$var$pushBody(str, stack, node);
    } else close();
}
var $b3df840da8354e81$var$Stringifier = /*#__PURE__*/ function() {
    function Stringifier(builder) {
        (0, $gd0sY._)(this, Stringifier);
        this.builder = builder;
    }
    (0, $7cSld._)(Stringifier, [
        {
            key: "atrule",
            value: function atrule(node, semicolon) {
                var start = $b3df840da8354e81$var$atruleStart(this, node);
                if (node.nodes) this.block(node, start);
                else {
                    var end = (node.raws.between || '') + (semicolon ? ';' : '');
                    this.builder(start + end, node);
                }
            }
        },
        {
            key: "beforeAfter",
            value: function beforeAfter(node, detect) {
                var value;
                if (node.type === 'decl') value = this.raw(node, null, 'beforeDecl');
                else if (node.type === 'comment') value = this.raw(node, null, 'beforeComment');
                else if (detect === 'before') value = this.raw(node, null, 'beforeRule');
                else value = this.raw(node, null, 'beforeClose');
                var buf = node.parent;
                var depth = 0;
                while(buf && buf.type !== 'root'){
                    depth += 1;
                    buf = buf.parent;
                }
                if (value.includes('\n')) {
                    var indent = this.raw(node, null, 'indent');
                    if (indent.length) for(var step = 0; step < depth; step++)value += indent;
                }
                return value;
            }
        },
        {
            key: "block",
            value: function block(node, start) {
                var between = this.raw(node, 'between', 'beforeOpen');
                this.builder(start + between + '{', node, 'start');
                var after;
                if (node.nodes && node.nodes.length) {
                    this.body(node);
                    after = this.raw(node, 'after');
                } else after = this.raw(node, 'after', 'emptyBody');
                if (after) this.builder(after);
                this.builder('}', node, 'end');
            }
        },
        {
            key: "body",
            value: function body(node) {
                var _this = this;
                // Rules and at-rules are expanded into an explicit stack instead of
                // recursive `stringify()` calls to survive deeply nested trees.
                // If a subclass changes the traversal methods, its children go
                // through `stringify()` to keep the override in charge.
                var proto = Stringifier.prototype;
                var expandable = [
                    'atrule',
                    'block',
                    'body',
                    'rule',
                    'stringify'
                ].every(function(method) {
                    return _this[method] === proto[method];
                });
                var stack = [];
                $b3df840da8354e81$var$pushBody(this, stack, node);
                while(stack.length > 0){
                    var entry = stack.pop();
                    if (typeof entry === 'function') {
                        entry();
                        continue;
                    }
                    var child = entry.node;
                    var before = this.raw(child, 'before');
                    if (before) this.builder(before);
                    if (expandable && child.type === 'rule') $b3df840da8354e81$var$pushBlock(this, stack, child, this.rawValue(child, 'selector'));
                    else if (expandable && child.type === 'atrule' && child.nodes) $b3df840da8354e81$var$pushBlock(this, stack, child, $b3df840da8354e81$var$atruleStart(this, child));
                    else this.stringify(child, entry.semicolon);
                }
            }
        },
        {
            key: "comment",
            value: function comment(node) {
                var left = this.raw(node, 'left', 'commentLeft');
                var right = this.raw(node, 'right', 'commentRight');
                this.builder('/*' + left + node.text + right + '*/', node);
            }
        },
        {
            key: "decl",
            value: function decl(node, semicolon) {
                var raws = node.raws;
                var between = this.raw(node, 'between', 'colon');
                var string = node.prop + between + this.rawValue(node, 'value');
                if (node.important) string += raws.important || ' !important';
                if (semicolon) string += ';';
                this.builder(string, node);
            }
        },
        {
            key: "document",
            value: function document(node) {
                this.body(node);
            }
        },
        {
            key: "raw",
            value: function raw(node, own, detect) {
                var value;
                if (!detect) detect = own;
                // Already had
                if (own) {
                    value = node.raws[own];
                    if (typeof value !== 'undefined') return value;
                }
                var parent = node.parent;
                if (detect === 'before') {
                    // Hack for first rule in CSS
                    if (!parent || parent.type === 'root' && parent.first === node) return '';
                    // `root` nodes in `document` should use only their own raws
                    if (parent && parent.type === 'document') return '';
                }
                // Floating child without parent
                if (!parent) return $b3df840da8354e81$var$DEFAULT_RAW[detect];
                // Detect style by other nodes
                var root = node.root();
                var cache = root.rawCache || (root.rawCache = {});
                if (typeof cache[detect] !== 'undefined') return cache[detect];
                if (detect === 'before' || detect === 'after') return this.beforeAfter(node, detect);
                else {
                    var method = 'raw' + $b3df840da8354e81$var$capitalize(detect);
                    if (this[method]) value = this[method](root, node);
                    else root.walk(function(i) {
                        value = i.raws[own];
                        if (typeof value !== 'undefined') return false;
                    });
                }
                if (typeof value === 'undefined') value = $b3df840da8354e81$var$DEFAULT_RAW[detect];
                cache[detect] = value;
                return value;
            }
        },
        {
            key: "rawBeforeClose",
            value: function rawBeforeClose(root) {
                var value;
                root.walk(function(i) {
                    if (i.nodes && i.nodes.length > 0) {
                        if (typeof i.raws.after !== 'undefined') {
                            value = i.raws.after;
                            if (value.includes('\n')) value = value.replace(/[^\n]+$/, '');
                            return false;
                        }
                    }
                });
                if (value) value = value.replace(/\S/g, '');
                return value;
            }
        },
        {
            key: "rawBeforeComment",
            value: function rawBeforeComment(root, node) {
                var value;
                root.walkComments(function(i) {
                    if (typeof i.raws.before !== 'undefined') {
                        value = i.raws.before;
                        if (value.includes('\n')) value = value.replace(/[^\n]+$/, '');
                        return false;
                    }
                });
                if (typeof value === 'undefined') value = this.raw(node, null, 'beforeDecl');
                else if (value) value = value.replace(/\S/g, '');
                return value;
            }
        },
        {
            key: "rawBeforeDecl",
            value: function rawBeforeDecl(root, node) {
                var value;
                root.walkDecls(function(i) {
                    if (typeof i.raws.before !== 'undefined') {
                        value = i.raws.before;
                        if (value.includes('\n')) value = value.replace(/[^\n]+$/, '');
                        return false;
                    }
                });
                if (typeof value === 'undefined') value = this.raw(node, null, 'beforeRule');
                else if (value) value = value.replace(/\S/g, '');
                return value;
            }
        },
        {
            key: "rawBeforeOpen",
            value: function rawBeforeOpen(root) {
                var value;
                root.walk(function(i) {
                    if (i.type !== 'decl') {
                        value = i.raws.between;
                        if (typeof value !== 'undefined') return false;
                    }
                });
                return value;
            }
        },
        {
            key: "rawBeforeRule",
            value: function rawBeforeRule(root) {
                var value;
                root.walk(function(i) {
                    if (i.nodes && (i.parent !== root || root.first !== i)) {
                        if (typeof i.raws.before !== 'undefined') {
                            value = i.raws.before;
                            if (value.includes('\n')) value = value.replace(/[^\n]+$/, '');
                            return false;
                        }
                    }
                });
                if (value) value = value.replace(/\S/g, '');
                return value;
            }
        },
        {
            key: "rawColon",
            value: function rawColon(root) {
                var value;
                root.walkDecls(function(i) {
                    if (typeof i.raws.between !== 'undefined') {
                        value = i.raws.between.replace(/[^\s:]/g, '');
                        return false;
                    }
                });
                return value;
            }
        },
        {
            key: "rawEmptyBody",
            value: function rawEmptyBody(root) {
                var value;
                root.walk(function(i) {
                    if (i.nodes && i.nodes.length === 0) {
                        value = i.raws.after;
                        if (typeof value !== 'undefined') return false;
                    }
                });
                return value;
            }
        },
        {
            key: "rawIndent",
            value: function rawIndent(root) {
                if (root.raws.indent) return root.raws.indent;
                var value;
                root.walk(function(i) {
                    var p = i.parent;
                    if (p && p !== root && p.parent && p.parent === root) {
                        if (typeof i.raws.before !== 'undefined') {
                            var parts = i.raws.before.split('\n');
                            value = parts[parts.length - 1];
                            value = value.replace(/\S/g, '');
                            return false;
                        }
                    }
                });
                return value;
            }
        },
        {
            key: "rawSemicolon",
            value: function rawSemicolon(root) {
                var value;
                root.walk(function(i) {
                    if (i.nodes && i.nodes.length && i.last.type === 'decl') {
                        value = i.raws.semicolon;
                        if (typeof value !== 'undefined') return false;
                    }
                });
                return value;
            }
        },
        {
            key: "rawValue",
            value: function rawValue(node, prop) {
                var value = node[prop];
                var raw = node.raws[prop];
                if (raw && raw.value === value) return raw.raw;
                return value;
            }
        },
        {
            key: "root",
            value: function root(node) {
                var inDocument = node.parent && node.parent.type === 'document';
                if (!inDocument && node.source && node.source.input.hasBOM) this.builder('\uFEFF', node, 'start');
                this.body(node);
                if (node.raws.after) this.builder(node.raws.after);
            }
        },
        {
            key: "rule",
            value: function rule(node) {
                this.block(node, this.rawValue(node, 'selector'));
                if (node.raws.ownSemicolon) this.builder(node.raws.ownSemicolon, node, 'end');
            }
        },
        {
            key: "stringify",
            value: function stringify(node, semicolon) {
                /* c8 ignore start */ if (!this[node.type]) throw new Error('Unknown AST node type ' + node.type + '. ' + 'Maybe you need to change PostCSS stringifier.');
                /* c8 ignore stop */ this[node.type](node, semicolon);
            }
        }
    ]);
    return Stringifier;
}();
module.exports = $b3df840da8354e81$var$Stringifier;
$b3df840da8354e81$var$Stringifier.default = $b3df840da8354e81$var$Stringifier;

});

parcelRegister("6WwiZ", function(module, exports) {

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");
'use strict';

var $frsxx = parcelRequire("frsxx");
var $50e138060ef29341$var$STYLE_TAG = /(<)(\/?style\b)/gi;
var $50e138060ef29341$var$COMMENT_OPEN = /(<)(!--)/g;
function $50e138060ef29341$var$escapeHTMLInCSS(str) {
    if (!str.includes('<')) return str;
    return str.replace($50e138060ef29341$var$STYLE_TAG, '\\3c $2').replace($50e138060ef29341$var$COMMENT_OPEN, '\\3c $2');
}
function $50e138060ef29341$var$cutEscaped(chunks, css, escaped) {
    var parts = [];
    var at = 0;
    var into = 0;
    for(var i = 0; i < chunks.length; i += 3){
        var from = into;
        var end = at + chunks[i].length;
        while(at < end)if (css[at] === escaped[into]) {
            at += 1;
            into += 1;
        } else {
            // The `<` of this pair was replaced by the `\3c ` in front of it
            at += 1;
            into += 4;
        }
        parts.push(escaped.slice(from, into));
    }
    return parts;
}
var $50e138060ef29341$var$SafeStringifier = /*#__PURE__*/ function(Stringifier) {
    (0, $NBk0Y._)(SafeStringifier, Stringifier);
    function SafeStringifier() {
        (0, $gd0sY._)(this, SafeStringifier);
        return (0, $8xMIM._)(this, SafeStringifier, arguments);
    }
    (0, $7cSld._)(SafeStringifier, [
        {
            key: "escapeHTML",
            value: function escapeHTML(print) {
                var builder = this.builder;
                var chunks, css;
                this.builder = function(str, child, type) {
                    if (chunks) {
                        css += str;
                        chunks.push(str, child, type);
                    } else if (str.includes('<')) {
                        // Dangerous sequences start with `<`, so everything before
                        // the first `<` is safe to pass through. The rest is buffered
                        // to escape it as a whole.
                        css = str;
                        chunks = [
                            str,
                            child,
                            type
                        ];
                    } else builder(str, child, type);
                };
                print();
                this.builder = builder;
                if (!chunks) return;
                var escaped = $50e138060ef29341$var$escapeHTMLInCSS(css);
                if (escaped === css) // Keep the chunks to get a precise source map
                for(var i = 0; i < chunks.length; i += 3)builder(chunks[i], chunks[i + 1], chunks[i + 2]);
                else {
                    var parts = $50e138060ef29341$var$cutEscaped(chunks, css, escaped);
                    for(var i1 = 0; i1 < chunks.length; i1 += 3)builder(parts[i1 / 3], chunks[i1 + 1], chunks[i1 + 2]);
                }
            }
        },
        {
            key: "root",
            value: function root(node) {
                var _this = this;
                if (node.parent && node.parent.type === 'document') {
                    // Document raws around the Root hold markup and are kept as is since CSS in Document can be marked with <style>
                    this.escapeHTML(function() {
                        return _this.body(node);
                    });
                    if (node.raws.after) this.builder(node.raws.after);
                } else this.escapeHTML(function() {
                    return (0, $bl6Nv._)((0, $7GsX9._)(SafeStringifier.prototype), "root", _this).call(_this, node);
                });
            }
        }
    ]);
    return SafeStringifier;
}($frsxx);
function $50e138060ef29341$var$stringify(node, builder) {
    var str = new $50e138060ef29341$var$SafeStringifier(builder);
    // Root escapes its own output and keeps markup in Document raws
    if (node.type === 'root' || node.type === 'document') str.stringify(node);
    else str.escapeHTML(function() {
        return str.stringify(node);
    });
}
module.exports = $50e138060ef29341$var$stringify;
$50e138060ef29341$var$stringify.default = $50e138060ef29341$var$stringify;

});

parcelRegister("187Aq", function(module, exports) {

$parcel$export(module.exports, "isClean", function () { return $0d2c6c50ea6f32e8$export$ae5e7911ce0728f9; }, function (v) { return $0d2c6c50ea6f32e8$export$ae5e7911ce0728f9 = v; });
$parcel$export(module.exports, "my", function () { return $0d2c6c50ea6f32e8$export$94fa0a6beb22f989; }, function (v) { return $0d2c6c50ea6f32e8$export$94fa0a6beb22f989 = v; });
var $0d2c6c50ea6f32e8$export$ae5e7911ce0728f9;
var $0d2c6c50ea6f32e8$export$94fa0a6beb22f989;
'use strict';
$0d2c6c50ea6f32e8$export$ae5e7911ce0728f9 = Symbol('isClean');
$0d2c6c50ea6f32e8$export$94fa0a6beb22f989 = Symbol('my');

});



parcelRegister("3MpJA", function(module, exports) {

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $NBk0Y = parcelRequire("NBk0Y");

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $dHaQg = parcelRequire("dHaQg");
'use strict';

var $i6IAv = parcelRequire("i6IAv");
var $2c09d1118e175cff$var$Declaration = /*#__PURE__*/ function(Node) {
    (0, $NBk0Y._)(Declaration, Node);
    function Declaration(defaults) {
        (0, $gd0sY._)(this, Declaration);
        var _this;
        if (defaults && typeof defaults.value !== 'undefined' && typeof defaults.value !== 'string') defaults = (0, $9Jpjh._)((0, $lvTkn._)({}, defaults), {
            value: String(defaults.value)
        });
        _this = (0, $8xMIM._)(this, Declaration, [
            defaults
        ]);
        _this.type = 'decl';
        return _this;
    }
    (0, $7cSld._)(Declaration, [
        {
            key: "variable",
            get: function get() {
                return this.prop.startsWith('--') || this.prop[0] === '$';
            }
        }
    ]);
    return Declaration;
}((0, $dHaQg._)($i6IAv));
module.exports = $2c09d1118e175cff$var$Declaration;
$2c09d1118e175cff$var$Declaration.default = $2c09d1118e175cff$var$Declaration;

});
parcelRegister("lvTkn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fa9769297b8a68c8$export$71511d61b312f219; });

var $khBmn = parcelRequire("khBmn");
function $fa9769297b8a68c8$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $khBmn._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("khBmn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ec426015f75d7738$export$71511d61b312f219; });
function $ec426015f75d7738$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("9Jpjh", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $715bf31211e65705$export$71511d61b312f219; });
function $715bf31211e65705$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $715bf31211e65705$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $715bf31211e65705$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});




parcelRegister("juIUa", function(module, exports) {

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $NBk0Y = parcelRequire("NBk0Y");

var $lvTkn = parcelRequire("lvTkn");
'use strict';

var $97P0p = parcelRequire("97P0p");
var $e313a6d4033449cf$var$LazyResult, $e313a6d4033449cf$var$Processor;
var $e313a6d4033449cf$var$Document = /*#__PURE__*/ function(Container) {
    (0, $NBk0Y._)(Document, Container);
    function Document(defaults) {
        (0, $gd0sY._)(this, Document);
        var _this;
        // type needs to be passed to super, otherwise child roots won't be normalized correctly
        _this = (0, $8xMIM._)(this, Document, [
            (0, $lvTkn._)({
                type: 'document'
            }, defaults)
        ]);
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    (0, $7cSld._)(Document, [
        {
            key: "toResult",
            value: function toResult() {
                var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var lazy = new $e313a6d4033449cf$var$LazyResult(new $e313a6d4033449cf$var$Processor(), this, opts);
                return lazy.stringify();
            }
        }
    ]);
    return Document;
}($97P0p);
$e313a6d4033449cf$var$Document.registerLazyResult = function(dependant) {
    $e313a6d4033449cf$var$LazyResult = dependant;
};
$e313a6d4033449cf$var$Document.registerProcessor = function(dependant) {
    $e313a6d4033449cf$var$Processor = dependant;
};
module.exports = $e313a6d4033449cf$var$Document;
$e313a6d4033449cf$var$Document.default = $e313a6d4033449cf$var$Document;

});

parcelRegister("czT62", function(module, exports) {

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $aRv4I = parcelRequire("aRv4I");
'use strict';

var $kAGiU = parcelRequire("kAGiU");

var $7lbcT = parcelRequire("7lbcT");

var $3MpJA = parcelRequire("3MpJA");

var $cdX05 = parcelRequire("cdX05");

var $2eQEP = parcelRequire("2eQEP");

var $kw7YN = parcelRequire("kw7YN");

var $faiIs = parcelRequire("faiIs");
function $92837deda84fdabd$var$hydrateInputs(json, inputs) {
    if (!json.inputs) return inputs;
    return json.inputs.map(function(input) {
        var inputHydrated = (0, $9Jpjh._)((0, $lvTkn._)({}, input), {
            __proto__: $cdX05.prototype
        });
        if (inputHydrated.map) inputHydrated.map = (0, $9Jpjh._)((0, $lvTkn._)({}, inputHydrated.map), {
            __proto__: $2eQEP.prototype
        });
        return inputHydrated;
    });
}
function $92837deda84fdabd$var$constructNode(json, inputs, children) {
    var defaults = (0, $lvTkn._)({}, json);
    delete defaults.inputs;
    delete defaults.nodes;
    if (defaults.source) {
        var _defaults_source = defaults.source, inputId = _defaults_source.inputId, source = (0, $aRv4I._)(_defaults_source, [
            "inputId"
        ]);
        defaults.source = source;
        if (inputId != null) defaults.source.input = inputs[inputId];
    }
    var node;
    if (defaults.type === 'root') node = new $kw7YN(defaults);
    else if (defaults.type === 'decl') node = new $3MpJA(defaults);
    else if (defaults.type === 'rule') node = new $faiIs(defaults);
    else if (defaults.type === 'comment') node = new $7lbcT(defaults);
    else if (defaults.type === 'atrule') node = new $kAGiU(defaults);
    else throw new Error('Unknown node type: ' + json.type);
    // Rehydrated children are attached after construction. Passing them
    // through the container constructor would re-run insertion spacing
    // normalization and overwrite each child's own `raws.before`.
    if (children) {
        node.nodes = children;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                child.parent = node;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return node;
}
function $92837deda84fdabd$var$fromJSON(json, inputs) {
    if (Array.isArray(json)) return json.map(function(n) {
        return $92837deda84fdabd$var$fromJSON(n);
    });
    // An explicit stack instead of recursive calls to survive deeply
    // nested trees. Children are rehydrated before their parent node
    // is constructed.
    var result;
    var stack = [
        {
            childIndex: 0,
            children: [],
            inputs: $92837deda84fdabd$var$hydrateInputs(json, inputs),
            json: json
        }
    ];
    while(stack.length > 0){
        var frame = stack[stack.length - 1];
        var jsonNodes = frame.json.nodes;
        if (jsonNodes && frame.childIndex < jsonNodes.length) {
            var childJson = jsonNodes[frame.childIndex];
            frame.childIndex += 1;
            stack.push({
                childIndex: 0,
                children: [],
                inputs: $92837deda84fdabd$var$hydrateInputs(childJson, frame.inputs),
                json: childJson
            });
            continue;
        }
        stack.pop();
        var node = $92837deda84fdabd$var$constructNode(frame.json, frame.inputs, jsonNodes ? frame.children : undefined);
        if (stack.length > 0) stack[stack.length - 1].children.push(node);
        else result = node;
    }
    return result;
}
module.exports = $92837deda84fdabd$var$fromJSON;
$92837deda84fdabd$var$fromJSON.default = $92837deda84fdabd$var$fromJSON;

});
parcelRegister("aRv4I", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7e86f5813bbb0f77$export$71511d61b312f219; });

var $gCwzj = parcelRequire("gCwzj");
function $7e86f5813bbb0f77$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = (0, $gCwzj._)(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("gCwzj", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c19975616f0f5e3a$export$71511d61b312f219; });
function $c19975616f0f5e3a$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("cdX05", function(module, exports) {

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $lvTkn = parcelRequire("lvTkn");

var $2bfPH = parcelRequire("2bfPH");
'use strict';

var $hzoFu = parcelRequire("hzoFu");
var $8e64773090d62e09$require$nanoid = $hzoFu.nanoid;

var $BMbiM = parcelRequire("BMbiM");
var $8e64773090d62e09$var$isAbsolute = $BMbiM.isAbsolute, $8e64773090d62e09$var$resolve = $BMbiM.resolve;

var $BMbiM = parcelRequire("BMbiM");
var $8e64773090d62e09$var$SourceMapConsumer = $BMbiM.SourceMapConsumer, $8e64773090d62e09$var$SourceMapGenerator = $BMbiM.SourceMapGenerator;

var $BMbiM = parcelRequire("BMbiM");
var $8e64773090d62e09$var$fileURLToPath = $BMbiM.fileURLToPath, $8e64773090d62e09$var$pathToFileURL = $BMbiM.pathToFileURL;

var $kyruP = parcelRequire("kyruP");

var $2eQEP = parcelRequire("2eQEP");

var $BMbiM = parcelRequire("BMbiM");
var $8e64773090d62e09$var$lineToIndexCache = Symbol('lineToIndexCache');
var $8e64773090d62e09$var$sourceMapAvailable = Boolean($8e64773090d62e09$var$SourceMapConsumer && $8e64773090d62e09$var$SourceMapGenerator);
var $8e64773090d62e09$var$pathAvailable = Boolean($8e64773090d62e09$var$resolve && $8e64773090d62e09$var$isAbsolute);
function $8e64773090d62e09$var$getLineToIndex(input) {
    if (input[$8e64773090d62e09$var$lineToIndexCache]) return input[$8e64773090d62e09$var$lineToIndexCache];
    var lines = input.css.split('\n');
    var lineToIndex = new Array(lines.length);
    var prevIndex = 0;
    for(var i = 0, l = lines.length; i < l; i++){
        lineToIndex[i] = prevIndex;
        prevIndex += lines[i].length + 1;
    }
    input[$8e64773090d62e09$var$lineToIndexCache] = lineToIndex;
    return lineToIndex;
}
var $8e64773090d62e09$var$Input = /*#__PURE__*/ function() {
    function Input(css) {
        var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $gd0sY._)(this, Input);
        if (css === null || typeof css === 'undefined' || (typeof css === "undefined" ? "undefined" : (0, $2bfPH._)(css)) === 'object' && !css.toString) throw new Error("PostCSS received ".concat(css, " instead of CSS string"));
        this.css = css.toString();
        if (this.css[0] === '\uFEFF' || this.css[0] === '\uFFFE') {
            this.hasBOM = true;
            this.css = this.css.slice(1);
        } else this.hasBOM = false;
        this.document = this.css;
        if (opts.document) this.document = opts.document.toString();
        if (opts.from) {
            if (!$8e64773090d62e09$var$pathAvailable || /^\w+:\/\//.test(opts.from) || $8e64773090d62e09$var$isAbsolute(opts.from)) this.file = opts.from;
            else this.file = $8e64773090d62e09$var$resolve(opts.from);
        }
        if ($8e64773090d62e09$var$pathAvailable && $8e64773090d62e09$var$sourceMapAvailable) {
            var map = new $2eQEP(this.css, opts);
            if (map.text) {
                this.map = map;
                var file = map.consumer().file;
                if (!this.file && file) this.file = this.mapResolve(file);
            }
        }
        if (!this.file) this.id = '<input css ' + $8e64773090d62e09$require$nanoid(6) + '>';
        if (this.map) this.map.file = this.from;
    }
    (0, $7cSld._)(Input, [
        {
            key: "from",
            get: function get() {
                return this.file || this.id;
            }
        },
        {
            key: "error",
            value: function error(message, line, column) {
                var opts = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                var endColumn, endLine, endOffset, offset, result;
                if (line && (typeof line === "undefined" ? "undefined" : (0, $2bfPH._)(line)) === 'object') {
                    var start = line;
                    var end = column;
                    if (typeof start.offset === 'number') {
                        offset = start.offset;
                        var pos = this.fromOffset(offset);
                        line = pos.line;
                        column = pos.col;
                    } else {
                        line = start.line;
                        column = start.column;
                        offset = this.fromLineAndColumn(line, column);
                    }
                    if (typeof end.offset === 'number') {
                        endOffset = end.offset;
                        var pos1 = this.fromOffset(endOffset);
                        endLine = pos1.line;
                        endColumn = pos1.col;
                    } else {
                        endLine = end.line;
                        endColumn = end.column;
                        endOffset = this.fromLineAndColumn(end.line, end.column);
                    }
                } else if (!column) {
                    offset = line;
                    var pos2 = this.fromOffset(offset);
                    line = pos2.line;
                    column = pos2.col;
                } else offset = this.fromLineAndColumn(line, column);
                var origin = this.origin(line, column, endLine, endColumn);
                if (origin) result = new $kyruP(message, origin.endLine === undefined ? origin.line : {
                    column: origin.column,
                    line: origin.line
                }, origin.endLine === undefined ? origin.column : {
                    column: origin.endColumn,
                    line: origin.endLine
                }, origin.source, origin.file, opts.plugin);
                else result = new $kyruP(message, endLine === undefined ? line : {
                    column: column,
                    line: line
                }, endLine === undefined ? column : {
                    column: endColumn,
                    line: endLine
                }, this.css, this.file, opts.plugin);
                result.input = {
                    column: column,
                    endColumn: endColumn,
                    endLine: endLine,
                    endOffset: endOffset,
                    line: line,
                    offset: offset,
                    source: this.css
                };
                if (this.file) {
                    if ($8e64773090d62e09$var$pathToFileURL) result.input.url = $8e64773090d62e09$var$pathToFileURL(this.file).toString();
                    result.input.file = this.file;
                }
                return result;
            }
        },
        {
            key: "fromLineAndColumn",
            value: function fromLineAndColumn(line, column) {
                var lineToIndex = $8e64773090d62e09$var$getLineToIndex(this);
                var index = lineToIndex[line - 1];
                return index + column - 1;
            }
        },
        {
            key: "fromOffset",
            value: function fromOffset(offset) {
                var lineToIndex = $8e64773090d62e09$var$getLineToIndex(this);
                var lastLine = lineToIndex[lineToIndex.length - 1];
                var min = 0;
                if (offset >= lastLine) min = lineToIndex.length - 1;
                else {
                    var max = lineToIndex.length - 2;
                    var mid;
                    while(min < max){
                        mid = min + (max - min >> 1);
                        if (offset < lineToIndex[mid]) max = mid - 1;
                        else if (offset >= lineToIndex[mid + 1]) min = mid + 1;
                        else {
                            min = mid;
                            break;
                        }
                    }
                }
                return {
                    col: offset - lineToIndex[min] + 1,
                    line: min + 1
                };
            }
        },
        {
            key: "mapResolve",
            value: function mapResolve(file) {
                if (/^\w+:\/\//.test(file)) return file;
                return $8e64773090d62e09$var$resolve(this.map.consumer().sourceRoot || this.map.root || '.', file);
            }
        },
        {
            key: "origin",
            value: function origin(line, column, endLine, endColumn) {
                if (!this.map) return false;
                var consumer = this.map.consumer();
                var from = consumer.originalPositionFor({
                    column: column - 1,
                    line: line
                });
                if (!from.source) return false;
                var to;
                if (typeof endLine === 'number') {
                    var toPosition = consumer.originalPositionFor({
                        column: endColumn - 1,
                        line: endLine
                    });
                    // The source map may not have a mapping that covers the end position
                    // (`originalPositionFor()` then returns `null` for `line`/`column`
                    // instead of omitting them). Treat that the same as not requesting
                    // an end position at all, so `endLine`/`endColumn` stay a consistent
                    // `undefined` pair instead of a mix of `null` and a bogus number.
                    if (toPosition.source) to = toPosition;
                }
                var fromUrl;
                if ($8e64773090d62e09$var$isAbsolute(from.source)) fromUrl = $8e64773090d62e09$var$pathToFileURL(from.source);
                else fromUrl = new URL(from.source, this.map.consumer().sourceRoot || $8e64773090d62e09$var$pathToFileURL(this.map.mapFile));
                var result = {
                    column: from.column + 1,
                    endColumn: to && to.column + 1,
                    endLine: to && to.line,
                    line: from.line,
                    url: fromUrl.toString()
                };
                if (fromUrl.protocol === 'file:') {
                    if ($8e64773090d62e09$var$fileURLToPath) result.file = $8e64773090d62e09$var$fileURLToPath(fromUrl);
                    else /* c8 ignore next 2 */ throw new Error("file: protocol is not available in this PostCSS build");
                }
                var source = consumer.sourceContentFor(from.source);
                if (source) result.source = source;
                return result;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var json = {};
                for(var _i = 0, _iter = [
                    'hasBOM',
                    'css',
                    'file',
                    'id'
                ]; _i < _iter.length; _i++){
                    var name = _iter[_i];
                    if (this[name] != null) json[name] = this[name];
                }
                if (this.map) {
                    json.map = (0, $lvTkn._)({}, this.map);
                    if (json.map.consumerCache) json.map.consumerCache = undefined;
                }
                return json;
            }
        }
    ]);
    return Input;
}();
module.exports = $8e64773090d62e09$var$Input;
$8e64773090d62e09$var$Input.default = $8e64773090d62e09$var$Input;
if ($BMbiM && $BMbiM.registerInput) $BMbiM.registerInput($8e64773090d62e09$var$Input);

});
parcelRegister("hzoFu", function(module, exports) {

$parcel$export(module.exports, "nanoid", function () { return $cca8d7245a96e150$export$ac4959f4f1338dfc; });
var $cca8d7245a96e150$var$urlAlphabet = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
var $cca8d7245a96e150$export$62e99e5c9f473d7f = function(alphabet) {
    var defaultSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 21;
    return function() {
        var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultSize;
        var id = '';
        var i = size | 0;
        while(i-- > 0)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
var $cca8d7245a96e150$export$ac4959f4f1338dfc = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 21;
    var id = '';
    var i = size | 0;
    while(i-- > 0)id += $cca8d7245a96e150$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};

});

parcelRegister("2eQEP", function(module, exports) {

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $2bfPH = parcelRequire("2bfPH");

var $hjdi2 = parcelRequire("hjdi2");
var $1a15bc4a2f1fc808$require$Buffer = $hjdi2.Buffer;
'use strict';

var $BMbiM = parcelRequire("BMbiM");
var $1a15bc4a2f1fc808$var$existsSync = $BMbiM.existsSync, $1a15bc4a2f1fc808$var$readFileSync = $BMbiM.readFileSync, $1a15bc4a2f1fc808$var$realpathSync = $BMbiM.realpathSync;

var $BMbiM = parcelRequire("BMbiM");
var $1a15bc4a2f1fc808$var$dirname = $BMbiM.dirname, $1a15bc4a2f1fc808$var$isAbsolute = $BMbiM.isAbsolute, $1a15bc4a2f1fc808$var$join = $BMbiM.join, $1a15bc4a2f1fc808$var$relative = $BMbiM.relative, $1a15bc4a2f1fc808$var$sep = $BMbiM.sep;

var $BMbiM = parcelRequire("BMbiM");
var $1a15bc4a2f1fc808$var$SourceMapConsumer = $BMbiM.SourceMapConsumer, $1a15bc4a2f1fc808$var$SourceMapGenerator = $BMbiM.SourceMapGenerator;
function $1a15bc4a2f1fc808$var$realPath(path) {
    try {
        return $1a15bc4a2f1fc808$var$realpathSync(path);
    } catch (e) {
        // Missing or dangling: keep the literal path. The existsSync() check below
        // still gates the read, and a path that does not exist cannot escape.
        return path;
    }
}
function $1a15bc4a2f1fc808$var$fromBase64(str) {
    if ($1a15bc4a2f1fc808$require$Buffer) return $1a15bc4a2f1fc808$require$Buffer.from(str, 'base64').toString();
    else /* c8 ignore next 2 */ return window.atob(str);
}
var $1a15bc4a2f1fc808$var$PreviousMap = /*#__PURE__*/ function() {
    "use strict";
    function PreviousMap(css, opts) {
        (0, $gd0sY._)(this, PreviousMap);
        if (opts.map === false) return;
        if (opts.unsafeMap) this.unsafeMap = true;
        this.loadAnnotation(css);
        this.inline = this.startWith(this.annotation, 'data:');
        var prev = opts.map ? opts.map.prev : undefined;
        var text = this.loadMap(opts.from, prev);
        if (!this.mapFile && opts.from) this.mapFile = opts.from;
        if (this.mapFile) this.root = $1a15bc4a2f1fc808$var$dirname(this.mapFile);
        if (text) this.text = text;
    }
    (0, $7cSld._)(PreviousMap, [
        {
            key: "consumer",
            value: function consumer() {
                if (!this.consumerCache) this.consumerCache = new $1a15bc4a2f1fc808$var$SourceMapConsumer(this.json || this.text);
                return this.consumerCache;
            }
        },
        {
            key: "decodeInline",
            value: function decodeInline(text) {
                var baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
                var baseUri = /^data:application\/json;base64,/;
                var charsetUri = /^data:application\/json;charset=utf-?8,/;
                var uri = /^data:application\/json,/;
                var uriMatch = text.match(charsetUri) || text.match(uri);
                if (uriMatch) return decodeURIComponent(text.substr(uriMatch[0].length));
                var baseUriMatch = text.match(baseCharsetUri) || text.match(baseUri);
                if (baseUriMatch) return $1a15bc4a2f1fc808$var$fromBase64(text.substr(baseUriMatch[0].length));
                var encoding = text.slice(22);
                encoding = encoding.slice(0, encoding.indexOf(','));
                throw new Error('Unsupported source map encoding ' + encoding);
            }
        },
        {
            key: "getAnnotationURL",
            value: function getAnnotationURL(sourceMapString) {
                return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, '').trim();
            }
        },
        {
            key: "isMap",
            value: function isMap(map) {
                if ((typeof map === "undefined" ? "undefined" : (0, $2bfPH._)(map)) !== 'object') return false;
                return typeof map.mappings === 'string' || typeof map._mappings === 'string' || Array.isArray(map.sections);
            }
        },
        {
            key: "loadAnnotation",
            value: function loadAnnotation(css) {
                var comments = css.match(/\/\*\s*# sourceMappingURL=/g);
                if (!comments) return;
                // sourceMappingURLs from comments, strings, etc.
                var start = css.lastIndexOf(comments.pop());
                var end = css.indexOf('*/', start);
                if (start > -1 && end > -1) // Locate the last sourceMappingURL to avoid pickin
                this.annotation = this.getAnnotationURL(css.substring(start, end));
            }
        },
        {
            key: "loadFile",
            value: function loadFile(path, cssFile, trusted) {
                if (!trusted && !this.unsafeMap) {
                    if (!/\.map$/i.test(path)) return undefined;
                    if (!cssFile) return undefined;
                    // Compare *resolved* paths: relative() is textual, so without this a
                    // symlink at or below the CSS file's directory points the map outside it.
                    var rel = $1a15bc4a2f1fc808$var$relative($1a15bc4a2f1fc808$var$realPath($1a15bc4a2f1fc808$var$dirname(cssFile)), $1a15bc4a2f1fc808$var$realPath(path));
                    if (rel === '..' || rel.startsWith('..' + $1a15bc4a2f1fc808$var$sep) || $1a15bc4a2f1fc808$var$isAbsolute(rel)) return undefined;
                }
                this.root = $1a15bc4a2f1fc808$var$dirname(path);
                if ($1a15bc4a2f1fc808$var$existsSync(path)) {
                    this.mapFile = path;
                    return $1a15bc4a2f1fc808$var$readFileSync(path, 'utf-8').toString().trim();
                }
            }
        },
        {
            key: "loadMap",
            value: function loadMap(file, prev) {
                if (prev === false) return false;
                if (prev) {
                    if (typeof prev === 'string') return prev;
                    else if (typeof prev === 'function') {
                        var prevPath = prev(file);
                        if (prevPath) {
                            var map = this.loadFile(prevPath, file, true);
                            if (!map) throw new Error('Unable to load previous source map: ' + prevPath.toString());
                            return map;
                        }
                    } else if (prev instanceof $1a15bc4a2f1fc808$var$SourceMapConsumer) return $1a15bc4a2f1fc808$var$SourceMapGenerator.fromSourceMap(prev).toString();
                    else if (prev instanceof $1a15bc4a2f1fc808$var$SourceMapGenerator) return prev.toString();
                    else if (this.isMap(prev)) return JSON.stringify(prev);
                    else throw new Error('Unsupported previous source map format: ' + prev.toString());
                } else if (this.inline) return this.decodeInline(this.annotation);
                else if (this.annotation) {
                    var map1 = this.annotation;
                    if (file) map1 = $1a15bc4a2f1fc808$var$join($1a15bc4a2f1fc808$var$dirname(file), map1);
                    var unknown = this.loadFile(map1, file, false);
                    if (unknown) try {
                        /* c8 ignore next 4 */ this.json = JSON.parse(unknown.replace(/^\)]}'[^\n]*\n/, ''));
                    } catch (e) {
                        return undefined;
                    }
                    return unknown;
                }
            }
        },
        {
            key: "startWith",
            value: function startWith(string, start) {
                if (!string) return false;
                return string.substr(0, start.length) === start;
            }
        },
        {
            key: "withContent",
            value: function withContent() {
                return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
            }
        }
    ]);
    return PreviousMap;
}();
module.exports = $1a15bc4a2f1fc808$var$PreviousMap;
$1a15bc4a2f1fc808$var$PreviousMap.default = $1a15bc4a2f1fc808$var$PreviousMap;

});


parcelRegister("kw7YN", function(module, exports) {

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $2bfPH = parcelRequire("2bfPH");
'use strict';

var $97P0p = parcelRequire("97P0p");
var $eefcfc6212fd00e0$var$LazyResult, $eefcfc6212fd00e0$var$Processor;
var $eefcfc6212fd00e0$var$Root = /*#__PURE__*/ function(Container) {
    (0, $NBk0Y._)(Root, Container);
    function Root(defaults) {
        (0, $gd0sY._)(this, Root);
        var _this;
        _this = (0, $8xMIM._)(this, Root, [
            defaults
        ]);
        _this.type = 'root';
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    (0, $7cSld._)(Root, [
        {
            key: "normalize",
            value: function normalize(child, sample, type) {
                var keepBefore = new Set();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (Array.isArray(child) ? child : [
                        child
                    ])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        if (node && (typeof node === "undefined" ? "undefined" : (0, $2bfPH._)(node)) === 'object' && !node.parent && node.raws && typeof node.raws.before !== 'undefined') keepBefore.add(node.raws);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var nodes = (0, $bl6Nv._)((0, $7GsX9._)(Root.prototype), "normalize", this).call(this, child);
                if (sample) {
                    if (type === 'prepend') {
                        if (this.nodes.length > 1) sample.raws.before = this.nodes[1].raws.before;
                        else delete sample.raws.before;
                    } else if (this.first !== sample) {
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = nodes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var node1 = _step1.value;
                                if (!keepBefore.has(node1.raws)) node1.raws.before = sample.raws.before;
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                }
                return nodes;
            }
        },
        {
            key: "removeChild",
            value: function removeChild(child, ignore) {
                var index = this.index(child);
                if (!ignore && index === 0 && this.nodes.length > 1) this.nodes[1].raws.before = this.nodes[index].raws.before;
                return (0, $bl6Nv._)((0, $7GsX9._)(Root.prototype), "removeChild", this).call(this, child);
            }
        },
        {
            key: "toResult",
            value: function toResult() {
                var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var lazy = new $eefcfc6212fd00e0$var$LazyResult(new $eefcfc6212fd00e0$var$Processor(), this, opts);
                return lazy.stringify();
            }
        }
    ]);
    return Root;
}($97P0p);
$eefcfc6212fd00e0$var$Root.registerLazyResult = function(dependant) {
    $eefcfc6212fd00e0$var$LazyResult = dependant;
};
$eefcfc6212fd00e0$var$Root.registerProcessor = function(dependant) {
    $eefcfc6212fd00e0$var$Processor = dependant;
};
module.exports = $eefcfc6212fd00e0$var$Root;
$eefcfc6212fd00e0$var$Root.default = $eefcfc6212fd00e0$var$Root;
$97P0p.registerRoot($eefcfc6212fd00e0$var$Root);

});

parcelRegister("faiIs", function(module, exports) {

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $NBk0Y = parcelRequire("NBk0Y");
'use strict';

var $97P0p = parcelRequire("97P0p");

var $3XYS5 = parcelRequire("3XYS5");
var $b0a64ecdcb5c175e$var$Rule = /*#__PURE__*/ function(Container) {
    (0, $NBk0Y._)(Rule, Container);
    function Rule(defaults) {
        (0, $gd0sY._)(this, Rule);
        var _this;
        _this = (0, $8xMIM._)(this, Rule, [
            defaults
        ]);
        _this.type = 'rule';
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    (0, $7cSld._)(Rule, [
        {
            key: "selectors",
            get: function get() {
                return $3XYS5.comma(this.selector);
            },
            set: function set(values) {
                var match = this.selector ? this.selector.match(/,\s*/) : null;
                var sep = match ? match[0] : ',' + this.raw('between', 'beforeOpen');
                this.selector = values.join(sep);
            }
        }
    ]);
    return Rule;
}($97P0p);
module.exports = $b0a64ecdcb5c175e$var$Rule;
$b0a64ecdcb5c175e$var$Rule.default = $b0a64ecdcb5c175e$var$Rule;
$97P0p.registerRule($b0a64ecdcb5c175e$var$Rule);

});
parcelRegister("3XYS5", function(module, exports) {
'use strict';
var $2e36198ea6d8bfdb$var$list = {
    comma: function(string) {
        return $2e36198ea6d8bfdb$var$list.split(string, [
            ','
        ], true);
    },
    space: function(string) {
        var spaces = [
            ' ',
            '\n',
            '\t'
        ];
        return $2e36198ea6d8bfdb$var$list.split(string, spaces);
    },
    split: function(string, separators, last) {
        if (typeof string !== 'string') return [];
        var array = [];
        var current = '';
        var split = false;
        var func = 0;
        var inQuote = false;
        var prevQuote = '';
        var escape = false;
        var inComment = false;
        for(var i = 0; i < string.length; i++){
            var letter = string[i];
            if (inComment) {
                current += letter;
                if (letter === '*' && string[i + 1] === '/') {
                    current += '/';
                    i += 1;
                    inComment = false;
                }
                continue;
            }
            if (escape) escape = false;
            else if (letter === '\\') escape = true;
            else if (inQuote) {
                if (letter === prevQuote) inQuote = false;
            } else if (letter === '"' || letter === "'") {
                inQuote = true;
                prevQuote = letter;
            } else if (letter === '/' && string[i + 1] === '*') {
                current += '/*';
                i += 1;
                inComment = true;
                continue;
            } else if (letter === '(') func += 1;
            else if (letter === ')') {
                if (func > 0) func -= 1;
            } else if (func === 0) {
                if (separators.includes(letter)) split = true;
            }
            if (split) {
                var value = current.trim();
                if (last || value !== '') array.push(value);
                current = '';
                split = false;
            } else current += letter;
        }
        var value1 = current.trim();
        if (last || value1 !== '') array.push(value1);
        return array;
    }
};
module.exports = $2e36198ea6d8bfdb$var$list;
$2e36198ea6d8bfdb$var$list.default = $2e36198ea6d8bfdb$var$list;

});



parcelRegister("k6evn", function(module, exports) {

var $1Mz1E = parcelRequire("1Mz1E");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $21h22 = parcelRequire("21h22");

var $2bfPH = parcelRequire("2bfPH");

var $iLZuz = parcelRequire("iLZuz");

var $6PS3Z = parcelRequire("6PS3Z");
'use strict';

var $97P0p = parcelRequire("97P0p");

var $juIUa = parcelRequire("juIUa");

var $2bF0I = parcelRequire("2bF0I");

var $2ZjIU = parcelRequire("2ZjIU");

var $4EyWg = parcelRequire("4EyWg");

var $kw7YN = parcelRequire("kw7YN");

var $6WwiZ = parcelRequire("6WwiZ");

var $187Aq = parcelRequire("187Aq");
var $ea1f9e9743e8882e$var$isClean = $187Aq.isClean, $ea1f9e9743e8882e$var$my = $187Aq.my;
parcelRequire("2iTct");
var $ea1f9e9743e8882e$var$TYPE_TO_CLASS_NAME = {
    atrule: 'AtRule',
    comment: 'Comment',
    decl: 'Declaration',
    document: 'Document',
    root: 'Root',
    rule: 'Rule'
};
var $ea1f9e9743e8882e$var$PLUGIN_PROPS = {
    AtRule: true,
    AtRuleExit: true,
    Comment: true,
    CommentExit: true,
    Declaration: true,
    DeclarationExit: true,
    Document: true,
    DocumentExit: true,
    Once: true,
    OnceExit: true,
    postcssPlugin: true,
    prepare: true,
    Root: true,
    RootExit: true,
    Rule: true,
    RuleExit: true
};
var $ea1f9e9743e8882e$var$NOT_VISITORS = {
    Once: true,
    postcssPlugin: true,
    prepare: true
};
var $ea1f9e9743e8882e$var$CHILDREN = 0;
function $ea1f9e9743e8882e$var$isPromise(obj) {
    return (typeof obj === "undefined" ? "undefined" : (0, $2bfPH._)(obj)) === 'object' && typeof obj.then === 'function';
}
function $ea1f9e9743e8882e$var$getEvents(node) {
    var key = false;
    var type = $ea1f9e9743e8882e$var$TYPE_TO_CLASS_NAME[node.type];
    if (node.type === 'decl') key = node.prop.toLowerCase();
    else if (node.type === 'atrule') key = node.name.toLowerCase();
    if (key && node.append) return [
        type,
        type + '-' + key,
        $ea1f9e9743e8882e$var$CHILDREN,
        type + 'Exit',
        type + 'Exit-' + key
    ];
    else if (key) return [
        type,
        type + '-' + key,
        type + 'Exit',
        type + 'Exit-' + key
    ];
    else if (node.append) return [
        type,
        $ea1f9e9743e8882e$var$CHILDREN,
        type + 'Exit'
    ];
    else return [
        type,
        type + 'Exit'
    ];
}
function $ea1f9e9743e8882e$var$toStack(node) {
    var events;
    if (node.type === 'document') events = [
        'Document',
        $ea1f9e9743e8882e$var$CHILDREN,
        'DocumentExit'
    ];
    else if (node.type === 'root') events = [
        'Root',
        $ea1f9e9743e8882e$var$CHILDREN,
        'RootExit'
    ];
    else events = $ea1f9e9743e8882e$var$getEvents(node);
    return {
        eventIndex: 0,
        events: events,
        iterator: 0,
        node: node,
        visitorIndex: 0,
        visitors: []
    };
}
function $ea1f9e9743e8882e$var$cleanMarks(node) {
    var stack = [
        node
    ];
    while(stack.length > 0){
        var next = stack.pop();
        next[$ea1f9e9743e8882e$var$isClean] = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (next.nodes) try {
            for(var _iterator = next.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var i = _step.value;
                stack.push(i);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return node;
}
var $ea1f9e9743e8882e$var$postcss = {};
var $ea1f9e9743e8882e$var$LazyResult = /*#__PURE__*/ function() {
    function LazyResult(processor, css, opts) {
        var _this = this;
        (0, $gd0sY._)(this, LazyResult);
        this.stringified = false;
        this.processed = false;
        var root;
        if ((typeof css === "undefined" ? "undefined" : (0, $2bfPH._)(css)) === 'object' && css !== null && (css.type === 'root' || css.type === 'document')) root = $ea1f9e9743e8882e$var$cleanMarks(css);
        else if (css instanceof LazyResult || css instanceof $4EyWg) {
            root = $ea1f9e9743e8882e$var$cleanMarks(css.root);
            if (css.map) {
                if (typeof opts.map === 'undefined') opts.map = {};
                if (!opts.map.inline) opts.map.inline = false;
                opts.map.prev = css.map;
            }
        } else {
            var parser = $2ZjIU;
            if (opts.syntax) parser = opts.syntax.parse;
            if (opts.parser) parser = opts.parser;
            if (parser.parse) parser = parser.parse;
            try {
                root = parser(css, opts);
            } catch (error) {
                this.processed = true;
                this.error = error;
            }
            if (root && !root[$ea1f9e9743e8882e$var$my]) /* c8 ignore next 2 */ $97P0p.rebuild(root);
        }
        this.result = new $4EyWg(processor, root, opts);
        this.helpers = (0, $9Jpjh._)((0, $lvTkn._)({}, $ea1f9e9743e8882e$var$postcss), {
            postcss: $ea1f9e9743e8882e$var$postcss,
            result: this.result
        });
        this.plugins = this.processor.plugins.map(function(plugin) {
            if ((typeof plugin === "undefined" ? "undefined" : (0, $2bfPH._)(plugin)) === 'object' && plugin.prepare) return (0, $lvTkn._)({}, plugin, plugin.prepare(_this.result));
            else return plugin;
        });
    }
    (0, $7cSld._)(LazyResult, [
        {
            key: "content",
            get: function get() {
                return this.stringify().content;
            }
        },
        {
            key: "css",
            get: function get() {
                return this.stringify().css;
            }
        },
        {
            key: "map",
            get: function get() {
                return this.stringify().map;
            }
        },
        {
            key: "messages",
            get: function get() {
                return this.sync().messages;
            }
        },
        {
            key: "opts",
            get: function get() {
                return this.result.opts;
            }
        },
        {
            key: "processor",
            get: function get() {
                return this.result.processor;
            }
        },
        {
            key: "root",
            get: function get() {
                return this.sync().root;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return 'LazyResult';
            }
        },
        {
            key: "async",
            value: function async() {
                if (this.error) return Promise.reject(this.error);
                if (this.processed) return Promise.resolve(this.result);
                if (!this.processing) this.processing = this.runAsync();
                return this.processing;
            }
        },
        {
            key: "catch",
            value: function _catch(onRejected) {
                return this.async().catch(onRejected);
            }
        },
        {
            key: "finally",
            value: function _finally(onFinally) {
                return this.async().then(onFinally, onFinally);
            }
        },
        {
            key: "getAsyncError",
            value: function getAsyncError() {
                throw new Error('Use process(css).then(cb) to work with async plugins');
            }
        },
        {
            key: "handleError",
            value: function handleError(error, node) {
                var plugin = this.result.lastPlugin;
                try {
                    if (node) node.addToError(error);
                    this.error = error;
                    if (error.name === 'CssSyntaxError' && !error.plugin) {
                        error.plugin = plugin.postcssPlugin;
                        error.setMessage();
                    } else plugin.postcssVersion;
                } catch (err) {
                    /* c8 ignore next 3 */ // eslint-disable-next-line no-console
                    if (console && console.error) console.error(err);
                }
                return error;
            }
        },
        {
            key: "prepareVisitors",
            value: function prepareVisitors() {
                var _this = this;
                this.listeners = {};
                var add = function(plugin, type, cb) {
                    if (!_this.listeners[type]) _this.listeners[type] = [];
                    _this.listeners[type].push([
                        plugin,
                        cb
                    ]);
                };
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var plugin = _step.value;
                        if ((typeof plugin === "undefined" ? "undefined" : (0, $2bfPH._)(plugin)) === 'object') for(var event in plugin){
                            if (!$ea1f9e9743e8882e$var$PLUGIN_PROPS[event] && /^[A-Z]/.test(event)) throw new Error("Unknown event ".concat(event, " in ").concat(plugin.postcssPlugin, ". ") + "Try to update PostCSS (".concat(this.processor.version, " now)."));
                            if (!$ea1f9e9743e8882e$var$NOT_VISITORS[event]) {
                                if ((0, $2bfPH._)(plugin[event]) === 'object') {
                                    for(var filter in plugin[event])if (filter === '*') add(plugin, event, plugin[event][filter]);
                                    else add(plugin, event + '-' + filter.toLowerCase(), plugin[event][filter]);
                                } else if (typeof plugin[event] === 'function') add(plugin, event, plugin[event]);
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.hasListener = Object.keys(this.listeners).length > 0;
            }
        },
        {
            key: "runAsync",
            value: function runAsync() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                    var _this, i, plugin, promise, error, root, stack, promise1, e, node, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _this1, _loop, _iterator, _step, err;
                    return (0, $iLZuz._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                this.plugin = 0;
                                i = 0;
                                _state.label = 1;
                            case 1:
                                if (!(i < this.plugins.length)) return [
                                    3,
                                    6
                                ];
                                plugin = this.plugins[i];
                                promise = this.runOnRoot(plugin);
                                if (!$ea1f9e9743e8882e$var$isPromise(promise)) return [
                                    3,
                                    5
                                ];
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    promise
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                error = _state.sent();
                                throw this.handleError(error);
                            case 5:
                                i++;
                                return [
                                    3,
                                    1
                                ];
                            case 6:
                                this.prepareVisitors();
                                if (!this.hasListener) return [
                                    3,
                                    22
                                ];
                                root = this.result.root;
                                _state.label = 7;
                            case 7:
                                if (!!root[$ea1f9e9743e8882e$var$isClean]) return [
                                    3,
                                    14
                                ];
                                root[$ea1f9e9743e8882e$var$isClean] = true;
                                stack = [
                                    $ea1f9e9743e8882e$var$toStack(root)
                                ];
                                _state.label = 8;
                            case 8:
                                if (!(stack.length > 0)) return [
                                    3,
                                    13
                                ];
                                promise1 = this.visitTick(stack);
                                if (!$ea1f9e9743e8882e$var$isPromise(promise1)) return [
                                    3,
                                    12
                                ];
                                _state.label = 9;
                            case 9:
                                _state.trys.push([
                                    9,
                                    11,
                                    ,
                                    12
                                ]);
                                return [
                                    4,
                                    promise1
                                ];
                            case 10:
                                _state.sent();
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                e = _state.sent();
                                node = stack[stack.length - 1].node;
                                throw this.handleError(e, node);
                            case 12:
                                return [
                                    3,
                                    8
                                ];
                            case 13:
                                return [
                                    3,
                                    7
                                ];
                            case 14:
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                if (!this.listeners.OnceExit) return [
                                    3,
                                    22
                                ];
                                _state.label = 15;
                            case 15:
                                _state.trys.push([
                                    15,
                                    20,
                                    21,
                                    22
                                ]);
                                _loop = function() {
                                    var _step_value, plugin, visitor, roots, e;
                                    return (0, $iLZuz._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _step_value = (0, $21h22._)(_step.value, 2), plugin = _step_value[0], visitor = _step_value[1];
                                                _this1.result.lastPlugin = plugin;
                                                _state.label = 1;
                                            case 1:
                                                _state.trys.push([
                                                    1,
                                                    6,
                                                    ,
                                                    7
                                                ]);
                                                if (!(root.type === 'document')) return [
                                                    3,
                                                    3
                                                ];
                                                roots = root.nodes.map(function(subRoot) {
                                                    return visitor(subRoot, _this.helpers);
                                                });
                                                return [
                                                    4,
                                                    Promise.all(roots)
                                                ];
                                            case 2:
                                                _state.sent();
                                                return [
                                                    3,
                                                    5
                                                ];
                                            case 3:
                                                return [
                                                    4,
                                                    visitor(root, _this1.helpers)
                                                ];
                                            case 4:
                                                _state.sent();
                                                _state.label = 5;
                                            case 5:
                                                return [
                                                    3,
                                                    7
                                                ];
                                            case 6:
                                                e = _state.sent();
                                                throw _this1.handleError(e);
                                            case 7:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                };
                                _iterator = this.listeners.OnceExit[Symbol.iterator]();
                                _state.label = 16;
                            case 16:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    19
                                ];
                                _this1 = this;
                                return [
                                    5,
                                    (0, $6PS3Z.__values)(_loop())
                                ];
                            case 17:
                                _state.sent();
                                _state.label = 18;
                            case 18:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    16
                                ];
                            case 19:
                                return [
                                    3,
                                    22
                                ];
                            case 20:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    22
                                ];
                            case 21:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 22:
                                this.processed = true;
                                return [
                                    2,
                                    this.stringify()
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "runOnRoot",
            value: function runOnRoot(plugin) {
                var _this = this;
                this.result.lastPlugin = plugin;
                try {
                    if ((typeof plugin === "undefined" ? "undefined" : (0, $2bfPH._)(plugin)) === 'object' && plugin.Once) {
                        if (this.result.root.type === 'document') {
                            var roots = this.result.root.nodes.map(function(root) {
                                return plugin.Once(root, _this.helpers);
                            });
                            if ($ea1f9e9743e8882e$var$isPromise(roots[0])) return Promise.all(roots);
                            return roots;
                        }
                        return plugin.Once(this.result.root, this.helpers);
                    } else if (typeof plugin === 'function') return plugin(this.result.root, this.result);
                } catch (error) {
                    throw this.handleError(error);
                }
            }
        },
        {
            key: "stringify",
            value: function stringify1() {
                if (this.error) throw this.error;
                if (this.stringified) return this.result;
                this.stringified = true;
                this.sync();
                var opts = this.result.opts;
                var str = $6WwiZ;
                if (opts.syntax) str = opts.syntax.stringify;
                if (opts.stringifier) str = opts.stringifier;
                if (str.stringify) str = str.stringify;
                var rootSource = this.result.root.source;
                if (opts.map === undefined && !(rootSource && rootSource.input && rootSource.input.map)) {
                    var result = '';
                    str(this.result.root, function(i) {
                        result += i;
                    });
                    this.result.css = result;
                    return this.result;
                }
                var map = new $2bF0I(str, this.result.root, this.result.opts);
                var data = map.generate();
                this.result.css = data[0];
                this.result.map = data[1];
                return this.result;
            }
        },
        {
            key: "sync",
            value: function sync() {
                if (this.error) throw this.error;
                if (this.processed) return this.result;
                this.processed = true;
                if (this.processing) throw this.getAsyncError();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var plugin = _step.value;
                        var promise = this.runOnRoot(plugin);
                        if ($ea1f9e9743e8882e$var$isPromise(promise)) throw this.getAsyncError();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.prepareVisitors();
                if (this.hasListener) {
                    var root = this.result.root;
                    while(!root[$ea1f9e9743e8882e$var$isClean]){
                        root[$ea1f9e9743e8882e$var$isClean] = true;
                        this.walkSync(root);
                    }
                    if (this.listeners.OnceExit) {
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        if (root.type === 'document') try {
                            for(var _iterator1 = root.nodes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var subRoot = _step1.value;
                                this.visitSync(this.listeners.OnceExit, subRoot);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        else this.visitSync(this.listeners.OnceExit, root);
                    }
                }
                return this.result;
            }
        },
        {
            key: "then",
            value: function then(onFulfilled, onRejected) {
                return this.async().then(onFulfilled, onRejected);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.css;
            }
        },
        {
            key: "visitSync",
            value: function visitSync(visitors, node) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = visitors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $21h22._)(_step.value, 2), plugin = _step_value[0], visitor = _step_value[1];
                        this.result.lastPlugin = plugin;
                        var promise = void 0;
                        try {
                            promise = visitor(node, this.helpers);
                        } catch (e) {
                            throw this.handleError(e, node.proxyOf);
                        }
                        if (node.type !== 'root' && node.type !== 'document' && !node.parent) return true;
                        if ($ea1f9e9743e8882e$var$isPromise(promise)) throw this.getAsyncError();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "visitTick",
            value: function visitTick(stack) {
                var visit = stack[stack.length - 1];
                var node = visit.node, visitors = visit.visitors;
                if (node.type !== 'root' && node.type !== 'document' && !node.parent) {
                    stack.pop();
                    return;
                }
                if (visitors.length > 0 && visit.visitorIndex < visitors.length) {
                    var _visitors_visit_visitorIndex = (0, $21h22._)(visitors[visit.visitorIndex], 2), plugin = _visitors_visit_visitorIndex[0], visitor = _visitors_visit_visitorIndex[1];
                    visit.visitorIndex += 1;
                    if (visit.visitorIndex === visitors.length) {
                        visit.visitors = [];
                        visit.visitorIndex = 0;
                    }
                    this.result.lastPlugin = plugin;
                    try {
                        return visitor(node.toProxy(), this.helpers);
                    } catch (e) {
                        throw this.handleError(e, node);
                    }
                }
                if (visit.iterator !== 0) {
                    var iterator = visit.iterator;
                    // Advance past the child we just finished visiting. Like
                    // `Container#each`, the index is incremented only after a child has
                    // been fully processed, so a node inserted right after the current
                    // child is not skipped by the `existIndex < index` adjustment in
                    // `Container#insertAfter()` (which would fire exit events too early).
                    if (visit.descending) {
                        visit.descending = false;
                        node.indexes[iterator] += 1;
                    }
                    var child;
                    while(child = node.nodes[node.indexes[iterator]]){
                        if (!child[$ea1f9e9743e8882e$var$isClean]) {
                            child[$ea1f9e9743e8882e$var$isClean] = true;
                            visit.descending = true;
                            stack.push($ea1f9e9743e8882e$var$toStack(child));
                            return;
                        }
                        node.indexes[iterator] += 1;
                    }
                    visit.iterator = 0;
                    delete node.indexes[iterator];
                }
                var events = visit.events;
                while(visit.eventIndex < events.length){
                    var event = events[visit.eventIndex];
                    visit.eventIndex += 1;
                    if (event === $ea1f9e9743e8882e$var$CHILDREN) {
                        if (node.nodes && node.nodes.length) {
                            node[$ea1f9e9743e8882e$var$isClean] = true;
                            visit.iterator = node.getIterator();
                        }
                        return;
                    } else if (this.listeners[event]) {
                        visit.visitors = this.listeners[event];
                        return;
                    }
                }
                stack.pop();
            }
        },
        {
            key: "walkSync",
            value: function walkSync(node) {
                // An explicit stack like in async `visitTick()` to survive deeply
                // nested trees. Unlike `visitTick()`, nodes are marked clean only
                // on entering, so a node dirtied by its own visitors is revisited
                // on the next pass.
                node[$ea1f9e9743e8882e$var$isClean] = true;
                var stack = [
                    {
                        eventIndex: 0,
                        events: $ea1f9e9743e8882e$var$getEvents(node),
                        iterator: 0,
                        node: node
                    }
                ];
                while(stack.length > 0){
                    var visit = stack[stack.length - 1];
                    var visitNode = visit.node;
                    if (visit.iterator !== 0) {
                        var iterator = visit.iterator;
                        // Advance past the child we just finished visiting. Like
                        // `Container#each`, the index is incremented only after a child has
                        // been fully processed. Incrementing before (as this loop used to)
                        // makes a node inserted right after the current child get skipped by
                        // the `existIndex < index` adjustment in `Container#insertAfter()`,
                        // which fires exit events before those new siblings are visited.
                        if (visit.descending) {
                            visit.descending = false;
                            visitNode.indexes[iterator] += 1;
                        }
                        var child = void 0;
                        var descended = false;
                        while(child = visitNode.nodes[visitNode.indexes[iterator]]){
                            if (!child[$ea1f9e9743e8882e$var$isClean]) {
                                child[$ea1f9e9743e8882e$var$isClean] = true;
                                visit.descending = true;
                                stack.push({
                                    eventIndex: 0,
                                    events: $ea1f9e9743e8882e$var$getEvents(child),
                                    iterator: 0,
                                    node: child
                                });
                                descended = true;
                                break;
                            }
                            visitNode.indexes[iterator] += 1;
                        }
                        if (descended) continue;
                        visit.iterator = 0;
                        delete visitNode.indexes[iterator];
                    }
                    if (visit.eventIndex < visit.events.length) {
                        var event = visit.events[visit.eventIndex];
                        visit.eventIndex += 1;
                        if (event === $ea1f9e9743e8882e$var$CHILDREN) {
                            if (visitNode.nodes && visitNode.nodes.length) visit.iterator = visitNode.getIterator();
                        } else {
                            var visitors = this.listeners[event];
                            if (visitors) {
                                if (this.visitSync(visitors, visitNode.toProxy())) stack.pop();
                            }
                        }
                        continue;
                    }
                    stack.pop();
                }
            }
        },
        {
            key: "warnings",
            value: function warnings() {
                return this.sync().warnings();
            }
        }
    ]);
    return LazyResult;
}();
$ea1f9e9743e8882e$var$LazyResult.registerPostcss = function(dependant) {
    $ea1f9e9743e8882e$var$postcss = dependant;
};
module.exports = $ea1f9e9743e8882e$var$LazyResult;
$ea1f9e9743e8882e$var$LazyResult.default = $ea1f9e9743e8882e$var$LazyResult;
$kw7YN.registerLazyResult($ea1f9e9743e8882e$var$LazyResult);
$juIUa.registerLazyResult($ea1f9e9743e8882e$var$LazyResult);

});
parcelRegister("1Mz1E", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $14c571840e589f0e$export$71511d61b312f219; });
function $14c571840e589f0e$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $14c571840e589f0e$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $14c571840e589f0e$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $14c571840e589f0e$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("iLZuz", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $daac50d2f5864f61$export$71511d61b312f219; });
function $daac50d2f5864f61$export$71511d61b312f219(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}

});

parcelRegister("6PS3Z", function(module, exports) {

$parcel$export(module.exports, "__values", function () { return $4fa1715f971c561b$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $2bfPH = parcelRequire("2bfPH");
var $4fa1715f971c561b$var$extendStatics = function extendStatics1(d, b) {
    $4fa1715f971c561b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $4fa1715f971c561b$var$extendStatics(d, b);
};
function $4fa1715f971c561b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $4fa1715f971c561b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $4fa1715f971c561b$export$18ce0697a983be9b = function __assign1() {
    $4fa1715f971c561b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4fa1715f971c561b$export$18ce0697a983be9b.apply(this, arguments);
};
function $4fa1715f971c561b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $4fa1715f971c561b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $2bfPH._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $4fa1715f971c561b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $4fa1715f971c561b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $2bfPH._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $4fa1715f971c561b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $4fa1715f971c561b$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $2bfPH._)(x)) === "symbol" ? x : "".concat(x);
}
function $4fa1715f971c561b$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $2bfPH._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $4fa1715f971c561b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $2bfPH._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $4fa1715f971c561b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $4fa1715f971c561b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $4fa1715f971c561b$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $4fa1715f971c561b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $4fa1715f971c561b$export$45d3717a4c69092e(o, m, p);
}
function $4fa1715f971c561b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $4fa1715f971c561b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $4fa1715f971c561b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($4fa1715f971c561b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $4fa1715f971c561b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $4fa1715f971c561b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $4fa1715f971c561b$export$10c90e4f7922046c(v) {
    return this instanceof $4fa1715f971c561b$export$10c90e4f7922046c ? (this.v = v, this) : new $4fa1715f971c561b$export$10c90e4f7922046c(v);
}
function $4fa1715f971c561b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $4fa1715f971c561b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $4fa1715f971c561b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $4fa1715f971c561b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $4fa1715f971c561b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $4fa1715f971c561b$export$19a8beecd37a4c45 === "function" ? $4fa1715f971c561b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $4fa1715f971c561b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $4fa1715f971c561b$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $4fa1715f971c561b$var$ownKeys = function ownKeys1(o) {
    $4fa1715f971c561b$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $4fa1715f971c561b$var$ownKeys(o);
};
function $4fa1715f971c561b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $4fa1715f971c561b$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $4fa1715f971c561b$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $4fa1715f971c561b$var$__setModuleDefault(result, mod);
    return result;
}
function $4fa1715f971c561b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $4fa1715f971c561b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $4fa1715f971c561b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $4fa1715f971c561b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $2bfPH._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $4fa1715f971c561b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $4fa1715f971c561b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $4fa1715f971c561b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $4fa1715f971c561b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $4fa1715f971c561b$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $4fa1715f971c561b$export$2e2bcd8739ae039 = {
    __extends: $4fa1715f971c561b$export$a8ba968b8961cb8a,
    __assign: $4fa1715f971c561b$export$18ce0697a983be9b,
    __rest: $4fa1715f971c561b$export$3c9a16f847548506,
    __decorate: $4fa1715f971c561b$export$29e00dfd3077644b,
    __param: $4fa1715f971c561b$export$d5ad3fd78186038f,
    __esDecorate: $4fa1715f971c561b$export$3a84e1ae4e97e9b0,
    __runInitializers: $4fa1715f971c561b$export$d831c04e792af3d,
    __propKey: $4fa1715f971c561b$export$6a2a36740a146cb8,
    __setFunctionName: $4fa1715f971c561b$export$d1a06452d3489bc7,
    __metadata: $4fa1715f971c561b$export$f1db080c865becb9,
    __awaiter: $4fa1715f971c561b$export$1050f835b63b671e,
    __generator: $4fa1715f971c561b$export$67ebef60e6f28a6,
    __createBinding: $4fa1715f971c561b$export$45d3717a4c69092e,
    __exportStar: $4fa1715f971c561b$export$f33643c0debef087,
    __values: $4fa1715f971c561b$export$19a8beecd37a4c45,
    __read: $4fa1715f971c561b$export$8d051b38c9118094,
    __spread: $4fa1715f971c561b$export$afc72e2116322959,
    __spreadArrays: $4fa1715f971c561b$export$6388937ca91ccae8,
    __spreadArray: $4fa1715f971c561b$export$1216008129fb82ed,
    __await: $4fa1715f971c561b$export$10c90e4f7922046c,
    __asyncGenerator: $4fa1715f971c561b$export$e427f37a30a4de9b,
    __asyncDelegator: $4fa1715f971c561b$export$bbd80228419bb833,
    __asyncValues: $4fa1715f971c561b$export$e3b29a3d6162315f,
    __makeTemplateObject: $4fa1715f971c561b$export$4fb47efe1390b86f,
    __importStar: $4fa1715f971c561b$export$c21735bcef00d192,
    __importDefault: $4fa1715f971c561b$export$da59b14a69baef04,
    __classPrivateFieldGet: $4fa1715f971c561b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $4fa1715f971c561b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $4fa1715f971c561b$export$81fdc39f203e4e04,
    __addDisposableResource: $4fa1715f971c561b$export$88ac25d8e944e405,
    __disposeResources: $4fa1715f971c561b$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $4fa1715f971c561b$export$889dfb5d17574b0b
};

});

parcelRegister("2bF0I", function(module, exports) {

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $hjdi2 = parcelRequire("hjdi2");
var $197c6bad57e53eb3$require$Buffer = $hjdi2.Buffer;
'use strict';

var $BMbiM = parcelRequire("BMbiM");
var $197c6bad57e53eb3$var$dirname = $BMbiM.dirname, $197c6bad57e53eb3$var$relative = $BMbiM.relative, $197c6bad57e53eb3$var$resolve = $BMbiM.resolve, $197c6bad57e53eb3$var$sep = $BMbiM.sep;

var $BMbiM = parcelRequire("BMbiM");
var $197c6bad57e53eb3$var$SourceMapConsumer = $BMbiM.SourceMapConsumer, $197c6bad57e53eb3$var$SourceMapGenerator = $BMbiM.SourceMapGenerator;

var $BMbiM = parcelRequire("BMbiM");
var $197c6bad57e53eb3$require$pathToFileURL = $BMbiM.pathToFileURL;

var $cdX05 = parcelRequire("cdX05");
var $197c6bad57e53eb3$var$sourceMapAvailable = Boolean($197c6bad57e53eb3$var$SourceMapConsumer && $197c6bad57e53eb3$var$SourceMapGenerator);
var $197c6bad57e53eb3$var$pathAvailable = Boolean($197c6bad57e53eb3$var$dirname && $197c6bad57e53eb3$var$resolve && $197c6bad57e53eb3$var$relative && $197c6bad57e53eb3$var$sep);
var $197c6bad57e53eb3$var$MapGenerator = /*#__PURE__*/ function() {
    "use strict";
    function MapGenerator(stringify, root, opts, cssString) {
        (0, $gd0sY._)(this, MapGenerator);
        this.stringify = stringify;
        this.mapOpts = opts.map || {};
        this.root = root;
        this.opts = opts;
        this.css = cssString;
        this.originalCSS = cssString;
        this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
        this.memoizedFileURLs = new Map();
        this.memoizedPaths = new Map();
        this.memoizedURLs = new Map();
    }
    (0, $7cSld._)(MapGenerator, [
        {
            key: "addAnnotation",
            value: function addAnnotation() {
                var content;
                if (this.isInline()) content = 'data:application/json;base64,' + this.toBase64(this.map.toString());
                else if (typeof this.mapOpts.annotation === 'string') content = this.mapOpts.annotation;
                else if (typeof this.mapOpts.annotation === 'function') content = this.mapOpts.annotation(this.opts.to, this.root);
                else content = this.outputFile() + '.map';
                var eol = '\n';
                if (this.css.includes('\r\n')) eol = '\r\n';
                this.css += eol + '/*# sourceMappingURL=' + content + ' */';
            }
        },
        {
            key: "applyPrevMaps",
            value: function applyPrevMaps() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.previous()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var prev = _step.value;
                        var from = this.toUrl(this.path(prev.file));
                        var root = prev.root || $197c6bad57e53eb3$var$dirname(prev.file);
                        var map = void 0;
                        if (this.mapOpts.sourcesContent === false) {
                            map = new $197c6bad57e53eb3$var$SourceMapConsumer(prev.text);
                            if (map.sourcesContent) map.sourcesContent = null;
                        } else map = prev.consumer();
                        this.map.applySourceMap(map, from, this.toUrl(this.path(root)));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "clearAnnotation",
            value: function clearAnnotation() {
                if (this.mapOpts.annotation === false) return;
                if (this.root) {
                    var node;
                    for(var i = this.root.nodes.length - 1; i >= 0; i--){
                        node = this.root.nodes[i];
                        if (node.type !== 'comment') continue;
                        if (node.text.startsWith('# sourceMappingURL=')) this.root.removeChild(i);
                    }
                } else if (this.css) {
                    // Single forward pass. Removing every annotation from the whole
                    // string separately would be O(n^2) on many annotations.
                    var annotation = '/*# sourceMappingURL=';
                    var css = '';
                    var cursor = 0;
                    var startIndex;
                    while((startIndex = this.css.indexOf(annotation, cursor)) !== -1){
                        var endIndex = this.css.indexOf('*/', startIndex + annotation.length);
                        if (endIndex === -1) break;
                        while(startIndex > cursor && this.css[startIndex - 1] === '\n')startIndex--;
                        css += this.css.slice(cursor, startIndex);
                        cursor = endIndex + 2;
                    }
                    if (cursor > 0) this.css = css + this.css.slice(cursor);
                }
            }
        },
        {
            key: "generate",
            value: function generate() {
                this.clearAnnotation();
                if ($197c6bad57e53eb3$var$pathAvailable && $197c6bad57e53eb3$var$sourceMapAvailable && this.isMap()) return this.generateMap();
                else {
                    var result = '';
                    this.stringify(this.root, function(i) {
                        result += i;
                    });
                    return [
                        result
                    ];
                }
            }
        },
        {
            key: "generateMap",
            value: function generateMap() {
                if (this.root) this.generateString();
                else if (this.previous().length === 1) {
                    var prev = this.previous()[0].consumer();
                    prev.file = this.outputFile();
                    this.map = $197c6bad57e53eb3$var$SourceMapGenerator.fromSourceMap(prev, {
                        ignoreInvalidMapping: true
                    });
                } else {
                    this.map = new $197c6bad57e53eb3$var$SourceMapGenerator({
                        file: this.outputFile(),
                        ignoreInvalidMapping: true
                    });
                    this.map.addMapping({
                        generated: {
                            column: 0,
                            line: 1
                        },
                        original: {
                            column: 0,
                            line: 1
                        },
                        source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : '<no source>'
                    });
                }
                if (this.isSourcesContent()) this.setSourcesContent();
                if (this.root && this.previous().length > 0) this.applyPrevMaps();
                if (this.isAnnotation()) this.addAnnotation();
                if (this.isInline()) return [
                    this.css
                ];
                else return [
                    this.css,
                    this.map
                ];
            }
        },
        {
            key: "generateString",
            value: function generateString() {
                var _this = this;
                this.css = '';
                this.map = new $197c6bad57e53eb3$var$SourceMapGenerator({
                    file: this.outputFile(),
                    ignoreInvalidMapping: true
                });
                var line = 1;
                var column = 1;
                var noSource = '<no source>';
                var mapping = {
                    generated: {
                        column: 0,
                        line: 0
                    },
                    original: {
                        column: 0,
                        line: 0
                    },
                    source: ''
                };
                var last, lines;
                this.stringify(this.root, function(str, node, type) {
                    _this.css += str;
                    if (node && type !== 'end') {
                        mapping.generated.line = line;
                        mapping.generated.column = column - 1;
                        if (node.source && node.source.start) {
                            mapping.source = _this.sourcePath(node);
                            mapping.original.line = node.source.start.line;
                            mapping.original.column = node.source.start.column - 1;
                            _this.map.addMapping(mapping);
                        } else {
                            mapping.source = noSource;
                            mapping.original.line = 1;
                            mapping.original.column = 0;
                            _this.map.addMapping(mapping);
                        }
                    }
                    lines = str.match(/\n/g);
                    if (lines) {
                        line += lines.length;
                        last = str.lastIndexOf('\n');
                        column = str.length - last;
                    } else column += str.length;
                    if (node && type !== 'start') {
                        var p = node.parent || {
                            raws: {}
                        };
                        var childless = node.type === 'decl' || node.type === 'atrule' && !node.nodes;
                        if (!childless || node !== p.last || p.raws.semicolon) {
                            if (node.source && node.source.end) {
                                mapping.source = _this.sourcePath(node);
                                mapping.original.line = node.source.end.line;
                                mapping.original.column = node.source.end.column - 1;
                                mapping.generated.line = line;
                                mapping.generated.column = column - 2;
                                _this.map.addMapping(mapping);
                            } else {
                                mapping.source = noSource;
                                mapping.original.line = 1;
                                mapping.original.column = 0;
                                mapping.generated.line = line;
                                mapping.generated.column = column - 1;
                                _this.map.addMapping(mapping);
                            }
                        }
                    }
                });
            }
        },
        {
            key: "isAnnotation",
            value: function isAnnotation() {
                if (this.isInline()) return true;
                if (typeof this.mapOpts.annotation !== 'undefined') return this.mapOpts.annotation;
                if (this.previous().length) return this.previous().some(function(i) {
                    return i.annotation;
                });
                return true;
            }
        },
        {
            key: "isInline",
            value: function isInline() {
                if (typeof this.mapOpts.inline !== 'undefined') return this.mapOpts.inline;
                var annotation = this.mapOpts.annotation;
                if (typeof annotation !== 'undefined' && annotation !== true) return false;
                if (this.previous().length) return this.previous().some(function(i) {
                    return i.inline;
                });
                return true;
            }
        },
        {
            key: "isMap",
            value: function isMap() {
                if (typeof this.opts.map !== 'undefined') return !!this.opts.map;
                return this.previous().length > 0;
            }
        },
        {
            key: "isSourcesContent",
            value: function isSourcesContent() {
                if (typeof this.mapOpts.sourcesContent !== 'undefined') return this.mapOpts.sourcesContent;
                if (this.previous().length) return this.previous().some(function(i) {
                    return i.withContent();
                });
                return true;
            }
        },
        {
            key: "outputFile",
            value: function outputFile() {
                if (this.opts.to) return this.path(this.opts.to);
                else if (this.opts.from) return this.path(this.opts.from);
                else return 'to.css';
            }
        },
        {
            key: "path",
            value: function path(file) {
                if (this.mapOpts.absolute) return file;
                if (file.charCodeAt(0) === 60 /* `<` */ ) return file;
                if (/^\w+:\/\//.test(file)) return file;
                var cached = this.memoizedPaths.get(file);
                if (cached) return cached;
                var from = this.opts.to ? $197c6bad57e53eb3$var$dirname(this.opts.to) : '.';
                if (typeof this.mapOpts.annotation === 'string') from = $197c6bad57e53eb3$var$dirname($197c6bad57e53eb3$var$resolve(from, this.mapOpts.annotation));
                var path = $197c6bad57e53eb3$var$relative(from, file);
                this.memoizedPaths.set(file, path);
                return path;
            }
        },
        {
            key: "previous",
            value: function previous() {
                var _this = this;
                if (!this.previousMaps) {
                    this.previousMaps = [];
                    if (this.root) this.root.walk(function(node) {
                        if (node.source && node.source.input.map) {
                            var map = node.source.input.map;
                            if (!_this.previousMaps.includes(map)) _this.previousMaps.push(map);
                        }
                    });
                    else {
                        var input = new $cdX05(this.originalCSS, this.opts);
                        if (input.map) this.previousMaps.push(input.map);
                    }
                }
                return this.previousMaps;
            }
        },
        {
            key: "setSourcesContent",
            value: function setSourcesContent() {
                var _this = this;
                var already = {};
                if (this.root) this.root.walk(function(node) {
                    if (node.source) {
                        var from = node.source.input.from;
                        if (from && !already[from]) {
                            already[from] = true;
                            var fromUrl = _this.usesFileUrls ? _this.toFileUrl(from) : _this.toUrl(_this.path(from));
                            _this.map.setSourceContent(fromUrl, node.source.input.css);
                        }
                    }
                });
                else if (this.css) {
                    var from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : '<no source>';
                    this.map.setSourceContent(from, this.css);
                }
            }
        },
        {
            key: "sourcePath",
            value: function sourcePath(node) {
                if (this.mapOpts.from) return this.toUrl(this.mapOpts.from);
                else if (this.usesFileUrls) return this.toFileUrl(node.source.input.from);
                else return this.toUrl(this.path(node.source.input.from));
            }
        },
        {
            key: "toBase64",
            value: function toBase64(str) {
                if ($197c6bad57e53eb3$require$Buffer) return $197c6bad57e53eb3$require$Buffer.from(str).toString('base64');
                else return window.btoa(unescape(encodeURIComponent(str)));
            }
        },
        {
            key: "toFileUrl",
            value: function toFileUrl(path) {
                var cached = this.memoizedFileURLs.get(path);
                if (cached) return cached;
                if ($197c6bad57e53eb3$require$pathToFileURL) {
                    var fileURL = $197c6bad57e53eb3$require$pathToFileURL(path).toString();
                    this.memoizedFileURLs.set(path, fileURL);
                    return fileURL;
                } else throw new Error('`map.absolute` option is not available in this PostCSS build');
            }
        },
        {
            key: "toUrl",
            value: function toUrl(path) {
                var cached = this.memoizedURLs.get(path);
                if (cached) return cached;
                if ($197c6bad57e53eb3$var$sep === '\\') path = path.replace(/\\/g, '/');
                var url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
                this.memoizedURLs.set(path, url);
                return url;
            }
        }
    ]);
    return MapGenerator;
}();
module.exports = $197c6bad57e53eb3$var$MapGenerator;

});

parcelRegister("2ZjIU", function(module, exports) {
'use strict';

var $97P0p = parcelRequire("97P0p");

var $cdX05 = parcelRequire("cdX05");

var $6JSYH = parcelRequire("6JSYH");
function $22d093ea6f2fbace$var$parse(css, opts) {
    var input = new $cdX05(css, opts);
    var parser = new $6JSYH(input);
    try {
        parser.parse();
    } catch (e) {
        throw e;
    }
    return parser.root;
}
module.exports = $22d093ea6f2fbace$var$parse;
$22d093ea6f2fbace$var$parse.default = $22d093ea6f2fbace$var$parse;
$97P0p.registerParse($22d093ea6f2fbace$var$parse);

});
parcelRegister("6JSYH", function(module, exports) {

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $21h22 = parcelRequire("21h22");
'use strict';

var $kAGiU = parcelRequire("kAGiU");

var $7lbcT = parcelRequire("7lbcT");

var $3MpJA = parcelRequire("3MpJA");

var $kw7YN = parcelRequire("kw7YN");

var $faiIs = parcelRequire("faiIs");

var $GpfJq = parcelRequire("GpfJq");
var $4e81978dfdaec181$var$SAFE_COMMENT_NEIGHBOR = {
    empty: true,
    space: true
};
function $4e81978dfdaec181$var$findLastWithPosition(tokens) {
    for(var i = tokens.length - 1; i >= 0; i--){
        var token = tokens[i];
        var pos = token[3] || token[2];
        if (pos) return pos;
    }
}
function $4e81978dfdaec181$var$tokensToString(tokens, from, to) {
    var result = '';
    for(var i = from; i < to; i++)result += tokens[i][1];
    return result;
}
var $4e81978dfdaec181$var$Parser = /*#__PURE__*/ function() {
    function Parser(input) {
        (0, $gd0sY._)(this, Parser);
        this.input = input;
        this.root = new $kw7YN();
        this.current = this.root;
        this.spaces = '';
        this.semicolon = false;
        this.createTokenizer();
        this.root.source = {
            input: input,
            start: {
                column: 1,
                line: 1,
                offset: 0
            }
        };
    }
    (0, $7cSld._)(Parser, [
        {
            key: "atrule",
            value: function atrule(token) {
                var node = new $kAGiU();
                node.name = token[1].slice(1);
                if (node.name === '') this.unnamedAtrule(node, token);
                this.init(node, token[2]);
                var type;
                var prev;
                var shift;
                var last = false;
                var open = false;
                var params = [];
                var brackets = [];
                while(!this.tokenizer.endOfFile()){
                    token = this.tokenizer.nextToken();
                    type = token[0];
                    if (type === '(' || type === '[') brackets.push(type === '(' ? ')' : ']');
                    else if (type === '{' && brackets.length > 0) brackets.push('}');
                    else if (type === brackets[brackets.length - 1]) brackets.pop();
                    if (brackets.length === 0) {
                        if (type === ';') {
                            node.source.end = this.getPosition(token[2]);
                            node.source.end.offset++;
                            this.semicolon = true;
                            break;
                        } else if (type === '{') {
                            open = true;
                            break;
                        } else if (type === '}') {
                            if (params.length > 0) {
                                shift = params.length - 1;
                                prev = params[shift];
                                while(prev && prev[0] === 'space')prev = params[--shift];
                                if (prev) {
                                    node.source.end = this.getPosition(prev[3] || prev[2]);
                                    node.source.end.offset++;
                                }
                            }
                            this.end(token);
                            break;
                        } else params.push(token);
                    } else params.push(token);
                    if (this.tokenizer.endOfFile()) {
                        last = true;
                        break;
                    }
                }
                node.raws.between = this.spacesAndCommentsFromEnd(params);
                if (params.length) {
                    node.raws.afterName = this.spacesAndCommentsFromStart(params);
                    this.raw(node, 'params', params);
                    if (last) {
                        token = params[params.length - 1];
                        node.source.end = this.getPosition(token[3] || token[2]);
                        node.source.end.offset++;
                        this.spaces = node.raws.between;
                        node.raws.between = '';
                    }
                } else {
                    node.raws.afterName = '';
                    node.params = '';
                }
                if (open) {
                    node.nodes = [];
                    this.current = node;
                }
            }
        },
        {
            key: "checkMissedSemicolon",
            value: function checkMissedSemicolon(tokens) {
                var colon = this.colon(tokens);
                if (colon === false) return;
                var founded = 0;
                var token;
                for(var j = colon - 1; j >= 0; j--){
                    token = tokens[j];
                    if (token[0] !== 'space') {
                        founded += 1;
                        if (founded === 2) break;
                    }
                }
                // If the token is a word, e.g. `!important`, `red` or any other valid
                // property's value. Then we need to return the colon after that word
                // token. [3] is the "end" colon of that word. And because we need it
                // after that one we do +1 to get the next one.
                throw this.input.error('Missed semicolon', token[0] === 'word' ? token[3] + 1 : token[2]);
            }
        },
        {
            key: "colon",
            value: function colon(tokens) {
                var brackets = 0;
                var prev, token, type;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = tokens.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $21h22._)(_step.value, 2), i = _step_value[0], element = _step_value[1];
                        token = element;
                        type = token[0];
                        if (type === '(') brackets += 1;
                        if (type === ')') brackets -= 1;
                        if (brackets === 0 && type === ':') {
                            if (!prev) this.doubleColon(token);
                            else if (prev[0] === 'word' && prev[1] === 'progid') continue;
                            else return i;
                        }
                        prev = token;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return false;
            }
        },
        {
            key: "comment",
            value: function comment(token) {
                var node = new $7lbcT();
                this.init(node, token[2]);
                node.source.end = this.getPosition(token[3] || token[2]);
                node.source.end.offset++;
                var text = token[1].slice(2, -2);
                if (!text.trim()) {
                    node.text = '';
                    node.raws.left = text;
                    node.raws.right = '';
                } else {
                    var match = text.match(/^(\s*)([^]*\S)(\s*)$/);
                    node.text = match[2];
                    node.raws.left = match[1];
                    node.raws.right = match[3];
                }
            }
        },
        {
            key: "createTokenizer",
            value: function createTokenizer() {
                this.tokenizer = $GpfJq(this.input);
            }
        },
        {
            key: "decl",
            value: function decl(tokens, customProperty) {
                var node = new $3MpJA();
                this.init(node, tokens[0][2]);
                var last = tokens[tokens.length - 1];
                if (last[0] === ';') {
                    this.semicolon = true;
                    tokens.pop();
                }
                node.source.end = this.getPosition(last[3] || last[2] || $4e81978dfdaec181$var$findLastWithPosition(tokens));
                node.source.end.offset++;
                var start = 0;
                while(tokens[start][0] !== 'word'){
                    if (start === tokens.length - 1) this.unknownWord([
                        tokens[start]
                    ]);
                    start++;
                }
                node.raws.before += $4e81978dfdaec181$var$tokensToString(tokens, 0, start);
                node.source.start = this.getPosition(tokens[start][2]);
                var propStart = start;
                while(start < tokens.length){
                    var type = tokens[start][0];
                    if (type === ':' || type === 'space' || type === 'comment') break;
                    start++;
                }
                node.prop = $4e81978dfdaec181$var$tokensToString(tokens, propStart, start);
                var betweenStart = start;
                var token;
                while(start < tokens.length){
                    token = tokens[start];
                    start++;
                    if (token[0] === ':') break;
                    if (token[0] === 'word' && /\w/.test(token[1])) this.unknownWord([
                        token
                    ]);
                }
                node.raws.between = $4e81978dfdaec181$var$tokensToString(tokens, betweenStart, start);
                if (node.prop[0] === '_' || node.prop[0] === '*') {
                    node.raws.before += node.prop[0];
                    node.prop = node.prop.slice(1);
                }
                var firstSpacesStart = start;
                while(start < tokens.length){
                    var next = tokens[start][0];
                    if (next !== 'space' && next !== 'comment') break;
                    start++;
                }
                var firstSpaces = tokens.slice(firstSpacesStart, start);
                tokens = tokens.slice(start);
                this.precheckMissedSemicolon(tokens);
                for(var i = tokens.length - 1; i >= 0; i--){
                    token = tokens[i];
                    if (token[1].toLowerCase() === '!important') {
                        node.important = true;
                        var string = this.stringFrom(tokens, i);
                        string = this.spacesFromEnd(tokens) + string;
                        if (string !== ' !important') node.raws.important = string;
                        break;
                    } else if (token[1].toLowerCase() === 'important') {
                        var cache = tokens.slice(0);
                        var str = '';
                        for(var j = i; j > 0; j--){
                            var type1 = cache[j][0];
                            if (str.trim().startsWith('!') && type1 !== 'space') break;
                            str = cache.pop()[1] + str;
                        }
                        if (str.trim().startsWith('!')) {
                            node.important = true;
                            node.raws.important = str;
                            tokens = cache;
                        }
                    }
                    if (token[0] !== 'space' && token[0] !== 'comment') break;
                }
                var hasWord = tokens.some(function(i) {
                    return i[0] !== 'space' && i[0] !== 'comment';
                });
                if (hasWord) {
                    node.raws.between += firstSpaces.map(function(i) {
                        return i[1];
                    }).join('');
                    firstSpaces = [];
                }
                this.raw(node, 'value', firstSpaces.concat(tokens), customProperty);
                if (node.value.includes(':') && !customProperty) this.checkMissedSemicolon(tokens);
            }
        },
        {
            key: "doubleColon",
            value: function doubleColon(token) {
                throw this.input.error('Double colon', {
                    offset: token[2]
                }, {
                    offset: token[2] + token[1].length
                });
            }
        },
        {
            key: "emptyRule",
            value: function emptyRule(token) {
                var node = new $faiIs();
                this.init(node, token[2]);
                node.selector = '';
                node.raws.between = '';
                this.current = node;
            }
        },
        {
            key: "end",
            value: function end(token) {
                if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
                this.semicolon = false;
                this.current.raws.after = (this.current.raws.after || '') + this.spaces;
                this.spaces = '';
                if (this.current.parent) {
                    this.current.source.end = this.getPosition(token[2]);
                    this.current.source.end.offset++;
                    this.current = this.current.parent;
                } else this.unexpectedClose(token);
            }
        },
        {
            key: "endFile",
            value: function endFile() {
                if (this.current.parent) this.unclosedBlock();
                if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
                this.current.raws.after = (this.current.raws.after || '') + this.spaces;
                this.root.source.end = this.getPosition(this.tokenizer.position());
            }
        },
        {
            key: "freeSemicolon",
            value: function freeSemicolon(token) {
                this.spaces += token[1];
                if (this.current.nodes) {
                    var prev = this.current.nodes[this.current.nodes.length - 1];
                    if (prev && prev.type === 'rule' && !prev.raws.ownSemicolon) {
                        prev.raws.ownSemicolon = this.spaces;
                        this.spaces = '';
                        // `ownSemicolon` also holds the spaces before the semicolon, but
                        // the position above is the semicolon itself, so the node ends
                        // right after it.
                        prev.source.end = this.getPosition(token[2]);
                        prev.source.end.offset++;
                    }
                }
            }
        },
        {
            // Helpers
            key: "getPosition",
            value: function getPosition(offset) {
                var pos = this.input.fromOffset(offset);
                return {
                    column: pos.col,
                    line: pos.line,
                    offset: offset
                };
            }
        },
        {
            key: "init",
            value: function init(node, offset) {
                this.current.push(node);
                node.source = {
                    input: this.input,
                    start: this.getPosition(offset)
                };
                node.raws.before = this.spaces;
                this.spaces = '';
                if (node.type !== 'comment') this.semicolon = false;
            }
        },
        {
            key: "other",
            value: function other(start) {
                var end = false;
                var type = null;
                var colon = false;
                var bracket = null;
                var brackets = [];
                var customProperty = start[1].startsWith('--');
                var tokens = [];
                var token = start;
                while(token){
                    type = token[0];
                    tokens.push(token);
                    if (type === '(' || type === '[') {
                        if (!bracket) bracket = token;
                        brackets.push(type === '(' ? ')' : ']');
                    } else if (customProperty && colon && type === '{') {
                        if (!bracket) bracket = token;
                        brackets.push('}');
                    } else if (brackets.length === 0) {
                        if (type === ';') {
                            if (colon) {
                                this.decl(tokens, customProperty);
                                return;
                            } else break;
                        } else if (type === '{') {
                            this.rule(tokens);
                            return;
                        } else if (type === '}') {
                            this.tokenizer.back(tokens.pop());
                            end = true;
                            break;
                        } else if (type === ':') colon = true;
                    } else if (type === brackets[brackets.length - 1]) {
                        brackets.pop();
                        if (brackets.length === 0) bracket = null;
                    }
                    token = this.tokenizer.nextToken();
                }
                if (this.tokenizer.endOfFile()) end = true;
                if (brackets.length > 0) this.unclosedBracket(bracket);
                if (end && colon) {
                    if (!customProperty) while(tokens.length){
                        token = tokens[tokens.length - 1][0];
                        if (token !== 'space' && token !== 'comment') break;
                        this.tokenizer.back(tokens.pop());
                    }
                    this.decl(tokens, customProperty);
                } else this.unknownWord(tokens);
            }
        },
        {
            key: "parse",
            value: function parse() {
                var token;
                while(!this.tokenizer.endOfFile()){
                    token = this.tokenizer.nextToken();
                    switch(token[0]){
                        case 'space':
                            this.spaces += token[1];
                            break;
                        case ';':
                            this.freeSemicolon(token);
                            break;
                        case '}':
                            this.end(token);
                            break;
                        case 'comment':
                            this.comment(token);
                            break;
                        case 'at-word':
                            this.atrule(token);
                            break;
                        case '{':
                            this.emptyRule(token);
                            break;
                        default:
                            this.other(token);
                            break;
                    }
                }
                this.endFile();
            }
        },
        {
            key: "precheckMissedSemicolon",
            value: function precheckMissedSemicolon() {
            // Hook for Safe Parser
            }
        },
        {
            key: "raw",
            value: function raw(node, prop, tokens, customProperty) {
                var token, type;
                var length = tokens.length;
                var value = '';
                // Last character of `value`. Reading it from `value` would flatten
                // the string concatenation on every comment and make parsing O(n^2).
                var last = '';
                var clean = true;
                var next, prev;
                for(var i = 0; i < length; i += 1){
                    token = tokens[i];
                    type = token[0];
                    if (type === 'space' && i === length - 1 && !customProperty) clean = false;
                    else if (type === 'comment') {
                        prev = tokens[i - 1] ? tokens[i - 1][0] : 'empty';
                        next = tokens[i + 1] ? tokens[i + 1][0] : 'empty';
                        if (!$4e81978dfdaec181$var$SAFE_COMMENT_NEIGHBOR[prev] && !$4e81978dfdaec181$var$SAFE_COMMENT_NEIGHBOR[next]) {
                            if (last === ',') clean = false;
                            else {
                                value += token[1];
                                last = token[1].slice(-1);
                            }
                        } else clean = false;
                    } else {
                        value += token[1];
                        last = token[1].slice(-1);
                    }
                }
                if (!clean) {
                    var raw = tokens.reduce(function(all, i) {
                        return all + i[1];
                    }, '');
                    node.raws[prop] = {
                        raw: raw,
                        value: value
                    };
                }
                node[prop] = value;
            }
        },
        {
            key: "rule",
            value: function rule(tokens) {
                tokens.pop();
                var node = new $faiIs();
                this.init(node, tokens[0][2]);
                node.raws.between = this.spacesAndCommentsFromEnd(tokens);
                this.raw(node, 'selector', tokens);
                this.current = node;
            }
        },
        {
            key: "spacesAndCommentsFromEnd",
            value: function spacesAndCommentsFromEnd(tokens) {
                var lastTokenType;
                var spaces = '';
                while(tokens.length){
                    lastTokenType = tokens[tokens.length - 1][0];
                    if (lastTokenType !== 'space' && lastTokenType !== 'comment') break;
                    spaces = tokens.pop()[1] + spaces;
                }
                return spaces;
            }
        },
        {
            // Errors
            key: "spacesAndCommentsFromStart",
            value: function spacesAndCommentsFromStart(tokens) {
                var next;
                var spaces = '';
                while(tokens.length){
                    next = tokens[0][0];
                    if (next !== 'space' && next !== 'comment') break;
                    spaces += tokens.shift()[1];
                }
                return spaces;
            }
        },
        {
            key: "spacesFromEnd",
            value: function spacesFromEnd(tokens) {
                var lastTokenType;
                var spaces = '';
                while(tokens.length){
                    lastTokenType = tokens[tokens.length - 1][0];
                    if (lastTokenType !== 'space') break;
                    spaces = tokens.pop()[1] + spaces;
                }
                return spaces;
            }
        },
        {
            key: "stringFrom",
            value: function stringFrom(tokens, from) {
                var result = '';
                for(var i = from; i < tokens.length; i++)result += tokens[i][1];
                tokens.splice(from, tokens.length - from);
                return result;
            }
        },
        {
            key: "unclosedBlock",
            value: function unclosedBlock() {
                var pos = this.current.source.start;
                throw this.input.error('Unclosed block', pos.line, pos.column);
            }
        },
        {
            key: "unclosedBracket",
            value: function unclosedBracket(bracket) {
                throw this.input.error('Unclosed bracket', {
                    offset: bracket[2]
                }, {
                    offset: bracket[2] + 1
                });
            }
        },
        {
            key: "unexpectedClose",
            value: function unexpectedClose(token) {
                throw this.input.error('Unexpected }', {
                    offset: token[2]
                }, {
                    offset: token[2] + 1
                });
            }
        },
        {
            key: "unknownWord",
            value: function unknownWord(tokens) {
                throw this.input.error('Unknown word ' + tokens[0][1], {
                    offset: tokens[0][2]
                }, {
                    offset: tokens[0][2] + tokens[0][1].length
                });
            }
        },
        {
            key: "unnamedAtrule",
            value: function unnamedAtrule(node, token) {
                throw this.input.error('At-rule without name', {
                    offset: token[2]
                }, {
                    offset: token[2] + token[1].length
                });
            }
        }
    ]);
    return Parser;
}();
module.exports = $4e81978dfdaec181$var$Parser;

});
parcelRegister("GpfJq", function(module, exports) {
'use strict';
var $07f7830693e9969a$var$SINGLE_QUOTE = "'".charCodeAt(0);
var $07f7830693e9969a$var$DOUBLE_QUOTE = '"'.charCodeAt(0);
var $07f7830693e9969a$var$BACKSLASH = '\\'.charCodeAt(0);
var $07f7830693e9969a$var$SLASH = '/'.charCodeAt(0);
var $07f7830693e9969a$var$NEWLINE = '\n'.charCodeAt(0);
var $07f7830693e9969a$var$SPACE = ' '.charCodeAt(0);
var $07f7830693e9969a$var$FEED = '\f'.charCodeAt(0);
var $07f7830693e9969a$var$TAB = '\t'.charCodeAt(0);
var $07f7830693e9969a$var$CR = '\r'.charCodeAt(0);
var $07f7830693e9969a$var$OPEN_SQUARE = '['.charCodeAt(0);
var $07f7830693e9969a$var$CLOSE_SQUARE = ']'.charCodeAt(0);
var $07f7830693e9969a$var$OPEN_PARENTHESES = '('.charCodeAt(0);
var $07f7830693e9969a$var$CLOSE_PARENTHESES = ')'.charCodeAt(0);
var $07f7830693e9969a$var$OPEN_CURLY = '{'.charCodeAt(0);
var $07f7830693e9969a$var$CLOSE_CURLY = '}'.charCodeAt(0);
var $07f7830693e9969a$var$SEMICOLON = ';'.charCodeAt(0);
var $07f7830693e9969a$var$ASTERISK = '*'.charCodeAt(0);
var $07f7830693e9969a$var$COLON = ':'.charCodeAt(0);
var $07f7830693e9969a$var$AT = '@'.charCodeAt(0);
var $07f7830693e9969a$var$RE_AT_END = /[\t\n\f\r "#'()/;[\\\]{}]/g;
var $07f7830693e9969a$var$RE_WORD_END = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
var $07f7830693e9969a$var$RE_BAD_BRACKET = /.[\r\n"'(/\\]/;
var $07f7830693e9969a$var$RE_HEX_ESCAPE = /[\da-f]/i;
module.exports = function tokenizer(input) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var css = input.css.valueOf();
    var ignore = options.ignoreErrors;
    var code, content, escape, next, quote;
    var currentToken, escaped, escapePos, n, prev;
    var length = css.length;
    var pos = 0;
    var buffer = [];
    var returned = [];
    var lastBadParen = -1;
    function position() {
        return pos;
    }
    function unclosed(what) {
        throw input.error('Unclosed ' + what, pos);
    }
    function endOfFile() {
        return returned.length === 0 && pos >= length;
    }
    function nextToken(opts) {
        if (returned.length) return returned.pop();
        if (pos >= length) return;
        var ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
        code = css.charCodeAt(pos);
        switch(code){
            case $07f7830693e9969a$var$NEWLINE:
            case $07f7830693e9969a$var$SPACE:
            case $07f7830693e9969a$var$TAB:
            case $07f7830693e9969a$var$CR:
            case $07f7830693e9969a$var$FEED:
                next = pos;
                do {
                    next += 1;
                    code = css.charCodeAt(next);
                }while (code === $07f7830693e9969a$var$SPACE || code === $07f7830693e9969a$var$NEWLINE || code === $07f7830693e9969a$var$TAB || code === $07f7830693e9969a$var$CR || code === $07f7830693e9969a$var$FEED);
                currentToken = [
                    'space',
                    css.slice(pos, next)
                ];
                pos = next - 1;
                break;
            case $07f7830693e9969a$var$OPEN_SQUARE:
            case $07f7830693e9969a$var$CLOSE_SQUARE:
            case $07f7830693e9969a$var$OPEN_CURLY:
            case $07f7830693e9969a$var$CLOSE_CURLY:
            case $07f7830693e9969a$var$COLON:
            case $07f7830693e9969a$var$SEMICOLON:
            case $07f7830693e9969a$var$CLOSE_PARENTHESES:
                {
                    var controlChar = String.fromCharCode(code);
                    currentToken = [
                        controlChar,
                        controlChar,
                        pos
                    ];
                    break;
                }
            case $07f7830693e9969a$var$OPEN_PARENTHESES:
                prev = buffer.length ? buffer.pop()[1] : '';
                n = css.charCodeAt(pos + 1);
                if (prev === 'url' && n !== $07f7830693e9969a$var$SINGLE_QUOTE && n !== $07f7830693e9969a$var$DOUBLE_QUOTE && n !== $07f7830693e9969a$var$SPACE && n !== $07f7830693e9969a$var$NEWLINE && n !== $07f7830693e9969a$var$TAB && n !== $07f7830693e9969a$var$FEED && n !== $07f7830693e9969a$var$CR) {
                    next = pos;
                    do {
                        escaped = false;
                        next = css.indexOf(')', next + 1);
                        if (next === -1) {
                            if (ignore || ignoreUnclosed) {
                                next = pos;
                                break;
                            } else unclosed('bracket');
                        }
                        escapePos = next;
                        while(css.charCodeAt(escapePos - 1) === $07f7830693e9969a$var$BACKSLASH){
                            escapePos -= 1;
                            escaped = !escaped;
                        }
                    }while (escaped);
                    currentToken = [
                        'brackets',
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else if (pos <= lastBadParen) currentToken = [
                    '(',
                    '(',
                    pos
                ];
                else {
                    next = css.indexOf(')', pos + 1);
                    content = css.slice(pos, next + 1);
                    if (next === -1 || $07f7830693e9969a$var$RE_BAD_BRACKET.test(content)) {
                        lastBadParen = next === -1 ? length : next;
                        currentToken = [
                            '(',
                            '(',
                            pos
                        ];
                    } else {
                        currentToken = [
                            'brackets',
                            content,
                            pos,
                            next
                        ];
                        pos = next;
                    }
                }
                break;
            case $07f7830693e9969a$var$SINGLE_QUOTE:
            case $07f7830693e9969a$var$DOUBLE_QUOTE:
                quote = code === $07f7830693e9969a$var$SINGLE_QUOTE ? "'" : '"';
                next = pos;
                do {
                    escaped = false;
                    next = css.indexOf(quote, next + 1);
                    if (next === -1) {
                        if (ignore || ignoreUnclosed) {
                            next = pos + 1;
                            break;
                        } else unclosed('string');
                    }
                    escapePos = next;
                    while(css.charCodeAt(escapePos - 1) === $07f7830693e9969a$var$BACKSLASH){
                        escapePos -= 1;
                        escaped = !escaped;
                    }
                }while (escaped);
                currentToken = [
                    'string',
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $07f7830693e9969a$var$AT:
                $07f7830693e9969a$var$RE_AT_END.lastIndex = pos + 1;
                $07f7830693e9969a$var$RE_AT_END.test(css);
                if ($07f7830693e9969a$var$RE_AT_END.lastIndex === 0) next = css.length - 1;
                else next = $07f7830693e9969a$var$RE_AT_END.lastIndex - 2;
                currentToken = [
                    'at-word',
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $07f7830693e9969a$var$BACKSLASH:
                next = pos;
                escape = true;
                while(css.charCodeAt(next + 1) === $07f7830693e9969a$var$BACKSLASH){
                    next += 1;
                    escape = !escape;
                }
                code = css.charCodeAt(next + 1);
                if (escape && code !== $07f7830693e9969a$var$SLASH && code !== $07f7830693e9969a$var$SPACE && code !== $07f7830693e9969a$var$NEWLINE && code !== $07f7830693e9969a$var$TAB && code !== $07f7830693e9969a$var$CR && code !== $07f7830693e9969a$var$FEED) {
                    next += 1;
                    if ($07f7830693e9969a$var$RE_HEX_ESCAPE.test(css.charAt(next))) {
                        while($07f7830693e9969a$var$RE_HEX_ESCAPE.test(css.charAt(next + 1)))next += 1;
                        if (css.charCodeAt(next + 1) === $07f7830693e9969a$var$SPACE) next += 1;
                    }
                }
                currentToken = [
                    'word',
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            default:
                if (code === $07f7830693e9969a$var$SLASH && css.charCodeAt(pos + 1) === $07f7830693e9969a$var$ASTERISK) {
                    next = css.indexOf('*/', pos + 2) + 1;
                    if (next === 0) {
                        if (ignore || ignoreUnclosed) next = css.length;
                        else unclosed('comment');
                    }
                    currentToken = [
                        'comment',
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    $07f7830693e9969a$var$RE_WORD_END.lastIndex = pos + 1;
                    $07f7830693e9969a$var$RE_WORD_END.test(css);
                    if ($07f7830693e9969a$var$RE_WORD_END.lastIndex === 0) next = css.length - 1;
                    else next = $07f7830693e9969a$var$RE_WORD_END.lastIndex - 2;
                    currentToken = [
                        'word',
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    buffer.push(currentToken);
                    pos = next;
                }
                break;
        }
        pos++;
        return currentToken;
    }
    function back(token) {
        returned.push(token);
    }
    return {
        back: back,
        endOfFile: endOfFile,
        nextToken: nextToken,
        position: position
    };
};

});



parcelRegister("4EyWg", function(module, exports) {

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");
'use strict';

var $9Jalz = parcelRequire("9Jalz");
var $3635fff2a16ad386$var$Result = /*#__PURE__*/ function() {
    function Result(processor, root, opts) {
        (0, $gd0sY._)(this, Result);
        this.processor = processor;
        this.messages = [];
        this.root = root;
        this.opts = opts;
        this.css = '';
        this.map = undefined;
    }
    (0, $7cSld._)(Result, [
        {
            key: "content",
            get: function get() {
                return this.css;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.css;
            }
        },
        {
            key: "warn",
            value: function warn(text) {
                var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (!opts.plugin) {
                    if (this.lastPlugin && this.lastPlugin.postcssPlugin) opts.plugin = this.lastPlugin.postcssPlugin;
                }
                var warning = new $9Jalz(text, opts);
                this.messages.push(warning);
                return warning;
            }
        },
        {
            key: "warnings",
            value: function warnings() {
                return this.messages.filter(function(i) {
                    return i.type === 'warning';
                });
            }
        }
    ]);
    return Result;
}();
module.exports = $3635fff2a16ad386$var$Result;
$3635fff2a16ad386$var$Result.default = $3635fff2a16ad386$var$Result;

});
parcelRegister("9Jalz", function(module, exports) {

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");
'use strict';

var $97P0p = parcelRequire("97P0p");

var $187Aq = parcelRequire("187Aq");
var $715057b2406363b3$require$my = $187Aq.my;
var $715057b2406363b3$var$Warning = /*#__PURE__*/ function() {
    function Warning(text) {
        var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $gd0sY._)(this, Warning);
        this.type = 'warning';
        this.text = text;
        if (opts.node && opts.node.source) {
            if (!opts.node[$715057b2406363b3$require$my]) // The node comes from another PostCSS copy in node_modules, so it does
            // not have this copy’s methods. Container#normalize() rebuilds such
            // nodes on insert, but a node passed straight to Result#warn() never
            // goes through it.
            $97P0p.rebuild(opts.node);
            var range = opts.node.rangeBy(opts);
            this.line = range.start.line;
            this.column = range.start.column;
            this.endLine = range.end.line;
            this.endColumn = range.end.column;
        }
        for(var opt in opts)this[opt] = opts[opt];
    }
    (0, $7cSld._)(Warning, [
        {
            key: "toString",
            value: function toString() {
                if (this.node) return this.node.error(this.text, {
                    index: this.index,
                    plugin: this.plugin,
                    word: this.word
                }).message;
                if (this.plugin) return this.plugin + ': ' + this.text;
                return this.text;
            }
        }
    ]);
    return Warning;
}();
module.exports = $715057b2406363b3$var$Warning;
$715057b2406363b3$var$Warning.default = $715057b2406363b3$var$Warning;

});


parcelRegister("2iTct", function(module, exports) {
/* eslint-disable no-console */ 'use strict';
var $1ad814d3ae66f039$var$printed = {};
module.exports = function warnOnce(message) {
    if ($1ad814d3ae66f039$var$printed[message]) return;
    $1ad814d3ae66f039$var$printed[message] = true;
    if (typeof console !== 'undefined' && console.warn) console.warn(message);
};

});


parcelRegister("1jdCW", function(module, exports) {

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $2bfPH = parcelRequire("2bfPH");
'use strict';

var $juIUa = parcelRequire("juIUa");

var $k6evn = parcelRequire("k6evn");

var $iSyqS = parcelRequire("iSyqS");

var $kw7YN = parcelRequire("kw7YN");
var $0f4222de7e4afe1f$var$Processor = /*#__PURE__*/ function() {
    function Processor() {
        var plugins = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        (0, $gd0sY._)(this, Processor);
        this.version = '8.5.31';
        this.plugins = this.normalize(plugins);
    }
    (0, $7cSld._)(Processor, [
        {
            key: "normalize",
            value: function normalize(plugins) {
                var normalized = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        if (i.postcss === true) i = i();
                        else if (i.postcss) i = i.postcss;
                        if ((typeof i === "undefined" ? "undefined" : (0, $2bfPH._)(i)) === 'object' && Array.isArray(i.plugins)) normalized = normalized.concat(i.plugins);
                        else if ((typeof i === "undefined" ? "undefined" : (0, $2bfPH._)(i)) === 'object' && i.postcssPlugin) normalized.push(i);
                        else if (typeof i === 'function') normalized.push(i);
                        else if ((typeof i === "undefined" ? "undefined" : (0, $2bfPH._)(i)) === 'object' && (i.parse || i.stringify)) ;
                        else throw new Error(i + ' is not a PostCSS plugin');
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return normalized;
            }
        },
        {
            key: "process",
            value: function process(css) {
                var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (!this.plugins.length && !opts.parser && !opts.stringifier && !opts.syntax) return new $iSyqS(this, css, opts);
                else return new $k6evn(this, css, opts);
            }
        },
        {
            key: "use",
            value: function use(plugin) {
                this.plugins = this.plugins.concat(this.normalize([
                    plugin
                ]));
                return this;
            }
        }
    ]);
    return Processor;
}();
module.exports = $0f4222de7e4afe1f$var$Processor;
$0f4222de7e4afe1f$var$Processor.default = $0f4222de7e4afe1f$var$Processor;
$kw7YN.registerProcessor($0f4222de7e4afe1f$var$Processor);
$juIUa.registerProcessor($0f4222de7e4afe1f$var$Processor);

});
parcelRegister("iSyqS", function(module, exports) {

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $21h22 = parcelRequire("21h22");
'use strict';

var $2bF0I = parcelRequire("2bF0I");

var $2ZjIU = parcelRequire("2ZjIU");

var $4EyWg = parcelRequire("4EyWg");

var $6WwiZ = parcelRequire("6WwiZ");
parcelRequire("2iTct");
var $dbe7fabd644bbf84$var$NoWorkResult = /*#__PURE__*/ function() {
    function NoWorkResult(processor, css, opts) {
        (0, $gd0sY._)(this, NoWorkResult);
        css = css.toString();
        this.stringified = false;
        this._processor = processor;
        this._css = css;
        this._opts = opts;
        this._map = undefined;
        var str = $6WwiZ;
        this.result = new $4EyWg(this._processor, undefined, this._opts);
        this.result.css = css;
        var self = this;
        Object.defineProperty(this.result, 'root', {
            get: function() {
                return self.root;
            }
        });
        var map = new $2bF0I(str, undefined, this._opts, css);
        if (map.isMap()) {
            var _map_generate = (0, $21h22._)(map.generate(), 2), generatedCSS = _map_generate[0], generatedMap = _map_generate[1];
            if (generatedCSS) this.result.css = generatedCSS;
            if (generatedMap) this.result.map = generatedMap;
        } else {
            map.clearAnnotation();
            this.result.css = map.css;
        }
    }
    (0, $7cSld._)(NoWorkResult, [
        {
            key: "content",
            get: function get() {
                return this.result.css;
            }
        },
        {
            key: "css",
            get: function get() {
                return this.result.css;
            }
        },
        {
            key: "map",
            get: function get() {
                return this.result.map;
            }
        },
        {
            key: "messages",
            get: function get() {
                return [];
            }
        },
        {
            key: "opts",
            get: function get() {
                return this.result.opts;
            }
        },
        {
            key: "processor",
            get: function get() {
                return this.result.processor;
            }
        },
        {
            key: "root",
            get: function get() {
                if (this._root) return this._root;
                var root;
                var parser = $2ZjIU;
                try {
                    root = parser(this._css, this._opts);
                } catch (error) {
                    this.error = error;
                }
                if (this.error) throw this.error;
                else {
                    this._root = root;
                    return root;
                }
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return 'NoWorkResult';
            }
        },
        {
            key: "async",
            value: function async() {
                if (this.error) return Promise.reject(this.error);
                return Promise.resolve(this.result);
            }
        },
        {
            key: "catch",
            value: function _catch(onRejected) {
                return this.async().catch(onRejected);
            }
        },
        {
            key: "finally",
            value: function _finally(onFinally) {
                return this.async().then(onFinally, onFinally);
            }
        },
        {
            key: "sync",
            value: function sync() {
                if (this.error) throw this.error;
                return this.result;
            }
        },
        {
            key: "then",
            value: function then(onFulfilled, onRejected) {
                return this.async().then(onFulfilled, onRejected);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this._css;
            }
        },
        {
            key: "warnings",
            value: function warnings() {
                return [];
            }
        }
    ]);
    return NoWorkResult;
}();
module.exports = $dbe7fabd644bbf84$var$NoWorkResult;
$dbe7fabd644bbf84$var$NoWorkResult.default = $dbe7fabd644bbf84$var$NoWorkResult;

});




parcelRegister("78xzh", function(module, exports) {
var $532351a981765e50$var$minus = "-".charCodeAt(0);
var $532351a981765e50$var$plus = "+".charCodeAt(0);
var $532351a981765e50$var$dot = ".".charCodeAt(0);
var $532351a981765e50$var$exp = "e".charCodeAt(0);
var $532351a981765e50$var$EXP = "E".charCodeAt(0);
// Check if three code points would start a number
// https://www.w3.org/TR/css-syntax-3/#starts-with-a-number
function $532351a981765e50$var$likeNumber(value) {
    var code = value.charCodeAt(0);
    var nextCode;
    if (code === $532351a981765e50$var$plus || code === $532351a981765e50$var$minus) {
        nextCode = value.charCodeAt(1);
        if (nextCode >= 48 && nextCode <= 57) return true;
        var nextNextCode = value.charCodeAt(2);
        if (nextCode === $532351a981765e50$var$dot && nextNextCode >= 48 && nextNextCode <= 57) return true;
        return false;
    }
    if (code === $532351a981765e50$var$dot) {
        nextCode = value.charCodeAt(1);
        if (nextCode >= 48 && nextCode <= 57) return true;
        return false;
    }
    if (code >= 48 && code <= 57) return true;
    return false;
}
// Consume a number
// https://www.w3.org/TR/css-syntax-3/#consume-number
module.exports = function(value) {
    var pos = 0;
    var length = value.length;
    var code;
    var nextCode;
    var nextNextCode;
    if (length === 0 || !$532351a981765e50$var$likeNumber(value)) return false;
    code = value.charCodeAt(pos);
    if (code === $532351a981765e50$var$plus || code === $532351a981765e50$var$minus) pos++;
    while(pos < length){
        code = value.charCodeAt(pos);
        if (code < 48 || code > 57) break;
        pos += 1;
    }
    code = value.charCodeAt(pos);
    nextCode = value.charCodeAt(pos + 1);
    if (code === $532351a981765e50$var$dot && nextCode >= 48 && nextCode <= 57) {
        pos += 2;
        while(pos < length){
            code = value.charCodeAt(pos);
            if (code < 48 || code > 57) break;
            pos += 1;
        }
    }
    code = value.charCodeAt(pos);
    nextCode = value.charCodeAt(pos + 1);
    nextNextCode = value.charCodeAt(pos + 2);
    if ((code === $532351a981765e50$var$exp || code === $532351a981765e50$var$EXP) && (nextCode >= 48 && nextCode <= 57 || (nextCode === $532351a981765e50$var$plus || nextCode === $532351a981765e50$var$minus) && nextNextCode >= 48 && nextNextCode <= 57)) {
        pos += nextCode === $532351a981765e50$var$plus || nextCode === $532351a981765e50$var$minus ? 3 : 2;
        while(pos < length){
            code = value.charCodeAt(pos);
            if (code < 48 || code > 57) break;
            pos += 1;
        }
    }
    return {
        number: value.slice(0, pos),
        unit: value.slice(pos)
    };
};

});

parcelRegister("9JzRC", function(module, exports) {
module.exports = {
    "0": "_I _IB",
    "1": "_d ZD",
    "2": "_qS _uI",
    "3": "_4 _e",
    "4": "J jB",
    "5": "B C",
    "6": "_Y _RF",
    "7": "_vS _qI",
    "8": "_BE _AB",
    "9": "gD _AB",
    A: "A B",
    B: "D A",
    C: "FE GE",
    D: "_DE _aP",
    E: "_PC AD",
    F: "J _U",
    G: "_FD _rS",
    H: "_NC _JP",
    I: "_v _UB",
    J: "_YH _tI",
    K: "_H _tI",
    L: "FD GD",
    M: "_2 _p",
    N: "_DE _sS",
    O: "_KG _rS",
    P: "_TH _tE",
    Q: "_wI _BC",
    R: "_3T _WH",
    S: "_tS _xE",
    T: "_h _P",
    U: "_EB _vE",
    V: "F _A",
    W: "_FD _pK",
    X: "I _w",
    Y: "_4 _dC",
    Z: "_OC AD",
    a: "_H _pM",
    b: "_SC _uS",
    c: "_FB AD",
    d: "iC _HG",
    e: "HD iC",
    f: "_g _L",
    g: "BD cC",
    h: "F _5",
    i: "J _e",
    j: "_eM _hE",
    k: "wD xD",
    l: "_k yD",
    m: "_g _6",
    n: "_g _Y",
    o: "_d _wC",
    p: "_HD _AB",
    q: "_j _pE",
    r: "E _wS",
    s: "_4 _VH",
    t: "_q _SF",
    u: "_6 _cC",
    v: "C _AC",
    w: "0D 1D",
    x: "_wI _tB",
    y: "_1E AD",
    z: "_TC _p",
    AB: "_qK _jB",
    BB: "_5 _sS",
    CB: "_qM _sM",
    DB: "_o bD",
    EB: "_HH _NB",
    FB: "_dD E",
    GB: "_dD AD",
    HB: "_zI _WH",
    IB: "R _3D",
    JB: "C M",
    KB: "cC _l",
    LB: "_rM _WH",
    MB: "_4D _LP",
    NB: "_CG _qB",
    OB: "_2 _eC",
    PB: "F _ND",
    QB: "_0I _XH",
    RB: "_KG _0S",
    SB: "_RC _XH",
    TB: "_QG _vM",
    UB: "_9B _8B",
    VB: "_cC fC",
    WB: "_2 _HD",
    XB: "_4T _sM",
    YB: "H XC",
    ZB: "_v _9B",
    aB: "_m _VB",
    bB: "_DE _sB",
    cB: "_4T _cP",
    dB: "_2S _wS",
    eB: "F _jK",
    fB: "_A _sB",
    gB: "_EB _mU",
    hB: "_OB fD",
    iB: "_6T _cP",
    jB: "_oK _gD",
    kB: "_wE _tB",
    lB: "F TD",
    mB: "jB _XB",
    nB: "_tM _uS",
    oB: "_zI _xS",
    pB: "_QB jC",
    qB: "LB MB",
    rB: "EC FC",
    sB: "WC 8C",
    tB: "_VB _oM",
    uB: "_7D _hD",
    vB: "_4 L",
    wB: "_EB _5T",
    xB: "_EB _BU",
    yB: "_sE LD",
    zB: "FB _CC",
    "0B": "_aC _aK",
    "1B": "J _SH",
    "2B": "_vS DC",
    "3B": "_v G",
    "4B": "EB _zB",
    "5B": "_VP _CU",
    "6B": "_KG _xI",
    "7B": "_jC _p",
    "8B": "P Q",
    "9B": "G O",
    AC: "M N",
    BC: "_cC _rE",
    CC: "_GH _NB",
    DC: "_Y G",
    EC: "_wE _BC",
    FC: "_RF _BC",
    GC: "_Y _iD",
    HC: "_4 _dD",
    IC: "_RF _tB",
    JC: "_vC _A",
    KC: "_iK _kC",
    LC: "_g FD",
    MC: "_rK _xS",
    NC: "_KF _CH",
    OC: "_dD _vC",
    PC: "_OC _A",
    QC: "_fK _jI",
    RC: "_4 _OC",
    SC: "_H _h",
    TC: "E _mM",
    UC: "_EE _gE",
    VC: "_JD _oM",
    WC: "_xC _qE",
    XC: "_vB _hP",
    YC: "vB wB",
    ZC: "xB yB",
    aC: "_UB kB",
    bC: "_NF _QF",
    cC: "_lE _PF",
    dC: "_PC _v",
    eC: "dD eD",
    fC: "_mE _ED",
    gC: "D _vC",
    hC: "kB _EB",
    iC: "_PF _rE",
    jC: "E cD",
    kC: "_bP _jB",
    lC: "6B _iE",
    mC: "_AD IC",
    nC: "_1B 4D",
    oC: "_tS _VB",
    pC: "F _TH",
    qC: "J 2D",
    rC: "iC YD",
    sC: "_PH _qI",
    tC: "_wI _xE",
    uC: "_AT _uE",
    vC: "E F",
    wC: "ZD aD",
    xC: "_WB _qK",
    yC: "_n _iD",
    zC: "_WB hD",
    "0C": "K _uE",
    "1C": "_g _EU",
    "2C": "_MG _FU",
    "3C": "_vB _VH",
    "4C": "_HC _hP",
    "5C": "_OD _sB",
    "6C": "_6T _AU",
    "7C": "_QD _p",
    "8C": "_jP _tI",
    "9C": "_1K _gD",
    AD: "_rB _tT",
    BD: "_LF _j",
    CD: "dC DC",
    DD: "_oE _fS",
    ED: "_CD eC",
    FD: "cC J",
    GD: "jC WC",
    HD: "_eC _BE",
    ID: "_NH _ED",
    JD: "_PF fC",
    KD: "_LG _NF",
    LD: "_WB _IG",
    MD: "J _rI",
    ND: "_rM _dP",
    OD: "_uM _TH",
    PD: "_NH _vI",
    QD: "E _7T",
    RD: "_mI _IE",
    SD: "ID _yB",
    TD: "_TF _eP",
    UD: "C _YB",
    VD: "I 1D",
    WD: "_H _FC",
    XD: "_Y _bH",
    YD: "_5 _aP",
    ZD: "_HE _qE",
    aD: "_gP _xK",
    bD: "_yK _3I",
    cD: "_nU _xE",
    dD: "L D",
    eD: "sB tB",
    fD: "_kE _iE",
    gD: "_DD _9D",
    hD: "_mE _vI",
    iD: "_8D _6D",
    jD: "_ID _BC",
    kD: "_OF _ED",
    lD: "_A _v",
    mD: "_JD _pI",
    nD: "_FE _cM",
    oD: "_4D V",
    pD: "_4D _KP",
    qD: "_rB GC",
    rD: "E _uI",
    sD: "_NC 4",
    tD: "_EB _pU",
    uD: "_ZC zB",
    vD: "_OD _kK",
    wD: "_4S _0E",
    xD: "_lP _zS",
    yD: "_fH R",
    zD: "_7M _zS",
    "0D": "_GU _FC",
    "1D": "_IU _L",
    "2D": "_oU _mK",
    "3D": "H S",
    "4D": "T U",
    "5D": "_LH _jE",
    "6D": "_MH _QC",
    "7D": "_5D _bC",
    "8D": "_nE _7D",
    "9D": "_vT _FG",
    AE: "XC MD",
    BE: "fD gD",
    CE: "_mS _oS",
    DE: "_A C",
    EE: "_MB _cK",
    FE: "_AD _TP",
    GE: "O _8B",
    HE: "_DC _lU",
    IE: "_lK _jB",
    JE: "_fC _BC",
    KE: "_hE _pE",
    LE: "_Y _8D",
    ME: "_sK CB",
    NE: "_7D _6D",
    OE: "_GD _AE",
    PE: "_nK _gD",
    QE: "J _KU",
    RE: "K _MT",
    SE: "_H _zS",
    TE: "_fD 9B",
    UE: "_hS _RD",
    VE: "_0T _gD",
    WE: "_h _EJ",
    XE: "_aH 9D",
    YE: "_VF _YG",
    ZE: "_4I _9T",
    aE: "_SG _tI",
    bE: "_4S _jD",
    cE: "_oP _9T",
    dE: "_IT _jB",
    eE: "_LU _uE",
    fE: "AB BB",
    gE: "_qT _aI",
    hE: "_YS _JH",
    iE: "7B 8B",
    jE: "oB pB",
    kE: "5B 6B",
    lE: "_AD _hK",
    mE: "_6D _NH",
    nE: "_aC _EB",
    oE: "bC wC",
    pE: "gC _eS",
    qE: "ZC _lI",
    rE: "_BD _pE",
    sE: "JD KD",
    tE: "_kK XC",
    uE: "_nK _mK",
    vE: "_rI _nM",
    wE: "_7D _fC",
    xE: "_tB _L",
    yE: "_aC _HH",
    zE: "_MB _ZK",
    "0E": "_ID _tB",
    "1E": "_OC A",
    "2E": "_IB fC",
    "3E": "_fD _KH",
    "4E": "_TF M",
    "5E": "_Y _LG",
    "6E": "_Y _KD",
    "7E": "_H _PG",
    "8E": "_H _xM",
    "9E": "_EB _nM",
    AF: "_eC fD",
    BF: "_FD _QH",
    CF: "_n _OU",
    DF: "_LD kD",
    EF: "_mC JC",
    FF: "_4I _fP",
    GF: "_7S _0E",
    HF: "_pP _PD",
    IF: "_5M _EC",
    JF: "W X",
    KF: "0 1",
    LF: "_MB _ZM",
    MF: "_bM _SP",
    NF: "qB rB",
    OF: "_KH _dM",
    PF: "_fM _IB",
    QF: "_kI _YC",
    RF: "_PH _ED",
    SF: "_kU ED",
    TF: "_MG C",
    UF: "_yE IB",
    VF: "_LD _oI",
    WF: "HB _NB",
    XF: "_JP _fE",
    YF: "_MB _VS",
    ZF: "_fC _tB",
    aF: "_h _iD",
    bF: "_uK oB",
    cF: "_hC _uB",
    dF: "_aC DB",
    eF: "_9B P",
    fF: "_MB _GP",
    gF: "_jM QD",
    hF: "_Y _1S",
    iF: "_EE _qT",
    jF: "_GC _3E",
    kF: "_aH _YP",
    lF: "KD LD",
    mF: "_MD jC",
    nF: "_xC _oK",
    oF: "J _QH",
    pF: "_H _0E",
    qF: "_H _DU",
    rF: "_EB _kS",
    sF: "_EB _QU",
    tF: "_Y _1M",
    uF: "_Y _dF",
    vF: "_UH _yS",
    wF: "_wI _cC",
    xF: "_a XC",
    yF: "_x GD",
    zF: "_gP _7K",
    "0F": "_2B _P",
    "1F": "_ZB P",
    "2F": "_VF qD",
    "3F": "_iP _uB",
    "4F": "_nC 5D",
    "5F": "_6S _jD",
    "6F": "_WG _QS",
    "7F": "_9S _kB",
    "8F": "_GT _mD",
    "9F": "_qU _ZP",
    AG: "v w",
    BG: "_RS _IP",
    CG: "IB _rT",
    DG: "QC RC",
    EG: "_gI _sT",
    FG: "_jU 7C",
    GG: "_gM _hM",
    HG: "YD 9C",
    IG: "hD _iK",
    JG: "_GD _sI",
    KG: "_FD I",
    LG: "_nE _5D",
    MG: "_4 _PC",
    NG: "_aS _QC",
    OG: "KB _qB",
    PG: "_bC _hD",
    QG: "_4 _FB",
    RG: "_dM _ED",
    SG: "_H _GE",
    TG: "_yI _BC",
    UG: "_lE _DG",
    VG: "_kE 7B",
    WG: "_wM _EH",
    XG: "_oT _fE",
    YG: "_lS kC",
    ZG: "_vK 3B",
    aG: "_H _zB",
    bG: "_MH _fK",
    cG: "_wK mB",
    dG: "_sK _t",
    eG: "_lE QC",
    fG: "_HE _nK",
    gG: "_KE _SF",
    hG: "B _sB",
    iG: "L ID",
    jG: "1 _CH",
    kG: "eD _8",
    lG: "_NC _DH",
    mG: "_IB _oD",
    nG: "_IB _pD",
    oG: "_H _WM",
    pG: "_NH DC",
    qG: "_Y _aC",
    rG: "_Y _yE",
    sG: "_Y _vK",
    tG: "_oE _uT",
    uG: "_n _L",
    vG: "_wE _cC",
    wG: "_qM _rU",
    xG: "_W 0D",
    yG: "_u _UC",
    zG: "_HE _gF",
    "0G": "_gP _AN",
    "1G": "_aB _WT",
    "2G": "_eB VD",
    "3G": "_XF _q",
    "4G": "_iP _EC",
    "5G": "_YF _HP",
    "6G": "_4M _uB",
    "7G": "_fF d",
    "8G": "_lH _kI",
    "9G": "_HU _P",
    AH: "_ST _BC",
    BH: "_sU _0K",
    CH: "2 3",
    DH: "4 _mT",
    EH: "p _SS",
    FH: "DB EB",
    GH: "GB HB",
    HH: "_aK _GH",
    IH: "eB fB",
    JH: "_IH _hI",
    KH: "9B AC",
    LH: "lB _bS",
    MH: "_ZC _aS",
    NH: "_fD _OF",
    OH: "pC qC",
    PH: "_8D _mE",
    QH: "zD 9C",
    RH: "kD _hS",
    SH: "2D 3D",
    TH: "_jK _nI",
    UH: "G K",
    VH: "_e ID",
    WH: "_JG _uE",
    XH: "_VH _yB",
    YH: "_H _I",
    ZH: "_8D _MH",
    aH: "_MD _lM",
    bH: "_KD _kI",
    cH: "_XM _bK",
    dH: "_aC _FH",
    eH: "_zE _RS",
    fH: "_lE _fM",
    gH: "_h _8D",
    hH: "_1I _q",
    iH: "_1I _j",
    jH: "K _OG",
    kH: "_vC _lD",
    lH: "_5D _NF",
    mH: "_jM tD",
    nH: "u _bK",
    oH: "tB _2I",
    pH: "0B _QC",
    qH: "_mT _XG",
    rH: "_HC _vM",
    sH: "N G",
    tH: "pD _IE",
    uH: "_fE _t",
    vH: "_IB _rE",
    wH: "_IB _UC",
    xH: "_ZK _BG",
    yH: "_H h",
    zH: "_H _jD",
    "0H": "_H _IC",
    "1H": "_H _5S",
    "2H": "_H _TG",
    "3H": "_H _hH",
    "4H": "_H _iH",
    "5H": "_H _nH",
    "6H": "_vC A",
    "7H": "_LH oB",
    "8H": "_Y _CJ",
    "9H": "_6 _lE",
    AI: "_2 dD",
    BI: "_rK _fP",
    CI: "_RC _vM",
    DI: "_1E _SD",
    EI: "_3E BC",
    FI: "_SG _EN",
    GI: "_XF _j",
    HI: "_6S _PD",
    II: "_eH k",
    JI: "_zC iD",
    KI: "_4E _vU",
    LI: "_8M _q",
    MI: "_hF ND",
    NI: "_jF BC",
    OI: "_5K _tI",
    PI: "_BN _PG",
    QI: "_CN _xM",
    RI: "_aG _kB",
    SI: "_rP _6I",
    TI: "_KJ _hD",
    UI: "_LT _JE",
    VI: "_ZT _AU",
    WI: "_SU _L",
    XI: "_TU _P",
    YI: "_tU _P",
    ZI: "_uU _L",
    aI: "y z",
    bI: "7 8",
    cI: "n o",
    dI: "Z a",
    eI: "_QS u",
    fI: "RB SB",
    gI: "NB OB",
    hI: "_MP I",
    iI: "_QP PC",
    jI: "3B 4B",
    kI: "_eD uB",
    lI: "mC _cS",
    mI: "oD pD",
    nI: "VD WD",
    oI: "_RH _mI",
    pI: "_LF CB",
    qI: "DC _VB",
    rI: "_SH _pS",
    sI: "_AE _CE",
    tI: "_IB _BD",
    uI: "_wC _mM",
    vI: "_qI _pI",
    wI: "_H _6",
    xI: "_QH _w",
    yI: "_bC _fC",
    zI: "B _rK",
    "0I": "_RC A",
    "1I": "_dI _ZM",
    "2I": "uB _YC",
    "3I": "XD XC",
    "4I": "_AC _UH",
    "5I": "_bS _jE",
    "6I": "_OF _vI",
    "7I": "_kD _tB",
    "8I": "_tK LB",
    "9I": "jB _dC",
    AJ: "rB _QF",
    BJ: "_OH _1T",
    CJ: "_ZH 1B",
    DJ: "_HD _IG",
    EJ: "_TH _kK",
    FJ: "CC _ED",
    GJ: "HC _hK",
    HJ: "_Y _PH",
    IJ: "_n _8D",
    JJ: "_pT _YK",
    KJ: "_H wB",
    LJ: "DC eC",
    MJ: "_H _3S",
    NJ: "_H _2I",
    OJ: "_7D _mE",
    PJ: "_PH DC",
    QJ: "D E",
    RJ: "kB _HH",
    SJ: "K _CT",
    TJ: "RC _eK",
    UJ: "ID _sE",
    VJ: "jD _kC",
    WJ: "_H _3D",
    XJ: "_H _7I",
    YJ: "_H _ME",
    ZJ: "_H _pH",
    aJ: "_H _PT",
    bJ: "_H _LN",
    cJ: "_EB _xU",
    dJ: "_sT _MF",
    eJ: "_5D qB",
    fJ: "_6D 5B",
    gJ: "_dC G",
    hJ: "_Y _0B",
    iJ: "_Y _tK",
    jJ: "_Y _UF",
    kJ: "_Y _8I",
    lJ: "_Y _9M",
    mJ: "_pE _SF",
    nJ: "_DD _vT",
    oJ: "_SH 4D",
    pJ: "_FD _xI",
    qJ: "_DE M",
    rJ: "_YH _IB",
    sJ: "_gC _A",
    tJ: "_LD _RH",
    uJ: "_u _4D",
    vJ: "_GC _VG",
    wJ: "_0 _4D",
    xJ: "_sK _j",
    yJ: "_jC _DJ",
    zJ: "_gP _tE",
    "0J": "_nD NC",
    "1J": "_yC _UU",
    "2J": "_yC _wU",
    "3J": "_jP _cF",
    "4J": "_YF f",
    "5J": "_UG SC",
    "6J": "_LE _ZC",
    "7J": "_mP _JE",
    "8J": "_mP _ZF",
    "9J": "_2M _JE",
    AK: "_TD XC",
    BK: "_BT _PG",
    CK: "_5E qB",
    DK: "_6K _EC",
    EK: "_DT _j",
    FK: "_DT _q",
    GK: "_GN _jD",
    HK: "_OT _iC",
    IK: "_AL _oK",
    JK: "_BL q",
    KK: "_DL _XS",
    LK: "_MN _mD",
    MK: "_uP _DU",
    NK: "_xP n",
    OK: "_aT _vE",
    PK: "_bT _FC",
    QK: "_cT CB",
    RK: "_VU _L",
    SK: "_yU _P",
    TK: "_zU _P",
    UK: "_0U _P",
    VK: "_1U _L",
    WK: "_2U _L",
    XK: "_3U _P",
    YK: "_HP h",
    ZK: "_VS _YK",
    aK: "_FH FB",
    bK: "_gE _fE",
    cK: "_ZK _YM",
    dK: "_OP _WS",
    eK: "_RP UC",
    fK: "1B 2B",
    gK: "_cM _iI",
    hK: "_TP _gK",
    iK: "iD jD",
    jK: "TD UD",
    kK: "_sB XD",
    lK: "_lS _nS",
    mK: "_gD SD",
    nK: "_jM _1T",
    oK: "_jM _2T",
    pK: "_l _QH",
    qK: "_IG _bP",
    rK: "_v _UH",
    sK: "_YM _bK",
    tK: "_yE _CG",
    uK: "_nE _LH",
    vK: "_ZH _fK",
    wK: "_nE lB",
    xK: "_nI _tE",
    yK: "_yM _pM",
    zK: "_rT _qB",
    "0K": "_mS kC",
    "1K": "_OH _2T",
    "2K": "_kD _BC",
    "3K": "_LF _EG",
    "4K": "_2E _pI",
    "5K": "_H Q",
    "6K": "_H MB",
    "7K": "WD _tE",
    "8K": "KC _gK",
    "9K": "_RH oD",
    AL: "_HD _qK",
    BL: "_wM p",
    CL: "_nD _QP",
    DL: "_3K _bM",
    EL: "_H _cH",
    FL: "F A",
    GL: "B _v",
    HL: "_UG _RP",
    IL: "_sP _YS",
    JL: "C XC",
    KL: "C _aP",
    LL: "C _3I",
    ML: "Q _hC",
    NL: "J _xI",
    OL: "J _WU",
    PL: "8C _3I",
    QL: "_nT _cI",
    RL: "_EH _QS",
    SL: "_H _YK",
    TL: "_H _tB",
    UL: "_H _n",
    VL: "_H _hD",
    WL: "_H _2K",
    XL: "_H _VT",
    YL: "_H _yP",
    ZL: "_H _4U",
    aL: "_H _5U",
    bL: "_vC _ND",
    cL: "_EB _ZP",
    dL: "_LF _gI",
    eL: "_OF DC",
    fL: "_PF _oD",
    gL: "_Y _UB",
    hL: "_Y _wK",
    iL: "_Y _dH",
    jL: "_Y _eF",
    kL: "_Y _ZG",
    lL: "_fS _9D",
    mL: "_FD _ON",
    nL: "_IG _oI",
    oL: "_wC bD",
    pL: "_GD XC",
    qL: "_JG _nK",
    rL: "_fC _cC",
    sL: "_n _PH",
    tL: "_n _dT",
    uL: "_n _YU",
    vL: "_n _ZU",
    wL: "_m _6U",
    xL: "_hC _EC",
    yL: "_FE LC",
    zL: "_0 _wM",
    "0L": "_sK _q",
    "1L": "_GE _hC",
    "2L": "_yK XC",
    "3L": "_6S _0E",
    "4L": "_7S _jD",
    "5L": "_lP _FC",
    "6L": "_mP _hD",
    "7L": "_oP _yS",
    "8L": "_2M _ZF",
    "9L": "_pP _0E",
    AM: "_4M _EC",
    BM: "_8M _j",
    CM: "_rP _7I",
    DM: "_DN _6I",
    EM: "_DN _2K",
    FM: "_ET _7I",
    GM: "_FT _uB",
    HM: "_FN _0E",
    IM: "_NT _IC",
    JM: "_NJ _hD",
    KM: "_OJ DC",
    LM: "_NU _P",
    MM: "_NU _XU",
    NM: "_UT _VC",
    OM: "_NN _vE",
    PM: "_PN _L",
    QM: "_zP _BC",
    RM: "_0P _iC",
    SM: "_7U _pI",
    TM: "_8U _P",
    UM: "_9U _P",
    VM: "_AV _L",
    WM: "_JF Y",
    XM: "_EH _eI",
    YM: "_BG _XM",
    ZM: "_cK _bK",
    aM: "TB UB",
    bM: "_fI _aM",
    cM: "LC MC",
    dM: "BC CC",
    eM: "_EG _MF",
    fM: "_DG _eK",
    gM: "aC rC",
    hM: "sC tC",
    iM: "3C 4C",
    jM: "_qE _OH",
    kM: "aC _yT",
    lM: "jC _zT",
    mM: "bD cD",
    nM: "_lM _ZP",
    oM: "_rE _SF",
    pM: "_PH _vI",
    qM: "_Y _UH",
    rM: "_A _rK",
    sM: "ID _cP",
    tM: "_H _5",
    uM: "F B",
    vM: "_VH _sE",
    wM: "_zE _BG",
    xM: "_yI _tB",
    yM: "_H C",
    zM: "_tT _hK",
    "0M": "2B _jI",
    "1M": "_0B GB",
    "2M": "_H _YC",
    "3M": "_ZS _gK",
    "4M": "_H _WF",
    "5M": "_H _zK",
    "6M": "OD _oS",
    "7M": "_H N",
    "8M": "_H _8T",
    "9M": "_UF _US",
    AN: "UD _xK",
    BN: "_H pB",
    CN: "_H _jE",
    DN: "_H 8B",
    EN: "_hC _kB",
    FN: "_H _QC",
    GN: "_H _NG",
    HN: "_H _hK",
    IN: "_H _8S",
    JN: "_UF JB",
    KN: "_2E _oM",
    LN: "PC _mD",
    MN: "_H _iI",
    NN: "J _HH",
    ON: "yD _QH",
    PN: "_n _KD",
    QN: "_H _JU",
    RN: "_MH 1B",
    SN: "_V _v",
    TN: "_xC _mH",
    UN: "WC _sI",
    VN: "_H _8K",
    WN: "_H _XT",
    XN: "_OE _0K",
    YN: "C _sS",
    ZN: "N _UB",
    aN: "J _vE",
    bN: "EB _eT",
    cN: "IB JB",
    dN: "K _mK",
    eN: "yB _aS",
    fN: "UD VD",
    gN: "9C _w",
    hN: "pD _lK",
    iN: "_8B _hC",
    jN: "_XM _gE",
    kN: "_H _IB",
    lN: "_H _iC",
    mN: "_H _4B",
    nN: "_H _cF",
    oN: "_H _SN",
    pN: "_H _1P",
    qN: "_H _BV",
    rN: "_PC C",
    sN: "_dM _vI",
    tN: "_NF _kI",
    uN: "_7D _RN",
    vN: "_mE DC",
    wN: "_Y _9B",
    xN: "_Y _ZH",
    yN: "_Y _uK",
    zN: "_dS _9D",
    "0N": "_FD _l",
    "1N": "_FD _0S",
    "2N": "_6 EC",
    "3N": "_n _GV",
    "4N": "_3T _cU",
    "5N": "_zE i",
    "6N": "_EE v",
    "7N": "_LD _9K",
    "8N": "_u _MB",
    "9N": "_GC 5B",
    AO: "_GC _kE",
    BO: "_GC _fD",
    CO: "_0 _UC",
    DO: "_0 _iF",
    EO: "_GE kB",
    FO: "_lD G",
    GO: "_pD Z",
    HO: "_iP _kB",
    IO: "_LE xB",
    JO: "_2M _hD",
    KO: "_NE 5B",
    LO: "_NE _fD",
    MO: "_8S _bC",
    NO: "_9S _uB",
    OO: "_BT _xM",
    PO: "_BT _TG",
    QO: "_6K _uB",
    RO: "_BN _xM",
    SO: "_CN _PG",
    TO: "_ET _6I",
    UO: "_FT _EC",
    VO: "_HJ dC",
    WO: "_HJ _CD",
    XO: "_HT _EV",
    YO: "_IJ _L",
    ZO: "_IJ _FV",
    aO: "_JJ _dG",
    bO: "_tP CB",
    cO: "_JT _kB",
    dO: "_JT _EC",
    eO: "_FN _jD",
    fO: "_KT _uB",
    gO: "_KT _EC",
    hO: "_LT _hD",
    iO: "_HU _DV",
    jO: "_mF 7D",
    kO: "_HN _iC",
    lO: "_HN _VC",
    mO: "_IN _xM",
    nO: "_IN _TG",
    oO: "_qH _t",
    pO: "_NT _FC",
    qO: "_QT _uI",
    rO: "_QT _wS",
    sO: "_TT _iC",
    tO: "_TT _VC",
    uO: "_YT _hH",
    vO: "_EL _j",
    wO: "_QN _t",
    xO: "_TN _GG",
    yO: "_2P _KN",
    zO: "_3P 3B",
    "0O": "_4P aC",
    "1O": "_gT _aU",
    "2O": "_hT _gD",
    "3O": "_iT iD",
    "4O": "_bU _FC",
    "5O": "_dU _P",
    "6O": "_CV _vE",
    "7O": "_HV _P",
    "8O": "_IV _P",
    "9O": "_JV _P",
    AP: "_KV _P",
    BP: "_LV _L",
    CP: "_MV _L",
    DP: "_NV _L",
    EP: "_OV _L",
    FP: "_PV _P",
    GP: "b c",
    HP: "f g",
    IP: "_TS _cI",
    JP: "_DH _oT",
    KP: "V _WM",
    LP: "_KP _dI",
    MP: "_iU iB",
    NP: "WB XB",
    OP: "YB ZB",
    PP: "CB QB",
    QP: "NC OC",
    RP: "SC TC",
    SP: "_XS _dK",
    TP: "IC _ZS",
    UP: "1C 2C",
    VP: "lC YC",
    WP: "uC vC",
    XP: "mD nD",
    YP: "9D AE",
    ZP: "_YP _kS",
    aP: "_sB XC",
    bP: "_oI _lK",
    cP: "_yB _WH",
    dP: "LD _WH",
    eP: "_XH _GD",
    fP: "_sI _uE",
    gP: "_tM _pM",
    hP: "_VH JD",
    iP: "_H _NB",
    jP: "_H _8B",
    kP: "yB _NG",
    lP: "_H _AC",
    mP: "_H _QF",
    nP: "_VP PD",
    oP: "N _UH",
    pP: "_H _kP",
    qP: "cC _6",
    rP: "_H _lC",
    sP: "_LF _eM",
    tP: "_H _ZM",
    uP: "_H AC",
    vP: "_H _jH",
    wP: "_H _PU",
    xP: "_eH _TS",
    yP: "TC UC",
    zP: "_H _FJ",
    "0P": "_H _GJ",
    "1P": "X Y",
    "2P": "_H UC",
    "3P": "_7D _bG",
    "4P": "_kF _gS",
    "5P": "B _3B",
    "6P": "g h",
    "7P": "OC PC",
    "8P": "WC XC",
    "9P": "_H _ED",
    AQ: "_H _oH",
    BQ: "_H _LJ",
    CQ: "L AD",
    DQ: "9 _fE",
    EQ: "C H",
    FQ: "C _tE",
    GQ: "R H",
    HQ: "m _cI",
    IQ: "J iC",
    JQ: "jB ID",
    KQ: "kB _aK",
    LQ: "IB _US",
    MQ: "K _kT",
    NQ: "K _hU",
    OQ: "lB mB",
    PQ: "pB _bC",
    QQ: "pB _yI",
    RQ: "6B 7B",
    SQ: "fC _oM",
    TQ: "8C XC",
    UQ: "xD yD",
    VQ: "_3D _rE",
    WQ: "_KF 2",
    XQ: "_IB _4D",
    YQ: "_H _v",
    ZQ: "_H _JE",
    aQ: "_H _ZF",
    bQ: "_H _KN",
    cQ: "_H _GL",
    dQ: "_H _6P",
    eQ: "_H _QV",
    fQ: "_H _RV",
    gQ: "_H _UV",
    hQ: "_AC _UB",
    iQ: "_vC _lF",
    jQ: "_EB _yT",
    kQ: "_EB _kM",
    lQ: "_dK _gG",
    mQ: "_SP _hE",
    nQ: "_SP _KE",
    oQ: "_NF sB",
    pQ: "_iE _OF",
    qQ: "_AD _L",
    rQ: "_4 ID",
    sQ: "_7D xB",
    tQ: "_dC _LG",
    uQ: "_Y _bF",
    vQ: "_WP _eU",
    wQ: "_DD _UP",
    xQ: "_5 _AN",
    yQ: "_5 _8P",
    zQ: "_lM _YP",
    "0Q": "_nI _kK",
    "1Q": "_6 _AD",
    "2Q": "_6 _FE",
    "3Q": "_6 _mC",
    "4Q": "_6 _qD",
    "5Q": "_6 _eG",
    "6Q": "_yB jC",
    "7Q": "_yB _XN",
    "8Q": "_h _XV",
    "9Q": "_KG _fU",
    AR: "_wE _VB",
    BR: "_iD 5B",
    CR: "_V AD",
    DR: "_EE _AG",
    ER: "_MG _eP",
    FR: "_u _WG",
    GR: "_u _iF",
    HR: "_HE ZC",
    IR: "_1I CB",
    JR: "_OD WC",
    KR: "_2B _ZV",
    LR: "_7 _WV",
    MR: "_7 _iV",
    NR: "_yC _L",
    OR: "_oD _JF",
    PR: "_2S _uI",
    QR: "_RG _tB",
    RR: "_yK _tE",
    SR: "_aF _TV",
    TR: "_aF _YV",
    UR: "_7S _PD",
    VR: "_4E _1S",
    WR: "_9S _EC",
    XR: "_3M _lT",
    YR: "_DJ _oI",
    ZR: "_DJ _9K",
    aR: "_gH _P",
    bR: "_oC _IL",
    cR: "_5M _kB",
    dR: "_lF jC",
    eR: "_5K _EN",
    fR: "_ET _2K",
    gR: "_FT _kB",
    hR: "_GT _VC",
    iR: "_sP cB",
    jR: "_HT _P",
    kR: "_JJ _YM",
    lR: "_tP _j",
    mR: "_tP _q",
    nR: "_JT _uB",
    oR: "_GN _PD",
    pR: "_KT _kB",
    qR: "_6E sB",
    rR: "_MJ _j",
    sR: "_MJ _q",
    tR: "_nF _DD",
    uR: "_OT _VC",
    vR: "_fG _DD",
    wR: "_UT _iC",
    xR: "_VT G",
    yR: "_rH SD",
    zR: "_YT _iH",
    "0R": "_vP _uB",
    "1R": "_vP _kB",
    "2R": "_wP _j",
    "3R": "_wP _q",
    "4R": "_PJ _CL",
    "5R": "_FL _jT",
    "6R": "_HL _L",
    "7R": "_VN _VC",
    "8R": "_WN _ME",
    "9R": "_5P _UN",
    AS: "_7P _JD",
    BS: "_9P _BC",
    CS: "_AQ _JE",
    DS: "_BQ _tB",
    ES: "_gU _iC",
    FS: "_SV _CT",
    GS: "_VV CB",
    HS: "_aV _L",
    IS: "_bV _P",
    JS: "_cV _P",
    KS: "_dV _P",
    LS: "_eV _L",
    MS: "_fV _L",
    NS: "_gV _L",
    OS: "_hV _L",
    PS: "_jV _P",
    QS: "s t",
    RS: "i j",
    SS: "q r",
    TS: "k _nT",
    US: "JB K",
    VS: "_GP _pT",
    WS: "aB bB",
    XS: "VB _NP",
    YS: "cB dB",
    ZS: "JC KC",
    aS: "zB 0B",
    bS: "mB nB",
    cS: "nC oC",
    dS: "zC 0C",
    eS: "VC hC",
    fS: "_uT _dS",
    gS: "BE ZC",
    hS: "lD _XP",
    iS: "_wT RD",
    jS: "5D 6D",
    kS: "_gS _kM",
    lS: "qD rD",
    mS: "ND OD",
    nS: "_xT sD",
    oS: "_xT PD",
    pS: "4D _jS",
    qS: "E _d",
    rS: "_pK _w",
    sS: "H _aP",
    tS: "_H _m",
    uS: "_pM _P",
    vS: "_h _PH",
    wS: "_uI _p",
    xS: "WC _fP",
    yS: "_CE _uE",
    zS: "_UB _tI",
    "0S": "yD _xI",
    "1S": "_eP _AE",
    "2S": "E _HG",
    "3S": "_aI _fE",
    "4S": "_H _jI",
    "5S": "_eI _bK",
    "6S": "_H _0M",
    "7S": "_H 4B",
    "8S": "nB _jE",
    "9S": "_H _qB",
    AT: "K _nP",
    BT: "_H _5I",
    CT: "_9D SD",
    DT: "_H _bK",
    ET: "_H _iE",
    FT: "_H _CC",
    GT: "_H _zM",
    HT: "_h _KD",
    IT: "rD _nS",
    JT: "_H _EB",
    KT: "_H _OG",
    LT: "_H _AJ",
    MT: "_BJ _mK",
    NT: "_H _dC",
    OT: "_H _3M",
    PT: "_eK _4K",
    QT: "E 9C",
    RT: "_SS _5S",
    ST: "_H eC",
    TT: "_H _gK",
    UT: "_H _MU",
    VT: "_gC _lD",
    WT: "_UC _L",
    XT: "e _YK",
    YT: "_H Y",
    ZT: "_vC _rM",
    aT: "J _aK",
    bT: "_H _kH",
    cT: "_H _RT",
    dT: "_ZH _L",
    eT: "FB _GH",
    fT: "MC _iI",
    gT: "_vC _DE",
    hT: "_WP uD",
    iT: "_HD hD",
    jT: "LD jC",
    kT: "_FG SD",
    lT: "_mD _P",
    mT: "5 6",
    nT: "l m",
    oT: "_bI 9",
    pT: "d e",
    qT: "_AG x",
    rT: "_US KB",
    sT: "PB _PP",
    tT: "GC HC",
    uT: "xC yC",
    vT: "_UP _iM",
    wT: "_GG _WP",
    xT: "kC _VP",
    yT: "bC CE",
    zT: "7D 8D",
    "0T": "_wT uD",
    "1T": "QD _iS",
    "2T": "tD _0T",
    "3T": "_qM _XH",
    "4T": "_dC _UH",
    "5T": "_pS _nM",
    "6T": "_gC _rM",
    "7T": "aD _mM",
    "8T": "_LP _ZM",
    "9T": "MD _yS",
    AU: "KD _dP",
    BU: "_jS _nM",
    CU: "sD _jB",
    DU: "_RG _BC",
    EU: "_4 _L",
    FU: "_XH jC",
    GU: "_H _9I",
    HU: "_h _LG",
    IU: "_n _tK",
    JU: "x _3S",
    KU: "I _xI",
    LU: "_UH _6M",
    MU: "FC _zM",
    NU: "_h _bH",
    OU: "_dH _L",
    PU: "U _8T",
    QU: "6D _nM",
    RU: "_IP _cH",
    SU: "_n _LG",
    TU: "_gH xB",
    UU: "_kE _L",
    VU: "_g _RC",
    WU: "DB _vE",
    XU: "vB _P",
    YU: "_UB _L",
    ZU: "_nE _L",
    aU: "LD _GD",
    bU: "_H _lD",
    cU: "_JG _PE",
    dU: "_HT _eD",
    eU: "RD _mK",
    fU: "xD _0S",
    gU: "_H _fT",
    hU: "_fS _CT",
    iU: "gB hB",
    jU: "5C 6C",
    kU: "CD DD",
    lU: "_XH _JG",
    mU: "3D _5T",
    nU: "_H _qP",
    oU: "K _iS",
    pU: "AE _kS",
    qU: "_EB _zT",
    rU: "iC _sM",
    sU: "_DC _1S",
    tU: "_h _yE",
    uU: "_n _cG",
    vU: "_eP XC",
    wU: "5B _L",
    xU: "8D _ZP",
    yU: "_h _1M",
    zU: "_h _bF",
    "0U": "_h _9M",
    "1U": "_n _yE",
    "2U": "_n _CJ",
    "3U": "_aF _VG",
    "4U": "a _ZM",
    "5U": "r _5S",
    "6U": "EC _L",
    "7U": "_H _VB",
    "8U": "_h _wK",
    "9U": "_h _8I",
    AV: "_n _vK",
    BV: "j _RU",
    CV: "J _FH",
    DV: "qB _P",
    EV: "sB _P",
    FV: "xB _L",
    GV: "_9B _L",
    HV: "_h _0B",
    IV: "_h _uK",
    JV: "_h _ZG",
    KV: "_h _JN",
    LV: "_n _UF",
    MV: "_n _uK",
    NV: "_n _wK",
    OV: "_n _8I",
    PV: "_2B _nD",
    QV: "o _cH",
    RV: "w _JU",
    SV: "K _dS",
    TV: "5B _P",
    UV: "RC _PT",
    VV: "_H _RU",
    WV: "_MB _P",
    XV: "_UB _P",
    YV: "_kE _P",
    ZV: "_AD _P",
    aV: "_g _HC",
    bV: "_h _ZH",
    cV: "_h _tK",
    dV: "_h _dH",
    eV: "_n _1M",
    fV: "_n _bF",
    gV: "_n _eF",
    hV: "_n _JN",
    iV: "_zE _P",
    jV: "_2B _CL"
};

});

parcelRegister("iwMEh", function(module, exports) {
//! moment.js
//! version : 2.31.0
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

var $2bfPH = parcelRequire("2bfPH");
(function(global, factory) {
    module.exports = factory();
})(undefined, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidOffset: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function some(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid$2(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidOffset && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid$1(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if ((0, $2bfPH._)(arguments[i]) === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg + '\n' + new Error().stack);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\e)|(\\)?(eHHmm|[Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function func() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        var cacheKey = '$' + format;
        if (!hasOwnProp(formatFunctions, cacheKey)) formatFunctions[cacheKey] = makeFormatFunction(format);
        return formatFunctions[cacheKey](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function func(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get$2(this, unit);
        };
    }
    function get$2(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if ((typeof units === "undefined" ? "undefined" : (0, $2bfPH._)(units)) === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod$1(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function indexOf(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod$1(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord, monthsParseProperties = [
        'monthsParse',
        'longMonthsParse',
        'shortMonthsParse',
        'monthsRegex',
        'monthsShortRegex',
        'monthsStrictRegex',
        'monthsShortStrictRegex'
    ];
    function clearMonthsParseCache(locale, config) {
        var i, prop;
        for(i = 0; i < monthsParseProperties.length; i++){
            prop = monthsParseProperties[i];
            if (!hasOwnProp(config, prop)) delete locale['_' + prop];
        }
    }
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse$1(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse$1.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get$2(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    addFormatToken('eHHmm', 0, 0, function() {
        return '' + this.weekday() + zeroFill(this.hours(), 2) + zeroFill(this.minutes(), 2);
    });
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('eHHmm', match5to6);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    addWeekParseToken('eHHmm', function(input, week, config) {
        var weekdayEnd = input.length - 4;
        week.e = toInt(input.substr(0, weekdayEnd));
        config._a[HOUR] = toInt(input.substr(weekdayEnd, 2));
        config._a[MINUTE] = toInt(input.substr(weekdayEnd + 2));
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord, weekdaysParseProperties = [
        'weekdaysParse',
        'fullWeekdaysParse',
        'shortWeekdaysParse',
        'minWeekdaysParse',
        'weekdaysRegex',
        'weekdaysShortRegex',
        'weekdaysMinRegex',
        'weekdaysStrictRegex',
        'weekdaysShortStrictRegex',
        'weekdaysMinStrictRegex'
    ];
    function clearWeekdaysParseCache(locale, config) {
        var i, prop;
        for(i = 0; i < weekdaysParseProperties.length; i++){
            prop = weekdaysParseProperties[i];
            if (!hasOwnProp(config, prop)) delete locale['_' + prop];
        }
    }
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get$2(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    function set(config) {
        var prop, i;
        clearMonthsParseCache(this, config);
        clearWeekdaysParseCache(this, config);
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function keys(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar$1(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var _$format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()], formatCache = this._longDateFormatCache;
        if (_$format || !formatUpper) return _$format;
        if (formatCache && formatCache[key] && formatCache[key].formatUpper === formatUpper) return formatCache[key].format;
        _$format = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        if (!formatCache) formatCache = this._longDateFormatCache = {};
        formatCache[key] = {
            formatUpper: formatUpper,
            format: _$format
        };
        return _$format;
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTimeWithoutPostformat(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function relativeTime$1(number, withoutSuffix, string, isFuture) {
        return this.postformat(relativeTimeWithoutPostformat.call(this, number, withoutSuffix, string, isFuture));
    }
    function pastFutureWithoutPostformat(diff, output) {
        var _$format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(_$format) ? _$format(output) : _$format.replace(/%s/i, output);
    }
    function pastFuture(diff, output) {
        return this.postformat(pastFutureWithoutPostformat.call(this, diff, output));
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYearFromDayOfYear(year, dayOfYear, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), week = Math.floor((dayOfYear - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = year - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(year, dow, doy)) {
            resWeek = week - weeksInYear(year, dow, doy);
            resYear = year + 1;
        } else {
            resYear = year;
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        return weekOfYearFromDayOfYear(mom.year(), mom.dayOfYear(), dow, doy);
    }
    function weekOfYearFromDate(year, month, date, dow, doy) {
        var dayOfYear = Math.round((createUTCDate(year, month, date) - createUTCDate(year, 0, 1)) / 864e5) + 1;
        return weekOfYearFromDayOfYear(year, dayOfYear, dow, doy);
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, _$locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                _$locale = loadLocale(split.slice(0, j).join('-'));
                if (_$locale) return _$locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Only canonical locale module names are safe to append to the require path.
        return typeof name === 'string' && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(name);
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire, normalizedName;
        // Preserve exact custom locale names before trying the canonical built-in name.
        // Use hasOwnProp rather than a plain lookup so that names like "__proto__",
        // "constructor", or "prototype" can't resolve to an inherited Object.prototype
        // property instead of a real (or missing) locale entry.
        if (hasOwnProp(locales, name)) return locales[name];
        normalizedName = normalizeLocale(name);
        if (hasOwnProp(locales, normalizedName)) return locales[normalizedName];
        // TODO: Find a better way to register and load all the locales in Node
        if (module && module.exports && isLocaleNameSane(normalizedName)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + normalizedName);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[normalizedName] = null; // null means not found
        }
        if (hasOwnProp(locales, normalizedName)) return locales[normalizedName];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var _$locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    _$locale = loadLocale(config.parentLocale);
                    if (_$locale != null) parentConfig = _$locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        var _$locale, tmpLocale = loadLocale(name), parentConfig = baseConfig;
        if (tmpLocale != null) name = tmpLocale._abbr;
        if (config != null) {
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                _$locale = new Locale(config);
                _$locale.parentLocale = locales[name];
                locales[name] = _$locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var _$locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            _$locale = loadLocale(key);
            if (_$locale) return _$locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config, now, forWeek) {
        var hadWeekContext = Object.prototype.hasOwnProperty.call(config, '_isDefaultDatePartsForWeek'), weekContext = config._isDefaultDatePartsForWeek;
        // hooks is actually the exported moment object
        config._isDefaultDatePartsForWeek = !!forWeek;
        try {
            return hooks._getDefaultDateParts(config, now, forWeek);
        } finally{
            if (hadWeekContext) config._isDefaultDatePartsForWeek = weekContext;
            else delete config._isDefaultDatePartsForWeek;
        }
    }
    function currentDateNow(config) {
        var now = config._defaultDatePartsNow;
        if (!now) return hooks.now();
        if (!now.hasValue) {
            now.value = hooks.now();
            now.hasValue = true;
        }
        return now.value;
    }
    // Internal hook for extensions that supply omitted calendar fields.
    function getDefaultDateParts(config, now, forWeek) {
        var useWeekDefaults = forWeek || config._isDefaultDatePartsForWeek, nowValue = useWeekDefaults ? createLocal(now) : new Date(now);
        if (useWeekDefaults) return [
            nowValue.year(),
            nowValue.month(),
            nowValue.date()
        ];
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    hooks._getDefaultDateParts = getDefaultDateParts;
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], now, currentDate, expectedWeekday, yearToUse, dateIsDefaulted;
        if (config._d) return;
        if (config._a[YEAR] == null || config._a[MONTH] == null || config._a[DATE] == null) {
            now = currentDateNow(config);
            currentDate = currentDateArray(config, now);
        }
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config, currentDateArray(config, now, true));
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = config._a[YEAR] != null ? config._a[YEAR] : currentDate[YEAR];
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        dateIsDefaulted = config._a[YEAR] == null || config._a[MONTH] == null || config._a[DATE] == null;
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && !dateIsDefaulted && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config, currentDate) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYearFromDate(currentDate[YEAR], currentDate[MONTH], currentDate[DATE], 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYearFromDate(currentDate[YEAR], currentDate[MONTH], currentDate[DATE], dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, defaultDatePartsNow = {}, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._defaultDatePartsNow = defaultDatePartsNow;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid$2(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, _$format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || _$format === undefined && input === '') return createInvalid$1({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(_$format)) configFromStringAndArray(config);
        else if (_$format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid$2(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid$1();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid$1();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        for(i = 0; i < moments.length; ++i)if (isMoment(moments[i])) {
            res = moments[i];
            break;
        }
        if (!res) return createInvalid$1();
        for(++i; i < moments.length; ++i)if (isMoment(moments[i]) && (!moments[i].isValid() || moments[i][fn](res))) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function now() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, _$weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + _$weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var _$offset = this.utcOffset(), sign = '+';
            if (_$offset < 0) {
                _$offset = -_$offset;
                sign = '-';
            }
            return sign + zeroFill(~~(_$offset / 60), 2) + separator + zeroFill(~~_$offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        var _$offset = offsetFromString(matchShortOffset, input);
        config._useUTC = true;
        config._tzm = _$offset;
        if (_$offset === null) getParsingFlags(config).invalidOffset = input;
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        if (toInt(parts[2]) > 59 || (parts[0] === '+' ? minutes > 840 : minutes > 720)) return null;
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, _$diff;
        if (model._isUTC) {
            res = model.clone();
            _$diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + _$diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var _$offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (_$offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract$1(this, createDuration(input - _$offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? _$offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if ((typeof duration === "undefined" ? "undefined" : (0, $2bfPH._)(duration)) === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract$1(this, dur, direction);
            return this;
        };
    }
    function addSubtract$1(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get$2(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get$2(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add$1 = createAdder(1, 'add'), subtract$1 = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var _$diff = myMoment.diff(now, 'days', true);
        return _$diff < -6 ? 'sameElse' : _$diff < -1 ? 'lastWeek' : _$diff < 0 ? 'lastDay' : _$diff < 1 ? 'sameDay' : _$diff < 2 ? 'nextDay' : _$diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), _$format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[_$format]) ? formats[_$format].call(this, now) : formats[_$format]);
        return this.format(output || this.localeData().calendar(_$format, this, createLocal(now)));
    }
    function clone$1() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString$1(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf$1() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid() {
        return isValid$2(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch((0, $2bfPH._)(eras[i].since)){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch((0, $2bfPH._)(eras[i].until)){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto$2 = Moment.prototype;
    proto$2.add = add$1;
    proto$2.calendar = calendar;
    proto$2.clone = clone$1;
    proto$2.diff = diff;
    proto$2.endOf = endOf;
    proto$2.format = format;
    proto$2.from = from;
    proto$2.fromNow = fromNow;
    proto$2.to = to;
    proto$2.toNow = toNow;
    proto$2.get = stringGet;
    proto$2.invalidAt = invalidAt;
    proto$2.isAfter = isAfter;
    proto$2.isBefore = isBefore;
    proto$2.isBetween = isBetween;
    proto$2.isSame = isSame;
    proto$2.isSameOrAfter = isSameOrAfter;
    proto$2.isSameOrBefore = isSameOrBefore;
    proto$2.isValid = isValid;
    proto$2.lang = lang;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.max = prototypeMax;
    proto$2.min = prototypeMin;
    proto$2.parsingFlags = parsingFlags;
    proto$2.set = stringSet;
    proto$2.startOf = startOf;
    proto$2.subtract = subtract$1;
    proto$2.toArray = toArray;
    proto$2.toObject = toObject;
    proto$2.toDate = toDate;
    proto$2.toISOString = toISOString$1;
    proto$2.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto$2[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto$2.toJSON = toJSON;
    proto$2.toString = toString;
    proto$2.unix = unix;
    proto$2.valueOf = valueOf$1;
    proto$2.creationData = creationData;
    proto$2.eraName = getEraName;
    proto$2.eraNarrow = getEraNarrow;
    proto$2.eraAbbr = getEraAbbr;
    proto$2.eraYear = getEraYear;
    proto$2.year = getSetYear;
    proto$2.isLeapYear = getIsLeapYear;
    proto$2.weekYear = getSetWeekYear;
    proto$2.isoWeekYear = getSetISOWeekYear;
    proto$2.quarter = proto$2.quarters = getSetQuarter;
    proto$2.month = getSetMonth;
    proto$2.daysInMonth = getDaysInMonth;
    proto$2.week = proto$2.weeks = getSetWeek;
    proto$2.isoWeek = proto$2.isoWeeks = getSetISOWeek;
    proto$2.weeksInYear = getWeeksInYear;
    proto$2.weeksInWeekYear = getWeeksInWeekYear;
    proto$2.isoWeeksInYear = getISOWeeksInYear;
    proto$2.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto$2.date = getSetDayOfMonth;
    proto$2.day = proto$2.days = getSetDayOfWeek;
    proto$2.weekday = getSetLocaleDayOfWeek;
    proto$2.isoWeekday = getSetISODayOfWeek;
    proto$2.dayOfYear = getSetDayOfYear;
    proto$2.hour = proto$2.hours = getSetHour;
    proto$2.minute = proto$2.minutes = getSetMinute;
    proto$2.second = proto$2.seconds = getSetSecond;
    proto$2.millisecond = proto$2.milliseconds = getSetMillisecond;
    proto$2.utcOffset = getSetOffset;
    proto$2.utc = setOffsetToUTC;
    proto$2.local = setOffsetToLocal;
    proto$2.parseZone = setOffsetToParsedOffset;
    proto$2.hasAlignedHourOffset = hasAlignedHourOffset;
    proto$2.isDST = isDaylightSavingTime;
    proto$2.isLocal = isLocal;
    proto$2.isUtcOffset = isUtcOffset;
    proto$2.isUtc = isUtc;
    proto$2.isUTC = isUtc;
    proto$2.zoneAbbr = getZoneAbbr;
    proto$2.zoneName = getZoneName;
    proto$2.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto$2.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto$2.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto$2.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto$2.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar$1;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime$1;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var _$locale = getLocale(), utc = createUTC().set(setter, index);
        return _$locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var _$locale = getLocale(), shift = localeSorted ? _$locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function ordinal(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs$1() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add(input, value) {
        return addSubtract(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract(input, value) {
        return addSubtract(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf = asMilliseconds;
    function clone() {
        return createDuration(this);
    }
    function get(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return relativeTimeWithoutPostformat.call(locale, number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), _$weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || _$weeks <= 1 && [
            'w'
        ] || _$weeks < thresholds.w && [
            'ww',
            _$weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, _$locale, output;
        if ((typeof argWithSuffix === "undefined" ? "undefined" : (0, $2bfPH._)(argWithSuffix)) === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if ((typeof argThresholds === "undefined" ? "undefined" : (0, $2bfPH._)(argThresholds)) === 'object') {
            th = extend(extend({}, thresholds), argThresholds || {});
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        _$locale = this.localeData();
        output = relativeTime(this, !withSuffix, th, _$locale);
        if (withSuffix) output = pastFutureWithoutPostformat.call(_$locale, +this, output);
        return _$locale.postformat(output);
    }
    var abs = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs(this._milliseconds) / 1000, days = abs(this._days), months = abs(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto = Duration.prototype;
    proto.isValid = isValid$1;
    proto.abs = abs$1;
    proto.add = add;
    proto.subtract = subtract;
    proto.as = as;
    proto.asMilliseconds = asMilliseconds;
    proto.asSeconds = asSeconds;
    proto.asMinutes = asMinutes;
    proto.asHours = asHours;
    proto.asDays = asDays;
    proto.asWeeks = asWeeks;
    proto.asMonths = asMonths;
    proto.asQuarters = asQuarters;
    proto.asYears = asYears;
    proto.valueOf = valueOf;
    proto._bubble = bubble;
    proto.clone = clone;
    proto.get = get;
    proto.milliseconds = milliseconds;
    proto.seconds = seconds;
    proto.minutes = minutes;
    proto.hours = hours;
    proto.days = days;
    proto.weeks = weeks;
    proto.months = months;
    proto.years = years;
    proto.humanize = humanize;
    proto.toISOString = toISOString;
    proto.toString = toISOString;
    proto.toJSON = toISOString;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString);
    proto.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.31.0';
    setHookCallback(createLocal);
    hooks.fn = proto$2;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid$1;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto$2;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});


var $1Mz1E = parcelRequire("1Mz1E");

var $iLZuz = parcelRequire("iLZuz");
var $eb0af92fb0d106cc$exports = {};

$eb0af92fb0d106cc$exports = (parcelRequire("iFI1t"));


var $09d1114e8c0ab763$exports = {};

$09d1114e8c0ab763$exports = (parcelRequire("5WNjD"));


var $3253481c11effcc0$exports = {};

$3253481c11effcc0$exports = (parcelRequire("avNV9"));


var $0f601913c0a3e0d3$exports = {};

$0f601913c0a3e0d3$exports = (parcelRequire("fJZFI"));


var $f6a213ca3eebef7b$exports = {};

$f6a213ca3eebef7b$exports = (parcelRequire("iN4iX"));


var $168312580b27ea53$exports = {};

$168312580b27ea53$exports = (parcelRequire("Sohz8"));


'use strict';
var $1ead49884bf20dde$exports = {};

var $2bfPH = parcelRequire("2bfPH");
'use strict';
var $1ead49884bf20dde$var$check = function check(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$1ead49884bf20dde$exports = // eslint-disable-next-line es/no-global-this -- safe
$1ead49884bf20dde$var$check((typeof globalThis === "undefined" ? "undefined" : (0, $2bfPH._)(globalThis)) == 'object' && globalThis) || $1ead49884bf20dde$var$check((typeof window === "undefined" ? "undefined" : (0, $2bfPH._)(window)) == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
$1ead49884bf20dde$var$check((typeof self === "undefined" ? "undefined" : (0, $2bfPH._)(self)) == 'object' && self) || $1ead49884bf20dde$var$check((typeof $parcel$global === "undefined" ? "undefined" : (0, $2bfPH._)($parcel$global)) == 'object' && $parcel$global) || $1ead49884bf20dde$var$check((0, $2bfPH._)(undefined) == 'object' && undefined) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function('return this')();


var $0d528644feb97cd1$exports = {};
'use strict';
var $96060468f75fa518$exports = {};
'use strict';
$96060468f75fa518$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$0d528644feb97cd1$exports = !$96060468f75fa518$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function get() {
            return 7;
        }
    })[1] !== 7;
});


var $b189ff7f3b3df88c$exports = {};
'use strict';
var $aebf1e289fcd164b$exports = {};
'use strict';
var $9f41ca860d21cc91$exports = {};
'use strict';
var $2de804e6e0ac4ce5$exports = {};
'use strict';

$2de804e6e0ac4ce5$exports = !$96060468f75fa518$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != 'function' || test.hasOwnProperty('prototype');
});


var $9f41ca860d21cc91$var$FunctionPrototype = Function.prototype;
var $9f41ca860d21cc91$var$call = $9f41ca860d21cc91$var$FunctionPrototype.call;
var $9f41ca860d21cc91$var$uncurryThisWithBind = $2de804e6e0ac4ce5$exports && $9f41ca860d21cc91$var$FunctionPrototype.bind.bind($9f41ca860d21cc91$var$call, $9f41ca860d21cc91$var$call);
$9f41ca860d21cc91$exports = $2de804e6e0ac4ce5$exports ? $9f41ca860d21cc91$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $9f41ca860d21cc91$var$call.apply(fn, arguments);
    };
};



var $949af3bfb22c0f7a$exports = {};
'use strict';
var $dd1230ebf086376e$exports = {};

var $2bfPH = parcelRequire("2bfPH");
'use strict';
var $dd1230ebf086376e$var$documentAll = (typeof document === "undefined" ? "undefined" : (0, $2bfPH._)(document)) == 'object' && document.all;
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var $dd1230ebf086376e$var$IS_HTMLDDA = typeof $dd1230ebf086376e$var$documentAll == 'undefined' && $dd1230ebf086376e$var$documentAll !== undefined;
$dd1230ebf086376e$exports = {
    all: $dd1230ebf086376e$var$documentAll,
    IS_HTMLDDA: $dd1230ebf086376e$var$IS_HTMLDDA
};


var $949af3bfb22c0f7a$var$documentAll = $dd1230ebf086376e$exports.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
$949af3bfb22c0f7a$exports = $dd1230ebf086376e$exports.IS_HTMLDDA ? function(argument) {
    return typeof argument == 'function' || argument === $949af3bfb22c0f7a$var$documentAll;
} : function(argument) {
    return typeof argument == 'function';
};


var $fdeb7b1f575da8bb$exports = {};
'use strict';

var $09cc824a0d5d0975$exports = {};
'use strict';
var $5af9d624af4e6a41$exports = {};
'use strict';
var $58513722d670444b$exports = {};
'use strict';
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$58513722d670444b$exports = function(it) {
    return it === null || it === undefined;
};


var $5af9d624af4e6a41$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$5af9d624af4e6a41$exports = function(it) {
    if ($58513722d670444b$exports(it)) throw new $5af9d624af4e6a41$var$$TypeError("Can't call method on " + it);
    return it;
};


var $09cc824a0d5d0975$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$09cc824a0d5d0975$exports = function(argument) {
    return $09cc824a0d5d0975$var$$Object($5af9d624af4e6a41$exports(argument));
};


var $fdeb7b1f575da8bb$var$hasOwnProperty = $9f41ca860d21cc91$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$fdeb7b1f575da8bb$exports = Object.hasOwn || function hasOwn(it, key) {
    return $fdeb7b1f575da8bb$var$hasOwnProperty($09cc824a0d5d0975$exports(it), key);
};



var $485e4e4dfdefee3a$exports = {};
'use strict';


var $485e4e4dfdefee3a$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $485e4e4dfdefee3a$var$getDescriptor = $0d528644feb97cd1$exports && Object.getOwnPropertyDescriptor;
var $485e4e4dfdefee3a$var$EXISTS = $fdeb7b1f575da8bb$exports($485e4e4dfdefee3a$var$FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var $485e4e4dfdefee3a$var$PROPER = $485e4e4dfdefee3a$var$EXISTS && (function something() {}).name === 'something';
var $485e4e4dfdefee3a$var$CONFIGURABLE = $485e4e4dfdefee3a$var$EXISTS && (!$0d528644feb97cd1$exports || $0d528644feb97cd1$exports && $485e4e4dfdefee3a$var$getDescriptor($485e4e4dfdefee3a$var$FunctionPrototype, 'name').configurable);
$485e4e4dfdefee3a$exports = {
    EXISTS: $485e4e4dfdefee3a$var$EXISTS,
    PROPER: $485e4e4dfdefee3a$var$PROPER,
    CONFIGURABLE: $485e4e4dfdefee3a$var$CONFIGURABLE
};


var $aebf1e289fcd164b$require$CONFIGURABLE_FUNCTION_NAME = $485e4e4dfdefee3a$exports.CONFIGURABLE;
var $50d3870cee9f5e7f$exports = {};
'use strict';


var $fa85345b71b28001$exports = {};
'use strict';

var $e044c5967fffdaf0$exports = {};
'use strict';

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $e044c5967fffdaf0$var$defineProperty = Object.defineProperty;
$e044c5967fffdaf0$exports = function(key, value) {
    try {
        $e044c5967fffdaf0$var$defineProperty($1ead49884bf20dde$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $1ead49884bf20dde$exports[key] = value;
    }
    return value;
};


var $fa85345b71b28001$var$SHARED = '__core-js_shared__';
var $fa85345b71b28001$var$store = $1ead49884bf20dde$exports[$fa85345b71b28001$var$SHARED] || $e044c5967fffdaf0$exports($fa85345b71b28001$var$SHARED, {});
$fa85345b71b28001$exports = $fa85345b71b28001$var$store;


var $50d3870cee9f5e7f$var$functionToString = $9f41ca860d21cc91$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$949af3bfb22c0f7a$exports($fa85345b71b28001$exports.inspectSource)) $fa85345b71b28001$exports.inspectSource = function(it) {
    return $50d3870cee9f5e7f$var$functionToString(it);
};
$50d3870cee9f5e7f$exports = $fa85345b71b28001$exports.inspectSource;


var $b47f30a466c7ec29$exports = {};
'use strict';
var $063bc28a41b3e757$exports = {};
'use strict';


var $063bc28a41b3e757$var$WeakMap = $1ead49884bf20dde$exports.WeakMap;
$063bc28a41b3e757$exports = $949af3bfb22c0f7a$exports($063bc28a41b3e757$var$WeakMap) && /native code/.test(String($063bc28a41b3e757$var$WeakMap));



var $f4b00df85299c602$exports = {};

var $2bfPH = parcelRequire("2bfPH");
'use strict';


var $f4b00df85299c602$var$documentAll = $dd1230ebf086376e$exports.all;
$f4b00df85299c602$exports = $dd1230ebf086376e$exports.IS_HTMLDDA ? function(it) {
    return (typeof it === "undefined" ? "undefined" : (0, $2bfPH._)(it)) == 'object' ? it !== null : $949af3bfb22c0f7a$exports(it) || it === $f4b00df85299c602$var$documentAll;
} : function(it) {
    return (typeof it === "undefined" ? "undefined" : (0, $2bfPH._)(it)) == 'object' ? it !== null : $949af3bfb22c0f7a$exports(it);
};


var $ef5a29b8ab1b6dee$exports = {};
'use strict';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $e8e92a7bc6108450$export$2d1720544b23b823;
'use strict';

var $b8db3aa2b01757aa$exports = {};
'use strict';


var $70d94f3ac3d58fca$exports = {};
'use strict';


var $70d94f3ac3d58fca$var$document = $1ead49884bf20dde$exports.document;
// typeof document.createElement is 'object' in old IE
var $70d94f3ac3d58fca$var$EXISTS = $f4b00df85299c602$exports($70d94f3ac3d58fca$var$document) && $f4b00df85299c602$exports($70d94f3ac3d58fca$var$document.createElement);
$70d94f3ac3d58fca$exports = function(it) {
    return $70d94f3ac3d58fca$var$EXISTS ? $70d94f3ac3d58fca$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$b8db3aa2b01757aa$exports = !$0d528644feb97cd1$exports && !$96060468f75fa518$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($70d94f3ac3d58fca$exports('div'), 'a', {
        get: function get() {
            return 7;
        }
    }).a !== 7;
});


var $cf831b0a8e01c395$exports = {};
'use strict';


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$cf831b0a8e01c395$exports = $0d528644feb97cd1$exports && $96060468f75fa518$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, 'prototype', {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $bd2fa3997a292fd6$exports = {};
'use strict';

var $bd2fa3997a292fd6$var$$String = String;
var $bd2fa3997a292fd6$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$bd2fa3997a292fd6$exports = function(argument) {
    if ($f4b00df85299c602$exports(argument)) return argument;
    throw new $bd2fa3997a292fd6$var$$TypeError($bd2fa3997a292fd6$var$$String(argument) + ' is not an object');
};


var $9eb0acbaca04d410$exports = {};
'use strict';
var $475eb1fef87517f1$exports = {};
'use strict';
var $6802a9e55af5dd5e$exports = {};
'use strict';

var $6802a9e55af5dd5e$var$call = Function.prototype.call;
$6802a9e55af5dd5e$exports = $2de804e6e0ac4ce5$exports ? $6802a9e55af5dd5e$var$call.bind($6802a9e55af5dd5e$var$call) : function() {
    return $6802a9e55af5dd5e$var$call.apply($6802a9e55af5dd5e$var$call, arguments);
};



var $f79d80c605158a45$exports = {};

var $2bfPH = parcelRequire("2bfPH");
'use strict';
var $0e0bb92cd5467db0$exports = {};
'use strict';


var $0e0bb92cd5467db0$var$aFunction = function aFunction(argument) {
    return $949af3bfb22c0f7a$exports(argument) ? argument : undefined;
};
$0e0bb92cd5467db0$exports = function(namespace, method) {
    return arguments.length < 2 ? $0e0bb92cd5467db0$var$aFunction($1ead49884bf20dde$exports[namespace]) : $1ead49884bf20dde$exports[namespace] && $1ead49884bf20dde$exports[namespace][method];
};



var $bf4b11ed93c27c8d$exports = {};
'use strict';

$bf4b11ed93c27c8d$exports = $9f41ca860d21cc91$exports({}.isPrototypeOf);


var $da58d49e8bbaac7b$exports = {};

var $2bfPH = parcelRequire("2bfPH");
'use strict';
var $37c740310667c498$exports = {};
'use strict';
var $7f99271386091bcd$exports = {};
'use strict';

var $ada1c05f5915ea23$exports = {};
'use strict';
$ada1c05f5915ea23$exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';


var $7f99271386091bcd$var$process = $1ead49884bf20dde$exports.process;
var $7f99271386091bcd$var$Deno = $1ead49884bf20dde$exports.Deno;
var $7f99271386091bcd$var$versions = $7f99271386091bcd$var$process && $7f99271386091bcd$var$process.versions || $7f99271386091bcd$var$Deno && $7f99271386091bcd$var$Deno.version;
var $7f99271386091bcd$var$v8 = $7f99271386091bcd$var$versions && $7f99271386091bcd$var$versions.v8;
var $7f99271386091bcd$var$match, $7f99271386091bcd$var$version;
if ($7f99271386091bcd$var$v8) {
    $7f99271386091bcd$var$match = $7f99271386091bcd$var$v8.split('.');
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $7f99271386091bcd$var$version = $7f99271386091bcd$var$match[0] > 0 && $7f99271386091bcd$var$match[0] < 4 ? 1 : +($7f99271386091bcd$var$match[0] + $7f99271386091bcd$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$7f99271386091bcd$var$version && $ada1c05f5915ea23$exports) {
    $7f99271386091bcd$var$match = $ada1c05f5915ea23$exports.match(/Edge\/(\d+)/);
    if (!$7f99271386091bcd$var$match || $7f99271386091bcd$var$match[1] >= 74) {
        $7f99271386091bcd$var$match = $ada1c05f5915ea23$exports.match(/Chrome\/(\d+)/);
        if ($7f99271386091bcd$var$match) $7f99271386091bcd$var$version = +$7f99271386091bcd$var$match[1];
    }
}
$7f99271386091bcd$exports = $7f99271386091bcd$var$version;




var $37c740310667c498$var$$String = $1ead49884bf20dde$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$37c740310667c498$exports = !!Object.getOwnPropertySymbols && !$96060468f75fa518$exports(function() {
    var symbol = Symbol('symbol detection');
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$37c740310667c498$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $7f99271386091bcd$exports && $7f99271386091bcd$exports < 41;
});


$da58d49e8bbaac7b$exports = $37c740310667c498$exports && !Symbol.sham && (0, $2bfPH._)(Symbol.iterator) == 'symbol';


var $f79d80c605158a45$var$$Object = Object;
$f79d80c605158a45$exports = $da58d49e8bbaac7b$exports ? function(it) {
    return (typeof it === "undefined" ? "undefined" : (0, $2bfPH._)(it)) == 'symbol';
} : function(it) {
    var $Symbol = $0e0bb92cd5467db0$exports('Symbol');
    return $949af3bfb22c0f7a$exports($Symbol) && $bf4b11ed93c27c8d$exports($Symbol.prototype, $f79d80c605158a45$var$$Object(it));
};


var $5f99e5864ea661ef$exports = {};
'use strict';
var $bd0ebcdc318fde38$exports = {};
'use strict';

var $9c373a1bb870a4bd$exports = {};
'use strict';
var $9c373a1bb870a4bd$var$$String = String;
$9c373a1bb870a4bd$exports = function(argument) {
    try {
        return $9c373a1bb870a4bd$var$$String(argument);
    } catch (error) {
        return 'Object';
    }
};


var $bd0ebcdc318fde38$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$bd0ebcdc318fde38$exports = function(argument) {
    if ($949af3bfb22c0f7a$exports(argument)) return argument;
    throw new $bd0ebcdc318fde38$var$$TypeError($9c373a1bb870a4bd$exports(argument) + ' is not a function');
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$5f99e5864ea661ef$exports = function(V, P) {
    var func = V[P];
    return $58513722d670444b$exports(func) ? undefined : $bd0ebcdc318fde38$exports(func);
};


var $00254e4191a29567$exports = {};
'use strict';



var $00254e4191a29567$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$00254e4191a29567$exports = function(input, pref) {
    var fn, val;
    if (pref === 'string' && $949af3bfb22c0f7a$exports(fn = input.toString) && !$f4b00df85299c602$exports(val = $6802a9e55af5dd5e$exports(fn, input))) return val;
    if ($949af3bfb22c0f7a$exports(fn = input.valueOf) && !$f4b00df85299c602$exports(val = $6802a9e55af5dd5e$exports(fn, input))) return val;
    if (pref !== 'string' && $949af3bfb22c0f7a$exports(fn = input.toString) && !$f4b00df85299c602$exports(val = $6802a9e55af5dd5e$exports(fn, input))) return val;
    throw new $00254e4191a29567$var$$TypeError("Can't convert object to primitive value");
};


var $9329e43f362edb15$exports = {};
'use strict';

var $137d6b181aa668de$exports = {};
'use strict';
var $d8f1ba9794a0dcec$exports = {};
'use strict';
$d8f1ba9794a0dcec$exports = false;



($137d6b181aa668de$exports = function(key, value) {
    return $fa85345b71b28001$exports[key] || ($fa85345b71b28001$exports[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: '3.33.3',
    mode: $d8f1ba9794a0dcec$exports ? 'pure' : 'global',
    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
    license: 'https://github.com/zloirock/core-js/blob/v3.33.3/LICENSE',
    source: 'https://github.com/zloirock/core-js'
});



var $6941d29bd8ecdc7a$exports = {};
'use strict';

var $6941d29bd8ecdc7a$var$id = 0;
var $6941d29bd8ecdc7a$var$postfix = Math.random();
var $6941d29bd8ecdc7a$var$toString = $9f41ca860d21cc91$exports(1.0.toString);
$6941d29bd8ecdc7a$exports = function(key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + $6941d29bd8ecdc7a$var$toString(++$6941d29bd8ecdc7a$var$id + $6941d29bd8ecdc7a$var$postfix, 36);
};




var $9329e43f362edb15$var$Symbol = $1ead49884bf20dde$exports.Symbol;
var $9329e43f362edb15$var$WellKnownSymbolsStore = $137d6b181aa668de$exports('wks');
var $9329e43f362edb15$var$createWellKnownSymbol = $da58d49e8bbaac7b$exports ? $9329e43f362edb15$var$Symbol['for'] || $9329e43f362edb15$var$Symbol : $9329e43f362edb15$var$Symbol && $9329e43f362edb15$var$Symbol.withoutSetter || $6941d29bd8ecdc7a$exports;
$9329e43f362edb15$exports = function(name) {
    if (!$fdeb7b1f575da8bb$exports($9329e43f362edb15$var$WellKnownSymbolsStore, name)) $9329e43f362edb15$var$WellKnownSymbolsStore[name] = $37c740310667c498$exports && $fdeb7b1f575da8bb$exports($9329e43f362edb15$var$Symbol, name) ? $9329e43f362edb15$var$Symbol[name] : $9329e43f362edb15$var$createWellKnownSymbol('Symbol.' + name);
    return $9329e43f362edb15$var$WellKnownSymbolsStore[name];
};


var $475eb1fef87517f1$var$$TypeError = TypeError;
var $475eb1fef87517f1$var$TO_PRIMITIVE = $9329e43f362edb15$exports('toPrimitive');
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$475eb1fef87517f1$exports = function(input, pref) {
    if (!$f4b00df85299c602$exports(input) || $f79d80c605158a45$exports(input)) return input;
    var exoticToPrim = $5f99e5864ea661ef$exports(input, $475eb1fef87517f1$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = $6802a9e55af5dd5e$exports(exoticToPrim, input, pref);
        if (!$f4b00df85299c602$exports(result) || $f79d80c605158a45$exports(result)) return result;
        throw new $475eb1fef87517f1$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = 'number';
    return $00254e4191a29567$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$9eb0acbaca04d410$exports = function(argument) {
    var key = $475eb1fef87517f1$exports(argument, 'string');
    return $f79d80c605158a45$exports(key) ? key : key + '';
};


var $e8e92a7bc6108450$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $e8e92a7bc6108450$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $e8e92a7bc6108450$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $e8e92a7bc6108450$var$ENUMERABLE = 'enumerable';
var $e8e92a7bc6108450$var$CONFIGURABLE = 'configurable';
var $e8e92a7bc6108450$var$WRITABLE = 'writable';
$e8e92a7bc6108450$export$2d1720544b23b823 = $0d528644feb97cd1$exports ? $cf831b0a8e01c395$exports ? function defineProperty(O, P, Attributes) {
    $bd2fa3997a292fd6$exports(O);
    P = $9eb0acbaca04d410$exports(P);
    $bd2fa3997a292fd6$exports(Attributes);
    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && $e8e92a7bc6108450$var$WRITABLE in Attributes && !Attributes[$e8e92a7bc6108450$var$WRITABLE]) {
        var current = $e8e92a7bc6108450$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$e8e92a7bc6108450$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $e8e92a7bc6108450$var$CONFIGURABLE in Attributes ? Attributes[$e8e92a7bc6108450$var$CONFIGURABLE] : current[$e8e92a7bc6108450$var$CONFIGURABLE],
                enumerable: $e8e92a7bc6108450$var$ENUMERABLE in Attributes ? Attributes[$e8e92a7bc6108450$var$ENUMERABLE] : current[$e8e92a7bc6108450$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $e8e92a7bc6108450$var$$defineProperty(O, P, Attributes);
} : $e8e92a7bc6108450$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $bd2fa3997a292fd6$exports(O);
    P = $9eb0acbaca04d410$exports(P);
    $bd2fa3997a292fd6$exports(Attributes);
    if ($b8db3aa2b01757aa$exports) try {
        return $e8e92a7bc6108450$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw new $e8e92a7bc6108450$var$$TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};


var $ba72b26e724aa12a$exports = {};
'use strict';
$ba72b26e724aa12a$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


$ef5a29b8ab1b6dee$exports = $0d528644feb97cd1$exports ? function(object, key, value) {
    return $e8e92a7bc6108450$export$2d1720544b23b823(object, key, $ba72b26e724aa12a$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};




var $5dece42ead086f46$exports = {};
'use strict';


var $5dece42ead086f46$var$keys = $137d6b181aa668de$exports('keys');
$5dece42ead086f46$exports = function(key) {
    return $5dece42ead086f46$var$keys[key] || ($5dece42ead086f46$var$keys[key] = $6941d29bd8ecdc7a$exports(key));
};


var $33a6c22af1cafc53$exports = {};
'use strict';
$33a6c22af1cafc53$exports = {};


var $b47f30a466c7ec29$var$OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var $b47f30a466c7ec29$var$TypeError = $1ead49884bf20dde$exports.TypeError;
var $b47f30a466c7ec29$var$WeakMap = $1ead49884bf20dde$exports.WeakMap;
var $b47f30a466c7ec29$var$set, $b47f30a466c7ec29$var$get, $b47f30a466c7ec29$var$has;
var $b47f30a466c7ec29$var$enforce = function enforce(it) {
    return $b47f30a466c7ec29$var$has(it) ? $b47f30a466c7ec29$var$get(it) : $b47f30a466c7ec29$var$set(it, {});
};
var $b47f30a466c7ec29$var$getterFor = function getterFor(TYPE) {
    return function(it) {
        var state;
        if (!$f4b00df85299c602$exports(it) || (state = $b47f30a466c7ec29$var$get(it)).type !== TYPE) throw new $b47f30a466c7ec29$var$TypeError('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if ($063bc28a41b3e757$exports || $fa85345b71b28001$exports.state) {
    var $b47f30a466c7ec29$var$store = $fa85345b71b28001$exports.state || ($fa85345b71b28001$exports.state = new $b47f30a466c7ec29$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $b47f30a466c7ec29$var$store.get = $b47f30a466c7ec29$var$store.get;
    $b47f30a466c7ec29$var$store.has = $b47f30a466c7ec29$var$store.has;
    $b47f30a466c7ec29$var$store.set = $b47f30a466c7ec29$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $b47f30a466c7ec29$var$set = function set(it, metadata) {
        if ($b47f30a466c7ec29$var$store.has(it)) throw new $b47f30a466c7ec29$var$TypeError($b47f30a466c7ec29$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $b47f30a466c7ec29$var$store.set(it, metadata);
        return metadata;
    };
    $b47f30a466c7ec29$var$get = function get(it) {
        return $b47f30a466c7ec29$var$store.get(it) || {};
    };
    $b47f30a466c7ec29$var$has = function has(it) {
        return $b47f30a466c7ec29$var$store.has(it);
    };
} else {
    var $b47f30a466c7ec29$var$STATE = $5dece42ead086f46$exports('state');
    $33a6c22af1cafc53$exports[$b47f30a466c7ec29$var$STATE] = true;
    $b47f30a466c7ec29$var$set = function set(it, metadata) {
        if ($fdeb7b1f575da8bb$exports(it, $b47f30a466c7ec29$var$STATE)) throw new $b47f30a466c7ec29$var$TypeError($b47f30a466c7ec29$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $ef5a29b8ab1b6dee$exports(it, $b47f30a466c7ec29$var$STATE, metadata);
        return metadata;
    };
    $b47f30a466c7ec29$var$get = function get(it) {
        return $fdeb7b1f575da8bb$exports(it, $b47f30a466c7ec29$var$STATE) ? it[$b47f30a466c7ec29$var$STATE] : {};
    };
    $b47f30a466c7ec29$var$has = function has(it) {
        return $fdeb7b1f575da8bb$exports(it, $b47f30a466c7ec29$var$STATE);
    };
}
$b47f30a466c7ec29$exports = {
    set: $b47f30a466c7ec29$var$set,
    get: $b47f30a466c7ec29$var$get,
    has: $b47f30a466c7ec29$var$has,
    enforce: $b47f30a466c7ec29$var$enforce,
    getterFor: $b47f30a466c7ec29$var$getterFor
};


var $aebf1e289fcd164b$var$enforceInternalState = $b47f30a466c7ec29$exports.enforce;
var $aebf1e289fcd164b$var$getInternalState = $b47f30a466c7ec29$exports.get;
var $aebf1e289fcd164b$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $aebf1e289fcd164b$var$defineProperty = Object.defineProperty;
var $aebf1e289fcd164b$var$stringSlice = $9f41ca860d21cc91$exports(''.slice);
var $aebf1e289fcd164b$var$replace = $9f41ca860d21cc91$exports(''.replace);
var $aebf1e289fcd164b$var$join = $9f41ca860d21cc91$exports([].join);
var $aebf1e289fcd164b$var$CONFIGURABLE_LENGTH = $0d528644feb97cd1$exports && !$96060468f75fa518$exports(function() {
    return $aebf1e289fcd164b$var$defineProperty(function() {}, 'length', {
        value: 8
    }).length !== 8;
});
var $aebf1e289fcd164b$var$TEMPLATE = String(String).split('String');
var $aebf1e289fcd164b$var$makeBuiltIn = $aebf1e289fcd164b$exports = function makeBuiltIn(value, name, options) {
    if ($aebf1e289fcd164b$var$stringSlice($aebf1e289fcd164b$var$$String(name), 0, 7) === 'Symbol(') name = '[' + $aebf1e289fcd164b$var$replace($aebf1e289fcd164b$var$$String(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
    if (options && options.getter) name = 'get ' + name;
    if (options && options.setter) name = 'set ' + name;
    if (!$fdeb7b1f575da8bb$exports(value, 'name') || $aebf1e289fcd164b$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($0d528644feb97cd1$exports) $aebf1e289fcd164b$var$defineProperty(value, 'name', {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($aebf1e289fcd164b$var$CONFIGURABLE_LENGTH && options && $fdeb7b1f575da8bb$exports(options, 'arity') && value.length !== options.arity) $aebf1e289fcd164b$var$defineProperty(value, 'length', {
        value: options.arity
    });
    try {
        if (options && $fdeb7b1f575da8bb$exports(options, 'constructor') && options.constructor) {
            if ($0d528644feb97cd1$exports) $aebf1e289fcd164b$var$defineProperty(value, 'prototype', {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $aebf1e289fcd164b$var$enforceInternalState(value);
    if (!$fdeb7b1f575da8bb$exports(state, 'source')) state.source = $aebf1e289fcd164b$var$join($aebf1e289fcd164b$var$TEMPLATE, typeof name == 'string' ? name : '');
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $aebf1e289fcd164b$var$makeBuiltIn(function toString() {
    return $949af3bfb22c0f7a$exports(this) && $aebf1e289fcd164b$var$getInternalState(this).source || $50d3870cee9f5e7f$exports(this);
}, 'toString');



$b189ff7f3b3df88c$exports = function(target, name, descriptor) {
    if (descriptor.get) $aebf1e289fcd164b$exports(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $aebf1e289fcd164b$exports(descriptor.set, name, {
        setter: true
    });
    return $e8e92a7bc6108450$export$2d1720544b23b823(target, name, descriptor);
};


var $9b189ab247edc789$exports = {};
'use strict';

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
$9b189ab247edc789$exports = function() {
    var that = $bd2fa3997a292fd6$exports(this);
    var result = '';
    if (that.hasIndices) result += 'd';
    if (that.global) result += 'g';
    if (that.ignoreCase) result += 'i';
    if (that.multiline) result += 'm';
    if (that.dotAll) result += 's';
    if (that.unicode) result += 'u';
    if (that.unicodeSets) result += 'v';
    if (that.sticky) result += 'y';
    return result;
};



// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
var $ac588893180e426a$var$RegExp = $1ead49884bf20dde$exports.RegExp;
var $ac588893180e426a$var$RegExpPrototype = $ac588893180e426a$var$RegExp.prototype;
var $ac588893180e426a$var$FORCED = $0d528644feb97cd1$exports && $96060468f75fa518$exports(function() {
    var INDICES_SUPPORT = true;
    try {
        $ac588893180e426a$var$RegExp('.', 'd');
    } catch (error) {
        INDICES_SUPPORT = false;
    }
    var O = {};
    // modern V8 bug
    var calls = '';
    var expected = INDICES_SUPPORT ? 'dgimsy' : 'gimsy';
    var addGetter = function addGetter(key, chr) {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty(O, key, {
            get: function get() {
                calls += chr;
                return true;
            }
        });
    };
    var pairs = {
        dotAll: 's',
        global: 'g',
        ignoreCase: 'i',
        multiline: 'm',
        sticky: 'y'
    };
    if (INDICES_SUPPORT) pairs.hasIndices = 'd';
    for(var key in pairs)addGetter(key, pairs[key]);
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var result = Object.getOwnPropertyDescriptor($ac588893180e426a$var$RegExpPrototype, 'flags').get.call(O);
    return result !== expected || calls !== expected;
});
// `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
if ($ac588893180e426a$var$FORCED) $b189ff7f3b3df88c$exports($ac588893180e426a$var$RegExpPrototype, 'flags', {
    configurable: true,
    get: $9b189ab247edc789$exports
});


'use strict';
'use strict';
var $96bb668bce359868$exports = {};

var $2bfPH = parcelRequire("2bfPH");
'use strict';

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $71aa77ce3e8adaac$export$2d1720544b23b823;
'use strict';


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $d89ba9b7c3cb9015$export$2d1720544b23b823;
'use strict';
var $d89ba9b7c3cb9015$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $d89ba9b7c3cb9015$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $d89ba9b7c3cb9015$var$NASHORN_BUG = $d89ba9b7c3cb9015$var$getOwnPropertyDescriptor && !$d89ba9b7c3cb9015$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$d89ba9b7c3cb9015$export$2d1720544b23b823 = $d89ba9b7c3cb9015$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $d89ba9b7c3cb9015$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $d89ba9b7c3cb9015$var$$propertyIsEnumerable;



var $a5965fca3692b529$exports = {};
'use strict';
var $85e4084a9434bc7d$exports = {};
'use strict';


var $516745d5e75afd39$exports = {};
'use strict';

var $516745d5e75afd39$var$toString = $9f41ca860d21cc91$exports({}.toString);
var $516745d5e75afd39$var$stringSlice = $9f41ca860d21cc91$exports(''.slice);
$516745d5e75afd39$exports = function(it) {
    return $516745d5e75afd39$var$stringSlice($516745d5e75afd39$var$toString(it), 8, -1);
};


var $85e4084a9434bc7d$var$$Object = Object;
var $85e4084a9434bc7d$var$split = $9f41ca860d21cc91$exports(''.split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$85e4084a9434bc7d$exports = $96060468f75fa518$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$85e4084a9434bc7d$var$$Object('z').propertyIsEnumerable(0);
}) ? function(it) {
    return $516745d5e75afd39$exports(it) === 'String' ? $85e4084a9434bc7d$var$split(it, '') : $85e4084a9434bc7d$var$$Object(it);
} : $85e4084a9434bc7d$var$$Object;



$a5965fca3692b529$exports = function(it) {
    return $85e4084a9434bc7d$exports($5af9d624af4e6a41$exports(it));
};





// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $71aa77ce3e8adaac$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$71aa77ce3e8adaac$export$2d1720544b23b823 = $0d528644feb97cd1$exports ? $71aa77ce3e8adaac$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $a5965fca3692b529$exports(O);
    P = $9eb0acbaca04d410$exports(P);
    if ($b8db3aa2b01757aa$exports) try {
        return $71aa77ce3e8adaac$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($fdeb7b1f575da8bb$exports(O, P)) return $ba72b26e724aa12a$exports(!$6802a9e55af5dd5e$exports($d89ba9b7c3cb9015$export$2d1720544b23b823, O, P), O[P]);
};


var $96bb668bce359868$require$getOwnPropertyDescriptor = $71aa77ce3e8adaac$export$2d1720544b23b823;

var $16751ffca47571bb$exports = {};
'use strict';




$16751ffca47571bb$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($949af3bfb22c0f7a$exports(value)) $aebf1e289fcd164b$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $e044c5967fffdaf0$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $e8e92a7bc6108450$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $35133ac58f23cfb3$exports = {};
'use strict';

var $d7a21b0851510955$exports = {};
'use strict';


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $d117f6558efcc3de$export$2d1720544b23b823;
'use strict';
var $b388f3f4eb3e0f63$exports = {};
'use strict';



var $0de68748265d2ac4$exports = {};
'use strict';

var $e872ce2f1329c90c$exports = {};
'use strict';
var $a8dee6d64032fcca$exports = {};
'use strict';
var $900ff51020c41029$exports = {};
'use strict';
var $900ff51020c41029$var$ceil = Math.ceil;
var $900ff51020c41029$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$900ff51020c41029$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $900ff51020c41029$var$floor : $900ff51020c41029$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$a8dee6d64032fcca$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $900ff51020c41029$exports(number);
};


var $e872ce2f1329c90c$var$max = Math.max;
var $e872ce2f1329c90c$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$e872ce2f1329c90c$exports = function(index, length) {
    var integer = $a8dee6d64032fcca$exports(index);
    return integer < 0 ? $e872ce2f1329c90c$var$max(integer + length, 0) : $e872ce2f1329c90c$var$min(integer, length);
};


var $e7927f66efaf38a1$exports = {};
'use strict';
var $1a9876d681e7c416$exports = {};
'use strict';

var $1a9876d681e7c416$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$1a9876d681e7c416$exports = function(argument) {
    return argument > 0 ? $1a9876d681e7c416$var$min($a8dee6d64032fcca$exports(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$e7927f66efaf38a1$exports = function(obj) {
    return $1a9876d681e7c416$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $0de68748265d2ac4$var$createMethod = function createMethod(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $a5965fca3692b529$exports($this);
        var length = $e7927f66efaf38a1$exports(O);
        var index = $e872ce2f1329c90c$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$0de68748265d2ac4$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $0de68748265d2ac4$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $0de68748265d2ac4$var$createMethod(false)
};


var $b388f3f4eb3e0f63$require$indexOf = $0de68748265d2ac4$exports.indexOf;

var $b388f3f4eb3e0f63$var$push = $9f41ca860d21cc91$exports([].push);
$b388f3f4eb3e0f63$exports = function(object, names) {
    var O = $a5965fca3692b529$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$fdeb7b1f575da8bb$exports($33a6c22af1cafc53$exports, key) && $fdeb7b1f575da8bb$exports(O, key) && $b388f3f4eb3e0f63$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($fdeb7b1f575da8bb$exports(O, key = names[i++])) ~$b388f3f4eb3e0f63$require$indexOf(result, key) || $b388f3f4eb3e0f63$var$push(result, key);
    return result;
};


var $c57cbd544edb5163$exports = {};
'use strict';
// IE8- don't enum bug keys
$c57cbd544edb5163$exports = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];


var $d117f6558efcc3de$var$hiddenKeys = $c57cbd544edb5163$exports.concat('length', 'prototype');
$d117f6558efcc3de$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $b388f3f4eb3e0f63$exports(O, $d117f6558efcc3de$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $53dad536534b6471$export$2d1720544b23b823;
'use strict';
$53dad536534b6471$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $d7a21b0851510955$var$concat = $9f41ca860d21cc91$exports([].concat);
// all object keys, includes non-enumerable and symbols
$d7a21b0851510955$exports = $0e0bb92cd5467db0$exports('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = $d117f6558efcc3de$export$2d1720544b23b823($bd2fa3997a292fd6$exports(it));
    var getOwnPropertySymbols = $53dad536534b6471$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $d7a21b0851510955$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$35133ac58f23cfb3$exports = function(target, source, exceptions) {
    var keys = $d7a21b0851510955$exports(source);
    var defineProperty = $e8e92a7bc6108450$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $71aa77ce3e8adaac$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$fdeb7b1f575da8bb$exports(target, key) && !(exceptions && $fdeb7b1f575da8bb$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $43bfb390c1103106$exports = {};
'use strict';


var $43bfb390c1103106$var$replacement = /#|\.prototype\./;
var $43bfb390c1103106$var$isForced = function isForced(feature, detection) {
    var value = $43bfb390c1103106$var$data[$43bfb390c1103106$var$normalize(feature)];
    return value === $43bfb390c1103106$var$POLYFILL ? true : value === $43bfb390c1103106$var$NATIVE ? false : $949af3bfb22c0f7a$exports(detection) ? $96060468f75fa518$exports(detection) : !!detection;
};
var $43bfb390c1103106$var$normalize = $43bfb390c1103106$var$isForced.normalize = function normalize(string) {
    return String(string).replace($43bfb390c1103106$var$replacement, '.').toLowerCase();
};
var $43bfb390c1103106$var$data = $43bfb390c1103106$var$isForced.data = {};
var $43bfb390c1103106$var$NATIVE = $43bfb390c1103106$var$isForced.NATIVE = 'N';
var $43bfb390c1103106$var$POLYFILL = $43bfb390c1103106$var$isForced.POLYFILL = 'P';
$43bfb390c1103106$exports = $43bfb390c1103106$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $96bb668bce359868$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $1ead49884bf20dde$exports;
    else if (STATIC) target = $1ead49884bf20dde$exports[TARGET] || $e044c5967fffdaf0$exports(TARGET, {});
    else target = ($1ead49884bf20dde$exports[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $96bb668bce359868$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $43bfb390c1103106$exports(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if ((typeof sourceProperty === "undefined" ? "undefined" : (0, $2bfPH._)(sourceProperty)) == (typeof targetProperty === "undefined" ? "undefined" : (0, $2bfPH._)(targetProperty))) continue;
            $35133ac58f23cfb3$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $ef5a29b8ab1b6dee$exports(sourceProperty, 'sham', true);
        $16751ffca47571bb$exports(target, key, sourceProperty, options);
    }
};



var $493eb7b6d60fbac9$exports = {};
'use strict';

var $cbc7689970761cf4$exports = {};

var $2bfPH = parcelRequire("2bfPH");
'use strict';

var $cbc7689970761cf4$var$FunctionPrototype = Function.prototype;
var $cbc7689970761cf4$var$apply = $cbc7689970761cf4$var$FunctionPrototype.apply;
var $cbc7689970761cf4$var$call = $cbc7689970761cf4$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
$cbc7689970761cf4$exports = (typeof Reflect === "undefined" ? "undefined" : (0, $2bfPH._)(Reflect)) == 'object' && Reflect.apply || ($2de804e6e0ac4ce5$exports ? $cbc7689970761cf4$var$call.bind($cbc7689970761cf4$var$apply) : function() {
    return $cbc7689970761cf4$var$call.apply($cbc7689970761cf4$var$apply, arguments);
});


var $e754e499232c5a96$exports = {};
'use strict';
var $e8027c71edc04551$exports = {};
'use strict';


$e8027c71edc04551$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($516745d5e75afd39$exports(fn) === 'Function') return $9f41ca860d21cc91$exports(fn);
};




var $e754e499232c5a96$var$bind = $e8027c71edc04551$exports($e8027c71edc04551$exports.bind);
// optional / simple context binding
$e754e499232c5a96$exports = function(fn, that) {
    $bd0ebcdc318fde38$exports(fn);
    return that === undefined ? fn : $2de804e6e0ac4ce5$exports ? $e754e499232c5a96$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};





var $c8ebed84161beafa$exports = {};
'use strict';

$c8ebed84161beafa$exports = $0e0bb92cd5467db0$exports('document', 'documentElement');


var $84321561e543a7aa$exports = {};
'use strict';

$84321561e543a7aa$exports = $9f41ca860d21cc91$exports([].slice);



var $94588ef997ae0f6e$exports = {};
'use strict';
var $94588ef997ae0f6e$var$$TypeError = TypeError;
$94588ef997ae0f6e$exports = function(passed, required) {
    if (passed < required) throw new $94588ef997ae0f6e$var$$TypeError('Not enough arguments');
    return passed;
};


var $193f88e99e42f7e6$exports = {};
'use strict';

// eslint-disable-next-line redos/no-vulnerable -- safe
$193f88e99e42f7e6$exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($ada1c05f5915ea23$exports);


var $b5b2bbffb72f51f8$exports = {};
'use strict';


$b5b2bbffb72f51f8$exports = $516745d5e75afd39$exports($1ead49884bf20dde$exports.process) === 'process';


var $493eb7b6d60fbac9$var$set = $1ead49884bf20dde$exports.setImmediate;
var $493eb7b6d60fbac9$var$clear = $1ead49884bf20dde$exports.clearImmediate;
var $493eb7b6d60fbac9$var$process = $1ead49884bf20dde$exports.process;
var $493eb7b6d60fbac9$var$Dispatch = $1ead49884bf20dde$exports.Dispatch;
var $493eb7b6d60fbac9$var$Function = $1ead49884bf20dde$exports.Function;
var $493eb7b6d60fbac9$var$MessageChannel = $1ead49884bf20dde$exports.MessageChannel;
var $493eb7b6d60fbac9$var$String = $1ead49884bf20dde$exports.String;
var $493eb7b6d60fbac9$var$counter = 0;
var $493eb7b6d60fbac9$var$queue = {};
var $493eb7b6d60fbac9$var$ONREADYSTATECHANGE = 'onreadystatechange';
var $493eb7b6d60fbac9$var$$location, $493eb7b6d60fbac9$var$defer, $493eb7b6d60fbac9$var$channel, $493eb7b6d60fbac9$var$port;
$96060468f75fa518$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $493eb7b6d60fbac9$var$$location = $1ead49884bf20dde$exports.location;
});
var $493eb7b6d60fbac9$var$run = function run(id) {
    if ($fdeb7b1f575da8bb$exports($493eb7b6d60fbac9$var$queue, id)) {
        var fn = $493eb7b6d60fbac9$var$queue[id];
        delete $493eb7b6d60fbac9$var$queue[id];
        fn();
    }
};
var $493eb7b6d60fbac9$var$runner = function runner(id) {
    return function() {
        $493eb7b6d60fbac9$var$run(id);
    };
};
var $493eb7b6d60fbac9$var$eventListener = function eventListener(event) {
    $493eb7b6d60fbac9$var$run(event.data);
};
var $493eb7b6d60fbac9$var$globalPostMessageDefer = function globalPostMessageDefer(id) {
    // old engines have not location.origin
    $1ead49884bf20dde$exports.postMessage($493eb7b6d60fbac9$var$String(id), $493eb7b6d60fbac9$var$$location.protocol + '//' + $493eb7b6d60fbac9$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$493eb7b6d60fbac9$var$set || !$493eb7b6d60fbac9$var$clear) {
    $493eb7b6d60fbac9$var$set = function setImmediate(handler) {
        $94588ef997ae0f6e$exports(arguments.length, 1);
        var fn = $949af3bfb22c0f7a$exports(handler) ? handler : $493eb7b6d60fbac9$var$Function(handler);
        var args = $84321561e543a7aa$exports(arguments, 1);
        $493eb7b6d60fbac9$var$queue[++$493eb7b6d60fbac9$var$counter] = function() {
            $cbc7689970761cf4$exports(fn, undefined, args);
        };
        $493eb7b6d60fbac9$var$defer($493eb7b6d60fbac9$var$counter);
        return $493eb7b6d60fbac9$var$counter;
    };
    $493eb7b6d60fbac9$var$clear = function clearImmediate(id) {
        delete $493eb7b6d60fbac9$var$queue[id];
    };
    // Node.js 0.8-
    if ($b5b2bbffb72f51f8$exports) $493eb7b6d60fbac9$var$defer = function defer(id) {
        $493eb7b6d60fbac9$var$process.nextTick($493eb7b6d60fbac9$var$runner(id));
    };
    else if ($493eb7b6d60fbac9$var$Dispatch && $493eb7b6d60fbac9$var$Dispatch.now) $493eb7b6d60fbac9$var$defer = function defer(id) {
        $493eb7b6d60fbac9$var$Dispatch.now($493eb7b6d60fbac9$var$runner(id));
    };
    else if ($493eb7b6d60fbac9$var$MessageChannel && !$193f88e99e42f7e6$exports) {
        $493eb7b6d60fbac9$var$channel = new $493eb7b6d60fbac9$var$MessageChannel();
        $493eb7b6d60fbac9$var$port = $493eb7b6d60fbac9$var$channel.port2;
        $493eb7b6d60fbac9$var$channel.port1.onmessage = $493eb7b6d60fbac9$var$eventListener;
        $493eb7b6d60fbac9$var$defer = $e754e499232c5a96$exports($493eb7b6d60fbac9$var$port.postMessage, $493eb7b6d60fbac9$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($1ead49884bf20dde$exports.addEventListener && $949af3bfb22c0f7a$exports($1ead49884bf20dde$exports.postMessage) && !$1ead49884bf20dde$exports.importScripts && $493eb7b6d60fbac9$var$$location && $493eb7b6d60fbac9$var$$location.protocol !== 'file:' && !$96060468f75fa518$exports($493eb7b6d60fbac9$var$globalPostMessageDefer)) {
        $493eb7b6d60fbac9$var$defer = $493eb7b6d60fbac9$var$globalPostMessageDefer;
        $1ead49884bf20dde$exports.addEventListener('message', $493eb7b6d60fbac9$var$eventListener, false);
    // IE8-
    } else if ($493eb7b6d60fbac9$var$ONREADYSTATECHANGE in $70d94f3ac3d58fca$exports('script')) $493eb7b6d60fbac9$var$defer = function defer(id) {
        $c8ebed84161beafa$exports.appendChild($70d94f3ac3d58fca$exports('script'))[$493eb7b6d60fbac9$var$ONREADYSTATECHANGE] = function() {
            $c8ebed84161beafa$exports.removeChild(this);
            $493eb7b6d60fbac9$var$run(id);
        };
    };
    else $493eb7b6d60fbac9$var$defer = function defer(id) {
        setTimeout($493eb7b6d60fbac9$var$runner(id), 0);
    };
}
$493eb7b6d60fbac9$exports = {
    set: $493eb7b6d60fbac9$var$set,
    clear: $493eb7b6d60fbac9$var$clear
};


var $81b81c476fd9eea2$require$clearImmediate = $493eb7b6d60fbac9$exports.clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$96bb668bce359868$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $1ead49884bf20dde$exports.clearImmediate !== $81b81c476fd9eea2$require$clearImmediate
}, {
    clearImmediate: $81b81c476fd9eea2$require$clearImmediate
});


'use strict';



var $a245e4cc4fc9cf23$require$setTask = $493eb7b6d60fbac9$exports.set;
var $1a534060f473de4f$exports = {};
'use strict';



var $7c77b73c6c4f683a$exports = {};
'use strict';
/* global Bun -- Bun case */ $7c77b73c6c4f683a$exports = typeof Bun == 'function' && Bun && typeof Bun.version == 'string';





var $1a534060f473de4f$var$Function = $1ead49884bf20dde$exports.Function;
// dirty IE9- and Bun 0.3.0- checks
var $1a534060f473de4f$var$WRAP = /MSIE .\./.test($ada1c05f5915ea23$exports) || $7c77b73c6c4f683a$exports && function() {
    var version = $1ead49884bf20dde$exports.Bun.version.split('.');
    return version.length < 3 || version[0] === '0' && (version[1] < 3 || version[1] === '3' && version[2] === '0');
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
$1a534060f473de4f$exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $1a534060f473de4f$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $94588ef997ae0f6e$exports(arguments.length, 1) > firstParamIndex;
        var fn = $949af3bfb22c0f7a$exports(handler) ? handler : $1a534060f473de4f$var$Function(handler);
        var params = boundArgs ? $84321561e543a7aa$exports(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function callback() {
            $cbc7689970761cf4$exports(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};


// https://github.com/oven-sh/bun/issues/1633
var $a245e4cc4fc9cf23$var$setImmediate = $1ead49884bf20dde$exports.setImmediate ? $1a534060f473de4f$exports($a245e4cc4fc9cf23$require$setTask, false) : $a245e4cc4fc9cf23$require$setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$96bb668bce359868$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $1ead49884bf20dde$exports.setImmediate !== $a245e4cc4fc9cf23$var$setImmediate
}, {
    setImmediate: $a245e4cc4fc9cf23$var$setImmediate
});





var $1Mz1E = parcelRequire("1Mz1E");

var $21h22 = parcelRequire("21h22");

var $6zk1M = parcelRequire("6zk1M");

var $iLZuz = parcelRequire("iLZuz");
var $326dc9ed303f2323$exports = {};

$326dc9ed303f2323$exports = (parcelRequire("aQ3l1"));


var $20e5c9c200d6533f$exports = {};

$20e5c9c200d6533f$exports = (parcelRequire("a1Gfq"));


var $3a47f8c3e8d7e9c8$exports = {};

$3a47f8c3e8d7e9c8$exports = (parcelRequire("iBHH7"));


var $9b80a5bab44f198e$exports = {};

$9b80a5bab44f198e$exports = (parcelRequire("d9pBi"));


var $751050c55dbce8e1$exports = {};

$751050c55dbce8e1$exports = (parcelRequire("gbqmo"));




var $2953d2395b4d6651$exports = {};

$2953d2395b4d6651$exports = (parcelRequire("d21fN"));



var $21h22 = parcelRequire("21h22");

var $6zk1M = parcelRequire("6zk1M");

var $2bfPH = parcelRequire("2bfPH");
'use strict';
function $1b1301b4e217f9ec$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
var $3a4de46bd2d3d207$var$toString = Object.prototype.toString;
var $3a4de46bd2d3d207$var$getPrototypeOf = Object.getPrototypeOf;
var $3a4de46bd2d3d207$var$iterator = Symbol.iterator, $3a4de46bd2d3d207$var$toStringTag = Symbol.toStringTag;
/* Creating a function that will check if an object has a property. */ var $3a4de46bd2d3d207$var$hasOwnProperty = function(param) {
    var hasOwnProperty = param.hasOwnProperty;
    return function(obj, prop) {
        return hasOwnProperty.call(obj, prop);
    };
}(Object.prototype);
var $3a4de46bd2d3d207$var$isUnsafeObjectKey = function(prop) {
    return typeof prop === 'string' && (prop === '__proto__' || prop === 'constructor' || prop === 'prototype');
};
/**
 * Determine whether an inherited object must be treated as a shared-prototype
 * boundary. Cross-realm Object.prototype objects cannot be distinguished
 * reliably from application-created null-prototype objects because their
 * properties are mutable, so all inherited terminal prototypes are excluded
 * as a fail-closed boundary. A null-prototype source still keeps its own
 * properties, as produced by mergeConfig and other safe materialization paths.
 *
 * @param {*} obj The object to inspect
 * @param {*} prototype The object's prototype
 * @param {boolean} source Whether obj is the original traversal source
 *
 * @returns {boolean} True when obj is a safe prototype traversal boundary
 */ var $3a4de46bd2d3d207$var$isPrototypeBoundary = function(obj, prototype, source) {
    return obj === Object.prototype || !source && prototype === null;
};
/**
 * Determine whether an object can retain its identity through code paths that
 * add, replace, and remove config properties without bypassing unsafe-key
 * filtering. Immutable objects, unsafe-key-bearing objects, and objects with
 * accessor or restricted data properties must be materialized instead.
 *
 * @param {*} obj The object to inspect
 *
 * @returns {boolean} True when every own property is safe and fully mutable
 */ var $3a4de46bd2d3d207$var$isSafeAndFullyMutable = function(obj) {
    var _props;
    if (!Object.isExtensible(obj)) return false;
    var props = Object.getOwnPropertyNames(obj);
    if (Object.getOwnPropertySymbols) (_props = props).push.apply(_props, (0, $6zk1M._)(Object.getOwnPropertySymbols(obj)));
    return props.every(function(prop) {
        if ($3a4de46bd2d3d207$var$isUnsafeObjectKey(prop)) return false;
        var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
        return !!descriptor && descriptor.configurable && descriptor.writable === true;
    });
};
/**
 * Walk the prototype chain (excluding the source realm's Object.prototype)
 * looking for an own `prop`. This distinguishes genuine own/inherited members
 * — including class accessors and template prototypes — from members injected
 * via Object.prototype pollution (e.g. `Object.prototype.username = '...'`),
 * which live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ var $3a4de46bd2d3d207$var$hasOwnInPrototypeChain = function(thing, prop) {
    var obj = thing;
    var seen = [];
    while(obj != null){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        var prototype = $3a4de46bd2d3d207$var$getPrototypeOf(obj);
        if ($3a4de46bd2d3d207$var$isPrototypeBoundary(obj, prototype, obj === thing)) return false;
        if ($3a4de46bd2d3d207$var$hasOwnProperty(obj, prop)) return true;
        obj = prototype;
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ var $3a4de46bd2d3d207$var$getSafeProp = function(obj, prop) {
    return obj != null && $3a4de46bd2d3d207$var$hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
};
/**
 * Flatten an object and its application-defined prototype chain into a
 * null-prototype object. Members inherited only from the source realm's
 * Object.prototype are deliberately excluded, while class/template members
 * below that boundary are preserved.
 *
 * @param {*} thing The value to flatten
 *
 * @returns {*} A null-prototype copy, or the original value when it is already
 * structurally safe or is not an object
 */ var $3a4de46bd2d3d207$var$toSafeFlatObject = function(thing) {
    if (thing == null || (typeof thing === "undefined" ? "undefined" : (0, $2bfPH._)(thing)) !== 'object' && typeof thing !== 'function') return thing;
    var sourcePrototype = $3a4de46bd2d3d207$var$getPrototypeOf(thing);
    if (sourcePrototype === null && $3a4de46bd2d3d207$var$isSafeAndFullyMutable(thing)) return thing;
    var result = Object.create(null);
    var merged = Object.create(null);
    var seen = [];
    var current = thing;
    while(current != null){
        var _props;
        if (seen.indexOf(current) !== -1) break;
        seen.push(current);
        var prototype = current === thing ? sourcePrototype : $3a4de46bd2d3d207$var$getPrototypeOf(current);
        if ($3a4de46bd2d3d207$var$isPrototypeBoundary(current, prototype, current === thing)) break;
        var props = Object.getOwnPropertyNames(current);
        if (Object.getOwnPropertySymbols) (_props = props).push.apply(_props, (0, $6zk1M._)(Object.getOwnPropertySymbols(current)));
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = props[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var prop = _step.value;
                if ($3a4de46bd2d3d207$var$isUnsafeObjectKey(prop)) continue;
                if (!$3a4de46bd2d3d207$var$hasOwnProperty(merged, prop)) {
                    result[prop] = thing[prop];
                    merged[prop] = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        current = prototype;
    }
    return result;
};
var $3a4de46bd2d3d207$var$kindOf = function(cache) {
    return function(thing) {
        var str = $3a4de46bd2d3d207$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
}(Object.create(null));
var $3a4de46bd2d3d207$var$kindOfTest = function(type) {
    type = type.toLowerCase();
    return function(thing) {
        return $3a4de46bd2d3d207$var$kindOf(thing) === type;
    };
};
var $3a4de46bd2d3d207$var$typeOfTest = function(type) {
    return function(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, $2bfPH._)(thing)) === type;
    };
};
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ var $3a4de46bd2d3d207$var$isArray = Array.isArray;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ var $3a4de46bd2d3d207$var$isUndefined = $3a4de46bd2d3d207$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $3a4de46bd2d3d207$var$isBuffer(val) {
    return val !== null && !$3a4de46bd2d3d207$var$isUndefined(val) && val.constructor !== null && !$3a4de46bd2d3d207$var$isUndefined(val.constructor) && $3a4de46bd2d3d207$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ var $3a4de46bd2d3d207$var$isArrayBuffer = $3a4de46bd2d3d207$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $3a4de46bd2d3d207$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $3a4de46bd2d3d207$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ var $3a4de46bd2d3d207$var$isString = $3a4de46bd2d3d207$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ var $3a4de46bd2d3d207$var$isFunction = $3a4de46bd2d3d207$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ var $3a4de46bd2d3d207$var$isNumber = $3a4de46bd2d3d207$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ var $3a4de46bd2d3d207$var$isObject = function(thing) {
    return thing !== null && (typeof thing === "undefined" ? "undefined" : (0, $2bfPH._)(thing)) === 'object';
};
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ var $3a4de46bd2d3d207$var$isBoolean = function(thing) {
    return thing === true || thing === false;
};
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ var $3a4de46bd2d3d207$var$isPlainObject = function(val) {
    if (!$3a4de46bd2d3d207$var$isObject(val)) return false;
    var prototype = $3a4de46bd2d3d207$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || $3a4de46bd2d3d207$var$getPrototypeOf(prototype) === null) && // Treat safe own/inherited Symbol.toStringTag or Symbol.iterator members as
    // evidence the value is tagged/iterable, while ignoring members reachable
    // only through shared or terminal prototype boundaries.
    !$3a4de46bd2d3d207$var$hasOwnInPrototypeChain(val, $3a4de46bd2d3d207$var$toStringTag) && !$3a4de46bd2d3d207$var$hasOwnInPrototypeChain(val, $3a4de46bd2d3d207$var$iterator);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ var $3a4de46bd2d3d207$var$isEmptyObject = function(val) {
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$3a4de46bd2d3d207$var$isObject(val) || $3a4de46bd2d3d207$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ var $3a4de46bd2d3d207$var$isDate = $3a4de46bd2d3d207$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ var $3a4de46bd2d3d207$var$isFile = $3a4de46bd2d3d207$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ var $3a4de46bd2d3d207$var$isReactNativeBlob = function(value) {
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ var $3a4de46bd2d3d207$var$isReactNative = function(formData) {
    return formData && typeof formData.getParts !== 'undefined';
};
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ var $3a4de46bd2d3d207$var$isBlob = $3a4de46bd2d3d207$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ var $3a4de46bd2d3d207$var$isFileList = $3a4de46bd2d3d207$var$kindOfTest('FileList');
var $3a4de46bd2d3d207$var$isSet = $3a4de46bd2d3d207$var$kindOfTest('Set');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ var $3a4de46bd2d3d207$var$isStream = function(val) {
    return $3a4de46bd2d3d207$var$isObject(val) && $3a4de46bd2d3d207$var$isFunction(val.pipe);
};
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $3a4de46bd2d3d207$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
var $3a4de46bd2d3d207$var$G = $3a4de46bd2d3d207$var$getGlobal();
var $3a4de46bd2d3d207$var$FormDataCtor = typeof $3a4de46bd2d3d207$var$G.FormData !== 'undefined' ? $3a4de46bd2d3d207$var$G.FormData : undefined;
var $3a4de46bd2d3d207$var$isFormData = function(thing) {
    if (!thing) return false;
    if ($3a4de46bd2d3d207$var$FormDataCtor && thing instanceof $3a4de46bd2d3d207$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    var proto = $3a4de46bd2d3d207$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$3a4de46bd2d3d207$var$isFunction(thing.append)) return false;
    var kind = $3a4de46bd2d3d207$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $3a4de46bd2d3d207$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ var $3a4de46bd2d3d207$var$isURLSearchParams = $3a4de46bd2d3d207$var$kindOfTest('URLSearchParams');
var $3a4de46bd2d3d207$var$_map = (0, $21h22._)([
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($3a4de46bd2d3d207$var$kindOfTest), 4), $3a4de46bd2d3d207$var$isReadableStream = $3a4de46bd2d3d207$var$_map[0], $3a4de46bd2d3d207$var$isRequest = $3a4de46bd2d3d207$var$_map[1], $3a4de46bd2d3d207$var$isResponse = $3a4de46bd2d3d207$var$_map[2], $3a4de46bd2d3d207$var$isHeaders = $3a4de46bd2d3d207$var$_map[3];
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ var $3a4de46bd2d3d207$var$trim = function(str) {
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $3a4de46bd2d3d207$var$forEach(obj, fn) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_allOwnKeys = _ref.allOwnKeys, allOwnKeys = _ref_allOwnKeys === void 0 ? false : _ref_allOwnKeys;
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    var i;
    var l;
    // Force an array if not already something iterable
    if ((typeof obj === "undefined" ? "undefined" : (0, $2bfPH._)(obj)) !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($3a4de46bd2d3d207$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($3a4de46bd2d3d207$var$isBuffer(obj)) return;
        // Iterate over object keys
        var keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        var len = keys.length;
        var key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $3a4de46bd2d3d207$var$findKey(obj, key) {
    if ($3a4de46bd2d3d207$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    var keys = Object.keys(obj);
    var i = keys.length;
    var _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
var $3a4de46bd2d3d207$var$_global = function() {
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
}();
var $3a4de46bd2d3d207$var$isContextDefined = function(context) {
    return !$3a4de46bd2d3d207$var$isUndefined(context) && context !== $3a4de46bd2d3d207$var$_global;
};
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $3a4de46bd2d3d207$var$merge() {
    for(var _len = arguments.length, objs = new Array(_len), _key = 0; _key < _len; _key++){
        objs[_key] = arguments[_key];
    }
    var _ref = $3a4de46bd2d3d207$var$isContextDefined(this) && this || {}, caseless = _ref.caseless, skipUndefined = _ref.skipUndefined;
    var result = {};
    var assignValue = function(val, key) {
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        var targetKey = caseless && typeof key === 'string' && $3a4de46bd2d3d207$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        var existing = $3a4de46bd2d3d207$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($3a4de46bd2d3d207$var$isPlainObject(existing) && $3a4de46bd2d3d207$var$isPlainObject(val)) result[targetKey] = $3a4de46bd2d3d207$var$merge(existing, val);
        else if ($3a4de46bd2d3d207$var$isPlainObject(val)) result[targetKey] = $3a4de46bd2d3d207$var$merge({}, val);
        else if ($3a4de46bd2d3d207$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$3a4de46bd2d3d207$var$isUndefined(val)) result[targetKey] = val;
    };
    for(var i = 0, l = objs.length; i < l; i++){
        var source = objs[i];
        if (!source || $3a4de46bd2d3d207$var$isBuffer(source)) continue;
        $3a4de46bd2d3d207$var$forEach(source, assignValue);
        if ((typeof source === "undefined" ? "undefined" : (0, $2bfPH._)(source)) !== 'object' || $3a4de46bd2d3d207$var$isArray(source)) continue;
        var symbols = Object.getOwnPropertySymbols(source);
        for(var j = 0; j < symbols.length; j++){
            var symbol = symbols[j];
            if ($3a4de46bd2d3d207$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ var $3a4de46bd2d3d207$var$extend = function(a, b, thisArg) {
    var allOwnKeys = (arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}).allOwnKeys;
    $3a4de46bd2d3d207$var$forEach(b, function(val, key) {
        if (thisArg && $3a4de46bd2d3d207$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $1b1301b4e217f9ec$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ var $3a4de46bd2d3d207$var$stripBOM = function(content) {
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ var $3a4de46bd2d3d207$var$inherits = function(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ var $3a4de46bd2d3d207$var$toFlatObject = function(sourceObj, destObj, filter, propFilter) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $3a4de46bd2d3d207$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ var $3a4de46bd2d3d207$var$endsWith = function(str, searchString, position) {
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    var lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ var $3a4de46bd2d3d207$var$toArray = function(thing) {
    if (!thing) return null;
    if ($3a4de46bd2d3d207$var$isArray(thing)) return thing;
    var i = thing.length;
    if (!$3a4de46bd2d3d207$var$isNumber(i)) return null;
    var arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
var $3a4de46bd2d3d207$var$isTypedArray = function(TypedArray) {
    // eslint-disable-next-line func-names
    return function(thing) {
        return TypedArray && thing instanceof TypedArray;
    };
}(typeof Uint8Array !== 'undefined' && $3a4de46bd2d3d207$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ var $3a4de46bd2d3d207$var$forEachEntry = function(obj, fn) {
    var generator = obj && obj[$3a4de46bd2d3d207$var$iterator];
    var _iterator = generator.call(obj);
    var result;
    while((result = _iterator.next()) && !result.done){
        var pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ var $3a4de46bd2d3d207$var$matchAll = function(regExp, str) {
    var matches;
    var arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ var $3a4de46bd2d3d207$var$isHTMLForm = $3a4de46bd2d3d207$var$kindOfTest('HTMLFormElement');
var $3a4de46bd2d3d207$var$toCamelCase = function(str) {
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
var $3a4de46bd2d3d207$var$propertyIsEnumerable = Object.prototype.propertyIsEnumerable;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ var $3a4de46bd2d3d207$var$isRegExp = $3a4de46bd2d3d207$var$kindOfTest('RegExp');
var $3a4de46bd2d3d207$var$reduceDescriptors = function(obj, reducer) {
    var descriptors = Object.getOwnPropertyDescriptors(obj);
    var reducedDescriptors = {};
    $3a4de46bd2d3d207$var$forEach(descriptors, function(descriptor, name) {
        var ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ var $3a4de46bd2d3d207$var$freezeMethods = function(obj) {
    $3a4de46bd2d3d207$var$reduceDescriptors(obj, function(descriptor, name) {
        // skip restricted props in strict mode
        if ($3a4de46bd2d3d207$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        var value = obj[name];
        if (!$3a4de46bd2d3d207$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = function() {
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ var $3a4de46bd2d3d207$var$toObjectSet = function(arrayOrString, delimiter) {
    var obj = {};
    var define = function(arr) {
        arr.forEach(function(value) {
            obj[value] = true;
        });
    };
    $3a4de46bd2d3d207$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
var $3a4de46bd2d3d207$var$noop = function() {};
var $3a4de46bd2d3d207$var$toFiniteNumber = function(value, defaultValue) {
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $3a4de46bd2d3d207$var$isSpecCompliantForm(thing) {
    return !!(thing && $3a4de46bd2d3d207$var$isFunction(thing.append) && thing[$3a4de46bd2d3d207$var$toStringTag] === 'FormData' && thing[$3a4de46bd2d3d207$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ var $3a4de46bd2d3d207$var$toJSONObject = function(obj) {
    var visited = new WeakSet();
    var visit = function(source) {
        if ($3a4de46bd2d3d207$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($3a4de46bd2d3d207$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                var target;
                if ($3a4de46bd2d3d207$var$isSet(source)) {
                    target = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = source[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var value = _step.value;
                            var reducedValue = visit(value);
                            !$3a4de46bd2d3d207$var$isUndefined(reducedValue) && target.push(reducedValue);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                } else {
                    target = $3a4de46bd2d3d207$var$isArray(source) ? [] : {};
                    $3a4de46bd2d3d207$var$forEach(source, function(value, key) {
                        var reducedValue = visit(value);
                        !$3a4de46bd2d3d207$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                    });
                }
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ var $3a4de46bd2d3d207$var$isAsyncFn = $3a4de46bd2d3d207$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ var $3a4de46bd2d3d207$var$isThenable = function(thing) {
    return thing && ($3a4de46bd2d3d207$var$isObject(thing) || $3a4de46bd2d3d207$var$isFunction(thing)) && $3a4de46bd2d3d207$var$isFunction(thing.then) && $3a4de46bd2d3d207$var$isFunction(thing.catch);
};
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ var $3a4de46bd2d3d207$var$_setImmediate = function(setImmediateSupported, postMessageSupported) {
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? function(token, callbacks) {
        $3a4de46bd2d3d207$var$_global.addEventListener('message', function(param) {
            var source = param.source, data = param.data;
            if (source === $3a4de46bd2d3d207$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return function(cb) {
            callbacks.push(cb);
            $3a4de46bd2d3d207$var$_global.postMessage(token, '*');
        };
    }("axios@".concat(Math.random()), []) : function(cb) {
        return setTimeout(cb);
    };
}(typeof setImmediate === 'function', $3a4de46bd2d3d207$var$isFunction($3a4de46bd2d3d207$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ var $3a4de46bd2d3d207$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($3a4de46bd2d3d207$var$_global) : $3a4de46bd2d3d207$var$_setImmediate;
// *********************
var $3a4de46bd2d3d207$var$isIterable = function(thing) {
    return thing != null && $3a4de46bd2d3d207$var$isFunction(thing[$3a4de46bd2d3d207$var$iterator]);
};
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ var $3a4de46bd2d3d207$var$isSafeIterable = function(thing) {
    return thing != null && $3a4de46bd2d3d207$var$hasOwnInPrototypeChain(thing, $3a4de46bd2d3d207$var$iterator) && $3a4de46bd2d3d207$var$isIterable(thing);
};
var $3a4de46bd2d3d207$export$2e2bcd8739ae039 = {
    isArray: $3a4de46bd2d3d207$var$isArray,
    isArrayBuffer: $3a4de46bd2d3d207$var$isArrayBuffer,
    isBuffer: $3a4de46bd2d3d207$var$isBuffer,
    isFormData: $3a4de46bd2d3d207$var$isFormData,
    isArrayBufferView: $3a4de46bd2d3d207$var$isArrayBufferView,
    isString: $3a4de46bd2d3d207$var$isString,
    isNumber: $3a4de46bd2d3d207$var$isNumber,
    isBoolean: $3a4de46bd2d3d207$var$isBoolean,
    isObject: $3a4de46bd2d3d207$var$isObject,
    isPlainObject: $3a4de46bd2d3d207$var$isPlainObject,
    isEmptyObject: $3a4de46bd2d3d207$var$isEmptyObject,
    isReadableStream: $3a4de46bd2d3d207$var$isReadableStream,
    isRequest: $3a4de46bd2d3d207$var$isRequest,
    isResponse: $3a4de46bd2d3d207$var$isResponse,
    isHeaders: $3a4de46bd2d3d207$var$isHeaders,
    isUndefined: $3a4de46bd2d3d207$var$isUndefined,
    isDate: $3a4de46bd2d3d207$var$isDate,
    isFile: $3a4de46bd2d3d207$var$isFile,
    isReactNativeBlob: $3a4de46bd2d3d207$var$isReactNativeBlob,
    isReactNative: $3a4de46bd2d3d207$var$isReactNative,
    isBlob: $3a4de46bd2d3d207$var$isBlob,
    isRegExp: $3a4de46bd2d3d207$var$isRegExp,
    isFunction: $3a4de46bd2d3d207$var$isFunction,
    isStream: $3a4de46bd2d3d207$var$isStream,
    isURLSearchParams: $3a4de46bd2d3d207$var$isURLSearchParams,
    isTypedArray: $3a4de46bd2d3d207$var$isTypedArray,
    isFileList: $3a4de46bd2d3d207$var$isFileList,
    forEach: $3a4de46bd2d3d207$var$forEach,
    merge: $3a4de46bd2d3d207$var$merge,
    extend: $3a4de46bd2d3d207$var$extend,
    trim: $3a4de46bd2d3d207$var$trim,
    stripBOM: $3a4de46bd2d3d207$var$stripBOM,
    inherits: $3a4de46bd2d3d207$var$inherits,
    toFlatObject: $3a4de46bd2d3d207$var$toFlatObject,
    kindOf: $3a4de46bd2d3d207$var$kindOf,
    kindOfTest: $3a4de46bd2d3d207$var$kindOfTest,
    endsWith: $3a4de46bd2d3d207$var$endsWith,
    toArray: $3a4de46bd2d3d207$var$toArray,
    forEachEntry: $3a4de46bd2d3d207$var$forEachEntry,
    matchAll: $3a4de46bd2d3d207$var$matchAll,
    isHTMLForm: $3a4de46bd2d3d207$var$isHTMLForm,
    hasOwnProperty: $3a4de46bd2d3d207$var$hasOwnProperty,
    hasOwnProp: $3a4de46bd2d3d207$var$hasOwnProperty,
    hasOwnInPrototypeChain: $3a4de46bd2d3d207$var$hasOwnInPrototypeChain,
    getSafeProp: $3a4de46bd2d3d207$var$getSafeProp,
    toSafeFlatObject: $3a4de46bd2d3d207$var$toSafeFlatObject,
    reduceDescriptors: $3a4de46bd2d3d207$var$reduceDescriptors,
    freezeMethods: $3a4de46bd2d3d207$var$freezeMethods,
    toObjectSet: $3a4de46bd2d3d207$var$toObjectSet,
    toCamelCase: $3a4de46bd2d3d207$var$toCamelCase,
    noop: $3a4de46bd2d3d207$var$noop,
    toFiniteNumber: $3a4de46bd2d3d207$var$toFiniteNumber,
    findKey: $3a4de46bd2d3d207$var$findKey,
    global: $3a4de46bd2d3d207$var$_global,
    isContextDefined: $3a4de46bd2d3d207$var$isContextDefined,
    isSpecCompliantForm: $3a4de46bd2d3d207$var$isSpecCompliantForm,
    toJSONObject: $3a4de46bd2d3d207$var$toJSONObject,
    isAsyncFn: $3a4de46bd2d3d207$var$isAsyncFn,
    isThenable: $3a4de46bd2d3d207$var$isThenable,
    setImmediate: $3a4de46bd2d3d207$var$_setImmediate,
    asap: $3a4de46bd2d3d207$var$asap,
    isIterable: $3a4de46bd2d3d207$var$isIterable,
    isSafeIterable: $3a4de46bd2d3d207$var$isSafeIterable
};




var $1Mz1E = parcelRequire("1Mz1E");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $6zk1M = parcelRequire("6zk1M");

var $iLZuz = parcelRequire("iLZuz");



var $2bfPH = parcelRequire("2bfPH");


var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $NBk0Y = parcelRequire("NBk0Y");

var $21h22 = parcelRequire("21h22");

var $2bfPH = parcelRequire("2bfPH");

var $dHaQg = parcelRequire("dHaQg");


var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $21h22 = parcelRequire("21h22");

var $6zk1M = parcelRequire("6zk1M");


'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $a3e89a53ea0e856d$var$ignoreDuplicateOf = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $a3e89a53ea0e856d$export$2e2bcd8739ae039 = function(rawHeaders) {
    var parsed = {};
    var key;
    var val;
    var i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        var hasKey = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).hasOwnProp(parsed, key);
        if (!key || hasKey && (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).hasOwnProp($a3e89a53ea0e856d$var$ignoreDuplicateOf, key)) return;
        if (key === 'set-cookie') {
            if (hasKey) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = hasKey ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};



'use strict';
function $3d267e8cadaf0dda$var$trimSPorHTAB(str) {
    var start = 0;
    var end = str.length;
    while(start < end){
        var code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        var code1 = str.charCodeAt(end - 1);
        if (code1 !== 0x09 && code1 !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
var $3d267e8cadaf0dda$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
var $3d267e8cadaf0dda$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $3d267e8cadaf0dda$var$sanitizeValue(value, invalidChars) {
    if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isArray(value)) return value.map(function(item) {
        return $3d267e8cadaf0dda$var$sanitizeValue(item, invalidChars);
    });
    return $3d267e8cadaf0dda$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
var $3d267e8cadaf0dda$export$9e344cffce061a22 = function(value) {
    return $3d267e8cadaf0dda$var$sanitizeValue(value, $3d267e8cadaf0dda$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
};
var $3d267e8cadaf0dda$export$59dd66c2a12d8f62 = function(value) {
    return $3d267e8cadaf0dda$var$sanitizeValue(value, $3d267e8cadaf0dda$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
};
function $3d267e8cadaf0dda$export$c30c72bb7e677d54(headers) {
    var byteStringHeaders = Object.create(null);
    (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).forEach(headers.toJSON(), function(value, header) {
        byteStringHeaders[header] = $3d267e8cadaf0dda$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}


'use strict';
var $04a1252241532790$var$$internals = Symbol('internals');
function $04a1252241532790$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $04a1252241532790$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isArray(value) ? value.map($04a1252241532790$var$normalizeValue) : (0, $3d267e8cadaf0dda$export$9e344cffce061a22)(String(value));
}
function $04a1252241532790$var$parseTokens(str) {
    var tokens = Object.create(null);
    var tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    var match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
var $04a1252241532790$var$parameterNameRE = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function $04a1252241532790$var$trimOWS(value) {
    var start = 0;
    var end = value.length;
    while(start < end){
        var code = value.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        var code1 = value.charCodeAt(end - 1);
        if (code1 !== 0x09 && code1 !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === value.length ? value : value.slice(start, end);
}
function $04a1252241532790$var$decodeQuotedString(value) {
    var last = value.length - 1;
    if (last < 1 || value.charCodeAt(0) !== 0x22 || value.charCodeAt(last) !== 0x22) return value;
    var decoded = '';
    for(var i = 1; i < last; i++){
        var code = value.charCodeAt(i);
        if (code === 0x22) return value;
        if (code === 0x5c) {
            i += 1;
            if (i >= last) return value;
        }
        decoded += value[i];
    }
    return decoded;
}
function $04a1252241532790$var$parseParameters(value) {
    var parameters = Object.create(null);
    var str = String(value);
    var start = 0;
    var quoted = false;
    var escaped = false;
    function parseParameter(end) {
        var part = $04a1252241532790$var$trimOWS(str.slice(start, end));
        var equals = part.indexOf('=');
        if (equals < 1) return;
        var name = $04a1252241532790$var$trimOWS(part.slice(0, equals));
        if (!$04a1252241532790$var$parameterNameRE.test(name)) return;
        var normalizedName = name.toLowerCase();
        if (normalizedName === '__proto__' || normalizedName === 'constructor' || normalizedName === 'prototype') return;
        var parameterValue = $04a1252241532790$var$trimOWS(part.slice(equals + 1));
        parameters[normalizedName] = $04a1252241532790$var$decodeQuotedString(parameterValue);
    }
    for(var i = 0; i < str.length; i++){
        var code = str.charCodeAt(i);
        if (quoted) {
            if (escaped) escaped = false;
            else if (code === 0x5c) escaped = true;
            else if (code === 0x22) quoted = false;
        } else if (code === 0x22) quoted = true;
        else if (code === 0x2c || code === 0x3b) {
            parseParameter(i);
            start = i + 1;
        }
    }
    parseParameter(str.length);
    return parameters;
}
var $04a1252241532790$var$isValidHeaderName = function(str) {
    return /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
};
function $04a1252241532790$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $04a1252241532790$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, function(w, char, str) {
        return char.toUpperCase() + str;
    });
}
function $04a1252241532790$var$buildAccessors(obj, header) {
    var accessorName = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach(function(methodName) {
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function value(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
var $04a1252241532790$var$AxiosHeaders = /*#__PURE__*/ function() {
    function AxiosHeaders(headers) {
        (0, $gd0sY._)(this, AxiosHeaders);
        headers && this.set(headers);
    }
    (0, $7cSld._)(AxiosHeaders, [
        {
            key: "set",
            value: function set(header, valueOrRewrite, rewrite) {
                var self = this;
                function setHeader(_value, _header, _rewrite) {
                    var lHeader = $04a1252241532790$var$normalizeHeader(_header);
                    if (!lHeader) return;
                    var key = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).findKey(self, lHeader);
                    if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $04a1252241532790$var$normalizeValue(_value);
                }
                var setHeaders = function(headers, _rewrite) {
                    return (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).forEach(headers, function(_value, _header) {
                        return setHeader(_value, _header, _rewrite);
                    });
                };
                if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
                else if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$04a1252241532790$var$isValidHeaderName(header)) setHeaders((0, $a3e89a53ea0e856d$export$2e2bcd8739ae039)(header), valueOrRewrite);
                else if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isObject(header) && (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isSafeIterable(header)) {
                    var obj = Object.create(null), dest, key;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = header[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var entry = _step.value;
                            if (!(0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                            key = entry[0];
                            if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).hasOwnProp(obj, key)) {
                                dest = obj[key];
                                obj[key] = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isArray(dest) ? (0, $6zk1M._)(dest).concat([
                                    entry[1]
                                ]) : [
                                    dest,
                                    entry[1]
                                ];
                            } else obj[key] = entry[1];
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    setHeaders(obj, valueOrRewrite);
                } else header != null && setHeader(valueOrRewrite, header, rewrite);
                return this;
            }
        },
        {
            key: "get",
            value: function get(header, parser) {
                header = $04a1252241532790$var$normalizeHeader(header);
                if (header) {
                    var key = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).findKey(this, header);
                    if (key) {
                        var value = this[key];
                        if (!parser) return value;
                        if (parser === true) return $04a1252241532790$var$parseTokens(value);
                        if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                        if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                        throw new TypeError('parser must be boolean|regexp|function');
                    }
                }
            }
        },
        {
            key: "has",
            value: function has(header, matcher) {
                header = $04a1252241532790$var$normalizeHeader(header);
                if (header) {
                    var key = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).findKey(this, header);
                    return !!(key && this[key] !== undefined && (!matcher || $04a1252241532790$var$matchHeaderValue(this, this[key], key, matcher)));
                }
                return false;
            }
        },
        {
            key: "delete",
            value: function _delete(header, matcher) {
                var self = this;
                var deleted = false;
                function deleteHeader(_header) {
                    _header = $04a1252241532790$var$normalizeHeader(_header);
                    if (_header) {
                        var key = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).findKey(self, _header);
                        if (key && (!matcher || $04a1252241532790$var$matchHeaderValue(self, self[key], key, matcher))) {
                            delete self[key];
                            deleted = true;
                        }
                    }
                }
                if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
                else deleteHeader(header);
                return deleted;
            }
        },
        {
            key: "clear",
            value: function clear(matcher) {
                var keys = Object.keys(this);
                var i = keys.length;
                var deleted = false;
                while(i--){
                    var key = keys[i];
                    if (!matcher || $04a1252241532790$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                        delete this[key];
                        deleted = true;
                    }
                }
                return deleted;
            }
        },
        {
            key: "normalize",
            value: function normalize(format) {
                var self = this;
                var headers = {};
                (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).forEach(this, function(value, header) {
                    var key = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).findKey(headers, header);
                    if (key) {
                        self[key] = $04a1252241532790$var$normalizeValue(value);
                        delete self[header];
                        return;
                    }
                    var normalized = format ? $04a1252241532790$var$formatHeader(header) : String(header).trim();
                    if (normalized !== header) delete self[header];
                    self[normalized] = $04a1252241532790$var$normalizeValue(value);
                    headers[normalized] = true;
                });
                return this;
            }
        },
        {
            key: "concat",
            value: function concat() {
                for(var _len = arguments.length, targets = new Array(_len), _key = 0; _key < _len; _key++){
                    targets[_key] = arguments[_key];
                }
                var _this_constructor;
                return (_this_constructor = this.constructor).concat.apply(_this_constructor, [
                    this
                ].concat((0, $6zk1M._)(targets)));
            }
        },
        {
            key: "toJSON",
            value: function toJSON(asStrings) {
                var obj = Object.create(null);
                (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).forEach(this, function(value, header) {
                    value != null && value !== false && (obj[header] = asStrings && (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
                });
                return obj;
            }
        },
        {
            key: Symbol.iterator,
            value: function value() {
                return Object.entries(this.toJSON())[Symbol.iterator]();
            }
        },
        {
            key: "toString",
            value: function toString() {
                return Object.entries(this.toJSON()).map(function(param) {
                    var _param = (0, $21h22._)(param, 2), header = _param[0], value = _param[1];
                    return header + ': ' + value;
                }).join('\n');
            }
        },
        {
            key: "getSetCookie",
            value: function getSetCookie() {
                var value = this.get('set-cookie');
                return (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isArray(value) ? value : value == null || value === false ? [] : [
                    value
                ];
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return 'AxiosHeaders';
            }
        }
    ], [
        {
            key: "from",
            value: function from(thing) {
                return thing instanceof this ? thing : new this(thing);
            }
        },
        {
            key: "parseParameters",
            value: function parseParameters1(value) {
                return $04a1252241532790$var$parseParameters(value);
            }
        },
        {
            key: "concat",
            value: function concat(first) {
                for(var _len = arguments.length, targets = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    targets[_key - 1] = arguments[_key];
                }
                var computed = new this(first);
                targets.forEach(function(target) {
                    return computed.set(target);
                });
                return computed;
            }
        },
        {
            key: "accessor",
            value: function accessor(header) {
                var internals = this[$04a1252241532790$var$$internals] = this[$04a1252241532790$var$$internals] = {
                    accessors: {}
                };
                var accessors = internals.accessors;
                var prototype = this.prototype;
                function defineAccessor(_header) {
                    var lHeader = $04a1252241532790$var$normalizeHeader(_header);
                    if (!accessors[lHeader]) {
                        $04a1252241532790$var$buildAccessors(prototype, _header);
                        accessors[lHeader] = true;
                    }
                }
                (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
                return this;
            }
        }
    ]);
    return AxiosHeaders;
}();
$04a1252241532790$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).reduceDescriptors($04a1252241532790$var$AxiosHeaders.prototype, function(param, key) {
    var value = param.value;
    var mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: function() {
            return value;
        },
        set: function(headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).freezeMethods($04a1252241532790$var$AxiosHeaders);
var $04a1252241532790$export$2e2bcd8739ae039 = $04a1252241532790$var$AxiosHeaders;


'use strict';
var $7c06a4a7e1384c25$export$6acd2efa8ac62a1b = '[REDACTED ****]';
function $7c06a4a7e1384c25$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).hasOwnProp(source, 'toJSON')) return true;
    var prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $7c06a4a7e1384c25$var$redactConfig(config, redactKeys) {
    var lowerKeys = new Set(redactKeys.map(function(k) {
        return String(k).toLowerCase();
    }));
    var seen = [];
    var visit = function(source) {
        if (source === null || (typeof source === "undefined" ? "undefined" : (0, $2bfPH._)(source)) !== 'object') return source;
        if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $04a1252241532790$export$2e2bcd8739ae039)) source = source.toJSON();
        seen.push(source);
        var result;
        if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isArray(source)) {
            result = [];
            source.forEach(function(v, i) {
                var reducedValue = visit(v);
                if (!(0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isPlainObject(source) && $7c06a4a7e1384c25$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $21h22._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                    var reducedValue = lowerKeys.has(key.toLowerCase()) ? $7c06a4a7e1384c25$export$6acd2efa8ac62a1b : visit(value);
                    if (!(0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[key] = reducedValue;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
function $7c06a4a7e1384c25$var$stringifySafely(value) {
    try {
        return String(value);
    } catch (err) {
        return '';
    }
}
function $7c06a4a7e1384c25$var$aggregateErrorMessage(error) {
    var message = error.errors.map(function(entry) {
        try {
            return entry && entry.message ? $7c06a4a7e1384c25$var$stringifySafely(entry.message) : $7c06a4a7e1384c25$var$stringifySafely(entry);
        } catch (err) {
            return '';
        }
    }).filter(Boolean).join('; ');
    return message || error.name || 'AggregateError';
}
var $7c06a4a7e1384c25$var$AxiosError = /*#__PURE__*/ function(Error1) {
    (0, $NBk0Y._)(AxiosError, Error1);
    function AxiosError(message, code, config, request, response) {
        (0, $gd0sY._)(this, AxiosError);
        var _this;
        _this = (0, $8xMIM._)(this, AxiosError, [
            message
        ]);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(_this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        _this.name = 'AxiosError';
        _this.isAxiosError = true;
        code && (_this.code = code);
        config && (_this.config = config);
        request && (_this.request = request);
        if (response) {
            _this.response = response;
            _this.status = response.status;
        }
        return _this;
    }
    (0, $7cSld._)(AxiosError, [
        {
            key: "toJSON",
            value: function toJSON() {
                // Opt-in redaction: when the request config carries a `redact` array, the
                // value of any matching key (case-insensitive, at any depth) is replaced
                // with REDACTED in the serialized snapshot. Undefined or empty leaves the
                // existing serialization behavior unchanged.
                var config = this.config;
                var redactKeys = config && (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).hasOwnProp(config, 'redact') ? config.redact : undefined;
                var serializedConfig = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isArray(redactKeys) && redactKeys.length > 0 ? $7c06a4a7e1384c25$var$redactConfig(config, redactKeys) : (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).toJSONObject(config);
                return {
                    // Standard
                    message: this.message,
                    name: this.name,
                    // Microsoft
                    description: this.description,
                    number: this.number,
                    // Mozilla
                    fileName: this.fileName,
                    lineNumber: this.lineNumber,
                    columnNumber: this.columnNumber,
                    stack: this.stack,
                    // Axios
                    config: serializedConfig,
                    code: this.code,
                    status: this.status
                };
            }
        }
    ], [
        {
            key: "from",
            value: function from(error, code, config, request, response, customProps) {
                // `AggregateError` (thrown by Node on dual-stack/Happy-Eyeballs connection
                // failures) has an empty `message`; its detail lives in `errors[]`. Without
                // this, the wrapped error surfaces with a blank message (see #6721).
                var message = error.message;
                if (!message && (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isArray(error.errors) && error.errors.length) message = $7c06a4a7e1384c25$var$aggregateErrorMessage(error);
                var axiosError = new AxiosError(message, code || error.code, config, request, response);
                // Match native `Error` `cause` semantics: non-enumerable. The wrapped
                // error often carries circular internals (sockets, requests, agents), so
                // an enumerable `cause` makes structured loggers (pino/winston) and any
                // own-property walk throw "Converting circular structure to JSON".
                // Regression from #6982; see #7205. `__proto__: null` mirrors the
                // `message` descriptor below (prototype-pollution-safe descriptor).
                Object.defineProperty(axiosError, 'cause', {
                    __proto__: null,
                    value: error,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                axiosError.name = error.name;
                // Preserve status from the original error if not already set from response
                if (error.status != null && axiosError.status == null) axiosError.status = error.status;
                customProps && Object.assign(axiosError, customProps);
                return axiosError;
            }
        }
    ]);
    return AxiosError;
}((0, $dHaQg._)(Error));
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$7c06a4a7e1384c25$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$7c06a4a7e1384c25$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$7c06a4a7e1384c25$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$7c06a4a7e1384c25$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$7c06a4a7e1384c25$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$7c06a4a7e1384c25$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$7c06a4a7e1384c25$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$7c06a4a7e1384c25$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$7c06a4a7e1384c25$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$7c06a4a7e1384c25$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$7c06a4a7e1384c25$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$7c06a4a7e1384c25$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$7c06a4a7e1384c25$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$7c06a4a7e1384c25$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $7c06a4a7e1384c25$export$2e2bcd8739ae039 = $7c06a4a7e1384c25$var$AxiosError;


// eslint-disable-next-line strict
var $7f37bc1a5a507c65$export$2e2bcd8739ae039 = null;



'use strict';
var $820b2ad2216a17dd$export$659081b45d03227d = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $820b2ad2216a17dd$var$isVisitable(thing) {
    return (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $820b2ad2216a17dd$var$removeBrackets(key) {
    return (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $820b2ad2216a17dd$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $820b2ad2216a17dd$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $820b2ad2216a17dd$var$isFlatArray(arr) {
    return (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isArray(arr) && !arr.some($820b2ad2216a17dd$var$isVisitable);
}
var $820b2ad2216a17dd$var$predicates = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).toFlatObject((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $820b2ad2216a17dd$var$toFormData(obj, formData, options) {
    if (!(0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $7f37bc1a5a507c65$export$2e2bcd8739ae039) || FormData)();
    var option = function(name, fallback) {
        var value = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).getSafeProp(options, name);
        return (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isUndefined(value) ? fallback : value;
    };
    var metaTokens = option('metaTokens', true);
    // eslint-disable-next-line no-use-before-define
    var visitor = option('visitor') || defaultVisitor;
    var dots = option('dots', false);
    var indexes = option('indexes', false);
    var _Blob = option('Blob') || typeof Blob !== 'undefined' && Blob;
    var maxDepth = option('maxDepth', $820b2ad2216a17dd$export$659081b45d03227d);
    var useBlob = _Blob && (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    var stack = [];
    if (!(0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isTypedArray(value)) {
            if (useBlob && typeof _Blob === 'function') return new _Blob([
                value
            ]);
            if ((0, $7f37bc1a5a507c65$export$2e2bcd8739ae039) && (0, $7f37bc1a5a507c65$export$2e2bcd8739ae039).isBufferAvailable()) return (0, $7f37bc1a5a507c65$export$2e2bcd8739ae039).from(value);
            throw new (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.', (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
        }
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        var ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        var arr = value;
        if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isReactNative(formData) && (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($820b2ad2216a17dd$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) === 'object') {
            if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isArray(value) && $820b2ad2216a17dd$var$isFlatArray(value) || ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isFileList(value) || (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $820b2ad2216a17dd$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $820b2ad2216a17dd$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($820b2ad2216a17dd$var$isVisitable(value)) return true;
        formData.append($820b2ad2216a17dd$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    var exposedHelpers = Object.assign($820b2ad2216a17dd$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $820b2ad2216a17dd$var$isVisitable
    });
    function build(value, path) {
        var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            var result = !((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $820b2ad2216a17dd$export$2e2bcd8739ae039 = $820b2ad2216a17dd$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $551add8fbf62a8f2$var$encode(str) {
    var charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $551add8fbf62a8f2$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $820b2ad2216a17dd$export$2e2bcd8739ae039)(params, this, options);
}
var $551add8fbf62a8f2$var$prototype = $551add8fbf62a8f2$var$AxiosURLSearchParams.prototype;
$551add8fbf62a8f2$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$551add8fbf62a8f2$var$prototype.toString = function toString(encoder) {
    var _this = this;
    var _encode = encoder ? function(value) {
        return encoder.call(_this, value, $551add8fbf62a8f2$var$encode);
    } : $551add8fbf62a8f2$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $551add8fbf62a8f2$export$2e2bcd8739ae039 = $551add8fbf62a8f2$var$AxiosURLSearchParams;


'use strict';
function $06b1d73e713c56eb$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $06b1d73e713c56eb$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    url = url || '';
    var _options = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    var _encode = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).getSafeProp(_options, 'encode') || $06b1d73e713c56eb$export$c564cdbbe6da493;
    var serializeFn = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).getSafeProp(_options, 'serialize');
    var serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $551add8fbf62a8f2$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

'use strict';
var $6dabe340a72bef76$var$$internals = Symbol('internals');
// `handlers` is public and may be replaced with a nullish value by user code;
// `clear()` has always tolerated that. Treat it as an empty stack rather than
// dereferencing it.
function $6dabe340a72bef76$var$countHandlers(handlers) {
    return handlers ? handlers.length : 0;
}
function $6dabe340a72bef76$var$trimHandlers(handlers) {
    if (!handlers) return;
    while(handlers.length && handlers[handlers.length - 1] === null)handlers.pop();
}
function $6dabe340a72bef76$var$syncHandlerEntries(manager, internals) {
    var handlers = manager.handlers;
    var length = $6dabe340a72bef76$var$countHandlers(handlers);
    if (handlers !== internals.handlersRef) {
        internals.handlersRef = handlers;
        internals.handlerEntries.clear();
    } else if (length !== internals.handlersLength) {
        if (!length) internals.handlerEntries.clear();
        else internals.handlerEntries.forEach(function removeStaleEntry(entry, id) {
            if (handlers[entry.index] !== entry.handler) internals.handlerEntries.delete(id);
        });
    }
    internals.handlersLength = length;
}
var $6dabe340a72bef76$var$InterceptorManager = /*#__PURE__*/ function() {
    function InterceptorManager() {
        (0, $gd0sY._)(this, InterceptorManager);
        this.handlers = [];
        this[$6dabe340a72bef76$var$$internals] = {
            handlersRef: this.handlers,
            handlersLength: this.handlers.length,
            handlerEntries: new Map(),
            iterationDepth: 0,
            nextId: 0
        };
    }
    (0, $7cSld._)(InterceptorManager, [
        {
            /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ key: "use",
            value: function use(fulfilled, rejected, options) {
                var handler = {
                    fulfilled: fulfilled,
                    rejected: rejected,
                    synchronous: options ? options.synchronous : false,
                    runWhen: options ? options.runWhen : null
                };
                var internals = this[$6dabe340a72bef76$var$$internals];
                if (this.handlers == null) this.handlers = [];
                $6dabe340a72bef76$var$syncHandlerEntries(this, internals);
                var id = internals.nextId++;
                this.handlers.push(handler);
                internals.handlerEntries.set(id, {
                    handler: handler,
                    index: this.handlers.length - 1
                });
                internals.handlersLength = this.handlers.length;
                return id;
            }
        },
        {
            /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ key: "eject",
            value: function eject(id) {
                var internals = this[$6dabe340a72bef76$var$$internals];
                $6dabe340a72bef76$var$syncHandlerEntries(this, internals);
                var entry = internals.handlerEntries.get(id);
                if (entry) {
                    internals.handlerEntries.delete(id);
                    // Ignore IDs invalidated by clear or direct replacement of handlers.
                    if (this.handlers[entry.index] !== entry.handler) return;
                    this.handlers[entry.index] = null;
                    // Do not reuse an index while forEach is walking its length snapshot.
                    if (!internals.iterationDepth) {
                        $6dabe340a72bef76$var$trimHandlers(this.handlers);
                        internals.handlersLength = this.handlers.length;
                    }
                }
            }
        },
        {
            /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ key: "clear",
            value: function clear() {
                if (this.handlers) {
                    this.handlers = [];
                    $6dabe340a72bef76$var$syncHandlerEntries(this, this[$6dabe340a72bef76$var$$internals]);
                }
            }
        },
        {
            /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ key: "forEach",
            value: function forEach(fn) {
                var internals = this[$6dabe340a72bef76$var$$internals];
                $6dabe340a72bef76$var$syncHandlerEntries(this, internals);
                internals.iterationDepth++;
                try {
                    (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
                        if (h !== null) fn(h);
                    });
                } finally{
                    if (!--internals.iterationDepth) {
                        $6dabe340a72bef76$var$syncHandlerEntries(this, internals);
                        $6dabe340a72bef76$var$trimHandlers(this.handlers);
                        internals.handlersLength = $6dabe340a72bef76$var$countHandlers(this.handlers);
                    }
                }
            }
        }
    ]);
    return InterceptorManager;
}();
var $6dabe340a72bef76$export$2e2bcd8739ae039 = $6dabe340a72bef76$var$InterceptorManager;





'use strict';
var $3ff60df591703cf6$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
};




var $lvTkn = parcelRequire("lvTkn");



var $lvTkn = parcelRequire("lvTkn");

'use strict';
var $5b57da801bbd2535$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $551add8fbf62a8f2$export$2e2bcd8739ae039);


'use strict';
var $d0ecd50456e98b83$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $0821d0eebb982e98$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $54f753ce9938835d$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: (0, $5b57da801bbd2535$export$2e2bcd8739ae039),
        FormData: (0, $d0ecd50456e98b83$export$2e2bcd8739ae039),
        Blob: (0, $0821d0eebb982e98$export$2e2bcd8739ae039)
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $6aab419c72eb78db$exports = {};

$parcel$export($6aab419c72eb78db$exports, "hasBrowserEnv", function () { return $6aab419c72eb78db$export$c4996c4b7b93b0bf; });
$parcel$export($6aab419c72eb78db$exports, "navigator", function () { return $6aab419c72eb78db$export$ec7c8efa7f5790ae; });
$parcel$export($6aab419c72eb78db$exports, "hasStandardBrowserEnv", function () { return $6aab419c72eb78db$export$c0bcc9250309d66; });
$parcel$export($6aab419c72eb78db$exports, "hasStandardBrowserWebWorkerEnv", function () { return $6aab419c72eb78db$export$c81692cf5af97dac; });
$parcel$export($6aab419c72eb78db$exports, "origin", function () { return $6aab419c72eb78db$export$f710a83a91838a36; });

var $2bfPH = parcelRequire("2bfPH");
var $6aab419c72eb78db$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
var $6aab419c72eb78db$export$ec7c8efa7f5790ae = (typeof navigator === "undefined" ? "undefined" : (0, $2bfPH._)(navigator)) === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ var $6aab419c72eb78db$export$c0bcc9250309d66 = $6aab419c72eb78db$export$c4996c4b7b93b0bf && (!$6aab419c72eb78db$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($6aab419c72eb78db$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ var $6aab419c72eb78db$export$c81692cf5af97dac = function() {
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
}();
var $6aab419c72eb78db$export$f710a83a91838a36 = $6aab419c72eb78db$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $8feb31e97706e1f3$export$2e2bcd8739ae039 = (0, $lvTkn._)({}, $6aab419c72eb78db$exports, (0, $54f753ce9938835d$export$2e2bcd8739ae039));


'use strict';
function $2797b72efe8505b1$export$2e2bcd8739ae039(data, options) {
    return (0, $820b2ad2216a17dd$export$2e2bcd8739ae039)(data, new (0, $8feb31e97706e1f3$export$2e2bcd8739ae039).classes.URLSearchParams(), (0, $lvTkn._)({
        visitor: function visitor(value, key, path, helpers) {
            if ((0, $8feb31e97706e1f3$export$2e2bcd8739ae039).isNode && (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}






'use strict';
var $5b65bc79ed38e11f$var$MAX_DEPTH = (0, $820b2ad2216a17dd$export$659081b45d03227d);
function $5b65bc79ed38e11f$var$throwIfDepthExceeded(index) {
    if (index > $5b65bc79ed38e11f$var$MAX_DEPTH) throw new (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039)('FormData field is too deeply nested (' + index + ' levels). Max depth: ' + $5b65bc79ed38e11f$var$MAX_DEPTH, (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5b65bc79ed38e11f$var$parsePropPath(name) {
    // foo[x][y][z] -> ['foo', 'x', 'y', 'z']
    // foo.x.y.z    -> ['foo', 'x', 'y', 'z']
    // A path is split on `.` and on `[...]` groups. A segment — whether written
    // in dot notation or captured inside brackets — may contain any character
    // except `.`, `[` and `]`, so a key like `user-name` or `user name` is kept
    // literal instead of being split (#5402). `.`, `[` and `]` keep their existing
    // meaning, e.g. `foo[bar.baz]` -> ['foo', 'bar', 'baz'] and `[]` is an array push.
    // Excluding `[` from the bracket group also makes the match fail fast at the
    // next `[`, so a malformed name cannot rescan to the end of the string from
    // every unmatched `[` — parsing stays linear in the length of the name.
    var path = [];
    var pattern = /[^.[\]]+|\[([^.[\]]*)]/g;
    var match;
    while((match = pattern.exec(name)) !== null){
        $5b65bc79ed38e11f$var$throwIfDepthExceeded(path.length);
        path.push(match[0] === '[]' ? '' : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5b65bc79ed38e11f$var$arrayToObject(arr) {
    var obj = {};
    var keys = Object.keys(arr);
    var i;
    var len = keys.length;
    var key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5b65bc79ed38e11f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        $5b65bc79ed38e11f$var$throwIfDepthExceeded(index);
        var name = path[index++];
        if (name === '__proto__') return true;
        var isNumericKey = Number.isFinite(+name);
        var isLast = index >= path.length;
        name = !name && (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).hasOwnProp(target, name) || !(0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        var result = buildPath(path, value, target[name], index);
        if (result && (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $5b65bc79ed38e11f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isFormData(formData) && (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        var obj = {};
        (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).forEachEntry(formData, function(name, value) {
            buildPath($5b65bc79ed38e11f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5b65bc79ed38e11f$export$2e2bcd8739ae039 = $5b65bc79ed38e11f$var$formDataToJSON;


'use strict';
var $1916f923f08c72c1$var$methodList = Object.freeze([
    'get',
    'delete',
    'head',
    'options',
    'post',
    'put',
    'patch',
    'purge',
    'link',
    'unlink',
    'query'
]);
var $1916f923f08c72c1$export$2e2bcd8739ae039 = $1916f923f08c72c1$var$methodList;


'use strict';
var $dbe0f2b7eb8069ce$var$own = function(obj, key) {
    return obj != null && (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).hasOwnProp(obj, key) ? obj[key] : undefined;
};
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $dbe0f2b7eb8069ce$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $dbe0f2b7eb8069ce$var$defaults = {
    transitional: (0, $3ff60df591703cf6$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            var contentType = headers.getContentType() || '';
            var hasJSONContentType = contentType.indexOf('application/json') > -1;
            var isObjectPayload = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            var isFormData = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $5b65bc79ed38e11f$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isBuffer(data) || (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isStream(data) || (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isFile(data) || (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isBlob(data) || (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            var isFileList;
            if (isObjectPayload) {
                var formSerializer = $dbe0f2b7eb8069ce$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $2797b72efe8505b1$export$2e2bcd8739ae039)(data, formSerializer).toString();
                if ((isFileList = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    var env = $dbe0f2b7eb8069ce$var$own(this, 'env');
                    var _FormData = env && env.FormData;
                    return (0, $820b2ad2216a17dd$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $dbe0f2b7eb8069ce$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = $dbe0f2b7eb8069ce$var$own(this, 'transitional') || $dbe0f2b7eb8069ce$var$defaults.transitional;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var responseType = $dbe0f2b7eb8069ce$var$own(this, 'responseType');
            var JSONRequested = responseType === 'json';
            if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isResponse(data) || (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                var silentJSONParsing = transitional && transitional.silentJSONParsing;
                var strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $dbe0f2b7eb8069ce$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).from(e, (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, $dbe0f2b7eb8069ce$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $8feb31e97706e1f3$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $8feb31e97706e1f3$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).forEach((0, $1916f923f08c72c1$export$2e2bcd8739ae039), function(method) {
    $dbe0f2b7eb8069ce$var$defaults.headers[method] = {};
});
var $dbe0f2b7eb8069ce$export$2e2bcd8739ae039 = $dbe0f2b7eb8069ce$var$defaults;



'use strict';
function $807b146aacf21b81$export$2e2bcd8739ae039(fns, response) {
    var config = this || (0, $dbe0f2b7eb8069ce$export$2e2bcd8739ae039);
    var context = response || config;
    var headers = (0, $04a1252241532790$export$2e2bcd8739ae039).from(context.headers);
    var data = context.data;
    (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $d7256a7d37d85f2e$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $NBk0Y = parcelRequire("NBk0Y");

'use strict';
var $22cd54147a3afac2$var$CanceledError = /*#__PURE__*/ function(AxiosError1) {
    (0, $NBk0Y._)(CanceledError, AxiosError1);
    function CanceledError(message, config, request) {
        (0, $gd0sY._)(this, CanceledError);
        var _this;
        _this = (0, $8xMIM._)(this, CanceledError, [
            message == null ? 'canceled' : message,
            (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).ERR_CANCELED,
            config,
            request
        ]);
        _this.name = 'CanceledError';
        _this.__CANCEL__ = true;
        return _this;
    }
    return CanceledError;
}((0, $7c06a4a7e1384c25$export$2e2bcd8739ae039));
var $22cd54147a3afac2$export$2e2bcd8739ae039 = $22cd54147a3afac2$var$CanceledError;




var $21h22 = parcelRequire("21h22");



var $21h22 = parcelRequire("21h22");


'use strict';
function $f1f30840a93e520c$export$2e2bcd8739ae039(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).ERR_BAD_REQUEST : (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, response.config, response.request, response));
}





'use strict';
var $58605d84e3fccde3$var$urlParserControlCharacters = /[\t\n\r]/g;
function $58605d84e3fccde3$export$2e2bcd8739ae039(url) {
    if (typeof url !== 'string') return url;
    var start = 0;
    while(start < url.length && url.charCodeAt(start) <= 0x20)start++;
    return url.slice(start).replace($58605d84e3fccde3$var$urlParserControlCharacters, '');
}


'use strict';
function $b25f2763dfa6501d$export$2e2bcd8739ae039(url) {
    var match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}





var $khBmn = parcelRequire("khBmn");

var $6zk1M = parcelRequire("6zk1M");
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $01a16c665513448d$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    var bytes = new Array(samplesCount);
    var timestamps = new Array(samplesCount);
    var head = 0;
    var tail = 0;
    var firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        var now = Date.now();
        var startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        var i = tail;
        var bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        var passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $01a16c665513448d$export$2e2bcd8739ae039 = $01a16c665513448d$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Array<Function>}
 */ 
var $6zk1M = parcelRequire("6zk1M");
function $27980831125337e8$var$throttle(fn, freq) {
    var timestamp = 0;
    var threshold = 1000 / freq;
    var lastArgs;
    var timer;
    var invoke = function(args) {
        var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(void 0, (0, $6zk1M._)(args));
    };
    var throttled = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var now = Date.now();
        var passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(function() {
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    var flush = function() {
        return lastArgs && invoke(lastArgs);
    };
    var flushWith = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return invoke(args);
    };
    return [
        throttled,
        flush,
        flushWith
    ];
}
var $27980831125337e8$export$2e2bcd8739ae039 = $27980831125337e8$var$throttle;



var $93480ef9fbbde9f0$export$c1b28109d46c3592 = function(listener, isDownloadStream) {
    var freq = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3;
    var bytesNotified = 0;
    var _speedometer = (0, $01a16c665513448d$export$2e2bcd8739ae039)(50, 250);
    return (0, $27980831125337e8$export$2e2bcd8739ae039)(function(e) {
        if (!e || !(0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isNumber(e.loaded)) return;
        var rawLoaded = e.loaded;
        var total = e.lengthComputable ? e.total : undefined;
        var loaded = Math.max(0, total != null ? Math.min(rawLoaded, total) : rawLoaded);
        var progressBytes = Math.max(0, loaded - bytesNotified);
        var rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        var data = (0, $khBmn._)({
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null
        }, isDownloadStream ? 'download' : 'upload', true);
        listener(data);
    }, freq);
};
var $93480ef9fbbde9f0$export$d9fadd12586c18d6 = function(total, throttled) {
    var lengthComputable = total != null;
    return [
        function(loaded) {
            return throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            });
        },
        throttled[1]
    ];
};
var $93480ef9fbbde9f0$export$5d35863c355a22a9 = function(fn) {
    var scheduler = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).asap;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return scheduler(function() {
            return fn.apply(void 0, (0, $6zk1M._)(args));
        });
    };
};






var $2043b7792dbe2aa0$export$2e2bcd8739ae039 = (0, $8feb31e97706e1f3$export$2e2bcd8739ae039).hasStandardBrowserEnv ? function(origin, isMSIE) {
    return function(url) {
        url = new URL(url, (0, $8feb31e97706e1f3$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    };
}(new URL((0, $8feb31e97706e1f3$export$2e2bcd8739ae039).origin), (0, $8feb31e97706e1f3$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $8feb31e97706e1f3$export$2e2bcd8739ae039).navigator.userAgent)) : function() {
    return true;
};




var $04b77d00dcb686db$export$2e2bcd8739ae039 = (0, $8feb31e97706e1f3$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write: function(name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        var cookie = [
            "".concat(name, "=").concat(encodeURIComponent(value))
        ];
        if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isNumber(expires)) cookie.push("expires=".concat(new Date(expires).toUTCString()));
        if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isString(path)) cookie.push("path=".concat(path));
        if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isString(domain)) cookie.push("domain=".concat(domain));
        if (secure === true) cookie.push('secure');
        if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isString(sameSite)) cookie.push("SameSite=".concat(sameSite));
        document.cookie = cookie.join('; ');
    },
    read: function(name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        var cookies = document.cookie.split(';');
        for(var i = 0; i < cookies.length; i++){
            var cookie = cookies[i].replace(/^\s+/, '');
            var eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) try {
                return decodeURIComponent(cookie.slice(eq + 1));
            } catch (e) {
                return cookie.slice(eq + 1);
            }
        }
        return null;
    },
    remove: function(name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write: function() {},
    read: function() {
        return null;
    },
    remove: function() {}
};



'use strict';
function $3ecb38f59360d474$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $0cf81edb9cfc4031$export$2e2bcd8739ae039(baseURL, relativeURL) {
    if (!relativeURL) return baseURL;
    var end = baseURL.length;
    while(end > 0 && baseURL.charCodeAt(end - 1) === 47)end--;
    return baseURL.slice(0, end) + '/' + relativeURL.replace(/^\/+/, '');
}



'use strict';
var $35a666b8f5497d94$var$malformedHttpProtocol = /^https?:(?!\/\/)/i;
// Redact the parts of a URL that can carry secrets before it is embedded in an
// error message. AxiosError.toJSON() serializes `message` verbatim and errors
// are commonly logged, while the opt-in `config.redact` model only cleans
// config keys — it cannot reach the message. Redact only the genuinely
// sensitive substrings — userinfo (credentials), query parameter values and
// fragment contents — with the same REDACTED marker the config redaction uses,
// while keeping the scheme, host, path and parameter names so the offending
// request stays accurately identifiable.
function $35a666b8f5497d94$var$redactFragment(fragment) {
    if (!fragment) return fragment;
    return fragment.replace(/(^|&)([^=&]*=)?[^&]+/g, function(match, separator) {
        var parameterName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : '';
        return "".concat(separator).concat(parameterName).concat((0, $7c06a4a7e1384c25$export$6acd2efa8ac62a1b));
    });
}
function $35a666b8f5497d94$var$redactSensitiveURLParts(url) {
    var redactedURL = url.replace(/^(https?:\/{0,2})[^/?#]*@/i, "$1".concat((0, $7c06a4a7e1384c25$export$6acd2efa8ac62a1b), "@"));
    var fragmentIndex = redactedURL.indexOf('#');
    var urlWithoutFragment = fragmentIndex === -1 ? redactedURL : redactedURL.slice(0, fragmentIndex);
    var redactedURLWithoutFragment = urlWithoutFragment.replace(/([?&][^=&#]*=)[^&#]*/g, "$1".concat((0, $7c06a4a7e1384c25$export$6acd2efa8ac62a1b)));
    if (fragmentIndex === -1) return redactedURLWithoutFragment;
    return "".concat(redactedURLWithoutFragment, "#").concat($35a666b8f5497d94$var$redactFragment(redactedURL.slice(fragmentIndex + 1)));
}
function $35a666b8f5497d94$var$assertValidHttpProtocolURL(url, config) {
    if (typeof url === 'string') {
        var normalizedURL = (0, $58605d84e3fccde3$export$2e2bcd8739ae039)(url);
        if ($35a666b8f5497d94$var$malformedHttpProtocol.test(normalizedURL)) throw new (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039)("Invalid URL ".concat(JSON.stringify($35a666b8f5497d94$var$redactSensitiveURLParts(normalizedURL)), ': missing "//" after protocol'), (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).ERR_INVALID_URL, config);
    }
}
function $35a666b8f5497d94$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls, config) {
    $35a666b8f5497d94$var$assertValidHttpProtocolURL(requestedURL, config);
    var isRelativeUrl = !(0, $3ecb38f59360d474$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        $35a666b8f5497d94$var$assertValidHttpProtocolURL(baseURL, config);
        return (0, $0cf81edb9cfc4031$export$2e2bcd8739ae039)(baseURL, requestedURL);
    }
    return requestedURL;
}



var $lvTkn = parcelRequire("lvTkn");


'use strict';
var $9e2d44d1266464bc$var$headersToObject = function(thing) {
    return thing instanceof (0, $04a1252241532790$export$2e2bcd8739ae039) ? (0, $lvTkn._)({}, thing) : thing;
};
var $9e2d44d1266464bc$var$ownEnumerableKeys = function(thing) {
    if (Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor) return Object.keys(thing).concat(Object.getOwnPropertySymbols(thing).filter(function(symbol) {
        return Object.getOwnPropertyDescriptor(thing, symbol).enumerable;
    }));
    return Object.keys(thing);
};
function $9e2d44d1266464bc$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    var config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isPlainObject(target) && (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    function getMergedTransitionalOption(prop) {
        var transitional2 = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).hasOwnProp(config2, 'transitional') ? config2.transitional : undefined;
        if (!(0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isUndefined(transitional2)) {
            if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isPlainObject(transitional2)) {
                if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).hasOwnProp(transitional2, prop)) return transitional2[prop];
            } else return undefined;
        }
        var transitional1 = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).hasOwnProp(config1, 'transitional') ? config1.transitional : undefined;
        if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isPlainObject(transitional1) && (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).hasOwnProp(transitional1, prop)) return transitional1[prop];
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    var mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutErrorMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: function(a, b, prop) {
            return mergeDeepProperties($9e2d44d1266464bc$var$headersToObject(a), $9e2d44d1266464bc$var$headersToObject(b), prop, true);
        }
    };
    (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).forEach($9e2d44d1266464bc$var$ownEnumerableKeys((0, $lvTkn._)({}, config1, config2)), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        var merge = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        var a = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        var b = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        var configValue = merge(a, b, prop);
        (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).hasOwnProp(config2, 'validateStatus') && (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isUndefined(config2.validateStatus) && getMergedTransitionalOption('validateStatusUndefinedResolves') === false) {
        if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).hasOwnProp(config1, 'validateStatus')) config.validateStatus = getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}




var $21h22 = parcelRequire("21h22");
'use strict';
var $9c8d15a98596f51c$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $9c8d15a98596f51c$export$2e2bcd8739ae039(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders || {}).forEach(function(param) {
        var _param = (0, $21h22._)(param, 2), key = _param[0], val = _param[1];
        if ($9c8d15a98596f51c$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}



/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ var $9f56b5d281d652bf$var$encodeUTF8 = function(str) {
    return encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, function(_, hex) {
        return String.fromCharCode(parseInt(hex, 16));
    });
};
function $9f56b5d281d652bf$var$resolveConfig(config) {
    var newConfig = (0, $9e2d44d1266464bc$export$2e2bcd8739ae039)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    var own = function(key) {
        return (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    };
    var data = own('data');
    var withXSRFToken = own('withXSRFToken');
    var xsrfHeaderName = own('xsrfHeaderName');
    var xsrfCookieName = own('xsrfCookieName');
    var headers = own('headers');
    var auth = own('auth');
    var baseURL = own('baseURL');
    var allowAbsoluteUrls = own('allowAbsoluteUrls');
    var url = own('url');
    newConfig.headers = headers = (0, $04a1252241532790$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $06b1d73e713c56eb$export$2e2bcd8739ae039)((0, $35a666b8f5497d94$export$2e2bcd8739ae039)(baseURL, url, allowAbsoluteUrls, newConfig), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) {
        var username = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).getSafeProp(auth, 'username') || '';
        var password = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).getSafeProp(auth, 'password') || '';
        try {
            headers.set('Authorization', 'Basic ' + btoa(username + ':' + (password ? $9f56b5d281d652bf$var$encodeUTF8(password) : '')));
        } catch (e) {
            throw (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).from(e, (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE, config);
        }
    }
    if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isFormData(data)) {
        var getHeaders = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).getSafeProp(data, 'getHeaders');
        if ((0, $8feb31e97706e1f3$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $8feb31e97706e1f3$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv || (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isFunction(getHeaders)) // Node.js FormData (like form-data package)
        (0, $9c8d15a98596f51c$export$2e2bcd8739ae039)(headers, getHeaders.call(data), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $8feb31e97706e1f3$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        var shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $2043b7792dbe2aa0$export$2e2bcd8739ae039)(newConfig.url);
        if (shouldSendXSRF) {
            var xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $04b77d00dcb686db$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $9f56b5d281d652bf$export$2e2bcd8739ae039 = $9f56b5d281d652bf$var$resolveConfig;



var $d893a30218208208$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $d893a30218208208$export$2e2bcd8739ae039 = $d893a30218208208$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var _config = (0, $9f56b5d281d652bf$export$2e2bcd8739ae039)(config);
        var requestData = _config.data;
        var requestHeaders = (0, $04a1252241532790$export$2e2bcd8739ae039).from(_config.headers).normalize();
        var responseType = _config.responseType, onUploadProgress = _config.onUploadProgress, onDownloadProgress = _config.onDownloadProgress;
        var onCanceled;
        var uploadThrottled, downloadThrottled;
        var flushUpload, flushDownload, flushDownloadWithEvent;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        var request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend(event) {
            if (!request) return;
            // Status 0 means no response was received, which onerror and onabort normally
            // reject before this runs. Firefox 152 fires only readystatechange and loadend for
            // navigation-canceled requests (https://bugzilla.mozilla.org/show_bug.cgi?id=1505389),
            // leaving settle() to resolve them as an empty success. ECONNABORTED is the error
            // onabort raised on Firefox 151. Reads over file:, which some environments report as
            // status 0 on success, are excluded by the request URL's scheme after browser-style
            // preprocessing, by the page origin's scheme for relative URLs (which inherit it), or
            // by responseURL where implemented.
            if (request.status === 0 && ((0, $b25f2763dfa6501d$export$2e2bcd8739ae039)((0, $58605d84e3fccde3$export$2e2bcd8739ae039)(_config.url)) || (0, $b25f2763dfa6501d$export$2e2bcd8739ae039)((0, $8feb31e97706e1f3$export$2e2bcd8739ae039).origin)) !== 'file' && !(request.responseURL && request.responseURL.startsWith('file:'))) {
                reject(new (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039)('Request aborted', (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).ECONNABORTED, config, request));
                done();
                // Clean up request
                request = null;
                return;
            }
            // When loadend is still dispatching, flushing with it gives progress
            // listeners a final delivery whose event has a live target. The legacy
            // ready-state fallback has no event, so replay its pending progress.
            // A throwing listener must not block settlement; rethrow asynchronously,
            // matching how listener errors surface on the throttle timer path.
            try {
                if (event) flushDownloadWithEvent && flushDownloadWithEvent(event);
                else flushDownload && flushDownload();
            } catch (err) {
                setTimeout(function() {
                    throw err;
                });
            }
            // A final progress callback can cancel the request synchronously.
            if (!request) return;
            // Prepare the response
            var responseHeaders = (0, $04a1252241532790$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $f1f30840a93e520c$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039)('Request aborted', (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            var msg = event && event.message ? event.message : 'Network Error';
            var err = new (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039)(msg, (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            var transitional = _config.transitional || (0, $3ff60df591703cf6$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).ETIMEDOUT : (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).forEach((0, $3d267e8cadaf0dda$export$c30c72bb7e677d54)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            var ref;
            ref = (0, $21h22._)((0, $93480ef9fbbde9f0$export$c1b28109d46c3592)(onDownloadProgress, true), 3), downloadThrottled = ref[0], flushDownload = ref[1], flushDownloadWithEvent = ref[2], ref;
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            var ref1;
            ref1 = (0, $21h22._)((0, $93480ef9fbbde9f0$export$c1b28109d46c3592)(onUploadProgress), 2), uploadThrottled = ref1[0], flushUpload = ref1[1], ref1;
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $22cd54147a3afac2$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        var protocol = (0, $b25f2763dfa6501d$export$2e2bcd8739ae039)(_config.url);
        if (protocol && !(0, $8feb31e97706e1f3$export$2e2bcd8739ae039).protocols.includes(protocol)) {
            reject(new (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            done();
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};



var $1Mz1E = parcelRequire("1Mz1E");

var $21h22 = parcelRequire("21h22");

var $6zk1M = parcelRequire("6zk1M");

var $iLZuz = parcelRequire("iLZuz");






var $6acf272d514eb301$var$composeSignals = function(signals, timeout) {
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    var controller = new AbortController();
    var aborted = false;
    var onabort = function onabort(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            var err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039) ? err : new (0, $22cd54147a3afac2$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    var timer = timeout && setTimeout(function() {
        timer = null;
        onabort(new (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039)("timeout of ".concat(timeout, "ms exceeded"), (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    var unsubscribe = function() {
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach(function(signal) {
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach(function(signal) {
        if (aborted) return;
        if (signal.aborted) {
            onabort.call(signal);
            return;
        }
        signal.addEventListener('abort', onabort, {
            once: true
        });
    });
    var signal = controller.signal;
    signal.unsubscribe = function() {
        return (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).asap(unsubscribe);
    };
    return signal;
};
var $6acf272d514eb301$export$2e2bcd8739ae039 = $6acf272d514eb301$var$composeSignals;


function $44f51f0e59b934eb$export$71511d61b312f219(value, /** 0: await 1: delegate */ kind) {
    this.v = value;
    this.k = kind;
}


function $b14263dc72fcd840$export$71511d61b312f219(inner) {
    var iter = {}, waiting = false;
    function pump(key, value) {
        waiting = true;
        value = new Promise(function(resolve) {
            resolve(inner[key](value));
        });
        return {
            done: false,
            value: new (0, $44f51f0e59b934eb$export$71511d61b312f219)(value, /* kind: delegate */ 1)
        };
    }
    iter[typeof Symbol !== "undefined" && Symbol.iterator || "@@iterator"] = function() {
        return this;
    };
    iter.next = function(value) {
        if (waiting) {
            waiting = false;
            return value;
        }
        return pump("next", value);
    };
    if (typeof inner.throw === "function") iter.throw = function(value) {
        if (waiting) {
            waiting = false;
            throw value;
        }
        return pump("throw", value);
    };
    if (typeof inner.return === "function") iter.return = function(value) {
        if (waiting) {
            waiting = false;
            return value;
        }
        return pump("return", value);
    };
    return iter;
}


function $9630d115d03ffb62$export$71511d61b312f219(iterable) {
    var method, async, sync, retry = 2;
    for("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;){
        if (async && null != (method = iterable[async])) return method.call(iterable);
        if (sync && null != (method = iterable[sync])) return new $9630d115d03ffb62$var$AsyncFromSyncIterator(method.call(iterable));
        async = "@@asyncIterator", sync = "@@iterator";
    }
    throw new TypeError("Object is not async iterable");
}
function $9630d115d03ffb62$var$AsyncFromSyncIterator(s) {
    function AsyncFromSyncIteratorContinuation(r) {
        if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object."));
        var done = r.done;
        return Promise.resolve(r.value).then(function(value) {
            return {
                value: value,
                done: done
            };
        });
    }
    return $9630d115d03ffb62$var$AsyncFromSyncIterator = function(s) {
        this.s = s, this.n = s.next;
    }, $9630d115d03ffb62$var$AsyncFromSyncIterator.prototype = {
        s: null,
        n: null,
        next: function() {
            return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
        },
        return: function(value) {
            var ret = this.s.return;
            return void 0 === ret ? Promise.resolve({
                value: value,
                done: !0
            }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments));
        },
        throw: function(value) {
            var thr = this.s.return;
            return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments));
        }
    }, new $9630d115d03ffb62$var$AsyncFromSyncIterator(s);
}



var $1Mz1E = parcelRequire("1Mz1E");

function $42c45d5ce9cda8b5$export$71511d61b312f219(value) {
    return new (0, $44f51f0e59b934eb$export$71511d61b312f219)(value, /* kind: await */ 0);
}



function $db09894caf572385$export$71511d61b312f219(gen) {
    var front, back;
    function send(key, arg) {
        return new Promise(function(resolve, reject) {
            var request = {
                key: key,
                arg: arg,
                resolve: resolve,
                reject: reject,
                next: null
            };
            if (back) back = back.next = request;
            else {
                front = back = request;
                resume(key, arg);
            }
        });
    }
    function resume(key, arg) {
        try {
            var result = gen[key](arg);
            var value = result.value;
            var overloaded = value instanceof (0, $44f51f0e59b934eb$export$71511d61b312f219);
            Promise.resolve(overloaded ? value.v : value).then(function(arg) {
                if (overloaded) {
                    var nextKey = key === "return" ? "return" : "next";
                    if (!value.k || arg.done) return resume(nextKey, arg);
                    else arg = gen[nextKey](arg).value;
                }
                settle(result.done ? "return" : "normal", arg);
            }, function(err) {
                resume("throw", err);
            });
        } catch (err) {
            settle("throw", err);
        }
    }
    function settle(type, value) {
        switch(type){
            case "return":
                front.resolve({
                    value: value,
                    done: true
                });
                break;
            case "throw":
                front.reject(value);
                break;
            default:
                front.resolve({
                    value: value,
                    done: false
                });
                break;
        }
        front = front.next;
        if (front) resume(front.key, front.arg);
        else back = null;
    }
    this._invoke = send;
    if (typeof gen.return !== "function") this.return = undefined;
}
$db09894caf572385$export$71511d61b312f219.prototype[typeof Symbol === "function" && Symbol.asyncIterator || "@@asyncIterator"] = function() {
    return this;
};
$db09894caf572385$export$71511d61b312f219.prototype.next = function(arg) {
    return this._invoke("next", arg);
};
$db09894caf572385$export$71511d61b312f219.prototype.throw = function(arg) {
    return this._invoke("throw", arg);
};
$db09894caf572385$export$71511d61b312f219.prototype.return = function(arg) {
    return this._invoke("return", arg);
};


function $c1f5f572ccfff5c9$export$71511d61b312f219(fn) {
    return function() {
        return new (0, $db09894caf572385$export$71511d61b312f219)(fn.apply(this, arguments));
    };
}



var $iLZuz = parcelRequire("iLZuz");

var $6PS3Z = parcelRequire("6PS3Z");
var $a529be70d8488b1d$export$71b051935044bd5d = function streamChunk(chunk, chunkSize) {
    var len, pos, end;
    return (0, $iLZuz._)(this, function(_state) {
        switch(_state.label){
            case 0:
                len = chunk.byteLength;
                if (!(!chunkSize || len < chunkSize)) return [
                    3,
                    2
                ];
                return [
                    4,
                    chunk
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
            case 2:
                pos = 0;
                _state.label = 3;
            case 3:
                if (!(pos < len)) return [
                    3,
                    5
                ];
                end = pos + chunkSize;
                return [
                    4,
                    chunk.slice(pos, end)
                ];
            case 4:
                _state.sent();
                pos = end;
                return [
                    3,
                    3
                ];
            case 5:
                return [
                    2
                ];
        }
    });
};
var $a529be70d8488b1d$export$f9f241124ee3198e = function readBytes(iterable, chunkSize) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $c1f5f572ccfff5c9$export$71511d61b312f219)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        8,
                        13
                    ]);
                    _iterator = (0, $9630d115d03ffb62$export$71511d61b312f219)($a529be70d8488b1d$var$readStream(iterable));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        (0, $42c45d5ce9cda8b5$export$71511d61b312f219)(_iterator.next())
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        6
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        5,
                        (0, $6PS3Z.__values)((0, $b14263dc72fcd840$export$71511d61b312f219)((0, $9630d115d03ffb62$export$71511d61b312f219)($a529be70d8488b1d$export$71b051935044bd5d(chunk, chunkSize))))
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 6:
                    return [
                        3,
                        13
                    ];
                case 7:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        13
                    ];
                case 8:
                    _state.trys.push([
                        8,
                        ,
                        11,
                        12
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                        3,
                        10
                    ];
                    return [
                        4,
                        (0, $42c45d5ce9cda8b5$export$71511d61b312f219)(_iterator.return())
                    ];
                case 9:
                    _state.sent();
                    _state.label = 10;
                case 10:
                    return [
                        3,
                        12
                    ];
                case 11:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        7
                    ];
                case 13:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $a529be70d8488b1d$var$readStream = function readStream(stream) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $c1f5f572ccfff5c9$export$71511d61b312f219)(function() {
        var reader, _ref, done, value;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!stream[Symbol.asyncIterator]) return [
                        3,
                        2
                    ];
                    return [
                        5,
                        (0, $6PS3Z.__values)((0, $b14263dc72fcd840$export$71511d61b312f219)((0, $9630d115d03ffb62$export$71511d61b312f219)(stream)))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
                case 2:
                    reader = stream.getReader();
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        9,
                        11
                    ]);
                    _state.label = 4;
                case 4:
                    return [
                        4,
                        (0, $42c45d5ce9cda8b5$export$71511d61b312f219)(reader.read())
                    ];
                case 5:
                    _ref = _state.sent(), done = _ref.done, value = _ref.value;
                    if (done) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        value
                    ];
                case 6:
                    _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        4
                    ];
                case 8:
                    return [
                        3,
                        11
                    ];
                case 9:
                    return [
                        4,
                        (0, $42c45d5ce9cda8b5$export$71511d61b312f219)(reader.cancel())
                    ];
                case 10:
                    _state.sent();
                    return [
                        7
                    ];
                case 11:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $a529be70d8488b1d$export$b0119225647bd83 = function(stream, chunkSize, onProgress, onFinish) {
    var iterator = $a529be70d8488b1d$export$f9f241124ee3198e(stream, chunkSize);
    var bytes = 0;
    var done;
    var _onFinish = function(e) {
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        pull: function(controller) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                var _ref, done, value, len, loadedBytes, err;
                return (0, $iLZuz._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                iterator.next()
                            ];
                        case 1:
                            _ref = _state.sent(), done = _ref.done, value = _ref.value;
                            if (done) {
                                _onFinish();
                                controller.close();
                                return [
                                    2
                                ];
                            }
                            len = value.byteLength;
                            if (onProgress) {
                                loadedBytes = bytes += len;
                                onProgress(loadedBytes);
                            }
                            controller.enqueue(new Uint8Array(value));
                            return [
                                3,
                                3
                            ];
                        case 2:
                            err = _state.sent();
                            _onFinish(err);
                            throw err;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        cancel: function(reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






/**
 * Estimate data: URL byte lengths *without* allocating large buffers.
 * - Fetch percent-decodes a base64 body before decoding it.
 * - Node's Buffer.from(body, 'base64') sizes its backing allocation from the
 *   raw body, including ignored characters and content after padding.
 * - Non-base64 data is percent-decoded and then encoded as UTF-8.
 */ var $736927a056b9b88e$var$isHexDigit = function(charCode) {
    return charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
};
var $736927a056b9b88e$var$isPercentEncodedByte = function(str, i, len) {
    return i + 2 < len && $736927a056b9b88e$var$isHexDigit(str.charCodeAt(i + 1)) && $736927a056b9b88e$var$isHexDigit(str.charCodeAt(i + 2));
};
var $736927a056b9b88e$var$hexValue = function(charCode) {
    return charCode <= 57 ? charCode - 48 : (charCode & 0xdf) - 55;
};
var $736927a056b9b88e$var$isBase64Char = function(charCode) {
    return charCode >= 65 && charCode <= 90 || // A-Z
    charCode >= 97 && charCode <= 122 || // a-z
    charCode >= 48 && charCode <= 57 || // 0-9
    charCode === 43 || // +
    charCode === 47 || // /
    charCode === 45 || // - (base64url)
    charCode === 95;
}; // _ (base64url)
var $736927a056b9b88e$var$isBase64Whitespace = function(charCode) {
    return charCode === 9 || charCode === 10 || charCode === 12 || charCode === 13 || charCode === 32;
};
var $736927a056b9b88e$var$base64Bytes = function(significant) {
    var groups = Math.floor(significant / 4);
    var remainder = significant % 4;
    return groups * 3 + (remainder === 2 ? 1 : remainder === 3 ? 2 : 0);
};
// Buffer.byteLength(body, 'base64') uses the raw string length as an allocation
// upper bound even when Buffer.from later ignores characters or stops at '='.
var $736927a056b9b88e$var$estimateBase64BufferAllocation = function(body) {
    var len = body.length;
    var padding = 0;
    if (len > 0 && body.charCodeAt(len - 1) === 61 /* '=' */ ) {
        padding++;
        if (len > 1 && body.charCodeAt(len - 2) === 61 /* '=' */ ) padding++;
    }
    return Math.floor((len - padding) * 3 / 4);
};
var $736927a056b9b88e$var$estimatePercentDecodedBase64Bytes = function(body) {
    var len = body.length;
    var significant = 0;
    var padding = 0;
    var invalid = false;
    for(var i = 0; i < len; i++){
        var code = body.charCodeAt(i);
        if (code === 37 /* '%' */  && $736927a056b9b88e$var$isPercentEncodedByte(body, i, len)) {
            code = $736927a056b9b88e$var$hexValue(body.charCodeAt(i + 1)) * 16 + $736927a056b9b88e$var$hexValue(body.charCodeAt(i + 2));
            i += 2;
        }
        if ($736927a056b9b88e$var$isBase64Whitespace(code)) continue;
        if (code === 61 /* '=' */ ) {
            padding++;
            continue;
        }
        if (!$736927a056b9b88e$var$isBase64Char(code) || padding > 0) {
            invalid = true;
            continue;
        }
        significant++;
    }
    // Fetch rejects malformed forgiving-base64 input. Returning the raw-size
    // allocation bound keeps that invalid input from becoming a pre-check bypass.
    if (invalid || padding > 2 || padding > 0 && (significant + padding) % 4 !== 0 || significant % 4 === 1) return $736927a056b9b88e$var$estimateBase64BufferAllocation(body);
    return $736927a056b9b88e$var$base64Bytes(significant);
};
var $736927a056b9b88e$var$estimateDataURLBytes = function(url, estimateBase64) {
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    var comma = url.indexOf(',');
    if (comma < 0) return 0;
    var meta = url.slice(5, comma);
    var body = url.slice(comma + 1);
    var isBase64 = /;base64/i.test(meta);
    if (isBase64) return estimateBase64(body);
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    var bytes = 0;
    for(var i = 0, len = body.length; i < len; i++){
        var c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && $736927a056b9b88e$var$isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            var next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
};
function $736927a056b9b88e$export$2e2bcd8739ae039(url) {
    // Fetch removes URL fragments before processing a data: URL.
    var fragmentIndex = typeof url === 'string' ? url.indexOf('#') : -1;
    return $736927a056b9b88e$var$estimateDataURLBytes(fragmentIndex === -1 ? url : url.slice(0, fragmentIndex), $736927a056b9b88e$var$estimatePercentDecodedBase64Bytes);
}
function $736927a056b9b88e$export$1f39e64b554a246f(url) {
    return $736927a056b9b88e$var$estimateDataURLBytes(url, $736927a056b9b88e$var$estimateBase64BufferAllocation);
}


var $3b06195f6625dbe1$export$a4ad2735b021c132 = "1.20.0";



var $04aed082eee974b7$var$DEFAULT_CHUNK_SIZE = 65536;
var $04aed082eee974b7$var$DEFAULT_REQUEST_OPTIONS = {
    cache: 'default',
    redirect: 'follow',
    referrer: 'about:client',
    referrerPolicy: '',
    mode: 'cors',
    integrity: '',
    keepalive: false,
    priority: 'auto',
    window: null
};
var $04aed082eee974b7$var$isFunction = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isFunction;
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ var $04aed082eee974b7$var$encodeUTF8 = function(str) {
    return encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, function(_, hex) {
        return String.fromCharCode(parseInt(hex, 16));
    });
};
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
var $04aed082eee974b7$var$decodeURIComponentSafe = function(value) {
    if (!(0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
var $04aed082eee974b7$var$test = function(fn) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    try {
        return !!fn.apply(void 0, (0, $6zk1M._)(args));
    } catch (e) {
        return false;
    }
};
var $04aed082eee974b7$var$maybeWithAuthCredentials = function(url) {
    var protocolIndex = url.indexOf('://');
    var urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
var $04aed082eee974b7$var$factory = function(env) {
    var globalObject = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).global !== undefined && (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).global !== null ? (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).global : globalThis;
    var ReadableStream = globalObject.ReadableStream, TextEncoder = globalObject.TextEncoder;
    env = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    var envFetch = env.fetch, Request = env.Request, Response = env.Response;
    var isFetchSupported = envFetch ? $04aed082eee974b7$var$isFunction(envFetch) : typeof fetch === 'function';
    var isRequestSupported = $04aed082eee974b7$var$isFunction(Request);
    var isResponseSupported = $04aed082eee974b7$var$isFunction(Response);
    if (!isFetchSupported) return false;
    var isReadableStreamSupported = isFetchSupported && $04aed082eee974b7$var$isFunction(ReadableStream);
    var encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? function(encoder) {
        return function(str) {
            return encoder.encode(str);
        };
    }(new TextEncoder()) : function(str) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var _;
            return (0, $iLZuz._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ = Uint8Array.bind;
                        return [
                            4,
                            new Request(str).arrayBuffer()
                        ];
                    case 1:
                        return [
                            2,
                            new (_.apply(Uint8Array, [
                                void 0,
                                _state.sent()
                            ]))
                        ];
                }
            });
        })();
    });
    var supportsRequestStream = isRequestSupported && isReadableStreamSupported && $04aed082eee974b7$var$test(function() {
        var duplexAccessed = false;
        var request = new Request((0, $8feb31e97706e1f3$export$2e2bcd8739ae039).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        var hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    var supportsResponseStream = isResponseSupported && isReadableStreamSupported && $04aed082eee974b7$var$test(function() {
        return (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isReadableStream(new Response('').body);
    });
    var resolvers = {
        stream: supportsResponseStream && function(res) {
            return res.body;
        }
    };
    isFetchSupported && function() {
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach(function(type) {
            !resolvers[type] && (resolvers[type] = function(res, config) {
                var method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039)("Response type '".concat(type, "' is not supported"), (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    }();
    var getBodyLength = function(body) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var _request;
            return (0, $iLZuz._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (body == null) return [
                            2,
                            0
                        ];
                        if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isBlob(body)) return [
                            2,
                            body.size
                        ];
                        if (!(0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isSpecCompliantForm(body)) return [
                            3,
                            2
                        ];
                        _request = new Request((0, $8feb31e97706e1f3$export$2e2bcd8739ae039).origin, {
                            method: 'POST',
                            body: body
                        });
                        return [
                            4,
                            _request.arrayBuffer()
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent().byteLength
                        ];
                    case 2:
                        if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isArrayBuffer(body)) return [
                            2,
                            body.byteLength
                        ];
                        if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
                        if (!(0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isString(body)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            encodeText(body)
                        ];
                    case 3:
                        return [
                            2,
                            _state.sent().byteLength
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    var resolveBodyLength = function(headers, body) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var length;
            return (0, $iLZuz._)(this, function(_state) {
                length = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
                return [
                    2,
                    length == null ? getBodyLength(body) : length
                ];
            });
        })();
    };
    return function(config) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var _resolveConfig, url, method, data, signal, cancelToken, timeout, onDownloadProgress, onUploadProgress, responseType, headers, _resolveConfig_withCredentials, withCredentials, fetchOptions, maxContentLength, maxBodyLength, maxRedirects, hasMaxContentLength, hasMaxBodyLength, own, _fetch, composedSignal, request, unsubscribe, requestContentLength, pendingBodyError, maxBodyLengthError, auth, configAuth, username, password, parsedURL, urlUsername, urlPassword, estimated, outboundLength, mustEnforceStreamBody, trackRequestStream, _tmp, _request, contentTypeHeader, _ref, onProgress, flush, isCredentialsSupported, contentType, safeFetchOptions, resolvedOptions, response, responseHeaders, declaredLength, isStreamResponse, options, responseContentLength, _ref1, onProgress1, flush1, bytesRead, onChunkProgress, responseData, materializedSize, err, canceledError, networkError;
            return (0, $iLZuz._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _resolveConfig = (0, $9f56b5d281d652bf$export$2e2bcd8739ae039)(config), url = _resolveConfig.url, method = _resolveConfig.method, data = _resolveConfig.data, signal = _resolveConfig.signal, cancelToken = _resolveConfig.cancelToken, timeout = _resolveConfig.timeout, onDownloadProgress = _resolveConfig.onDownloadProgress, onUploadProgress = _resolveConfig.onUploadProgress, responseType = _resolveConfig.responseType, headers = _resolveConfig.headers, _resolveConfig_withCredentials = _resolveConfig.withCredentials, withCredentials = _resolveConfig_withCredentials === void 0 ? 'same-origin' : _resolveConfig_withCredentials, fetchOptions = _resolveConfig.fetchOptions, maxContentLength = _resolveConfig.maxContentLength, maxBodyLength = _resolveConfig.maxBodyLength, maxRedirects = _resolveConfig.maxRedirects;
                        hasMaxContentLength = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isNumber(maxContentLength) && maxContentLength > -1;
                        hasMaxBodyLength = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isNumber(maxBodyLength) && maxBodyLength > -1;
                        own = function(key) {
                            return (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).hasOwnProp(config, key) ? config[key] : undefined;
                        };
                        _fetch = envFetch || fetch;
                        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
                        composedSignal = (0, $6acf272d514eb301$export$2e2bcd8739ae039)([
                            signal,
                            cancelToken && cancelToken.toAbortSignal()
                        ], timeout);
                        request = null;
                        unsubscribe = composedSignal && composedSignal.unsubscribe && function() {
                            composedSignal.unsubscribe();
                        };
                        // AxiosError we raise while the request body is being streamed. Captured
                        // by identity so the catch block can surface it directly, regardless of
                        // how the runtime wraps the resulting fetch rejection (undici exposes it
                        // as `err.cause`; some browsers drop the original error entirely).
                        pendingBodyError = null;
                        maxBodyLengthError = function() {
                            return new (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039)('Request body larger than maxBodyLength limit', (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config, request);
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            12,
                            ,
                            13
                        ]);
                        // HTTP basic authentication
                        auth = undefined;
                        configAuth = own('auth');
                        if (configAuth) {
                            username = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).getSafeProp(configAuth, 'username') || '';
                            password = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).getSafeProp(configAuth, 'password') || '';
                            auth = {
                                username: username,
                                password: password
                            };
                        }
                        if ($04aed082eee974b7$var$maybeWithAuthCredentials(url)) {
                            parsedURL = new URL(url, (0, $8feb31e97706e1f3$export$2e2bcd8739ae039).origin);
                            if (!auth && (parsedURL.username || parsedURL.password)) {
                                urlUsername = $04aed082eee974b7$var$decodeURIComponentSafe(parsedURL.username);
                                urlPassword = $04aed082eee974b7$var$decodeURIComponentSafe(parsedURL.password);
                                auth = {
                                    username: urlUsername,
                                    password: urlPassword
                                };
                            }
                            if (parsedURL.username || parsedURL.password) {
                                parsedURL.username = '';
                                parsedURL.password = '';
                                url = parsedURL.href;
                            }
                        }
                        if (auth) {
                            headers.delete('authorization');
                            headers.set('Authorization', 'Basic ' + btoa($04aed082eee974b7$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
                        }
                        // Enforce maxContentLength for data: URLs up-front so we never materialize
                        // an oversized payload. The HTTP adapter applies the same check (see http.js
                        // "if (protocol === 'data:')" branch).
                        if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                            estimated = (0, $736927a056b9b88e$export$2e2bcd8739ae039)(url);
                            if (estimated > maxContentLength) throw new (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                        }
                        if (!(hasMaxBodyLength && method !== 'get' && method !== 'head')) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            getBodyLength(data)
                        ];
                    case 2:
                        outboundLength = _state.sent();
                        if (typeof outboundLength === 'number' && isFinite(outboundLength)) {
                            requestContentLength = outboundLength;
                            if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                        }
                        _state.label = 3;
                    case 3:
                        // A streamed body under maxBodyLength must be counted as fetch consumes
                        // it; its size is never trusted from a caller-declared Content-Length.
                        mustEnforceStreamBody = hasMaxBodyLength && ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isReadableStream(data) || (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isStream(data));
                        trackRequestStream = function(stream, onProgress, flush) {
                            return (0, $a529be70d8488b1d$export$b0119225647bd83)(stream, $04aed082eee974b7$var$DEFAULT_CHUNK_SIZE, function(loadedBytes) {
                                if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                                onProgress && onProgress(loadedBytes);
                            }, flush);
                        };
                        if (!(supportsRequestStream && method !== 'get' && method !== 'head' && (onUploadProgress || mustEnforceStreamBody))) return [
                            3,
                            7
                        ];
                        if (!(requestContentLength == null)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            resolveBodyLength(headers, data)
                        ];
                    case 4:
                        _tmp = _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 5:
                        _tmp = requestContentLength;
                        _state.label = 6;
                    case 6:
                        requestContentLength = _tmp;
                        // A declared length of 0 is only trusted to skip the wrap when we are
                        // not enforcing a stream limit (which must not rely on that header).
                        if (requestContentLength !== 0 || mustEnforceStreamBody) {
                            _request = new Request(url, {
                                method: 'POST',
                                body: data,
                                duplex: 'half'
                            });
                            ;
                            if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                            if (_request.body) {
                                _ref = (0, $21h22._)(onUploadProgress && (0, $93480ef9fbbde9f0$export$d9fadd12586c18d6)(requestContentLength, (0, $93480ef9fbbde9f0$export$c1b28109d46c3592)((0, $93480ef9fbbde9f0$export$5d35863c355a22a9)(onUploadProgress))) || [], 2), onProgress = _ref[0], flush = _ref[1];
                                data = trackRequestStream(_request.body, onProgress, flush);
                            }
                        }
                        return [
                            3,
                            8
                        ];
                    case 7:
                        if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== 'get' && method !== 'head') data = trackRequestStream(data);
                        else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== 'get' && method !== 'head') throw new (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039)('Stream request bodies are not supported by the current fetch implementation', (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config, request);
                        _state.label = 8;
                    case 8:
                        if (!(0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
                        // Cloudflare Workers throws when credentials are defined
                        // see https://github.com/cloudflare/workerd/issues/902
                        isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
                        // If data is FormData and Content-Type is multipart/form-data without boundary,
                        // delete it so fetch can set it correctly with the boundary
                        if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isFormData(data)) {
                            contentType = headers.getContentType();
                            if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
                        }
                        // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
                        headers.set('User-Agent', 'axios/' + (0, $3b06195f6625dbe1$export$a4ad2735b021c132), false);
                        safeFetchOptions = fetchOptions == null ? fetchOptions : Object.assign(Object.create(null), fetchOptions);
                        if (safeFetchOptions) {
                            // These options are owned by Axios and are already reflected in the
                            // resolved Request passed to fetch.
                            delete safeFetchOptions.body;
                            delete safeFetchOptions.headers;
                            delete safeFetchOptions.method;
                            delete safeFetchOptions.signal;
                            delete safeFetchOptions.duplex;
                            delete safeFetchOptions.credentials;
                        }
                        resolvedOptions = Object.assign(Object.create(null), safeFetchOptions, {
                            signal: composedSignal,
                            method: method.toUpperCase(),
                            headers: (0, $3d267e8cadaf0dda$export$c30c72bb7e677d54)(headers.normalize()),
                            body: data,
                            duplex: 'half',
                            credentials: isCredentialsSupported ? withCredentials : undefined
                        });
                        if (isRequestSupported) {
                            (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).forEach($04aed082eee974b7$var$DEFAULT_REQUEST_OPTIONS, function(value, key) {
                                if (resolvedOptions[key] === undefined) resolvedOptions[key] = value;
                            });
                            if (resolvedOptions.signal === undefined) resolvedOptions.signal = null;
                            if (resolvedOptions.body === undefined) resolvedOptions.body = null;
                        }
                        if (maxRedirects === 0) {
                            resolvedOptions.redirect = 'manual';
                            if (safeFetchOptions) safeFetchOptions.redirect = 'manual';
                        }
                        request = isRequestSupported && new Request(url, resolvedOptions);
                        return [
                            4,
                            isRequestSupported ? _fetch(request, safeFetchOptions) : _fetch(url, resolvedOptions)
                        ];
                    case 9:
                        response = _state.sent();
                        responseHeaders = (0, $04a1252241532790$export$2e2bcd8739ae039).from(response.headers);
                        // Cheap pre-check: if the server honestly declares a content-length that
                        // already exceeds the cap, reject before we start streaming.
                        if (hasMaxContentLength) {
                            declaredLength = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                            if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                        }
                        isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
                        if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                            options = {};
                            [
                                'status',
                                'statusText',
                                'headers'
                            ].forEach(function(prop) {
                                options[prop] = response[prop];
                            });
                            responseContentLength = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                            _ref1 = (0, $21h22._)(onDownloadProgress && (0, $93480ef9fbbde9f0$export$d9fadd12586c18d6)(responseContentLength, (0, $93480ef9fbbde9f0$export$c1b28109d46c3592)((0, $93480ef9fbbde9f0$export$5d35863c355a22a9)(onDownloadProgress), true)) || [], 2), onProgress1 = _ref1[0], flush1 = _ref1[1];
                            bytesRead = 0;
                            onChunkProgress = function(loadedBytes) {
                                if (hasMaxContentLength) {
                                    bytesRead = loadedBytes;
                                    if (bytesRead > maxContentLength) throw new (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                                }
                                onProgress1 && onProgress1(loadedBytes);
                            };
                            response = new Response((0, $a529be70d8488b1d$export$b0119225647bd83)(response.body, $04aed082eee974b7$var$DEFAULT_CHUNK_SIZE, onChunkProgress, function() {
                                flush1 && flush1();
                                unsubscribe && unsubscribe();
                            }), options);
                        }
                        responseType = responseType || 'text';
                        return [
                            4,
                            resolvers[(0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config)
                        ];
                    case 10:
                        responseData = _state.sent();
                        // Fallback enforcement for environments without ReadableStream support
                        // (legacy runtimes). Detect materialized size from typed output; skip
                        // streams/Response passthrough since the user will read those themselves.
                        if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                            ;
                            if (responseData != null) {
                                if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                                else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                                else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                            }
                            if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                        }
                        !isStreamResponse && unsubscribe && unsubscribe();
                        return [
                            4,
                            new Promise(function(resolve, reject) {
                                (0, $f1f30840a93e520c$export$2e2bcd8739ae039)(resolve, reject, {
                                    data: responseData,
                                    headers: (0, $04a1252241532790$export$2e2bcd8739ae039).from(response.headers),
                                    status: response.status,
                                    statusText: response.statusText,
                                    config: config,
                                    request: request
                                });
                            })
                        ];
                    case 11:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 12:
                        err = _state.sent();
                        unsubscribe && unsubscribe();
                        // Safari can surface fetch aborts as a DOMException-like object whose
                        // branded getters throw. Prefer our composed signal reason before reading
                        // the caught error, preserving timeout vs cancellation semantics.
                        if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039)) {
                            canceledError = composedSignal.reason;
                            canceledError.config = config;
                            request && (canceledError.request = request);
                            if (err !== canceledError) // Non-enumerable to match native Error `cause` semantics so loggers
                            // don't recurse into circular fetch internals (see #7205).
                            Object.defineProperty(canceledError, 'cause', {
                                __proto__: null,
                                value: err,
                                writable: true,
                                enumerable: false,
                                configurable: true
                            });
                            throw canceledError;
                        }
                        // Surface a maxBodyLength violation we raised while the request body was
                        // being streamed. Matching by identity (rather than reading
                        // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
                        // and avoids both prototype-pollution reads and mis-attributing a foreign
                        // AxiosError that merely happened to land in `err.cause`.
                        if (pendingBodyError) {
                            request && !pendingBodyError.request && (pendingBodyError.request = request);
                            throw pendingBodyError;
                        }
                        // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
                        // pre-checks, response size enforcement) without re-wrapping them.
                        if (err instanceof (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039)) {
                            request && !err.request && (err.request = request);
                            throw err;
                        }
                        if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
                            networkError = new (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039)('Network Error', (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response);
                            // Non-enumerable to match native Error `cause` semantics so loggers
                            // don't recurse into circular fetch internals (see #7205).
                            Object.defineProperty(networkError, 'cause', {
                                __proto__: null,
                                value: err.cause || err,
                                writable: true,
                                enumerable: false,
                                configurable: true
                            });
                            throw networkError;
                        }
                        throw (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    };
};
var $04aed082eee974b7$var$seedCache = new Map();
var $04aed082eee974b7$export$3105c6651375d4fa = function(config) {
    var env = config && config.env || {};
    var fetch1 = env.fetch, Request = env.Request, Response = env.Response;
    var seeds = [
        Request,
        Response,
        fetch1
    ];
    var len = seeds.length, i = len, seed, target, map = $04aed082eee974b7$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $04aed082eee974b7$var$factory(env));
        map = target;
    }
    return target;
};
var $04aed082eee974b7$var$adapter = $04aed082eee974b7$export$3105c6651375d4fa();
var $04aed082eee974b7$export$2e2bcd8739ae039 = $04aed082eee974b7$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ var $2efaa1fee131f2b1$var$knownAdapters = {
    http: (0, $7f37bc1a5a507c65$export$2e2bcd8739ae039),
    xhr: (0, $d893a30218208208$export$2e2bcd8739ae039),
    fetch: {
        get: $04aed082eee974b7$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).forEach($2efaa1fee131f2b1$var$knownAdapters, function(fn, value) {
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ var $2efaa1fee131f2b1$var$renderReason = function(reason) {
    return "- ".concat(reason);
};
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ var $2efaa1fee131f2b1$var$isResolvedHandle = function(adapter) {
    return (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
};
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $2efaa1fee131f2b1$var$getAdapter(adapters, config) {
    adapters = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    var length = adapters.length;
    var nameOrAdapter;
    var adapter;
    var rejectedReasons = {};
    for(var i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        var id = void 0;
        adapter = nameOrAdapter;
        if (!$2efaa1fee131f2b1$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $2efaa1fee131f2b1$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039)("Unknown adapter '".concat(id, "'"));
        }
        if (adapter && ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        var reasons = Object.entries(rejectedReasons).map(function(param) {
            var _param = (0, $21h22._)(param, 2), id = _param[0], state = _param[1];
            return "adapter ".concat(id, " ") + (state === false ? 'is not supported by the environment' : 'is not available in the build');
        });
        var s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($2efaa1fee131f2b1$var$renderReason).join('\n') : ' ' + $2efaa1fee131f2b1$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039)("There is no suitable adapter to dispatch the request " + s, (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $2efaa1fee131f2b1$export$2e2bcd8739ae039 = {
    /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ getAdapter: $2efaa1fee131f2b1$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $2efaa1fee131f2b1$var$knownAdapters
};



'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $8d2f9c2e2db62612$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $22cd54147a3afac2$export$2e2bcd8739ae039)(null, config);
}
function $8d2f9c2e2db62612$export$2e2bcd8739ae039(_config) {
    // Interceptors may replace the merged config with an ordinary object. Flatten
    // it at the dispatch boundary so shared prototype members cannot become
    // request behavior, while preserving intentional template/class members.
    var config = (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).toSafeFlatObject(_config);
    $8d2f9c2e2db62612$var$throwIfCancellationRequested(config);
    config.headers = (0, $04a1252241532790$export$2e2bcd8739ae039).from((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).getSafeProp(config, 'headers'));
    // Transform request data
    config.data = (0, $807b146aacf21b81$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    var adapter = (0, $2efaa1fee131f2b1$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $dbe0f2b7eb8069ce$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $8d2f9c2e2db62612$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $807b146aacf21b81$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $04a1252241532790$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $d7256a7d37d85f2e$export$2e2bcd8739ae039)(reason)) {
            $8d2f9c2e2db62612$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $807b146aacf21b81$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $04a1252241532790$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}






var $2bfPH = parcelRequire("2bfPH");


'use strict';
var $88a9f131d9df9200$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach(function(type, i) {
    $88a9f131d9df9200$var$validators[type] = function validator(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, $2bfPH._)(thing)) === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
var $88a9f131d9df9200$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $88a9f131d9df9200$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $3b06195f6625dbe1$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$88a9f131d9df9200$var$deprecatedWarnings[opt]) {
            $88a9f131d9df9200$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$88a9f131d9df9200$var$validators.spelling = function spelling(correctSpelling) {
    return function(value, opt) {
        // eslint-disable-next-line no-console
        console.warn("".concat(opt, " is likely a misspelling of ").concat(correctSpelling));
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $88a9f131d9df9200$var$assertOptions(options, schema, allowUnknown) {
    if ((typeof options === "undefined" ? "undefined" : (0, $2bfPH._)(options)) !== 'object' || options === null) throw new (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039)('options must be an object', (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        var validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $88a9f131d9df9200$export$2e2bcd8739ae039 = {
    assertOptions: $88a9f131d9df9200$var$assertOptions,
    validators: $88a9f131d9df9200$var$validators
};




'use strict';
var $cadd2b8bf935de77$var$validators = (0, $88a9f131d9df9200$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ var $cadd2b8bf935de77$var$Axios = /*#__PURE__*/ function() {
    function Axios(instanceConfig) {
        (0, $gd0sY._)(this, Axios);
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $6dabe340a72bef76$export$2e2bcd8739ae039)(),
            response: new (0, $6dabe340a72bef76$export$2e2bcd8739ae039)()
        };
    }
    (0, $7cSld._)(Axios, [
        {
            key: "request",
            value: /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ function request(configOrUrl, config) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                    var err, dummy, dummyStack, stack, firstNewlineIndex, firstNewlineIndex1, secondNewlineIndex, stackWithoutTwoTopLines;
                    return (0, $iLZuz._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    this._request(configOrUrl, config)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                err = _state.sent();
                                if (err instanceof Error) try {
                                    dummy = {};
                                    Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                                    dummyStack = dummy.stack;
                                    stack = '';
                                    // slice off the Error: ... line
                                    if (typeof dummyStack === 'string') {
                                        firstNewlineIndex = dummyStack.indexOf('\n');
                                        stack = firstNewlineIndex === -1 ? '' : dummyStack.slice(firstNewlineIndex + 1);
                                    }
                                    if (!err.stack) err.stack = stack;
                                    else if (stack) {
                                        firstNewlineIndex1 = stack.indexOf('\n');
                                        secondNewlineIndex = firstNewlineIndex1 === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex1 + 1);
                                        stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                                        if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                                    }
                                } catch (e) {
                                // Ignore failures from custom stack hooks or un-writable stack properties.
                                }
                                throw err;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "_request",
            value: function _request(configOrUrl, config) {
                var _this = this;
                /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
                if (typeof configOrUrl === 'string') {
                    config = config || {};
                    config.url = configOrUrl;
                } else config = configOrUrl || {};
                config = (0, $9e2d44d1266464bc$export$2e2bcd8739ae039)(this.defaults, config);
                var transitional = config.transitional, paramsSerializer = config.paramsSerializer, headers = config.headers;
                if (transitional !== undefined) (0, $88a9f131d9df9200$export$2e2bcd8739ae039).assertOptions(transitional, {
                    silentJSONParsing: $cadd2b8bf935de77$var$validators.transitional($cadd2b8bf935de77$var$validators.boolean),
                    forcedJSONParsing: $cadd2b8bf935de77$var$validators.transitional($cadd2b8bf935de77$var$validators.boolean),
                    clarifyTimeoutError: $cadd2b8bf935de77$var$validators.transitional($cadd2b8bf935de77$var$validators.boolean),
                    legacyInterceptorReqResOrdering: $cadd2b8bf935de77$var$validators.transitional($cadd2b8bf935de77$var$validators.boolean),
                    advertiseZstdAcceptEncoding: $cadd2b8bf935de77$var$validators.transitional($cadd2b8bf935de77$var$validators.boolean),
                    validateStatusUndefinedResolves: $cadd2b8bf935de77$var$validators.transitional($cadd2b8bf935de77$var$validators.boolean)
                }, false);
                if (paramsSerializer != null) {
                    if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                        serialize: paramsSerializer
                    };
                    else (0, $88a9f131d9df9200$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                        encode: $cadd2b8bf935de77$var$validators.function,
                        serialize: $cadd2b8bf935de77$var$validators.function
                    }, true);
                }
                // Set config.allowAbsoluteUrls
                if (config.allowAbsoluteUrls !== undefined) ;
                else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
                else config.allowAbsoluteUrls = true;
                (0, $88a9f131d9df9200$export$2e2bcd8739ae039).assertOptions(config, {
                    baseUrl: $cadd2b8bf935de77$var$validators.spelling('baseURL'),
                    withXsrfToken: $cadd2b8bf935de77$var$validators.spelling('withXSRFToken')
                }, true);
                // Set config.method
                config.method = ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).getSafeProp(config, 'method') || (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).getSafeProp(this.defaults, 'method') || 'get').toLowerCase();
                // Flatten headers
                var contextHeaders = headers && (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
                headers && (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).forEach((0, $1916f923f08c72c1$export$2e2bcd8739ae039).concat('common'), function(method) {
                    delete headers[method];
                });
                config.headers = (0, $04a1252241532790$export$2e2bcd8739ae039).concat(contextHeaders, headers);
                // filter out skipped interceptors
                var requestInterceptorChain = [];
                var synchronousRequestInterceptors = true;
                this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
                    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
                    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
                    var transitional = config.transitional || (0, $3ff60df591703cf6$export$2e2bcd8739ae039);
                    var legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
                    if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
                    else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
                });
                var responseInterceptorChain = [];
                this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
                    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
                });
                var promise;
                var i = 0;
                var len;
                if (!synchronousRequestInterceptors) {
                    var _chain, _chain1;
                    var chain = [
                        (0, $8d2f9c2e2db62612$export$2e2bcd8739ae039).bind(this),
                        undefined
                    ];
                    (_chain = chain).unshift.apply(_chain, (0, $6zk1M._)(requestInterceptorChain));
                    (_chain1 = chain).push.apply(_chain1, (0, $6zk1M._)(responseInterceptorChain));
                    len = chain.length;
                    promise = Promise.resolve(config);
                    while(i < len)promise = promise.then(chain[i++], chain[i++]);
                    return promise;
                }
                len = requestInterceptorChain.length;
                var newConfig = config;
                while(i < len){
                    var onFulfilled = requestInterceptorChain[i++];
                    var onRejected = requestInterceptorChain[i++];
                    try {
                        newConfig = onFulfilled ? onFulfilled(newConfig) : newConfig;
                    } catch (error) {
                        if (!onRejected) {
                            promise = Promise.reject(error);
                            break;
                        }
                        try {
                            var rejectedResult = onRejected.call(this, error);
                            if ((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isThenable(rejectedResult)) promise = Promise.resolve(rejectedResult).then(function() {
                                return (0, $8d2f9c2e2db62612$export$2e2bcd8739ae039).call(_this, newConfig);
                            });
                        } catch (rejectedError) {
                            promise = Promise.reject(rejectedError);
                        }
                        break;
                    }
                }
                if (!promise) try {
                    promise = (0, $8d2f9c2e2db62612$export$2e2bcd8739ae039).call(this, newConfig);
                } catch (error) {
                    promise = Promise.reject(error);
                }
                i = 0;
                len = responseInterceptorChain.length;
                while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
                return promise;
            }
        },
        {
            key: "getUri",
            value: function getUri(config) {
                config = (0, $9e2d44d1266464bc$export$2e2bcd8739ae039)(this.defaults, config);
                var fullPath = (0, $35a666b8f5497d94$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
                return (0, $06b1d73e713c56eb$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
            }
        }
    ]);
    return Axios;
}();
// Provide aliases for supported request methods
(0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $cadd2b8bf935de77$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $9e2d44d1266464bc$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: config && (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).hasOwnProp(config, 'data') ? config.data : undefined
        }));
    };
});
(0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $9e2d44d1266464bc$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $cadd2b8bf935de77$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $cadd2b8bf935de77$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $cadd2b8bf935de77$export$2e2bcd8739ae039 = $cadd2b8bf935de77$var$Axios;







var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ var $e20b2d2817632610$var$CancelToken = /*#__PURE__*/ function() {
    function CancelToken(executor) {
        (0, $gd0sY._)(this, CancelToken);
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        var resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        var token = this;
        // eslint-disable-next-line func-names
        this.promise.then(function(cancel) {
            if (!token._listeners) return;
            var i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = function(onfulfilled) {
            var _resolve;
            // eslint-disable-next-line func-names
            var promise = new Promise(function(resolve) {
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $22cd54147a3afac2$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    (0, $7cSld._)(CancelToken, [
        {
            /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ key: "throwIfRequested",
            value: function throwIfRequested() {
                if (this.reason) throw this.reason;
            }
        },
        {
            /**
   * Subscribe to the cancel signal
   */ key: "subscribe",
            value: function subscribe(listener) {
                if (this.reason) {
                    listener(this.reason);
                    return;
                }
                if (this._listeners) this._listeners.push(listener);
                else this._listeners = [
                    listener
                ];
            }
        },
        {
            /**
   * Unsubscribe from the cancel signal
   */ key: "unsubscribe",
            value: function unsubscribe(listener) {
                if (!this._listeners) return;
                var index = this._listeners.indexOf(listener);
                if (index !== -1) this._listeners.splice(index, 1);
            }
        },
        {
            key: "toAbortSignal",
            value: function toAbortSignal() {
                var _this = this;
                var controller = new AbortController();
                var abort = function(err) {
                    controller.abort(err);
                };
                this.subscribe(abort);
                controller.signal.unsubscribe = function() {
                    return _this.unsubscribe(abort);
                };
                return controller.signal;
            }
        }
    ], [
        {
            key: "source",
            value: /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ function source() {
                var cancel;
                var token = new CancelToken(function executor(c) {
                    cancel = c;
                });
                return {
                    token: token,
                    cancel: cancel
                };
            }
        }
    ]);
    return CancelToken;
}();
var $e20b2d2817632610$export$2e2bcd8739ae039 = $e20b2d2817632610$var$CancelToken;






'use strict';
function $27e1575c63fd772f$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $fdeaa6e810f5330e$export$2e2bcd8739ae039(payload) {
    return (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}





var $21h22 = parcelRequire("21h22");
var $bdcc2a67627b0050$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    /**
   * @deprecated Use `ContentTooLarge` instead.
   */ PayloadTooLarge: 413,
    ContentTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    /**
   * @deprecated Use `UnprocessableContent` instead.
   */ UnprocessableEntity: 422,
    UnprocessableContent: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerReturnsAnUnknownError: 520,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($bdcc2a67627b0050$var$HttpStatusCode).forEach(function(param) {
    var _param = (0, $21h22._)(param, 2), key = _param[0], value = _param[1];
    if ($bdcc2a67627b0050$var$HttpStatusCode[value] === undefined) $bdcc2a67627b0050$var$HttpStatusCode[value] = key;
});
var $bdcc2a67627b0050$export$2e2bcd8739ae039 = $bdcc2a67627b0050$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $00bae815612f32bf$var$createInstance(defaultConfig) {
    var context = new (0, $cadd2b8bf935de77$export$2e2bcd8739ae039)(defaultConfig);
    var instance = (0, $1b1301b4e217f9ec$export$2e2bcd8739ae039)((0, $cadd2b8bf935de77$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).extend(instance, (0, $cadd2b8bf935de77$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $00bae815612f32bf$var$createInstance((0, $9e2d44d1266464bc$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $00bae815612f32bf$var$axios = $00bae815612f32bf$var$createInstance((0, $dbe0f2b7eb8069ce$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$00bae815612f32bf$var$axios.Axios = (0, $cadd2b8bf935de77$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$00bae815612f32bf$var$axios.CanceledError = (0, $22cd54147a3afac2$export$2e2bcd8739ae039);
$00bae815612f32bf$var$axios.CancelToken = (0, $e20b2d2817632610$export$2e2bcd8739ae039);
$00bae815612f32bf$var$axios.isCancel = (0, $d7256a7d37d85f2e$export$2e2bcd8739ae039);
$00bae815612f32bf$var$axios.VERSION = (0, $3b06195f6625dbe1$export$a4ad2735b021c132);
$00bae815612f32bf$var$axios.toFormData = (0, $820b2ad2216a17dd$export$2e2bcd8739ae039);
// Expose AxiosError class
$00bae815612f32bf$var$axios.AxiosError = (0, $7c06a4a7e1384c25$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$00bae815612f32bf$var$axios.Cancel = $00bae815612f32bf$var$axios.CanceledError;
// Expose all/spread
$00bae815612f32bf$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$00bae815612f32bf$var$axios.spread = (0, $27e1575c63fd772f$export$2e2bcd8739ae039);
// Expose isAxiosError
$00bae815612f32bf$var$axios.isAxiosError = (0, $fdeaa6e810f5330e$export$2e2bcd8739ae039);
// Expose mergeConfig
$00bae815612f32bf$var$axios.mergeConfig = (0, $9e2d44d1266464bc$export$2e2bcd8739ae039);
$00bae815612f32bf$var$axios.AxiosHeaders = (0, $04a1252241532790$export$2e2bcd8739ae039);
$00bae815612f32bf$var$axios.formToJSON = function(thing) {
    return (0, $5b65bc79ed38e11f$export$2e2bcd8739ae039)((0, $3a4de46bd2d3d207$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
};
$00bae815612f32bf$var$axios.getAdapter = (0, $2efaa1fee131f2b1$export$2e2bcd8739ae039).getAdapter;
$00bae815612f32bf$var$axios.HttpStatusCode = (0, $bdcc2a67627b0050$export$2e2bcd8739ae039);
$00bae815612f32bf$var$axios.default = $00bae815612f32bf$var$axios;
var // this module should only have a default export
$00bae815612f32bf$export$2e2bcd8739ae039 = $00bae815612f32bf$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
var $01c4a72039533074$export$1c00760e9e5a4e95 = (0, $00bae815612f32bf$export$2e2bcd8739ae039).Axios, $01c4a72039533074$export$c1fbed17c2f6a328 = (0, $00bae815612f32bf$export$2e2bcd8739ae039).AxiosError, $01c4a72039533074$export$1ab0c6b20d94fa14 = (0, $00bae815612f32bf$export$2e2bcd8739ae039).CanceledError, $01c4a72039533074$export$3b22524397b493c6 = (0, $00bae815612f32bf$export$2e2bcd8739ae039).isCancel, $01c4a72039533074$export$fd08e3cb425f0d61 = (0, $00bae815612f32bf$export$2e2bcd8739ae039).CancelToken, $01c4a72039533074$export$a4ad2735b021c132 = (0, $00bae815612f32bf$export$2e2bcd8739ae039).VERSION, $01c4a72039533074$export$84bf76cd7afc7469 = (0, $00bae815612f32bf$export$2e2bcd8739ae039).all, $01c4a72039533074$export$848c9b7ead0df967 = (0, $00bae815612f32bf$export$2e2bcd8739ae039).Cancel, $01c4a72039533074$export$fbafdbe06a5b5a9a = (0, $00bae815612f32bf$export$2e2bcd8739ae039).isAxiosError, $01c4a72039533074$export$3ae0fd4797ed47c8 = (0, $00bae815612f32bf$export$2e2bcd8739ae039).spread, $01c4a72039533074$export$10ae0d317ea97f8b = (0, $00bae815612f32bf$export$2e2bcd8739ae039).toFormData, $01c4a72039533074$export$4e7d6ff0f3e6520 = (0, $00bae815612f32bf$export$2e2bcd8739ae039).AxiosHeaders, $01c4a72039533074$export$a972f69c851492b3 = (0, $00bae815612f32bf$export$2e2bcd8739ae039).HttpStatusCode, $01c4a72039533074$export$86d7c59254d6a2c9 = (0, $00bae815612f32bf$export$2e2bcd8739ae039).formToJSON, $01c4a72039533074$export$17ddc20a97d669e2 = (0, $00bae815612f32bf$export$2e2bcd8739ae039).getAdapter, $01c4a72039533074$export$7ec1ebcfa9d8bd6a = (0, $00bae815612f32bf$export$2e2bcd8739ae039).mergeConfig, $01c4a72039533074$export$185802fd694ee1f5 = (0, $00bae815612f32bf$export$2e2bcd8739ae039).create;


function $72f582fa7c15ef93$export$c86512ceef10c086() {
    var root = document.querySelector(".rs-workspace");
    if (!root) return;
    var period = root.dataset.period;
    var companies = (0, $6zk1M._)(root.querySelectorAll(".rs-company"));
    var errorText = function(error) {
        var _error_response_data, _error_response;
        return ((_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.message) || "Forbindelsen mislykkedes. Pr\xf8v igen.";
    };
    function loadCompany(company) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var panel, response, error, retry;
            return (0, $iLZuz._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (company.dataset.loading || company.dataset.loaded) return [
                            2
                        ];
                        company.dataset.loading = "true";
                        panel = company.querySelector(".rs-company-panel");
                        panel.setAttribute("aria-busy", "true");
                        panel.textContent = "Henter brugere og aktivitet\u2026";
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            (0, $00bae815612f32bf$export$2e2bcd8739ae039).get("/api/v1/companies/".concat(company.dataset.companyId, "/workspace"), {
                                params: {
                                    period: period
                                }
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        if (response.data.status !== "success" || typeof response.data.html !== "string") throw new Error("Invalid response");
                        panel.innerHTML = response.data.html;
                        company.dataset.loaded = "true";
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        panel.textContent = errorText(error);
                        retry = document.createElement("button");
                        retry.type = "button";
                        retry.className = "rs-button rs-button--small";
                        retry.textContent = "Pr\xf8v igen";
                        retry.addEventListener("click", function() {
                            return loadCompany(company);
                        });
                        panel.append(retry);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        delete company.dataset.loading;
                        panel.removeAttribute("aria-busy");
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var company = _step.value;
            company.addEventListener("toggle", function() {
                if (company.open) loadCompany(company);
            });
        };
        for(var _iterator = companies[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    root.addEventListener("input", function(event) {
        var field = event.target;
        if (field.matches("[data-user-search]")) {
            var panel = field.closest(".rs-company-panel");
            var count = 0;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = panel.querySelectorAll("[data-rs-user]")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var row = _step.value;
                    var _context, _context2;
                    row.hidden = !(0, (/*@__PURE__*/$parcel$interopDefault($326dc9ed303f2323$exports)))(_context = row.dataset.search).call(_context, (0, (/*@__PURE__*/$parcel$interopDefault($20e5c9c200d6533f$exports)))(_context2 = field.value).call(_context2).toLowerCase());
                    if (!row.hidden) count++;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            panel.querySelector(".rs-user-empty").hidden = count > 0;
        }
        var settings = field.closest(".rs-settings-form");
        if (settings) settings.dataset.dirty = "true";
    });
    root.addEventListener("click", function(event) {
        if (!event.target.closest("[data-refresh-company]")) return;
        var company = event.target.closest(".rs-company");
        var form = company.querySelector(".rs-settings-form");
        if (form === null || form === void 0 ? void 0 : form.dataset.dirty) {
            form.querySelector(".rs-form-status").textContent = "Gem dine \xe6ndringer, f\xf8r du opdaterer tallene.";
            return;
        }
        delete company.dataset.loaded;
        loadCompany(company);
    });
    root.addEventListener("submit", function(event) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var form, submit, status, _context3, _context4, error, button, status1, data, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, control, response, company, previousActive, counter, activeCount, badge, integrations, _i, _iter, _iter__i, key, label, tag, error1;
            return (0, $iLZuz._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        form = event.target;
                        if (!form.matches(".rs-add-admin-form")) return [
                            3,
                            6
                        ];
                        event.preventDefault();
                        submit = form.querySelector("[type=submit]");
                        if (submit.disabled) return [
                            2
                        ];
                        submit.disabled = true;
                        status = form.querySelector(".rs-form-status");
                        status.textContent = "Opretter administrator\u2026";
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            (0, $00bae815612f32bf$export$2e2bcd8739ae039).post("/api/v1/users", {
                                companyId: form.dataset.companyId,
                                name: (0, (/*@__PURE__*/$parcel$interopDefault($20e5c9c200d6533f$exports)))(_context3 = form.elements.adminName.value).call(_context3),
                                email: (0, (/*@__PURE__*/$parcel$interopDefault($20e5c9c200d6533f$exports)))(_context4 = form.elements.adminEmail.value).call(_context4),
                                onboarding: true
                            })
                        ];
                    case 2:
                        _state.sent();
                        status.textContent = "Administratoren er oprettet. Opdat\xe9r tallene for at se brugeren i listen.";
                        form.reset();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        status.textContent = errorText(error);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        submit.disabled = false;
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                    case 6:
                        if (!form.matches(".rs-settings-form")) return [
                            2
                        ];
                        event.preventDefault();
                        button = form.querySelector("[type=submit]");
                        if (button.disabled) return [
                            2
                        ];
                        status1 = form.querySelector(".rs-form-status");
                        data = {};
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = form.elements[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                control = _step.value;
                                if (control.name) data[control.name] = control.type === "checkbox" ? control.checked : control.value;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        button.disabled = true;
                        status1.textContent = "Gemmer indstillinger\u2026";
                        form.setAttribute("aria-busy", "true");
                        _state.label = 7;
                    case 7:
                        _state.trys.push([
                            7,
                            9,
                            10,
                            11
                        ]);
                        return [
                            4,
                            (0, $00bae815612f32bf$export$2e2bcd8739ae039).patch("/api/v1/companies/".concat(form.dataset.companyId, "/workspace"), data)
                        ];
                    case 8:
                        response = _state.sent();
                        if (response.data.status !== "success") throw new Error("Save failed");
                        company = form.closest(".rs-company");
                        previousActive = company.dataset.companyActive === "true";
                        company.dataset.companyActive = String(response.data.data.active);
                        counter = root.querySelector("[data-active-company-count]");
                        activeCount = Number(root.dataset.activeCompanies) + Number(response.data.data.active) - Number(previousActive);
                        root.dataset.activeCompanies = String(activeCount);
                        if (counter) counter.textContent = "".concat(activeCount, " aktive");
                        badge = company.querySelector("[data-company-status]");
                        badge.textContent = response.data.data.active ? "Aktivt" : "Deaktiveret";
                        badge.className = "rs-badge ".concat(response.data.data.active ? "rs-badge--green" : "rs-badge--muted");
                        company.querySelector("[data-pbx-value]").textContent = response.data.data.pbxId || "Ikke tilsluttet";
                        company.querySelector("[data-app-template]").textContent = response.data.data.appTemplate || "Ikke valgt";
                        integrations = company.querySelector(".rs-integrations");
                        integrations.replaceChildren();
                        for(_i = 0, _iter = [
                            [
                                "hubspot",
                                "HubSpot"
                            ],
                            [
                                "salesforce",
                                "Salesforce"
                            ],
                            [
                                "tpIntegration",
                                response.data.data.appTemplate === "aganalytics" ? "agAnalytics" : response.data.data.appTemplate === "egclinea" ? "EG-Clinea" : "Universal app"
                            ],
                            [
                                "sms",
                                "SMS"
                            ],
                            [
                                "dentalsuite",
                                "DentalSuite"
                            ]
                        ]; _i < _iter.length; _i++){
                            _iter__i = (0, $21h22._)(_iter[_i], 2), key = _iter__i[0], label = _iter__i[1];
                            if (data[key]) {
                                tag = document.createElement("span");
                                tag.textContent = label;
                                integrations.append(tag);
                            }
                        }
                        delete form.dataset.dirty;
                        if (form.elements.smsApiToken) form.elements.smsApiToken.value = "";
                        if (form.elements.flexfoneApiKey) form.elements.flexfoneApiKey.value = "";
                        status1.textContent = "Indstillingerne er gemt.";
                        return [
                            3,
                            11
                        ];
                    case 9:
                        error1 = _state.sent();
                        status1.textContent = errorText(error1);
                        return [
                            3,
                            11
                        ];
                    case 10:
                        button.disabled = false;
                        form.removeAttribute("aria-busy");
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        })();
    });
    var createPanel = root.querySelector("#rs-create");
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = root.querySelectorAll("[data-open-create]")[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var link = _step1.value;
            link.addEventListener("click", function(event) {
                event.preventDefault();
                createPanel.open = true;
                createPanel.scrollIntoView({
                    block: "start"
                });
                createPanel.querySelector("[name=name]").focus({
                    preventScroll: true
                });
            });
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    var form = createPanel.querySelector("form");
    var button = form.querySelector("[type=submit]");
    var status = form.querySelector(".rs-form-status");
    var result = form.querySelector(".rs-create-result");
    var newKey = function() {
        var _context5;
        if (window.crypto.randomUUID) return window.crypto.randomUUID();
        var bytes = window.crypto.getRandomValues(new Uint8Array(16));
        bytes[6] = bytes[6] & 15 | 64;
        bytes[8] = bytes[8] & 63 | 128;
        var hex = (0, (/*@__PURE__*/$parcel$interopDefault($3a47f8c3e8d7e9c8$exports)))(_context5 = (0, $6zk1M._)(bytes)).call(_context5, function(byte) {
            var _context6;
            return (0, (/*@__PURE__*/$parcel$interopDefault($9b80a5bab44f198e$exports)))(_context6 = byte.toString(16)).call(_context6, 2, "0");
        }).join("");
        return "".concat((0, (/*@__PURE__*/$parcel$interopDefault($751050c55dbce8e1$exports)))(hex).call(hex, 0, 8), "-").concat((0, (/*@__PURE__*/$parcel$interopDefault($751050c55dbce8e1$exports)))(hex).call(hex, 8, 12), "-").concat((0, (/*@__PURE__*/$parcel$interopDefault($751050c55dbce8e1$exports)))(hex).call(hex, 12, 16), "-").concat((0, (/*@__PURE__*/$parcel$interopDefault($751050c55dbce8e1$exports)))(hex).call(hex, 16, 20), "-").concat((0, (/*@__PURE__*/$parcel$interopDefault($751050c55dbce8e1$exports)))(hex).call(hex, 20));
    };
    var key = newKey();
    var created;
    var completed = false;
    var configure = function() {
        var admin = form.elements.createAdmin.checked;
        var pbx = form.elements.connectPbx.checked;
        var adminFields = form.querySelector("[data-admin-fields]");
        var pbxFields = form.querySelector("[data-pbx-fields]");
        adminFields.hidden = !admin;
        pbxFields.hidden = !pbx;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = adminFields.querySelectorAll("input")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var control = _step.value;
                control.disabled = !admin;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = pbxFields.querySelectorAll("input, select")[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var control1 = _step1.value;
                control1.disabled = !pbx || !!created;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    };
    form.elements.createAdmin.addEventListener("change", configure);
    form.elements.connectPbx.addEventListener("change", configure);
    configure();
    form.addEventListener("submit", function(event) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var _response_data_data, data, _i, _iter, name, _context7, _i1, _iter1, name1, _context8, _i2, _iter2, name2, _context9, response, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, fieldset, _context0, _context1, response1, link, again, error;
            return (0, $iLZuz._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        if (completed || button.disabled || !form.reportValidity()) return [
                            2
                        ];
                        button.disabled = true;
                        form.setAttribute("aria-busy", "true");
                        result.hidden = true;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        if (!!created) return [
                            3,
                            3
                        ];
                        status.textContent = "Opretter firma\u2026";
                        data = new FormData();
                        for(_i = 0, _iter = [
                            "name",
                            "email",
                            "address",
                            "zip",
                            "city",
                            "jwtCookieExpiresIn"
                        ]; _i < _iter.length; _i++){
                            name = _iter[_i];
                            ;
                            data.append(name, (0, (/*@__PURE__*/$parcel$interopDefault($20e5c9c200d6533f$exports)))(_context7 = form.elements[name].value).call(_context7));
                        }
                        data.append("creationKey", key);
                        if (form.elements.connectPbx.checked) for(_i1 = 0, _iter1 = [
                            "pbxId",
                            "flexfoneApiKey"
                        ]; _i1 < _iter1.length; _i1++){
                            name1 = _iter1[_i1];
                            ;
                            data.append(name1, (0, (/*@__PURE__*/$parcel$interopDefault($20e5c9c200d6533f$exports)))(_context8 = form.elements[name1].value).call(_context8));
                        }
                        data.append("recordings", (0, (/*@__PURE__*/$parcel$interopDefault($f6a213ca3eebef7b$exports)))({
                            keepRecordings: form.elements.connectPbx.checked ? form.elements.recordingMode.value : "no",
                            deleteAfter: form.elements.retention.value
                        }));
                        if (form.elements.createAdmin.checked) for(_i2 = 0, _iter2 = [
                            "adminName",
                            "adminEmail"
                        ]; _i2 < _iter2.length; _i2++){
                            name2 = _iter2[_i2];
                            ;
                            data.append(name2, (0, (/*@__PURE__*/$parcel$interopDefault($20e5c9c200d6533f$exports)))(_context9 = form.elements[name2].value).call(_context9));
                        }
                        if (form.elements.logo.files[0]) data.append("logo", form.elements.logo.files[0]);
                        return [
                            4,
                            (0, $00bae815612f32bf$export$2e2bcd8739ae039).post("/api/v1/companies", data)
                        ];
                    case 2:
                        response = _state.sent();
                        if (response.data.status !== "success" || !((_response_data_data = response.data.data) === null || _response_data_data === void 0 ? void 0 : _response_data_data.id)) throw new Error("Creation failed");
                        created = response.data.data;
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = form.querySelectorAll("[data-company-fields]")[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                fieldset = _step.value;
                                fieldset.disabled = true;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        // Credentials need not remain in the document once the company exists.
                        form.elements.flexfoneApiKey.value = "";
                        _state.label = 3;
                    case 3:
                        if (!form.elements.createAdmin.checked) return [
                            3,
                            5
                        ];
                        status.textContent = "".concat(created.name, " er oprettet. Opretter administrator\u2026");
                        return [
                            4,
                            (0, $00bae815612f32bf$export$2e2bcd8739ae039).post("/api/v1/users", {
                                name: (0, (/*@__PURE__*/$parcel$interopDefault($20e5c9c200d6533f$exports)))(_context0 = form.elements.adminName.value).call(_context0),
                                email: (0, (/*@__PURE__*/$parcel$interopDefault($20e5c9c200d6533f$exports)))(_context1 = form.elements.adminEmail.value).call(_context1),
                                companyId: created.id,
                                onboarding: true
                            })
                        ];
                    case 4:
                        response1 = _state.sent();
                        if (response1.data.status !== "success") throw new Error("Administrator creation failed");
                        _state.label = 5;
                    case 5:
                        status.textContent = form.elements.createAdmin.checked ? "Firma og administrator er oprettet. Administratoren kan bestille et loginlink p\xe5 login-siden." : "Firmaet er oprettet. En administrator kan tilf\xf8jes senere.";
                        result.replaceChildren();
                        link = document.createElement("a");
                        link.className = "rs-button rs-button--primary";
                        link.href = "/companies?open=".concat(encodeURIComponent(created.id));
                        link.textContent = "\xc5bn firma i oversigten";
                        result.append(link);
                        again = document.createElement("button");
                        again.type = "button";
                        again.className = "rs-button";
                        again.textContent = "Opret endnu et firma";
                        again.addEventListener("click", function() {
                            form.reset();
                            created = undefined;
                            completed = false;
                            key = newKey();
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = form.querySelectorAll("[data-company-fields]")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var fieldset = _step.value;
                                    fieldset.disabled = false;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            form.elements.createAdmin.disabled = false;
                            button.hidden = false;
                            button.textContent = "Opret firma";
                            result.hidden = true;
                            configure();
                            status.textContent = "Firmaet tilknyttes automatisk din firmaoversigt.";
                            form.elements.name.focus();
                        });
                        result.append(again);
                        result.hidden = false;
                        button.hidden = true;
                        completed = true;
                        form.elements.createAdmin.disabled = true;
                        return [
                            3,
                            8
                        ];
                    case 6:
                        error = _state.sent();
                        status.textContent = created ? "".concat(created.name, " er allerede oprettet. Administratoren kunne ikke oprettes: ").concat(errorText(error), " Ret eventuelt administratorens oplysninger og pr\xf8v igen; firmaet oprettes ikke igen.") : errorText(error);
                        button.textContent = created ? "Pr\xf8v administrator igen" : "Pr\xf8v oprettelse igen";
                        return [
                            3,
                            8
                        ];
                    case 7:
                        button.disabled = false;
                        form.removeAttribute("aria-busy");
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        })();
    });
    var openId = new (0, (/*@__PURE__*/$parcel$interopDefault($168312580b27ea53$exports)))(window.location.search).get("open");
    var selected = (0, (/*@__PURE__*/$parcel$interopDefault($2953d2395b4d6651$exports)))(companies).call(companies, function(company) {
        return company.dataset.companyId === openId;
    });
    if (selected) {
        selected.open = true;
        selected.scrollIntoView({
            block: "start"
        });
    }
    if (location.hash === "#rs-create") createPanel.open = true;
}




var $1Mz1E = parcelRequire("1Mz1E");

var $iLZuz = parcelRequire("iLZuz");
var $7874bf713c9acb54$exports = {};

$7874bf713c9acb54$exports = (parcelRequire("jhB9V"));




var $1Mz1E = parcelRequire("1Mz1E");

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $6zk1M = parcelRequire("6zk1M");

var $iLZuz = parcelRequire("iLZuz");




var $da0d08deac01b774$exports = {};

$da0d08deac01b774$exports = (parcelRequire("7qWrq"));


var $8760b36c3cf09caa$exports = {};

$8760b36c3cf09caa$exports = (parcelRequire("hYDwd"));




var $b5cefcb8c642b94d$exports = {};

$b5cefcb8c642b94d$exports = (parcelRequire("gPyTW"));




var $49596b6f343a09f1$exports = {};
/*!
 * 
 * litepicker.umd.js
 * Litepicker v2.0.12 (https://github.com/wakirin/Litepicker)
 * Package: litepicker (https://www.npmjs.com/package/litepicker)
 * License: MIT (https://github.com/wakirin/Litepicker/blob/master/LICENCE.md)
 * Copyright 2019-2021 Rinat G.
 *     
 * Hash: 504eef9c08cb42543660
 * 
 */ 
var $2bfPH = parcelRequire("2bfPH");
!function(t, e) {
    $49596b6f343a09f1$exports = e();
}(window, function() {
    return function(t) {
        var e = {};
        function i(n) {
            if (e[n]) return e[n].exports;
            var o = e[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return t[n].call(o.exports, o, o.exports, i), o.l = !0, o.exports;
        }
        return i.m = t, i.c = e, i.d = function(t, e, n) {
            i.o(t, e) || Object.defineProperty(t, e, {
                enumerable: !0,
                get: n
            });
        }, i.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }, i.t = function(t, e) {
            if (1 & e && (t = i(t)), 8 & e) return t;
            if (4 & e && "object" == (typeof t === "undefined" ? "undefined" : (0, $2bfPH._)(t)) && t && t.__esModule) return t;
            var n = Object.create(null);
            if (i.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: t
            }), 2 & e && "string" != typeof t) for(var o in t)i.d(n, o, (function(e) {
                return t[e];
            }).bind(null, o));
            return n;
        }, i.n = function(t) {
            var e = t && t.__esModule ? function e() {
                return t.default;
            } : function() {
                return t;
            };
            return i.d(e, "a", e), e;
        }, i.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }, i.p = "", i(i.s = 4);
    }([
        function(t, e, i) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var n = function() {
                function t(e, i, n) {
                    void 0 === e && (e = null), void 0 === i && (i = null), void 0 === n && (n = "en-US"), this.dateInstance = "object" == (typeof i === "undefined" ? "undefined" : (0, $2bfPH._)(i)) && null !== i ? i.parse(e instanceof t ? e.clone().toJSDate() : e) : "string" == typeof i ? t.parseDateTime(e, i, n) : e ? t.parseDateTime(e) : t.parseDateTime(new Date), this.lang = n;
                }
                return t.parseDateTime = function(e, i, n) {
                    if (void 0 === i && (i = "YYYY-MM-DD"), void 0 === n && (n = "en-US"), !e) return new Date(NaN);
                    if (e instanceof Date) return new Date(e);
                    if (e instanceof t) return e.clone().toJSDate();
                    if (/^-?\d{10,}$/.test(e)) return t.getDateZeroTime(new Date(Number(e)));
                    if ("string" == typeof e) {
                        for(var o = [], s = null; null != (s = t.regex.exec(i));)"\\" !== s[1] && o.push(s);
                        if (o.length) {
                            var r = {
                                year: null,
                                month: null,
                                shortMonth: null,
                                longMonth: null,
                                day: null,
                                value: ""
                            };
                            o[0].index > 0 && (r.value += ".*?");
                            for(var a = 0, l = Object.entries(o); a < l.length; a++){
                                var c = l[a], h = c[0], p = c[1], d = Number(h), u = t.formatPatterns(p[0], n), m = u.group, f = u.pattern;
                                r[m] = d + 1, r.value += f, r.value += ".*?";
                            }
                            var g = new RegExp("^" + r.value + "$");
                            if (g.test(e)) {
                                var v = g.exec(e), y = Number(v[r.year]), b = null;
                                r.month ? b = Number(v[r.month]) - 1 : r.shortMonth ? b = t.shortMonths(n).indexOf(v[r.shortMonth]) : r.longMonth && (b = t.longMonths(n).indexOf(v[r.longMonth]));
                                var k = Number(v[r.day]) || 1;
                                return new Date(y, b, k, 0, 0, 0, 0);
                            }
                        }
                    }
                    return t.getDateZeroTime(new Date(e));
                }, t.convertArray = function(e, i) {
                    return e.map(function(e) {
                        return e instanceof Array ? e.map(function(e) {
                            return new t(e, i);
                        }) : new t(e, i);
                    });
                }, t.getDateZeroTime = function(t) {
                    return new Date(t.getFullYear(), t.getMonth(), t.getDate(), 0, 0, 0, 0);
                }, t.shortMonths = function(e) {
                    return t.MONTH_JS.map(function(t) {
                        return new Date(2019, t).toLocaleString(e, {
                            month: "short"
                        });
                    });
                }, t.longMonths = function(e) {
                    return t.MONTH_JS.map(function(t) {
                        return new Date(2019, t).toLocaleString(e, {
                            month: "long"
                        });
                    });
                }, t.formatPatterns = function(e, i) {
                    switch(e){
                        case "YY":
                        case "YYYY":
                            return {
                                group: "year",
                                pattern: "(\\d{" + e.length + "})"
                            };
                        case "M":
                            return {
                                group: "month",
                                pattern: "(\\d{1,2})"
                            };
                        case "MM":
                            return {
                                group: "month",
                                pattern: "(\\d{2})"
                            };
                        case "MMM":
                            return {
                                group: "shortMonth",
                                pattern: "(" + t.shortMonths(i).join("|") + ")"
                            };
                        case "MMMM":
                            return {
                                group: "longMonth",
                                pattern: "(" + t.longMonths(i).join("|") + ")"
                            };
                        case "D":
                            return {
                                group: "day",
                                pattern: "(\\d{1,2})"
                            };
                        case "DD":
                            return {
                                group: "day",
                                pattern: "(\\d{2})"
                            };
                    }
                }, t.prototype.toJSDate = function() {
                    return this.dateInstance;
                }, t.prototype.toLocaleString = function(t, e) {
                    return this.dateInstance.toLocaleString(t, e);
                }, t.prototype.toDateString = function() {
                    return this.dateInstance.toDateString();
                }, t.prototype.getSeconds = function() {
                    return this.dateInstance.getSeconds();
                }, t.prototype.getDay = function() {
                    return this.dateInstance.getDay();
                }, t.prototype.getTime = function() {
                    return this.dateInstance.getTime();
                }, t.prototype.getDate = function() {
                    return this.dateInstance.getDate();
                }, t.prototype.getMonth = function() {
                    return this.dateInstance.getMonth();
                }, t.prototype.getFullYear = function() {
                    return this.dateInstance.getFullYear();
                }, t.prototype.setMonth = function(t) {
                    return this.dateInstance.setMonth(t);
                }, t.prototype.setHours = function(t, e, i, n) {
                    void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === n && (n = 0), this.dateInstance.setHours(t, e, i, n);
                }, t.prototype.setSeconds = function(t) {
                    return this.dateInstance.setSeconds(t);
                }, t.prototype.setDate = function(t) {
                    return this.dateInstance.setDate(t);
                }, t.prototype.setFullYear = function(t) {
                    return this.dateInstance.setFullYear(t);
                }, t.prototype.getWeek = function(t) {
                    var _$e = new Date(this.timestamp()), i = (this.getDay() + (7 - t)) % 7;
                    _$e.setDate(_$e.getDate() - i);
                    var n = _$e.getTime();
                    return _$e.setMonth(0, 1), _$e.getDay() !== t && _$e.setMonth(0, 1 + (4 - _$e.getDay() + 7) % 7), 1 + Math.ceil((n - _$e.getTime()) / 6048e5);
                }, t.prototype.clone = function() {
                    return new t(this.toJSDate());
                }, t.prototype.isBetween = function(t, e, i) {
                    switch(void 0 === i && (i = "()"), i){
                        default:
                        case "()":
                            return this.timestamp() > t.getTime() && this.timestamp() < e.getTime();
                        case "[)":
                            return this.timestamp() >= t.getTime() && this.timestamp() < e.getTime();
                        case "(]":
                            return this.timestamp() > t.getTime() && this.timestamp() <= e.getTime();
                        case "[]":
                            return this.timestamp() >= t.getTime() && this.timestamp() <= e.getTime();
                    }
                }, t.prototype.isBefore = function(t, e) {
                    switch(void 0 === e && (e = "seconds"), e){
                        case "second":
                        case "seconds":
                            return t.getTime() > this.getTime();
                        case "day":
                        case "days":
                            return new Date(t.getFullYear(), t.getMonth(), t.getDate()).getTime() > new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime();
                        case "month":
                        case "months":
                            return new Date(t.getFullYear(), t.getMonth(), 1).getTime() > new Date(this.getFullYear(), this.getMonth(), 1).getTime();
                        case "year":
                        case "years":
                            return t.getFullYear() > this.getFullYear();
                    }
                    throw new Error("isBefore: Invalid unit!");
                }, t.prototype.isSameOrBefore = function(t, e) {
                    switch(void 0 === e && (e = "seconds"), e){
                        case "second":
                        case "seconds":
                            return t.getTime() >= this.getTime();
                        case "day":
                        case "days":
                            return new Date(t.getFullYear(), t.getMonth(), t.getDate()).getTime() >= new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime();
                        case "month":
                        case "months":
                            return new Date(t.getFullYear(), t.getMonth(), 1).getTime() >= new Date(this.getFullYear(), this.getMonth(), 1).getTime();
                    }
                    throw new Error("isSameOrBefore: Invalid unit!");
                }, t.prototype.isAfter = function(t, e) {
                    switch(void 0 === e && (e = "seconds"), e){
                        case "second":
                        case "seconds":
                            return this.getTime() > t.getTime();
                        case "day":
                        case "days":
                            return new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime() > new Date(t.getFullYear(), t.getMonth(), t.getDate()).getTime();
                        case "month":
                        case "months":
                            return new Date(this.getFullYear(), this.getMonth(), 1).getTime() > new Date(t.getFullYear(), t.getMonth(), 1).getTime();
                        case "year":
                        case "years":
                            return this.getFullYear() > t.getFullYear();
                    }
                    throw new Error("isAfter: Invalid unit!");
                }, t.prototype.isSameOrAfter = function(t, e) {
                    switch(void 0 === e && (e = "seconds"), e){
                        case "second":
                        case "seconds":
                            return this.getTime() >= t.getTime();
                        case "day":
                        case "days":
                            return new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime() >= new Date(t.getFullYear(), t.getMonth(), t.getDate()).getTime();
                        case "month":
                        case "months":
                            return new Date(this.getFullYear(), this.getMonth(), 1).getTime() >= new Date(t.getFullYear(), t.getMonth(), 1).getTime();
                    }
                    throw new Error("isSameOrAfter: Invalid unit!");
                }, t.prototype.isSame = function(t, e) {
                    switch(void 0 === e && (e = "seconds"), e){
                        case "second":
                        case "seconds":
                            return this.getTime() === t.getTime();
                        case "day":
                        case "days":
                            return new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime() === new Date(t.getFullYear(), t.getMonth(), t.getDate()).getTime();
                        case "month":
                        case "months":
                            return new Date(this.getFullYear(), this.getMonth(), 1).getTime() === new Date(t.getFullYear(), t.getMonth(), 1).getTime();
                    }
                    throw new Error("isSame: Invalid unit!");
                }, t.prototype.add = function(t, e) {
                    switch(void 0 === e && (e = "seconds"), e){
                        case "second":
                        case "seconds":
                            this.setSeconds(this.getSeconds() + t);
                            break;
                        case "day":
                        case "days":
                            this.setDate(this.getDate() + t);
                            break;
                        case "month":
                        case "months":
                            this.setMonth(this.getMonth() + t);
                    }
                    return this;
                }, t.prototype.subtract = function(t, e) {
                    switch(void 0 === e && (e = "seconds"), e){
                        case "second":
                        case "seconds":
                            this.setSeconds(this.getSeconds() - t);
                            break;
                        case "day":
                        case "days":
                            this.setDate(this.getDate() - t);
                            break;
                        case "month":
                        case "months":
                            this.setMonth(this.getMonth() - t);
                    }
                    return this;
                }, t.prototype.diff = function(t, e) {
                    void 0 === e && (e = "seconds");
                    switch(e){
                        default:
                        case "second":
                        case "seconds":
                            return this.getTime() - t.getTime();
                        case "day":
                        case "days":
                            return Math.round((this.timestamp() - t.getTime()) / 864e5);
                        case "month":
                        case "months":
                    }
                }, t.prototype.format = function(e, i) {
                    if (void 0 === i && (i = "en-US"), "object" == (typeof e === "undefined" ? "undefined" : (0, $2bfPH._)(e))) return e.output(this.clone().toJSDate());
                    for(var n = "", o = [], s = null; null != (s = t.regex.exec(e));)"\\" !== s[1] && o.push(s);
                    if (o.length) {
                        o[0].index > 0 && (n += e.substring(0, o[0].index));
                        for(var r = 0, a = Object.entries(o); r < a.length; r++){
                            var l = a[r], c = l[0], h = l[1], p = Number(c);
                            n += this.formatTokens(h[0], i), o[p + 1] && (n += e.substring(h.index + h[0].length, o[p + 1].index)), p === o.length - 1 && (n += e.substring(h.index + h[0].length));
                        }
                    }
                    return n.replace(/\\/g, "");
                }, t.prototype.timestamp = function() {
                    return new Date(this.getFullYear(), this.getMonth(), this.getDate(), 0, 0, 0, 0).getTime();
                }, t.prototype.formatTokens = function(e, i) {
                    switch(e){
                        case "YY":
                            return String(this.getFullYear()).slice(-2);
                        case "YYYY":
                            return String(this.getFullYear());
                        case "M":
                            return String(this.getMonth() + 1);
                        case "MM":
                            return ("0" + (this.getMonth() + 1)).slice(-2);
                        case "MMM":
                            return t.shortMonths(i)[this.getMonth()];
                        case "MMMM":
                            return t.longMonths(i)[this.getMonth()];
                        case "D":
                            return String(this.getDate());
                        case "DD":
                            return ("0" + this.getDate()).slice(-2);
                        default:
                            return "";
                    }
                }, t.regex = /(\\)?(Y{2,4}|M{1,4}|D{1,2}|d{1,4})/g, t.MONTH_JS = [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11
                ], t;
            }();
            e.DateTime = n;
        },
        function(t, e, i) {
            "use strict";
            var n, o = this && this.__extends || (n = function(t, e) {
                return (n = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t, e) {
                    t.__proto__ = e;
                } || function(t, e) {
                    for(var _$i in e)e.hasOwnProperty(_$i) && (t[_$i] = e[_$i]);
                })(t, e);
            }, function(t, e) {
                function i() {
                    this.constructor = t;
                }
                n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i);
            }), s = this && this.__spreadArrays || function() {
                for(var t = 0, _$e = 0, _$i = arguments.length; _$e < _$i; _$e++)t += arguments[_$e].length;
                var n = Array(t), o = 0;
                for(_$e = 0; _$e < _$i; _$e++)for(var s = arguments[_$e], r = 0, a = s.length; r < a; r++, o++)n[o] = s[r];
                return n;
            };
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var r = i(5), a = i(0), l = i(3), c = i(2), h = function(t) {
                function e(e) {
                    var _$i = t.call(this, e) || this;
                    return _$i.preventClick = !1, _$i.bindEvents(), _$i;
                }
                return o(e, t), e.prototype.scrollToDate = function(t) {
                    if (this.options.scrollToDate) {
                        var _$e = this.options.startDate instanceof a.DateTime ? this.options.startDate.clone() : null, _$i = this.options.endDate instanceof a.DateTime ? this.options.endDate.clone() : null;
                        !this.options.startDate || t && t !== this.options.element ? t && this.options.endDate && t === this.options.elementEnd && (_$i.setDate(1), this.options.numberOfMonths > 1 && _$i.isAfter(_$e) && _$i.setMonth(_$i.getMonth() - (this.options.numberOfMonths - 1)), this.calendars[0] = _$i.clone()) : (_$e.setDate(1), this.calendars[0] = _$e.clone());
                    }
                }, e.prototype.bindEvents = function() {
                    document.addEventListener("click", this.onClick.bind(this), !0), this.ui = document.createElement("div"), this.ui.className = l.litepicker, this.ui.style.display = "none", this.ui.addEventListener("mouseenter", this.onMouseEnter.bind(this), !0), this.ui.addEventListener("mouseleave", this.onMouseLeave.bind(this), !1), this.options.autoRefresh ? (this.options.element instanceof HTMLElement && this.options.element.addEventListener("keyup", this.onInput.bind(this), !0), this.options.elementEnd instanceof HTMLElement && this.options.elementEnd.addEventListener("keyup", this.onInput.bind(this), !0)) : (this.options.element instanceof HTMLElement && this.options.element.addEventListener("change", this.onInput.bind(this), !0), this.options.elementEnd instanceof HTMLElement && this.options.elementEnd.addEventListener("change", this.onInput.bind(this), !0)), this.options.parentEl ? this.options.parentEl instanceof HTMLElement ? this.options.parentEl.appendChild(this.ui) : document.querySelector(this.options.parentEl).appendChild(this.ui) : this.options.inlineMode ? this.options.element instanceof HTMLInputElement ? this.options.element.parentNode.appendChild(this.ui) : this.options.element.appendChild(this.ui) : document.body.appendChild(this.ui), this.updateInput(), this.init(), "function" == typeof this.options.setup && this.options.setup.call(this, this), this.render(), this.options.inlineMode && this.show();
                }, e.prototype.updateInput = function() {
                    if (this.options.element instanceof HTMLInputElement) {
                        var _$t = this.options.startDate, _$e = this.options.endDate;
                        if (this.options.singleMode && _$t) this.options.element.value = _$t.format(this.options.format, this.options.lang);
                        else if (!this.options.singleMode && _$t && _$e) {
                            var _$i = _$t.format(this.options.format, this.options.lang), n = _$e.format(this.options.format, this.options.lang);
                            this.options.elementEnd instanceof HTMLInputElement ? (this.options.element.value = _$i, this.options.elementEnd.value = n) : this.options.element.value = "" + _$i + this.options.delimiter + n;
                        }
                        _$t || _$e || (this.options.element.value = "", this.options.elementEnd instanceof HTMLInputElement && (this.options.elementEnd.value = ""));
                    }
                }, e.prototype.isSamePicker = function(t) {
                    return t.closest("." + l.litepicker) === this.ui;
                }, e.prototype.shouldShown = function(t) {
                    return !t.disabled && (t === this.options.element || this.options.elementEnd && t === this.options.elementEnd);
                }, e.prototype.shouldResetDatePicked = function() {
                    return this.options.singleMode || 2 === this.datePicked.length;
                }, e.prototype.shouldSwapDatePicked = function() {
                    return 2 === this.datePicked.length && this.datePicked[0].getTime() > this.datePicked[1].getTime();
                }, e.prototype.shouldCheckLockDays = function() {
                    return this.options.disallowLockDaysInRange && 2 === this.datePicked.length;
                }, e.prototype.onClick = function(t) {
                    var _$e = t.target;
                    if (t.target.shadowRoot && (_$e = t.composedPath()[0]), _$e && this.ui) {
                        if (this.shouldShown(_$e)) this.show(_$e);
                        else if (_$e.closest("." + l.litepicker) || !this.isShowning()) {
                            if (this.isSamePicker(_$e)) {
                                if (this.emit("before:click", _$e), this.preventClick) this.preventClick = !1;
                                else {
                                    if (_$e.classList.contains(l.dayItem)) {
                                        if (t.preventDefault(), _$e.classList.contains(l.isLocked)) return;
                                        if (this.shouldResetDatePicked() && (this.datePicked.length = 0), this.datePicked[this.datePicked.length] = new a.DateTime(_$e.dataset.time), this.shouldSwapDatePicked()) {
                                            var _$i = this.datePicked[1].clone();
                                            this.datePicked[1] = this.datePicked[0].clone(), this.datePicked[0] = _$i.clone();
                                        }
                                        if (this.shouldCheckLockDays()) c.rangeIsLocked(this.datePicked, this.options) && (this.emit("error:range", this.datePicked), this.datePicked.length = 0);
                                        return this.render(), this.emit.apply(this, s([
                                            "preselect"
                                        ], s(this.datePicked).map(function(t) {
                                            return t.clone();
                                        }))), void (this.options.autoApply && (this.options.singleMode && this.datePicked.length ? (this.setDate(this.datePicked[0]), this.hide()) : this.options.singleMode || 2 !== this.datePicked.length || (this.setDateRange(this.datePicked[0], this.datePicked[1]), this.hide())));
                                    }
                                    if (_$e.classList.contains(l.buttonPreviousMonth)) {
                                        t.preventDefault();
                                        var n = 0, o = this.options.switchingMonths || this.options.numberOfMonths;
                                        if (this.options.splitView) {
                                            var r = _$e.closest("." + l.monthItem);
                                            n = c.findNestedMonthItem(r), o = 1;
                                        }
                                        return this.calendars[n].setMonth(this.calendars[n].getMonth() - o), this.gotoDate(this.calendars[n], n), void this.emit("change:month", this.calendars[n], n);
                                    }
                                    if (_$e.classList.contains(l.buttonNextMonth)) {
                                        t.preventDefault();
                                        n = 0, o = this.options.switchingMonths || this.options.numberOfMonths;
                                        if (this.options.splitView) {
                                            r = _$e.closest("." + l.monthItem);
                                            n = c.findNestedMonthItem(r), o = 1;
                                        }
                                        return this.calendars[n].setMonth(this.calendars[n].getMonth() + o), this.gotoDate(this.calendars[n], n), void this.emit("change:month", this.calendars[n], n);
                                    }
                                    _$e.classList.contains(l.buttonCancel) && (t.preventDefault(), this.hide(), this.emit("button:cancel")), _$e.classList.contains(l.buttonApply) && (t.preventDefault(), this.options.singleMode && this.datePicked.length ? this.setDate(this.datePicked[0]) : this.options.singleMode || 2 !== this.datePicked.length || this.setDateRange(this.datePicked[0], this.datePicked[1]), this.hide(), this.emit("button:apply", this.options.startDate, this.options.endDate));
                                }
                            }
                        } else this.hide();
                    }
                }, e.prototype.showTooltip = function(t, e) {
                    var _$i = this.ui.querySelector("." + l.containerTooltip);
                    _$i.style.visibility = "visible", _$i.innerHTML = e;
                    var n = this.ui.getBoundingClientRect(), o = _$i.getBoundingClientRect(), s = t.getBoundingClientRect(), r = s.top, a = s.left;
                    if (this.options.inlineMode && this.options.parentEl) {
                        var c = this.ui.parentNode.getBoundingClientRect();
                        r -= c.top, a -= c.left;
                    } else r -= n.top, a -= n.left;
                    r -= o.height, a -= o.width / 2, a += s.width / 2, _$i.style.top = r + "px", _$i.style.left = a + "px", this.emit("tooltip", _$i, t);
                }, e.prototype.hideTooltip = function() {
                    this.ui.querySelector("." + l.containerTooltip).style.visibility = "hidden";
                }, e.prototype.shouldAllowMouseEnter = function(t) {
                    return !this.options.singleMode && !t.classList.contains(l.isLocked);
                }, e.prototype.shouldAllowRepick = function() {
                    return this.options.elementEnd && this.options.allowRepick && this.options.startDate && this.options.endDate;
                }, e.prototype.isDayItem = function(t) {
                    return t.classList.contains(l.dayItem);
                }, e.prototype.onMouseEnter = function(t) {
                    var _$e = this, _$i = t.target;
                    if (this.isDayItem(_$i) && this.shouldAllowMouseEnter(_$i)) {
                        if (this.shouldAllowRepick() && (this.triggerElement === this.options.element ? this.datePicked[0] = this.options.endDate.clone() : this.triggerElement === this.options.elementEnd && (this.datePicked[0] = this.options.startDate.clone())), 1 !== this.datePicked.length) return;
                        var n = this.ui.querySelector("." + l.dayItem + '[data-time="' + this.datePicked[0].getTime() + '"]'), o = this.datePicked[0].clone(), s = new a.DateTime(_$i.dataset.time), r = !1;
                        if (o.getTime() > s.getTime()) {
                            var c = o.clone();
                            o = s.clone(), s = c.clone(), r = !0;
                        }
                        if (Array.prototype.slice.call(this.ui.querySelectorAll("." + l.dayItem)).forEach(function(t) {
                            var _$i = new a.DateTime(t.dataset.time), n = _$e.renderDay(_$i);
                            _$i.isBetween(o, s) && n.classList.add(l.isInRange), t.className = n.className;
                        }), _$i.classList.add(l.isEndDate), r ? (n && n.classList.add(l.isFlipped), _$i.classList.add(l.isFlipped)) : (n && n.classList.remove(l.isFlipped), _$i.classList.remove(l.isFlipped)), this.options.showTooltip) {
                            var h = s.diff(o, "day") + 1;
                            if ("function" == typeof this.options.tooltipNumber && (h = this.options.tooltipNumber.call(this, h)), h > 0) {
                                var p = this.pluralSelector(h), d = h + " " + (this.options.tooltipText[p] ? this.options.tooltipText[p] : "[" + p + "]");
                                this.showTooltip(_$i, d);
                                var u = window.navigator.userAgent, m = /(iphone|ipad)/i.test(u), f = /OS 1([0-2])/i.test(u);
                                m && f && _$i.dispatchEvent(new Event("click"));
                            } else this.hideTooltip();
                        }
                    }
                }, e.prototype.onMouseLeave = function(t) {
                    t.target;
                    this.options.allowRepick && (!this.options.allowRepick || this.options.startDate || this.options.endDate) && (this.datePicked.length = 0, this.render());
                }, e.prototype.onInput = function(t) {
                    var _$e = this.parseInput(), _$i = _$e[0], n = _$e[1], o = this.options.format;
                    if (this.options.elementEnd ? _$i instanceof a.DateTime && n instanceof a.DateTime && _$i.format(o) === this.options.element.value && n.format(o) === this.options.elementEnd.value : this.options.singleMode ? _$i instanceof a.DateTime && _$i.format(o) === this.options.element.value : _$i instanceof a.DateTime && n instanceof a.DateTime && "" + _$i.format(o) + this.options.delimiter + n.format(o) === this.options.element.value) {
                        if (n && _$i.getTime() > n.getTime()) {
                            var s = _$i.clone();
                            _$i = n.clone(), n = s.clone();
                        }
                        this.options.startDate = new a.DateTime(_$i, this.options.format, this.options.lang), n && (this.options.endDate = new a.DateTime(n, this.options.format, this.options.lang)), this.updateInput(), this.render();
                        var r = _$i.clone(), l = 0;
                        (this.options.elementEnd ? _$i.format(o) === t.target.value : t.target.value.startsWith(_$i.format(o))) || (r = n.clone(), l = this.options.numberOfMonths - 1), this.emit("selected", this.getStartDate(), this.getEndDate()), this.gotoDate(r, l);
                    }
                }, e;
            }(r.Calendar);
            e.Litepicker = h;
        },
        function(t, e, i) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.findNestedMonthItem = function(t) {
                for(var _$e = t.parentNode.childNodes, i = 0; i < _$e.length; i += 1){
                    if (_$e.item(i) === t) return i;
                }
                return 0;
            }, e.dateIsLocked = function(t, e, i) {
                var n = !1;
                return e.lockDays.length && (n = e.lockDays.filter(function(i) {
                    return i instanceof Array ? t.isBetween(i[0], i[1], e.lockDaysInclusivity) : i.isSame(t, "day");
                }).length), n || "function" != typeof e.lockDaysFilter || (n = e.lockDaysFilter.call(this, t.clone(), null, i)), n;
            }, e.rangeIsLocked = function(t, e) {
                var i = !1;
                return e.lockDays.length && (i = e.lockDays.filter(function(i) {
                    if (i instanceof Array) {
                        var n = t[0].toDateString() === i[0].toDateString() && t[1].toDateString() === i[1].toDateString();
                        return i[0].isBetween(t[0], t[1], e.lockDaysInclusivity) || i[1].isBetween(t[0], t[1], e.lockDaysInclusivity) || n;
                    }
                    return i.isBetween(t[0], t[1], e.lockDaysInclusivity);
                }).length), i || "function" != typeof e.lockDaysFilter || (i = e.lockDaysFilter.call(this, t[0].clone(), t[1].clone(), t)), i;
            };
        },
        function(t, e, i) {
            var n = i(8);
            "string" == typeof n && (n = [
                [
                    t.i,
                    n,
                    ""
                ]
            ]);
            var o = {
                insert: function insert(t) {
                    var e = document.querySelector("head"), _$i = window._lastElementInsertedByStyleLoader;
                    window.disableLitepickerStyles || (_$i ? _$i.nextSibling ? e.insertBefore(t, _$i.nextSibling) : e.appendChild(t) : e.insertBefore(t, e.firstChild), window._lastElementInsertedByStyleLoader = t);
                },
                singleton: !1
            };
            i(10)(n, o);
            n.locals && (t.exports = n.locals);
        },
        function(t, e, i) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var n = i(1);
            e.Litepicker = n.Litepicker, i(11), window.Litepicker = n.Litepicker, e.default = n.Litepicker;
        },
        function(t, e, i) {
            "use strict";
            var n, o = this && this.__extends || (n = function(t, e) {
                return (n = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t, e) {
                    t.__proto__ = e;
                } || function(t, e) {
                    for(var _$i in e)e.hasOwnProperty(_$i) && (t[_$i] = e[_$i]);
                })(t, e);
            }, function(t, e) {
                function i() {
                    this.constructor = t;
                }
                n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i);
            });
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var s = i(6), r = i(0), a = i(3), l = i(2), c = function(t) {
                function e(e) {
                    return t.call(this, e) || this;
                }
                return o(e, t), e.prototype.render = function() {
                    var _$t = this;
                    this.emit("before:render", this.ui);
                    var _$e = document.createElement("div");
                    _$e.className = a.containerMain;
                    var _$i = document.createElement("div");
                    _$i.className = a.containerMonths, a["columns" + this.options.numberOfColumns] && (_$i.classList.remove(a.columns2, a.columns3, a.columns4), _$i.classList.add(a["columns" + this.options.numberOfColumns])), this.options.splitView && _$i.classList.add(a.splitView), this.options.showWeekNumbers && _$i.classList.add(a.showWeekNumbers);
                    for(var n = this.calendars[0].clone(), o = n.getMonth(), s = n.getMonth() + this.options.numberOfMonths, r = 0, l = o; l < s; l += 1){
                        var c = n.clone();
                        c.setDate(1), c.setHours(0, 0, 0, 0), this.options.splitView ? c = this.calendars[r].clone() : c.setMonth(l), _$i.appendChild(this.renderMonth(c, r)), r += 1;
                    }
                    if (this.ui.innerHTML = "", _$e.appendChild(_$i), this.options.resetButton) {
                        var h = void 0;
                        "function" == typeof this.options.resetButton ? h = this.options.resetButton.call(this) : ((h = document.createElement("button")).type = "button", h.className = a.resetButton, h.innerHTML = this.options.buttonText.reset), h.addEventListener("click", function(e) {
                            e.preventDefault(), _$t.clearSelection();
                        }), _$e.querySelector("." + a.monthItem + ":last-child").querySelector("." + a.monthItemHeader).appendChild(h);
                    }
                    this.ui.appendChild(_$e), this.options.autoApply && !this.options.footerHTML || this.ui.appendChild(this.renderFooter()), this.options.showTooltip && this.ui.appendChild(this.renderTooltip()), this.ui.dataset.plugins = (this.options.plugins || []).join("|"), this.emit("render", this.ui);
                }, e.prototype.renderMonth = function(t, e) {
                    var _$i = this, n = t.clone(), o = 32 - new Date(n.getFullYear(), n.getMonth(), 32).getDate(), s = document.createElement("div");
                    s.className = a.monthItem;
                    var c = document.createElement("div");
                    c.className = a.monthItemHeader;
                    var h = document.createElement("div");
                    if (this.options.dropdowns.months) {
                        var p = document.createElement("select");
                        p.className = a.monthItemName;
                        for(var d = 0; d < 12; d += 1){
                            var u = document.createElement("option"), m = new r.DateTime(new Date(t.getFullYear(), d, 2, 0, 0, 0)), f = new r.DateTime(new Date(t.getFullYear(), d, 1, 0, 0, 0));
                            u.value = String(d), u.text = m.toLocaleString(this.options.lang, {
                                month: "long"
                            }), u.disabled = this.options.minDate && f.isBefore(new r.DateTime(this.options.minDate), "month") || this.options.maxDate && f.isAfter(new r.DateTime(this.options.maxDate), "month"), u.selected = f.getMonth() === t.getMonth(), p.appendChild(u);
                        }
                        p.addEventListener("change", function(t) {
                            var _$e = t.target, n = 0;
                            if (_$i.options.splitView) {
                                var o = _$e.closest("." + a.monthItem);
                                n = l.findNestedMonthItem(o);
                            }
                            _$i.calendars[n].setMonth(Number(_$e.value)), _$i.render(), _$i.emit("change:month", _$i.calendars[n], n, t);
                        }), h.appendChild(p);
                    } else (m = document.createElement("strong")).className = a.monthItemName, m.innerHTML = t.toLocaleString(this.options.lang, {
                        month: "long"
                    }), h.appendChild(m);
                    if (this.options.dropdowns.years) {
                        var g = document.createElement("select");
                        g.className = a.monthItemYear;
                        var v = this.options.dropdowns.minYear, y = this.options.dropdowns.maxYear ? this.options.dropdowns.maxYear : (new Date).getFullYear();
                        if (t.getFullYear() > y) (u = document.createElement("option")).value = String(t.getFullYear()), u.text = String(t.getFullYear()), u.selected = !0, u.disabled = !0, g.appendChild(u);
                        for(d = y; d >= v; d -= 1){
                            var u = document.createElement("option"), b = new r.DateTime(new Date(d, 0, 1, 0, 0, 0));
                            u.value = String(d), u.text = String(d), u.disabled = this.options.minDate && b.isBefore(new r.DateTime(this.options.minDate), "year") || this.options.maxDate && b.isAfter(new r.DateTime(this.options.maxDate), "year"), u.selected = t.getFullYear() === d, g.appendChild(u);
                        }
                        if (t.getFullYear() < v) (u = document.createElement("option")).value = String(t.getFullYear()), u.text = String(t.getFullYear()), u.selected = !0, u.disabled = !0, g.appendChild(u);
                        if ("asc" === this.options.dropdowns.years) {
                            var k = Array.prototype.slice.call(g.childNodes).reverse();
                            g.innerHTML = "", k.forEach(function(t) {
                                t.innerHTML = t.value, g.appendChild(t);
                            });
                        }
                        g.addEventListener("change", function(t) {
                            var _$e = t.target, n = 0;
                            if (_$i.options.splitView) {
                                var o = _$e.closest("." + a.monthItem);
                                n = l.findNestedMonthItem(o);
                            }
                            _$i.calendars[n].setFullYear(Number(_$e.value)), _$i.render(), _$i.emit("change:year", _$i.calendars[n], n, t);
                        }), h.appendChild(g);
                    } else {
                        var w = document.createElement("span");
                        w.className = a.monthItemYear, w.innerHTML = String(t.getFullYear()), h.appendChild(w);
                    }
                    var D = document.createElement("button");
                    D.type = "button", D.className = a.buttonPreviousMonth, D.innerHTML = this.options.buttonText.previousMonth;
                    var x = document.createElement("button");
                    x.type = "button", x.className = a.buttonNextMonth, x.innerHTML = this.options.buttonText.nextMonth, c.appendChild(D), c.appendChild(h), c.appendChild(x), this.options.minDate && n.isSameOrBefore(new r.DateTime(this.options.minDate), "month") && s.classList.add(a.noPreviousMonth), this.options.maxDate && n.isSameOrAfter(new r.DateTime(this.options.maxDate), "month") && s.classList.add(a.noNextMonth);
                    var M = document.createElement("div");
                    M.className = a.monthItemWeekdaysRow, this.options.showWeekNumbers && (M.innerHTML = "<div>W</div>");
                    for(var _ = 1; _ <= 7; _ += 1){
                        var T = 3 + this.options.firstDay + _, L = document.createElement("div");
                        L.innerHTML = this.weekdayName(T), L.title = this.weekdayName(T, "long"), M.appendChild(L);
                    }
                    var E = document.createElement("div");
                    E.className = a.containerDays;
                    var S = this.calcSkipDays(n);
                    this.options.showWeekNumbers && S && E.appendChild(this.renderWeekNumber(n));
                    for(var I = 0; I < S; I += 1){
                        var P = document.createElement("div");
                        E.appendChild(P);
                    }
                    for(I = 1; I <= o; I += 1)n.setDate(I), this.options.showWeekNumbers && n.getDay() === this.options.firstDay && E.appendChild(this.renderWeekNumber(n)), E.appendChild(this.renderDay(n));
                    return s.appendChild(c), s.appendChild(M), s.appendChild(E), this.emit("render:month", s, t), s;
                }, e.prototype.renderDay = function(t) {
                    t.setHours();
                    var _$e = document.createElement("div");
                    if (_$e.className = a.dayItem, _$e.innerHTML = String(t.getDate()), _$e.dataset.time = String(t.getTime()), t.toDateString() === (new Date).toDateString() && _$e.classList.add(a.isToday), this.datePicked.length) this.datePicked[0].toDateString() === t.toDateString() && (_$e.classList.add(a.isStartDate), this.options.singleMode && _$e.classList.add(a.isEndDate)), 2 === this.datePicked.length && this.datePicked[1].toDateString() === t.toDateString() && _$e.classList.add(a.isEndDate), 2 === this.datePicked.length && t.isBetween(this.datePicked[0], this.datePicked[1]) && _$e.classList.add(a.isInRange);
                    else if (this.options.startDate) {
                        var _$i = this.options.startDate, n = this.options.endDate;
                        _$i.toDateString() === t.toDateString() && (_$e.classList.add(a.isStartDate), this.options.singleMode && _$e.classList.add(a.isEndDate)), n && n.toDateString() === t.toDateString() && _$e.classList.add(a.isEndDate), _$i && n && t.isBetween(_$i, n) && _$e.classList.add(a.isInRange);
                    }
                    if (this.options.minDate && t.isBefore(new r.DateTime(this.options.minDate)) && _$e.classList.add(a.isLocked), this.options.maxDate && t.isAfter(new r.DateTime(this.options.maxDate)) && _$e.classList.add(a.isLocked), this.options.minDays > 1 && 1 === this.datePicked.length) {
                        var o = this.options.minDays - 1, s = this.datePicked[0].clone().subtract(o, "day"), c = this.datePicked[0].clone().add(o, "day");
                        t.isBetween(s, this.datePicked[0], "(]") && _$e.classList.add(a.isLocked), t.isBetween(this.datePicked[0], c, "[)") && _$e.classList.add(a.isLocked);
                    }
                    if (this.options.maxDays && 1 === this.datePicked.length) {
                        var h = this.options.maxDays;
                        s = this.datePicked[0].clone().subtract(h, "day"), c = this.datePicked[0].clone().add(h, "day");
                        t.isSameOrBefore(s) && _$e.classList.add(a.isLocked), t.isSameOrAfter(c) && _$e.classList.add(a.isLocked);
                    }
                    (this.options.selectForward && 1 === this.datePicked.length && t.isBefore(this.datePicked[0]) && _$e.classList.add(a.isLocked), this.options.selectBackward && 1 === this.datePicked.length && t.isAfter(this.datePicked[0]) && _$e.classList.add(a.isLocked), l.dateIsLocked(t, this.options, this.datePicked) && _$e.classList.add(a.isLocked), this.options.highlightedDays.length) && this.options.highlightedDays.filter(function(e) {
                        return e instanceof Array ? t.isBetween(e[0], e[1], "[]") : e.isSame(t, "day");
                    }).length && _$e.classList.add(a.isHighlighted);
                    return _$e.tabIndex = _$e.classList.contains("is-locked") ? -1 : 0, this.emit("render:day", _$e, t), _$e;
                }, e.prototype.renderFooter = function() {
                    var _$t = document.createElement("div");
                    if (_$t.className = a.containerFooter, this.options.footerHTML ? _$t.innerHTML = this.options.footerHTML : _$t.innerHTML = '\n      <span class="' + a.previewDateRange + '"></span>\n      <button type="button" class="' + a.buttonCancel + '">' + this.options.buttonText.cancel + '</button>\n      <button type="button" class="' + a.buttonApply + '">' + this.options.buttonText.apply + "</button>\n      ", this.options.singleMode) {
                        if (1 === this.datePicked.length) {
                            var _$e = this.datePicked[0].format(this.options.format, this.options.lang);
                            _$t.querySelector("." + a.previewDateRange).innerHTML = _$e;
                        }
                    } else if (1 === this.datePicked.length && _$t.querySelector("." + a.buttonApply).setAttribute("disabled", ""), 2 === this.datePicked.length) {
                        _$e = this.datePicked[0].format(this.options.format, this.options.lang);
                        var _$i = this.datePicked[1].format(this.options.format, this.options.lang);
                        _$t.querySelector("." + a.previewDateRange).innerHTML = "" + _$e + this.options.delimiter + _$i;
                    }
                    return this.emit("render:footer", _$t), _$t;
                }, e.prototype.renderWeekNumber = function(t) {
                    var _$e = document.createElement("div"), _$i = t.getWeek(this.options.firstDay);
                    return _$e.className = a.weekNumber, _$e.innerHTML = 53 === _$i && 0 === t.getMonth() ? "53 / 1" : _$i, _$e;
                }, e.prototype.renderTooltip = function() {
                    var _$t = document.createElement("div");
                    return _$t.className = a.containerTooltip, _$t;
                }, e.prototype.weekdayName = function(t, e) {
                    return void 0 === e && (e = "short"), new Date(1970, 0, t, 12, 0, 0, 0).toLocaleString(this.options.lang, {
                        weekday: e
                    });
                }, e.prototype.calcSkipDays = function(t) {
                    var _$e = t.getDay() - this.options.firstDay;
                    return _$e < 0 && (_$e += 7), _$e;
                }, e;
            }(s.LPCore);
            e.Calendar = c;
        },
        function(t, e, i) {
            "use strict";
            var n, o = this && this.__extends || (n = function(t, e) {
                return (n = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t, e) {
                    t.__proto__ = e;
                } || function(t, e) {
                    for(var _$i in e)e.hasOwnProperty(_$i) && (t[_$i] = e[_$i]);
                })(t, e);
            }, function(t, e) {
                function i() {
                    this.constructor = t;
                }
                n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i);
            }), s = this && this.__assign || function() {
                return (s = Object.assign || function(t) {
                    for(var _$e, _$i = 1, n = arguments.length; _$i < n; _$i++)for(var o in _$e = arguments[_$i])Object.prototype.hasOwnProperty.call(_$e, o) && (t[o] = _$e[o]);
                    return t;
                }).apply(this, arguments);
            };
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var r = i(7), a = i(0), l = i(1), c = function(t) {
                function e(e) {
                    var _$i = t.call(this) || this;
                    _$i.datePicked = [], _$i.calendars = [], _$i.options = {
                        element: null,
                        elementEnd: null,
                        parentEl: null,
                        firstDay: 1,
                        format: "YYYY-MM-DD",
                        lang: "en-US",
                        delimiter: " - ",
                        numberOfMonths: 1,
                        numberOfColumns: 1,
                        startDate: null,
                        endDate: null,
                        zIndex: 9999,
                        position: "auto",
                        selectForward: !1,
                        selectBackward: !1,
                        splitView: !1,
                        inlineMode: !1,
                        singleMode: !0,
                        autoApply: !0,
                        allowRepick: !1,
                        showWeekNumbers: !1,
                        showTooltip: !0,
                        scrollToDate: !0,
                        mobileFriendly: !0,
                        resetButton: !1,
                        autoRefresh: !1,
                        lockDaysFormat: "YYYY-MM-DD",
                        lockDays: [],
                        disallowLockDaysInRange: !1,
                        lockDaysInclusivity: "[]",
                        highlightedDaysFormat: "YYYY-MM-DD",
                        highlightedDays: [],
                        dropdowns: {
                            minYear: 1990,
                            maxYear: null,
                            months: !1,
                            years: !1
                        },
                        buttonText: {
                            apply: "Apply",
                            cancel: "Cancel",
                            previousMonth: '<svg width="11" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M7.919 0l2.748 2.667L5.333 8l5.334 5.333L7.919 16 0 8z" fill-rule="nonzero"/></svg>',
                            nextMonth: '<svg width="11" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M2.748 16L0 13.333 5.333 8 0 2.667 2.748 0l7.919 8z" fill-rule="nonzero"/></svg>',
                            reset: '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">\n        <path d="M0 0h24v24H0z" fill="none"/>\n        <path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"/>\n      </svg>'
                        },
                        tooltipText: {
                            one: "day",
                            other: "days"
                        }
                    }, _$i.options = s(s({}, _$i.options), e.element.dataset), Object.keys(_$i.options).forEach(function(t) {
                        "true" !== _$i.options[t] && "false" !== _$i.options[t] || (_$i.options[t] = "true" === _$i.options[t]);
                    });
                    var n = s(s({}, _$i.options.dropdowns), e.dropdowns), o = s(s({}, _$i.options.buttonText), e.buttonText), r = s(s({}, _$i.options.tooltipText), e.tooltipText);
                    _$i.options = s(s({}, _$i.options), e), _$i.options.dropdowns = s({}, n), _$i.options.buttonText = s({}, o), _$i.options.tooltipText = s({}, r), _$i.options.elementEnd || (_$i.options.allowRepick = !1), _$i.options.lockDays.length && (_$i.options.lockDays = a.DateTime.convertArray(_$i.options.lockDays, _$i.options.lockDaysFormat)), _$i.options.highlightedDays.length && (_$i.options.highlightedDays = a.DateTime.convertArray(_$i.options.highlightedDays, _$i.options.highlightedDaysFormat));
                    var l = _$i.parseInput(), c = l[0], h = l[1];
                    _$i.options.startDate && (_$i.options.singleMode || _$i.options.endDate) && (c = new a.DateTime(_$i.options.startDate, _$i.options.format, _$i.options.lang)), c && _$i.options.endDate && (h = new a.DateTime(_$i.options.endDate, _$i.options.format, _$i.options.lang)), c instanceof a.DateTime && !isNaN(c.getTime()) && (_$i.options.startDate = c), _$i.options.startDate && h instanceof a.DateTime && !isNaN(h.getTime()) && (_$i.options.endDate = h), !_$i.options.singleMode || _$i.options.startDate instanceof a.DateTime || (_$i.options.startDate = null), _$i.options.singleMode || _$i.options.startDate instanceof a.DateTime && _$i.options.endDate instanceof a.DateTime || (_$i.options.startDate = null, _$i.options.endDate = null);
                    for(var p = 0; p < _$i.options.numberOfMonths; p += 1){
                        var d = _$i.options.startDate instanceof a.DateTime ? _$i.options.startDate.clone() : new a.DateTime;
                        if (!_$i.options.startDate && (0 === p || _$i.options.splitView)) {
                            var u = _$i.options.maxDate ? new a.DateTime(_$i.options.maxDate) : null, m = _$i.options.minDate ? new a.DateTime(_$i.options.minDate) : null, f = _$i.options.numberOfMonths - 1;
                            m && u && d.isAfter(u) ? (d = m.clone()).setDate(1) : !m && u && d.isAfter(u) && ((d = u.clone()).setDate(1), d.setMonth(d.getMonth() - f));
                        }
                        d.setDate(1), d.setMonth(d.getMonth() + p), _$i.calendars[p] = d;
                    }
                    if (_$i.options.showTooltip) {
                        if (_$i.options.tooltipPluralSelector) _$i.pluralSelector = _$i.options.tooltipPluralSelector;
                        else try {
                            var g = new Intl.PluralRules(_$i.options.lang);
                            _$i.pluralSelector = g.select.bind(g);
                        } catch (t) {
                            _$i.pluralSelector = function(t) {
                                return 0 === Math.abs(t) ? "one" : "other";
                            };
                        }
                    }
                    return _$i;
                }
                return o(e, t), e.add = function(t, e) {
                    l.Litepicker.prototype[t] = e;
                }, e.prototype.DateTime = function(t, e) {
                    return t ? new a.DateTime(t, e) : new a.DateTime;
                }, e.prototype.init = function() {
                    var _$t = this;
                    this.options.plugins && this.options.plugins.length && this.options.plugins.forEach(function(e) {
                        l.Litepicker.prototype.hasOwnProperty(e) ? l.Litepicker.prototype[e].init.call(_$t, _$t) : console.warn("Litepicker: plugin \xab" + e + "\xbb not found.");
                    });
                }, e.prototype.parseInput = function() {
                    var _$t = this.options.delimiter, _$e = new RegExp("" + _$t), _$i = this.options.element instanceof HTMLInputElement ? this.options.element.value.split(_$t) : [];
                    if (this.options.elementEnd) {
                        if (this.options.element instanceof HTMLInputElement && this.options.element.value.length && this.options.elementEnd instanceof HTMLInputElement && this.options.elementEnd.value.length) return [
                            new a.DateTime(this.options.element.value, this.options.format),
                            new a.DateTime(this.options.elementEnd.value, this.options.format)
                        ];
                    } else if (this.options.singleMode) {
                        if (this.options.element instanceof HTMLInputElement && this.options.element.value.length) return [
                            new a.DateTime(this.options.element.value, this.options.format)
                        ];
                    } else if (this.options.element instanceof HTMLInputElement && _$e.test(this.options.element.value) && _$i.length && _$i.length % 2 == 0) {
                        var n = _$i.slice(0, _$i.length / 2).join(_$t), o = _$i.slice(_$i.length / 2).join(_$t);
                        return [
                            new a.DateTime(n, this.options.format),
                            new a.DateTime(o, this.options.format)
                        ];
                    }
                    return [];
                }, e.prototype.isShowning = function() {
                    return this.ui && "none" !== this.ui.style.display;
                }, e.prototype.findPosition = function(t) {
                    var _$e = t.getBoundingClientRect(), _$i = this.ui.getBoundingClientRect(), n = this.options.position.split(" "), o = window.scrollX || window.pageXOffset, s = window.scrollY || window.pageYOffset, r = 0, a = 0;
                    if ("auto" !== n[0] && /top|bottom/.test(n[0])) r = _$e[n[0]] + s, "top" === n[0] && (r -= _$i.height);
                    else {
                        r = _$e.bottom + s;
                        var l = _$e.bottom + _$i.height > window.innerHeight, c = _$e.top + s - _$i.height >= _$i.height;
                        l && c && (r = _$e.top + s - _$i.height);
                    }
                    if (/left|right/.test(n[0]) || n[1] && "auto" !== n[1] && /left|right/.test(n[1])) a = /left|right/.test(n[0]) ? _$e[n[0]] + o : _$e[n[1]] + o, "right" !== n[0] && "right" !== n[1] || (a -= _$i.width);
                    else {
                        a = _$e.left + o;
                        l = _$e.left + _$i.width > window.innerWidth;
                        var h = _$e.right + o - _$i.width >= 0;
                        l && h && (a = _$e.right + o - _$i.width);
                    }
                    return {
                        left: a,
                        top: r
                    };
                }, e;
            }(r.EventEmitter);
            e.LPCore = c;
        },
        function(t, e, i) {
            "use strict";
            var n, o = "object" == (typeof Reflect === "undefined" ? "undefined" : (0, $2bfPH._)(Reflect)) ? Reflect : null, s = o && "function" == typeof o.apply ? o.apply : function s(t, e, i) {
                return Function.prototype.apply.call(t, e, i);
            };
            n = o && "function" == typeof o.ownKeys ? o.ownKeys : Object.getOwnPropertySymbols ? function n(t) {
                return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
            } : function(t) {
                return Object.getOwnPropertyNames(t);
            };
            var r = Number.isNaN || function(t) {
                return t != t;
            };
            function a() {
                a.init.call(this);
            }
            t.exports = a, a.EventEmitter = a, a.prototype._events = void 0, a.prototype._eventsCount = 0, a.prototype._maxListeners = void 0;
            var l = 10;
            function c(t) {
                return void 0 === t._maxListeners ? a.defaultMaxListeners : t._maxListeners;
            }
            function h(t, e, i, n) {
                var o, s, r, _$a;
                if ("function" != typeof i) throw new TypeError('The "listener" argument must be of type Function. Received type ' + (typeof i === "undefined" ? "undefined" : (0, $2bfPH._)(i)));
                if (void 0 === (s = t._events) ? (s = t._events = Object.create(null), t._eventsCount = 0) : (void 0 !== s.newListener && (t.emit("newListener", e, i.listener ? i.listener : i), s = t._events), r = s[e]), void 0 === r) r = s[e] = i, ++t._eventsCount;
                else if ("function" == typeof r ? r = s[e] = n ? [
                    i,
                    r
                ] : [
                    r,
                    i
                ] : n ? r.unshift(i) : r.push(i), (o = c(t)) > 0 && r.length > o && !r.warned) {
                    r.warned = !0;
                    var l = new Error("Possible EventEmitter memory leak detected. " + r.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
                    l.name = "MaxListenersExceededWarning", l.emitter = t, l.type = e, l.count = r.length, _$a = l, console && console.warn && console.warn(_$a);
                }
                return t;
            }
            function p() {
                for(var _$t = [], e = 0; e < arguments.length; e++)_$t.push(arguments[e]);
                this.fired || (this.target.removeListener(this.type, this.wrapFn), this.fired = !0, s(this.listener, this.target, _$t));
            }
            function d(t, e, i) {
                var n = {
                    fired: !1,
                    wrapFn: void 0,
                    target: t,
                    type: e,
                    listener: i
                }, o = p.bind(n);
                return o.listener = i, n.wrapFn = o, o;
            }
            function u(t, e, i) {
                var n = t._events;
                if (void 0 === n) return [];
                var o = n[e];
                return void 0 === o ? [] : "function" == typeof o ? i ? [
                    o.listener || o
                ] : [
                    o
                ] : i ? function(t) {
                    for(var _$e = new Array(t.length), _$i = 0; _$i < _$e.length; ++_$i)_$e[_$i] = t[_$i].listener || t[_$i];
                    return _$e;
                }(o) : f(o, o.length);
            }
            function m(t) {
                var e = this._events;
                if (void 0 !== e) {
                    var i = e[t];
                    if ("function" == typeof i) return 1;
                    if (void 0 !== i) return i.length;
                }
                return 0;
            }
            function f(t, e) {
                for(var i = new Array(e), n = 0; n < e; ++n)i[n] = t[n];
                return i;
            }
            Object.defineProperty(a, "defaultMaxListeners", {
                enumerable: !0,
                get: function get() {
                    return l;
                },
                set: function set(t) {
                    if ("number" != typeof t || t < 0 || r(t)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t + ".");
                    l = t;
                }
            }), a.init = function() {
                void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
            }, a.prototype.setMaxListeners = function(t) {
                if ("number" != typeof t || t < 0 || r(t)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t + ".");
                return this._maxListeners = t, this;
            }, a.prototype.getMaxListeners = function() {
                return c(this);
            }, a.prototype.emit = function(t) {
                for(var e = [], i = 1; i < arguments.length; i++)e.push(arguments[i]);
                var n = "error" === t, o = this._events;
                if (void 0 !== o) n = n && void 0 === o.error;
                else if (!n) return !1;
                if (n) {
                    var r;
                    if (e.length > 0 && (r = e[0]), r instanceof Error) throw r;
                    var _$a = new Error("Unhandled error." + (r ? " (" + r.message + ")" : ""));
                    throw _$a.context = r, _$a;
                }
                var l = o[t];
                if (void 0 === l) return !1;
                if ("function" == typeof l) s(l, this, e);
                else {
                    var c = l.length, h = f(l, c);
                    for(i = 0; i < c; ++i)s(h[i], this, e);
                }
                return !0;
            }, a.prototype.addListener = function(t, e) {
                return h(this, t, e, !1);
            }, a.prototype.on = a.prototype.addListener, a.prototype.prependListener = function(t, e) {
                return h(this, t, e, !0);
            }, a.prototype.once = function(t, e) {
                if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + (typeof e === "undefined" ? "undefined" : (0, $2bfPH._)(e)));
                return this.on(t, d(this, t, e)), this;
            }, a.prototype.prependOnceListener = function(t, e) {
                if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + (typeof e === "undefined" ? "undefined" : (0, $2bfPH._)(e)));
                return this.prependListener(t, d(this, t, e)), this;
            }, a.prototype.removeListener = function(t, e) {
                var i, n, o, s, r;
                if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + (typeof e === "undefined" ? "undefined" : (0, $2bfPH._)(e)));
                if (void 0 === (n = this._events)) return this;
                if (void 0 === (i = n[t])) return this;
                if (i === e || i.listener === e) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete n[t], n.removeListener && this.emit("removeListener", t, i.listener || e));
                else if ("function" != typeof i) {
                    for(o = -1, s = i.length - 1; s >= 0; s--)if (i[s] === e || i[s].listener === e) {
                        r = i[s].listener, o = s;
                        break;
                    }
                    if (o < 0) return this;
                    0 === o ? i.shift() : function(t, e) {
                        for(; e + 1 < t.length; e++)t[e] = t[e + 1];
                        t.pop();
                    }(i, o), 1 === i.length && (n[t] = i[0]), void 0 !== n.removeListener && this.emit("removeListener", t, r || e);
                }
                return this;
            }, a.prototype.off = a.prototype.removeListener, a.prototype.removeAllListeners = function(t) {
                var e, i, n;
                if (void 0 === (i = this._events)) return this;
                if (void 0 === i.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== i[t] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete i[t]), this;
                if (0 === arguments.length) {
                    var o, s = Object.keys(i);
                    for(n = 0; n < s.length; ++n)"removeListener" !== (o = s[n]) && this.removeAllListeners(o);
                    return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
                }
                if ("function" == typeof (e = i[t])) this.removeListener(t, e);
                else if (void 0 !== e) for(n = e.length - 1; n >= 0; n--)this.removeListener(t, e[n]);
                return this;
            }, a.prototype.listeners = function(t) {
                return u(this, t, !0);
            }, a.prototype.rawListeners = function(t) {
                return u(this, t, !1);
            }, a.listenerCount = function(t, e) {
                return "function" == typeof t.listenerCount ? t.listenerCount(e) : m.call(t, e);
            }, a.prototype.listenerCount = m, a.prototype.eventNames = function() {
                return this._eventsCount > 0 ? n(this._events) : [];
            };
        },
        function(t, e, i) {
            (e = i(9)(!1)).push([
                t.i,
                ':root{--litepicker-container-months-color-bg: #fff;--litepicker-container-months-box-shadow-color: #ddd;--litepicker-footer-color-bg: #fafafa;--litepicker-footer-box-shadow-color: #ddd;--litepicker-tooltip-color-bg: #fff;--litepicker-month-header-color: #333;--litepicker-button-prev-month-color: #9e9e9e;--litepicker-button-next-month-color: #9e9e9e;--litepicker-button-prev-month-color-hover: #2196f3;--litepicker-button-next-month-color-hover: #2196f3;--litepicker-month-width: calc(var(--litepicker-day-width) * 7);--litepicker-month-weekday-color: #9e9e9e;--litepicker-month-week-number-color: #9e9e9e;--litepicker-day-width: 38px;--litepicker-day-color: #333;--litepicker-day-color-hover: #2196f3;--litepicker-is-today-color: #f44336;--litepicker-is-in-range-color: #bbdefb;--litepicker-is-locked-color: #9e9e9e;--litepicker-is-start-color: #fff;--litepicker-is-start-color-bg: #2196f3;--litepicker-is-end-color: #fff;--litepicker-is-end-color-bg: #2196f3;--litepicker-button-cancel-color: #fff;--litepicker-button-cancel-color-bg: #9e9e9e;--litepicker-button-apply-color: #fff;--litepicker-button-apply-color-bg: #2196f3;--litepicker-button-reset-color: #909090;--litepicker-button-reset-color-hover: #2196f3;--litepicker-highlighted-day-color: #333;--litepicker-highlighted-day-color-bg: #ffeb3b}.show-week-numbers{--litepicker-month-width: calc(var(--litepicker-day-width) * 8)}.litepicker{font-family:-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;font-size:0.8em;display:none}.litepicker button{border:none;background:none}.litepicker .container__main{display:-webkit-box;display:-ms-flexbox;display:flex}.litepicker .container__months{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;background-color:var(--litepicker-container-months-color-bg);border-radius:5px;-webkit-box-shadow:0 0 5px var(--litepicker-container-months-box-shadow-color);box-shadow:0 0 5px var(--litepicker-container-months-box-shadow-color);width:calc(var(--litepicker-month-width) + 10px);-webkit-box-sizing:content-box;box-sizing:content-box}.litepicker .container__months.columns-2{width:calc((var(--litepicker-month-width) * 2) + 20px)}.litepicker .container__months.columns-3{width:calc((var(--litepicker-month-width) * 3) + 30px)}.litepicker .container__months.columns-4{width:calc((var(--litepicker-month-width) * 4) + 40px)}.litepicker .container__months.split-view .month-item-header .button-previous-month,.litepicker .container__months.split-view .month-item-header .button-next-month{visibility:visible}.litepicker .container__months .month-item{padding:5px;width:var(--litepicker-month-width);-webkit-box-sizing:content-box;box-sizing:content-box}.litepicker .container__months .month-item-header{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;font-weight:500;padding:10px 5px;text-align:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:var(--litepicker-month-header-color)}.litepicker .container__months .month-item-header div{-webkit-box-flex:1;-ms-flex:1;flex:1}.litepicker .container__months .month-item-header div>.month-item-name{margin-right:5px}.litepicker .container__months .month-item-header div>.month-item-year{padding:0}.litepicker .container__months .month-item-header .reset-button{color:var(--litepicker-button-reset-color)}.litepicker .container__months .month-item-header .reset-button>svg{fill:var(--litepicker-button-reset-color)}.litepicker .container__months .month-item-header .reset-button *{pointer-events:none}.litepicker .container__months .month-item-header .reset-button:hover{color:var(--litepicker-button-reset-color-hover)}.litepicker .container__months .month-item-header .reset-button:hover>svg{fill:var(--litepicker-button-reset-color-hover)}.litepicker .container__months .month-item-header .button-previous-month,.litepicker .container__months .month-item-header .button-next-month{visibility:hidden;text-decoration:none;padding:3px 5px;border-radius:3px;-webkit-transition:color 0.3s, border 0.3s;transition:color 0.3s, border 0.3s;cursor:default}.litepicker .container__months .month-item-header .button-previous-month *,.litepicker .container__months .month-item-header .button-next-month *{pointer-events:none}.litepicker .container__months .month-item-header .button-previous-month{color:var(--litepicker-button-prev-month-color)}.litepicker .container__months .month-item-header .button-previous-month>svg,.litepicker .container__months .month-item-header .button-previous-month>img{fill:var(--litepicker-button-prev-month-color)}.litepicker .container__months .month-item-header .button-previous-month:hover{color:var(--litepicker-button-prev-month-color-hover)}.litepicker .container__months .month-item-header .button-previous-month:hover>svg{fill:var(--litepicker-button-prev-month-color-hover)}.litepicker .container__months .month-item-header .button-next-month{color:var(--litepicker-button-next-month-color)}.litepicker .container__months .month-item-header .button-next-month>svg,.litepicker .container__months .month-item-header .button-next-month>img{fill:var(--litepicker-button-next-month-color)}.litepicker .container__months .month-item-header .button-next-month:hover{color:var(--litepicker-button-next-month-color-hover)}.litepicker .container__months .month-item-header .button-next-month:hover>svg{fill:var(--litepicker-button-next-month-color-hover)}.litepicker .container__months .month-item-weekdays-row{display:-webkit-box;display:-ms-flexbox;display:flex;justify-self:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;color:var(--litepicker-month-weekday-color)}.litepicker .container__months .month-item-weekdays-row>div{padding:5px 0;font-size:85%;-webkit-box-flex:1;-ms-flex:1;flex:1;width:var(--litepicker-day-width);text-align:center}.litepicker .container__months .month-item:first-child .button-previous-month{visibility:visible}.litepicker .container__months .month-item:last-child .button-next-month{visibility:visible}.litepicker .container__months .month-item.no-previous-month .button-previous-month{visibility:hidden}.litepicker .container__months .month-item.no-next-month .button-next-month{visibility:hidden}.litepicker .container__days{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;justify-self:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;text-align:center;-webkit-box-sizing:content-box;box-sizing:content-box}.litepicker .container__days>div,.litepicker .container__days>a{padding:5px 0;width:var(--litepicker-day-width)}.litepicker .container__days .day-item{color:var(--litepicker-day-color);text-align:center;text-decoration:none;border-radius:3px;-webkit-transition:color 0.3s, border 0.3s;transition:color 0.3s, border 0.3s;cursor:default}.litepicker .container__days .day-item:hover{color:var(--litepicker-day-color-hover);-webkit-box-shadow:inset 0 0 0 1px var(--litepicker-day-color-hover);box-shadow:inset 0 0 0 1px var(--litepicker-day-color-hover)}.litepicker .container__days .day-item.is-today{color:var(--litepicker-is-today-color)}.litepicker .container__days .day-item.is-locked{color:var(--litepicker-is-locked-color)}.litepicker .container__days .day-item.is-locked:hover{color:var(--litepicker-is-locked-color);-webkit-box-shadow:none;box-shadow:none;cursor:default}.litepicker .container__days .day-item.is-in-range{background-color:var(--litepicker-is-in-range-color);border-radius:0}.litepicker .container__days .day-item.is-start-date{color:var(--litepicker-is-start-color);background-color:var(--litepicker-is-start-color-bg);border-top-left-radius:5px;border-bottom-left-radius:5px;border-top-right-radius:0;border-bottom-right-radius:0}.litepicker .container__days .day-item.is-start-date.is-flipped{border-top-left-radius:0;border-bottom-left-radius:0;border-top-right-radius:5px;border-bottom-right-radius:5px}.litepicker .container__days .day-item.is-end-date{color:var(--litepicker-is-end-color);background-color:var(--litepicker-is-end-color-bg);border-top-left-radius:0;border-bottom-left-radius:0;border-top-right-radius:5px;border-bottom-right-radius:5px}.litepicker .container__days .day-item.is-end-date.is-flipped{border-top-left-radius:5px;border-bottom-left-radius:5px;border-top-right-radius:0;border-bottom-right-radius:0}.litepicker .container__days .day-item.is-start-date.is-end-date{border-top-left-radius:5px;border-bottom-left-radius:5px;border-top-right-radius:5px;border-bottom-right-radius:5px}.litepicker .container__days .day-item.is-highlighted{color:var(--litepicker-highlighted-day-color);background-color:var(--litepicker-highlighted-day-color-bg)}.litepicker .container__days .week-number{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:var(--litepicker-month-week-number-color);font-size:85%}.litepicker .container__footer{text-align:right;padding:10px 5px;margin:0 5px;background-color:var(--litepicker-footer-color-bg);-webkit-box-shadow:inset 0px 3px 3px 0px var(--litepicker-footer-box-shadow-color);box-shadow:inset 0px 3px 3px 0px var(--litepicker-footer-box-shadow-color);border-bottom-left-radius:5px;border-bottom-right-radius:5px}.litepicker .container__footer .preview-date-range{margin-right:10px;font-size:90%}.litepicker .container__footer .button-cancel{background-color:var(--litepicker-button-cancel-color-bg);color:var(--litepicker-button-cancel-color);border:0;padding:3px 7px 4px;border-radius:3px}.litepicker .container__footer .button-cancel *{pointer-events:none}.litepicker .container__footer .button-apply{background-color:var(--litepicker-button-apply-color-bg);color:var(--litepicker-button-apply-color);border:0;padding:3px 7px 4px;border-radius:3px;margin-left:10px;margin-right:10px}.litepicker .container__footer .button-apply:disabled{opacity:0.7}.litepicker .container__footer .button-apply *{pointer-events:none}.litepicker .container__tooltip{position:absolute;margin-top:-4px;padding:4px 8px;border-radius:4px;background-color:var(--litepicker-tooltip-color-bg);-webkit-box-shadow:0 1px 3px rgba(0,0,0,0.25);box-shadow:0 1px 3px rgba(0,0,0,0.25);white-space:nowrap;font-size:11px;pointer-events:none;visibility:hidden}.litepicker .container__tooltip:before{position:absolute;bottom:-5px;left:calc(50% - 5px);border-top:5px solid rgba(0,0,0,0.12);border-right:5px solid transparent;border-left:5px solid transparent;content:""}.litepicker .container__tooltip:after{position:absolute;bottom:-4px;left:calc(50% - 4px);border-top:4px solid var(--litepicker-tooltip-color-bg);border-right:4px solid transparent;border-left:4px solid transparent;content:""}\n',
                ""
            ]), e.locals = {
                showWeekNumbers: "show-week-numbers",
                litepicker: "litepicker",
                containerMain: "container__main",
                containerMonths: "container__months",
                columns2: "columns-2",
                columns3: "columns-3",
                columns4: "columns-4",
                splitView: "split-view",
                monthItemHeader: "month-item-header",
                buttonPreviousMonth: "button-previous-month",
                buttonNextMonth: "button-next-month",
                monthItem: "month-item",
                monthItemName: "month-item-name",
                monthItemYear: "month-item-year",
                resetButton: "reset-button",
                monthItemWeekdaysRow: "month-item-weekdays-row",
                noPreviousMonth: "no-previous-month",
                noNextMonth: "no-next-month",
                containerDays: "container__days",
                dayItem: "day-item",
                isToday: "is-today",
                isLocked: "is-locked",
                isInRange: "is-in-range",
                isStartDate: "is-start-date",
                isFlipped: "is-flipped",
                isEndDate: "is-end-date",
                isHighlighted: "is-highlighted",
                weekNumber: "week-number",
                containerFooter: "container__footer",
                previewDateRange: "preview-date-range",
                buttonCancel: "button-cancel",
                buttonApply: "button-apply",
                containerTooltip: "container__tooltip"
            }, t.exports = e;
        },
        function(t, e, i) {
            "use strict";
            t.exports = function(t) {
                var e = [];
                return e.toString = function() {
                    return this.map(function(e) {
                        var i = function(t, e) {
                            var i = t[1] || "", n = t[3];
                            if (!n) return i;
                            if (e && "function" == typeof btoa) {
                                var o = (r = n, a = btoa(unescape(encodeURIComponent(JSON.stringify(r)))), l = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(a), "/*# ".concat(l, " */")), s = n.sources.map(function(t) {
                                    return "/*# sourceURL=".concat(n.sourceRoot || "").concat(t, " */");
                                });
                                return [
                                    i
                                ].concat(s).concat([
                                    o
                                ]).join("\n");
                            }
                            var r, a, l;
                            return [
                                i
                            ].join("\n");
                        }(e, t);
                        return e[2] ? "@media ".concat(e[2], " {").concat(i, "}") : i;
                    }).join("");
                }, e.i = function(t, i, n) {
                    "string" == typeof t && (t = [
                        [
                            null,
                            t,
                            ""
                        ]
                    ]);
                    var o = {};
                    if (n) for(var s = 0; s < this.length; s++){
                        var r = this[s][0];
                        null != r && (o[r] = !0);
                    }
                    for(var a = 0; a < t.length; a++){
                        var l = [].concat(t[a]);
                        n && o[l[0]] || (i && (l[2] ? l[2] = "".concat(i, " and ").concat(l[2]) : l[2] = i), e.push(l));
                    }
                }, e;
            };
        },
        function(t, e, i) {
            "use strict";
            var n, o = {}, s = function s() {
                return void 0 === n && (n = Boolean(window && document && document.all && !window.atob)), n;
            }, r = function() {
                var _$t = {};
                return function(e) {
                    if (void 0 === _$t[e]) {
                        var i = document.querySelector(e);
                        if (window.HTMLIFrameElement && i instanceof window.HTMLIFrameElement) try {
                            i = i.contentDocument.head;
                        } catch (t) {
                            i = null;
                        }
                        _$t[e] = i;
                    }
                    return _$t[e];
                };
            }();
            function a(t, e) {
                for(var i = [], n = {}, o = 0; o < t.length; o++){
                    var s = t[o], r = e.base ? s[0] + e.base : s[0], a = {
                        css: s[1],
                        media: s[2],
                        sourceMap: s[3]
                    };
                    n[r] ? n[r].parts.push(a) : i.push(n[r] = {
                        id: r,
                        parts: [
                            a
                        ]
                    });
                }
                return i;
            }
            function l(t, e) {
                for(var i = 0; i < t.length; i++){
                    var n = t[i], s = o[n.id], r = 0;
                    if (s) {
                        for(s.refs++; r < s.parts.length; r++)s.parts[r](n.parts[r]);
                        for(; r < n.parts.length; r++)s.parts.push(g(n.parts[r], e));
                    } else {
                        for(var a = []; r < n.parts.length; r++)a.push(g(n.parts[r], e));
                        o[n.id] = {
                            id: n.id,
                            refs: 1,
                            parts: a
                        };
                    }
                }
            }
            function c(t) {
                var e = document.createElement("style");
                if (void 0 === t.attributes.nonce) {
                    var n = i.nc;
                    n && (t.attributes.nonce = n);
                }
                if (Object.keys(t.attributes).forEach(function(i) {
                    e.setAttribute(i, t.attributes[i]);
                }), "function" == typeof t.insert) t.insert(e);
                else {
                    var o = r(t.insert || "head");
                    if (!o) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
                    o.appendChild(e);
                }
                return e;
            }
            var h, p = (h = [], function p(t, e) {
                return h[t] = e, h.filter(Boolean).join("\n");
            });
            function d(t, e, i, n) {
                var o = i ? "" : n.css;
                if (t.styleSheet) t.styleSheet.cssText = p(e, o);
                else {
                    var s = document.createTextNode(o), r = t.childNodes;
                    r[e] && t.removeChild(r[e]), r.length ? t.insertBefore(s, r[e]) : t.appendChild(s);
                }
            }
            function u(t, e, i) {
                var n = i.css, o = i.media, s = i.sourceMap;
                if (o && t.setAttribute("media", o), s && btoa && (n += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(s)))), " */")), t.styleSheet) t.styleSheet.cssText = n;
                else {
                    for(; t.firstChild;)t.removeChild(t.firstChild);
                    t.appendChild(document.createTextNode(n));
                }
            }
            var m = null, f = 0;
            function g(t, e) {
                var i, n, o;
                if (e.singleton) {
                    var s = f++;
                    i = m || (m = c(e)), n = d.bind(null, i, s, !1), o = d.bind(null, i, s, !0);
                } else i = c(e), n = u.bind(null, i, e), o = function o() {
                    !function(t) {
                        if (null === t.parentNode) return !1;
                        t.parentNode.removeChild(t);
                    }(i);
                };
                return n(t), function(e) {
                    if (e) {
                        if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return;
                        n(t = e);
                    } else o();
                };
            }
            t.exports = function(t, e) {
                (e = e || {}).attributes = "object" == (0, $2bfPH._)(e.attributes) ? e.attributes : {}, e.singleton || "boolean" == typeof e.singleton || (e.singleton = s());
                var i = a(t, e);
                return l(i, e), function(t) {
                    for(var n = [], s = 0; s < i.length; s++){
                        var r = i[s], c = o[r.id];
                        c && (c.refs--, n.push(c));
                    }
                    t && l(a(t, e), e);
                    for(var h = 0; h < n.length; h++){
                        var p = n[h];
                        if (0 === p.refs) {
                            for(var d = 0; d < p.parts.length; d++)p.parts[d]();
                            delete o[p.id];
                        }
                    }
                };
            };
        },
        function(t, e, i) {
            "use strict";
            var n = this && this.__assign || function() {
                return (n = Object.assign || function(t) {
                    for(var _$e, _$i = 1, n = arguments.length; _$i < n; _$i++)for(var o in _$e = arguments[_$i])Object.prototype.hasOwnProperty.call(_$e, o) && (t[o] = _$e[o]);
                    return t;
                }).apply(this, arguments);
            };
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var o = i(0), s = i(1), r = i(2);
            s.Litepicker.prototype.show = function(t) {
                void 0 === t && (t = null), this.emit("before:show", t);
                var _$e = t || this.options.element;
                if (this.triggerElement = _$e, !this.isShowning()) {
                    if (this.options.inlineMode) return this.ui.style.position = "relative", this.ui.style.display = "inline-block", this.ui.style.top = null, this.ui.style.left = null, this.ui.style.bottom = null, void (this.ui.style.right = null);
                    this.scrollToDate(t), this.render(), this.ui.style.position = "absolute", this.ui.style.display = "block", this.ui.style.zIndex = this.options.zIndex;
                    var _$i = this.findPosition(_$e);
                    this.ui.style.top = _$i.top + "px", this.ui.style.left = _$i.left + "px", this.ui.style.right = null, this.ui.style.bottom = null, this.emit("show", t);
                }
            }, s.Litepicker.prototype.hide = function() {
                this.isShowning() && (this.datePicked.length = 0, this.updateInput(), this.options.inlineMode ? this.render() : (this.ui.style.display = "none", this.emit("hide")));
            }, s.Litepicker.prototype.getDate = function() {
                return this.getStartDate();
            }, s.Litepicker.prototype.getStartDate = function() {
                return this.options.startDate ? this.options.startDate.clone() : null;
            }, s.Litepicker.prototype.getEndDate = function() {
                return this.options.endDate ? this.options.endDate.clone() : null;
            }, s.Litepicker.prototype.setDate = function(t, e) {
                void 0 === e && (e = !1);
                var _$i = new o.DateTime(t, this.options.format, this.options.lang);
                r.dateIsLocked(_$i, this.options, [
                    _$i
                ]) && !e ? this.emit("error:date", _$i) : (this.setStartDate(t), this.options.inlineMode && this.render(), this.emit("selected", this.getDate()));
            }, s.Litepicker.prototype.setStartDate = function(t) {
                t && (this.options.startDate = new o.DateTime(t, this.options.format, this.options.lang), this.updateInput());
            }, s.Litepicker.prototype.setEndDate = function(t) {
                t && (this.options.endDate = new o.DateTime(t, this.options.format, this.options.lang), this.options.startDate.getTime() > this.options.endDate.getTime() && (this.options.endDate = this.options.startDate.clone(), this.options.startDate = new o.DateTime(t, this.options.format, this.options.lang)), this.updateInput());
            }, s.Litepicker.prototype.setDateRange = function(t, e, i) {
                void 0 === i && (i = !1), this.triggerElement = void 0;
                var n = new o.DateTime(t, this.options.format, this.options.lang), s = new o.DateTime(e, this.options.format, this.options.lang);
                (this.options.disallowLockDaysInRange ? r.rangeIsLocked([
                    n,
                    s
                ], this.options) : r.dateIsLocked(n, this.options, [
                    n,
                    s
                ]) || r.dateIsLocked(s, this.options, [
                    n,
                    s
                ])) && !i ? this.emit("error:range", [
                    n,
                    s
                ]) : (this.setStartDate(n), this.setEndDate(s), this.options.inlineMode && this.render(), this.updateInput(), this.emit("selected", this.getStartDate(), this.getEndDate()));
            }, s.Litepicker.prototype.gotoDate = function(t, e) {
                void 0 === e && (e = 0);
                var _$i = new o.DateTime(t);
                _$i.setDate(1), this.calendars[e] = _$i.clone(), this.render();
            }, s.Litepicker.prototype.setLockDays = function(t) {
                this.options.lockDays = o.DateTime.convertArray(t, this.options.lockDaysFormat), this.render();
            }, s.Litepicker.prototype.setHighlightedDays = function(t) {
                this.options.highlightedDays = o.DateTime.convertArray(t, this.options.highlightedDaysFormat), this.render();
            }, s.Litepicker.prototype.setOptions = function(t) {
                delete t.element, delete t.elementEnd, delete t.parentEl, t.startDate && (t.startDate = new o.DateTime(t.startDate, this.options.format, this.options.lang)), t.endDate && (t.endDate = new o.DateTime(t.endDate, this.options.format, this.options.lang));
                var _$e = n(n({}, this.options.dropdowns), t.dropdowns), _$i = n(n({}, this.options.buttonText), t.buttonText), s = n(n({}, this.options.tooltipText), t.tooltipText);
                this.options = n(n({}, this.options), t), this.options.dropdowns = n({}, _$e), this.options.buttonText = n({}, _$i), this.options.tooltipText = n({}, s), !this.options.singleMode || this.options.startDate instanceof o.DateTime || (this.options.startDate = null, this.options.endDate = null), this.options.singleMode || this.options.startDate instanceof o.DateTime && this.options.endDate instanceof o.DateTime || (this.options.startDate = null, this.options.endDate = null);
                for(var r = 0; r < this.options.numberOfMonths; r += 1){
                    var a = this.options.startDate ? this.options.startDate.clone() : new o.DateTime;
                    a.setDate(1), a.setMonth(a.getMonth() + r), this.calendars[r] = a;
                }
                this.options.lockDays.length && (this.options.lockDays = o.DateTime.convertArray(this.options.lockDays, this.options.lockDaysFormat)), this.options.highlightedDays.length && (this.options.highlightedDays = o.DateTime.convertArray(this.options.highlightedDays, this.options.highlightedDaysFormat)), this.render(), this.options.inlineMode && this.show(), this.updateInput();
            }, s.Litepicker.prototype.clearSelection = function() {
                this.options.startDate = null, this.options.endDate = null, this.datePicked.length = 0, this.updateInput(), this.isShowning() && this.render(), this.emit("clear:selection");
            }, s.Litepicker.prototype.destroy = function() {
                this.ui && this.ui.parentNode && (this.ui.parentNode.removeChild(this.ui), this.ui = null), this.emit("destroy");
            };
        }
    ]);
});



var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $khBmn = parcelRequire("khBmn");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $cRssL = parcelRequire("cRssL");

var $21h22 = parcelRequire("21h22");

var $6zk1M = parcelRequire("6zk1M");

var $2bfPH = parcelRequire("2bfPH");

var $iLZuz = parcelRequire("iLZuz");

var $6PS3Z = parcelRequire("6PS3Z");

var $94db4f2abf87558b$var$Buffer = (parcelRequire("hjdi2")).Buffer;
var $94db4f2abf87558b$var$__defProp = Object.defineProperty;
var $94db4f2abf87558b$var$__defProps = Object.defineProperties;
var $94db4f2abf87558b$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $94db4f2abf87558b$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $94db4f2abf87558b$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $94db4f2abf87558b$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $94db4f2abf87558b$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $94db4f2abf87558b$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $94db4f2abf87558b$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($94db4f2abf87558b$var$__hasOwnProp.call(b, prop)) $94db4f2abf87558b$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($94db4f2abf87558b$var$__getOwnPropSymbols) try {
        for(var _iterator = $94db4f2abf87558b$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($94db4f2abf87558b$var$__propIsEnum.call(b, prop)) $94db4f2abf87558b$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $94db4f2abf87558b$var$__spreadProps = function(a, b) {
    return $94db4f2abf87558b$var$__defProps(a, $94db4f2abf87558b$var$__getOwnPropDescs(b));
};
var $94db4f2abf87558b$var$__publicField = function(obj, key, value) {
    $94db4f2abf87558b$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : (0, $2bfPH._)(key)) !== "symbol" ? key + "" : key, value);
    return value;
};
var $94db4f2abf87558b$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve2, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve2(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $94db4f2abf87558b$export$f1963fc784a1cb56 = function BaseXmlComponent(rootKey) {
    "use strict";
    (0, $gd0sY._)(this, BaseXmlComponent);
    $94db4f2abf87558b$var$__publicField(this, "rootKey");
    this.rootKey = rootKey;
};
var $94db4f2abf87558b$export$253fab909bb52269 = Object.seal({});
var $94db4f2abf87558b$export$19f99b70db82ec96 = /*#__PURE__*/ function(BaseXmlComponent1) {
    "use strict";
    (0, $NBk0Y._)(XmlComponent, BaseXmlComponent1);
    function XmlComponent(rootKey) {
        (0, $gd0sY._)(this, XmlComponent);
        var _this;
        _this = (0, $8xMIM._)(this, XmlComponent, [
            rootKey
        ]);
        // eslint-disable-next-line functional/prefer-readonly-type, @typescript-eslint/no-explicit-any
        $94db4f2abf87558b$var$__publicField(_this, "root");
        _this.root = new Array();
        return _this;
    }
    (0, $7cSld._)(XmlComponent, [
        {
            // This method is called by the formatter to get the XML representation of this component.
            // It is called recursively for all child components.
            // It is a serializer to be used in the xml library.
            // https://www.npmjs.com/package/xml
            // Child components can override this method to customize the XML representation, or execute side effects.
            key: "prepForXml",
            value: function prepForXml(context) {
                var _a;
                context.stack.push(this);
                var children = this.root.map(function(comp) {
                    if (comp instanceof $94db4f2abf87558b$export$f1963fc784a1cb56) return comp.prepForXml(context);
                    return comp;
                }).filter(function(comp) {
                    return comp !== void 0;
                });
                context.stack.pop();
                return (0, $khBmn._)({}, this.rootKey, children.length ? children.length === 1 && ((_a = children[0]) == null ? void 0 : _a._attr) ? children[0] : children : $94db4f2abf87558b$export$253fab909bb52269);
            }
        },
        {
            /**
   * @deprecated Do not use this method. It is only used internally by the library. It will be removed in a future version.
   */ key: "addChildElement",
            value: function addChildElement(child) {
                this.root.push(child);
                return this;
            }
        }
    ]);
    return XmlComponent;
}($94db4f2abf87558b$export$f1963fc784a1cb56);
var $94db4f2abf87558b$export$951524d865ce655a = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(IgnoreIfEmptyXmlComponent, XmlComponent);
    function IgnoreIfEmptyXmlComponent() {
        (0, $gd0sY._)(this, IgnoreIfEmptyXmlComponent);
        return (0, $8xMIM._)(this, IgnoreIfEmptyXmlComponent, arguments);
    }
    (0, $7cSld._)(IgnoreIfEmptyXmlComponent, [
        {
            key: "prepForXml",
            value: function prepForXml(context) {
                var result = (0, $bl6Nv._)((0, $7GsX9._)(IgnoreIfEmptyXmlComponent.prototype), "prepForXml", this).call(this, context);
                if (result && ((0, $2bfPH._)(result[this.rootKey]) !== "object" || Object.keys(result[this.rootKey]).length)) return result;
                return void 0;
            }
        }
    ]);
    return IgnoreIfEmptyXmlComponent;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$d14a6833c537c2d = /*#__PURE__*/ function(BaseXmlComponent) {
    "use strict";
    (0, $NBk0Y._)(XmlAttributeComponent, BaseXmlComponent);
    function XmlAttributeComponent(root) {
        (0, $gd0sY._)(this, XmlAttributeComponent);
        var _this;
        _this = (0, $8xMIM._)(this, XmlAttributeComponent, [
            "_attr"
        ]);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys");
        _this.root = root;
        return _this;
    }
    (0, $7cSld._)(XmlAttributeComponent, [
        {
            key: "prepForXml",
            value: function prepForXml(_) {
                var _this = this;
                var attrs = {};
                Object.keys(this.root).forEach(function(key) {
                    var value = _this.root[key];
                    if (value !== void 0) {
                        var newKey = _this.xmlKeys && _this.xmlKeys[key] || key;
                        attrs[newKey] = value;
                    }
                });
                return {
                    _attr: attrs
                };
            }
        }
    ]);
    return XmlAttributeComponent;
}($94db4f2abf87558b$export$f1963fc784a1cb56);
var $94db4f2abf87558b$export$b95d92bd70e2302a = /*#__PURE__*/ function(BaseXmlComponent) {
    "use strict";
    (0, $NBk0Y._)(NextAttributeComponent, BaseXmlComponent);
    function NextAttributeComponent(root) {
        (0, $gd0sY._)(this, NextAttributeComponent);
        var _this;
        _this = (0, $8xMIM._)(this, NextAttributeComponent, [
            "_attr"
        ]);
        _this.root = root;
        return _this;
    }
    (0, $7cSld._)(NextAttributeComponent, [
        {
            key: "prepForXml",
            value: function prepForXml(_) {
                var attrs = Object.values(this.root).filter(function(param) {
                    var value = param.value;
                    return value !== void 0;
                }).reduce(function(acc, param) {
                    var key = param.key, value = param.value;
                    return $94db4f2abf87558b$var$__spreadProps($94db4f2abf87558b$var$__spreadValues({}, acc), (0, $khBmn._)({}, key, value));
                }, {});
                return {
                    _attr: attrs
                };
            }
        }
    ]);
    return NextAttributeComponent;
}($94db4f2abf87558b$export$f1963fc784a1cb56);
var $94db4f2abf87558b$export$21991851b0bb231f = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(Attributes, XmlAttributeComponent);
    function Attributes() {
        (0, $gd0sY._)(this, Attributes);
        var _this;
        _this = (0, $8xMIM._)(this, Attributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            val: "w:val",
            color: "w:color",
            fill: "w:fill",
            space: "w:space",
            sz: "w:sz",
            type: "w:type",
            rsidR: "w:rsidR",
            rsidRPr: "w:rsidRPr",
            rsidSect: "w:rsidSect",
            w: "w:w",
            h: "w:h",
            top: "w:top",
            right: "w:right",
            bottom: "w:bottom",
            left: "w:left",
            header: "w:header",
            footer: "w:footer",
            gutter: "w:gutter",
            linePitch: "w:linePitch",
            pos: "w:pos"
        });
        return _this;
    }
    return Attributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function $94db4f2abf87558b$var$getDefaultExportFromCjs$1(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var $94db4f2abf87558b$var$sax$1 = {};
var $94db4f2abf87558b$var$events = {
    exports: {}
};
var $94db4f2abf87558b$var$R = (typeof Reflect === "undefined" ? "undefined" : (0, $2bfPH._)(Reflect)) === "object" ? Reflect : null;
var $94db4f2abf87558b$var$ReflectApply = $94db4f2abf87558b$var$R && typeof $94db4f2abf87558b$var$R.apply === "function" ? $94db4f2abf87558b$var$R.apply : function ReflectApply2(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $94db4f2abf87558b$var$ReflectOwnKeys;
if ($94db4f2abf87558b$var$R && typeof $94db4f2abf87558b$var$R.ownKeys === "function") $94db4f2abf87558b$var$ReflectOwnKeys = $94db4f2abf87558b$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $94db4f2abf87558b$var$ReflectOwnKeys = function ReflectOwnKeys2(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $94db4f2abf87558b$var$ReflectOwnKeys = function ReflectOwnKeys2(target) {
    return Object.getOwnPropertyNames(target);
};
function $94db4f2abf87558b$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $94db4f2abf87558b$var$NumberIsNaN = Number.isNaN || function NumberIsNaN2(value) {
    return value !== value;
};
function $94db4f2abf87558b$var$EventEmitter() {
    $94db4f2abf87558b$var$EventEmitter.init.call(this);
}
$94db4f2abf87558b$var$events.exports = $94db4f2abf87558b$var$EventEmitter;
$94db4f2abf87558b$var$events.exports.once = $94db4f2abf87558b$var$once2;
$94db4f2abf87558b$var$EventEmitter.EventEmitter = $94db4f2abf87558b$var$EventEmitter;
$94db4f2abf87558b$var$EventEmitter.prototype._events = void 0;
$94db4f2abf87558b$var$EventEmitter.prototype._eventsCount = 0;
$94db4f2abf87558b$var$EventEmitter.prototype._maxListeners = void 0;
var $94db4f2abf87558b$var$defaultMaxListeners = 10;
function $94db4f2abf87558b$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + (typeof listener === "undefined" ? "undefined" : (0, $2bfPH._)(listener)));
}
Object.defineProperty($94db4f2abf87558b$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function get() {
        return $94db4f2abf87558b$var$defaultMaxListeners;
    },
    set: function set(arg) {
        if (typeof arg !== "number" || arg < 0 || $94db4f2abf87558b$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $94db4f2abf87558b$var$defaultMaxListeners = arg;
    }
});
$94db4f2abf87558b$var$EventEmitter.init = function() {
    if (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) {
        this._events = /* @__PURE__ */ Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || void 0;
};
$94db4f2abf87558b$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $94db4f2abf87558b$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $94db4f2abf87558b$var$_getMaxListeners(that) {
    if (that._maxListeners === void 0) return $94db4f2abf87558b$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$94db4f2abf87558b$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $94db4f2abf87558b$var$_getMaxListeners(this);
};
$94db4f2abf87558b$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events2 = this._events;
    if (events2 !== void 0) doError = doError && events2.error === void 0;
    else if (!doError) return false;
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) throw er;
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err;
    }
    var handler = events2[type];
    if (handler === void 0) return false;
    if (typeof handler === "function") $94db4f2abf87558b$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners2 = $94db4f2abf87558b$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$94db4f2abf87558b$var$ReflectApply(listeners2[i], this, args);
    }
    return true;
};
function $94db4f2abf87558b$var$_addListener(target, type, listener, prepend) {
    var m;
    var events2;
    var existing;
    $94db4f2abf87558b$var$checkListener(listener);
    events2 = target._events;
    if (events2 === void 0) {
        events2 = target._events = /* @__PURE__ */ Object.create(null);
        target._eventsCount = 0;
    } else {
        if (events2.newListener !== void 0) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            events2 = target._events;
        }
        existing = events2[type];
    }
    if (existing === void 0) {
        existing = events2[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") existing = events2[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        m = $94db4f2abf87558b$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners added. Use emitter.setMaxListeners() to increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $94db4f2abf87558b$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$94db4f2abf87558b$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $94db4f2abf87558b$var$_addListener(this, type, listener, false);
};
$94db4f2abf87558b$var$EventEmitter.prototype.on = $94db4f2abf87558b$var$EventEmitter.prototype.addListener;
$94db4f2abf87558b$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $94db4f2abf87558b$var$_addListener(this, type, listener, true);
};
function $94db4f2abf87558b$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $94db4f2abf87558b$var$_onceWrap(target, type, listener) {
    var state2 = {
        fired: false,
        wrapFn: void 0,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $94db4f2abf87558b$var$onceWrapper.bind(state2);
    wrapped.listener = listener;
    state2.wrapFn = wrapped;
    return wrapped;
}
$94db4f2abf87558b$var$EventEmitter.prototype.once = function once(type, listener) {
    $94db4f2abf87558b$var$checkListener(listener);
    this.on(type, $94db4f2abf87558b$var$_onceWrap(this, type, listener));
    return this;
};
$94db4f2abf87558b$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $94db4f2abf87558b$var$checkListener(listener);
    this.prependListener(type, $94db4f2abf87558b$var$_onceWrap(this, type, listener));
    return this;
};
$94db4f2abf87558b$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events2, position, i, originalListener;
    $94db4f2abf87558b$var$checkListener(listener);
    events2 = this._events;
    if (events2 === void 0) return this;
    list = events2[type];
    if (list === void 0) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = /* @__PURE__ */ Object.create(null);
        else {
            delete events2[type];
            if (events2.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $94db4f2abf87558b$var$spliceOne(list, position);
        if (list.length === 1) events2[type] = list[0];
        if (events2.removeListener !== void 0) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$94db4f2abf87558b$var$EventEmitter.prototype.off = $94db4f2abf87558b$var$EventEmitter.prototype.removeListener;
$94db4f2abf87558b$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners2, events2, i;
    events2 = this._events;
    if (events2 === void 0) return this;
    if (events2.removeListener === void 0) {
        if (arguments.length === 0) {
            this._events = /* @__PURE__ */ Object.create(null);
            this._eventsCount = 0;
        } else if (events2[type] !== void 0) {
            if (--this._eventsCount === 0) this._events = /* @__PURE__ */ Object.create(null);
            else delete events2[type];
        }
        return this;
    }
    if (arguments.length === 0) {
        var keys = Object.keys(events2);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = /* @__PURE__ */ Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners2 = events2[type];
    if (typeof listeners2 === "function") this.removeListener(type, listeners2);
    else if (listeners2 !== void 0) for(i = listeners2.length - 1; i >= 0; i--)this.removeListener(type, listeners2[i]);
    return this;
};
function $94db4f2abf87558b$var$_listeners(target, type, unwrap) {
    var events2 = target._events;
    if (events2 === void 0) return [];
    var evlistener = events2[type];
    if (evlistener === void 0) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $94db4f2abf87558b$var$unwrapListeners(evlistener) : $94db4f2abf87558b$var$arrayClone(evlistener, evlistener.length);
}
$94db4f2abf87558b$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $94db4f2abf87558b$var$_listeners(this, type, true);
};
$94db4f2abf87558b$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $94db4f2abf87558b$var$_listeners(this, type, false);
};
$94db4f2abf87558b$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $94db4f2abf87558b$var$listenerCount.call(emitter, type);
};
$94db4f2abf87558b$var$EventEmitter.prototype.listenerCount = $94db4f2abf87558b$var$listenerCount;
function $94db4f2abf87558b$var$listenerCount(type) {
    var events2 = this._events;
    if (events2 !== void 0) {
        var evlistener = events2[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== void 0) return evlistener.length;
    }
    return 0;
}
$94db4f2abf87558b$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $94db4f2abf87558b$var$ReflectOwnKeys(this._events) : [];
};
function $94db4f2abf87558b$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $94db4f2abf87558b$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $94db4f2abf87558b$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $94db4f2abf87558b$var$once2(emitter, name) {
    return new Promise(function(resolve2, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve2([].slice.call(arguments));
        }
        $94db4f2abf87558b$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $94db4f2abf87558b$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $94db4f2abf87558b$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $94db4f2abf87558b$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $94db4f2abf87558b$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") emitter.addEventListener(name, function wrapListener(arg) {
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + (typeof emitter === "undefined" ? "undefined" : (0, $2bfPH._)(emitter)));
}
var $94db4f2abf87558b$var$eventsExports = $94db4f2abf87558b$var$events.exports;
var $94db4f2abf87558b$var$inherits_browser = {
    exports: {}
};
if (typeof Object.create === "function") $94db4f2abf87558b$var$inherits_browser.exports = function inherits2(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else $94db4f2abf87558b$var$inherits_browser.exports = function inherits2(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};
var $94db4f2abf87558b$var$inherits_browserExports = $94db4f2abf87558b$var$inherits_browser.exports;
function $94db4f2abf87558b$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var $94db4f2abf87558b$var$browser$1 = {
    exports: {}
};
var $94db4f2abf87558b$var$process = $94db4f2abf87558b$var$browser$1.exports = {};
var $94db4f2abf87558b$var$cachedSetTimeout;
var $94db4f2abf87558b$var$cachedClearTimeout;
function $94db4f2abf87558b$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $94db4f2abf87558b$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $94db4f2abf87558b$var$cachedSetTimeout = setTimeout;
        else $94db4f2abf87558b$var$cachedSetTimeout = $94db4f2abf87558b$var$defaultSetTimout;
    } catch (e) {
        $94db4f2abf87558b$var$cachedSetTimeout = $94db4f2abf87558b$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $94db4f2abf87558b$var$cachedClearTimeout = clearTimeout;
        else $94db4f2abf87558b$var$cachedClearTimeout = $94db4f2abf87558b$var$defaultClearTimeout;
    } catch (e) {
        $94db4f2abf87558b$var$cachedClearTimeout = $94db4f2abf87558b$var$defaultClearTimeout;
    }
})();
function $94db4f2abf87558b$var$runTimeout(fun) {
    if ($94db4f2abf87558b$var$cachedSetTimeout === setTimeout) return setTimeout(fun, 0);
    if (($94db4f2abf87558b$var$cachedSetTimeout === $94db4f2abf87558b$var$defaultSetTimout || !$94db4f2abf87558b$var$cachedSetTimeout) && setTimeout) {
        $94db4f2abf87558b$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        return $94db4f2abf87558b$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            return $94db4f2abf87558b$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e2) {
            return $94db4f2abf87558b$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $94db4f2abf87558b$var$runClearTimeout(marker) {
    if ($94db4f2abf87558b$var$cachedClearTimeout === clearTimeout) return clearTimeout(marker);
    if (($94db4f2abf87558b$var$cachedClearTimeout === $94db4f2abf87558b$var$defaultClearTimeout || !$94db4f2abf87558b$var$cachedClearTimeout) && clearTimeout) {
        $94db4f2abf87558b$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        return $94db4f2abf87558b$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            return $94db4f2abf87558b$var$cachedClearTimeout.call(null, marker);
        } catch (e2) {
            return $94db4f2abf87558b$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $94db4f2abf87558b$var$queue = [];
var $94db4f2abf87558b$var$draining = false;
var $94db4f2abf87558b$var$currentQueue;
var $94db4f2abf87558b$var$queueIndex = -1;
function $94db4f2abf87558b$var$cleanUpNextTick() {
    if (!$94db4f2abf87558b$var$draining || !$94db4f2abf87558b$var$currentQueue) return;
    $94db4f2abf87558b$var$draining = false;
    if ($94db4f2abf87558b$var$currentQueue.length) $94db4f2abf87558b$var$queue = $94db4f2abf87558b$var$currentQueue.concat($94db4f2abf87558b$var$queue);
    else $94db4f2abf87558b$var$queueIndex = -1;
    if ($94db4f2abf87558b$var$queue.length) $94db4f2abf87558b$var$drainQueue();
}
function $94db4f2abf87558b$var$drainQueue() {
    if ($94db4f2abf87558b$var$draining) return;
    var timeout = $94db4f2abf87558b$var$runTimeout($94db4f2abf87558b$var$cleanUpNextTick);
    $94db4f2abf87558b$var$draining = true;
    var len = $94db4f2abf87558b$var$queue.length;
    while(len){
        $94db4f2abf87558b$var$currentQueue = $94db4f2abf87558b$var$queue;
        $94db4f2abf87558b$var$queue = [];
        while(++$94db4f2abf87558b$var$queueIndex < len)if ($94db4f2abf87558b$var$currentQueue) $94db4f2abf87558b$var$currentQueue[$94db4f2abf87558b$var$queueIndex].run();
        $94db4f2abf87558b$var$queueIndex = -1;
        len = $94db4f2abf87558b$var$queue.length;
    }
    $94db4f2abf87558b$var$currentQueue = null;
    $94db4f2abf87558b$var$draining = false;
    $94db4f2abf87558b$var$runClearTimeout(timeout);
}
$94db4f2abf87558b$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $94db4f2abf87558b$var$queue.push(new $94db4f2abf87558b$var$Item(fun, args));
    if ($94db4f2abf87558b$var$queue.length === 1 && !$94db4f2abf87558b$var$draining) $94db4f2abf87558b$var$runTimeout($94db4f2abf87558b$var$drainQueue);
};
function $94db4f2abf87558b$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$94db4f2abf87558b$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$94db4f2abf87558b$var$process.title = "browser";
$94db4f2abf87558b$var$process.browser = true;
$94db4f2abf87558b$var$process.env = {};
$94db4f2abf87558b$var$process.argv = [];
$94db4f2abf87558b$var$process.version = "";
$94db4f2abf87558b$var$process.versions = {};
function $94db4f2abf87558b$var$noop() {}
$94db4f2abf87558b$var$process.on = $94db4f2abf87558b$var$noop;
$94db4f2abf87558b$var$process.addListener = $94db4f2abf87558b$var$noop;
$94db4f2abf87558b$var$process.once = $94db4f2abf87558b$var$noop;
$94db4f2abf87558b$var$process.off = $94db4f2abf87558b$var$noop;
$94db4f2abf87558b$var$process.removeListener = $94db4f2abf87558b$var$noop;
$94db4f2abf87558b$var$process.removeAllListeners = $94db4f2abf87558b$var$noop;
$94db4f2abf87558b$var$process.emit = $94db4f2abf87558b$var$noop;
$94db4f2abf87558b$var$process.prependListener = $94db4f2abf87558b$var$noop;
$94db4f2abf87558b$var$process.prependOnceListener = $94db4f2abf87558b$var$noop;
$94db4f2abf87558b$var$process.listeners = function(name) {
    return [];
};
$94db4f2abf87558b$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$94db4f2abf87558b$var$process.cwd = function() {
    return "/";
};
$94db4f2abf87558b$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$94db4f2abf87558b$var$process.umask = function() {
    return 0;
};
var $94db4f2abf87558b$var$browserExports = $94db4f2abf87558b$var$browser$1.exports;
var $94db4f2abf87558b$var$process$1 = /* @__PURE__ */ $94db4f2abf87558b$var$getDefaultExportFromCjs($94db4f2abf87558b$var$browserExports);
var $94db4f2abf87558b$var$streamBrowser;
var $94db4f2abf87558b$var$hasRequiredStreamBrowser;
function $94db4f2abf87558b$var$requireStreamBrowser() {
    if ($94db4f2abf87558b$var$hasRequiredStreamBrowser) return $94db4f2abf87558b$var$streamBrowser;
    $94db4f2abf87558b$var$hasRequiredStreamBrowser = 1;
    $94db4f2abf87558b$var$streamBrowser = $94db4f2abf87558b$var$eventsExports.EventEmitter;
    return $94db4f2abf87558b$var$streamBrowser;
}
var $94db4f2abf87558b$var$buffer = {};
var $94db4f2abf87558b$var$base64Js = {};
var $94db4f2abf87558b$var$hasRequiredBase64Js;
function $94db4f2abf87558b$var$requireBase64Js() {
    if ($94db4f2abf87558b$var$hasRequiredBase64Js) return $94db4f2abf87558b$var$base64Js;
    $94db4f2abf87558b$var$hasRequiredBase64Js = 1;
    $94db4f2abf87558b$var$base64Js.byteLength = byteLength;
    $94db4f2abf87558b$var$base64Js.toByteArray = toByteArray;
    $94db4f2abf87558b$var$base64Js.fromByteArray = fromByteArray;
    var lookup = [];
    var revLookup = [];
    var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
    var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    for(var i = 0, len = code.length; i < len; ++i){
        lookup[i] = code[i];
        revLookup[code.charCodeAt(i)] = i;
    }
    revLookup["-".charCodeAt(0)] = 62;
    revLookup["_".charCodeAt(0)] = 63;
    function getLens(b64) {
        var len2 = b64.length;
        if (len2 % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
        var validLen = b64.indexOf("=");
        if (validLen === -1) validLen = len2;
        var placeHoldersLen = validLen === len2 ? 0 : 4 - validLen % 4;
        return [
            validLen,
            placeHoldersLen
        ];
    }
    function byteLength(b64) {
        var lens = getLens(b64);
        var validLen = lens[0];
        var placeHoldersLen = lens[1];
        return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
    }
    function _byteLength(b64, validLen, placeHoldersLen) {
        return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
    }
    function toByteArray(b64) {
        var tmp;
        var lens = getLens(b64);
        var validLen = lens[0];
        var placeHoldersLen = lens[1];
        var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
        var curByte = 0;
        var len2 = placeHoldersLen > 0 ? validLen - 4 : validLen;
        var i2;
        for(i2 = 0; i2 < len2; i2 += 4){
            tmp = revLookup[b64.charCodeAt(i2)] << 18 | revLookup[b64.charCodeAt(i2 + 1)] << 12 | revLookup[b64.charCodeAt(i2 + 2)] << 6 | revLookup[b64.charCodeAt(i2 + 3)];
            arr[curByte++] = tmp >> 16 & 255;
            arr[curByte++] = tmp >> 8 & 255;
            arr[curByte++] = tmp & 255;
        }
        if (placeHoldersLen === 2) {
            tmp = revLookup[b64.charCodeAt(i2)] << 2 | revLookup[b64.charCodeAt(i2 + 1)] >> 4;
            arr[curByte++] = tmp & 255;
        }
        if (placeHoldersLen === 1) {
            tmp = revLookup[b64.charCodeAt(i2)] << 10 | revLookup[b64.charCodeAt(i2 + 1)] << 4 | revLookup[b64.charCodeAt(i2 + 2)] >> 2;
            arr[curByte++] = tmp >> 8 & 255;
            arr[curByte++] = tmp & 255;
        }
        return arr;
    }
    function tripletToBase64(num) {
        return lookup[num >> 18 & 63] + lookup[num >> 12 & 63] + lookup[num >> 6 & 63] + lookup[num & 63];
    }
    function encodeChunk(uint8, start, end) {
        var tmp;
        var output = [];
        for(var i2 = start; i2 < end; i2 += 3){
            tmp = (uint8[i2] << 16 & 16711680) + (uint8[i2 + 1] << 8 & 65280) + (uint8[i2 + 2] & 255);
            output.push(tripletToBase64(tmp));
        }
        return output.join("");
    }
    function fromByteArray(uint8) {
        var tmp;
        var len2 = uint8.length;
        var extraBytes = len2 % 3;
        var parts = [];
        var maxChunkLength = 16383;
        for(var i2 = 0, len22 = len2 - extraBytes; i2 < len22; i2 += maxChunkLength)parts.push(encodeChunk(uint8, i2, i2 + maxChunkLength > len22 ? len22 : i2 + maxChunkLength));
        if (extraBytes === 1) {
            tmp = uint8[len2 - 1];
            parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 63] + "==");
        } else if (extraBytes === 2) {
            tmp = (uint8[len2 - 2] << 8) + uint8[len2 - 1];
            parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 63] + lookup[tmp << 2 & 63] + "=");
        }
        return parts.join("");
    }
    return $94db4f2abf87558b$var$base64Js;
}
var $94db4f2abf87558b$var$ieee754 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $94db4f2abf87558b$var$hasRequiredIeee754;
function $94db4f2abf87558b$var$requireIeee754() {
    if ($94db4f2abf87558b$var$hasRequiredIeee754) return $94db4f2abf87558b$var$ieee754;
    $94db4f2abf87558b$var$hasRequiredIeee754 = 1;
    $94db4f2abf87558b$var$ieee754.read = function(buffer2, offset, isLE, mLen, nBytes) {
        var e, m;
        var eLen = nBytes * 8 - mLen - 1;
        var eMax = (1 << eLen) - 1;
        var eBias = eMax >> 1;
        var nBits = -7;
        var i = isLE ? nBytes - 1 : 0;
        var d = isLE ? -1 : 1;
        var s = buffer2[offset + i];
        i += d;
        e = s & (1 << -nBits) - 1;
        s >>= -nBits;
        nBits += eLen;
        for(; nBits > 0; e = e * 256 + buffer2[offset + i], i += d, nBits -= 8);
        m = e & (1 << -nBits) - 1;
        e >>= -nBits;
        nBits += mLen;
        for(; nBits > 0; m = m * 256 + buffer2[offset + i], i += d, nBits -= 8);
        if (e === 0) e = 1 - eBias;
        else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
        else {
            m = m + Math.pow(2, mLen);
            e = e - eBias;
        }
        return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
    };
    $94db4f2abf87558b$var$ieee754.write = function(buffer2, value, offset, isLE, mLen, nBytes) {
        var e, m, c;
        var eLen = nBytes * 8 - mLen - 1;
        var eMax = (1 << eLen) - 1;
        var eBias = eMax >> 1;
        var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
        var i = isLE ? 0 : nBytes - 1;
        var d = isLE ? 1 : -1;
        var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
        value = Math.abs(value);
        if (isNaN(value) || value === Infinity) {
            m = isNaN(value) ? 1 : 0;
            e = eMax;
        } else {
            e = Math.floor(Math.log(value) / Math.LN2);
            if (value * (c = Math.pow(2, -e)) < 1) {
                e--;
                c *= 2;
            }
            if (e + eBias >= 1) value += rt / c;
            else value += rt * Math.pow(2, 1 - eBias);
            if (value * c >= 2) {
                e++;
                c /= 2;
            }
            if (e + eBias >= eMax) {
                m = 0;
                e = eMax;
            } else if (e + eBias >= 1) {
                m = (value * c - 1) * Math.pow(2, mLen);
                e = e + eBias;
            } else {
                m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
                e = 0;
            }
        }
        for(; mLen >= 8; buffer2[offset + i] = m & 255, i += d, m /= 256, mLen -= 8);
        e = e << mLen | m;
        eLen += mLen;
        for(; eLen > 0; buffer2[offset + i] = e & 255, i += d, e /= 256, eLen -= 8);
        buffer2[offset + i - d] |= s * 128;
    };
    return $94db4f2abf87558b$var$ieee754;
}
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ var $94db4f2abf87558b$var$hasRequiredBuffer;
function $94db4f2abf87558b$var$requireBuffer() {
    if ($94db4f2abf87558b$var$hasRequiredBuffer) return $94db4f2abf87558b$var$buffer;
    $94db4f2abf87558b$var$hasRequiredBuffer = 1;
    (function(exports) {
        var base64 = $94db4f2abf87558b$var$requireBase64Js();
        var ieee7542 = $94db4f2abf87558b$var$requireIeee754();
        var customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" ? Symbol["for"]("nodejs.util.inspect.custom") : null;
        exports.Buffer = Buffer2;
        exports.SlowBuffer = SlowBuffer;
        exports.INSPECT_MAX_BYTES = 50;
        var K_MAX_LENGTH = 2147483647;
        exports.kMaxLength = K_MAX_LENGTH;
        Buffer2.TYPED_ARRAY_SUPPORT = typedArraySupport();
        if (!Buffer2.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
        function typedArraySupport() {
            try {
                var arr = new Uint8Array(1);
                var proto = {
                    foo: function foo() {
                        return 42;
                    }
                };
                Object.setPrototypeOf(proto, Uint8Array.prototype);
                Object.setPrototypeOf(arr, proto);
                return arr.foo() === 42;
            } catch (e) {
                return false;
            }
        }
        Object.defineProperty(Buffer2.prototype, "parent", {
            enumerable: true,
            get: function get() {
                if (!Buffer2.isBuffer(this)) return void 0;
                return this.buffer;
            }
        });
        Object.defineProperty(Buffer2.prototype, "offset", {
            enumerable: true,
            get: function get() {
                if (!Buffer2.isBuffer(this)) return void 0;
                return this.byteOffset;
            }
        });
        function createBuffer(length) {
            if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
            var buf = new Uint8Array(length);
            Object.setPrototypeOf(buf, Buffer2.prototype);
            return buf;
        }
        function Buffer2(arg, encodingOrOffset, length) {
            if (typeof arg === "number") {
                if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
                return allocUnsafe(arg);
            }
            return from(arg, encodingOrOffset, length);
        }
        Buffer2.poolSize = 8192;
        function from(value, encodingOrOffset, length) {
            if (typeof value === "string") return fromString(value, encodingOrOffset);
            if (ArrayBuffer.isView(value)) return fromArrayView(value);
            if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)));
            if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
            if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
            if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
            var valueOf = value.valueOf && value.valueOf();
            if (valueOf != null && valueOf !== value) return Buffer2.from(valueOf, encodingOrOffset, length);
            var b = fromObject(value);
            if (b) return b;
            if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return Buffer2.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
            throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)));
        }
        Buffer2.from = function(value, encodingOrOffset, length) {
            return from(value, encodingOrOffset, length);
        };
        Object.setPrototypeOf(Buffer2.prototype, Uint8Array.prototype);
        Object.setPrototypeOf(Buffer2, Uint8Array);
        function assertSize(size) {
            if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
            else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
        }
        function alloc(size, fill, encoding) {
            assertSize(size);
            if (size <= 0) return createBuffer(size);
            if (fill !== void 0) return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
            return createBuffer(size);
        }
        Buffer2.alloc = function(size, fill, encoding) {
            return alloc(size, fill, encoding);
        };
        function allocUnsafe(size) {
            assertSize(size);
            return createBuffer(size < 0 ? 0 : checked(size) | 0);
        }
        Buffer2.allocUnsafe = function(size) {
            return allocUnsafe(size);
        };
        Buffer2.allocUnsafeSlow = function(size) {
            return allocUnsafe(size);
        };
        function fromString(string, encoding) {
            if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
            if (!Buffer2.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
            var length = byteLength(string, encoding) | 0;
            var buf = createBuffer(length);
            var actual = buf.write(string, encoding);
            if (actual !== length) buf = buf.slice(0, actual);
            return buf;
        }
        function fromArrayLike(array) {
            var length = array.length < 0 ? 0 : checked(array.length) | 0;
            var buf = createBuffer(length);
            for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
            return buf;
        }
        function fromArrayView(arrayView) {
            if (isInstance(arrayView, Uint8Array)) {
                var copy = new Uint8Array(arrayView);
                return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
            }
            return fromArrayLike(arrayView);
        }
        function fromArrayBuffer(array, byteOffset, length) {
            if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
            if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
            var buf;
            if (byteOffset === void 0 && length === void 0) buf = new Uint8Array(array);
            else if (length === void 0) buf = new Uint8Array(array, byteOffset);
            else buf = new Uint8Array(array, byteOffset, length);
            Object.setPrototypeOf(buf, Buffer2.prototype);
            return buf;
        }
        function fromObject(obj) {
            if (Buffer2.isBuffer(obj)) {
                var len = checked(obj.length) | 0;
                var buf = createBuffer(len);
                if (buf.length === 0) return buf;
                obj.copy(buf, 0, 0, len);
                return buf;
            }
            if (obj.length !== void 0) {
                if (typeof obj.length !== "number" || numberIsNaN(obj.length)) return createBuffer(0);
                return fromArrayLike(obj);
            }
            if (obj.type === "Buffer" && Array.isArray(obj.data)) return fromArrayLike(obj.data);
        }
        function checked(length) {
            if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
            return length | 0;
        }
        function SlowBuffer(length) {
            if (+length != length) length = 0;
            return Buffer2.alloc(+length);
        }
        Buffer2.isBuffer = function isBuffer(b) {
            return b != null && b._isBuffer === true && b !== Buffer2.prototype;
        };
        Buffer2.compare = function compare(a, b) {
            if (isInstance(a, Uint8Array)) a = Buffer2.from(a, a.offset, a.byteLength);
            if (isInstance(b, Uint8Array)) b = Buffer2.from(b, b.offset, b.byteLength);
            if (!Buffer2.isBuffer(a) || !Buffer2.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
            if (a === b) return 0;
            var x = a.length;
            var y = b.length;
            for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
                x = a[i];
                y = b[i];
                break;
            }
            if (x < y) return -1;
            if (y < x) return 1;
            return 0;
        };
        Buffer2.isEncoding = function isEncoding(encoding) {
            switch(String(encoding).toLowerCase()){
                case "hex":
                case "utf8":
                case "utf-8":
                case "ascii":
                case "latin1":
                case "binary":
                case "base64":
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                    return true;
                default:
                    return false;
            }
        };
        Buffer2.concat = function concat(list, length) {
            if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
            if (list.length === 0) return Buffer2.alloc(0);
            var i;
            if (length === void 0) {
                length = 0;
                for(i = 0; i < list.length; ++i)length += list[i].length;
            }
            var buffer2 = Buffer2.allocUnsafe(length);
            var pos = 0;
            for(i = 0; i < list.length; ++i){
                var buf = list[i];
                if (isInstance(buf, Uint8Array)) {
                    if (pos + buf.length > buffer2.length) Buffer2.from(buf).copy(buffer2, pos);
                    else Uint8Array.prototype.set.call(buffer2, buf, pos);
                } else if (!Buffer2.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
                else buf.copy(buffer2, pos);
                pos += buf.length;
            }
            return buffer2;
        };
        function byteLength(string, encoding) {
            if (Buffer2.isBuffer(string)) return string.length;
            if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
            if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $2bfPH._)(string)));
            var len = string.length;
            var mustMatch = arguments.length > 2 && arguments[2] === true;
            if (!mustMatch && len === 0) return 0;
            var loweredCase = false;
            for(;;)switch(encoding){
                case "ascii":
                case "latin1":
                case "binary":
                    return len;
                case "utf8":
                case "utf-8":
                    return utf8ToBytes(string).length;
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                    return len * 2;
                case "hex":
                    return len >>> 1;
                case "base64":
                    return base64ToBytes(string).length;
                default:
                    if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length;
                    encoding = ("" + encoding).toLowerCase();
                    loweredCase = true;
            }
        }
        Buffer2.byteLength = byteLength;
        function slowToString(encoding, start, end) {
            var loweredCase = false;
            if (start === void 0 || start < 0) start = 0;
            if (start > this.length) return "";
            if (end === void 0 || end > this.length) end = this.length;
            if (end <= 0) return "";
            end >>>= 0;
            start >>>= 0;
            if (end <= start) return "";
            if (!encoding) encoding = "utf8";
            while(true)switch(encoding){
                case "hex":
                    return hexSlice(this, start, end);
                case "utf8":
                case "utf-8":
                    return utf8Slice(this, start, end);
                case "ascii":
                    return asciiSlice(this, start, end);
                case "latin1":
                case "binary":
                    return latin1Slice(this, start, end);
                case "base64":
                    return base64Slice(this, start, end);
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                    return utf16leSlice(this, start, end);
                default:
                    if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
                    encoding = (encoding + "").toLowerCase();
                    loweredCase = true;
            }
        }
        Buffer2.prototype._isBuffer = true;
        function swap(b, n, m) {
            var i = b[n];
            b[n] = b[m];
            b[m] = i;
        }
        Buffer2.prototype.swap16 = function swap16() {
            var len = this.length;
            if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
            for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
            return this;
        };
        Buffer2.prototype.swap32 = function swap32() {
            var len = this.length;
            if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
            for(var i = 0; i < len; i += 4){
                swap(this, i, i + 3);
                swap(this, i + 1, i + 2);
            }
            return this;
        };
        Buffer2.prototype.swap64 = function swap64() {
            var len = this.length;
            if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
            for(var i = 0; i < len; i += 8){
                swap(this, i, i + 7);
                swap(this, i + 1, i + 6);
                swap(this, i + 2, i + 5);
                swap(this, i + 3, i + 4);
            }
            return this;
        };
        Buffer2.prototype.toString = function toString() {
            var length = this.length;
            if (length === 0) return "";
            if (arguments.length === 0) return utf8Slice(this, 0, length);
            return slowToString.apply(this, arguments);
        };
        Buffer2.prototype.toLocaleString = Buffer2.prototype.toString;
        Buffer2.prototype.equals = function equals(b) {
            if (!Buffer2.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
            if (this === b) return true;
            return Buffer2.compare(this, b) === 0;
        };
        Buffer2.prototype.inspect = function inspect() {
            var str = "";
            var max = exports.INSPECT_MAX_BYTES;
            str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
            if (this.length > max) str += " ... ";
            return "<Buffer " + str + ">";
        };
        if (customInspectSymbol) Buffer2.prototype[customInspectSymbol] = Buffer2.prototype.inspect;
        Buffer2.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
            if (isInstance(target, Uint8Array)) target = Buffer2.from(target, target.offset, target.byteLength);
            if (!Buffer2.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $2bfPH._)(target)));
            if (start === void 0) start = 0;
            if (end === void 0) end = target ? target.length : 0;
            if (thisStart === void 0) thisStart = 0;
            if (thisEnd === void 0) thisEnd = this.length;
            if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
            if (thisStart >= thisEnd && start >= end) return 0;
            if (thisStart >= thisEnd) return -1;
            if (start >= end) return 1;
            start >>>= 0;
            end >>>= 0;
            thisStart >>>= 0;
            thisEnd >>>= 0;
            if (this === target) return 0;
            var x = thisEnd - thisStart;
            var y = end - start;
            var len = Math.min(x, y);
            var thisCopy = this.slice(thisStart, thisEnd);
            var targetCopy = target.slice(start, end);
            for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
                x = thisCopy[i];
                y = targetCopy[i];
                break;
            }
            if (x < y) return -1;
            if (y < x) return 1;
            return 0;
        };
        function bidirectionalIndexOf(buffer2, val, byteOffset, encoding, dir) {
            if (buffer2.length === 0) return -1;
            if (typeof byteOffset === "string") {
                encoding = byteOffset;
                byteOffset = 0;
            } else if (byteOffset > 2147483647) byteOffset = 2147483647;
            else if (byteOffset < -2147483648) byteOffset = -2147483648;
            byteOffset = +byteOffset;
            if (numberIsNaN(byteOffset)) byteOffset = dir ? 0 : buffer2.length - 1;
            if (byteOffset < 0) byteOffset = buffer2.length + byteOffset;
            if (byteOffset >= buffer2.length) {
                if (dir) return -1;
                else byteOffset = buffer2.length - 1;
            } else if (byteOffset < 0) {
                if (dir) byteOffset = 0;
                else return -1;
            }
            if (typeof val === "string") val = Buffer2.from(val, encoding);
            if (Buffer2.isBuffer(val)) {
                if (val.length === 0) return -1;
                return arrayIndexOf(buffer2, val, byteOffset, encoding, dir);
            } else if (typeof val === "number") {
                val = val & 255;
                if (typeof Uint8Array.prototype.indexOf === "function") {
                    if (dir) return Uint8Array.prototype.indexOf.call(buffer2, val, byteOffset);
                    else return Uint8Array.prototype.lastIndexOf.call(buffer2, val, byteOffset);
                }
                return arrayIndexOf(buffer2, [
                    val
                ], byteOffset, encoding, dir);
            }
            throw new TypeError("val must be string, number or Buffer");
        }
        function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
            var indexSize = 1;
            var arrLength = arr.length;
            var valLength = val.length;
            if (encoding !== void 0) {
                encoding = String(encoding).toLowerCase();
                if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
                    if (arr.length < 2 || val.length < 2) return -1;
                    indexSize = 2;
                    arrLength /= 2;
                    valLength /= 2;
                    byteOffset /= 2;
                }
            }
            function read(buf, i2) {
                if (indexSize === 1) return buf[i2];
                else return buf.readUInt16BE(i2 * indexSize);
            }
            var i;
            if (dir) {
                var foundIndex = -1;
                for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
                    if (foundIndex === -1) foundIndex = i;
                    if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
                } else {
                    if (foundIndex !== -1) i -= i - foundIndex;
                    foundIndex = -1;
                }
            } else {
                if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
                for(i = byteOffset; i >= 0; i--){
                    var found = true;
                    for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                        found = false;
                        break;
                    }
                    if (found) return i;
                }
            }
            return -1;
        }
        Buffer2.prototype.includes = function includes(val, byteOffset, encoding) {
            return this.indexOf(val, byteOffset, encoding) !== -1;
        };
        Buffer2.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
            return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
        };
        Buffer2.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
            return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
        };
        function hexWrite(buf, string, offset, length) {
            offset = Number(offset) || 0;
            var remaining = buf.length - offset;
            if (!length) length = remaining;
            else {
                length = Number(length);
                if (length > remaining) length = remaining;
            }
            var strLen = string.length;
            if (length > strLen / 2) length = strLen / 2;
            for(var i = 0; i < length; ++i){
                var parsed = parseInt(string.substr(i * 2, 2), 16);
                if (numberIsNaN(parsed)) return i;
                buf[offset + i] = parsed;
            }
            return i;
        }
        function utf8Write(buf, string, offset, length) {
            return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
        }
        function asciiWrite(buf, string, offset, length) {
            return blitBuffer(asciiToBytes(string), buf, offset, length);
        }
        function base64Write(buf, string, offset, length) {
            return blitBuffer(base64ToBytes(string), buf, offset, length);
        }
        function ucs2Write(buf, string, offset, length) {
            return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
        }
        Buffer2.prototype.write = function write(string, offset, length, encoding) {
            if (offset === void 0) {
                encoding = "utf8";
                length = this.length;
                offset = 0;
            } else if (length === void 0 && typeof offset === "string") {
                encoding = offset;
                length = this.length;
                offset = 0;
            } else if (isFinite(offset)) {
                offset = offset >>> 0;
                if (isFinite(length)) {
                    length = length >>> 0;
                    if (encoding === void 0) encoding = "utf8";
                } else {
                    encoding = length;
                    length = void 0;
                }
            } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
            var remaining = this.length - offset;
            if (length === void 0 || length > remaining) length = remaining;
            if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
            if (!encoding) encoding = "utf8";
            var loweredCase = false;
            for(;;)switch(encoding){
                case "hex":
                    return hexWrite(this, string, offset, length);
                case "utf8":
                case "utf-8":
                    return utf8Write(this, string, offset, length);
                case "ascii":
                case "latin1":
                case "binary":
                    return asciiWrite(this, string, offset, length);
                case "base64":
                    return base64Write(this, string, offset, length);
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                    return ucs2Write(this, string, offset, length);
                default:
                    if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
                    encoding = ("" + encoding).toLowerCase();
                    loweredCase = true;
            }
        };
        Buffer2.prototype.toJSON = function toJSON() {
            return {
                type: "Buffer",
                data: Array.prototype.slice.call(this._arr || this, 0)
            };
        };
        function base64Slice(buf, start, end) {
            if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
            else return base64.fromByteArray(buf.slice(start, end));
        }
        function utf8Slice(buf, start, end) {
            end = Math.min(buf.length, end);
            var res = [];
            var i = start;
            while(i < end){
                var firstByte = buf[i];
                var codePoint = null;
                var bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
                if (i + bytesPerSequence <= end) {
                    var secondByte, thirdByte, fourthByte, tempCodePoint;
                    switch(bytesPerSequence){
                        case 1:
                            if (firstByte < 128) codePoint = firstByte;
                            break;
                        case 2:
                            secondByte = buf[i + 1];
                            if ((secondByte & 192) === 128) {
                                tempCodePoint = (firstByte & 31) << 6 | secondByte & 63;
                                if (tempCodePoint > 127) codePoint = tempCodePoint;
                            }
                            break;
                        case 3:
                            secondByte = buf[i + 1];
                            thirdByte = buf[i + 2];
                            if ((secondByte & 192) === 128 && (thirdByte & 192) === 128) {
                                tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63;
                                if (tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343)) codePoint = tempCodePoint;
                            }
                            break;
                        case 4:
                            secondByte = buf[i + 1];
                            thirdByte = buf[i + 2];
                            fourthByte = buf[i + 3];
                            if ((secondByte & 192) === 128 && (thirdByte & 192) === 128 && (fourthByte & 192) === 128) {
                                tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63;
                                if (tempCodePoint > 65535 && tempCodePoint < 1114112) codePoint = tempCodePoint;
                            }
                    }
                }
                if (codePoint === null) {
                    codePoint = 65533;
                    bytesPerSequence = 1;
                } else if (codePoint > 65535) {
                    codePoint -= 65536;
                    res.push(codePoint >>> 10 & 1023 | 55296);
                    codePoint = 56320 | codePoint & 1023;
                }
                res.push(codePoint);
                i += bytesPerSequence;
            }
            return decodeCodePointsArray(res);
        }
        var MAX_ARGUMENTS_LENGTH = 4096;
        function decodeCodePointsArray(codePoints) {
            var len = codePoints.length;
            if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints);
            var res = "";
            var i = 0;
            while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
            return res;
        }
        function asciiSlice(buf, start, end) {
            var ret = "";
            end = Math.min(buf.length, end);
            for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 127);
            return ret;
        }
        function latin1Slice(buf, start, end) {
            var ret = "";
            end = Math.min(buf.length, end);
            for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
            return ret;
        }
        function hexSlice(buf, start, end) {
            var len = buf.length;
            if (!start || start < 0) start = 0;
            if (!end || end < 0 || end > len) end = len;
            var out = "";
            for(var i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
            return out;
        }
        function utf16leSlice(buf, start, end) {
            var bytes = buf.slice(start, end);
            var res = "";
            for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
            return res;
        }
        Buffer2.prototype.slice = function slice(start, end) {
            var len = this.length;
            start = ~~start;
            end = end === void 0 ? len : ~~end;
            if (start < 0) {
                start += len;
                if (start < 0) start = 0;
            } else if (start > len) start = len;
            if (end < 0) {
                end += len;
                if (end < 0) end = 0;
            } else if (end > len) end = len;
            if (end < start) end = start;
            var newBuf = this.subarray(start, end);
            Object.setPrototypeOf(newBuf, Buffer2.prototype);
            return newBuf;
        };
        function checkOffset(offset, ext, length) {
            if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
            if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
        }
        Buffer2.prototype.readUintLE = Buffer2.prototype.readUIntLE = function readUIntLE(offset, byteLength2, noAssert) {
            offset = offset >>> 0;
            byteLength2 = byteLength2 >>> 0;
            if (!noAssert) checkOffset(offset, byteLength2, this.length);
            var val = this[offset];
            var mul = 1;
            var i = 0;
            while(++i < byteLength2 && (mul *= 256))val += this[offset + i] * mul;
            return val;
        };
        Buffer2.prototype.readUintBE = Buffer2.prototype.readUIntBE = function readUIntBE(offset, byteLength2, noAssert) {
            offset = offset >>> 0;
            byteLength2 = byteLength2 >>> 0;
            if (!noAssert) checkOffset(offset, byteLength2, this.length);
            var val = this[offset + --byteLength2];
            var mul = 1;
            while(byteLength2 > 0 && (mul *= 256))val += this[offset + --byteLength2] * mul;
            return val;
        };
        Buffer2.prototype.readUint8 = Buffer2.prototype.readUInt8 = function readUInt8(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 1, this.length);
            return this[offset];
        };
        Buffer2.prototype.readUint16LE = Buffer2.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 2, this.length);
            return this[offset] | this[offset + 1] << 8;
        };
        Buffer2.prototype.readUint16BE = Buffer2.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 2, this.length);
            return this[offset] << 8 | this[offset + 1];
        };
        Buffer2.prototype.readUint32LE = Buffer2.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 4, this.length);
            return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 16777216;
        };
        Buffer2.prototype.readUint32BE = Buffer2.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 4, this.length);
            return this[offset] * 16777216 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
        };
        Buffer2.prototype.readIntLE = function readIntLE(offset, byteLength2, noAssert) {
            offset = offset >>> 0;
            byteLength2 = byteLength2 >>> 0;
            if (!noAssert) checkOffset(offset, byteLength2, this.length);
            var val = this[offset];
            var mul = 1;
            var i = 0;
            while(++i < byteLength2 && (mul *= 256))val += this[offset + i] * mul;
            mul *= 128;
            if (val >= mul) val -= Math.pow(2, 8 * byteLength2);
            return val;
        };
        Buffer2.prototype.readIntBE = function readIntBE(offset, byteLength2, noAssert) {
            offset = offset >>> 0;
            byteLength2 = byteLength2 >>> 0;
            if (!noAssert) checkOffset(offset, byteLength2, this.length);
            var i = byteLength2;
            var mul = 1;
            var val = this[offset + --i];
            while(i > 0 && (mul *= 256))val += this[offset + --i] * mul;
            mul *= 128;
            if (val >= mul) val -= Math.pow(2, 8 * byteLength2);
            return val;
        };
        Buffer2.prototype.readInt8 = function readInt8(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 1, this.length);
            if (!(this[offset] & 128)) return this[offset];
            return (255 - this[offset] + 1) * -1;
        };
        Buffer2.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 2, this.length);
            var val = this[offset] | this[offset + 1] << 8;
            return val & 32768 ? val | 4294901760 : val;
        };
        Buffer2.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 2, this.length);
            var val = this[offset + 1] | this[offset] << 8;
            return val & 32768 ? val | 4294901760 : val;
        };
        Buffer2.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 4, this.length);
            return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
        };
        Buffer2.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 4, this.length);
            return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
        };
        Buffer2.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 4, this.length);
            return ieee7542.read(this, offset, true, 23, 4);
        };
        Buffer2.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 4, this.length);
            return ieee7542.read(this, offset, false, 23, 4);
        };
        Buffer2.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 8, this.length);
            return ieee7542.read(this, offset, true, 52, 8);
        };
        Buffer2.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 8, this.length);
            return ieee7542.read(this, offset, false, 52, 8);
        };
        function checkInt(buf, value, offset, ext, max, min) {
            if (!Buffer2.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
            if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
            if (offset + ext > buf.length) throw new RangeError("Index out of range");
        }
        Buffer2.prototype.writeUintLE = Buffer2.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength2, noAssert) {
            value = +value;
            offset = offset >>> 0;
            byteLength2 = byteLength2 >>> 0;
            if (!noAssert) {
                var maxBytes = Math.pow(2, 8 * byteLength2) - 1;
                checkInt(this, value, offset, byteLength2, maxBytes, 0);
            }
            var mul = 1;
            var i = 0;
            this[offset] = value & 255;
            while(++i < byteLength2 && (mul *= 256))this[offset + i] = value / mul & 255;
            return offset + byteLength2;
        };
        Buffer2.prototype.writeUintBE = Buffer2.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength2, noAssert) {
            value = +value;
            offset = offset >>> 0;
            byteLength2 = byteLength2 >>> 0;
            if (!noAssert) {
                var maxBytes = Math.pow(2, 8 * byteLength2) - 1;
                checkInt(this, value, offset, byteLength2, maxBytes, 0);
            }
            var i = byteLength2 - 1;
            var mul = 1;
            this[offset + i] = value & 255;
            while(--i >= 0 && (mul *= 256))this[offset + i] = value / mul & 255;
            return offset + byteLength2;
        };
        Buffer2.prototype.writeUint8 = Buffer2.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 1, 255, 0);
            this[offset] = value & 255;
            return offset + 1;
        };
        Buffer2.prototype.writeUint16LE = Buffer2.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 2, 65535, 0);
            this[offset] = value & 255;
            this[offset + 1] = value >>> 8;
            return offset + 2;
        };
        Buffer2.prototype.writeUint16BE = Buffer2.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 2, 65535, 0);
            this[offset] = value >>> 8;
            this[offset + 1] = value & 255;
            return offset + 2;
        };
        Buffer2.prototype.writeUint32LE = Buffer2.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 4, 4294967295, 0);
            this[offset + 3] = value >>> 24;
            this[offset + 2] = value >>> 16;
            this[offset + 1] = value >>> 8;
            this[offset] = value & 255;
            return offset + 4;
        };
        Buffer2.prototype.writeUint32BE = Buffer2.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 4, 4294967295, 0);
            this[offset] = value >>> 24;
            this[offset + 1] = value >>> 16;
            this[offset + 2] = value >>> 8;
            this[offset + 3] = value & 255;
            return offset + 4;
        };
        Buffer2.prototype.writeIntLE = function writeIntLE(value, offset, byteLength2, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) {
                var limit = Math.pow(2, 8 * byteLength2 - 1);
                checkInt(this, value, offset, byteLength2, limit - 1, -limit);
            }
            var i = 0;
            var mul = 1;
            var sub = 0;
            this[offset] = value & 255;
            while(++i < byteLength2 && (mul *= 256)){
                if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
                this[offset + i] = (value / mul >> 0) - sub & 255;
            }
            return offset + byteLength2;
        };
        Buffer2.prototype.writeIntBE = function writeIntBE(value, offset, byteLength2, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) {
                var limit = Math.pow(2, 8 * byteLength2 - 1);
                checkInt(this, value, offset, byteLength2, limit - 1, -limit);
            }
            var i = byteLength2 - 1;
            var mul = 1;
            var sub = 0;
            this[offset + i] = value & 255;
            while(--i >= 0 && (mul *= 256)){
                if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
                this[offset + i] = (value / mul >> 0) - sub & 255;
            }
            return offset + byteLength2;
        };
        Buffer2.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 1, 127, -128);
            if (value < 0) value = 255 + value + 1;
            this[offset] = value & 255;
            return offset + 1;
        };
        Buffer2.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 2, 32767, -32768);
            this[offset] = value & 255;
            this[offset + 1] = value >>> 8;
            return offset + 2;
        };
        Buffer2.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 2, 32767, -32768);
            this[offset] = value >>> 8;
            this[offset + 1] = value & 255;
            return offset + 2;
        };
        Buffer2.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 4, 2147483647, -2147483648);
            this[offset] = value & 255;
            this[offset + 1] = value >>> 8;
            this[offset + 2] = value >>> 16;
            this[offset + 3] = value >>> 24;
            return offset + 4;
        };
        Buffer2.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 4, 2147483647, -2147483648);
            if (value < 0) value = 4294967295 + value + 1;
            this[offset] = value >>> 24;
            this[offset + 1] = value >>> 16;
            this[offset + 2] = value >>> 8;
            this[offset + 3] = value & 255;
            return offset + 4;
        };
        function checkIEEE754(buf, value, offset, ext, max, min) {
            if (offset + ext > buf.length) throw new RangeError("Index out of range");
            if (offset < 0) throw new RangeError("Index out of range");
        }
        function writeFloat(buf, value, offset, littleEndian, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkIEEE754(buf, value, offset, 4);
            ieee7542.write(buf, value, offset, littleEndian, 23, 4);
            return offset + 4;
        }
        Buffer2.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
            return writeFloat(this, value, offset, true, noAssert);
        };
        Buffer2.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
            return writeFloat(this, value, offset, false, noAssert);
        };
        function writeDouble(buf, value, offset, littleEndian, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkIEEE754(buf, value, offset, 8);
            ieee7542.write(buf, value, offset, littleEndian, 52, 8);
            return offset + 8;
        }
        Buffer2.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
            return writeDouble(this, value, offset, true, noAssert);
        };
        Buffer2.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
            return writeDouble(this, value, offset, false, noAssert);
        };
        Buffer2.prototype.copy = function copy(target, targetStart, start, end) {
            if (!Buffer2.isBuffer(target)) throw new TypeError("argument should be a Buffer");
            if (!start) start = 0;
            if (!end && end !== 0) end = this.length;
            if (targetStart >= target.length) targetStart = target.length;
            if (!targetStart) targetStart = 0;
            if (end > 0 && end < start) end = start;
            if (end === start) return 0;
            if (target.length === 0 || this.length === 0) return 0;
            if (targetStart < 0) throw new RangeError("targetStart out of bounds");
            if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
            if (end < 0) throw new RangeError("sourceEnd out of bounds");
            if (end > this.length) end = this.length;
            if (target.length - targetStart < end - start) end = target.length - targetStart + start;
            var len = end - start;
            if (this === target && typeof Uint8Array.prototype.copyWithin === "function") this.copyWithin(targetStart, start, end);
            else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
            return len;
        };
        Buffer2.prototype.fill = function fill(val, start, end, encoding) {
            if (typeof val === "string") {
                if (typeof start === "string") {
                    encoding = start;
                    start = 0;
                    end = this.length;
                } else if (typeof end === "string") {
                    encoding = end;
                    end = this.length;
                }
                if (encoding !== void 0 && typeof encoding !== "string") throw new TypeError("encoding must be a string");
                if (typeof encoding === "string" && !Buffer2.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
                if (val.length === 1) {
                    var code = val.charCodeAt(0);
                    if (encoding === "utf8" && code < 128 || encoding === "latin1") val = code;
                }
            } else if (typeof val === "number") val = val & 255;
            else if (typeof val === "boolean") val = Number(val);
            if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
            if (end <= start) return this;
            start = start >>> 0;
            end = end === void 0 ? this.length : end >>> 0;
            if (!val) val = 0;
            var i;
            if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
            else {
                var bytes = Buffer2.isBuffer(val) ? val : Buffer2.from(val, encoding);
                var len = bytes.length;
                if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
                for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
            }
            return this;
        };
        var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
        function base64clean(str) {
            str = str.split("=")[0];
            str = str.trim().replace(INVALID_BASE64_RE, "");
            if (str.length < 2) return "";
            while(str.length % 4 !== 0)str = str + "=";
            return str;
        }
        function utf8ToBytes(string, units) {
            units = units || Infinity;
            var codePoint;
            var length = string.length;
            var leadSurrogate = null;
            var bytes = [];
            for(var i = 0; i < length; ++i){
                codePoint = string.charCodeAt(i);
                if (codePoint > 55295 && codePoint < 57344) {
                    if (!leadSurrogate) {
                        if (codePoint > 56319) {
                            if ((units -= 3) > -1) bytes.push(239, 191, 189);
                            continue;
                        } else if (i + 1 === length) {
                            if ((units -= 3) > -1) bytes.push(239, 191, 189);
                            continue;
                        }
                        leadSurrogate = codePoint;
                        continue;
                    }
                    if (codePoint < 56320) {
                        if ((units -= 3) > -1) bytes.push(239, 191, 189);
                        leadSurrogate = codePoint;
                        continue;
                    }
                    codePoint = (leadSurrogate - 55296 << 10 | codePoint - 56320) + 65536;
                } else if (leadSurrogate) {
                    if ((units -= 3) > -1) bytes.push(239, 191, 189);
                }
                leadSurrogate = null;
                if (codePoint < 128) {
                    if ((units -= 1) < 0) break;
                    bytes.push(codePoint);
                } else if (codePoint < 2048) {
                    if ((units -= 2) < 0) break;
                    bytes.push(codePoint >> 6 | 192, codePoint & 63 | 128);
                } else if (codePoint < 65536) {
                    if ((units -= 3) < 0) break;
                    bytes.push(codePoint >> 12 | 224, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
                } else if (codePoint < 1114112) {
                    if ((units -= 4) < 0) break;
                    bytes.push(codePoint >> 18 | 240, codePoint >> 12 & 63 | 128, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
                } else throw new Error("Invalid code point");
            }
            return bytes;
        }
        function asciiToBytes(str) {
            var byteArray = [];
            for(var i = 0; i < str.length; ++i)byteArray.push(str.charCodeAt(i) & 255);
            return byteArray;
        }
        function utf16leToBytes(str, units) {
            var c, hi, lo;
            var byteArray = [];
            for(var i = 0; i < str.length; ++i){
                if ((units -= 2) < 0) break;
                c = str.charCodeAt(i);
                hi = c >> 8;
                lo = c % 256;
                byteArray.push(lo);
                byteArray.push(hi);
            }
            return byteArray;
        }
        function base64ToBytes(str) {
            return base64.toByteArray(base64clean(str));
        }
        function blitBuffer(src, dst, offset, length) {
            for(var i = 0; i < length; ++i){
                if (i + offset >= dst.length || i >= src.length) break;
                dst[i + offset] = src[i];
            }
            return i;
        }
        function isInstance(obj, type) {
            return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
        }
        function numberIsNaN(obj) {
            return obj !== obj;
        }
        var hexSliceLookupTable = function() {
            var alphabet = "0123456789abcdef";
            var table = new Array(256);
            for(var i = 0; i < 16; ++i){
                var i16 = i * 16;
                for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
            }
            return table;
        }();
    })($94db4f2abf87558b$var$buffer);
    return $94db4f2abf87558b$var$buffer;
}
var $94db4f2abf87558b$var$util = {};
var $94db4f2abf87558b$var$types = {};
var $94db4f2abf87558b$var$shams$1;
var $94db4f2abf87558b$var$hasRequiredShams$1;
function $94db4f2abf87558b$var$requireShams$1() {
    if ($94db4f2abf87558b$var$hasRequiredShams$1) return $94db4f2abf87558b$var$shams$1;
    $94db4f2abf87558b$var$hasRequiredShams$1 = 1;
    $94db4f2abf87558b$var$shams$1 = function hasSymbols2() {
        if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
        if ((0, $2bfPH._)(Symbol.iterator) === "symbol") return true;
        var obj = {};
        var sym = Symbol("test");
        var symObj = Object(sym);
        if (typeof sym === "string") return false;
        if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
        if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
        var symVal = 42;
        obj[sym] = symVal;
        for(sym in obj)return false;
        if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
        if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
        var syms = Object.getOwnPropertySymbols(obj);
        if (syms.length !== 1 || syms[0] !== sym) return false;
        if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
        if (typeof Object.getOwnPropertyDescriptor === "function") {
            var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
            if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
        }
        return true;
    };
    return $94db4f2abf87558b$var$shams$1;
}
var $94db4f2abf87558b$var$shams;
var $94db4f2abf87558b$var$hasRequiredShams;
function $94db4f2abf87558b$var$requireShams() {
    if ($94db4f2abf87558b$var$hasRequiredShams) return $94db4f2abf87558b$var$shams;
    $94db4f2abf87558b$var$hasRequiredShams = 1;
    var hasSymbols2 = $94db4f2abf87558b$var$requireShams$1();
    $94db4f2abf87558b$var$shams = function hasToStringTagShams() {
        return hasSymbols2() && !!Symbol.toStringTag;
    };
    return $94db4f2abf87558b$var$shams;
}
var $94db4f2abf87558b$var$hasSymbols;
var $94db4f2abf87558b$var$hasRequiredHasSymbols;
function $94db4f2abf87558b$var$requireHasSymbols() {
    if ($94db4f2abf87558b$var$hasRequiredHasSymbols) return $94db4f2abf87558b$var$hasSymbols;
    $94db4f2abf87558b$var$hasRequiredHasSymbols = 1;
    var origSymbol = typeof Symbol !== "undefined" && Symbol;
    var hasSymbolSham = $94db4f2abf87558b$var$requireShams$1();
    $94db4f2abf87558b$var$hasSymbols = function hasNativeSymbols() {
        if (typeof origSymbol !== "function") return false;
        if (typeof Symbol !== "function") return false;
        if ((0, $2bfPH._)(origSymbol("foo")) !== "symbol") return false;
        if ((0, $2bfPH._)(Symbol("bar")) !== "symbol") return false;
        return hasSymbolSham();
    };
    return $94db4f2abf87558b$var$hasSymbols;
}
var $94db4f2abf87558b$var$hasProto;
var $94db4f2abf87558b$var$hasRequiredHasProto;
function $94db4f2abf87558b$var$requireHasProto() {
    if ($94db4f2abf87558b$var$hasRequiredHasProto) return $94db4f2abf87558b$var$hasProto;
    $94db4f2abf87558b$var$hasRequiredHasProto = 1;
    var test = {
        foo: {}
    };
    var $Object = Object;
    $94db4f2abf87558b$var$hasProto = function hasProto2() {
        return ({
            __proto__: test
        }).foo === test.foo && !(({
            __proto__: null
        }) instanceof $Object);
    };
    return $94db4f2abf87558b$var$hasProto;
}
var $94db4f2abf87558b$var$implementation;
var $94db4f2abf87558b$var$hasRequiredImplementation;
function $94db4f2abf87558b$var$requireImplementation() {
    if ($94db4f2abf87558b$var$hasRequiredImplementation) return $94db4f2abf87558b$var$implementation;
    $94db4f2abf87558b$var$hasRequiredImplementation = 1;
    var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
    var toStr = Object.prototype.toString;
    var max = Math.max;
    var funcType = "[object Function]";
    var concatty = function concatty2(a, b) {
        var arr = [];
        for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
        for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
        return arr;
    };
    var slicy = function slicy2(arrLike, offset) {
        var arr = [];
        for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
        return arr;
    };
    var joiny = function joiny(arr, joiner) {
        var str = "";
        for(var i = 0; i < arr.length; i += 1){
            str += arr[i];
            if (i + 1 < arr.length) str += joiner;
        }
        return str;
    };
    $94db4f2abf87558b$var$implementation = function bind(that) {
        var target = this;
        if (typeof target !== "function" || toStr.apply(target) !== funcType) throw new TypeError(ERROR_MESSAGE + target);
        var args = slicy(arguments, 1);
        var bound;
        var binder = function binder() {
            if (this instanceof bound) {
                var result = target.apply(this, concatty(args, arguments));
                if (Object(result) === result) return result;
                return this;
            }
            return target.apply(that, concatty(args, arguments));
        };
        var boundLength = max(0, target.length - args.length);
        var boundArgs = [];
        for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
        bound = Function("binder", "return function (" + joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
        if (target.prototype) {
            var Empty = function Empty2() {};
            Empty.prototype = target.prototype;
            bound.prototype = new Empty();
            Empty.prototype = null;
        }
        return bound;
    };
    return $94db4f2abf87558b$var$implementation;
}
var $94db4f2abf87558b$var$functionBind;
var $94db4f2abf87558b$var$hasRequiredFunctionBind;
function $94db4f2abf87558b$var$requireFunctionBind() {
    if ($94db4f2abf87558b$var$hasRequiredFunctionBind) return $94db4f2abf87558b$var$functionBind;
    $94db4f2abf87558b$var$hasRequiredFunctionBind = 1;
    var implementation2 = $94db4f2abf87558b$var$requireImplementation();
    $94db4f2abf87558b$var$functionBind = Function.prototype.bind || implementation2;
    return $94db4f2abf87558b$var$functionBind;
}
var $94db4f2abf87558b$var$hasown;
var $94db4f2abf87558b$var$hasRequiredHasown;
function $94db4f2abf87558b$var$requireHasown() {
    if ($94db4f2abf87558b$var$hasRequiredHasown) return $94db4f2abf87558b$var$hasown;
    $94db4f2abf87558b$var$hasRequiredHasown = 1;
    var call = Function.prototype.call;
    var $hasOwn = Object.prototype.hasOwnProperty;
    var bind = $94db4f2abf87558b$var$requireFunctionBind();
    $94db4f2abf87558b$var$hasown = bind.call(call, $hasOwn);
    return $94db4f2abf87558b$var$hasown;
}
var $94db4f2abf87558b$var$getIntrinsic;
var $94db4f2abf87558b$var$hasRequiredGetIntrinsic;
function $94db4f2abf87558b$var$requireGetIntrinsic() {
    if ($94db4f2abf87558b$var$hasRequiredGetIntrinsic) return $94db4f2abf87558b$var$getIntrinsic;
    $94db4f2abf87558b$var$hasRequiredGetIntrinsic = 1;
    var undefined$1;
    var $SyntaxError = SyntaxError;
    var $Function = Function;
    var $TypeError = TypeError;
    var getEvalledConstructor = function getEvalledConstructor(expressionSyntax) {
        try {
            return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
        } catch (e) {}
    };
    var $gOPD = Object.getOwnPropertyDescriptor;
    if ($gOPD) try {
        $gOPD({}, "");
    } catch (e) {
        $gOPD = null;
    }
    var throwTypeError = function throwTypeError() {
        throw new $TypeError();
    };
    var ThrowTypeError = $gOPD ? function() {
        try {
            arguments.callee;
            return throwTypeError;
        } catch (calleeThrows) {
            try {
                return $gOPD(arguments, "callee").get;
            } catch (gOPDthrows) {
                return throwTypeError;
            }
        }
    }() : throwTypeError;
    var hasSymbols2 = $94db4f2abf87558b$var$requireHasSymbols()();
    var hasProto2 = $94db4f2abf87558b$var$requireHasProto()();
    var getProto = Object.getPrototypeOf || (hasProto2 ? function(x) {
        return x.__proto__;
    } : null);
    var needsEval = {};
    var TypedArray = typeof Uint8Array === "undefined" || !getProto ? undefined$1 : getProto(Uint8Array);
    var INTRINSICS = {
        "%AggregateError%": typeof AggregateError === "undefined" ? undefined$1 : AggregateError,
        "%Array%": Array,
        "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined$1 : ArrayBuffer,
        "%ArrayIteratorPrototype%": hasSymbols2 && getProto ? getProto([][Symbol.iterator]()) : undefined$1,
        "%AsyncFromSyncIteratorPrototype%": undefined$1,
        "%AsyncFunction%": needsEval,
        "%AsyncGenerator%": needsEval,
        "%AsyncGeneratorFunction%": needsEval,
        "%AsyncIteratorPrototype%": needsEval,
        "%Atomics%": typeof Atomics === "undefined" ? undefined$1 : Atomics,
        "%BigInt%": typeof BigInt === "undefined" ? undefined$1 : BigInt,
        "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined$1 : BigInt64Array,
        "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined$1 : BigUint64Array,
        "%Boolean%": Boolean,
        "%DataView%": typeof DataView === "undefined" ? undefined$1 : DataView,
        "%Date%": Date,
        "%decodeURI%": decodeURI,
        "%decodeURIComponent%": decodeURIComponent,
        "%encodeURI%": encodeURI,
        "%encodeURIComponent%": encodeURIComponent,
        "%Error%": Error,
        "%eval%": eval,
        // eslint-disable-line no-eval
        "%EvalError%": EvalError,
        "%Float32Array%": typeof Float32Array === "undefined" ? undefined$1 : Float32Array,
        "%Float64Array%": typeof Float64Array === "undefined" ? undefined$1 : Float64Array,
        "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined$1 : FinalizationRegistry,
        "%Function%": $Function,
        "%GeneratorFunction%": needsEval,
        "%Int8Array%": typeof Int8Array === "undefined" ? undefined$1 : Int8Array,
        "%Int16Array%": typeof Int16Array === "undefined" ? undefined$1 : Int16Array,
        "%Int32Array%": typeof Int32Array === "undefined" ? undefined$1 : Int32Array,
        "%isFinite%": isFinite,
        "%isNaN%": isNaN,
        "%IteratorPrototype%": hasSymbols2 && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
        "%JSON%": (typeof JSON === "undefined" ? "undefined" : (0, $2bfPH._)(JSON)) === "object" ? JSON : undefined$1,
        "%Map%": typeof Map === "undefined" ? undefined$1 : Map,
        "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols2 || !getProto ? undefined$1 : getProto(/* @__PURE__ */ new Map()[Symbol.iterator]()),
        "%Math%": Math,
        "%Number%": Number,
        "%Object%": Object,
        "%parseFloat%": parseFloat,
        "%parseInt%": parseInt,
        "%Promise%": typeof Promise === "undefined" ? undefined$1 : Promise,
        "%Proxy%": typeof Proxy === "undefined" ? undefined$1 : Proxy,
        "%RangeError%": RangeError,
        "%ReferenceError%": ReferenceError,
        "%Reflect%": typeof Reflect === "undefined" ? undefined$1 : Reflect,
        "%RegExp%": RegExp,
        "%Set%": typeof Set === "undefined" ? undefined$1 : Set,
        "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols2 || !getProto ? undefined$1 : getProto(/* @__PURE__ */ new Set()[Symbol.iterator]()),
        "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined$1 : SharedArrayBuffer,
        "%String%": String,
        "%StringIteratorPrototype%": hasSymbols2 && getProto ? getProto(""[Symbol.iterator]()) : undefined$1,
        "%Symbol%": hasSymbols2 ? Symbol : undefined$1,
        "%SyntaxError%": $SyntaxError,
        "%ThrowTypeError%": ThrowTypeError,
        "%TypedArray%": TypedArray,
        "%TypeError%": $TypeError,
        "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined$1 : Uint8Array,
        "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined$1 : Uint8ClampedArray,
        "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined$1 : Uint16Array,
        "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined$1 : Uint32Array,
        "%URIError%": URIError,
        "%WeakMap%": typeof WeakMap === "undefined" ? undefined$1 : WeakMap,
        "%WeakRef%": typeof WeakRef === "undefined" ? undefined$1 : WeakRef,
        "%WeakSet%": typeof WeakSet === "undefined" ? undefined$1 : WeakSet
    };
    if (getProto) try {
        null.error;
    } catch (e) {
        var errorProto = getProto(getProto(e));
        INTRINSICS["%Error.prototype%"] = errorProto;
    }
    var doEval = function doEval2(name) {
        var value;
        if (name === "%AsyncFunction%") value = getEvalledConstructor("async function () {}");
        else if (name === "%GeneratorFunction%") value = getEvalledConstructor("function* () {}");
        else if (name === "%AsyncGeneratorFunction%") value = getEvalledConstructor("async function* () {}");
        else if (name === "%AsyncGenerator%") {
            var fn = doEval2("%AsyncGeneratorFunction%");
            if (fn) value = fn.prototype;
        } else if (name === "%AsyncIteratorPrototype%") {
            var gen = doEval2("%AsyncGenerator%");
            if (gen && getProto) value = getProto(gen.prototype);
        }
        INTRINSICS[name] = value;
        return value;
    };
    var LEGACY_ALIASES = {
        "%ArrayBufferPrototype%": [
            "ArrayBuffer",
            "prototype"
        ],
        "%ArrayPrototype%": [
            "Array",
            "prototype"
        ],
        "%ArrayProto_entries%": [
            "Array",
            "prototype",
            "entries"
        ],
        "%ArrayProto_forEach%": [
            "Array",
            "prototype",
            "forEach"
        ],
        "%ArrayProto_keys%": [
            "Array",
            "prototype",
            "keys"
        ],
        "%ArrayProto_values%": [
            "Array",
            "prototype",
            "values"
        ],
        "%AsyncFunctionPrototype%": [
            "AsyncFunction",
            "prototype"
        ],
        "%AsyncGenerator%": [
            "AsyncGeneratorFunction",
            "prototype"
        ],
        "%AsyncGeneratorPrototype%": [
            "AsyncGeneratorFunction",
            "prototype",
            "prototype"
        ],
        "%BooleanPrototype%": [
            "Boolean",
            "prototype"
        ],
        "%DataViewPrototype%": [
            "DataView",
            "prototype"
        ],
        "%DatePrototype%": [
            "Date",
            "prototype"
        ],
        "%ErrorPrototype%": [
            "Error",
            "prototype"
        ],
        "%EvalErrorPrototype%": [
            "EvalError",
            "prototype"
        ],
        "%Float32ArrayPrototype%": [
            "Float32Array",
            "prototype"
        ],
        "%Float64ArrayPrototype%": [
            "Float64Array",
            "prototype"
        ],
        "%FunctionPrototype%": [
            "Function",
            "prototype"
        ],
        "%Generator%": [
            "GeneratorFunction",
            "prototype"
        ],
        "%GeneratorPrototype%": [
            "GeneratorFunction",
            "prototype",
            "prototype"
        ],
        "%Int8ArrayPrototype%": [
            "Int8Array",
            "prototype"
        ],
        "%Int16ArrayPrototype%": [
            "Int16Array",
            "prototype"
        ],
        "%Int32ArrayPrototype%": [
            "Int32Array",
            "prototype"
        ],
        "%JSONParse%": [
            "JSON",
            "parse"
        ],
        "%JSONStringify%": [
            "JSON",
            "stringify"
        ],
        "%MapPrototype%": [
            "Map",
            "prototype"
        ],
        "%NumberPrototype%": [
            "Number",
            "prototype"
        ],
        "%ObjectPrototype%": [
            "Object",
            "prototype"
        ],
        "%ObjProto_toString%": [
            "Object",
            "prototype",
            "toString"
        ],
        "%ObjProto_valueOf%": [
            "Object",
            "prototype",
            "valueOf"
        ],
        "%PromisePrototype%": [
            "Promise",
            "prototype"
        ],
        "%PromiseProto_then%": [
            "Promise",
            "prototype",
            "then"
        ],
        "%Promise_all%": [
            "Promise",
            "all"
        ],
        "%Promise_reject%": [
            "Promise",
            "reject"
        ],
        "%Promise_resolve%": [
            "Promise",
            "resolve"
        ],
        "%RangeErrorPrototype%": [
            "RangeError",
            "prototype"
        ],
        "%ReferenceErrorPrototype%": [
            "ReferenceError",
            "prototype"
        ],
        "%RegExpPrototype%": [
            "RegExp",
            "prototype"
        ],
        "%SetPrototype%": [
            "Set",
            "prototype"
        ],
        "%SharedArrayBufferPrototype%": [
            "SharedArrayBuffer",
            "prototype"
        ],
        "%StringPrototype%": [
            "String",
            "prototype"
        ],
        "%SymbolPrototype%": [
            "Symbol",
            "prototype"
        ],
        "%SyntaxErrorPrototype%": [
            "SyntaxError",
            "prototype"
        ],
        "%TypedArrayPrototype%": [
            "TypedArray",
            "prototype"
        ],
        "%TypeErrorPrototype%": [
            "TypeError",
            "prototype"
        ],
        "%Uint8ArrayPrototype%": [
            "Uint8Array",
            "prototype"
        ],
        "%Uint8ClampedArrayPrototype%": [
            "Uint8ClampedArray",
            "prototype"
        ],
        "%Uint16ArrayPrototype%": [
            "Uint16Array",
            "prototype"
        ],
        "%Uint32ArrayPrototype%": [
            "Uint32Array",
            "prototype"
        ],
        "%URIErrorPrototype%": [
            "URIError",
            "prototype"
        ],
        "%WeakMapPrototype%": [
            "WeakMap",
            "prototype"
        ],
        "%WeakSetPrototype%": [
            "WeakSet",
            "prototype"
        ]
    };
    var bind = $94db4f2abf87558b$var$requireFunctionBind();
    var hasOwn = $94db4f2abf87558b$var$requireHasown();
    var $concat = bind.call(Function.call, Array.prototype.concat);
    var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
    var $replace = bind.call(Function.call, String.prototype.replace);
    var $strSlice = bind.call(Function.call, String.prototype.slice);
    var $exec = bind.call(Function.call, RegExp.prototype.exec);
    var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
    var reEscapeChar = /\\(\\)?/g;
    var stringToPath = function stringToPath2(string) {
        var first = $strSlice(string, 0, 1);
        var last = $strSlice(string, -1);
        if (first === "%" && last !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
        else if (last === "%" && first !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
        var result = [];
        $replace(string, rePropName, function(match, number, quote, subString) {
            result[result.length] = quote ? $replace(subString, reEscapeChar, "$1") : number || match;
        });
        return result;
    };
    var getBaseIntrinsic = function getBaseIntrinsic2(name, allowMissing) {
        var intrinsicName = name;
        var alias;
        if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
            alias = LEGACY_ALIASES[intrinsicName];
            intrinsicName = "%" + alias[0] + "%";
        }
        if (hasOwn(INTRINSICS, intrinsicName)) {
            var value = INTRINSICS[intrinsicName];
            if (value === needsEval) value = doEval(intrinsicName);
            if (typeof value === "undefined" && !allowMissing) throw new $TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
            return {
                alias: alias,
                name: intrinsicName,
                value: value
            };
        }
        throw new $SyntaxError("intrinsic " + name + " does not exist!");
    };
    $94db4f2abf87558b$var$getIntrinsic = function GetIntrinsic(name, allowMissing) {
        if (typeof name !== "string" || name.length === 0) throw new $TypeError("intrinsic name must be a non-empty string");
        if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $TypeError('"allowMissing" argument must be a boolean');
        if ($exec(/^%?[^%]*%?$/, name) === null) throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
        var parts = stringToPath(name);
        var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
        var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
        var intrinsicRealName = intrinsic.name;
        var value = intrinsic.value;
        var skipFurtherCaching = false;
        var alias = intrinsic.alias;
        if (alias) {
            intrinsicBaseName = alias[0];
            $spliceApply(parts, $concat([
                0,
                1
            ], alias));
        }
        for(var i = 1, isOwn = true; i < parts.length; i += 1){
            var part = parts[i];
            var first = $strSlice(part, 0, 1);
            var last = $strSlice(part, -1);
            if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $SyntaxError("property names with quotes must have matching quotes");
            if (part === "constructor" || !isOwn) skipFurtherCaching = true;
            intrinsicBaseName += "." + part;
            intrinsicRealName = "%" + intrinsicBaseName + "%";
            if (hasOwn(INTRINSICS, intrinsicRealName)) value = INTRINSICS[intrinsicRealName];
            else if (value != null) {
                if (!(part in value)) {
                    if (!allowMissing) throw new $TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                    return void 0;
                }
                if ($gOPD && i + 1 >= parts.length) {
                    var desc = $gOPD(value, part);
                    isOwn = !!desc;
                    if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                    else value = value[part];
                } else {
                    isOwn = hasOwn(value, part);
                    value = value[part];
                }
                if (isOwn && !skipFurtherCaching) INTRINSICS[intrinsicRealName] = value;
            }
        }
        return value;
    };
    return $94db4f2abf87558b$var$getIntrinsic;
}
var $94db4f2abf87558b$var$callBind = {
    exports: {}
};
var $94db4f2abf87558b$var$hasPropertyDescriptors_1;
var $94db4f2abf87558b$var$hasRequiredHasPropertyDescriptors;
function $94db4f2abf87558b$var$requireHasPropertyDescriptors() {
    if ($94db4f2abf87558b$var$hasRequiredHasPropertyDescriptors) return $94db4f2abf87558b$var$hasPropertyDescriptors_1;
    $94db4f2abf87558b$var$hasRequiredHasPropertyDescriptors = 1;
    var GetIntrinsic = $94db4f2abf87558b$var$requireGetIntrinsic();
    var $defineProperty = GetIntrinsic("%Object.defineProperty%", true);
    var hasPropertyDescriptors = function hasPropertyDescriptors2() {
        if ($defineProperty) try {
            $defineProperty({}, "a", {
                value: 1
            });
            return true;
        } catch (e) {
            return false;
        }
        return false;
    };
    hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
        if (!hasPropertyDescriptors()) return null;
        try {
            return $defineProperty([], "length", {
                value: 1
            }).length !== 1;
        } catch (e) {
            return true;
        }
    };
    $94db4f2abf87558b$var$hasPropertyDescriptors_1 = hasPropertyDescriptors;
    return $94db4f2abf87558b$var$hasPropertyDescriptors_1;
}
var $94db4f2abf87558b$var$gopd;
var $94db4f2abf87558b$var$hasRequiredGopd;
function $94db4f2abf87558b$var$requireGopd() {
    if ($94db4f2abf87558b$var$hasRequiredGopd) return $94db4f2abf87558b$var$gopd;
    $94db4f2abf87558b$var$hasRequiredGopd = 1;
    var GetIntrinsic = $94db4f2abf87558b$var$requireGetIntrinsic();
    var $gOPD = GetIntrinsic("%Object.getOwnPropertyDescriptor%", true);
    if ($gOPD) try {
        $gOPD([], "length");
    } catch (e) {
        $gOPD = null;
    }
    $94db4f2abf87558b$var$gopd = $gOPD;
    return $94db4f2abf87558b$var$gopd;
}
var $94db4f2abf87558b$var$defineDataProperty;
var $94db4f2abf87558b$var$hasRequiredDefineDataProperty;
function $94db4f2abf87558b$var$requireDefineDataProperty() {
    if ($94db4f2abf87558b$var$hasRequiredDefineDataProperty) return $94db4f2abf87558b$var$defineDataProperty;
    $94db4f2abf87558b$var$hasRequiredDefineDataProperty = 1;
    var hasPropertyDescriptors = $94db4f2abf87558b$var$requireHasPropertyDescriptors()();
    var GetIntrinsic = $94db4f2abf87558b$var$requireGetIntrinsic();
    var $defineProperty = hasPropertyDescriptors && GetIntrinsic("%Object.defineProperty%", true);
    if ($defineProperty) try {
        $defineProperty({}, "a", {
            value: 1
        });
    } catch (e) {
        $defineProperty = false;
    }
    var $SyntaxError = GetIntrinsic("%SyntaxError%");
    var $TypeError = GetIntrinsic("%TypeError%");
    var gopd2 = $94db4f2abf87558b$var$requireGopd();
    $94db4f2abf87558b$var$defineDataProperty = function defineDataProperty2(obj, property, value) {
        if (!obj || (typeof obj === "undefined" ? "undefined" : (0, $2bfPH._)(obj)) !== "object" && typeof obj !== "function") throw new $TypeError("`obj` must be an object or a function`");
        if (typeof property !== "string" && (typeof property === "undefined" ? "undefined" : (0, $2bfPH._)(property)) !== "symbol") throw new $TypeError("`property` must be a string or a symbol`");
        if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $TypeError("`nonEnumerable`, if provided, must be a boolean or null");
        if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $TypeError("`nonWritable`, if provided, must be a boolean or null");
        if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $TypeError("`nonConfigurable`, if provided, must be a boolean or null");
        if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $TypeError("`loose`, if provided, must be a boolean");
        var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
        var nonWritable = arguments.length > 4 ? arguments[4] : null;
        var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
        var loose = arguments.length > 6 ? arguments[6] : false;
        var desc = !!gopd2 && gopd2(obj, property);
        if ($defineProperty) $defineProperty(obj, property, {
            configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
            enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
            value: value,
            writable: nonWritable === null && desc ? desc.writable : !nonWritable
        });
        else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) obj[property] = value;
        else throw new $SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
    };
    return $94db4f2abf87558b$var$defineDataProperty;
}
var $94db4f2abf87558b$var$setFunctionLength;
var $94db4f2abf87558b$var$hasRequiredSetFunctionLength;
function $94db4f2abf87558b$var$requireSetFunctionLength() {
    if ($94db4f2abf87558b$var$hasRequiredSetFunctionLength) return $94db4f2abf87558b$var$setFunctionLength;
    $94db4f2abf87558b$var$hasRequiredSetFunctionLength = 1;
    var GetIntrinsic = $94db4f2abf87558b$var$requireGetIntrinsic();
    var define = $94db4f2abf87558b$var$requireDefineDataProperty();
    var hasDescriptors = $94db4f2abf87558b$var$requireHasPropertyDescriptors()();
    var gOPD = $94db4f2abf87558b$var$requireGopd();
    var $TypeError = GetIntrinsic("%TypeError%");
    var $floor = GetIntrinsic("%Math.floor%");
    $94db4f2abf87558b$var$setFunctionLength = function setFunctionLength2(fn, length) {
        if (typeof fn !== "function") throw new $TypeError("`fn` is not a function");
        if (typeof length !== "number" || length < 0 || length > 4294967295 || $floor(length) !== length) throw new $TypeError("`length` must be a positive 32-bit integer");
        var loose = arguments.length > 2 && !!arguments[2];
        var functionLengthIsConfigurable = true;
        var functionLengthIsWritable = true;
        if ("length" in fn && gOPD) {
            var desc = gOPD(fn, "length");
            if (desc && !desc.configurable) functionLengthIsConfigurable = false;
            if (desc && !desc.writable) functionLengthIsWritable = false;
        }
        if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
            if (hasDescriptors) define(fn, "length", length, true, true);
            else define(fn, "length", length);
        }
        return fn;
    };
    return $94db4f2abf87558b$var$setFunctionLength;
}
var $94db4f2abf87558b$var$hasRequiredCallBind;
function $94db4f2abf87558b$var$requireCallBind() {
    if ($94db4f2abf87558b$var$hasRequiredCallBind) return $94db4f2abf87558b$var$callBind.exports;
    $94db4f2abf87558b$var$hasRequiredCallBind = 1;
    (function(module) {
        var bind = $94db4f2abf87558b$var$requireFunctionBind();
        var GetIntrinsic = $94db4f2abf87558b$var$requireGetIntrinsic();
        var setFunctionLength2 = $94db4f2abf87558b$var$requireSetFunctionLength();
        var $TypeError = GetIntrinsic("%TypeError%");
        var $apply = GetIntrinsic("%Function.prototype.apply%");
        var $call = GetIntrinsic("%Function.prototype.call%");
        var $reflectApply = GetIntrinsic("%Reflect.apply%", true) || bind.call($call, $apply);
        var $defineProperty = GetIntrinsic("%Object.defineProperty%", true);
        var $max = GetIntrinsic("%Math.max%");
        if ($defineProperty) try {
            $defineProperty({}, "a", {
                value: 1
            });
        } catch (e) {
            $defineProperty = null;
        }
        module.exports = function callBind2(originalFunction) {
            if (typeof originalFunction !== "function") throw new $TypeError("a function is required");
            var func = $reflectApply(bind, $call, arguments);
            return setFunctionLength2(func, 1 + $max(0, originalFunction.length - (arguments.length - 1)), true);
        };
        var applyBind = function applyBind2() {
            return $reflectApply(bind, $apply, arguments);
        };
        if ($defineProperty) $defineProperty(module.exports, "apply", {
            value: applyBind
        });
        else module.exports.apply = applyBind;
    })($94db4f2abf87558b$var$callBind);
    return $94db4f2abf87558b$var$callBind.exports;
}
var $94db4f2abf87558b$var$callBound;
var $94db4f2abf87558b$var$hasRequiredCallBound;
function $94db4f2abf87558b$var$requireCallBound() {
    if ($94db4f2abf87558b$var$hasRequiredCallBound) return $94db4f2abf87558b$var$callBound;
    $94db4f2abf87558b$var$hasRequiredCallBound = 1;
    var GetIntrinsic = $94db4f2abf87558b$var$requireGetIntrinsic();
    var callBind2 = $94db4f2abf87558b$var$requireCallBind();
    var $indexOf = callBind2(GetIntrinsic("String.prototype.indexOf"));
    $94db4f2abf87558b$var$callBound = function callBoundIntrinsic(name, allowMissing) {
        var intrinsic = GetIntrinsic(name, !!allowMissing);
        if (typeof intrinsic === "function" && $indexOf(name, ".prototype.") > -1) return callBind2(intrinsic);
        return intrinsic;
    };
    return $94db4f2abf87558b$var$callBound;
}
var $94db4f2abf87558b$var$isArguments;
var $94db4f2abf87558b$var$hasRequiredIsArguments;
function $94db4f2abf87558b$var$requireIsArguments() {
    if ($94db4f2abf87558b$var$hasRequiredIsArguments) return $94db4f2abf87558b$var$isArguments;
    $94db4f2abf87558b$var$hasRequiredIsArguments = 1;
    var hasToStringTag = $94db4f2abf87558b$var$requireShams()();
    var callBound2 = $94db4f2abf87558b$var$requireCallBound();
    var $toString = callBound2("Object.prototype.toString");
    var isStandardArguments = function isArguments2(value) {
        if (hasToStringTag && value && (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) === "object" && Symbol.toStringTag in value) return false;
        return $toString(value) === "[object Arguments]";
    };
    var isLegacyArguments = function isArguments2(value) {
        if (isStandardArguments(value)) return true;
        return value !== null && (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) === "object" && typeof value.length === "number" && value.length >= 0 && $toString(value) !== "[object Array]" && $toString(value.callee) === "[object Function]";
    };
    var supportsStandardArguments = function() {
        return isStandardArguments(arguments);
    }();
    isStandardArguments.isLegacyArguments = isLegacyArguments;
    $94db4f2abf87558b$var$isArguments = supportsStandardArguments ? isStandardArguments : isLegacyArguments;
    return $94db4f2abf87558b$var$isArguments;
}
var $94db4f2abf87558b$var$isGeneratorFunction;
var $94db4f2abf87558b$var$hasRequiredIsGeneratorFunction;
function $94db4f2abf87558b$var$requireIsGeneratorFunction() {
    if ($94db4f2abf87558b$var$hasRequiredIsGeneratorFunction) return $94db4f2abf87558b$var$isGeneratorFunction;
    $94db4f2abf87558b$var$hasRequiredIsGeneratorFunction = 1;
    var toStr = Object.prototype.toString;
    var fnToStr = Function.prototype.toString;
    var isFnRegex = /^\s*(?:function)?\*/;
    var hasToStringTag = $94db4f2abf87558b$var$requireShams()();
    var getProto = Object.getPrototypeOf;
    var getGeneratorFunc = function getGeneratorFunc() {
        if (!hasToStringTag) return false;
        try {
            return Function("return function*() {}")();
        } catch (e) {}
    };
    var GeneratorFunction;
    $94db4f2abf87558b$var$isGeneratorFunction = function isGeneratorFunction2(fn) {
        if (typeof fn !== "function") return false;
        if (isFnRegex.test(fnToStr.call(fn))) return true;
        if (!hasToStringTag) {
            var str = toStr.call(fn);
            return str === "[object GeneratorFunction]";
        }
        if (!getProto) return false;
        if (typeof GeneratorFunction === "undefined") {
            var generatorFunc = getGeneratorFunc();
            GeneratorFunction = generatorFunc ? getProto(generatorFunc) : false;
        }
        return getProto(fn) === GeneratorFunction;
    };
    return $94db4f2abf87558b$var$isGeneratorFunction;
}
var $94db4f2abf87558b$var$isCallable;
var $94db4f2abf87558b$var$hasRequiredIsCallable;
function $94db4f2abf87558b$var$requireIsCallable() {
    if ($94db4f2abf87558b$var$hasRequiredIsCallable) return $94db4f2abf87558b$var$isCallable;
    $94db4f2abf87558b$var$hasRequiredIsCallable = 1;
    var fnToStr = Function.prototype.toString;
    var reflectApply = (typeof Reflect === "undefined" ? "undefined" : (0, $2bfPH._)(Reflect)) === "object" && Reflect !== null && Reflect.apply;
    var badArrayLike;
    var isCallableMarker;
    if (typeof reflectApply === "function" && typeof Object.defineProperty === "function") try {
        badArrayLike = Object.defineProperty({}, "length", {
            get: function get() {
                throw isCallableMarker;
            }
        });
        isCallableMarker = {};
        reflectApply(function() {
            throw 42;
        }, null, badArrayLike);
    } catch (_) {
        if (_ !== isCallableMarker) reflectApply = null;
    }
    else reflectApply = null;
    var constructorRegex = /^\s*class\b/;
    var isES6ClassFn = function isES6ClassFunction(value) {
        try {
            var fnStr = fnToStr.call(value);
            return constructorRegex.test(fnStr);
        } catch (e) {
            return false;
        }
    };
    var tryFunctionObject = function tryFunctionToStr(value) {
        try {
            if (isES6ClassFn(value)) return false;
            fnToStr.call(value);
            return true;
        } catch (e) {
            return false;
        }
    };
    var toStr = Object.prototype.toString;
    var objectClass = "[object Object]";
    var fnClass = "[object Function]";
    var genClass = "[object GeneratorFunction]";
    var ddaClass = "[object HTMLAllCollection]";
    var ddaClass2 = "[object HTML document.all class]";
    var ddaClass3 = "[object HTMLCollection]";
    var hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag;
    var isIE68 = !(0 in [
        , 
    ]);
    var isDDA = function isDocumentDotAll() {
        return false;
    };
    if ((typeof document === "undefined" ? "undefined" : (0, $2bfPH._)(document)) === "object") {
        var all = document.all;
        if (toStr.call(all) === toStr.call(document.all)) isDDA = function isDocumentDotAll(value) {
            if ((isIE68 || !value) && (typeof value === "undefined" || (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) === "object")) try {
                var str = toStr.call(value);
                return (str === ddaClass || str === ddaClass2 || str === ddaClass3 || str === objectClass) && value("") == null;
            } catch (e) {}
            return false;
        };
    }
    $94db4f2abf87558b$var$isCallable = reflectApply ? function isCallable2(value) {
        if (isDDA(value)) return true;
        if (!value) return false;
        if (typeof value !== "function" && (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) !== "object") return false;
        try {
            reflectApply(value, null, badArrayLike);
        } catch (e) {
            if (e !== isCallableMarker) return false;
        }
        return !isES6ClassFn(value) && tryFunctionObject(value);
    } : function isCallable2(value) {
        if (isDDA(value)) return true;
        if (!value) return false;
        if (typeof value !== "function" && (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) !== "object") return false;
        if (hasToStringTag) return tryFunctionObject(value);
        if (isES6ClassFn(value)) return false;
        var strClass = toStr.call(value);
        if (strClass !== fnClass && strClass !== genClass && !/^\[object HTML/.test(strClass)) return false;
        return tryFunctionObject(value);
    };
    return $94db4f2abf87558b$var$isCallable;
}
var $94db4f2abf87558b$var$forEach_1;
var $94db4f2abf87558b$var$hasRequiredForEach;
function $94db4f2abf87558b$var$requireForEach() {
    if ($94db4f2abf87558b$var$hasRequiredForEach) return $94db4f2abf87558b$var$forEach_1;
    $94db4f2abf87558b$var$hasRequiredForEach = 1;
    var isCallable2 = $94db4f2abf87558b$var$requireIsCallable();
    var toStr = Object.prototype.toString;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var forEachArray = function forEachArray2(array, iterator, receiver) {
        for(var i = 0, len = array.length; i < len; i++)if (hasOwnProperty.call(array, i)) {
            if (receiver == null) iterator(array[i], i, array);
            else iterator.call(receiver, array[i], i, array);
        }
    };
    var forEachString = function forEachString2(string, iterator, receiver) {
        for(var i = 0, len = string.length; i < len; i++)if (receiver == null) iterator(string.charAt(i), i, string);
        else iterator.call(receiver, string.charAt(i), i, string);
    };
    var forEachObject = function forEachObject2(object, iterator, receiver) {
        for(var k in object)if (hasOwnProperty.call(object, k)) {
            if (receiver == null) iterator(object[k], k, object);
            else iterator.call(receiver, object[k], k, object);
        }
    };
    var forEach = function forEach2(list, iterator, thisArg) {
        if (!isCallable2(iterator)) throw new TypeError("iterator must be a function");
        var receiver;
        if (arguments.length >= 3) receiver = thisArg;
        if (toStr.call(list) === "[object Array]") forEachArray(list, iterator, receiver);
        else if (typeof list === "string") forEachString(list, iterator, receiver);
        else forEachObject(list, iterator, receiver);
    };
    $94db4f2abf87558b$var$forEach_1 = forEach;
    return $94db4f2abf87558b$var$forEach_1;
}
var $94db4f2abf87558b$var$availableTypedArrays;
var $94db4f2abf87558b$var$hasRequiredAvailableTypedArrays;
function $94db4f2abf87558b$var$requireAvailableTypedArrays() {
    if ($94db4f2abf87558b$var$hasRequiredAvailableTypedArrays) return $94db4f2abf87558b$var$availableTypedArrays;
    $94db4f2abf87558b$var$hasRequiredAvailableTypedArrays = 1;
    var possibleNames = [
        "BigInt64Array",
        "BigUint64Array",
        "Float32Array",
        "Float64Array",
        "Int16Array",
        "Int32Array",
        "Int8Array",
        "Uint16Array",
        "Uint32Array",
        "Uint8Array",
        "Uint8ClampedArray"
    ];
    var g = typeof globalThis === "undefined" ? $94db4f2abf87558b$var$commonjsGlobal : globalThis;
    $94db4f2abf87558b$var$availableTypedArrays = function availableTypedArrays2() {
        var out = [];
        for(var i = 0; i < possibleNames.length; i++)if (typeof g[possibleNames[i]] === "function") out[out.length] = possibleNames[i];
        return out;
    };
    return $94db4f2abf87558b$var$availableTypedArrays;
}
var $94db4f2abf87558b$var$whichTypedArray;
var $94db4f2abf87558b$var$hasRequiredWhichTypedArray;
function $94db4f2abf87558b$var$requireWhichTypedArray() {
    if ($94db4f2abf87558b$var$hasRequiredWhichTypedArray) return $94db4f2abf87558b$var$whichTypedArray;
    $94db4f2abf87558b$var$hasRequiredWhichTypedArray = 1;
    var forEach = $94db4f2abf87558b$var$requireForEach();
    var availableTypedArrays2 = $94db4f2abf87558b$var$requireAvailableTypedArrays();
    var callBind2 = $94db4f2abf87558b$var$requireCallBind();
    var callBound2 = $94db4f2abf87558b$var$requireCallBound();
    var gOPD = $94db4f2abf87558b$var$requireGopd();
    var $toString = callBound2("Object.prototype.toString");
    var hasToStringTag = $94db4f2abf87558b$var$requireShams()();
    var g = typeof globalThis === "undefined" ? $94db4f2abf87558b$var$commonjsGlobal : globalThis;
    var typedArrays = availableTypedArrays2();
    var $slice = callBound2("String.prototype.slice");
    var getPrototypeOf = Object.getPrototypeOf;
    var $indexOf = callBound2("Array.prototype.indexOf", true) || function indexOf(array, value) {
        for(var i = 0; i < array.length; i += 1){
            if (array[i] === value) return i;
        }
        return -1;
    };
    var cache = {
        __proto__: null
    };
    if (hasToStringTag && gOPD && getPrototypeOf) forEach(typedArrays, function(typedArray) {
        var arr = new g[typedArray]();
        if (Symbol.toStringTag in arr) {
            var proto = getPrototypeOf(arr);
            var descriptor = gOPD(proto, Symbol.toStringTag);
            if (!descriptor) {
                var superProto = getPrototypeOf(proto);
                descriptor = gOPD(superProto, Symbol.toStringTag);
            }
            cache["$" + typedArray] = callBind2(descriptor.get);
        }
    });
    else forEach(typedArrays, function(typedArray) {
        var arr = new g[typedArray]();
        var fn = arr.slice || arr.set;
        if (fn) cache["$" + typedArray] = callBind2(fn);
    });
    var tryTypedArrays = function tryAllTypedArrays(value) {
        var found = false;
        forEach(cache, function(getter, typedArray) {
            if (!found) try {
                if ("$" + getter(value) === typedArray) found = $slice(typedArray, 1);
            } catch (e) {}
        });
        return found;
    };
    var trySlices = function tryAllSlices(value) {
        var found = false;
        forEach(cache, function(getter, name) {
            if (!found) try {
                getter(value);
                found = $slice(name, 1);
            } catch (e) {}
        });
        return found;
    };
    $94db4f2abf87558b$var$whichTypedArray = function whichTypedArray2(value) {
        if (!value || (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) !== "object") return false;
        if (!hasToStringTag) {
            var tag = $slice($toString(value), 8, -1);
            if ($indexOf(typedArrays, tag) > -1) return tag;
            if (tag !== "Object") return false;
            return trySlices(value);
        }
        if (!gOPD) return null;
        return tryTypedArrays(value);
    };
    return $94db4f2abf87558b$var$whichTypedArray;
}
var $94db4f2abf87558b$var$isTypedArray;
var $94db4f2abf87558b$var$hasRequiredIsTypedArray;
function $94db4f2abf87558b$var$requireIsTypedArray() {
    if ($94db4f2abf87558b$var$hasRequiredIsTypedArray) return $94db4f2abf87558b$var$isTypedArray;
    $94db4f2abf87558b$var$hasRequiredIsTypedArray = 1;
    var whichTypedArray2 = $94db4f2abf87558b$var$requireWhichTypedArray();
    $94db4f2abf87558b$var$isTypedArray = function isTypedArray2(value) {
        return !!whichTypedArray2(value);
    };
    return $94db4f2abf87558b$var$isTypedArray;
}
var $94db4f2abf87558b$var$hasRequiredTypes;
function $94db4f2abf87558b$var$requireTypes() {
    if ($94db4f2abf87558b$var$hasRequiredTypes) return $94db4f2abf87558b$var$types;
    $94db4f2abf87558b$var$hasRequiredTypes = 1;
    (function(exports) {
        var isArgumentsObject = $94db4f2abf87558b$var$requireIsArguments();
        var isGeneratorFunction2 = $94db4f2abf87558b$var$requireIsGeneratorFunction();
        var whichTypedArray2 = $94db4f2abf87558b$var$requireWhichTypedArray();
        var isTypedArray2 = $94db4f2abf87558b$var$requireIsTypedArray();
        function uncurryThis(f) {
            return f.call.bind(f);
        }
        var BigIntSupported = typeof BigInt !== "undefined";
        var SymbolSupported = typeof Symbol !== "undefined";
        var ObjectToString = uncurryThis(Object.prototype.toString);
        var numberValue = uncurryThis(Number.prototype.valueOf);
        var stringValue = uncurryThis(String.prototype.valueOf);
        var booleanValue = uncurryThis(Boolean.prototype.valueOf);
        if (BigIntSupported) var bigIntValue = uncurryThis(BigInt.prototype.valueOf);
        if (SymbolSupported) var symbolValue = uncurryThis(Symbol.prototype.valueOf);
        function checkBoxedPrimitive(value, prototypeValueOf) {
            if ((typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) !== "object") return false;
            try {
                prototypeValueOf(value);
                return true;
            } catch (e) {
                return false;
            }
        }
        exports.isArgumentsObject = isArgumentsObject;
        exports.isGeneratorFunction = isGeneratorFunction2;
        exports.isTypedArray = isTypedArray2;
        function isPromise(input) {
            return typeof Promise !== "undefined" && input instanceof Promise || input !== null && (typeof input === "undefined" ? "undefined" : (0, $2bfPH._)(input)) === "object" && typeof input.then === "function" && typeof input.catch === "function";
        }
        exports.isPromise = isPromise;
        function isArrayBufferView(value) {
            if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) return ArrayBuffer.isView(value);
            return isTypedArray2(value) || isDataView(value);
        }
        exports.isArrayBufferView = isArrayBufferView;
        function isUint8Array(value) {
            return whichTypedArray2(value) === "Uint8Array";
        }
        exports.isUint8Array = isUint8Array;
        function isUint8ClampedArray(value) {
            return whichTypedArray2(value) === "Uint8ClampedArray";
        }
        exports.isUint8ClampedArray = isUint8ClampedArray;
        function isUint16Array(value) {
            return whichTypedArray2(value) === "Uint16Array";
        }
        exports.isUint16Array = isUint16Array;
        function isUint32Array(value) {
            return whichTypedArray2(value) === "Uint32Array";
        }
        exports.isUint32Array = isUint32Array;
        function isInt8Array(value) {
            return whichTypedArray2(value) === "Int8Array";
        }
        exports.isInt8Array = isInt8Array;
        function isInt16Array(value) {
            return whichTypedArray2(value) === "Int16Array";
        }
        exports.isInt16Array = isInt16Array;
        function isInt32Array(value) {
            return whichTypedArray2(value) === "Int32Array";
        }
        exports.isInt32Array = isInt32Array;
        function isFloat32Array(value) {
            return whichTypedArray2(value) === "Float32Array";
        }
        exports.isFloat32Array = isFloat32Array;
        function isFloat64Array(value) {
            return whichTypedArray2(value) === "Float64Array";
        }
        exports.isFloat64Array = isFloat64Array;
        function isBigInt64Array(value) {
            return whichTypedArray2(value) === "BigInt64Array";
        }
        exports.isBigInt64Array = isBigInt64Array;
        function isBigUint64Array(value) {
            return whichTypedArray2(value) === "BigUint64Array";
        }
        exports.isBigUint64Array = isBigUint64Array;
        function isMapToString(value) {
            return ObjectToString(value) === "[object Map]";
        }
        isMapToString.working = typeof Map !== "undefined" && isMapToString(/* @__PURE__ */ new Map());
        function isMap(value) {
            if (typeof Map === "undefined") return false;
            return isMapToString.working ? isMapToString(value) : value instanceof Map;
        }
        exports.isMap = isMap;
        function isSetToString(value) {
            return ObjectToString(value) === "[object Set]";
        }
        isSetToString.working = typeof Set !== "undefined" && isSetToString(/* @__PURE__ */ new Set());
        function isSet(value) {
            if (typeof Set === "undefined") return false;
            return isSetToString.working ? isSetToString(value) : value instanceof Set;
        }
        exports.isSet = isSet;
        function isWeakMapToString(value) {
            return ObjectToString(value) === "[object WeakMap]";
        }
        isWeakMapToString.working = typeof WeakMap !== "undefined" && isWeakMapToString(/* @__PURE__ */ new WeakMap());
        function isWeakMap(value) {
            if (typeof WeakMap === "undefined") return false;
            return isWeakMapToString.working ? isWeakMapToString(value) : value instanceof WeakMap;
        }
        exports.isWeakMap = isWeakMap;
        function isWeakSetToString(value) {
            return ObjectToString(value) === "[object WeakSet]";
        }
        isWeakSetToString.working = typeof WeakSet !== "undefined" && isWeakSetToString(/* @__PURE__ */ new WeakSet());
        function isWeakSet(value) {
            return isWeakSetToString(value);
        }
        exports.isWeakSet = isWeakSet;
        function isArrayBufferToString(value) {
            return ObjectToString(value) === "[object ArrayBuffer]";
        }
        isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && isArrayBufferToString(new ArrayBuffer());
        function isArrayBuffer(value) {
            if (typeof ArrayBuffer === "undefined") return false;
            return isArrayBufferToString.working ? isArrayBufferToString(value) : value instanceof ArrayBuffer;
        }
        exports.isArrayBuffer = isArrayBuffer;
        function isDataViewToString(value) {
            return ObjectToString(value) === "[object DataView]";
        }
        isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
        function isDataView(value) {
            if (typeof DataView === "undefined") return false;
            return isDataViewToString.working ? isDataViewToString(value) : value instanceof DataView;
        }
        exports.isDataView = isDataView;
        var SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : void 0;
        function isSharedArrayBufferToString(value) {
            return ObjectToString(value) === "[object SharedArrayBuffer]";
        }
        function isSharedArrayBuffer(value) {
            if (typeof SharedArrayBufferCopy === "undefined") return false;
            if (typeof isSharedArrayBufferToString.working === "undefined") isSharedArrayBufferToString.working = isSharedArrayBufferToString(new SharedArrayBufferCopy());
            return isSharedArrayBufferToString.working ? isSharedArrayBufferToString(value) : value instanceof SharedArrayBufferCopy;
        }
        exports.isSharedArrayBuffer = isSharedArrayBuffer;
        function isAsyncFunction(value) {
            return ObjectToString(value) === "[object AsyncFunction]";
        }
        exports.isAsyncFunction = isAsyncFunction;
        function isMapIterator(value) {
            return ObjectToString(value) === "[object Map Iterator]";
        }
        exports.isMapIterator = isMapIterator;
        function isSetIterator(value) {
            return ObjectToString(value) === "[object Set Iterator]";
        }
        exports.isSetIterator = isSetIterator;
        function isGeneratorObject(value) {
            return ObjectToString(value) === "[object Generator]";
        }
        exports.isGeneratorObject = isGeneratorObject;
        function isWebAssemblyCompiledModule(value) {
            return ObjectToString(value) === "[object WebAssembly.Module]";
        }
        exports.isWebAssemblyCompiledModule = isWebAssemblyCompiledModule;
        function isNumberObject(value) {
            return checkBoxedPrimitive(value, numberValue);
        }
        exports.isNumberObject = isNumberObject;
        function isStringObject(value) {
            return checkBoxedPrimitive(value, stringValue);
        }
        exports.isStringObject = isStringObject;
        function isBooleanObject(value) {
            return checkBoxedPrimitive(value, booleanValue);
        }
        exports.isBooleanObject = isBooleanObject;
        function isBigIntObject(value) {
            return BigIntSupported && checkBoxedPrimitive(value, bigIntValue);
        }
        exports.isBigIntObject = isBigIntObject;
        function isSymbolObject(value) {
            return SymbolSupported && checkBoxedPrimitive(value, symbolValue);
        }
        exports.isSymbolObject = isSymbolObject;
        function isBoxedPrimitive(value) {
            return isNumberObject(value) || isStringObject(value) || isBooleanObject(value) || isBigIntObject(value) || isSymbolObject(value);
        }
        exports.isBoxedPrimitive = isBoxedPrimitive;
        function isAnyArrayBuffer(value) {
            return typeof Uint8Array !== "undefined" && (isArrayBuffer(value) || isSharedArrayBuffer(value));
        }
        exports.isAnyArrayBuffer = isAnyArrayBuffer;
        [
            "isProxy",
            "isExternal",
            "isModuleNamespaceObject"
        ].forEach(function(method) {
            Object.defineProperty(exports, method, {
                enumerable: false,
                value: function value() {
                    throw new Error(method + " is not supported in userland");
                }
            });
        });
    })($94db4f2abf87558b$var$types);
    return $94db4f2abf87558b$var$types;
}
var $94db4f2abf87558b$var$isBufferBrowser;
var $94db4f2abf87558b$var$hasRequiredIsBufferBrowser;
function $94db4f2abf87558b$var$requireIsBufferBrowser() {
    if ($94db4f2abf87558b$var$hasRequiredIsBufferBrowser) return $94db4f2abf87558b$var$isBufferBrowser;
    $94db4f2abf87558b$var$hasRequiredIsBufferBrowser = 1;
    $94db4f2abf87558b$var$isBufferBrowser = function isBuffer(arg) {
        return arg && (typeof arg === "undefined" ? "undefined" : (0, $2bfPH._)(arg)) === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
    };
    return $94db4f2abf87558b$var$isBufferBrowser;
}
var $94db4f2abf87558b$var$hasRequiredUtil;
function $94db4f2abf87558b$var$requireUtil() {
    if ($94db4f2abf87558b$var$hasRequiredUtil) return $94db4f2abf87558b$var$util;
    $94db4f2abf87558b$var$hasRequiredUtil = 1;
    (function(exports) {
        var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors2(obj) {
            var keys = Object.keys(obj);
            var descriptors = {};
            for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
            return descriptors;
        };
        var formatRegExp = /%[sdj%]/g;
        exports.format = function(f) {
            if (!isString(f)) {
                var objects = [];
                for(var i = 0; i < arguments.length; i++)objects.push(inspect(arguments[i]));
                return objects.join(" ");
            }
            var i = 1;
            var args = arguments;
            var len = args.length;
            var str = String(f).replace(formatRegExp, function(x2) {
                if (x2 === "%%") return "%";
                if (i >= len) return x2;
                switch(x2){
                    case "%s":
                        return String(args[i++]);
                    case "%d":
                        return Number(args[i++]);
                    case "%j":
                        try {
                            return JSON.stringify(args[i++]);
                        } catch (_) {
                            return "[Circular]";
                        }
                    default:
                        return x2;
                }
            });
            for(var x = args[i]; i < len; x = args[++i])if (isNull(x) || !isObject(x)) str += " " + x;
            else str += " " + inspect(x);
            return str;
        };
        exports.deprecate = function(fn, msg) {
            if (typeof $94db4f2abf87558b$var$process$1 !== "undefined" && $94db4f2abf87558b$var$process$1.noDeprecation === true) return fn;
            if (typeof $94db4f2abf87558b$var$process$1 === "undefined") return function() {
                return exports.deprecate(fn, msg).apply(this, arguments);
            };
            var warned = false;
            function deprecated() {
                if (!warned) {
                    if ($94db4f2abf87558b$var$process$1.throwDeprecation) throw new Error(msg);
                    else if ($94db4f2abf87558b$var$process$1.traceDeprecation) console.trace(msg);
                    else console.error(msg);
                    warned = true;
                }
                return fn.apply(this, arguments);
            }
            return deprecated;
        };
        var debugs = {};
        var debugEnvRegex = /^$/;
        if ($94db4f2abf87558b$var$process$1.env.NODE_DEBUG) {
            var debugEnv = $94db4f2abf87558b$var$process$1.env.NODE_DEBUG;
            debugEnv = debugEnv.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase();
            debugEnvRegex = new RegExp("^" + debugEnv + "$", "i");
        }
        exports.debuglog = function(set) {
            set = set.toUpperCase();
            if (!debugs[set]) {
                if (debugEnvRegex.test(set)) {
                    var pid = $94db4f2abf87558b$var$process$1.pid;
                    debugs[set] = function() {
                        var msg = exports.format.apply(exports, arguments);
                        console.error("%s %d: %s", set, pid, msg);
                    };
                } else debugs[set] = function() {};
            }
            return debugs[set];
        };
        function inspect(obj, opts) {
            var ctx = {
                seen: [],
                stylize: stylizeNoColor
            };
            if (arguments.length >= 3) ctx.depth = arguments[2];
            if (arguments.length >= 4) ctx.colors = arguments[3];
            if (isBoolean(opts)) ctx.showHidden = opts;
            else if (opts) exports._extend(ctx, opts);
            if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
            if (isUndefined(ctx.depth)) ctx.depth = 2;
            if (isUndefined(ctx.colors)) ctx.colors = false;
            if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
            if (ctx.colors) ctx.stylize = stylizeWithColor;
            return formatValue(ctx, obj, ctx.depth);
        }
        exports.inspect = inspect;
        inspect.colors = {
            "bold": [
                1,
                22
            ],
            "italic": [
                3,
                23
            ],
            "underline": [
                4,
                24
            ],
            "inverse": [
                7,
                27
            ],
            "white": [
                37,
                39
            ],
            "grey": [
                90,
                39
            ],
            "black": [
                30,
                39
            ],
            "blue": [
                34,
                39
            ],
            "cyan": [
                36,
                39
            ],
            "green": [
                32,
                39
            ],
            "magenta": [
                35,
                39
            ],
            "red": [
                31,
                39
            ],
            "yellow": [
                33,
                39
            ]
        };
        inspect.styles = {
            "special": "cyan",
            "number": "yellow",
            "boolean": "yellow",
            "undefined": "grey",
            "null": "bold",
            "string": "green",
            "date": "magenta",
            // "name": intentionally not styling
            "regexp": "red"
        };
        function stylizeWithColor(str, styleType) {
            var style = inspect.styles[styleType];
            if (style) return "\x1B[" + inspect.colors[style][0] + "m" + str + "\x1B[" + inspect.colors[style][1] + "m";
            else return str;
        }
        function stylizeNoColor(str, styleType) {
            return str;
        }
        function arrayToHash(array) {
            var hash = {};
            array.forEach(function(val, idx) {
                hash[val] = true;
            });
            return hash;
        }
        function formatValue(ctx, value, recurseTimes) {
            if (ctx.customInspect && value && isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
            value.inspect !== exports.inspect && // Also filter out any prototype objects using the circular check.
            !(value.constructor && value.constructor.prototype === value)) {
                var ret = value.inspect(recurseTimes, ctx);
                if (!isString(ret)) ret = formatValue(ctx, ret, recurseTimes);
                return ret;
            }
            var primitive = formatPrimitive(ctx, value);
            if (primitive) return primitive;
            var keys = Object.keys(value);
            var visibleKeys = arrayToHash(keys);
            if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
            if (isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return formatError(value);
            if (keys.length === 0) {
                if (isFunction(value)) {
                    var name = value.name ? ": " + value.name : "";
                    return ctx.stylize("[Function" + name + "]", "special");
                }
                if (isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
                if (isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
                if (isError(value)) return formatError(value);
            }
            var base = "", array = false, braces = [
                "{",
                "}"
            ];
            if (isArray2(value)) {
                array = true;
                braces = [
                    "[",
                    "]"
                ];
            }
            if (isFunction(value)) {
                var n = value.name ? ": " + value.name : "";
                base = " [Function" + n + "]";
            }
            if (isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
            if (isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
            if (isError(value)) base = " " + formatError(value);
            if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
            if (recurseTimes < 0) {
                if (isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
                else return ctx.stylize("[Object]", "special");
            }
            ctx.seen.push(value);
            var output;
            if (array) output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
            else output = keys.map(function(key) {
                return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
            });
            ctx.seen.pop();
            return reduceToSingleString(output, base, braces);
        }
        function formatPrimitive(ctx, value) {
            if (isUndefined(value)) return ctx.stylize("undefined", "undefined");
            if (isString(value)) {
                var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                return ctx.stylize(simple, "string");
            }
            if (isNumber(value)) return ctx.stylize("" + value, "number");
            if (isBoolean(value)) return ctx.stylize("" + value, "boolean");
            if (isNull(value)) return ctx.stylize("null", "null");
        }
        function formatError(value) {
            return "[" + Error.prototype.toString.call(value) + "]";
        }
        function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
            var output = [];
            for(var i = 0, l = value.length; i < l; ++i)if (hasOwnProperty(value, String(i))) output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
            else output.push("");
            keys.forEach(function(key) {
                if (!key.match(/^\d+$/)) output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
            });
            return output;
        }
        function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
            var name, str, desc;
            desc = Object.getOwnPropertyDescriptor(value, key) || {
                value: value[key]
            };
            if (desc.get) {
                if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
                else str = ctx.stylize("[Getter]", "special");
            } else if (desc.set) str = ctx.stylize("[Setter]", "special");
            if (!hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
            if (!str) {
                if (ctx.seen.indexOf(desc.value) < 0) {
                    if (isNull(recurseTimes)) str = formatValue(ctx, desc.value, null);
                    else str = formatValue(ctx, desc.value, recurseTimes - 1);
                    if (str.indexOf("\n") > -1) {
                        if (array) str = str.split("\n").map(function(line) {
                            return "  " + line;
                        }).join("\n").slice(2);
                        else str = "\n" + str.split("\n").map(function(line) {
                            return "   " + line;
                        }).join("\n");
                    }
                } else str = ctx.stylize("[Circular]", "special");
            }
            if (isUndefined(name)) {
                if (array && key.match(/^\d+$/)) return str;
                name = JSON.stringify("" + key);
                if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
                    name = name.slice(1, -1);
                    name = ctx.stylize(name, "name");
                } else {
                    name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
                    name = ctx.stylize(name, "string");
                }
            }
            return name + ": " + str;
        }
        function reduceToSingleString(output, base, braces) {
            var length = output.reduce(function(prev, cur) {
                cur.indexOf("\n");
                return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
            }, 0);
            if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
            return braces[0] + base + " " + output.join(", ") + " " + braces[1];
        }
        exports.types = $94db4f2abf87558b$var$requireTypes();
        function isArray2(ar) {
            return Array.isArray(ar);
        }
        exports.isArray = isArray2;
        function isBoolean(arg) {
            return typeof arg === "boolean";
        }
        exports.isBoolean = isBoolean;
        function isNull(arg) {
            return arg === null;
        }
        exports.isNull = isNull;
        function isNullOrUndefined(arg) {
            return arg == null;
        }
        exports.isNullOrUndefined = isNullOrUndefined;
        function isNumber(arg) {
            return typeof arg === "number";
        }
        exports.isNumber = isNumber;
        function isString(arg) {
            return typeof arg === "string";
        }
        exports.isString = isString;
        function isSymbol(arg) {
            return (typeof arg === "undefined" ? "undefined" : (0, $2bfPH._)(arg)) === "symbol";
        }
        exports.isSymbol = isSymbol;
        function isUndefined(arg) {
            return arg === void 0;
        }
        exports.isUndefined = isUndefined;
        function isRegExp(re) {
            return isObject(re) && objectToString(re) === "[object RegExp]";
        }
        exports.isRegExp = isRegExp;
        exports.types.isRegExp = isRegExp;
        function isObject(arg) {
            return (typeof arg === "undefined" ? "undefined" : (0, $2bfPH._)(arg)) === "object" && arg !== null;
        }
        exports.isObject = isObject;
        function isDate(d) {
            return isObject(d) && objectToString(d) === "[object Date]";
        }
        exports.isDate = isDate;
        exports.types.isDate = isDate;
        function isError(e) {
            return isObject(e) && (objectToString(e) === "[object Error]" || e instanceof Error);
        }
        exports.isError = isError;
        exports.types.isNativeError = isError;
        function isFunction(arg) {
            return typeof arg === "function";
        }
        exports.isFunction = isFunction;
        function isPrimitive(arg) {
            return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || (typeof arg === "undefined" ? "undefined" : (0, $2bfPH._)(arg)) === "symbol" || // ES6 symbol
            typeof arg === "undefined";
        }
        exports.isPrimitive = isPrimitive;
        exports.isBuffer = $94db4f2abf87558b$var$requireIsBufferBrowser();
        function objectToString(o) {
            return Object.prototype.toString.call(o);
        }
        function pad(n) {
            return n < 10 ? "0" + n.toString(10) : n.toString(10);
        }
        var months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ];
        function timestamp() {
            var d = /* @__PURE__ */ new Date();
            var time = [
                pad(d.getHours()),
                pad(d.getMinutes()),
                pad(d.getSeconds())
            ].join(":");
            return [
                d.getDate(),
                months[d.getMonth()],
                time
            ].join(" ");
        }
        exports.log = function() {
            console.log("%s - %s", timestamp(), exports.format.apply(exports, arguments));
        };
        exports.inherits = $94db4f2abf87558b$var$inherits_browserExports;
        exports._extend = function(origin, add) {
            if (!add || !isObject(add)) return origin;
            var keys = Object.keys(add);
            var i = keys.length;
            while(i--)origin[keys[i]] = add[keys[i]];
            return origin;
        };
        function hasOwnProperty(obj, prop) {
            return Object.prototype.hasOwnProperty.call(obj, prop);
        }
        var kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : void 0;
        exports.promisify = function promisify(original) {
            if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
            if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
                var fn = original[kCustomPromisifiedSymbol];
                if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
                Object.defineProperty(fn, kCustomPromisifiedSymbol, {
                    value: fn,
                    enumerable: false,
                    writable: false,
                    configurable: true
                });
                return fn;
            }
            function fn() {
                var promiseResolve, promiseReject;
                var promise = new Promise(function(resolve2, reject) {
                    promiseResolve = resolve2;
                    promiseReject = reject;
                });
                var args = [];
                for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
                args.push(function(err, value) {
                    if (err) promiseReject(err);
                    else promiseResolve(value);
                });
                try {
                    original.apply(this, args);
                } catch (err) {
                    promiseReject(err);
                }
                return promise;
            }
            Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
            if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
                value: fn,
                enumerable: false,
                writable: false,
                configurable: true
            });
            return Object.defineProperties(fn, getOwnPropertyDescriptors(original));
        };
        exports.promisify.custom = kCustomPromisifiedSymbol;
        function callbackifyOnRejected(reason, cb) {
            if (!reason) {
                var newReason = new Error("Promise was rejected with a falsy value");
                newReason.reason = reason;
                reason = newReason;
            }
            return cb(reason);
        }
        function callbackify(original) {
            if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
            function callbackified() {
                var args = [];
                for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
                var maybeCb = args.pop();
                if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
                var self2 = this;
                var cb = function cb() {
                    return maybeCb.apply(self2, arguments);
                };
                original.apply(this, args).then(function(ret) {
                    $94db4f2abf87558b$var$process$1.nextTick(cb.bind(null, null, ret));
                }, function(rej) {
                    $94db4f2abf87558b$var$process$1.nextTick(callbackifyOnRejected.bind(null, rej, cb));
                });
            }
            Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
            Object.defineProperties(callbackified, getOwnPropertyDescriptors(original));
            return callbackified;
        }
        exports.callbackify = callbackify;
    })($94db4f2abf87558b$var$util);
    return $94db4f2abf87558b$var$util;
}
var $94db4f2abf87558b$var$buffer_list;
var $94db4f2abf87558b$var$hasRequiredBuffer_list;
function $94db4f2abf87558b$var$requireBuffer_list() {
    if ($94db4f2abf87558b$var$hasRequiredBuffer_list) return $94db4f2abf87558b$var$buffer_list;
    $94db4f2abf87558b$var$hasRequiredBuffer_list = 1;
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }
    var _require = $94db4f2abf87558b$var$requireBuffer(), Buffer2 = _require.Buffer;
    var _require2 = $94db4f2abf87558b$var$requireUtil(), inspect = _require2.inspect;
    var custom = inspect && inspect.custom || "inspect";
    function copyBuffer(src, target, offset) {
        Buffer2.prototype.copy.call(src, target, offset);
    }
    $94db4f2abf87558b$var$buffer_list = /* @__PURE__ */ function() {
        function BufferList() {
            _classCallCheck(this, BufferList);
            this.head = null;
            this.tail = null;
            this.length = 0;
        }
        _createClass(BufferList, [
            {
                key: "push",
                value: function push(v) {
                    var entry = {
                        data: v,
                        next: null
                    };
                    if (this.length > 0) this.tail.next = entry;
                    else this.head = entry;
                    this.tail = entry;
                    ++this.length;
                }
            },
            {
                key: "unshift",
                value: function unshift(v) {
                    var entry = {
                        data: v,
                        next: this.head
                    };
                    if (this.length === 0) this.tail = entry;
                    this.head = entry;
                    ++this.length;
                }
            },
            {
                key: "shift",
                value: function shift() {
                    if (this.length === 0) return;
                    var ret = this.head.data;
                    if (this.length === 1) this.head = this.tail = null;
                    else this.head = this.head.next;
                    --this.length;
                    return ret;
                }
            },
            {
                key: "clear",
                value: function clear() {
                    this.head = this.tail = null;
                    this.length = 0;
                }
            },
            {
                key: "join",
                value: function join(s) {
                    if (this.length === 0) return "";
                    var p = this.head;
                    var ret = "" + p.data;
                    while(p = p.next)ret += s + p.data;
                    return ret;
                }
            },
            {
                key: "concat",
                value: function concat(n) {
                    if (this.length === 0) return Buffer2.alloc(0);
                    var ret = Buffer2.allocUnsafe(n >>> 0);
                    var p = this.head;
                    var i = 0;
                    while(p){
                        copyBuffer(p.data, ret, i);
                        i += p.data.length;
                        p = p.next;
                    }
                    return ret;
                }
            },
            {
                key: "consume",
                value: function consume(n, hasStrings) {
                    var ret;
                    if (n < this.head.data.length) {
                        ret = this.head.data.slice(0, n);
                        this.head.data = this.head.data.slice(n);
                    } else if (n === this.head.data.length) ret = this.shift();
                    else ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                    return ret;
                }
            },
            {
                key: "first",
                value: function first() {
                    return this.head.data;
                }
            },
            {
                key: "_getString",
                value: function _getString(n) {
                    var p = this.head;
                    var c = 1;
                    var ret = p.data;
                    n -= ret.length;
                    while(p = p.next){
                        var str = p.data;
                        var nb = n > str.length ? str.length : n;
                        if (nb === str.length) ret += str;
                        else ret += str.slice(0, n);
                        n -= nb;
                        if (n === 0) {
                            if (nb === str.length) {
                                ++c;
                                if (p.next) this.head = p.next;
                                else this.head = this.tail = null;
                            } else {
                                this.head = p;
                                p.data = str.slice(nb);
                            }
                            break;
                        }
                        ++c;
                    }
                    this.length -= c;
                    return ret;
                }
            },
            {
                key: "_getBuffer",
                value: function _getBuffer(n) {
                    var ret = Buffer2.allocUnsafe(n);
                    var p = this.head;
                    var c = 1;
                    p.data.copy(ret);
                    n -= p.data.length;
                    while(p = p.next){
                        var buf = p.data;
                        var nb = n > buf.length ? buf.length : n;
                        buf.copy(ret, ret.length - n, 0, nb);
                        n -= nb;
                        if (n === 0) {
                            if (nb === buf.length) {
                                ++c;
                                if (p.next) this.head = p.next;
                                else this.head = this.tail = null;
                            } else {
                                this.head = p;
                                p.data = buf.slice(nb);
                            }
                            break;
                        }
                        ++c;
                    }
                    this.length -= c;
                    return ret;
                }
            },
            {
                key: custom,
                value: function value(_, options2) {
                    return inspect(this, _objectSpread({}, options2, {
                        // Only inspect one level.
                        depth: 0,
                        // It should not recurse.
                        customInspect: false
                    }));
                }
            }
        ]);
        return BufferList;
    }();
    return $94db4f2abf87558b$var$buffer_list;
}
var $94db4f2abf87558b$var$destroy_1;
var $94db4f2abf87558b$var$hasRequiredDestroy;
function $94db4f2abf87558b$var$requireDestroy() {
    if ($94db4f2abf87558b$var$hasRequiredDestroy) return $94db4f2abf87558b$var$destroy_1;
    $94db4f2abf87558b$var$hasRequiredDestroy = 1;
    function destroy(err, cb) {
        var _this = this;
        var readableDestroyed = this._readableState && this._readableState.destroyed;
        var writableDestroyed = this._writableState && this._writableState.destroyed;
        if (readableDestroyed || writableDestroyed) {
            if (cb) cb(err);
            else if (err) {
                if (!this._writableState) $94db4f2abf87558b$var$process$1.nextTick(emitErrorNT, this, err);
                else if (!this._writableState.errorEmitted) {
                    this._writableState.errorEmitted = true;
                    $94db4f2abf87558b$var$process$1.nextTick(emitErrorNT, this, err);
                }
            }
            return this;
        }
        if (this._readableState) this._readableState.destroyed = true;
        if (this._writableState) this._writableState.destroyed = true;
        this._destroy(err || null, function(err2) {
            if (!cb && err2) {
                if (!_this._writableState) $94db4f2abf87558b$var$process$1.nextTick(emitErrorAndCloseNT, _this, err2);
                else if (!_this._writableState.errorEmitted) {
                    _this._writableState.errorEmitted = true;
                    $94db4f2abf87558b$var$process$1.nextTick(emitErrorAndCloseNT, _this, err2);
                } else $94db4f2abf87558b$var$process$1.nextTick(emitCloseNT, _this);
            } else if (cb) {
                $94db4f2abf87558b$var$process$1.nextTick(emitCloseNT, _this);
                cb(err2);
            } else $94db4f2abf87558b$var$process$1.nextTick(emitCloseNT, _this);
        });
        return this;
    }
    function emitErrorAndCloseNT(self2, err) {
        emitErrorNT(self2, err);
        emitCloseNT(self2);
    }
    function emitCloseNT(self2) {
        if (self2._writableState && !self2._writableState.emitClose) return;
        if (self2._readableState && !self2._readableState.emitClose) return;
        self2.emit("close");
    }
    function undestroy() {
        if (this._readableState) {
            this._readableState.destroyed = false;
            this._readableState.reading = false;
            this._readableState.ended = false;
            this._readableState.endEmitted = false;
        }
        if (this._writableState) {
            this._writableState.destroyed = false;
            this._writableState.ended = false;
            this._writableState.ending = false;
            this._writableState.finalCalled = false;
            this._writableState.prefinished = false;
            this._writableState.finished = false;
            this._writableState.errorEmitted = false;
        }
    }
    function emitErrorNT(self2, err) {
        self2.emit("error", err);
    }
    function errorOrDestroy(stream, err) {
        var rState = stream._readableState;
        var wState = stream._writableState;
        if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
        else stream.emit("error", err);
    }
    $94db4f2abf87558b$var$destroy_1 = {
        destroy: destroy,
        undestroy: undestroy,
        errorOrDestroy: errorOrDestroy
    };
    return $94db4f2abf87558b$var$destroy_1;
}
var $94db4f2abf87558b$var$errorsBrowser = {};
var $94db4f2abf87558b$var$hasRequiredErrorsBrowser;
function $94db4f2abf87558b$var$requireErrorsBrowser() {
    if ($94db4f2abf87558b$var$hasRequiredErrorsBrowser) return $94db4f2abf87558b$var$errorsBrowser;
    $94db4f2abf87558b$var$hasRequiredErrorsBrowser = 1;
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        subClass.__proto__ = superClass;
    }
    var codes = {};
    function createErrorType(code, message, Base) {
        if (!Base) Base = Error;
        function getMessage(arg1, arg2, arg3) {
            if (typeof message === "string") return message;
            else return message(arg1, arg2, arg3);
        }
        var NodeError = /* @__PURE__ */ function(_Base) {
            _inheritsLoose(NodeError2, _Base);
            function NodeError2(arg1, arg2, arg3) {
                return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
            }
            return NodeError2;
        }(Base);
        NodeError.prototype.name = Base.name;
        NodeError.prototype.code = code;
        codes[code] = NodeError;
    }
    function oneOf(expected, thing) {
        if (Array.isArray(expected)) {
            var len = expected.length;
            expected = expected.map(function(i) {
                return String(i);
            });
            if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
            else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
            else return "of ".concat(thing, " ").concat(expected[0]);
        } else return "of ".concat(thing, " ").concat(String(expected));
    }
    function startsWith(str, search, pos) {
        return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
    }
    function endsWith(str, search, this_len) {
        if (this_len === void 0 || this_len > str.length) this_len = str.length;
        return str.substring(this_len - search.length, this_len) === search;
    }
    function includes(str, search, start) {
        if (typeof start !== "number") start = 0;
        if (start + search.length > str.length) return false;
        else return str.indexOf(search, start) !== -1;
    }
    createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
        return 'The value "' + value + '" is invalid for option "' + name + '"';
    }, TypeError);
    createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
        var determiner;
        if (typeof expected === "string" && startsWith(expected, "not ")) {
            determiner = "must not be";
            expected = expected.replace(/^not /, "");
        } else determiner = "must be";
        var msg;
        if (endsWith(name, " argument")) msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
        else {
            var type = includes(name, ".") ? "property" : "argument";
            msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
        }
        msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $2bfPH._)(actual));
        return msg;
    }, TypeError);
    createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
    createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
        return "The " + name + " method is not implemented";
    });
    createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
    createErrorType("ERR_STREAM_DESTROYED", function(name) {
        return "Cannot call " + name + " after a stream was destroyed";
    });
    createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
    createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
    createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
    createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
    createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
        return "Unknown encoding: " + arg;
    }, TypeError);
    createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
    $94db4f2abf87558b$var$errorsBrowser.codes = codes;
    return $94db4f2abf87558b$var$errorsBrowser;
}
var $94db4f2abf87558b$var$state;
var $94db4f2abf87558b$var$hasRequiredState;
function $94db4f2abf87558b$var$requireState() {
    if ($94db4f2abf87558b$var$hasRequiredState) return $94db4f2abf87558b$var$state;
    $94db4f2abf87558b$var$hasRequiredState = 1;
    var ERR_INVALID_OPT_VALUE = $94db4f2abf87558b$var$requireErrorsBrowser().codes.ERR_INVALID_OPT_VALUE;
    function highWaterMarkFrom(options2, isDuplex, duplexKey) {
        return options2.highWaterMark != null ? options2.highWaterMark : isDuplex ? options2[duplexKey] : null;
    }
    function getHighWaterMark(state2, options2, duplexKey, isDuplex) {
        var hwm = highWaterMarkFrom(options2, isDuplex, duplexKey);
        if (hwm != null) {
            if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
                var name = isDuplex ? duplexKey : "highWaterMark";
                throw new ERR_INVALID_OPT_VALUE(name, hwm);
            }
            return Math.floor(hwm);
        }
        return state2.objectMode ? 16 : 16384;
    }
    $94db4f2abf87558b$var$state = {
        getHighWaterMark: getHighWaterMark
    };
    return $94db4f2abf87558b$var$state;
}
var $94db4f2abf87558b$var$browser;
var $94db4f2abf87558b$var$hasRequiredBrowser;
function $94db4f2abf87558b$var$requireBrowser() {
    if ($94db4f2abf87558b$var$hasRequiredBrowser) return $94db4f2abf87558b$var$browser;
    $94db4f2abf87558b$var$hasRequiredBrowser = 1;
    $94db4f2abf87558b$var$browser = deprecate;
    function deprecate(fn, msg) {
        if (config("noDeprecation")) return fn;
        var warned = false;
        function deprecated() {
            if (!warned) {
                if (config("throwDeprecation")) throw new Error(msg);
                else if (config("traceDeprecation")) console.trace(msg);
                else console.warn(msg);
                warned = true;
            }
            return fn.apply(this, arguments);
        }
        return deprecated;
    }
    function config(name) {
        try {
            if (!$94db4f2abf87558b$var$commonjsGlobal.localStorage) return false;
        } catch (_) {
            return false;
        }
        var val = $94db4f2abf87558b$var$commonjsGlobal.localStorage[name];
        if (null == val) return false;
        return String(val).toLowerCase() === "true";
    }
    return $94db4f2abf87558b$var$browser;
}
var $94db4f2abf87558b$var$_stream_writable;
var $94db4f2abf87558b$var$hasRequired_stream_writable;
function $94db4f2abf87558b$var$require_stream_writable() {
    if ($94db4f2abf87558b$var$hasRequired_stream_writable) return $94db4f2abf87558b$var$_stream_writable;
    $94db4f2abf87558b$var$hasRequired_stream_writable = 1;
    $94db4f2abf87558b$var$_stream_writable = Writable;
    function CorkedRequest(state2) {
        var _this = this;
        this.next = null;
        this.entry = null;
        this.finish = function() {
            onCorkedFinish(_this, state2);
        };
    }
    var Duplex;
    Writable.WritableState = WritableState;
    var internalUtil = {
        deprecate: $94db4f2abf87558b$var$requireBrowser()
    };
    var Stream2 = $94db4f2abf87558b$var$requireStreamBrowser();
    var Buffer2 = $94db4f2abf87558b$var$requireBuffer().Buffer;
    var OurUint8Array = $94db4f2abf87558b$var$commonjsGlobal.Uint8Array || function() {};
    function _uint8ArrayToBuffer(chunk) {
        return Buffer2.from(chunk);
    }
    function _isUint8Array(obj) {
        return Buffer2.isBuffer(obj) || obj instanceof OurUint8Array;
    }
    var destroyImpl = $94db4f2abf87558b$var$requireDestroy();
    var _require = $94db4f2abf87558b$var$requireState(), getHighWaterMark = _require.getHighWaterMark;
    var _require$codes = $94db4f2abf87558b$var$requireErrorsBrowser().codes, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED, ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
    var errorOrDestroy = destroyImpl.errorOrDestroy;
    $94db4f2abf87558b$var$inherits_browserExports(Writable, Stream2);
    function nop() {}
    function WritableState(options2, stream, isDuplex) {
        Duplex = Duplex || $94db4f2abf87558b$var$require_stream_duplex();
        options2 = options2 || {};
        if (typeof isDuplex !== "boolean") isDuplex = stream instanceof Duplex;
        this.objectMode = !!options2.objectMode;
        if (isDuplex) this.objectMode = this.objectMode || !!options2.writableObjectMode;
        this.highWaterMark = getHighWaterMark(this, options2, "writableHighWaterMark", isDuplex);
        this.finalCalled = false;
        this.needDrain = false;
        this.ending = false;
        this.ended = false;
        this.finished = false;
        this.destroyed = false;
        var noDecode = options2.decodeStrings === false;
        this.decodeStrings = !noDecode;
        this.defaultEncoding = options2.defaultEncoding || "utf8";
        this.length = 0;
        this.writing = false;
        this.corked = 0;
        this.sync = true;
        this.bufferProcessing = false;
        this.onwrite = function(er) {
            onwrite(stream, er);
        };
        this.writecb = null;
        this.writelen = 0;
        this.bufferedRequest = null;
        this.lastBufferedRequest = null;
        this.pendingcb = 0;
        this.prefinished = false;
        this.errorEmitted = false;
        this.emitClose = options2.emitClose !== false;
        this.autoDestroy = !!options2.autoDestroy;
        this.bufferedRequestCount = 0;
        this.corkedRequestsFree = new CorkedRequest(this);
    }
    WritableState.prototype.getBuffer = function getBuffer() {
        var current = this.bufferedRequest;
        var out = [];
        while(current){
            out.push(current);
            current = current.next;
        }
        return out;
    };
    (function() {
        try {
            Object.defineProperty(WritableState.prototype, "buffer", {
                get: internalUtil.deprecate(function writableStateBufferGetter() {
                    return this.getBuffer();
                }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
            });
        } catch (_) {}
    })();
    var realHasInstance;
    if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
        realHasInstance = Function.prototype[Symbol.hasInstance];
        Object.defineProperty(Writable, Symbol.hasInstance, {
            value: function value(object) {
                if (realHasInstance.call(this, object)) return true;
                if (this !== Writable) return false;
                return object && object._writableState instanceof WritableState;
            }
        });
    } else realHasInstance = function realHasInstance2(object) {
        return object instanceof this;
    };
    function Writable(options2) {
        Duplex = Duplex || $94db4f2abf87558b$var$require_stream_duplex();
        var isDuplex = this instanceof Duplex;
        if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options2);
        this._writableState = new WritableState(options2, this, isDuplex);
        this.writable = true;
        if (options2) {
            if (typeof options2.write === "function") this._write = options2.write;
            if (typeof options2.writev === "function") this._writev = options2.writev;
            if (typeof options2.destroy === "function") this._destroy = options2.destroy;
            if (typeof options2.final === "function") this._final = options2.final;
        }
        Stream2.call(this);
    }
    Writable.prototype.pipe = function() {
        errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
    };
    function writeAfterEnd(stream, cb) {
        var er = new ERR_STREAM_WRITE_AFTER_END();
        errorOrDestroy(stream, er);
        $94db4f2abf87558b$var$process$1.nextTick(cb, er);
    }
    function validChunk(stream, state2, chunk, cb) {
        var er;
        if (chunk === null) er = new ERR_STREAM_NULL_VALUES();
        else if (typeof chunk !== "string" && !state2.objectMode) er = new ERR_INVALID_ARG_TYPE("chunk", [
            "string",
            "Buffer"
        ], chunk);
        if (er) {
            errorOrDestroy(stream, er);
            $94db4f2abf87558b$var$process$1.nextTick(cb, er);
            return false;
        }
        return true;
    }
    Writable.prototype.write = function(chunk, encoding, cb) {
        var state2 = this._writableState;
        var ret = false;
        var isBuf = !state2.objectMode && _isUint8Array(chunk);
        if (isBuf && !Buffer2.isBuffer(chunk)) chunk = _uint8ArrayToBuffer(chunk);
        if (typeof encoding === "function") {
            cb = encoding;
            encoding = null;
        }
        if (isBuf) encoding = "buffer";
        else if (!encoding) encoding = state2.defaultEncoding;
        if (typeof cb !== "function") cb = nop;
        if (state2.ending) writeAfterEnd(this, cb);
        else if (isBuf || validChunk(this, state2, chunk, cb)) {
            state2.pendingcb++;
            ret = writeOrBuffer(this, state2, isBuf, chunk, encoding, cb);
        }
        return ret;
    };
    Writable.prototype.cork = function() {
        this._writableState.corked++;
    };
    Writable.prototype.uncork = function() {
        var state2 = this._writableState;
        if (state2.corked) {
            state2.corked--;
            if (!state2.writing && !state2.corked && !state2.bufferProcessing && state2.bufferedRequest) clearBuffer(this, state2);
        }
    };
    Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
        if (typeof encoding === "string") encoding = encoding.toLowerCase();
        if (!([
            "hex",
            "utf8",
            "utf-8",
            "ascii",
            "binary",
            "base64",
            "ucs2",
            "ucs-2",
            "utf16le",
            "utf-16le",
            "raw"
        ].indexOf((encoding + "").toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
        this._writableState.defaultEncoding = encoding;
        return this;
    };
    Object.defineProperty(Writable.prototype, "writableBuffer", {
        // making it explicit this property is not enumerable
        // because otherwise some prototype manipulation in
        // userland will fail
        enumerable: false,
        get: function get() {
            return this._writableState && this._writableState.getBuffer();
        }
    });
    function decodeChunk(state2, chunk, encoding) {
        if (!state2.objectMode && state2.decodeStrings !== false && typeof chunk === "string") chunk = Buffer2.from(chunk, encoding);
        return chunk;
    }
    Object.defineProperty(Writable.prototype, "writableHighWaterMark", {
        // making it explicit this property is not enumerable
        // because otherwise some prototype manipulation in
        // userland will fail
        enumerable: false,
        get: function get() {
            return this._writableState.highWaterMark;
        }
    });
    function writeOrBuffer(stream, state2, isBuf, chunk, encoding, cb) {
        if (!isBuf) {
            var newChunk = decodeChunk(state2, chunk, encoding);
            if (chunk !== newChunk) {
                isBuf = true;
                encoding = "buffer";
                chunk = newChunk;
            }
        }
        var len = state2.objectMode ? 1 : chunk.length;
        state2.length += len;
        var ret = state2.length < state2.highWaterMark;
        if (!ret) state2.needDrain = true;
        if (state2.writing || state2.corked) {
            var last = state2.lastBufferedRequest;
            state2.lastBufferedRequest = {
                chunk: chunk,
                encoding: encoding,
                isBuf: isBuf,
                callback: cb,
                next: null
            };
            if (last) last.next = state2.lastBufferedRequest;
            else state2.bufferedRequest = state2.lastBufferedRequest;
            state2.bufferedRequestCount += 1;
        } else doWrite(stream, state2, false, len, chunk, encoding, cb);
        return ret;
    }
    function doWrite(stream, state2, writev, len, chunk, encoding, cb) {
        state2.writelen = len;
        state2.writecb = cb;
        state2.writing = true;
        state2.sync = true;
        if (state2.destroyed) state2.onwrite(new ERR_STREAM_DESTROYED("write"));
        else if (writev) stream._writev(chunk, state2.onwrite);
        else stream._write(chunk, encoding, state2.onwrite);
        state2.sync = false;
    }
    function onwriteError(stream, state2, sync, er, cb) {
        --state2.pendingcb;
        if (sync) {
            $94db4f2abf87558b$var$process$1.nextTick(cb, er);
            $94db4f2abf87558b$var$process$1.nextTick(finishMaybe, stream, state2);
            stream._writableState.errorEmitted = true;
            errorOrDestroy(stream, er);
        } else {
            cb(er);
            stream._writableState.errorEmitted = true;
            errorOrDestroy(stream, er);
            finishMaybe(stream, state2);
        }
    }
    function onwriteStateUpdate(state2) {
        state2.writing = false;
        state2.writecb = null;
        state2.length -= state2.writelen;
        state2.writelen = 0;
    }
    function onwrite(stream, er) {
        var state2 = stream._writableState;
        var sync = state2.sync;
        var cb = state2.writecb;
        if (typeof cb !== "function") throw new ERR_MULTIPLE_CALLBACK();
        onwriteStateUpdate(state2);
        if (er) onwriteError(stream, state2, sync, er, cb);
        else {
            var finished = needFinish(state2) || stream.destroyed;
            if (!finished && !state2.corked && !state2.bufferProcessing && state2.bufferedRequest) clearBuffer(stream, state2);
            if (sync) $94db4f2abf87558b$var$process$1.nextTick(afterWrite, stream, state2, finished, cb);
            else afterWrite(stream, state2, finished, cb);
        }
    }
    function afterWrite(stream, state2, finished, cb) {
        if (!finished) onwriteDrain(stream, state2);
        state2.pendingcb--;
        cb();
        finishMaybe(stream, state2);
    }
    function onwriteDrain(stream, state2) {
        if (state2.length === 0 && state2.needDrain) {
            state2.needDrain = false;
            stream.emit("drain");
        }
    }
    function clearBuffer(stream, state2) {
        state2.bufferProcessing = true;
        var entry = state2.bufferedRequest;
        if (stream._writev && entry && entry.next) {
            var l = state2.bufferedRequestCount;
            var buffer2 = new Array(l);
            var holder = state2.corkedRequestsFree;
            holder.entry = entry;
            var count = 0;
            var allBuffers = true;
            while(entry){
                buffer2[count] = entry;
                if (!entry.isBuf) allBuffers = false;
                entry = entry.next;
                count += 1;
            }
            buffer2.allBuffers = allBuffers;
            doWrite(stream, state2, true, state2.length, buffer2, "", holder.finish);
            state2.pendingcb++;
            state2.lastBufferedRequest = null;
            if (holder.next) {
                state2.corkedRequestsFree = holder.next;
                holder.next = null;
            } else state2.corkedRequestsFree = new CorkedRequest(state2);
            state2.bufferedRequestCount = 0;
        } else {
            while(entry){
                var chunk = entry.chunk;
                var encoding = entry.encoding;
                var cb = entry.callback;
                var len = state2.objectMode ? 1 : chunk.length;
                doWrite(stream, state2, false, len, chunk, encoding, cb);
                entry = entry.next;
                state2.bufferedRequestCount--;
                if (state2.writing) break;
            }
            if (entry === null) state2.lastBufferedRequest = null;
        }
        state2.bufferedRequest = entry;
        state2.bufferProcessing = false;
    }
    Writable.prototype._write = function(chunk, encoding, cb) {
        cb(new ERR_METHOD_NOT_IMPLEMENTED("_write()"));
    };
    Writable.prototype._writev = null;
    Writable.prototype.end = function(chunk, encoding, cb) {
        var state2 = this._writableState;
        if (typeof chunk === "function") {
            cb = chunk;
            chunk = null;
            encoding = null;
        } else if (typeof encoding === "function") {
            cb = encoding;
            encoding = null;
        }
        if (chunk !== null && chunk !== void 0) this.write(chunk, encoding);
        if (state2.corked) {
            state2.corked = 1;
            this.uncork();
        }
        if (!state2.ending) endWritable(this, state2, cb);
        return this;
    };
    Object.defineProperty(Writable.prototype, "writableLength", {
        // making it explicit this property is not enumerable
        // because otherwise some prototype manipulation in
        // userland will fail
        enumerable: false,
        get: function get() {
            return this._writableState.length;
        }
    });
    function needFinish(state2) {
        return state2.ending && state2.length === 0 && state2.bufferedRequest === null && !state2.finished && !state2.writing;
    }
    function callFinal(stream, state2) {
        stream._final(function(err) {
            state2.pendingcb--;
            if (err) errorOrDestroy(stream, err);
            state2.prefinished = true;
            stream.emit("prefinish");
            finishMaybe(stream, state2);
        });
    }
    function prefinish(stream, state2) {
        if (!state2.prefinished && !state2.finalCalled) {
            if (typeof stream._final === "function" && !state2.destroyed) {
                state2.pendingcb++;
                state2.finalCalled = true;
                $94db4f2abf87558b$var$process$1.nextTick(callFinal, stream, state2);
            } else {
                state2.prefinished = true;
                stream.emit("prefinish");
            }
        }
    }
    function finishMaybe(stream, state2) {
        var need = needFinish(state2);
        if (need) {
            prefinish(stream, state2);
            if (state2.pendingcb === 0) {
                state2.finished = true;
                stream.emit("finish");
                if (state2.autoDestroy) {
                    var rState = stream._readableState;
                    if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
                }
            }
        }
        return need;
    }
    function endWritable(stream, state2, cb) {
        state2.ending = true;
        finishMaybe(stream, state2);
        if (cb) {
            if (state2.finished) $94db4f2abf87558b$var$process$1.nextTick(cb);
            else stream.once("finish", cb);
        }
        state2.ended = true;
        stream.writable = false;
    }
    function onCorkedFinish(corkReq, state2, err) {
        var entry = corkReq.entry;
        corkReq.entry = null;
        while(entry){
            var cb = entry.callback;
            state2.pendingcb--;
            cb(err);
            entry = entry.next;
        }
        state2.corkedRequestsFree.next = corkReq;
    }
    Object.defineProperty(Writable.prototype, "destroyed", {
        // making it explicit this property is not enumerable
        // because otherwise some prototype manipulation in
        // userland will fail
        enumerable: false,
        get: function get() {
            if (this._writableState === void 0) return false;
            return this._writableState.destroyed;
        },
        set: function set(value) {
            if (!this._writableState) return;
            this._writableState.destroyed = value;
        }
    });
    Writable.prototype.destroy = destroyImpl.destroy;
    Writable.prototype._undestroy = destroyImpl.undestroy;
    Writable.prototype._destroy = function(err, cb) {
        cb(err);
    };
    return $94db4f2abf87558b$var$_stream_writable;
}
var $94db4f2abf87558b$var$_stream_duplex;
var $94db4f2abf87558b$var$hasRequired_stream_duplex;
function $94db4f2abf87558b$var$require_stream_duplex() {
    if ($94db4f2abf87558b$var$hasRequired_stream_duplex) return $94db4f2abf87558b$var$_stream_duplex;
    $94db4f2abf87558b$var$hasRequired_stream_duplex = 1;
    var objectKeys = Object.keys || function(obj) {
        var keys2 = [];
        for(var key in obj)keys2.push(key);
        return keys2;
    };
    $94db4f2abf87558b$var$_stream_duplex = Duplex;
    var Readable = $94db4f2abf87558b$var$require_stream_readable();
    var Writable = $94db4f2abf87558b$var$require_stream_writable();
    $94db4f2abf87558b$var$inherits_browserExports(Duplex, Readable);
    var keys = objectKeys(Writable.prototype);
    for(var v = 0; v < keys.length; v++){
        var method = keys[v];
        if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
    }
    function Duplex(options2) {
        if (!(this instanceof Duplex)) return new Duplex(options2);
        Readable.call(this, options2);
        Writable.call(this, options2);
        this.allowHalfOpen = true;
        if (options2) {
            if (options2.readable === false) this.readable = false;
            if (options2.writable === false) this.writable = false;
            if (options2.allowHalfOpen === false) {
                this.allowHalfOpen = false;
                this.once("end", onend);
            }
        }
    }
    Object.defineProperty(Duplex.prototype, "writableHighWaterMark", {
        // making it explicit this property is not enumerable
        // because otherwise some prototype manipulation in
        // userland will fail
        enumerable: false,
        get: function get() {
            return this._writableState.highWaterMark;
        }
    });
    Object.defineProperty(Duplex.prototype, "writableBuffer", {
        // making it explicit this property is not enumerable
        // because otherwise some prototype manipulation in
        // userland will fail
        enumerable: false,
        get: function get() {
            return this._writableState && this._writableState.getBuffer();
        }
    });
    Object.defineProperty(Duplex.prototype, "writableLength", {
        // making it explicit this property is not enumerable
        // because otherwise some prototype manipulation in
        // userland will fail
        enumerable: false,
        get: function get() {
            return this._writableState.length;
        }
    });
    function onend() {
        if (this._writableState.ended) return;
        $94db4f2abf87558b$var$process$1.nextTick(onEndNT, this);
    }
    function onEndNT(self2) {
        self2.end();
    }
    Object.defineProperty(Duplex.prototype, "destroyed", {
        // making it explicit this property is not enumerable
        // because otherwise some prototype manipulation in
        // userland will fail
        enumerable: false,
        get: function get() {
            if (this._readableState === void 0 || this._writableState === void 0) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function set(value) {
            if (this._readableState === void 0 || this._writableState === void 0) return;
            this._readableState.destroyed = value;
            this._writableState.destroyed = value;
        }
    });
    return $94db4f2abf87558b$var$_stream_duplex;
}
var $94db4f2abf87558b$var$string_decoder = {};
var $94db4f2abf87558b$var$safeBuffer = {
    exports: {}
};
var $94db4f2abf87558b$var$hasRequiredSafeBuffer;
function $94db4f2abf87558b$var$requireSafeBuffer() {
    if ($94db4f2abf87558b$var$hasRequiredSafeBuffer) return $94db4f2abf87558b$var$safeBuffer.exports;
    $94db4f2abf87558b$var$hasRequiredSafeBuffer = 1;
    (function(module, exports) {
        var buffer2 = $94db4f2abf87558b$var$requireBuffer();
        var Buffer2 = buffer2.Buffer;
        function copyProps(src, dst) {
            for(var key in src)dst[key] = src[key];
        }
        if (Buffer2.from && Buffer2.alloc && Buffer2.allocUnsafe && Buffer2.allocUnsafeSlow) module.exports = buffer2;
        else {
            copyProps(buffer2, exports);
            exports.Buffer = SafeBuffer;
        }
        function SafeBuffer(arg, encodingOrOffset, length) {
            return Buffer2(arg, encodingOrOffset, length);
        }
        copyProps(Buffer2, SafeBuffer);
        SafeBuffer.from = function(arg, encodingOrOffset, length) {
            if (typeof arg === "number") throw new TypeError("Argument must not be a number");
            return Buffer2(arg, encodingOrOffset, length);
        };
        SafeBuffer.alloc = function(size, fill, encoding) {
            if (typeof size !== "number") throw new TypeError("Argument must be a number");
            var buf = Buffer2(size);
            if (fill !== void 0) {
                if (typeof encoding === "string") buf.fill(fill, encoding);
                else buf.fill(fill);
            } else buf.fill(0);
            return buf;
        };
        SafeBuffer.allocUnsafe = function(size) {
            if (typeof size !== "number") throw new TypeError("Argument must be a number");
            return Buffer2(size);
        };
        SafeBuffer.allocUnsafeSlow = function(size) {
            if (typeof size !== "number") throw new TypeError("Argument must be a number");
            return buffer2.SlowBuffer(size);
        };
    })($94db4f2abf87558b$var$safeBuffer, $94db4f2abf87558b$var$safeBuffer.exports);
    return $94db4f2abf87558b$var$safeBuffer.exports;
}
var $94db4f2abf87558b$var$hasRequiredString_decoder;
function $94db4f2abf87558b$var$requireString_decoder() {
    if ($94db4f2abf87558b$var$hasRequiredString_decoder) return $94db4f2abf87558b$var$string_decoder;
    $94db4f2abf87558b$var$hasRequiredString_decoder = 1;
    var Buffer2 = $94db4f2abf87558b$var$requireSafeBuffer().Buffer;
    var isEncoding = Buffer2.isEncoding || function(encoding) {
        encoding = "" + encoding;
        switch(encoding && encoding.toLowerCase()){
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
            case "raw":
                return true;
            default:
                return false;
        }
    };
    function _normalizeEncoding(enc) {
        if (!enc) return "utf8";
        var retried;
        while(true)switch(enc){
            case "utf8":
            case "utf-8":
                return "utf8";
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return "utf16le";
            case "latin1":
            case "binary":
                return "latin1";
            case "base64":
            case "ascii":
            case "hex":
                return enc;
            default:
                if (retried) return;
                enc = ("" + enc).toLowerCase();
                retried = true;
        }
    }
    function normalizeEncoding(enc) {
        var nenc = _normalizeEncoding(enc);
        if (typeof nenc !== "string" && (Buffer2.isEncoding === isEncoding || !isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
        return nenc || enc;
    }
    $94db4f2abf87558b$var$string_decoder.StringDecoder = StringDecoder;
    function StringDecoder(encoding) {
        this.encoding = normalizeEncoding(encoding);
        var nb;
        switch(this.encoding){
            case "utf16le":
                this.text = utf16Text;
                this.end = utf16End;
                nb = 4;
                break;
            case "utf8":
                this.fillLast = utf8FillLast;
                nb = 4;
                break;
            case "base64":
                this.text = base64Text;
                this.end = base64End;
                nb = 3;
                break;
            default:
                this.write = simpleWrite;
                this.end = simpleEnd;
                return;
        }
        this.lastNeed = 0;
        this.lastTotal = 0;
        this.lastChar = Buffer2.allocUnsafe(nb);
    }
    StringDecoder.prototype.write = function(buf) {
        if (buf.length === 0) return "";
        var r;
        var i;
        if (this.lastNeed) {
            r = this.fillLast(buf);
            if (r === void 0) return "";
            i = this.lastNeed;
            this.lastNeed = 0;
        } else i = 0;
        if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
        return r || "";
    };
    StringDecoder.prototype.end = utf8End;
    StringDecoder.prototype.text = utf8Text;
    StringDecoder.prototype.fillLast = function(buf) {
        if (this.lastNeed <= buf.length) {
            buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
            return this.lastChar.toString(this.encoding, 0, this.lastTotal);
        }
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
        this.lastNeed -= buf.length;
    };
    function utf8CheckByte(byte) {
        if (byte <= 127) return 0;
        else if (byte >> 5 === 6) return 2;
        else if (byte >> 4 === 14) return 3;
        else if (byte >> 3 === 30) return 4;
        return byte >> 6 === 2 ? -1 : -2;
    }
    function utf8CheckIncomplete(self2, buf, i) {
        var j = buf.length - 1;
        if (j < i) return 0;
        var nb = utf8CheckByte(buf[j]);
        if (nb >= 0) {
            if (nb > 0) self2.lastNeed = nb - 1;
            return nb;
        }
        if (--j < i || nb === -2) return 0;
        nb = utf8CheckByte(buf[j]);
        if (nb >= 0) {
            if (nb > 0) self2.lastNeed = nb - 2;
            return nb;
        }
        if (--j < i || nb === -2) return 0;
        nb = utf8CheckByte(buf[j]);
        if (nb >= 0) {
            if (nb > 0) {
                if (nb === 2) nb = 0;
                else self2.lastNeed = nb - 3;
            }
            return nb;
        }
        return 0;
    }
    function utf8CheckExtraBytes(self2, buf, p) {
        if ((buf[0] & 192) !== 128) {
            self2.lastNeed = 0;
            return "\uFFFD";
        }
        if (self2.lastNeed > 1 && buf.length > 1) {
            if ((buf[1] & 192) !== 128) {
                self2.lastNeed = 1;
                return "\uFFFD";
            }
            if (self2.lastNeed > 2 && buf.length > 2) {
                if ((buf[2] & 192) !== 128) {
                    self2.lastNeed = 2;
                    return "\uFFFD";
                }
            }
        }
    }
    function utf8FillLast(buf) {
        var p = this.lastTotal - this.lastNeed;
        var r = utf8CheckExtraBytes(this, buf);
        if (r !== void 0) return r;
        if (this.lastNeed <= buf.length) {
            buf.copy(this.lastChar, p, 0, this.lastNeed);
            return this.lastChar.toString(this.encoding, 0, this.lastTotal);
        }
        buf.copy(this.lastChar, p, 0, buf.length);
        this.lastNeed -= buf.length;
    }
    function utf8Text(buf, i) {
        var total = utf8CheckIncomplete(this, buf, i);
        if (!this.lastNeed) return buf.toString("utf8", i);
        this.lastTotal = total;
        var end = buf.length - (total - this.lastNeed);
        buf.copy(this.lastChar, 0, end);
        return buf.toString("utf8", i, end);
    }
    function utf8End(buf) {
        var r = buf && buf.length ? this.write(buf) : "";
        if (this.lastNeed) return r + "\uFFFD";
        return r;
    }
    function utf16Text(buf, i) {
        if ((buf.length - i) % 2 === 0) {
            var r = buf.toString("utf16le", i);
            if (r) {
                var c = r.charCodeAt(r.length - 1);
                if (c >= 55296 && c <= 56319) {
                    this.lastNeed = 2;
                    this.lastTotal = 4;
                    this.lastChar[0] = buf[buf.length - 2];
                    this.lastChar[1] = buf[buf.length - 1];
                    return r.slice(0, -1);
                }
            }
            return r;
        }
        this.lastNeed = 1;
        this.lastTotal = 2;
        this.lastChar[0] = buf[buf.length - 1];
        return buf.toString("utf16le", i, buf.length - 1);
    }
    function utf16End(buf) {
        var r = buf && buf.length ? this.write(buf) : "";
        if (this.lastNeed) {
            var end = this.lastTotal - this.lastNeed;
            return r + this.lastChar.toString("utf16le", 0, end);
        }
        return r;
    }
    function base64Text(buf, i) {
        var n = (buf.length - i) % 3;
        if (n === 0) return buf.toString("base64", i);
        this.lastNeed = 3 - n;
        this.lastTotal = 3;
        if (n === 1) this.lastChar[0] = buf[buf.length - 1];
        else {
            this.lastChar[0] = buf[buf.length - 2];
            this.lastChar[1] = buf[buf.length - 1];
        }
        return buf.toString("base64", i, buf.length - n);
    }
    function base64End(buf) {
        var r = buf && buf.length ? this.write(buf) : "";
        if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
        return r;
    }
    function simpleWrite(buf) {
        return buf.toString(this.encoding);
    }
    function simpleEnd(buf) {
        return buf && buf.length ? this.write(buf) : "";
    }
    return $94db4f2abf87558b$var$string_decoder;
}
var $94db4f2abf87558b$var$endOfStream;
var $94db4f2abf87558b$var$hasRequiredEndOfStream;
function $94db4f2abf87558b$var$requireEndOfStream() {
    if ($94db4f2abf87558b$var$hasRequiredEndOfStream) return $94db4f2abf87558b$var$endOfStream;
    $94db4f2abf87558b$var$hasRequiredEndOfStream = 1;
    var ERR_STREAM_PREMATURE_CLOSE = $94db4f2abf87558b$var$requireErrorsBrowser().codes.ERR_STREAM_PREMATURE_CLOSE;
    function once3(callback) {
        var called = false;
        return function() {
            if (called) return;
            called = true;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            callback.apply(this, args);
        };
    }
    function noop2() {}
    function isRequest(stream) {
        return stream.setHeader && typeof stream.abort === "function";
    }
    function eos(stream, opts, callback) {
        if (typeof opts === "function") return eos(stream, null, opts);
        if (!opts) opts = {};
        callback = once3(callback || noop2);
        var readable = opts.readable || opts.readable !== false && stream.readable;
        var writable = opts.writable || opts.writable !== false && stream.writable;
        var onlegacyfinish = function onlegacyfinish2() {
            if (!stream.writable) onfinish();
        };
        var writableEnded = stream._writableState && stream._writableState.finished;
        var onfinish = function onfinish2() {
            writable = false;
            writableEnded = true;
            if (!readable) callback.call(stream);
        };
        var readableEnded = stream._readableState && stream._readableState.endEmitted;
        var onend = function onend2() {
            readable = false;
            readableEnded = true;
            if (!writable) callback.call(stream);
        };
        var onerror = function onerror2(err) {
            callback.call(stream, err);
        };
        var onclose = function onclose2() {
            var err;
            if (readable && !readableEnded) {
                if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
                return callback.call(stream, err);
            }
            if (writable && !writableEnded) {
                if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
                return callback.call(stream, err);
            }
        };
        var onrequest = function onrequest2() {
            stream.req.on("finish", onfinish);
        };
        if (isRequest(stream)) {
            stream.on("complete", onfinish);
            stream.on("abort", onclose);
            if (stream.req) onrequest();
            else stream.on("request", onrequest);
        } else if (writable && !stream._writableState) {
            stream.on("end", onlegacyfinish);
            stream.on("close", onlegacyfinish);
        }
        stream.on("end", onend);
        stream.on("finish", onfinish);
        if (opts.error !== false) stream.on("error", onerror);
        stream.on("close", onclose);
        return function() {
            stream.removeListener("complete", onfinish);
            stream.removeListener("abort", onclose);
            stream.removeListener("request", onrequest);
            if (stream.req) stream.req.removeListener("finish", onfinish);
            stream.removeListener("end", onlegacyfinish);
            stream.removeListener("close", onlegacyfinish);
            stream.removeListener("finish", onfinish);
            stream.removeListener("end", onend);
            stream.removeListener("error", onerror);
            stream.removeListener("close", onclose);
        };
    }
    $94db4f2abf87558b$var$endOfStream = eos;
    return $94db4f2abf87558b$var$endOfStream;
}
var $94db4f2abf87558b$var$async_iterator;
var $94db4f2abf87558b$var$hasRequiredAsync_iterator;
function $94db4f2abf87558b$var$requireAsync_iterator() {
    if ($94db4f2abf87558b$var$hasRequiredAsync_iterator) return $94db4f2abf87558b$var$async_iterator;
    $94db4f2abf87558b$var$hasRequiredAsync_iterator = 1;
    var _Object$setPrototypeO;
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    var finished = $94db4f2abf87558b$var$requireEndOfStream();
    var kLastResolve = Symbol("lastResolve");
    var kLastReject = Symbol("lastReject");
    var kError = Symbol("error");
    var kEnded = Symbol("ended");
    var kLastPromise = Symbol("lastPromise");
    var kHandlePromise = Symbol("handlePromise");
    var kStream = Symbol("stream");
    function createIterResult(value, done) {
        return {
            value: value,
            done: done
        };
    }
    function readAndResolve(iter) {
        var resolve2 = iter[kLastResolve];
        if (resolve2 !== null) {
            var data = iter[kStream].read();
            if (data !== null) {
                iter[kLastPromise] = null;
                iter[kLastResolve] = null;
                iter[kLastReject] = null;
                resolve2(createIterResult(data, false));
            }
        }
    }
    function onReadable(iter) {
        $94db4f2abf87558b$var$process$1.nextTick(readAndResolve, iter);
    }
    function wrapForNext(lastPromise, iter) {
        return function(resolve2, reject) {
            lastPromise.then(function() {
                if (iter[kEnded]) {
                    resolve2(createIterResult(void 0, true));
                    return;
                }
                iter[kHandlePromise](resolve2, reject);
            }, reject);
        };
    }
    var AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
    var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
        get stream () {
            return this[kStream];
        },
        next: function next() {
            var _this = this;
            var error = this[kError];
            if (error !== null) return Promise.reject(error);
            if (this[kEnded]) return Promise.resolve(createIterResult(void 0, true));
            if (this[kStream].destroyed) return new Promise(function(resolve2, reject) {
                $94db4f2abf87558b$var$process$1.nextTick(function() {
                    if (_this[kError]) reject(_this[kError]);
                    else resolve2(createIterResult(void 0, true));
                });
            });
            var lastPromise = this[kLastPromise];
            var promise;
            if (lastPromise) promise = new Promise(wrapForNext(lastPromise, this));
            else {
                var data = this[kStream].read();
                if (data !== null) return Promise.resolve(createIterResult(data, false));
                promise = new Promise(this[kHandlePromise]);
            }
            this[kLastPromise] = promise;
            return promise;
        }
    }, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function() {
        return this;
    }), _defineProperty(_Object$setPrototypeO, "return", function _return() {
        var _this2 = this;
        return new Promise(function(resolve2, reject) {
            _this2[kStream].destroy(null, function(err) {
                if (err) {
                    reject(err);
                    return;
                }
                resolve2(createIterResult(void 0, true));
            });
        });
    }), _Object$setPrototypeO), AsyncIteratorPrototype);
    var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator2(stream) {
        var _Object$create;
        var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
            value: stream,
            writable: true
        }), _defineProperty(_Object$create, kLastResolve, {
            value: null,
            writable: true
        }), _defineProperty(_Object$create, kLastReject, {
            value: null,
            writable: true
        }), _defineProperty(_Object$create, kError, {
            value: null,
            writable: true
        }), _defineProperty(_Object$create, kEnded, {
            value: stream._readableState.endEmitted,
            writable: true
        }), _defineProperty(_Object$create, kHandlePromise, {
            value: function value(resolve2, reject) {
                var data = iterator[kStream].read();
                if (data) {
                    iterator[kLastPromise] = null;
                    iterator[kLastResolve] = null;
                    iterator[kLastReject] = null;
                    resolve2(createIterResult(data, false));
                } else {
                    iterator[kLastResolve] = resolve2;
                    iterator[kLastReject] = reject;
                }
            },
            writable: true
        }), _Object$create));
        iterator[kLastPromise] = null;
        finished(stream, function(err) {
            if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
                var reject = iterator[kLastReject];
                if (reject !== null) {
                    iterator[kLastPromise] = null;
                    iterator[kLastResolve] = null;
                    iterator[kLastReject] = null;
                    reject(err);
                }
                iterator[kError] = err;
                return;
            }
            var resolve2 = iterator[kLastResolve];
            if (resolve2 !== null) {
                iterator[kLastPromise] = null;
                iterator[kLastResolve] = null;
                iterator[kLastReject] = null;
                resolve2(createIterResult(void 0, true));
            }
            iterator[kEnded] = true;
        });
        stream.on("readable", onReadable.bind(null, iterator));
        return iterator;
    };
    $94db4f2abf87558b$var$async_iterator = createReadableStreamAsyncIterator;
    return $94db4f2abf87558b$var$async_iterator;
}
var $94db4f2abf87558b$var$fromBrowser;
var $94db4f2abf87558b$var$hasRequiredFromBrowser;
function $94db4f2abf87558b$var$requireFromBrowser() {
    if ($94db4f2abf87558b$var$hasRequiredFromBrowser) return $94db4f2abf87558b$var$fromBrowser;
    $94db4f2abf87558b$var$hasRequiredFromBrowser = 1;
    $94db4f2abf87558b$var$fromBrowser = function fromBrowser() {
        throw new Error("Readable.from is not available in the browser");
    };
    return $94db4f2abf87558b$var$fromBrowser;
}
var $94db4f2abf87558b$var$_stream_readable;
var $94db4f2abf87558b$var$hasRequired_stream_readable;
function $94db4f2abf87558b$var$require_stream_readable() {
    if ($94db4f2abf87558b$var$hasRequired_stream_readable) return $94db4f2abf87558b$var$_stream_readable;
    $94db4f2abf87558b$var$hasRequired_stream_readable = 1;
    $94db4f2abf87558b$var$_stream_readable = Readable;
    var Duplex;
    Readable.ReadableState = ReadableState;
    $94db4f2abf87558b$var$eventsExports.EventEmitter;
    var EElistenerCount = function EElistenerCount2(emitter, type) {
        return emitter.listeners(type).length;
    };
    var Stream2 = $94db4f2abf87558b$var$requireStreamBrowser();
    var Buffer2 = $94db4f2abf87558b$var$requireBuffer().Buffer;
    var OurUint8Array = $94db4f2abf87558b$var$commonjsGlobal.Uint8Array || function() {};
    function _uint8ArrayToBuffer(chunk) {
        return Buffer2.from(chunk);
    }
    function _isUint8Array(obj) {
        return Buffer2.isBuffer(obj) || obj instanceof OurUint8Array;
    }
    var debugUtil = $94db4f2abf87558b$var$requireUtil();
    var debug;
    if (debugUtil && debugUtil.debuglog) debug = debugUtil.debuglog("stream");
    else debug = function debug2() {};
    var BufferList = $94db4f2abf87558b$var$requireBuffer_list();
    var destroyImpl = $94db4f2abf87558b$var$requireDestroy();
    var _require = $94db4f2abf87558b$var$requireState(), getHighWaterMark = _require.getHighWaterMark;
    var _require$codes = $94db4f2abf87558b$var$requireErrorsBrowser().codes, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
    var StringDecoder;
    var createReadableStreamAsyncIterator;
    var from;
    $94db4f2abf87558b$var$inherits_browserExports(Readable, Stream2);
    var errorOrDestroy = destroyImpl.errorOrDestroy;
    var kProxyEvents = [
        "error",
        "close",
        "destroy",
        "pause",
        "resume"
    ];
    function prependListener2(emitter, event, fn) {
        if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
        if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
        else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
        else emitter._events[event] = [
            fn,
            emitter._events[event]
        ];
    }
    function ReadableState(options2, stream, isDuplex) {
        Duplex = Duplex || $94db4f2abf87558b$var$require_stream_duplex();
        options2 = options2 || {};
        if (typeof isDuplex !== "boolean") isDuplex = stream instanceof Duplex;
        this.objectMode = !!options2.objectMode;
        if (isDuplex) this.objectMode = this.objectMode || !!options2.readableObjectMode;
        this.highWaterMark = getHighWaterMark(this, options2, "readableHighWaterMark", isDuplex);
        this.buffer = new BufferList();
        this.length = 0;
        this.pipes = null;
        this.pipesCount = 0;
        this.flowing = null;
        this.ended = false;
        this.endEmitted = false;
        this.reading = false;
        this.sync = true;
        this.needReadable = false;
        this.emittedReadable = false;
        this.readableListening = false;
        this.resumeScheduled = false;
        this.paused = true;
        this.emitClose = options2.emitClose !== false;
        this.autoDestroy = !!options2.autoDestroy;
        this.destroyed = false;
        this.defaultEncoding = options2.defaultEncoding || "utf8";
        this.awaitDrain = 0;
        this.readingMore = false;
        this.decoder = null;
        this.encoding = null;
        if (options2.encoding) {
            if (!StringDecoder) StringDecoder = $94db4f2abf87558b$var$requireString_decoder().StringDecoder;
            this.decoder = new StringDecoder(options2.encoding);
            this.encoding = options2.encoding;
        }
    }
    function Readable(options2) {
        Duplex = Duplex || $94db4f2abf87558b$var$require_stream_duplex();
        if (!(this instanceof Readable)) return new Readable(options2);
        var isDuplex = this instanceof Duplex;
        this._readableState = new ReadableState(options2, this, isDuplex);
        this.readable = true;
        if (options2) {
            if (typeof options2.read === "function") this._read = options2.read;
            if (typeof options2.destroy === "function") this._destroy = options2.destroy;
        }
        Stream2.call(this);
    }
    Object.defineProperty(Readable.prototype, "destroyed", {
        // making it explicit this property is not enumerable
        // because otherwise some prototype manipulation in
        // userland will fail
        enumerable: false,
        get: function get() {
            if (this._readableState === void 0) return false;
            return this._readableState.destroyed;
        },
        set: function set(value) {
            if (!this._readableState) return;
            this._readableState.destroyed = value;
        }
    });
    Readable.prototype.destroy = destroyImpl.destroy;
    Readable.prototype._undestroy = destroyImpl.undestroy;
    Readable.prototype._destroy = function(err, cb) {
        cb(err);
    };
    Readable.prototype.push = function(chunk, encoding) {
        var state2 = this._readableState;
        var skipChunkCheck;
        if (!state2.objectMode) {
            if (typeof chunk === "string") {
                encoding = encoding || state2.defaultEncoding;
                if (encoding !== state2.encoding) {
                    chunk = Buffer2.from(chunk, encoding);
                    encoding = "";
                }
                skipChunkCheck = true;
            }
        } else skipChunkCheck = true;
        return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
    };
    Readable.prototype.unshift = function(chunk) {
        return readableAddChunk(this, chunk, null, true, false);
    };
    function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
        debug("readableAddChunk", chunk);
        var state2 = stream._readableState;
        if (chunk === null) {
            state2.reading = false;
            onEofChunk(stream, state2);
        } else {
            var er;
            if (!skipChunkCheck) er = chunkInvalid(state2, chunk);
            if (er) errorOrDestroy(stream, er);
            else if (state2.objectMode || chunk && chunk.length > 0) {
                if (typeof chunk !== "string" && !state2.objectMode && Object.getPrototypeOf(chunk) !== Buffer2.prototype) chunk = _uint8ArrayToBuffer(chunk);
                if (addToFront) {
                    if (state2.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                    else addChunk(stream, state2, chunk, true);
                } else if (state2.ended) errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
                else if (state2.destroyed) return false;
                else {
                    state2.reading = false;
                    if (state2.decoder && !encoding) {
                        chunk = state2.decoder.write(chunk);
                        if (state2.objectMode || chunk.length !== 0) addChunk(stream, state2, chunk, false);
                        else maybeReadMore(stream, state2);
                    } else addChunk(stream, state2, chunk, false);
                }
            } else if (!addToFront) {
                state2.reading = false;
                maybeReadMore(stream, state2);
            }
        }
        return !state2.ended && (state2.length < state2.highWaterMark || state2.length === 0);
    }
    function addChunk(stream, state2, chunk, addToFront) {
        if (state2.flowing && state2.length === 0 && !state2.sync) {
            state2.awaitDrain = 0;
            stream.emit("data", chunk);
        } else {
            state2.length += state2.objectMode ? 1 : chunk.length;
            if (addToFront) state2.buffer.unshift(chunk);
            else state2.buffer.push(chunk);
            if (state2.needReadable) emitReadable(stream);
        }
        maybeReadMore(stream, state2);
    }
    function chunkInvalid(state2, chunk) {
        var er;
        if (!_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== void 0 && !state2.objectMode) er = new ERR_INVALID_ARG_TYPE("chunk", [
            "string",
            "Buffer",
            "Uint8Array"
        ], chunk);
        return er;
    }
    Readable.prototype.isPaused = function() {
        return this._readableState.flowing === false;
    };
    Readable.prototype.setEncoding = function(enc) {
        if (!StringDecoder) StringDecoder = $94db4f2abf87558b$var$requireString_decoder().StringDecoder;
        var decoder = new StringDecoder(enc);
        this._readableState.decoder = decoder;
        this._readableState.encoding = this._readableState.decoder.encoding;
        var p = this._readableState.buffer.head;
        var content = "";
        while(p !== null){
            content += decoder.write(p.data);
            p = p.next;
        }
        this._readableState.buffer.clear();
        if (content !== "") this._readableState.buffer.push(content);
        this._readableState.length = content.length;
        return this;
    };
    var MAX_HWM = 1073741824;
    function computeNewHighWaterMark(n) {
        if (n >= MAX_HWM) n = MAX_HWM;
        else {
            n--;
            n |= n >>> 1;
            n |= n >>> 2;
            n |= n >>> 4;
            n |= n >>> 8;
            n |= n >>> 16;
            n++;
        }
        return n;
    }
    function howMuchToRead(n, state2) {
        if (n <= 0 || state2.length === 0 && state2.ended) return 0;
        if (state2.objectMode) return 1;
        if (n !== n) {
            if (state2.flowing && state2.length) return state2.buffer.head.data.length;
            else return state2.length;
        }
        if (n > state2.highWaterMark) state2.highWaterMark = computeNewHighWaterMark(n);
        if (n <= state2.length) return n;
        if (!state2.ended) {
            state2.needReadable = true;
            return 0;
        }
        return state2.length;
    }
    Readable.prototype.read = function(n) {
        debug("read", n);
        n = parseInt(n, 10);
        var state2 = this._readableState;
        var nOrig = n;
        if (n !== 0) state2.emittedReadable = false;
        if (n === 0 && state2.needReadable && ((state2.highWaterMark !== 0 ? state2.length >= state2.highWaterMark : state2.length > 0) || state2.ended)) {
            debug("read: emitReadable", state2.length, state2.ended);
            if (state2.length === 0 && state2.ended) endReadable(this);
            else emitReadable(this);
            return null;
        }
        n = howMuchToRead(n, state2);
        if (n === 0 && state2.ended) {
            if (state2.length === 0) endReadable(this);
            return null;
        }
        var doRead = state2.needReadable;
        debug("need readable", doRead);
        if (state2.length === 0 || state2.length - n < state2.highWaterMark) {
            doRead = true;
            debug("length less than watermark", doRead);
        }
        if (state2.ended || state2.reading) {
            doRead = false;
            debug("reading or ended", doRead);
        } else if (doRead) {
            debug("do read");
            state2.reading = true;
            state2.sync = true;
            if (state2.length === 0) state2.needReadable = true;
            this._read(state2.highWaterMark);
            state2.sync = false;
            if (!state2.reading) n = howMuchToRead(nOrig, state2);
        }
        var ret;
        if (n > 0) ret = fromList(n, state2);
        else ret = null;
        if (ret === null) {
            state2.needReadable = state2.length <= state2.highWaterMark;
            n = 0;
        } else {
            state2.length -= n;
            state2.awaitDrain = 0;
        }
        if (state2.length === 0) {
            if (!state2.ended) state2.needReadable = true;
            if (nOrig !== n && state2.ended) endReadable(this);
        }
        if (ret !== null) this.emit("data", ret);
        return ret;
    };
    function onEofChunk(stream, state2) {
        debug("onEofChunk");
        if (state2.ended) return;
        if (state2.decoder) {
            var chunk = state2.decoder.end();
            if (chunk && chunk.length) {
                state2.buffer.push(chunk);
                state2.length += state2.objectMode ? 1 : chunk.length;
            }
        }
        state2.ended = true;
        if (state2.sync) emitReadable(stream);
        else {
            state2.needReadable = false;
            if (!state2.emittedReadable) {
                state2.emittedReadable = true;
                emitReadable_(stream);
            }
        }
    }
    function emitReadable(stream) {
        var state2 = stream._readableState;
        debug("emitReadable", state2.needReadable, state2.emittedReadable);
        state2.needReadable = false;
        if (!state2.emittedReadable) {
            debug("emitReadable", state2.flowing);
            state2.emittedReadable = true;
            $94db4f2abf87558b$var$process$1.nextTick(emitReadable_, stream);
        }
    }
    function emitReadable_(stream) {
        var state2 = stream._readableState;
        debug("emitReadable_", state2.destroyed, state2.length, state2.ended);
        if (!state2.destroyed && (state2.length || state2.ended)) {
            stream.emit("readable");
            state2.emittedReadable = false;
        }
        state2.needReadable = !state2.flowing && !state2.ended && state2.length <= state2.highWaterMark;
        flow(stream);
    }
    function maybeReadMore(stream, state2) {
        if (!state2.readingMore) {
            state2.readingMore = true;
            $94db4f2abf87558b$var$process$1.nextTick(maybeReadMore_, stream, state2);
        }
    }
    function maybeReadMore_(stream, state2) {
        while(!state2.reading && !state2.ended && (state2.length < state2.highWaterMark || state2.flowing && state2.length === 0)){
            var len = state2.length;
            debug("maybeReadMore read 0");
            stream.read(0);
            if (len === state2.length) break;
        }
        state2.readingMore = false;
    }
    Readable.prototype._read = function(n) {
        errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED("_read()"));
    };
    Readable.prototype.pipe = function(dest, pipeOpts) {
        var src = this;
        var state2 = this._readableState;
        switch(state2.pipesCount){
            case 0:
                state2.pipes = dest;
                break;
            case 1:
                state2.pipes = [
                    state2.pipes,
                    dest
                ];
                break;
            default:
                state2.pipes.push(dest);
                break;
        }
        state2.pipesCount += 1;
        debug("pipe count=%d opts=%j", state2.pipesCount, pipeOpts);
        var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $94db4f2abf87558b$var$process$1.stdout && dest !== $94db4f2abf87558b$var$process$1.stderr;
        var endFn = doEnd ? onend : unpipe;
        if (state2.endEmitted) $94db4f2abf87558b$var$process$1.nextTick(endFn);
        else src.once("end", endFn);
        dest.on("unpipe", onunpipe);
        function onunpipe(readable, unpipeInfo) {
            debug("onunpipe");
            if (readable === src) {
                if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                    unpipeInfo.hasUnpiped = true;
                    cleanup();
                }
            }
        }
        function onend() {
            debug("onend");
            dest.end();
        }
        var ondrain = pipeOnDrain(src);
        dest.on("drain", ondrain);
        var cleanedUp = false;
        function cleanup() {
            debug("cleanup");
            dest.removeListener("close", onclose);
            dest.removeListener("finish", onfinish);
            dest.removeListener("drain", ondrain);
            dest.removeListener("error", onerror);
            dest.removeListener("unpipe", onunpipe);
            src.removeListener("end", onend);
            src.removeListener("end", unpipe);
            src.removeListener("data", ondata);
            cleanedUp = true;
            if (state2.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
        }
        src.on("data", ondata);
        function ondata(chunk) {
            debug("ondata");
            var ret = dest.write(chunk);
            debug("dest.write", ret);
            if (ret === false) {
                if ((state2.pipesCount === 1 && state2.pipes === dest || state2.pipesCount > 1 && indexOf(state2.pipes, dest) !== -1) && !cleanedUp) {
                    debug("false write response, pause", state2.awaitDrain);
                    state2.awaitDrain++;
                }
                src.pause();
            }
        }
        function onerror(er) {
            debug("onerror", er);
            unpipe();
            dest.removeListener("error", onerror);
            if (EElistenerCount(dest, "error") === 0) errorOrDestroy(dest, er);
        }
        prependListener2(dest, "error", onerror);
        function onclose() {
            dest.removeListener("finish", onfinish);
            unpipe();
        }
        dest.once("close", onclose);
        function onfinish() {
            debug("onfinish");
            dest.removeListener("close", onclose);
            unpipe();
        }
        dest.once("finish", onfinish);
        function unpipe() {
            debug("unpipe");
            src.unpipe(dest);
        }
        dest.emit("pipe", src);
        if (!state2.flowing) {
            debug("pipe resume");
            src.resume();
        }
        return dest;
    };
    function pipeOnDrain(src) {
        return function pipeOnDrainFunctionResult() {
            var state2 = src._readableState;
            debug("pipeOnDrain", state2.awaitDrain);
            if (state2.awaitDrain) state2.awaitDrain--;
            if (state2.awaitDrain === 0 && EElistenerCount(src, "data")) {
                state2.flowing = true;
                flow(src);
            }
        };
    }
    Readable.prototype.unpipe = function(dest) {
        var state2 = this._readableState;
        var unpipeInfo = {
            hasUnpiped: false
        };
        if (state2.pipesCount === 0) return this;
        if (state2.pipesCount === 1) {
            if (dest && dest !== state2.pipes) return this;
            if (!dest) dest = state2.pipes;
            state2.pipes = null;
            state2.pipesCount = 0;
            state2.flowing = false;
            if (dest) dest.emit("unpipe", this, unpipeInfo);
            return this;
        }
        if (!dest) {
            var dests = state2.pipes;
            var len = state2.pipesCount;
            state2.pipes = null;
            state2.pipesCount = 0;
            state2.flowing = false;
            for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
                hasUnpiped: false
            });
            return this;
        }
        var index = indexOf(state2.pipes, dest);
        if (index === -1) return this;
        state2.pipes.splice(index, 1);
        state2.pipesCount -= 1;
        if (state2.pipesCount === 1) state2.pipes = state2.pipes[0];
        dest.emit("unpipe", this, unpipeInfo);
        return this;
    };
    Readable.prototype.on = function(ev, fn) {
        var res = Stream2.prototype.on.call(this, ev, fn);
        var state2 = this._readableState;
        if (ev === "data") {
            state2.readableListening = this.listenerCount("readable") > 0;
            if (state2.flowing !== false) this.resume();
        } else if (ev === "readable") {
            if (!state2.endEmitted && !state2.readableListening) {
                state2.readableListening = state2.needReadable = true;
                state2.flowing = false;
                state2.emittedReadable = false;
                debug("on readable", state2.length, state2.reading);
                if (state2.length) emitReadable(this);
                else if (!state2.reading) $94db4f2abf87558b$var$process$1.nextTick(nReadingNextTick, this);
            }
        }
        return res;
    };
    Readable.prototype.addListener = Readable.prototype.on;
    Readable.prototype.removeListener = function(ev, fn) {
        var res = Stream2.prototype.removeListener.call(this, ev, fn);
        if (ev === "readable") $94db4f2abf87558b$var$process$1.nextTick(updateReadableListening, this);
        return res;
    };
    Readable.prototype.removeAllListeners = function(ev) {
        var res = Stream2.prototype.removeAllListeners.apply(this, arguments);
        if (ev === "readable" || ev === void 0) $94db4f2abf87558b$var$process$1.nextTick(updateReadableListening, this);
        return res;
    };
    function updateReadableListening(self2) {
        var state2 = self2._readableState;
        state2.readableListening = self2.listenerCount("readable") > 0;
        if (state2.resumeScheduled && !state2.paused) state2.flowing = true;
        else if (self2.listenerCount("data") > 0) self2.resume();
    }
    function nReadingNextTick(self2) {
        debug("readable nexttick read 0");
        self2.read(0);
    }
    Readable.prototype.resume = function() {
        var state2 = this._readableState;
        if (!state2.flowing) {
            debug("resume");
            state2.flowing = !state2.readableListening;
            resume(this, state2);
        }
        state2.paused = false;
        return this;
    };
    function resume(stream, state2) {
        if (!state2.resumeScheduled) {
            state2.resumeScheduled = true;
            $94db4f2abf87558b$var$process$1.nextTick(resume_, stream, state2);
        }
    }
    function resume_(stream, state2) {
        debug("resume", state2.reading);
        if (!state2.reading) stream.read(0);
        state2.resumeScheduled = false;
        stream.emit("resume");
        flow(stream);
        if (state2.flowing && !state2.reading) stream.read(0);
    }
    Readable.prototype.pause = function() {
        debug("call pause flowing=%j", this._readableState.flowing);
        if (this._readableState.flowing !== false) {
            debug("pause");
            this._readableState.flowing = false;
            this.emit("pause");
        }
        this._readableState.paused = true;
        return this;
    };
    function flow(stream) {
        var state2 = stream._readableState;
        debug("flow", state2.flowing);
        while(state2.flowing && stream.read() !== null);
    }
    Readable.prototype.wrap = function(stream) {
        var _this = this;
        var state2 = this._readableState;
        var paused = false;
        stream.on("end", function() {
            debug("wrapped end");
            if (state2.decoder && !state2.ended) {
                var chunk = state2.decoder.end();
                if (chunk && chunk.length) _this.push(chunk);
            }
            _this.push(null);
        });
        stream.on("data", function(chunk) {
            debug("wrapped data");
            if (state2.decoder) chunk = state2.decoder.write(chunk);
            if (state2.objectMode && (chunk === null || chunk === void 0)) return;
            else if (!state2.objectMode && (!chunk || !chunk.length)) return;
            var ret = _this.push(chunk);
            if (!ret) {
                paused = true;
                stream.pause();
            }
        });
        for(var i in stream)if (this[i] === void 0 && typeof stream[i] === "function") this[i] = /* @__PURE__ */ function methodWrap(method) {
            return function methodWrapReturnFunction() {
                return stream[method].apply(stream, arguments);
            };
        }(i);
        for(var n = 0; n < kProxyEvents.length; n++)stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
        this._read = function(n2) {
            debug("wrapped _read", n2);
            if (paused) {
                paused = false;
                stream.resume();
            }
        };
        return this;
    };
    if (typeof Symbol === "function") Readable.prototype[Symbol.asyncIterator] = function() {
        if (createReadableStreamAsyncIterator === void 0) createReadableStreamAsyncIterator = $94db4f2abf87558b$var$requireAsync_iterator();
        return createReadableStreamAsyncIterator(this);
    };
    Object.defineProperty(Readable.prototype, "readableHighWaterMark", {
        // making it explicit this property is not enumerable
        // because otherwise some prototype manipulation in
        // userland will fail
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    });
    Object.defineProperty(Readable.prototype, "readableBuffer", {
        // making it explicit this property is not enumerable
        // because otherwise some prototype manipulation in
        // userland will fail
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    });
    Object.defineProperty(Readable.prototype, "readableFlowing", {
        // making it explicit this property is not enumerable
        // because otherwise some prototype manipulation in
        // userland will fail
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state2) {
            if (this._readableState) this._readableState.flowing = state2;
        }
    });
    Readable._fromList = fromList;
    Object.defineProperty(Readable.prototype, "readableLength", {
        // making it explicit this property is not enumerable
        // because otherwise some prototype manipulation in
        // userland will fail
        enumerable: false,
        get: function get() {
            return this._readableState.length;
        }
    });
    function fromList(n, state2) {
        if (state2.length === 0) return null;
        var ret;
        if (state2.objectMode) ret = state2.buffer.shift();
        else if (!n || n >= state2.length) {
            if (state2.decoder) ret = state2.buffer.join("");
            else if (state2.buffer.length === 1) ret = state2.buffer.first();
            else ret = state2.buffer.concat(state2.length);
            state2.buffer.clear();
        } else ret = state2.buffer.consume(n, state2.decoder);
        return ret;
    }
    function endReadable(stream) {
        var state2 = stream._readableState;
        debug("endReadable", state2.endEmitted);
        if (!state2.endEmitted) {
            state2.ended = true;
            $94db4f2abf87558b$var$process$1.nextTick(endReadableNT, state2, stream);
        }
    }
    function endReadableNT(state2, stream) {
        debug("endReadableNT", state2.endEmitted, state2.length);
        if (!state2.endEmitted && state2.length === 0) {
            state2.endEmitted = true;
            stream.readable = false;
            stream.emit("end");
            if (state2.autoDestroy) {
                var wState = stream._writableState;
                if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
            }
        }
    }
    if (typeof Symbol === "function") Readable.from = function(iterable, opts) {
        if (from === void 0) from = $94db4f2abf87558b$var$requireFromBrowser();
        return from(Readable, iterable, opts);
    };
    function indexOf(xs, x) {
        for(var i = 0, l = xs.length; i < l; i++){
            if (xs[i] === x) return i;
        }
        return -1;
    }
    return $94db4f2abf87558b$var$_stream_readable;
}
var $94db4f2abf87558b$var$_stream_transform;
var $94db4f2abf87558b$var$hasRequired_stream_transform;
function $94db4f2abf87558b$var$require_stream_transform() {
    if ($94db4f2abf87558b$var$hasRequired_stream_transform) return $94db4f2abf87558b$var$_stream_transform;
    $94db4f2abf87558b$var$hasRequired_stream_transform = 1;
    $94db4f2abf87558b$var$_stream_transform = Transform;
    var _require$codes = $94db4f2abf87558b$var$requireErrorsBrowser().codes, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
    var Duplex = $94db4f2abf87558b$var$require_stream_duplex();
    $94db4f2abf87558b$var$inherits_browserExports(Transform, Duplex);
    function afterTransform(er, data) {
        var ts = this._transformState;
        ts.transforming = false;
        var cb = ts.writecb;
        if (cb === null) return this.emit("error", new ERR_MULTIPLE_CALLBACK());
        ts.writechunk = null;
        ts.writecb = null;
        if (data != null) this.push(data);
        cb(er);
        var rs = this._readableState;
        rs.reading = false;
        if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
    function Transform(options2) {
        if (!(this instanceof Transform)) return new Transform(options2);
        Duplex.call(this, options2);
        this._transformState = {
            afterTransform: afterTransform.bind(this),
            needTransform: false,
            transforming: false,
            writecb: null,
            writechunk: null,
            writeencoding: null
        };
        this._readableState.needReadable = true;
        this._readableState.sync = false;
        if (options2) {
            if (typeof options2.transform === "function") this._transform = options2.transform;
            if (typeof options2.flush === "function") this._flush = options2.flush;
        }
        this.on("prefinish", prefinish);
    }
    function prefinish() {
        var _this = this;
        if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
            done(_this, er, data);
        });
        else done(this, null, null);
    }
    Transform.prototype.push = function(chunk, encoding) {
        this._transformState.needTransform = false;
        return Duplex.prototype.push.call(this, chunk, encoding);
    };
    Transform.prototype._transform = function(chunk, encoding, cb) {
        cb(new ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
    };
    Transform.prototype._write = function(chunk, encoding, cb) {
        var ts = this._transformState;
        ts.writecb = cb;
        ts.writechunk = chunk;
        ts.writeencoding = encoding;
        if (!ts.transforming) {
            var rs = this._readableState;
            if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
        }
    };
    Transform.prototype._read = function(n) {
        var ts = this._transformState;
        if (ts.writechunk !== null && !ts.transforming) {
            ts.transforming = true;
            this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
        } else ts.needTransform = true;
    };
    Transform.prototype._destroy = function(err, cb) {
        Duplex.prototype._destroy.call(this, err, function(err2) {
            cb(err2);
        });
    };
    function done(stream, er, data) {
        if (er) return stream.emit("error", er);
        if (data != null) stream.push(data);
        if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
        if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
        return stream.push(null);
    }
    return $94db4f2abf87558b$var$_stream_transform;
}
var $94db4f2abf87558b$var$_stream_passthrough;
var $94db4f2abf87558b$var$hasRequired_stream_passthrough;
function $94db4f2abf87558b$var$require_stream_passthrough() {
    if ($94db4f2abf87558b$var$hasRequired_stream_passthrough) return $94db4f2abf87558b$var$_stream_passthrough;
    $94db4f2abf87558b$var$hasRequired_stream_passthrough = 1;
    $94db4f2abf87558b$var$_stream_passthrough = PassThrough;
    var Transform = $94db4f2abf87558b$var$require_stream_transform();
    $94db4f2abf87558b$var$inherits_browserExports(PassThrough, Transform);
    function PassThrough(options2) {
        if (!(this instanceof PassThrough)) return new PassThrough(options2);
        Transform.call(this, options2);
    }
    PassThrough.prototype._transform = function(chunk, encoding, cb) {
        cb(null, chunk);
    };
    return $94db4f2abf87558b$var$_stream_passthrough;
}
var $94db4f2abf87558b$var$pipeline_1;
var $94db4f2abf87558b$var$hasRequiredPipeline;
function $94db4f2abf87558b$var$requirePipeline() {
    if ($94db4f2abf87558b$var$hasRequiredPipeline) return $94db4f2abf87558b$var$pipeline_1;
    $94db4f2abf87558b$var$hasRequiredPipeline = 1;
    var eos;
    function once3(callback) {
        var called = false;
        return function() {
            if (called) return;
            called = true;
            callback.apply(void 0, arguments);
        };
    }
    var _require$codes = $94db4f2abf87558b$var$requireErrorsBrowser().codes, ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
    function noop2(err) {
        if (err) throw err;
    }
    function isRequest(stream) {
        return stream.setHeader && typeof stream.abort === "function";
    }
    function destroyer(stream, reading, writing, callback) {
        callback = once3(callback);
        var closed = false;
        stream.on("close", function() {
            closed = true;
        });
        if (eos === void 0) eos = $94db4f2abf87558b$var$requireEndOfStream();
        eos(stream, {
            readable: reading,
            writable: writing
        }, function(err) {
            if (err) return callback(err);
            closed = true;
            callback();
        });
        var destroyed = false;
        return function(err) {
            if (closed) return;
            if (destroyed) return;
            destroyed = true;
            if (isRequest(stream)) return stream.abort();
            if (typeof stream.destroy === "function") return stream.destroy();
            callback(err || new ERR_STREAM_DESTROYED("pipe"));
        };
    }
    function call(fn) {
        fn();
    }
    function pipe(from, to) {
        return from.pipe(to);
    }
    function popCallback(streams) {
        if (!streams.length) return noop2;
        if (typeof streams[streams.length - 1] !== "function") return noop2;
        return streams.pop();
    }
    function pipeline() {
        for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
        var callback = popCallback(streams);
        if (Array.isArray(streams[0])) streams = streams[0];
        if (streams.length < 2) throw new ERR_MISSING_ARGS("streams");
        var error;
        var destroys = streams.map(function(stream, i) {
            var reading = i < streams.length - 1;
            var writing = i > 0;
            return destroyer(stream, reading, writing, function(err) {
                if (!error) error = err;
                if (err) destroys.forEach(call);
                if (reading) return;
                destroys.forEach(call);
                callback(error);
            });
        });
        return streams.reduce(pipe);
    }
    $94db4f2abf87558b$var$pipeline_1 = pipeline;
    return $94db4f2abf87558b$var$pipeline_1;
}
var $94db4f2abf87558b$var$streamBrowserify = $94db4f2abf87558b$var$Stream$1;
var $94db4f2abf87558b$var$EE = $94db4f2abf87558b$var$eventsExports.EventEmitter;
var $94db4f2abf87558b$var$inherits = $94db4f2abf87558b$var$inherits_browserExports;
$94db4f2abf87558b$var$inherits($94db4f2abf87558b$var$Stream$1, $94db4f2abf87558b$var$EE);
$94db4f2abf87558b$var$Stream$1.Readable = $94db4f2abf87558b$var$require_stream_readable();
$94db4f2abf87558b$var$Stream$1.Writable = $94db4f2abf87558b$var$require_stream_writable();
$94db4f2abf87558b$var$Stream$1.Duplex = $94db4f2abf87558b$var$require_stream_duplex();
$94db4f2abf87558b$var$Stream$1.Transform = $94db4f2abf87558b$var$require_stream_transform();
$94db4f2abf87558b$var$Stream$1.PassThrough = $94db4f2abf87558b$var$require_stream_passthrough();
$94db4f2abf87558b$var$Stream$1.finished = $94db4f2abf87558b$var$requireEndOfStream();
$94db4f2abf87558b$var$Stream$1.pipeline = $94db4f2abf87558b$var$requirePipeline();
$94db4f2abf87558b$var$Stream$1.Stream = $94db4f2abf87558b$var$Stream$1;
function $94db4f2abf87558b$var$Stream$1() {
    $94db4f2abf87558b$var$EE.call(this);
}
$94db4f2abf87558b$var$Stream$1.prototype.pipe = function(dest, options2) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    if (!dest._isStdio && (!options2 || options2.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    function onerror(er) {
        cleanup();
        if ($94db4f2abf87558b$var$EE.listenerCount(this, "error") === 0) throw er;
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    return dest;
};
(function(exports) {
    (function(sax2) {
        sax2.parser = function(strict, opt) {
            return new SAXParser(strict, opt);
        };
        sax2.SAXParser = SAXParser;
        sax2.SAXStream = SAXStream;
        sax2.createStream = createStream;
        sax2.MAX_BUFFER_LENGTH = 65536;
        var buffers = [
            "comment",
            "sgmlDecl",
            "textNode",
            "tagName",
            "doctype",
            "procInstName",
            "procInstBody",
            "entity",
            "attribName",
            "attribValue",
            "cdata",
            "script"
        ];
        sax2.EVENTS = [
            "text",
            "processinginstruction",
            "sgmldeclaration",
            "doctype",
            "comment",
            "opentagstart",
            "attribute",
            "opentag",
            "closetag",
            "opencdata",
            "cdata",
            "closecdata",
            "error",
            "end",
            "ready",
            "script",
            "opennamespace",
            "closenamespace"
        ];
        function SAXParser(strict, opt) {
            if (!(this instanceof SAXParser)) return new SAXParser(strict, opt);
            var parser = this;
            clearBuffers(parser);
            parser.q = parser.c = "";
            parser.bufferCheckPosition = sax2.MAX_BUFFER_LENGTH;
            parser.opt = opt || {};
            parser.opt.lowercase = parser.opt.lowercase || parser.opt.lowercasetags;
            parser.looseCase = parser.opt.lowercase ? "toLowerCase" : "toUpperCase";
            parser.tags = [];
            parser.closed = parser.closedRoot = parser.sawRoot = false;
            parser.tag = parser.error = null;
            parser.strict = !!strict;
            parser.noscript = !!(strict || parser.opt.noscript);
            parser.state = S.BEGIN;
            parser.strictEntities = parser.opt.strictEntities;
            parser.ENTITIES = parser.strictEntities ? Object.create(sax2.XML_ENTITIES) : Object.create(sax2.ENTITIES);
            parser.attribList = [];
            if (parser.opt.xmlns) parser.ns = Object.create(rootNS);
            parser.trackPosition = parser.opt.position !== false;
            if (parser.trackPosition) parser.position = parser.line = parser.column = 0;
            emit2(parser, "onready");
        }
        if (!Object.create) Object.create = function(o) {
            function F() {}
            F.prototype = o;
            var newf = new F();
            return newf;
        };
        if (!Object.keys) Object.keys = function(o) {
            var a = [];
            for(var i in o)if (o.hasOwnProperty(i)) a.push(i);
            return a;
        };
        function checkBufferLength(parser) {
            var maxAllowed = Math.max(sax2.MAX_BUFFER_LENGTH, 10);
            var maxActual = 0;
            for(var i = 0, l = buffers.length; i < l; i++){
                var len = parser[buffers[i]].length;
                if (len > maxAllowed) switch(buffers[i]){
                    case "textNode":
                        closeText(parser);
                        break;
                    case "cdata":
                        emitNode(parser, "oncdata", parser.cdata);
                        parser.cdata = "";
                        break;
                    case "script":
                        emitNode(parser, "onscript", parser.script);
                        parser.script = "";
                        break;
                    default:
                        error(parser, "Max buffer length exceeded: " + buffers[i]);
                }
                maxActual = Math.max(maxActual, len);
            }
            var m = sax2.MAX_BUFFER_LENGTH - maxActual;
            parser.bufferCheckPosition = m + parser.position;
        }
        function clearBuffers(parser) {
            for(var i = 0, l = buffers.length; i < l; i++)parser[buffers[i]] = "";
        }
        function flushBuffers(parser) {
            closeText(parser);
            if (parser.cdata !== "") {
                emitNode(parser, "oncdata", parser.cdata);
                parser.cdata = "";
            }
            if (parser.script !== "") {
                emitNode(parser, "onscript", parser.script);
                parser.script = "";
            }
        }
        SAXParser.prototype = {
            end: function end1() {
                end(this);
            },
            write: write,
            resume: function resume() {
                this.error = null;
                return this;
            },
            close: function close() {
                return this.write(null);
            },
            flush: function flush() {
                flushBuffers(this);
            }
        };
        var Stream2;
        try {
            Stream2 = $94db4f2abf87558b$var$streamBrowserify.Stream;
        } catch (ex) {
            Stream2 = function Stream2() {};
        }
        var streamWraps = sax2.EVENTS.filter(function(ev) {
            return ev !== "error" && ev !== "end";
        });
        function createStream(strict, opt) {
            return new SAXStream(strict, opt);
        }
        function SAXStream(strict, opt) {
            if (!(this instanceof SAXStream)) return new SAXStream(strict, opt);
            Stream2.apply(this);
            this._parser = new SAXParser(strict, opt);
            this.writable = true;
            this.readable = true;
            var me = this;
            this._parser.onend = function() {
                me.emit("end");
            };
            this._parser.onerror = function(er) {
                me.emit("error", er);
                me._parser.error = null;
            };
            this._decoder = null;
            streamWraps.forEach(function(ev) {
                Object.defineProperty(me, "on" + ev, {
                    get: function get() {
                        return me._parser["on" + ev];
                    },
                    set: function set(h) {
                        if (!h) {
                            me.removeAllListeners(ev);
                            me._parser["on" + ev] = h;
                            return h;
                        }
                        me.on(ev, h);
                    },
                    enumerable: true,
                    configurable: false
                });
            });
        }
        SAXStream.prototype = Object.create(Stream2.prototype, {
            constructor: {
                value: SAXStream
            }
        });
        SAXStream.prototype.write = function(data) {
            if (typeof $94db4f2abf87558b$var$Buffer === "function" && typeof $94db4f2abf87558b$var$Buffer.isBuffer === "function" && $94db4f2abf87558b$var$Buffer.isBuffer(data)) {
                if (!this._decoder) {
                    var SD = $94db4f2abf87558b$var$requireString_decoder().StringDecoder;
                    this._decoder = new SD("utf8");
                }
                data = this._decoder.write(data);
            }
            this._parser.write(data.toString());
            this.emit("data", data);
            return true;
        };
        SAXStream.prototype.end = function(chunk) {
            if (chunk && chunk.length) this.write(chunk);
            this._parser.end();
            return true;
        };
        SAXStream.prototype.on = function(ev, handler) {
            var me = this;
            if (!me._parser["on" + ev] && streamWraps.indexOf(ev) !== -1) me._parser["on" + ev] = function() {
                var args = arguments.length === 1 ? [
                    arguments[0]
                ] : Array.apply(null, arguments);
                args.splice(0, 0, ev);
                me.emit.apply(me, args);
            };
            return Stream2.prototype.on.call(me, ev, handler);
        };
        var CDATA = "[CDATA[";
        var DOCTYPE = "DOCTYPE";
        var XML_NAMESPACE = "http://www.w3.org/XML/1998/namespace";
        var XMLNS_NAMESPACE = "http://www.w3.org/2000/xmlns/";
        var rootNS = {
            xml: XML_NAMESPACE,
            xmlns: XMLNS_NAMESPACE
        };
        var nameStart = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;
        var nameBody = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;
        var entityStart = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;
        var entityBody = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;
        function isWhitespace(c) {
            return c === " " || c === "\n" || c === "\r" || c === "	";
        }
        function isQuote(c) {
            return c === '"' || c === "'";
        }
        function isAttribEnd(c) {
            return c === ">" || isWhitespace(c);
        }
        function isMatch(regex, c) {
            return regex.test(c);
        }
        function notMatch(regex, c) {
            return !isMatch(regex, c);
        }
        var S = 0;
        sax2.STATE = {
            BEGIN: S++,
            // leading byte order mark or whitespace
            BEGIN_WHITESPACE: S++,
            // leading whitespace
            TEXT: S++,
            // general stuff
            TEXT_ENTITY: S++,
            // &amp and such.
            OPEN_WAKA: S++,
            // <
            SGML_DECL: S++,
            // <!BLARG
            SGML_DECL_QUOTED: S++,
            // <!BLARG foo "bar
            DOCTYPE: S++,
            // <!DOCTYPE
            DOCTYPE_QUOTED: S++,
            // <!DOCTYPE "//blah
            DOCTYPE_DTD: S++,
            // <!DOCTYPE "//blah" [ ...
            DOCTYPE_DTD_QUOTED: S++,
            // <!DOCTYPE "//blah" [ "foo
            COMMENT_STARTING: S++,
            // <!-
            COMMENT: S++,
            // <!--
            COMMENT_ENDING: S++,
            // <!-- blah -
            COMMENT_ENDED: S++,
            // <!-- blah --
            CDATA: S++,
            // <![CDATA[ something
            CDATA_ENDING: S++,
            // ]
            CDATA_ENDING_2: S++,
            // ]]
            PROC_INST: S++,
            // <?hi
            PROC_INST_BODY: S++,
            // <?hi there
            PROC_INST_ENDING: S++,
            // <?hi "there" ?
            OPEN_TAG: S++,
            // <strong
            OPEN_TAG_SLASH: S++,
            // <strong /
            ATTRIB: S++,
            // <a
            ATTRIB_NAME: S++,
            // <a foo
            ATTRIB_NAME_SAW_WHITE: S++,
            // <a foo _
            ATTRIB_VALUE: S++,
            // <a foo=
            ATTRIB_VALUE_QUOTED: S++,
            // <a foo="bar
            ATTRIB_VALUE_CLOSED: S++,
            // <a foo="bar"
            ATTRIB_VALUE_UNQUOTED: S++,
            // <a foo=bar
            ATTRIB_VALUE_ENTITY_Q: S++,
            // <foo bar="&quot;"
            ATTRIB_VALUE_ENTITY_U: S++,
            // <foo bar=&quot
            CLOSE_TAG: S++,
            // </a
            CLOSE_TAG_SAW_WHITE: S++,
            // </a   >
            SCRIPT: S++,
            // <script> ...
            SCRIPT_ENDING: S++
        };
        sax2.XML_ENTITIES = {
            "amp": "&",
            "gt": ">",
            "lt": "<",
            "quot": '"',
            "apos": "'"
        };
        sax2.ENTITIES = {
            "amp": "&",
            "gt": ">",
            "lt": "<",
            "quot": '"',
            "apos": "'",
            "AElig": 198,
            "Aacute": 193,
            "Acirc": 194,
            "Agrave": 192,
            "Aring": 197,
            "Atilde": 195,
            "Auml": 196,
            "Ccedil": 199,
            "ETH": 208,
            "Eacute": 201,
            "Ecirc": 202,
            "Egrave": 200,
            "Euml": 203,
            "Iacute": 205,
            "Icirc": 206,
            "Igrave": 204,
            "Iuml": 207,
            "Ntilde": 209,
            "Oacute": 211,
            "Ocirc": 212,
            "Ograve": 210,
            "Oslash": 216,
            "Otilde": 213,
            "Ouml": 214,
            "THORN": 222,
            "Uacute": 218,
            "Ucirc": 219,
            "Ugrave": 217,
            "Uuml": 220,
            "Yacute": 221,
            "aacute": 225,
            "acirc": 226,
            "aelig": 230,
            "agrave": 224,
            "aring": 229,
            "atilde": 227,
            "auml": 228,
            "ccedil": 231,
            "eacute": 233,
            "ecirc": 234,
            "egrave": 232,
            "eth": 240,
            "euml": 235,
            "iacute": 237,
            "icirc": 238,
            "igrave": 236,
            "iuml": 239,
            "ntilde": 241,
            "oacute": 243,
            "ocirc": 244,
            "ograve": 242,
            "oslash": 248,
            "otilde": 245,
            "ouml": 246,
            "szlig": 223,
            "thorn": 254,
            "uacute": 250,
            "ucirc": 251,
            "ugrave": 249,
            "uuml": 252,
            "yacute": 253,
            "yuml": 255,
            "copy": 169,
            "reg": 174,
            "nbsp": 160,
            "iexcl": 161,
            "cent": 162,
            "pound": 163,
            "curren": 164,
            "yen": 165,
            "brvbar": 166,
            "sect": 167,
            "uml": 168,
            "ordf": 170,
            "laquo": 171,
            "not": 172,
            "shy": 173,
            "macr": 175,
            "deg": 176,
            "plusmn": 177,
            "sup1": 185,
            "sup2": 178,
            "sup3": 179,
            "acute": 180,
            "micro": 181,
            "para": 182,
            "middot": 183,
            "cedil": 184,
            "ordm": 186,
            "raquo": 187,
            "frac14": 188,
            "frac12": 189,
            "frac34": 190,
            "iquest": 191,
            "times": 215,
            "divide": 247,
            "OElig": 338,
            "oelig": 339,
            "Scaron": 352,
            "scaron": 353,
            "Yuml": 376,
            "fnof": 402,
            "circ": 710,
            "tilde": 732,
            "Alpha": 913,
            "Beta": 914,
            "Gamma": 915,
            "Delta": 916,
            "Epsilon": 917,
            "Zeta": 918,
            "Eta": 919,
            "Theta": 920,
            "Iota": 921,
            "Kappa": 922,
            "Lambda": 923,
            "Mu": 924,
            "Nu": 925,
            "Xi": 926,
            "Omicron": 927,
            "Pi": 928,
            "Rho": 929,
            "Sigma": 931,
            "Tau": 932,
            "Upsilon": 933,
            "Phi": 934,
            "Chi": 935,
            "Psi": 936,
            "Omega": 937,
            "alpha": 945,
            "beta": 946,
            "gamma": 947,
            "delta": 948,
            "epsilon": 949,
            "zeta": 950,
            "eta": 951,
            "theta": 952,
            "iota": 953,
            "kappa": 954,
            "lambda": 955,
            "mu": 956,
            "nu": 957,
            "xi": 958,
            "omicron": 959,
            "pi": 960,
            "rho": 961,
            "sigmaf": 962,
            "sigma": 963,
            "tau": 964,
            "upsilon": 965,
            "phi": 966,
            "chi": 967,
            "psi": 968,
            "omega": 969,
            "thetasym": 977,
            "upsih": 978,
            "piv": 982,
            "ensp": 8194,
            "emsp": 8195,
            "thinsp": 8201,
            "zwnj": 8204,
            "zwj": 8205,
            "lrm": 8206,
            "rlm": 8207,
            "ndash": 8211,
            "mdash": 8212,
            "lsquo": 8216,
            "rsquo": 8217,
            "sbquo": 8218,
            "ldquo": 8220,
            "rdquo": 8221,
            "bdquo": 8222,
            "dagger": 8224,
            "Dagger": 8225,
            "bull": 8226,
            "hellip": 8230,
            "permil": 8240,
            "prime": 8242,
            "Prime": 8243,
            "lsaquo": 8249,
            "rsaquo": 8250,
            "oline": 8254,
            "frasl": 8260,
            "euro": 8364,
            "image": 8465,
            "weierp": 8472,
            "real": 8476,
            "trade": 8482,
            "alefsym": 8501,
            "larr": 8592,
            "uarr": 8593,
            "rarr": 8594,
            "darr": 8595,
            "harr": 8596,
            "crarr": 8629,
            "lArr": 8656,
            "uArr": 8657,
            "rArr": 8658,
            "dArr": 8659,
            "hArr": 8660,
            "forall": 8704,
            "part": 8706,
            "exist": 8707,
            "empty": 8709,
            "nabla": 8711,
            "isin": 8712,
            "notin": 8713,
            "ni": 8715,
            "prod": 8719,
            "sum": 8721,
            "minus": 8722,
            "lowast": 8727,
            "radic": 8730,
            "prop": 8733,
            "infin": 8734,
            "ang": 8736,
            "and": 8743,
            "or": 8744,
            "cap": 8745,
            "cup": 8746,
            "int": 8747,
            "there4": 8756,
            "sim": 8764,
            "cong": 8773,
            "asymp": 8776,
            "ne": 8800,
            "equiv": 8801,
            "le": 8804,
            "ge": 8805,
            "sub": 8834,
            "sup": 8835,
            "nsub": 8836,
            "sube": 8838,
            "supe": 8839,
            "oplus": 8853,
            "otimes": 8855,
            "perp": 8869,
            "sdot": 8901,
            "lceil": 8968,
            "rceil": 8969,
            "lfloor": 8970,
            "rfloor": 8971,
            "lang": 9001,
            "rang": 9002,
            "loz": 9674,
            "spades": 9824,
            "clubs": 9827,
            "hearts": 9829,
            "diams": 9830
        };
        Object.keys(sax2.ENTITIES).forEach(function(key) {
            var e = sax2.ENTITIES[key];
            var s2 = typeof e === "number" ? String.fromCharCode(e) : e;
            sax2.ENTITIES[key] = s2;
        });
        for(var s in sax2.STATE)sax2.STATE[sax2.STATE[s]] = s;
        S = sax2.STATE;
        function emit2(parser, event, data) {
            parser[event] && parser[event](data);
        }
        function emitNode(parser, nodeType, data) {
            if (parser.textNode) closeText(parser);
            emit2(parser, nodeType, data);
        }
        function closeText(parser) {
            parser.textNode = textopts(parser.opt, parser.textNode);
            if (parser.textNode) emit2(parser, "ontext", parser.textNode);
            parser.textNode = "";
        }
        function textopts(opt, text) {
            if (opt.trim) text = text.trim();
            if (opt.normalize) text = text.replace(/\s+/g, " ");
            return text;
        }
        function error(parser, er) {
            closeText(parser);
            if (parser.trackPosition) er += "\nLine: " + parser.line + "\nColumn: " + parser.column + "\nChar: " + parser.c;
            er = new Error(er);
            parser.error = er;
            emit2(parser, "onerror", er);
            return parser;
        }
        function end(parser) {
            if (parser.sawRoot && !parser.closedRoot) strictFail(parser, "Unclosed root tag");
            if (parser.state !== S.BEGIN && parser.state !== S.BEGIN_WHITESPACE && parser.state !== S.TEXT) error(parser, "Unexpected end");
            closeText(parser);
            parser.c = "";
            parser.closed = true;
            emit2(parser, "onend");
            SAXParser.call(parser, parser.strict, parser.opt);
            return parser;
        }
        function strictFail(parser, message) {
            if ((typeof parser === "undefined" ? "undefined" : (0, $2bfPH._)(parser)) !== "object" || !(parser instanceof SAXParser)) throw new Error("bad call to strictFail");
            if (parser.strict) error(parser, message);
        }
        function newTag(parser) {
            if (!parser.strict) parser.tagName = parser.tagName[parser.looseCase]();
            var parent = parser.tags[parser.tags.length - 1] || parser;
            var tag = parser.tag = {
                name: parser.tagName,
                attributes: {}
            };
            if (parser.opt.xmlns) tag.ns = parent.ns;
            parser.attribList.length = 0;
            emitNode(parser, "onopentagstart", tag);
        }
        function qname(name, attribute2) {
            var i = name.indexOf(":");
            var qualName = i < 0 ? [
                "",
                name
            ] : name.split(":");
            var prefix = qualName[0];
            var local = qualName[1];
            if (attribute2 && name === "xmlns") {
                prefix = "xmlns";
                local = "";
            }
            return {
                prefix: prefix,
                local: local
            };
        }
        function attrib(parser) {
            if (!parser.strict) parser.attribName = parser.attribName[parser.looseCase]();
            if (parser.attribList.indexOf(parser.attribName) !== -1 || parser.tag.attributes.hasOwnProperty(parser.attribName)) {
                parser.attribName = parser.attribValue = "";
                return;
            }
            if (parser.opt.xmlns) {
                var qn = qname(parser.attribName, true);
                var prefix = qn.prefix;
                var local = qn.local;
                if (prefix === "xmlns") {
                    if (local === "xml" && parser.attribValue !== XML_NAMESPACE) strictFail(parser, "xml: prefix must be bound to " + XML_NAMESPACE + "\nActual: " + parser.attribValue);
                    else if (local === "xmlns" && parser.attribValue !== XMLNS_NAMESPACE) strictFail(parser, "xmlns: prefix must be bound to " + XMLNS_NAMESPACE + "\nActual: " + parser.attribValue);
                    else {
                        var tag = parser.tag;
                        var parent = parser.tags[parser.tags.length - 1] || parser;
                        if (tag.ns === parent.ns) tag.ns = Object.create(parent.ns);
                        tag.ns[local] = parser.attribValue;
                    }
                }
                parser.attribList.push([
                    parser.attribName,
                    parser.attribValue
                ]);
            } else {
                parser.tag.attributes[parser.attribName] = parser.attribValue;
                emitNode(parser, "onattribute", {
                    name: parser.attribName,
                    value: parser.attribValue
                });
            }
            parser.attribName = parser.attribValue = "";
        }
        function openTag(parser, selfClosing) {
            if (parser.opt.xmlns) {
                var tag = parser.tag;
                var qn = qname(parser.tagName);
                tag.prefix = qn.prefix;
                tag.local = qn.local;
                tag.uri = tag.ns[qn.prefix] || "";
                if (tag.prefix && !tag.uri) {
                    strictFail(parser, "Unbound namespace prefix: " + JSON.stringify(parser.tagName));
                    tag.uri = qn.prefix;
                }
                var parent = parser.tags[parser.tags.length - 1] || parser;
                if (tag.ns && parent.ns !== tag.ns) Object.keys(tag.ns).forEach(function(p) {
                    emitNode(parser, "onopennamespace", {
                        prefix: p,
                        uri: tag.ns[p]
                    });
                });
                for(var i = 0, l = parser.attribList.length; i < l; i++){
                    var nv = parser.attribList[i];
                    var name = nv[0];
                    var value = nv[1];
                    var qualName = qname(name, true);
                    var prefix = qualName.prefix;
                    var local = qualName.local;
                    var uri = prefix === "" ? "" : tag.ns[prefix] || "";
                    var a = {
                        name: name,
                        value: value,
                        prefix: prefix,
                        local: local,
                        uri: uri
                    };
                    if (prefix && prefix !== "xmlns" && !uri) {
                        strictFail(parser, "Unbound namespace prefix: " + JSON.stringify(prefix));
                        a.uri = prefix;
                    }
                    parser.tag.attributes[name] = a;
                    emitNode(parser, "onattribute", a);
                }
                parser.attribList.length = 0;
            }
            parser.tag.isSelfClosing = !!selfClosing;
            parser.sawRoot = true;
            parser.tags.push(parser.tag);
            emitNode(parser, "onopentag", parser.tag);
            if (!selfClosing) {
                if (!parser.noscript && parser.tagName.toLowerCase() === "script") parser.state = S.SCRIPT;
                else parser.state = S.TEXT;
                parser.tag = null;
                parser.tagName = "";
            }
            parser.attribName = parser.attribValue = "";
            parser.attribList.length = 0;
        }
        function closeTag(parser) {
            if (!parser.tagName) {
                strictFail(parser, "Weird empty close tag.");
                parser.textNode += "</>";
                parser.state = S.TEXT;
                return;
            }
            if (parser.script) {
                if (parser.tagName !== "script") {
                    parser.script += "</" + parser.tagName + ">";
                    parser.tagName = "";
                    parser.state = S.SCRIPT;
                    return;
                }
                emitNode(parser, "onscript", parser.script);
                parser.script = "";
            }
            var t = parser.tags.length;
            var tagName = parser.tagName;
            if (!parser.strict) tagName = tagName[parser.looseCase]();
            var closeTo = tagName;
            while(t--){
                var close = parser.tags[t];
                if (close.name !== closeTo) strictFail(parser, "Unexpected close tag");
                else break;
            }
            if (t < 0) {
                strictFail(parser, "Unmatched closing tag: " + parser.tagName);
                parser.textNode += "</" + parser.tagName + ">";
                parser.state = S.TEXT;
                return;
            }
            parser.tagName = tagName;
            var s2 = parser.tags.length;
            while(s2-- > t){
                var tag = parser.tag = parser.tags.pop();
                parser.tagName = parser.tag.name;
                emitNode(parser, "onclosetag", parser.tagName);
                var x = {};
                for(var i in tag.ns)x[i] = tag.ns[i];
                var parent = parser.tags[parser.tags.length - 1] || parser;
                if (parser.opt.xmlns && tag.ns !== parent.ns) Object.keys(tag.ns).forEach(function(p) {
                    var n = tag.ns[p];
                    emitNode(parser, "onclosenamespace", {
                        prefix: p,
                        uri: n
                    });
                });
            }
            if (t === 0) parser.closedRoot = true;
            parser.tagName = parser.attribValue = parser.attribName = "";
            parser.attribList.length = 0;
            parser.state = S.TEXT;
        }
        function parseEntity(parser) {
            var entity = parser.entity;
            var entityLC = entity.toLowerCase();
            var num;
            var numStr = "";
            if (parser.ENTITIES[entity]) return parser.ENTITIES[entity];
            if (parser.ENTITIES[entityLC]) return parser.ENTITIES[entityLC];
            entity = entityLC;
            if (entity.charAt(0) === "#") {
                if (entity.charAt(1) === "x") {
                    entity = entity.slice(2);
                    num = parseInt(entity, 16);
                    numStr = num.toString(16);
                } else {
                    entity = entity.slice(1);
                    num = parseInt(entity, 10);
                    numStr = num.toString(10);
                }
            }
            entity = entity.replace(/^0+/, "");
            if (isNaN(num) || numStr.toLowerCase() !== entity) {
                strictFail(parser, "Invalid character entity");
                return "&" + parser.entity + ";";
            }
            return String.fromCodePoint(num);
        }
        function beginWhiteSpace(parser, c) {
            if (c === "<") {
                parser.state = S.OPEN_WAKA;
                parser.startTagPosition = parser.position;
            } else if (!isWhitespace(c)) {
                strictFail(parser, "Non-whitespace before first tag.");
                parser.textNode = c;
                parser.state = S.TEXT;
            }
        }
        function charAt(chunk, i) {
            var result = "";
            if (i < chunk.length) result = chunk.charAt(i);
            return result;
        }
        function write(chunk) {
            var parser = this;
            if (this.error) throw this.error;
            if (parser.closed) return error(parser, "Cannot write after close. Assign an onready handler.");
            if (chunk === null) return end(parser);
            if ((typeof chunk === "undefined" ? "undefined" : (0, $2bfPH._)(chunk)) === "object") chunk = chunk.toString();
            var i = 0;
            var c = "";
            while(true){
                c = charAt(chunk, i++);
                parser.c = c;
                if (!c) break;
                if (parser.trackPosition) {
                    parser.position++;
                    if (c === "\n") {
                        parser.line++;
                        parser.column = 0;
                    } else parser.column++;
                }
                switch(parser.state){
                    case S.BEGIN:
                        parser.state = S.BEGIN_WHITESPACE;
                        if (c === "\uFEFF") continue;
                        beginWhiteSpace(parser, c);
                        continue;
                    case S.BEGIN_WHITESPACE:
                        beginWhiteSpace(parser, c);
                        continue;
                    case S.TEXT:
                        if (parser.sawRoot && !parser.closedRoot) {
                            var starti = i - 1;
                            while(c && c !== "<" && c !== "&"){
                                c = charAt(chunk, i++);
                                if (c && parser.trackPosition) {
                                    parser.position++;
                                    if (c === "\n") {
                                        parser.line++;
                                        parser.column = 0;
                                    } else parser.column++;
                                }
                            }
                            parser.textNode += chunk.substring(starti, i - 1);
                        }
                        if (c === "<" && !(parser.sawRoot && parser.closedRoot && !parser.strict)) {
                            parser.state = S.OPEN_WAKA;
                            parser.startTagPosition = parser.position;
                        } else {
                            if (!isWhitespace(c) && (!parser.sawRoot || parser.closedRoot)) strictFail(parser, "Text data outside of root node.");
                            if (c === "&") parser.state = S.TEXT_ENTITY;
                            else parser.textNode += c;
                        }
                        continue;
                    case S.SCRIPT:
                        if (c === "<") parser.state = S.SCRIPT_ENDING;
                        else parser.script += c;
                        continue;
                    case S.SCRIPT_ENDING:
                        if (c === "/") parser.state = S.CLOSE_TAG;
                        else {
                            parser.script += "<" + c;
                            parser.state = S.SCRIPT;
                        }
                        continue;
                    case S.OPEN_WAKA:
                        if (c === "!") {
                            parser.state = S.SGML_DECL;
                            parser.sgmlDecl = "";
                        } else if (isWhitespace(c)) ;
                        else if (isMatch(nameStart, c)) {
                            parser.state = S.OPEN_TAG;
                            parser.tagName = c;
                        } else if (c === "/") {
                            parser.state = S.CLOSE_TAG;
                            parser.tagName = "";
                        } else if (c === "?") {
                            parser.state = S.PROC_INST;
                            parser.procInstName = parser.procInstBody = "";
                        } else {
                            strictFail(parser, "Unencoded <");
                            if (parser.startTagPosition + 1 < parser.position) {
                                var pad = parser.position - parser.startTagPosition;
                                c = new Array(pad).join(" ") + c;
                            }
                            parser.textNode += "<" + c;
                            parser.state = S.TEXT;
                        }
                        continue;
                    case S.SGML_DECL:
                        if ((parser.sgmlDecl + c).toUpperCase() === CDATA) {
                            emitNode(parser, "onopencdata");
                            parser.state = S.CDATA;
                            parser.sgmlDecl = "";
                            parser.cdata = "";
                        } else if (parser.sgmlDecl + c === "--") {
                            parser.state = S.COMMENT;
                            parser.comment = "";
                            parser.sgmlDecl = "";
                        } else if ((parser.sgmlDecl + c).toUpperCase() === DOCTYPE) {
                            parser.state = S.DOCTYPE;
                            if (parser.doctype || parser.sawRoot) strictFail(parser, "Inappropriately located doctype declaration");
                            parser.doctype = "";
                            parser.sgmlDecl = "";
                        } else if (c === ">") {
                            emitNode(parser, "onsgmldeclaration", parser.sgmlDecl);
                            parser.sgmlDecl = "";
                            parser.state = S.TEXT;
                        } else if (isQuote(c)) {
                            parser.state = S.SGML_DECL_QUOTED;
                            parser.sgmlDecl += c;
                        } else parser.sgmlDecl += c;
                        continue;
                    case S.SGML_DECL_QUOTED:
                        if (c === parser.q) {
                            parser.state = S.SGML_DECL;
                            parser.q = "";
                        }
                        parser.sgmlDecl += c;
                        continue;
                    case S.DOCTYPE:
                        if (c === ">") {
                            parser.state = S.TEXT;
                            emitNode(parser, "ondoctype", parser.doctype);
                            parser.doctype = true;
                        } else {
                            parser.doctype += c;
                            if (c === "[") parser.state = S.DOCTYPE_DTD;
                            else if (isQuote(c)) {
                                parser.state = S.DOCTYPE_QUOTED;
                                parser.q = c;
                            }
                        }
                        continue;
                    case S.DOCTYPE_QUOTED:
                        parser.doctype += c;
                        if (c === parser.q) {
                            parser.q = "";
                            parser.state = S.DOCTYPE;
                        }
                        continue;
                    case S.DOCTYPE_DTD:
                        parser.doctype += c;
                        if (c === "]") parser.state = S.DOCTYPE;
                        else if (isQuote(c)) {
                            parser.state = S.DOCTYPE_DTD_QUOTED;
                            parser.q = c;
                        }
                        continue;
                    case S.DOCTYPE_DTD_QUOTED:
                        parser.doctype += c;
                        if (c === parser.q) {
                            parser.state = S.DOCTYPE_DTD;
                            parser.q = "";
                        }
                        continue;
                    case S.COMMENT:
                        if (c === "-") parser.state = S.COMMENT_ENDING;
                        else parser.comment += c;
                        continue;
                    case S.COMMENT_ENDING:
                        if (c === "-") {
                            parser.state = S.COMMENT_ENDED;
                            parser.comment = textopts(parser.opt, parser.comment);
                            if (parser.comment) emitNode(parser, "oncomment", parser.comment);
                            parser.comment = "";
                        } else {
                            parser.comment += "-" + c;
                            parser.state = S.COMMENT;
                        }
                        continue;
                    case S.COMMENT_ENDED:
                        if (c !== ">") {
                            strictFail(parser, "Malformed comment");
                            parser.comment += "--" + c;
                            parser.state = S.COMMENT;
                        } else parser.state = S.TEXT;
                        continue;
                    case S.CDATA:
                        if (c === "]") parser.state = S.CDATA_ENDING;
                        else parser.cdata += c;
                        continue;
                    case S.CDATA_ENDING:
                        if (c === "]") parser.state = S.CDATA_ENDING_2;
                        else {
                            parser.cdata += "]" + c;
                            parser.state = S.CDATA;
                        }
                        continue;
                    case S.CDATA_ENDING_2:
                        if (c === ">") {
                            if (parser.cdata) emitNode(parser, "oncdata", parser.cdata);
                            emitNode(parser, "onclosecdata");
                            parser.cdata = "";
                            parser.state = S.TEXT;
                        } else if (c === "]") parser.cdata += "]";
                        else {
                            parser.cdata += "]]" + c;
                            parser.state = S.CDATA;
                        }
                        continue;
                    case S.PROC_INST:
                        if (c === "?") parser.state = S.PROC_INST_ENDING;
                        else if (isWhitespace(c)) parser.state = S.PROC_INST_BODY;
                        else parser.procInstName += c;
                        continue;
                    case S.PROC_INST_BODY:
                        if (!parser.procInstBody && isWhitespace(c)) continue;
                        else if (c === "?") parser.state = S.PROC_INST_ENDING;
                        else parser.procInstBody += c;
                        continue;
                    case S.PROC_INST_ENDING:
                        if (c === ">") {
                            emitNode(parser, "onprocessinginstruction", {
                                name: parser.procInstName,
                                body: parser.procInstBody
                            });
                            parser.procInstName = parser.procInstBody = "";
                            parser.state = S.TEXT;
                        } else {
                            parser.procInstBody += "?" + c;
                            parser.state = S.PROC_INST_BODY;
                        }
                        continue;
                    case S.OPEN_TAG:
                        if (isMatch(nameBody, c)) parser.tagName += c;
                        else {
                            newTag(parser);
                            if (c === ">") openTag(parser);
                            else if (c === "/") parser.state = S.OPEN_TAG_SLASH;
                            else {
                                if (!isWhitespace(c)) strictFail(parser, "Invalid character in tag name");
                                parser.state = S.ATTRIB;
                            }
                        }
                        continue;
                    case S.OPEN_TAG_SLASH:
                        if (c === ">") {
                            openTag(parser, true);
                            closeTag(parser);
                        } else {
                            strictFail(parser, "Forward-slash in opening tag not followed by >");
                            parser.state = S.ATTRIB;
                        }
                        continue;
                    case S.ATTRIB:
                        if (isWhitespace(c)) continue;
                        else if (c === ">") openTag(parser);
                        else if (c === "/") parser.state = S.OPEN_TAG_SLASH;
                        else if (isMatch(nameStart, c)) {
                            parser.attribName = c;
                            parser.attribValue = "";
                            parser.state = S.ATTRIB_NAME;
                        } else strictFail(parser, "Invalid attribute name");
                        continue;
                    case S.ATTRIB_NAME:
                        if (c === "=") parser.state = S.ATTRIB_VALUE;
                        else if (c === ">") {
                            strictFail(parser, "Attribute without value");
                            parser.attribValue = parser.attribName;
                            attrib(parser);
                            openTag(parser);
                        } else if (isWhitespace(c)) parser.state = S.ATTRIB_NAME_SAW_WHITE;
                        else if (isMatch(nameBody, c)) parser.attribName += c;
                        else strictFail(parser, "Invalid attribute name");
                        continue;
                    case S.ATTRIB_NAME_SAW_WHITE:
                        if (c === "=") parser.state = S.ATTRIB_VALUE;
                        else if (isWhitespace(c)) continue;
                        else {
                            strictFail(parser, "Attribute without value");
                            parser.tag.attributes[parser.attribName] = "";
                            parser.attribValue = "";
                            emitNode(parser, "onattribute", {
                                name: parser.attribName,
                                value: ""
                            });
                            parser.attribName = "";
                            if (c === ">") openTag(parser);
                            else if (isMatch(nameStart, c)) {
                                parser.attribName = c;
                                parser.state = S.ATTRIB_NAME;
                            } else {
                                strictFail(parser, "Invalid attribute name");
                                parser.state = S.ATTRIB;
                            }
                        }
                        continue;
                    case S.ATTRIB_VALUE:
                        if (isWhitespace(c)) continue;
                        else if (isQuote(c)) {
                            parser.q = c;
                            parser.state = S.ATTRIB_VALUE_QUOTED;
                        } else {
                            strictFail(parser, "Unquoted attribute value");
                            parser.state = S.ATTRIB_VALUE_UNQUOTED;
                            parser.attribValue = c;
                        }
                        continue;
                    case S.ATTRIB_VALUE_QUOTED:
                        if (c !== parser.q) {
                            if (c === "&") parser.state = S.ATTRIB_VALUE_ENTITY_Q;
                            else parser.attribValue += c;
                            continue;
                        }
                        attrib(parser);
                        parser.q = "";
                        parser.state = S.ATTRIB_VALUE_CLOSED;
                        continue;
                    case S.ATTRIB_VALUE_CLOSED:
                        if (isWhitespace(c)) parser.state = S.ATTRIB;
                        else if (c === ">") openTag(parser);
                        else if (c === "/") parser.state = S.OPEN_TAG_SLASH;
                        else if (isMatch(nameStart, c)) {
                            strictFail(parser, "No whitespace between attributes");
                            parser.attribName = c;
                            parser.attribValue = "";
                            parser.state = S.ATTRIB_NAME;
                        } else strictFail(parser, "Invalid attribute name");
                        continue;
                    case S.ATTRIB_VALUE_UNQUOTED:
                        if (!isAttribEnd(c)) {
                            if (c === "&") parser.state = S.ATTRIB_VALUE_ENTITY_U;
                            else parser.attribValue += c;
                            continue;
                        }
                        attrib(parser);
                        if (c === ">") openTag(parser);
                        else parser.state = S.ATTRIB;
                        continue;
                    case S.CLOSE_TAG:
                        if (!parser.tagName) {
                            if (isWhitespace(c)) continue;
                            else if (notMatch(nameStart, c)) {
                                if (parser.script) {
                                    parser.script += "</" + c;
                                    parser.state = S.SCRIPT;
                                } else strictFail(parser, "Invalid tagname in closing tag.");
                            } else parser.tagName = c;
                        } else if (c === ">") closeTag(parser);
                        else if (isMatch(nameBody, c)) parser.tagName += c;
                        else if (parser.script) {
                            parser.script += "</" + parser.tagName;
                            parser.tagName = "";
                            parser.state = S.SCRIPT;
                        } else {
                            if (!isWhitespace(c)) strictFail(parser, "Invalid tagname in closing tag");
                            parser.state = S.CLOSE_TAG_SAW_WHITE;
                        }
                        continue;
                    case S.CLOSE_TAG_SAW_WHITE:
                        if (isWhitespace(c)) continue;
                        if (c === ">") closeTag(parser);
                        else strictFail(parser, "Invalid characters in closing tag");
                        continue;
                    case S.TEXT_ENTITY:
                    case S.ATTRIB_VALUE_ENTITY_Q:
                    case S.ATTRIB_VALUE_ENTITY_U:
                        var returnState;
                        var buffer2;
                        switch(parser.state){
                            case S.TEXT_ENTITY:
                                returnState = S.TEXT;
                                buffer2 = "textNode";
                                break;
                            case S.ATTRIB_VALUE_ENTITY_Q:
                                returnState = S.ATTRIB_VALUE_QUOTED;
                                buffer2 = "attribValue";
                                break;
                            case S.ATTRIB_VALUE_ENTITY_U:
                                returnState = S.ATTRIB_VALUE_UNQUOTED;
                                buffer2 = "attribValue";
                                break;
                        }
                        if (c === ";") {
                            parser[buffer2] += parseEntity(parser);
                            parser.entity = "";
                            parser.state = returnState;
                        } else if (isMatch(parser.entity.length ? entityBody : entityStart, c)) parser.entity += c;
                        else {
                            strictFail(parser, "Invalid character in entity name");
                            parser[buffer2] += "&" + parser.entity + c;
                            parser.entity = "";
                            parser.state = returnState;
                        }
                        continue;
                    default:
                        throw new Error(parser, "Unknown state: " + parser.state);
                }
            }
            if (parser.position >= parser.bufferCheckPosition) checkBufferLength(parser);
            return parser;
        }
        /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */ if (!String.fromCodePoint) (function() {
            var stringFromCharCode = String.fromCharCode;
            var floor = Math.floor;
            var fromCodePoint = function fromCodePoint() {
                var MAX_SIZE = 16384;
                var codeUnits = [];
                var highSurrogate;
                var lowSurrogate;
                var index = -1;
                var length = arguments.length;
                if (!length) return "";
                var result = "";
                while(++index < length){
                    var codePoint = Number(arguments[index]);
                    if (!isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
                    codePoint < 0 || // not a valid Unicode code point
                    codePoint > 1114111 || // not a valid Unicode code point
                    floor(codePoint) !== codePoint) throw RangeError("Invalid code point: " + codePoint);
                    if (codePoint <= 65535) codeUnits.push(codePoint);
                    else {
                        codePoint -= 65536;
                        highSurrogate = (codePoint >> 10) + 55296;
                        lowSurrogate = codePoint % 1024 + 56320;
                        codeUnits.push(highSurrogate, lowSurrogate);
                    }
                    if (index + 1 === length || codeUnits.length > MAX_SIZE) {
                        result += stringFromCharCode.apply(null, codeUnits);
                        codeUnits.length = 0;
                    }
                }
                return result;
            };
            if (Object.defineProperty) Object.defineProperty(String, "fromCodePoint", {
                value: fromCodePoint,
                configurable: true,
                writable: true
            });
            else String.fromCodePoint = fromCodePoint;
        })();
    })(exports);
})($94db4f2abf87558b$var$sax$1);
var $94db4f2abf87558b$var$arrayHelper = {
    isArray: function isArray(value) {
        if (Array.isArray) return Array.isArray(value);
        return Object.prototype.toString.call(value) === "[object Array]";
    }
};
var $94db4f2abf87558b$var$isArray$2 = $94db4f2abf87558b$var$arrayHelper.isArray;
var $94db4f2abf87558b$var$optionsHelper = {
    copyOptions: function copyOptions(options2) {
        var key, copy = {};
        for(key in options2)if (options2.hasOwnProperty(key)) copy[key] = options2[key];
        return copy;
    },
    ensureFlagExists: function ensureFlagExists(item, options2) {
        if (!(item in options2) || typeof options2[item] !== "boolean") options2[item] = false;
    },
    ensureSpacesExists: function ensureSpacesExists(options2) {
        if (!("spaces" in options2) || typeof options2.spaces !== "number" && typeof options2.spaces !== "string") options2.spaces = 0;
    },
    ensureAlwaysArrayExists: function ensureAlwaysArrayExists(options2) {
        if (!("alwaysArray" in options2) || typeof options2.alwaysArray !== "boolean" && !$94db4f2abf87558b$var$isArray$2(options2.alwaysArray)) options2.alwaysArray = false;
    },
    ensureKeyExists: function ensureKeyExists(key, options2) {
        if (!(key + "Key" in options2) || typeof options2[key + "Key"] !== "string") options2[key + "Key"] = options2.compact ? "_" + key : key;
    },
    checkFnExists: function checkFnExists(key, options2) {
        return key + "Fn" in options2;
    }
};
var $94db4f2abf87558b$var$sax = $94db4f2abf87558b$var$sax$1;
var $94db4f2abf87558b$var$helper$2 = $94db4f2abf87558b$var$optionsHelper;
var $94db4f2abf87558b$var$isArray$1 = $94db4f2abf87558b$var$arrayHelper.isArray;
var $94db4f2abf87558b$var$options;
var $94db4f2abf87558b$var$currentElement$1;
function $94db4f2abf87558b$var$validateOptions$2(userOptions) {
    $94db4f2abf87558b$var$options = $94db4f2abf87558b$var$helper$2.copyOptions(userOptions);
    $94db4f2abf87558b$var$helper$2.ensureFlagExists("ignoreDeclaration", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.ensureFlagExists("ignoreInstruction", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.ensureFlagExists("ignoreAttributes", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.ensureFlagExists("ignoreText", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.ensureFlagExists("ignoreComment", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.ensureFlagExists("ignoreCdata", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.ensureFlagExists("ignoreDoctype", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.ensureFlagExists("compact", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.ensureFlagExists("alwaysChildren", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.ensureFlagExists("addParent", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.ensureFlagExists("trim", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.ensureFlagExists("nativeType", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.ensureFlagExists("nativeTypeAttributes", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.ensureFlagExists("sanitize", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.ensureFlagExists("instructionHasAttributes", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.ensureFlagExists("captureSpacesBetweenElements", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.ensureAlwaysArrayExists($94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.ensureKeyExists("declaration", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.ensureKeyExists("instruction", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.ensureKeyExists("attributes", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.ensureKeyExists("text", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.ensureKeyExists("comment", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.ensureKeyExists("cdata", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.ensureKeyExists("doctype", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.ensureKeyExists("type", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.ensureKeyExists("name", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.ensureKeyExists("elements", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.ensureKeyExists("parent", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.checkFnExists("doctype", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.checkFnExists("instruction", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.checkFnExists("cdata", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.checkFnExists("comment", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.checkFnExists("text", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.checkFnExists("instructionName", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.checkFnExists("elementName", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.checkFnExists("attributeName", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.checkFnExists("attributeValue", $94db4f2abf87558b$var$options);
    $94db4f2abf87558b$var$helper$2.checkFnExists("attributes", $94db4f2abf87558b$var$options);
    return $94db4f2abf87558b$var$options;
}
function $94db4f2abf87558b$var$nativeType(value) {
    var nValue = Number(value);
    if (!isNaN(nValue)) return nValue;
    var bValue = value.toLowerCase();
    if (bValue === "true") return true;
    else if (bValue === "false") return false;
    return value;
}
function $94db4f2abf87558b$var$addField(type, value) {
    var key;
    if ($94db4f2abf87558b$var$options.compact) {
        if (!$94db4f2abf87558b$var$currentElement$1[$94db4f2abf87558b$var$options[type + "Key"]] && ($94db4f2abf87558b$var$isArray$1($94db4f2abf87558b$var$options.alwaysArray) ? $94db4f2abf87558b$var$options.alwaysArray.indexOf($94db4f2abf87558b$var$options[type + "Key"]) !== -1 : $94db4f2abf87558b$var$options.alwaysArray)) $94db4f2abf87558b$var$currentElement$1[$94db4f2abf87558b$var$options[type + "Key"]] = [];
        if ($94db4f2abf87558b$var$currentElement$1[$94db4f2abf87558b$var$options[type + "Key"]] && !$94db4f2abf87558b$var$isArray$1($94db4f2abf87558b$var$currentElement$1[$94db4f2abf87558b$var$options[type + "Key"]])) $94db4f2abf87558b$var$currentElement$1[$94db4f2abf87558b$var$options[type + "Key"]] = [
            $94db4f2abf87558b$var$currentElement$1[$94db4f2abf87558b$var$options[type + "Key"]]
        ];
        if (type + "Fn" in $94db4f2abf87558b$var$options && typeof value === "string") value = $94db4f2abf87558b$var$options[type + "Fn"](value, $94db4f2abf87558b$var$currentElement$1);
        if (type === "instruction" && ("instructionFn" in $94db4f2abf87558b$var$options || "instructionNameFn" in $94db4f2abf87558b$var$options)) {
            for(key in value)if (value.hasOwnProperty(key)) {
                if ("instructionFn" in $94db4f2abf87558b$var$options) value[key] = $94db4f2abf87558b$var$options.instructionFn(value[key], key, $94db4f2abf87558b$var$currentElement$1);
                else {
                    var temp = value[key];
                    delete value[key];
                    value[$94db4f2abf87558b$var$options.instructionNameFn(key, temp, $94db4f2abf87558b$var$currentElement$1)] = temp;
                }
            }
        }
        if ($94db4f2abf87558b$var$isArray$1($94db4f2abf87558b$var$currentElement$1[$94db4f2abf87558b$var$options[type + "Key"]])) $94db4f2abf87558b$var$currentElement$1[$94db4f2abf87558b$var$options[type + "Key"]].push(value);
        else $94db4f2abf87558b$var$currentElement$1[$94db4f2abf87558b$var$options[type + "Key"]] = value;
    } else {
        if (!$94db4f2abf87558b$var$currentElement$1[$94db4f2abf87558b$var$options.elementsKey]) $94db4f2abf87558b$var$currentElement$1[$94db4f2abf87558b$var$options.elementsKey] = [];
        var element2 = {};
        element2[$94db4f2abf87558b$var$options.typeKey] = type;
        if (type === "instruction") {
            for(key in value){
                if (value.hasOwnProperty(key)) break;
            }
            element2[$94db4f2abf87558b$var$options.nameKey] = "instructionNameFn" in $94db4f2abf87558b$var$options ? $94db4f2abf87558b$var$options.instructionNameFn(key, value, $94db4f2abf87558b$var$currentElement$1) : key;
            if ($94db4f2abf87558b$var$options.instructionHasAttributes) {
                element2[$94db4f2abf87558b$var$options.attributesKey] = value[key][$94db4f2abf87558b$var$options.attributesKey];
                if ("instructionFn" in $94db4f2abf87558b$var$options) element2[$94db4f2abf87558b$var$options.attributesKey] = $94db4f2abf87558b$var$options.instructionFn(element2[$94db4f2abf87558b$var$options.attributesKey], key, $94db4f2abf87558b$var$currentElement$1);
            } else {
                if ("instructionFn" in $94db4f2abf87558b$var$options) value[key] = $94db4f2abf87558b$var$options.instructionFn(value[key], key, $94db4f2abf87558b$var$currentElement$1);
                element2[$94db4f2abf87558b$var$options.instructionKey] = value[key];
            }
        } else {
            if (type + "Fn" in $94db4f2abf87558b$var$options) value = $94db4f2abf87558b$var$options[type + "Fn"](value, $94db4f2abf87558b$var$currentElement$1);
            element2[$94db4f2abf87558b$var$options[type + "Key"]] = value;
        }
        if ($94db4f2abf87558b$var$options.addParent) element2[$94db4f2abf87558b$var$options.parentKey] = $94db4f2abf87558b$var$currentElement$1;
        $94db4f2abf87558b$var$currentElement$1[$94db4f2abf87558b$var$options.elementsKey].push(element2);
    }
}
function $94db4f2abf87558b$var$manipulateAttributes(attributes) {
    if ("attributesFn" in $94db4f2abf87558b$var$options && attributes) attributes = $94db4f2abf87558b$var$options.attributesFn(attributes, $94db4f2abf87558b$var$currentElement$1);
    if (($94db4f2abf87558b$var$options.trim || "attributeValueFn" in $94db4f2abf87558b$var$options || "attributeNameFn" in $94db4f2abf87558b$var$options || $94db4f2abf87558b$var$options.nativeTypeAttributes) && attributes) {
        var key;
        for(key in attributes)if (attributes.hasOwnProperty(key)) {
            if ($94db4f2abf87558b$var$options.trim) attributes[key] = attributes[key].trim();
            if ($94db4f2abf87558b$var$options.nativeTypeAttributes) attributes[key] = $94db4f2abf87558b$var$nativeType(attributes[key]);
            if ("attributeValueFn" in $94db4f2abf87558b$var$options) attributes[key] = $94db4f2abf87558b$var$options.attributeValueFn(attributes[key], key, $94db4f2abf87558b$var$currentElement$1);
            if ("attributeNameFn" in $94db4f2abf87558b$var$options) {
                var temp = attributes[key];
                delete attributes[key];
                attributes[$94db4f2abf87558b$var$options.attributeNameFn(key, attributes[key], $94db4f2abf87558b$var$currentElement$1)] = temp;
            }
        }
    }
    return attributes;
}
function $94db4f2abf87558b$var$onInstruction(instruction) {
    var attributes = {};
    if (instruction.body && (instruction.name.toLowerCase() === "xml" || $94db4f2abf87558b$var$options.instructionHasAttributes)) {
        var attrsRegExp = /([\w:-]+)\s*=\s*(?:"([^"]*)"|'([^']*)'|(\w+))\s*/g;
        var match;
        while((match = attrsRegExp.exec(instruction.body)) !== null)attributes[match[1]] = match[2] || match[3] || match[4];
        attributes = $94db4f2abf87558b$var$manipulateAttributes(attributes);
    }
    if (instruction.name.toLowerCase() === "xml") {
        if ($94db4f2abf87558b$var$options.ignoreDeclaration) return;
        $94db4f2abf87558b$var$currentElement$1[$94db4f2abf87558b$var$options.declarationKey] = {};
        if (Object.keys(attributes).length) $94db4f2abf87558b$var$currentElement$1[$94db4f2abf87558b$var$options.declarationKey][$94db4f2abf87558b$var$options.attributesKey] = attributes;
        if ($94db4f2abf87558b$var$options.addParent) $94db4f2abf87558b$var$currentElement$1[$94db4f2abf87558b$var$options.declarationKey][$94db4f2abf87558b$var$options.parentKey] = $94db4f2abf87558b$var$currentElement$1;
    } else {
        if ($94db4f2abf87558b$var$options.ignoreInstruction) return;
        if ($94db4f2abf87558b$var$options.trim) instruction.body = instruction.body.trim();
        var value = {};
        if ($94db4f2abf87558b$var$options.instructionHasAttributes && Object.keys(attributes).length) {
            value[instruction.name] = {};
            value[instruction.name][$94db4f2abf87558b$var$options.attributesKey] = attributes;
        } else value[instruction.name] = instruction.body;
        $94db4f2abf87558b$var$addField("instruction", value);
    }
}
function $94db4f2abf87558b$var$onStartElement(name, attributes) {
    var element2;
    if ((typeof name === "undefined" ? "undefined" : (0, $2bfPH._)(name)) === "object") {
        attributes = name.attributes;
        name = name.name;
    }
    attributes = $94db4f2abf87558b$var$manipulateAttributes(attributes);
    if ("elementNameFn" in $94db4f2abf87558b$var$options) name = $94db4f2abf87558b$var$options.elementNameFn(name, $94db4f2abf87558b$var$currentElement$1);
    if ($94db4f2abf87558b$var$options.compact) {
        element2 = {};
        if (!$94db4f2abf87558b$var$options.ignoreAttributes && attributes && Object.keys(attributes).length) {
            element2[$94db4f2abf87558b$var$options.attributesKey] = {};
            var key;
            for(key in attributes)if (attributes.hasOwnProperty(key)) element2[$94db4f2abf87558b$var$options.attributesKey][key] = attributes[key];
        }
        if (!(name in $94db4f2abf87558b$var$currentElement$1) && ($94db4f2abf87558b$var$isArray$1($94db4f2abf87558b$var$options.alwaysArray) ? $94db4f2abf87558b$var$options.alwaysArray.indexOf(name) !== -1 : $94db4f2abf87558b$var$options.alwaysArray)) $94db4f2abf87558b$var$currentElement$1[name] = [];
        if ($94db4f2abf87558b$var$currentElement$1[name] && !$94db4f2abf87558b$var$isArray$1($94db4f2abf87558b$var$currentElement$1[name])) $94db4f2abf87558b$var$currentElement$1[name] = [
            $94db4f2abf87558b$var$currentElement$1[name]
        ];
        if ($94db4f2abf87558b$var$isArray$1($94db4f2abf87558b$var$currentElement$1[name])) $94db4f2abf87558b$var$currentElement$1[name].push(element2);
        else $94db4f2abf87558b$var$currentElement$1[name] = element2;
    } else {
        if (!$94db4f2abf87558b$var$currentElement$1[$94db4f2abf87558b$var$options.elementsKey]) $94db4f2abf87558b$var$currentElement$1[$94db4f2abf87558b$var$options.elementsKey] = [];
        element2 = {};
        element2[$94db4f2abf87558b$var$options.typeKey] = "element";
        element2[$94db4f2abf87558b$var$options.nameKey] = name;
        if (!$94db4f2abf87558b$var$options.ignoreAttributes && attributes && Object.keys(attributes).length) element2[$94db4f2abf87558b$var$options.attributesKey] = attributes;
        if ($94db4f2abf87558b$var$options.alwaysChildren) element2[$94db4f2abf87558b$var$options.elementsKey] = [];
        $94db4f2abf87558b$var$currentElement$1[$94db4f2abf87558b$var$options.elementsKey].push(element2);
    }
    element2[$94db4f2abf87558b$var$options.parentKey] = $94db4f2abf87558b$var$currentElement$1;
    $94db4f2abf87558b$var$currentElement$1 = element2;
}
function $94db4f2abf87558b$var$onText(text) {
    if ($94db4f2abf87558b$var$options.ignoreText) return;
    if (!text.trim() && !$94db4f2abf87558b$var$options.captureSpacesBetweenElements) return;
    if ($94db4f2abf87558b$var$options.trim) text = text.trim();
    if ($94db4f2abf87558b$var$options.nativeType) text = $94db4f2abf87558b$var$nativeType(text);
    if ($94db4f2abf87558b$var$options.sanitize) text = text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    $94db4f2abf87558b$var$addField("text", text);
}
function $94db4f2abf87558b$var$onComment(comment) {
    if ($94db4f2abf87558b$var$options.ignoreComment) return;
    if ($94db4f2abf87558b$var$options.trim) comment = comment.trim();
    $94db4f2abf87558b$var$addField("comment", comment);
}
function $94db4f2abf87558b$var$onEndElement(name) {
    var parentElement = $94db4f2abf87558b$var$currentElement$1[$94db4f2abf87558b$var$options.parentKey];
    if (!$94db4f2abf87558b$var$options.addParent) delete $94db4f2abf87558b$var$currentElement$1[$94db4f2abf87558b$var$options.parentKey];
    $94db4f2abf87558b$var$currentElement$1 = parentElement;
}
function $94db4f2abf87558b$var$onCdata(cdata) {
    if ($94db4f2abf87558b$var$options.ignoreCdata) return;
    if ($94db4f2abf87558b$var$options.trim) cdata = cdata.trim();
    $94db4f2abf87558b$var$addField("cdata", cdata);
}
function $94db4f2abf87558b$var$onDoctype(doctype) {
    if ($94db4f2abf87558b$var$options.ignoreDoctype) return;
    doctype = doctype.replace(/^ /, "");
    if ($94db4f2abf87558b$var$options.trim) doctype = doctype.trim();
    $94db4f2abf87558b$var$addField("doctype", doctype);
}
function $94db4f2abf87558b$var$onError(error) {
    error.note = error;
}
var $94db4f2abf87558b$var$xml2js$2 = function xml2js$2(xml2, userOptions) {
    var parser = $94db4f2abf87558b$var$sax.parser(true, {});
    var result = {};
    $94db4f2abf87558b$var$currentElement$1 = result;
    $94db4f2abf87558b$var$options = $94db4f2abf87558b$var$validateOptions$2(userOptions);
    parser.opt = {
        strictEntities: true
    };
    parser.onopentag = $94db4f2abf87558b$var$onStartElement;
    parser.ontext = $94db4f2abf87558b$var$onText;
    parser.oncomment = $94db4f2abf87558b$var$onComment;
    parser.onclosetag = $94db4f2abf87558b$var$onEndElement;
    parser.onerror = $94db4f2abf87558b$var$onError;
    parser.oncdata = $94db4f2abf87558b$var$onCdata;
    parser.ondoctype = $94db4f2abf87558b$var$onDoctype;
    parser.onprocessinginstruction = $94db4f2abf87558b$var$onInstruction;
    parser.write(xml2).close();
    if (result[$94db4f2abf87558b$var$options.elementsKey]) {
        var temp = result[$94db4f2abf87558b$var$options.elementsKey];
        delete result[$94db4f2abf87558b$var$options.elementsKey];
        result[$94db4f2abf87558b$var$options.elementsKey] = temp;
        delete result.text;
    }
    return result;
};
var $94db4f2abf87558b$var$helper$1 = $94db4f2abf87558b$var$optionsHelper;
var $94db4f2abf87558b$var$xml2js$1 = $94db4f2abf87558b$var$xml2js$2;
function $94db4f2abf87558b$var$validateOptions$1(userOptions) {
    var options2 = $94db4f2abf87558b$var$helper$1.copyOptions(userOptions);
    $94db4f2abf87558b$var$helper$1.ensureSpacesExists(options2);
    return options2;
}
var $94db4f2abf87558b$var$xml2json$1 = function xml2json$1(xml2, userOptions) {
    var options2, js, json, parentKey;
    options2 = $94db4f2abf87558b$var$validateOptions$1(userOptions);
    js = $94db4f2abf87558b$var$xml2js$1(xml2, options2);
    parentKey = "compact" in options2 && options2.compact ? "_parent" : "parent";
    if ("addParent" in options2 && options2.addParent) json = JSON.stringify(js, function(k, v) {
        return k === parentKey ? "_" : v;
    }, options2.spaces);
    else json = JSON.stringify(js, null, options2.spaces);
    return json.replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
};
var $94db4f2abf87558b$var$helper = $94db4f2abf87558b$var$optionsHelper;
var $94db4f2abf87558b$var$isArray = $94db4f2abf87558b$var$arrayHelper.isArray;
var $94db4f2abf87558b$var$currentElement, $94db4f2abf87558b$var$currentElementName;
function $94db4f2abf87558b$var$validateOptions(userOptions) {
    var options2 = $94db4f2abf87558b$var$helper.copyOptions(userOptions);
    $94db4f2abf87558b$var$helper.ensureFlagExists("ignoreDeclaration", options2);
    $94db4f2abf87558b$var$helper.ensureFlagExists("ignoreInstruction", options2);
    $94db4f2abf87558b$var$helper.ensureFlagExists("ignoreAttributes", options2);
    $94db4f2abf87558b$var$helper.ensureFlagExists("ignoreText", options2);
    $94db4f2abf87558b$var$helper.ensureFlagExists("ignoreComment", options2);
    $94db4f2abf87558b$var$helper.ensureFlagExists("ignoreCdata", options2);
    $94db4f2abf87558b$var$helper.ensureFlagExists("ignoreDoctype", options2);
    $94db4f2abf87558b$var$helper.ensureFlagExists("compact", options2);
    $94db4f2abf87558b$var$helper.ensureFlagExists("indentText", options2);
    $94db4f2abf87558b$var$helper.ensureFlagExists("indentCdata", options2);
    $94db4f2abf87558b$var$helper.ensureFlagExists("indentAttributes", options2);
    $94db4f2abf87558b$var$helper.ensureFlagExists("indentInstruction", options2);
    $94db4f2abf87558b$var$helper.ensureFlagExists("fullTagEmptyElement", options2);
    $94db4f2abf87558b$var$helper.ensureFlagExists("noQuotesForNativeAttributes", options2);
    $94db4f2abf87558b$var$helper.ensureSpacesExists(options2);
    if (typeof options2.spaces === "number") options2.spaces = Array(options2.spaces + 1).join(" ");
    $94db4f2abf87558b$var$helper.ensureKeyExists("declaration", options2);
    $94db4f2abf87558b$var$helper.ensureKeyExists("instruction", options2);
    $94db4f2abf87558b$var$helper.ensureKeyExists("attributes", options2);
    $94db4f2abf87558b$var$helper.ensureKeyExists("text", options2);
    $94db4f2abf87558b$var$helper.ensureKeyExists("comment", options2);
    $94db4f2abf87558b$var$helper.ensureKeyExists("cdata", options2);
    $94db4f2abf87558b$var$helper.ensureKeyExists("doctype", options2);
    $94db4f2abf87558b$var$helper.ensureKeyExists("type", options2);
    $94db4f2abf87558b$var$helper.ensureKeyExists("name", options2);
    $94db4f2abf87558b$var$helper.ensureKeyExists("elements", options2);
    $94db4f2abf87558b$var$helper.checkFnExists("doctype", options2);
    $94db4f2abf87558b$var$helper.checkFnExists("instruction", options2);
    $94db4f2abf87558b$var$helper.checkFnExists("cdata", options2);
    $94db4f2abf87558b$var$helper.checkFnExists("comment", options2);
    $94db4f2abf87558b$var$helper.checkFnExists("text", options2);
    $94db4f2abf87558b$var$helper.checkFnExists("instructionName", options2);
    $94db4f2abf87558b$var$helper.checkFnExists("elementName", options2);
    $94db4f2abf87558b$var$helper.checkFnExists("attributeName", options2);
    $94db4f2abf87558b$var$helper.checkFnExists("attributeValue", options2);
    $94db4f2abf87558b$var$helper.checkFnExists("attributes", options2);
    $94db4f2abf87558b$var$helper.checkFnExists("fullTagEmptyElement", options2);
    return options2;
}
function $94db4f2abf87558b$var$writeIndentation(options2, depth, firstLine) {
    return (!firstLine && options2.spaces ? "\n" : "") + Array(depth + 1).join(options2.spaces);
}
function $94db4f2abf87558b$var$writeAttributes(attributes, options2, depth) {
    if (options2.ignoreAttributes) return "";
    if ("attributesFn" in options2) attributes = options2.attributesFn(attributes, $94db4f2abf87558b$var$currentElementName, $94db4f2abf87558b$var$currentElement);
    var key, attr, attrName, quote, result = [];
    for(key in attributes)if (attributes.hasOwnProperty(key) && attributes[key] !== null && attributes[key] !== void 0) {
        quote = options2.noQuotesForNativeAttributes && typeof attributes[key] !== "string" ? "" : '"';
        attr = "" + attributes[key];
        attr = attr.replace(/"/g, "&quot;");
        attrName = "attributeNameFn" in options2 ? options2.attributeNameFn(key, attr, $94db4f2abf87558b$var$currentElementName, $94db4f2abf87558b$var$currentElement) : key;
        result.push(options2.spaces && options2.indentAttributes ? $94db4f2abf87558b$var$writeIndentation(options2, depth + 1, false) : " ");
        result.push(attrName + "=" + quote + ("attributeValueFn" in options2 ? options2.attributeValueFn(attr, key, $94db4f2abf87558b$var$currentElementName, $94db4f2abf87558b$var$currentElement) : attr) + quote);
    }
    if (attributes && Object.keys(attributes).length && options2.spaces && options2.indentAttributes) result.push($94db4f2abf87558b$var$writeIndentation(options2, depth, false));
    return result.join("");
}
function $94db4f2abf87558b$var$writeDeclaration(declaration, options2, depth) {
    $94db4f2abf87558b$var$currentElement = declaration;
    $94db4f2abf87558b$var$currentElementName = "xml";
    return options2.ignoreDeclaration ? "" : "<?xml" + $94db4f2abf87558b$var$writeAttributes(declaration[options2.attributesKey], options2, depth) + "?>";
}
function $94db4f2abf87558b$var$writeInstruction(instruction, options2, depth) {
    if (options2.ignoreInstruction) return "";
    var key;
    for(key in instruction){
        if (instruction.hasOwnProperty(key)) break;
    }
    var instructionName = "instructionNameFn" in options2 ? options2.instructionNameFn(key, instruction[key], $94db4f2abf87558b$var$currentElementName, $94db4f2abf87558b$var$currentElement) : key;
    if ((0, $2bfPH._)(instruction[key]) === "object") {
        $94db4f2abf87558b$var$currentElement = instruction;
        $94db4f2abf87558b$var$currentElementName = instructionName;
        return "<?" + instructionName + $94db4f2abf87558b$var$writeAttributes(instruction[key][options2.attributesKey], options2, depth) + "?>";
    } else {
        var instructionValue = instruction[key] ? instruction[key] : "";
        if ("instructionFn" in options2) instructionValue = options2.instructionFn(instructionValue, key, $94db4f2abf87558b$var$currentElementName, $94db4f2abf87558b$var$currentElement);
        return "<?" + instructionName + (instructionValue ? " " + instructionValue : "") + "?>";
    }
}
function $94db4f2abf87558b$var$writeComment(comment, options2) {
    return options2.ignoreComment ? "" : "<!--" + ("commentFn" in options2 ? options2.commentFn(comment, $94db4f2abf87558b$var$currentElementName, $94db4f2abf87558b$var$currentElement) : comment) + "-->";
}
function $94db4f2abf87558b$var$writeCdata(cdata, options2) {
    return options2.ignoreCdata ? "" : "<![CDATA[" + ("cdataFn" in options2 ? options2.cdataFn(cdata, $94db4f2abf87558b$var$currentElementName, $94db4f2abf87558b$var$currentElement) : cdata.replace("]]>", "]]]]><![CDATA[>")) + "]]>";
}
function $94db4f2abf87558b$var$writeDoctype(doctype, options2) {
    return options2.ignoreDoctype ? "" : "<!DOCTYPE " + ("doctypeFn" in options2 ? options2.doctypeFn(doctype, $94db4f2abf87558b$var$currentElementName, $94db4f2abf87558b$var$currentElement) : doctype) + ">";
}
function $94db4f2abf87558b$var$writeText(text, options2) {
    if (options2.ignoreText) return "";
    text = "" + text;
    text = text.replace(/&amp;/g, "&");
    text = text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    return "textFn" in options2 ? options2.textFn(text, $94db4f2abf87558b$var$currentElementName, $94db4f2abf87558b$var$currentElement) : text;
}
function $94db4f2abf87558b$var$hasContent(element2, options2) {
    var i;
    if (element2.elements && element2.elements.length) for(i = 0; i < element2.elements.length; ++i)switch(element2.elements[i][options2.typeKey]){
        case "text":
            if (options2.indentText) return true;
            break;
        case "cdata":
            if (options2.indentCdata) return true;
            break;
        case "instruction":
            if (options2.indentInstruction) return true;
            break;
        case "doctype":
        case "comment":
        case "element":
            return true;
        default:
            return true;
    }
    return false;
}
function $94db4f2abf87558b$var$writeElement(element2, options2, depth) {
    $94db4f2abf87558b$var$currentElement = element2;
    $94db4f2abf87558b$var$currentElementName = element2.name;
    var xml2 = [], elementName = "elementNameFn" in options2 ? options2.elementNameFn(element2.name, element2) : element2.name;
    xml2.push("<" + elementName);
    if (element2[options2.attributesKey]) xml2.push($94db4f2abf87558b$var$writeAttributes(element2[options2.attributesKey], options2, depth));
    var withClosingTag = element2[options2.elementsKey] && element2[options2.elementsKey].length || element2[options2.attributesKey] && element2[options2.attributesKey]["xml:space"] === "preserve";
    if (!withClosingTag) {
        if ("fullTagEmptyElementFn" in options2) withClosingTag = options2.fullTagEmptyElementFn(element2.name, element2);
        else withClosingTag = options2.fullTagEmptyElement;
    }
    if (withClosingTag) {
        xml2.push(">");
        if (element2[options2.elementsKey] && element2[options2.elementsKey].length) {
            xml2.push($94db4f2abf87558b$var$writeElements(element2[options2.elementsKey], options2, depth + 1));
            $94db4f2abf87558b$var$currentElement = element2;
            $94db4f2abf87558b$var$currentElementName = element2.name;
        }
        xml2.push(options2.spaces && $94db4f2abf87558b$var$hasContent(element2, options2) ? "\n" + Array(depth + 1).join(options2.spaces) : "");
        xml2.push("</" + elementName + ">");
    } else xml2.push("/>");
    return xml2.join("");
}
function $94db4f2abf87558b$var$writeElements(elements, options2, depth, firstLine) {
    return elements.reduce(function(xml2, element2) {
        var indent = $94db4f2abf87558b$var$writeIndentation(options2, depth, firstLine && !xml2);
        switch(element2.type){
            case "element":
                return xml2 + indent + $94db4f2abf87558b$var$writeElement(element2, options2, depth);
            case "comment":
                return xml2 + indent + $94db4f2abf87558b$var$writeComment(element2[options2.commentKey], options2);
            case "doctype":
                return xml2 + indent + $94db4f2abf87558b$var$writeDoctype(element2[options2.doctypeKey], options2);
            case "cdata":
                return xml2 + (options2.indentCdata ? indent : "") + $94db4f2abf87558b$var$writeCdata(element2[options2.cdataKey], options2);
            case "text":
                return xml2 + (options2.indentText ? indent : "") + $94db4f2abf87558b$var$writeText(element2[options2.textKey], options2);
            case "instruction":
                var instruction = {};
                instruction[element2[options2.nameKey]] = element2[options2.attributesKey] ? element2 : element2[options2.instructionKey];
                return xml2 + (options2.indentInstruction ? indent : "") + $94db4f2abf87558b$var$writeInstruction(instruction, options2, depth);
        }
    }, "");
}
function $94db4f2abf87558b$var$hasContentCompact(element2, options2, anyContent) {
    var key;
    for(key in element2)if (element2.hasOwnProperty(key)) switch(key){
        case options2.parentKey:
        case options2.attributesKey:
            break;
        case options2.textKey:
            if (options2.indentText || anyContent) return true;
            break;
        case options2.cdataKey:
            if (options2.indentCdata || anyContent) return true;
            break;
        case options2.instructionKey:
            if (options2.indentInstruction || anyContent) return true;
            break;
        case options2.doctypeKey:
        case options2.commentKey:
            return true;
        default:
            return true;
    }
    return false;
}
function $94db4f2abf87558b$var$writeElementCompact(element2, name, options2, depth, indent) {
    $94db4f2abf87558b$var$currentElement = element2;
    $94db4f2abf87558b$var$currentElementName = name;
    var elementName = "elementNameFn" in options2 ? options2.elementNameFn(name, element2) : name;
    if (typeof element2 === "undefined" || element2 === null || element2 === "") return "fullTagEmptyElementFn" in options2 && options2.fullTagEmptyElementFn(name, element2) || options2.fullTagEmptyElement ? "<" + elementName + "></" + elementName + ">" : "<" + elementName + "/>";
    var xml2 = [];
    if (name) {
        xml2.push("<" + elementName);
        if ((typeof element2 === "undefined" ? "undefined" : (0, $2bfPH._)(element2)) !== "object") {
            xml2.push(">" + $94db4f2abf87558b$var$writeText(element2, options2) + "</" + elementName + ">");
            return xml2.join("");
        }
        if (element2[options2.attributesKey]) xml2.push($94db4f2abf87558b$var$writeAttributes(element2[options2.attributesKey], options2, depth));
        var withClosingTag = $94db4f2abf87558b$var$hasContentCompact(element2, options2, true) || element2[options2.attributesKey] && element2[options2.attributesKey]["xml:space"] === "preserve";
        if (!withClosingTag) {
            if ("fullTagEmptyElementFn" in options2) withClosingTag = options2.fullTagEmptyElementFn(name, element2);
            else withClosingTag = options2.fullTagEmptyElement;
        }
        if (withClosingTag) xml2.push(">");
        else {
            xml2.push("/>");
            return xml2.join("");
        }
    }
    xml2.push($94db4f2abf87558b$var$writeElementsCompact(element2, options2, depth + 1, false));
    $94db4f2abf87558b$var$currentElement = element2;
    $94db4f2abf87558b$var$currentElementName = name;
    if (name) xml2.push((indent ? $94db4f2abf87558b$var$writeIndentation(options2, depth, false) : "") + "</" + elementName + ">");
    return xml2.join("");
}
function $94db4f2abf87558b$var$writeElementsCompact(element2, options2, depth, firstLine) {
    var i, key, nodes, xml2 = [];
    for(key in element2)if (element2.hasOwnProperty(key)) {
        nodes = $94db4f2abf87558b$var$isArray(element2[key]) ? element2[key] : [
            element2[key]
        ];
        for(i = 0; i < nodes.length; ++i){
            switch(key){
                case options2.declarationKey:
                    xml2.push($94db4f2abf87558b$var$writeDeclaration(nodes[i], options2, depth));
                    break;
                case options2.instructionKey:
                    xml2.push((options2.indentInstruction ? $94db4f2abf87558b$var$writeIndentation(options2, depth, firstLine) : "") + $94db4f2abf87558b$var$writeInstruction(nodes[i], options2, depth));
                    break;
                case options2.attributesKey:
                case options2.parentKey:
                    break;
                case options2.textKey:
                    xml2.push((options2.indentText ? $94db4f2abf87558b$var$writeIndentation(options2, depth, firstLine) : "") + $94db4f2abf87558b$var$writeText(nodes[i], options2));
                    break;
                case options2.cdataKey:
                    xml2.push((options2.indentCdata ? $94db4f2abf87558b$var$writeIndentation(options2, depth, firstLine) : "") + $94db4f2abf87558b$var$writeCdata(nodes[i], options2));
                    break;
                case options2.doctypeKey:
                    xml2.push($94db4f2abf87558b$var$writeIndentation(options2, depth, firstLine) + $94db4f2abf87558b$var$writeDoctype(nodes[i], options2));
                    break;
                case options2.commentKey:
                    xml2.push($94db4f2abf87558b$var$writeIndentation(options2, depth, firstLine) + $94db4f2abf87558b$var$writeComment(nodes[i], options2));
                    break;
                default:
                    xml2.push($94db4f2abf87558b$var$writeIndentation(options2, depth, firstLine) + $94db4f2abf87558b$var$writeElementCompact(nodes[i], key, options2, depth, $94db4f2abf87558b$var$hasContentCompact(nodes[i], options2)));
            }
            firstLine = firstLine && !xml2.length;
        }
    }
    return xml2.join("");
}
var $94db4f2abf87558b$var$js2xml$2 = function js2xml$2(js, options2) {
    options2 = $94db4f2abf87558b$var$validateOptions(options2);
    var xml2 = [];
    $94db4f2abf87558b$var$currentElement = js;
    $94db4f2abf87558b$var$currentElementName = "_root_";
    if (options2.compact) xml2.push($94db4f2abf87558b$var$writeElementsCompact(js, options2, 0, true));
    else {
        if (js[options2.declarationKey]) xml2.push($94db4f2abf87558b$var$writeDeclaration(js[options2.declarationKey], options2, 0));
        if (js[options2.elementsKey] && js[options2.elementsKey].length) xml2.push($94db4f2abf87558b$var$writeElements(js[options2.elementsKey], options2, 0, !xml2.length));
    }
    return xml2.join("");
};
var $94db4f2abf87558b$var$js2xml$1 = $94db4f2abf87558b$var$js2xml$2;
var $94db4f2abf87558b$var$json2xml$1 = function json2xml$1(json, options2) {
    if (json instanceof $94db4f2abf87558b$var$Buffer) json = json.toString();
    var js = null;
    if (typeof json === "string") try {
        js = JSON.parse(json);
    } catch (e) {
        throw new Error("The JSON structure is invalid");
    }
    else js = json;
    return $94db4f2abf87558b$var$js2xml$1(js, options2);
};
var $94db4f2abf87558b$var$xml2js = $94db4f2abf87558b$var$xml2js$2;
var $94db4f2abf87558b$var$xml2json = $94db4f2abf87558b$var$xml2json$1;
var $94db4f2abf87558b$var$js2xml = $94db4f2abf87558b$var$js2xml$2;
var $94db4f2abf87558b$var$json2xml = $94db4f2abf87558b$var$json2xml$1;
var $94db4f2abf87558b$var$lib = {
    xml2js: $94db4f2abf87558b$var$xml2js,
    xml2json: $94db4f2abf87558b$var$xml2json,
    js2xml: $94db4f2abf87558b$var$js2xml,
    json2xml: $94db4f2abf87558b$var$json2xml
};
var $94db4f2abf87558b$export$cd3b8f5143756514 = function(element2) {
    switch(element2.type){
        case void 0:
        case "element":
            var xmlComponent = new $94db4f2abf87558b$export$77c93fcadb03b2c4(element2.name, element2.attributes);
            var childElements = element2.elements || [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = childElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var childElm = _step.value;
                    var child = $94db4f2abf87558b$export$cd3b8f5143756514(childElm);
                    if (child !== void 0) xmlComponent.push(child);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return xmlComponent;
        case "text":
            return element2.text;
        default:
            return void 0;
    }
};
var $94db4f2abf87558b$var$ImportedXmlComponentAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(ImportedXmlComponentAttributes, XmlAttributeComponent);
    function ImportedXmlComponentAttributes() {
        (0, $gd0sY._)(this, ImportedXmlComponentAttributes);
        return (0, $8xMIM._)(this, ImportedXmlComponentAttributes, arguments);
    }
    return ImportedXmlComponentAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$77c93fcadb03b2c4 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(ImportedXmlComponent, XmlComponent);
    function ImportedXmlComponent(rootKey, _attr) {
        (0, $gd0sY._)(this, ImportedXmlComponent);
        var _this;
        _this = (0, $8xMIM._)(this, ImportedXmlComponent, [
            rootKey
        ]);
        if (_attr) _this.root.push(new $94db4f2abf87558b$var$ImportedXmlComponentAttributes(_attr));
        return _this;
    }
    (0, $7cSld._)(ImportedXmlComponent, [
        {
            key: "push",
            value: function push(xmlComponent) {
                this.root.push(xmlComponent);
            }
        }
    ], [
        {
            key: "fromXmlString",
            value: /**
   * Converts the xml string to a XmlComponent tree.
   *
   * @param importedContent xml content of the imported component
   */ function fromXmlString(importedContent) {
                var xmlObj = $94db4f2abf87558b$var$lib.xml2js(importedContent, {
                    compact: false
                });
                return $94db4f2abf87558b$export$cd3b8f5143756514(xmlObj);
            }
        }
    ]);
    return ImportedXmlComponent;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$f3691753fff0e91f = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(ImportedRootElementAttributes, XmlComponent);
    function ImportedRootElementAttributes(_attr) {
        (0, $gd0sY._)(this, ImportedRootElementAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, ImportedRootElementAttributes, [
            ""
        ]);
        _this._attr = _attr;
        return _this;
    }
    (0, $7cSld._)(ImportedRootElementAttributes, [
        {
            key: "prepForXml",
            value: function prepForXml(_) {
                return {
                    _attr: this._attr
                };
            }
        }
    ]);
    return ImportedRootElementAttributes;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$c4bbce4cc16b0237 = "";
var $94db4f2abf87558b$export$646396cb36770d6c = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(InitializableXmlComponent, XmlComponent);
    function InitializableXmlComponent(rootKey, initComponent) {
        (0, $gd0sY._)(this, InitializableXmlComponent);
        var _this;
        _this = (0, $8xMIM._)(this, InitializableXmlComponent, [
            rootKey
        ]);
        if (initComponent) _this.root = initComponent.root;
        return _this;
    }
    return InitializableXmlComponent;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$3965b376946dc953 = function(val) {
    if (isNaN(val)) throw new Error("Invalid value '".concat(val, "' specified. Must be an integer."));
    return Math.floor(val);
};
var $94db4f2abf87558b$export$58d953e127c6884e = function(val) {
    var value = $94db4f2abf87558b$export$3965b376946dc953(val);
    if (value < 0) throw new Error("Invalid value '".concat(val, "' specified. Must be a positive integer."));
    return value;
};
var $94db4f2abf87558b$var$hexBinary = function(val, length) {
    var expectedLength = length * 2;
    if (val.length !== expectedLength || isNaN(Number("0x".concat(val)))) throw new Error("Invalid hex value '".concat(val, "'. Expected ").concat(expectedLength, " digit hex value"));
    return val;
};
var $94db4f2abf87558b$export$a5c0e816bf39352b = function(val) {
    return $94db4f2abf87558b$var$hexBinary(val, 4);
};
var $94db4f2abf87558b$export$545c905536cb1e26 = function(val) {
    return $94db4f2abf87558b$var$hexBinary(val, 2);
};
var $94db4f2abf87558b$export$2a22699fe7518b3d = function(val) {
    return $94db4f2abf87558b$var$hexBinary(val, 1);
};
var $94db4f2abf87558b$export$931bfbdf25b9a036 = function(val) {
    var unit = val.slice(-2);
    var amount = val.substring(0, val.length - 2);
    return "".concat(Number(amount)).concat(unit);
};
var $94db4f2abf87558b$export$f6298d17c608c740 = function(val) {
    var value = $94db4f2abf87558b$export$931bfbdf25b9a036(val);
    if (parseFloat(value) < 0) throw new Error("Invalid value '".concat(value, "' specified. Expected a positive number."));
    return value;
};
var $94db4f2abf87558b$export$39c9e6e42c794b97 = function(val) {
    if (val === "auto") return val;
    var color = val.charAt(0) === "#" ? val.substring(1) : val;
    return $94db4f2abf87558b$var$hexBinary(color, 3);
};
var $94db4f2abf87558b$export$866cabb7ed3455e9 = function(val) {
    return typeof val === "string" ? $94db4f2abf87558b$export$931bfbdf25b9a036(val) : $94db4f2abf87558b$export$3965b376946dc953(val);
};
var $94db4f2abf87558b$export$3813118357b6f66a = function(val) {
    return typeof val === "string" ? $94db4f2abf87558b$export$f6298d17c608c740(val) : $94db4f2abf87558b$export$58d953e127c6884e(val);
};
var $94db4f2abf87558b$export$100aeae069b884f4 = function(val) {
    return typeof val === "string" ? $94db4f2abf87558b$export$931bfbdf25b9a036(val) : $94db4f2abf87558b$export$3965b376946dc953(val);
};
var $94db4f2abf87558b$export$ffe63bc01ceacb3d = function(val) {
    return typeof val === "string" ? $94db4f2abf87558b$export$f6298d17c608c740(val) : $94db4f2abf87558b$export$58d953e127c6884e(val);
};
var $94db4f2abf87558b$export$ac4c0555c0ebcb52 = function(val) {
    var percent = val.substring(0, val.length - 1);
    return "".concat(Number(percent), "%");
};
var $94db4f2abf87558b$export$cb4dd365b0fd654b = function(val) {
    if (typeof val === "number") return $94db4f2abf87558b$export$3965b376946dc953(val);
    if (val.slice(-1) === "%") return $94db4f2abf87558b$export$ac4c0555c0ebcb52(val);
    return $94db4f2abf87558b$export$931bfbdf25b9a036(val);
};
var $94db4f2abf87558b$export$1363940119b3ec20 = $94db4f2abf87558b$export$58d953e127c6884e;
var $94db4f2abf87558b$export$1a8952df865d374b = $94db4f2abf87558b$export$58d953e127c6884e;
var $94db4f2abf87558b$export$89d9edd4d0429282 = function(val) {
    return val.toISOString();
};
var $94db4f2abf87558b$export$9ea807bff926c949 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(OnOffElement, XmlComponent);
    function OnOffElement(name) {
        var val = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        (0, $gd0sY._)(this, OnOffElement);
        var _this;
        _this = (0, $8xMIM._)(this, OnOffElement, [
            name
        ]);
        if (val !== true) _this.root.push(new $94db4f2abf87558b$export$21991851b0bb231f({
            val: val
        }));
        return _this;
    }
    return OnOffElement;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$47eaf94bc2b4abbf = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(HpsMeasureElement, XmlComponent);
    function HpsMeasureElement(name, val) {
        (0, $gd0sY._)(this, HpsMeasureElement);
        var _this;
        _this = (0, $8xMIM._)(this, HpsMeasureElement, [
            name
        ]);
        _this.root.push(new $94db4f2abf87558b$export$21991851b0bb231f({
            val: $94db4f2abf87558b$export$3813118357b6f66a(val)
        }));
        return _this;
    }
    return HpsMeasureElement;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$96977b263db98d55 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(EmptyElement, XmlComponent);
    function EmptyElement() {
        (0, $gd0sY._)(this, EmptyElement);
        return (0, $8xMIM._)(this, EmptyElement, arguments);
    }
    return EmptyElement;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$eacbde36aa74068 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(StringValueElement, XmlComponent);
    function StringValueElement(name, val) {
        (0, $gd0sY._)(this, StringValueElement);
        var _this;
        _this = (0, $8xMIM._)(this, StringValueElement, [
            name
        ]);
        _this.root.push(new $94db4f2abf87558b$export$21991851b0bb231f({
            val: val
        }));
        return _this;
    }
    return StringValueElement;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$e9d3b59c3f434130 = function(name, value) {
    return new $94db4f2abf87558b$export$da493cbe1334accc({
        name: name,
        attributes: {
            value: {
                key: "w:val",
                value: value
            }
        }
    });
};
var $94db4f2abf87558b$export$7c6d6f8dacf13e40 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(NumberValueElement, XmlComponent);
    function NumberValueElement(name, val) {
        (0, $gd0sY._)(this, NumberValueElement);
        var _this;
        _this = (0, $8xMIM._)(this, NumberValueElement, [
            name
        ]);
        _this.root.push(new $94db4f2abf87558b$export$21991851b0bb231f({
            val: val
        }));
        return _this;
    }
    return NumberValueElement;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$5616f64bff69d2 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(StringEnumValueElement, XmlComponent);
    function StringEnumValueElement(name, val) {
        (0, $gd0sY._)(this, StringEnumValueElement);
        var _this;
        _this = (0, $8xMIM._)(this, StringEnumValueElement, [
            name
        ]);
        _this.root.push(new $94db4f2abf87558b$export$21991851b0bb231f({
            val: val
        }));
        return _this;
    }
    return StringEnumValueElement;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$5ef82a33e5d8976f = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(StringContainer, XmlComponent);
    function StringContainer(name, val) {
        (0, $gd0sY._)(this, StringContainer);
        var _this;
        _this = (0, $8xMIM._)(this, StringContainer, [
            name
        ]);
        _this.root.push(val);
        return _this;
    }
    return StringContainer;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$da493cbe1334accc = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(BuilderElement, XmlComponent);
    function BuilderElement(param) {
        var name = param.name, attributes = param.attributes, children = param.children;
        var _this_root;
        (0, $gd0sY._)(this, BuilderElement);
        var _this;
        _this = (0, $8xMIM._)(this, BuilderElement, [
            name
        ]);
        if (attributes) _this.root.push(new $94db4f2abf87558b$export$b95d92bd70e2302a(attributes));
        if (children) (_this_root = _this.root).push.apply(_this_root, (0, $6zk1M._)(children));
        return _this;
    }
    return BuilderElement;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$97e681628fc5cdf4 = {
    /** Align Start */ START: "start",
    /** Align Center */ CENTER: "center",
    /** End */ END: "end",
    /** Justified */ BOTH: "both",
    /** Medium Kashida Length */ MEDIUM_KASHIDA: "mediumKashida",
    /** Distribute All Characters Equally */ DISTRIBUTE: "distribute",
    /** Align to List Tab */ NUM_TAB: "numTab",
    /** Widest Kashida Length */ HIGH_KASHIDA: "highKashida",
    /** Low Kashida Length */ LOW_KASHIDA: "lowKashida",
    /** Thai Language Justification */ THAI_DISTRIBUTE: "thaiDistribute",
    /** Align Left */ LEFT: "left",
    /** Align Right */ RIGHT: "right",
    /** Justified */ JUSTIFIED: "both"
};
var $94db4f2abf87558b$export$1f0c0d50b8c8ca7c = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(AlignmentAttributes, XmlAttributeComponent);
    function AlignmentAttributes() {
        (0, $gd0sY._)(this, AlignmentAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, AlignmentAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            val: "w:val"
        });
        return _this;
    }
    return AlignmentAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$9d7927214ed7d2cf = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Alignment, XmlComponent);
    function Alignment(type) {
        (0, $gd0sY._)(this, Alignment);
        var _this;
        _this = (0, $8xMIM._)(this, Alignment, [
            "w:jc"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$1f0c0d50b8c8ca7c({
            val: type
        }));
        return _this;
    }
    return Alignment;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$a6733098a4eb57cf = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(BorderElement, XmlComponent);
    function BorderElement(elementName, param) {
        var color = param.color, size = param.size, space = param.space, style = param.style;
        (0, $gd0sY._)(this, BorderElement);
        var _this;
        _this = (0, $8xMIM._)(this, BorderElement, [
            elementName
        ]);
        _this.root.push(new $94db4f2abf87558b$var$BordersAttributes({
            style: style,
            color: color === void 0 ? void 0 : $94db4f2abf87558b$export$39c9e6e42c794b97(color),
            size: size === void 0 ? void 0 : $94db4f2abf87558b$export$1363940119b3ec20(size),
            space: space === void 0 ? void 0 : $94db4f2abf87558b$export$1a8952df865d374b(space)
        }));
        return _this;
    }
    return BorderElement;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$BordersAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(BordersAttributes, XmlAttributeComponent);
    function BordersAttributes() {
        (0, $gd0sY._)(this, BordersAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, BordersAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            style: "w:val",
            color: "w:color",
            size: "w:sz",
            space: "w:space"
        });
        return _this;
    }
    return BordersAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$5f9c7f3ab6d185b = {
    SINGLE: "single",
    DASH_DOT_STROKED: "dashDotStroked",
    DASHED: "dashed",
    DASH_SMALL_GAP: "dashSmallGap",
    DOT_DASH: "dotDash",
    DOT_DOT_DASH: "dotDotDash",
    DOTTED: "dotted",
    DOUBLE: "double",
    DOUBLE_WAVE: "doubleWave",
    INSET: "inset",
    NIL: "nil",
    NONE: "none",
    OUTSET: "outset",
    THICK: "thick",
    THICK_THIN_LARGE_GAP: "thickThinLargeGap",
    THICK_THIN_MEDIUM_GAP: "thickThinMediumGap",
    THICK_THIN_SMALL_GAP: "thickThinSmallGap",
    THIN_THICK_LARGE_GAP: "thinThickLargeGap",
    THIN_THICK_MEDIUM_GAP: "thinThickMediumGap",
    THIN_THICK_SMALL_GAP: "thinThickSmallGap",
    THIN_THICK_THIN_LARGE_GAP: "thinThickThinLargeGap",
    THIN_THICK_THIN_MEDIUM_GAP: "thinThickThinMediumGap",
    THIN_THICK_THIN_SMALL_GAP: "thinThickThinSmallGap",
    THREE_D_EMBOSS: "threeDEmboss",
    THREE_D_ENGRAVE: "threeDEngrave",
    TRIPLE: "triple",
    WAVE: "wave"
};
var $94db4f2abf87558b$export$d8e9c9d63e86d41e = /*#__PURE__*/ function(IgnoreIfEmptyXmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Border, IgnoreIfEmptyXmlComponent);
    function Border(options2) {
        (0, $gd0sY._)(this, Border);
        var _this;
        _this = (0, $8xMIM._)(this, Border, [
            "w:pBdr"
        ]);
        if (options2.top) _this.root.push(new $94db4f2abf87558b$export$a6733098a4eb57cf("w:top", options2.top));
        if (options2.bottom) _this.root.push(new $94db4f2abf87558b$export$a6733098a4eb57cf("w:bottom", options2.bottom));
        if (options2.left) _this.root.push(new $94db4f2abf87558b$export$a6733098a4eb57cf("w:left", options2.left));
        if (options2.right) _this.root.push(new $94db4f2abf87558b$export$a6733098a4eb57cf("w:right", options2.right));
        return _this;
    }
    return Border;
}($94db4f2abf87558b$export$951524d865ce655a);
var $94db4f2abf87558b$export$ae968d136aefa6fc = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(ThematicBreak, XmlComponent);
    function ThematicBreak() {
        (0, $gd0sY._)(this, ThematicBreak);
        var _this;
        _this = (0, $8xMIM._)(this, ThematicBreak, [
            "w:pBdr"
        ]);
        var bottom = new $94db4f2abf87558b$export$a6733098a4eb57cf("w:bottom", {
            color: "auto",
            space: 1,
            style: $94db4f2abf87558b$export$5f9c7f3ab6d185b.SINGLE,
            size: 6
        });
        _this.root.push(bottom);
        return _this;
    }
    return ThematicBreak;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$e883eb7bc5d8ee6 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Indent, XmlComponent);
    function Indent(param) {
        var start = param.start, end = param.end, left = param.left, right = param.right, hanging = param.hanging, firstLine = param.firstLine;
        (0, $gd0sY._)(this, Indent);
        var _this;
        _this = (0, $8xMIM._)(this, Indent, [
            "w:ind"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$b95d92bd70e2302a({
            start: {
                key: "w:start",
                value: start === void 0 ? void 0 : $94db4f2abf87558b$export$866cabb7ed3455e9(start)
            },
            end: {
                key: "w:end",
                value: end === void 0 ? void 0 : $94db4f2abf87558b$export$866cabb7ed3455e9(end)
            },
            left: {
                key: "w:left",
                value: left === void 0 ? void 0 : $94db4f2abf87558b$export$866cabb7ed3455e9(left)
            },
            right: {
                key: "w:right",
                value: right === void 0 ? void 0 : $94db4f2abf87558b$export$866cabb7ed3455e9(right)
            },
            hanging: {
                key: "w:hanging",
                value: hanging === void 0 ? void 0 : $94db4f2abf87558b$export$ffe63bc01ceacb3d(hanging)
            },
            firstLine: {
                key: "w:firstLine",
                value: firstLine === void 0 ? void 0 : $94db4f2abf87558b$export$ffe63bc01ceacb3d(firstLine)
            }
        }));
        return _this;
    }
    return Indent;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$Break$1 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Break, XmlComponent);
    function Break() {
        (0, $gd0sY._)(this, Break);
        return (0, $8xMIM._)(this, Break, [
            "w:br"
        ]);
    }
    return Break;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$FieldCharacterType = {
    BEGIN: "begin",
    END: "end",
    SEPARATE: "separate"
};
var $94db4f2abf87558b$var$FidCharAttrs = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(FidCharAttrs, XmlAttributeComponent);
    function FidCharAttrs() {
        (0, $gd0sY._)(this, FidCharAttrs);
        var _this;
        _this = (0, $8xMIM._)(this, FidCharAttrs, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            type: "w:fldCharType",
            dirty: "w:dirty"
        });
        return _this;
    }
    return FidCharAttrs;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$Begin = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Begin, XmlComponent);
    function Begin(dirty) {
        (0, $gd0sY._)(this, Begin);
        var _this;
        _this = (0, $8xMIM._)(this, Begin, [
            "w:fldChar"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$FidCharAttrs({
            type: $94db4f2abf87558b$var$FieldCharacterType.BEGIN,
            dirty: dirty
        }));
        return _this;
    }
    return Begin;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$Separate = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Separate, XmlComponent);
    function Separate(dirty) {
        (0, $gd0sY._)(this, Separate);
        var _this;
        _this = (0, $8xMIM._)(this, Separate, [
            "w:fldChar"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$FidCharAttrs({
            type: $94db4f2abf87558b$var$FieldCharacterType.SEPARATE,
            dirty: dirty
        }));
        return _this;
    }
    return Separate;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$End = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(End, XmlComponent);
    function End(dirty) {
        (0, $gd0sY._)(this, End);
        var _this;
        _this = (0, $8xMIM._)(this, End, [
            "w:fldChar"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$FidCharAttrs({
            type: $94db4f2abf87558b$var$FieldCharacterType.END,
            dirty: dirty
        }));
        return _this;
    }
    return End;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$ac6f53b7b1ca6d = {
    CENTER: "center",
    INSIDE: "inside",
    LEFT: "left",
    OUTSIDE: "outside",
    RIGHT: "right"
};
var $94db4f2abf87558b$export$9da8b3349e2dd4ea = {
    BOTTOM: "bottom",
    CENTER: "center",
    INSIDE: "inside",
    OUTSIDE: "outside",
    TOP: "top"
};
var $94db4f2abf87558b$export$27bce688931fdfcc = {
    DECIMAL: "decimal",
    UPPER_ROMAN: "upperRoman",
    LOWER_ROMAN: "lowerRoman",
    UPPER_LETTER: "upperLetter",
    LOWER_LETTER: "lowerLetter",
    ORDINAL: "ordinal",
    CARDINAL_TEXT: "cardinalText",
    ORDINAL_TEXT: "ordinalText",
    HEX: "hex",
    CHICAGO: "chicago",
    IDEOGRAPH_DIGITAL: "ideographDigital",
    JAPANESE_COUNTING: "japaneseCounting",
    AIUEO: "aiueo",
    IROHA: "iroha",
    DECIMAL_FULL_WIDTH: "decimalFullWidth",
    DECIMAL_HALF_WIDTH: "decimalHalfWidth",
    JAPANESE_LEGAL: "japaneseLegal",
    JAPANESE_DIGITAL_TEN_THOUSAND: "japaneseDigitalTenThousand",
    DECIMAL_ENCLOSED_CIRCLE: "decimalEnclosedCircle",
    DECIMAL_FULL_WIDTH_2: "decimalFullWidth2",
    AIUEO_FULL_WIDTH: "aiueoFullWidth",
    IROHA_FULL_WIDTH: "irohaFullWidth",
    DECIMAL_ZERO: "decimalZero",
    BULLET: "bullet",
    GANADA: "ganada",
    CHOSUNG: "chosung",
    DECIMAL_ENCLOSED_FULL_STOP: "decimalEnclosedFullstop",
    DECIMAL_ENCLOSED_PAREN: "decimalEnclosedParen",
    DECIMAL_ENCLOSED_CIRCLE_CHINESE: "decimalEnclosedCircleChinese",
    IDEOGRAPH_ENCLOSED_CIRCLE: "ideographEnclosedCircle",
    IDEOGRAPH_TRADITIONAL: "ideographTraditional",
    IDEOGRAPH_ZODIAC: "ideographZodiac",
    IDEOGRAPH_ZODIAC_TRADITIONAL: "ideographZodiacTraditional",
    TAIWANESE_COUNTING: "taiwaneseCounting",
    IDEOGRAPH_LEGAL_TRADITIONAL: "ideographLegalTraditional",
    TAIWANESE_COUNTING_THOUSAND: "taiwaneseCountingThousand",
    TAIWANESE_DIGITAL: "taiwaneseDigital",
    CHINESE_COUNTING: "chineseCounting",
    CHINESE_LEGAL_SIMPLIFIED: "chineseLegalSimplified",
    CHINESE_COUNTING_TEN_THOUSAND: "chineseCountingThousand",
    KOREAN_DIGITAL: "koreanDigital",
    KOREAN_COUNTING: "koreanCounting",
    KOREAN_LEGAL: "koreanLegal",
    KOREAN_DIGITAL_2: "koreanDigital2",
    VIETNAMESE_COUNTING: "vietnameseCounting",
    RUSSIAN_LOWER: "russianLower",
    RUSSIAN_UPPER: "russianUpper",
    NONE: "none",
    NUMBER_IN_DASH: "numberInDash",
    HEBREW_1: "hebrew1",
    HEBREW_2: "hebrew2",
    ARABIC_ALPHA: "arabicAlpha",
    ARABIC_ABJAD: "arabicAbjad",
    HINDI_VOWELS: "hindiVowels",
    HINDI_CONSONANTS: "hindiConsonants",
    HINDI_NUMBERS: "hindiNumbers",
    HINDI_COUNTING: "hindiCounting",
    THAI_LETTERS: "thaiLetters",
    THAI_NUMBERS: "thaiNumbers",
    THAI_COUNTING: "thaiCounting",
    BAHT_TEXT: "bahtText",
    DOLLAR_TEXT: "dollarText"
};
var $94db4f2abf87558b$export$bb538ef550ced38 = {
    DEFAULT: "default",
    PRESERVE: "preserve"
};
var $94db4f2abf87558b$var$TextAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(TextAttributes, XmlAttributeComponent);
    function TextAttributes() {
        (0, $gd0sY._)(this, TextAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, TextAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            space: "xml:space"
        });
        return _this;
    }
    return TextAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$Page = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Page, XmlComponent);
    function Page() {
        (0, $gd0sY._)(this, Page);
        var _this;
        _this = (0, $8xMIM._)(this, Page, [
            "w:instrText"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$TextAttributes({
            space: $94db4f2abf87558b$export$bb538ef550ced38.PRESERVE
        }));
        _this.root.push("PAGE");
        return _this;
    }
    return Page;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$NumberOfPages = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(NumberOfPages, XmlComponent);
    function NumberOfPages() {
        (0, $gd0sY._)(this, NumberOfPages);
        var _this;
        _this = (0, $8xMIM._)(this, NumberOfPages, [
            "w:instrText"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$TextAttributes({
            space: $94db4f2abf87558b$export$bb538ef550ced38.PRESERVE
        }));
        _this.root.push("NUMPAGES");
        return _this;
    }
    return NumberOfPages;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$NumberOfPagesSection = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(NumberOfPagesSection, XmlComponent);
    function NumberOfPagesSection() {
        (0, $gd0sY._)(this, NumberOfPagesSection);
        var _this;
        _this = (0, $8xMIM._)(this, NumberOfPagesSection, [
            "w:instrText"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$TextAttributes({
            space: $94db4f2abf87558b$export$bb538ef550ced38.PRESERVE
        }));
        _this.root.push("SECTIONPAGES");
        return _this;
    }
    return NumberOfPagesSection;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$CurrentSection = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(CurrentSection, XmlComponent);
    function CurrentSection() {
        (0, $gd0sY._)(this, CurrentSection);
        var _this;
        _this = (0, $8xMIM._)(this, CurrentSection, [
            "w:instrText"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$TextAttributes({
            space: $94db4f2abf87558b$export$bb538ef550ced38.PRESERVE
        }));
        _this.root.push("SECTION");
        return _this;
    }
    return CurrentSection;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$ShadingAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(ShadingAttributes, XmlAttributeComponent);
    function ShadingAttributes() {
        (0, $gd0sY._)(this, ShadingAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, ShadingAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            fill: "w:fill",
            color: "w:color",
            type: "w:val"
        });
        return _this;
    }
    return ShadingAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$21ac63597b3ebf8e = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Shading, XmlComponent);
    function Shading(param) {
        var fill = param.fill, color = param.color, type = param.type;
        (0, $gd0sY._)(this, Shading);
        var _this;
        _this = (0, $8xMIM._)(this, Shading, [
            "w:shd"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$ShadingAttributes({
            fill: fill === void 0 ? void 0 : $94db4f2abf87558b$export$39c9e6e42c794b97(fill),
            color: color === void 0 ? void 0 : $94db4f2abf87558b$export$39c9e6e42c794b97(color),
            type: type
        }));
        return _this;
    }
    return Shading;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$44d637c1ab7244fb = {
    CLEAR: "clear",
    DIAGONAL_CROSS: "diagCross",
    DIAGONAL_STRIPE: "diagStripe",
    HORIZONTAL_CROSS: "horzCross",
    HORIZONTAL_STRIPE: "horzStripe",
    NIL: "nil",
    PERCENT_5: "pct5",
    PERCENT_10: "pct10",
    PERCENT_12: "pct12",
    PERCENT_15: "pct15",
    PERCENT_20: "pct20",
    PERCENT_25: "pct25",
    PERCENT_30: "pct30",
    PERCENT_35: "pct35",
    PERCENT_37: "pct37",
    PERCENT_40: "pct40",
    PERCENT_45: "pct45",
    PERCENT_50: "pct50",
    PERCENT_55: "pct55",
    PERCENT_60: "pct60",
    PERCENT_62: "pct62",
    PERCENT_65: "pct65",
    PERCENT_70: "pct70",
    PERCENT_75: "pct75",
    PERCENT_80: "pct80",
    PERCENT_85: "pct85",
    PERCENT_87: "pct87",
    PERCENT_90: "pct90",
    PERCENT_95: "pct95",
    REVERSE_DIAGONAL_STRIPE: "reverseDiagStripe",
    SOLID: "solid",
    THIN_DIAGONAL_CROSS: "thinDiagCross",
    THIN_DIAGONAL_STRIPE: "thinDiagStripe",
    THIN_HORIZONTAL_CROSS: "thinHorzCross",
    THIN_REVERSE_DIAGONAL_STRIPE: "thinReverseDiagStripe",
    THIN_VERTICAL_STRIPE: "thinVertStripe",
    VERTICAL_STRIPE: "vertStripe"
};
var $94db4f2abf87558b$var$ChangeAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(ChangeAttributes, XmlAttributeComponent);
    function ChangeAttributes() {
        (0, $gd0sY._)(this, ChangeAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, ChangeAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            id: "w:id",
            author: "w:author",
            date: "w:date"
        });
        return _this;
    }
    return ChangeAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$bd85bf7ed3568df8 = {
    DOT: "dot"
};
var $94db4f2abf87558b$export$4346136c589de1a1 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(BaseEmphasisMark, XmlComponent);
    function BaseEmphasisMark(emphasisMarkType) {
        (0, $gd0sY._)(this, BaseEmphasisMark);
        var _this;
        _this = (0, $8xMIM._)(this, BaseEmphasisMark, [
            "w:em"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$21991851b0bb231f({
            val: emphasisMarkType
        }));
        return _this;
    }
    return BaseEmphasisMark;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$19e3176976994b01 = /*#__PURE__*/ function(BaseEmphasisMark) {
    "use strict";
    (0, $NBk0Y._)(EmphasisMark, BaseEmphasisMark);
    function EmphasisMark() {
        var emphasisMarkType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $94db4f2abf87558b$export$bd85bf7ed3568df8.DOT;
        (0, $gd0sY._)(this, EmphasisMark);
        return (0, $8xMIM._)(this, EmphasisMark, [
            emphasisMarkType
        ]);
    }
    return EmphasisMark;
}($94db4f2abf87558b$export$4346136c589de1a1);
var $94db4f2abf87558b$export$1a4a9e0df1cf2f7d = /*#__PURE__*/ function(BaseEmphasisMark) {
    "use strict";
    (0, $NBk0Y._)(DotEmphasisMark, BaseEmphasisMark);
    function DotEmphasisMark() {
        (0, $gd0sY._)(this, DotEmphasisMark);
        return (0, $8xMIM._)(this, DotEmphasisMark, [
            $94db4f2abf87558b$export$bd85bf7ed3568df8.DOT
        ]);
    }
    return DotEmphasisMark;
}($94db4f2abf87558b$export$4346136c589de1a1);
var $94db4f2abf87558b$var$CharacterSpacing = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(CharacterSpacing, XmlComponent);
    function CharacterSpacing(value) {
        (0, $gd0sY._)(this, CharacterSpacing);
        var _this;
        _this = (0, $8xMIM._)(this, CharacterSpacing, [
            "w:spacing"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$21991851b0bb231f({
            val: $94db4f2abf87558b$export$866cabb7ed3455e9(value)
        }));
        return _this;
    }
    return CharacterSpacing;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$Color = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Color, XmlComponent);
    function Color(color) {
        (0, $gd0sY._)(this, Color);
        var _this;
        _this = (0, $8xMIM._)(this, Color, [
            "w:color"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$21991851b0bb231f({
            val: $94db4f2abf87558b$export$39c9e6e42c794b97(color)
        }));
        return _this;
    }
    return Color;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$Highlight = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Highlight, XmlComponent);
    function Highlight(color) {
        (0, $gd0sY._)(this, Highlight);
        var _this;
        _this = (0, $8xMIM._)(this, Highlight, [
            "w:highlight"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$21991851b0bb231f({
            val: color
        }));
        return _this;
    }
    return Highlight;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$HighlightComplexScript = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(HighlightComplexScript, XmlComponent);
    function HighlightComplexScript(color) {
        (0, $gd0sY._)(this, HighlightComplexScript);
        var _this;
        _this = (0, $8xMIM._)(this, HighlightComplexScript, [
            "w:highlightCs"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$21991851b0bb231f({
            val: color
        }));
        return _this;
    }
    return HighlightComplexScript;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$createLanguageComponent = function(options2) {
    return new $94db4f2abf87558b$export$da493cbe1334accc({
        name: "w:lang",
        attributes: {
            value: {
                key: "w:val",
                value: options2.value
            },
            eastAsia: {
                key: "w:eastAsia",
                value: options2.eastAsia
            },
            bidirectional: {
                key: "w:bidi",
                value: options2.bidirectional
            }
        }
    });
};
var $94db4f2abf87558b$var$RunFontAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(RunFontAttributes, XmlAttributeComponent);
    function RunFontAttributes() {
        (0, $gd0sY._)(this, RunFontAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, RunFontAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            ascii: "w:ascii",
            cs: "w:cs",
            eastAsia: "w:eastAsia",
            hAnsi: "w:hAnsi",
            hint: "w:hint"
        });
        return _this;
    }
    return RunFontAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$b2daa015e8fb0d8d = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(RunFonts, XmlComponent);
    function RunFonts(nameOrAttrs, hint) {
        (0, $gd0sY._)(this, RunFonts);
        var _this;
        _this = (0, $8xMIM._)(this, RunFonts, [
            "w:rFonts"
        ]);
        if (typeof nameOrAttrs === "string") {
            var name = nameOrAttrs;
            _this.root.push(new $94db4f2abf87558b$var$RunFontAttributes({
                ascii: name,
                cs: name,
                eastAsia: name,
                hAnsi: name,
                hint: hint
            }));
        } else {
            var attrs = nameOrAttrs;
            _this.root.push(new $94db4f2abf87558b$var$RunFontAttributes(attrs));
        }
        return _this;
    }
    return RunFonts;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$VerticalAlign$1 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(VerticalAlign, XmlComponent);
    function VerticalAlign(type) {
        (0, $gd0sY._)(this, VerticalAlign);
        var _this;
        _this = (0, $8xMIM._)(this, VerticalAlign, [
            "w:vertAlign"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$21991851b0bb231f({
            val: type
        }));
        return _this;
    }
    return VerticalAlign;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$SuperScript = /*#__PURE__*/ function(VerticalAlign$1) {
    "use strict";
    (0, $NBk0Y._)(SuperScript, VerticalAlign$1);
    function SuperScript() {
        (0, $gd0sY._)(this, SuperScript);
        return (0, $8xMIM._)(this, SuperScript, [
            "superscript"
        ]);
    }
    return SuperScript;
}($94db4f2abf87558b$var$VerticalAlign$1);
var $94db4f2abf87558b$var$SubScript = /*#__PURE__*/ function(VerticalAlign$1) {
    "use strict";
    (0, $NBk0Y._)(SubScript, VerticalAlign$1);
    function SubScript() {
        (0, $gd0sY._)(this, SubScript);
        return (0, $8xMIM._)(this, SubScript, [
            "subscript"
        ]);
    }
    return SubScript;
}($94db4f2abf87558b$var$VerticalAlign$1);
var $94db4f2abf87558b$export$7d5cc92343d18d1b = {
    SINGLE: "single",
    WORDS: "words",
    DOUBLE: "double",
    THICK: "thick",
    DOTTED: "dotted",
    DOTTEDHEAVY: "dottedHeavy",
    DASH: "dash",
    DASHEDHEAVY: "dashedHeavy",
    DASHLONG: "dashLong",
    DASHLONGHEAVY: "dashLongHeavy",
    DOTDASH: "dotDash",
    DASHDOTHEAVY: "dashDotHeavy",
    DOTDOTDASH: "dotDotDash",
    DASHDOTDOTHEAVY: "dashDotDotHeavy",
    WAVE: "wave",
    WAVYHEAVY: "wavyHeavy",
    WAVYDOUBLE: "wavyDouble",
    NONE: "none"
};
var $94db4f2abf87558b$export$741ee5bff4f2bc22 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Underline, XmlComponent);
    function Underline() {
        var underlineType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $94db4f2abf87558b$export$7d5cc92343d18d1b.SINGLE, color = arguments.length > 1 ? arguments[1] : void 0;
        (0, $gd0sY._)(this, Underline);
        var _this;
        _this = (0, $8xMIM._)(this, Underline, [
            "w:u"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$21991851b0bb231f({
            val: underlineType,
            color: color === void 0 ? void 0 : $94db4f2abf87558b$export$39c9e6e42c794b97(color)
        }));
        return _this;
    }
    return Underline;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$f71093cf721ae205 = {
    BLINK_BACKGROUND: "blinkBackground",
    LIGHTS: "lights",
    ANTS_BLACK: "antsBlack",
    ANTS_RED: "antsRed",
    SHIMMER: "shimmer",
    SPARKLE: "sparkle",
    NONE: "none"
};
var $94db4f2abf87558b$export$5ae5540473946c91 = /*#__PURE__*/ function(IgnoreIfEmptyXmlComponent) {
    "use strict";
    (0, $NBk0Y._)(RunProperties, IgnoreIfEmptyXmlComponent);
    function RunProperties(options2) {
        (0, $gd0sY._)(this, RunProperties);
        var _this;
        var _a, _b;
        _this = (0, $8xMIM._)(this, RunProperties, [
            "w:rPr"
        ]);
        if (!options2) return (0, $cRssL._)(_this);
        if (options2.noProof !== void 0) _this.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:noProof", options2.noProof));
        if (options2.bold !== void 0) _this.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:b", options2.bold));
        if (options2.boldComplexScript === void 0 && options2.bold !== void 0 || options2.boldComplexScript) _this.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:bCs", (_a = options2.boldComplexScript) != null ? _a : options2.bold));
        if (options2.italics !== void 0) _this.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:i", options2.italics));
        if (options2.italicsComplexScript === void 0 && options2.italics !== void 0 || options2.italicsComplexScript) _this.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:iCs", (_b = options2.italicsComplexScript) != null ? _b : options2.italics));
        if (options2.underline) _this.push(new $94db4f2abf87558b$export$741ee5bff4f2bc22(options2.underline.type, options2.underline.color));
        if (options2.effect) _this.push(new $94db4f2abf87558b$export$eacbde36aa74068("w:effect", options2.effect));
        if (options2.emphasisMark) _this.push(new $94db4f2abf87558b$export$19e3176976994b01(options2.emphasisMark.type));
        if (options2.color) _this.push(new $94db4f2abf87558b$var$Color(options2.color));
        if (options2.kern) _this.push(new $94db4f2abf87558b$export$47eaf94bc2b4abbf("w:kern", options2.kern));
        if (options2.position) _this.push(new $94db4f2abf87558b$export$eacbde36aa74068("w:position", options2.position));
        if (options2.size !== void 0) _this.push(new $94db4f2abf87558b$export$47eaf94bc2b4abbf("w:sz", options2.size));
        var szCs = options2.sizeComplexScript === void 0 || options2.sizeComplexScript === true ? options2.size : options2.sizeComplexScript;
        if (szCs) _this.push(new $94db4f2abf87558b$export$47eaf94bc2b4abbf("w:szCs", szCs));
        if (options2.rightToLeft !== void 0) _this.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:rtl", options2.rightToLeft));
        if (options2.smallCaps !== void 0) _this.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:smallCaps", options2.smallCaps));
        else if (options2.allCaps !== void 0) _this.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:caps", options2.allCaps));
        if (options2.strike !== void 0) _this.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:strike", options2.strike));
        if (options2.doubleStrike !== void 0) _this.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:dstrike", options2.doubleStrike));
        if (options2.subScript) _this.push(new $94db4f2abf87558b$var$SubScript());
        if (options2.superScript) _this.push(new $94db4f2abf87558b$var$SuperScript());
        if (options2.style) _this.push(new $94db4f2abf87558b$export$eacbde36aa74068("w:rStyle", options2.style));
        if (options2.font) {
            if (typeof options2.font === "string") _this.push(new $94db4f2abf87558b$export$b2daa015e8fb0d8d(options2.font));
            else if ("name" in options2.font) _this.push(new $94db4f2abf87558b$export$b2daa015e8fb0d8d(options2.font.name, options2.font.hint));
            else _this.push(new $94db4f2abf87558b$export$b2daa015e8fb0d8d(options2.font));
        }
        if (options2.highlight) _this.push(new $94db4f2abf87558b$var$Highlight(options2.highlight));
        var highlightCs = options2.highlightComplexScript === void 0 || options2.highlightComplexScript === true ? options2.highlight : options2.highlightComplexScript;
        if (highlightCs) _this.push(new $94db4f2abf87558b$var$HighlightComplexScript(highlightCs));
        if (options2.characterSpacing) _this.push(new $94db4f2abf87558b$var$CharacterSpacing(options2.characterSpacing));
        if (options2.emboss !== void 0) _this.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:emboss", options2.emboss));
        if (options2.imprint !== void 0) _this.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:imprint", options2.imprint));
        if (options2.shading) _this.push(new $94db4f2abf87558b$export$21ac63597b3ebf8e(options2.shading));
        if (options2.revision) _this.push(new $94db4f2abf87558b$export$d0aecc325b7ec545(options2.revision));
        if (options2.border) _this.push(new $94db4f2abf87558b$export$a6733098a4eb57cf("w:bdr", options2.border));
        if (options2.snapToGrid !== void 0) _this.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:snapToGrid", options2.snapToGrid));
        if (options2.vanish) _this.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:vanish", options2.vanish));
        if (options2.specVanish) _this.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:specVanish", options2.vanish));
        if (options2.scale !== void 0) _this.push(new $94db4f2abf87558b$export$7c6d6f8dacf13e40("w:w", options2.scale));
        if (options2.language) _this.push($94db4f2abf87558b$var$createLanguageComponent(options2.language));
        if (options2.math) _this.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:oMath", options2.math));
        return _this;
    }
    (0, $7cSld._)(RunProperties, [
        {
            key: "push",
            value: function push(item) {
                this.root.push(item);
            }
        }
    ]);
    return RunProperties;
}($94db4f2abf87558b$export$951524d865ce655a);
var $94db4f2abf87558b$export$d0aecc325b7ec545 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(RunPropertiesChange, XmlComponent);
    function RunPropertiesChange(options2) {
        (0, $gd0sY._)(this, RunPropertiesChange);
        var _this;
        _this = (0, $8xMIM._)(this, RunPropertiesChange, [
            "w:rPrChange"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$ChangeAttributes({
            id: options2.id,
            author: options2.author,
            date: options2.date
        }));
        _this.addChildElement(new $94db4f2abf87558b$export$5ae5540473946c91(options2));
        return _this;
    }
    return RunPropertiesChange;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$Text = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Text, XmlComponent);
    function Text(options2) {
        (0, $gd0sY._)(this, Text);
        var _this;
        var _a;
        _this = (0, $8xMIM._)(this, Text, [
            "w:t"
        ]);
        if (typeof options2 === "string") {
            _this.root.push(new $94db4f2abf87558b$var$TextAttributes({
                space: $94db4f2abf87558b$export$bb538ef550ced38.PRESERVE
            }));
            _this.root.push(options2);
            return (0, $cRssL._)(_this, _this);
        } else {
            _this.root.push(new $94db4f2abf87558b$var$TextAttributes({
                space: (_a = options2.space) != null ? _a : $94db4f2abf87558b$export$bb538ef550ced38.DEFAULT
            }));
            _this.root.push(options2.text);
            return (0, $cRssL._)(_this, _this);
        }
        return _this;
    }
    return Text;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$9d30b4f7b635f195 = {
    CURRENT: "CURRENT",
    TOTAL_PAGES: "TOTAL_PAGES",
    TOTAL_PAGES_IN_SECTION: "TOTAL_PAGES_IN_SECTION",
    CURRENT_SECTION: "SECTION"
};
var $94db4f2abf87558b$export$ddae37e51c7979e2 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Run, XmlComponent);
    function Run(options2) {
        (0, $gd0sY._)(this, Run);
        var _this;
        _this = (0, $8xMIM._)(this, Run, [
            "w:r"
        ]);
        $94db4f2abf87558b$var$__publicField(_this, "properties");
        _this.properties = new $94db4f2abf87558b$export$5ae5540473946c91(options2);
        _this.root.push(_this.properties);
        if (options2.break) for(var i = 0; i < options2.break; i++)_this.root.push(new $94db4f2abf87558b$var$Break$1());
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (options2.children) try {
            for(var _iterator = options2.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                if (typeof child === "string") {
                    switch(child){
                        case $94db4f2abf87558b$export$9d30b4f7b635f195.CURRENT:
                            _this.root.push(new $94db4f2abf87558b$var$Begin());
                            _this.root.push(new $94db4f2abf87558b$var$Page());
                            _this.root.push(new $94db4f2abf87558b$var$Separate());
                            _this.root.push(new $94db4f2abf87558b$var$End());
                            break;
                        case $94db4f2abf87558b$export$9d30b4f7b635f195.TOTAL_PAGES:
                            _this.root.push(new $94db4f2abf87558b$var$Begin());
                            _this.root.push(new $94db4f2abf87558b$var$NumberOfPages());
                            _this.root.push(new $94db4f2abf87558b$var$Separate());
                            _this.root.push(new $94db4f2abf87558b$var$End());
                            break;
                        case $94db4f2abf87558b$export$9d30b4f7b635f195.TOTAL_PAGES_IN_SECTION:
                            _this.root.push(new $94db4f2abf87558b$var$Begin());
                            _this.root.push(new $94db4f2abf87558b$var$NumberOfPagesSection());
                            _this.root.push(new $94db4f2abf87558b$var$Separate());
                            _this.root.push(new $94db4f2abf87558b$var$End());
                            break;
                        case $94db4f2abf87558b$export$9d30b4f7b635f195.CURRENT_SECTION:
                            _this.root.push(new $94db4f2abf87558b$var$Begin());
                            _this.root.push(new $94db4f2abf87558b$var$CurrentSection());
                            _this.root.push(new $94db4f2abf87558b$var$Separate());
                            _this.root.push(new $94db4f2abf87558b$var$End());
                            break;
                        default:
                            _this.root.push(new $94db4f2abf87558b$var$Text(child));
                            break;
                    }
                    continue;
                }
                _this.root.push(child);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        else if (options2.text) _this.root.push(new $94db4f2abf87558b$var$Text(options2.text));
        return _this;
    }
    return Run;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$84d920a4f7ee9ae2 = /*#__PURE__*/ function(Run) {
    "use strict";
    (0, $NBk0Y._)(TextRun, Run);
    function TextRun(options2) {
        (0, $gd0sY._)(this, TextRun);
        var _this;
        if (typeof options2 === "string") {
            _this = (0, $8xMIM._)(this, TextRun, [
                {}
            ]);
            _this.root.push(new $94db4f2abf87558b$var$Text(options2));
            return (0, $cRssL._)(_this, _this);
        }
        return _this = (0, $8xMIM._)(this, TextRun, [
            options2
        ]);
    }
    return TextRun;
}($94db4f2abf87558b$export$ddae37e51c7979e2);
var $94db4f2abf87558b$var$SymbolAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(SymbolAttributes, XmlAttributeComponent);
    function SymbolAttributes() {
        (0, $gd0sY._)(this, SymbolAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, SymbolAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            char: "w:char",
            symbolfont: "w:font"
        });
        return _this;
    }
    return SymbolAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$Symbol$1 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Symbol2, XmlComponent);
    function Symbol2() {
        var char = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", symbolfont = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Wingdings";
        (0, $gd0sY._)(this, Symbol2);
        var _this;
        _this = (0, $8xMIM._)(this, Symbol2, [
            "w:sym"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$SymbolAttributes({
            char: char,
            symbolfont: symbolfont
        }));
        return _this;
    }
    return Symbol2;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$2d254945a19d4f19 = /*#__PURE__*/ function(Run) {
    "use strict";
    (0, $NBk0Y._)(SymbolRun, Run);
    function SymbolRun(options2) {
        (0, $gd0sY._)(this, SymbolRun);
        var _this;
        if (typeof options2 === "string") {
            _this = (0, $8xMIM._)(this, SymbolRun, [
                {}
            ]);
            _this.root.push(new $94db4f2abf87558b$var$Symbol$1(options2));
            return (0, $cRssL._)(_this, _this);
        }
        _this = (0, $8xMIM._)(this, SymbolRun, [
            options2
        ]);
        _this.root.push(new $94db4f2abf87558b$var$Symbol$1(options2.char, options2.symbolfont));
        return _this;
    }
    return SymbolRun;
}($94db4f2abf87558b$export$ddae37e51c7979e2);
var $94db4f2abf87558b$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
var $94db4f2abf87558b$var$customAlphabet = function(alphabet) {
    var defaultSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 21;
    return function() {
        var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultSize;
        var id = "";
        var i = size;
        while(i--)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
var $94db4f2abf87558b$var$nanoid = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 21;
    var id = "";
    var i = size;
    while(i--)id += $94db4f2abf87558b$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
var $94db4f2abf87558b$export$9c2bb9525a3b6907 = function(millimeters) {
    return Math.floor(millimeters / 25.4 * 1440);
};
var $94db4f2abf87558b$export$4db9ad0f69d17611 = function(inches) {
    return Math.floor(inches * 1440);
};
var $94db4f2abf87558b$export$cad86b9e31290e6a = function() {
    var initial = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    var currentCount = initial;
    return function() {
        return ++currentCount;
    };
};
var $94db4f2abf87558b$export$704353bc8da186a0 = function() {
    return $94db4f2abf87558b$export$cad86b9e31290e6a();
};
var $94db4f2abf87558b$export$efd792105b1568d0 = function() {
    return $94db4f2abf87558b$export$cad86b9e31290e6a(1);
};
var $94db4f2abf87558b$export$63865147ffc7f253 = function() {
    return $94db4f2abf87558b$export$cad86b9e31290e6a();
};
var $94db4f2abf87558b$export$3be069097e26ba4c = function() {
    return $94db4f2abf87558b$export$cad86b9e31290e6a();
};
var $94db4f2abf87558b$export$8b15d37bc3f197d4 = function() {
    return $94db4f2abf87558b$var$nanoid().toLowerCase();
};
var $94db4f2abf87558b$var$generateUuidPart = function(count) {
    return $94db4f2abf87558b$var$customAlphabet("1234567890abcdef", count)();
};
var $94db4f2abf87558b$export$a261054604391cc = function() {
    return "".concat($94db4f2abf87558b$var$generateUuidPart(8), "-").concat($94db4f2abf87558b$var$generateUuidPart(4), "-").concat($94db4f2abf87558b$var$generateUuidPart(4), "-").concat($94db4f2abf87558b$var$generateUuidPart(4), "-").concat($94db4f2abf87558b$var$generateUuidPart(12));
};
var $94db4f2abf87558b$export$10c561c819151cc = {
    CHARACTER: "character",
    COLUMN: "column",
    INSIDE_MARGIN: "insideMargin",
    LEFT_MARGIN: "leftMargin",
    MARGIN: "margin",
    OUTSIDE_MARGIN: "outsideMargin",
    PAGE: "page",
    RIGHT_MARGIN: "rightMargin"
};
var $94db4f2abf87558b$export$f98d20a05a7811b3 = {
    BOTTOM_MARGIN: "bottomMargin",
    INSIDE_MARGIN: "insideMargin",
    LINE: "line",
    MARGIN: "margin",
    OUTSIDE_MARGIN: "outsideMargin",
    PAGE: "page",
    PARAGRAPH: "paragraph",
    TOP_MARGIN: "topMargin"
};
var $94db4f2abf87558b$var$SimplePosAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(SimplePosAttributes, XmlAttributeComponent);
    function SimplePosAttributes() {
        (0, $gd0sY._)(this, SimplePosAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, SimplePosAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            x: "x",
            y: "y"
        });
        return _this;
    }
    return SimplePosAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$f083ce4002ed0f3c = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(SimplePos, XmlComponent);
    function SimplePos() {
        (0, $gd0sY._)(this, SimplePos);
        var _this;
        _this = (0, $8xMIM._)(this, SimplePos, [
            "wp:simplePos"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$SimplePosAttributes({
            x: 0,
            y: 0
        }));
        return _this;
    }
    return SimplePos;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$Align = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Align, XmlComponent);
    function Align(value) {
        (0, $gd0sY._)(this, Align);
        var _this;
        _this = (0, $8xMIM._)(this, Align, [
            "wp:align"
        ]);
        _this.root.push(value);
        return _this;
    }
    return Align;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$PositionOffset = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(PositionOffset, XmlComponent);
    function PositionOffset(offsetValue) {
        (0, $gd0sY._)(this, PositionOffset);
        var _this;
        _this = (0, $8xMIM._)(this, PositionOffset, [
            "wp:posOffset"
        ]);
        _this.root.push(offsetValue.toString());
        return _this;
    }
    return PositionOffset;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$HorizontalPositionAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(HorizontalPositionAttributes, XmlAttributeComponent);
    function HorizontalPositionAttributes() {
        (0, $gd0sY._)(this, HorizontalPositionAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, HorizontalPositionAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            relativeFrom: "relativeFrom"
        });
        return _this;
    }
    return HorizontalPositionAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$2f540dfa2cd2d101 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(HorizontalPosition, XmlComponent);
    function HorizontalPosition(horizontalPosition) {
        (0, $gd0sY._)(this, HorizontalPosition);
        var _this;
        _this = (0, $8xMIM._)(this, HorizontalPosition, [
            "wp:positionH"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$HorizontalPositionAttributes({
            relativeFrom: horizontalPosition.relative || $94db4f2abf87558b$export$10c561c819151cc.PAGE
        }));
        if (horizontalPosition.align) _this.root.push(new $94db4f2abf87558b$var$Align(horizontalPosition.align));
        else if (horizontalPosition.offset !== void 0) _this.root.push(new $94db4f2abf87558b$var$PositionOffset(horizontalPosition.offset));
        else throw new Error("There is no configuration provided for floating position (Align or offset)");
        return _this;
    }
    return HorizontalPosition;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$VerticalPositionAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(VerticalPositionAttributes, XmlAttributeComponent);
    function VerticalPositionAttributes() {
        (0, $gd0sY._)(this, VerticalPositionAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, VerticalPositionAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            relativeFrom: "relativeFrom"
        });
        return _this;
    }
    return VerticalPositionAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$476176afbbcc648f = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(VerticalPosition, XmlComponent);
    function VerticalPosition(verticalPosition) {
        (0, $gd0sY._)(this, VerticalPosition);
        var _this;
        _this = (0, $8xMIM._)(this, VerticalPosition, [
            "wp:positionV"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$VerticalPositionAttributes({
            relativeFrom: verticalPosition.relative || $94db4f2abf87558b$export$f98d20a05a7811b3.PAGE
        }));
        if (verticalPosition.align) _this.root.push(new $94db4f2abf87558b$var$Align(verticalPosition.align));
        else if (verticalPosition.offset !== void 0) _this.root.push(new $94db4f2abf87558b$var$PositionOffset(verticalPosition.offset));
        else throw new Error("There is no configuration provided for floating position (Align or offset)");
        return _this;
    }
    return VerticalPosition;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$GraphicDataAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(GraphicDataAttributes, XmlAttributeComponent);
    function GraphicDataAttributes() {
        (0, $gd0sY._)(this, GraphicDataAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, GraphicDataAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            uri: "uri"
        });
        return _this;
    }
    return GraphicDataAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$BlipAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(BlipAttributes, XmlAttributeComponent);
    function BlipAttributes() {
        (0, $gd0sY._)(this, BlipAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, BlipAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            embed: "r:embed",
            cstate: "cstate"
        });
        return _this;
    }
    return BlipAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$Blip = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Blip, XmlComponent);
    function Blip(mediaData) {
        (0, $gd0sY._)(this, Blip);
        var _this;
        _this = (0, $8xMIM._)(this, Blip, [
            "a:blip"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$BlipAttributes({
            embed: "rId{".concat(mediaData.fileName, "}"),
            cstate: "none"
        }));
        return _this;
    }
    return Blip;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$SourceRectangle = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(SourceRectangle, XmlComponent);
    function SourceRectangle() {
        (0, $gd0sY._)(this, SourceRectangle);
        return (0, $8xMIM._)(this, SourceRectangle, [
            "a:srcRect"
        ]);
    }
    return SourceRectangle;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$FillRectangle = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(FillRectangle, XmlComponent);
    function FillRectangle() {
        (0, $gd0sY._)(this, FillRectangle);
        return (0, $8xMIM._)(this, FillRectangle, [
            "a:fillRect"
        ]);
    }
    return FillRectangle;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$Stretch = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Stretch, XmlComponent);
    function Stretch() {
        (0, $gd0sY._)(this, Stretch);
        var _this;
        _this = (0, $8xMIM._)(this, Stretch, [
            "a:stretch"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$FillRectangle());
        return _this;
    }
    return Stretch;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$BlipFill = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(BlipFill, XmlComponent);
    function BlipFill(mediaData) {
        (0, $gd0sY._)(this, BlipFill);
        var _this;
        _this = (0, $8xMIM._)(this, BlipFill, [
            "pic:blipFill"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$Blip(mediaData));
        _this.root.push(new $94db4f2abf87558b$var$SourceRectangle());
        _this.root.push(new $94db4f2abf87558b$var$Stretch());
        return _this;
    }
    return BlipFill;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$PicLocksAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(PicLocksAttributes, XmlAttributeComponent);
    function PicLocksAttributes() {
        (0, $gd0sY._)(this, PicLocksAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, PicLocksAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            noChangeAspect: "noChangeAspect",
            noChangeArrowheads: "noChangeArrowheads"
        });
        return _this;
    }
    return PicLocksAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$PicLocks = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(PicLocks, XmlComponent);
    function PicLocks() {
        (0, $gd0sY._)(this, PicLocks);
        var _this;
        _this = (0, $8xMIM._)(this, PicLocks, [
            "a:picLocks"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$PicLocksAttributes({
            noChangeAspect: 1,
            noChangeArrowheads: 1
        }));
        return _this;
    }
    return PicLocks;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$ChildNonVisualProperties = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(ChildNonVisualProperties, XmlComponent);
    function ChildNonVisualProperties() {
        (0, $gd0sY._)(this, ChildNonVisualProperties);
        var _this;
        _this = (0, $8xMIM._)(this, ChildNonVisualProperties, [
            "pic:cNvPicPr"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$PicLocks());
        return _this;
    }
    return ChildNonVisualProperties;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$createHyperlinkClick = function(linkId, hasXmlNs) {
    return new $94db4f2abf87558b$export$da493cbe1334accc({
        name: "a:hlinkClick",
        attributes: $94db4f2abf87558b$var$__spreadProps($94db4f2abf87558b$var$__spreadValues({}, hasXmlNs ? {
            xmlns: {
                key: "xmlns:a",
                value: "http://schemas.openxmlformats.org/drawingml/2006/main"
            }
        } : {}), {
            id: {
                key: "r:id",
                value: "rId".concat(linkId)
            }
        })
    });
};
var $94db4f2abf87558b$var$NonVisualPropertiesAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(NonVisualPropertiesAttributes, XmlAttributeComponent);
    function NonVisualPropertiesAttributes() {
        (0, $gd0sY._)(this, NonVisualPropertiesAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, NonVisualPropertiesAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            id: "id",
            name: "name",
            descr: "descr"
        });
        return _this;
    }
    return NonVisualPropertiesAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$NonVisualProperties = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(NonVisualProperties, XmlComponent);
    function NonVisualProperties() {
        (0, $gd0sY._)(this, NonVisualProperties);
        var _this;
        _this = (0, $8xMIM._)(this, NonVisualProperties, [
            "pic:cNvPr"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$NonVisualPropertiesAttributes({
            id: 0,
            name: "",
            descr: ""
        }));
        return _this;
    }
    (0, $7cSld._)(NonVisualProperties, [
        {
            key: "prepForXml",
            value: function prepForXml(context) {
                for(var i = context.stack.length - 1; i >= 0; i--){
                    var element2 = context.stack[i];
                    if (!(element2 instanceof $94db4f2abf87558b$export$6beda279b4a51476)) continue;
                    this.root.push($94db4f2abf87558b$var$createHyperlinkClick(element2.linkId, false));
                    break;
                }
                return (0, $bl6Nv._)((0, $7GsX9._)(NonVisualProperties.prototype), "prepForXml", this).call(this, context);
            }
        }
    ]);
    return NonVisualProperties;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$NonVisualPicProperties = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(NonVisualPicProperties, XmlComponent);
    function NonVisualPicProperties() {
        (0, $gd0sY._)(this, NonVisualPicProperties);
        var _this;
        _this = (0, $8xMIM._)(this, NonVisualPicProperties, [
            "pic:nvPicPr"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$NonVisualProperties());
        _this.root.push(new $94db4f2abf87558b$var$ChildNonVisualProperties());
        return _this;
    }
    return NonVisualPicProperties;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$PicAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(PicAttributes, XmlAttributeComponent);
    function PicAttributes() {
        (0, $gd0sY._)(this, PicAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, PicAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            xmlns: "xmlns:pic"
        });
        return _this;
    }
    return PicAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$ExtentsAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(ExtentsAttributes, XmlAttributeComponent);
    function ExtentsAttributes() {
        (0, $gd0sY._)(this, ExtentsAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, ExtentsAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            cx: "cx",
            cy: "cy"
        });
        return _this;
    }
    return ExtentsAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$Extents = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Extents, XmlComponent);
    function Extents(x, y) {
        (0, $gd0sY._)(this, Extents);
        var _this;
        _this = (0, $8xMIM._)(this, Extents, [
            "a:ext"
        ]);
        $94db4f2abf87558b$var$__publicField(_this, "attributes");
        _this.attributes = new $94db4f2abf87558b$var$ExtentsAttributes({
            cx: x,
            cy: y
        });
        _this.root.push(_this.attributes);
        return _this;
    }
    return Extents;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$OffsetAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(OffsetAttributes, XmlAttributeComponent);
    function OffsetAttributes() {
        (0, $gd0sY._)(this, OffsetAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, OffsetAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            x: "x",
            y: "y"
        });
        return _this;
    }
    return OffsetAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$Offset = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Offset, XmlComponent);
    function Offset() {
        (0, $gd0sY._)(this, Offset);
        var _this;
        _this = (0, $8xMIM._)(this, Offset, [
            "a:off"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$OffsetAttributes({
            x: 0,
            y: 0
        }));
        return _this;
    }
    return Offset;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$FormAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(FormAttributes, XmlAttributeComponent);
    function FormAttributes() {
        (0, $gd0sY._)(this, FormAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, FormAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            flipVertical: "flipV",
            flipHorizontal: "flipH",
            rotation: "rot"
        });
        return _this;
    }
    return FormAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$Form = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Form, XmlComponent);
    function Form(options2) {
        (0, $gd0sY._)(this, Form);
        var _this;
        var _a, _b;
        _this = (0, $8xMIM._)(this, Form, [
            "a:xfrm"
        ]);
        $94db4f2abf87558b$var$__publicField(_this, "extents");
        _this.root.push(new $94db4f2abf87558b$var$FormAttributes({
            flipVertical: (_a = options2.flip) == null ? void 0 : _a.vertical,
            flipHorizontal: (_b = options2.flip) == null ? void 0 : _b.horizontal,
            rotation: options2.rotation
        }));
        _this.extents = new $94db4f2abf87558b$var$Extents(options2.emus.x, options2.emus.y);
        _this.root.push(new $94db4f2abf87558b$var$Offset());
        _this.root.push(_this.extents);
        return _this;
    }
    return Form;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$createNoFill = function() {
    return new $94db4f2abf87558b$export$da493cbe1334accc({
        name: "a:noFill"
    });
};
var $94db4f2abf87558b$var$createSchemeColor = function(options2) {
    return new $94db4f2abf87558b$export$da493cbe1334accc({
        name: "a:schemeClr",
        attributes: {
            value: {
                key: "val",
                value: options2.value
            }
        }
    });
};
var $94db4f2abf87558b$var$createSolidRgbColor = function(options2) {
    return new $94db4f2abf87558b$export$da493cbe1334accc({
        name: "a:srgbClr",
        attributes: {
            value: {
                key: "val",
                value: options2.value
            }
        }
    });
};
var $94db4f2abf87558b$var$createSolidFill = function(options2) {
    return new $94db4f2abf87558b$export$da493cbe1334accc({
        name: "a:solidFill",
        children: [
            options2.type === "rgb" ? $94db4f2abf87558b$var$createSolidRgbColor(options2) : $94db4f2abf87558b$var$createSchemeColor(options2)
        ]
    });
};
var $94db4f2abf87558b$var$createOutline = function(options2) {
    return new $94db4f2abf87558b$export$da493cbe1334accc({
        name: "a:ln",
        attributes: {
            width: {
                key: "w",
                value: options2.width
            },
            cap: {
                key: "cap",
                value: options2.cap
            },
            compoundLine: {
                key: "cmpd",
                value: options2.compoundLine
            },
            align: {
                key: "algn",
                value: options2.align
            }
        },
        children: [
            options2.type === "noFill" ? $94db4f2abf87558b$var$createNoFill() : options2.solidFillType === "rgb" ? $94db4f2abf87558b$var$createSolidFill({
                type: "rgb",
                value: options2.value
            }) : $94db4f2abf87558b$var$createSolidFill({
                type: "scheme",
                value: options2.value
            })
        ]
    });
};
var $94db4f2abf87558b$var$AdjustmentValues = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(AdjustmentValues, XmlComponent);
    function AdjustmentValues() {
        (0, $gd0sY._)(this, AdjustmentValues);
        return (0, $8xMIM._)(this, AdjustmentValues, [
            "a:avLst"
        ]);
    }
    return AdjustmentValues;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$PresetGeometryAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(PresetGeometryAttributes, XmlAttributeComponent);
    function PresetGeometryAttributes() {
        (0, $gd0sY._)(this, PresetGeometryAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, PresetGeometryAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            prst: "prst"
        });
        return _this;
    }
    return PresetGeometryAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$PresetGeometry = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(PresetGeometry, XmlComponent);
    function PresetGeometry() {
        (0, $gd0sY._)(this, PresetGeometry);
        var _this;
        _this = (0, $8xMIM._)(this, PresetGeometry, [
            "a:prstGeom"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$PresetGeometryAttributes({
            prst: "rect"
        }));
        _this.root.push(new $94db4f2abf87558b$var$AdjustmentValues());
        return _this;
    }
    return PresetGeometry;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$ShapePropertiesAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(ShapePropertiesAttributes, XmlAttributeComponent);
    function ShapePropertiesAttributes() {
        (0, $gd0sY._)(this, ShapePropertiesAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, ShapePropertiesAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            bwMode: "bwMode"
        });
        return _this;
    }
    return ShapePropertiesAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$ShapeProperties = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(ShapeProperties, XmlComponent);
    function ShapeProperties(param) {
        var outline = param.outline, transform = param.transform;
        (0, $gd0sY._)(this, ShapeProperties);
        var _this;
        _this = (0, $8xMIM._)(this, ShapeProperties, [
            "pic:spPr"
        ]);
        $94db4f2abf87558b$var$__publicField(_this, "form");
        _this.root.push(new $94db4f2abf87558b$var$ShapePropertiesAttributes({
            bwMode: "auto"
        }));
        _this.form = new $94db4f2abf87558b$var$Form(transform);
        _this.root.push(_this.form);
        _this.root.push(new $94db4f2abf87558b$var$PresetGeometry());
        if (outline) {
            _this.root.push($94db4f2abf87558b$var$createNoFill());
            _this.root.push($94db4f2abf87558b$var$createOutline(outline));
        }
        return _this;
    }
    return ShapeProperties;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$Pic = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Pic, XmlComponent);
    function Pic(param) {
        var mediaData = param.mediaData, transform = param.transform, outline = param.outline;
        (0, $gd0sY._)(this, Pic);
        var _this;
        _this = (0, $8xMIM._)(this, Pic, [
            "pic:pic"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$PicAttributes({
            xmlns: "http://schemas.openxmlformats.org/drawingml/2006/picture"
        }));
        _this.root.push(new $94db4f2abf87558b$var$NonVisualPicProperties());
        _this.root.push(new $94db4f2abf87558b$var$BlipFill(mediaData));
        _this.root.push(new $94db4f2abf87558b$var$ShapeProperties({
            transform: transform,
            outline: outline
        }));
        return _this;
    }
    return Pic;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$GraphicData = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(GraphicData, XmlComponent);
    function GraphicData(param) {
        var mediaData = param.mediaData, transform = param.transform, outline = param.outline;
        (0, $gd0sY._)(this, GraphicData);
        var _this;
        _this = (0, $8xMIM._)(this, GraphicData, [
            "a:graphicData"
        ]);
        $94db4f2abf87558b$var$__publicField(_this, "pic");
        _this.root.push(new $94db4f2abf87558b$var$GraphicDataAttributes({
            uri: "http://schemas.openxmlformats.org/drawingml/2006/picture"
        }));
        _this.pic = new $94db4f2abf87558b$var$Pic({
            mediaData: mediaData,
            transform: transform,
            outline: outline
        });
        _this.root.push(_this.pic);
        return _this;
    }
    return GraphicData;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$GraphicAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(GraphicAttributes, XmlAttributeComponent);
    function GraphicAttributes() {
        (0, $gd0sY._)(this, GraphicAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, GraphicAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            a: "xmlns:a"
        });
        return _this;
    }
    return GraphicAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$Graphic = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Graphic, XmlComponent);
    function Graphic(param) {
        var mediaData = param.mediaData, transform = param.transform, outline = param.outline;
        (0, $gd0sY._)(this, Graphic);
        var _this;
        _this = (0, $8xMIM._)(this, Graphic, [
            "a:graphic"
        ]);
        $94db4f2abf87558b$var$__publicField(_this, "data");
        _this.root.push(new $94db4f2abf87558b$var$GraphicAttributes({
            a: "http://schemas.openxmlformats.org/drawingml/2006/main"
        }));
        _this.data = new $94db4f2abf87558b$var$GraphicData({
            mediaData: mediaData,
            transform: transform,
            outline: outline
        });
        _this.root.push(_this.data);
        return _this;
    }
    return Graphic;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$6a3bca3ba43863ad = {
    NONE: 0,
    SQUARE: 1,
    TIGHT: 2,
    TOP_AND_BOTTOM: 3
};
var $94db4f2abf87558b$export$18bd536dc9d39d85 = {
    BOTH_SIDES: "bothSides",
    LEFT: "left",
    RIGHT: "right",
    LARGEST: "largest"
};
var $94db4f2abf87558b$export$55989adc605dc8b3 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(WrapNone, XmlComponent);
    function WrapNone() {
        (0, $gd0sY._)(this, WrapNone);
        return (0, $8xMIM._)(this, WrapNone, [
            "wp:wrapNone"
        ]);
    }
    return WrapNone;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$WrapSquareAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(WrapSquareAttributes, XmlAttributeComponent);
    function WrapSquareAttributes() {
        (0, $gd0sY._)(this, WrapSquareAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, WrapSquareAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            distT: "distT",
            distB: "distB",
            distL: "distL",
            distR: "distR",
            wrapText: "wrapText"
        });
        return _this;
    }
    return WrapSquareAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$cb58bbb894326836 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(WrapSquare, XmlComponent);
    function WrapSquare(textWrapping) {
        var margins = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
        };
        (0, $gd0sY._)(this, WrapSquare);
        var _this;
        _this = (0, $8xMIM._)(this, WrapSquare, [
            "wp:wrapSquare"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$WrapSquareAttributes({
            wrapText: textWrapping.side || $94db4f2abf87558b$export$18bd536dc9d39d85.BOTH_SIDES,
            distT: margins.top,
            distB: margins.bottom,
            distL: margins.left,
            distR: margins.right
        }));
        return _this;
    }
    return WrapSquare;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$WrapTightAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(WrapTightAttributes, XmlAttributeComponent);
    function WrapTightAttributes() {
        (0, $gd0sY._)(this, WrapTightAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, WrapTightAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            distT: "distT",
            distB: "distB"
        });
        return _this;
    }
    return WrapTightAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$cdf188ce20f1ead1 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(WrapTight, XmlComponent);
    function WrapTight() {
        var margins = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
            top: 0,
            bottom: 0
        };
        (0, $gd0sY._)(this, WrapTight);
        var _this;
        _this = (0, $8xMIM._)(this, WrapTight, [
            "wp:wrapTight"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$WrapTightAttributes({
            distT: margins.top,
            distB: margins.bottom
        }));
        return _this;
    }
    return WrapTight;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$WrapTopAndBottomAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(WrapTopAndBottomAttributes, XmlAttributeComponent);
    function WrapTopAndBottomAttributes() {
        (0, $gd0sY._)(this, WrapTopAndBottomAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, WrapTopAndBottomAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            distT: "distT",
            distB: "distB"
        });
        return _this;
    }
    return WrapTopAndBottomAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$b8b93fdb253c534d = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(WrapTopAndBottom, XmlComponent);
    function WrapTopAndBottom() {
        var margins = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
            top: 0,
            bottom: 0
        };
        (0, $gd0sY._)(this, WrapTopAndBottom);
        var _this;
        _this = (0, $8xMIM._)(this, WrapTopAndBottom, [
            "wp:wrapTopAndBottom"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$WrapTopAndBottomAttributes({
            distT: margins.top,
            distB: margins.bottom
        }));
        return _this;
    }
    return WrapTopAndBottom;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$DocProperties = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(DocProperties, XmlComponent);
    function DocProperties() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
            name: "",
            description: "",
            title: ""
        }, name = _ref.name, description = _ref.description, title = _ref.title;
        (0, $gd0sY._)(this, DocProperties);
        var _this;
        _this = (0, $8xMIM._)(this, DocProperties, [
            "wp:docPr"
        ]);
        $94db4f2abf87558b$var$__publicField(_this, "docPropertiesUniqueNumericId", $94db4f2abf87558b$export$63865147ffc7f253());
        _this.root.push(new $94db4f2abf87558b$export$b95d92bd70e2302a({
            id: {
                key: "id",
                value: _this.docPropertiesUniqueNumericId()
            },
            name: {
                key: "name",
                value: name
            },
            description: {
                key: "descr",
                value: description
            },
            title: {
                key: "title",
                value: title
            }
        }));
        return _this;
    }
    (0, $7cSld._)(DocProperties, [
        {
            key: "prepForXml",
            value: function prepForXml(context) {
                for(var i = context.stack.length - 1; i >= 0; i--){
                    var element2 = context.stack[i];
                    if (!(element2 instanceof $94db4f2abf87558b$export$6beda279b4a51476)) continue;
                    this.root.push($94db4f2abf87558b$var$createHyperlinkClick(element2.linkId, true));
                    break;
                }
                return (0, $bl6Nv._)((0, $7GsX9._)(DocProperties.prototype), "prepForXml", this).call(this, context);
            }
        }
    ]);
    return DocProperties;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$createEffectExtent = function(param) {
    var top = param.top, right = param.right, bottom = param.bottom, left = param.left;
    return new $94db4f2abf87558b$export$da493cbe1334accc({
        name: "wp:effectExtent",
        attributes: {
            top: {
                key: "t",
                value: top
            },
            right: {
                key: "r",
                value: right
            },
            bottom: {
                key: "b",
                value: bottom
            },
            left: {
                key: "l",
                value: left
            }
        }
    });
};
var $94db4f2abf87558b$var$ExtentAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(ExtentAttributes, XmlAttributeComponent);
    function ExtentAttributes() {
        (0, $gd0sY._)(this, ExtentAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, ExtentAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            cx: "cx",
            cy: "cy"
        });
        return _this;
    }
    return ExtentAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$Extent = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Extent, XmlComponent);
    function Extent(x, y) {
        (0, $gd0sY._)(this, Extent);
        var _this;
        _this = (0, $8xMIM._)(this, Extent, [
            "wp:extent"
        ]);
        $94db4f2abf87558b$var$__publicField(_this, "attributes");
        _this.attributes = new $94db4f2abf87558b$var$ExtentAttributes({
            cx: x,
            cy: y
        });
        _this.root.push(_this.attributes);
        return _this;
    }
    return Extent;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$GraphicFrameLockAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(GraphicFrameLockAttributes, XmlAttributeComponent);
    function GraphicFrameLockAttributes() {
        (0, $gd0sY._)(this, GraphicFrameLockAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, GraphicFrameLockAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            xmlns: "xmlns:a",
            noChangeAspect: "noChangeAspect"
        });
        return _this;
    }
    return GraphicFrameLockAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$GraphicFrameLocks = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(GraphicFrameLocks, XmlComponent);
    function GraphicFrameLocks() {
        (0, $gd0sY._)(this, GraphicFrameLocks);
        var _this;
        _this = (0, $8xMIM._)(this, GraphicFrameLocks, [
            "a:graphicFrameLocks"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$GraphicFrameLockAttributes({
            xmlns: "http://schemas.openxmlformats.org/drawingml/2006/main",
            noChangeAspect: 1
        }));
        return _this;
    }
    return GraphicFrameLocks;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$GraphicFrameProperties = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(GraphicFrameProperties, XmlComponent);
    function GraphicFrameProperties() {
        (0, $gd0sY._)(this, GraphicFrameProperties);
        var _this;
        _this = (0, $8xMIM._)(this, GraphicFrameProperties, [
            "wp:cNvGraphicFramePr"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$GraphicFrameLocks());
        return _this;
    }
    return GraphicFrameProperties;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$AnchorAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(AnchorAttributes, XmlAttributeComponent);
    function AnchorAttributes() {
        (0, $gd0sY._)(this, AnchorAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, AnchorAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            distT: "distT",
            distB: "distB",
            distL: "distL",
            distR: "distR",
            allowOverlap: "allowOverlap",
            behindDoc: "behindDoc",
            layoutInCell: "layoutInCell",
            locked: "locked",
            relativeHeight: "relativeHeight",
            simplePos: "simplePos"
        });
        return _this;
    }
    return AnchorAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$Anchor = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Anchor, XmlComponent);
    function Anchor(param) {
        var mediaData = param.mediaData, transform = param.transform, drawingOptions = param.drawingOptions;
        (0, $gd0sY._)(this, Anchor);
        var _this;
        _this = (0, $8xMIM._)(this, Anchor, [
            "wp:anchor"
        ]);
        var floating = $94db4f2abf87558b$var$__spreadValues({
            allowOverlap: true,
            behindDocument: false,
            lockAnchor: false,
            layoutInCell: true,
            verticalPosition: {},
            horizontalPosition: {}
        }, drawingOptions.floating);
        _this.root.push(new $94db4f2abf87558b$var$AnchorAttributes({
            distT: floating.margins ? floating.margins.top || 0 : 0,
            distB: floating.margins ? floating.margins.bottom || 0 : 0,
            distL: floating.margins ? floating.margins.left || 0 : 0,
            distR: floating.margins ? floating.margins.right || 0 : 0,
            simplePos: "0",
            // note: word doesn't fully support - so we use 0
            allowOverlap: floating.allowOverlap === true ? "1" : "0",
            behindDoc: floating.behindDocument === true ? "1" : "0",
            locked: floating.lockAnchor === true ? "1" : "0",
            layoutInCell: floating.layoutInCell === true ? "1" : "0",
            relativeHeight: floating.zIndex ? floating.zIndex : transform.emus.y
        }));
        _this.root.push(new $94db4f2abf87558b$export$f083ce4002ed0f3c());
        _this.root.push(new $94db4f2abf87558b$export$2f540dfa2cd2d101(floating.horizontalPosition));
        _this.root.push(new $94db4f2abf87558b$export$476176afbbcc648f(floating.verticalPosition));
        _this.root.push(new $94db4f2abf87558b$var$Extent(transform.emus.x, transform.emus.y));
        _this.root.push($94db4f2abf87558b$var$createEffectExtent({
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }));
        if (drawingOptions.floating !== void 0 && drawingOptions.floating.wrap !== void 0) switch(drawingOptions.floating.wrap.type){
            case $94db4f2abf87558b$export$6a3bca3ba43863ad.SQUARE:
                _this.root.push(new $94db4f2abf87558b$export$cb58bbb894326836(drawingOptions.floating.wrap, drawingOptions.floating.margins));
                break;
            case $94db4f2abf87558b$export$6a3bca3ba43863ad.TIGHT:
                _this.root.push(new $94db4f2abf87558b$export$cdf188ce20f1ead1(drawingOptions.floating.margins));
                break;
            case $94db4f2abf87558b$export$6a3bca3ba43863ad.TOP_AND_BOTTOM:
                _this.root.push(new $94db4f2abf87558b$export$b8b93fdb253c534d(drawingOptions.floating.margins));
                break;
            case $94db4f2abf87558b$export$6a3bca3ba43863ad.NONE:
            default:
                _this.root.push(new $94db4f2abf87558b$export$55989adc605dc8b3());
        }
        else _this.root.push(new $94db4f2abf87558b$export$55989adc605dc8b3());
        _this.root.push(new $94db4f2abf87558b$var$DocProperties(drawingOptions.docProperties));
        _this.root.push(new $94db4f2abf87558b$var$GraphicFrameProperties());
        _this.root.push(new $94db4f2abf87558b$var$Graphic({
            mediaData: mediaData,
            transform: transform,
            outline: drawingOptions.outline
        }));
        return _this;
    }
    return Anchor;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$createInline = function(param) {
    var mediaData = param.mediaData, transform = param.transform, docProperties = param.docProperties, outline = param.outline;
    var _a, _b, _c, _d;
    return new $94db4f2abf87558b$export$da493cbe1334accc({
        name: "wp:inline",
        attributes: {
            distanceTop: {
                key: "distT",
                value: 0
            },
            distanceBottom: {
                key: "distB",
                value: 0
            },
            distanceLeft: {
                key: "distL",
                value: 0
            },
            distanceRight: {
                key: "distR",
                value: 0
            }
        },
        children: [
            new $94db4f2abf87558b$var$Extent(transform.emus.x, transform.emus.y),
            $94db4f2abf87558b$var$createEffectExtent(outline ? {
                top: ((_a = outline.width) != null ? _a : 9525) * 2,
                right: ((_b = outline.width) != null ? _b : 9525) * 2,
                bottom: ((_c = outline.width) != null ? _c : 9525) * 2,
                left: ((_d = outline.width) != null ? _d : 9525) * 2
            } : {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            }),
            new $94db4f2abf87558b$var$DocProperties(docProperties),
            new $94db4f2abf87558b$var$GraphicFrameProperties(),
            new $94db4f2abf87558b$var$Graphic({
                mediaData: mediaData,
                transform: transform,
                outline: outline
            })
        ]
    });
};
var $94db4f2abf87558b$export$6c98c30b3a286440 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Drawing, XmlComponent);
    function Drawing(imageData) {
        var drawingOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $gd0sY._)(this, Drawing);
        var _this;
        _this = (0, $8xMIM._)(this, Drawing, [
            "w:drawing"
        ]);
        if (!drawingOptions.floating) _this.root.push($94db4f2abf87558b$var$createInline({
            mediaData: imageData,
            transform: imageData.transformation,
            docProperties: drawingOptions.docProperties,
            outline: drawingOptions.outline
        }));
        else _this.root.push(new $94db4f2abf87558b$var$Anchor({
            mediaData: imageData,
            transform: imageData.transformation,
            drawingOptions: drawingOptions
        }));
        return _this;
    }
    return Drawing;
}($94db4f2abf87558b$export$19f99b70db82ec96);

var $94db4f2abf87558b$export$748e1095269a17e0 = /*#__PURE__*/ function(Run) {
    "use strict";
    (0, $NBk0Y._)(ImageRun, Run);
    function ImageRun(options2) {
        (0, $gd0sY._)(this, ImageRun);
        var _this;
        _this = (0, $8xMIM._)(this, ImageRun, [
            {}
        ]);
        $94db4f2abf87558b$var$__publicField(_this, "key", "".concat($94db4f2abf87558b$export$8b15d37bc3f197d4(), ".png"));
        $94db4f2abf87558b$var$__publicField(_this, "imageData");
        var newData = typeof options2.data === "string" ? _this.convertDataURIToBinary(options2.data) : options2.data;
        _this.imageData = {
            stream: newData,
            fileName: _this.key,
            transformation: {
                pixels: {
                    x: Math.round(options2.transformation.width),
                    y: Math.round(options2.transformation.height)
                },
                emus: {
                    x: Math.round(options2.transformation.width * 9525),
                    y: Math.round(options2.transformation.height * 9525)
                },
                flip: options2.transformation.flip,
                rotation: options2.transformation.rotation ? options2.transformation.rotation * 6e4 : void 0
            }
        };
        var drawing = new $94db4f2abf87558b$export$6c98c30b3a286440(_this.imageData, {
            floating: options2.floating,
            docProperties: options2.altText,
            outline: options2.outline
        });
        _this.root.push(drawing);
        return _this;
    }
    (0, $7cSld._)(ImageRun, [
        {
            key: "prepForXml",
            value: function prepForXml(context) {
                context.file.Media.addImage(this.key, this.imageData);
                return (0, $bl6Nv._)((0, $7GsX9._)(ImageRun.prototype), "prepForXml", this).call(this, context);
            }
        },
        {
            key: "convertDataURIToBinary",
            value: function convertDataURIToBinary(dataURI) {
                if (typeof atob === "function") {
                    var BASE64_MARKER = ";base64,";
                    var base64Index = dataURI.indexOf(BASE64_MARKER);
                    var base64IndexWithOffset = base64Index === -1 ? 0 : base64Index + BASE64_MARKER.length;
                    return new Uint8Array(atob(dataURI.substring(base64IndexWithOffset)).split("").map(function(c) {
                        return c.charCodeAt(0);
                    }));
                } else {
                    var b = (parcelRequire("hjdi2"));
                    return new b.Buffer(dataURI, "base64");
                }
            }
        }
    ]);
    return ImageRun;
}($94db4f2abf87558b$export$ddae37e51c7979e2);
var $94db4f2abf87558b$var$SequentialIdentifierInstruction = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(SequentialIdentifierInstruction, XmlComponent);
    function SequentialIdentifierInstruction(identifier) {
        (0, $gd0sY._)(this, SequentialIdentifierInstruction);
        var _this;
        _this = (0, $8xMIM._)(this, SequentialIdentifierInstruction, [
            "w:instrText"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$TextAttributes({
            space: $94db4f2abf87558b$export$bb538ef550ced38.PRESERVE
        }));
        _this.root.push("SEQ ".concat(identifier));
        return _this;
    }
    return SequentialIdentifierInstruction;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$c6c7e7a175869529 = /*#__PURE__*/ function(Run) {
    "use strict";
    (0, $NBk0Y._)(SequentialIdentifier, Run);
    function SequentialIdentifier(identifier) {
        (0, $gd0sY._)(this, SequentialIdentifier);
        var _this;
        _this = (0, $8xMIM._)(this, SequentialIdentifier, [
            {}
        ]);
        _this.root.push(new $94db4f2abf87558b$var$Begin(true));
        _this.root.push(new $94db4f2abf87558b$var$SequentialIdentifierInstruction(identifier));
        _this.root.push(new $94db4f2abf87558b$var$Separate());
        _this.root.push(new $94db4f2abf87558b$var$End());
        return _this;
    }
    return SequentialIdentifier;
}($94db4f2abf87558b$export$ddae37e51c7979e2);
var $94db4f2abf87558b$var$FldSimpleAttrs = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(FldSimpleAttrs, XmlAttributeComponent);
    function FldSimpleAttrs() {
        (0, $gd0sY._)(this, FldSimpleAttrs);
        var _this;
        _this = (0, $8xMIM._)(this, FldSimpleAttrs, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            instr: "w:instr"
        });
        return _this;
    }
    return FldSimpleAttrs;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$68548adcc40655f2 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(SimpleField, XmlComponent);
    function SimpleField(instruction, cachedValue) {
        (0, $gd0sY._)(this, SimpleField);
        var _this;
        _this = (0, $8xMIM._)(this, SimpleField, [
            "w:fldSimple"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$FldSimpleAttrs({
            instr: instruction
        }));
        if (cachedValue !== void 0) _this.root.push(new $94db4f2abf87558b$export$84d920a4f7ee9ae2(cachedValue));
        return _this;
    }
    return SimpleField;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$398abb3a757cc8e0 = /*#__PURE__*/ function(SimpleField) {
    "use strict";
    (0, $NBk0Y._)(SimpleMailMergeField, SimpleField);
    function SimpleMailMergeField(fieldName) {
        (0, $gd0sY._)(this, SimpleMailMergeField);
        return (0, $8xMIM._)(this, SimpleMailMergeField, [
            " MERGEFIELD ".concat(fieldName, " "),
            "\xab".concat(fieldName, "\xbb")
        ]);
    }
    return SimpleMailMergeField;
}($94db4f2abf87558b$export$68548adcc40655f2);
var $94db4f2abf87558b$var$CommentAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(CommentAttributes, XmlAttributeComponent);
    function CommentAttributes() {
        (0, $gd0sY._)(this, CommentAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, CommentAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            id: "w:id",
            initials: "w:initials",
            author: "w:author",
            date: "w:date"
        });
        return _this;
    }
    return CommentAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$CommentRangeAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(CommentRangeAttributes, XmlAttributeComponent);
    function CommentRangeAttributes() {
        (0, $gd0sY._)(this, CommentRangeAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, CommentRangeAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            id: "w:id"
        });
        return _this;
    }
    return CommentRangeAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$RootCommentsAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(RootCommentsAttributes, XmlAttributeComponent);
    function RootCommentsAttributes() {
        (0, $gd0sY._)(this, RootCommentsAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, RootCommentsAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            "xmlns:cx": "xmlns:cx",
            "xmlns:cx1": "xmlns:cx1",
            "xmlns:cx2": "xmlns:cx2",
            "xmlns:cx3": "xmlns:cx3",
            "xmlns:cx4": "xmlns:cx4",
            "xmlns:cx5": "xmlns:cx5",
            "xmlns:cx6": "xmlns:cx6",
            "xmlns:cx7": "xmlns:cx7",
            "xmlns:cx8": "xmlns:cx8",
            "xmlns:mc": "xmlns:mc",
            "xmlns:aink": "xmlns:aink",
            "xmlns:am3d": "xmlns:am3d",
            "xmlns:o": "xmlns:o",
            "xmlns:r": "xmlns:r",
            "xmlns:m": "xmlns:m",
            "xmlns:v": "xmlns:v",
            "xmlns:wp14": "xmlns:wp14",
            "xmlns:wp": "xmlns:wp",
            "xmlns:w10": "xmlns:w10",
            "xmlns:w": "xmlns:w",
            "xmlns:w14": "xmlns:w14",
            "xmlns:w15": "xmlns:w15",
            "xmlns:w16cex": "xmlns:w16cex",
            "xmlns:w16cid": "xmlns:w16cid",
            "xmlns:w16": "xmlns:w16",
            "xmlns:w16sdtdh": "xmlns:w16sdtdh",
            "xmlns:w16se": "xmlns:w16se",
            "xmlns:wpg": "xmlns:wpg",
            "xmlns:wpi": "xmlns:wpi",
            "xmlns:wne": "xmlns:wne",
            "xmlns:wps": "xmlns:wps"
        });
        return _this;
    }
    return RootCommentsAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$7fae596544522c24 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(CommentRangeStart, XmlComponent);
    function CommentRangeStart(id) {
        (0, $gd0sY._)(this, CommentRangeStart);
        var _this;
        _this = (0, $8xMIM._)(this, CommentRangeStart, [
            "w:commentRangeStart"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$CommentRangeAttributes({
            id: id
        }));
        return _this;
    }
    return CommentRangeStart;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$1c909ece16de52c8 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(CommentRangeEnd, XmlComponent);
    function CommentRangeEnd(id) {
        (0, $gd0sY._)(this, CommentRangeEnd);
        var _this;
        _this = (0, $8xMIM._)(this, CommentRangeEnd, [
            "w:commentRangeEnd"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$CommentRangeAttributes({
            id: id
        }));
        return _this;
    }
    return CommentRangeEnd;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$4b42d1c3b05fc701 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(CommentReference, XmlComponent);
    function CommentReference(id) {
        (0, $gd0sY._)(this, CommentReference);
        var _this;
        _this = (0, $8xMIM._)(this, CommentReference, [
            "w:commentReference"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$CommentRangeAttributes({
            id: id
        }));
        return _this;
    }
    return CommentReference;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$4d299b491347818a = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Comment, XmlComponent);
    function Comment(param) {
        var id = param.id, initials = param.initials, author = param.author, _param_date = param.date, date = _param_date === void 0 ? /* @__PURE__ */ new Date() : _param_date, children = param.children;
        (0, $gd0sY._)(this, Comment);
        var _this;
        _this = (0, $8xMIM._)(this, Comment, [
            "w:comment"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$CommentAttributes({
            id: id,
            initials: initials,
            author: author,
            date: date.toISOString()
        }));
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                _this.root.push(child);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _this;
    }
    return Comment;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$434c217d363ea16 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Comments, XmlComponent);
    function Comments(param) {
        var children = param.children;
        (0, $gd0sY._)(this, Comments);
        var _this;
        _this = (0, $8xMIM._)(this, Comments, [
            "w:comments"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$RootCommentsAttributes({
            "xmlns:cx": "http://schemas.microsoft.com/office/drawing/2014/chartex",
            "xmlns:cx1": "http://schemas.microsoft.com/office/drawing/2015/9/8/chartex",
            "xmlns:cx2": "http://schemas.microsoft.com/office/drawing/2015/10/21/chartex",
            "xmlns:cx3": "http://schemas.microsoft.com/office/drawing/2016/5/9/chartex",
            "xmlns:cx4": "http://schemas.microsoft.com/office/drawing/2016/5/10/chartex",
            "xmlns:cx5": "http://schemas.microsoft.com/office/drawing/2016/5/11/chartex",
            "xmlns:cx6": "http://schemas.microsoft.com/office/drawing/2016/5/12/chartex",
            "xmlns:cx7": "http://schemas.microsoft.com/office/drawing/2016/5/13/chartex",
            "xmlns:cx8": "http://schemas.microsoft.com/office/drawing/2016/5/14/chartex",
            "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
            "xmlns:aink": "http://schemas.microsoft.com/office/drawing/2016/ink",
            "xmlns:am3d": "http://schemas.microsoft.com/office/drawing/2017/model3d",
            "xmlns:o": "urn:schemas-microsoft-com:office:office",
            "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
            "xmlns:m": "http://schemas.openxmlformats.org/officeDocument/2006/math",
            "xmlns:v": "urn:schemas-microsoft-com:vml",
            "xmlns:wp14": "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
            "xmlns:wp": "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
            "xmlns:w10": "urn:schemas-microsoft-com:office:word",
            "xmlns:w": "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
            "xmlns:w14": "http://schemas.microsoft.com/office/word/2010/wordml",
            "xmlns:w15": "http://schemas.microsoft.com/office/word/2012/wordml",
            "xmlns:w16cex": "http://schemas.microsoft.com/office/word/2018/wordml/cex",
            "xmlns:w16cid": "http://schemas.microsoft.com/office/word/2016/wordml/cid",
            "xmlns:w16": "http://schemas.microsoft.com/office/word/2018/wordml",
            "xmlns:w16sdtdh": "http://schemas.microsoft.com/office/word/2020/wordml/sdtdatahash",
            "xmlns:w16se": "http://schemas.microsoft.com/office/word/2015/wordml/symex",
            "xmlns:wpg": "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
            "xmlns:wpi": "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
            "xmlns:wne": "http://schemas.microsoft.com/office/word/2006/wordml",
            "xmlns:wps": "http://schemas.microsoft.com/office/word/2010/wordprocessingShape"
        }));
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                _this.root.push(new $94db4f2abf87558b$export$4d299b491347818a(child));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _this;
    }
    return Comments;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$89cf22b7cd4e5412 = /*#__PURE__*/ function(EmptyElement) {
    "use strict";
    (0, $NBk0Y._)(NoBreakHyphen, EmptyElement);
    function NoBreakHyphen() {
        (0, $gd0sY._)(this, NoBreakHyphen);
        return (0, $8xMIM._)(this, NoBreakHyphen, [
            "w:noBreakHyphen"
        ]);
    }
    return NoBreakHyphen;
}($94db4f2abf87558b$export$96977b263db98d55);
var $94db4f2abf87558b$export$4fc66ded9fea0dc2 = /*#__PURE__*/ function(EmptyElement) {
    "use strict";
    (0, $NBk0Y._)(SoftHyphen, EmptyElement);
    function SoftHyphen() {
        (0, $gd0sY._)(this, SoftHyphen);
        return (0, $8xMIM._)(this, SoftHyphen, [
            "w:softHyphen"
        ]);
    }
    return SoftHyphen;
}($94db4f2abf87558b$export$96977b263db98d55);
var $94db4f2abf87558b$export$7aa9b47ca2ad3435 = /*#__PURE__*/ function(EmptyElement) {
    "use strict";
    (0, $NBk0Y._)(DayShort, EmptyElement);
    function DayShort() {
        (0, $gd0sY._)(this, DayShort);
        return (0, $8xMIM._)(this, DayShort, [
            "w:dayShort"
        ]);
    }
    return DayShort;
}($94db4f2abf87558b$export$96977b263db98d55);
var $94db4f2abf87558b$export$cb13e7e828d466b4 = /*#__PURE__*/ function(EmptyElement) {
    "use strict";
    (0, $NBk0Y._)(MonthShort, EmptyElement);
    function MonthShort() {
        (0, $gd0sY._)(this, MonthShort);
        return (0, $8xMIM._)(this, MonthShort, [
            "w:monthShort"
        ]);
    }
    return MonthShort;
}($94db4f2abf87558b$export$96977b263db98d55);
var $94db4f2abf87558b$export$b22abff4e0bb2227 = /*#__PURE__*/ function(EmptyElement) {
    "use strict";
    (0, $NBk0Y._)(YearShort, EmptyElement);
    function YearShort() {
        (0, $gd0sY._)(this, YearShort);
        return (0, $8xMIM._)(this, YearShort, [
            "w:yearShort"
        ]);
    }
    return YearShort;
}($94db4f2abf87558b$export$96977b263db98d55);
var $94db4f2abf87558b$export$7f11aa0bd1185b81 = /*#__PURE__*/ function(EmptyElement) {
    "use strict";
    (0, $NBk0Y._)(DayLong, EmptyElement);
    function DayLong() {
        (0, $gd0sY._)(this, DayLong);
        return (0, $8xMIM._)(this, DayLong, [
            "w:dayLong"
        ]);
    }
    return DayLong;
}($94db4f2abf87558b$export$96977b263db98d55);
var $94db4f2abf87558b$export$fb4c8c9ac11bc45a = /*#__PURE__*/ function(EmptyElement) {
    "use strict";
    (0, $NBk0Y._)(MonthLong, EmptyElement);
    function MonthLong() {
        (0, $gd0sY._)(this, MonthLong);
        return (0, $8xMIM._)(this, MonthLong, [
            "w:monthLong"
        ]);
    }
    return MonthLong;
}($94db4f2abf87558b$export$96977b263db98d55);
var $94db4f2abf87558b$export$45f274d2a51212fa = /*#__PURE__*/ function(EmptyElement) {
    "use strict";
    (0, $NBk0Y._)(YearLong, EmptyElement);
    function YearLong() {
        (0, $gd0sY._)(this, YearLong);
        return (0, $8xMIM._)(this, YearLong, [
            "w:yearLong"
        ]);
    }
    return YearLong;
}($94db4f2abf87558b$export$96977b263db98d55);
var $94db4f2abf87558b$export$f2387e03417b0225 = /*#__PURE__*/ function(EmptyElement) {
    "use strict";
    (0, $NBk0Y._)(AnnotationReference, EmptyElement);
    function AnnotationReference() {
        (0, $gd0sY._)(this, AnnotationReference);
        return (0, $8xMIM._)(this, AnnotationReference, [
            "w:annotationRef"
        ]);
    }
    return AnnotationReference;
}($94db4f2abf87558b$export$96977b263db98d55);
var $94db4f2abf87558b$export$c55c754dfdb27980 = /*#__PURE__*/ function(EmptyElement) {
    "use strict";
    (0, $NBk0Y._)(FootnoteReferenceElement, EmptyElement);
    function FootnoteReferenceElement() {
        (0, $gd0sY._)(this, FootnoteReferenceElement);
        return (0, $8xMIM._)(this, FootnoteReferenceElement, [
            "w:footnoteRef"
        ]);
    }
    return FootnoteReferenceElement;
}($94db4f2abf87558b$export$96977b263db98d55);
var $94db4f2abf87558b$export$6ab9196e64545ac3 = /*#__PURE__*/ function(EmptyElement) {
    "use strict";
    (0, $NBk0Y._)(EndnoteReference, EmptyElement);
    function EndnoteReference() {
        (0, $gd0sY._)(this, EndnoteReference);
        return (0, $8xMIM._)(this, EndnoteReference, [
            "w:endnoteRef"
        ]);
    }
    return EndnoteReference;
}($94db4f2abf87558b$export$96977b263db98d55);
var $94db4f2abf87558b$export$1ff3c3f08ae963c0 = /*#__PURE__*/ function(EmptyElement) {
    "use strict";
    (0, $NBk0Y._)(Separator, EmptyElement);
    function Separator() {
        (0, $gd0sY._)(this, Separator);
        return (0, $8xMIM._)(this, Separator, [
            "w:separator"
        ]);
    }
    return Separator;
}($94db4f2abf87558b$export$96977b263db98d55);
var $94db4f2abf87558b$export$16dff850c66f7024 = /*#__PURE__*/ function(EmptyElement) {
    "use strict";
    (0, $NBk0Y._)(ContinuationSeparator, EmptyElement);
    function ContinuationSeparator() {
        (0, $gd0sY._)(this, ContinuationSeparator);
        return (0, $8xMIM._)(this, ContinuationSeparator, [
            "w:continuationSeparator"
        ]);
    }
    return ContinuationSeparator;
}($94db4f2abf87558b$export$96977b263db98d55);
var $94db4f2abf87558b$export$b31d4e59306b6dff = /*#__PURE__*/ function(EmptyElement) {
    "use strict";
    (0, $NBk0Y._)(PageNumberElement, EmptyElement);
    function PageNumberElement() {
        (0, $gd0sY._)(this, PageNumberElement);
        return (0, $8xMIM._)(this, PageNumberElement, [
            "w:pgNum"
        ]);
    }
    return PageNumberElement;
}($94db4f2abf87558b$export$96977b263db98d55);
var $94db4f2abf87558b$export$f30b2ad466b6f52c = /*#__PURE__*/ function(EmptyElement) {
    "use strict";
    (0, $NBk0Y._)(CarriageReturn, EmptyElement);
    function CarriageReturn() {
        (0, $gd0sY._)(this, CarriageReturn);
        return (0, $8xMIM._)(this, CarriageReturn, [
            "w:cr"
        ]);
    }
    return CarriageReturn;
}($94db4f2abf87558b$export$96977b263db98d55);
var $94db4f2abf87558b$export$3e41faf802a29e71 = /*#__PURE__*/ function(EmptyElement) {
    "use strict";
    (0, $NBk0Y._)(Tab, EmptyElement);
    function Tab() {
        (0, $gd0sY._)(this, Tab);
        return (0, $8xMIM._)(this, Tab, [
            "w:tab"
        ]);
    }
    return Tab;
}($94db4f2abf87558b$export$96977b263db98d55);
var $94db4f2abf87558b$export$381f05e113561c91 = /*#__PURE__*/ function(EmptyElement) {
    "use strict";
    (0, $NBk0Y._)(LastRenderedPageBreak, EmptyElement);
    function LastRenderedPageBreak() {
        (0, $gd0sY._)(this, LastRenderedPageBreak);
        return (0, $8xMIM._)(this, LastRenderedPageBreak, [
            "w:lastRenderedPageBreak"
        ]);
    }
    return LastRenderedPageBreak;
}($94db4f2abf87558b$export$96977b263db98d55);
var $94db4f2abf87558b$export$142f52a4680b9e5d = {
    LEFT: "left",
    CENTER: "center",
    RIGHT: "right"
};
var $94db4f2abf87558b$export$f2247382176912fd = {
    MARGIN: "margin",
    INDENT: "indent"
};
var $94db4f2abf87558b$export$9c74d220d8b0cb92 = {
    NONE: "none",
    DOT: "dot",
    HYPHEN: "hyphen",
    UNDERSCORE: "underscore",
    // eslint-disable-next-line @typescript-eslint/naming-convention
    MIDDLE_DOT: "middleDot"
};
var $94db4f2abf87558b$export$9e7f52ab4ae6a08b = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(PositionalTab, XmlComponent);
    function PositionalTab(options2) {
        (0, $gd0sY._)(this, PositionalTab);
        var _this;
        _this = (0, $8xMIM._)(this, PositionalTab, [
            "w:ptab"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$b95d92bd70e2302a({
            alignment: {
                key: "w:alignment",
                value: options2.alignment
            },
            relativeTo: {
                key: "w:relativeTo",
                value: options2.relativeTo
            },
            leader: {
                key: "w:leader",
                value: options2.leader
            }
        }));
        return _this;
    }
    return PositionalTab;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$BreakType = {
    COLUMN: "column",
    PAGE: "page"
};
var $94db4f2abf87558b$var$Break2 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Break2, XmlComponent);
    function Break2(type) {
        (0, $gd0sY._)(this, Break2);
        var _this;
        _this = (0, $8xMIM._)(this, Break2, [
            "w:br"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$21991851b0bb231f({
            type: type
        }));
        return _this;
    }
    return Break2;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$9423c247516c9fc8 = /*#__PURE__*/ function(Run) {
    "use strict";
    (0, $NBk0Y._)(PageBreak, Run);
    function PageBreak() {
        (0, $gd0sY._)(this, PageBreak);
        var _this;
        _this = (0, $8xMIM._)(this, PageBreak, [
            {}
        ]);
        _this.root.push(new $94db4f2abf87558b$var$Break2($94db4f2abf87558b$var$BreakType.PAGE));
        return _this;
    }
    return PageBreak;
}($94db4f2abf87558b$export$ddae37e51c7979e2);
var $94db4f2abf87558b$export$40b3a3732603d761 = /*#__PURE__*/ function(Run) {
    "use strict";
    (0, $NBk0Y._)(ColumnBreak, Run);
    function ColumnBreak() {
        (0, $gd0sY._)(this, ColumnBreak);
        var _this;
        _this = (0, $8xMIM._)(this, ColumnBreak, [
            {}
        ]);
        _this.root.push(new $94db4f2abf87558b$var$Break2($94db4f2abf87558b$var$BreakType.COLUMN));
        return _this;
    }
    return ColumnBreak;
}($94db4f2abf87558b$export$ddae37e51c7979e2);
var $94db4f2abf87558b$export$f4d23c02e5ffac1a = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(PageBreakBefore, XmlComponent);
    function PageBreakBefore() {
        (0, $gd0sY._)(this, PageBreakBefore);
        return (0, $8xMIM._)(this, PageBreakBefore, [
            "w:pageBreakBefore"
        ]);
    }
    return PageBreakBefore;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$595a14bf61dfe45b = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    AT_LEAST: "atLeast",
    EXACTLY: "exactly",
    EXACT: "exact",
    AUTO: "auto"
};
var $94db4f2abf87558b$var$SpacingAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(SpacingAttributes, XmlAttributeComponent);
    function SpacingAttributes() {
        (0, $gd0sY._)(this, SpacingAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, SpacingAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            after: "w:after",
            before: "w:before",
            line: "w:line",
            lineRule: "w:lineRule"
        });
        return _this;
    }
    return SpacingAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$a39947a896defee6 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Spacing, XmlComponent);
    function Spacing(options2) {
        (0, $gd0sY._)(this, Spacing);
        var _this;
        _this = (0, $8xMIM._)(this, Spacing, [
            "w:spacing"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$SpacingAttributes(options2));
        return _this;
    }
    return Spacing;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$148b6b80f73d2a18 = {
    HEADING_1: "Heading1",
    HEADING_2: "Heading2",
    HEADING_3: "Heading3",
    HEADING_4: "Heading4",
    HEADING_5: "Heading5",
    HEADING_6: "Heading6",
    TITLE: "Title"
};
var $94db4f2abf87558b$export$d9e45bc13d335801 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Style, XmlComponent);
    function Style(styleId) {
        (0, $gd0sY._)(this, Style);
        var _this;
        _this = (0, $8xMIM._)(this, Style, [
            "w:pStyle"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$21991851b0bb231f({
            val: styleId
        }));
        return _this;
    }
    return Style;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$639143e2dbee2d0 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(TabStop, XmlComponent);
    function TabStop(tabDefinitions) {
        (0, $gd0sY._)(this, TabStop);
        var _this;
        _this = (0, $8xMIM._)(this, TabStop, [
            "w:tabs"
        ]);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = tabDefinitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var tabDefinition = _step.value;
                _this.root.push(new $94db4f2abf87558b$export$f9728ec8c3f86596(tabDefinition));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _this;
    }
    return TabStop;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$2effbc422db8f8ed = {
    LEFT: "left",
    RIGHT: "right",
    CENTER: "center",
    BAR: "bar",
    CLEAR: "clear",
    DECIMAL: "decimal",
    END: "end",
    NUM: "num",
    START: "start"
};
var $94db4f2abf87558b$export$aa498464def7b45a = {
    DOT: "dot",
    HYPHEN: "hyphen",
    // eslint-disable-next-line @typescript-eslint/naming-convention
    MIDDLE_DOT: "middleDot",
    NONE: "none",
    UNDERSCORE: "underscore"
};
var $94db4f2abf87558b$export$d53250c7bcc57c01 = {
    MAX: 9026
};
var $94db4f2abf87558b$export$fbf624c7a128869a = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(TabAttributes, XmlAttributeComponent);
    function TabAttributes() {
        (0, $gd0sY._)(this, TabAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, TabAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            val: "w:val",
            pos: "w:pos",
            leader: "w:leader"
        });
        return _this;
    }
    return TabAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$f9728ec8c3f86596 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(TabStopItem, XmlComponent);
    function TabStopItem(param) {
        var type = param.type, position = param.position, leader = param.leader;
        (0, $gd0sY._)(this, TabStopItem);
        var _this;
        _this = (0, $8xMIM._)(this, TabStopItem, [
            "w:tab"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$fbf624c7a128869a({
            val: type,
            pos: position,
            leader: leader
        }));
        return _this;
    }
    return TabStopItem;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$b5d3f7ce2f820092 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(NumberProperties, XmlComponent);
    function NumberProperties(numberId, indentLevel) {
        (0, $gd0sY._)(this, NumberProperties);
        var _this;
        _this = (0, $8xMIM._)(this, NumberProperties, [
            "w:numPr"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$IndentLevel(indentLevel));
        _this.root.push(new $94db4f2abf87558b$var$NumberId(numberId));
        return _this;
    }
    return NumberProperties;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$IndentLevel = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(IndentLevel, XmlComponent);
    function IndentLevel(level) {
        (0, $gd0sY._)(this, IndentLevel);
        var _this;
        _this = (0, $8xMIM._)(this, IndentLevel, [
            "w:ilvl"
        ]);
        if (level > 9) throw new Error("Level cannot be greater than 9. Read more here: https://answers.microsoft.com/en-us/msoffice/forum/all/does-word-support-more-than-9-list-levels/d130fdcd-1781-446d-8c84-c6c79124e4d7");
        _this.root.push(new $94db4f2abf87558b$export$21991851b0bb231f({
            val: level
        }));
        return _this;
    }
    return IndentLevel;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$NumberId = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(NumberId, XmlComponent);
    function NumberId(id) {
        (0, $gd0sY._)(this, NumberId);
        var _this;
        _this = (0, $8xMIM._)(this, NumberId, [
            "w:numId"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$21991851b0bb231f({
            val: typeof id === "string" ? "{".concat(id, "}") : id
        }));
        return _this;
    }
    return NumberId;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$FileChild = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(FileChild, XmlComponent);
    function FileChild() {
        (0, $gd0sY._)(this, FileChild);
        var _this;
        _this = (0, $8xMIM._)(this, FileChild, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "fileChild", Symbol());
        return _this;
    }
    return FileChild;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$RelationshipAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(RelationshipAttributes, XmlAttributeComponent);
    function RelationshipAttributes() {
        (0, $gd0sY._)(this, RelationshipAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, RelationshipAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            id: "Id",
            type: "Type",
            target: "Target",
            targetMode: "TargetMode"
        });
        return _this;
    }
    return RelationshipAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$TargetModeType = {
    EXTERNAL: "External"
};
var $94db4f2abf87558b$var$Relationship = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Relationship, XmlComponent);
    function Relationship(id, type, target, targetMode) {
        (0, $gd0sY._)(this, Relationship);
        var _this;
        _this = (0, $8xMIM._)(this, Relationship, [
            "Relationship"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$RelationshipAttributes({
            id: id,
            type: type,
            target: target,
            targetMode: targetMode
        }));
        return _this;
    }
    return Relationship;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$HyperlinkAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(HyperlinkAttributes, XmlAttributeComponent);
    function HyperlinkAttributes() {
        (0, $gd0sY._)(this, HyperlinkAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, HyperlinkAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            id: "r:id",
            history: "w:history",
            anchor: "w:anchor"
        });
        return _this;
    }
    return HyperlinkAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$3d0da6f803a431e6 = {
    INTERNAL: "INTERNAL",
    EXTERNAL: "EXTERNAL"
};
var $94db4f2abf87558b$export$6beda279b4a51476 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(ConcreteHyperlink, XmlComponent);
    function ConcreteHyperlink(children, relationshipId, anchor) {
        (0, $gd0sY._)(this, ConcreteHyperlink);
        var _this;
        _this = (0, $8xMIM._)(this, ConcreteHyperlink, [
            "w:hyperlink"
        ]);
        $94db4f2abf87558b$var$__publicField(_this, "linkId");
        _this.linkId = relationshipId;
        var props = {
            history: 1,
            anchor: anchor ? anchor : void 0,
            id: !anchor ? "rId".concat(_this.linkId) : void 0
        };
        var attributes = new $94db4f2abf87558b$var$HyperlinkAttributes(props);
        _this.root.push(attributes);
        children.forEach(function(child) {
            _this.root.push(child);
        });
        return _this;
    }
    return ConcreteHyperlink;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$d6a545b6cd90455e = /*#__PURE__*/ function(ConcreteHyperlink) {
    "use strict";
    (0, $NBk0Y._)(InternalHyperlink, ConcreteHyperlink);
    function InternalHyperlink(options2) {
        (0, $gd0sY._)(this, InternalHyperlink);
        return (0, $8xMIM._)(this, InternalHyperlink, [
            options2.children,
            $94db4f2abf87558b$export$8b15d37bc3f197d4(),
            options2.anchor
        ]);
    }
    return InternalHyperlink;
}($94db4f2abf87558b$export$6beda279b4a51476);
var $94db4f2abf87558b$export$6ea6a3f0b2b263f3 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(ExternalHyperlink, XmlComponent);
    function ExternalHyperlink(options2) {
        (0, $gd0sY._)(this, ExternalHyperlink);
        var _this;
        _this = (0, $8xMIM._)(this, ExternalHyperlink, [
            "w:externalHyperlink"
        ]);
        _this.options = options2;
        return _this;
    }
    return ExternalHyperlink;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$BookmarkStartAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(BookmarkStartAttributes, XmlAttributeComponent);
    function BookmarkStartAttributes() {
        (0, $gd0sY._)(this, BookmarkStartAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, BookmarkStartAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            id: "w:id",
            name: "w:name"
        });
        return _this;
    }
    return BookmarkStartAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$BookmarkEndAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(BookmarkEndAttributes, XmlAttributeComponent);
    function BookmarkEndAttributes() {
        (0, $gd0sY._)(this, BookmarkEndAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, BookmarkEndAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            id: "w:id"
        });
        return _this;
    }
    return BookmarkEndAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$301ef70c5c7bdf65 = function Bookmark(options2) {
    "use strict";
    (0, $gd0sY._)(this, Bookmark);
    $94db4f2abf87558b$var$__publicField(this, "bookmarkUniqueNumericId", $94db4f2abf87558b$export$3be069097e26ba4c());
    $94db4f2abf87558b$var$__publicField(this, "start");
    $94db4f2abf87558b$var$__publicField(this, "children");
    $94db4f2abf87558b$var$__publicField(this, "end");
    var linkId = this.bookmarkUniqueNumericId();
    this.start = new $94db4f2abf87558b$export$ad0c5cb04e0f1440(options2.id, linkId);
    this.children = options2.children;
    this.end = new $94db4f2abf87558b$export$9b661a8aff2b962a(linkId);
};
var $94db4f2abf87558b$export$ad0c5cb04e0f1440 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(BookmarkStart, XmlComponent);
    function BookmarkStart(id, linkId) {
        (0, $gd0sY._)(this, BookmarkStart);
        var _this;
        _this = (0, $8xMIM._)(this, BookmarkStart, [
            "w:bookmarkStart"
        ]);
        var attributes = new $94db4f2abf87558b$var$BookmarkStartAttributes({
            name: id,
            id: linkId
        });
        _this.root.push(attributes);
        return _this;
    }
    return BookmarkStart;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$9b661a8aff2b962a = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(BookmarkEnd, XmlComponent);
    function BookmarkEnd(linkId) {
        (0, $gd0sY._)(this, BookmarkEnd);
        var _this;
        _this = (0, $8xMIM._)(this, BookmarkEnd, [
            "w:bookmarkEnd"
        ]);
        var attributes = new $94db4f2abf87558b$var$BookmarkEndAttributes({
            id: linkId
        });
        _this.root.push(attributes);
        return _this;
    }
    return BookmarkEnd;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$2d9dc1cf136663b0 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(OutlineLevel, XmlComponent);
    function OutlineLevel(level) {
        (0, $gd0sY._)(this, OutlineLevel);
        var _this;
        _this = (0, $8xMIM._)(this, OutlineLevel, [
            "w:outlineLvl"
        ]);
        _this.level = level;
        _this.root.push(new $94db4f2abf87558b$export$21991851b0bb231f({
            val: level
        }));
        return _this;
    }
    return OutlineLevel;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$PageReferenceFieldInstruction = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(PageReferenceFieldInstruction, XmlComponent);
    function PageReferenceFieldInstruction(bookmarkId) {
        var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $gd0sY._)(this, PageReferenceFieldInstruction);
        var _this;
        _this = (0, $8xMIM._)(this, PageReferenceFieldInstruction, [
            "w:instrText"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$TextAttributes({
            space: $94db4f2abf87558b$export$bb538ef550ced38.PRESERVE
        }));
        var instruction = "PAGEREF ".concat(bookmarkId);
        if (options2.hyperlink) instruction = "".concat(instruction, " \\h");
        if (options2.useRelativePosition) instruction = "".concat(instruction, " \\p");
        _this.root.push(instruction);
        return _this;
    }
    return PageReferenceFieldInstruction;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$d235dfd3d86270a3 = /*#__PURE__*/ function(Run) {
    "use strict";
    (0, $NBk0Y._)(PageReference, Run);
    function PageReference(bookmarkId) {
        var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $gd0sY._)(this, PageReference);
        return (0, $8xMIM._)(this, PageReference, [
            {
                children: [
                    new $94db4f2abf87558b$var$Begin(true),
                    new $94db4f2abf87558b$var$PageReferenceFieldInstruction(bookmarkId, options2),
                    new $94db4f2abf87558b$var$End()
                ]
            }
        ]);
    }
    return PageReference;
}($94db4f2abf87558b$export$ddae37e51c7979e2);
var $94db4f2abf87558b$export$cbd1a71eaec89d7d = {
    BOTTOM: "bottom",
    CENTER: "center",
    TOP: "top"
};
var $94db4f2abf87558b$export$f53f51ea6e65c652 = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(VerticalAlignAttributes, XmlAttributeComponent);
    function VerticalAlignAttributes() {
        (0, $gd0sY._)(this, VerticalAlignAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, VerticalAlignAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            verticalAlign: "w:val"
        });
        return _this;
    }
    return VerticalAlignAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$a6efa4726c94649f = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(VerticalAlignElement, XmlComponent);
    function VerticalAlignElement(value) {
        (0, $gd0sY._)(this, VerticalAlignElement);
        var _this;
        _this = (0, $8xMIM._)(this, VerticalAlignElement, [
            "w:vAlign"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$f53f51ea6e65c652({
            verticalAlign: value
        }));
        return _this;
    }
    return VerticalAlignElement;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$df165515f58460ef = {
    DEFAULT: "default",
    FIRST: "first",
    EVEN: "even"
};
var $94db4f2abf87558b$var$FooterReferenceAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(FooterReferenceAttributes, XmlAttributeComponent);
    function FooterReferenceAttributes() {
        (0, $gd0sY._)(this, FooterReferenceAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, FooterReferenceAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            type: "w:type",
            id: "r:id"
        });
        return _this;
    }
    return FooterReferenceAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$a43a9c8e52ad1cf8 = {
    HEADER: "w:headerReference",
    FOOTER: "w:footerReference"
};
var $94db4f2abf87558b$export$5e9115ca7d433920 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(HeaderFooterReference, XmlComponent);
    function HeaderFooterReference(type, options2) {
        (0, $gd0sY._)(this, HeaderFooterReference);
        var _this;
        _this = (0, $8xMIM._)(this, HeaderFooterReference, [
            type
        ]);
        _this.root.push(new $94db4f2abf87558b$var$FooterReferenceAttributes({
            type: options2.type || $94db4f2abf87558b$export$df165515f58460ef.DEFAULT,
            id: "rId".concat(options2.id)
        }));
        return _this;
    }
    return HeaderFooterReference;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$f02cc02ad0e0bba3 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Columns, XmlComponent);
    function Columns(param) {
        var space = param.space, count = param.count, separate = param.separate, equalWidth = param.equalWidth, children = param.children;
        (0, $gd0sY._)(this, Columns);
        var _this;
        _this = (0, $8xMIM._)(this, Columns, [
            "w:cols"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$b95d92bd70e2302a({
            space: {
                key: "w:space",
                value: space === void 0 ? void 0 : $94db4f2abf87558b$export$ffe63bc01ceacb3d(space)
            },
            count: {
                key: "w:num",
                value: count === void 0 ? void 0 : $94db4f2abf87558b$export$3965b376946dc953(count)
            },
            separate: {
                key: "w:sep",
                value: separate
            },
            equalWidth: {
                key: "w:equalWidth",
                value: equalWidth
            }
        }));
        if (!equalWidth && children) children.forEach(function(column) {
            return _this.addChildElement(column);
        });
        return _this;
    }
    return Columns;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$4ad510af33d57e8f = {
    DEFAULT: "default",
    LINES: "lines",
    LINES_AND_CHARS: "linesAndChars",
    SNAP_TO_CHARS: "snapToChars"
};
var $94db4f2abf87558b$export$2748d582b124a036 = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(DocGridAttributes, XmlAttributeComponent);
    function DocGridAttributes() {
        (0, $gd0sY._)(this, DocGridAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, DocGridAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            type: "w:type",
            linePitch: "w:linePitch",
            charSpace: "w:charSpace"
        });
        return _this;
    }
    return DocGridAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$f8ae39f1be25f01a = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(DocumentGrid, XmlComponent);
    function DocumentGrid(linePitch, charSpace, type) {
        (0, $gd0sY._)(this, DocumentGrid);
        var _this;
        _this = (0, $8xMIM._)(this, DocumentGrid, [
            "w:docGrid"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$2748d582b124a036({
            type: type,
            linePitch: $94db4f2abf87558b$export$3965b376946dc953(linePitch),
            charSpace: charSpace ? $94db4f2abf87558b$export$3965b376946dc953(charSpace) : void 0
        }));
        return _this;
    }
    return DocumentGrid;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$40c8287995802d41 = {
    NEW_PAGE: "newPage",
    NEW_SECTION: "newSection",
    CONTINUOUS: "continuous"
};
var $94db4f2abf87558b$export$3484f2bb52b39a49 = function(param) {
    var countBy = param.countBy, start = param.start, restart = param.restart, distance = param.distance;
    return new $94db4f2abf87558b$export$da493cbe1334accc({
        name: "w:lnNumType",
        attributes: {
            countBy: {
                key: "w:countBy",
                value: countBy === void 0 ? void 0 : $94db4f2abf87558b$export$3965b376946dc953(countBy)
            },
            start: {
                key: "w:start",
                value: start === void 0 ? void 0 : $94db4f2abf87558b$export$3965b376946dc953(start)
            },
            restart: {
                key: "w:restart",
                value: restart
            },
            distance: {
                key: "w:distance",
                value: distance === void 0 ? void 0 : $94db4f2abf87558b$export$ffe63bc01ceacb3d(distance)
            }
        }
    });
};
var $94db4f2abf87558b$export$8bb308995b75dd36 = {
    ALL_PAGES: "allPages",
    FIRST_PAGE: "firstPage",
    NOT_FIRST_PAGE: "notFirstPage"
};
var $94db4f2abf87558b$export$c9d82c5cfac1c6f = {
    PAGE: "page",
    TEXT: "text"
};
var $94db4f2abf87558b$export$1f518d53a9e51fd8 = {
    BACK: "back",
    FRONT: "front"
};
var $94db4f2abf87558b$var$PageBordersAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(PageBordersAttributes, XmlAttributeComponent);
    function PageBordersAttributes() {
        (0, $gd0sY._)(this, PageBordersAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, PageBordersAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            display: "w:display",
            offsetFrom: "w:offsetFrom",
            zOrder: "w:zOrder"
        });
        return _this;
    }
    return PageBordersAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$de9d08c3f4557a89 = /*#__PURE__*/ function(IgnoreIfEmptyXmlComponent) {
    "use strict";
    (0, $NBk0Y._)(PageBorders, IgnoreIfEmptyXmlComponent);
    function PageBorders(options2) {
        (0, $gd0sY._)(this, PageBorders);
        var _this;
        _this = (0, $8xMIM._)(this, PageBorders, [
            "w:pgBorders"
        ]);
        if (!options2) return (0, $cRssL._)(_this, _this);
        if (options2.pageBorders) _this.root.push(new $94db4f2abf87558b$var$PageBordersAttributes({
            display: options2.pageBorders.display,
            offsetFrom: options2.pageBorders.offsetFrom,
            zOrder: options2.pageBorders.zOrder
        }));
        else _this.root.push(new $94db4f2abf87558b$var$PageBordersAttributes({}));
        if (options2.pageBorderTop) _this.root.push(new $94db4f2abf87558b$export$a6733098a4eb57cf("w:top", options2.pageBorderTop));
        if (options2.pageBorderLeft) _this.root.push(new $94db4f2abf87558b$export$a6733098a4eb57cf("w:left", options2.pageBorderLeft));
        if (options2.pageBorderBottom) _this.root.push(new $94db4f2abf87558b$export$a6733098a4eb57cf("w:bottom", options2.pageBorderBottom));
        if (options2.pageBorderRight) _this.root.push(new $94db4f2abf87558b$export$a6733098a4eb57cf("w:right", options2.pageBorderRight));
        return _this;
    }
    return PageBorders;
}($94db4f2abf87558b$export$951524d865ce655a);
var $94db4f2abf87558b$export$c4c7c131dba7ddb8 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(PageMargin, XmlComponent);
    function PageMargin(top, right, bottom, left, header, footer, gutter) {
        (0, $gd0sY._)(this, PageMargin);
        var _this;
        _this = (0, $8xMIM._)(this, PageMargin, [
            "w:pgMar"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$b95d92bd70e2302a({
            top: {
                key: "w:top",
                value: $94db4f2abf87558b$export$866cabb7ed3455e9(top)
            },
            right: {
                key: "w:right",
                value: $94db4f2abf87558b$export$ffe63bc01ceacb3d(right)
            },
            bottom: {
                key: "w:bottom",
                value: $94db4f2abf87558b$export$866cabb7ed3455e9(bottom)
            },
            left: {
                key: "w:left",
                value: $94db4f2abf87558b$export$ffe63bc01ceacb3d(left)
            },
            header: {
                key: "w:header",
                value: $94db4f2abf87558b$export$ffe63bc01ceacb3d(header)
            },
            footer: {
                key: "w:footer",
                value: $94db4f2abf87558b$export$ffe63bc01ceacb3d(footer)
            },
            gutter: {
                key: "w:gutter",
                value: $94db4f2abf87558b$export$ffe63bc01ceacb3d(gutter)
            }
        }));
        return _this;
    }
    return PageMargin;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$48aa6fc1cd40b49e = {
    HYPHEN: "hyphen",
    PERIOD: "period",
    COLON: "colon",
    EM_DASH: "emDash",
    EN_DASH: "endash"
};
var $94db4f2abf87558b$export$e3b964361512152d = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(PageNumberTypeAttributes, XmlAttributeComponent);
    function PageNumberTypeAttributes() {
        (0, $gd0sY._)(this, PageNumberTypeAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, PageNumberTypeAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            start: "w:start",
            formatType: "w:fmt",
            separator: "w:chapSep"
        });
        return _this;
    }
    return PageNumberTypeAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$fa056ea14efefec7 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(PageNumberType, XmlComponent);
    function PageNumberType(param) {
        var start = param.start, formatType = param.formatType, separator = param.separator;
        (0, $gd0sY._)(this, PageNumberType);
        var _this;
        _this = (0, $8xMIM._)(this, PageNumberType, [
            "w:pgNumType"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$e3b964361512152d({
            start: start === void 0 ? void 0 : $94db4f2abf87558b$export$3965b376946dc953(start),
            formatType: formatType,
            separator: separator
        }));
        return _this;
    }
    return PageNumberType;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$67acfc4ca0bb516e = {
    PORTRAIT: "portrait",
    LANDSCAPE: "landscape"
};
var $94db4f2abf87558b$export$58806466e4f39b44 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(PageSize, XmlComponent);
    function PageSize(width, height, orientation) {
        (0, $gd0sY._)(this, PageSize);
        var _this;
        _this = (0, $8xMIM._)(this, PageSize, [
            "w:pgSz"
        ]);
        var flip = orientation === $94db4f2abf87558b$export$67acfc4ca0bb516e.LANDSCAPE;
        var widthTwips = $94db4f2abf87558b$export$ffe63bc01ceacb3d(width);
        var heightTwips = $94db4f2abf87558b$export$ffe63bc01ceacb3d(height);
        _this.root.push(new $94db4f2abf87558b$export$b95d92bd70e2302a({
            width: {
                key: "w:w",
                value: flip ? heightTwips : widthTwips
            },
            height: {
                key: "w:h",
                value: flip ? widthTwips : heightTwips
            },
            orientation: {
                key: "w:orient",
                value: orientation
            }
        }));
        return _this;
    }
    return PageSize;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$853e5073bac6becf = {
    LEFT_TO_RIGHT_TOP_TO_BOTTOM: "lrTb",
    TOP_TO_BOTTOM_RIGHT_TO_LEFT: "tbRl"
};
var $94db4f2abf87558b$var$PageTextDirectionAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(PageTextDirectionAttributes, XmlAttributeComponent);
    function PageTextDirectionAttributes() {
        (0, $gd0sY._)(this, PageTextDirectionAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, PageTextDirectionAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            val: "w:val"
        });
        return _this;
    }
    return PageTextDirectionAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$e7b14932bf37ca00 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(PageTextDirection, XmlComponent);
    function PageTextDirection(value) {
        (0, $gd0sY._)(this, PageTextDirection);
        var _this;
        _this = (0, $8xMIM._)(this, PageTextDirection, [
            "w:textDirection"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$PageTextDirectionAttributes({
            val: value
        }));
        return _this;
    }
    return PageTextDirection;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$baf8ba8b113e8dcf = {
    NEXT_PAGE: "nextPage",
    NEXT_COLUMN: "nextColumn",
    CONTINUOUS: "continuous",
    EVEN_PAGE: "evenPage",
    ODD_PAGE: "oddPage"
};
var $94db4f2abf87558b$export$f0431657ae3c761f = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(SectionTypeAttributes, XmlAttributeComponent);
    function SectionTypeAttributes() {
        (0, $gd0sY._)(this, SectionTypeAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, SectionTypeAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            val: "w:val"
        });
        return _this;
    }
    return SectionTypeAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$92738401e1603719 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Type, XmlComponent);
    function Type(value) {
        (0, $gd0sY._)(this, Type);
        var _this;
        _this = (0, $8xMIM._)(this, Type, [
            "w:type"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$f0431657ae3c761f({
            val: value
        }));
        return _this;
    }
    return Type;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$e0587973aabf6efb = {
    TOP: 1440,
    RIGHT: 1440,
    BOTTOM: 1440,
    LEFT: 1440,
    HEADER: 708,
    FOOTER: 708,
    GUTTER: 0
};
var $94db4f2abf87558b$export$9cd1a883da4c58e9 = {
    WIDTH: 11906,
    HEIGHT: 16838,
    ORIENTATION: $94db4f2abf87558b$export$67acfc4ca0bb516e.PORTRAIT
};
var $94db4f2abf87558b$export$785f0f5de588d020 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(SectionProperties, XmlComponent);
    function SectionProperties() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, tmp = _ref.page, _ref1 = tmp === void 0 ? {} : tmp, tmp1 = _ref1.size, _ref2 = tmp1 === void 0 ? {} : tmp1, _ref_width = _ref2.width, width = _ref_width === void 0 ? $94db4f2abf87558b$export$9cd1a883da4c58e9.WIDTH : _ref_width, _ref_height = _ref2.height, height = _ref_height === void 0 ? $94db4f2abf87558b$export$9cd1a883da4c58e9.HEIGHT : _ref_height, _ref_orientation = _ref2.orientation, orientation = _ref_orientation === void 0 ? $94db4f2abf87558b$export$9cd1a883da4c58e9.ORIENTATION : _ref_orientation, tmp2 = _ref1.margin, _ref3 = tmp2 === void 0 ? {} : tmp2, _ref_top = _ref3.top, top = _ref_top === void 0 ? $94db4f2abf87558b$export$e0587973aabf6efb.TOP : _ref_top, _ref_right = _ref3.right, right = _ref_right === void 0 ? $94db4f2abf87558b$export$e0587973aabf6efb.RIGHT : _ref_right, _ref_bottom = _ref3.bottom, bottom = _ref_bottom === void 0 ? $94db4f2abf87558b$export$e0587973aabf6efb.BOTTOM : _ref_bottom, _ref_left = _ref3.left, left = _ref_left === void 0 ? $94db4f2abf87558b$export$e0587973aabf6efb.LEFT : _ref_left, _ref_header = _ref3.header, header = _ref_header === void 0 ? $94db4f2abf87558b$export$e0587973aabf6efb.HEADER : _ref_header, _ref_footer = _ref3.footer, footer = _ref_footer === void 0 ? $94db4f2abf87558b$export$e0587973aabf6efb.FOOTER : _ref_footer, _ref_gutter = _ref3.gutter, gutter = _ref_gutter === void 0 ? $94db4f2abf87558b$export$e0587973aabf6efb.GUTTER : _ref_gutter, _ref_pageNumbers = _ref1.pageNumbers, pageNumbers = _ref_pageNumbers === void 0 ? {} : _ref_pageNumbers, borders = _ref1.borders, textDirection = _ref1.textDirection, tmp3 = _ref.grid, _ref4 = tmp3 === void 0 ? {} : tmp3, _ref_linePitch = _ref4.linePitch, linePitch = _ref_linePitch === void 0 ? 360 : _ref_linePitch, charSpace = _ref4.charSpace, gridType = _ref4.type, _ref_headerWrapperGroup = _ref.headerWrapperGroup, headerWrapperGroup = _ref_headerWrapperGroup === void 0 ? {} : _ref_headerWrapperGroup, _ref_footerWrapperGroup = _ref.footerWrapperGroup, footerWrapperGroup = _ref_footerWrapperGroup === void 0 ? {} : _ref_footerWrapperGroup, lineNumbers = _ref.lineNumbers, titlePage = _ref.titlePage, verticalAlign = _ref.verticalAlign, column = _ref.column, type = _ref.type;
        (0, $gd0sY._)(this, SectionProperties);
        var _this;
        _this = (0, $8xMIM._)(this, SectionProperties, [
            "w:sectPr"
        ]);
        _this.addHeaderFooterGroup($94db4f2abf87558b$export$a43a9c8e52ad1cf8.HEADER, headerWrapperGroup);
        _this.addHeaderFooterGroup($94db4f2abf87558b$export$a43a9c8e52ad1cf8.FOOTER, footerWrapperGroup);
        if (type) _this.root.push(new $94db4f2abf87558b$export$92738401e1603719(type));
        _this.root.push(new $94db4f2abf87558b$export$58806466e4f39b44(width, height, orientation));
        _this.root.push(new $94db4f2abf87558b$export$c4c7c131dba7ddb8(top, right, bottom, left, header, footer, gutter));
        if (borders) _this.root.push(new $94db4f2abf87558b$export$de9d08c3f4557a89(borders));
        if (lineNumbers) _this.root.push($94db4f2abf87558b$export$3484f2bb52b39a49(lineNumbers));
        _this.root.push(new $94db4f2abf87558b$export$fa056ea14efefec7(pageNumbers));
        if (column) _this.root.push(new $94db4f2abf87558b$export$f02cc02ad0e0bba3(column));
        if (verticalAlign) _this.root.push(new $94db4f2abf87558b$export$a6efa4726c94649f(verticalAlign));
        if (titlePage !== void 0) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:titlePg", titlePage));
        if (textDirection) _this.root.push(new $94db4f2abf87558b$export$e7b14932bf37ca00(textDirection));
        _this.root.push(new $94db4f2abf87558b$export$f8ae39f1be25f01a(linePitch, charSpace, gridType));
        return _this;
    }
    (0, $7cSld._)(SectionProperties, [
        {
            key: "addHeaderFooterGroup",
            value: function addHeaderFooterGroup(type, group) {
                if (group.default) this.root.push(new $94db4f2abf87558b$export$5e9115ca7d433920(type, {
                    type: $94db4f2abf87558b$export$df165515f58460ef.DEFAULT,
                    id: group.default.View.ReferenceId
                }));
                if (group.first) this.root.push(new $94db4f2abf87558b$export$5e9115ca7d433920(type, {
                    type: $94db4f2abf87558b$export$df165515f58460ef.FIRST,
                    id: group.first.View.ReferenceId
                }));
                if (group.even) this.root.push(new $94db4f2abf87558b$export$5e9115ca7d433920(type, {
                    type: $94db4f2abf87558b$export$df165515f58460ef.EVEN,
                    id: group.even.View.ReferenceId
                }));
            }
        }
    ]);
    return SectionProperties;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$4b2c32e08f77ff18 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Body, XmlComponent);
    function Body() {
        (0, $gd0sY._)(this, Body);
        var _this;
        _this = (0, $8xMIM._)(this, Body, [
            "w:body"
        ]);
        // eslint-disable-next-line functional/prefer-readonly-type
        $94db4f2abf87558b$var$__publicField(_this, "sections", []);
        return _this;
    }
    (0, $7cSld._)(Body, [
        {
            /**
   * Adds new section properties.
   * Note: Previous section is created in paragraph after the current element, and then new section will be added.
   * The spec says:
   *  - section element should be in the last paragraph of the section
   *  - last section should be direct child of body
   *
   * @param options new section options
   */ key: "addSection",
            value: function addSection(options2) {
                var currentSection = this.sections.pop();
                this.root.push(this.createSectionParagraph(currentSection));
                this.sections.push(new $94db4f2abf87558b$export$785f0f5de588d020(options2));
            }
        },
        {
            key: "prepForXml",
            value: function prepForXml(context) {
                if (this.sections.length === 1) {
                    this.root.splice(0, 1);
                    this.root.push(this.sections.pop());
                }
                return (0, $bl6Nv._)((0, $7GsX9._)(Body.prototype), "prepForXml", this).call(this, context);
            }
        },
        {
            key: "push",
            value: function push(component) {
                this.root.push(component);
            }
        },
        {
            key: "createSectionParagraph",
            value: function createSectionParagraph(section) {
                var paragraph = new $94db4f2abf87558b$export$358a232cca1ab2ac({});
                var properties = new $94db4f2abf87558b$export$2580ab652a992a27({});
                properties.push(section);
                paragraph.addChildElement(properties);
                return paragraph;
            }
        }
    ]);
    return Body;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$816b5d811295e6bc = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Column, XmlComponent);
    function Column(param) {
        var width = param.width, space = param.space;
        (0, $gd0sY._)(this, Column);
        var _this;
        _this = (0, $8xMIM._)(this, Column, [
            "w:col"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$b95d92bd70e2302a({
            width: {
                key: "w:w",
                value: $94db4f2abf87558b$export$ffe63bc01ceacb3d(width)
            },
            space: {
                key: "w:space",
                value: space === void 0 ? void 0 : $94db4f2abf87558b$export$ffe63bc01ceacb3d(space)
            }
        }));
        return _this;
    }
    return Column;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$e2bedb2588efb3f4 = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(DocumentAttributes, XmlAttributeComponent);
    function DocumentAttributes() {
        (0, $gd0sY._)(this, DocumentAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, DocumentAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            wpc: "xmlns:wpc",
            mc: "xmlns:mc",
            o: "xmlns:o",
            r: "xmlns:r",
            m: "xmlns:m",
            v: "xmlns:v",
            wp14: "xmlns:wp14",
            wp: "xmlns:wp",
            w10: "xmlns:w10",
            w: "xmlns:w",
            w14: "xmlns:w14",
            w15: "xmlns:w15",
            wpg: "xmlns:wpg",
            wpi: "xmlns:wpi",
            wne: "xmlns:wne",
            wps: "xmlns:wps",
            Ignorable: "mc:Ignorable",
            cp: "xmlns:cp",
            dc: "xmlns:dc",
            dcterms: "xmlns:dcterms",
            dcmitype: "xmlns:dcmitype",
            xsi: "xmlns:xsi",
            type: "xsi:type",
            cx: "xmlns:cx",
            cx1: "xmlns:cx1",
            cx2: "xmlns:cx2",
            cx3: "xmlns:cx3",
            cx4: "xmlns:cx4",
            cx5: "xmlns:cx5",
            cx6: "xmlns:cx6",
            cx7: "xmlns:cx7",
            cx8: "xmlns:cx8",
            aink: "xmlns:aink",
            am3d: "xmlns:am3d",
            w16cex: "xmlns:w16cex",
            w16cid: "xmlns:w16cid",
            w16: "xmlns:w16",
            w16sdtdh: "xmlns:w16sdtdh",
            w16se: "xmlns:w16se"
        });
        return _this;
    }
    return DocumentAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$12711c2c2d60b4b5 = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(DocumentBackgroundAttributes, XmlAttributeComponent);
    function DocumentBackgroundAttributes() {
        (0, $gd0sY._)(this, DocumentBackgroundAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, DocumentBackgroundAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            color: "w:color",
            themeColor: "w:themeColor",
            themeShade: "w:themeShade",
            themeTint: "w:themeTint"
        });
        return _this;
    }
    return DocumentBackgroundAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$a4418effc9bcba0b = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(DocumentBackground, XmlComponent);
    function DocumentBackground(options2) {
        (0, $gd0sY._)(this, DocumentBackground);
        var _this;
        _this = (0, $8xMIM._)(this, DocumentBackground, [
            "w:background"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$12711c2c2d60b4b5({
            color: options2.color === void 0 ? void 0 : $94db4f2abf87558b$export$39c9e6e42c794b97(options2.color),
            themeColor: options2.themeColor,
            themeShade: options2.themeShade === void 0 ? void 0 : $94db4f2abf87558b$export$2a22699fe7518b3d(options2.themeShade),
            themeTint: options2.themeTint === void 0 ? void 0 : $94db4f2abf87558b$export$2a22699fe7518b3d(options2.themeTint)
        }));
        return _this;
    }
    return DocumentBackground;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$Document = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Document, XmlComponent);
    function Document(options2) {
        (0, $gd0sY._)(this, Document);
        var _this;
        _this = (0, $8xMIM._)(this, Document, [
            "w:document"
        ]);
        $94db4f2abf87558b$var$__publicField(_this, "body");
        _this.root.push(new $94db4f2abf87558b$export$e2bedb2588efb3f4({
            wpc: "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
            mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",
            o: "urn:schemas-microsoft-com:office:office",
            r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
            m: "http://schemas.openxmlformats.org/officeDocument/2006/math",
            v: "urn:schemas-microsoft-com:vml",
            wp14: "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
            wp: "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
            w10: "urn:schemas-microsoft-com:office:word",
            w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
            w14: "http://schemas.microsoft.com/office/word/2010/wordml",
            w15: "http://schemas.microsoft.com/office/word/2012/wordml",
            wpg: "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
            wpi: "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
            wne: "http://schemas.microsoft.com/office/word/2006/wordml",
            wps: "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",
            cx: "http://schemas.microsoft.com/office/drawing/2014/chartex",
            cx1: "http://schemas.microsoft.com/office/drawing/2015/9/8/chartex",
            cx2: "http://schemas.microsoft.com/office/drawing/2015/10/21/chartex",
            cx3: "http://schemas.microsoft.com/office/drawing/2016/5/9/chartex",
            cx4: "http://schemas.microsoft.com/office/drawing/2016/5/10/chartex",
            cx5: "http://schemas.microsoft.com/office/drawing/2016/5/11/chartex",
            cx6: "http://schemas.microsoft.com/office/drawing/2016/5/12/chartex",
            cx7: "http://schemas.microsoft.com/office/drawing/2016/5/13/chartex",
            cx8: "http://schemas.microsoft.com/office/drawing/2016/5/14/chartex",
            aink: "http://schemas.microsoft.com/office/drawing/2016/ink",
            am3d: "http://schemas.microsoft.com/office/drawing/2017/model3d",
            w16cex: "http://schemas.microsoft.com/office/word/2018/wordml/cex",
            w16cid: "http://schemas.microsoft.com/office/word/2016/wordml/cid",
            w16: "http://schemas.microsoft.com/office/word/2018/wordml",
            w16sdtdh: "http://schemas.microsoft.com/office/word/2020/wordml/sdtdatahash",
            w16se: "http://schemas.microsoft.com/office/word/2015/wordml/symex",
            Ignorable: "w14 w15 wp14"
        }));
        _this.body = new $94db4f2abf87558b$export$4b2c32e08f77ff18();
        if (options2.background) _this.root.push(new $94db4f2abf87558b$export$a4418effc9bcba0b(options2.background));
        _this.root.push(_this.body);
        return _this;
    }
    (0, $7cSld._)(Document, [
        {
            key: "add",
            value: function add(item) {
                this.body.push(item);
                return this;
            }
        },
        {
            key: "Body",
            get: function get() {
                return this.body;
            }
        }
    ]);
    return Document;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$RelationshipsAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(RelationshipsAttributes, XmlAttributeComponent);
    function RelationshipsAttributes() {
        (0, $gd0sY._)(this, RelationshipsAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, RelationshipsAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            xmlns: "xmlns"
        });
        return _this;
    }
    return RelationshipsAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$Relationships = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Relationships, XmlComponent);
    function Relationships() {
        (0, $gd0sY._)(this, Relationships);
        var _this;
        _this = (0, $8xMIM._)(this, Relationships, [
            "Relationships"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$RelationshipsAttributes({
            xmlns: "http://schemas.openxmlformats.org/package/2006/relationships"
        }));
        return _this;
    }
    (0, $7cSld._)(Relationships, [
        {
            key: "createRelationship",
            value: function createRelationship(id, type, target, targetMode) {
                var relationship = new $94db4f2abf87558b$var$Relationship("rId".concat(id), type, target, targetMode);
                this.root.push(relationship);
                return relationship;
            }
        },
        {
            key: "RelationshipCount",
            get: function get() {
                return this.root.length - 1;
            }
        }
    ]);
    return Relationships;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$DocumentWrapper = /*#__PURE__*/ function() {
    "use strict";
    function DocumentWrapper(options2) {
        (0, $gd0sY._)(this, DocumentWrapper);
        $94db4f2abf87558b$var$__publicField(this, "document");
        $94db4f2abf87558b$var$__publicField(this, "relationships");
        this.document = new $94db4f2abf87558b$var$Document(options2);
        this.relationships = new $94db4f2abf87558b$var$Relationships();
    }
    (0, $7cSld._)(DocumentWrapper, [
        {
            key: "View",
            get: function get() {
                return this.document;
            }
        },
        {
            key: "Relationships",
            get: function get() {
                return this.relationships;
            }
        }
    ]);
    return DocumentWrapper;
}();
var $94db4f2abf87558b$var$WordWrapAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(WordWrapAttributes, XmlAttributeComponent);
    function WordWrapAttributes() {
        (0, $gd0sY._)(this, WordWrapAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, WordWrapAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            val: "w:val"
        });
        return _this;
    }
    return WordWrapAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$WordWrap = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(WordWrap, XmlComponent);
    function WordWrap() {
        (0, $gd0sY._)(this, WordWrap);
        var _this;
        _this = (0, $8xMIM._)(this, WordWrap, [
            "w:wordWrap"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$WordWrapAttributes({
            val: 0
        }));
        return _this;
    }
    return WordWrap;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$6f1995c5dbac7f91 = {
    NONE: "none",
    DROP: "drop",
    MARGIN: "margin"
};
var $94db4f2abf87558b$export$ba211c2bc275e09c = {
    MARGIN: "margin",
    PAGE: "page",
    TEXT: "text"
};
var $94db4f2abf87558b$export$2d429d33139c34f9 = {
    AROUND: "around",
    AUTO: "auto",
    NONE: "none",
    // eslint-disable-next-line @typescript-eslint/naming-convention
    NOT_BESIDE: "notBeside",
    THROUGH: "through",
    TIGHT: "tight"
};
var $94db4f2abf87558b$export$e1cc76173cf5faa2 = function(options2) {
    var _a, _b;
    return new $94db4f2abf87558b$export$da493cbe1334accc({
        name: "w:framePr",
        attributes: {
            anchorLock: {
                key: "w:anchorLock",
                value: options2.anchorLock
            },
            dropCap: {
                key: "w:dropCap",
                value: options2.dropCap
            },
            width: {
                key: "w:w",
                value: options2.width
            },
            height: {
                key: "w:h",
                value: options2.height
            },
            x: {
                key: "w:x",
                value: options2.position ? options2.position.x : void 0
            },
            y: {
                key: "w:y",
                value: options2.position ? options2.position.y : void 0
            },
            anchorHorizontal: {
                key: "w:hAnchor",
                value: options2.anchor.horizontal
            },
            anchorVertical: {
                key: "w:vAnchor",
                value: options2.anchor.vertical
            },
            spaceHorizontal: {
                key: "w:hSpace",
                value: (_a = options2.space) == null ? void 0 : _a.horizontal
            },
            spaceVertical: {
                key: "w:vSpace",
                value: (_b = options2.space) == null ? void 0 : _b.vertical
            },
            rule: {
                key: "w:hRule",
                value: options2.rule
            },
            alignmentX: {
                key: "w:xAlign",
                value: options2.alignment ? options2.alignment.x : void 0
            },
            alignmentY: {
                key: "w:yAlign",
                value: options2.alignment ? options2.alignment.y : void 0
            },
            lines: {
                key: "w:lines",
                value: options2.lines
            },
            wrap: {
                key: "w:wrap",
                value: options2.wrap
            }
        }
    });
};
var $94db4f2abf87558b$export$2580ab652a992a27 = /*#__PURE__*/ function(IgnoreIfEmptyXmlComponent) {
    "use strict";
    (0, $NBk0Y._)(ParagraphProperties, IgnoreIfEmptyXmlComponent);
    function ParagraphProperties(options2) {
        (0, $gd0sY._)(this, ParagraphProperties);
        var _this;
        var _a, _b;
        _this = (0, $8xMIM._)(this, ParagraphProperties, [
            "w:pPr"
        ]);
        // eslint-disable-next-line functional/prefer-readonly-type
        $94db4f2abf87558b$var$__publicField(_this, "numberingReferences", []);
        if (!options2) return (0, $cRssL._)(_this, _this);
        if (options2.heading) _this.push(new $94db4f2abf87558b$export$d9e45bc13d335801(options2.heading));
        if (options2.bullet) _this.push(new $94db4f2abf87558b$export$d9e45bc13d335801("ListParagraph"));
        if (options2.numbering) {
            if (!options2.style && !options2.heading) {
                if (!options2.numbering.custom) _this.push(new $94db4f2abf87558b$export$d9e45bc13d335801("ListParagraph"));
            }
        }
        if (options2.style) _this.push(new $94db4f2abf87558b$export$d9e45bc13d335801(options2.style));
        if (options2.keepNext !== void 0) _this.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:keepNext", options2.keepNext));
        if (options2.keepLines !== void 0) _this.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:keepLines", options2.keepLines));
        if (options2.pageBreakBefore) _this.push(new $94db4f2abf87558b$export$f4d23c02e5ffac1a());
        if (options2.frame) _this.push($94db4f2abf87558b$export$e1cc76173cf5faa2(options2.frame));
        if (options2.widowControl !== void 0) _this.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:widowControl", options2.widowControl));
        if (options2.bullet) _this.push(new $94db4f2abf87558b$export$b5d3f7ce2f820092(1, options2.bullet.level));
        if (options2.numbering) {
            _this.numberingReferences.push({
                reference: options2.numbering.reference,
                instance: (_a = options2.numbering.instance) != null ? _a : 0
            });
            _this.push(new $94db4f2abf87558b$export$b5d3f7ce2f820092("".concat(options2.numbering.reference, "-").concat((_b = options2.numbering.instance) != null ? _b : 0), options2.numbering.level));
        }
        if (options2.border) _this.push(new $94db4f2abf87558b$export$d8e9c9d63e86d41e(options2.border));
        if (options2.thematicBreak) _this.push(new $94db4f2abf87558b$export$ae968d136aefa6fc());
        if (options2.shading) _this.push(new $94db4f2abf87558b$export$21ac63597b3ebf8e(options2.shading));
        if (options2.wordWrap) _this.push(new $94db4f2abf87558b$var$WordWrap());
        if (options2.overflowPunctuation) _this.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:overflowPunct", options2.overflowPunctuation));
        var tabDefinitions = (0, $6zk1M._)(options2.rightTabStop !== void 0 ? [
            {
                type: $94db4f2abf87558b$export$2effbc422db8f8ed.RIGHT,
                position: options2.rightTabStop
            }
        ] : []).concat((0, $6zk1M._)(options2.tabStops ? options2.tabStops : []), (0, $6zk1M._)(options2.leftTabStop !== void 0 ? [
            {
                type: $94db4f2abf87558b$export$2effbc422db8f8ed.LEFT,
                position: options2.leftTabStop
            }
        ] : []));
        if (tabDefinitions.length > 0) _this.push(new $94db4f2abf87558b$export$639143e2dbee2d0(tabDefinitions));
        if (options2.bidirectional !== void 0) _this.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:bidi", options2.bidirectional));
        if (options2.spacing) _this.push(new $94db4f2abf87558b$export$a39947a896defee6(options2.spacing));
        if (options2.indent) _this.push(new $94db4f2abf87558b$export$e883eb7bc5d8ee6(options2.indent));
        if (options2.contextualSpacing !== void 0) _this.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:contextualSpacing", options2.contextualSpacing));
        if (options2.alignment) _this.push(new $94db4f2abf87558b$export$9d7927214ed7d2cf(options2.alignment));
        if (options2.outlineLevel !== void 0) _this.push(new $94db4f2abf87558b$export$2d9dc1cf136663b0(options2.outlineLevel));
        if (options2.suppressLineNumbers !== void 0) _this.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:suppressLineNumbers", options2.suppressLineNumbers));
        if (options2.autoSpaceEastAsianText !== void 0) _this.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:autoSpaceDN", options2.autoSpaceEastAsianText));
        if (options2.run) _this.push(new $94db4f2abf87558b$export$5ae5540473946c91(options2.run));
        return _this;
    }
    (0, $7cSld._)(ParagraphProperties, [
        {
            key: "push",
            value: function push(item) {
                this.root.push(item);
            }
        },
        {
            key: "prepForXml",
            value: function prepForXml(context) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (context.viewWrapper instanceof $94db4f2abf87558b$var$DocumentWrapper) try {
                    for(var _iterator = this.numberingReferences[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var reference = _step.value;
                        context.file.Numbering.createConcreteNumberingInstance(reference.reference, reference.instance);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return (0, $bl6Nv._)((0, $7GsX9._)(ParagraphProperties.prototype), "prepForXml", this).call(this, context);
            }
        }
    ]);
    return ParagraphProperties;
}($94db4f2abf87558b$export$951524d865ce655a);
var $94db4f2abf87558b$export$358a232cca1ab2ac = /*#__PURE__*/ function(FileChild) {
    "use strict";
    (0, $NBk0Y._)(Paragraph, FileChild);
    function Paragraph(options2) {
        (0, $gd0sY._)(this, Paragraph);
        var _this;
        _this = (0, $8xMIM._)(this, Paragraph, [
            "w:p"
        ]);
        $94db4f2abf87558b$var$__publicField(_this, "properties");
        if (typeof options2 === "string") {
            _this.properties = new $94db4f2abf87558b$export$2580ab652a992a27({});
            _this.root.push(_this.properties);
            _this.root.push(new $94db4f2abf87558b$export$84d920a4f7ee9ae2(options2));
            return (0, $cRssL._)(_this, _this);
        }
        _this.properties = new $94db4f2abf87558b$export$2580ab652a992a27(options2);
        _this.root.push(_this.properties);
        if (options2.text) _this.root.push(new $94db4f2abf87558b$export$84d920a4f7ee9ae2(options2.text));
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (options2.children) try {
            for(var _iterator = options2.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                if (child instanceof $94db4f2abf87558b$export$301ef70c5c7bdf65) {
                    _this.root.push(child.start);
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = child.children[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var textRun = _step1.value;
                            _this.root.push(textRun);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    _this.root.push(child.end);
                    continue;
                }
                _this.root.push(child);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _this;
    }
    (0, $7cSld._)(Paragraph, [
        {
            key: "prepForXml",
            value: function prepForXml(context) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.root[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element2 = _step.value;
                        if (element2 instanceof $94db4f2abf87558b$export$6ea6a3f0b2b263f3) {
                            var index = this.root.indexOf(element2);
                            var concreteHyperlink = new $94db4f2abf87558b$export$6beda279b4a51476(element2.options.children, $94db4f2abf87558b$export$8b15d37bc3f197d4());
                            context.viewWrapper.Relationships.createRelationship(concreteHyperlink.linkId, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink", element2.options.link, $94db4f2abf87558b$var$TargetModeType.EXTERNAL);
                            this.root[index] = concreteHyperlink;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return (0, $bl6Nv._)((0, $7GsX9._)(Paragraph.prototype), "prepForXml", this).call(this, context);
            }
        },
        {
            key: "addRunToFront",
            value: function addRunToFront(run) {
                this.root.splice(1, 0, run);
                return this;
            }
        }
    ]);
    return Paragraph;
}($94db4f2abf87558b$var$FileChild);
var $94db4f2abf87558b$export$380958644dbbc22b = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Math2, XmlComponent);
    function Math2(options2) {
        (0, $gd0sY._)(this, Math2);
        var _this;
        _this = (0, $8xMIM._)(this, Math2, [
            "m:oMath"
        ]);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = options2.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                _this.root.push(child);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _this;
    }
    return Math2;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$MathText = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathText, XmlComponent);
    function MathText(text) {
        (0, $gd0sY._)(this, MathText);
        var _this;
        _this = (0, $8xMIM._)(this, MathText, [
            "m:t"
        ]);
        _this.root.push(text);
        return _this;
    }
    return MathText;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$90dfc67d0f4dd34b = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathRun, XmlComponent);
    function MathRun(text) {
        (0, $gd0sY._)(this, MathRun);
        var _this;
        _this = (0, $8xMIM._)(this, MathRun, [
            "m:r"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$MathText(text));
        return _this;
    }
    return MathRun;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$ff6b7d5a5a81866e = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathDenominator, XmlComponent);
    function MathDenominator(children) {
        (0, $gd0sY._)(this, MathDenominator);
        var _this;
        _this = (0, $8xMIM._)(this, MathDenominator, [
            "m:den"
        ]);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                _this.root.push(child);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _this;
    }
    return MathDenominator;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$99cac471ef125c11 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathNumerator, XmlComponent);
    function MathNumerator(children) {
        (0, $gd0sY._)(this, MathNumerator);
        var _this;
        _this = (0, $8xMIM._)(this, MathNumerator, [
            "m:num"
        ]);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                _this.root.push(child);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _this;
    }
    return MathNumerator;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$4733894f11785949 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathFraction, XmlComponent);
    function MathFraction(options2) {
        (0, $gd0sY._)(this, MathFraction);
        var _this;
        _this = (0, $8xMIM._)(this, MathFraction, [
            "m:f"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$99cac471ef125c11(options2.numerator));
        _this.root.push(new $94db4f2abf87558b$export$ff6b7d5a5a81866e(options2.denominator));
        return _this;
    }
    return MathFraction;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$MathAccentCharacterAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(MathAccentCharacterAttributes, XmlAttributeComponent);
    function MathAccentCharacterAttributes() {
        (0, $gd0sY._)(this, MathAccentCharacterAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, MathAccentCharacterAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            accent: "m:val"
        });
        return _this;
    }
    return MathAccentCharacterAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$4ef4dab109988195 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathAccentCharacter, XmlComponent);
    function MathAccentCharacter(accent) {
        (0, $gd0sY._)(this, MathAccentCharacter);
        var _this;
        _this = (0, $8xMIM._)(this, MathAccentCharacter, [
            "m:chr"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$MathAccentCharacterAttributes({
            accent: accent
        }));
        return _this;
    }
    return MathAccentCharacter;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$3a0bc45fe4ce7bb1 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathBase, XmlComponent);
    function MathBase(children) {
        (0, $gd0sY._)(this, MathBase);
        var _this;
        _this = (0, $8xMIM._)(this, MathBase, [
            "m:e"
        ]);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                _this.root.push(child);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _this;
    }
    return MathBase;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$MathLimitLocationAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(MathLimitLocationAttributes, XmlAttributeComponent);
    function MathLimitLocationAttributes() {
        (0, $gd0sY._)(this, MathLimitLocationAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, MathLimitLocationAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            value: "m:val"
        });
        return _this;
    }
    return MathLimitLocationAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$bd4e891531aaa3fc = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathLimitLocation, XmlComponent);
    function MathLimitLocation() {
        (0, $gd0sY._)(this, MathLimitLocation);
        var _this;
        _this = (0, $8xMIM._)(this, MathLimitLocation, [
            "m:limLoc"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$MathLimitLocationAttributes({
            value: "undOvr"
        }));
        return _this;
    }
    return MathLimitLocation;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$MathSubScriptHideAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(MathSubScriptHideAttributes, XmlAttributeComponent);
    function MathSubScriptHideAttributes() {
        (0, $gd0sY._)(this, MathSubScriptHideAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, MathSubScriptHideAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            hide: "m:val"
        });
        return _this;
    }
    return MathSubScriptHideAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$MathSubScriptHide = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathSubScriptHide, XmlComponent);
    function MathSubScriptHide() {
        (0, $gd0sY._)(this, MathSubScriptHide);
        var _this;
        _this = (0, $8xMIM._)(this, MathSubScriptHide, [
            "m:subHide"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$MathSubScriptHideAttributes({
            hide: 1
        }));
        return _this;
    }
    return MathSubScriptHide;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$MathSuperScriptHideAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(MathSuperScriptHideAttributes, XmlAttributeComponent);
    function MathSuperScriptHideAttributes() {
        (0, $gd0sY._)(this, MathSuperScriptHideAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, MathSuperScriptHideAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            hide: "m:val"
        });
        return _this;
    }
    return MathSuperScriptHideAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$MathSuperScriptHide = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathSuperScriptHide, XmlComponent);
    function MathSuperScriptHide() {
        (0, $gd0sY._)(this, MathSuperScriptHide);
        var _this;
        _this = (0, $8xMIM._)(this, MathSuperScriptHide, [
            "m:supHide"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$MathSuperScriptHideAttributes({
            hide: 1
        }));
        return _this;
    }
    return MathSuperScriptHide;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$403a32cd07406f85 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathNAryProperties, XmlComponent);
    function MathNAryProperties(accent, hasSuperScript, hasSubScript) {
        (0, $gd0sY._)(this, MathNAryProperties);
        var _this;
        _this = (0, $8xMIM._)(this, MathNAryProperties, [
            "m:naryPr"
        ]);
        if (!!accent) _this.root.push(new $94db4f2abf87558b$export$4ef4dab109988195(accent));
        _this.root.push(new $94db4f2abf87558b$export$bd4e891531aaa3fc());
        if (!hasSuperScript) _this.root.push(new $94db4f2abf87558b$var$MathSuperScriptHide());
        if (!hasSubScript) _this.root.push(new $94db4f2abf87558b$var$MathSubScriptHide());
        return _this;
    }
    return MathNAryProperties;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$c40e4ecd03de4197 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathSubScriptElement, XmlComponent);
    function MathSubScriptElement(children) {
        (0, $gd0sY._)(this, MathSubScriptElement);
        var _this;
        _this = (0, $8xMIM._)(this, MathSubScriptElement, [
            "m:sub"
        ]);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                _this.root.push(child);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _this;
    }
    return MathSubScriptElement;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$4b4bec4bcd0ce893 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathSuperScriptElement, XmlComponent);
    function MathSuperScriptElement(children) {
        (0, $gd0sY._)(this, MathSuperScriptElement);
        var _this;
        _this = (0, $8xMIM._)(this, MathSuperScriptElement, [
            "m:sup"
        ]);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                _this.root.push(child);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _this;
    }
    return MathSuperScriptElement;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$fdc132f2f50726bf = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathSum, XmlComponent);
    function MathSum(options2) {
        (0, $gd0sY._)(this, MathSum);
        var _this;
        _this = (0, $8xMIM._)(this, MathSum, [
            "m:nary"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$403a32cd07406f85("\u2211", !!options2.superScript, !!options2.subScript));
        if (!!options2.subScript) _this.root.push(new $94db4f2abf87558b$export$c40e4ecd03de4197(options2.subScript));
        if (!!options2.superScript) _this.root.push(new $94db4f2abf87558b$export$4b4bec4bcd0ce893(options2.superScript));
        _this.root.push(new $94db4f2abf87558b$export$3a0bc45fe4ce7bb1(options2.children));
        return _this;
    }
    return MathSum;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$284571621872e60b = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathIntegral, XmlComponent);
    function MathIntegral(options2) {
        (0, $gd0sY._)(this, MathIntegral);
        var _this;
        _this = (0, $8xMIM._)(this, MathIntegral, [
            "m:nary"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$403a32cd07406f85("", !!options2.superScript, !!options2.subScript));
        if (!!options2.subScript) _this.root.push(new $94db4f2abf87558b$export$c40e4ecd03de4197(options2.subScript));
        if (!!options2.superScript) _this.root.push(new $94db4f2abf87558b$export$4b4bec4bcd0ce893(options2.superScript));
        _this.root.push(new $94db4f2abf87558b$export$3a0bc45fe4ce7bb1(options2.children));
        return _this;
    }
    return MathIntegral;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$1d9655eebe3b3f32 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathSuperScriptProperties, XmlComponent);
    function MathSuperScriptProperties() {
        (0, $gd0sY._)(this, MathSuperScriptProperties);
        return (0, $8xMIM._)(this, MathSuperScriptProperties, [
            "m:sSupPr"
        ]);
    }
    return MathSuperScriptProperties;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$4841c07b5c4540ae = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathSuperScript, XmlComponent);
    function MathSuperScript(options2) {
        (0, $gd0sY._)(this, MathSuperScript);
        var _this;
        _this = (0, $8xMIM._)(this, MathSuperScript, [
            "m:sSup"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$1d9655eebe3b3f32());
        _this.root.push(new $94db4f2abf87558b$export$3a0bc45fe4ce7bb1(options2.children));
        _this.root.push(new $94db4f2abf87558b$export$4b4bec4bcd0ce893(options2.superScript));
        return _this;
    }
    return MathSuperScript;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$be294a49d32787c6 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathSubScriptProperties, XmlComponent);
    function MathSubScriptProperties() {
        (0, $gd0sY._)(this, MathSubScriptProperties);
        return (0, $8xMIM._)(this, MathSubScriptProperties, [
            "m:sSubPr"
        ]);
    }
    return MathSubScriptProperties;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$6c9d9f8e0a9a0050 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathSubScript, XmlComponent);
    function MathSubScript(options2) {
        (0, $gd0sY._)(this, MathSubScript);
        var _this;
        _this = (0, $8xMIM._)(this, MathSubScript, [
            "m:sSub"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$be294a49d32787c6());
        _this.root.push(new $94db4f2abf87558b$export$3a0bc45fe4ce7bb1(options2.children));
        _this.root.push(new $94db4f2abf87558b$export$c40e4ecd03de4197(options2.subScript));
        return _this;
    }
    return MathSubScript;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$2dca4527ab833f31 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathSubSuperScriptProperties, XmlComponent);
    function MathSubSuperScriptProperties() {
        (0, $gd0sY._)(this, MathSubSuperScriptProperties);
        return (0, $8xMIM._)(this, MathSubSuperScriptProperties, [
            "m:sSubSupPr"
        ]);
    }
    return MathSubSuperScriptProperties;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$b65c9d7e29726d90 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathSubSuperScript, XmlComponent);
    function MathSubSuperScript(options2) {
        (0, $gd0sY._)(this, MathSubSuperScript);
        var _this;
        _this = (0, $8xMIM._)(this, MathSubSuperScript, [
            "m:sSubSup"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$2dca4527ab833f31());
        _this.root.push(new $94db4f2abf87558b$export$3a0bc45fe4ce7bb1(options2.children));
        _this.root.push(new $94db4f2abf87558b$export$c40e4ecd03de4197(options2.subScript));
        _this.root.push(new $94db4f2abf87558b$export$4b4bec4bcd0ce893(options2.superScript));
        return _this;
    }
    return MathSubSuperScript;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$18f027e40eafdcad = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathPreSubSuperScriptProperties, XmlComponent);
    function MathPreSubSuperScriptProperties() {
        (0, $gd0sY._)(this, MathPreSubSuperScriptProperties);
        return (0, $8xMIM._)(this, MathPreSubSuperScriptProperties, [
            "m:sPrePr"
        ]);
    }
    return MathPreSubSuperScriptProperties;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$6a6b66354165e5d9 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathPreSubSuperScript, XmlComponent);
    function MathPreSubSuperScript(options2) {
        (0, $gd0sY._)(this, MathPreSubSuperScript);
        var _this;
        _this = (0, $8xMIM._)(this, MathPreSubSuperScript, [
            "m:sPre"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$18f027e40eafdcad());
        _this.root.push(new $94db4f2abf87558b$export$3a0bc45fe4ce7bb1(options2.children));
        _this.root.push(new $94db4f2abf87558b$export$c40e4ecd03de4197(options2.subScript));
        _this.root.push(new $94db4f2abf87558b$export$4b4bec4bcd0ce893(options2.superScript));
        return _this;
    }
    return MathPreSubSuperScript;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$188277a33510f07b = "";
var $94db4f2abf87558b$export$40049e2a10faefc0 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathDegree, XmlComponent);
    function MathDegree(children) {
        (0, $gd0sY._)(this, MathDegree);
        var _this;
        _this = (0, $8xMIM._)(this, MathDegree, [
            "m:deg"
        ]);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (!!children) try {
            for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                _this.root.push(child);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _this;
    }
    return MathDegree;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$MathDegreeHideAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(MathDegreeHideAttributes, XmlAttributeComponent);
    function MathDegreeHideAttributes() {
        (0, $gd0sY._)(this, MathDegreeHideAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, MathDegreeHideAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            hide: "m:val"
        });
        return _this;
    }
    return MathDegreeHideAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$MathDegreeHide = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathDegreeHide, XmlComponent);
    function MathDegreeHide() {
        (0, $gd0sY._)(this, MathDegreeHide);
        var _this;
        _this = (0, $8xMIM._)(this, MathDegreeHide, [
            "m:degHide"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$MathDegreeHideAttributes({
            hide: 1
        }));
        return _this;
    }
    return MathDegreeHide;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$428abb7ebef50ed3 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathRadicalProperties, XmlComponent);
    function MathRadicalProperties(hasDegree) {
        (0, $gd0sY._)(this, MathRadicalProperties);
        var _this;
        _this = (0, $8xMIM._)(this, MathRadicalProperties, [
            "m:radPr"
        ]);
        if (!hasDegree) _this.root.push(new $94db4f2abf87558b$var$MathDegreeHide());
        return _this;
    }
    return MathRadicalProperties;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$26950747f72b19b4 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathRadical, XmlComponent);
    function MathRadical(options2) {
        (0, $gd0sY._)(this, MathRadical);
        var _this;
        _this = (0, $8xMIM._)(this, MathRadical, [
            "m:rad"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$428abb7ebef50ed3(!!options2.degree));
        _this.root.push(new $94db4f2abf87558b$export$40049e2a10faefc0(options2.degree));
        _this.root.push(new $94db4f2abf87558b$export$3a0bc45fe4ce7bb1(options2.children));
        return _this;
    }
    return MathRadical;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$9d22093c8a5af07c = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathFunctionName, XmlComponent);
    function MathFunctionName(children) {
        (0, $gd0sY._)(this, MathFunctionName);
        var _this;
        _this = (0, $8xMIM._)(this, MathFunctionName, [
            "m:fName"
        ]);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                _this.root.push(child);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _this;
    }
    return MathFunctionName;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$2639caa68c82d30c = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathFunctionProperties, XmlComponent);
    function MathFunctionProperties() {
        (0, $gd0sY._)(this, MathFunctionProperties);
        return (0, $8xMIM._)(this, MathFunctionProperties, [
            "m:funcPr"
        ]);
    }
    return MathFunctionProperties;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$f46dd3ee437ba7d2 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathFunction, XmlComponent);
    function MathFunction(options2) {
        (0, $gd0sY._)(this, MathFunction);
        var _this;
        _this = (0, $8xMIM._)(this, MathFunction, [
            "m:func"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$2639caa68c82d30c());
        _this.root.push(new $94db4f2abf87558b$export$9d22093c8a5af07c(options2.name));
        _this.root.push(new $94db4f2abf87558b$export$3a0bc45fe4ce7bb1(options2.children));
        return _this;
    }
    return MathFunction;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$MathBeginningCharacterAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(MathBeginningCharacterAttributes, XmlAttributeComponent);
    function MathBeginningCharacterAttributes() {
        (0, $gd0sY._)(this, MathBeginningCharacterAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, MathBeginningCharacterAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            character: "m:val"
        });
        return _this;
    }
    return MathBeginningCharacterAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$MathBeginningCharacter = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathBeginningCharacter, XmlComponent);
    function MathBeginningCharacter(character) {
        (0, $gd0sY._)(this, MathBeginningCharacter);
        var _this;
        _this = (0, $8xMIM._)(this, MathBeginningCharacter, [
            "m:begChr"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$MathBeginningCharacterAttributes({
            character: character
        }));
        return _this;
    }
    return MathBeginningCharacter;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$MathEndingCharacterAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(MathEndingCharacterAttributes, XmlAttributeComponent);
    function MathEndingCharacterAttributes() {
        (0, $gd0sY._)(this, MathEndingCharacterAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, MathEndingCharacterAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            character: "m:val"
        });
        return _this;
    }
    return MathEndingCharacterAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$MathEndingCharacter = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathEndingCharacter, XmlComponent);
    function MathEndingCharacter(character) {
        (0, $gd0sY._)(this, MathEndingCharacter);
        var _this;
        _this = (0, $8xMIM._)(this, MathEndingCharacter, [
            "m:endChr"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$MathEndingCharacterAttributes({
            character: character
        }));
        return _this;
    }
    return MathEndingCharacter;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$MathBracketProperties = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathBracketProperties, XmlComponent);
    function MathBracketProperties(options2) {
        (0, $gd0sY._)(this, MathBracketProperties);
        var _this;
        _this = (0, $8xMIM._)(this, MathBracketProperties, [
            "m:dPr"
        ]);
        if (!!options2) {
            _this.root.push(new $94db4f2abf87558b$var$MathBeginningCharacter(options2.beginningCharacter));
            _this.root.push(new $94db4f2abf87558b$var$MathEndingCharacter(options2.endingCharacter));
        }
        return _this;
    }
    return MathBracketProperties;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$8f0bc5351033327c = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathRoundBrackets, XmlComponent);
    function MathRoundBrackets(options2) {
        (0, $gd0sY._)(this, MathRoundBrackets);
        var _this;
        _this = (0, $8xMIM._)(this, MathRoundBrackets, [
            "m:d"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$MathBracketProperties());
        _this.root.push(new $94db4f2abf87558b$export$3a0bc45fe4ce7bb1(options2.children));
        return _this;
    }
    return MathRoundBrackets;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$368e49b3c2c4bceb = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathSquareBrackets, XmlComponent);
    function MathSquareBrackets(options2) {
        (0, $gd0sY._)(this, MathSquareBrackets);
        var _this;
        _this = (0, $8xMIM._)(this, MathSquareBrackets, [
            "m:d"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$MathBracketProperties({
            beginningCharacter: "[",
            endingCharacter: "]"
        }));
        _this.root.push(new $94db4f2abf87558b$export$3a0bc45fe4ce7bb1(options2.children));
        return _this;
    }
    return MathSquareBrackets;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$c7412ca3c2c2fc72 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathCurlyBrackets, XmlComponent);
    function MathCurlyBrackets(options2) {
        (0, $gd0sY._)(this, MathCurlyBrackets);
        var _this;
        _this = (0, $8xMIM._)(this, MathCurlyBrackets, [
            "m:d"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$MathBracketProperties({
            beginningCharacter: "{",
            endingCharacter: "}"
        }));
        _this.root.push(new $94db4f2abf87558b$export$3a0bc45fe4ce7bb1(options2.children));
        return _this;
    }
    return MathCurlyBrackets;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$7bc6cec92819f63a = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MathAngledBrackets, XmlComponent);
    function MathAngledBrackets(options2) {
        (0, $gd0sY._)(this, MathAngledBrackets);
        var _this;
        _this = (0, $8xMIM._)(this, MathAngledBrackets, [
            "m:d"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$MathBracketProperties({
            beginningCharacter: "\u2329",
            endingCharacter: "\u232A"
        }));
        _this.root.push(new $94db4f2abf87558b$export$3a0bc45fe4ce7bb1(options2.children));
        return _this;
    }
    return MathAngledBrackets;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$TableGrid = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(TableGrid, XmlComponent);
    function TableGrid(widths) {
        (0, $gd0sY._)(this, TableGrid);
        var _this;
        _this = (0, $8xMIM._)(this, TableGrid, [
            "w:tblGrid"
        ]);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = widths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var width = _step.value;
                _this.root.push(new $94db4f2abf87558b$var$GridCol(width));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _this;
    }
    return TableGrid;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$GridCol = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(GridCol, XmlComponent);
    function GridCol(width) {
        (0, $gd0sY._)(this, GridCol);
        var _this;
        _this = (0, $8xMIM._)(this, GridCol, [
            "w:gridCol"
        ]);
        if (width !== void 0) _this.root.push(new $94db4f2abf87558b$export$b95d92bd70e2302a({
            width: {
                key: "w:w",
                value: $94db4f2abf87558b$export$ffe63bc01ceacb3d(width)
            }
        }));
        return _this;
    }
    return GridCol;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$TableCellMarginElementType = {
    TABLE: "w:tblCellMar",
    // eslint-disable-next-line @typescript-eslint/naming-convention
    TABLE_CELL: "w:tcMar"
};
var $94db4f2abf87558b$var$TableCellMargin = /*#__PURE__*/ function(IgnoreIfEmptyXmlComponent) {
    "use strict";
    (0, $NBk0Y._)(TableCellMargin, IgnoreIfEmptyXmlComponent);
    function TableCellMargin(type, param) {
        var _param_marginUnitType = param.marginUnitType, marginUnitType = _param_marginUnitType === void 0 ? $94db4f2abf87558b$export$4d41558722ac7eed.DXA : _param_marginUnitType, top = param.top, left = param.left, bottom = param.bottom, right = param.right;
        (0, $gd0sY._)(this, TableCellMargin);
        var _this;
        _this = (0, $8xMIM._)(this, TableCellMargin, [
            type
        ]);
        if (top !== void 0) _this.root.push(new $94db4f2abf87558b$export$691ad35ca26919d6("w:top", {
            type: marginUnitType,
            size: top
        }));
        if (left !== void 0) _this.root.push(new $94db4f2abf87558b$export$691ad35ca26919d6("w:left", {
            type: marginUnitType,
            size: left
        }));
        if (bottom !== void 0) _this.root.push(new $94db4f2abf87558b$export$691ad35ca26919d6("w:bottom", {
            type: marginUnitType,
            size: bottom
        }));
        if (right !== void 0) _this.root.push(new $94db4f2abf87558b$export$691ad35ca26919d6("w:right", {
            type: marginUnitType,
            size: right
        }));
        return _this;
    }
    return TableCellMargin;
}($94db4f2abf87558b$export$951524d865ce655a);
var $94db4f2abf87558b$export$4d41558722ac7eed = {
    /** Auto. */ AUTO: "auto",
    /** Value is in twentieths of a point */ DXA: "dxa",
    /** No (empty) value. */ NIL: "nil",
    /** Value is in percentage. */ PERCENTAGE: "pct"
};
var $94db4f2abf87558b$export$691ad35ca26919d6 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(TableWidthElement, XmlComponent);
    function TableWidthElement(name, param) {
        var _param_type = param.type, type = _param_type === void 0 ? $94db4f2abf87558b$export$4d41558722ac7eed.AUTO : _param_type, size = param.size;
        (0, $gd0sY._)(this, TableWidthElement);
        var _this;
        _this = (0, $8xMIM._)(this, TableWidthElement, [
            name
        ]);
        var tableWidthValue = size;
        if (type === $94db4f2abf87558b$export$4d41558722ac7eed.PERCENTAGE && typeof size === "number") tableWidthValue = "".concat(size, "%");
        _this.root.push(new $94db4f2abf87558b$export$b95d92bd70e2302a({
            type: {
                key: "w:type",
                value: type
            },
            size: {
                key: "w:w",
                value: $94db4f2abf87558b$export$cb4dd365b0fd654b(tableWidthValue)
            }
        }));
        return _this;
    }
    return TableWidthElement;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$a3702afe8c903878 = /*#__PURE__*/ function(IgnoreIfEmptyXmlComponent) {
    "use strict";
    (0, $NBk0Y._)(TableCellBorders, IgnoreIfEmptyXmlComponent);
    function TableCellBorders(options2) {
        (0, $gd0sY._)(this, TableCellBorders);
        var _this;
        _this = (0, $8xMIM._)(this, TableCellBorders, [
            "w:tcBorders"
        ]);
        if (options2.top) _this.root.push(new $94db4f2abf87558b$export$a6733098a4eb57cf("w:top", options2.top));
        if (options2.start) _this.root.push(new $94db4f2abf87558b$export$a6733098a4eb57cf("w:start", options2.start));
        if (options2.left) _this.root.push(new $94db4f2abf87558b$export$a6733098a4eb57cf("w:left", options2.left));
        if (options2.bottom) _this.root.push(new $94db4f2abf87558b$export$a6733098a4eb57cf("w:bottom", options2.bottom));
        if (options2.end) _this.root.push(new $94db4f2abf87558b$export$a6733098a4eb57cf("w:end", options2.end));
        if (options2.right) _this.root.push(new $94db4f2abf87558b$export$a6733098a4eb57cf("w:right", options2.right));
        return _this;
    }
    return TableCellBorders;
}($94db4f2abf87558b$export$951524d865ce655a);
var $94db4f2abf87558b$var$GridSpanAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(GridSpanAttributes, XmlAttributeComponent);
    function GridSpanAttributes() {
        (0, $gd0sY._)(this, GridSpanAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, GridSpanAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            val: "w:val"
        });
        return _this;
    }
    return GridSpanAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$6cde27bc1b78afe7 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(GridSpan, XmlComponent);
    function GridSpan(value) {
        (0, $gd0sY._)(this, GridSpan);
        var _this;
        _this = (0, $8xMIM._)(this, GridSpan, [
            "w:gridSpan"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$GridSpanAttributes({
            val: $94db4f2abf87558b$export$3965b376946dc953(value)
        }));
        return _this;
    }
    return GridSpan;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$ba6d52537e3f9b56 = {
    /**
   * Cell that is merged with upper one.
   */ CONTINUE: "continue",
    /**
   * Cell that is starting the vertical merge.
   */ RESTART: "restart"
};
var $94db4f2abf87558b$var$VerticalMergeAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(VerticalMergeAttributes, XmlAttributeComponent);
    function VerticalMergeAttributes() {
        (0, $gd0sY._)(this, VerticalMergeAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, VerticalMergeAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            val: "w:val"
        });
        return _this;
    }
    return VerticalMergeAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$ef0dbc2e8af92c85 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(VerticalMerge, XmlComponent);
    function VerticalMerge(value) {
        (0, $gd0sY._)(this, VerticalMerge);
        var _this;
        _this = (0, $8xMIM._)(this, VerticalMerge, [
            "w:vMerge"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$VerticalMergeAttributes({
            val: value
        }));
        return _this;
    }
    return VerticalMerge;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$63e1cbbb2c6e2c2 = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    BOTTOM_TO_TOP_LEFT_TO_RIGHT: "btLr",
    // eslint-disable-next-line @typescript-eslint/naming-convention
    LEFT_TO_RIGHT_TOP_TO_BOTTOM: "lrTb",
    // eslint-disable-next-line @typescript-eslint/naming-convention
    TOP_TO_BOTTOM_RIGHT_TO_LEFT: "tbRl"
};
var $94db4f2abf87558b$var$TDirectionAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(TDirectionAttributes, XmlAttributeComponent);
    function TDirectionAttributes() {
        (0, $gd0sY._)(this, TDirectionAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, TDirectionAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            val: "w:val"
        });
        return _this;
    }
    return TDirectionAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$ced1d73164c0b0e5 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(TDirection, XmlComponent);
    function TDirection(value) {
        (0, $gd0sY._)(this, TDirection);
        var _this;
        _this = (0, $8xMIM._)(this, TDirection, [
            "w:textDirection"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$TDirectionAttributes({
            val: value
        }));
        return _this;
    }
    return TDirection;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$TableCellProperties = /*#__PURE__*/ function(IgnoreIfEmptyXmlComponent) {
    "use strict";
    (0, $NBk0Y._)(TableCellProperties, IgnoreIfEmptyXmlComponent);
    function TableCellProperties(options2) {
        (0, $gd0sY._)(this, TableCellProperties);
        var _this;
        _this = (0, $8xMIM._)(this, TableCellProperties, [
            "w:tcPr"
        ]);
        if (options2.width) _this.root.push(new $94db4f2abf87558b$export$691ad35ca26919d6("w:tcW", options2.width));
        if (options2.columnSpan) _this.root.push(new $94db4f2abf87558b$export$6cde27bc1b78afe7(options2.columnSpan));
        if (options2.verticalMerge) _this.root.push(new $94db4f2abf87558b$export$ef0dbc2e8af92c85(options2.verticalMerge));
        else if (options2.rowSpan && options2.rowSpan > 1) _this.root.push(new $94db4f2abf87558b$export$ef0dbc2e8af92c85($94db4f2abf87558b$export$ba6d52537e3f9b56.RESTART));
        if (options2.borders) _this.root.push(new $94db4f2abf87558b$export$a3702afe8c903878(options2.borders));
        if (options2.shading) _this.root.push(new $94db4f2abf87558b$export$21ac63597b3ebf8e(options2.shading));
        if (options2.margins) _this.root.push(new $94db4f2abf87558b$var$TableCellMargin($94db4f2abf87558b$var$TableCellMarginElementType.TABLE_CELL, options2.margins));
        if (options2.textDirection) _this.root.push(new $94db4f2abf87558b$export$ced1d73164c0b0e5(options2.textDirection));
        if (options2.verticalAlign) _this.root.push(new $94db4f2abf87558b$export$a6efa4726c94649f(options2.verticalAlign));
        return _this;
    }
    return TableCellProperties;
}($94db4f2abf87558b$export$951524d865ce655a);
var $94db4f2abf87558b$export$1e4baea7053fc0e3 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(TableCell, XmlComponent);
    function TableCell(options2) {
        (0, $gd0sY._)(this, TableCell);
        var _this;
        _this = (0, $8xMIM._)(this, TableCell, [
            "w:tc"
        ]);
        _this.options = options2;
        _this.root.push(new $94db4f2abf87558b$var$TableCellProperties(options2));
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = options2.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                _this.root.push(child);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _this;
    }
    (0, $7cSld._)(TableCell, [
        {
            key: "prepForXml",
            value: function prepForXml(context) {
                if (!(this.root[this.root.length - 1] instanceof $94db4f2abf87558b$export$358a232cca1ab2ac)) this.root.push(new $94db4f2abf87558b$export$358a232cca1ab2ac({}));
                return (0, $bl6Nv._)((0, $7GsX9._)(TableCell.prototype), "prepForXml", this).call(this, context);
            }
        }
    ]);
    return TableCell;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$NONE_BORDER = {
    style: $94db4f2abf87558b$export$5f9c7f3ab6d185b.NONE,
    size: 0,
    color: "auto"
};
var $94db4f2abf87558b$var$DEFAULT_BORDER = {
    style: $94db4f2abf87558b$export$5f9c7f3ab6d185b.SINGLE,
    size: 4,
    color: "auto"
};
var $94db4f2abf87558b$export$5433bd36edb7bb1 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(TableBorders, XmlComponent);
    function TableBorders(options2) {
        (0, $gd0sY._)(this, TableBorders);
        var _this;
        _this = (0, $8xMIM._)(this, TableBorders, [
            "w:tblBorders"
        ]);
        if (options2.top) _this.root.push(new $94db4f2abf87558b$export$a6733098a4eb57cf("w:top", options2.top));
        else _this.root.push(new $94db4f2abf87558b$export$a6733098a4eb57cf("w:top", $94db4f2abf87558b$var$DEFAULT_BORDER));
        if (options2.left) _this.root.push(new $94db4f2abf87558b$export$a6733098a4eb57cf("w:left", options2.left));
        else _this.root.push(new $94db4f2abf87558b$export$a6733098a4eb57cf("w:left", $94db4f2abf87558b$var$DEFAULT_BORDER));
        if (options2.bottom) _this.root.push(new $94db4f2abf87558b$export$a6733098a4eb57cf("w:bottom", options2.bottom));
        else _this.root.push(new $94db4f2abf87558b$export$a6733098a4eb57cf("w:bottom", $94db4f2abf87558b$var$DEFAULT_BORDER));
        if (options2.right) _this.root.push(new $94db4f2abf87558b$export$a6733098a4eb57cf("w:right", options2.right));
        else _this.root.push(new $94db4f2abf87558b$export$a6733098a4eb57cf("w:right", $94db4f2abf87558b$var$DEFAULT_BORDER));
        if (options2.insideHorizontal) _this.root.push(new $94db4f2abf87558b$export$a6733098a4eb57cf("w:insideH", options2.insideHorizontal));
        else _this.root.push(new $94db4f2abf87558b$export$a6733098a4eb57cf("w:insideH", $94db4f2abf87558b$var$DEFAULT_BORDER));
        if (options2.insideVertical) _this.root.push(new $94db4f2abf87558b$export$a6733098a4eb57cf("w:insideV", options2.insideVertical));
        else _this.root.push(new $94db4f2abf87558b$export$a6733098a4eb57cf("w:insideV", $94db4f2abf87558b$var$DEFAULT_BORDER));
        return _this;
    }
    return TableBorders;
}($94db4f2abf87558b$export$19f99b70db82ec96);
$94db4f2abf87558b$var$__publicField($94db4f2abf87558b$export$5433bd36edb7bb1, "NONE", {
    top: $94db4f2abf87558b$var$NONE_BORDER,
    bottom: $94db4f2abf87558b$var$NONE_BORDER,
    left: $94db4f2abf87558b$var$NONE_BORDER,
    right: $94db4f2abf87558b$var$NONE_BORDER,
    insideHorizontal: $94db4f2abf87558b$var$NONE_BORDER,
    insideVertical: $94db4f2abf87558b$var$NONE_BORDER
});
var $94db4f2abf87558b$export$f92b8391c5df40cb = {
    MARGIN: "margin",
    PAGE: "page",
    TEXT: "text"
};
var $94db4f2abf87558b$export$c25e228331ab29ba = {
    CENTER: "center",
    INSIDE: "inside",
    LEFT: "left",
    OUTSIDE: "outside",
    RIGHT: "right"
};
var $94db4f2abf87558b$export$6c91432b7690e7dd = {
    CENTER: "center",
    INSIDE: "inside",
    BOTTOM: "bottom",
    OUTSIDE: "outside",
    INLINE: "inline",
    TOP: "top"
};
var $94db4f2abf87558b$export$ae9f0393a3d86f0c = {
    NEVER: "never",
    OVERLAP: "overlap"
};
var $94db4f2abf87558b$export$c7f5805bc6840420 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(TableFloatProperties, XmlComponent);
    function TableFloatProperties(param) {
        var horizontalAnchor = param.horizontalAnchor, verticalAnchor = param.verticalAnchor, absoluteHorizontalPosition = param.absoluteHorizontalPosition, relativeHorizontalPosition = param.relativeHorizontalPosition, absoluteVerticalPosition = param.absoluteVerticalPosition, relativeVerticalPosition = param.relativeVerticalPosition, bottomFromText = param.bottomFromText, topFromText = param.topFromText, leftFromText = param.leftFromText, rightFromText = param.rightFromText, overlap = param.overlap;
        (0, $gd0sY._)(this, TableFloatProperties);
        var _this;
        _this = (0, $8xMIM._)(this, TableFloatProperties, [
            "w:tblpPr"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$b95d92bd70e2302a({
            leftFromText: {
                key: "w:leftFromText",
                value: leftFromText === void 0 ? void 0 : $94db4f2abf87558b$export$ffe63bc01ceacb3d(leftFromText)
            },
            rightFromText: {
                key: "w:rightFromText",
                value: rightFromText === void 0 ? void 0 : $94db4f2abf87558b$export$ffe63bc01ceacb3d(rightFromText)
            },
            topFromText: {
                key: "w:topFromText",
                value: topFromText === void 0 ? void 0 : $94db4f2abf87558b$export$ffe63bc01ceacb3d(topFromText)
            },
            bottomFromText: {
                key: "w:bottomFromText",
                value: bottomFromText === void 0 ? void 0 : $94db4f2abf87558b$export$ffe63bc01ceacb3d(bottomFromText)
            },
            absoluteHorizontalPosition: {
                key: "w:tblpX",
                value: absoluteHorizontalPosition === void 0 ? void 0 : $94db4f2abf87558b$export$866cabb7ed3455e9(absoluteHorizontalPosition)
            },
            absoluteVerticalPosition: {
                key: "w:tblpY",
                value: absoluteVerticalPosition === void 0 ? void 0 : $94db4f2abf87558b$export$866cabb7ed3455e9(absoluteVerticalPosition)
            },
            horizontalAnchor: {
                key: "w:horzAnchor",
                value: horizontalAnchor === void 0 ? void 0 : horizontalAnchor
            },
            relativeHorizontalPosition: {
                key: "w:tblpXSpec",
                value: relativeHorizontalPosition
            },
            relativeVerticalPosition: {
                key: "w:tblpYSpec",
                value: relativeVerticalPosition
            },
            verticalAnchor: {
                key: "w:vertAnchor",
                value: verticalAnchor
            }
        }));
        if (overlap) _this.root.push(new $94db4f2abf87558b$export$5616f64bff69d2("w:tblOverlap", overlap));
        return _this;
    }
    return TableFloatProperties;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$b86104a70e212fe1 = {
    AUTOFIT: "autofit",
    FIXED: "fixed"
};
var $94db4f2abf87558b$var$TableLayoutAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(TableLayoutAttributes, XmlAttributeComponent);
    function TableLayoutAttributes() {
        (0, $gd0sY._)(this, TableLayoutAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, TableLayoutAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            type: "w:type"
        });
        return _this;
    }
    return TableLayoutAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$62444c3c724b1b20 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(TableLayout, XmlComponent);
    function TableLayout(type) {
        (0, $gd0sY._)(this, TableLayout);
        var _this;
        _this = (0, $8xMIM._)(this, TableLayout, [
            "w:tblLayout"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$TableLayoutAttributes({
            type: type
        }));
        return _this;
    }
    return TableLayout;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$6dad081acd6c9224 = /*#__PURE__*/ function(IgnoreIfEmptyXmlComponent) {
    "use strict";
    (0, $NBk0Y._)(TableProperties, IgnoreIfEmptyXmlComponent);
    function TableProperties(options2) {
        (0, $gd0sY._)(this, TableProperties);
        var _this;
        _this = (0, $8xMIM._)(this, TableProperties, [
            "w:tblPr"
        ]);
        if (options2.style) _this.root.push(new $94db4f2abf87558b$export$eacbde36aa74068("w:tblStyle", options2.style));
        if (options2.float) _this.root.push(new $94db4f2abf87558b$export$c7f5805bc6840420(options2.float));
        if (options2.visuallyRightToLeft !== void 0) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:bidiVisual", options2.visuallyRightToLeft));
        if (options2.width) _this.root.push(new $94db4f2abf87558b$export$691ad35ca26919d6("w:tblW", options2.width));
        if (options2.alignment) _this.root.push(new $94db4f2abf87558b$export$9d7927214ed7d2cf(options2.alignment));
        if (options2.indent) _this.root.push(new $94db4f2abf87558b$export$691ad35ca26919d6("w:tblInd", options2.indent));
        if (options2.borders) _this.root.push(new $94db4f2abf87558b$export$5433bd36edb7bb1(options2.borders));
        if (options2.shading) _this.root.push(new $94db4f2abf87558b$export$21ac63597b3ebf8e(options2.shading));
        if (options2.layout) _this.root.push(new $94db4f2abf87558b$export$62444c3c724b1b20(options2.layout));
        if (options2.cellMargin) _this.root.push(new $94db4f2abf87558b$var$TableCellMargin($94db4f2abf87558b$var$TableCellMarginElementType.TABLE, options2.cellMargin));
        return _this;
    }
    return TableProperties;
}($94db4f2abf87558b$export$951524d865ce655a);
var $94db4f2abf87558b$export$54ec01a60f47d33d = /*#__PURE__*/ function(FileChild) {
    "use strict";
    var _Math;
    (0, $NBk0Y._)(Table, FileChild);
    function Table(param) {
        var rows = param.rows, width = param.width, _param_columnWidths = param.// eslint-disable-next-line functional/immutable-data
        columnWidths, columnWidths = _param_columnWidths === void 0 ? Array((_Math = Math).max.apply(_Math, (0, $6zk1M._)(rows.map(function(row) {
            return row.CellCount;
        })))).fill(100) : _param_columnWidths, margins = param.margins, indent = param.indent, float = param.float, layout = param.layout, style = param.style, borders = param.borders, alignment = param.alignment, visuallyRightToLeft = param.visuallyRightToLeft;
        (0, $gd0sY._)(this, Table);
        var _this;
        _this = (0, $8xMIM._)(this, Table, [
            "w:tbl"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$6dad081acd6c9224({
            borders: borders != null ? borders : {},
            width: width != null ? width : {
                size: 100
            },
            indent: indent,
            float: float,
            layout: layout,
            style: style,
            alignment: alignment,
            cellMargin: margins,
            visuallyRightToLeft: visuallyRightToLeft
        }));
        _this.root.push(new $94db4f2abf87558b$var$TableGrid(columnWidths));
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = rows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var row = _step.value;
                _this.root.push(row);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        rows.forEach(function(row, rowIndex) {
            if (rowIndex === rows.length - 1) return;
            var columnIndex = 0;
            row.cells.forEach(function(cell) {
                if (cell.options.rowSpan && cell.options.rowSpan > 1) {
                    var continueCell = new $94db4f2abf87558b$export$1e4baea7053fc0e3({
                        // the inserted CONTINUE cell has rowSpan, and will be handled when process the next row
                        rowSpan: cell.options.rowSpan - 1,
                        columnSpan: cell.options.columnSpan,
                        borders: cell.options.borders,
                        children: [],
                        verticalMerge: $94db4f2abf87558b$export$ba6d52537e3f9b56.CONTINUE
                    });
                    rows[rowIndex + 1].addCellToColumnIndex(continueCell, columnIndex);
                }
                columnIndex += cell.options.columnSpan || 1;
            });
        });
        return _this;
    }
    return Table;
}($94db4f2abf87558b$var$FileChild);
var $94db4f2abf87558b$export$f6b000a26dc0329c = {
    /** Height is determined based on the content, so value is ignored. */ AUTO: "auto",
    /** At least the value specified */ ATLEAST: "atLeast",
    /** Exactly the value specified */ EXACT: "exact"
};
var $94db4f2abf87558b$export$891ad127202c0bd2 = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(TableRowHeightAttributes, XmlAttributeComponent);
    function TableRowHeightAttributes() {
        (0, $gd0sY._)(this, TableRowHeightAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, TableRowHeightAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            value: "w:val",
            rule: "w:hRule"
        });
        return _this;
    }
    return TableRowHeightAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$5ebfe399c7544ece = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(TableRowHeight, XmlComponent);
    function TableRowHeight(value, rule) {
        (0, $gd0sY._)(this, TableRowHeight);
        var _this;
        _this = (0, $8xMIM._)(this, TableRowHeight, [
            "w:trHeight"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$891ad127202c0bd2({
            value: $94db4f2abf87558b$export$ffe63bc01ceacb3d(value),
            rule: rule
        }));
        return _this;
    }
    return TableRowHeight;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$bc525f85d0e260b3 = /*#__PURE__*/ function(IgnoreIfEmptyXmlComponent) {
    "use strict";
    (0, $NBk0Y._)(TableRowProperties, IgnoreIfEmptyXmlComponent);
    function TableRowProperties(options2) {
        (0, $gd0sY._)(this, TableRowProperties);
        var _this;
        _this = (0, $8xMIM._)(this, TableRowProperties, [
            "w:trPr"
        ]);
        if (options2.cantSplit !== void 0) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:cantSplit", options2.cantSplit));
        if (options2.tableHeader !== void 0) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:tblHeader", options2.tableHeader));
        if (options2.height) _this.root.push(new $94db4f2abf87558b$export$5ebfe399c7544ece(options2.height.value, options2.height.rule));
        return _this;
    }
    return TableRowProperties;
}($94db4f2abf87558b$export$951524d865ce655a);
var $94db4f2abf87558b$export$b05581f4e764e162 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(TableRow, XmlComponent);
    function TableRow(options2) {
        (0, $gd0sY._)(this, TableRow);
        var _this;
        _this = (0, $8xMIM._)(this, TableRow, [
            "w:tr"
        ]);
        _this.options = options2;
        _this.root.push(new $94db4f2abf87558b$export$bc525f85d0e260b3(options2));
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = options2.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                _this.root.push(child);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _this;
    }
    (0, $7cSld._)(TableRow, [
        {
            key: "CellCount",
            get: function get() {
                return this.options.children.length;
            }
        },
        {
            key: "cells",
            get: function get() {
                return this.root.filter(function(xmlComponent) {
                    return xmlComponent instanceof $94db4f2abf87558b$export$1e4baea7053fc0e3;
                });
            }
        },
        {
            key: "addCellToIndex",
            value: function addCellToIndex(cell, index) {
                this.root.splice(index + 1, 0, cell);
            }
        },
        {
            key: "addCellToColumnIndex",
            value: function addCellToColumnIndex(cell, columnIndex) {
                var rootIndex = this.columnIndexToRootIndex(columnIndex, true);
                this.addCellToIndex(cell, rootIndex - 1);
            }
        },
        {
            key: "rootIndexToColumnIndex",
            value: function rootIndexToColumnIndex(rootIndex) {
                if (rootIndex < 1 || rootIndex >= this.root.length) throw new Error("cell 'rootIndex' should between 1 to ".concat(this.root.length - 1));
                var colIdx = 0;
                for(var rootIdx = 1; rootIdx < rootIndex; rootIdx++){
                    var cell = this.root[rootIdx];
                    colIdx += cell.options.columnSpan || 1;
                }
                return colIdx;
            }
        },
        {
            key: "columnIndexToRootIndex",
            value: function columnIndexToRootIndex(columnIndex) {
                var allowEndNewCell = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (columnIndex < 0) throw new Error("cell 'columnIndex' should not less than zero");
                var colIdx = 0;
                var rootIdx = 1;
                while(colIdx <= columnIndex){
                    if (rootIdx >= this.root.length) {
                        if (allowEndNewCell) return this.root.length;
                        else throw new Error("cell 'columnIndex' should not great than ".concat(colIdx - 1));
                    }
                    var cell = this.root[rootIdx];
                    rootIdx += 1;
                    colIdx += cell && cell.options.columnSpan || 1;
                }
                return rootIdx - 1;
            }
        }
    ]);
    return TableRow;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$AppPropertiesAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(AppPropertiesAttributes, XmlAttributeComponent);
    function AppPropertiesAttributes() {
        (0, $gd0sY._)(this, AppPropertiesAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, AppPropertiesAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            xmlns: "xmlns",
            vt: "xmlns:vt"
        });
        return _this;
    }
    return AppPropertiesAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$AppProperties = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(AppProperties, XmlComponent);
    function AppProperties() {
        (0, $gd0sY._)(this, AppProperties);
        var _this;
        _this = (0, $8xMIM._)(this, AppProperties, [
            "Properties"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$AppPropertiesAttributes({
            xmlns: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
            vt: "http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes"
        }));
        return _this;
    }
    return AppProperties;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$ContentTypeAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(ContentTypeAttributes, XmlAttributeComponent);
    function ContentTypeAttributes() {
        (0, $gd0sY._)(this, ContentTypeAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, ContentTypeAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            xmlns: "xmlns"
        });
        return _this;
    }
    return ContentTypeAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$DefaultAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(DefaultAttributes, XmlAttributeComponent);
    function DefaultAttributes() {
        (0, $gd0sY._)(this, DefaultAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, DefaultAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            contentType: "ContentType",
            extension: "Extension"
        });
        return _this;
    }
    return DefaultAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$Default = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Default, XmlComponent);
    function Default(contentType, extension) {
        (0, $gd0sY._)(this, Default);
        var _this;
        _this = (0, $8xMIM._)(this, Default, [
            "Default"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$DefaultAttributes({
            contentType: contentType,
            extension: extension
        }));
        return _this;
    }
    return Default;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$OverrideAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(OverrideAttributes, XmlAttributeComponent);
    function OverrideAttributes() {
        (0, $gd0sY._)(this, OverrideAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, OverrideAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            contentType: "ContentType",
            partName: "PartName"
        });
        return _this;
    }
    return OverrideAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$Override = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Override, XmlComponent);
    function Override(contentType, partName) {
        (0, $gd0sY._)(this, Override);
        var _this;
        _this = (0, $8xMIM._)(this, Override, [
            "Override"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$OverrideAttributes({
            contentType: contentType,
            partName: partName
        }));
        return _this;
    }
    return Override;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$ContentTypes = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(ContentTypes, XmlComponent);
    function ContentTypes() {
        (0, $gd0sY._)(this, ContentTypes);
        var _this;
        _this = (0, $8xMIM._)(this, ContentTypes, [
            "Types"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$ContentTypeAttributes({
            xmlns: "http://schemas.openxmlformats.org/package/2006/content-types"
        }));
        _this.root.push(new $94db4f2abf87558b$var$Default("image/png", "png"));
        _this.root.push(new $94db4f2abf87558b$var$Default("image/jpeg", "jpeg"));
        _this.root.push(new $94db4f2abf87558b$var$Default("image/jpeg", "jpg"));
        _this.root.push(new $94db4f2abf87558b$var$Default("image/bmp", "bmp"));
        _this.root.push(new $94db4f2abf87558b$var$Default("image/gif", "gif"));
        _this.root.push(new $94db4f2abf87558b$var$Default("application/vnd.openxmlformats-package.relationships+xml", "rels"));
        _this.root.push(new $94db4f2abf87558b$var$Default("application/xml", "xml"));
        _this.root.push(new $94db4f2abf87558b$var$Default("application/vnd.openxmlformats-officedocument.obfuscatedFont", "odttf"));
        _this.root.push(new $94db4f2abf87558b$var$Override("application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml", "/word/document.xml"));
        _this.root.push(new $94db4f2abf87558b$var$Override("application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml", "/word/styles.xml"));
        _this.root.push(new $94db4f2abf87558b$var$Override("application/vnd.openxmlformats-package.core-properties+xml", "/docProps/core.xml"));
        _this.root.push(new $94db4f2abf87558b$var$Override("application/vnd.openxmlformats-officedocument.custom-properties+xml", "/docProps/custom.xml"));
        _this.root.push(new $94db4f2abf87558b$var$Override("application/vnd.openxmlformats-officedocument.extended-properties+xml", "/docProps/app.xml"));
        _this.root.push(new $94db4f2abf87558b$var$Override("application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml", "/word/numbering.xml"));
        _this.root.push(new $94db4f2abf87558b$var$Override("application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml", "/word/footnotes.xml"));
        _this.root.push(new $94db4f2abf87558b$var$Override("application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml", "/word/settings.xml"));
        _this.root.push(new $94db4f2abf87558b$var$Override("application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml", "/word/comments.xml"));
        _this.root.push(new $94db4f2abf87558b$var$Override("application/vnd.openxmlformats-officedocument.wordprocessingml.fontTable+xml", "/word/fontTable.xml"));
        return _this;
    }
    (0, $7cSld._)(ContentTypes, [
        {
            key: "addFooter",
            value: function addFooter(index) {
                this.root.push(new $94db4f2abf87558b$var$Override("application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml", "/word/footer".concat(index, ".xml")));
            }
        },
        {
            key: "addHeader",
            value: function addHeader(index) {
                this.root.push(new $94db4f2abf87558b$var$Override("application/vnd.openxmlformats-officedocument.wordprocessingml.header+xml", "/word/header".concat(index, ".xml")));
            }
        }
    ]);
    return ContentTypes;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$CoreProperties = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(CoreProperties, XmlComponent);
    function CoreProperties(options2) {
        (0, $gd0sY._)(this, CoreProperties);
        var _this;
        _this = (0, $8xMIM._)(this, CoreProperties, [
            "cp:coreProperties"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$e2bedb2588efb3f4({
            cp: "http://schemas.openxmlformats.org/package/2006/metadata/core-properties",
            dc: "http://purl.org/dc/elements/1.1/",
            dcterms: "http://purl.org/dc/terms/",
            dcmitype: "http://purl.org/dc/dcmitype/",
            xsi: "http://www.w3.org/2001/XMLSchema-instance"
        }));
        if (options2.title) _this.root.push(new $94db4f2abf87558b$export$5ef82a33e5d8976f("dc:title", options2.title));
        if (options2.subject) _this.root.push(new $94db4f2abf87558b$export$5ef82a33e5d8976f("dc:subject", options2.subject));
        if (options2.creator) _this.root.push(new $94db4f2abf87558b$export$5ef82a33e5d8976f("dc:creator", options2.creator));
        if (options2.keywords) _this.root.push(new $94db4f2abf87558b$export$5ef82a33e5d8976f("cp:keywords", options2.keywords));
        if (options2.description) _this.root.push(new $94db4f2abf87558b$export$5ef82a33e5d8976f("dc:description", options2.description));
        if (options2.lastModifiedBy) _this.root.push(new $94db4f2abf87558b$export$5ef82a33e5d8976f("cp:lastModifiedBy", options2.lastModifiedBy));
        if (options2.revision) _this.root.push(new $94db4f2abf87558b$export$5ef82a33e5d8976f("cp:revision", String(options2.revision)));
        _this.root.push(new $94db4f2abf87558b$var$TimestampElement("dcterms:created"));
        _this.root.push(new $94db4f2abf87558b$var$TimestampElement("dcterms:modified"));
        return _this;
    }
    return CoreProperties;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$TimestampElement = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(TimestampElement, XmlComponent);
    function TimestampElement(name) {
        (0, $gd0sY._)(this, TimestampElement);
        var _this;
        _this = (0, $8xMIM._)(this, TimestampElement, [
            name
        ]);
        _this.root.push(new $94db4f2abf87558b$export$e2bedb2588efb3f4({
            type: "dcterms:W3CDTF"
        }));
        _this.root.push($94db4f2abf87558b$export$89d9edd4d0429282(/* @__PURE__ */ new Date()));
        return _this;
    }
    return TimestampElement;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$CustomPropertiesAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(CustomPropertiesAttributes, XmlAttributeComponent);
    function CustomPropertiesAttributes() {
        (0, $gd0sY._)(this, CustomPropertiesAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, CustomPropertiesAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            xmlns: "xmlns",
            vt: "xmlns:vt"
        });
        return _this;
    }
    return CustomPropertiesAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$CustomPropertyAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(CustomPropertyAttributes, XmlAttributeComponent);
    function CustomPropertyAttributes() {
        (0, $gd0sY._)(this, CustomPropertyAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, CustomPropertyAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            fmtid: "fmtid",
            pid: "pid",
            name: "name"
        });
        return _this;
    }
    return CustomPropertyAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$CustomProperty = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(CustomProperty, XmlComponent);
    function CustomProperty(id, properties) {
        (0, $gd0sY._)(this, CustomProperty);
        var _this;
        _this = (0, $8xMIM._)(this, CustomProperty, [
            "property"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$CustomPropertyAttributes({
            fmtid: "{D5CDD505-2E9C-101B-9397-08002B2CF9AE}",
            pid: id.toString(),
            name: properties.name
        }));
        _this.root.push(new $94db4f2abf87558b$var$CustomPropertyValue(properties.value));
        return _this;
    }
    return CustomProperty;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$CustomPropertyValue = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(CustomPropertyValue, XmlComponent);
    function CustomPropertyValue(value) {
        (0, $gd0sY._)(this, CustomPropertyValue);
        var _this;
        _this = (0, $8xMIM._)(this, CustomPropertyValue, [
            "vt:lpwstr"
        ]);
        _this.root.push(value);
        return _this;
    }
    return CustomPropertyValue;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$CustomProperties = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(CustomProperties, XmlComponent);
    function CustomProperties(properties) {
        (0, $gd0sY._)(this, CustomProperties);
        var _this;
        _this = (0, $8xMIM._)(this, CustomProperties, [
            "Properties"
        ]);
        // eslint-disable-next-line functional/prefer-readonly-type
        $94db4f2abf87558b$var$__publicField(_this, "nextId");
        // eslint-disable-next-line functional/prefer-readonly-type
        $94db4f2abf87558b$var$__publicField(_this, "properties", []);
        _this.root.push(new $94db4f2abf87558b$var$CustomPropertiesAttributes({
            xmlns: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",
            vt: "http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes"
        }));
        _this.nextId = 2;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = properties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var property = _step.value;
                _this.addCustomProperty(property);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _this;
    }
    (0, $7cSld._)(CustomProperties, [
        {
            key: "prepForXml",
            value: function prepForXml(context) {
                var _this = this;
                this.properties.forEach(function(x) {
                    return _this.root.push(x);
                });
                return (0, $bl6Nv._)((0, $7GsX9._)(CustomProperties.prototype), "prepForXml", this).call(this, context);
            }
        },
        {
            key: "addCustomProperty",
            value: function addCustomProperty(property) {
                this.properties.push(new $94db4f2abf87558b$var$CustomProperty(this.nextId++, property));
            }
        }
    ]);
    return CustomProperties;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$FooterAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(FooterAttributes, XmlAttributeComponent);
    function FooterAttributes() {
        (0, $gd0sY._)(this, FooterAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, FooterAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            wpc: "xmlns:wpc",
            mc: "xmlns:mc",
            o: "xmlns:o",
            r: "xmlns:r",
            m: "xmlns:m",
            v: "xmlns:v",
            wp14: "xmlns:wp14",
            wp: "xmlns:wp",
            w10: "xmlns:w10",
            w: "xmlns:w",
            w14: "xmlns:w14",
            w15: "xmlns:w15",
            wpg: "xmlns:wpg",
            wpi: "xmlns:wpi",
            wne: "xmlns:wne",
            wps: "xmlns:wps",
            cp: "xmlns:cp",
            dc: "xmlns:dc",
            dcterms: "xmlns:dcterms",
            dcmitype: "xmlns:dcmitype",
            xsi: "xmlns:xsi",
            type: "xsi:type"
        });
        return _this;
    }
    return FooterAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$Footer$1 = /*#__PURE__*/ function(InitializableXmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Footer, InitializableXmlComponent);
    function Footer(referenceNumber, initContent) {
        (0, $gd0sY._)(this, Footer);
        var _this;
        _this = (0, $8xMIM._)(this, Footer, [
            "w:ftr",
            initContent
        ]);
        $94db4f2abf87558b$var$__publicField(_this, "refId");
        _this.refId = referenceNumber;
        if (!initContent) _this.root.push(new $94db4f2abf87558b$var$FooterAttributes({
            wpc: "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
            mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",
            o: "urn:schemas-microsoft-com:office:office",
            r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
            m: "http://schemas.openxmlformats.org/officeDocument/2006/math",
            v: "urn:schemas-microsoft-com:vml",
            wp14: "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
            wp: "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
            w10: "urn:schemas-microsoft-com:office:word",
            w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
            w14: "http://schemas.microsoft.com/office/word/2010/wordml",
            w15: "http://schemas.microsoft.com/office/word/2012/wordml",
            wpg: "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
            wpi: "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
            wne: "http://schemas.microsoft.com/office/word/2006/wordml",
            wps: "http://schemas.microsoft.com/office/word/2010/wordprocessingShape"
        }));
        return _this;
    }
    (0, $7cSld._)(Footer, [
        {
            key: "ReferenceId",
            get: function get() {
                return this.refId;
            }
        },
        {
            key: "add",
            value: function add(item) {
                this.root.push(item);
            }
        }
    ]);
    return Footer;
}($94db4f2abf87558b$export$646396cb36770d6c);
var $94db4f2abf87558b$export$fd9000017733fabf = /*#__PURE__*/ function() {
    "use strict";
    function FooterWrapper(media, referenceId, initContent) {
        (0, $gd0sY._)(this, FooterWrapper);
        $94db4f2abf87558b$var$__publicField(this, "footer");
        $94db4f2abf87558b$var$__publicField(this, "relationships");
        this.media = media;
        this.footer = new $94db4f2abf87558b$var$Footer$1(referenceId, initContent);
        this.relationships = new $94db4f2abf87558b$var$Relationships();
    }
    (0, $7cSld._)(FooterWrapper, [
        {
            key: "add",
            value: function add(item) {
                this.footer.add(item);
            }
        },
        {
            key: "addChildElement",
            value: function addChildElement(childElement) {
                this.footer.addChildElement(childElement);
            }
        },
        {
            key: "View",
            get: function get() {
                return this.footer;
            }
        },
        {
            key: "Relationships",
            get: function get() {
                return this.relationships;
            }
        },
        {
            key: "Media",
            get: function get() {
                return this.media;
            }
        }
    ]);
    return FooterWrapper;
}();
var $94db4f2abf87558b$var$FootnoteAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(FootnoteAttributes, XmlAttributeComponent);
    function FootnoteAttributes() {
        (0, $gd0sY._)(this, FootnoteAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, FootnoteAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            type: "w:type",
            id: "w:id"
        });
        return _this;
    }
    return FootnoteAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$FootnoteRef = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(FootnoteRef, XmlComponent);
    function FootnoteRef() {
        (0, $gd0sY._)(this, FootnoteRef);
        return (0, $8xMIM._)(this, FootnoteRef, [
            "w:footnoteRef"
        ]);
    }
    return FootnoteRef;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$FootnoteRefRun = /*#__PURE__*/ function(Run) {
    "use strict";
    (0, $NBk0Y._)(FootnoteRefRun, Run);
    function FootnoteRefRun() {
        (0, $gd0sY._)(this, FootnoteRefRun);
        var _this;
        _this = (0, $8xMIM._)(this, FootnoteRefRun, [
            {
                style: "FootnoteReference"
            }
        ]);
        _this.root.push(new $94db4f2abf87558b$var$FootnoteRef());
        return _this;
    }
    return FootnoteRefRun;
}($94db4f2abf87558b$export$ddae37e51c7979e2);
var $94db4f2abf87558b$var$FootnoteType = {
    SEPERATOR: "separator",
    // eslint-disable-next-line @typescript-eslint/naming-convention
    CONTINUATION_SEPERATOR: "continuationSeparator"
};
var $94db4f2abf87558b$var$Footnote = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Footnote, XmlComponent);
    function Footnote(options2) {
        (0, $gd0sY._)(this, Footnote);
        var _this;
        _this = (0, $8xMIM._)(this, Footnote, [
            "w:footnote"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$FootnoteAttributes({
            type: options2.type,
            id: options2.id
        }));
        for(var i = 0; i < options2.children.length; i++){
            var child = options2.children[i];
            if (i === 0) child.addRunToFront(new $94db4f2abf87558b$var$FootnoteRefRun());
            _this.root.push(child);
        }
        return _this;
    }
    return Footnote;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$ContinuationSeperator = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(ContinuationSeperator, XmlComponent);
    function ContinuationSeperator() {
        (0, $gd0sY._)(this, ContinuationSeperator);
        return (0, $8xMIM._)(this, ContinuationSeperator, [
            "w:continuationSeparator"
        ]);
    }
    return ContinuationSeperator;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$ContinuationSeperatorRun = /*#__PURE__*/ function(Run) {
    "use strict";
    (0, $NBk0Y._)(ContinuationSeperatorRun, Run);
    function ContinuationSeperatorRun() {
        (0, $gd0sY._)(this, ContinuationSeperatorRun);
        var _this;
        _this = (0, $8xMIM._)(this, ContinuationSeperatorRun, [
            {}
        ]);
        _this.root.push(new $94db4f2abf87558b$var$ContinuationSeperator());
        return _this;
    }
    return ContinuationSeperatorRun;
}($94db4f2abf87558b$export$ddae37e51c7979e2);
var $94db4f2abf87558b$var$Seperator = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Seperator, XmlComponent);
    function Seperator() {
        (0, $gd0sY._)(this, Seperator);
        return (0, $8xMIM._)(this, Seperator, [
            "w:separator"
        ]);
    }
    return Seperator;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$SeperatorRun = /*#__PURE__*/ function(Run) {
    "use strict";
    (0, $NBk0Y._)(SeperatorRun, Run);
    function SeperatorRun() {
        (0, $gd0sY._)(this, SeperatorRun);
        var _this;
        _this = (0, $8xMIM._)(this, SeperatorRun, [
            {}
        ]);
        _this.root.push(new $94db4f2abf87558b$var$Seperator());
        return _this;
    }
    return SeperatorRun;
}($94db4f2abf87558b$export$ddae37e51c7979e2);
var $94db4f2abf87558b$var$FootnotesAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(FootnotesAttributes, XmlAttributeComponent);
    function FootnotesAttributes() {
        (0, $gd0sY._)(this, FootnotesAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, FootnotesAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            wpc: "xmlns:wpc",
            mc: "xmlns:mc",
            o: "xmlns:o",
            r: "xmlns:r",
            m: "xmlns:m",
            v: "xmlns:v",
            wp14: "xmlns:wp14",
            wp: "xmlns:wp",
            w10: "xmlns:w10",
            w: "xmlns:w",
            w14: "xmlns:w14",
            w15: "xmlns:w15",
            wpg: "xmlns:wpg",
            wpi: "xmlns:wpi",
            wne: "xmlns:wne",
            wps: "xmlns:wps",
            Ignorable: "mc:Ignorable"
        });
        return _this;
    }
    return FootnotesAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$4f472d314600dfca = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(FootNotes, XmlComponent);
    function FootNotes() {
        (0, $gd0sY._)(this, FootNotes);
        var _this;
        _this = (0, $8xMIM._)(this, FootNotes, [
            "w:footnotes"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$FootnotesAttributes({
            wpc: "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
            mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",
            o: "urn:schemas-microsoft-com:office:office",
            r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
            m: "http://schemas.openxmlformats.org/officeDocument/2006/math",
            v: "urn:schemas-microsoft-com:vml",
            wp14: "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
            wp: "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
            w10: "urn:schemas-microsoft-com:office:word",
            w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
            w14: "http://schemas.microsoft.com/office/word/2010/wordml",
            w15: "http://schemas.microsoft.com/office/word/2012/wordml",
            wpg: "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
            wpi: "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
            wne: "http://schemas.microsoft.com/office/word/2006/wordml",
            wps: "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",
            Ignorable: "w14 w15 wp14"
        }));
        var begin = new $94db4f2abf87558b$var$Footnote({
            id: -1,
            type: $94db4f2abf87558b$var$FootnoteType.SEPERATOR,
            children: [
                new $94db4f2abf87558b$export$358a232cca1ab2ac({
                    spacing: {
                        after: 0,
                        line: 240,
                        lineRule: $94db4f2abf87558b$export$595a14bf61dfe45b.AUTO
                    },
                    children: [
                        new $94db4f2abf87558b$var$SeperatorRun()
                    ]
                })
            ]
        });
        _this.root.push(begin);
        var spacing = new $94db4f2abf87558b$var$Footnote({
            id: 0,
            type: $94db4f2abf87558b$var$FootnoteType.CONTINUATION_SEPERATOR,
            children: [
                new $94db4f2abf87558b$export$358a232cca1ab2ac({
                    spacing: {
                        after: 0,
                        line: 240,
                        lineRule: $94db4f2abf87558b$export$595a14bf61dfe45b.AUTO
                    },
                    children: [
                        new $94db4f2abf87558b$var$ContinuationSeperatorRun()
                    ]
                })
            ]
        });
        _this.root.push(spacing);
        return _this;
    }
    (0, $7cSld._)(FootNotes, [
        {
            key: "createFootNote",
            value: function createFootNote(id, paragraph) {
                var footnote = new $94db4f2abf87558b$var$Footnote({
                    id: id,
                    children: paragraph
                });
                this.root.push(footnote);
            }
        }
    ]);
    return FootNotes;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$FootnotesWrapper = /*#__PURE__*/ function() {
    "use strict";
    function FootnotesWrapper() {
        (0, $gd0sY._)(this, FootnotesWrapper);
        $94db4f2abf87558b$var$__publicField(this, "footnotess");
        $94db4f2abf87558b$var$__publicField(this, "relationships");
        this.footnotess = new $94db4f2abf87558b$export$4f472d314600dfca();
        this.relationships = new $94db4f2abf87558b$var$Relationships();
    }
    (0, $7cSld._)(FootnotesWrapper, [
        {
            key: "View",
            get: function get() {
                return this.footnotess;
            }
        },
        {
            key: "Relationships",
            get: function get() {
                return this.relationships;
            }
        }
    ]);
    return FootnotesWrapper;
}();
var $94db4f2abf87558b$var$HeaderAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(HeaderAttributes, XmlAttributeComponent);
    function HeaderAttributes() {
        (0, $gd0sY._)(this, HeaderAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, HeaderAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            wpc: "xmlns:wpc",
            mc: "xmlns:mc",
            o: "xmlns:o",
            r: "xmlns:r",
            m: "xmlns:m",
            v: "xmlns:v",
            wp14: "xmlns:wp14",
            wp: "xmlns:wp",
            w10: "xmlns:w10",
            w: "xmlns:w",
            w14: "xmlns:w14",
            w15: "xmlns:w15",
            wpg: "xmlns:wpg",
            wpi: "xmlns:wpi",
            wne: "xmlns:wne",
            wps: "xmlns:wps",
            cp: "xmlns:cp",
            dc: "xmlns:dc",
            dcterms: "xmlns:dcterms",
            dcmitype: "xmlns:dcmitype",
            xsi: "xmlns:xsi",
            type: "xsi:type",
            cx: "xmlns:cx",
            cx1: "xmlns:cx1",
            cx2: "xmlns:cx2",
            cx3: "xmlns:cx3",
            cx4: "xmlns:cx4",
            cx5: "xmlns:cx5",
            cx6: "xmlns:cx6",
            cx7: "xmlns:cx7",
            cx8: "xmlns:cx8",
            w16cid: "xmlns:w16cid",
            w16se: "xmlns:w16se"
        });
        return _this;
    }
    return HeaderAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$Header$1 = /*#__PURE__*/ function(InitializableXmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Header, InitializableXmlComponent);
    function Header(referenceNumber, initContent) {
        (0, $gd0sY._)(this, Header);
        var _this;
        _this = (0, $8xMIM._)(this, Header, [
            "w:hdr",
            initContent
        ]);
        $94db4f2abf87558b$var$__publicField(_this, "refId");
        _this.refId = referenceNumber;
        if (!initContent) _this.root.push(new $94db4f2abf87558b$var$HeaderAttributes({
            wpc: "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
            mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",
            o: "urn:schemas-microsoft-com:office:office",
            r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
            m: "http://schemas.openxmlformats.org/officeDocument/2006/math",
            v: "urn:schemas-microsoft-com:vml",
            wp14: "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
            wp: "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
            w10: "urn:schemas-microsoft-com:office:word",
            w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
            w14: "http://schemas.microsoft.com/office/word/2010/wordml",
            w15: "http://schemas.microsoft.com/office/word/2012/wordml",
            wpg: "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
            wpi: "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
            wne: "http://schemas.microsoft.com/office/word/2006/wordml",
            wps: "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",
            cx: "http://schemas.microsoft.com/office/drawing/2014/chartex",
            cx1: "http://schemas.microsoft.com/office/drawing/2015/9/8/chartex",
            cx2: "http://schemas.microsoft.com/office/drawing/2015/10/21/chartex",
            cx3: "http://schemas.microsoft.com/office/drawing/2016/5/9/chartex",
            cx4: "http://schemas.microsoft.com/office/drawing/2016/5/10/chartex",
            cx5: "http://schemas.microsoft.com/office/drawing/2016/5/11/chartex",
            cx6: "http://schemas.microsoft.com/office/drawing/2016/5/12/chartex",
            cx7: "http://schemas.microsoft.com/office/drawing/2016/5/13/chartex",
            cx8: "http://schemas.microsoft.com/office/drawing/2016/5/14/chartex",
            w16cid: "http://schemas.microsoft.com/office/word/2016/wordml/cid",
            w16se: "http://schemas.microsoft.com/office/word/2015/wordml/symex"
        }));
        return _this;
    }
    (0, $7cSld._)(Header, [
        {
            key: "ReferenceId",
            get: function get() {
                return this.refId;
            }
        },
        {
            key: "add",
            value: function add(item) {
                this.root.push(item);
            }
        }
    ]);
    return Header;
}($94db4f2abf87558b$export$646396cb36770d6c);
var $94db4f2abf87558b$export$960a49cc3d27a090 = /*#__PURE__*/ function() {
    "use strict";
    function HeaderWrapper(media, referenceId, initContent) {
        (0, $gd0sY._)(this, HeaderWrapper);
        $94db4f2abf87558b$var$__publicField(this, "header");
        $94db4f2abf87558b$var$__publicField(this, "relationships");
        this.media = media;
        this.header = new $94db4f2abf87558b$var$Header$1(referenceId, initContent);
        this.relationships = new $94db4f2abf87558b$var$Relationships();
    }
    (0, $7cSld._)(HeaderWrapper, [
        {
            key: "add",
            value: function add(item) {
                this.header.add(item);
                return this;
            }
        },
        {
            key: "addChildElement",
            value: function addChildElement(childElement) {
                this.header.addChildElement(childElement);
            }
        },
        {
            key: "View",
            get: function get() {
                return this.header;
            }
        },
        {
            key: "Relationships",
            get: function get() {
                return this.relationships;
            }
        },
        {
            key: "Media",
            get: function get() {
                return this.media;
            }
        }
    ]);
    return HeaderWrapper;
}();
var $94db4f2abf87558b$export$7fc53215244aec38 = /*#__PURE__*/ function() {
    "use strict";
    function Media() {
        (0, $gd0sY._)(this, Media);
        // eslint-disable-next-line functional/prefer-readonly-type
        $94db4f2abf87558b$var$__publicField(this, "map");
        this.map = /* @__PURE__ */ new Map();
    }
    (0, $7cSld._)(Media, [
        {
            key: "addImage",
            value: function addImage(key, mediaData) {
                this.map.set(key, mediaData);
            }
        },
        {
            key: "Array",
            get: function get() {
                return Array.from(this.map.values());
            }
        }
    ]);
    return Media;
}();
var $94db4f2abf87558b$export$acf3e21fbd48faf6 = "";
var $94db4f2abf87558b$export$c17662f376a36ef9 = {
    DECIMAL: "decimal",
    UPPER_ROMAN: "upperRoman",
    LOWER_ROMAN: "lowerRoman",
    UPPER_LETTER: "upperLetter",
    LOWER_LETTER: "lowerLetter",
    ORDINAL: "ordinal",
    CARDINAL_TEXT: "cardinalText",
    ORDINAL_TEXT: "ordinalText",
    HEX: "hex",
    CHICAGO: "chicago",
    IDEOGRAPH__DIGITAL: "ideographDigital",
    JAPANESE_COUNTING: "japaneseCounting",
    AIUEO: "aiueo",
    IROHA: "iroha",
    DECIMAL_FULL_WIDTH: "decimalFullWidth",
    DECIMAL_HALF_WIDTH: "decimalHalfWidth",
    JAPANESE_LEGAL: "japaneseLegal",
    JAPANESE_DIGITAL_TEN_THOUSAND: "japaneseDigitalTenThousand",
    DECIMAL_ENCLOSED_CIRCLE: "decimalEnclosedCircle",
    DECIMAL_FULL_WIDTH2: "decimalFullWidth2",
    AIUEO_FULL_WIDTH: "aiueoFullWidth",
    IROHA_FULL_WIDTH: "irohaFullWidth",
    DECIMAL_ZERO: "decimalZero",
    BULLET: "bullet",
    GANADA: "ganada",
    CHOSUNG: "chosung",
    DECIMAL_ENCLOSED_FULLSTOP: "decimalEnclosedFullstop",
    DECIMAL_ENCLOSED_PARENTHESES: "decimalEnclosedParen",
    DECIMAL_ENCLOSED_CIRCLE_CHINESE: "decimalEnclosedCircleChinese",
    IDEOGRAPH_ENCLOSED_CIRCLE: "ideographEnclosedCircle",
    IDEOGRAPH_TRADITIONAL: "ideographTraditional",
    IDEOGRAPH_ZODIAC: "ideographZodiac",
    IDEOGRAPH_ZODIAC_TRADITIONAL: "ideographZodiacTraditional",
    TAIWANESE_COUNTING: "taiwaneseCounting",
    IDEOGRAPH_LEGAL_TRADITIONAL: "ideographLegalTraditional",
    TAIWANESE_COUNTING_THOUSAND: "taiwaneseCountingThousand",
    TAIWANESE_DIGITAL: "taiwaneseDigital",
    CHINESE_COUNTING: "chineseCounting",
    CHINESE_LEGAL_SIMPLIFIED: "chineseLegalSimplified",
    CHINESE_COUNTING_THOUSAND: "chineseCountingThousand",
    KOREAN_DIGITAL: "koreanDigital",
    KOREAN_COUNTING: "koreanCounting",
    KOREAN_LEGAL: "koreanLegal",
    KOREAN_DIGITAL2: "koreanDigital2",
    VIETNAMESE_COUNTING: "vietnameseCounting",
    RUSSIAN_LOWER: "russianLower",
    RUSSIAN_UPPER: "russianUpper",
    NONE: "none",
    NUMBER_IN_DASH: "numberInDash",
    HEBREW1: "hebrew1",
    HEBREW2: "hebrew2",
    ARABIC_ALPHA: "arabicAlpha",
    ARABIC_ABJAD: "arabicAbjad",
    HINDI_VOWELS: "hindiVowels",
    HINDI_CONSONANTS: "hindiConsonants",
    HINDI_NUMBERS: "hindiNumbers",
    HINDI_COUNTING: "hindiCounting",
    THAI_LETTERS: "thaiLetters",
    THAI_NUMBERS: "thaiNumbers",
    THAI_COUNTING: "thaiCounting",
    BAHT_TEXT: "bahtText",
    DOLLAR_TEXT: "dollarText",
    CUSTOM: "custom"
};
var $94db4f2abf87558b$var$LevelAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(LevelAttributes, XmlAttributeComponent);
    function LevelAttributes() {
        (0, $gd0sY._)(this, LevelAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, LevelAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            ilvl: "w:ilvl",
            tentative: "w15:tentative"
        });
        return _this;
    }
    return LevelAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$NumberFormat = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(NumberFormat, XmlComponent);
    function NumberFormat(value) {
        (0, $gd0sY._)(this, NumberFormat);
        var _this;
        _this = (0, $8xMIM._)(this, NumberFormat, [
            "w:numFmt"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$21991851b0bb231f({
            val: value
        }));
        return _this;
    }
    return NumberFormat;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$LevelText = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(LevelText, XmlComponent);
    function LevelText(value) {
        (0, $gd0sY._)(this, LevelText);
        var _this;
        _this = (0, $8xMIM._)(this, LevelText, [
            "w:lvlText"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$21991851b0bb231f({
            val: value
        }));
        return _this;
    }
    return LevelText;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$LevelJc = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(LevelJc, XmlComponent);
    function LevelJc(value) {
        (0, $gd0sY._)(this, LevelJc);
        var _this;
        _this = (0, $8xMIM._)(this, LevelJc, [
            "w:lvlJc"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$21991851b0bb231f({
            val: value
        }));
        return _this;
    }
    return LevelJc;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$47604b1a4ce5619b = {
    NOTHING: "nothing",
    SPACE: "space",
    TAB: "tab"
};
var $94db4f2abf87558b$var$Suffix = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Suffix, XmlComponent);
    function Suffix(value) {
        (0, $gd0sY._)(this, Suffix);
        var _this;
        _this = (0, $8xMIM._)(this, Suffix, [
            "w:suff"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$21991851b0bb231f({
            val: value
        }));
        return _this;
    }
    return Suffix;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$IsLegalNumberingStyle = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(IsLegalNumberingStyle, XmlComponent);
    function IsLegalNumberingStyle() {
        (0, $gd0sY._)(this, IsLegalNumberingStyle);
        return (0, $8xMIM._)(this, IsLegalNumberingStyle, [
            "w:isLgl"
        ]);
    }
    return IsLegalNumberingStyle;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$91f8da61a0e8158c = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(LevelBase, XmlComponent);
    function LevelBase(param) {
        var level = param.level, format2 = param.format, text = param.text, _param_alignment = param.alignment, alignment = _param_alignment === void 0 ? $94db4f2abf87558b$export$97e681628fc5cdf4.START : _param_alignment, _param_start = param.start, start = _param_start === void 0 ? 1 : _param_start, style = param.style, suffix = param.suffix, isLegalNumberingStyle = param.isLegalNumberingStyle;
        (0, $gd0sY._)(this, LevelBase);
        var _this;
        _this = (0, $8xMIM._)(this, LevelBase, [
            "w:lvl"
        ]);
        $94db4f2abf87558b$var$__publicField(_this, "paragraphProperties");
        $94db4f2abf87558b$var$__publicField(_this, "runProperties");
        _this.root.push(new $94db4f2abf87558b$export$7c6d6f8dacf13e40("w:start", $94db4f2abf87558b$export$3965b376946dc953(start)));
        if (format2) _this.root.push(new $94db4f2abf87558b$var$NumberFormat(format2));
        if (suffix) _this.root.push(new $94db4f2abf87558b$var$Suffix(suffix));
        if (isLegalNumberingStyle) _this.root.push(new $94db4f2abf87558b$var$IsLegalNumberingStyle());
        if (text) _this.root.push(new $94db4f2abf87558b$var$LevelText(text));
        _this.root.push(new $94db4f2abf87558b$var$LevelJc(alignment));
        _this.paragraphProperties = new $94db4f2abf87558b$export$2580ab652a992a27(style && style.paragraph);
        _this.runProperties = new $94db4f2abf87558b$export$5ae5540473946c91(style && style.run);
        _this.root.push(_this.paragraphProperties);
        _this.root.push(_this.runProperties);
        if (level > 9) throw new Error("Level cannot be greater than 9. Read more here: https://answers.microsoft.com/en-us/msoffice/forum/all/does-word-support-more-than-9-list-levels/d130fdcd-1781-446d-8c84-c6c79124e4d7");
        _this.root.push(new $94db4f2abf87558b$var$LevelAttributes({
            ilvl: $94db4f2abf87558b$export$3965b376946dc953(level),
            tentative: 1
        }));
        return _this;
    }
    return LevelBase;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$ca664994d1d54bff = /*#__PURE__*/ function(LevelBase) {
    "use strict";
    (0, $NBk0Y._)(Level, LevelBase);
    function Level() {
        (0, $gd0sY._)(this, Level);
        return (0, $8xMIM._)(this, Level, arguments);
    }
    return Level;
}($94db4f2abf87558b$export$91f8da61a0e8158c);
var $94db4f2abf87558b$export$797f82c452e3a5b7 = /*#__PURE__*/ function(LevelBase) {
    "use strict";
    (0, $NBk0Y._)(LevelForOverride, LevelBase);
    function LevelForOverride() {
        (0, $gd0sY._)(this, LevelForOverride);
        return (0, $8xMIM._)(this, LevelForOverride, arguments);
    }
    return LevelForOverride;
}($94db4f2abf87558b$export$91f8da61a0e8158c);
var $94db4f2abf87558b$var$MultiLevelType = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(MultiLevelType, XmlComponent);
    function MultiLevelType(value) {
        (0, $gd0sY._)(this, MultiLevelType);
        var _this;
        _this = (0, $8xMIM._)(this, MultiLevelType, [
            "w:multiLevelType"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$21991851b0bb231f({
            val: value
        }));
        return _this;
    }
    return MultiLevelType;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$AbstractNumberingAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(AbstractNumberingAttributes, XmlAttributeComponent);
    function AbstractNumberingAttributes() {
        (0, $gd0sY._)(this, AbstractNumberingAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, AbstractNumberingAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            abstractNumId: "w:abstractNumId",
            restartNumberingAfterBreak: "w15:restartNumberingAfterBreak"
        });
        return _this;
    }
    return AbstractNumberingAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$266bd704d5aa6083 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(AbstractNumbering, XmlComponent);
    function AbstractNumbering(id, levelOptions) {
        (0, $gd0sY._)(this, AbstractNumbering);
        var _this;
        _this = (0, $8xMIM._)(this, AbstractNumbering, [
            "w:abstractNum"
        ]);
        $94db4f2abf87558b$var$__publicField(_this, "id");
        _this.root.push(new $94db4f2abf87558b$var$AbstractNumberingAttributes({
            abstractNumId: $94db4f2abf87558b$export$3965b376946dc953(id),
            restartNumberingAfterBreak: 0
        }));
        _this.root.push(new $94db4f2abf87558b$var$MultiLevelType("hybridMultilevel"));
        _this.id = id;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = levelOptions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var option = _step.value;
                _this.root.push(new $94db4f2abf87558b$export$ca664994d1d54bff(option));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _this;
    }
    return AbstractNumbering;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$AbstractNumId = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(AbstractNumId, XmlComponent);
    function AbstractNumId(value) {
        (0, $gd0sY._)(this, AbstractNumId);
        var _this;
        _this = (0, $8xMIM._)(this, AbstractNumId, [
            "w:abstractNumId"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$21991851b0bb231f({
            val: value
        }));
        return _this;
    }
    return AbstractNumId;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$NumAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(NumAttributes, XmlAttributeComponent);
    function NumAttributes() {
        (0, $gd0sY._)(this, NumAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, NumAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            numId: "w:numId"
        });
        return _this;
    }
    return NumAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$706d61b850a8b75b = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(ConcreteNumbering, XmlComponent);
    function ConcreteNumbering(options2) {
        (0, $gd0sY._)(this, ConcreteNumbering);
        var _this;
        _this = (0, $8xMIM._)(this, ConcreteNumbering, [
            "w:num"
        ]);
        $94db4f2abf87558b$var$__publicField(_this, "numId");
        $94db4f2abf87558b$var$__publicField(_this, "reference");
        $94db4f2abf87558b$var$__publicField(_this, "instance");
        _this.numId = options2.numId;
        _this.reference = options2.reference;
        _this.instance = options2.instance;
        _this.root.push(new $94db4f2abf87558b$var$NumAttributes({
            numId: $94db4f2abf87558b$export$3965b376946dc953(options2.numId)
        }));
        _this.root.push(new $94db4f2abf87558b$var$AbstractNumId($94db4f2abf87558b$export$3965b376946dc953(options2.abstractNumId)));
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (options2.overrideLevels && options2.overrideLevels.length) try {
            for(var _iterator = options2.overrideLevels[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var level = _step.value;
                _this.root.push(new $94db4f2abf87558b$export$55dcfb0831b1f416(level.num, level.start));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _this;
    }
    return ConcreteNumbering;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$LevelOverrideAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(LevelOverrideAttributes, XmlAttributeComponent);
    function LevelOverrideAttributes() {
        (0, $gd0sY._)(this, LevelOverrideAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, LevelOverrideAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            ilvl: "w:ilvl"
        });
        return _this;
    }
    return LevelOverrideAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$55dcfb0831b1f416 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(LevelOverride, XmlComponent);
    function LevelOverride(levelNum, start) {
        (0, $gd0sY._)(this, LevelOverride);
        var _this;
        _this = (0, $8xMIM._)(this, LevelOverride, [
            "w:lvlOverride"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$LevelOverrideAttributes({
            ilvl: levelNum
        }));
        if (start !== void 0) _this.root.push(new $94db4f2abf87558b$var$StartOverride(start));
        return _this;
    }
    return LevelOverride;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$StartOverrideAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(StartOverrideAttributes, XmlAttributeComponent);
    function StartOverrideAttributes() {
        (0, $gd0sY._)(this, StartOverrideAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, StartOverrideAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            val: "w:val"
        });
        return _this;
    }
    return StartOverrideAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$StartOverride = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(StartOverride, XmlComponent);
    function StartOverride(start) {
        (0, $gd0sY._)(this, StartOverride);
        var _this;
        _this = (0, $8xMIM._)(this, StartOverride, [
            "w:startOverride"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$StartOverrideAttributes({
            val: start
        }));
        return _this;
    }
    return StartOverride;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$521a466b2293b1d9 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Numbering, XmlComponent);
    function Numbering(options2) {
        (0, $gd0sY._)(this, Numbering);
        var _this;
        _this = (0, $8xMIM._)(this, Numbering, [
            "w:numbering"
        ]);
        $94db4f2abf87558b$var$__publicField(_this, "abstractNumberingMap", /* @__PURE__ */ new Map());
        $94db4f2abf87558b$var$__publicField(_this, "concreteNumberingMap", /* @__PURE__ */ new Map());
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        $94db4f2abf87558b$var$__publicField(_this, "referenceConfigMap", /* @__PURE__ */ new Map());
        $94db4f2abf87558b$var$__publicField(_this, "abstractNumUniqueNumericId", $94db4f2abf87558b$export$704353bc8da186a0());
        $94db4f2abf87558b$var$__publicField(_this, "concreteNumUniqueNumericId", $94db4f2abf87558b$export$efd792105b1568d0());
        _this.root.push(new $94db4f2abf87558b$export$e2bedb2588efb3f4({
            wpc: "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
            mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",
            o: "urn:schemas-microsoft-com:office:office",
            r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
            m: "http://schemas.openxmlformats.org/officeDocument/2006/math",
            v: "urn:schemas-microsoft-com:vml",
            wp14: "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
            wp: "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
            w10: "urn:schemas-microsoft-com:office:word",
            w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
            w14: "http://schemas.microsoft.com/office/word/2010/wordml",
            w15: "http://schemas.microsoft.com/office/word/2012/wordml",
            wpg: "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
            wpi: "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
            wne: "http://schemas.microsoft.com/office/word/2006/wordml",
            wps: "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",
            Ignorable: "w14 w15 wp14"
        }));
        var abstractNumbering = new $94db4f2abf87558b$export$266bd704d5aa6083(_this.abstractNumUniqueNumericId(), [
            {
                level: 0,
                format: $94db4f2abf87558b$export$c17662f376a36ef9.BULLET,
                text: "\u25CF",
                alignment: $94db4f2abf87558b$export$97e681628fc5cdf4.LEFT,
                style: {
                    paragraph: {
                        indent: {
                            left: $94db4f2abf87558b$export$4db9ad0f69d17611(0.5),
                            hanging: $94db4f2abf87558b$export$4db9ad0f69d17611(0.25)
                        }
                    }
                }
            },
            {
                level: 1,
                format: $94db4f2abf87558b$export$c17662f376a36ef9.BULLET,
                text: "\u25CB",
                alignment: $94db4f2abf87558b$export$97e681628fc5cdf4.LEFT,
                style: {
                    paragraph: {
                        indent: {
                            left: $94db4f2abf87558b$export$4db9ad0f69d17611(1),
                            hanging: $94db4f2abf87558b$export$4db9ad0f69d17611(0.25)
                        }
                    }
                }
            },
            {
                level: 2,
                format: $94db4f2abf87558b$export$c17662f376a36ef9.BULLET,
                text: "\u25A0",
                alignment: $94db4f2abf87558b$export$97e681628fc5cdf4.LEFT,
                style: {
                    paragraph: {
                        indent: {
                            left: 2160,
                            hanging: $94db4f2abf87558b$export$4db9ad0f69d17611(0.25)
                        }
                    }
                }
            },
            {
                level: 3,
                format: $94db4f2abf87558b$export$c17662f376a36ef9.BULLET,
                text: "\u25CF",
                alignment: $94db4f2abf87558b$export$97e681628fc5cdf4.LEFT,
                style: {
                    paragraph: {
                        indent: {
                            left: 2880,
                            hanging: $94db4f2abf87558b$export$4db9ad0f69d17611(0.25)
                        }
                    }
                }
            },
            {
                level: 4,
                format: $94db4f2abf87558b$export$c17662f376a36ef9.BULLET,
                text: "\u25CB",
                alignment: $94db4f2abf87558b$export$97e681628fc5cdf4.LEFT,
                style: {
                    paragraph: {
                        indent: {
                            left: 3600,
                            hanging: $94db4f2abf87558b$export$4db9ad0f69d17611(0.25)
                        }
                    }
                }
            },
            {
                level: 5,
                format: $94db4f2abf87558b$export$c17662f376a36ef9.BULLET,
                text: "\u25A0",
                alignment: $94db4f2abf87558b$export$97e681628fc5cdf4.LEFT,
                style: {
                    paragraph: {
                        indent: {
                            left: 4320,
                            hanging: $94db4f2abf87558b$export$4db9ad0f69d17611(0.25)
                        }
                    }
                }
            },
            {
                level: 6,
                format: $94db4f2abf87558b$export$c17662f376a36ef9.BULLET,
                text: "\u25CF",
                alignment: $94db4f2abf87558b$export$97e681628fc5cdf4.LEFT,
                style: {
                    paragraph: {
                        indent: {
                            left: 5040,
                            hanging: $94db4f2abf87558b$export$4db9ad0f69d17611(0.25)
                        }
                    }
                }
            },
            {
                level: 7,
                format: $94db4f2abf87558b$export$c17662f376a36ef9.BULLET,
                text: "\u25CF",
                alignment: $94db4f2abf87558b$export$97e681628fc5cdf4.LEFT,
                style: {
                    paragraph: {
                        indent: {
                            left: 5760,
                            hanging: $94db4f2abf87558b$export$4db9ad0f69d17611(0.25)
                        }
                    }
                }
            },
            {
                level: 8,
                format: $94db4f2abf87558b$export$c17662f376a36ef9.BULLET,
                text: "\u25CF",
                alignment: $94db4f2abf87558b$export$97e681628fc5cdf4.LEFT,
                style: {
                    paragraph: {
                        indent: {
                            left: 6480,
                            hanging: $94db4f2abf87558b$export$4db9ad0f69d17611(0.25)
                        }
                    }
                }
            }
        ]);
        _this.concreteNumberingMap.set("default-bullet-numbering", new $94db4f2abf87558b$export$706d61b850a8b75b({
            numId: 1,
            abstractNumId: abstractNumbering.id,
            reference: "default-bullet-numbering",
            instance: 0,
            overrideLevels: [
                {
                    num: 0,
                    start: 1
                }
            ]
        }));
        _this.abstractNumberingMap.set("default-bullet-numbering", abstractNumbering);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = options2.config[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var con = _step.value;
                _this.abstractNumberingMap.set(con.reference, new $94db4f2abf87558b$export$266bd704d5aa6083(_this.abstractNumUniqueNumericId(), con.levels));
                _this.referenceConfigMap.set(con.reference, con.levels);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _this;
    }
    (0, $7cSld._)(Numbering, [
        {
            key: "prepForXml",
            value: function prepForXml(context) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.abstractNumberingMap.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var numbering = _step.value;
                        this.root.push(numbering);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = this.concreteNumberingMap.values()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var numbering1 = _step1.value;
                        this.root.push(numbering1);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return (0, $bl6Nv._)((0, $7GsX9._)(Numbering.prototype), "prepForXml", this).call(this, context);
            }
        },
        {
            key: "createConcreteNumberingInstance",
            value: function createConcreteNumberingInstance(reference, instance) {
                var abstractNumbering = this.abstractNumberingMap.get(reference);
                if (!abstractNumbering) return;
                var fullReference = "".concat(reference, "-").concat(instance);
                if (this.concreteNumberingMap.has(fullReference)) return;
                var referenceConfigLevels = this.referenceConfigMap.get(reference);
                var firstLevelStartNumber = referenceConfigLevels && referenceConfigLevels[0].start;
                var concreteNumberingSettings = {
                    numId: this.concreteNumUniqueNumericId(),
                    abstractNumId: abstractNumbering.id,
                    reference: reference,
                    instance: instance,
                    overrideLevels: [
                        firstLevelStartNumber && Number.isInteger(firstLevelStartNumber) ? {
                            num: 0,
                            start: firstLevelStartNumber
                        } : {
                            num: 0,
                            start: 1
                        }
                    ]
                };
                this.concreteNumberingMap.set(fullReference, new $94db4f2abf87558b$export$706d61b850a8b75b(concreteNumberingSettings));
            }
        },
        {
            key: "ConcreteNumbering",
            get: function get() {
                return Array.from(this.concreteNumberingMap.values());
            }
        },
        {
            key: "ReferenceConfig",
            get: // eslint-disable-next-line @typescript-eslint/no-explicit-any
            function get() {
                return Array.from(this.referenceConfigMap.values());
            }
        }
    ]);
    return Numbering;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$CompatibilitySettingAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(CompatibilitySettingAttributes, XmlAttributeComponent);
    function CompatibilitySettingAttributes() {
        (0, $gd0sY._)(this, CompatibilitySettingAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, CompatibilitySettingAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            version: "w:val",
            name: "w:name",
            uri: "w:uri"
        });
        return _this;
    }
    return CompatibilitySettingAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$CompatibilitySetting = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(CompatibilitySetting, XmlComponent);
    function CompatibilitySetting(version) {
        (0, $gd0sY._)(this, CompatibilitySetting);
        var _this;
        _this = (0, $8xMIM._)(this, CompatibilitySetting, [
            "w:compatSetting"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$CompatibilitySettingAttributes({
            version: version,
            uri: "http://schemas.microsoft.com/office/word",
            name: "compatibilityMode"
        }));
        return _this;
    }
    return CompatibilitySetting;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$Compatibility = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Compatibility, XmlComponent);
    function Compatibility(options2) {
        (0, $gd0sY._)(this, Compatibility);
        var _this;
        _this = (0, $8xMIM._)(this, Compatibility, [
            "w:compat"
        ]);
        if (options2.version) _this.root.push(new $94db4f2abf87558b$var$CompatibilitySetting(options2.version));
        if (options2.useSingleBorderforContiguousCells) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:useSingleBorderforContiguousCells", options2.useSingleBorderforContiguousCells));
        if (options2.wordPerfectJustification) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:wpJustification", options2.wordPerfectJustification));
        if (options2.noTabStopForHangingIndent) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:noTabHangInd", options2.noTabStopForHangingIndent));
        if (options2.noLeading) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:noLeading", options2.noLeading));
        if (options2.spaceForUnderline) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:spaceForUL", options2.spaceForUnderline));
        if (options2.noColumnBalance) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:noColumnBalance", options2.noColumnBalance));
        if (options2.balanceSingleByteDoubleByteWidth) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:balanceSingleByteDoubleByteWidth", options2.balanceSingleByteDoubleByteWidth));
        if (options2.noExtraLineSpacing) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:noExtraLineSpacing", options2.noExtraLineSpacing));
        if (options2.doNotLeaveBackslashAlone) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:doNotLeaveBackslashAlone", options2.doNotLeaveBackslashAlone));
        if (options2.underlineTrailingSpaces) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:ulTrailSpace", options2.underlineTrailingSpaces));
        if (options2.doNotExpandShiftReturn) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:doNotExpandShiftReturn", options2.doNotExpandShiftReturn));
        if (options2.spacingInWholePoints) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:spacingInWholePoints", options2.spacingInWholePoints));
        if (options2.lineWrapLikeWord6) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:lineWrapLikeWord6", options2.lineWrapLikeWord6));
        if (options2.printBodyTextBeforeHeader) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:printBodyTextBeforeHeader", options2.printBodyTextBeforeHeader));
        if (options2.printColorsBlack) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:printColBlack", options2.printColorsBlack));
        if (options2.spaceWidth) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:wpSpaceWidth", options2.spaceWidth));
        if (options2.showBreaksInFrames) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:showBreaksInFrames", options2.showBreaksInFrames));
        if (options2.subFontBySize) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:subFontBySize", options2.subFontBySize));
        if (options2.suppressBottomSpacing) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:suppressBottomSpacing", options2.suppressBottomSpacing));
        if (options2.suppressTopSpacing) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:suppressTopSpacing", options2.suppressTopSpacing));
        if (options2.suppressSpacingAtTopOfPage) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:suppressSpacingAtTopOfPage", options2.suppressSpacingAtTopOfPage));
        if (options2.suppressTopSpacingWP) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:suppressTopSpacingWP", options2.suppressTopSpacingWP));
        if (options2.suppressSpBfAfterPgBrk) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:suppressSpBfAfterPgBrk", options2.suppressSpBfAfterPgBrk));
        if (options2.swapBordersFacingPages) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:swapBordersFacingPages", options2.swapBordersFacingPages));
        if (options2.convertMailMergeEsc) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:convMailMergeEsc", options2.convertMailMergeEsc));
        if (options2.truncateFontHeightsLikeWP6) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:truncateFontHeightsLikeWP6", options2.truncateFontHeightsLikeWP6));
        if (options2.macWordSmallCaps) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:mwSmallCaps", options2.macWordSmallCaps));
        if (options2.usePrinterMetrics) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:usePrinterMetrics", options2.usePrinterMetrics));
        if (options2.doNotSuppressParagraphBorders) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:doNotSuppressParagraphBorders", options2.doNotSuppressParagraphBorders));
        if (options2.wrapTrailSpaces) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:wrapTrailSpaces", options2.wrapTrailSpaces));
        if (options2.footnoteLayoutLikeWW8) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:footnoteLayoutLikeWW8", options2.footnoteLayoutLikeWW8));
        if (options2.shapeLayoutLikeWW8) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:shapeLayoutLikeWW8", options2.shapeLayoutLikeWW8));
        if (options2.alignTablesRowByRow) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:alignTablesRowByRow", options2.alignTablesRowByRow));
        if (options2.forgetLastTabAlignment) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:forgetLastTabAlignment", options2.forgetLastTabAlignment));
        if (options2.adjustLineHeightInTable) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:adjustLineHeightInTable", options2.adjustLineHeightInTable));
        if (options2.autoSpaceLikeWord95) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:autoSpaceLikeWord95", options2.autoSpaceLikeWord95));
        if (options2.noSpaceRaiseLower) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:noSpaceRaiseLower", options2.noSpaceRaiseLower));
        if (options2.doNotUseHTMLParagraphAutoSpacing) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:doNotUseHTMLParagraphAutoSpacing", options2.doNotUseHTMLParagraphAutoSpacing));
        if (options2.layoutRawTableWidth) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:layoutRawTableWidth", options2.layoutRawTableWidth));
        if (options2.layoutTableRowsApart) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:layoutTableRowsApart", options2.layoutTableRowsApart));
        if (options2.useWord97LineBreakRules) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:useWord97LineBreakRules", options2.useWord97LineBreakRules));
        if (options2.doNotBreakWrappedTables) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:doNotBreakWrappedTables", options2.doNotBreakWrappedTables));
        if (options2.doNotSnapToGridInCell) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:doNotSnapToGridInCell", options2.doNotSnapToGridInCell));
        if (options2.selectFieldWithFirstOrLastCharacter) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:selectFldWithFirstOrLastChar", options2.selectFieldWithFirstOrLastCharacter));
        if (options2.applyBreakingRules) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:applyBreakingRules", options2.applyBreakingRules));
        if (options2.doNotWrapTextWithPunctuation) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:doNotWrapTextWithPunct", options2.doNotWrapTextWithPunctuation));
        if (options2.doNotUseEastAsianBreakRules) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:doNotUseEastAsianBreakRules", options2.doNotUseEastAsianBreakRules));
        if (options2.useWord2002TableStyleRules) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:useWord2002TableStyleRules", options2.useWord2002TableStyleRules));
        if (options2.growAutofit) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:growAutofit", options2.growAutofit));
        if (options2.useFELayout) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:useFELayout", options2.useFELayout));
        if (options2.useNormalStyleForList) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:useNormalStyleForList", options2.useNormalStyleForList));
        if (options2.doNotUseIndentAsNumberingTabStop) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:doNotUseIndentAsNumberingTabStop", options2.doNotUseIndentAsNumberingTabStop));
        if (options2.useAlternateEastAsianLineBreakRules) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:useAltKinsokuLineBreakRules", options2.useAlternateEastAsianLineBreakRules));
        if (options2.allowSpaceOfSameStyleInTable) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:allowSpaceOfSameStyleInTable", options2.allowSpaceOfSameStyleInTable));
        if (options2.doNotSuppressIndentation) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:doNotSuppressIndentation", options2.doNotSuppressIndentation));
        if (options2.doNotAutofitConstrainedTables) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:doNotAutofitConstrainedTables", options2.doNotAutofitConstrainedTables));
        if (options2.autofitToFirstFixedWidthCell) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:autofitToFirstFixedWidthCell", options2.autofitToFirstFixedWidthCell));
        if (options2.underlineTabInNumberingList) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:underlineTabInNumList", options2.underlineTabInNumberingList));
        if (options2.displayHangulFixedWidth) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:displayHangulFixedWidth", options2.displayHangulFixedWidth));
        if (options2.splitPgBreakAndParaMark) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:splitPgBreakAndParaMark", options2.splitPgBreakAndParaMark));
        if (options2.doNotVerticallyAlignCellWithSp) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:doNotVertAlignCellWithSp", options2.doNotVerticallyAlignCellWithSp));
        if (options2.doNotBreakConstrainedForcedTable) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:doNotBreakConstrainedForcedTable", options2.doNotBreakConstrainedForcedTable));
        if (options2.ignoreVerticalAlignmentInTextboxes) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:doNotVertAlignInTxbx", options2.ignoreVerticalAlignmentInTextboxes));
        if (options2.useAnsiKerningPairs) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:useAnsiKerningPairs", options2.useAnsiKerningPairs));
        if (options2.cachedColumnBalance) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:cachedColBalance", options2.cachedColumnBalance));
        return _this;
    }
    return Compatibility;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$SettingsAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(SettingsAttributes, XmlAttributeComponent);
    function SettingsAttributes() {
        (0, $gd0sY._)(this, SettingsAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, SettingsAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            wpc: "xmlns:wpc",
            mc: "xmlns:mc",
            o: "xmlns:o",
            r: "xmlns:r",
            m: "xmlns:m",
            v: "xmlns:v",
            wp14: "xmlns:wp14",
            wp: "xmlns:wp",
            w10: "xmlns:w10",
            w: "xmlns:w",
            w14: "xmlns:w14",
            w15: "xmlns:w15",
            wpg: "xmlns:wpg",
            wpi: "xmlns:wpi",
            wne: "xmlns:wne",
            wps: "xmlns:wps",
            Ignorable: "mc:Ignorable"
        });
        return _this;
    }
    return SettingsAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$Settings = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Settings, XmlComponent);
    function Settings(options2) {
        (0, $gd0sY._)(this, Settings);
        var _this;
        var _a, _b, _c, _d;
        _this = (0, $8xMIM._)(this, Settings, [
            "w:settings"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$SettingsAttributes({
            wpc: "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
            mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",
            o: "urn:schemas-microsoft-com:office:office",
            r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
            m: "http://schemas.openxmlformats.org/officeDocument/2006/math",
            v: "urn:schemas-microsoft-com:vml",
            wp14: "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
            wp: "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
            w10: "urn:schemas-microsoft-com:office:word",
            w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
            w14: "http://schemas.microsoft.com/office/word/2010/wordml",
            w15: "http://schemas.microsoft.com/office/word/2012/wordml",
            wpg: "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
            wpi: "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
            wne: "http://schemas.microsoft.com/office/word/2006/wordml",
            wps: "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",
            Ignorable: "w14 w15 wp14"
        }));
        _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:displayBackgroundShape", true));
        if (options2.trackRevisions !== void 0) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:trackRevisions", options2.trackRevisions));
        if (options2.evenAndOddHeaders !== void 0) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:evenAndOddHeaders", options2.evenAndOddHeaders));
        if (options2.updateFields !== void 0) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:updateFields", options2.updateFields));
        if (options2.defaultTabStop !== void 0) _this.root.push(new $94db4f2abf87558b$export$7c6d6f8dacf13e40("w:defaultTabStop", options2.defaultTabStop));
        _this.root.push(new $94db4f2abf87558b$var$Compatibility($94db4f2abf87558b$var$__spreadProps($94db4f2abf87558b$var$__spreadValues({}, (_a = options2.compatibility) != null ? _a : {}), {
            version: (_d = (_c = (_b = options2.compatibility) == null ? void 0 : _b.version) != null ? _c : options2.compatibilityModeVersion) != null ? _d : 15
        })));
        return _this;
    }
    return Settings;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$ComponentAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(ComponentAttributes, XmlAttributeComponent);
    function ComponentAttributes() {
        (0, $gd0sY._)(this, ComponentAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, ComponentAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            val: "w:val"
        });
        return _this;
    }
    return ComponentAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$Name = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Name, XmlComponent);
    function Name(value) {
        (0, $gd0sY._)(this, Name);
        var _this;
        _this = (0, $8xMIM._)(this, Name, [
            "w:name"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$ComponentAttributes({
            val: value
        }));
        return _this;
    }
    return Name;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$UiPriority = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(UiPriority, XmlComponent);
    function UiPriority(value) {
        (0, $gd0sY._)(this, UiPriority);
        var _this;
        _this = (0, $8xMIM._)(this, UiPriority, [
            "w:uiPriority"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$ComponentAttributes({
            val: $94db4f2abf87558b$export$3965b376946dc953(value)
        }));
        return _this;
    }
    return UiPriority;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$StyleAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(StyleAttributes, XmlAttributeComponent);
    function StyleAttributes() {
        (0, $gd0sY._)(this, StyleAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, StyleAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            type: "w:type",
            styleId: "w:styleId",
            default: "w:default",
            customStyle: "w:customStyle"
        });
        return _this;
    }
    return StyleAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$var$Style2 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Style2, XmlComponent);
    function Style2(attributes, options2) {
        (0, $gd0sY._)(this, Style2);
        var _this;
        _this = (0, $8xMIM._)(this, Style2, [
            "w:style"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$StyleAttributes(attributes));
        if (options2.name) _this.root.push(new $94db4f2abf87558b$var$Name(options2.name));
        if (options2.basedOn) _this.root.push(new $94db4f2abf87558b$export$eacbde36aa74068("w:basedOn", options2.basedOn));
        if (options2.next) _this.root.push(new $94db4f2abf87558b$export$eacbde36aa74068("w:next", options2.next));
        if (options2.link) _this.root.push(new $94db4f2abf87558b$export$eacbde36aa74068("w:link", options2.link));
        if (options2.uiPriority !== void 0) _this.root.push(new $94db4f2abf87558b$var$UiPriority(options2.uiPriority));
        if (options2.semiHidden !== void 0) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:semiHidden", options2.semiHidden));
        if (options2.unhideWhenUsed !== void 0) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:unhideWhenUsed", options2.unhideWhenUsed));
        if (options2.quickFormat !== void 0) _this.root.push(new $94db4f2abf87558b$export$9ea807bff926c949("w:qFormat", options2.quickFormat));
        return _this;
    }
    return Style2;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$6adfeaa1778d50f4 = /*#__PURE__*/ function(Style2) {
    "use strict";
    (0, $NBk0Y._)(StyleForParagraph, Style2);
    function StyleForParagraph(options2) {
        (0, $gd0sY._)(this, StyleForParagraph);
        var _this;
        _this = (0, $8xMIM._)(this, StyleForParagraph, [
            {
                type: "paragraph",
                styleId: options2.id
            },
            options2
        ]);
        $94db4f2abf87558b$var$__publicField(_this, "paragraphProperties");
        $94db4f2abf87558b$var$__publicField(_this, "runProperties");
        _this.paragraphProperties = new $94db4f2abf87558b$export$2580ab652a992a27(options2.paragraph);
        _this.runProperties = new $94db4f2abf87558b$export$5ae5540473946c91(options2.run);
        _this.root.push(_this.paragraphProperties);
        _this.root.push(_this.runProperties);
        return _this;
    }
    return StyleForParagraph;
}($94db4f2abf87558b$var$Style2);
var $94db4f2abf87558b$export$b30019f2711c7199 = /*#__PURE__*/ function(Style2) {
    "use strict";
    (0, $NBk0Y._)(StyleForCharacter, Style2);
    function StyleForCharacter(options2) {
        (0, $gd0sY._)(this, StyleForCharacter);
        var _this;
        _this = (0, $8xMIM._)(this, StyleForCharacter, [
            {
                type: "character",
                styleId: options2.id
            },
            $94db4f2abf87558b$var$__spreadValues({
                uiPriority: 99,
                unhideWhenUsed: true
            }, options2)
        ]);
        $94db4f2abf87558b$var$__publicField(_this, "runProperties");
        _this.runProperties = new $94db4f2abf87558b$export$5ae5540473946c91(options2.run);
        _this.root.push(_this.runProperties);
        return _this;
    }
    return StyleForCharacter;
}($94db4f2abf87558b$var$Style2);
var $94db4f2abf87558b$var$HeadingStyle = /*#__PURE__*/ function(StyleForParagraph) {
    "use strict";
    (0, $NBk0Y._)(HeadingStyle, StyleForParagraph);
    function HeadingStyle(options2) {
        (0, $gd0sY._)(this, HeadingStyle);
        return (0, $8xMIM._)(this, HeadingStyle, [
            $94db4f2abf87558b$var$__spreadValues({
                basedOn: "Normal",
                next: "Normal",
                quickFormat: true
            }, options2)
        ]);
    }
    return HeadingStyle;
}($94db4f2abf87558b$export$6adfeaa1778d50f4);
var $94db4f2abf87558b$var$TitleStyle = /*#__PURE__*/ function(HeadingStyle) {
    "use strict";
    (0, $NBk0Y._)(TitleStyle, HeadingStyle);
    function TitleStyle(options2) {
        (0, $gd0sY._)(this, TitleStyle);
        return (0, $8xMIM._)(this, TitleStyle, [
            $94db4f2abf87558b$var$__spreadValues({
                id: "Title",
                name: "Title"
            }, options2)
        ]);
    }
    return TitleStyle;
}($94db4f2abf87558b$var$HeadingStyle);
var $94db4f2abf87558b$var$Heading1Style = /*#__PURE__*/ function(HeadingStyle) {
    "use strict";
    (0, $NBk0Y._)(Heading1Style, HeadingStyle);
    function Heading1Style(options2) {
        (0, $gd0sY._)(this, Heading1Style);
        return (0, $8xMIM._)(this, Heading1Style, [
            $94db4f2abf87558b$var$__spreadValues({
                id: "Heading1",
                name: "Heading 1"
            }, options2)
        ]);
    }
    return Heading1Style;
}($94db4f2abf87558b$var$HeadingStyle);
var $94db4f2abf87558b$var$Heading2Style = /*#__PURE__*/ function(HeadingStyle) {
    "use strict";
    (0, $NBk0Y._)(Heading2Style, HeadingStyle);
    function Heading2Style(options2) {
        (0, $gd0sY._)(this, Heading2Style);
        return (0, $8xMIM._)(this, Heading2Style, [
            $94db4f2abf87558b$var$__spreadValues({
                id: "Heading2",
                name: "Heading 2"
            }, options2)
        ]);
    }
    return Heading2Style;
}($94db4f2abf87558b$var$HeadingStyle);
var $94db4f2abf87558b$var$Heading3Style = /*#__PURE__*/ function(HeadingStyle) {
    "use strict";
    (0, $NBk0Y._)(Heading3Style, HeadingStyle);
    function Heading3Style(options2) {
        (0, $gd0sY._)(this, Heading3Style);
        return (0, $8xMIM._)(this, Heading3Style, [
            $94db4f2abf87558b$var$__spreadValues({
                id: "Heading3",
                name: "Heading 3"
            }, options2)
        ]);
    }
    return Heading3Style;
}($94db4f2abf87558b$var$HeadingStyle);
var $94db4f2abf87558b$var$Heading4Style = /*#__PURE__*/ function(HeadingStyle) {
    "use strict";
    (0, $NBk0Y._)(Heading4Style, HeadingStyle);
    function Heading4Style(options2) {
        (0, $gd0sY._)(this, Heading4Style);
        return (0, $8xMIM._)(this, Heading4Style, [
            $94db4f2abf87558b$var$__spreadValues({
                id: "Heading4",
                name: "Heading 4"
            }, options2)
        ]);
    }
    return Heading4Style;
}($94db4f2abf87558b$var$HeadingStyle);
var $94db4f2abf87558b$var$Heading5Style = /*#__PURE__*/ function(HeadingStyle) {
    "use strict";
    (0, $NBk0Y._)(Heading5Style, HeadingStyle);
    function Heading5Style(options2) {
        (0, $gd0sY._)(this, Heading5Style);
        return (0, $8xMIM._)(this, Heading5Style, [
            $94db4f2abf87558b$var$__spreadValues({
                id: "Heading5",
                name: "Heading 5"
            }, options2)
        ]);
    }
    return Heading5Style;
}($94db4f2abf87558b$var$HeadingStyle);
var $94db4f2abf87558b$var$Heading6Style = /*#__PURE__*/ function(HeadingStyle) {
    "use strict";
    (0, $NBk0Y._)(Heading6Style, HeadingStyle);
    function Heading6Style(options2) {
        (0, $gd0sY._)(this, Heading6Style);
        return (0, $8xMIM._)(this, Heading6Style, [
            $94db4f2abf87558b$var$__spreadValues({
                id: "Heading6",
                name: "Heading 6"
            }, options2)
        ]);
    }
    return Heading6Style;
}($94db4f2abf87558b$var$HeadingStyle);
var $94db4f2abf87558b$var$StrongStyle = /*#__PURE__*/ function(HeadingStyle) {
    "use strict";
    (0, $NBk0Y._)(StrongStyle, HeadingStyle);
    function StrongStyle(options2) {
        (0, $gd0sY._)(this, StrongStyle);
        return (0, $8xMIM._)(this, StrongStyle, [
            $94db4f2abf87558b$var$__spreadValues({
                id: "Strong",
                name: "Strong"
            }, options2)
        ]);
    }
    return StrongStyle;
}($94db4f2abf87558b$var$HeadingStyle);
var $94db4f2abf87558b$var$ListParagraph = /*#__PURE__*/ function(StyleForParagraph) {
    "use strict";
    (0, $NBk0Y._)(ListParagraph, StyleForParagraph);
    function ListParagraph(options2) {
        (0, $gd0sY._)(this, ListParagraph);
        return (0, $8xMIM._)(this, ListParagraph, [
            $94db4f2abf87558b$var$__spreadValues({
                id: "ListParagraph",
                name: "List Paragraph",
                basedOn: "Normal",
                quickFormat: true
            }, options2)
        ]);
    }
    return ListParagraph;
}($94db4f2abf87558b$export$6adfeaa1778d50f4);
var $94db4f2abf87558b$var$FootnoteText = /*#__PURE__*/ function(StyleForParagraph) {
    "use strict";
    (0, $NBk0Y._)(FootnoteText, StyleForParagraph);
    function FootnoteText(options2) {
        (0, $gd0sY._)(this, FootnoteText);
        return (0, $8xMIM._)(this, FootnoteText, [
            $94db4f2abf87558b$var$__spreadValues({
                id: "FootnoteText",
                name: "footnote text",
                link: "FootnoteTextChar",
                basedOn: "Normal",
                uiPriority: 99,
                semiHidden: true,
                unhideWhenUsed: true,
                paragraph: {
                    spacing: {
                        after: 0,
                        line: 240,
                        lineRule: $94db4f2abf87558b$export$595a14bf61dfe45b.AUTO
                    }
                },
                run: {
                    size: 20
                }
            }, options2)
        ]);
    }
    return FootnoteText;
}($94db4f2abf87558b$export$6adfeaa1778d50f4);
var $94db4f2abf87558b$var$FootnoteReferenceStyle = /*#__PURE__*/ function(StyleForCharacter) {
    "use strict";
    (0, $NBk0Y._)(FootnoteReferenceStyle, StyleForCharacter);
    function FootnoteReferenceStyle(options2) {
        (0, $gd0sY._)(this, FootnoteReferenceStyle);
        return (0, $8xMIM._)(this, FootnoteReferenceStyle, [
            $94db4f2abf87558b$var$__spreadValues({
                id: "FootnoteReference",
                name: "footnote reference",
                basedOn: "DefaultParagraphFont",
                semiHidden: true,
                run: {
                    superScript: true
                }
            }, options2)
        ]);
    }
    return FootnoteReferenceStyle;
}($94db4f2abf87558b$export$b30019f2711c7199);
var $94db4f2abf87558b$var$FootnoteTextChar = /*#__PURE__*/ function(StyleForCharacter) {
    "use strict";
    (0, $NBk0Y._)(FootnoteTextChar, StyleForCharacter);
    function FootnoteTextChar(options2) {
        (0, $gd0sY._)(this, FootnoteTextChar);
        return (0, $8xMIM._)(this, FootnoteTextChar, [
            $94db4f2abf87558b$var$__spreadValues({
                id: "FootnoteTextChar",
                name: "Footnote Text Char",
                basedOn: "DefaultParagraphFont",
                link: "FootnoteText",
                semiHidden: true,
                run: {
                    size: 20
                }
            }, options2)
        ]);
    }
    return FootnoteTextChar;
}($94db4f2abf87558b$export$b30019f2711c7199);
var $94db4f2abf87558b$var$HyperlinkStyle = /*#__PURE__*/ function(StyleForCharacter) {
    "use strict";
    (0, $NBk0Y._)(HyperlinkStyle, StyleForCharacter);
    function HyperlinkStyle(options2) {
        (0, $gd0sY._)(this, HyperlinkStyle);
        return (0, $8xMIM._)(this, HyperlinkStyle, [
            $94db4f2abf87558b$var$__spreadValues({
                id: "Hyperlink",
                name: "Hyperlink",
                basedOn: "DefaultParagraphFont",
                run: {
                    color: "0563C1",
                    underline: {
                        type: $94db4f2abf87558b$export$7d5cc92343d18d1b.SINGLE
                    }
                }
            }, options2)
        ]);
    }
    return HyperlinkStyle;
}($94db4f2abf87558b$export$b30019f2711c7199);
var $94db4f2abf87558b$export$e155666bf54a9f18 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(Styles, XmlComponent);
    function Styles(options2) {
        (0, $gd0sY._)(this, Styles);
        var _this;
        _this = (0, $8xMIM._)(this, Styles, [
            "w:styles"
        ]);
        if (options2.initialStyles) _this.root.push(options2.initialStyles);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (options2.importedStyles) try {
            for(var _iterator = options2.importedStyles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var style = _step.value;
                _this.root.push(style);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        if (options2.paragraphStyles) try {
            for(var _iterator1 = options2.paragraphStyles[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var style1 = _step1.value;
                _this.root.push(new $94db4f2abf87558b$export$6adfeaa1778d50f4(style1));
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
        if (options2.characterStyles) try {
            for(var _iterator2 = options2.characterStyles[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                var style2 = _step2.value;
                _this.root.push(new $94db4f2abf87558b$export$b30019f2711c7199(style2));
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                    _iterator2.return();
                }
            } finally{
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
        return _this;
    }
    return Styles;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$1c732adbaa41477e = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(ParagraphPropertiesDefaults, XmlComponent);
    function ParagraphPropertiesDefaults(options2) {
        (0, $gd0sY._)(this, ParagraphPropertiesDefaults);
        var _this;
        _this = (0, $8xMIM._)(this, ParagraphPropertiesDefaults, [
            "w:pPrDefault"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$2580ab652a992a27(options2));
        return _this;
    }
    return ParagraphPropertiesDefaults;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$8bbc5109c297588f = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(RunPropertiesDefaults, XmlComponent);
    function RunPropertiesDefaults(options2) {
        (0, $gd0sY._)(this, RunPropertiesDefaults);
        var _this;
        _this = (0, $8xMIM._)(this, RunPropertiesDefaults, [
            "w:rPrDefault"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$5ae5540473946c91(options2));
        return _this;
    }
    return RunPropertiesDefaults;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$61bda0fab7780ed1 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(DocumentDefaults, XmlComponent);
    function DocumentDefaults(options2) {
        (0, $gd0sY._)(this, DocumentDefaults);
        var _this;
        _this = (0, $8xMIM._)(this, DocumentDefaults, [
            "w:docDefaults"
        ]);
        $94db4f2abf87558b$var$__publicField(_this, "runPropertiesDefaults");
        $94db4f2abf87558b$var$__publicField(_this, "paragraphPropertiesDefaults");
        _this.runPropertiesDefaults = new $94db4f2abf87558b$export$8bbc5109c297588f(options2.run);
        _this.paragraphPropertiesDefaults = new $94db4f2abf87558b$export$1c732adbaa41477e(options2.paragraph);
        _this.root.push(_this.runPropertiesDefaults);
        _this.root.push(_this.paragraphPropertiesDefaults);
        return _this;
    }
    return DocumentDefaults;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$ExternalStylesFactory = /*#__PURE__*/ function() {
    "use strict";
    function ExternalStylesFactory() {
        (0, $gd0sY._)(this, ExternalStylesFactory);
    }
    (0, $7cSld._)(ExternalStylesFactory, [
        {
            /**
   * Creates new Style based on the given styles.
   * Parses the styles and convert them to XmlComponent.
   * Example content from styles.xml:
   * <?xml version="1.0">
   * <w:styles xmlns:mc="some schema" ...>
   *
   *   <w:style w:type="paragraph" w:styleId="Heading1">
   *           <w:name w:val="heading 1"/>
   *           .....
   *   </w:style>
   *
   *   <w:style w:type="paragraph" w:styleId="Heading2">
   *           <w:name w:val="heading 2"/>
   *           .....
   *   </w:style>
   *
   *   <w:docDefaults>Or any other element will be parsed to</w:docDefaults>
   *
   * </w:styles>
   *
   * @param externalStyles context from styles.xml
   */ key: "newInstance",
            value: function newInstance(xmlData) {
                var xmlObj = $94db4f2abf87558b$var$lib.xml2js(xmlData, {
                    compact: false
                });
                var stylesXmlElement;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (xmlObj.elements || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var xmlElm = _step.value;
                        if (xmlElm.name === "w:styles") stylesXmlElement = xmlElm;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (stylesXmlElement === void 0) throw new Error("can not find styles element");
                var stylesElements = stylesXmlElement.elements || [];
                var importedStyle = new $94db4f2abf87558b$export$e155666bf54a9f18({
                    initialStyles: new $94db4f2abf87558b$export$f3691753fff0e91f(stylesXmlElement.attributes),
                    importedStyles: stylesElements.map(function(childElm) {
                        return $94db4f2abf87558b$export$cd3b8f5143756514(childElm);
                    })
                });
                return importedStyle;
            }
        }
    ]);
    return ExternalStylesFactory;
}();
var $94db4f2abf87558b$var$DefaultStylesFactory = /*#__PURE__*/ function() {
    "use strict";
    function DefaultStylesFactory() {
        (0, $gd0sY._)(this, DefaultStylesFactory);
    }
    (0, $7cSld._)(DefaultStylesFactory, [
        {
            key: "newInstance",
            value: function newInstance() {
                var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _a;
                var documentAttributes = new $94db4f2abf87558b$export$e2bedb2588efb3f4({
                    mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
                    w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
                    w14: "http://schemas.microsoft.com/office/word/2010/wordml",
                    w15: "http://schemas.microsoft.com/office/word/2012/wordml",
                    Ignorable: "w14 w15"
                });
                return {
                    initialStyles: documentAttributes,
                    importedStyles: [
                        new $94db4f2abf87558b$export$61bda0fab7780ed1((_a = options2.document) != null ? _a : {}),
                        new $94db4f2abf87558b$var$TitleStyle($94db4f2abf87558b$var$__spreadValues({
                            run: {
                                size: 56
                            }
                        }, options2.title)),
                        new $94db4f2abf87558b$var$Heading1Style($94db4f2abf87558b$var$__spreadValues({
                            run: {
                                color: "2E74B5",
                                size: 32
                            }
                        }, options2.heading1)),
                        new $94db4f2abf87558b$var$Heading2Style($94db4f2abf87558b$var$__spreadValues({
                            run: {
                                color: "2E74B5",
                                size: 26
                            }
                        }, options2.heading2)),
                        new $94db4f2abf87558b$var$Heading3Style($94db4f2abf87558b$var$__spreadValues({
                            run: {
                                color: "1F4D78",
                                size: 24
                            }
                        }, options2.heading3)),
                        new $94db4f2abf87558b$var$Heading4Style($94db4f2abf87558b$var$__spreadValues({
                            run: {
                                color: "2E74B5",
                                italics: true
                            }
                        }, options2.heading4)),
                        new $94db4f2abf87558b$var$Heading5Style($94db4f2abf87558b$var$__spreadValues({
                            run: {
                                color: "2E74B5"
                            }
                        }, options2.heading5)),
                        new $94db4f2abf87558b$var$Heading6Style($94db4f2abf87558b$var$__spreadValues({
                            run: {
                                color: "1F4D78"
                            }
                        }, options2.heading6)),
                        new $94db4f2abf87558b$var$StrongStyle($94db4f2abf87558b$var$__spreadValues({
                            run: {
                                bold: true
                            }
                        }, options2.strong)),
                        new $94db4f2abf87558b$var$ListParagraph(options2.listParagraph || {}),
                        new $94db4f2abf87558b$var$HyperlinkStyle(options2.hyperlink || {}),
                        new $94db4f2abf87558b$var$FootnoteReferenceStyle(options2.footnoteReference || {}),
                        new $94db4f2abf87558b$var$FootnoteText(options2.footnoteText || {}),
                        new $94db4f2abf87558b$var$FootnoteTextChar(options2.footnoteTextChar || {})
                    ]
                };
            }
        }
    ]);
    return DefaultStylesFactory;
}();
var $94db4f2abf87558b$export$fba22c9d3f66adb = {
    ANSI: "00",
    DEFAULT: "01",
    SYMBOL: "02",
    MAC: "4D",
    JIS: "80",
    HANGUL: "81",
    JOHAB: "82",
    GB_2312: "86",
    CHINESEBIG5: "88",
    GREEK: "A1",
    TURKISH: "A2",
    VIETNAMESE: "A3",
    HEBREW: "B1",
    ARABIC: "B2",
    BALTIC: "BA",
    RUSSIAN: "CC",
    THAI: "DE",
    EASTEUROPE: "EE",
    OEM: "FF"
};
var $94db4f2abf87558b$var$createFontRelationship = function(param, name) {
    var id = param.id, fontKey = param.fontKey, subsetted = param.subsetted;
    return new $94db4f2abf87558b$export$da493cbe1334accc({
        name: name,
        attributes: $94db4f2abf87558b$var$__spreadValues({
            id: {
                key: "r:id",
                value: id
            }
        }, fontKey ? {
            fontKey: {
                key: "w:fontKey",
                value: "{".concat(fontKey, "}")
            }
        } : {}),
        children: (0, $6zk1M._)(subsetted ? [
            new $94db4f2abf87558b$export$9ea807bff926c949("w:subsetted", subsetted)
        ] : [])
    });
};
var $94db4f2abf87558b$var$createFont = function(param) {
    var name = param.name, altName = param.altName, panose1 = param.panose1, charset = param.charset, family = param.family, notTrueType = param.notTrueType, pitch = param.pitch, sig = param.sig, embedRegular = param.embedRegular, embedBold = param.embedBold, embedItalic = param.embedItalic, embedBoldItalic = param.embedBoldItalic;
    return(// http://www.datypic.com/sc/ooxml/e-w_font-1.html
    new $94db4f2abf87558b$export$da493cbe1334accc({
        name: "w:font",
        attributes: {
            name: {
                key: "w:name",
                value: name
            }
        },
        children: // http://www.datypic.com/sc/ooxml/e-w_altName-1.html
        (0, $6zk1M._)(altName ? [
            $94db4f2abf87558b$export$e9d3b59c3f434130("w:altName", altName)
        ] : []).concat(// http://www.datypic.com/sc/ooxml/e-w_panose1-1.html
        (0, $6zk1M._)(panose1 ? [
            $94db4f2abf87558b$export$e9d3b59c3f434130("w:panose1", panose1)
        ] : []), // http://www.datypic.com/sc/ooxml/e-w_charset-1.html
        (0, $6zk1M._)(charset ? [
            $94db4f2abf87558b$export$e9d3b59c3f434130("w:charset", charset)
        ] : []), // http://www.datypic.com/sc/ooxml/e-w_family-1.html
        (0, $6zk1M._)(family ? [
            $94db4f2abf87558b$export$e9d3b59c3f434130("w:family", family)
        ] : []), // http://www.datypic.com/sc/ooxml/e-w_notTrueType-1.html
        (0, $6zk1M._)(notTrueType ? [
            new $94db4f2abf87558b$export$9ea807bff926c949("w:notTrueType", notTrueType)
        ] : []), (0, $6zk1M._)(pitch ? [
            $94db4f2abf87558b$export$e9d3b59c3f434130("w:pitch", pitch)
        ] : []), // http://www.datypic.com/sc/ooxml/e-w_sig-1.html
        (0, $6zk1M._)(sig ? [
            new $94db4f2abf87558b$export$da493cbe1334accc({
                name: "w:sig",
                attributes: {
                    usb0: {
                        key: "w:usb0",
                        value: sig.usb0
                    },
                    usb1: {
                        key: "w:usb1",
                        value: sig.usb1
                    },
                    usb2: {
                        key: "w:usb2",
                        value: sig.usb2
                    },
                    usb3: {
                        key: "w:usb3",
                        value: sig.usb3
                    },
                    csb0: {
                        key: "w:csb0",
                        value: sig.csb0
                    },
                    csb1: {
                        key: "w:csb1",
                        value: sig.csb1
                    }
                }
            })
        ] : []), // http://www.datypic.com/sc/ooxml/e-w_embedRegular-1.html
        (0, $6zk1M._)(embedRegular ? [
            $94db4f2abf87558b$var$createFontRelationship(embedRegular, "w:embedRegular")
        ] : []), // http://www.datypic.com/sc/ooxml/e-w_embedBold-1.html
        (0, $6zk1M._)(embedBold ? [
            $94db4f2abf87558b$var$createFontRelationship(embedBold, "w:embedBold")
        ] : []), // http://www.datypic.com/sc/ooxml/e-w_embedItalic-1.html
        (0, $6zk1M._)(embedItalic ? [
            $94db4f2abf87558b$var$createFontRelationship(embedItalic, "w:embedItalic")
        ] : []), // http://www.datypic.com/sc/ooxml/e-w_embedBoldItalic-1.html
        (0, $6zk1M._)(embedBoldItalic ? [
            $94db4f2abf87558b$var$createFontRelationship(embedBoldItalic, "w:embedBoldItalic")
        ] : []))
    }));
};
var $94db4f2abf87558b$var$createRegularFont = function(param) {
    var name = param.name, index = param.index, fontKey = param.fontKey, characterSet = param.characterSet;
    return $94db4f2abf87558b$var$createFont({
        name: name,
        sig: {
            usb0: "E0002AFF",
            usb1: "C000247B",
            usb2: "00000009",
            usb3: "00000000",
            csb0: "000001FF",
            csb1: "00000000"
        },
        charset: characterSet,
        family: "auto",
        pitch: "variable",
        embedRegular: {
            fontKey: fontKey,
            id: "rId".concat(index)
        }
    });
};
var $94db4f2abf87558b$var$createFontTable = function(fonts) {
    return(// https://c-rex.net/projects/samples/ooxml/e1/Part4/OOXML_P4_DOCX_Font_topic_ID0ERNCU.html
    // http://www.datypic.com/sc/ooxml/e-w_fonts.html
    new $94db4f2abf87558b$export$da493cbe1334accc({
        name: "w:fonts",
        attributes: {
            mc: {
                key: "xmlns:mc",
                value: "http://schemas.openxmlformats.org/markup-compatibility/2006"
            },
            r: {
                key: "xmlns:r",
                value: "http://schemas.openxmlformats.org/officeDocument/2006/relationships"
            },
            w: {
                key: "xmlns:w",
                value: "http://schemas.openxmlformats.org/wordprocessingml/2006/main"
            },
            w14: {
                key: "xmlns:w14",
                value: "http://schemas.microsoft.com/office/word/2010/wordml"
            },
            w15: {
                key: "xmlns:w15",
                value: "http://schemas.microsoft.com/office/word/2012/wordml"
            },
            w16cex: {
                key: "xmlns:w16cex",
                value: "http://schemas.microsoft.com/office/word/2018/wordml/cex"
            },
            w16cid: {
                key: "xmlns:w16cid",
                value: "http://schemas.microsoft.com/office/word/2016/wordml/cid"
            },
            w16: {
                key: "xmlns:w16",
                value: "http://schemas.microsoft.com/office/word/2018/wordml"
            },
            w16sdtdh: {
                key: "xmlns:w16sdtdh",
                value: "http://schemas.microsoft.com/office/word/2020/wordml/sdtdatahash"
            },
            w16se: {
                key: "xmlns:w16se",
                value: "http://schemas.microsoft.com/office/word/2015/wordml/symex"
            },
            Ignorable: {
                key: "mc:Ignorable",
                value: "w14 w15 w16se w16cid w16 w16cex w16sdtdh"
            }
        },
        children: fonts.map(function(font, i) {
            return $94db4f2abf87558b$var$createRegularFont({
                name: font.name,
                index: i + 1,
                fontKey: font.fontKey
            });
        })
    }));
};
var $94db4f2abf87558b$var$FontWrapper = /*#__PURE__*/ function() {
    "use strict";
    function FontWrapper(options2) {
        (0, $gd0sY._)(this, FontWrapper);
        $94db4f2abf87558b$var$__publicField(this, "fontTable");
        $94db4f2abf87558b$var$__publicField(this, "relationships");
        $94db4f2abf87558b$var$__publicField(this, "fontOptionsWithKey", []);
        this.options = options2;
        this.fontOptionsWithKey = options2.map(function(o) {
            return $94db4f2abf87558b$var$__spreadProps($94db4f2abf87558b$var$__spreadValues({}, o), {
                fontKey: $94db4f2abf87558b$export$a261054604391cc()
            });
        });
        this.fontTable = $94db4f2abf87558b$var$createFontTable(this.fontOptionsWithKey);
        this.relationships = new $94db4f2abf87558b$var$Relationships();
        for(var i = 0; i < options2.length; i++)this.relationships.createRelationship(i + 1, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/font", "fonts/".concat(options2[i].name, ".odttf"));
    }
    (0, $7cSld._)(FontWrapper, [
        {
            key: "View",
            get: function get() {
                return this.fontTable;
            }
        },
        {
            key: "Relationships",
            get: function get() {
                return this.relationships;
            }
        }
    ]);
    return FontWrapper;
}();
var $94db4f2abf87558b$export$b34a105447964f9f = /*#__PURE__*/ function() {
    "use strict";
    function File(options2) {
        (0, $gd0sY._)(this, File);
        // eslint-disable-next-line functional/prefer-readonly-type
        $94db4f2abf87558b$var$__publicField(this, "currentRelationshipId", 1);
        $94db4f2abf87558b$var$__publicField(this, "documentWrapper");
        // eslint-disable-next-line functional/prefer-readonly-type
        $94db4f2abf87558b$var$__publicField(this, "headers", []);
        // eslint-disable-next-line functional/prefer-readonly-type
        $94db4f2abf87558b$var$__publicField(this, "footers", []);
        $94db4f2abf87558b$var$__publicField(this, "coreProperties");
        $94db4f2abf87558b$var$__publicField(this, "numbering");
        $94db4f2abf87558b$var$__publicField(this, "media");
        $94db4f2abf87558b$var$__publicField(this, "fileRelationships");
        $94db4f2abf87558b$var$__publicField(this, "footnotesWrapper");
        $94db4f2abf87558b$var$__publicField(this, "settings");
        $94db4f2abf87558b$var$__publicField(this, "contentTypes");
        $94db4f2abf87558b$var$__publicField(this, "customProperties");
        $94db4f2abf87558b$var$__publicField(this, "appProperties");
        $94db4f2abf87558b$var$__publicField(this, "styles");
        $94db4f2abf87558b$var$__publicField(this, "comments");
        $94db4f2abf87558b$var$__publicField(this, "fontWrapper");
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.coreProperties = new $94db4f2abf87558b$var$CoreProperties($94db4f2abf87558b$var$__spreadProps($94db4f2abf87558b$var$__spreadValues({}, options2), {
            creator: (_a = options2.creator) != null ? _a : "Un-named",
            revision: (_b = options2.revision) != null ? _b : 1,
            lastModifiedBy: (_c = options2.lastModifiedBy) != null ? _c : "Un-named"
        }));
        this.numbering = new $94db4f2abf87558b$export$521a466b2293b1d9(options2.numbering ? options2.numbering : {
            config: []
        });
        this.comments = new $94db4f2abf87558b$export$434c217d363ea16((_d = options2.comments) != null ? _d : {
            children: []
        });
        this.fileRelationships = new $94db4f2abf87558b$var$Relationships();
        this.customProperties = new $94db4f2abf87558b$var$CustomProperties((_e = options2.customProperties) != null ? _e : []);
        this.appProperties = new $94db4f2abf87558b$var$AppProperties();
        this.footnotesWrapper = new $94db4f2abf87558b$var$FootnotesWrapper();
        this.contentTypes = new $94db4f2abf87558b$var$ContentTypes();
        this.documentWrapper = new $94db4f2abf87558b$var$DocumentWrapper({
            background: options2.background
        });
        this.settings = new $94db4f2abf87558b$var$Settings({
            compatibilityModeVersion: options2.compatabilityModeVersion,
            compatibility: options2.compatibility,
            evenAndOddHeaders: options2.evenAndOddHeaderAndFooters ? true : false,
            trackRevisions: (_f = options2.features) == null ? void 0 : _f.trackRevisions,
            updateFields: (_g = options2.features) == null ? void 0 : _g.updateFields,
            defaultTabStop: options2.defaultTabStop
        });
        this.media = new $94db4f2abf87558b$export$7fc53215244aec38();
        if (options2.externalStyles) {
            var stylesFactory = new $94db4f2abf87558b$var$ExternalStylesFactory();
            this.styles = stylesFactory.newInstance(options2.externalStyles);
        } else if (options2.styles) {
            var stylesFactory1 = new $94db4f2abf87558b$var$DefaultStylesFactory();
            var defaultStyles = stylesFactory1.newInstance(options2.styles.default);
            this.styles = new $94db4f2abf87558b$export$e155666bf54a9f18($94db4f2abf87558b$var$__spreadValues($94db4f2abf87558b$var$__spreadValues({}, defaultStyles), options2.styles));
        } else {
            var stylesFactory2 = new $94db4f2abf87558b$var$DefaultStylesFactory();
            this.styles = new $94db4f2abf87558b$export$e155666bf54a9f18(stylesFactory2.newInstance());
        }
        this.addDefaultRelationships();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = options2.sections[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var section = _step.value;
                this.addSection(section);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (options2.footnotes) for(var key in options2.footnotes)this.footnotesWrapper.View.createFootNote(parseFloat(key), options2.footnotes[key].children);
        this.fontWrapper = new $94db4f2abf87558b$var$FontWrapper((_h = options2.fonts) != null ? _h : []);
    }
    (0, $7cSld._)(File, [
        {
            key: "addSection",
            value: function addSection(param) {
                var _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, _param_footers = param.footers, footers = _param_footers === void 0 ? {} : _param_footers, children = param.children, properties = param.properties;
                this.documentWrapper.View.Body.addSection($94db4f2abf87558b$var$__spreadProps($94db4f2abf87558b$var$__spreadValues({}, properties), {
                    headerWrapperGroup: {
                        default: headers.default ? this.createHeader(headers.default) : void 0,
                        first: headers.first ? this.createHeader(headers.first) : void 0,
                        even: headers.even ? this.createHeader(headers.even) : void 0
                    },
                    footerWrapperGroup: {
                        default: footers.default ? this.createFooter(footers.default) : void 0,
                        first: footers.first ? this.createFooter(footers.first) : void 0,
                        even: footers.even ? this.createFooter(footers.even) : void 0
                    }
                }));
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var child = _step.value;
                        this.documentWrapper.View.add(child);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "createHeader",
            value: function createHeader(header) {
                var wrapper = new $94db4f2abf87558b$export$960a49cc3d27a090(this.media, this.currentRelationshipId++);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = header.options.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var child = _step.value;
                        wrapper.add(child);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.addHeaderToDocument(wrapper);
                return wrapper;
            }
        },
        {
            key: "createFooter",
            value: function createFooter(footer) {
                var wrapper = new $94db4f2abf87558b$export$fd9000017733fabf(this.media, this.currentRelationshipId++);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = footer.options.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var child = _step.value;
                        wrapper.add(child);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.addFooterToDocument(wrapper);
                return wrapper;
            }
        },
        {
            key: "addHeaderToDocument",
            value: function addHeaderToDocument(header) {
                var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $94db4f2abf87558b$export$df165515f58460ef.DEFAULT;
                this.headers.push({
                    header: header,
                    type: type
                });
                this.documentWrapper.Relationships.createRelationship(header.View.ReferenceId, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/header", "header".concat(this.headers.length, ".xml"));
                this.contentTypes.addHeader(this.headers.length);
            }
        },
        {
            key: "addFooterToDocument",
            value: function addFooterToDocument(footer) {
                var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $94db4f2abf87558b$export$df165515f58460ef.DEFAULT;
                this.footers.push({
                    footer: footer,
                    type: type
                });
                this.documentWrapper.Relationships.createRelationship(footer.View.ReferenceId, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/footer", "footer".concat(this.footers.length, ".xml"));
                this.contentTypes.addFooter(this.footers.length);
            }
        },
        {
            key: "addDefaultRelationships",
            value: function addDefaultRelationships() {
                this.fileRelationships.createRelationship(1, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument", "word/document.xml");
                this.fileRelationships.createRelationship(2, "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties", "docProps/core.xml");
                this.fileRelationships.createRelationship(3, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties", "docProps/app.xml");
                this.fileRelationships.createRelationship(4, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties", "docProps/custom.xml");
                this.documentWrapper.Relationships.createRelationship(// eslint-disable-next-line functional/immutable-data
                this.currentRelationshipId++, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles", "styles.xml");
                this.documentWrapper.Relationships.createRelationship(// eslint-disable-next-line functional/immutable-data
                this.currentRelationshipId++, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/numbering", "numbering.xml");
                this.documentWrapper.Relationships.createRelationship(// eslint-disable-next-line functional/immutable-data
                this.currentRelationshipId++, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/footnotes", "footnotes.xml");
                this.documentWrapper.Relationships.createRelationship(// eslint-disable-next-line functional/immutable-data
                this.currentRelationshipId++, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/settings", "settings.xml");
                this.documentWrapper.Relationships.createRelationship(// eslint-disable-next-line functional/immutable-data
                this.currentRelationshipId++, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments", "comments.xml");
            }
        },
        {
            key: "Document",
            get: function get() {
                return this.documentWrapper;
            }
        },
        {
            key: "Styles",
            get: function get() {
                return this.styles;
            }
        },
        {
            key: "CoreProperties",
            get: function get() {
                return this.coreProperties;
            }
        },
        {
            key: "Numbering",
            get: function get() {
                return this.numbering;
            }
        },
        {
            key: "Media",
            get: function get() {
                return this.media;
            }
        },
        {
            key: "FileRelationships",
            get: function get() {
                return this.fileRelationships;
            }
        },
        {
            key: "Headers",
            get: function get() {
                return this.headers.map(function(item) {
                    return item.header;
                });
            }
        },
        {
            key: "Footers",
            get: function get() {
                return this.footers.map(function(item) {
                    return item.footer;
                });
            }
        },
        {
            key: "ContentTypes",
            get: function get() {
                return this.contentTypes;
            }
        },
        {
            key: "CustomProperties",
            get: function get() {
                return this.customProperties;
            }
        },
        {
            key: "AppProperties",
            get: function get() {
                return this.appProperties;
            }
        },
        {
            key: "FootNotes",
            get: function get() {
                return this.footnotesWrapper;
            }
        },
        {
            key: "Settings",
            get: function get() {
                return this.settings;
            }
        },
        {
            key: "Comments",
            get: function get() {
                return this.comments;
            }
        },
        {
            key: "FontTable",
            get: function get() {
                return this.fontWrapper;
            }
        }
    ]);
    return File;
}();
var $94db4f2abf87558b$var$FieldInstruction = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(FieldInstruction, XmlComponent);
    function FieldInstruction() {
        var properties = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $gd0sY._)(this, FieldInstruction);
        var _this;
        _this = (0, $8xMIM._)(this, FieldInstruction, [
            "w:instrText"
        ]);
        $94db4f2abf87558b$var$__publicField(_this, "properties");
        _this.properties = properties;
        _this.root.push(new $94db4f2abf87558b$var$TextAttributes({
            space: $94db4f2abf87558b$export$bb538ef550ced38.PRESERVE
        }));
        var instruction = "TOC";
        if (_this.properties.captionLabel) instruction = "".concat(instruction, ' \\a "').concat(_this.properties.captionLabel, '"');
        if (_this.properties.entriesFromBookmark) instruction = "".concat(instruction, ' \\b "').concat(_this.properties.entriesFromBookmark, '"');
        if (_this.properties.captionLabelIncludingNumbers) instruction = "".concat(instruction, ' \\c "').concat(_this.properties.captionLabelIncludingNumbers, '"');
        if (_this.properties.sequenceAndPageNumbersSeparator) instruction = "".concat(instruction, ' \\d "').concat(_this.properties.sequenceAndPageNumbersSeparator, '"');
        if (_this.properties.tcFieldIdentifier) instruction = "".concat(instruction, ' \\f "').concat(_this.properties.tcFieldIdentifier, '"');
        if (_this.properties.hyperlink) instruction = "".concat(instruction, " \\h");
        if (_this.properties.tcFieldLevelRange) instruction = "".concat(instruction, ' \\l "').concat(_this.properties.tcFieldLevelRange, '"');
        if (_this.properties.pageNumbersEntryLevelsRange) instruction = "".concat(instruction, ' \\n "').concat(_this.properties.pageNumbersEntryLevelsRange, '"');
        if (_this.properties.headingStyleRange) instruction = "".concat(instruction, ' \\o "').concat(_this.properties.headingStyleRange, '"');
        if (_this.properties.entryAndPageNumberSeparator) instruction = "".concat(instruction, ' \\p "').concat(_this.properties.entryAndPageNumberSeparator, '"');
        if (_this.properties.seqFieldIdentifierForPrefix) instruction = "".concat(instruction, ' \\s "').concat(_this.properties.seqFieldIdentifierForPrefix, '"');
        if (_this.properties.stylesWithLevels && _this.properties.stylesWithLevels.length) {
            var styles = _this.properties.stylesWithLevels.map(function(sl) {
                return "".concat(sl.styleName, ",").concat(sl.level);
            }).join(",");
            instruction = "".concat(instruction, ' \\t "').concat(styles, '"');
        }
        if (_this.properties.useAppliedParagraphOutlineLevel) instruction = "".concat(instruction, " \\u");
        if (_this.properties.preserveTabInEntries) instruction = "".concat(instruction, " \\w");
        if (_this.properties.preserveNewLineInEntries) instruction = "".concat(instruction, " \\x");
        if (_this.properties.hideTabAndPageNumbersInWebView) instruction = "".concat(instruction, " \\z");
        _this.root.push(instruction);
        return _this;
    }
    return FieldInstruction;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$StructuredDocumentTagContent = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(StructuredDocumentTagContent, XmlComponent);
    function StructuredDocumentTagContent() {
        (0, $gd0sY._)(this, StructuredDocumentTagContent);
        return (0, $8xMIM._)(this, StructuredDocumentTagContent, [
            "w:sdtContent"
        ]);
    }
    return StructuredDocumentTagContent;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$StructuredDocumentTagProperties = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(StructuredDocumentTagProperties, XmlComponent);
    function StructuredDocumentTagProperties(alias) {
        (0, $gd0sY._)(this, StructuredDocumentTagProperties);
        var _this;
        _this = (0, $8xMIM._)(this, StructuredDocumentTagProperties, [
            "w:sdtPr"
        ]);
        if (alias) _this.root.push(new $94db4f2abf87558b$export$eacbde36aa74068("w:alias", alias));
        return _this;
    }
    return StructuredDocumentTagProperties;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$65a20d5539dff777 = /*#__PURE__*/ function(FileChild) {
    "use strict";
    (0, $NBk0Y._)(TableOfContents, FileChild);
    function TableOfContents() {
        var alias = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Table of Contents", properties = arguments.length > 1 ? arguments[1] : void 0;
        (0, $gd0sY._)(this, TableOfContents);
        var _this;
        _this = (0, $8xMIM._)(this, TableOfContents, [
            "w:sdt"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$StructuredDocumentTagProperties(alias));
        var content = new $94db4f2abf87558b$var$StructuredDocumentTagContent();
        var beginParagraph = new $94db4f2abf87558b$export$358a232cca1ab2ac({
            children: [
                new $94db4f2abf87558b$export$ddae37e51c7979e2({
                    children: [
                        new $94db4f2abf87558b$var$Begin(true),
                        new $94db4f2abf87558b$var$FieldInstruction(properties),
                        new $94db4f2abf87558b$var$Separate()
                    ]
                })
            ]
        });
        content.addChildElement(beginParagraph);
        var endParagraph = new $94db4f2abf87558b$export$358a232cca1ab2ac({
            children: [
                new $94db4f2abf87558b$export$ddae37e51c7979e2({
                    children: [
                        new $94db4f2abf87558b$var$End()
                    ]
                })
            ]
        });
        content.addChildElement(endParagraph);
        _this.root.push(content);
        return _this;
    }
    return TableOfContents;
}($94db4f2abf87558b$var$FileChild);
var $94db4f2abf87558b$export$8620d935ae9e70d8 = function StyleLevel(styleName, level) {
    "use strict";
    (0, $gd0sY._)(this, StyleLevel);
    $94db4f2abf87558b$var$__publicField(this, "styleName");
    $94db4f2abf87558b$var$__publicField(this, "level");
    this.styleName = styleName;
    this.level = level;
};
var $94db4f2abf87558b$export$8b251419efc915eb = function Header2() {
    "use strict";
    var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        children: []
    };
    (0, $gd0sY._)(this, Header2);
    $94db4f2abf87558b$var$__publicField(this, "options");
    this.options = options2;
};
var $94db4f2abf87558b$export$a06f1c675e846f6f = function Footer2() {
    "use strict";
    var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        children: []
    };
    (0, $gd0sY._)(this, Footer2);
    $94db4f2abf87558b$var$__publicField(this, "options");
    this.options = options2;
};
var $94db4f2abf87558b$export$acfee73582d2a289 = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(FootNoteReferenceRunAttributes, XmlAttributeComponent);
    function FootNoteReferenceRunAttributes() {
        (0, $gd0sY._)(this, FootNoteReferenceRunAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, FootNoteReferenceRunAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            id: "w:id"
        });
        return _this;
    }
    return FootNoteReferenceRunAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$ccd8225ec2fb34fe = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(FootnoteReference, XmlComponent);
    function FootnoteReference(id) {
        (0, $gd0sY._)(this, FootnoteReference);
        var _this;
        _this = (0, $8xMIM._)(this, FootnoteReference, [
            "w:footnoteReference"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$acfee73582d2a289({
            id: id
        }));
        return _this;
    }
    return FootnoteReference;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$c1993b92b39f032e = /*#__PURE__*/ function(Run) {
    "use strict";
    (0, $NBk0Y._)(FootnoteReferenceRun, Run);
    function FootnoteReferenceRun(id) {
        (0, $gd0sY._)(this, FootnoteReferenceRun);
        var _this;
        _this = (0, $8xMIM._)(this, FootnoteReferenceRun, [
            {
                style: "FootnoteReference"
            }
        ]);
        _this.root.push(new $94db4f2abf87558b$export$ccd8225ec2fb34fe(id));
        return _this;
    }
    return FootnoteReferenceRun;
}($94db4f2abf87558b$export$ddae37e51c7979e2);
var $94db4f2abf87558b$export$be933bc21596e47 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(InsertedTextRun, XmlComponent);
    function InsertedTextRun(options2) {
        (0, $gd0sY._)(this, InsertedTextRun);
        var _this;
        _this = (0, $8xMIM._)(this, InsertedTextRun, [
            "w:ins"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$ChangeAttributes({
            id: options2.id,
            author: options2.author,
            date: options2.date
        }));
        _this.addChildElement(new $94db4f2abf87558b$export$84d920a4f7ee9ae2(options2));
        return _this;
    }
    return InsertedTextRun;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$DeletedPage = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(DeletedPage, XmlComponent);
    function DeletedPage() {
        (0, $gd0sY._)(this, DeletedPage);
        var _this;
        _this = (0, $8xMIM._)(this, DeletedPage, [
            "w:delInstrText"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$TextAttributes({
            space: $94db4f2abf87558b$export$bb538ef550ced38.PRESERVE
        }));
        _this.root.push("PAGE");
        return _this;
    }
    return DeletedPage;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$DeletedNumberOfPages = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(DeletedNumberOfPages, XmlComponent);
    function DeletedNumberOfPages() {
        (0, $gd0sY._)(this, DeletedNumberOfPages);
        var _this;
        _this = (0, $8xMIM._)(this, DeletedNumberOfPages, [
            "w:delInstrText"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$TextAttributes({
            space: $94db4f2abf87558b$export$bb538ef550ced38.PRESERVE
        }));
        _this.root.push("NUMPAGES");
        return _this;
    }
    return DeletedNumberOfPages;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$DeletedNumberOfPagesSection = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(DeletedNumberOfPagesSection, XmlComponent);
    function DeletedNumberOfPagesSection() {
        (0, $gd0sY._)(this, DeletedNumberOfPagesSection);
        var _this;
        _this = (0, $8xMIM._)(this, DeletedNumberOfPagesSection, [
            "w:delInstrText"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$TextAttributes({
            space: $94db4f2abf87558b$export$bb538ef550ced38.PRESERVE
        }));
        _this.root.push("SECTIONPAGES");
        return _this;
    }
    return DeletedNumberOfPagesSection;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$DeletedText = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(DeletedText, XmlComponent);
    function DeletedText(text) {
        (0, $gd0sY._)(this, DeletedText);
        var _this;
        _this = (0, $8xMIM._)(this, DeletedText, [
            "w:delText"
        ]);
        _this.root.push(new $94db4f2abf87558b$var$TextAttributes({
            space: $94db4f2abf87558b$export$bb538ef550ced38.PRESERVE
        }));
        _this.root.push(text);
        return _this;
    }
    return DeletedText;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$fbc7a99f5255f638 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(DeletedTextRun, XmlComponent);
    function DeletedTextRun(options2) {
        (0, $gd0sY._)(this, DeletedTextRun);
        var _this;
        _this = (0, $8xMIM._)(this, DeletedTextRun, [
            "w:del"
        ]);
        $94db4f2abf87558b$var$__publicField(_this, "deletedTextRunWrapper");
        _this.root.push(new $94db4f2abf87558b$var$ChangeAttributes({
            id: options2.id,
            author: options2.author,
            date: options2.date
        }));
        _this.deletedTextRunWrapper = new $94db4f2abf87558b$var$DeletedTextRunWrapper(options2);
        _this.addChildElement(_this.deletedTextRunWrapper);
        return _this;
    }
    return DeletedTextRun;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$DeletedTextRunWrapper = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(DeletedTextRunWrapper, XmlComponent);
    function DeletedTextRunWrapper(options2) {
        (0, $gd0sY._)(this, DeletedTextRunWrapper);
        var _this;
        _this = (0, $8xMIM._)(this, DeletedTextRunWrapper, [
            "w:r"
        ]);
        _this.root.push(new $94db4f2abf87558b$export$5ae5540473946c91(options2));
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (options2.children) try {
            for(var _iterator = options2.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                if (typeof child === "string") {
                    switch(child){
                        case $94db4f2abf87558b$export$9d30b4f7b635f195.CURRENT:
                            _this.root.push(new $94db4f2abf87558b$var$Begin());
                            _this.root.push(new $94db4f2abf87558b$var$DeletedPage());
                            _this.root.push(new $94db4f2abf87558b$var$Separate());
                            _this.root.push(new $94db4f2abf87558b$var$End());
                            break;
                        case $94db4f2abf87558b$export$9d30b4f7b635f195.TOTAL_PAGES:
                            _this.root.push(new $94db4f2abf87558b$var$Begin());
                            _this.root.push(new $94db4f2abf87558b$var$DeletedNumberOfPages());
                            _this.root.push(new $94db4f2abf87558b$var$Separate());
                            _this.root.push(new $94db4f2abf87558b$var$End());
                            break;
                        case $94db4f2abf87558b$export$9d30b4f7b635f195.TOTAL_PAGES_IN_SECTION:
                            _this.root.push(new $94db4f2abf87558b$var$Begin());
                            _this.root.push(new $94db4f2abf87558b$var$DeletedNumberOfPagesSection());
                            _this.root.push(new $94db4f2abf87558b$var$Separate());
                            _this.root.push(new $94db4f2abf87558b$var$End());
                            break;
                        default:
                            _this.root.push(new $94db4f2abf87558b$var$DeletedText(child));
                            break;
                    }
                    continue;
                }
                _this.root.push(child);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        else if (options2.text) _this.root.push(new $94db4f2abf87558b$var$DeletedText(options2.text));
        if (options2.break) for(var i = 0; i < options2.break; i++)_this.root.splice(1, 0, new $94db4f2abf87558b$var$Break$1());
        return _this;
    }
    return DeletedTextRunWrapper;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$var$CheckboxSymbolAttributes = /*#__PURE__*/ function(XmlAttributeComponent) {
    "use strict";
    (0, $NBk0Y._)(CheckboxSymbolAttributes, XmlAttributeComponent);
    function CheckboxSymbolAttributes() {
        (0, $gd0sY._)(this, CheckboxSymbolAttributes);
        var _this;
        _this = (0, $8xMIM._)(this, CheckboxSymbolAttributes, arguments);
        $94db4f2abf87558b$var$__publicField(_this, "xmlKeys", {
            val: "w14:val",
            symbolfont: "w14:font"
        });
        return _this;
    }
    return CheckboxSymbolAttributes;
}($94db4f2abf87558b$export$d14a6833c537c2d);
var $94db4f2abf87558b$export$466d83ed591e9874 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(CheckBoxSymbolElement, XmlComponent);
    function CheckBoxSymbolElement(name, val, font) {
        (0, $gd0sY._)(this, CheckBoxSymbolElement);
        var _this;
        _this = (0, $8xMIM._)(this, CheckBoxSymbolElement, [
            name
        ]);
        if (font) _this.root.push(new $94db4f2abf87558b$var$CheckboxSymbolAttributes({
            val: $94db4f2abf87558b$export$545c905536cb1e26(val),
            symbolfont: font
        }));
        else _this.root.push(new $94db4f2abf87558b$var$CheckboxSymbolAttributes({
            val: val
        }));
        return _this;
    }
    return CheckBoxSymbolElement;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$9499831ee554ccd8 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(CheckBoxUtil, XmlComponent);
    function CheckBoxUtil(options2) {
        (0, $gd0sY._)(this, CheckBoxUtil);
        var _this;
        var _a, _b, _c, _d, _e, _f, _g, _h;
        _this = (0, $8xMIM._)(this, CheckBoxUtil, [
            "w14:checkbox"
        ]);
        $94db4f2abf87558b$var$__publicField(_this, "DEFAULT_UNCHECKED_SYMBOL", "2610");
        $94db4f2abf87558b$var$__publicField(_this, "DEFAULT_CHECKED_SYMBOL", "2612");
        $94db4f2abf87558b$var$__publicField(_this, "DEFAULT_FONT", "MS Gothic");
        var value = (options2 == null ? void 0 : options2.checked) ? "1" : "0";
        var symbol;
        var font;
        _this.root.push(new $94db4f2abf87558b$export$466d83ed591e9874("w14:checked", value));
        symbol = ((_a = options2 == null ? void 0 : options2.checkedState) == null ? void 0 : _a.value) ? (_b = options2 == null ? void 0 : options2.checkedState) == null ? void 0 : _b.value : _this.DEFAULT_CHECKED_SYMBOL;
        font = ((_c = options2 == null ? void 0 : options2.checkedState) == null ? void 0 : _c.font) ? (_d = options2 == null ? void 0 : options2.checkedState) == null ? void 0 : _d.font : _this.DEFAULT_FONT;
        _this.root.push(new $94db4f2abf87558b$export$466d83ed591e9874("w14:checkedState", symbol, font));
        symbol = ((_e = options2 == null ? void 0 : options2.uncheckedState) == null ? void 0 : _e.value) ? (_f = options2 == null ? void 0 : options2.uncheckedState) == null ? void 0 : _f.value : _this.DEFAULT_UNCHECKED_SYMBOL;
        font = ((_g = options2 == null ? void 0 : options2.uncheckedState) == null ? void 0 : _g.font) ? (_h = options2 == null ? void 0 : options2.uncheckedState) == null ? void 0 : _h.font : _this.DEFAULT_FONT;
        _this.root.push(new $94db4f2abf87558b$export$466d83ed591e9874("w14:uncheckedState", symbol, font));
        return _this;
    }
    return CheckBoxUtil;
}($94db4f2abf87558b$export$19f99b70db82ec96);
var $94db4f2abf87558b$export$ea5f704b89d806f6 = /*#__PURE__*/ function(XmlComponent) {
    "use strict";
    (0, $NBk0Y._)(CheckBox, XmlComponent);
    function CheckBox(options2) {
        (0, $gd0sY._)(this, CheckBox);
        var _this;
        var _a, _b, _c, _d;
        _this = (0, $8xMIM._)(this, CheckBox, [
            "w:sdt"
        ]);
        // default values per Microsoft
        $94db4f2abf87558b$var$__publicField(_this, "DEFAULT_UNCHECKED_SYMBOL", "2610");
        $94db4f2abf87558b$var$__publicField(_this, "DEFAULT_CHECKED_SYMBOL", "2612");
        $94db4f2abf87558b$var$__publicField(_this, "DEFAULT_FONT", "MS Gothic");
        var properties = new $94db4f2abf87558b$var$StructuredDocumentTagProperties(options2 == null ? void 0 : options2.alias);
        properties.addChildElement(new $94db4f2abf87558b$export$9499831ee554ccd8(options2));
        _this.root.push(properties);
        var content = new $94db4f2abf87558b$var$StructuredDocumentTagContent();
        var checkedFont = (_a = options2 == null ? void 0 : options2.checkedState) == null ? void 0 : _a.font;
        var checkedText = (_b = options2 == null ? void 0 : options2.checkedState) == null ? void 0 : _b.value;
        var uncheckedFont = (_c = options2 == null ? void 0 : options2.uncheckedState) == null ? void 0 : _c.font;
        var uncheckedText = (_d = options2 == null ? void 0 : options2.uncheckedState) == null ? void 0 : _d.value;
        var symbolFont;
        var char;
        if (options2 == null ? void 0 : options2.checked) {
            symbolFont = checkedFont ? checkedFont : _this.DEFAULT_FONT;
            char = checkedText ? checkedText : _this.DEFAULT_CHECKED_SYMBOL;
        } else {
            symbolFont = uncheckedFont ? uncheckedFont : _this.DEFAULT_FONT;
            char = uncheckedText ? uncheckedText : _this.DEFAULT_UNCHECKED_SYMBOL;
        }
        var initialRenderedChar = new $94db4f2abf87558b$export$2d254945a19d4f19({
            char: char,
            symbolfont: symbolFont
        });
        content.addChildElement(initialRenderedChar);
        _this.root.push(content);
        return _this;
    }
    return CheckBox;
}($94db4f2abf87558b$export$19f99b70db82ec96);
function $94db4f2abf87558b$var$commonjsRequire(path) {
    throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var $94db4f2abf87558b$var$jszip_min = {
    exports: {}
};
(function(module, exports) {
    !function(e) {
        module.exports = e();
    }(function() {
        return (function s(a, o, h) {
            function u(r, e2) {
                if (!o[r]) {
                    if (!a[r]) {
                        var t = "function" == typeof $94db4f2abf87558b$var$commonjsRequire && $94db4f2abf87558b$var$commonjsRequire;
                        if (!e2 && t) return t(r, true);
                        if (l) return l(r, true);
                        var n = new Error("Cannot find module '" + r + "'");
                        throw n.code = "MODULE_NOT_FOUND", n;
                    }
                    var i = o[r] = {
                        exports: {}
                    };
                    a[r][0].call(i.exports, function(e3) {
                        var t2 = a[r][1][e3];
                        return u(t2 || e3);
                    }, i, i.exports, s, a, o, h);
                }
                return o[r].exports;
            }
            for(var l = "function" == typeof $94db4f2abf87558b$var$commonjsRequire && $94db4f2abf87558b$var$commonjsRequire, e = 0; e < h.length; e++)u(h[e]);
            return u;
        })({
            1: [
                function(e, t, r) {
                    var d = e("./utils"), c = e("./support"), p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                    r.encode = function(e2) {
                        for(var t2, r2, n, i, s, a, o, h = [], u = 0, l = e2.length, f = l, c2 = "string" !== d.getTypeOf(e2); u < e2.length;)f = l - u, n = c2 ? (t2 = e2[u++], r2 = u < l ? e2[u++] : 0, u < l ? e2[u++] : 0) : (t2 = e2.charCodeAt(u++), r2 = u < l ? e2.charCodeAt(u++) : 0, u < l ? e2.charCodeAt(u++) : 0), i = t2 >> 2, s = (3 & t2) << 4 | r2 >> 4, a = 1 < f ? (15 & r2) << 2 | n >> 6 : 64, o = 2 < f ? 63 & n : 64, h.push(p.charAt(i) + p.charAt(s) + p.charAt(a) + p.charAt(o));
                        return h.join("");
                    }, r.decode = function(e2) {
                        var t2, r2, n, i, s, a, o = 0, h = 0, u = "data:";
                        if (e2.substr(0, u.length) === u) throw new Error("Invalid base64 input, it looks like a data url.");
                        var l, f = 3 * (e2 = e2.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
                        if (e2.charAt(e2.length - 1) === p.charAt(64) && f--, e2.charAt(e2.length - 2) === p.charAt(64) && f--, f % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
                        for(l = c.uint8array ? new Uint8Array(0 | f) : new Array(0 | f); o < e2.length;)t2 = p.indexOf(e2.charAt(o++)) << 2 | (i = p.indexOf(e2.charAt(o++))) >> 4, r2 = (15 & i) << 4 | (s = p.indexOf(e2.charAt(o++))) >> 2, n = (3 & s) << 6 | (a = p.indexOf(e2.charAt(o++))), l[h++] = t2, 64 !== s && (l[h++] = r2), 64 !== a && (l[h++] = n);
                        return l;
                    };
                },
                {
                    "./support": 30,
                    "./utils": 32
                }
            ],
            2: [
                function(e, t, r) {
                    var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), a = e("./stream/DataLengthProbe");
                    function o(e2, t2, r2, n2, i2) {
                        this.compressedSize = e2, this.uncompressedSize = t2, this.crc32 = r2, this.compression = n2, this.compressedContent = i2;
                    }
                    o.prototype = {
                        getContentWorker: function getContentWorker() {
                            var e2 = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")), t2 = this;
                            return e2.on("end", function() {
                                if (this.streamInfo.data_length !== t2.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                            }), e2;
                        },
                        getCompressedWorker: function getCompressedWorker() {
                            return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                        }
                    }, o.createWorkerFrom = function(e2, t2, r2) {
                        return e2.pipe(new s()).pipe(new a("uncompressedSize")).pipe(t2.compressWorker(r2)).pipe(new a("compressedSize")).withStreamInfo("compression", t2);
                    }, t.exports = o;
                },
                {
                    "./external": 6,
                    "./stream/Crc32Probe": 25,
                    "./stream/DataLengthProbe": 26,
                    "./stream/DataWorker": 27
                }
            ],
            3: [
                function(e, t, r) {
                    var n = e("./stream/GenericWorker");
                    r.STORE = {
                        magic: "\0\0",
                        compressWorker: function compressWorker() {
                            return new n("STORE compression");
                        },
                        uncompressWorker: function uncompressWorker() {
                            return new n("STORE decompression");
                        }
                    }, r.DEFLATE = e("./flate");
                },
                {
                    "./flate": 7,
                    "./stream/GenericWorker": 28
                }
            ],
            4: [
                function(e, t, r) {
                    var n = e("./utils");
                    var o = function() {
                        for(var e2, t2 = [], r2 = 0; r2 < 256; r2++){
                            e2 = r2;
                            for(var n2 = 0; n2 < 8; n2++)e2 = 1 & e2 ? 3988292384 ^ e2 >>> 1 : e2 >>> 1;
                            t2[r2] = e2;
                        }
                        return t2;
                    }();
                    t.exports = function(e2, t2) {
                        return void 0 !== e2 && e2.length ? "string" !== n.getTypeOf(e2) ? function(e3, t3, r2, n2) {
                            var i = o, s = n2 + r2;
                            e3 ^= -1;
                            for(var a = n2; a < s; a++)e3 = e3 >>> 8 ^ i[255 & (e3 ^ t3[a])];
                            return -1 ^ e3;
                        }(0 | t2, e2, e2.length, 0) : function(e3, t3, r2, n2) {
                            var i = o, s = n2 + r2;
                            e3 ^= -1;
                            for(var a = n2; a < s; a++)e3 = e3 >>> 8 ^ i[255 & (e3 ^ t3.charCodeAt(a))];
                            return -1 ^ e3;
                        }(0 | t2, e2, e2.length, 0) : 0;
                    };
                },
                {
                    "./utils": 32
                }
            ],
            5: [
                function(e, t, r) {
                    r.base64 = false, r.binary = false, r.dir = false, r.createFolders = true, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
                },
                {}
            ],
            6: [
                function(e, t, r) {
                    var n = null;
                    n = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
                        Promise: n
                    };
                },
                {
                    lie: 37
                }
            ],
            7: [
                function(e, t, r) {
                    var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), a = e("./stream/GenericWorker"), o = n ? "uint8array" : "array";
                    function h(e2, t2) {
                        a.call(this, "FlateWorker/" + e2), this._pako = null, this._pakoAction = e2, this._pakoOptions = t2, this.meta = {};
                    }
                    r.magic = "\b\0", s.inherits(h, a), h.prototype.processChunk = function(e2) {
                        this.meta = e2.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(o, e2.data), false);
                    }, h.prototype.flush = function() {
                        a.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], true);
                    }, h.prototype.cleanUp = function() {
                        a.prototype.cleanUp.call(this), this._pako = null;
                    }, h.prototype._createPako = function() {
                        this._pako = new i[this._pakoAction]({
                            raw: true,
                            level: this._pakoOptions.level || -1
                        });
                        var t2 = this;
                        this._pako.onData = function(e2) {
                            t2.push({
                                data: e2,
                                meta: t2.meta
                            });
                        };
                    }, r.compressWorker = function(e2) {
                        return new h("Deflate", e2);
                    }, r.uncompressWorker = function() {
                        return new h("Inflate", {});
                    };
                },
                {
                    "./stream/GenericWorker": 28,
                    "./utils": 32,
                    pako: 38
                }
            ],
            8: [
                function(e, t, r) {
                    function A(e2, t2) {
                        var r2, n2 = "";
                        for(r2 = 0; r2 < t2; r2++)n2 += String.fromCharCode(255 & e2), e2 >>>= 8;
                        return n2;
                    }
                    function n(e2, t2, r2, n2, i2, s2) {
                        var a, o, h = e2.file, u = e2.compression, l = s2 !== O.utf8encode, f = I.transformTo("string", s2(h.name)), c = I.transformTo("string", O.utf8encode(h.name)), d = h.comment, p = I.transformTo("string", s2(d)), m = I.transformTo("string", O.utf8encode(d)), _ = c.length !== h.name.length, g = m.length !== d.length, b = "", v = "", y = "", w = h.dir, k = h.date, x = {
                            crc32: 0,
                            compressedSize: 0,
                            uncompressedSize: 0
                        };
                        t2 && !r2 || (x.crc32 = e2.crc32, x.compressedSize = e2.compressedSize, x.uncompressedSize = e2.uncompressedSize);
                        var S = 0;
                        t2 && (S |= 8), l || !_ && !g || (S |= 2048);
                        var z = 0, C = 0;
                        w && (z |= 16), "UNIX" === i2 ? (C = 798, z |= function(e3, t3) {
                            var r3 = e3;
                            return e3 || (r3 = t3 ? 16893 : 33204), (65535 & r3) << 16;
                        }(h.unixPermissions, w)) : (C = 20, z |= function(e3) {
                            return 63 & (e3 || 0);
                        }(h.dosPermissions)), a = k.getUTCHours(), a <<= 6, a |= k.getUTCMinutes(), a <<= 5, a |= k.getUTCSeconds() / 2, o = k.getUTCFullYear() - 1980, o <<= 4, o |= k.getUTCMonth() + 1, o <<= 5, o |= k.getUTCDate(), _ && (v = A(1, 1) + A(B(f), 4) + c, b += "up" + A(v.length, 2) + v), g && (y = A(1, 1) + A(B(p), 4) + m, b += "uc" + A(y.length, 2) + y);
                        var E = "";
                        return E += "\n\0", E += A(S, 2), E += u.magic, E += A(a, 2), E += A(o, 2), E += A(x.crc32, 4), E += A(x.compressedSize, 4), E += A(x.uncompressedSize, 4), E += A(f.length, 2), E += A(b.length, 2), {
                            fileRecord: R2.LOCAL_FILE_HEADER + E + f + b,
                            dirRecord: R2.CENTRAL_FILE_HEADER + A(C, 2) + E + A(p.length, 2) + "\0\0\0\0" + A(z, 4) + A(n2, 4) + f + b + p
                        };
                    }
                    var I = e("../utils"), i = e("../stream/GenericWorker"), O = e("../utf8"), B = e("../crc32"), R2 = e("../signature");
                    function s(e2, t2, r2, n2) {
                        i.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t2, this.zipPlatform = r2, this.encodeFileName = n2, this.streamFiles = e2, this.accumulate = false, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                    }
                    I.inherits(s, i), s.prototype.push = function(e2) {
                        var t2 = e2.meta.percent || 0, r2 = this.entriesCount, n2 = this._sources.length;
                        this.accumulate ? this.contentBuffer.push(e2) : (this.bytesWritten += e2.data.length, i.prototype.push.call(this, {
                            data: e2.data,
                            meta: {
                                currentFile: this.currentFile,
                                percent: r2 ? (t2 + 100 * (r2 - n2 - 1)) / r2 : 100
                            }
                        }));
                    }, s.prototype.openedSource = function(e2) {
                        this.currentSourceOffset = this.bytesWritten, this.currentFile = e2.file.name;
                        var t2 = this.streamFiles && !e2.file.dir;
                        if (t2) {
                            var r2 = n(e2, t2, false, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                            this.push({
                                data: r2.fileRecord,
                                meta: {
                                    percent: 0
                                }
                            });
                        } else this.accumulate = true;
                    }, s.prototype.closedSource = function(e2) {
                        this.accumulate = false;
                        var t2 = this.streamFiles && !e2.file.dir, r2 = n(e2, t2, true, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                        if (this.dirRecords.push(r2.dirRecord), t2) this.push({
                            data: function(e3) {
                                return R2.DATA_DESCRIPTOR + A(e3.crc32, 4) + A(e3.compressedSize, 4) + A(e3.uncompressedSize, 4);
                            }(e2),
                            meta: {
                                percent: 100
                            }
                        });
                        else for(this.push({
                            data: r2.fileRecord,
                            meta: {
                                percent: 0
                            }
                        }); this.contentBuffer.length;)this.push(this.contentBuffer.shift());
                        this.currentFile = null;
                    }, s.prototype.flush = function() {
                        for(var e2 = this.bytesWritten, t2 = 0; t2 < this.dirRecords.length; t2++)this.push({
                            data: this.dirRecords[t2],
                            meta: {
                                percent: 100
                            }
                        });
                        var r2 = this.bytesWritten - e2, n2 = function(e3, t3, r3, n3, i2) {
                            var s2 = I.transformTo("string", i2(n3));
                            return R2.CENTRAL_DIRECTORY_END + "\0\0\0\0" + A(e3, 2) + A(e3, 2) + A(t3, 4) + A(r3, 4) + A(s2.length, 2) + s2;
                        }(this.dirRecords.length, r2, e2, this.zipComment, this.encodeFileName);
                        this.push({
                            data: n2,
                            meta: {
                                percent: 100
                            }
                        });
                    }, s.prototype.prepareNextSource = function() {
                        this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                    }, s.prototype.registerPrevious = function(e2) {
                        this._sources.push(e2);
                        var t2 = this;
                        return e2.on("data", function(e3) {
                            t2.processChunk(e3);
                        }), e2.on("end", function() {
                            t2.closedSource(t2.previous.streamInfo), t2._sources.length ? t2.prepareNextSource() : t2.end();
                        }), e2.on("error", function(e3) {
                            t2.error(e3);
                        }), this;
                    }, s.prototype.resume = function() {
                        return !!i.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), true) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), true));
                    }, s.prototype.error = function(e2) {
                        var t2 = this._sources;
                        if (!i.prototype.error.call(this, e2)) return false;
                        for(var r2 = 0; r2 < t2.length; r2++)try {
                            t2[r2].error(e2);
                        } catch (e3) {}
                        return true;
                    }, s.prototype.lock = function() {
                        i.prototype.lock.call(this);
                        for(var e2 = this._sources, t2 = 0; t2 < e2.length; t2++)e2[t2].lock();
                    }, t.exports = s;
                },
                {
                    "../crc32": 4,
                    "../signature": 23,
                    "../stream/GenericWorker": 28,
                    "../utf8": 31,
                    "../utils": 32
                }
            ],
            9: [
                function(e, t, r) {
                    var u = e("../compressions"), n = e("./ZipFileWorker");
                    r.generateWorker = function(e2, a, t2) {
                        var o = new n(a.streamFiles, t2, a.platform, a.encodeFileName), h = 0;
                        try {
                            e2.forEach(function(e3, t3) {
                                h++;
                                var r2 = function(e4, t4) {
                                    var r3 = e4 || t4, n3 = u[r3];
                                    if (!n3) throw new Error(r3 + " is not a valid compression method !");
                                    return n3;
                                }(t3.options.compression, a.compression), n2 = t3.options.compressionOptions || a.compressionOptions || {}, i = t3.dir, s = t3.date;
                                t3._compressWorker(r2, n2).withStreamInfo("file", {
                                    name: e3,
                                    dir: i,
                                    date: s,
                                    comment: t3.comment || "",
                                    unixPermissions: t3.unixPermissions,
                                    dosPermissions: t3.dosPermissions
                                }).pipe(o);
                            }), o.entriesCount = h;
                        } catch (e3) {
                            o.error(e3);
                        }
                        return o;
                    };
                },
                {
                    "../compressions": 3,
                    "./ZipFileWorker": 8
                }
            ],
            10: [
                function(e, t, r) {
                    function n() {
                        if (!(this instanceof n)) return new n();
                        if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                        this.files = /* @__PURE__ */ Object.create(null), this.comment = null, this.root = "", this.clone = function() {
                            var e2 = new n();
                            for(var t2 in this)"function" != typeof this[t2] && (e2[t2] = this[t2]);
                            return e2;
                        };
                    }
                    (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.1", n.loadAsync = function(e2, t2) {
                        return new n().loadAsync(e2, t2);
                    }, n.external = e("./external"), t.exports = n;
                },
                {
                    "./defaults": 5,
                    "./external": 6,
                    "./load": 11,
                    "./object": 15,
                    "./support": 30
                }
            ],
            11: [
                function(e, t, r) {
                    var u = e("./utils"), i = e("./external"), n = e("./utf8"), s = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
                    function f(n2) {
                        return new i.Promise(function(e2, t2) {
                            var r2 = n2.decompressed.getContentWorker().pipe(new a());
                            r2.on("error", function(e3) {
                                t2(e3);
                            }).on("end", function() {
                                r2.streamInfo.crc32 !== n2.decompressed.crc32 ? t2(new Error("Corrupted zip : CRC32 mismatch")) : e2();
                            }).resume();
                        });
                    }
                    t.exports = function(e2, o) {
                        var h = this;
                        return o = u.extend(o || {}, {
                            base64: false,
                            checkCRC32: false,
                            optimizedBinaryString: false,
                            createFolders: false,
                            decodeFileName: n.utf8decode
                        }), l.isNode && l.isStream(e2) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : u.prepareContent("the loaded zip file", e2, true, o.optimizedBinaryString, o.base64).then(function(e3) {
                            var t2 = new s(o);
                            return t2.load(e3), t2;
                        }).then(function(e3) {
                            var t2 = [
                                i.Promise.resolve(e3)
                            ], r2 = e3.files;
                            if (o.checkCRC32) for(var n2 = 0; n2 < r2.length; n2++)t2.push(f(r2[n2]));
                            return i.Promise.all(t2);
                        }).then(function(e3) {
                            for(var t2 = e3.shift(), r2 = t2.files, n2 = 0; n2 < r2.length; n2++){
                                var i2 = r2[n2], s2 = i2.fileNameStr, a2 = u.resolve(i2.fileNameStr);
                                h.file(a2, i2.decompressed, {
                                    binary: true,
                                    optimizedBinaryString: true,
                                    date: i2.date,
                                    dir: i2.dir,
                                    comment: i2.fileCommentStr.length ? i2.fileCommentStr : null,
                                    unixPermissions: i2.unixPermissions,
                                    dosPermissions: i2.dosPermissions,
                                    createFolders: o.createFolders
                                }), i2.dir || (h.file(a2).unsafeOriginalName = s2);
                            }
                            return t2.zipComment.length && (h.comment = t2.zipComment), h;
                        });
                    };
                },
                {
                    "./external": 6,
                    "./nodejsUtils": 14,
                    "./stream/Crc32Probe": 25,
                    "./utf8": 31,
                    "./utils": 32,
                    "./zipEntries": 33
                }
            ],
            12: [
                function(e, t, r) {
                    var n = e("../utils"), i = e("../stream/GenericWorker");
                    function s(e2, t2) {
                        i.call(this, "Nodejs stream input adapter for " + e2), this._upstreamEnded = false, this._bindStream(t2);
                    }
                    n.inherits(s, i), s.prototype._bindStream = function(e2) {
                        var t2 = this;
                        (this._stream = e2).pause(), e2.on("data", function(e3) {
                            t2.push({
                                data: e3,
                                meta: {
                                    percent: 0
                                }
                            });
                        }).on("error", function(e3) {
                            t2.isPaused ? this.generatedError = e3 : t2.error(e3);
                        }).on("end", function() {
                            t2.isPaused ? t2._upstreamEnded = true : t2.end();
                        });
                    }, s.prototype.pause = function() {
                        return !!i.prototype.pause.call(this) && (this._stream.pause(), true);
                    }, s.prototype.resume = function() {
                        return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), true);
                    }, t.exports = s;
                },
                {
                    "../stream/GenericWorker": 28,
                    "../utils": 32
                }
            ],
            13: [
                function(e, t, r) {
                    var i = e("readable-stream").Readable;
                    function n(e2, t2, r2) {
                        i.call(this, t2), this._helper = e2;
                        var n2 = this;
                        e2.on("data", function(e3, t3) {
                            n2.push(e3) || n2._helper.pause(), r2 && r2(t3);
                        }).on("error", function(e3) {
                            n2.emit("error", e3);
                        }).on("end", function() {
                            n2.push(null);
                        });
                    }
                    e("../utils").inherits(n, i), n.prototype._read = function() {
                        this._helper.resume();
                    }, t.exports = n;
                },
                {
                    "../utils": 32,
                    "readable-stream": 16
                }
            ],
            14: [
                function(e, t, r) {
                    t.exports = {
                        isNode: "undefined" != typeof $94db4f2abf87558b$var$Buffer,
                        newBufferFrom: function newBufferFrom(e2, t2) {
                            if ($94db4f2abf87558b$var$Buffer.from && $94db4f2abf87558b$var$Buffer.from !== Uint8Array.from) return $94db4f2abf87558b$var$Buffer.from(e2, t2);
                            if ("number" == typeof e2) throw new Error('The "data" argument must not be a number');
                            return new $94db4f2abf87558b$var$Buffer(e2, t2);
                        },
                        allocBuffer: function allocBuffer(e2) {
                            if ($94db4f2abf87558b$var$Buffer.alloc) return $94db4f2abf87558b$var$Buffer.alloc(e2);
                            var t2 = new $94db4f2abf87558b$var$Buffer(e2);
                            return t2.fill(0), t2;
                        },
                        isBuffer: function isBuffer(e2) {
                            return $94db4f2abf87558b$var$Buffer.isBuffer(e2);
                        },
                        isStream: function isStream(e2) {
                            return e2 && "function" == typeof e2.on && "function" == typeof e2.pause && "function" == typeof e2.resume;
                        }
                    };
                },
                {}
            ],
            15: [
                function(e, t, r) {
                    function s(e2, t2, r2) {
                        var n2, i2 = u.getTypeOf(t2), s2 = u.extend(r2 || {}, f);
                        s2.date = s2.date || /* @__PURE__ */ new Date(), null !== s2.compression && (s2.compression = s2.compression.toUpperCase()), "string" == typeof s2.unixPermissions && (s2.unixPermissions = parseInt(s2.unixPermissions, 8)), s2.unixPermissions && 16384 & s2.unixPermissions && (s2.dir = true), s2.dosPermissions && 16 & s2.dosPermissions && (s2.dir = true), s2.dir && (e2 = g(e2)), s2.createFolders && (n2 = _(e2)) && b.call(this, n2, true);
                        var a2 = "string" === i2 && false === s2.binary && false === s2.base64;
                        r2 && void 0 !== r2.binary || (s2.binary = !a2), (t2 instanceof c && 0 === t2.uncompressedSize || s2.dir || !t2 || 0 === t2.length) && (s2.base64 = false, s2.binary = true, t2 = "", s2.compression = "STORE", i2 = "string");
                        var o2 = null;
                        o2 = t2 instanceof c || t2 instanceof l ? t2 : p.isNode && p.isStream(t2) ? new m(e2, t2) : u.prepareContent(e2, t2, s2.binary, s2.optimizedBinaryString, s2.base64);
                        var h2 = new d(e2, o2, s2);
                        this.files[e2] = h2;
                    }
                    var i = e("./utf8"), u = e("./utils"), l = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), f = e("./defaults"), c = e("./compressedObject"), d = e("./zipObject"), o = e("./generate"), p = e("./nodejsUtils"), m = e("./nodejs/NodejsStreamInputAdapter"), _ = function _(e2) {
                        "/" === e2.slice(-1) && (e2 = e2.substring(0, e2.length - 1));
                        var t2 = e2.lastIndexOf("/");
                        return 0 < t2 ? e2.substring(0, t2) : "";
                    }, g = function g(e2) {
                        return "/" !== e2.slice(-1) && (e2 += "/"), e2;
                    }, b = function b(e2, t2) {
                        return t2 = void 0 !== t2 ? t2 : f.createFolders, e2 = g(e2), this.files[e2] || s.call(this, e2, null, {
                            dir: true,
                            createFolders: t2
                        }), this.files[e2];
                    };
                    function h(e2) {
                        return "[object RegExp]" === Object.prototype.toString.call(e2);
                    }
                    var n = {
                        load: function load() {
                            throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                        },
                        forEach: function forEach(e2) {
                            var t2, r2, n2;
                            for(t2 in this.files)n2 = this.files[t2], (r2 = t2.slice(this.root.length, t2.length)) && t2.slice(0, this.root.length) === this.root && e2(r2, n2);
                        },
                        filter: function filter(r2) {
                            var n2 = [];
                            return this.forEach(function(e2, t2) {
                                r2(e2, t2) && n2.push(t2);
                            }), n2;
                        },
                        file: function file(e2, t2, r2) {
                            if (1 !== arguments.length) return e2 = this.root + e2, s.call(this, e2, t2, r2), this;
                            if (h(e2)) {
                                var n2 = e2;
                                return this.filter(function(e3, t3) {
                                    return !t3.dir && n2.test(e3);
                                });
                            }
                            var i2 = this.files[this.root + e2];
                            return i2 && !i2.dir ? i2 : null;
                        },
                        folder: function folder(r2) {
                            if (!r2) return this;
                            if (h(r2)) return this.filter(function(e3, t3) {
                                return t3.dir && r2.test(e3);
                            });
                            var e2 = this.root + r2, t2 = b.call(this, e2), n2 = this.clone();
                            return n2.root = t2.name, n2;
                        },
                        remove: function remove(r2) {
                            r2 = this.root + r2;
                            var e2 = this.files[r2];
                            if (e2 || ("/" !== r2.slice(-1) && (r2 += "/"), e2 = this.files[r2]), e2 && !e2.dir) delete this.files[r2];
                            else for(var t2 = this.filter(function(e3, t3) {
                                return t3.name.slice(0, r2.length) === r2;
                            }), n2 = 0; n2 < t2.length; n2++)delete this.files[t2[n2].name];
                            return this;
                        },
                        generate: function generate() {
                            throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                        },
                        generateInternalStream: function generateInternalStream(e2) {
                            var t2, r2 = {};
                            try {
                                if ((r2 = u.extend(e2 || {}, {
                                    streamFiles: false,
                                    compression: "STORE",
                                    compressionOptions: null,
                                    type: "",
                                    platform: "DOS",
                                    comment: null,
                                    mimeType: "application/zip",
                                    encodeFileName: i.utf8encode
                                })).type = r2.type.toLowerCase(), r2.compression = r2.compression.toUpperCase(), "binarystring" === r2.type && (r2.type = "string"), !r2.type) throw new Error("No output type specified.");
                                u.checkSupport(r2.type), "darwin" !== r2.platform && "freebsd" !== r2.platform && "linux" !== r2.platform && "sunos" !== r2.platform || (r2.platform = "UNIX"), "win32" === r2.platform && (r2.platform = "DOS");
                                var n2 = r2.comment || this.comment || "";
                                t2 = o.generateWorker(this, r2, n2);
                            } catch (e3) {
                                (t2 = new l("error")).error(e3);
                            }
                            return new a(t2, r2.type || "string", r2.mimeType);
                        },
                        generateAsync: function generateAsync(e2, t2) {
                            return this.generateInternalStream(e2).accumulate(t2);
                        },
                        generateNodeStream: function generateNodeStream(e2, t2) {
                            return (e2 = e2 || {}).type || (e2.type = "nodebuffer"), this.generateInternalStream(e2).toNodejsStream(t2);
                        }
                    };
                    t.exports = n;
                },
                {
                    "./compressedObject": 2,
                    "./defaults": 5,
                    "./generate": 9,
                    "./nodejs/NodejsStreamInputAdapter": 12,
                    "./nodejsUtils": 14,
                    "./stream/GenericWorker": 28,
                    "./stream/StreamHelper": 29,
                    "./utf8": 31,
                    "./utils": 32,
                    "./zipObject": 35
                }
            ],
            16: [
                function(e, t, r) {
                    t.exports = e("stream");
                },
                {
                    stream: void 0
                }
            ],
            17: [
                function(e, t, r) {
                    var n = e("./DataReader");
                    function i(e2) {
                        n.call(this, e2);
                        for(var t2 = 0; t2 < this.data.length; t2++)e2[t2] = 255 & e2[t2];
                    }
                    e("../utils").inherits(i, n), i.prototype.byteAt = function(e2) {
                        return this.data[this.zero + e2];
                    }, i.prototype.lastIndexOfSignature = function(e2) {
                        for(var t2 = e2.charCodeAt(0), r2 = e2.charCodeAt(1), n2 = e2.charCodeAt(2), i2 = e2.charCodeAt(3), s = this.length - 4; 0 <= s; --s)if (this.data[s] === t2 && this.data[s + 1] === r2 && this.data[s + 2] === n2 && this.data[s + 3] === i2) return s - this.zero;
                        return -1;
                    }, i.prototype.readAndCheckSignature = function(e2) {
                        var t2 = e2.charCodeAt(0), r2 = e2.charCodeAt(1), n2 = e2.charCodeAt(2), i2 = e2.charCodeAt(3), s = this.readData(4);
                        return t2 === s[0] && r2 === s[1] && n2 === s[2] && i2 === s[3];
                    }, i.prototype.readData = function(e2) {
                        if (this.checkOffset(e2), 0 === e2) return [];
                        var t2 = this.data.slice(this.zero + this.index, this.zero + this.index + e2);
                        return this.index += e2, t2;
                    }, t.exports = i;
                },
                {
                    "../utils": 32,
                    "./DataReader": 18
                }
            ],
            18: [
                function(e, t, r) {
                    var n = e("../utils");
                    function i(e2) {
                        this.data = e2, this.length = e2.length, this.index = 0, this.zero = 0;
                    }
                    i.prototype = {
                        checkOffset: function checkOffset(e2) {
                            this.checkIndex(this.index + e2);
                        },
                        checkIndex: function checkIndex(e2) {
                            if (this.length < this.zero + e2 || e2 < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e2 + "). Corrupted zip ?");
                        },
                        setIndex: function setIndex(e2) {
                            this.checkIndex(e2), this.index = e2;
                        },
                        skip: function skip(e2) {
                            this.setIndex(this.index + e2);
                        },
                        byteAt: function byteAt() {},
                        readInt: function readInt(e2) {
                            var t2, r2 = 0;
                            for(this.checkOffset(e2), t2 = this.index + e2 - 1; t2 >= this.index; t2--)r2 = (r2 << 8) + this.byteAt(t2);
                            return this.index += e2, r2;
                        },
                        readString: function readString(e2) {
                            return n.transformTo("string", this.readData(e2));
                        },
                        readData: function readData() {},
                        lastIndexOfSignature: function lastIndexOfSignature() {},
                        readAndCheckSignature: function readAndCheckSignature() {},
                        readDate: function readDate() {
                            var e2 = this.readInt(4);
                            return new Date(Date.UTC(1980 + (e2 >> 25 & 127), (e2 >> 21 & 15) - 1, e2 >> 16 & 31, e2 >> 11 & 31, e2 >> 5 & 63, (31 & e2) << 1));
                        }
                    }, t.exports = i;
                },
                {
                    "../utils": 32
                }
            ],
            19: [
                function(e, t, r) {
                    var n = e("./Uint8ArrayReader");
                    function i(e2) {
                        n.call(this, e2);
                    }
                    e("../utils").inherits(i, n), i.prototype.readData = function(e2) {
                        this.checkOffset(e2);
                        var t2 = this.data.slice(this.zero + this.index, this.zero + this.index + e2);
                        return this.index += e2, t2;
                    }, t.exports = i;
                },
                {
                    "../utils": 32,
                    "./Uint8ArrayReader": 21
                }
            ],
            20: [
                function(e, t, r) {
                    var n = e("./DataReader");
                    function i(e2) {
                        n.call(this, e2);
                    }
                    e("../utils").inherits(i, n), i.prototype.byteAt = function(e2) {
                        return this.data.charCodeAt(this.zero + e2);
                    }, i.prototype.lastIndexOfSignature = function(e2) {
                        return this.data.lastIndexOf(e2) - this.zero;
                    }, i.prototype.readAndCheckSignature = function(e2) {
                        return e2 === this.readData(4);
                    }, i.prototype.readData = function(e2) {
                        this.checkOffset(e2);
                        var t2 = this.data.slice(this.zero + this.index, this.zero + this.index + e2);
                        return this.index += e2, t2;
                    }, t.exports = i;
                },
                {
                    "../utils": 32,
                    "./DataReader": 18
                }
            ],
            21: [
                function(e, t, r) {
                    var n = e("./ArrayReader");
                    function i(e2) {
                        n.call(this, e2);
                    }
                    e("../utils").inherits(i, n), i.prototype.readData = function(e2) {
                        if (this.checkOffset(e2), 0 === e2) return new Uint8Array(0);
                        var t2 = this.data.subarray(this.zero + this.index, this.zero + this.index + e2);
                        return this.index += e2, t2;
                    }, t.exports = i;
                },
                {
                    "../utils": 32,
                    "./ArrayReader": 17
                }
            ],
            22: [
                function(e, t, r) {
                    var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), a = e("./StringReader"), o = e("./NodeBufferReader"), h = e("./Uint8ArrayReader");
                    t.exports = function(e2) {
                        var t2 = n.getTypeOf(e2);
                        return n.checkSupport(t2), "string" !== t2 || i.uint8array ? "nodebuffer" === t2 ? new o(e2) : i.uint8array ? new h(n.transformTo("uint8array", e2)) : new s(n.transformTo("array", e2)) : new a(e2);
                    };
                },
                {
                    "../support": 30,
                    "../utils": 32,
                    "./ArrayReader": 17,
                    "./NodeBufferReader": 19,
                    "./StringReader": 20,
                    "./Uint8ArrayReader": 21
                }
            ],
            23: [
                function(e, t, r) {
                    r.LOCAL_FILE_HEADER = "PK", r.CENTRAL_FILE_HEADER = "PK", r.CENTRAL_DIRECTORY_END = "PK", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x07", r.ZIP64_CENTRAL_DIRECTORY_END = "PK", r.DATA_DESCRIPTOR = "PK\x07\b";
                },
                {}
            ],
            24: [
                function(e, t, r) {
                    var n = e("./GenericWorker"), i = e("../utils");
                    function s(e2) {
                        n.call(this, "ConvertWorker to " + e2), this.destType = e2;
                    }
                    i.inherits(s, n), s.prototype.processChunk = function(e2) {
                        this.push({
                            data: i.transformTo(this.destType, e2.data),
                            meta: e2.meta
                        });
                    }, t.exports = s;
                },
                {
                    "../utils": 32,
                    "./GenericWorker": 28
                }
            ],
            25: [
                function(e, t, r) {
                    var n = e("./GenericWorker"), i = e("../crc32");
                    function s() {
                        n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                    }
                    e("../utils").inherits(s, n), s.prototype.processChunk = function(e2) {
                        this.streamInfo.crc32 = i(e2.data, this.streamInfo.crc32 || 0), this.push(e2);
                    }, t.exports = s;
                },
                {
                    "../crc32": 4,
                    "../utils": 32,
                    "./GenericWorker": 28
                }
            ],
            26: [
                function(e, t, r) {
                    var n = e("../utils"), i = e("./GenericWorker");
                    function s(e2) {
                        i.call(this, "DataLengthProbe for " + e2), this.propName = e2, this.withStreamInfo(e2, 0);
                    }
                    n.inherits(s, i), s.prototype.processChunk = function(e2) {
                        if (e2) {
                            var t2 = this.streamInfo[this.propName] || 0;
                            this.streamInfo[this.propName] = t2 + e2.data.length;
                        }
                        i.prototype.processChunk.call(this, e2);
                    }, t.exports = s;
                },
                {
                    "../utils": 32,
                    "./GenericWorker": 28
                }
            ],
            27: [
                function(e, t, r) {
                    var n = e("../utils"), i = e("./GenericWorker");
                    function s(e2) {
                        i.call(this, "DataWorker");
                        var t2 = this;
                        this.dataIsReady = false, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = false, e2.then(function(e3) {
                            t2.dataIsReady = true, t2.data = e3, t2.max = e3 && e3.length || 0, t2.type = n.getTypeOf(e3), t2.isPaused || t2._tickAndRepeat();
                        }, function(e3) {
                            t2.error(e3);
                        });
                    }
                    n.inherits(s, i), s.prototype.cleanUp = function() {
                        i.prototype.cleanUp.call(this), this.data = null;
                    }, s.prototype.resume = function() {
                        return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = true, n.delay(this._tickAndRepeat, [], this)), true);
                    }, s.prototype._tickAndRepeat = function() {
                        this._tickScheduled = false, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = true));
                    }, s.prototype._tick = function() {
                        if (this.isPaused || this.isFinished) return false;
                        var e2 = null, t2 = Math.min(this.max, this.index + 16384);
                        if (this.index >= this.max) return this.end();
                        switch(this.type){
                            case "string":
                                e2 = this.data.substring(this.index, t2);
                                break;
                            case "uint8array":
                                e2 = this.data.subarray(this.index, t2);
                                break;
                            case "array":
                            case "nodebuffer":
                                e2 = this.data.slice(this.index, t2);
                        }
                        return this.index = t2, this.push({
                            data: e2,
                            meta: {
                                percent: this.max ? this.index / this.max * 100 : 0
                            }
                        });
                    }, t.exports = s;
                },
                {
                    "../utils": 32,
                    "./GenericWorker": 28
                }
            ],
            28: [
                function(e, t, r) {
                    function n(e2) {
                        this.name = e2 || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = true, this.isFinished = false, this.isLocked = false, this._listeners = {
                            data: [],
                            end: [],
                            error: []
                        }, this.previous = null;
                    }
                    n.prototype = {
                        push: function push(e2) {
                            this.emit("data", e2);
                        },
                        end: function end() {
                            if (this.isFinished) return false;
                            this.flush();
                            try {
                                this.emit("end"), this.cleanUp(), this.isFinished = true;
                            } catch (e2) {
                                this.emit("error", e2);
                            }
                            return true;
                        },
                        error: function error(e2) {
                            return !this.isFinished && (this.isPaused ? this.generatedError = e2 : (this.isFinished = true, this.emit("error", e2), this.previous && this.previous.error(e2), this.cleanUp()), true);
                        },
                        on: function on(e2, t2) {
                            return this._listeners[e2].push(t2), this;
                        },
                        cleanUp: function cleanUp() {
                            this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                        },
                        emit: function emit(e2, t2) {
                            if (this._listeners[e2]) for(var r2 = 0; r2 < this._listeners[e2].length; r2++)this._listeners[e2][r2].call(this, t2);
                        },
                        pipe: function pipe(e2) {
                            return e2.registerPrevious(this);
                        },
                        registerPrevious: function registerPrevious(e2) {
                            if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                            this.streamInfo = e2.streamInfo, this.mergeStreamInfo(), this.previous = e2;
                            var t2 = this;
                            return e2.on("data", function(e3) {
                                t2.processChunk(e3);
                            }), e2.on("end", function() {
                                t2.end();
                            }), e2.on("error", function(e3) {
                                t2.error(e3);
                            }), this;
                        },
                        pause: function pause() {
                            return !this.isPaused && !this.isFinished && (this.isPaused = true, this.previous && this.previous.pause(), true);
                        },
                        resume: function resume() {
                            if (!this.isPaused || this.isFinished) return false;
                            var e2 = this.isPaused = false;
                            return this.generatedError && (this.error(this.generatedError), e2 = true), this.previous && this.previous.resume(), !e2;
                        },
                        flush: function flush() {},
                        processChunk: function processChunk(e2) {
                            this.push(e2);
                        },
                        withStreamInfo: function withStreamInfo(e2, t2) {
                            return this.extraStreamInfo[e2] = t2, this.mergeStreamInfo(), this;
                        },
                        mergeStreamInfo: function mergeStreamInfo() {
                            for(var e2 in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e2) && (this.streamInfo[e2] = this.extraStreamInfo[e2]);
                        },
                        lock: function lock() {
                            if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                            this.isLocked = true, this.previous && this.previous.lock();
                        },
                        toString: function toString() {
                            var e2 = "Worker " + this.name;
                            return this.previous ? this.previous + " -> " + e2 : e2;
                        }
                    }, t.exports = n;
                },
                {}
            ],
            29: [
                function(e, t, r) {
                    var h = e("../utils"), i = e("./ConvertWorker"), s = e("./GenericWorker"), u = e("../base64"), n = e("../support"), a = e("../external"), o = null;
                    if (n.nodestream) try {
                        o = e("../nodejs/NodejsStreamOutputAdapter");
                    } catch (e2) {}
                    function l(e2, o2) {
                        return new a.Promise(function(t2, r2) {
                            var n2 = [], i2 = e2._internalType, s2 = e2._outputType, a2 = e2._mimeType;
                            e2.on("data", function(e3, t3) {
                                n2.push(e3), o2 && o2(t3);
                            }).on("error", function(e3) {
                                n2 = [], r2(e3);
                            }).on("end", function() {
                                try {
                                    var e3 = function(e4, t3, r3) {
                                        switch(e4){
                                            case "blob":
                                                return h.newBlob(h.transformTo("arraybuffer", t3), r3);
                                            case "base64":
                                                return u.encode(t3);
                                            default:
                                                return h.transformTo(e4, t3);
                                        }
                                    }(s2, function(e4, t3) {
                                        var r3, n3 = 0, i3 = null, s3 = 0;
                                        for(r3 = 0; r3 < t3.length; r3++)s3 += t3[r3].length;
                                        switch(e4){
                                            case "string":
                                                return t3.join("");
                                            case "array":
                                                return Array.prototype.concat.apply([], t3);
                                            case "uint8array":
                                                for(i3 = new Uint8Array(s3), r3 = 0; r3 < t3.length; r3++)i3.set(t3[r3], n3), n3 += t3[r3].length;
                                                return i3;
                                            case "nodebuffer":
                                                return $94db4f2abf87558b$var$Buffer.concat(t3);
                                            default:
                                                throw new Error("concat : unsupported type '" + e4 + "'");
                                        }
                                    }(i2, n2), a2);
                                    t2(e3);
                                } catch (e4) {
                                    r2(e4);
                                }
                                n2 = [];
                            }).resume();
                        });
                    }
                    function f(e2, t2, r2) {
                        var n2 = t2;
                        switch(t2){
                            case "blob":
                            case "arraybuffer":
                                n2 = "uint8array";
                                break;
                            case "base64":
                                n2 = "string";
                        }
                        try {
                            this._internalType = n2, this._outputType = t2, this._mimeType = r2, h.checkSupport(n2), this._worker = e2.pipe(new i(n2)), e2.lock();
                        } catch (e3) {
                            this._worker = new s("error"), this._worker.error(e3);
                        }
                    }
                    f.prototype = {
                        accumulate: function accumulate(e2) {
                            return l(this, e2);
                        },
                        on: function on(e2, t2) {
                            var r2 = this;
                            return "data" === e2 ? this._worker.on(e2, function(e3) {
                                t2.call(r2, e3.data, e3.meta);
                            }) : this._worker.on(e2, function() {
                                h.delay(t2, arguments, r2);
                            }), this;
                        },
                        resume: function resume() {
                            return h.delay(this._worker.resume, [], this._worker), this;
                        },
                        pause: function pause() {
                            return this._worker.pause(), this;
                        },
                        toNodejsStream: function toNodejsStream(e2) {
                            if (h.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                            return new o(this, {
                                objectMode: "nodebuffer" !== this._outputType
                            }, e2);
                        }
                    }, t.exports = f;
                },
                {
                    "../base64": 1,
                    "../external": 6,
                    "../nodejs/NodejsStreamOutputAdapter": 13,
                    "../support": 30,
                    "../utils": 32,
                    "./ConvertWorker": 24,
                    "./GenericWorker": 28
                }
            ],
            30: [
                function(e, t, r) {
                    if (r.base64 = true, r.array = true, r.string = true, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = "undefined" != typeof $94db4f2abf87558b$var$Buffer, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = false;
                    else {
                        var n = new ArrayBuffer(0);
                        try {
                            r.blob = 0 === new Blob([
                                n
                            ], {
                                type: "application/zip"
                            }).size;
                        } catch (e2) {
                            try {
                                var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
                                i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
                            } catch (e3) {
                                r.blob = false;
                            }
                        }
                    }
                    try {
                        r.nodestream = !!e("readable-stream").Readable;
                    } catch (e2) {
                        r.nodestream = false;
                    }
                },
                {
                    "readable-stream": 16
                }
            ],
            31: [
                function(e, t, s) {
                    for(var o = e("./utils"), h = e("./support"), r = e("./nodejsUtils"), n = e("./stream/GenericWorker"), u = new Array(256), i = 0; i < 256; i++)u[i] = 252 <= i ? 6 : 248 <= i ? 5 : 240 <= i ? 4 : 224 <= i ? 3 : 192 <= i ? 2 : 1;
                    u[254] = u[254] = 1;
                    function a() {
                        n.call(this, "utf-8 decode"), this.leftOver = null;
                    }
                    function l() {
                        n.call(this, "utf-8 encode");
                    }
                    s.utf8encode = function(e2) {
                        return h.nodebuffer ? r.newBufferFrom(e2, "utf-8") : function(e3) {
                            var t2, r2, n2, i2, s2, a2 = e3.length, o2 = 0;
                            for(i2 = 0; i2 < a2; i2++)55296 == (64512 & (r2 = e3.charCodeAt(i2))) && i2 + 1 < a2 && 56320 == (64512 & (n2 = e3.charCodeAt(i2 + 1))) && (r2 = 65536 + (r2 - 55296 << 10) + (n2 - 56320), i2++), o2 += r2 < 128 ? 1 : r2 < 2048 ? 2 : r2 < 65536 ? 3 : 4;
                            for(t2 = h.uint8array ? new Uint8Array(o2) : new Array(o2), i2 = s2 = 0; s2 < o2; i2++)55296 == (64512 & (r2 = e3.charCodeAt(i2))) && i2 + 1 < a2 && 56320 == (64512 & (n2 = e3.charCodeAt(i2 + 1))) && (r2 = 65536 + (r2 - 55296 << 10) + (n2 - 56320), i2++), r2 < 128 ? t2[s2++] = r2 : (r2 < 2048 ? t2[s2++] = 192 | r2 >>> 6 : (r2 < 65536 ? t2[s2++] = 224 | r2 >>> 12 : (t2[s2++] = 240 | r2 >>> 18, t2[s2++] = 128 | r2 >>> 12 & 63), t2[s2++] = 128 | r2 >>> 6 & 63), t2[s2++] = 128 | 63 & r2);
                            return t2;
                        }(e2);
                    }, s.utf8decode = function(e2) {
                        return h.nodebuffer ? o.transformTo("nodebuffer", e2).toString("utf-8") : function(e3) {
                            var t2, r2, n2, i2, s2 = e3.length, a2 = new Array(2 * s2);
                            for(t2 = r2 = 0; t2 < s2;)if ((n2 = e3[t2++]) < 128) a2[r2++] = n2;
                            else if (4 < (i2 = u[n2])) a2[r2++] = 65533, t2 += i2 - 1;
                            else {
                                for(n2 &= 2 === i2 ? 31 : 3 === i2 ? 15 : 7; 1 < i2 && t2 < s2;)n2 = n2 << 6 | 63 & e3[t2++], i2--;
                                1 < i2 ? a2[r2++] = 65533 : n2 < 65536 ? a2[r2++] = n2 : (n2 -= 65536, a2[r2++] = 55296 | n2 >> 10 & 1023, a2[r2++] = 56320 | 1023 & n2);
                            }
                            return a2.length !== r2 && (a2.subarray ? a2 = a2.subarray(0, r2) : a2.length = r2), o.applyFromCharCode(a2);
                        }(e2 = o.transformTo(h.uint8array ? "uint8array" : "array", e2));
                    }, o.inherits(a, n), a.prototype.processChunk = function(e2) {
                        var t2 = o.transformTo(h.uint8array ? "uint8array" : "array", e2.data);
                        if (this.leftOver && this.leftOver.length) {
                            if (h.uint8array) {
                                var r2 = t2;
                                (t2 = new Uint8Array(r2.length + this.leftOver.length)).set(this.leftOver, 0), t2.set(r2, this.leftOver.length);
                            } else t2 = this.leftOver.concat(t2);
                            this.leftOver = null;
                        }
                        var n2 = function(e3, t3) {
                            var r3;
                            for((t3 = t3 || e3.length) > e3.length && (t3 = e3.length), r3 = t3 - 1; 0 <= r3 && 128 == (192 & e3[r3]);)r3--;
                            return r3 < 0 ? t3 : 0 === r3 ? t3 : r3 + u[e3[r3]] > t3 ? r3 : t3;
                        }(t2), i2 = t2;
                        n2 !== t2.length && (h.uint8array ? (i2 = t2.subarray(0, n2), this.leftOver = t2.subarray(n2, t2.length)) : (i2 = t2.slice(0, n2), this.leftOver = t2.slice(n2, t2.length))), this.push({
                            data: s.utf8decode(i2),
                            meta: e2.meta
                        });
                    }, a.prototype.flush = function() {
                        this.leftOver && this.leftOver.length && (this.push({
                            data: s.utf8decode(this.leftOver),
                            meta: {}
                        }), this.leftOver = null);
                    }, s.Utf8DecodeWorker = a, o.inherits(l, n), l.prototype.processChunk = function(e2) {
                        this.push({
                            data: s.utf8encode(e2.data),
                            meta: e2.meta
                        });
                    }, s.Utf8EncodeWorker = l;
                },
                {
                    "./nodejsUtils": 14,
                    "./stream/GenericWorker": 28,
                    "./support": 30,
                    "./utils": 32
                }
            ],
            32: [
                function(e, t, a) {
                    var o = e("./support"), h = e("./base64"), r = e("./nodejsUtils"), u = e("./external");
                    function n(e2) {
                        return e2;
                    }
                    function l(e2, t2) {
                        for(var r2 = 0; r2 < e2.length; ++r2)t2[r2] = 255 & e2.charCodeAt(r2);
                        return t2;
                    }
                    e("setimmediate"), a.newBlob = function(t2, r2) {
                        a.checkSupport("blob");
                        try {
                            return new Blob([
                                t2
                            ], {
                                type: r2
                            });
                        } catch (e2) {
                            try {
                                var n2 = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
                                return n2.append(t2), n2.getBlob(r2);
                            } catch (e3) {
                                throw new Error("Bug : can't construct the Blob.");
                            }
                        }
                    };
                    var i = {
                        stringifyByChunk: function stringifyByChunk(e2, t2, r2) {
                            var n2 = [], i2 = 0, s2 = e2.length;
                            if (s2 <= r2) return String.fromCharCode.apply(null, e2);
                            for(; i2 < s2;)"array" === t2 || "nodebuffer" === t2 ? n2.push(String.fromCharCode.apply(null, e2.slice(i2, Math.min(i2 + r2, s2)))) : n2.push(String.fromCharCode.apply(null, e2.subarray(i2, Math.min(i2 + r2, s2)))), i2 += r2;
                            return n2.join("");
                        },
                        stringifyByChar: function stringifyByChar(e2) {
                            for(var t2 = "", r2 = 0; r2 < e2.length; r2++)t2 += String.fromCharCode(e2[r2]);
                            return t2;
                        },
                        applyCanBeUsed: {
                            uint8array: function() {
                                try {
                                    return o.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                                } catch (e2) {
                                    return false;
                                }
                            }(),
                            nodebuffer: function() {
                                try {
                                    return o.nodebuffer && 1 === String.fromCharCode.apply(null, r.allocBuffer(1)).length;
                                } catch (e2) {
                                    return false;
                                }
                            }()
                        }
                    };
                    function s(e2) {
                        var t2 = 65536, r2 = a.getTypeOf(e2), n2 = true;
                        if ("uint8array" === r2 ? n2 = i.applyCanBeUsed.uint8array : "nodebuffer" === r2 && (n2 = i.applyCanBeUsed.nodebuffer), n2) for(; 1 < t2;)try {
                            return i.stringifyByChunk(e2, r2, t2);
                        } catch (e3) {
                            t2 = Math.floor(t2 / 2);
                        }
                        return i.stringifyByChar(e2);
                    }
                    function f(e2, t2) {
                        for(var r2 = 0; r2 < e2.length; r2++)t2[r2] = e2[r2];
                        return t2;
                    }
                    a.applyFromCharCode = s;
                    var c = {};
                    c.string = {
                        string: n,
                        array: function array(e2) {
                            return l(e2, new Array(e2.length));
                        },
                        arraybuffer: function arraybuffer(e2) {
                            return c.string.uint8array(e2).buffer;
                        },
                        uint8array: function uint8array(e2) {
                            return l(e2, new Uint8Array(e2.length));
                        },
                        nodebuffer: function nodebuffer(e2) {
                            return l(e2, r.allocBuffer(e2.length));
                        }
                    }, c.array = {
                        string: s,
                        array: n,
                        arraybuffer: function arraybuffer(e2) {
                            return new Uint8Array(e2).buffer;
                        },
                        uint8array: function uint8array(e2) {
                            return new Uint8Array(e2);
                        },
                        nodebuffer: function nodebuffer(e2) {
                            return r.newBufferFrom(e2);
                        }
                    }, c.arraybuffer = {
                        string: function string(e2) {
                            return s(new Uint8Array(e2));
                        },
                        array: function array(e2) {
                            return f(new Uint8Array(e2), new Array(e2.byteLength));
                        },
                        arraybuffer: n,
                        uint8array: function uint8array(e2) {
                            return new Uint8Array(e2);
                        },
                        nodebuffer: function nodebuffer(e2) {
                            return r.newBufferFrom(new Uint8Array(e2));
                        }
                    }, c.uint8array = {
                        string: s,
                        array: function array(e2) {
                            return f(e2, new Array(e2.length));
                        },
                        arraybuffer: function arraybuffer(e2) {
                            return e2.buffer;
                        },
                        uint8array: n,
                        nodebuffer: function nodebuffer(e2) {
                            return r.newBufferFrom(e2);
                        }
                    }, c.nodebuffer = {
                        string: s,
                        array: function array(e2) {
                            return f(e2, new Array(e2.length));
                        },
                        arraybuffer: function arraybuffer(e2) {
                            return c.nodebuffer.uint8array(e2).buffer;
                        },
                        uint8array: function uint8array(e2) {
                            return f(e2, new Uint8Array(e2.length));
                        },
                        nodebuffer: n
                    }, a.transformTo = function(e2, t2) {
                        if (t2 = t2 || "", !e2) return t2;
                        a.checkSupport(e2);
                        var r2 = a.getTypeOf(t2);
                        return c[r2][e2](t2);
                    }, a.resolve = function(e2) {
                        for(var t2 = e2.split("/"), r2 = [], n2 = 0; n2 < t2.length; n2++){
                            var i2 = t2[n2];
                            "." === i2 || "" === i2 && 0 !== n2 && n2 !== t2.length - 1 || (".." === i2 ? r2.pop() : r2.push(i2));
                        }
                        return r2.join("/");
                    }, a.getTypeOf = function(e2) {
                        return "string" == typeof e2 ? "string" : "[object Array]" === Object.prototype.toString.call(e2) ? "array" : o.nodebuffer && r.isBuffer(e2) ? "nodebuffer" : o.uint8array && e2 instanceof Uint8Array ? "uint8array" : o.arraybuffer && e2 instanceof ArrayBuffer ? "arraybuffer" : void 0;
                    }, a.checkSupport = function(e2) {
                        if (!o[e2.toLowerCase()]) throw new Error(e2 + " is not supported by this platform");
                    }, a.MAX_VALUE_16BITS = 65535, a.MAX_VALUE_32BITS = -1, a.pretty = function(e2) {
                        var t2, r2, n2 = "";
                        for(r2 = 0; r2 < (e2 || "").length; r2++)n2 += "\\x" + ((t2 = e2.charCodeAt(r2)) < 16 ? "0" : "") + t2.toString(16).toUpperCase();
                        return n2;
                    }, a.delay = function(e2, t2, r2) {
                        setImmediate(function() {
                            e2.apply(r2 || null, t2 || []);
                        });
                    }, a.inherits = function(e2, t2) {
                        function r2() {}
                        r2.prototype = t2.prototype, e2.prototype = new r2();
                    }, a.extend = function() {
                        var e2, t2, r2 = {};
                        for(e2 = 0; e2 < arguments.length; e2++)for(t2 in arguments[e2])Object.prototype.hasOwnProperty.call(arguments[e2], t2) && void 0 === r2[t2] && (r2[t2] = arguments[e2][t2]);
                        return r2;
                    }, a.prepareContent = function(r2, e2, n2, i2, s2) {
                        return u.Promise.resolve(e2).then(function(n3) {
                            return o.blob && (n3 instanceof Blob || -1 !== [
                                "[object File]",
                                "[object Blob]"
                            ].indexOf(Object.prototype.toString.call(n3))) && "undefined" != typeof FileReader ? new u.Promise(function(t2, r3) {
                                var e3 = new FileReader();
                                e3.onload = function(e4) {
                                    t2(e4.target.result);
                                }, e3.onerror = function(e4) {
                                    r3(e4.target.error);
                                }, e3.readAsArrayBuffer(n3);
                            }) : n3;
                        }).then(function(e3) {
                            var t2 = a.getTypeOf(e3);
                            return t2 ? ("arraybuffer" === t2 ? e3 = a.transformTo("uint8array", e3) : "string" === t2 && (s2 ? e3 = h.decode(e3) : n2 && true !== i2 && (e3 = function(e4) {
                                return l(e4, o.uint8array ? new Uint8Array(e4.length) : new Array(e4.length));
                            }(e3))), e3) : u.Promise.reject(new Error("Can't read the data of '" + r2 + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                        });
                    };
                },
                {
                    "./base64": 1,
                    "./external": 6,
                    "./nodejsUtils": 14,
                    "./support": 30,
                    setimmediate: 54
                }
            ],
            33: [
                function(e, t, r) {
                    var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), a = e("./zipEntry"), o = e("./support");
                    function h(e2) {
                        this.files = [], this.loadOptions = e2;
                    }
                    h.prototype = {
                        checkSignature: function checkSignature(e2) {
                            if (!this.reader.readAndCheckSignature(e2)) {
                                this.reader.index -= 4;
                                var t2 = this.reader.readString(4);
                                throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t2) + ", expected " + i.pretty(e2) + ")");
                            }
                        },
                        isSignature: function isSignature(e2, t2) {
                            var r2 = this.reader.index;
                            this.reader.setIndex(e2);
                            var n2 = this.reader.readString(4) === t2;
                            return this.reader.setIndex(r2), n2;
                        },
                        readBlockEndOfCentral: function readBlockEndOfCentral() {
                            this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                            var e2 = this.reader.readData(this.zipCommentLength), t2 = o.uint8array ? "uint8array" : "array", r2 = i.transformTo(t2, e2);
                            this.zipComment = this.loadOptions.decodeFileName(r2);
                        },
                        readBlockZip64EndOfCentral: function readBlockZip64EndOfCentral() {
                            this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                            for(var e2, t2, r2, n2 = this.zip64EndOfCentralSize - 44; 0 < n2;)e2 = this.reader.readInt(2), t2 = this.reader.readInt(4), r2 = this.reader.readData(t2), this.zip64ExtensibleData[e2] = {
                                id: e2,
                                length: t2,
                                value: r2
                            };
                        },
                        readBlockZip64EndOfCentralLocator: function readBlockZip64EndOfCentralLocator() {
                            if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                        },
                        readLocalFiles: function readLocalFiles() {
                            var e2, t2;
                            for(e2 = 0; e2 < this.files.length; e2++)t2 = this.files[e2], this.reader.setIndex(t2.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t2.readLocalPart(this.reader), t2.handleUTF8(), t2.processAttributes();
                        },
                        readCentralDir: function readCentralDir() {
                            var e2;
                            for(this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e2 = new a({
                                zip64: this.zip64
                            }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e2);
                            if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                        },
                        readEndOfCentral: function readEndOfCentral() {
                            var e2 = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
                            if (e2 < 0) throw !this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip: can't find end of central directory");
                            this.reader.setIndex(e2);
                            var t2 = e2;
                            if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                                if (this.zip64 = true, (e2 = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                                if (this.reader.setIndex(e2), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                                this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                            }
                            var r2 = this.centralDirOffset + this.centralDirSize;
                            this.zip64 && (r2 += 20, r2 += 12 + this.zip64EndOfCentralSize);
                            var n2 = t2 - r2;
                            if (0 < n2) this.isSignature(t2, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n2);
                            else if (n2 < 0) throw new Error("Corrupted zip: missing " + Math.abs(n2) + " bytes.");
                        },
                        prepareReader: function prepareReader(e2) {
                            this.reader = n(e2);
                        },
                        load: function load(e2) {
                            this.prepareReader(e2), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                        }
                    }, t.exports = h;
                },
                {
                    "./reader/readerFor": 22,
                    "./signature": 23,
                    "./support": 30,
                    "./utils": 32,
                    "./zipEntry": 34
                }
            ],
            34: [
                function(e, t, r) {
                    var n = e("./reader/readerFor"), s = e("./utils"), i = e("./compressedObject"), a = e("./crc32"), o = e("./utf8"), h = e("./compressions"), u = e("./support");
                    function l(e2, t2) {
                        this.options = e2, this.loadOptions = t2;
                    }
                    l.prototype = {
                        isEncrypted: function isEncrypted() {
                            return 1 == (1 & this.bitFlag);
                        },
                        useUTF8: function useUTF8() {
                            return 2048 == (2048 & this.bitFlag);
                        },
                        readLocalPart: function readLocalPart(e2) {
                            var t2, r2;
                            if (e2.skip(22), this.fileNameLength = e2.readInt(2), r2 = e2.readInt(2), this.fileName = e2.readData(this.fileNameLength), e2.skip(r2), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                            if (null === (t2 = function(e3) {
                                for(var t3 in h)if (Object.prototype.hasOwnProperty.call(h, t3) && h[t3].magic === e3) return h[t3];
                                return null;
                            }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + s.pretty(this.compressionMethod) + " unknown (inner file : " + s.transformTo("string", this.fileName) + ")");
                            this.decompressed = new i(this.compressedSize, this.uncompressedSize, this.crc32, t2, e2.readData(this.compressedSize));
                        },
                        readCentralPart: function readCentralPart(e2) {
                            this.versionMadeBy = e2.readInt(2), e2.skip(2), this.bitFlag = e2.readInt(2), this.compressionMethod = e2.readString(2), this.date = e2.readDate(), this.crc32 = e2.readInt(4), this.compressedSize = e2.readInt(4), this.uncompressedSize = e2.readInt(4);
                            var t2 = e2.readInt(2);
                            if (this.extraFieldsLength = e2.readInt(2), this.fileCommentLength = e2.readInt(2), this.diskNumberStart = e2.readInt(2), this.internalFileAttributes = e2.readInt(2), this.externalFileAttributes = e2.readInt(4), this.localHeaderOffset = e2.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                            e2.skip(t2), this.readExtraFields(e2), this.parseZIP64ExtraField(e2), this.fileComment = e2.readData(this.fileCommentLength);
                        },
                        processAttributes: function processAttributes() {
                            this.unixPermissions = null, this.dosPermissions = null;
                            var e2 = this.versionMadeBy >> 8;
                            this.dir = !!(16 & this.externalFileAttributes), 0 == e2 && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e2 && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = true);
                        },
                        parseZIP64ExtraField: function parseZIP64ExtraField() {
                            if (this.extraFields[1]) {
                                var e2 = n(this.extraFields[1].value);
                                this.uncompressedSize === s.MAX_VALUE_32BITS && (this.uncompressedSize = e2.readInt(8)), this.compressedSize === s.MAX_VALUE_32BITS && (this.compressedSize = e2.readInt(8)), this.localHeaderOffset === s.MAX_VALUE_32BITS && (this.localHeaderOffset = e2.readInt(8)), this.diskNumberStart === s.MAX_VALUE_32BITS && (this.diskNumberStart = e2.readInt(4));
                            }
                        },
                        readExtraFields: function readExtraFields(e2) {
                            var t2, r2, n2, i2 = e2.index + this.extraFieldsLength;
                            for(this.extraFields || (this.extraFields = {}); e2.index + 4 < i2;)t2 = e2.readInt(2), r2 = e2.readInt(2), n2 = e2.readData(r2), this.extraFields[t2] = {
                                id: t2,
                                length: r2,
                                value: n2
                            };
                            e2.setIndex(i2);
                        },
                        handleUTF8: function handleUTF8() {
                            var e2 = u.uint8array ? "uint8array" : "array";
                            if (this.useUTF8()) this.fileNameStr = o.utf8decode(this.fileName), this.fileCommentStr = o.utf8decode(this.fileComment);
                            else {
                                var t2 = this.findExtraFieldUnicodePath();
                                if (null !== t2) this.fileNameStr = t2;
                                else {
                                    var r2 = s.transformTo(e2, this.fileName);
                                    this.fileNameStr = this.loadOptions.decodeFileName(r2);
                                }
                                var n2 = this.findExtraFieldUnicodeComment();
                                if (null !== n2) this.fileCommentStr = n2;
                                else {
                                    var i2 = s.transformTo(e2, this.fileComment);
                                    this.fileCommentStr = this.loadOptions.decodeFileName(i2);
                                }
                            }
                        },
                        findExtraFieldUnicodePath: function findExtraFieldUnicodePath() {
                            var e2 = this.extraFields[28789];
                            if (e2) {
                                var t2 = n(e2.value);
                                return 1 !== t2.readInt(1) ? null : a(this.fileName) !== t2.readInt(4) ? null : o.utf8decode(t2.readData(e2.length - 5));
                            }
                            return null;
                        },
                        findExtraFieldUnicodeComment: function findExtraFieldUnicodeComment() {
                            var e2 = this.extraFields[25461];
                            if (e2) {
                                var t2 = n(e2.value);
                                return 1 !== t2.readInt(1) ? null : a(this.fileComment) !== t2.readInt(4) ? null : o.utf8decode(t2.readData(e2.length - 5));
                            }
                            return null;
                        }
                    }, t.exports = l;
                },
                {
                    "./compressedObject": 2,
                    "./compressions": 3,
                    "./crc32": 4,
                    "./reader/readerFor": 22,
                    "./support": 30,
                    "./utf8": 31,
                    "./utils": 32
                }
            ],
            35: [
                function(e, t, r) {
                    function n(e2, t2, r2) {
                        this.name = e2, this.dir = r2.dir, this.date = r2.date, this.comment = r2.comment, this.unixPermissions = r2.unixPermissions, this.dosPermissions = r2.dosPermissions, this._data = t2, this._dataBinary = r2.binary, this.options = {
                            compression: r2.compression,
                            compressionOptions: r2.compressionOptions
                        };
                    }
                    var s = e("./stream/StreamHelper"), i = e("./stream/DataWorker"), a = e("./utf8"), o = e("./compressedObject"), h = e("./stream/GenericWorker");
                    n.prototype = {
                        internalStream: function internalStream(e2) {
                            var t2 = null, r2 = "string";
                            try {
                                if (!e2) throw new Error("No output type specified.");
                                var n2 = "string" === (r2 = e2.toLowerCase()) || "text" === r2;
                                "binarystring" !== r2 && "text" !== r2 || (r2 = "string"), t2 = this._decompressWorker();
                                var i2 = !this._dataBinary;
                                i2 && !n2 && (t2 = t2.pipe(new a.Utf8EncodeWorker())), !i2 && n2 && (t2 = t2.pipe(new a.Utf8DecodeWorker()));
                            } catch (e3) {
                                (t2 = new h("error")).error(e3);
                            }
                            return new s(t2, r2, "");
                        },
                        async: function async(e2, t2) {
                            return this.internalStream(e2).accumulate(t2);
                        },
                        nodeStream: function nodeStream(e2, t2) {
                            return this.internalStream(e2 || "nodebuffer").toNodejsStream(t2);
                        },
                        _compressWorker: function _compressWorker(e2, t2) {
                            if (this._data instanceof o && this._data.compression.magic === e2.magic) return this._data.getCompressedWorker();
                            var r2 = this._decompressWorker();
                            return this._dataBinary || (r2 = r2.pipe(new a.Utf8EncodeWorker())), o.createWorkerFrom(r2, e2, t2);
                        },
                        _decompressWorker: function _decompressWorker() {
                            return this._data instanceof o ? this._data.getContentWorker() : this._data instanceof h ? this._data : new i(this._data);
                        }
                    };
                    for(var u = [
                        "asText",
                        "asBinary",
                        "asNodeBuffer",
                        "asUint8Array",
                        "asArrayBuffer"
                    ], l = function l() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    }, f = 0; f < u.length; f++)n.prototype[u[f]] = l;
                    t.exports = n;
                },
                {
                    "./compressedObject": 2,
                    "./stream/DataWorker": 27,
                    "./stream/GenericWorker": 28,
                    "./stream/StreamHelper": 29,
                    "./utf8": 31
                }
            ],
            36: [
                function(e, l, t) {
                    (function(t2) {
                        var r, n, e2 = t2.MutationObserver || t2.WebKitMutationObserver;
                        if (e2) {
                            var i = 0, s = new e2(u), a = t2.document.createTextNode("");
                            s.observe(a, {
                                characterData: true
                            }), r = function r() {
                                a.data = i = ++i % 2;
                            };
                        } else if (t2.setImmediate || void 0 === t2.MessageChannel) r = "document" in t2 && "onreadystatechange" in t2.document.createElement("script") ? function r() {
                            var e3 = t2.document.createElement("script");
                            e3.onreadystatechange = function() {
                                u(), e3.onreadystatechange = null, e3.parentNode.removeChild(e3), e3 = null;
                            }, t2.document.documentElement.appendChild(e3);
                        } : function() {
                            setTimeout(u, 0);
                        };
                        else {
                            var o = new t2.MessageChannel();
                            o.port1.onmessage = u, r = function r() {
                                o.port2.postMessage(0);
                            };
                        }
                        var h = [];
                        function u() {
                            var e3, t3;
                            n = true;
                            for(var r2 = h.length; r2;){
                                for(t3 = h, h = [], e3 = -1; ++e3 < r2;)t3[e3]();
                                r2 = h.length;
                            }
                            n = false;
                        }
                        l.exports = function(e3) {
                            1 !== h.push(e3) || n || r();
                        };
                    }).call(this, "undefined" != typeof $94db4f2abf87558b$var$commonjsGlobal ? $94db4f2abf87558b$var$commonjsGlobal : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
                },
                {}
            ],
            37: [
                function(e, t, r) {
                    var i = e("immediate");
                    function u() {}
                    var l = {}, s = [
                        "REJECTED"
                    ], a = [
                        "FULFILLED"
                    ], n = [
                        "PENDING"
                    ];
                    function o(e2) {
                        if ("function" != typeof e2) throw new TypeError("resolver must be a function");
                        this.state = n, this.queue = [], this.outcome = void 0, e2 !== u && d(this, e2);
                    }
                    function h(e2, t2, r2) {
                        this.promise = e2, "function" == typeof t2 && (this.onFulfilled = t2, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r2 && (this.onRejected = r2, this.callRejected = this.otherCallRejected);
                    }
                    function f(t2, r2, n2) {
                        i(function() {
                            var e2;
                            try {
                                e2 = r2(n2);
                            } catch (e3) {
                                return l.reject(t2, e3);
                            }
                            e2 === t2 ? l.reject(t2, new TypeError("Cannot resolve promise with itself")) : l.resolve(t2, e2);
                        });
                    }
                    function c(e2) {
                        var t2 = e2 && e2.then;
                        if (e2 && ("object" == (typeof e2 === "undefined" ? "undefined" : (0, $2bfPH._)(e2)) || "function" == typeof e2) && "function" == typeof t2) return function() {
                            t2.apply(e2, arguments);
                        };
                    }
                    function d(t2, e2) {
                        var r2 = false;
                        function n2(e3) {
                            r2 || (r2 = true, l.reject(t2, e3));
                        }
                        function i2(e3) {
                            r2 || (r2 = true, l.resolve(t2, e3));
                        }
                        var s2 = p(function() {
                            e2(i2, n2);
                        });
                        "error" === s2.status && n2(s2.value);
                    }
                    function p(e2, t2) {
                        var r2 = {};
                        try {
                            r2.value = e2(t2), r2.status = "success";
                        } catch (e3) {
                            r2.status = "error", r2.value = e3;
                        }
                        return r2;
                    }
                    (t.exports = o).prototype.finally = function(t2) {
                        if ("function" != typeof t2) return this;
                        var r2 = this.constructor;
                        return this.then(function(e2) {
                            return r2.resolve(t2()).then(function() {
                                return e2;
                            });
                        }, function(e2) {
                            return r2.resolve(t2()).then(function() {
                                throw e2;
                            });
                        });
                    }, o.prototype.catch = function(e2) {
                        return this.then(null, e2);
                    }, o.prototype.then = function(e2, t2) {
                        if ("function" != typeof e2 && this.state === a || "function" != typeof t2 && this.state === s) return this;
                        var r2 = new this.constructor(u);
                        this.state !== n ? f(r2, this.state === a ? e2 : t2, this.outcome) : this.queue.push(new h(r2, e2, t2));
                        return r2;
                    }, h.prototype.callFulfilled = function(e2) {
                        l.resolve(this.promise, e2);
                    }, h.prototype.otherCallFulfilled = function(e2) {
                        f(this.promise, this.onFulfilled, e2);
                    }, h.prototype.callRejected = function(e2) {
                        l.reject(this.promise, e2);
                    }, h.prototype.otherCallRejected = function(e2) {
                        f(this.promise, this.onRejected, e2);
                    }, l.resolve = function(e2, t2) {
                        var r2 = p(c, t2);
                        if ("error" === r2.status) return l.reject(e2, r2.value);
                        var n2 = r2.value;
                        if (n2) d(e2, n2);
                        else {
                            e2.state = a, e2.outcome = t2;
                            for(var i2 = -1, s2 = e2.queue.length; ++i2 < s2;)e2.queue[i2].callFulfilled(t2);
                        }
                        return e2;
                    }, l.reject = function(e2, t2) {
                        e2.state = s, e2.outcome = t2;
                        for(var r2 = -1, n2 = e2.queue.length; ++r2 < n2;)e2.queue[r2].callRejected(t2);
                        return e2;
                    }, o.resolve = function(e2) {
                        if (e2 instanceof this) return e2;
                        return l.resolve(new this(u), e2);
                    }, o.reject = function(e2) {
                        var t2 = new this(u);
                        return l.reject(t2, e2);
                    }, o.all = function(e2) {
                        var r2 = this;
                        if ("[object Array]" !== Object.prototype.toString.call(e2)) return this.reject(new TypeError("must be an array"));
                        var n2 = e2.length, i2 = false;
                        if (!n2) return this.resolve([]);
                        var s2 = new Array(n2), a2 = 0, t2 = -1, o2 = new this(u);
                        for(; ++t2 < n2;)h2(e2[t2], t2);
                        return o2;
                        function h2(e3, t3) {
                            r2.resolve(e3).then(function(e4) {
                                s2[t3] = e4, ++a2 !== n2 || i2 || (i2 = true, l.resolve(o2, s2));
                            }, function(e4) {
                                i2 || (i2 = true, l.reject(o2, e4));
                            });
                        }
                    }, o.race = function(e2) {
                        var t2 = this;
                        if ("[object Array]" !== Object.prototype.toString.call(e2)) return this.reject(new TypeError("must be an array"));
                        var r2 = e2.length, n2 = false;
                        if (!r2) return this.resolve([]);
                        var i2 = -1, s2 = new this(u);
                        for(; ++i2 < r2;)a2 = e2[i2], t2.resolve(a2).then(function(e3) {
                            n2 || (n2 = true, l.resolve(s2, e3));
                        }, function(e3) {
                            n2 || (n2 = true, l.reject(s2, e3));
                        });
                        var a2;
                        return s2;
                    };
                },
                {
                    immediate: 36
                }
            ],
            38: [
                function(e, t, r) {
                    var n = {};
                    (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = n;
                },
                {
                    "./lib/deflate": 39,
                    "./lib/inflate": 40,
                    "./lib/utils/common": 41,
                    "./lib/zlib/constants": 44
                }
            ],
            39: [
                function(e, t, r) {
                    var a = e("./zlib/deflate"), o = e("./utils/common"), h = e("./utils/strings"), i = e("./zlib/messages"), s = e("./zlib/zstream"), u = Object.prototype.toString, l = 0, f = -1, c = 0, d = 8;
                    function p(e2) {
                        if (!(this instanceof p)) return new p(e2);
                        this.options = o.assign({
                            level: f,
                            method: d,
                            chunkSize: 16384,
                            windowBits: 15,
                            memLevel: 8,
                            strategy: c,
                            to: ""
                        }, e2 || {});
                        var t2 = this.options;
                        t2.raw && 0 < t2.windowBits ? t2.windowBits = -t2.windowBits : t2.gzip && 0 < t2.windowBits && t2.windowBits < 16 && (t2.windowBits += 16), this.err = 0, this.msg = "", this.ended = false, this.chunks = [], this.strm = new s(), this.strm.avail_out = 0;
                        var r2 = a.deflateInit2(this.strm, t2.level, t2.method, t2.windowBits, t2.memLevel, t2.strategy);
                        if (r2 !== l) throw new Error(i[r2]);
                        if (t2.header && a.deflateSetHeader(this.strm, t2.header), t2.dictionary) {
                            var n2;
                            if (n2 = "string" == typeof t2.dictionary ? h.string2buf(t2.dictionary) : "[object ArrayBuffer]" === u.call(t2.dictionary) ? new Uint8Array(t2.dictionary) : t2.dictionary, (r2 = a.deflateSetDictionary(this.strm, n2)) !== l) throw new Error(i[r2]);
                            this._dict_set = true;
                        }
                    }
                    function n(e2, t2) {
                        var r2 = new p(t2);
                        if (r2.push(e2, true), r2.err) throw r2.msg || i[r2.err];
                        return r2.result;
                    }
                    p.prototype.push = function(e2, t2) {
                        var r2, n2, i2 = this.strm, s2 = this.options.chunkSize;
                        if (this.ended) return false;
                        n2 = t2 === ~~t2 ? t2 : true === t2 ? 4 : 0, "string" == typeof e2 ? i2.input = h.string2buf(e2) : "[object ArrayBuffer]" === u.call(e2) ? i2.input = new Uint8Array(e2) : i2.input = e2, i2.next_in = 0, i2.avail_in = i2.input.length;
                        do {
                            if (0 === i2.avail_out && (i2.output = new o.Buf8(s2), i2.next_out = 0, i2.avail_out = s2), 1 !== (r2 = a.deflate(i2, n2)) && r2 !== l) return this.onEnd(r2), this.ended = true, false;
                            0 !== i2.avail_out && (0 !== i2.avail_in || 4 !== n2 && 2 !== n2) || ("string" === this.options.to ? this.onData(h.buf2binstring(o.shrinkBuf(i2.output, i2.next_out))) : this.onData(o.shrinkBuf(i2.output, i2.next_out)));
                        }while ((0 < i2.avail_in || 0 === i2.avail_out) && 1 !== r2);
                        return 4 === n2 ? (r2 = a.deflateEnd(this.strm), this.onEnd(r2), this.ended = true, r2 === l) : 2 !== n2 || (this.onEnd(l), i2.avail_out = 0, true);
                    }, p.prototype.onData = function(e2) {
                        this.chunks.push(e2);
                    }, p.prototype.onEnd = function(e2) {
                        e2 === l && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = e2, this.msg = this.strm.msg;
                    }, r.Deflate = p, r.deflate = n, r.deflateRaw = function(e2, t2) {
                        return (t2 = t2 || {}).raw = true, n(e2, t2);
                    }, r.gzip = function(e2, t2) {
                        return (t2 = t2 || {}).gzip = true, n(e2, t2);
                    };
                },
                {
                    "./utils/common": 41,
                    "./utils/strings": 42,
                    "./zlib/deflate": 46,
                    "./zlib/messages": 51,
                    "./zlib/zstream": 53
                }
            ],
            40: [
                function(e, t, r) {
                    var c = e("./zlib/inflate"), d = e("./utils/common"), p = e("./utils/strings"), m = e("./zlib/constants"), n = e("./zlib/messages"), i = e("./zlib/zstream"), s = e("./zlib/gzheader"), _ = Object.prototype.toString;
                    function a(e2) {
                        if (!(this instanceof a)) return new a(e2);
                        this.options = d.assign({
                            chunkSize: 16384,
                            windowBits: 0,
                            to: ""
                        }, e2 || {});
                        var t2 = this.options;
                        t2.raw && 0 <= t2.windowBits && t2.windowBits < 16 && (t2.windowBits = -t2.windowBits, 0 === t2.windowBits && (t2.windowBits = -15)), !(0 <= t2.windowBits && t2.windowBits < 16) || e2 && e2.windowBits || (t2.windowBits += 32), 15 < t2.windowBits && t2.windowBits < 48 && 0 == (15 & t2.windowBits) && (t2.windowBits |= 15), this.err = 0, this.msg = "", this.ended = false, this.chunks = [], this.strm = new i(), this.strm.avail_out = 0;
                        var r2 = c.inflateInit2(this.strm, t2.windowBits);
                        if (r2 !== m.Z_OK) throw new Error(n[r2]);
                        this.header = new s(), c.inflateGetHeader(this.strm, this.header);
                    }
                    function o(e2, t2) {
                        var r2 = new a(t2);
                        if (r2.push(e2, true), r2.err) throw r2.msg || n[r2.err];
                        return r2.result;
                    }
                    a.prototype.push = function(e2, t2) {
                        var r2, n2, i2, s2, a2, o2, h = this.strm, u = this.options.chunkSize, l = this.options.dictionary, f = false;
                        if (this.ended) return false;
                        n2 = t2 === ~~t2 ? t2 : true === t2 ? m.Z_FINISH : m.Z_NO_FLUSH, "string" == typeof e2 ? h.input = p.binstring2buf(e2) : "[object ArrayBuffer]" === _.call(e2) ? h.input = new Uint8Array(e2) : h.input = e2, h.next_in = 0, h.avail_in = h.input.length;
                        do {
                            if (0 === h.avail_out && (h.output = new d.Buf8(u), h.next_out = 0, h.avail_out = u), (r2 = c.inflate(h, m.Z_NO_FLUSH)) === m.Z_NEED_DICT && l && (o2 = "string" == typeof l ? p.string2buf(l) : "[object ArrayBuffer]" === _.call(l) ? new Uint8Array(l) : l, r2 = c.inflateSetDictionary(this.strm, o2)), r2 === m.Z_BUF_ERROR && true === f && (r2 = m.Z_OK, f = false), r2 !== m.Z_STREAM_END && r2 !== m.Z_OK) return this.onEnd(r2), this.ended = true, false;
                            h.next_out && (0 !== h.avail_out && r2 !== m.Z_STREAM_END && (0 !== h.avail_in || n2 !== m.Z_FINISH && n2 !== m.Z_SYNC_FLUSH) || ("string" === this.options.to ? (i2 = p.utf8border(h.output, h.next_out), s2 = h.next_out - i2, a2 = p.buf2string(h.output, i2), h.next_out = s2, h.avail_out = u - s2, s2 && d.arraySet(h.output, h.output, i2, s2, 0), this.onData(a2)) : this.onData(d.shrinkBuf(h.output, h.next_out)))), 0 === h.avail_in && 0 === h.avail_out && (f = true);
                        }while ((0 < h.avail_in || 0 === h.avail_out) && r2 !== m.Z_STREAM_END);
                        return r2 === m.Z_STREAM_END && (n2 = m.Z_FINISH), n2 === m.Z_FINISH ? (r2 = c.inflateEnd(this.strm), this.onEnd(r2), this.ended = true, r2 === m.Z_OK) : n2 !== m.Z_SYNC_FLUSH || (this.onEnd(m.Z_OK), h.avail_out = 0, true);
                    }, a.prototype.onData = function(e2) {
                        this.chunks.push(e2);
                    }, a.prototype.onEnd = function(e2) {
                        e2 === m.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = d.flattenChunks(this.chunks)), this.chunks = [], this.err = e2, this.msg = this.strm.msg;
                    }, r.Inflate = a, r.inflate = o, r.inflateRaw = function(e2, t2) {
                        return (t2 = t2 || {}).raw = true, o(e2, t2);
                    }, r.ungzip = o;
                },
                {
                    "./utils/common": 41,
                    "./utils/strings": 42,
                    "./zlib/constants": 44,
                    "./zlib/gzheader": 47,
                    "./zlib/inflate": 49,
                    "./zlib/messages": 51,
                    "./zlib/zstream": 53
                }
            ],
            41: [
                function(e, t, r) {
                    var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                    r.assign = function(e2) {
                        for(var t2 = Array.prototype.slice.call(arguments, 1); t2.length;){
                            var r2 = t2.shift();
                            if (r2) {
                                if ("object" != (typeof r2 === "undefined" ? "undefined" : (0, $2bfPH._)(r2))) throw new TypeError(r2 + "must be non-object");
                                for(var n2 in r2)r2.hasOwnProperty(n2) && (e2[n2] = r2[n2]);
                            }
                        }
                        return e2;
                    }, r.shrinkBuf = function(e2, t2) {
                        return e2.length === t2 ? e2 : e2.subarray ? e2.subarray(0, t2) : (e2.length = t2, e2);
                    };
                    var i = {
                        arraySet: function arraySet(e2, t2, r2, n2, i2) {
                            if (t2.subarray && e2.subarray) e2.set(t2.subarray(r2, r2 + n2), i2);
                            else for(var s2 = 0; s2 < n2; s2++)e2[i2 + s2] = t2[r2 + s2];
                        },
                        flattenChunks: function flattenChunks(e2) {
                            var t2, r2, n2, i2, s2, a;
                            for(t2 = n2 = 0, r2 = e2.length; t2 < r2; t2++)n2 += e2[t2].length;
                            for(a = new Uint8Array(n2), t2 = i2 = 0, r2 = e2.length; t2 < r2; t2++)s2 = e2[t2], a.set(s2, i2), i2 += s2.length;
                            return a;
                        }
                    }, s = {
                        arraySet: function arraySet(e2, t2, r2, n2, i2) {
                            for(var s2 = 0; s2 < n2; s2++)e2[i2 + s2] = t2[r2 + s2];
                        },
                        flattenChunks: function flattenChunks(e2) {
                            return [].concat.apply([], e2);
                        }
                    };
                    r.setTyped = function(e2) {
                        e2 ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
                    }, r.setTyped(n);
                },
                {}
            ],
            42: [
                function(e, t, r) {
                    var h = e("./common"), i = true, s = true;
                    try {
                        String.fromCharCode.apply(null, [
                            0
                        ]);
                    } catch (e2) {
                        i = false;
                    }
                    try {
                        String.fromCharCode.apply(null, new Uint8Array(1));
                    } catch (e2) {
                        s = false;
                    }
                    for(var u = new h.Buf8(256), n = 0; n < 256; n++)u[n] = 252 <= n ? 6 : 248 <= n ? 5 : 240 <= n ? 4 : 224 <= n ? 3 : 192 <= n ? 2 : 1;
                    function l(e2, t2) {
                        if (t2 < 65537 && (e2.subarray && s || !e2.subarray && i)) return String.fromCharCode.apply(null, h.shrinkBuf(e2, t2));
                        for(var r2 = "", n2 = 0; n2 < t2; n2++)r2 += String.fromCharCode(e2[n2]);
                        return r2;
                    }
                    u[254] = u[254] = 1, r.string2buf = function(e2) {
                        var t2, r2, n2, i2, s2, a = e2.length, o = 0;
                        for(i2 = 0; i2 < a; i2++)55296 == (64512 & (r2 = e2.charCodeAt(i2))) && i2 + 1 < a && 56320 == (64512 & (n2 = e2.charCodeAt(i2 + 1))) && (r2 = 65536 + (r2 - 55296 << 10) + (n2 - 56320), i2++), o += r2 < 128 ? 1 : r2 < 2048 ? 2 : r2 < 65536 ? 3 : 4;
                        for(t2 = new h.Buf8(o), i2 = s2 = 0; s2 < o; i2++)55296 == (64512 & (r2 = e2.charCodeAt(i2))) && i2 + 1 < a && 56320 == (64512 & (n2 = e2.charCodeAt(i2 + 1))) && (r2 = 65536 + (r2 - 55296 << 10) + (n2 - 56320), i2++), r2 < 128 ? t2[s2++] = r2 : (r2 < 2048 ? t2[s2++] = 192 | r2 >>> 6 : (r2 < 65536 ? t2[s2++] = 224 | r2 >>> 12 : (t2[s2++] = 240 | r2 >>> 18, t2[s2++] = 128 | r2 >>> 12 & 63), t2[s2++] = 128 | r2 >>> 6 & 63), t2[s2++] = 128 | 63 & r2);
                        return t2;
                    }, r.buf2binstring = function(e2) {
                        return l(e2, e2.length);
                    }, r.binstring2buf = function(e2) {
                        for(var t2 = new h.Buf8(e2.length), r2 = 0, n2 = t2.length; r2 < n2; r2++)t2[r2] = e2.charCodeAt(r2);
                        return t2;
                    }, r.buf2string = function(e2, t2) {
                        var r2, n2, i2, s2, a = t2 || e2.length, o = new Array(2 * a);
                        for(r2 = n2 = 0; r2 < a;)if ((i2 = e2[r2++]) < 128) o[n2++] = i2;
                        else if (4 < (s2 = u[i2])) o[n2++] = 65533, r2 += s2 - 1;
                        else {
                            for(i2 &= 2 === s2 ? 31 : 3 === s2 ? 15 : 7; 1 < s2 && r2 < a;)i2 = i2 << 6 | 63 & e2[r2++], s2--;
                            1 < s2 ? o[n2++] = 65533 : i2 < 65536 ? o[n2++] = i2 : (i2 -= 65536, o[n2++] = 55296 | i2 >> 10 & 1023, o[n2++] = 56320 | 1023 & i2);
                        }
                        return l(o, n2);
                    }, r.utf8border = function(e2, t2) {
                        var r2;
                        for((t2 = t2 || e2.length) > e2.length && (t2 = e2.length), r2 = t2 - 1; 0 <= r2 && 128 == (192 & e2[r2]);)r2--;
                        return r2 < 0 ? t2 : 0 === r2 ? t2 : r2 + u[e2[r2]] > t2 ? r2 : t2;
                    };
                },
                {
                    "./common": 41
                }
            ],
            43: [
                function(e, t, r) {
                    t.exports = function(e2, t2, r2, n) {
                        for(var i = 65535 & e2 | 0, s = e2 >>> 16 & 65535 | 0, a = 0; 0 !== r2;){
                            for(r2 -= a = 2e3 < r2 ? 2e3 : r2; s = s + (i = i + t2[n++] | 0) | 0, --a;);
                            i %= 65521, s %= 65521;
                        }
                        return i | s << 16 | 0;
                    };
                },
                {}
            ],
            44: [
                function(e, t, r) {
                    t.exports = {
                        Z_NO_FLUSH: 0,
                        Z_PARTIAL_FLUSH: 1,
                        Z_SYNC_FLUSH: 2,
                        Z_FULL_FLUSH: 3,
                        Z_FINISH: 4,
                        Z_BLOCK: 5,
                        Z_TREES: 6,
                        Z_OK: 0,
                        Z_STREAM_END: 1,
                        Z_NEED_DICT: 2,
                        Z_ERRNO: -1,
                        Z_STREAM_ERROR: -2,
                        Z_DATA_ERROR: -3,
                        Z_BUF_ERROR: -5,
                        Z_NO_COMPRESSION: 0,
                        Z_BEST_SPEED: 1,
                        Z_BEST_COMPRESSION: 9,
                        Z_DEFAULT_COMPRESSION: -1,
                        Z_FILTERED: 1,
                        Z_HUFFMAN_ONLY: 2,
                        Z_RLE: 3,
                        Z_FIXED: 4,
                        Z_DEFAULT_STRATEGY: 0,
                        Z_BINARY: 0,
                        Z_TEXT: 1,
                        Z_UNKNOWN: 2,
                        Z_DEFLATED: 8
                    };
                },
                {}
            ],
            45: [
                function(e, t, r) {
                    var o = function() {
                        for(var e2, t2 = [], r2 = 0; r2 < 256; r2++){
                            e2 = r2;
                            for(var n = 0; n < 8; n++)e2 = 1 & e2 ? 3988292384 ^ e2 >>> 1 : e2 >>> 1;
                            t2[r2] = e2;
                        }
                        return t2;
                    }();
                    t.exports = function(e2, t2, r2, n) {
                        var i = o, s = n + r2;
                        e2 ^= -1;
                        for(var a = n; a < s; a++)e2 = e2 >>> 8 ^ i[255 & (e2 ^ t2[a])];
                        return -1 ^ e2;
                    };
                },
                {}
            ],
            46: [
                function(e, t, r) {
                    var h, c = e("../utils/common"), u = e("./trees"), d = e("./adler32"), p = e("./crc32"), n = e("./messages"), l = 0, f = 4, m = 0, _ = -2, g = -1, b = 4, i = 2, v = 8, y = 9, s = 286, a = 30, o = 19, w = 2 * s + 1, k = 15, x = 3, S = 258, z = S + x + 1, C = 42, E = 113, A = 1, I = 2, O = 3, B = 4;
                    function R2(e2, t2) {
                        return e2.msg = n[t2], t2;
                    }
                    function T(e2) {
                        return (e2 << 1) - (4 < e2 ? 9 : 0);
                    }
                    function D(e2) {
                        for(var t2 = e2.length; 0 <= --t2;)e2[t2] = 0;
                    }
                    function F(e2) {
                        var t2 = e2.state, r2 = t2.pending;
                        r2 > e2.avail_out && (r2 = e2.avail_out), 0 !== r2 && (c.arraySet(e2.output, t2.pending_buf, t2.pending_out, r2, e2.next_out), e2.next_out += r2, t2.pending_out += r2, e2.total_out += r2, e2.avail_out -= r2, t2.pending -= r2, 0 === t2.pending && (t2.pending_out = 0));
                    }
                    function N(e2, t2) {
                        u._tr_flush_block(e2, 0 <= e2.block_start ? e2.block_start : -1, e2.strstart - e2.block_start, t2), e2.block_start = e2.strstart, F(e2.strm);
                    }
                    function U(e2, t2) {
                        e2.pending_buf[e2.pending++] = t2;
                    }
                    function P(e2, t2) {
                        e2.pending_buf[e2.pending++] = t2 >>> 8 & 255, e2.pending_buf[e2.pending++] = 255 & t2;
                    }
                    function L(e2, t2) {
                        var r2, n2, i2 = e2.max_chain_length, s2 = e2.strstart, a2 = e2.prev_length, o2 = e2.nice_match, h2 = e2.strstart > e2.w_size - z ? e2.strstart - (e2.w_size - z) : 0, u2 = e2.window, l2 = e2.w_mask, f2 = e2.prev, c2 = e2.strstart + S, d2 = u2[s2 + a2 - 1], p2 = u2[s2 + a2];
                        e2.prev_length >= e2.good_match && (i2 >>= 2), o2 > e2.lookahead && (o2 = e2.lookahead);
                        do if (u2[(r2 = t2) + a2] === p2 && u2[r2 + a2 - 1] === d2 && u2[r2] === u2[s2] && u2[++r2] === u2[s2 + 1]) {
                            s2 += 2, r2++;
                            do ;
                            while (u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && s2 < c2);
                            if (n2 = S - (c2 - s2), s2 = c2 - S, a2 < n2) {
                                if (e2.match_start = t2, o2 <= (a2 = n2)) break;
                                d2 = u2[s2 + a2 - 1], p2 = u2[s2 + a2];
                            }
                        }
                        while ((t2 = f2[t2 & l2]) > h2 && 0 != --i2);
                        return a2 <= e2.lookahead ? a2 : e2.lookahead;
                    }
                    function j(e2) {
                        var t2, r2, n2, i2, s2, a2, o2, h2, u2, l2, f2 = e2.w_size;
                        do {
                            if (i2 = e2.window_size - e2.lookahead - e2.strstart, e2.strstart >= f2 + (f2 - z)) {
                                for(c.arraySet(e2.window, e2.window, f2, f2, 0), e2.match_start -= f2, e2.strstart -= f2, e2.block_start -= f2, t2 = r2 = e2.hash_size; n2 = e2.head[--t2], e2.head[t2] = f2 <= n2 ? n2 - f2 : 0, --r2;);
                                for(t2 = r2 = f2; n2 = e2.prev[--t2], e2.prev[t2] = f2 <= n2 ? n2 - f2 : 0, --r2;);
                                i2 += f2;
                            }
                            if (0 === e2.strm.avail_in) break;
                            if (a2 = e2.strm, o2 = e2.window, h2 = e2.strstart + e2.lookahead, u2 = i2, l2 = void 0, l2 = a2.avail_in, u2 < l2 && (l2 = u2), r2 = 0 === l2 ? 0 : (a2.avail_in -= l2, c.arraySet(o2, a2.input, a2.next_in, l2, h2), 1 === a2.state.wrap ? a2.adler = d(a2.adler, o2, l2, h2) : 2 === a2.state.wrap && (a2.adler = p(a2.adler, o2, l2, h2)), a2.next_in += l2, a2.total_in += l2, l2), e2.lookahead += r2, e2.lookahead + e2.insert >= x) for(s2 = e2.strstart - e2.insert, e2.ins_h = e2.window[s2], e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[s2 + 1]) & e2.hash_mask; e2.insert && (e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[s2 + x - 1]) & e2.hash_mask, e2.prev[s2 & e2.w_mask] = e2.head[e2.ins_h], e2.head[e2.ins_h] = s2, s2++, e2.insert--, !(e2.lookahead + e2.insert < x)););
                        }while (e2.lookahead < z && 0 !== e2.strm.avail_in);
                    }
                    function Z(e2, t2) {
                        for(var r2, n2;;){
                            if (e2.lookahead < z) {
                                if (j(e2), e2.lookahead < z && t2 === l) return A;
                                if (0 === e2.lookahead) break;
                            }
                            if (r2 = 0, e2.lookahead >= x && (e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[e2.strstart + x - 1]) & e2.hash_mask, r2 = e2.prev[e2.strstart & e2.w_mask] = e2.head[e2.ins_h], e2.head[e2.ins_h] = e2.strstart), 0 !== r2 && e2.strstart - r2 <= e2.w_size - z && (e2.match_length = L(e2, r2)), e2.match_length >= x) {
                                if (n2 = u._tr_tally(e2, e2.strstart - e2.match_start, e2.match_length - x), e2.lookahead -= e2.match_length, e2.match_length <= e2.max_lazy_match && e2.lookahead >= x) {
                                    for(e2.match_length--; e2.strstart++, e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[e2.strstart + x - 1]) & e2.hash_mask, r2 = e2.prev[e2.strstart & e2.w_mask] = e2.head[e2.ins_h], e2.head[e2.ins_h] = e2.strstart, 0 != --e2.match_length;);
                                    e2.strstart++;
                                } else e2.strstart += e2.match_length, e2.match_length = 0, e2.ins_h = e2.window[e2.strstart], e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[e2.strstart + 1]) & e2.hash_mask;
                            } else n2 = u._tr_tally(e2, 0, e2.window[e2.strstart]), e2.lookahead--, e2.strstart++;
                            if (n2 && (N(e2, false), 0 === e2.strm.avail_out)) return A;
                        }
                        return e2.insert = e2.strstart < x - 1 ? e2.strstart : x - 1, t2 === f ? (N(e2, true), 0 === e2.strm.avail_out ? O : B) : e2.last_lit && (N(e2, false), 0 === e2.strm.avail_out) ? A : I;
                    }
                    function W(e2, t2) {
                        for(var r2, n2, i2;;){
                            if (e2.lookahead < z) {
                                if (j(e2), e2.lookahead < z && t2 === l) return A;
                                if (0 === e2.lookahead) break;
                            }
                            if (r2 = 0, e2.lookahead >= x && (e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[e2.strstart + x - 1]) & e2.hash_mask, r2 = e2.prev[e2.strstart & e2.w_mask] = e2.head[e2.ins_h], e2.head[e2.ins_h] = e2.strstart), e2.prev_length = e2.match_length, e2.prev_match = e2.match_start, e2.match_length = x - 1, 0 !== r2 && e2.prev_length < e2.max_lazy_match && e2.strstart - r2 <= e2.w_size - z && (e2.match_length = L(e2, r2), e2.match_length <= 5 && (1 === e2.strategy || e2.match_length === x && 4096 < e2.strstart - e2.match_start) && (e2.match_length = x - 1)), e2.prev_length >= x && e2.match_length <= e2.prev_length) {
                                for(i2 = e2.strstart + e2.lookahead - x, n2 = u._tr_tally(e2, e2.strstart - 1 - e2.prev_match, e2.prev_length - x), e2.lookahead -= e2.prev_length - 1, e2.prev_length -= 2; ++e2.strstart <= i2 && (e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[e2.strstart + x - 1]) & e2.hash_mask, r2 = e2.prev[e2.strstart & e2.w_mask] = e2.head[e2.ins_h], e2.head[e2.ins_h] = e2.strstart), 0 != --e2.prev_length;);
                                if (e2.match_available = 0, e2.match_length = x - 1, e2.strstart++, n2 && (N(e2, false), 0 === e2.strm.avail_out)) return A;
                            } else if (e2.match_available) {
                                if ((n2 = u._tr_tally(e2, 0, e2.window[e2.strstart - 1])) && N(e2, false), e2.strstart++, e2.lookahead--, 0 === e2.strm.avail_out) return A;
                            } else e2.match_available = 1, e2.strstart++, e2.lookahead--;
                        }
                        return e2.match_available && (n2 = u._tr_tally(e2, 0, e2.window[e2.strstart - 1]), e2.match_available = 0), e2.insert = e2.strstart < x - 1 ? e2.strstart : x - 1, t2 === f ? (N(e2, true), 0 === e2.strm.avail_out ? O : B) : e2.last_lit && (N(e2, false), 0 === e2.strm.avail_out) ? A : I;
                    }
                    function M(e2, t2, r2, n2, i2) {
                        this.good_length = e2, this.max_lazy = t2, this.nice_length = r2, this.max_chain = n2, this.func = i2;
                    }
                    function H() {
                        this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = v, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new c.Buf16(2 * w), this.dyn_dtree = new c.Buf16(2 * (2 * a + 1)), this.bl_tree = new c.Buf16(2 * (2 * o + 1)), D(this.dyn_ltree), D(this.dyn_dtree), D(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new c.Buf16(k + 1), this.heap = new c.Buf16(2 * s + 1), D(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new c.Buf16(2 * s + 1), D(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                    }
                    function G(e2) {
                        var t2;
                        return e2 && e2.state ? (e2.total_in = e2.total_out = 0, e2.data_type = i, (t2 = e2.state).pending = 0, t2.pending_out = 0, t2.wrap < 0 && (t2.wrap = -t2.wrap), t2.status = t2.wrap ? C : E, e2.adler = 2 === t2.wrap ? 0 : 1, t2.last_flush = l, u._tr_init(t2), m) : R2(e2, _);
                    }
                    function K(e2) {
                        var t2 = G(e2);
                        return t2 === m && function(e3) {
                            e3.window_size = 2 * e3.w_size, D(e3.head), e3.max_lazy_match = h[e3.level].max_lazy, e3.good_match = h[e3.level].good_length, e3.nice_match = h[e3.level].nice_length, e3.max_chain_length = h[e3.level].max_chain, e3.strstart = 0, e3.block_start = 0, e3.lookahead = 0, e3.insert = 0, e3.match_length = e3.prev_length = x - 1, e3.match_available = 0, e3.ins_h = 0;
                        }(e2.state), t2;
                    }
                    function Y(e2, t2, r2, n2, i2, s2) {
                        if (!e2) return _;
                        var a2 = 1;
                        if (t2 === g && (t2 = 6), n2 < 0 ? (a2 = 0, n2 = -n2) : 15 < n2 && (a2 = 2, n2 -= 16), i2 < 1 || y < i2 || r2 !== v || n2 < 8 || 15 < n2 || t2 < 0 || 9 < t2 || s2 < 0 || b < s2) return R2(e2, _);
                        8 === n2 && (n2 = 9);
                        var o2 = new H();
                        return (e2.state = o2).strm = e2, o2.wrap = a2, o2.gzhead = null, o2.w_bits = n2, o2.w_size = 1 << o2.w_bits, o2.w_mask = o2.w_size - 1, o2.hash_bits = i2 + 7, o2.hash_size = 1 << o2.hash_bits, o2.hash_mask = o2.hash_size - 1, o2.hash_shift = ~~((o2.hash_bits + x - 1) / x), o2.window = new c.Buf8(2 * o2.w_size), o2.head = new c.Buf16(o2.hash_size), o2.prev = new c.Buf16(o2.w_size), o2.lit_bufsize = 1 << i2 + 6, o2.pending_buf_size = 4 * o2.lit_bufsize, o2.pending_buf = new c.Buf8(o2.pending_buf_size), o2.d_buf = 1 * o2.lit_bufsize, o2.l_buf = 3 * o2.lit_bufsize, o2.level = t2, o2.strategy = s2, o2.method = r2, K(e2);
                    }
                    h = [
                        new M(0, 0, 0, 0, function(e2, t2) {
                            var r2 = 65535;
                            for(r2 > e2.pending_buf_size - 5 && (r2 = e2.pending_buf_size - 5);;){
                                if (e2.lookahead <= 1) {
                                    if (j(e2), 0 === e2.lookahead && t2 === l) return A;
                                    if (0 === e2.lookahead) break;
                                }
                                e2.strstart += e2.lookahead, e2.lookahead = 0;
                                var n2 = e2.block_start + r2;
                                if ((0 === e2.strstart || e2.strstart >= n2) && (e2.lookahead = e2.strstart - n2, e2.strstart = n2, N(e2, false), 0 === e2.strm.avail_out)) return A;
                                if (e2.strstart - e2.block_start >= e2.w_size - z && (N(e2, false), 0 === e2.strm.avail_out)) return A;
                            }
                            return e2.insert = 0, t2 === f ? (N(e2, true), 0 === e2.strm.avail_out ? O : B) : (e2.strstart > e2.block_start && (N(e2, false), e2.strm.avail_out), A);
                        }),
                        new M(4, 4, 8, 4, Z),
                        new M(4, 5, 16, 8, Z),
                        new M(4, 6, 32, 32, Z),
                        new M(4, 4, 16, 16, W),
                        new M(8, 16, 32, 32, W),
                        new M(8, 16, 128, 128, W),
                        new M(8, 32, 128, 256, W),
                        new M(32, 128, 258, 1024, W),
                        new M(32, 258, 258, 4096, W)
                    ], r.deflateInit = function(e2, t2) {
                        return Y(e2, t2, v, 15, 8, 0);
                    }, r.deflateInit2 = Y, r.deflateReset = K, r.deflateResetKeep = G, r.deflateSetHeader = function(e2, t2) {
                        return e2 && e2.state ? 2 !== e2.state.wrap ? _ : (e2.state.gzhead = t2, m) : _;
                    }, r.deflate = function(e2, t2) {
                        var r2, n2, i2, s2;
                        if (!e2 || !e2.state || 5 < t2 || t2 < 0) return e2 ? R2(e2, _) : _;
                        if (n2 = e2.state, !e2.output || !e2.input && 0 !== e2.avail_in || 666 === n2.status && t2 !== f) return R2(e2, 0 === e2.avail_out ? -5 : _);
                        if (n2.strm = e2, r2 = n2.last_flush, n2.last_flush = t2, n2.status === C) {
                            if (2 === n2.wrap) e2.adler = 0, U(n2, 31), U(n2, 139), U(n2, 8), n2.gzhead ? (U(n2, (n2.gzhead.text ? 1 : 0) + (n2.gzhead.hcrc ? 2 : 0) + (n2.gzhead.extra ? 4 : 0) + (n2.gzhead.name ? 8 : 0) + (n2.gzhead.comment ? 16 : 0)), U(n2, 255 & n2.gzhead.time), U(n2, n2.gzhead.time >> 8 & 255), U(n2, n2.gzhead.time >> 16 & 255), U(n2, n2.gzhead.time >> 24 & 255), U(n2, 9 === n2.level ? 2 : 2 <= n2.strategy || n2.level < 2 ? 4 : 0), U(n2, 255 & n2.gzhead.os), n2.gzhead.extra && n2.gzhead.extra.length && (U(n2, 255 & n2.gzhead.extra.length), U(n2, n2.gzhead.extra.length >> 8 & 255)), n2.gzhead.hcrc && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending, 0)), n2.gzindex = 0, n2.status = 69) : (U(n2, 0), U(n2, 0), U(n2, 0), U(n2, 0), U(n2, 0), U(n2, 9 === n2.level ? 2 : 2 <= n2.strategy || n2.level < 2 ? 4 : 0), U(n2, 3), n2.status = E);
                            else {
                                var a2 = v + (n2.w_bits - 8 << 4) << 8;
                                a2 |= (2 <= n2.strategy || n2.level < 2 ? 0 : n2.level < 6 ? 1 : 6 === n2.level ? 2 : 3) << 6, 0 !== n2.strstart && (a2 |= 32), a2 += 31 - a2 % 31, n2.status = E, P(n2, a2), 0 !== n2.strstart && (P(n2, e2.adler >>> 16), P(n2, 65535 & e2.adler)), e2.adler = 1;
                            }
                        }
                        if (69 === n2.status) {
                            if (n2.gzhead.extra) {
                                for(i2 = n2.pending; n2.gzindex < (65535 & n2.gzhead.extra.length) && (n2.pending !== n2.pending_buf_size || (n2.gzhead.hcrc && n2.pending > i2 && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending - i2, i2)), F(e2), i2 = n2.pending, n2.pending !== n2.pending_buf_size));)U(n2, 255 & n2.gzhead.extra[n2.gzindex]), n2.gzindex++;
                                n2.gzhead.hcrc && n2.pending > i2 && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending - i2, i2)), n2.gzindex === n2.gzhead.extra.length && (n2.gzindex = 0, n2.status = 73);
                            } else n2.status = 73;
                        }
                        if (73 === n2.status) {
                            if (n2.gzhead.name) {
                                i2 = n2.pending;
                                do {
                                    if (n2.pending === n2.pending_buf_size && (n2.gzhead.hcrc && n2.pending > i2 && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending - i2, i2)), F(e2), i2 = n2.pending, n2.pending === n2.pending_buf_size)) {
                                        s2 = 1;
                                        break;
                                    }
                                    s2 = n2.gzindex < n2.gzhead.name.length ? 255 & n2.gzhead.name.charCodeAt(n2.gzindex++) : 0, U(n2, s2);
                                }while (0 !== s2);
                                n2.gzhead.hcrc && n2.pending > i2 && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending - i2, i2)), 0 === s2 && (n2.gzindex = 0, n2.status = 91);
                            } else n2.status = 91;
                        }
                        if (91 === n2.status) {
                            if (n2.gzhead.comment) {
                                i2 = n2.pending;
                                do {
                                    if (n2.pending === n2.pending_buf_size && (n2.gzhead.hcrc && n2.pending > i2 && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending - i2, i2)), F(e2), i2 = n2.pending, n2.pending === n2.pending_buf_size)) {
                                        s2 = 1;
                                        break;
                                    }
                                    s2 = n2.gzindex < n2.gzhead.comment.length ? 255 & n2.gzhead.comment.charCodeAt(n2.gzindex++) : 0, U(n2, s2);
                                }while (0 !== s2);
                                n2.gzhead.hcrc && n2.pending > i2 && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending - i2, i2)), 0 === s2 && (n2.status = 103);
                            } else n2.status = 103;
                        }
                        if (103 === n2.status && (n2.gzhead.hcrc ? (n2.pending + 2 > n2.pending_buf_size && F(e2), n2.pending + 2 <= n2.pending_buf_size && (U(n2, 255 & e2.adler), U(n2, e2.adler >> 8 & 255), e2.adler = 0, n2.status = E)) : n2.status = E), 0 !== n2.pending) {
                            if (F(e2), 0 === e2.avail_out) return n2.last_flush = -1, m;
                        } else if (0 === e2.avail_in && T(t2) <= T(r2) && t2 !== f) return R2(e2, -5);
                        if (666 === n2.status && 0 !== e2.avail_in) return R2(e2, -5);
                        if (0 !== e2.avail_in || 0 !== n2.lookahead || t2 !== l && 666 !== n2.status) {
                            var o2 = 2 === n2.strategy ? function(e3, t3) {
                                for(var r3;;){
                                    if (0 === e3.lookahead && (j(e3), 0 === e3.lookahead)) {
                                        if (t3 === l) return A;
                                        break;
                                    }
                                    if (e3.match_length = 0, r3 = u._tr_tally(e3, 0, e3.window[e3.strstart]), e3.lookahead--, e3.strstart++, r3 && (N(e3, false), 0 === e3.strm.avail_out)) return A;
                                }
                                return e3.insert = 0, t3 === f ? (N(e3, true), 0 === e3.strm.avail_out ? O : B) : e3.last_lit && (N(e3, false), 0 === e3.strm.avail_out) ? A : I;
                            }(n2, t2) : 3 === n2.strategy ? function(e3, t3) {
                                for(var r3, n3, i3, s3, a3 = e3.window;;){
                                    if (e3.lookahead <= S) {
                                        if (j(e3), e3.lookahead <= S && t3 === l) return A;
                                        if (0 === e3.lookahead) break;
                                    }
                                    if (e3.match_length = 0, e3.lookahead >= x && 0 < e3.strstart && (n3 = a3[i3 = e3.strstart - 1]) === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3]) {
                                        s3 = e3.strstart + S;
                                        do ;
                                        while (n3 === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3] && i3 < s3);
                                        e3.match_length = S - (s3 - i3), e3.match_length > e3.lookahead && (e3.match_length = e3.lookahead);
                                    }
                                    if (e3.match_length >= x ? (r3 = u._tr_tally(e3, 1, e3.match_length - x), e3.lookahead -= e3.match_length, e3.strstart += e3.match_length, e3.match_length = 0) : (r3 = u._tr_tally(e3, 0, e3.window[e3.strstart]), e3.lookahead--, e3.strstart++), r3 && (N(e3, false), 0 === e3.strm.avail_out)) return A;
                                }
                                return e3.insert = 0, t3 === f ? (N(e3, true), 0 === e3.strm.avail_out ? O : B) : e3.last_lit && (N(e3, false), 0 === e3.strm.avail_out) ? A : I;
                            }(n2, t2) : h[n2.level].func(n2, t2);
                            if (o2 !== O && o2 !== B || (n2.status = 666), o2 === A || o2 === O) return 0 === e2.avail_out && (n2.last_flush = -1), m;
                            if (o2 === I && (1 === t2 ? u._tr_align(n2) : 5 !== t2 && (u._tr_stored_block(n2, 0, 0, false), 3 === t2 && (D(n2.head), 0 === n2.lookahead && (n2.strstart = 0, n2.block_start = 0, n2.insert = 0))), F(e2), 0 === e2.avail_out)) return n2.last_flush = -1, m;
                        }
                        return t2 !== f ? m : n2.wrap <= 0 ? 1 : (2 === n2.wrap ? (U(n2, 255 & e2.adler), U(n2, e2.adler >> 8 & 255), U(n2, e2.adler >> 16 & 255), U(n2, e2.adler >> 24 & 255), U(n2, 255 & e2.total_in), U(n2, e2.total_in >> 8 & 255), U(n2, e2.total_in >> 16 & 255), U(n2, e2.total_in >> 24 & 255)) : (P(n2, e2.adler >>> 16), P(n2, 65535 & e2.adler)), F(e2), 0 < n2.wrap && (n2.wrap = -n2.wrap), 0 !== n2.pending ? m : 1);
                    }, r.deflateEnd = function(e2) {
                        var t2;
                        return e2 && e2.state ? (t2 = e2.state.status) !== C && 69 !== t2 && 73 !== t2 && 91 !== t2 && 103 !== t2 && t2 !== E && 666 !== t2 ? R2(e2, _) : (e2.state = null, t2 === E ? R2(e2, -3) : m) : _;
                    }, r.deflateSetDictionary = function(e2, t2) {
                        var r2, n2, i2, s2, a2, o2, h2, u2, l2 = t2.length;
                        if (!e2 || !e2.state) return _;
                        if (2 === (s2 = (r2 = e2.state).wrap) || 1 === s2 && r2.status !== C || r2.lookahead) return _;
                        for(1 === s2 && (e2.adler = d(e2.adler, t2, l2, 0)), r2.wrap = 0, l2 >= r2.w_size && (0 === s2 && (D(r2.head), r2.strstart = 0, r2.block_start = 0, r2.insert = 0), u2 = new c.Buf8(r2.w_size), c.arraySet(u2, t2, l2 - r2.w_size, r2.w_size, 0), t2 = u2, l2 = r2.w_size), a2 = e2.avail_in, o2 = e2.next_in, h2 = e2.input, e2.avail_in = l2, e2.next_in = 0, e2.input = t2, j(r2); r2.lookahead >= x;){
                            for(n2 = r2.strstart, i2 = r2.lookahead - (x - 1); r2.ins_h = (r2.ins_h << r2.hash_shift ^ r2.window[n2 + x - 1]) & r2.hash_mask, r2.prev[n2 & r2.w_mask] = r2.head[r2.ins_h], r2.head[r2.ins_h] = n2, n2++, --i2;);
                            r2.strstart = n2, r2.lookahead = x - 1, j(r2);
                        }
                        return r2.strstart += r2.lookahead, r2.block_start = r2.strstart, r2.insert = r2.lookahead, r2.lookahead = 0, r2.match_length = r2.prev_length = x - 1, r2.match_available = 0, e2.next_in = o2, e2.input = h2, e2.avail_in = a2, r2.wrap = s2, m;
                    }, r.deflateInfo = "pako deflate (from Nodeca project)";
                },
                {
                    "../utils/common": 41,
                    "./adler32": 43,
                    "./crc32": 45,
                    "./messages": 51,
                    "./trees": 52
                }
            ],
            47: [
                function(e, t, r) {
                    t.exports = function() {
                        this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = false;
                    };
                },
                {}
            ],
            48: [
                function(e, t, r) {
                    t.exports = function(e2, t2) {
                        var r2, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C;
                        r2 = e2.state, n = e2.next_in, z = e2.input, i = n + (e2.avail_in - 5), s = e2.next_out, C = e2.output, a = s - (t2 - e2.avail_out), o = s + (e2.avail_out - 257), h = r2.dmax, u = r2.wsize, l = r2.whave, f = r2.wnext, c = r2.window, d = r2.hold, p = r2.bits, m = r2.lencode, _ = r2.distcode, g = (1 << r2.lenbits) - 1, b = (1 << r2.distbits) - 1;
                        e: do {
                            p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = m[d & g];
                            t: for(;;){
                                if (d >>>= y = v >>> 24, p -= y, 0 === (y = v >>> 16 & 255)) C[s++] = 65535 & v;
                                else {
                                    if (!(16 & y)) {
                                        if (0 == (64 & y)) {
                                            v = m[(65535 & v) + (d & (1 << y) - 1)];
                                            continue t;
                                        }
                                        if (32 & y) {
                                            r2.mode = 12;
                                            break e;
                                        }
                                        e2.msg = "invalid literal/length code", r2.mode = 30;
                                        break e;
                                    }
                                    w = 65535 & v, (y &= 15) && (p < y && (d += z[n++] << p, p += 8), w += d & (1 << y) - 1, d >>>= y, p -= y), p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = _[d & b];
                                    r: for(;;){
                                        if (d >>>= y = v >>> 24, p -= y, !(16 & (y = v >>> 16 & 255))) {
                                            if (0 == (64 & y)) {
                                                v = _[(65535 & v) + (d & (1 << y) - 1)];
                                                continue r;
                                            }
                                            e2.msg = "invalid distance code", r2.mode = 30;
                                            break e;
                                        }
                                        if (k = 65535 & v, p < (y &= 15) && (d += z[n++] << p, (p += 8) < y && (d += z[n++] << p, p += 8)), h < (k += d & (1 << y) - 1)) {
                                            e2.msg = "invalid distance too far back", r2.mode = 30;
                                            break e;
                                        }
                                        if (d >>>= y, p -= y, (y = s - a) < k) {
                                            if (l < (y = k - y) && r2.sane) {
                                                e2.msg = "invalid distance too far back", r2.mode = 30;
                                                break e;
                                            }
                                            if (S = c, (x = 0) === f) {
                                                if (x += u - y, y < w) {
                                                    for(w -= y; C[s++] = c[x++], --y;);
                                                    x = s - k, S = C;
                                                }
                                            } else if (f < y) {
                                                if (x += u + f - y, (y -= f) < w) {
                                                    for(w -= y; C[s++] = c[x++], --y;);
                                                    if (x = 0, f < w) {
                                                        for(w -= y = f; C[s++] = c[x++], --y;);
                                                        x = s - k, S = C;
                                                    }
                                                }
                                            } else if (x += f - y, y < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                x = s - k, S = C;
                                            }
                                            for(; 2 < w;)C[s++] = S[x++], C[s++] = S[x++], C[s++] = S[x++], w -= 3;
                                            w && (C[s++] = S[x++], 1 < w && (C[s++] = S[x++]));
                                        } else {
                                            for(x = s - k; C[s++] = C[x++], C[s++] = C[x++], C[s++] = C[x++], 2 < (w -= 3););
                                            w && (C[s++] = C[x++], 1 < w && (C[s++] = C[x++]));
                                        }
                                        break;
                                    }
                                }
                                break;
                            }
                        }while (n < i && s < o);
                        n -= w = p >> 3, d &= (1 << (p -= w << 3)) - 1, e2.next_in = n, e2.next_out = s, e2.avail_in = n < i ? i - n + 5 : 5 - (n - i), e2.avail_out = s < o ? o - s + 257 : 257 - (s - o), r2.hold = d, r2.bits = p;
                    };
                },
                {}
            ],
            49: [
                function(e, t, r) {
                    var I = e("../utils/common"), O = e("./adler32"), B = e("./crc32"), R2 = e("./inffast"), T = e("./inftrees"), D = 1, F = 2, N = 0, U = -2, P = 1, n = 852, i = 592;
                    function L(e2) {
                        return (e2 >>> 24 & 255) + (e2 >>> 8 & 65280) + ((65280 & e2) << 8) + ((255 & e2) << 24);
                    }
                    function s() {
                        this.mode = 0, this.last = false, this.wrap = 0, this.havedict = false, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new I.Buf16(320), this.work = new I.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                    }
                    function a(e2) {
                        var t2;
                        return e2 && e2.state ? (t2 = e2.state, e2.total_in = e2.total_out = t2.total = 0, e2.msg = "", t2.wrap && (e2.adler = 1 & t2.wrap), t2.mode = P, t2.last = 0, t2.havedict = 0, t2.dmax = 32768, t2.head = null, t2.hold = 0, t2.bits = 0, t2.lencode = t2.lendyn = new I.Buf32(n), t2.distcode = t2.distdyn = new I.Buf32(i), t2.sane = 1, t2.back = -1, N) : U;
                    }
                    function o(e2) {
                        var t2;
                        return e2 && e2.state ? ((t2 = e2.state).wsize = 0, t2.whave = 0, t2.wnext = 0, a(e2)) : U;
                    }
                    function h(e2, t2) {
                        var r2, n2;
                        return e2 && e2.state ? (n2 = e2.state, t2 < 0 ? (r2 = 0, t2 = -t2) : (r2 = 1 + (t2 >> 4), t2 < 48 && (t2 &= 15)), t2 && (t2 < 8 || 15 < t2) ? U : (null !== n2.window && n2.wbits !== t2 && (n2.window = null), n2.wrap = r2, n2.wbits = t2, o(e2))) : U;
                    }
                    function u(e2, t2) {
                        var r2, n2;
                        return e2 ? (n2 = new s(), (e2.state = n2).window = null, (r2 = h(e2, t2)) !== N && (e2.state = null), r2) : U;
                    }
                    var l, f, c = true;
                    function j(e2) {
                        if (c) {
                            var t2;
                            for(l = new I.Buf32(512), f = new I.Buf32(32), t2 = 0; t2 < 144;)e2.lens[t2++] = 8;
                            for(; t2 < 256;)e2.lens[t2++] = 9;
                            for(; t2 < 280;)e2.lens[t2++] = 7;
                            for(; t2 < 288;)e2.lens[t2++] = 8;
                            for(T(D, e2.lens, 0, 288, l, 0, e2.work, {
                                bits: 9
                            }), t2 = 0; t2 < 32;)e2.lens[t2++] = 5;
                            T(F, e2.lens, 0, 32, f, 0, e2.work, {
                                bits: 5
                            }), c = false;
                        }
                        e2.lencode = l, e2.lenbits = 9, e2.distcode = f, e2.distbits = 5;
                    }
                    function Z(e2, t2, r2, n2) {
                        var i2, s2 = e2.state;
                        return null === s2.window && (s2.wsize = 1 << s2.wbits, s2.wnext = 0, s2.whave = 0, s2.window = new I.Buf8(s2.wsize)), n2 >= s2.wsize ? (I.arraySet(s2.window, t2, r2 - s2.wsize, s2.wsize, 0), s2.wnext = 0, s2.whave = s2.wsize) : (n2 < (i2 = s2.wsize - s2.wnext) && (i2 = n2), I.arraySet(s2.window, t2, r2 - n2, i2, s2.wnext), (n2 -= i2) ? (I.arraySet(s2.window, t2, r2 - n2, n2, 0), s2.wnext = n2, s2.whave = s2.wsize) : (s2.wnext += i2, s2.wnext === s2.wsize && (s2.wnext = 0), s2.whave < s2.wsize && (s2.whave += i2))), 0;
                    }
                    r.inflateReset = o, r.inflateReset2 = h, r.inflateResetKeep = a, r.inflateInit = function(e2) {
                        return u(e2, 15);
                    }, r.inflateInit2 = u, r.inflate = function(e2, t2) {
                        var r2, n2, i2, s2, a2, o2, h2, u2, l2, f2, c2, d, p, m, _, g, b, v, y, w, k, x, S, z, C = 0, E = new I.Buf8(4), A = [
                            16,
                            17,
                            18,
                            0,
                            8,
                            7,
                            9,
                            6,
                            10,
                            5,
                            11,
                            4,
                            12,
                            3,
                            13,
                            2,
                            14,
                            1,
                            15
                        ];
                        if (!e2 || !e2.state || !e2.output || !e2.input && 0 !== e2.avail_in) return U;
                        12 === (r2 = e2.state).mode && (r2.mode = 13), a2 = e2.next_out, i2 = e2.output, h2 = e2.avail_out, s2 = e2.next_in, n2 = e2.input, o2 = e2.avail_in, u2 = r2.hold, l2 = r2.bits, f2 = o2, c2 = h2, x = N;
                        e: for(;;)switch(r2.mode){
                            case P:
                                if (0 === r2.wrap) {
                                    r2.mode = 13;
                                    break;
                                }
                                for(; l2 < 16;){
                                    if (0 === o2) break e;
                                    o2--, u2 += n2[s2++] << l2, l2 += 8;
                                }
                                if (2 & r2.wrap && 35615 === u2) {
                                    E[r2.check = 0] = 255 & u2, E[1] = u2 >>> 8 & 255, r2.check = B(r2.check, E, 2, 0), l2 = u2 = 0, r2.mode = 2;
                                    break;
                                }
                                if (r2.flags = 0, r2.head && (r2.head.done = false), !(1 & r2.wrap) || (((255 & u2) << 8) + (u2 >> 8)) % 31) {
                                    e2.msg = "incorrect header check", r2.mode = 30;
                                    break;
                                }
                                if (8 != (15 & u2)) {
                                    e2.msg = "unknown compression method", r2.mode = 30;
                                    break;
                                }
                                if (l2 -= 4, k = 8 + (15 & (u2 >>>= 4)), 0 === r2.wbits) r2.wbits = k;
                                else if (k > r2.wbits) {
                                    e2.msg = "invalid window size", r2.mode = 30;
                                    break;
                                }
                                r2.dmax = 1 << k, e2.adler = r2.check = 1, r2.mode = 512 & u2 ? 10 : 12, l2 = u2 = 0;
                                break;
                            case 2:
                                for(; l2 < 16;){
                                    if (0 === o2) break e;
                                    o2--, u2 += n2[s2++] << l2, l2 += 8;
                                }
                                if (r2.flags = u2, 8 != (255 & r2.flags)) {
                                    e2.msg = "unknown compression method", r2.mode = 30;
                                    break;
                                }
                                if (57344 & r2.flags) {
                                    e2.msg = "unknown header flags set", r2.mode = 30;
                                    break;
                                }
                                r2.head && (r2.head.text = u2 >> 8 & 1), 512 & r2.flags && (E[0] = 255 & u2, E[1] = u2 >>> 8 & 255, r2.check = B(r2.check, E, 2, 0)), l2 = u2 = 0, r2.mode = 3;
                            case 3:
                                for(; l2 < 32;){
                                    if (0 === o2) break e;
                                    o2--, u2 += n2[s2++] << l2, l2 += 8;
                                }
                                r2.head && (r2.head.time = u2), 512 & r2.flags && (E[0] = 255 & u2, E[1] = u2 >>> 8 & 255, E[2] = u2 >>> 16 & 255, E[3] = u2 >>> 24 & 255, r2.check = B(r2.check, E, 4, 0)), l2 = u2 = 0, r2.mode = 4;
                            case 4:
                                for(; l2 < 16;){
                                    if (0 === o2) break e;
                                    o2--, u2 += n2[s2++] << l2, l2 += 8;
                                }
                                r2.head && (r2.head.xflags = 255 & u2, r2.head.os = u2 >> 8), 512 & r2.flags && (E[0] = 255 & u2, E[1] = u2 >>> 8 & 255, r2.check = B(r2.check, E, 2, 0)), l2 = u2 = 0, r2.mode = 5;
                            case 5:
                                if (1024 & r2.flags) {
                                    for(; l2 < 16;){
                                        if (0 === o2) break e;
                                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                                    }
                                    r2.length = u2, r2.head && (r2.head.extra_len = u2), 512 & r2.flags && (E[0] = 255 & u2, E[1] = u2 >>> 8 & 255, r2.check = B(r2.check, E, 2, 0)), l2 = u2 = 0;
                                } else r2.head && (r2.head.extra = null);
                                r2.mode = 6;
                            case 6:
                                if (1024 & r2.flags && (o2 < (d = r2.length) && (d = o2), d && (r2.head && (k = r2.head.extra_len - r2.length, r2.head.extra || (r2.head.extra = new Array(r2.head.extra_len)), I.arraySet(r2.head.extra, n2, s2, d, k)), 512 & r2.flags && (r2.check = B(r2.check, n2, d, s2)), o2 -= d, s2 += d, r2.length -= d), r2.length)) break e;
                                r2.length = 0, r2.mode = 7;
                            case 7:
                                if (2048 & r2.flags) {
                                    if (0 === o2) break e;
                                    for(d = 0; k = n2[s2 + d++], r2.head && k && r2.length < 65536 && (r2.head.name += String.fromCharCode(k)), k && d < o2;);
                                    if (512 & r2.flags && (r2.check = B(r2.check, n2, d, s2)), o2 -= d, s2 += d, k) break e;
                                } else r2.head && (r2.head.name = null);
                                r2.length = 0, r2.mode = 8;
                            case 8:
                                if (4096 & r2.flags) {
                                    if (0 === o2) break e;
                                    for(d = 0; k = n2[s2 + d++], r2.head && k && r2.length < 65536 && (r2.head.comment += String.fromCharCode(k)), k && d < o2;);
                                    if (512 & r2.flags && (r2.check = B(r2.check, n2, d, s2)), o2 -= d, s2 += d, k) break e;
                                } else r2.head && (r2.head.comment = null);
                                r2.mode = 9;
                            case 9:
                                if (512 & r2.flags) {
                                    for(; l2 < 16;){
                                        if (0 === o2) break e;
                                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                                    }
                                    if (u2 !== (65535 & r2.check)) {
                                        e2.msg = "header crc mismatch", r2.mode = 30;
                                        break;
                                    }
                                    l2 = u2 = 0;
                                }
                                r2.head && (r2.head.hcrc = r2.flags >> 9 & 1, r2.head.done = true), e2.adler = r2.check = 0, r2.mode = 12;
                                break;
                            case 10:
                                for(; l2 < 32;){
                                    if (0 === o2) break e;
                                    o2--, u2 += n2[s2++] << l2, l2 += 8;
                                }
                                e2.adler = r2.check = L(u2), l2 = u2 = 0, r2.mode = 11;
                            case 11:
                                if (0 === r2.havedict) return e2.next_out = a2, e2.avail_out = h2, e2.next_in = s2, e2.avail_in = o2, r2.hold = u2, r2.bits = l2, 2;
                                e2.adler = r2.check = 1, r2.mode = 12;
                            case 12:
                                if (5 === t2 || 6 === t2) break e;
                            case 13:
                                if (r2.last) {
                                    u2 >>>= 7 & l2, l2 -= 7 & l2, r2.mode = 27;
                                    break;
                                }
                                for(; l2 < 3;){
                                    if (0 === o2) break e;
                                    o2--, u2 += n2[s2++] << l2, l2 += 8;
                                }
                                switch(r2.last = 1 & u2, l2 -= 1, 3 & (u2 >>>= 1)){
                                    case 0:
                                        r2.mode = 14;
                                        break;
                                    case 1:
                                        if (j(r2), r2.mode = 20, 6 !== t2) break;
                                        u2 >>>= 2, l2 -= 2;
                                        break e;
                                    case 2:
                                        r2.mode = 17;
                                        break;
                                    case 3:
                                        e2.msg = "invalid block type", r2.mode = 30;
                                }
                                u2 >>>= 2, l2 -= 2;
                                break;
                            case 14:
                                for(u2 >>>= 7 & l2, l2 -= 7 & l2; l2 < 32;){
                                    if (0 === o2) break e;
                                    o2--, u2 += n2[s2++] << l2, l2 += 8;
                                }
                                if ((65535 & u2) != (u2 >>> 16 ^ 65535)) {
                                    e2.msg = "invalid stored block lengths", r2.mode = 30;
                                    break;
                                }
                                if (r2.length = 65535 & u2, l2 = u2 = 0, r2.mode = 15, 6 === t2) break e;
                            case 15:
                                r2.mode = 16;
                            case 16:
                                if (d = r2.length) {
                                    if (o2 < d && (d = o2), h2 < d && (d = h2), 0 === d) break e;
                                    I.arraySet(i2, n2, s2, d, a2), o2 -= d, s2 += d, h2 -= d, a2 += d, r2.length -= d;
                                    break;
                                }
                                r2.mode = 12;
                                break;
                            case 17:
                                for(; l2 < 14;){
                                    if (0 === o2) break e;
                                    o2--, u2 += n2[s2++] << l2, l2 += 8;
                                }
                                if (r2.nlen = 257 + (31 & u2), u2 >>>= 5, l2 -= 5, r2.ndist = 1 + (31 & u2), u2 >>>= 5, l2 -= 5, r2.ncode = 4 + (15 & u2), u2 >>>= 4, l2 -= 4, 286 < r2.nlen || 30 < r2.ndist) {
                                    e2.msg = "too many length or distance symbols", r2.mode = 30;
                                    break;
                                }
                                r2.have = 0, r2.mode = 18;
                            case 18:
                                for(; r2.have < r2.ncode;){
                                    for(; l2 < 3;){
                                        if (0 === o2) break e;
                                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                                    }
                                    r2.lens[A[r2.have++]] = 7 & u2, u2 >>>= 3, l2 -= 3;
                                }
                                for(; r2.have < 19;)r2.lens[A[r2.have++]] = 0;
                                if (r2.lencode = r2.lendyn, r2.lenbits = 7, S = {
                                    bits: r2.lenbits
                                }, x = T(0, r2.lens, 0, 19, r2.lencode, 0, r2.work, S), r2.lenbits = S.bits, x) {
                                    e2.msg = "invalid code lengths set", r2.mode = 30;
                                    break;
                                }
                                r2.have = 0, r2.mode = 19;
                            case 19:
                                for(; r2.have < r2.nlen + r2.ndist;){
                                    for(; g = (C = r2.lencode[u2 & (1 << r2.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l2);){
                                        if (0 === o2) break e;
                                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                                    }
                                    if (b < 16) u2 >>>= _, l2 -= _, r2.lens[r2.have++] = b;
                                    else {
                                        if (16 === b) {
                                            for(z = _ + 2; l2 < z;){
                                                if (0 === o2) break e;
                                                o2--, u2 += n2[s2++] << l2, l2 += 8;
                                            }
                                            if (u2 >>>= _, l2 -= _, 0 === r2.have) {
                                                e2.msg = "invalid bit length repeat", r2.mode = 30;
                                                break;
                                            }
                                            k = r2.lens[r2.have - 1], d = 3 + (3 & u2), u2 >>>= 2, l2 -= 2;
                                        } else if (17 === b) {
                                            for(z = _ + 3; l2 < z;){
                                                if (0 === o2) break e;
                                                o2--, u2 += n2[s2++] << l2, l2 += 8;
                                            }
                                            l2 -= _, k = 0, d = 3 + (7 & (u2 >>>= _)), u2 >>>= 3, l2 -= 3;
                                        } else {
                                            for(z = _ + 7; l2 < z;){
                                                if (0 === o2) break e;
                                                o2--, u2 += n2[s2++] << l2, l2 += 8;
                                            }
                                            l2 -= _, k = 0, d = 11 + (127 & (u2 >>>= _)), u2 >>>= 7, l2 -= 7;
                                        }
                                        if (r2.have + d > r2.nlen + r2.ndist) {
                                            e2.msg = "invalid bit length repeat", r2.mode = 30;
                                            break;
                                        }
                                        for(; d--;)r2.lens[r2.have++] = k;
                                    }
                                }
                                if (30 === r2.mode) break;
                                if (0 === r2.lens[256]) {
                                    e2.msg = "invalid code -- missing end-of-block", r2.mode = 30;
                                    break;
                                }
                                if (r2.lenbits = 9, S = {
                                    bits: r2.lenbits
                                }, x = T(D, r2.lens, 0, r2.nlen, r2.lencode, 0, r2.work, S), r2.lenbits = S.bits, x) {
                                    e2.msg = "invalid literal/lengths set", r2.mode = 30;
                                    break;
                                }
                                if (r2.distbits = 6, r2.distcode = r2.distdyn, S = {
                                    bits: r2.distbits
                                }, x = T(F, r2.lens, r2.nlen, r2.ndist, r2.distcode, 0, r2.work, S), r2.distbits = S.bits, x) {
                                    e2.msg = "invalid distances set", r2.mode = 30;
                                    break;
                                }
                                if (r2.mode = 20, 6 === t2) break e;
                            case 20:
                                r2.mode = 21;
                            case 21:
                                if (6 <= o2 && 258 <= h2) {
                                    e2.next_out = a2, e2.avail_out = h2, e2.next_in = s2, e2.avail_in = o2, r2.hold = u2, r2.bits = l2, R2(e2, c2), a2 = e2.next_out, i2 = e2.output, h2 = e2.avail_out, s2 = e2.next_in, n2 = e2.input, o2 = e2.avail_in, u2 = r2.hold, l2 = r2.bits, 12 === r2.mode && (r2.back = -1);
                                    break;
                                }
                                for(r2.back = 0; g = (C = r2.lencode[u2 & (1 << r2.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l2);){
                                    if (0 === o2) break e;
                                    o2--, u2 += n2[s2++] << l2, l2 += 8;
                                }
                                if (g && 0 == (240 & g)) {
                                    for(v = _, y = g, w = b; g = (C = r2.lencode[w + ((u2 & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l2);){
                                        if (0 === o2) break e;
                                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                                    }
                                    u2 >>>= v, l2 -= v, r2.back += v;
                                }
                                if (u2 >>>= _, l2 -= _, r2.back += _, r2.length = b, 0 === g) {
                                    r2.mode = 26;
                                    break;
                                }
                                if (32 & g) {
                                    r2.back = -1, r2.mode = 12;
                                    break;
                                }
                                if (64 & g) {
                                    e2.msg = "invalid literal/length code", r2.mode = 30;
                                    break;
                                }
                                r2.extra = 15 & g, r2.mode = 22;
                            case 22:
                                if (r2.extra) {
                                    for(z = r2.extra; l2 < z;){
                                        if (0 === o2) break e;
                                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                                    }
                                    r2.length += u2 & (1 << r2.extra) - 1, u2 >>>= r2.extra, l2 -= r2.extra, r2.back += r2.extra;
                                }
                                r2.was = r2.length, r2.mode = 23;
                            case 23:
                                for(; g = (C = r2.distcode[u2 & (1 << r2.distbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l2);){
                                    if (0 === o2) break e;
                                    o2--, u2 += n2[s2++] << l2, l2 += 8;
                                }
                                if (0 == (240 & g)) {
                                    for(v = _, y = g, w = b; g = (C = r2.distcode[w + ((u2 & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l2);){
                                        if (0 === o2) break e;
                                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                                    }
                                    u2 >>>= v, l2 -= v, r2.back += v;
                                }
                                if (u2 >>>= _, l2 -= _, r2.back += _, 64 & g) {
                                    e2.msg = "invalid distance code", r2.mode = 30;
                                    break;
                                }
                                r2.offset = b, r2.extra = 15 & g, r2.mode = 24;
                            case 24:
                                if (r2.extra) {
                                    for(z = r2.extra; l2 < z;){
                                        if (0 === o2) break e;
                                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                                    }
                                    r2.offset += u2 & (1 << r2.extra) - 1, u2 >>>= r2.extra, l2 -= r2.extra, r2.back += r2.extra;
                                }
                                if (r2.offset > r2.dmax) {
                                    e2.msg = "invalid distance too far back", r2.mode = 30;
                                    break;
                                }
                                r2.mode = 25;
                            case 25:
                                if (0 === h2) break e;
                                if (d = c2 - h2, r2.offset > d) {
                                    if ((d = r2.offset - d) > r2.whave && r2.sane) {
                                        e2.msg = "invalid distance too far back", r2.mode = 30;
                                        break;
                                    }
                                    p = d > r2.wnext ? (d -= r2.wnext, r2.wsize - d) : r2.wnext - d, d > r2.length && (d = r2.length), m = r2.window;
                                } else m = i2, p = a2 - r2.offset, d = r2.length;
                                for(h2 < d && (d = h2), h2 -= d, r2.length -= d; i2[a2++] = m[p++], --d;);
                                0 === r2.length && (r2.mode = 21);
                                break;
                            case 26:
                                if (0 === h2) break e;
                                i2[a2++] = r2.length, h2--, r2.mode = 21;
                                break;
                            case 27:
                                if (r2.wrap) {
                                    for(; l2 < 32;){
                                        if (0 === o2) break e;
                                        o2--, u2 |= n2[s2++] << l2, l2 += 8;
                                    }
                                    if (c2 -= h2, e2.total_out += c2, r2.total += c2, c2 && (e2.adler = r2.check = r2.flags ? B(r2.check, i2, c2, a2 - c2) : O(r2.check, i2, c2, a2 - c2)), c2 = h2, (r2.flags ? u2 : L(u2)) !== r2.check) {
                                        e2.msg = "incorrect data check", r2.mode = 30;
                                        break;
                                    }
                                    l2 = u2 = 0;
                                }
                                r2.mode = 28;
                            case 28:
                                if (r2.wrap && r2.flags) {
                                    for(; l2 < 32;){
                                        if (0 === o2) break e;
                                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                                    }
                                    if (u2 !== (4294967295 & r2.total)) {
                                        e2.msg = "incorrect length check", r2.mode = 30;
                                        break;
                                    }
                                    l2 = u2 = 0;
                                }
                                r2.mode = 29;
                            case 29:
                                x = 1;
                                break e;
                            case 30:
                                x = -3;
                                break e;
                            case 31:
                                return -4;
                            case 32:
                            default:
                                return U;
                        }
                        return e2.next_out = a2, e2.avail_out = h2, e2.next_in = s2, e2.avail_in = o2, r2.hold = u2, r2.bits = l2, (r2.wsize || c2 !== e2.avail_out && r2.mode < 30 && (r2.mode < 27 || 4 !== t2)) && Z(e2, e2.output, e2.next_out, c2 - e2.avail_out) ? (r2.mode = 31, -4) : (f2 -= e2.avail_in, c2 -= e2.avail_out, e2.total_in += f2, e2.total_out += c2, r2.total += c2, r2.wrap && c2 && (e2.adler = r2.check = r2.flags ? B(r2.check, i2, c2, e2.next_out - c2) : O(r2.check, i2, c2, e2.next_out - c2)), e2.data_type = r2.bits + (r2.last ? 64 : 0) + (12 === r2.mode ? 128 : 0) + (20 === r2.mode || 15 === r2.mode ? 256 : 0), (0 == f2 && 0 === c2 || 4 === t2) && x === N && (x = -5), x);
                    }, r.inflateEnd = function(e2) {
                        if (!e2 || !e2.state) return U;
                        var t2 = e2.state;
                        return t2.window && (t2.window = null), e2.state = null, N;
                    }, r.inflateGetHeader = function(e2, t2) {
                        var r2;
                        return e2 && e2.state ? 0 == (2 & (r2 = e2.state).wrap) ? U : ((r2.head = t2).done = false, N) : U;
                    }, r.inflateSetDictionary = function(e2, t2) {
                        var r2, n2 = t2.length;
                        return e2 && e2.state ? 0 !== (r2 = e2.state).wrap && 11 !== r2.mode ? U : 11 === r2.mode && O(1, t2, n2, 0) !== r2.check ? -3 : Z(e2, t2, n2, n2) ? (r2.mode = 31, -4) : (r2.havedict = 1, N) : U;
                    }, r.inflateInfo = "pako inflate (from Nodeca project)";
                },
                {
                    "../utils/common": 41,
                    "./adler32": 43,
                    "./crc32": 45,
                    "./inffast": 48,
                    "./inftrees": 50
                }
            ],
            50: [
                function(e, t, r) {
                    var D = e("../utils/common"), F = [
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        13,
                        15,
                        17,
                        19,
                        23,
                        27,
                        31,
                        35,
                        43,
                        51,
                        59,
                        67,
                        83,
                        99,
                        115,
                        131,
                        163,
                        195,
                        227,
                        258,
                        0,
                        0
                    ], N = [
                        16,
                        16,
                        16,
                        16,
                        16,
                        16,
                        16,
                        16,
                        17,
                        17,
                        17,
                        17,
                        18,
                        18,
                        18,
                        18,
                        19,
                        19,
                        19,
                        19,
                        20,
                        20,
                        20,
                        20,
                        21,
                        21,
                        21,
                        21,
                        16,
                        72,
                        78
                    ], U = [
                        1,
                        2,
                        3,
                        4,
                        5,
                        7,
                        9,
                        13,
                        17,
                        25,
                        33,
                        49,
                        65,
                        97,
                        129,
                        193,
                        257,
                        385,
                        513,
                        769,
                        1025,
                        1537,
                        2049,
                        3073,
                        4097,
                        6145,
                        8193,
                        12289,
                        16385,
                        24577,
                        0,
                        0
                    ], P = [
                        16,
                        16,
                        16,
                        16,
                        17,
                        17,
                        18,
                        18,
                        19,
                        19,
                        20,
                        20,
                        21,
                        21,
                        22,
                        22,
                        23,
                        23,
                        24,
                        24,
                        25,
                        25,
                        26,
                        26,
                        27,
                        27,
                        28,
                        28,
                        29,
                        29,
                        64,
                        64
                    ];
                    t.exports = function(e2, t2, r2, n, i, s, a, o) {
                        var h, u, l, f, c, d, p, m, _, g = o.bits, b = 0, v = 0, y = 0, w = 0, k = 0, x = 0, S = 0, z = 0, C = 0, E = 0, A = null, I = 0, O = new D.Buf16(16), B = new D.Buf16(16), R2 = null, T = 0;
                        for(b = 0; b <= 15; b++)O[b] = 0;
                        for(v = 0; v < n; v++)O[t2[r2 + v]]++;
                        for(k = g, w = 15; 1 <= w && 0 === O[w]; w--);
                        if (w < k && (k = w), 0 === w) return i[s++] = 20971520, i[s++] = 20971520, o.bits = 1, 0;
                        for(y = 1; y < w && 0 === O[y]; y++);
                        for(k < y && (k = y), b = z = 1; b <= 15; b++)if (z <<= 1, (z -= O[b]) < 0) return -1;
                        if (0 < z && (0 === e2 || 1 !== w)) return -1;
                        for(B[1] = 0, b = 1; b < 15; b++)B[b + 1] = B[b] + O[b];
                        for(v = 0; v < n; v++)0 !== t2[r2 + v] && (a[B[t2[r2 + v]]++] = v);
                        if (d = 0 === e2 ? (A = R2 = a, 19) : 1 === e2 ? (A = F, I -= 257, R2 = N, T -= 257, 256) : (A = U, R2 = P, -1), b = y, c = s, S = v = E = 0, l = -1, f = (C = 1 << (x = k)) - 1, 1 === e2 && 852 < C || 2 === e2 && 592 < C) return 1;
                        for(;;){
                            for(p = b - S, _ = a[v] < d ? (m = 0, a[v]) : a[v] > d ? (m = R2[T + a[v]], A[I + a[v]]) : (m = 96, 0), h = 1 << b - S, y = u = 1 << x; i[c + (E >> S) + (u -= h)] = p << 24 | m << 16 | _ | 0, 0 !== u;);
                            for(h = 1 << b - 1; E & h;)h >>= 1;
                            if (0 !== h ? (E &= h - 1, E += h) : E = 0, v++, 0 == --O[b]) {
                                if (b === w) break;
                                b = t2[r2 + a[v]];
                            }
                            if (k < b && (E & f) !== l) {
                                for(0 === S && (S = k), c += y, z = 1 << (x = b - S); x + S < w && !((z -= O[x + S]) <= 0);)x++, z <<= 1;
                                if (C += 1 << x, 1 === e2 && 852 < C || 2 === e2 && 592 < C) return 1;
                                i[l = E & f] = k << 24 | x << 16 | c - s | 0;
                            }
                        }
                        return 0 !== E && (i[c + E] = b - S << 24 | 4194304), o.bits = k, 0;
                    };
                },
                {
                    "../utils/common": 41
                }
            ],
            51: [
                function(e, t, r) {
                    t.exports = {
                        2: "need dictionary",
                        1: "stream end",
                        0: "",
                        "-1": "file error",
                        "-2": "stream error",
                        "-3": "data error",
                        "-4": "insufficient memory",
                        "-5": "buffer error",
                        "-6": "incompatible version"
                    };
                },
                {}
            ],
            52: [
                function(e, t, r) {
                    var i = e("../utils/common"), o = 0, h = 1;
                    function n(e2) {
                        for(var t2 = e2.length; 0 <= --t2;)e2[t2] = 0;
                    }
                    var s = 0, a = 29, u = 256, l = u + 1 + a, f = 30, c = 19, _ = 2 * l + 1, g = 15, d = 16, p = 7, m = 256, b = 16, v = 17, y = 18, w = [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        1,
                        1,
                        1,
                        2,
                        2,
                        2,
                        2,
                        3,
                        3,
                        3,
                        3,
                        4,
                        4,
                        4,
                        4,
                        5,
                        5,
                        5,
                        5,
                        0
                    ], k = [
                        0,
                        0,
                        0,
                        0,
                        1,
                        1,
                        2,
                        2,
                        3,
                        3,
                        4,
                        4,
                        5,
                        5,
                        6,
                        6,
                        7,
                        7,
                        8,
                        8,
                        9,
                        9,
                        10,
                        10,
                        11,
                        11,
                        12,
                        12,
                        13,
                        13
                    ], x = [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        3,
                        7
                    ], S = [
                        16,
                        17,
                        18,
                        0,
                        8,
                        7,
                        9,
                        6,
                        10,
                        5,
                        11,
                        4,
                        12,
                        3,
                        13,
                        2,
                        14,
                        1,
                        15
                    ], z = new Array(2 * (l + 2));
                    n(z);
                    var C = new Array(2 * f);
                    n(C);
                    var E = new Array(512);
                    n(E);
                    var A = new Array(256);
                    n(A);
                    var I = new Array(a);
                    n(I);
                    var O, B, R2, T = new Array(f);
                    function D(e2, t2, r2, n2, i2) {
                        this.static_tree = e2, this.extra_bits = t2, this.extra_base = r2, this.elems = n2, this.max_length = i2, this.has_stree = e2 && e2.length;
                    }
                    function F(e2, t2) {
                        this.dyn_tree = e2, this.max_code = 0, this.stat_desc = t2;
                    }
                    function N(e2) {
                        return e2 < 256 ? E[e2] : E[256 + (e2 >>> 7)];
                    }
                    function U(e2, t2) {
                        e2.pending_buf[e2.pending++] = 255 & t2, e2.pending_buf[e2.pending++] = t2 >>> 8 & 255;
                    }
                    function P(e2, t2, r2) {
                        e2.bi_valid > d - r2 ? (e2.bi_buf |= t2 << e2.bi_valid & 65535, U(e2, e2.bi_buf), e2.bi_buf = t2 >> d - e2.bi_valid, e2.bi_valid += r2 - d) : (e2.bi_buf |= t2 << e2.bi_valid & 65535, e2.bi_valid += r2);
                    }
                    function L(e2, t2, r2) {
                        P(e2, r2[2 * t2], r2[2 * t2 + 1]);
                    }
                    function j(e2, t2) {
                        for(var r2 = 0; r2 |= 1 & e2, e2 >>>= 1, r2 <<= 1, 0 < --t2;);
                        return r2 >>> 1;
                    }
                    function Z(e2, t2, r2) {
                        var n2, i2, s2 = new Array(g + 1), a2 = 0;
                        for(n2 = 1; n2 <= g; n2++)s2[n2] = a2 = a2 + r2[n2 - 1] << 1;
                        for(i2 = 0; i2 <= t2; i2++){
                            var o2 = e2[2 * i2 + 1];
                            0 !== o2 && (e2[2 * i2] = j(s2[o2]++, o2));
                        }
                    }
                    function W(e2) {
                        var t2;
                        for(t2 = 0; t2 < l; t2++)e2.dyn_ltree[2 * t2] = 0;
                        for(t2 = 0; t2 < f; t2++)e2.dyn_dtree[2 * t2] = 0;
                        for(t2 = 0; t2 < c; t2++)e2.bl_tree[2 * t2] = 0;
                        e2.dyn_ltree[2 * m] = 1, e2.opt_len = e2.static_len = 0, e2.last_lit = e2.matches = 0;
                    }
                    function M(e2) {
                        8 < e2.bi_valid ? U(e2, e2.bi_buf) : 0 < e2.bi_valid && (e2.pending_buf[e2.pending++] = e2.bi_buf), e2.bi_buf = 0, e2.bi_valid = 0;
                    }
                    function H(e2, t2, r2, n2) {
                        var i2 = 2 * t2, s2 = 2 * r2;
                        return e2[i2] < e2[s2] || e2[i2] === e2[s2] && n2[t2] <= n2[r2];
                    }
                    function G(e2, t2, r2) {
                        for(var n2 = e2.heap[r2], i2 = r2 << 1; i2 <= e2.heap_len && (i2 < e2.heap_len && H(t2, e2.heap[i2 + 1], e2.heap[i2], e2.depth) && i2++, !H(t2, n2, e2.heap[i2], e2.depth));)e2.heap[r2] = e2.heap[i2], r2 = i2, i2 <<= 1;
                        e2.heap[r2] = n2;
                    }
                    function K(e2, t2, r2) {
                        var n2, i2, s2, a2, o2 = 0;
                        if (0 !== e2.last_lit) for(; n2 = e2.pending_buf[e2.d_buf + 2 * o2] << 8 | e2.pending_buf[e2.d_buf + 2 * o2 + 1], i2 = e2.pending_buf[e2.l_buf + o2], o2++, 0 === n2 ? L(e2, i2, t2) : (L(e2, (s2 = A[i2]) + u + 1, t2), 0 !== (a2 = w[s2]) && P(e2, i2 -= I[s2], a2), L(e2, s2 = N(--n2), r2), 0 !== (a2 = k[s2]) && P(e2, n2 -= T[s2], a2)), o2 < e2.last_lit;);
                        L(e2, m, t2);
                    }
                    function Y(e2, t2) {
                        var r2, n2, i2, s2 = t2.dyn_tree, a2 = t2.stat_desc.static_tree, o2 = t2.stat_desc.has_stree, h2 = t2.stat_desc.elems, u2 = -1;
                        for(e2.heap_len = 0, e2.heap_max = _, r2 = 0; r2 < h2; r2++)0 !== s2[2 * r2] ? (e2.heap[++e2.heap_len] = u2 = r2, e2.depth[r2] = 0) : s2[2 * r2 + 1] = 0;
                        for(; e2.heap_len < 2;)s2[2 * (i2 = e2.heap[++e2.heap_len] = u2 < 2 ? ++u2 : 0)] = 1, e2.depth[i2] = 0, e2.opt_len--, o2 && (e2.static_len -= a2[2 * i2 + 1]);
                        for(t2.max_code = u2, r2 = e2.heap_len >> 1; 1 <= r2; r2--)G(e2, s2, r2);
                        for(i2 = h2; r2 = e2.heap[1], e2.heap[1] = e2.heap[e2.heap_len--], G(e2, s2, 1), n2 = e2.heap[1], e2.heap[--e2.heap_max] = r2, e2.heap[--e2.heap_max] = n2, s2[2 * i2] = s2[2 * r2] + s2[2 * n2], e2.depth[i2] = (e2.depth[r2] >= e2.depth[n2] ? e2.depth[r2] : e2.depth[n2]) + 1, s2[2 * r2 + 1] = s2[2 * n2 + 1] = i2, e2.heap[1] = i2++, G(e2, s2, 1), 2 <= e2.heap_len;);
                        e2.heap[--e2.heap_max] = e2.heap[1], function(e3, t3) {
                            var r3, n3, i3, s3, a3, o3, h3 = t3.dyn_tree, u3 = t3.max_code, l2 = t3.stat_desc.static_tree, f2 = t3.stat_desc.has_stree, c2 = t3.stat_desc.extra_bits, d2 = t3.stat_desc.extra_base, p2 = t3.stat_desc.max_length, m2 = 0;
                            for(s3 = 0; s3 <= g; s3++)e3.bl_count[s3] = 0;
                            for(h3[2 * e3.heap[e3.heap_max] + 1] = 0, r3 = e3.heap_max + 1; r3 < _; r3++)p2 < (s3 = h3[2 * h3[2 * (n3 = e3.heap[r3]) + 1] + 1] + 1) && (s3 = p2, m2++), h3[2 * n3 + 1] = s3, u3 < n3 || (e3.bl_count[s3]++, a3 = 0, d2 <= n3 && (a3 = c2[n3 - d2]), o3 = h3[2 * n3], e3.opt_len += o3 * (s3 + a3), f2 && (e3.static_len += o3 * (l2[2 * n3 + 1] + a3)));
                            if (0 !== m2) {
                                do {
                                    for(s3 = p2 - 1; 0 === e3.bl_count[s3];)s3--;
                                    e3.bl_count[s3]--, e3.bl_count[s3 + 1] += 2, e3.bl_count[p2]--, m2 -= 2;
                                }while (0 < m2);
                                for(s3 = p2; 0 !== s3; s3--)for(n3 = e3.bl_count[s3]; 0 !== n3;)u3 < (i3 = e3.heap[--r3]) || (h3[2 * i3 + 1] !== s3 && (e3.opt_len += (s3 - h3[2 * i3 + 1]) * h3[2 * i3], h3[2 * i3 + 1] = s3), n3--);
                            }
                        }(e2, t2), Z(s2, u2, e2.bl_count);
                    }
                    function X(e2, t2, r2) {
                        var n2, i2, s2 = -1, a2 = t2[1], o2 = 0, h2 = 7, u2 = 4;
                        for(0 === a2 && (h2 = 138, u2 = 3), t2[2 * (r2 + 1) + 1] = 65535, n2 = 0; n2 <= r2; n2++)i2 = a2, a2 = t2[2 * (n2 + 1) + 1], ++o2 < h2 && i2 === a2 || (o2 < u2 ? e2.bl_tree[2 * i2] += o2 : 0 !== i2 ? (i2 !== s2 && e2.bl_tree[2 * i2]++, e2.bl_tree[2 * b]++) : o2 <= 10 ? e2.bl_tree[2 * v]++ : e2.bl_tree[2 * y]++, s2 = i2, u2 = (o2 = 0) === a2 ? (h2 = 138, 3) : i2 === a2 ? (h2 = 6, 3) : (h2 = 7, 4));
                    }
                    function V(e2, t2, r2) {
                        var n2, i2, s2 = -1, a2 = t2[1], o2 = 0, h2 = 7, u2 = 4;
                        for(0 === a2 && (h2 = 138, u2 = 3), n2 = 0; n2 <= r2; n2++)if (i2 = a2, a2 = t2[2 * (n2 + 1) + 1], !(++o2 < h2 && i2 === a2)) {
                            if (o2 < u2) for(; L(e2, i2, e2.bl_tree), 0 != --o2;);
                            else 0 !== i2 ? (i2 !== s2 && (L(e2, i2, e2.bl_tree), o2--), L(e2, b, e2.bl_tree), P(e2, o2 - 3, 2)) : o2 <= 10 ? (L(e2, v, e2.bl_tree), P(e2, o2 - 3, 3)) : (L(e2, y, e2.bl_tree), P(e2, o2 - 11, 7));
                            s2 = i2, u2 = (o2 = 0) === a2 ? (h2 = 138, 3) : i2 === a2 ? (h2 = 6, 3) : (h2 = 7, 4);
                        }
                    }
                    n(T);
                    var q = false;
                    function J(e2, t2, r2, n2) {
                        P(e2, (s << 1) + (n2 ? 1 : 0), 3), function(e3, t3, r3, n3) {
                            M(e3), n3 && (U(e3, r3), U(e3, ~r3)), i.arraySet(e3.pending_buf, e3.window, t3, r3, e3.pending), e3.pending += r3;
                        }(e2, t2, r2, true);
                    }
                    r._tr_init = function(e2) {
                        q || (function() {
                            var e3, t2, r2, n2, i2, s2 = new Array(g + 1);
                            for(n2 = r2 = 0; n2 < a - 1; n2++)for(I[n2] = r2, e3 = 0; e3 < 1 << w[n2]; e3++)A[r2++] = n2;
                            for(A[r2 - 1] = n2, n2 = i2 = 0; n2 < 16; n2++)for(T[n2] = i2, e3 = 0; e3 < 1 << k[n2]; e3++)E[i2++] = n2;
                            for(i2 >>= 7; n2 < f; n2++)for(T[n2] = i2 << 7, e3 = 0; e3 < 1 << k[n2] - 7; e3++)E[256 + i2++] = n2;
                            for(t2 = 0; t2 <= g; t2++)s2[t2] = 0;
                            for(e3 = 0; e3 <= 143;)z[2 * e3 + 1] = 8, e3++, s2[8]++;
                            for(; e3 <= 255;)z[2 * e3 + 1] = 9, e3++, s2[9]++;
                            for(; e3 <= 279;)z[2 * e3 + 1] = 7, e3++, s2[7]++;
                            for(; e3 <= 287;)z[2 * e3 + 1] = 8, e3++, s2[8]++;
                            for(Z(z, l + 1, s2), e3 = 0; e3 < f; e3++)C[2 * e3 + 1] = 5, C[2 * e3] = j(e3, 5);
                            O = new D(z, w, u + 1, l, g), B = new D(C, k, 0, f, g), R2 = new D(new Array(0), x, 0, c, p);
                        }(), q = true), e2.l_desc = new F(e2.dyn_ltree, O), e2.d_desc = new F(e2.dyn_dtree, B), e2.bl_desc = new F(e2.bl_tree, R2), e2.bi_buf = 0, e2.bi_valid = 0, W(e2);
                    }, r._tr_stored_block = J, r._tr_flush_block = function(e2, t2, r2, n2) {
                        var i2, s2, a2 = 0;
                        0 < e2.level ? (2 === e2.strm.data_type && (e2.strm.data_type = function(e3) {
                            var t3, r3 = 4093624447;
                            for(t3 = 0; t3 <= 31; t3++, r3 >>>= 1)if (1 & r3 && 0 !== e3.dyn_ltree[2 * t3]) return o;
                            if (0 !== e3.dyn_ltree[18] || 0 !== e3.dyn_ltree[20] || 0 !== e3.dyn_ltree[26]) return h;
                            for(t3 = 32; t3 < u; t3++)if (0 !== e3.dyn_ltree[2 * t3]) return h;
                            return o;
                        }(e2)), Y(e2, e2.l_desc), Y(e2, e2.d_desc), a2 = function(e3) {
                            var t3;
                            for(X(e3, e3.dyn_ltree, e3.l_desc.max_code), X(e3, e3.dyn_dtree, e3.d_desc.max_code), Y(e3, e3.bl_desc), t3 = c - 1; 3 <= t3 && 0 === e3.bl_tree[2 * S[t3] + 1]; t3--);
                            return e3.opt_len += 3 * (t3 + 1) + 5 + 5 + 4, t3;
                        }(e2), i2 = e2.opt_len + 3 + 7 >>> 3, (s2 = e2.static_len + 3 + 7 >>> 3) <= i2 && (i2 = s2)) : i2 = s2 = r2 + 5, r2 + 4 <= i2 && -1 !== t2 ? J(e2, t2, r2, n2) : 4 === e2.strategy || s2 === i2 ? (P(e2, 2 + (n2 ? 1 : 0), 3), K(e2, z, C)) : (P(e2, 4 + (n2 ? 1 : 0), 3), function(e3, t3, r3, n3) {
                            var i3;
                            for(P(e3, t3 - 257, 5), P(e3, r3 - 1, 5), P(e3, n3 - 4, 4), i3 = 0; i3 < n3; i3++)P(e3, e3.bl_tree[2 * S[i3] + 1], 3);
                            V(e3, e3.dyn_ltree, t3 - 1), V(e3, e3.dyn_dtree, r3 - 1);
                        }(e2, e2.l_desc.max_code + 1, e2.d_desc.max_code + 1, a2 + 1), K(e2, e2.dyn_ltree, e2.dyn_dtree)), W(e2), n2 && M(e2);
                    }, r._tr_tally = function(e2, t2, r2) {
                        return e2.pending_buf[e2.d_buf + 2 * e2.last_lit] = t2 >>> 8 & 255, e2.pending_buf[e2.d_buf + 2 * e2.last_lit + 1] = 255 & t2, e2.pending_buf[e2.l_buf + e2.last_lit] = 255 & r2, e2.last_lit++, 0 === t2 ? e2.dyn_ltree[2 * r2]++ : (e2.matches++, t2--, e2.dyn_ltree[2 * (A[r2] + u + 1)]++, e2.dyn_dtree[2 * N(t2)]++), e2.last_lit === e2.lit_bufsize - 1;
                    }, r._tr_align = function(e2) {
                        P(e2, 2, 3), L(e2, m, z), function(e3) {
                            16 === e3.bi_valid ? (U(e3, e3.bi_buf), e3.bi_buf = 0, e3.bi_valid = 0) : 8 <= e3.bi_valid && (e3.pending_buf[e3.pending++] = 255 & e3.bi_buf, e3.bi_buf >>= 8, e3.bi_valid -= 8);
                        }(e2);
                    };
                },
                {
                    "../utils/common": 41
                }
            ],
            53: [
                function(e, t, r) {
                    t.exports = function() {
                        this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                    };
                },
                {}
            ],
            54: [
                function(e, t, r) {
                    (function(e2) {
                        !function(r2, n) {
                            if (!r2.setImmediate) {
                                var i, s, t2, a, o = 1, h = {}, u = false, l = r2.document, e3 = Object.getPrototypeOf && Object.getPrototypeOf(r2);
                                e3 = e3 && e3.setTimeout ? e3 : r2, i = "[object process]" === ({}).toString.call(r2.process) ? function i(e4) {
                                    $94db4f2abf87558b$var$process$1.nextTick(function() {
                                        c(e4);
                                    });
                                } : function() {
                                    if (r2.postMessage && !r2.importScripts) {
                                        var e4 = true, t3 = r2.onmessage;
                                        return r2.onmessage = function() {
                                            e4 = false;
                                        }, r2.postMessage("", "*"), r2.onmessage = t3, e4;
                                    }
                                }() ? (a = "setImmediate$" + Math.random() + "$", r2.addEventListener ? r2.addEventListener("message", d, false) : r2.attachEvent("onmessage", d), function(e4) {
                                    r2.postMessage(a + e4, "*");
                                }) : r2.MessageChannel ? ((t2 = new MessageChannel()).port1.onmessage = function(e4) {
                                    c(e4.data);
                                }, function(e4) {
                                    t2.port2.postMessage(e4);
                                }) : l && "onreadystatechange" in l.createElement("script") ? (s = l.documentElement, function(e4) {
                                    var t3 = l.createElement("script");
                                    t3.onreadystatechange = function() {
                                        c(e4), t3.onreadystatechange = null, s.removeChild(t3), t3 = null;
                                    }, s.appendChild(t3);
                                }) : function(e4) {
                                    setTimeout(c, 0, e4);
                                }, e3.setImmediate = function(e4) {
                                    "function" != typeof e4 && (e4 = new Function("" + e4));
                                    for(var t3 = new Array(arguments.length - 1), r3 = 0; r3 < t3.length; r3++)t3[r3] = arguments[r3 + 1];
                                    var n2 = {
                                        callback: e4,
                                        args: t3
                                    };
                                    return h[o] = n2, i(o), o++;
                                }, e3.clearImmediate = f;
                            }
                            function f(e4) {
                                delete h[e4];
                            }
                            function c(e4) {
                                if (u) setTimeout(c, 0, e4);
                                else {
                                    var t3 = h[e4];
                                    if (t3) {
                                        u = true;
                                        try {
                                            !function(e5) {
                                                var t4 = e5.callback, r3 = e5.args;
                                                switch(r3.length){
                                                    case 0:
                                                        t4();
                                                        break;
                                                    case 1:
                                                        t4(r3[0]);
                                                        break;
                                                    case 2:
                                                        t4(r3[0], r3[1]);
                                                        break;
                                                    case 3:
                                                        t4(r3[0], r3[1], r3[2]);
                                                        break;
                                                    default:
                                                        t4.apply(n, r3);
                                                }
                                            }(t3);
                                        } finally{
                                            f(e4), u = false;
                                        }
                                    }
                                }
                            }
                            function d(e4) {
                                e4.source === r2 && "string" == typeof e4.data && 0 === e4.data.indexOf(a) && c(+e4.data.slice(a.length));
                            }
                        }("undefined" == typeof self ? void 0 === e2 ? this : e2 : self);
                    }).call(this, "undefined" != typeof $94db4f2abf87558b$var$commonjsGlobal ? $94db4f2abf87558b$var$commonjsGlobal : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
                },
                {}
            ]
        }, {}, [
            10
        ])(10);
    });
})($94db4f2abf87558b$var$jszip_min);
var $94db4f2abf87558b$var$jszip_minExports = $94db4f2abf87558b$var$jszip_min.exports;
var $94db4f2abf87558b$var$JSZip = /* @__PURE__ */ $94db4f2abf87558b$var$getDefaultExportFromCjs$1($94db4f2abf87558b$var$jszip_minExports);
var $94db4f2abf87558b$var$xml$2 = {
    exports: {}
};
var $94db4f2abf87558b$var$XML_CHARACTER_MAP = {
    "&": "&amp;",
    '"': "&quot;",
    "'": "&apos;",
    "<": "&lt;",
    ">": "&gt;"
};
function $94db4f2abf87558b$var$escapeForXML$1(string) {
    return string && string.replace ? string.replace(/([&"<>'])/g, function(str, item) {
        return $94db4f2abf87558b$var$XML_CHARACTER_MAP[item];
    }) : string;
}
var $94db4f2abf87558b$var$escapeForXML_1 = $94db4f2abf87558b$var$escapeForXML$1;
var $94db4f2abf87558b$var$escapeForXML = $94db4f2abf87558b$var$escapeForXML_1;
var $94db4f2abf87558b$var$Stream = $94db4f2abf87558b$var$streamBrowserify.Stream;
var $94db4f2abf87558b$var$DEFAULT_INDENT = "    ";
function $94db4f2abf87558b$var$xml(input, options2) {
    if ((typeof options2 === "undefined" ? "undefined" : (0, $2bfPH._)(options2)) !== "object") options2 = {
        indent: options2
    };
    var stream = options2.stream ? new $94db4f2abf87558b$var$Stream() : null, output = "", interrupted = false, indent = !options2.indent ? "" : options2.indent === true ? $94db4f2abf87558b$var$DEFAULT_INDENT : options2.indent, instant = true;
    function delay(func) {
        if (!instant) func();
        else $94db4f2abf87558b$var$process$1.nextTick(func);
    }
    function append(interrupt, out) {
        if (out !== void 0) output += out;
        if (interrupt && !interrupted) {
            stream = stream || new $94db4f2abf87558b$var$Stream();
            interrupted = true;
        }
        if (interrupt && interrupted) {
            var data = output;
            delay(function() {
                stream.emit("data", data);
            });
            output = "";
        }
    }
    function add(value, last) {
        $94db4f2abf87558b$var$format(append, $94db4f2abf87558b$var$resolve(value, indent, indent ? 1 : 0), last);
    }
    function end() {
        if (stream) {
            var data = output;
            delay(function() {
                stream.emit("data", data);
                stream.emit("end");
                stream.readable = false;
                stream.emit("close");
            });
        }
    }
    function addXmlDeclaration(declaration) {
        var encoding = declaration.encoding || "UTF-8", attr = {
            version: "1.0",
            encoding: encoding
        };
        if (declaration.standalone) attr.standalone = declaration.standalone;
        add({
            "?xml": {
                _attr: attr
            }
        });
        output = output.replace("/>", "?>");
    }
    delay(function() {
        instant = false;
    });
    if (options2.declaration) addXmlDeclaration(options2.declaration);
    if (input && input.forEach) input.forEach(function(value, i) {
        var last;
        if (i + 1 === input.length) last = end;
        add(value, last);
    });
    else add(input, end);
    if (stream) {
        stream.readable = true;
        return stream;
    }
    return output;
}
function $94db4f2abf87558b$var$element() {
    var input = Array.prototype.slice.call(arguments), self2 = {
        _elem: $94db4f2abf87558b$var$resolve(input)
    };
    self2.push = function(input2) {
        if (!this.append) throw new Error("not assigned to a parent!");
        var that = this;
        var indent = this._elem.indent;
        $94db4f2abf87558b$var$format(this.append, $94db4f2abf87558b$var$resolve(input2, indent, this._elem.icount + (indent ? 1 : 0)), function() {
            that.append(true);
        });
    };
    self2.close = function(input2) {
        if (input2 !== void 0) this.push(input2);
        if (this.end) this.end();
    };
    return self2;
}
function $94db4f2abf87558b$var$create_indent(character, count) {
    return new Array(count || 0).join(character || "");
}
function $94db4f2abf87558b$var$resolve(data, indent, indent_count) {
    indent_count = indent_count || 0;
    var indent_spaces = $94db4f2abf87558b$var$create_indent(indent, indent_count);
    var name;
    var values = data;
    var interrupt = false;
    if ((typeof data === "undefined" ? "undefined" : (0, $2bfPH._)(data)) === "object") {
        var keys = Object.keys(data);
        name = keys[0];
        values = data[name];
        if (values && values._elem) {
            values._elem.name = name;
            values._elem.icount = indent_count;
            values._elem.indent = indent;
            values._elem.indents = indent_spaces;
            values._elem.interrupt = values;
            return values._elem;
        }
    }
    var attributes = [], content = [];
    var isStringContent;
    function get_attributes(obj) {
        var keys2 = Object.keys(obj);
        keys2.forEach(function(key) {
            attributes.push($94db4f2abf87558b$var$attribute(key, obj[key]));
        });
    }
    switch(typeof values === "undefined" ? "undefined" : (0, $2bfPH._)(values)){
        case "object":
            if (values === null) break;
            if (values._attr) get_attributes(values._attr);
            if (values._cdata) content.push(("<![CDATA[" + values._cdata).replace(/\]\]>/g, "]]]]><![CDATA[>") + "]]>");
            if (values.forEach) {
                isStringContent = false;
                content.push("");
                values.forEach(function(value) {
                    if ((typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) == "object") {
                        var _name = Object.keys(value)[0];
                        if (_name == "_attr") get_attributes(value._attr);
                        else content.push($94db4f2abf87558b$var$resolve(value, indent, indent_count + 1));
                    } else {
                        content.pop();
                        isStringContent = true;
                        content.push($94db4f2abf87558b$var$escapeForXML(value));
                    }
                });
                if (!isStringContent) content.push("");
            }
            break;
        default:
            content.push($94db4f2abf87558b$var$escapeForXML(values));
    }
    return {
        name: name,
        interrupt: interrupt,
        attributes: attributes,
        content: content,
        icount: indent_count,
        indents: indent_spaces,
        indent: indent
    };
}
function $94db4f2abf87558b$var$format(append, elem, end) {
    if ((typeof elem === "undefined" ? "undefined" : (0, $2bfPH._)(elem)) != "object") return append(false, elem);
    var len = elem.interrupt ? 1 : elem.content.length;
    function proceed() {
        while(elem.content.length){
            var value = elem.content.shift();
            if (value === void 0) continue;
            if (interrupt(value)) return;
            $94db4f2abf87558b$var$format(append, value);
        }
        append(false, (len > 1 ? elem.indents : "") + (elem.name ? "</" + elem.name + ">" : "") + (elem.indent && !end ? "\n" : ""));
        if (end) end();
    }
    function interrupt(value) {
        if (value.interrupt) {
            value.interrupt.append = append;
            value.interrupt.end = proceed;
            value.interrupt = false;
            append(true);
            return true;
        }
        return false;
    }
    append(false, elem.indents + (elem.name ? "<" + elem.name : "") + (elem.attributes.length ? " " + elem.attributes.join(" ") : "") + (len ? elem.name ? ">" : "" : elem.name ? "/>" : "") + (elem.indent && len > 1 ? "\n" : ""));
    if (!len) return append(false, elem.indent ? "\n" : "");
    if (!interrupt(elem)) proceed();
}
function $94db4f2abf87558b$var$attribute(key, value) {
    return key + '="' + $94db4f2abf87558b$var$escapeForXML(value) + '"';
}
$94db4f2abf87558b$var$xml$2.exports = $94db4f2abf87558b$var$xml;
$94db4f2abf87558b$var$xml$2.exports.element = $94db4f2abf87558b$var$xml$2.exports.Element = $94db4f2abf87558b$var$element;
var $94db4f2abf87558b$var$xmlExports = $94db4f2abf87558b$var$xml$2.exports;
var $94db4f2abf87558b$var$xml$1 = /* @__PURE__ */ $94db4f2abf87558b$var$getDefaultExportFromCjs$1($94db4f2abf87558b$var$xmlExports);
var $94db4f2abf87558b$var$obfuscatedStartOffset = 0;
var $94db4f2abf87558b$var$obfuscatedEndOffset = 32;
var $94db4f2abf87558b$var$guidSize = 32;
var $94db4f2abf87558b$var$obfuscate = function(buf, fontKey) {
    var guid = fontKey.replace(/-/g, "");
    if (guid.length !== $94db4f2abf87558b$var$guidSize) throw new Error("Error: Cannot extract GUID from font filename: ".concat(fontKey));
    var hexStrings = guid.replace(/(..)/g, "$1 ").trim().split(" ");
    var hexNumbers = hexStrings.map(function(hexString) {
        return parseInt(hexString, 16);
    });
    hexNumbers.reverse();
    var bytesToObfuscate = buf.slice($94db4f2abf87558b$var$obfuscatedStartOffset, $94db4f2abf87558b$var$obfuscatedEndOffset);
    var obfuscatedBytes = bytesToObfuscate.map(function(byte, i) {
        return byte ^ hexNumbers[i % hexNumbers.length];
    });
    var out = $94db4f2abf87558b$var$Buffer.concat([
        buf.slice(0, $94db4f2abf87558b$var$obfuscatedStartOffset),
        obfuscatedBytes,
        buf.slice($94db4f2abf87558b$var$obfuscatedEndOffset)
    ]);
    return out;
};
var $94db4f2abf87558b$var$Formatter = /*#__PURE__*/ function() {
    "use strict";
    function Formatter() {
        (0, $gd0sY._)(this, Formatter);
    }
    (0, $7cSld._)(Formatter, [
        {
            // tslint:disable-next-line: no-object-literal-type-assertion
            key: "format",
            value: function format(input) {
                var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
                    stack: []
                };
                var output = input.prepForXml(context);
                if (output) return output;
                else throw Error("XMLComponent did not format correctly");
            }
        }
    ]);
    return Formatter;
}();
var $94db4f2abf87558b$var$ImageReplacer = /*#__PURE__*/ function() {
    "use strict";
    function ImageReplacer() {
        (0, $gd0sY._)(this, ImageReplacer);
    }
    (0, $7cSld._)(ImageReplacer, [
        {
            key: "replace",
            value: function replace(xmlData, mediaData, offset) {
                var currentXmlData = xmlData;
                mediaData.forEach(function(image, i) {
                    currentXmlData = currentXmlData.replace(new RegExp("{".concat(image.fileName, "}"), "g"), (offset + i).toString());
                });
                return currentXmlData;
            }
        },
        {
            key: "getMediaData",
            value: function getMediaData(xmlData, media) {
                return media.Array.filter(function(image) {
                    return xmlData.search("{".concat(image.fileName, "}")) > 0;
                });
            }
        }
    ]);
    return ImageReplacer;
}();
var $94db4f2abf87558b$var$NumberingReplacer = /*#__PURE__*/ function() {
    "use strict";
    function NumberingReplacer() {
        (0, $gd0sY._)(this, NumberingReplacer);
    }
    (0, $7cSld._)(NumberingReplacer, [
        {
            key: "replace",
            value: function replace(xmlData, concreteNumberings) {
                var currentXmlData = xmlData;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = concreteNumberings[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var concreteNumbering = _step.value;
                        currentXmlData = currentXmlData.replace(new RegExp("{".concat(concreteNumbering.reference, "-").concat(concreteNumbering.instance, "}"), "g"), concreteNumbering.numId.toString());
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return currentXmlData;
            }
        }
    ]);
    return NumberingReplacer;
}();
var $94db4f2abf87558b$var$Compiler = /*#__PURE__*/ function() {
    "use strict";
    function Compiler() {
        (0, $gd0sY._)(this, Compiler);
        $94db4f2abf87558b$var$__publicField(this, "formatter");
        $94db4f2abf87558b$var$__publicField(this, "imageReplacer");
        $94db4f2abf87558b$var$__publicField(this, "numberingReplacer");
        this.formatter = new $94db4f2abf87558b$var$Formatter();
        this.imageReplacer = new $94db4f2abf87558b$var$ImageReplacer();
        this.numberingReplacer = new $94db4f2abf87558b$var$NumberingReplacer();
    }
    (0, $7cSld._)(Compiler, [
        {
            key: "compile",
            value: function compile(file, prettifyXml) {
                var zip = new $94db4f2abf87558b$var$JSZip();
                var xmlifiedFileMapping = this.xmlifyFile(file, prettifyXml);
                var map = new Map(Object.entries(xmlifiedFileMapping));
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = map[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $21h22._)(_step.value, 2), obj = _step_value[1];
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        if (Array.isArray(obj)) try {
                            for(var _iterator1 = obj[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var subFile = _step1.value;
                                zip.file(subFile.path, subFile.data);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        else zip.file(obj.path, obj.data);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                try {
                    for(var _iterator2 = file.Media.Array[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        var _step_value1 = _step2.value, stream = _step_value1.stream, fileName = _step_value1.fileName;
                        zip.file("word/media/".concat(fileName), stream);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
                var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                try {
                    for(var _iterator3 = file.FontTable.fontOptionsWithKey[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                        var _step_value2 = _step3.value, buffer2 = _step_value2.data, name = _step_value2.name, fontKey = _step_value2.fontKey;
                        var _name_split = (0, $21h22._)(name.split("."), 1), nameWithoutExtension = _name_split[0];
                        zip.file("word/fonts/".concat(nameWithoutExtension, ".odttf"), $94db4f2abf87558b$var$obfuscate(buffer2, fontKey));
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                            _iterator3.return();
                        }
                    } finally{
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
                return zip;
            }
        },
        {
            key: "xmlifyFile",
            value: function xmlifyFile(file, prettify) {
                var _this = this;
                var documentRelationshipCount = file.Document.Relationships.RelationshipCount + 1;
                var documentXmlData = $94db4f2abf87558b$var$xml$1(this.formatter.format(file.Document.View, {
                    viewWrapper: file.Document,
                    file: file,
                    stack: []
                }), {
                    indent: prettify,
                    declaration: {
                        standalone: "yes",
                        encoding: "UTF-8"
                    }
                });
                var documentMediaDatas = this.imageReplacer.getMediaData(documentXmlData, file.Media);
                return {
                    Relationships: {
                        data: function() {
                            documentMediaDatas.forEach(function(mediaData, i) {
                                file.Document.Relationships.createRelationship(documentRelationshipCount + i, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image", "media/".concat(mediaData.fileName));
                            });
                            return $94db4f2abf87558b$var$xml$1(_this.formatter.format(file.Document.Relationships, {
                                viewWrapper: file.Document,
                                file: file,
                                stack: []
                            }), {
                                indent: prettify,
                                declaration: {
                                    encoding: "UTF-8"
                                }
                            });
                        }(),
                        path: "word/_rels/document.xml.rels"
                    },
                    Document: {
                        data: function() {
                            var xmlData = _this.imageReplacer.replace(documentXmlData, documentMediaDatas, documentRelationshipCount);
                            var referenedXmlData = _this.numberingReplacer.replace(xmlData, file.Numbering.ConcreteNumbering);
                            return referenedXmlData;
                        }(),
                        path: "word/document.xml"
                    },
                    Styles: {
                        data: function() {
                            var xmlStyles = $94db4f2abf87558b$var$xml$1(_this.formatter.format(file.Styles, {
                                viewWrapper: file.Document,
                                file: file,
                                stack: []
                            }), {
                                indent: prettify,
                                declaration: {
                                    standalone: "yes",
                                    encoding: "UTF-8"
                                }
                            });
                            var referencedXmlStyles = _this.numberingReplacer.replace(xmlStyles, file.Numbering.ConcreteNumbering);
                            return referencedXmlStyles;
                        }(),
                        path: "word/styles.xml"
                    },
                    Properties: {
                        data: $94db4f2abf87558b$var$xml$1(this.formatter.format(file.CoreProperties, {
                            viewWrapper: file.Document,
                            file: file,
                            stack: []
                        }), {
                            indent: prettify,
                            declaration: {
                                standalone: "yes",
                                encoding: "UTF-8"
                            }
                        }),
                        path: "docProps/core.xml"
                    },
                    Numbering: {
                        data: $94db4f2abf87558b$var$xml$1(this.formatter.format(file.Numbering, {
                            viewWrapper: file.Document,
                            file: file,
                            stack: []
                        }), {
                            indent: prettify,
                            declaration: {
                                standalone: "yes",
                                encoding: "UTF-8"
                            }
                        }),
                        path: "word/numbering.xml"
                    },
                    FileRelationships: {
                        data: $94db4f2abf87558b$var$xml$1(this.formatter.format(file.FileRelationships, {
                            viewWrapper: file.Document,
                            file: file,
                            stack: []
                        }), {
                            indent: prettify,
                            declaration: {
                                encoding: "UTF-8"
                            }
                        }),
                        path: "_rels/.rels"
                    },
                    HeaderRelationships: file.Headers.map(function(headerWrapper, index) {
                        var xmlData = $94db4f2abf87558b$var$xml$1(_this.formatter.format(headerWrapper.View, {
                            viewWrapper: headerWrapper,
                            file: file,
                            stack: []
                        }), {
                            indent: prettify,
                            declaration: {
                                encoding: "UTF-8"
                            }
                        });
                        var mediaDatas = _this.imageReplacer.getMediaData(xmlData, file.Media);
                        mediaDatas.forEach(function(mediaData, i) {
                            headerWrapper.Relationships.createRelationship(i, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image", "media/".concat(mediaData.fileName));
                        });
                        return {
                            data: $94db4f2abf87558b$var$xml$1(_this.formatter.format(headerWrapper.Relationships, {
                                viewWrapper: headerWrapper,
                                file: file,
                                stack: []
                            }), {
                                indent: prettify,
                                declaration: {
                                    encoding: "UTF-8"
                                }
                            }),
                            path: "word/_rels/header".concat(index + 1, ".xml.rels")
                        };
                    }),
                    FooterRelationships: file.Footers.map(function(footerWrapper, index) {
                        var xmlData = $94db4f2abf87558b$var$xml$1(_this.formatter.format(footerWrapper.View, {
                            viewWrapper: footerWrapper,
                            file: file,
                            stack: []
                        }), {
                            indent: prettify,
                            declaration: {
                                encoding: "UTF-8"
                            }
                        });
                        var mediaDatas = _this.imageReplacer.getMediaData(xmlData, file.Media);
                        mediaDatas.forEach(function(mediaData, i) {
                            footerWrapper.Relationships.createRelationship(i, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image", "media/".concat(mediaData.fileName));
                        });
                        return {
                            data: $94db4f2abf87558b$var$xml$1(_this.formatter.format(footerWrapper.Relationships, {
                                viewWrapper: footerWrapper,
                                file: file,
                                stack: []
                            }), {
                                indent: prettify,
                                declaration: {
                                    encoding: "UTF-8"
                                }
                            }),
                            path: "word/_rels/footer".concat(index + 1, ".xml.rels")
                        };
                    }),
                    Headers: file.Headers.map(function(headerWrapper, index) {
                        var tempXmlData = $94db4f2abf87558b$var$xml$1(_this.formatter.format(headerWrapper.View, {
                            viewWrapper: headerWrapper,
                            file: file,
                            stack: []
                        }), {
                            indent: prettify,
                            declaration: {
                                encoding: "UTF-8"
                            }
                        });
                        var mediaDatas = _this.imageReplacer.getMediaData(tempXmlData, file.Media);
                        var xmlData = _this.imageReplacer.replace(tempXmlData, mediaDatas, 0);
                        var referenedXmlData = _this.numberingReplacer.replace(xmlData, file.Numbering.ConcreteNumbering);
                        return {
                            data: referenedXmlData,
                            path: "word/header".concat(index + 1, ".xml")
                        };
                    }),
                    Footers: file.Footers.map(function(footerWrapper, index) {
                        var tempXmlData = $94db4f2abf87558b$var$xml$1(_this.formatter.format(footerWrapper.View, {
                            viewWrapper: footerWrapper,
                            file: file,
                            stack: []
                        }), {
                            indent: prettify,
                            declaration: {
                                encoding: "UTF-8"
                            }
                        });
                        var mediaDatas = _this.imageReplacer.getMediaData(tempXmlData, file.Media);
                        var xmlData = _this.imageReplacer.replace(tempXmlData, mediaDatas, 0);
                        var referenedXmlData = _this.numberingReplacer.replace(xmlData, file.Numbering.ConcreteNumbering);
                        return {
                            data: referenedXmlData,
                            path: "word/footer".concat(index + 1, ".xml")
                        };
                    }),
                    ContentTypes: {
                        data: $94db4f2abf87558b$var$xml$1(this.formatter.format(file.ContentTypes, {
                            viewWrapper: file.Document,
                            file: file,
                            stack: []
                        }), {
                            indent: prettify,
                            declaration: {
                                encoding: "UTF-8"
                            }
                        }),
                        path: "[Content_Types].xml"
                    },
                    CustomProperties: {
                        data: $94db4f2abf87558b$var$xml$1(this.formatter.format(file.CustomProperties, {
                            viewWrapper: file.Document,
                            file: file,
                            stack: []
                        }), {
                            indent: prettify,
                            declaration: {
                                standalone: "yes",
                                encoding: "UTF-8"
                            }
                        }),
                        path: "docProps/custom.xml"
                    },
                    AppProperties: {
                        data: $94db4f2abf87558b$var$xml$1(this.formatter.format(file.AppProperties, {
                            viewWrapper: file.Document,
                            file: file,
                            stack: []
                        }), {
                            indent: prettify,
                            declaration: {
                                standalone: "yes",
                                encoding: "UTF-8"
                            }
                        }),
                        path: "docProps/app.xml"
                    },
                    FootNotes: {
                        data: $94db4f2abf87558b$var$xml$1(this.formatter.format(file.FootNotes.View, {
                            viewWrapper: file.FootNotes,
                            file: file,
                            stack: []
                        }), {
                            indent: prettify,
                            declaration: {
                                encoding: "UTF-8"
                            }
                        }),
                        path: "word/footnotes.xml"
                    },
                    FootNotesRelationships: {
                        data: $94db4f2abf87558b$var$xml$1(this.formatter.format(file.FootNotes.Relationships, {
                            viewWrapper: file.FootNotes,
                            file: file,
                            stack: []
                        }), {
                            indent: prettify,
                            declaration: {
                                encoding: "UTF-8"
                            }
                        }),
                        path: "word/_rels/footnotes.xml.rels"
                    },
                    Settings: {
                        data: $94db4f2abf87558b$var$xml$1(this.formatter.format(file.Settings, {
                            viewWrapper: file.Document,
                            file: file,
                            stack: []
                        }), {
                            indent: prettify,
                            declaration: {
                                standalone: "yes",
                                encoding: "UTF-8"
                            }
                        }),
                        path: "word/settings.xml"
                    },
                    Comments: {
                        data: $94db4f2abf87558b$var$xml$1(this.formatter.format(file.Comments, {
                            viewWrapper: file.Document,
                            file: file,
                            stack: []
                        }), {
                            indent: prettify,
                            declaration: {
                                standalone: "yes",
                                encoding: "UTF-8"
                            }
                        }),
                        path: "word/comments.xml"
                    },
                    FontTable: {
                        data: $94db4f2abf87558b$var$xml$1(this.formatter.format(file.FontTable.View, {
                            viewWrapper: file.Document,
                            file: file,
                            stack: []
                        }), {
                            indent: prettify,
                            declaration: {
                                standalone: "yes",
                                encoding: "UTF-8"
                            }
                        }),
                        path: "word/fontTable.xml"
                    },
                    FontTableRelationships: {
                        data: function() {
                            return $94db4f2abf87558b$var$xml$1(_this.formatter.format(file.FontTable.Relationships, {
                                viewWrapper: file.Document,
                                file: file,
                                stack: []
                            }), {
                                indent: prettify,
                                declaration: {
                                    encoding: "UTF-8"
                                }
                            });
                        }(),
                        path: "word/_rels/fontTable.xml.rels"
                    }
                };
            }
        }
    ]);
    return Compiler;
}();
var $94db4f2abf87558b$export$846689ea131a0290 = {
    NONE: "",
    WITH_2_BLANKS: "  ",
    WITH_4_BLANKS: "    ",
    // eslint-disable-next-line @typescript-eslint/naming-convention
    WITH_TAB: "	"
};
var $94db4f2abf87558b$var$convertPrettifyType = function(prettify) {
    return prettify === true ? $94db4f2abf87558b$export$846689ea131a0290.WITH_2_BLANKS : prettify === false ? void 0 : prettify;
};
var $94db4f2abf87558b$export$b9ec4b114aa40074 = /*#__PURE__*/ function() {
    "use strict";
    function Packer() {
        (0, $gd0sY._)(this, Packer);
    }
    (0, $7cSld._)(Packer, null, [
        {
            key: "toString",
            value: function toString(file, prettify) {
                return $94db4f2abf87558b$var$__async(this, null, function() {
                    var zip, zipData;
                    return (0, $iLZuz._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                zip = this.compiler.compile(file, $94db4f2abf87558b$var$convertPrettifyType(prettify));
                                return [
                                    4,
                                    zip.generateAsync({
                                        type: "string",
                                        mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                        compression: "DEFLATE"
                                    })
                                ];
                            case 1:
                                zipData = _state.sent();
                                return [
                                    2,
                                    zipData
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "toBuffer",
            value: function toBuffer(file, prettify) {
                return $94db4f2abf87558b$var$__async(this, null, function() {
                    var zip, zipData;
                    return (0, $iLZuz._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                zip = this.compiler.compile(file, $94db4f2abf87558b$var$convertPrettifyType(prettify));
                                return [
                                    4,
                                    zip.generateAsync({
                                        type: "nodebuffer",
                                        mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                        compression: "DEFLATE"
                                    })
                                ];
                            case 1:
                                zipData = _state.sent();
                                return [
                                    2,
                                    zipData
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "toBase64String",
            value: function toBase64String(file, prettify) {
                return $94db4f2abf87558b$var$__async(this, null, function() {
                    var zip, zipData;
                    return (0, $iLZuz._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                zip = this.compiler.compile(file, $94db4f2abf87558b$var$convertPrettifyType(prettify));
                                return [
                                    4,
                                    zip.generateAsync({
                                        type: "base64",
                                        mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                        compression: "DEFLATE"
                                    })
                                ];
                            case 1:
                                zipData = _state.sent();
                                return [
                                    2,
                                    zipData
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "toBlob",
            value: function toBlob(file, prettify) {
                return $94db4f2abf87558b$var$__async(this, null, function() {
                    var zip, zipData;
                    return (0, $iLZuz._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                zip = this.compiler.compile(file, $94db4f2abf87558b$var$convertPrettifyType(prettify));
                                return [
                                    4,
                                    zip.generateAsync({
                                        type: "blob",
                                        mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                        compression: "DEFLATE"
                                    })
                                ];
                            case 1:
                                zipData = _state.sent();
                                return [
                                    2,
                                    zipData
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "toStream",
            value: function toStream(file, prettify) {
                var stream = new $94db4f2abf87558b$var$streamBrowserify.Stream();
                var zip = this.compiler.compile(file, $94db4f2abf87558b$var$convertPrettifyType(prettify));
                zip.generateAsync({
                    type: "nodebuffer",
                    mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    compression: "DEFLATE"
                }).then(function(z) {
                    stream.emit("data", z);
                    stream.emit("end");
                });
                return stream;
            }
        }
    ]);
    return Packer;
}();
$94db4f2abf87558b$var$__publicField($94db4f2abf87558b$export$b9ec4b114aa40074, "compiler", new $94db4f2abf87558b$var$Compiler());
var $94db4f2abf87558b$var$formatter$1 = new $94db4f2abf87558b$var$Formatter();
var $94db4f2abf87558b$var$toJson = function(xmlData) {
    var xmlObj = $94db4f2abf87558b$var$lib.xml2js(xmlData, {
        compact: false,
        captureSpacesBetweenElements: true
    });
    return xmlObj;
};
var $94db4f2abf87558b$var$createTextElementContents = function(text) {
    var _a;
    var textJson = $94db4f2abf87558b$var$toJson($94db4f2abf87558b$var$xml$1($94db4f2abf87558b$var$formatter$1.format(new $94db4f2abf87558b$var$Text({
        text: text
    }))));
    return (_a = textJson.elements[0].elements) != null ? _a : [];
};
var $94db4f2abf87558b$var$patchSpaceAttribute = function(element2) {
    return $94db4f2abf87558b$var$__spreadProps($94db4f2abf87558b$var$__spreadValues({}, element2), {
        attributes: {
            "xml:space": "preserve"
        }
    });
};
var $94db4f2abf87558b$var$getFirstLevelElements = function(relationships, id) {
    var _a, _b;
    return (_b = (_a = relationships.elements) == null ? void 0 : _a.filter(function(e) {
        return e.name === id;
    })[0].elements) != null ? _b : [];
};
var $94db4f2abf87558b$var$ReplaceMode = {
    START: 0,
    MIDDLE: 1,
    END: 2
};
var $94db4f2abf87558b$var$replaceTokenInParagraphElement = function(param) {
    var paragraphElement = param.paragraphElement, renderedParagraph = param.renderedParagraph, originalText = param.originalText, replacementText = param.replacementText;
    var startIndex = renderedParagraph.text.indexOf(originalText);
    var endIndex = startIndex + originalText.length - 1;
    var replaceMode = $94db4f2abf87558b$var$ReplaceMode.START;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator = renderedParagraph.runs[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
            var run = _step.value;
            try {
                for(var _iterator1 = run.parts[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = _step1.value, text = _step_value.text, index = _step_value.index, start = _step_value.start, end = _step_value.end;
                    switch(replaceMode){
                        case $94db4f2abf87558b$var$ReplaceMode.START:
                            if (startIndex >= start) {
                                var offsetStartIndex = startIndex - start;
                                var offsetEndIndex = Math.min(endIndex, end) - start;
                                var partToReplace = run.text.substring(offsetStartIndex, offsetEndIndex + 1);
                                if (partToReplace === "") continue;
                                var firstPart = text.replace(partToReplace, replacementText);
                                $94db4f2abf87558b$var$patchTextElement(paragraphElement.elements[run.index].elements[index], firstPart);
                                replaceMode = $94db4f2abf87558b$var$ReplaceMode.MIDDLE;
                                continue;
                            }
                            break;
                        case $94db4f2abf87558b$var$ReplaceMode.MIDDLE:
                            if (endIndex <= end) {
                                var lastPart = text.substring(endIndex - start + 1);
                                $94db4f2abf87558b$var$patchTextElement(paragraphElement.elements[run.index].elements[index], lastPart);
                                var currentElement2 = paragraphElement.elements[run.index].elements[index];
                                paragraphElement.elements[run.index].elements[index] = $94db4f2abf87558b$var$patchSpaceAttribute(currentElement2);
                                replaceMode = $94db4f2abf87558b$var$ReplaceMode.END;
                            } else $94db4f2abf87558b$var$patchTextElement(paragraphElement.elements[run.index].elements[index], "");
                            break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return paragraphElement;
};
var $94db4f2abf87558b$var$patchTextElement = function(element2, text) {
    element2.elements = $94db4f2abf87558b$var$createTextElementContents(text);
    return element2;
};
var $94db4f2abf87558b$var$findRunElementIndexWithToken = function(paragraphElement, token) {
    var _a, _b, _c, _d;
    for(var i = 0; i < ((_a = paragraphElement.elements) != null ? _a : []).length; i++){
        var element2 = paragraphElement.elements[i];
        if (element2.type === "element" && element2.name === "w:r") {
            var textElement = ((_b = element2.elements) != null ? _b : []).filter(function(e) {
                return e.type === "element" && e.name === "w:t";
            });
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = textElement[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var text = _step.value;
                    if (!((_c = text.elements) == null ? void 0 : _c[0])) continue;
                    if ((_d = text.elements[0].text) == null ? void 0 : _d.includes(token)) return i;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }
    throw new Error("Token not found");
};
var $94db4f2abf87558b$var$splitRunElement = function(runElement, token) {
    var _a, _b;
    var splitIndex = 0;
    var splitElements = (_b = (_a = runElement.elements) == null ? void 0 : _a.map(function(e, i) {
        var _a2, _b2;
        if (e.type === "element" && e.name === "w:t") {
            var text = (_b2 = (_a2 = e.elements) == null ? void 0 : _a2[0].text) != null ? _b2 : "";
            var splitText = text.split(token);
            var newElements = splitText.map(function(t) {
                return $94db4f2abf87558b$var$__spreadProps($94db4f2abf87558b$var$__spreadValues($94db4f2abf87558b$var$__spreadValues({}, e), $94db4f2abf87558b$var$patchSpaceAttribute(e)), {
                    elements: $94db4f2abf87558b$var$createTextElementContents(t)
                });
            });
            splitIndex = i;
            return newElements;
        } else return e;
    }).flat()) != null ? _b : [];
    var leftRunElement = $94db4f2abf87558b$var$__spreadProps($94db4f2abf87558b$var$__spreadValues({}, JSON.parse(JSON.stringify(runElement))), {
        elements: splitElements.slice(0, splitIndex + 1)
    });
    var rightRunElement = $94db4f2abf87558b$var$__spreadProps($94db4f2abf87558b$var$__spreadValues({}, JSON.parse(JSON.stringify(runElement))), {
        elements: splitElements.slice(splitIndex + 1)
    });
    return {
        left: leftRunElement,
        right: rightRunElement
    };
};
var $94db4f2abf87558b$var$formatter = new $94db4f2abf87558b$var$Formatter();
var $94db4f2abf87558b$var$SPLIT_TOKEN = "\u0275";
var $94db4f2abf87558b$var$replacer = function(json, patch, patchText, renderedParagraphs, context) {
    var keepOriginalStyles = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var renderedParagraph = _step.value;
            var textJson = patch.children.map(function(c) {
                return $94db4f2abf87558b$var$toJson($94db4f2abf87558b$var$xml$1($94db4f2abf87558b$var$formatter.format(c, context)));
            }).map(function(c) {
                return c.elements[0];
            });
            switch(patch.type){
                case $94db4f2abf87558b$export$f2a72f9061335e5d.DOCUMENT:
                    {
                        var _parentElement_elements;
                        var parentElement = $94db4f2abf87558b$var$goToParentElementFromPath(json, renderedParagraph.path);
                        var elementIndex = $94db4f2abf87558b$var$getLastElementIndexFromPath(renderedParagraph.path);
                        (_parentElement_elements = parentElement.elements).splice.apply(_parentElement_elements, [
                            elementIndex,
                            1
                        ].concat((0, $6zk1M._)(textJson)));
                        break;
                    }
                case $94db4f2abf87558b$export$f2a72f9061335e5d.PARAGRAPH:
                default:
                    {
                        var _paragraphElement_elements;
                        var paragraphElement = $94db4f2abf87558b$var$goToElementFromPath(json, renderedParagraph.path);
                        $94db4f2abf87558b$var$replaceTokenInParagraphElement({
                            paragraphElement: paragraphElement,
                            renderedParagraph: renderedParagraph,
                            originalText: patchText,
                            replacementText: $94db4f2abf87558b$var$SPLIT_TOKEN
                        });
                        var index = $94db4f2abf87558b$var$findRunElementIndexWithToken(paragraphElement, $94db4f2abf87558b$var$SPLIT_TOKEN);
                        var runElementToBeReplaced = paragraphElement.elements[index];
                        var _splitRunElement = $94db4f2abf87558b$var$splitRunElement(runElementToBeReplaced, $94db4f2abf87558b$var$SPLIT_TOKEN), left = _splitRunElement.left, right = _splitRunElement.right;
                        var newRunElements = textJson;
                        var patchedRightElement = right;
                        if (keepOriginalStyles) {
                            var runElementNonTextualElements = runElementToBeReplaced.elements.filter(function(e) {
                                return e.type === "element" && e.name !== "w:t";
                            });
                            newRunElements = textJson.map(function(e) {
                                return $94db4f2abf87558b$var$__spreadProps($94db4f2abf87558b$var$__spreadValues({}, e), {
                                    elements: (0, $6zk1M._)(runElementNonTextualElements).concat((0, $6zk1M._)(e.elements))
                                });
                            });
                            patchedRightElement = $94db4f2abf87558b$var$__spreadProps($94db4f2abf87558b$var$__spreadValues({}, right), {
                                elements: (0, $6zk1M._)(runElementNonTextualElements).concat((0, $6zk1M._)(right.elements))
                            });
                        }
                        (_paragraphElement_elements = paragraphElement.elements).splice.apply(_paragraphElement_elements, [
                            index,
                            1,
                            left
                        ].concat((0, $6zk1M._)(newRunElements), [
                            patchedRightElement
                        ]));
                        break;
                    }
            }
        };
        for(var _iterator = renderedParagraphs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return json;
};
var $94db4f2abf87558b$var$goToElementFromPath = function(json, path) {
    var element2 = json;
    for(var i = 1; i < path.length; i++){
        var index = path[i];
        var nextElements = element2.elements;
        if (!nextElements) throw new Error("Could not find element");
        element2 = nextElements[index];
    }
    return element2;
};
var $94db4f2abf87558b$var$goToParentElementFromPath = function(json, path) {
    return $94db4f2abf87558b$var$goToElementFromPath(json, path.slice(0, path.length - 1));
};
var $94db4f2abf87558b$var$getLastElementIndexFromPath = function(path) {
    return path[path.length - 1];
};
var $94db4f2abf87558b$var$renderParagraphNode = function(node) {
    if (node.element.name !== "w:p") throw new Error("Invalid node type: ".concat(node.element.name));
    if (!node.element.elements) return {
        text: "",
        runs: [],
        index: -1,
        path: []
    };
    var currentRunStringLength = 0;
    var runs = node.element.elements.map(function(element2, i) {
        return {
            element: element2,
            i: i
        };
    }).filter(function(param) {
        var element2 = param.element;
        return element2.name === "w:r";
    }).map(function(param) {
        var element2 = param.element, i = param.i;
        var renderedRunNode = $94db4f2abf87558b$var$renderRunNode(element2, i, currentRunStringLength);
        currentRunStringLength += renderedRunNode.text.length;
        return renderedRunNode;
    }).filter(function(e) {
        return !!e;
    }).map(function(e) {
        return e;
    });
    var text = runs.reduce(function(acc, curr) {
        return acc + curr.text;
    }, "");
    return {
        text: text,
        runs: runs,
        index: node.index,
        path: $94db4f2abf87558b$var$buildNodePath(node)
    };
};
var $94db4f2abf87558b$var$renderRunNode = function(node, index, currentRunStringIndex) {
    if (!node.elements) return {
        text: "",
        parts: [],
        index: -1,
        start: currentRunStringIndex,
        end: currentRunStringIndex
    };
    var currentTextStringIndex = currentRunStringIndex;
    var parts = node.elements.map(function(element2, i) {
        var _a, _b;
        return element2.name === "w:t" && element2.elements && element2.elements.length > 0 ? {
            text: (_b = (_a = element2.elements[0].text) == null ? void 0 : _a.toString()) != null ? _b : "",
            index: i,
            start: currentTextStringIndex,
            end: function() {
                var _a2, _b2;
                currentTextStringIndex += ((_b2 = (_a2 = element2.elements[0].text) == null ? void 0 : _a2.toString()) != null ? _b2 : "").length - 1;
                return currentTextStringIndex;
            }()
        } : void 0;
    }).filter(function(e) {
        return !!e;
    }).map(function(e) {
        return e;
    });
    var text = parts.reduce(function(acc, curr) {
        return acc + curr.text;
    }, "");
    return {
        text: text,
        parts: parts,
        index: index,
        start: currentRunStringIndex,
        end: currentTextStringIndex
    };
};
var $94db4f2abf87558b$var$buildNodePath = function(node) {
    return node.parent ? (0, $6zk1M._)($94db4f2abf87558b$var$buildNodePath(node.parent)).concat([
        node.index
    ]) : [
        node.index
    ];
};
var $94db4f2abf87558b$var$elementsToWrapper = function(wrapper) {
    var _a, _b;
    return (_b = (_a = wrapper.element.elements) == null ? void 0 : _a.map(function(e, i) {
        return {
            element: e,
            index: i,
            parent: wrapper
        };
    })) != null ? _b : [];
};
var $94db4f2abf87558b$var$findLocationOfText = function(node, text) {
    var renderedParagraphs = [];
    var queue2 = (0, $6zk1M._)($94db4f2abf87558b$var$elementsToWrapper({
        element: node,
        index: 0,
        parent: void 0
    }));
    var currentNode;
    while(queue2.length > 0){
        var _queue2;
        currentNode = queue2.shift();
        if (currentNode.element.name === "w:p") renderedParagraphs = (0, $6zk1M._)(renderedParagraphs).concat([
            $94db4f2abf87558b$var$renderParagraphNode(currentNode)
        ]);
        else (_queue2 = queue2).push.apply(_queue2, (0, $6zk1M._)($94db4f2abf87558b$var$elementsToWrapper(currentNode)));
    }
    return renderedParagraphs.filter(function(p) {
        return p.text.includes(text);
    });
};
var $94db4f2abf87558b$var$getIdFromRelationshipId = function(relationshipId) {
    var output = parseInt(relationshipId.substring(3), 10);
    return isNaN(output) ? 0 : output;
};
var $94db4f2abf87558b$var$getNextRelationshipIndex = function(relationships) {
    var relationshipElements = $94db4f2abf87558b$var$getFirstLevelElements(relationships, "Relationships");
    return relationshipElements.map(function(e) {
        var _a, _b, _c;
        return $94db4f2abf87558b$var$getIdFromRelationshipId((_c = (_b = (_a = e.attributes) == null ? void 0 : _a.Id) == null ? void 0 : _b.toString()) != null ? _c : "");
    }).reduce(function(acc, curr) {
        return Math.max(acc, curr);
    }, 0) + 1;
};
var $94db4f2abf87558b$var$appendRelationship = function(relationships, id, type, target, targetMode) {
    var relationshipElements = $94db4f2abf87558b$var$getFirstLevelElements(relationships, "Relationships");
    relationshipElements.push({
        attributes: {
            Id: "rId".concat(id),
            Type: type,
            Target: target,
            TargetMode: targetMode
        },
        name: "Relationship",
        type: "element"
    });
    return relationshipElements;
};
var $94db4f2abf87558b$var$appendContentType = function(element2, contentType, extension) {
    var relationshipElements = $94db4f2abf87558b$var$getFirstLevelElements(element2, "Types");
    var exist = relationshipElements.some(function(el) {
        var _a, _b;
        return el.type === "element" && el.name === "Default" && ((_a = el == null ? void 0 : el.attributes) == null ? void 0 : _a.ContentType) === contentType && ((_b = el == null ? void 0 : el.attributes) == null ? void 0 : _b.Extension) === extension;
    });
    if (exist) return;
    relationshipElements.push({
        attributes: {
            ContentType: contentType,
            Extension: extension
        },
        name: "Default",
        type: "element"
    });
};
var $94db4f2abf87558b$export$f2a72f9061335e5d = {
    DOCUMENT: "file",
    PARAGRAPH: "paragraph"
};
var $94db4f2abf87558b$var$imageReplacer = new $94db4f2abf87558b$var$ImageReplacer();
var $94db4f2abf87558b$export$cbdefd6464a7f9df = function(data, options2) {
    return $94db4f2abf87558b$var$__async(void 0, null, function() {
        var _a, _b, zipContent, contexts, file, map, imageRelationshipAdditions, hyperlinkRelationshipAdditions, hasMedia, binaryContentMap, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, err, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, _step_value, key, mediaDatas, relationshipKey, relationshipsJson, index, newJson, i, fileName, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _step_value1, key1, hyperlink, relationshipKey1, relationshipsJson1, contentTypesJson, zip, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _step_value2, key2, value, output, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, _step_value3, key3, value1, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, _step_value4, stream, fileName1;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $94db4f2abf87558b$var$JSZip.loadAsync(data)
                    ];
                case 1:
                    zipContent = _state.sent();
                    contexts = /* @__PURE__ */ new Map();
                    file = {
                        Media: new $94db4f2abf87558b$export$7fc53215244aec38()
                    };
                    map = /* @__PURE__ */ new Map();
                    imageRelationshipAdditions = [];
                    hyperlinkRelationshipAdditions = [];
                    hasMedia = false;
                    binaryContentMap = /* @__PURE__ */ new Map();
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        7,
                        8,
                        9
                    ]);
                    _loop = function() {
                        var _step_value, key, value, _, _tmp, json, context, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step1, _step_value1, patchKey, patchValue, patchText, renderedParagraphs, mediaDatas;
                        return (0, $iLZuz._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _step_value = (0, $21h22._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                                    if (!(!key.endsWith(".xml") && !key.endsWith(".rels"))) return [
                                        3,
                                        2
                                    ];
                                    _ = binaryContentMap.set;
                                    _tmp = [
                                        key
                                    ];
                                    return [
                                        4,
                                        value.async("uint8array")
                                    ];
                                case 1:
                                    _.apply(binaryContentMap, _tmp.concat([
                                        _state.sent()
                                    ]));
                                    return [
                                        2,
                                        "continue"
                                    ];
                                case 2:
                                    return [
                                        4,
                                        value.async("text")
                                    ];
                                case 3:
                                    json = $94db4f2abf87558b$var$toJson.apply(void 0, [
                                        _state.sent()
                                    ]);
                                    if (key.startsWith("word/") && !key.endsWith(".xml.rels")) {
                                        context = {
                                            file: file,
                                            viewWrapper: {
                                                Relationships: {
                                                    createRelationship: function(linkId, _, target, __) {
                                                        hyperlinkRelationshipAdditions.push({
                                                            key: key,
                                                            hyperlink: {
                                                                id: linkId,
                                                                link: target
                                                            }
                                                        });
                                                    }
                                                }
                                            },
                                            stack: []
                                        };
                                        contexts.set(key, context);
                                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        try {
                                            for(_iterator = Object.entries(options2.patches)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                _step_value1 = (0, $21h22._)(_step1.value, 2), patchKey = _step_value1[0], patchValue = _step_value1[1];
                                                patchText = "{{".concat(patchKey, "}}");
                                                renderedParagraphs = $94db4f2abf87558b$var$findLocationOfText(json, patchText);
                                                $94db4f2abf87558b$var$replacer(json, $94db4f2abf87558b$var$__spreadProps($94db4f2abf87558b$var$__spreadValues({}, patchValue), {
                                                    children: patchValue.children.map(function(element2) {
                                                        if (element2 instanceof $94db4f2abf87558b$export$6ea6a3f0b2b263f3) {
                                                            var concreteHyperlink = new $94db4f2abf87558b$export$6beda279b4a51476(element2.options.children, $94db4f2abf87558b$export$8b15d37bc3f197d4());
                                                            hyperlinkRelationshipAdditions.push({
                                                                key: key,
                                                                hyperlink: {
                                                                    id: concreteHyperlink.linkId,
                                                                    link: element2.options.link
                                                                }
                                                            });
                                                            return concreteHyperlink;
                                                        } else return element2;
                                                    })
                                                }), patchText, renderedParagraphs, context, options2.keepOriginalStyles);
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                    _iterator.return();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                        mediaDatas = $94db4f2abf87558b$var$imageReplacer.getMediaData(JSON.stringify(json), context.file.Media);
                                        if (mediaDatas.length > 0) {
                                            hasMedia = true;
                                            imageRelationshipAdditions.push({
                                                key: key,
                                                mediaDatas: mediaDatas
                                            });
                                        }
                                    }
                                    map.set(key, json);
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    _iterator = Object.entries(zipContent.files)[Symbol.iterator]();
                    _state.label = 3;
                case 3:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        6
                    ];
                    return [
                        5,
                        (0, $6PS3Z.__values)(_loop())
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        3
                    ];
                case 6:
                    return [
                        3,
                        9
                    ];
                case 7:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        9
                    ];
                case 8:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 9:
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(_iterator1 = imageRelationshipAdditions[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            _step_value = _step1.value, key = _step_value.key, mediaDatas = _step_value.mediaDatas;
                            relationshipKey = "word/_rels/".concat(key.split("/").pop(), ".rels");
                            relationshipsJson = (_a = map.get(relationshipKey)) != null ? _a : $94db4f2abf87558b$var$createRelationshipFile();
                            map.set(relationshipKey, relationshipsJson);
                            index = $94db4f2abf87558b$var$getNextRelationshipIndex(relationshipsJson);
                            newJson = $94db4f2abf87558b$var$imageReplacer.replace(JSON.stringify(map.get(key)), mediaDatas, index);
                            map.set(key, JSON.parse(newJson));
                            for(i = 0; i < mediaDatas.length; i++){
                                fileName = mediaDatas[i].fileName;
                                $94db4f2abf87558b$var$appendRelationship(relationshipsJson, index + i, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image", "media/".concat(fileName));
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(_iterator2 = hyperlinkRelationshipAdditions[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            _step_value1 = _step2.value, key1 = _step_value1.key, hyperlink = _step_value1.hyperlink;
                            relationshipKey1 = "word/_rels/".concat(key1.split("/").pop(), ".rels");
                            relationshipsJson1 = (_b = map.get(relationshipKey1)) != null ? _b : $94db4f2abf87558b$var$createRelationshipFile();
                            map.set(relationshipKey1, relationshipsJson1);
                            $94db4f2abf87558b$var$appendRelationship(relationshipsJson1, hyperlink.id, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink", hyperlink.link, $94db4f2abf87558b$var$TargetModeType.EXTERNAL);
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                    if (hasMedia) {
                        contentTypesJson = map.get("[Content_Types].xml");
                        if (!contentTypesJson) throw new Error("Could not find content types file");
                        $94db4f2abf87558b$var$appendContentType(contentTypesJson, "image/png", "png");
                        $94db4f2abf87558b$var$appendContentType(contentTypesJson, "image/jpeg", "jpeg");
                        $94db4f2abf87558b$var$appendContentType(contentTypesJson, "image/jpeg", "jpg");
                        $94db4f2abf87558b$var$appendContentType(contentTypesJson, "image/bmp", "bmp");
                        $94db4f2abf87558b$var$appendContentType(contentTypesJson, "image/gif", "gif");
                    }
                    zip = new $94db4f2abf87558b$var$JSZip();
                    _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                    try {
                        for(_iterator3 = map[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                            _step_value2 = (0, $21h22._)(_step3.value, 2), key2 = _step_value2[0], value = _step_value2[1];
                            output = $94db4f2abf87558b$var$toXml(value);
                            zip.file(key2, output);
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                _iterator3.return();
                            }
                        } finally{
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                    _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
                    try {
                        for(_iterator4 = binaryContentMap[Symbol.iterator](); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                            _step_value3 = (0, $21h22._)(_step4.value, 2), key3 = _step_value3[0], value1 = _step_value3[1];
                            zip.file(key3, value1);
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                                _iterator4.return();
                            }
                        } finally{
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }
                    _iteratorNormalCompletion5 = true, _didIteratorError5 = false, _iteratorError5 = undefined;
                    try {
                        for(_iterator5 = file.Media.Array[Symbol.iterator](); !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true){
                            _step_value4 = _step5.value, stream = _step_value4.stream, fileName1 = _step_value4.fileName;
                            zip.file("word/media/".concat(fileName1), stream);
                        }
                    } catch (err) {
                        _didIteratorError5 = true;
                        _iteratorError5 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                                _iterator5.return();
                            }
                        } finally{
                            if (_didIteratorError5) {
                                throw _iteratorError5;
                            }
                        }
                    }
                    return [
                        2,
                        zip.generateAsync({
                            type: "uint8array",
                            mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                            compression: "DEFLATE"
                        })
                    ];
            }
        });
    });
};
var $94db4f2abf87558b$var$toXml = function(jsonObj) {
    var output = $94db4f2abf87558b$var$lib.js2xml(jsonObj);
    return output;
};
var $94db4f2abf87558b$var$createRelationshipFile = function() {
    return {
        declaration: {
            attributes: {
                version: "1.0",
                encoding: "UTF-8",
                standalone: "yes"
            }
        },
        elements: [
            {
                type: "element",
                name: "Relationships",
                attributes: {
                    xmlns: "http://schemas.openxmlformats.org/package/2006/relationships"
                },
                elements: []
            }
        ]
    };
};


var $027784accdf3eedc$exports = {};

var $2bfPH = parcelRequire("2bfPH");
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})(undefined, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != (typeof b === "undefined" ? "undefined" : (0, $2bfPH._)(b)) && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == (typeof window === "undefined" ? "undefined" : (0, $2bfPH._)(window)) && window.window === window ? window : "object" == (typeof self === "undefined" ? "undefined" : (0, $2bfPH._)(self)) && self.self === self ? self : "object" == (typeof $parcel$global === "undefined" ? "undefined" : (0, $2bfPH._)($parcel$global)) && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != (typeof window === "undefined" ? "undefined" : (0, $2bfPH._)(window)) || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, $027784accdf3eedc$exports = g;
});



var $1Mz1E = parcelRequire("1Mz1E");

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $iLZuz = parcelRequire("iLZuz");
var $979b1f5a2e975a61$exports = {};

$979b1f5a2e975a61$exports = (parcelRequire("eMmTl"));




var $d35bff39a532d6a8$exports = {};

var $2bfPH = parcelRequire("2bfPH");
var $40761280b577a31b$exports = {};
// shim for using process in browser
var $40761280b577a31b$var$process = $40761280b577a31b$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $40761280b577a31b$var$cachedSetTimeout;
var $40761280b577a31b$var$cachedClearTimeout;
function $40761280b577a31b$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $40761280b577a31b$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $40761280b577a31b$var$cachedSetTimeout = setTimeout;
        else $40761280b577a31b$var$cachedSetTimeout = $40761280b577a31b$var$defaultSetTimout;
    } catch (e) {
        $40761280b577a31b$var$cachedSetTimeout = $40761280b577a31b$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $40761280b577a31b$var$cachedClearTimeout = clearTimeout;
        else $40761280b577a31b$var$cachedClearTimeout = $40761280b577a31b$var$defaultClearTimeout;
    } catch (e) {
        $40761280b577a31b$var$cachedClearTimeout = $40761280b577a31b$var$defaultClearTimeout;
    }
})();
function $40761280b577a31b$var$runTimeout(fun) {
    if ($40761280b577a31b$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($40761280b577a31b$var$cachedSetTimeout === $40761280b577a31b$var$defaultSetTimout || !$40761280b577a31b$var$cachedSetTimeout) && setTimeout) {
        $40761280b577a31b$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $40761280b577a31b$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $40761280b577a31b$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $40761280b577a31b$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $40761280b577a31b$var$runClearTimeout(marker) {
    if ($40761280b577a31b$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($40761280b577a31b$var$cachedClearTimeout === $40761280b577a31b$var$defaultClearTimeout || !$40761280b577a31b$var$cachedClearTimeout) && clearTimeout) {
        $40761280b577a31b$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $40761280b577a31b$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $40761280b577a31b$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $40761280b577a31b$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $40761280b577a31b$var$queue = [];
var $40761280b577a31b$var$draining = false;
var $40761280b577a31b$var$currentQueue;
var $40761280b577a31b$var$queueIndex = -1;
function $40761280b577a31b$var$cleanUpNextTick() {
    if (!$40761280b577a31b$var$draining || !$40761280b577a31b$var$currentQueue) return;
    $40761280b577a31b$var$draining = false;
    if ($40761280b577a31b$var$currentQueue.length) $40761280b577a31b$var$queue = $40761280b577a31b$var$currentQueue.concat($40761280b577a31b$var$queue);
    else $40761280b577a31b$var$queueIndex = -1;
    if ($40761280b577a31b$var$queue.length) $40761280b577a31b$var$drainQueue();
}
function $40761280b577a31b$var$drainQueue() {
    if ($40761280b577a31b$var$draining) return;
    var timeout = $40761280b577a31b$var$runTimeout($40761280b577a31b$var$cleanUpNextTick);
    $40761280b577a31b$var$draining = true;
    var len = $40761280b577a31b$var$queue.length;
    while(len){
        $40761280b577a31b$var$currentQueue = $40761280b577a31b$var$queue;
        $40761280b577a31b$var$queue = [];
        while(++$40761280b577a31b$var$queueIndex < len)if ($40761280b577a31b$var$currentQueue) $40761280b577a31b$var$currentQueue[$40761280b577a31b$var$queueIndex].run();
        $40761280b577a31b$var$queueIndex = -1;
        len = $40761280b577a31b$var$queue.length;
    }
    $40761280b577a31b$var$currentQueue = null;
    $40761280b577a31b$var$draining = false;
    $40761280b577a31b$var$runClearTimeout(timeout);
}
$40761280b577a31b$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $40761280b577a31b$var$queue.push(new $40761280b577a31b$var$Item(fun, args));
    if ($40761280b577a31b$var$queue.length === 1 && !$40761280b577a31b$var$draining) $40761280b577a31b$var$runTimeout($40761280b577a31b$var$drainQueue);
};
// v8 likes predictible objects
function $40761280b577a31b$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$40761280b577a31b$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$40761280b577a31b$var$process.title = 'browser';
$40761280b577a31b$var$process.browser = true;
$40761280b577a31b$var$process.env = {};
$40761280b577a31b$var$process.argv = [];
$40761280b577a31b$var$process.version = ''; // empty string to avoid regexp issues
$40761280b577a31b$var$process.versions = {};
function $40761280b577a31b$var$noop() {}
$40761280b577a31b$var$process.on = $40761280b577a31b$var$noop;
$40761280b577a31b$var$process.addListener = $40761280b577a31b$var$noop;
$40761280b577a31b$var$process.once = $40761280b577a31b$var$noop;
$40761280b577a31b$var$process.off = $40761280b577a31b$var$noop;
$40761280b577a31b$var$process.removeListener = $40761280b577a31b$var$noop;
$40761280b577a31b$var$process.removeAllListeners = $40761280b577a31b$var$noop;
$40761280b577a31b$var$process.emit = $40761280b577a31b$var$noop;
$40761280b577a31b$var$process.prependListener = $40761280b577a31b$var$noop;
$40761280b577a31b$var$process.prependOnceListener = $40761280b577a31b$var$noop;
$40761280b577a31b$var$process.listeners = function(name) {
    return [];
};
$40761280b577a31b$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$40761280b577a31b$var$process.cwd = function() {
    return '/';
};
$40761280b577a31b$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$40761280b577a31b$var$process.umask = function() {
    return 0;
};


var $d9eea3283bc93203$exports = {};

var $2bfPH = parcelRequire("2bfPH");

var $21h22 = parcelRequire("21h22");

var $6zk1M = parcelRequire("6zk1M");
var $d2e30b95e37327a0$export$615d43d8cc127491;
var $d2e30b95e37327a0$export$36ffab104b289974;
var $d2e30b95e37327a0$export$bd0bfd2513508520;
var $d2e30b95e37327a0$export$37623781dd5ede44;
"use strict";
"function" == typeof SuppressedError && SuppressedError;
var $d2e30b95e37327a0$var$n = function(n, a) {
    if (n === a) return 0;
    var _n_split_map = (0, $21h22._)(n.split(".", 2).map(Number), 2), tmp = _n_split_map[0], e = tmp === void 0 ? 0 : tmp, tmp1 = _n_split_map[1], u = tmp1 === void 0 ? 0 : tmp1, _a_split_map = (0, $21h22._)(a.split(".", 2).map(Number), 2), tmp2 = _a_split_map[0], s = tmp2 === void 0 ? 0 : tmp2, tmp3 = _a_split_map[1], o = tmp3 === void 0 ? 0 : tmp3;
    if (isNaN(e) || isNaN(u)) throw new Error("Invalid version: ".concat(n));
    if (isNaN(s) || isNaN(o)) throw new Error("Invalid version: ".concat(a));
    return e !== s ? e > s ? 1 : -1 : u !== o ? u > o ? 1 : -1 : 0;
}, $d2e30b95e37327a0$var$a = {
    c: {
        longName: "chrome"
    },
    ca: {
        longName: "chrome_android"
    },
    e: {
        longName: "edge"
    },
    f: {
        longName: "firefox"
    },
    fa: {
        longName: "firefox_android"
    },
    s: {
        longName: "safari"
    },
    si: {
        longName: "safari_ios"
    },
    o: {
        longName: "opera",
        engine: "Blink"
    },
    oa: {
        longName: "opera_android",
        engine: "Blink"
    },
    sa: {
        longName: "samsunginternet_android",
        engine: "Blink"
    },
    wva: {
        longName: "webview_android",
        engine: "Blink"
    },
    y: {
        longName: "ya_android",
        engine: "Blink"
    },
    u: {
        longName: "uc_android",
        engine: "Blink"
    },
    q: {
        longName: "qq_android",
        engine: "Blink"
    },
    k: {
        longName: "kai_os",
        engine: "Gecko"
    },
    fb: {
        longName: "facebook_android",
        engine: "Blink"
    },
    ia: {
        longName: "instagram_android",
        engine: "Blink"
    }
}, $d2e30b95e37327a0$var$e = function(n) {
    return 6 === n.length && /^\d{6}$/.test(n) ? "20".concat(n.slice(0, 2), "-").concat(n.slice(2, 4), "-").concat(n.slice(4, 6)) : 8 === n.length && /^\d{8}$/.test(n) ? "".concat(n.slice(0, 4), "-").concat(n.slice(4, 6), "-").concat(n.slice(6, 8)) : n;
}, $d2e30b95e37327a0$var$u = {}, $d2e30b95e37327a0$var$s = {};
var $d2e30b95e37327a0$var$o = "", $d2e30b95e37327a0$var$f = !1;
"pre_baseline\nc,1,081211\nc,2,090521\nc,3,090915\nc,4,100125\nc,5,100525\nc,6,100902\nc,7,101019\nc,8,101202\nc,9,110203\nc,10,110308\nc,11,110427\nc,12,110607\nc,13,110802\nc,14,110916\nc,15,111025\nc,16,111213\nc,17,120208\nc,18,120328\nc,19,120515\nc,20,120626\nc,21,120731\nc,22,120925\nc,23,121106\nc,24,130110\nc,25,130221\nc,26,130326\nc,27,130521\nc,28,130709\nc,29,130820\nc,30,131001\nc,31,131112\nc,32,140114\nc,33,140220\nc,34,140408\nc,35,140520\nc,36,140716\nc,37,140826\nc,38,141007\nc,39,141118\nc,40,150121\nc,41,150303\nc,42,150414\nc,43,150519\nc,44,150721\nca,18,120627\nca,25,130227\nca,26,130403\nca,27,130522\nca,28,130710\nca,29,130821\nca,30,131002\nca,31,131114\nca,32,140115\nca,33,140226\nca,34,140402\nca,35,140520\nca,36,140716\nca,37,140903\nca,38,141008\nca,39,141112\nca,40,150121\nca,41,150311\nca,42,150415\nca,43,150527\nf,1,041109\nf,1.5,051129\nf,2,061024\nf,3,080617\nf,3.5,090630\nf,3.6,100121\nf,4,110322\nf,5,110621\nf,6,110816\nf,7,110927\nf,8,111108\nf,9,111220\nf,10,120131\nf,11,120313\nf,12,120424\nf,13,120605\nf,14,120717\nf,15,120828\nf,16,121009\nf,17,121120\nf,18,130108\nf,19,130219\nf,20,130402\nf,21,130514\nf,22,130625\nf,23,130806\nf,24,130917\nf,25,131029\nf,26,131210\nf,27,140204\nf,28,140318\nf,29,140429\nf,30,140610\nf,31,140722\nf,32,140902\nf,33,141014\nf,34,141201\nf,35,150113\nf,36,150224\nf,37,150331\nf,38,150512\nf,39,150702\nfa,4,110329\nfa,5,110621\nfa,6,110816\nfa,7,110927\nfa,8,111108\nfa,9,111221\nfa,10,120131\nfa,14,120626\nfa,15,120828\nfa,16,121009\nfa,17,121120\nfa,18,130108\nfa,19,130219\nfa,20,130402\nfa,21,130514\nfa,22,130625\nfa,23,130806\nfa,24,130917\nfa,25,131029\nfa,26,131210\nfa,27,140204\nfa,28,140318\nfa,29,140429\nfa,30,140610\nfa,31,140722\nfa,32,140902\nfa,33,141014\nfa,34,141201\nfa,35,150113\nfa,36,150227\nfa,37,150331\nfa,38,150512\nfa,39,150702\ns,1,030623\ns,1.1,031024\ns,1.2,040202\ns,1.3,050415\ns,2,050429\ns,3,071026\ns,3.1,080318\ns,4,090608\ns,5,100607\ns,5.1,110720\ns,6,120725\ns,7,131022\ns,8,141016\nsi,1,070629\nsi,2,080711\nsi,3,090617\nsi,3.2,100403\nsi,4,100621\nsi,4.2,101122\nsi,5,111012\nsi,6,120910\nsi,7,130918\nsi,8,140917\n20150729\nc,38,141007\nca,38,141008\ne,12,150729\nf,38,150512\nfa,38,150512\ns,11,170919\nsi,11,170919\no,25,141015,38\noa,25,141016,38\nsa,3.0,150410,38\nwva,38,141008,38\ny,14.12,u,38\nu,11.1,u,40\nq,8.1,u,57\nk,2.0,170701,48\nfb,66,u,48\nia,23,u,62\n20150922\nf,41,150922\nfa,41,150922\n20150930\nc,44,150721\nca,44,150729\no,31,150804,44\noa,32,150923,45\nsa,4.0,160311,44\nwva,44,150729,44\ny,15.9,u,44\nu,11.6,u,57\n20151112\ne,13,151112\n20151231\nc,44,150721\nca,44,150729\ne,13,151112\nf,41,150922\nfa,41,150922\ns,11,170919\nsi,11,170919\no,31,150804,44\noa,32,150923,45\nsa,4.0,160311,44\nwva,44,150729,44\ny,15.9,u,44\nu,11.6,u,57\nq,8.1,u,57\nk,2.0,170701,48\nfb,66,u,48\nia,23,u,62\n20160308\nf,45,160308\nfa,45,160308\n20160607\nf,47,160607\nfa,47,160607\n20160802\ne,14,160802\n20160907\nc,53,160831\nca,53,160907\no,40,160920,53\noa,41,161025,54\nsa,6.0,170823,56\nwva,53,160907,53\ny,16.10,u,53\nfb,95,u,53\n20160920\nf,49,160920\nfa,49,160920\nk,3.0,210901,84\n20161231\nc,53,160831\nca,53,160907\ne,14,160802\nf,49,160920\nfa,49,160920\ns,11,170919\nsi,11,170919\no,40,160920,53\noa,41,161025,54\nsa,6.0,170823,56\nwva,53,160907,53\ny,16.10,u,53\nu,11.6,u,57\nq,8.1,u,57\nk,3.0,210901,84\nfb,95,u,53\nia,23,u,62\n20170201\nc,56,170125\nca,56,170201\nf,50,161115\nfa,50,161115\no,43,170207,56\noa,43,170927,59\nwva,56,170201,56\ny,17.3,u,56\nfb,112,u,56\n20170307\nf,52,170307\nfa,52,170307\n20170316\nca,57,170316\n20170405\nc,57,170309\ne,15,170405\no,44,170321,57\nsa,7.0,180316,59\nwva,57,170316,57\ny,17.4,u,57\nfb,117,u,57\n20170419\nf,53,170419\nfa,53,170419\n20170928\nfa,56,170928\n20171017\ne,16,171017\n20171024\nc,62,171017\nca,62,171024\no,49,171108,62\noa,46,180514,63\nsa,8.0,180718,63\nwva,62,171024,62\ny,17.11,u,62\nu,13.3,200909,78\nq,9.6,u,66\nfb,149,u,62\n20171128\nfa,57,171128\n20171231\nc,62,171017\nca,62,171024\ne,16,171017\nf,53,170419\nfa,57,171128\ns,11,170919\nsi,11,170919\no,49,171108,62\noa,46,180514,63\nsa,8.0,180718,63\nwva,62,171024,62\ny,17.11,u,62\nu,13.3,200909,78\nq,9.6,u,66\nk,3.0,210901,84\nfb,149,u,62\nia,23,u,62\n20180412\ns,11.1,180412\nsi,11.3,180329\n20180430\ne,17,180430\n20180509\nc,66,180417\nca,66,180417\nf,60,180509\nfa,60,180509\no,53,180510,66\noa,47,180723,66\nsa,9.0,180915,67\nwva,66,180417,66\ny,18.6,u,66\nfb,169,u,66\nia,42,u,66\n20180905\nf,62,180905\nfa,62,180905\n20181002\ne,18,181002\n20181023\nf,63,181023\nfa,63,181023\n20181211\nf,64,181211\nfa,64,181211\n20181231\nc,66,180417\nca,66,180417\ne,18,181002\nf,64,181211\nfa,64,181211\ns,11.1,180412\nsi,11.3,180329\no,53,180510,66\noa,47,180723,66\nsa,9.0,180915,67\nwva,66,180417,66\ny,18.6,u,66\nu,13.3,200909,78\nq,9.6,u,66\nk,3.0,210901,84\nfb,169,u,66\nia,42,u,66\n20190129\nf,65,190129\nfa,65,190129\n20190325\ns,12.1,190325\nsi,12.2,190325\n20190919\ns,13,190919\nsi,13,190919\n20191231\nc,66,180417\nca,66,180417\ne,18,181002\nf,65,190129\nfa,65,190129\ns,13,190919\nsi,13,190919\no,53,180510,66\noa,47,180723,66\nsa,9.0,180915,67\nwva,66,180417,66\ny,18.6,u,66\nu,13.3,200909,78\nq,9.6,u,66\nk,3.0,210901,84\nfb,169,u,66\nia,42,u,66\n20200115\nc,76,190730\nca,76,190730\ne,79,200115\nf,68,190709\nfa,68,190709\no,63,190820,76\noa,54,191018,76\nsa,12.0,200619,79\nwva,76,190730,76\ny,19.9,u,76\nq,10.9,201122,77\nfb,233,u,76\nia,96,u,80\n20200204\nc,80,200204\nca,80,200204\no,67,200303,80\noa,57,200330,80\nsa,13.0,201202,83\nwva,80,200204,80\ny,20.3,u,80\nu,15.3,230317,100\nq,11.7,211102,89\nfb,256,u,80\n20200207\ne,80,200207\n20200324\ns,13.1,200324\nsi,13.4,200324\n20200413\nc,81,200407\nca,81,200407\ne,81,200413\no,68,200422,81\noa,58,200513,81\nwva,81,200407,81\ny,20.4,u,81\nfb,266,u,81\nia,137,u,81\n20200727\nc,84,200727\nca,84,200727\ne,84,200716\no,70,200727,84\noa,60,200923,85\nsa,14.0,210417,87\nwva,84,200727,84\ny,20.8,200902,84\nfb,297,201202,86\nia,153,u,84\n20200728\nf,78,200630\nfa,79,200728\n20200827\nc,85,200825\nca,85,200825\ne,85,200827\no,71,200915,85\nwva,85,200825,85\ny,20.9,200927,85\nia,163,u,92\n20200916\nf,79,200728\ns,14,200916\nsi,14,200916\n20201020\nc,86,201020\nca,86,201020\ne,86,201009\no,72,201021,86\noa,61,201207,86\nwva,86,201020,86\ny,20.11,201111,86\n20201117\nf,83,201117\nfa,83,201117\n20201119\nc,87,201117\nca,87,201117\ne,87,201119\no,73,201209,87\noa,62,210216,87\nwva,87,201117,87\ny,20.12,201220,87\nfb,348,211219,96\n20201231\nc,87,201117\nca,87,201117\ne,87,201119\nf,83,201117\nfa,83,201117\ns,14,200916\nsi,14,200916\no,73,201209,87\noa,62,210216,87\nsa,14.0,210417,87\nwva,87,201117,87\ny,20.12,201220,87\nu,15.3,230317,100\nq,11.7,211102,89\nk,3.0,210901,84\nfb,348,211219,96\nia,163,u,92\n20210121\nc,88,210119\nca,88,210119\ne,88,210121\nf,84,201215\nfa,84,201215\no,74,210202,88\noa,63,210416,89\nsa,15.0,210813,90\nwva,88,210119,88\ny,21.1,211231,88\n20210126\nf,85,210126\nfa,85,210126\nk,4.0,250501,123\n20210426\nc,89,210302\nca,89,210302\ne,89,210304\nf,86,210223\nfa,86,210223\ns,14.1,210426\nsi,14.5,210426\no,75,210324,89\nwva,89,210302,89\ny,21.3,210404,89\n20210810\nf,91,210810\nfa,91,210810\n20210902\ne,93,210902\n20210907\nf,92,210907\nfa,92,210907\n20210920\nc,93,210831\nca,93,210831\ns,15,210920\nsi,15,210920\no,79,210914,93\noa,66,211215,94\nsa,17.0,220504,96\nwva,93,210831,93\ny,21.9,210929,93\nq,13.4,230426,98\nia,258,221104,106\n20211005\nf,93,211005\nfa,93,211005\n20211025\ns,15.1,211025\nsi,15.1,211025\n20211102\nf,94,211102\nfa,94,211102\n20211119\nc,96,211115\nca,96,211115\ne,96,211119\no,82,211202,96\noa,67,220131,96\nwva,96,211115,96\ny,22.1,211231,96\n20211207\nf,95,211207\n20211213\ns,15.2,211213\nsi,15.2,211213\n20211231\nc,96,211115\nca,96,211115\ne,96,211119\nf,95,211207\nfa,94,211102\ns,15.2,211213\nsi,15.2,211213\no,82,211202,96\noa,67,220131,96\nsa,17.0,220504,96\nwva,96,211115,96\ny,22.1,211231,96\nu,15.3,230317,100\nq,13.4,230426,98\nk,4.0,250501,123\nfb,348,211219,96\nia,258,221104,106\n20220106\nc,97,220104\nca,97,220104\ne,97,220106\no,83,220119,97\noa,68,220330,99\nsa,18.0,220808,99\nwva,97,220104,97\ny,22.3,220325,98\nfb,399,230204,109\n20220203\nc,98,220201\nca,98,220201\ne,98,220203\nf,96,220111\nfa,96,220111\no,84,220216,98\nwva,98,220201,98\n20220303\nc,99,220301\nca,99,220301\ne,99,220303\no,85,220323,99\nwva,99,220301,99\ny,22.5,220520,100\nq,14.2,231014,109\n20220314\nf,98,220308\nfa,98,220308\ns,15.4,220314\nsi,15.4,220314\n20220428\nc,101,220426\nca,101,220426\ne,101,220428\no,87,220517,101\noa,70,220629,102\nsa,19.0,221101,102\nwva,101,220426,101\ny,22.7,220707,102\nu,17.6,250515,123\n20220503\nf,100,220503\nfa,100,220503\n20220531\nf,101,220531\nfa,101,220531\n20220628\nf,102,220628\nfa,102,220628\n20220726\nf,103,220726\nfa,103,220726\n20220805\nc,104,220802\nca,104,220802\ne,104,220805\no,90,220818,104\noa,71,220916,104\nsa,20.0,230210,106\nwva,104,220802,104\ny,22.8,u,104\n20220823\nf,104,220823\nfa,104,220823\n20220902\nc,105,220902\nca,105,220902\ne,105,220901\ns,15.6,220720\nsi,15.6,220720\no,91,220914,105\noa,72,221021,106\nwva,105,220902,105\ny,22.11,221111,106\n20220912\ns,16,220912\nsi,16,220912\n20221003\nc,106,220927\nca,106,220927\ne,106,221003\no,92,221019,106\nwva,106,220927,106\n20221027\nc,107,221025\nca,107,221025\ne,107,221027\no,93,221117,107\noa,73,230117,108\nsa,21.0,230519,110\nwva,107,221025,107\ny,23.1,230110,108\nia,279,231231,109\n20221115\nf,107,221115\nfa,107,221115\n20221205\nc,108,221129\nca,108,221129\ne,108,221205\no,94,221215,108\nwva,108,221129,108\n20221213\nf,108,221213\nfa,108,221213\n20221231\nc,108,221129\nca,108,221129\ne,108,221205\nf,108,221213\nfa,108,221213\ns,16,220912\nsi,16,220912\no,94,221215,108\noa,73,230117,108\nsa,21.0,230519,110\nwva,108,221129,108\ny,23.1,230110,108\nu,17.6,250515,123\nq,14.2,231014,109\nk,4.0,250501,123\nfb,399,230204,109\nia,279,231231,109\n20230112\nc,109,230110\nca,109,230110\ne,109,230112\no,95,230201,109\noa,74,230313,110\nwva,109,230110,109\ny,23.3,230326,110\n20230214\nf,110,230214\nfa,110,230214\n20230313\nc,111,230307\nca,111,230307\ne,111,230313\no,97,230322,111\noa,75,230517,112\nsa,22.0,230714,111\nwva,111,230301,111\ny,23.5,230519,112\nq,19.1,250708,121\nfb,420,230628,114\nia,288,u,114\n20230314\nf,111,230314\nfa,111,230314\n20230327\ns,16.4,230327\nsi,16.4,230327\n20230411\nf,112,230411\nfa,112,230411\n20230509\nf,113,230509\nfa,113,230509\n20230606\nf,114,230606\nfa,114,230606\n20230704\nc,112,230404\nca,112,230404\ne,112,230406\nf,115,230704\nfa,115,230704\no,98,230420,112\nsa,23.0,231018,115\nwva,112,230404,112\n20230721\nc,115,230718\nca,115,230721\ne,115,230721\no,101,230726,115\noa,77,230831,115\nwva,115,230721,115\ny,23.9,230913,116\nfb,430,230903,116\nia,292,u,115\n20230801\nf,116,230801\nfa,116,230801\n20230915\nc,117,230912\nca,117,230912\ne,117,230915\no,103,231003,117\noa,78,231023,117\nsa,24.0,240125,117\nwva,117,230912,117\ny,23.11,231115,118\nfb,434,231005,117\nia,302,u,117\n20230918\ns,17,230918\nsi,17,230918\n20231013\nc,118,231010\nca,118,231010\ne,118,231013\nf,118,230926\nfa,118,230926\no,104,231023,118\noa,79,231206,119\nsa,25.0,240424,121\nwva,118,231010,118\nfb,437,u,118\nia,306,240117,118\n20231024\nf,119,231024\nfa,119,231024\n20231102\nc,119,231031\nca,119,231031\ne,119,231102\no,105,231114,119\nwva,119,231031,119\ny,24.1,240118,120\nfb,439,231111,119\nia,309,u,119\n20231121\nf,120,231121\nfa,120,231121\n20231205\nca,120,231205\n20231207\nc,120,231205\ne,120,231207\no,106,231219,120\noa,80,240125,120\nwva,120,231205,120\nfb,443,231207,120\nia,311,u,120\n20231211\ns,17.2,231211\nsi,17.2,231211\n20231219\nf,121,231219\nfa,121,231219\n20231231\nc,120,231205\nca,120,231205\ne,120,231207\nf,121,231219\nfa,121,231219\ns,17.2,231211\nsi,17.2,231211\no,106,231219,120\noa,80,240125,120\nsa,25.0,240424,121\nwva,120,231205,120\ny,24.1,240118,120\nu,17.6,250515,123\nq,19.1,250708,121\nk,4.0,250501,123\nfb,443,231207,120\nia,311,u,120\n20240123\nf,122,240123\nfa,122,240123\n20240125\nc,121,240123\nca,121,240123\ne,121,240125\no,107,240207,121\noa,81,240314,122\nwva,121,240123,121\ny,24.4,240327,122\nfb,448,240129,121\nia,317,240203,121\n20240220\nf,123,240220\nfa,123,240220\n20240305\ns,17.4,240305\nsi,17.4,240305\n20240319\nf,124,240319\nfa,124,240319\n20240322\nc,123,240319\nca,123,240319\ne,123,240322\no,109,240327,123\noa,82,240502,124\nsa,27.0,241106,125\nwva,123,240319,123\ny,24.6,240604,124\nfb,465,240707,126\nia,338,240706,126\n20240416\nf,125,240416\nfa,125,240416\n20240418\nc,124,240416\nca,124,240416\ne,124,240418\no,110,240514,124\nwva,124,240416,124\n20240513\ns,17.5,240513\nsi,17.5,240513\n20240514\nf,126,240514\nfa,126,240514\n20240517\nc,125,240514\nca,125,240514\ne,125,240517\no,111,240612,125\noa,83,240625,126\nwva,125,240514,125\ny,24.7,240718,126\n20240611\nf,127,240611\nfa,127,240611\n20240709\nf,128,240709\nfa,128,240709\n20240725\nc,127,240723\nca,127,240723\ne,127,240725\no,113,240822,127\noa,84,240826,127\nsa,28.0,250402,130\nwva,127,240723,127\ny,24.10,241011,128\nfb,474,240730,127\nia,346,240901,127\n20240806\nf,129,240806\nfa,129,240806\n20240903\nf,130,240903\nfa,130,240903\n20240916\ns,18,240916\nsi,18,240916\n20241001\nf,131,241001\nfa,131,241001\n20241017\nc,130,241015\nca,130,241015\ne,130,241017\no,115,241127,130\noa,86,241202,130\nwva,130,241015,130\ny,24.12,241130,130\nfb,486,241018,130\nia,355,241106,130\n20241029\nf,132,241029\nfa,132,241029\n20241211\ns,18.2,241211\nsi,18.2,241211\n20241231\nc,130,241015\nca,130,241015\ne,130,241017\nf,132,241029\nfa,132,241029\ns,18.2,241211\nsi,18.2,241211\no,115,241127,130\noa,86,241202,130\nsa,28.0,250402,130\nwva,130,241015,130\ny,24.12,241130,130\nfb,486,241018,130\nia,355,241106,130\n20250107\nf,134,250107\nfa,134,250107\n20250127\nsi,18.3,250127\n20250304\nf,136,250304\nfa,136,250304\n20250331\ns,18.4,250331\nsi,18.4,250331\n20250401\nc,133,250204\nca,133,250204\ne,133,250206\nf,137,250401\nfa,137,250401\no,118,250415,133\noa,88,250319,134\nsa,29.0,251025,136\nwva,133,250204,133\ny,25.4,250423,134\nfb,503,250312,134\nia,378,250503,135\n20250404\nc,135,250401\nca,135,250401\ne,135,250404\no,120,250702,135\noa,89,250429,135\nwva,135,250401,135\ny,25.6,250904,136\nfb,514,250528,136\n20250429\nf,138,250429\nfa,138,250429\n20250501\nc,136,250429\nca,136,250429\ne,136,250501\no,121,250827,137\noa,90,250618,137\nwva,136,250429,136\nia,381,250619,137\n20250512\nsi,18.5,250512\n20250527\nf,139,250527\nfa,139,250527\n20250529\nc,137,250527\nca,137,250527\ne,137,250529\nwva,137,250527,137\ny,25.8,250830,138\nfb,515,250531,137\n20250626\nc,138,250624\nca,138,250624\ne,138,250626\no,122,250911,138\noa,91,250819,139\nwva,138,250624,138\nia,390,250726,138\n20250819\nf,142,250819\nfa,142,250819\n20250905\nc,140,250902\nca,140,250902\ne,140,250905\no,124,251113,140\noa,92,251008,140\nwva,140,250902,140\ny,25.10,251009,140\nia,399,250928,140\n20250915\ns,26,250915\nsi,26,250915\n20250916\nf,143,250916\nfa,143,250916\n20251003\nc,141,250930\nca,141,250930\ne,141,251003\no,125,251204,141\noa,93,251125,142\nwva,141,250930,141\ny,25.12,251207,142\nia,400,251006,141\n20251014\nf,144,251014\nfa,144,251014\n20251111\nf,145,251111\nfa,145,251111\n20251212\ns,26.2,251212\nsi,26.2,251212\n20251231\nc,141,250930\nca,141,250930\ne,141,251003\nf,145,251111\nfa,145,251111\ns,26.2,251212\nsi,26.2,251212\no,125,251204,141\noa,93,251125,142\nwva,141,250930,141\ny,25.12,251207,142\nia,400,251006,141\n20260113\nf,147,260113\nfa,147,260113\n20260211\ns,26.3,260211\nsi,26.3,260211\n20260214\nc,145,260210\nca,145,260210\ne,145,260214\no,129,260318,145\noa,96,260310,145\nwva,145,260210,145\ny,26.4,260425,146\nia,423,260405,146\n20260224\nf,148,260224\nfa,148,260224\n20260313\nc,146,260310\nca,146,260310\ne,146,260313\no,130,260408,146\noa,97,260416,146\nwva,146,260310,146\n20260324\nf,149,260324\nfa,149,260324\ns,26.4,260324\nsi,26.4,260324\n20260410\nc,147,260407\nca,147,260407\ne,147,260410\no,131,260429,147\noa,98,260505,147\nwva,147,260407,147\ny,26.6,260608,148\nia,430,260530,148\n20260505\nca,148,260505\n20260507\nc,148,260505\ne,148,260507\no,132,260528,148\noa,99,260610,148\nwva,148,260505,148\n20260511\ns,26.5,260511\nsi,26.5,260511\n20260519\nf,151,260519\nfa,151,260519\n20260616\nf,152,260616\nfa,152,260616\n20260721\nf,153,260721\nfa,153,260721\n20260818\nf,154,260818\nfa,154,260818\n20260828\nc,152,260825\nca,152,260825\ne,152,260828\no,136,u,152\nwva,152,260825,152\n20260901\nf,155,260901\nfa,155,260901\nreleases\nc,45,150901\nc,46,151013\nc,47,151201\nc,48,160120\nc,49,160302\nc,50,160413\nc,51,160525\nc,52,160720\nc,54,161012\nc,55,161201\nc,58,170419\nc,59,170605\nc,60,170725\nc,61,170905\nc,63,171206\nc,64,180123\nc,65,180306\nc,67,180529\nc,68,180724\nc,69,180904\nc,70,181016\nc,71,181204\nc,72,190129\nc,73,190312\nc,74,190423\nc,75,190604\nc,77,190910\nc,78,191022\nc,79,191210\nc,83,200519\nc,90,210413\nc,91,210525\nc,92,210720\nc,94,210921\nc,95,211019\nc,100,220329\nc,102,220524\nc,103,220621\nc,110,230207\nc,113,230502\nc,114,230530\nc,116,230815\nc,122,240220\nc,126,240611\nc,128,240820\nc,129,240917\nc,131,241112\nc,132,250114\nc,134,250304\nc,139,250805\nc,142,251028\nc,143,251202\nc,144,260113\nc,149,260602\nc,150,260630\nc,151,260728\nc,153,260908\nc,154,260922\nca,45,150901\nca,46,151014\nca,47,151202\nca,48,160126\nca,49,160309\nca,50,160413\nca,51,160608\nca,52,160727\nca,54,161019\nca,55,161206\nca,58,170425\nca,59,170606\nca,60,170801\nca,61,170905\nca,63,171205\nca,64,180123\nca,65,180306\nca,67,180531\nca,68,180724\nca,69,180904\nca,70,181017\nca,71,181204\nca,72,190129\nca,73,190312\nca,74,190424\nca,75,190604\nca,77,190910\nca,78,191022\nca,79,191217\nca,83,200519\nca,90,210413\nca,91,210525\nca,92,210720\nca,94,210921\nca,95,211019\nca,100,220329\nca,102,220524\nca,103,220621\nca,110,230207\nca,113,230502\nca,114,230530\nca,116,230815\nca,122,240220\nca,126,240611\nca,128,240820\nca,129,240917\nca,131,241112\nca,132,250114\nca,134,250304\nca,139,250805\nca,142,251028\nca,143,251202\nca,144,260113\nca,149,260602\nca,150,260630\nca,151,260728\nca,153,260908\nca,154,260922\ne,83,200521\ne,90,210415\ne,91,210527\ne,92,210722\ne,94,210924\ne,95,211021\ne,100,220401\ne,102,220531\ne,103,220623\ne,110,230209\ne,113,230505\ne,114,230602\ne,116,230821\ne,122,240223\ne,126,240613\ne,128,240822\ne,129,240919\ne,131,241114\ne,132,250117\ne,134,250306\ne,139,250807\ne,142,251031\ne,143,251205\ne,144,260121\ne,149,260604\ne,150,260702\ne,151,260731\ne,153,260910\ne,154,260924\nf,40,150811\nf,42,151103\nf,43,151215\nf,44,160126\nf,46,160426\nf,48,160802\nf,51,170124\nf,54,170613\nf,55,170808\nf,56,170928\nf,57,171114\nf,58,180123\nf,59,180313\nf,61,180626\nf,66,190319\nf,67,190521\nf,69,190903\nf,70,191022\nf,71,191210\nf,72,200107\nf,73,200211\nf,74,200310\nf,75,200407\nf,76,200505\nf,77,200602\nf,80,200825\nf,81,200922\nf,82,201020\nf,87,210323\nf,88,210419\nf,89,210601\nf,90,210713\nf,97,220208\nf,99,220405\nf,105,220920\nf,106,221018\nf,109,230117\nf,117,230829\nf,133,241126\nf,135,250204\nf,140,250624\nf,141,250722\nf,146,251209\nf,150,260421\nf,156,260915\nf,157,260929\nfa,40,150811\nfa,42,151103\nfa,43,151215\nfa,44,160126\nfa,46,160426\nfa,48,160802\nfa,51,170124\nfa,54,170613\nfa,55,170808\nfa,58,180122\nfa,59,180313\nfa,61,180626\nfa,66,190319\nfa,67,190521\nfa,80,200831\nfa,81,200922\nfa,82,201020\nfa,87,210323\nfa,88,210419\nfa,89,210601\nfa,90,210713\nfa,95,211207\nfa,97,220208\nfa,99,220405\nfa,105,220920\nfa,106,221018\nfa,109,230117\nfa,117,230829\nfa,133,241126\nfa,135,250204\nfa,140,250624\nfa,141,250722\nfa,146,251209\nfa,150,260421\nfa,156,260915\nfa,157,260929\ns,9,150930\ns,9.1,160321\ns,10,160920\ns,10.1,170327\ns,12,180917\ns,15.3,220126\ns,15.5,220516\ns,16.1,221024\ns,16.2,221213\ns,16.3,230123\ns,16.5,230518\ns,16.6,230724\ns,17.1,231025\ns,17.3,240122\ns,17.6,240729\ns,18.1,241028\ns,18.3,250127\ns,18.5,250512\ns,18.6,250729\ns,26.1,251103\ns,26.6,260727\ns,27,u\nsi,9,150916\nsi,9.3,160321\nsi,10,160913\nsi,10.3,170327\nsi,12,180917\nsi,15.3,220126\nsi,15.5,220516\nsi,16.1,221024\nsi,16.2,221213\nsi,16.3,230123\nsi,16.5,230518\nsi,16.6,230724\nsi,17.1,231025\nsi,17.3,240122\nsi,17.6,240729\nsi,18.1,241028\nsi,18.6,250729\nsi,26.1,251103\nsi,26.6,260727\nsi,27,u\no,15,130702,28\no,16,130827,29\no,17,131008,30\no,18,131119,31\no,19,140128,32\no,20,140304,33\no,21,140506,34\no,22,140603,35\no,23,140722,36\no,24,140902,37\no,26,141203,39\no,27,150127,40\no,28,150310,41\no,29,150428,42\no,30,150609,43\no,32,150915,45\no,33,151027,46\no,34,151208,47\no,35,160202,48\no,36,160315,49\no,37,160504,50\no,38,160608,51\no,39,160802,52\no,41,161025,54\no,42,161213,55\no,45,170510,58\no,46,170622,59\no,47,170809,60\no,48,170927,61\no,50,180104,63\no,51,180207,64\no,52,180322,65\no,54,180628,67\no,55,180816,68\no,56,180925,69\no,57,181128,70\no,58,190123,71\no,60,190409,73\no,62,190627,75\no,64,191007,77\no,65,191113,78\no,66,200107,79\no,69,200624,83\no,76,210428,90\no,77,210609,91\no,78,210803,92\no,80,211005,94\no,81,211104,95\no,86,220420,100\no,88,220608,102\no,89,220707,103\no,96,230222,110\no,99,230516,113\no,100,230629,114\no,102,230823,116\no,108,240305,122\no,112,240711,126\no,114,240925,128\no,116,250108,131\no,117,250213,132\no,119,250513,134\no,123,251028,139\no,126,260108,142\no,127,260202,143\no,128,260226,144\no,133,260629,149\no,134,260806,150\no,135,260820,151\no,137,u,153\noa,15,130708,28\noa,16,130918,29\noa,18,131120,31\noa,19,140128,32\noa,20,140306,33\noa,21,140422,34\noa,22,140617,35\noa,24,140910,37\noa,26,141202,39\noa,27,150129,40\noa,28,150310,41\noa,29,150428,42\noa,30,150610,43\noa,33,151103,46\noa,34,151216,47\noa,35,160204,48\noa,36,160331,49\noa,37,160616,50\noa,42,170121,55\noa,44,171211,60\noa,45,180215,61\noa,48,181108,69\noa,49,181207,70\noa,50,190218,71\noa,51,190321,72\noa,52,190517,73\noa,53,190711,74\noa,55,191203,77\noa,56,200206,78\noa,59,200630,83\noa,64,210525,91\noa,65,211020,92\noa,69,220509,100\noa,76,230626,114\noa,85,241029,128\noa,87,250122,132\noa,94,260113,143\noa,95,260211,144\noa,100,260701,149\noa,101,260826,151\nsa,1.5,130925,28\nsa,1.6,140411,28\nsa,2.0,141017,34\nsa,2.1,150107,34\nsa,3.2,150824,38\nsa,4.2,160802,44\nsa,5.0,161215,51\nsa,5.2,170421,51\nsa,5.4,170517,51\nsa,6.2,171026,56\nsa,6.4,180219,56\nsa,7.2,180620,59\nsa,7.4,180912,59\nsa,8.2,181221,63\nsa,9.2,190402,67\nsa,9.4,190725,67\nsa,10.0,190822,71\nsa,10.2,191009,71\nsa,11.0,191205,75\nsa,11.2,200322,75\nsa,12.1,200707,79\nsa,13.2,210120,83\nsa,14.2,210625,87\nsa,16.0,211125,92\nsa,16.2,220306,92\nsa,18.1,220909,99\nsa,19.1,221108,102\nsa,26.0,240607,122\nwva,4.4,131209,30\nwva,4.4.3,140602,33\nwva,37,140903,37\nwva,39,141112,39\nwva,40,150121,40\nwva,41,150311,41\nwva,42,150415,42\nwva,43,150527,43\nwva,45,150901,45\nwva,46,151014,46\nwva,47,151202,47\nwva,48,160126,48\nwva,49,160309,49\nwva,50,160413,50\nwva,51,160608,51\nwva,52,160727,52\nwva,54,161019,54\nwva,55,161206,55\nwva,58,170425,58\nwva,59,170606,59\nwva,60,170801,60\nwva,61,170905,61\nwva,63,171205,63\nwva,64,180123,64\nwva,65,180306,65\nwva,67,180531,67\nwva,68,180724,68\nwva,69,180904,69\nwva,70,181017,70\nwva,71,181204,71\nwva,72,190129,72\nwva,73,190312,73\nwva,74,190424,74\nwva,75,190604,75\nwva,77,190910,77\nwva,78,191022,78\nwva,79,191217,79\nwva,83,200519,83\nwva,90,210413,90\nwva,91,210525,91\nwva,92,210720,92\nwva,94,210921,94\nwva,95,211019,95\nwva,100,220329,100\nwva,102,220524,102\nwva,103,220621,103\nwva,110,230207,110\nwva,113,230502,113\nwva,114,230530,114\nwva,116,230815,116\nwva,122,240220,122\nwva,126,240611,126\nwva,128,240820,128\nwva,129,240917,129\nwva,131,241112,131\nwva,132,250114,132\nwva,134,250304,134\nwva,139,250805,139\nwva,142,251028,142\nwva,143,251202,143\nwva,144,260113,144\nwva,149,260602,149\nwva,150,260630,150\nwva,151,260728,151\nwva,153,260908,153\nwva,154,260922,154\ny,1.0,u,25\ny,1.5,u,22\ny,1.6,u,25\ny,1.7,u,25\ny,1.20,u,25\ny,2.5,u,25\ny,3.2,u,25\ny,4.6,u,25\ny,5.3,u,25\ny,5.4,u,25\ny,7.4,u,25\ny,9.6,u,25\ny,10.5,u,25\ny,11.4,u,25\ny,11.5,u,25\ny,12.7,u,25\ny,13.9,u,28\ny,13.10,u,28\ny,13.11,u,28\ny,13.12,u,30\ny,14.2,u,32\ny,14.4,u,33\ny,14.5,u,34\ny,14.7,u,35\ny,14.8,u,36\ny,14.10,u,37\ny,15.2,u,40\ny,15.4,u,41\ny,15.6,u,42\ny,15.7,u,43\ny,15.10,u,45\ny,15.12,u,46\ny,16.2,u,47\ny,16.3,u,47\ny,16.4,u,49\ny,16.6,u,50\ny,16.7,u,51\ny,16.9,u,52\ny,16.11,u,54\ny,17.1,u,55\ny,17.6,u,58\ny,17.7,u,59\ny,17.9,u,60\ny,17.10,u,61\ny,18.1,u,63\ny,18.2,u,63\ny,18.3,u,64\ny,18.4,u,65\ny,18.7,u,67\ny,18.9,u,68\ny,18.10,u,69\ny,18.11,u,70\ny,19.1,u,71\ny,19.3,u,72\ny,19.4,u,73\ny,19.5,u,75\ny,19.6,u,75\ny,19.7,u,75\ny,19.10,u,77\ny,19.11,u,78\ny,19.12,u,78\ny,20.2,u,79\ny,20.6,u,81\ny,20.7,u,83\ny,21.2,u,88\ny,21.5,u,90\ny,21.6,210928,91\ny,21.8,210928,92\ny,21.11,211029,94\ny,22.4,u,92\ny,22.9,220827,104\ny,23.7,230706,114\ny,24.2,240325,120\ny,24.9,241001,126\ny,25.2,250424,132\ny,25.3,250423,132\ny,26.3,260304,144\ny,26.7,260723,149\ny,26.8,260801,150\nu,10.5,u,31\nu,10.7,u,31\nu,10.8,u,31\nu,10.10,u,31\nu,11.0,u,31\nu,11.2,u,40\nu,11.3,u,40\nu,11.4,u,40\nu,11.5,u,40\nu,11.8,u,57\nu,11.9,u,57\nu,12.0,u,57\nu,12.1,u,57\nu,12.2,u,57\nu,12.3,u,57\nu,12.4,u,57\nu,12.5,u,57\nu,12.6,u,57\nu,12.7,u,57\nu,12.8,u,57\nu,12.9,u,57\nu,12.10,u,57\nu,12.11,u,57\nu,12.12,u,57\nu,12.13,u,57\nu,12.14,u,57\nu,13.0,u,57\nu,13.1,u,57\nu,13.2,u,57\nu,13.4,210928,78\nu,13.5,230825,78\nu,13.6,231217,78\nu,13.7,230624,78\nu,13.8,220430,78\nu,13.9,220518,78\nu,15.0,220824,78\nu,15.1,221111,78\nu,15.2,230423,78\nu,15.4,231025,100\nu,15.5,230822,100\nu,16.0,230824,100\nu,16.1,231015,100\nu,16.2,231209,100\nu,16.3,240308,100\nu,16.4,241003,100\nu,16.5,240530,100\nu,16.6,240723,100\nu,17.0,240824,100\nu,17.1,240926,100\nu,17.2,241129,100\nu,17.3,250107,100\nu,17.4,250226,100\nu,17.5,250408,100\nu,17.7,250611,123\nu,17.8,250730,123\nu,18.0,250817,123\nu,18.1,251004,123\nu,18.2,251104,123\nu,18.3,251212,123\nu,18.4,260109,123\nu,18.5,260128,123\nu,18.6,260321,123\nu,18.8,260503,123\nu,18.9,260702,123\nu,18.10,260808,123\nu,19.0,260824,123\nq,6.0,u,37\nq,6.1,u,37\nq,6.2,u,37\nq,6.3,u,37\nq,6.4,u,37\nq,6.6,u,37\nq,6.7,u,37\nq,6.8,u,37\nq,6.9,u,37\nq,7.0,u,37\nq,7.1,u,37\nq,7.2,u,37\nq,7.3,u,37\nq,7.4,u,37\nq,7.5,u,37\nq,7.6,u,37\nq,7.7,u,37\nq,7.8,u,37\nq,7.9,u,37\nq,8.0,u,37\nq,8.2,u,57\nq,8.3,u,57\nq,8.4,u,57\nq,8.5,u,57\nq,8.6,u,57\nq,8.7,u,57\nq,8.8,u,57\nq,8.9,u,57\nq,9.1,u,57\nq,9.7,u,66\nq,9.8,u,66\nq,10.0,u,66\nq,10.1,u,66\nq,10.2,u,66\nq,10.3,u,66\nq,10.4,u,66\nq,10.5,u,66\nq,10.7,200909,66\nq,11.0,u,77\nq,11.2,210130,77\nq,11.3,210331,77\nq,11.9,u,89\nq,12.0,211104,89\nq,12.1,211105,89\nq,12.2,211207,89\nq,12.5,220407,89\nq,12.7,220521,89\nq,12.8,220630,89\nq,12.9,220726,89\nq,13.0,220815,89\nq,13.1,220910,89\nq,13.2,221026,89\nq,13.3,221109,89\nq,13.5,230206,98\nq,13.6,230209,98\nq,13.7,230421,98\nq,13.8,230421,98\nq,14.0,231212,98\nq,14.1,230716,98\nq,14.3,230913,109\nq,14.4,231031,109\nq,14.5,231112,109\nq,14.6,231224,109\nq,14.7,240118,109\nq,14.8,240304,109\nq,14.9,240409,109\nq,15.0,240417,109\nq,15.1,240518,109\nq,15.2,241024,109\nq,15.3,240728,109\nq,15.4,240907,109\nq,15.5,240924,109\nq,15.6,241024,109\nq,15.7,241203,109\nq,15.8,241211,109\nq,15.9,250201,109\nq,19.2,250715,121\nq,19.3,250831,121\nq,19.4,250920,121\nq,19.5,251023,121\nq,19.6,251117,121\nq,19.7,251218,121\nq,19.8,260120,121\nq,19.9,260309,121\nq,20.0,260406,121\nq,20.1,260430,121\nq,20.2,260610,121\nq,20.3,260617,121\nq,20.4,260728,121\nq,20.5,260817,121\nk,1.0,170301,37\nk,2.5,170701,48\nk,3.1,220301,84\nfb,68,u,48\nfb,74,u,50\nfb,75,u,50\nfb,76,u,50\nfb,77,u,50\nfb,78,u,50\nfb,79,u,50\nfb,80,u,51\nfb,81,u,51\nfb,82,u,51\nfb,83,u,51\nfb,84,u,51\nfb,86,u,51\nfb,87,u,52\nfb,88,u,52\nfb,89,u,52\nfb,90,u,52\nfb,91,u,52\nfb,92,u,52\nfb,93,u,52\nfb,94,u,52\nfb,96,u,53\nfb,97,u,53\nfb,98,u,53\nfb,99,u,53\nfb,100,u,54\nfb,101,u,54\nfb,103,u,54\nfb,104,u,54\nfb,105,u,54\nfb,106,u,55\nfb,107,u,55\nfb,108,u,55\nfb,109,u,55\nfb,110,u,55\nfb,111,u,55\nfb,113,u,56\nfb,114,u,56\nfb,115,u,56\nfb,116,u,56\nfb,118,u,57\nfb,119,u,57\nfb,120,u,57\nfb,121,u,57\nfb,122,u,58\nfb,123,u,58\nfb,124,u,58\nfb,125,u,58\nfb,126,u,58\nfb,127,u,58\nfb,128,u,58\nfb,129,u,58\nfb,130,u,59\nfb,131,u,59\nfb,132,u,59\nfb,133,u,59\nfb,134,u,59\nfb,135,u,59\nfb,136,u,59\nfb,137,u,59\nfb,138,u,60\nfb,140,u,60\nfb,142,u,61\nfb,143,u,61\nfb,144,u,61\nfb,145,u,61\nfb,146,u,61\nfb,147,u,61\nfb,148,u,61\nfb,150,u,62\nfb,151,u,62\nfb,152,u,62\nfb,153,u,63\nfb,154,u,63\nfb,155,u,63\nfb,156,u,63\nfb,157,u,64\nfb,158,u,64\nfb,159,u,64\nfb,160,u,64\nfb,161,u,64\nfb,162,u,64\nfb,163,u,65\nfb,164,u,65\nfb,165,u,65\nfb,166,u,65\nfb,167,u,65\nfb,168,u,65\nfb,170,u,66\nfb,171,u,66\nfb,172,u,66\nfb,173,u,66\nfb,174,u,66\nfb,175,u,67\nfb,176,u,67\nfb,177,u,67\nfb,178,u,67\nfb,180,u,67\nfb,181,u,67\nfb,182,u,67\nfb,183,u,68\nfb,184,u,68\nfb,185,u,68\nfb,186,u,68\nfb,187,u,68\nfb,188,u,68\nfb,202,u,71\nfb,227,u,75\nfb,228,u,75\nfb,229,u,75\nfb,230,u,75\nfb,231,u,75\nfb,235,u,76\nfb,236,u,76\nfb,237,u,76\nfb,238,u,76\nfb,240,u,77\nfb,241,u,77\nfb,242,u,77\nfb,243,u,77\nfb,244,u,78\nfb,245,u,78\nfb,246,u,78\nfb,247,u,78\nfb,248,u,78\nfb,249,u,78\nfb,250,u,78\nfb,251,u,79\nfb,252,u,79\nfb,253,u,79\nfb,254,u,79\nfb,255,u,79\nfb,257,u,80\nfb,258,u,80\nfb,259,u,80\nfb,260,u,80\nfb,261,u,80\nfb,262,u,80\nfb,263,u,80\nfb,264,u,80\nfb,265,u,80\nfb,267,u,81\nfb,268,u,81\nfb,269,u,81\nfb,270,u,81\nfb,271,u,81\nfb,272,u,83\nfb,273,u,83\nfb,274,u,83\nfb,275,u,83\nfb,400,230210,109\nfb,436,231013,117\nfb,438,231028,118\nfb,440,231112,119\nfb,441,231120,119\nfb,442,231129,119\nfb,444,231213,120\nfb,445,231221,120\nfb,446,240106,120\nfb,447,240112,120\nfb,449,240202,121\nfb,450,240205,121\nfb,451,240217,121\nfb,452,240225,122\nfb,453,240228,122\nfb,454,240304,122\nfb,466,u,126\nfb,469,u,126\nfb,471,240710,126\nfb,472,240711,126\nfb,475,240801,127\nfb,476,240809,127\nfb,477,240816,127\nfb,478,240821,128\nfb,479,240831,128\nfb,480,240907,128\nfb,481,240914,128\nfb,482,240920,129\nfb,483,240927,129\nfb,484,241004,129\nfb,485,241011,129\nfb,487,241026,130\nfb,488,241102,130\nfb,489,241109,130\nfb,494,241226,131\nfb,497,250126,132\nia,24,u,62\nia,25,u,62\nia,26,u,63\nia,27,u,63\nia,28,u,63\nia,29,u,63\nia,30,u,63\nia,31,u,64\nia,32,u,64\nia,33,u,64\nia,34,u,64\nia,35,u,65\nia,36,u,65\nia,37,u,65\nia,38,u,65\nia,39,u,65\nia,40,u,65\nia,41,u,65\nia,43,u,66\nia,44,u,66\nia,45,u,66\nia,46,u,66\nia,47,u,66\nia,48,u,67\nia,49,u,67\nia,50,u,67\nia,51,u,67\nia,52,u,67\nia,53,u,67\nia,54,u,67\nia,55,u,67\nia,56,u,68\nia,57,u,68\nia,58,u,68\nia,59,u,68\nia,60,u,68\nia,61,u,68\nia,65,u,69\nia,66,u,69\nia,68,u,69\nia,72,u,70\nia,74,u,71\nia,75,u,71\nia,79,u,71\nia,81,u,72\nia,82,u,72\nia,83,u,72\nia,84,u,73\nia,86,u,73\nia,95,u,74\nia,97,u,80\nia,98,u,80\nia,103,u,80\nia,104,u,80\nia,117,u,80\nia,118,u,80\nia,119,u,80\nia,120,u,80\nia,121,u,80\nia,127,u,80\nia,128,u,80\nia,129,u,80\nia,130,u,80\nia,131,u,80\nia,132,u,80\nia,133,u,80\nia,134,u,80\nia,135,u,80\nia,136,u,80\nia,138,u,81\nia,139,u,81\nia,140,u,81\nia,141,u,81\nia,142,u,81\nia,143,u,83\nia,144,u,83\nia,145,u,83\nia,146,u,83\nia,164,u,92\nia,230,u,92\nia,259,221104,106\nia,281,u,109\nia,289,231221,114\nia,290,231230,114\nia,295,u,115\nia,296,u,115\nia,297,u,115\nia,298,240111,115\nia,299,u,115\nia,300,u,116\nia,301,240112,116\nia,303,u,117\nia,304,u,117\nia,305,u,117\nia,307,u,118\nia,308,240119,118\nia,310,u,119\nia,312,u,120\nia,313,u,120\nia,314,u,120\nia,315,240119,120\nia,316,240125,120\nia,318,240216,121\nia,320,240304,121\nia,321,240307,122\nia,347,240911,127\nia,349,240920,128\nia,366,u,132\nia,367,250215,132\nia,382,250619,137\nia,383,250618,137\nia,384,250616,137\nia,385,250627,137\nia,387,250709,137\nia,392,250812,138\nia,394,250826,139\nia,395,250913,139\nia,396,250920,139\nia,397,250919,139\nia,401,251008,141\nia,404,251031,141\nia,406,251116,141\nia,407,251123,142\nia,408,251128,142\nia,409,251216,143\nia,410,251217,143\nia,411,260107,143\nia,438,260722,150\nia,443,260821,151\nia,444,260827,151\n".split("\n").forEach(function(n) {
    if (n = n.trim()) {
        if ("releases" !== n) {
            if ($d2e30b95e37327a0$var$f) {
                var a = n.split(",");
                if (a.length >= 3) {
                    var _a = (0, $21h22._)(a, 4), _$n = _a[0], u1 = _a[1], o1 = _a[2], f1 = _a[3], i = [
                        _$n,
                        u1,
                        $d2e30b95e37327a0$var$e(o1.trim())
                    ];
                    f1 && i.push(f1.trim()), $d2e30b95e37327a0$var$s[_$n] || ($d2e30b95e37327a0$var$s[_$n] = []), $d2e30b95e37327a0$var$s[_$n].push(i);
                }
                return;
            }
            if (n.startsWith("20") || n.startsWith("pre_baseline")) return $d2e30b95e37327a0$var$o = $d2e30b95e37327a0$var$e(n), void ($d2e30b95e37327a0$var$u[$d2e30b95e37327a0$var$o] = []);
            {
                var a1 = n.split(",");
                if (a1.length >= 3) {
                    var _a1 = (0, $21h22._)(a1, 4), _$n1 = _a1[0], s1 = _a1[1], f2 = _a1[2], i1 = _a1[3], r = [
                        _$n1,
                        s1,
                        $d2e30b95e37327a0$var$e(f2.trim())
                    ];
                    if (i1 && r.push(i1.trim()), !$d2e30b95e37327a0$var$u[$d2e30b95e37327a0$var$o]) throw new Error("Timeline entry for date ".concat($d2e30b95e37327a0$var$o, " is undefined. This should not happen."));
                    $d2e30b95e37327a0$var$u[$d2e30b95e37327a0$var$o].push(r);
                }
            }
        } else $d2e30b95e37327a0$var$f = !0;
    }
});
var $d2e30b95e37327a0$var$i = {};
Object.keys($d2e30b95e37327a0$var$a).forEach(function(n) {
    var a;
    $d2e30b95e37327a0$var$i[n] = (0, $6zk1M._)(null !== (a = $d2e30b95e37327a0$var$s[n]) && void 0 !== a ? a : []);
}), Object.keys($d2e30b95e37327a0$var$u).forEach(function(n) {
    $d2e30b95e37327a0$var$u[n].forEach(function(n) {
        var a = n[0];
        $d2e30b95e37327a0$var$i[a] && ($d2e30b95e37327a0$var$i[a].some(function(a) {
            return a[1] === n[1];
        }) || $d2e30b95e37327a0$var$i[a].push(n));
    });
}), Object.keys($d2e30b95e37327a0$var$i).forEach(function(a) {
    $d2e30b95e37327a0$var$i[a].sort(function(a, e) {
        return $d2e30b95e37327a0$var$n(a[1], e[1]);
    });
});
var $d2e30b95e37327a0$var$r = !1;
var $d2e30b95e37327a0$var$c = Object.keys($d2e30b95e37327a0$var$a).filter(function(n) {
    return void 0 === $d2e30b95e37327a0$var$a[n].engine;
}).map(function(n) {
    var _a_n = $d2e30b95e37327a0$var$a[n], e = _a_n.longName;
    return {
        shortName: n,
        longName: e
    };
}), $d2e30b95e37327a0$var$t = [
    "webview_android",
    "samsunginternet_android",
    "opera_android",
    "opera",
    "ya_android",
    "uc_android",
    "qq_android",
    "kai_os",
    "facebook_android",
    "instagram_android"
], $d2e30b95e37327a0$var$b = function(a) {
    var e = [], u = [];
    return a.forEach(function(n) {
        $d2e30b95e37327a0$var$c.some(function(a) {
            return a.longName === n.browser;
        }) ? e.push(n) : u.push(n);
    }), e.sort(function(a, e) {
        return a.browser < e.browser ? -1 : a.browser > e.browser ? 1 : $d2e30b95e37327a0$var$n(a.version, e.version);
    }), u.sort(function(a, e) {
        var u = $d2e30b95e37327a0$var$t.indexOf(a.browser), s = $d2e30b95e37327a0$var$t.indexOf(e.browser);
        return u !== s ? u - s : $d2e30b95e37327a0$var$n(a.version, e.version);
    }), (0, $6zk1M._)(e).concat((0, $6zk1M._)(u));
};
var $d2e30b95e37327a0$var$l = !1;
var $d2e30b95e37327a0$var$w = function(n) {
    if (!1 === n.includeDownstreamBrowsers && !0 === n.includeKaiOS) throw new Error("KaiOS is a downstream browser and can only be included if you include other downstream browsers. Please ensure you use `includeDownstreamBrowsers: true`.");
}, $d2e30b95e37327a0$var$v = function(n, e, u, s, o) {
    var f;
    var i = {
        browser: e,
        version: u,
        release_date: "u" === s ? "unknown" : s
    };
    return o && (i.engine_version = o, i.engine = null === (f = $d2e30b95e37327a0$var$a[n]) || void 0 === f ? void 0 : f.engine), i;
};
function $d2e30b95e37327a0$var$y(e) {
    var s, o, f, t, _$y, p, d;
    var g = null != e ? e : {}, q = {
        listAllCompatibleVersions: null !== (s = g.listAllCompatibleVersions) && void 0 !== s && s,
        includeDownstreamBrowsers: null !== (o = g.includeDownstreamBrowsers) && void 0 !== o && o,
        widelyAvailableOnDate: null !== (f = g.widelyAvailableOnDate) && void 0 !== f ? f : void 0,
        targetYear: null !== (t = g.targetYear) && void 0 !== t ? t : void 0,
        includeKaiOS: null !== (_$y = g.includeKaiOS) && void 0 !== _$y && _$y,
        overrideLastUpdated: null !== (p = g.overrideLastUpdated) && void 0 !== p ? p : void 0,
        suppressWarnings: null !== (d = g.suppressWarnings) && void 0 !== d && d
    }, m = new Date;
    if (q.widelyAvailableOnDate || q.targetYear) {
        if (q.targetYear && q.widelyAvailableOnDate) throw new Error("You cannot use targetYear and widelyAvailableOnDate at the same time.  Please remove one of these options and try again.");
        q.widelyAvailableOnDate ? m = new Date(q.widelyAvailableOnDate) : q.targetYear && (m = new Date("".concat(q.targetYear, "-12-31")));
    } else m = new Date;
    if ((q.widelyAvailableOnDate || void 0 === q.targetYear) && m.setMonth(m.getMonth() - 30), !q.suppressWarnings) {
        if (function(n, a) {
            if ($d2e30b95e37327a0$var$r || false) return;
            var _$e = new Date;
            _$e.setMonth(_$e.getMonth() - 2), n > _$e && (null != a ? a : 1788456871688) < _$e.getTime() && (console.warn("[baseline-browser-mapping] The data in this module is over two months old and you are targetting a recent feature cut off date of " + n.toISOString().slice(0, 10) + ". To ensure accurate Baseline data, please update to the latest version of this module using the package manager of your choice.You can suppress these warnings using the environment variables `BROWSERSLIST_IGNORE_OLD_DATA=true` or `BASELINE_BROWSER_MAPPING_IGNORE_OLD_DATA=true` or by passing `suppressWarnings: true` when you call `getCompatibleVersions()` or `getAllVersions()`."), $d2e30b95e37327a0$var$r = !0);
        }(m, q.overrideLastUpdated), $d2e30b95e37327a0$var$w(q), m.getFullYear() < 2015 && !$d2e30b95e37327a0$var$l && console.warn(new Error("There are no browser versions compatible with Baseline before 2015.  You may receive unexpected results.")), m.getFullYear() < 2002) throw new Error("None of the browsers in the core set were released before 2002.  Please use a date after 2002.");
        if (m.getFullYear() > (new Date).getFullYear()) throw new Error("There are no browser versions compatible with Baseline in the future");
    }
    var h = m < new Date("2015-07-29"), _ = {};
    Object.keys($d2e30b95e37327a0$var$a).forEach(function(n) {
        _[n] = void 0;
    }), Object.keys($d2e30b95e37327a0$var$u).forEach(function(n) {
        var a = $d2e30b95e37327a0$var$u[n];
        var _$e = !1;
        _$e = "pre_baseline" === n || new Date(n) <= m, _$e && a.forEach(function(a) {
            var _$e = a[0];
            "pre_baseline" !== n && (_[_$e] = a);
        });
    });
    var O = [];
    return Object.keys($d2e30b95e37327a0$var$a).forEach(function(e) {
        var u, s;
        var _a_e = $d2e30b95e37327a0$var$a[e], o = _a_e.longName;
        if (!q.includeKaiOS && "k" === e) return;
        var f = $d2e30b95e37327a0$var$c.some(function(n) {
            return n.shortName === e;
        });
        if (q.includeDownstreamBrowsers || f) {
            if (h) {
                if (q.listAllCompatibleVersions) {
                    O.push({
                        browser: o,
                        version: "0",
                        release_date: ""
                    });
                    (null !== (u = $d2e30b95e37327a0$var$i[e]) && void 0 !== u ? u : []).forEach(function(n) {
                        O.push($d2e30b95e37327a0$var$v(e, o, n[1], n[2], n[3]));
                    });
                } else O.push({
                    browser: o,
                    version: "0",
                    release_date: ""
                });
            } else {
                var a1 = _[e];
                if (!a1) return;
                var u1 = a1[1];
                if (q.listAllCompatibleVersions) (null !== (s = $d2e30b95e37327a0$var$i[e]) && void 0 !== s ? s : []).forEach(function(a) {
                    var s = a[1];
                    $d2e30b95e37327a0$var$n(s, u1) >= 0 && O.push($d2e30b95e37327a0$var$v(e, o, s, a[2], a[3]));
                });
                else O.push($d2e30b95e37327a0$var$v(e, o, u1, a1[2], a1[3]));
            }
        }
    }), $d2e30b95e37327a0$var$b(O);
}
$d2e30b95e37327a0$export$615d43d8cc127491 = function() {
    $d2e30b95e37327a0$var$r = !1;
}, $d2e30b95e37327a0$export$36ffab104b289974 = function(a) {
    var e, u, s, o, f;
    $d2e30b95e37327a0$var$l = !0;
    var i = null != a ? a : {}, r = {
        outputFormat: null !== (e = i.outputFormat) && void 0 !== e ? e : "array",
        includeDownstreamBrowsers: null !== (u = i.includeDownstreamBrowsers) && void 0 !== u && u,
        useSupports: null !== (s = i.useSupports) && void 0 !== s && s,
        includeKaiOS: null !== (o = i.includeKaiOS) && void 0 !== o && o,
        suppressWarnings: null !== (f = i.suppressWarnings) && void 0 !== f && f
    };
    $d2e30b95e37327a0$var$w(r);
    var t = (new Date).getFullYear() + 1;
    var b = (0, $6zk1M._)(Array(t).keys()).slice(2015), v = {};
    b.forEach(function(n) {
        v[n] = {}, $d2e30b95e37327a0$var$y({
            targetYear: n,
            suppressWarnings: r.suppressWarnings
        }).forEach(function(a) {
            v[n] && (v[n][a.browser] = a);
        });
    });
    var p = $d2e30b95e37327a0$var$y({
        suppressWarnings: r.suppressWarnings
    }), d = {};
    p.forEach(function(n) {
        d[n.browser] = n;
    });
    var g = new Date;
    g.setMonth(g.getMonth() + 30);
    var q = $d2e30b95e37327a0$var$y({
        widelyAvailableOnDate: g.toISOString().slice(0, 10),
        suppressWarnings: r.suppressWarnings
    }), m = {};
    q.forEach(function(n) {
        m[n.browser] = n;
    });
    var h = $d2e30b95e37327a0$var$y({
        targetYear: 2002,
        listAllCompatibleVersions: !0,
        suppressWarnings: r.suppressWarnings
    }), _ = [];
    if ($d2e30b95e37327a0$var$c.map(function(n) {
        return n.longName;
    }).forEach(function(a) {
        var e, u, s, o;
        var f = h.filter(function(n) {
            return n.browser == a;
        }).sort(function(a, e) {
            return $d2e30b95e37327a0$var$n(a.version, e.version);
        }), i = null !== (u = null === (e = d[a]) || void 0 === e ? void 0 : e.version) && void 0 !== u ? u : "0", c = null !== (o = null === (s = m[a]) || void 0 === s ? void 0 : s.version) && void 0 !== o ? o : "0";
        b.forEach(function(e) {
            var u;
            if (v[e]) {
                var s = (null !== (u = v[e][a]) && void 0 !== u ? u : {
                    version: "0"
                }).version, o = f.findIndex(function(a) {
                    return 0 === $d2e30b95e37327a0$var$n(a.version, s);
                });
                (e === t - 1 ? f : f.slice(0, o)).forEach(function(a) {
                    var u = $d2e30b95e37327a0$var$n(a.version, i) >= 0, s = $d2e30b95e37327a0$var$n(a.version, c) >= 0, o = Object.assign(Object.assign({}, a), {
                        year: e <= 2015 ? "pre_baseline" : e - 1
                    });
                    r.useSupports ? (u && (o.supports = "widely"), s && (o.supports = "newly")) : o = Object.assign(Object.assign({}, o), {
                        wa_compatible: u
                    }), _.push(o);
                }), f = f.slice(o, f.length);
            }
        });
    }), r.includeDownstreamBrowsers) $d2e30b95e37327a0$var$y({
        targetYear: 2002,
        listAllCompatibleVersions: !0,
        includeDownstreamBrowsers: !0,
        includeKaiOS: r.includeKaiOS,
        suppressWarnings: r.suppressWarnings
    }).filter(function(n) {
        return !$d2e30b95e37327a0$var$c.map(function(n) {
            return n.longName;
        }).includes(n.browser);
    }).forEach(function(n) {
        var _$a = "Gecko" === n.engine ? "firefox" : "chrome";
        var e = _.find(function(e) {
            return e.browser === _$a && e.version === n.engine_version;
        });
        e && (r.useSupports ? _.push(Object.assign(Object.assign({}, n), {
            year: e.year,
            supports: e.supports
        })) : _.push(Object.assign(Object.assign({}, n), {
            year: e.year,
            wa_compatible: e.wa_compatible
        })));
    });
    if (_.sort(function(a, e) {
        if ("pre_baseline" === a.year && "pre_baseline" !== e.year) return -1;
        if ("pre_baseline" === e.year && "pre_baseline" !== a.year) return 1;
        if ("pre_baseline" !== a.year && "pre_baseline" !== e.year) {
            if (a.year < e.year) return -1;
            if (a.year > e.year) return 1;
        }
        return a.browser < e.browser ? -1 : a.browser > e.browser ? 1 : $d2e30b95e37327a0$var$n(a.version, e.version);
    }), "object" === r.outputFormat) {
        var n1 = {};
        return _.forEach(function(a) {
            n1[a.browser] || (n1[a.browser] = {});
            var e = {
                year: a.year,
                release_date: a.release_date,
                engine: a.engine,
                engine_version: a.engine_version
            };
            n1[a.browser][a.version] = r.useSupports ? a.supports ? Object.assign(Object.assign({}, e), {
                supports: a.supports
            }) : e : Object.assign(Object.assign({}, e), {
                wa_compatible: a.wa_compatible
            });
        }), null != n1 ? n1 : {};
    }
    if ("csv" === r.outputFormat) {
        var n2 = '"browser","version","year","'.concat(r.useSupports ? "supports" : "wa_compatible", '","release_date","engine","engine_version"');
        return _.forEach(function(a) {
            var e, u, s, o;
            var f = {
                browser: a.browser,
                version: a.version,
                year: a.year,
                release_date: null !== (e = a.release_date) && void 0 !== e ? e : "NULL",
                engine: null !== (u = a.engine) && void 0 !== u ? u : "NULL",
                engine_version: null !== (s = a.engine_version) && void 0 !== s ? s : "NULL"
            };
            f = r.useSupports ? Object.assign(Object.assign({}, f), {
                supports: null !== (o = a.supports) && void 0 !== o ? o : ""
            }) : Object.assign(Object.assign({}, f), {
                wa_compatible: a.wa_compatible
            }), n2 += '\n"'.concat(f.browser, '","').concat(f.version, '","').concat(f.year, '","').concat(r.useSupports ? f.supports : f.wa_compatible, '","').concat(f.release_date, '","').concat(f.engine, '","').concat(f.engine_version, '"');
        }), n2;
    }
    return _;
}, $d2e30b95e37327a0$export$bd0bfd2513508520 = $d2e30b95e37327a0$var$y, $d2e30b95e37327a0$export$37623781dd5ede44 = function(n) {
    var e, s, o, f;
    var i = null != n ? n : {}, r = null !== (e = i.groupBy) && void 0 !== e ? e : "date", t = null !== (s = i.listAllBrowsers) && void 0 !== s && s, l = null !== (o = i.includeDownstreamBrowsers) && void 0 !== o && o, w = null !== (f = i.includeKaiOS) && void 0 !== f && f;
    if (!1 === l && !0 === w) throw new Error("KaiOS is a downstream browser and can only be included if you include other downstream browsers. Please ensure you use `includeDownstreamBrowsers: true`.");
    var _$y = {}, p = [];
    if (Object.keys($d2e30b95e37327a0$var$u).forEach(function(n) {
        var e = $d2e30b95e37327a0$var$u[n];
        if ("pre_baseline" === n) return;
        var s = new Set;
        e.forEach(function(n) {
            var a = n[0], e = _$y[a], u = n[1];
            e && e[1] === u || s.add(a), _$y[a] = n;
        });
        var o = [];
        if (Object.keys($d2e30b95e37327a0$var$a).forEach(function(n) {
            var _a_n = $d2e30b95e37327a0$var$a[n], e = _a_n.longName;
            if (!w && "k" === n) return;
            var u = $d2e30b95e37327a0$var$c.some(function(a) {
                return a.shortName === n;
            });
            if (!l && !u) return;
            var f = s.has(n);
            if (t || f) {
                var a1 = _$y[n];
                a1 && o.push($d2e30b95e37327a0$var$v(n, e, a1[1], a1[2], a1[3]));
            }
        }), o.length > 0) {
            var a1 = $d2e30b95e37327a0$var$b(o);
            p.push({
                date: n,
                browsers: a1
            });
        }
    }), "browser" === r) {
        var _$n = {};
        return Object.keys($d2e30b95e37327a0$var$a).forEach(function(e) {
            var _a_e = $d2e30b95e37327a0$var$a[e], u = _a_e.longName;
            if (!w && "k" === e) return;
            var s = $d2e30b95e37327a0$var$c.some(function(n) {
                return n.shortName === e;
            });
            (l || s) && (_$n[u] = []);
        }), p.forEach(function(a) {
            a.browsers.forEach(function(e) {
                var u = e.browser, s = function(n, a) {
                    var _$e = {};
                    for(var u in n)Object.prototype.hasOwnProperty.call(n, u) && a.indexOf(u) < 0 && (_$e[u] = n[u]);
                    if (null != n && "function" == typeof Object.getOwnPropertySymbols) {
                        var s = 0;
                        for(u = Object.getOwnPropertySymbols(n); s < u.length; s++)a.indexOf(u[s]) < 0 && Object.prototype.propertyIsEnumerable.call(n, u[s]) && (_$e[u[s]] = n[u[s]]);
                    }
                    return _$e;
                }(e, [
                    "browser"
                ]);
                _$n[u] && _$n[u].push(Object.assign({
                    date: a.date
                }, s));
            });
        }), _$n;
    }
    return p;
};


var $a8fce34ed20f3bbb$exports = {};
$a8fce34ed20f3bbb$exports = JSON.parse("[{\"name\":\"nodejs\",\"version\":\"0.2.0\",\"date\":\"2011-08-26\",\"lts\":false,\"security\":false,\"v8\":\"2.3.8.0\"},{\"name\":\"nodejs\",\"version\":\"0.3.0\",\"date\":\"2011-08-26\",\"lts\":false,\"security\":false,\"v8\":\"2.5.1.0\"},{\"name\":\"nodejs\",\"version\":\"0.4.0\",\"date\":\"2011-08-26\",\"lts\":false,\"security\":false,\"v8\":\"3.1.2.0\"},{\"name\":\"nodejs\",\"version\":\"0.5.0\",\"date\":\"2011-08-26\",\"lts\":false,\"security\":false,\"v8\":\"3.1.8.25\"},{\"name\":\"nodejs\",\"version\":\"0.6.0\",\"date\":\"2011-11-04\",\"lts\":false,\"security\":false,\"v8\":\"3.6.6.6\"},{\"name\":\"nodejs\",\"version\":\"0.7.0\",\"date\":\"2012-01-17\",\"lts\":false,\"security\":false,\"v8\":\"3.8.6.0\"},{\"name\":\"nodejs\",\"version\":\"0.8.0\",\"date\":\"2012-06-22\",\"lts\":false,\"security\":false,\"v8\":\"3.11.10.10\"},{\"name\":\"nodejs\",\"version\":\"0.9.0\",\"date\":\"2012-07-20\",\"lts\":false,\"security\":false,\"v8\":\"3.11.10.15\"},{\"name\":\"nodejs\",\"version\":\"0.10.0\",\"date\":\"2013-03-11\",\"lts\":false,\"security\":false,\"v8\":\"3.14.5.8\"},{\"name\":\"nodejs\",\"version\":\"0.11.0\",\"date\":\"2013-03-28\",\"lts\":false,\"security\":false,\"v8\":\"3.17.13.0\"},{\"name\":\"nodejs\",\"version\":\"0.12.0\",\"date\":\"2015-02-06\",\"lts\":false,\"security\":false,\"v8\":\"3.28.73.0\"},{\"name\":\"nodejs\",\"version\":\"4.0.0\",\"date\":\"2015-09-08\",\"lts\":false,\"security\":false,\"v8\":\"4.5.103.30\"},{\"name\":\"nodejs\",\"version\":\"4.1.0\",\"date\":\"2015-09-17\",\"lts\":false,\"security\":false,\"v8\":\"4.5.103.33\"},{\"name\":\"nodejs\",\"version\":\"4.2.0\",\"date\":\"2015-10-12\",\"lts\":\"Argon\",\"security\":false,\"v8\":\"4.5.103.35\"},{\"name\":\"nodejs\",\"version\":\"4.3.0\",\"date\":\"2016-02-09\",\"lts\":\"Argon\",\"security\":false,\"v8\":\"4.5.103.35\"},{\"name\":\"nodejs\",\"version\":\"4.4.0\",\"date\":\"2016-03-08\",\"lts\":\"Argon\",\"security\":false,\"v8\":\"4.5.103.35\"},{\"name\":\"nodejs\",\"version\":\"4.5.0\",\"date\":\"2016-08-16\",\"lts\":\"Argon\",\"security\":false,\"v8\":\"4.5.103.37\"},{\"name\":\"nodejs\",\"version\":\"4.6.0\",\"date\":\"2016-09-27\",\"lts\":\"Argon\",\"security\":true,\"v8\":\"4.5.103.37\"},{\"name\":\"nodejs\",\"version\":\"4.7.0\",\"date\":\"2016-12-06\",\"lts\":\"Argon\",\"security\":false,\"v8\":\"4.5.103.43\"},{\"name\":\"nodejs\",\"version\":\"4.8.0\",\"date\":\"2017-02-21\",\"lts\":\"Argon\",\"security\":false,\"v8\":\"4.5.103.45\"},{\"name\":\"nodejs\",\"version\":\"4.9.0\",\"date\":\"2018-03-28\",\"lts\":\"Argon\",\"security\":true,\"v8\":\"4.5.103.53\"},{\"name\":\"nodejs\",\"version\":\"5.0.0\",\"date\":\"2015-10-29\",\"lts\":false,\"security\":false,\"v8\":\"4.6.85.28\"},{\"name\":\"nodejs\",\"version\":\"5.1.0\",\"date\":\"2015-11-17\",\"lts\":false,\"security\":false,\"v8\":\"4.6.85.31\"},{\"name\":\"nodejs\",\"version\":\"5.2.0\",\"date\":\"2015-12-09\",\"lts\":false,\"security\":false,\"v8\":\"4.6.85.31\"},{\"name\":\"nodejs\",\"version\":\"5.3.0\",\"date\":\"2015-12-15\",\"lts\":false,\"security\":false,\"v8\":\"4.6.85.31\"},{\"name\":\"nodejs\",\"version\":\"5.4.0\",\"date\":\"2016-01-06\",\"lts\":false,\"security\":false,\"v8\":\"4.6.85.31\"},{\"name\":\"nodejs\",\"version\":\"5.5.0\",\"date\":\"2016-01-21\",\"lts\":false,\"security\":false,\"v8\":\"4.6.85.31\"},{\"name\":\"nodejs\",\"version\":\"5.6.0\",\"date\":\"2016-02-09\",\"lts\":false,\"security\":false,\"v8\":\"4.6.85.31\"},{\"name\":\"nodejs\",\"version\":\"5.7.0\",\"date\":\"2016-02-23\",\"lts\":false,\"security\":false,\"v8\":\"4.6.85.31\"},{\"name\":\"nodejs\",\"version\":\"5.8.0\",\"date\":\"2016-03-09\",\"lts\":false,\"security\":false,\"v8\":\"4.6.85.31\"},{\"name\":\"nodejs\",\"version\":\"5.9.0\",\"date\":\"2016-03-16\",\"lts\":false,\"security\":false,\"v8\":\"4.6.85.31\"},{\"name\":\"nodejs\",\"version\":\"5.10.0\",\"date\":\"2016-04-01\",\"lts\":false,\"security\":false,\"v8\":\"4.6.85.31\"},{\"name\":\"nodejs\",\"version\":\"5.11.0\",\"date\":\"2016-04-21\",\"lts\":false,\"security\":false,\"v8\":\"4.6.85.31\"},{\"name\":\"nodejs\",\"version\":\"5.12.0\",\"date\":\"2016-06-23\",\"lts\":false,\"security\":false,\"v8\":\"4.6.85.32\"},{\"name\":\"nodejs\",\"version\":\"6.0.0\",\"date\":\"2016-04-26\",\"lts\":false,\"security\":false,\"v8\":\"5.0.71.35\"},{\"name\":\"nodejs\",\"version\":\"6.1.0\",\"date\":\"2016-05-05\",\"lts\":false,\"security\":false,\"v8\":\"5.0.71.35\"},{\"name\":\"nodejs\",\"version\":\"6.2.0\",\"date\":\"2016-05-17\",\"lts\":false,\"security\":false,\"v8\":\"5.0.71.47\"},{\"name\":\"nodejs\",\"version\":\"6.3.0\",\"date\":\"2016-07-06\",\"lts\":false,\"security\":false,\"v8\":\"5.0.71.52\"},{\"name\":\"nodejs\",\"version\":\"6.4.0\",\"date\":\"2016-08-12\",\"lts\":false,\"security\":false,\"v8\":\"5.0.71.60\"},{\"name\":\"nodejs\",\"version\":\"6.5.0\",\"date\":\"2016-08-26\",\"lts\":false,\"security\":false,\"v8\":\"5.1.281.81\"},{\"name\":\"nodejs\",\"version\":\"6.6.0\",\"date\":\"2016-09-14\",\"lts\":false,\"security\":false,\"v8\":\"5.1.281.83\"},{\"name\":\"nodejs\",\"version\":\"6.7.0\",\"date\":\"2016-09-27\",\"lts\":false,\"security\":true,\"v8\":\"5.1.281.83\"},{\"name\":\"nodejs\",\"version\":\"6.8.0\",\"date\":\"2016-10-12\",\"lts\":false,\"security\":false,\"v8\":\"5.1.281.84\"},{\"name\":\"nodejs\",\"version\":\"6.9.0\",\"date\":\"2016-10-18\",\"lts\":\"Boron\",\"security\":false,\"v8\":\"5.1.281.84\"},{\"name\":\"nodejs\",\"version\":\"6.10.0\",\"date\":\"2017-02-21\",\"lts\":\"Boron\",\"security\":false,\"v8\":\"5.1.281.93\"},{\"name\":\"nodejs\",\"version\":\"6.11.0\",\"date\":\"2017-06-06\",\"lts\":\"Boron\",\"security\":false,\"v8\":\"5.1.281.102\"},{\"name\":\"nodejs\",\"version\":\"6.12.0\",\"date\":\"2017-11-06\",\"lts\":\"Boron\",\"security\":false,\"v8\":\"5.1.281.108\"},{\"name\":\"nodejs\",\"version\":\"6.13.0\",\"date\":\"2018-02-10\",\"lts\":\"Boron\",\"security\":false,\"v8\":\"5.1.281.111\"},{\"name\":\"nodejs\",\"version\":\"6.14.0\",\"date\":\"2018-03-28\",\"lts\":\"Boron\",\"security\":true,\"v8\":\"5.1.281.111\"},{\"name\":\"nodejs\",\"version\":\"6.15.0\",\"date\":\"2018-11-27\",\"lts\":\"Boron\",\"security\":true,\"v8\":\"5.1.281.111\"},{\"name\":\"nodejs\",\"version\":\"6.16.0\",\"date\":\"2018-12-26\",\"lts\":\"Boron\",\"security\":false,\"v8\":\"5.1.281.111\"},{\"name\":\"nodejs\",\"version\":\"6.17.0\",\"date\":\"2019-02-28\",\"lts\":\"Boron\",\"security\":true,\"v8\":\"5.1.281.111\"},{\"name\":\"nodejs\",\"version\":\"7.0.0\",\"date\":\"2016-10-25\",\"lts\":false,\"security\":false,\"v8\":\"5.4.500.36\"},{\"name\":\"nodejs\",\"version\":\"7.1.0\",\"date\":\"2016-11-08\",\"lts\":false,\"security\":false,\"v8\":\"5.4.500.36\"},{\"name\":\"nodejs\",\"version\":\"7.2.0\",\"date\":\"2016-11-22\",\"lts\":false,\"security\":false,\"v8\":\"5.4.500.43\"},{\"name\":\"nodejs\",\"version\":\"7.3.0\",\"date\":\"2016-12-20\",\"lts\":false,\"security\":false,\"v8\":\"5.4.500.45\"},{\"name\":\"nodejs\",\"version\":\"7.4.0\",\"date\":\"2017-01-04\",\"lts\":false,\"security\":false,\"v8\":\"5.4.500.45\"},{\"name\":\"nodejs\",\"version\":\"7.5.0\",\"date\":\"2017-01-31\",\"lts\":false,\"security\":false,\"v8\":\"5.4.500.48\"},{\"name\":\"nodejs\",\"version\":\"7.6.0\",\"date\":\"2017-02-21\",\"lts\":false,\"security\":false,\"v8\":\"5.5.372.40\"},{\"name\":\"nodejs\",\"version\":\"7.7.0\",\"date\":\"2017-02-28\",\"lts\":false,\"security\":false,\"v8\":\"5.5.372.41\"},{\"name\":\"nodejs\",\"version\":\"7.8.0\",\"date\":\"2017-03-29\",\"lts\":false,\"security\":false,\"v8\":\"5.5.372.43\"},{\"name\":\"nodejs\",\"version\":\"7.9.0\",\"date\":\"2017-04-11\",\"lts\":false,\"security\":false,\"v8\":\"5.5.372.43\"},{\"name\":\"nodejs\",\"version\":\"7.10.0\",\"date\":\"2017-05-02\",\"lts\":false,\"security\":false,\"v8\":\"5.5.372.43\"},{\"name\":\"nodejs\",\"version\":\"8.0.0\",\"date\":\"2017-05-30\",\"lts\":false,\"security\":false,\"v8\":\"5.8.283.41\"},{\"name\":\"nodejs\",\"version\":\"8.1.0\",\"date\":\"2017-06-08\",\"lts\":false,\"security\":false,\"v8\":\"5.8.283.41\"},{\"name\":\"nodejs\",\"version\":\"8.2.0\",\"date\":\"2017-07-19\",\"lts\":false,\"security\":false,\"v8\":\"5.8.283.41\"},{\"name\":\"nodejs\",\"version\":\"8.3.0\",\"date\":\"2017-08-08\",\"lts\":false,\"security\":false,\"v8\":\"6.0.286.52\"},{\"name\":\"nodejs\",\"version\":\"8.4.0\",\"date\":\"2017-08-15\",\"lts\":false,\"security\":false,\"v8\":\"6.0.286.52\"},{\"name\":\"nodejs\",\"version\":\"8.5.0\",\"date\":\"2017-09-12\",\"lts\":false,\"security\":false,\"v8\":\"6.0.287.53\"},{\"name\":\"nodejs\",\"version\":\"8.6.0\",\"date\":\"2017-09-26\",\"lts\":false,\"security\":false,\"v8\":\"6.0.287.53\"},{\"name\":\"nodejs\",\"version\":\"8.7.0\",\"date\":\"2017-10-11\",\"lts\":false,\"security\":false,\"v8\":\"6.1.534.42\"},{\"name\":\"nodejs\",\"version\":\"8.8.0\",\"date\":\"2017-10-24\",\"lts\":false,\"security\":false,\"v8\":\"6.1.534.42\"},{\"name\":\"nodejs\",\"version\":\"8.9.0\",\"date\":\"2017-10-31\",\"lts\":\"Carbon\",\"security\":false,\"v8\":\"6.1.534.46\"},{\"name\":\"nodejs\",\"version\":\"8.10.0\",\"date\":\"2018-03-06\",\"lts\":\"Carbon\",\"security\":false,\"v8\":\"6.2.414.50\"},{\"name\":\"nodejs\",\"version\":\"8.11.0\",\"date\":\"2018-03-28\",\"lts\":\"Carbon\",\"security\":true,\"v8\":\"6.2.414.50\"},{\"name\":\"nodejs\",\"version\":\"8.12.0\",\"date\":\"2018-09-10\",\"lts\":\"Carbon\",\"security\":false,\"v8\":\"6.2.414.66\"},{\"name\":\"nodejs\",\"version\":\"8.13.0\",\"date\":\"2018-11-20\",\"lts\":\"Carbon\",\"security\":false,\"v8\":\"6.2.414.72\"},{\"name\":\"nodejs\",\"version\":\"8.14.0\",\"date\":\"2018-11-27\",\"lts\":\"Carbon\",\"security\":true,\"v8\":\"6.2.414.72\"},{\"name\":\"nodejs\",\"version\":\"8.15.0\",\"date\":\"2018-12-26\",\"lts\":\"Carbon\",\"security\":false,\"v8\":\"6.2.414.75\"},{\"name\":\"nodejs\",\"version\":\"8.16.0\",\"date\":\"2019-04-16\",\"lts\":\"Carbon\",\"security\":false,\"v8\":\"6.2.414.77\"},{\"name\":\"nodejs\",\"version\":\"8.17.0\",\"date\":\"2019-12-17\",\"lts\":\"Carbon\",\"security\":true,\"v8\":\"6.2.414.78\"},{\"name\":\"nodejs\",\"version\":\"9.0.0\",\"date\":\"2017-10-31\",\"lts\":false,\"security\":false,\"v8\":\"6.2.414.32\"},{\"name\":\"nodejs\",\"version\":\"9.1.0\",\"date\":\"2017-11-07\",\"lts\":false,\"security\":false,\"v8\":\"6.2.414.32\"},{\"name\":\"nodejs\",\"version\":\"9.2.0\",\"date\":\"2017-11-14\",\"lts\":false,\"security\":false,\"v8\":\"6.2.414.44\"},{\"name\":\"nodejs\",\"version\":\"9.3.0\",\"date\":\"2017-12-12\",\"lts\":false,\"security\":false,\"v8\":\"6.2.414.46\"},{\"name\":\"nodejs\",\"version\":\"9.4.0\",\"date\":\"2018-01-10\",\"lts\":false,\"security\":false,\"v8\":\"6.2.414.46\"},{\"name\":\"nodejs\",\"version\":\"9.5.0\",\"date\":\"2018-01-31\",\"lts\":false,\"security\":false,\"v8\":\"6.2.414.46\"},{\"name\":\"nodejs\",\"version\":\"9.6.0\",\"date\":\"2018-02-21\",\"lts\":false,\"security\":false,\"v8\":\"6.2.414.46\"},{\"name\":\"nodejs\",\"version\":\"9.7.0\",\"date\":\"2018-03-01\",\"lts\":false,\"security\":false,\"v8\":\"6.2.414.46\"},{\"name\":\"nodejs\",\"version\":\"9.8.0\",\"date\":\"2018-03-07\",\"lts\":false,\"security\":false,\"v8\":\"6.2.414.46\"},{\"name\":\"nodejs\",\"version\":\"9.9.0\",\"date\":\"2018-03-21\",\"lts\":false,\"security\":false,\"v8\":\"6.2.414.46\"},{\"name\":\"nodejs\",\"version\":\"9.10.0\",\"date\":\"2018-03-28\",\"lts\":false,\"security\":true,\"v8\":\"6.2.414.46\"},{\"name\":\"nodejs\",\"version\":\"9.11.0\",\"date\":\"2018-04-04\",\"lts\":false,\"security\":false,\"v8\":\"6.2.414.46\"},{\"name\":\"nodejs\",\"version\":\"10.0.0\",\"date\":\"2018-04-24\",\"lts\":false,\"security\":false,\"v8\":\"6.6.346.24\"},{\"name\":\"nodejs\",\"version\":\"10.1.0\",\"date\":\"2018-05-08\",\"lts\":false,\"security\":false,\"v8\":\"6.6.346.27\"},{\"name\":\"nodejs\",\"version\":\"10.2.0\",\"date\":\"2018-05-23\",\"lts\":false,\"security\":false,\"v8\":\"6.6.346.32\"},{\"name\":\"nodejs\",\"version\":\"10.3.0\",\"date\":\"2018-05-29\",\"lts\":false,\"security\":false,\"v8\":\"6.6.346.32\"},{\"name\":\"nodejs\",\"version\":\"10.4.0\",\"date\":\"2018-06-06\",\"lts\":false,\"security\":false,\"v8\":\"6.7.288.43\"},{\"name\":\"nodejs\",\"version\":\"10.5.0\",\"date\":\"2018-06-20\",\"lts\":false,\"security\":false,\"v8\":\"6.7.288.46\"},{\"name\":\"nodejs\",\"version\":\"10.6.0\",\"date\":\"2018-07-04\",\"lts\":false,\"security\":false,\"v8\":\"6.7.288.46\"},{\"name\":\"nodejs\",\"version\":\"10.7.0\",\"date\":\"2018-07-18\",\"lts\":false,\"security\":false,\"v8\":\"6.7.288.49\"},{\"name\":\"nodejs\",\"version\":\"10.8.0\",\"date\":\"2018-08-01\",\"lts\":false,\"security\":false,\"v8\":\"6.7.288.49\"},{\"name\":\"nodejs\",\"version\":\"10.9.0\",\"date\":\"2018-08-15\",\"lts\":false,\"security\":false,\"v8\":\"6.8.275.24\"},{\"name\":\"nodejs\",\"version\":\"10.10.0\",\"date\":\"2018-09-06\",\"lts\":false,\"security\":false,\"v8\":\"6.8.275.30\"},{\"name\":\"nodejs\",\"version\":\"10.11.0\",\"date\":\"2018-09-19\",\"lts\":false,\"security\":false,\"v8\":\"6.8.275.32\"},{\"name\":\"nodejs\",\"version\":\"10.12.0\",\"date\":\"2018-10-10\",\"lts\":false,\"security\":false,\"v8\":\"6.8.275.32\"},{\"name\":\"nodejs\",\"version\":\"10.13.0\",\"date\":\"2018-10-30\",\"lts\":\"Dubnium\",\"security\":false,\"v8\":\"6.8.275.32\"},{\"name\":\"nodejs\",\"version\":\"10.14.0\",\"date\":\"2018-11-27\",\"lts\":\"Dubnium\",\"security\":true,\"v8\":\"6.8.275.32\"},{\"name\":\"nodejs\",\"version\":\"10.15.0\",\"date\":\"2018-12-26\",\"lts\":\"Dubnium\",\"security\":false,\"v8\":\"6.8.275.32\"},{\"name\":\"nodejs\",\"version\":\"10.16.0\",\"date\":\"2019-05-28\",\"lts\":\"Dubnium\",\"security\":false,\"v8\":\"6.8.275.32\"},{\"name\":\"nodejs\",\"version\":\"10.17.0\",\"date\":\"2019-10-22\",\"lts\":\"Dubnium\",\"security\":false,\"v8\":\"6.8.275.32\"},{\"name\":\"nodejs\",\"version\":\"10.18.0\",\"date\":\"2019-12-17\",\"lts\":\"Dubnium\",\"security\":true,\"v8\":\"6.8.275.32\"},{\"name\":\"nodejs\",\"version\":\"10.19.0\",\"date\":\"2020-02-05\",\"lts\":\"Dubnium\",\"security\":true,\"v8\":\"6.8.275.32\"},{\"name\":\"nodejs\",\"version\":\"10.20.0\",\"date\":\"2020-03-26\",\"lts\":\"Dubnium\",\"security\":false,\"v8\":\"6.8.275.32\"},{\"name\":\"nodejs\",\"version\":\"10.21.0\",\"date\":\"2020-06-02\",\"lts\":\"Dubnium\",\"security\":true,\"v8\":\"6.8.275.32\"},{\"name\":\"nodejs\",\"version\":\"10.22.0\",\"date\":\"2020-07-21\",\"lts\":\"Dubnium\",\"security\":false,\"v8\":\"6.8.275.32\"},{\"name\":\"nodejs\",\"version\":\"10.23.0\",\"date\":\"2020-10-27\",\"lts\":\"Dubnium\",\"security\":false,\"v8\":\"6.8.275.32\"},{\"name\":\"nodejs\",\"version\":\"10.24.0\",\"date\":\"2021-02-23\",\"lts\":\"Dubnium\",\"security\":true,\"v8\":\"6.8.275.32\"},{\"name\":\"nodejs\",\"version\":\"11.0.0\",\"date\":\"2018-10-23\",\"lts\":false,\"security\":false,\"v8\":\"7.0.276.28\"},{\"name\":\"nodejs\",\"version\":\"11.1.0\",\"date\":\"2018-10-30\",\"lts\":false,\"security\":false,\"v8\":\"7.0.276.32\"},{\"name\":\"nodejs\",\"version\":\"11.2.0\",\"date\":\"2018-11-15\",\"lts\":false,\"security\":false,\"v8\":\"7.0.276.38\"},{\"name\":\"nodejs\",\"version\":\"11.3.0\",\"date\":\"2018-11-27\",\"lts\":false,\"security\":true,\"v8\":\"7.0.276.38\"},{\"name\":\"nodejs\",\"version\":\"11.4.0\",\"date\":\"2018-12-07\",\"lts\":false,\"security\":false,\"v8\":\"7.0.276.38\"},{\"name\":\"nodejs\",\"version\":\"11.5.0\",\"date\":\"2018-12-18\",\"lts\":false,\"security\":false,\"v8\":\"7.0.276.38\"},{\"name\":\"nodejs\",\"version\":\"11.6.0\",\"date\":\"2018-12-26\",\"lts\":false,\"security\":false,\"v8\":\"7.0.276.38\"},{\"name\":\"nodejs\",\"version\":\"11.7.0\",\"date\":\"2019-01-17\",\"lts\":false,\"security\":false,\"v8\":\"7.0.276.38\"},{\"name\":\"nodejs\",\"version\":\"11.8.0\",\"date\":\"2019-01-24\",\"lts\":false,\"security\":false,\"v8\":\"7.0.276.38\"},{\"name\":\"nodejs\",\"version\":\"11.9.0\",\"date\":\"2019-01-30\",\"lts\":false,\"security\":false,\"v8\":\"7.0.276.38\"},{\"name\":\"nodejs\",\"version\":\"11.10.0\",\"date\":\"2019-02-14\",\"lts\":false,\"security\":false,\"v8\":\"7.0.276.38\"},{\"name\":\"nodejs\",\"version\":\"11.11.0\",\"date\":\"2019-03-05\",\"lts\":false,\"security\":false,\"v8\":\"7.0.276.38\"},{\"name\":\"nodejs\",\"version\":\"11.12.0\",\"date\":\"2019-03-14\",\"lts\":false,\"security\":false,\"v8\":\"7.0.276.38\"},{\"name\":\"nodejs\",\"version\":\"11.13.0\",\"date\":\"2019-03-28\",\"lts\":false,\"security\":false,\"v8\":\"7.0.276.38\"},{\"name\":\"nodejs\",\"version\":\"11.14.0\",\"date\":\"2019-04-10\",\"lts\":false,\"security\":false,\"v8\":\"7.0.276.38\"},{\"name\":\"nodejs\",\"version\":\"11.15.0\",\"date\":\"2019-04-30\",\"lts\":false,\"security\":false,\"v8\":\"7.0.276.38\"},{\"name\":\"nodejs\",\"version\":\"12.0.0\",\"date\":\"2019-04-23\",\"lts\":false,\"security\":false,\"v8\":\"7.4.288.21\"},{\"name\":\"nodejs\",\"version\":\"12.1.0\",\"date\":\"2019-04-29\",\"lts\":false,\"security\":false,\"v8\":\"7.4.288.21\"},{\"name\":\"nodejs\",\"version\":\"12.2.0\",\"date\":\"2019-05-07\",\"lts\":false,\"security\":false,\"v8\":\"7.4.288.21\"},{\"name\":\"nodejs\",\"version\":\"12.3.0\",\"date\":\"2019-05-21\",\"lts\":false,\"security\":false,\"v8\":\"7.4.288.27\"},{\"name\":\"nodejs\",\"version\":\"12.4.0\",\"date\":\"2019-06-04\",\"lts\":false,\"security\":false,\"v8\":\"7.4.288.27\"},{\"name\":\"nodejs\",\"version\":\"12.5.0\",\"date\":\"2019-06-26\",\"lts\":false,\"security\":false,\"v8\":\"7.5.288.22\"},{\"name\":\"nodejs\",\"version\":\"12.6.0\",\"date\":\"2019-07-03\",\"lts\":false,\"security\":false,\"v8\":\"7.5.288.22\"},{\"name\":\"nodejs\",\"version\":\"12.7.0\",\"date\":\"2019-07-23\",\"lts\":false,\"security\":false,\"v8\":\"7.5.288.22\"},{\"name\":\"nodejs\",\"version\":\"12.8.0\",\"date\":\"2019-08-06\",\"lts\":false,\"security\":false,\"v8\":\"7.5.288.22\"},{\"name\":\"nodejs\",\"version\":\"12.9.0\",\"date\":\"2019-08-20\",\"lts\":false,\"security\":false,\"v8\":\"7.6.303.29\"},{\"name\":\"nodejs\",\"version\":\"12.10.0\",\"date\":\"2019-09-04\",\"lts\":false,\"security\":false,\"v8\":\"7.6.303.29\"},{\"name\":\"nodejs\",\"version\":\"12.11.0\",\"date\":\"2019-09-25\",\"lts\":false,\"security\":false,\"v8\":\"7.7.299.11\"},{\"name\":\"nodejs\",\"version\":\"12.12.0\",\"date\":\"2019-10-11\",\"lts\":false,\"security\":false,\"v8\":\"7.7.299.13\"},{\"name\":\"nodejs\",\"version\":\"12.13.0\",\"date\":\"2019-10-21\",\"lts\":\"Erbium\",\"security\":false,\"v8\":\"7.7.299.13\"},{\"name\":\"nodejs\",\"version\":\"12.14.0\",\"date\":\"2019-12-17\",\"lts\":\"Erbium\",\"security\":true,\"v8\":\"7.7.299.13\"},{\"name\":\"nodejs\",\"version\":\"12.15.0\",\"date\":\"2020-02-05\",\"lts\":\"Erbium\",\"security\":true,\"v8\":\"7.7.299.13\"},{\"name\":\"nodejs\",\"version\":\"12.16.0\",\"date\":\"2020-02-11\",\"lts\":\"Erbium\",\"security\":false,\"v8\":\"7.8.279.23\"},{\"name\":\"nodejs\",\"version\":\"12.17.0\",\"date\":\"2020-05-26\",\"lts\":\"Erbium\",\"security\":false,\"v8\":\"7.8.279.23\"},{\"name\":\"nodejs\",\"version\":\"12.18.0\",\"date\":\"2020-06-02\",\"lts\":\"Erbium\",\"security\":true,\"v8\":\"7.8.279.23\"},{\"name\":\"nodejs\",\"version\":\"12.19.0\",\"date\":\"2020-10-06\",\"lts\":\"Erbium\",\"security\":false,\"v8\":\"7.8.279.23\"},{\"name\":\"nodejs\",\"version\":\"12.20.0\",\"date\":\"2020-11-24\",\"lts\":\"Erbium\",\"security\":false,\"v8\":\"7.8.279.23\"},{\"name\":\"nodejs\",\"version\":\"12.21.0\",\"date\":\"2021-02-23\",\"lts\":\"Erbium\",\"security\":true,\"v8\":\"7.8.279.23\"},{\"name\":\"nodejs\",\"version\":\"12.22.0\",\"date\":\"2021-03-30\",\"lts\":\"Erbium\",\"security\":false,\"v8\":\"7.8.279.23\"},{\"name\":\"nodejs\",\"version\":\"13.0.0\",\"date\":\"2019-10-22\",\"lts\":false,\"security\":false,\"v8\":\"7.8.279.17\"},{\"name\":\"nodejs\",\"version\":\"13.1.0\",\"date\":\"2019-11-05\",\"lts\":false,\"security\":false,\"v8\":\"7.8.279.17\"},{\"name\":\"nodejs\",\"version\":\"13.2.0\",\"date\":\"2019-11-21\",\"lts\":false,\"security\":false,\"v8\":\"7.9.317.23\"},{\"name\":\"nodejs\",\"version\":\"13.3.0\",\"date\":\"2019-12-03\",\"lts\":false,\"security\":false,\"v8\":\"7.9.317.25\"},{\"name\":\"nodejs\",\"version\":\"13.4.0\",\"date\":\"2019-12-17\",\"lts\":false,\"security\":true,\"v8\":\"7.9.317.25\"},{\"name\":\"nodejs\",\"version\":\"13.5.0\",\"date\":\"2019-12-18\",\"lts\":false,\"security\":false,\"v8\":\"7.9.317.25\"},{\"name\":\"nodejs\",\"version\":\"13.6.0\",\"date\":\"2020-01-07\",\"lts\":false,\"security\":false,\"v8\":\"7.9.317.25\"},{\"name\":\"nodejs\",\"version\":\"13.7.0\",\"date\":\"2020-01-21\",\"lts\":false,\"security\":false,\"v8\":\"7.9.317.25\"},{\"name\":\"nodejs\",\"version\":\"13.8.0\",\"date\":\"2020-02-05\",\"lts\":false,\"security\":true,\"v8\":\"7.9.317.25\"},{\"name\":\"nodejs\",\"version\":\"13.9.0\",\"date\":\"2020-02-18\",\"lts\":false,\"security\":false,\"v8\":\"7.9.317.25\"},{\"name\":\"nodejs\",\"version\":\"13.10.0\",\"date\":\"2020-03-04\",\"lts\":false,\"security\":false,\"v8\":\"7.9.317.25\"},{\"name\":\"nodejs\",\"version\":\"13.11.0\",\"date\":\"2020-03-12\",\"lts\":false,\"security\":false,\"v8\":\"7.9.317.25\"},{\"name\":\"nodejs\",\"version\":\"13.12.0\",\"date\":\"2020-03-26\",\"lts\":false,\"security\":false,\"v8\":\"7.9.317.25\"},{\"name\":\"nodejs\",\"version\":\"13.13.0\",\"date\":\"2020-04-14\",\"lts\":false,\"security\":false,\"v8\":\"7.9.317.25\"},{\"name\":\"nodejs\",\"version\":\"13.14.0\",\"date\":\"2020-04-29\",\"lts\":false,\"security\":false,\"v8\":\"7.9.317.25\"},{\"name\":\"nodejs\",\"version\":\"14.0.0\",\"date\":\"2020-04-21\",\"lts\":false,\"security\":false,\"v8\":\"8.1.307.30\"},{\"name\":\"nodejs\",\"version\":\"14.1.0\",\"date\":\"2020-04-29\",\"lts\":false,\"security\":false,\"v8\":\"8.1.307.31\"},{\"name\":\"nodejs\",\"version\":\"14.2.0\",\"date\":\"2020-05-05\",\"lts\":false,\"security\":false,\"v8\":\"8.1.307.31\"},{\"name\":\"nodejs\",\"version\":\"14.3.0\",\"date\":\"2020-05-19\",\"lts\":false,\"security\":false,\"v8\":\"8.1.307.31\"},{\"name\":\"nodejs\",\"version\":\"14.4.0\",\"date\":\"2020-06-02\",\"lts\":false,\"security\":true,\"v8\":\"8.1.307.31\"},{\"name\":\"nodejs\",\"version\":\"14.5.0\",\"date\":\"2020-06-30\",\"lts\":false,\"security\":false,\"v8\":\"8.3.110.9\"},{\"name\":\"nodejs\",\"version\":\"14.6.0\",\"date\":\"2020-07-20\",\"lts\":false,\"security\":false,\"v8\":\"8.4.371.19\"},{\"name\":\"nodejs\",\"version\":\"14.7.0\",\"date\":\"2020-07-29\",\"lts\":false,\"security\":false,\"v8\":\"8.4.371.19\"},{\"name\":\"nodejs\",\"version\":\"14.8.0\",\"date\":\"2020-08-11\",\"lts\":false,\"security\":false,\"v8\":\"8.4.371.19\"},{\"name\":\"nodejs\",\"version\":\"14.9.0\",\"date\":\"2020-08-27\",\"lts\":false,\"security\":false,\"v8\":\"8.4.371.19\"},{\"name\":\"nodejs\",\"version\":\"14.10.0\",\"date\":\"2020-09-08\",\"lts\":false,\"security\":false,\"v8\":\"8.4.371.19\"},{\"name\":\"nodejs\",\"version\":\"14.11.0\",\"date\":\"2020-09-15\",\"lts\":false,\"security\":true,\"v8\":\"8.4.371.19\"},{\"name\":\"nodejs\",\"version\":\"14.12.0\",\"date\":\"2020-09-22\",\"lts\":false,\"security\":false,\"v8\":\"8.4.371.19\"},{\"name\":\"nodejs\",\"version\":\"14.13.0\",\"date\":\"2020-09-29\",\"lts\":false,\"security\":false,\"v8\":\"8.4.371.19\"},{\"name\":\"nodejs\",\"version\":\"14.14.0\",\"date\":\"2020-10-15\",\"lts\":false,\"security\":false,\"v8\":\"8.4.371.19\"},{\"name\":\"nodejs\",\"version\":\"14.15.0\",\"date\":\"2020-10-27\",\"lts\":\"Fermium\",\"security\":false,\"v8\":\"8.4.371.19\"},{\"name\":\"nodejs\",\"version\":\"14.16.0\",\"date\":\"2021-02-23\",\"lts\":\"Fermium\",\"security\":true,\"v8\":\"8.4.371.19\"},{\"name\":\"nodejs\",\"version\":\"14.17.0\",\"date\":\"2021-05-11\",\"lts\":\"Fermium\",\"security\":false,\"v8\":\"8.4.371.23\"},{\"name\":\"nodejs\",\"version\":\"14.18.0\",\"date\":\"2021-09-28\",\"lts\":\"Fermium\",\"security\":false,\"v8\":\"8.4.371.23\"},{\"name\":\"nodejs\",\"version\":\"14.19.0\",\"date\":\"2022-02-01\",\"lts\":\"Fermium\",\"security\":false,\"v8\":\"8.4.371.23\"},{\"name\":\"nodejs\",\"version\":\"14.20.0\",\"date\":\"2022-07-07\",\"lts\":\"Fermium\",\"security\":true,\"v8\":\"8.4.371.23\"},{\"name\":\"nodejs\",\"version\":\"14.21.0\",\"date\":\"2022-11-01\",\"lts\":\"Fermium\",\"security\":false,\"v8\":\"8.4.371.23\"},{\"name\":\"nodejs\",\"version\":\"15.0.0\",\"date\":\"2020-10-20\",\"lts\":false,\"security\":false,\"v8\":\"8.6.395.16\"},{\"name\":\"nodejs\",\"version\":\"15.1.0\",\"date\":\"2020-11-04\",\"lts\":false,\"security\":false,\"v8\":\"8.6.395.17\"},{\"name\":\"nodejs\",\"version\":\"15.2.0\",\"date\":\"2020-11-10\",\"lts\":false,\"security\":false,\"v8\":\"8.6.395.17\"},{\"name\":\"nodejs\",\"version\":\"15.3.0\",\"date\":\"2020-11-24\",\"lts\":false,\"security\":false,\"v8\":\"8.6.395.17\"},{\"name\":\"nodejs\",\"version\":\"15.4.0\",\"date\":\"2020-12-09\",\"lts\":false,\"security\":false,\"v8\":\"8.6.395.17\"},{\"name\":\"nodejs\",\"version\":\"15.5.0\",\"date\":\"2020-12-22\",\"lts\":false,\"security\":false,\"v8\":\"8.6.395.17\"},{\"name\":\"nodejs\",\"version\":\"15.6.0\",\"date\":\"2021-01-14\",\"lts\":false,\"security\":false,\"v8\":\"8.6.395.17\"},{\"name\":\"nodejs\",\"version\":\"15.7.0\",\"date\":\"2021-01-25\",\"lts\":false,\"security\":false,\"v8\":\"8.6.395.17\"},{\"name\":\"nodejs\",\"version\":\"15.8.0\",\"date\":\"2021-02-02\",\"lts\":false,\"security\":false,\"v8\":\"8.6.395.17\"},{\"name\":\"nodejs\",\"version\":\"15.9.0\",\"date\":\"2021-02-18\",\"lts\":false,\"security\":false,\"v8\":\"8.6.395.17\"},{\"name\":\"nodejs\",\"version\":\"15.10.0\",\"date\":\"2021-02-23\",\"lts\":false,\"security\":true,\"v8\":\"8.6.395.17\"},{\"name\":\"nodejs\",\"version\":\"15.11.0\",\"date\":\"2021-03-03\",\"lts\":false,\"security\":false,\"v8\":\"8.6.395.17\"},{\"name\":\"nodejs\",\"version\":\"15.12.0\",\"date\":\"2021-03-17\",\"lts\":false,\"security\":false,\"v8\":\"8.6.395.17\"},{\"name\":\"nodejs\",\"version\":\"15.13.0\",\"date\":\"2021-03-31\",\"lts\":false,\"security\":false,\"v8\":\"8.6.395.17\"},{\"name\":\"nodejs\",\"version\":\"15.14.0\",\"date\":\"2021-04-06\",\"lts\":false,\"security\":false,\"v8\":\"8.6.395.17\"},{\"name\":\"nodejs\",\"version\":\"16.0.0\",\"date\":\"2021-04-20\",\"lts\":false,\"security\":false,\"v8\":\"9.0.257.17\"},{\"name\":\"nodejs\",\"version\":\"16.1.0\",\"date\":\"2021-05-04\",\"lts\":false,\"security\":false,\"v8\":\"9.0.257.24\"},{\"name\":\"nodejs\",\"version\":\"16.2.0\",\"date\":\"2021-05-19\",\"lts\":false,\"security\":false,\"v8\":\"9.0.257.25\"},{\"name\":\"nodejs\",\"version\":\"16.3.0\",\"date\":\"2021-06-03\",\"lts\":false,\"security\":false,\"v8\":\"9.0.257.25\"},{\"name\":\"nodejs\",\"version\":\"16.4.0\",\"date\":\"2021-06-23\",\"lts\":false,\"security\":false,\"v8\":\"9.1.269.36\"},{\"name\":\"nodejs\",\"version\":\"16.5.0\",\"date\":\"2021-07-14\",\"lts\":false,\"security\":false,\"v8\":\"9.1.269.38\"},{\"name\":\"nodejs\",\"version\":\"16.6.0\",\"date\":\"2021-07-29\",\"lts\":false,\"security\":true,\"v8\":\"9.2.230.21\"},{\"name\":\"nodejs\",\"version\":\"16.7.0\",\"date\":\"2021-08-18\",\"lts\":false,\"security\":false,\"v8\":\"9.2.230.21\"},{\"name\":\"nodejs\",\"version\":\"16.8.0\",\"date\":\"2021-08-25\",\"lts\":false,\"security\":false,\"v8\":\"9.2.230.21\"},{\"name\":\"nodejs\",\"version\":\"16.9.0\",\"date\":\"2021-09-07\",\"lts\":false,\"security\":false,\"v8\":\"9.3.345.16\"},{\"name\":\"nodejs\",\"version\":\"16.10.0\",\"date\":\"2021-09-22\",\"lts\":false,\"security\":false,\"v8\":\"9.3.345.19\"},{\"name\":\"nodejs\",\"version\":\"16.11.0\",\"date\":\"2021-10-08\",\"lts\":false,\"security\":false,\"v8\":\"9.4.146.19\"},{\"name\":\"nodejs\",\"version\":\"16.12.0\",\"date\":\"2021-10-20\",\"lts\":false,\"security\":false,\"v8\":\"9.4.146.19\"},{\"name\":\"nodejs\",\"version\":\"16.13.0\",\"date\":\"2021-10-26\",\"lts\":\"Gallium\",\"security\":false,\"v8\":\"9.4.146.19\"},{\"name\":\"nodejs\",\"version\":\"16.14.0\",\"date\":\"2022-02-08\",\"lts\":\"Gallium\",\"security\":false,\"v8\":\"9.4.146.24\"},{\"name\":\"nodejs\",\"version\":\"16.15.0\",\"date\":\"2022-04-26\",\"lts\":\"Gallium\",\"security\":false,\"v8\":\"9.4.146.24\"},{\"name\":\"nodejs\",\"version\":\"16.16.0\",\"date\":\"2022-07-07\",\"lts\":\"Gallium\",\"security\":true,\"v8\":\"9.4.146.24\"},{\"name\":\"nodejs\",\"version\":\"16.17.0\",\"date\":\"2022-08-16\",\"lts\":\"Gallium\",\"security\":false,\"v8\":\"9.4.146.26\"},{\"name\":\"nodejs\",\"version\":\"16.18.0\",\"date\":\"2022-10-12\",\"lts\":\"Gallium\",\"security\":false,\"v8\":\"9.4.146.26\"},{\"name\":\"nodejs\",\"version\":\"16.19.0\",\"date\":\"2022-12-13\",\"lts\":\"Gallium\",\"security\":false,\"v8\":\"9.4.146.26\"},{\"name\":\"nodejs\",\"version\":\"16.20.0\",\"date\":\"2023-03-28\",\"lts\":\"Gallium\",\"security\":false,\"v8\":\"9.4.146.26\"},{\"name\":\"nodejs\",\"version\":\"17.0.0\",\"date\":\"2021-10-19\",\"lts\":false,\"security\":false,\"v8\":\"9.5.172.21\"},{\"name\":\"nodejs\",\"version\":\"17.1.0\",\"date\":\"2021-11-09\",\"lts\":false,\"security\":false,\"v8\":\"9.5.172.25\"},{\"name\":\"nodejs\",\"version\":\"17.2.0\",\"date\":\"2021-11-30\",\"lts\":false,\"security\":false,\"v8\":\"9.6.180.14\"},{\"name\":\"nodejs\",\"version\":\"17.3.0\",\"date\":\"2021-12-17\",\"lts\":false,\"security\":false,\"v8\":\"9.6.180.15\"},{\"name\":\"nodejs\",\"version\":\"17.4.0\",\"date\":\"2022-01-18\",\"lts\":false,\"security\":false,\"v8\":\"9.6.180.15\"},{\"name\":\"nodejs\",\"version\":\"17.5.0\",\"date\":\"2022-02-10\",\"lts\":false,\"security\":false,\"v8\":\"9.6.180.15\"},{\"name\":\"nodejs\",\"version\":\"17.6.0\",\"date\":\"2022-02-22\",\"lts\":false,\"security\":false,\"v8\":\"9.6.180.15\"},{\"name\":\"nodejs\",\"version\":\"17.7.0\",\"date\":\"2022-03-09\",\"lts\":false,\"security\":false,\"v8\":\"9.6.180.15\"},{\"name\":\"nodejs\",\"version\":\"17.8.0\",\"date\":\"2022-03-22\",\"lts\":false,\"security\":false,\"v8\":\"9.6.180.15\"},{\"name\":\"nodejs\",\"version\":\"17.9.0\",\"date\":\"2022-04-07\",\"lts\":false,\"security\":false,\"v8\":\"9.6.180.15\"},{\"name\":\"nodejs\",\"version\":\"18.0.0\",\"date\":\"2022-04-18\",\"lts\":false,\"security\":false,\"v8\":\"10.1.124.8\"},{\"name\":\"nodejs\",\"version\":\"18.1.0\",\"date\":\"2022-05-03\",\"lts\":false,\"security\":false,\"v8\":\"10.1.124.8\"},{\"name\":\"nodejs\",\"version\":\"18.2.0\",\"date\":\"2022-05-17\",\"lts\":false,\"security\":false,\"v8\":\"10.1.124.8\"},{\"name\":\"nodejs\",\"version\":\"18.3.0\",\"date\":\"2022-06-02\",\"lts\":false,\"security\":false,\"v8\":\"10.2.154.4\"},{\"name\":\"nodejs\",\"version\":\"18.4.0\",\"date\":\"2022-06-16\",\"lts\":false,\"security\":false,\"v8\":\"10.2.154.4\"},{\"name\":\"nodejs\",\"version\":\"18.5.0\",\"date\":\"2022-07-06\",\"lts\":false,\"security\":true,\"v8\":\"10.2.154.4\"},{\"name\":\"nodejs\",\"version\":\"18.6.0\",\"date\":\"2022-07-13\",\"lts\":false,\"security\":false,\"v8\":\"10.2.154.13\"},{\"name\":\"nodejs\",\"version\":\"18.7.0\",\"date\":\"2022-07-26\",\"lts\":false,\"security\":false,\"v8\":\"10.2.154.13\"},{\"name\":\"nodejs\",\"version\":\"18.8.0\",\"date\":\"2022-08-24\",\"lts\":false,\"security\":false,\"v8\":\"10.2.154.13\"},{\"name\":\"nodejs\",\"version\":\"18.9.0\",\"date\":\"2022-09-07\",\"lts\":false,\"security\":false,\"v8\":\"10.2.154.15\"},{\"name\":\"nodejs\",\"version\":\"18.10.0\",\"date\":\"2022-09-28\",\"lts\":false,\"security\":false,\"v8\":\"10.2.154.15\"},{\"name\":\"nodejs\",\"version\":\"18.11.0\",\"date\":\"2022-10-13\",\"lts\":false,\"security\":false,\"v8\":\"10.2.154.15\"},{\"name\":\"nodejs\",\"version\":\"18.12.0\",\"date\":\"2022-10-25\",\"lts\":\"Hydrogen\",\"security\":false,\"v8\":\"10.2.154.15\"},{\"name\":\"nodejs\",\"version\":\"18.13.0\",\"date\":\"2023-01-05\",\"lts\":\"Hydrogen\",\"security\":false,\"v8\":\"10.2.154.23\"},{\"name\":\"nodejs\",\"version\":\"18.14.0\",\"date\":\"2023-02-01\",\"lts\":\"Hydrogen\",\"security\":false,\"v8\":\"10.2.154.23\"},{\"name\":\"nodejs\",\"version\":\"18.15.0\",\"date\":\"2023-03-05\",\"lts\":\"Hydrogen\",\"security\":false,\"v8\":\"10.2.154.26\"},{\"name\":\"nodejs\",\"version\":\"18.16.0\",\"date\":\"2023-04-12\",\"lts\":\"Hydrogen\",\"security\":false,\"v8\":\"10.2.154.26\"},{\"name\":\"nodejs\",\"version\":\"18.17.0\",\"date\":\"2023-07-18\",\"lts\":\"Hydrogen\",\"security\":false,\"v8\":\"10.2.154.26\"},{\"name\":\"nodejs\",\"version\":\"18.18.0\",\"date\":\"2023-09-18\",\"lts\":\"Hydrogen\",\"security\":false,\"v8\":\"10.2.154.26\"},{\"name\":\"nodejs\",\"version\":\"18.19.0\",\"date\":\"2023-11-29\",\"lts\":\"Hydrogen\",\"security\":false,\"v8\":\"10.2.154.26\"},{\"name\":\"nodejs\",\"version\":\"18.20.0\",\"date\":\"2024-03-26\",\"lts\":\"Hydrogen\",\"security\":false,\"v8\":\"10.2.154.26\"},{\"name\":\"nodejs\",\"version\":\"19.0.0\",\"date\":\"2022-10-17\",\"lts\":false,\"security\":false,\"v8\":\"10.7.193.13\"},{\"name\":\"nodejs\",\"version\":\"19.1.0\",\"date\":\"2022-11-14\",\"lts\":false,\"security\":false,\"v8\":\"10.7.193.20\"},{\"name\":\"nodejs\",\"version\":\"19.2.0\",\"date\":\"2022-11-29\",\"lts\":false,\"security\":false,\"v8\":\"10.8.168.20\"},{\"name\":\"nodejs\",\"version\":\"19.3.0\",\"date\":\"2022-12-14\",\"lts\":false,\"security\":false,\"v8\":\"10.8.168.21\"},{\"name\":\"nodejs\",\"version\":\"19.4.0\",\"date\":\"2023-01-05\",\"lts\":false,\"security\":false,\"v8\":\"10.8.168.25\"},{\"name\":\"nodejs\",\"version\":\"19.5.0\",\"date\":\"2023-01-24\",\"lts\":false,\"security\":false,\"v8\":\"10.8.168.25\"},{\"name\":\"nodejs\",\"version\":\"19.6.0\",\"date\":\"2023-02-01\",\"lts\":false,\"security\":false,\"v8\":\"10.8.168.25\"},{\"name\":\"nodejs\",\"version\":\"19.7.0\",\"date\":\"2023-02-21\",\"lts\":false,\"security\":false,\"v8\":\"10.8.168.25\"},{\"name\":\"nodejs\",\"version\":\"19.8.0\",\"date\":\"2023-03-14\",\"lts\":false,\"security\":false,\"v8\":\"10.8.168.25\"},{\"name\":\"nodejs\",\"version\":\"19.9.0\",\"date\":\"2023-04-10\",\"lts\":false,\"security\":false,\"v8\":\"10.8.168.25\"},{\"name\":\"nodejs\",\"version\":\"20.0.0\",\"date\":\"2023-04-17\",\"lts\":false,\"security\":false,\"v8\":\"11.3.244.4\"},{\"name\":\"nodejs\",\"version\":\"20.1.0\",\"date\":\"2023-05-03\",\"lts\":false,\"security\":false,\"v8\":\"11.3.244.8\"},{\"name\":\"nodejs\",\"version\":\"20.2.0\",\"date\":\"2023-05-16\",\"lts\":false,\"security\":false,\"v8\":\"11.3.244.8\"},{\"name\":\"nodejs\",\"version\":\"20.3.0\",\"date\":\"2023-06-08\",\"lts\":false,\"security\":false,\"v8\":\"11.3.244.8\"},{\"name\":\"nodejs\",\"version\":\"20.4.0\",\"date\":\"2023-07-04\",\"lts\":false,\"security\":false,\"v8\":\"11.3.244.8\"},{\"name\":\"nodejs\",\"version\":\"20.5.0\",\"date\":\"2023-07-19\",\"lts\":false,\"security\":false,\"v8\":\"11.3.244.8\"},{\"name\":\"nodejs\",\"version\":\"20.6.0\",\"date\":\"2023-08-23\",\"lts\":false,\"security\":false,\"v8\":\"11.3.244.8\"},{\"name\":\"nodejs\",\"version\":\"20.7.0\",\"date\":\"2023-09-18\",\"lts\":false,\"security\":false,\"v8\":\"11.3.244.8\"},{\"name\":\"nodejs\",\"version\":\"20.8.0\",\"date\":\"2023-09-28\",\"lts\":false,\"security\":false,\"v8\":\"11.3.244.8\"},{\"name\":\"nodejs\",\"version\":\"20.9.0\",\"date\":\"2023-10-24\",\"lts\":\"Iron\",\"security\":false,\"v8\":\"11.3.244.8\"},{\"name\":\"nodejs\",\"version\":\"20.10.0\",\"date\":\"2023-11-22\",\"lts\":\"Iron\",\"security\":false,\"v8\":\"11.3.244.8\"},{\"name\":\"nodejs\",\"version\":\"20.11.0\",\"date\":\"2024-01-09\",\"lts\":\"Iron\",\"security\":false,\"v8\":\"11.3.244.8\"},{\"name\":\"nodejs\",\"version\":\"20.12.0\",\"date\":\"2024-03-26\",\"lts\":\"Iron\",\"security\":false,\"v8\":\"11.3.244.8\"},{\"name\":\"nodejs\",\"version\":\"20.13.0\",\"date\":\"2024-05-07\",\"lts\":\"Iron\",\"security\":false,\"v8\":\"11.3.244.8\"},{\"name\":\"nodejs\",\"version\":\"20.14.0\",\"date\":\"2024-05-28\",\"lts\":\"Iron\",\"security\":false,\"v8\":\"11.3.244.8\"},{\"name\":\"nodejs\",\"version\":\"20.15.0\",\"date\":\"2024-06-20\",\"lts\":\"Iron\",\"security\":false,\"v8\":\"11.3.244.8\"},{\"name\":\"nodejs\",\"version\":\"20.16.0\",\"date\":\"2024-07-24\",\"lts\":\"Iron\",\"security\":false,\"v8\":\"11.3.244.8\"},{\"name\":\"nodejs\",\"version\":\"20.17.0\",\"date\":\"2024-08-21\",\"lts\":\"Iron\",\"security\":false,\"v8\":\"11.3.244.8\"},{\"name\":\"nodejs\",\"version\":\"20.18.0\",\"date\":\"2024-10-03\",\"lts\":\"Iron\",\"security\":false,\"v8\":\"11.3.244.8\"},{\"name\":\"nodejs\",\"version\":\"20.19.0\",\"date\":\"2025-03-13\",\"lts\":\"Iron\",\"security\":false,\"v8\":\"11.3.244.8\"},{\"name\":\"nodejs\",\"version\":\"20.20.0\",\"date\":\"2026-01-12\",\"lts\":\"Iron\",\"security\":true,\"v8\":\"11.3.244.8\"},{\"name\":\"nodejs\",\"version\":\"21.0.0\",\"date\":\"2023-10-17\",\"lts\":false,\"security\":false,\"v8\":\"11.8.172.13\"},{\"name\":\"nodejs\",\"version\":\"21.1.0\",\"date\":\"2023-10-24\",\"lts\":false,\"security\":false,\"v8\":\"11.8.172.15\"},{\"name\":\"nodejs\",\"version\":\"21.2.0\",\"date\":\"2023-11-14\",\"lts\":false,\"security\":false,\"v8\":\"11.8.172.17\"},{\"name\":\"nodejs\",\"version\":\"21.3.0\",\"date\":\"2023-11-30\",\"lts\":false,\"security\":false,\"v8\":\"11.8.172.17\"},{\"name\":\"nodejs\",\"version\":\"21.4.0\",\"date\":\"2023-12-05\",\"lts\":false,\"security\":false,\"v8\":\"11.8.172.17\"},{\"name\":\"nodejs\",\"version\":\"21.5.0\",\"date\":\"2023-12-19\",\"lts\":false,\"security\":false,\"v8\":\"11.8.172.17\"},{\"name\":\"nodejs\",\"version\":\"21.6.0\",\"date\":\"2024-01-14\",\"lts\":false,\"security\":false,\"v8\":\"11.8.172.17\"},{\"name\":\"nodejs\",\"version\":\"21.7.0\",\"date\":\"2024-03-06\",\"lts\":false,\"security\":false,\"v8\":\"11.8.172.17\"},{\"name\":\"nodejs\",\"version\":\"22.0.0\",\"date\":\"2024-04-24\",\"lts\":false,\"security\":false,\"v8\":\"12.4.254.14\"},{\"name\":\"nodejs\",\"version\":\"22.1.0\",\"date\":\"2024-05-02\",\"lts\":false,\"security\":false,\"v8\":\"12.4.254.14\"},{\"name\":\"nodejs\",\"version\":\"22.2.0\",\"date\":\"2024-05-15\",\"lts\":false,\"security\":false,\"v8\":\"12.4.254.14\"},{\"name\":\"nodejs\",\"version\":\"22.3.0\",\"date\":\"2024-06-11\",\"lts\":false,\"security\":false,\"v8\":\"12.4.254.20\"},{\"name\":\"nodejs\",\"version\":\"22.4.0\",\"date\":\"2024-07-02\",\"lts\":false,\"security\":false,\"v8\":\"12.4.254.21\"},{\"name\":\"nodejs\",\"version\":\"22.5.0\",\"date\":\"2024-07-17\",\"lts\":false,\"security\":false,\"v8\":\"12.4.254.21\"},{\"name\":\"nodejs\",\"version\":\"22.6.0\",\"date\":\"2024-08-06\",\"lts\":false,\"security\":false,\"v8\":\"12.4.254.21\"},{\"name\":\"nodejs\",\"version\":\"22.7.0\",\"date\":\"2024-08-21\",\"lts\":false,\"security\":false,\"v8\":\"12.4.254.21\"},{\"name\":\"nodejs\",\"version\":\"22.8.0\",\"date\":\"2024-09-03\",\"lts\":false,\"security\":false,\"v8\":\"12.4.254.21\"},{\"name\":\"nodejs\",\"version\":\"22.9.0\",\"date\":\"2024-09-17\",\"lts\":false,\"security\":false,\"v8\":\"12.4.254.21\"},{\"name\":\"nodejs\",\"version\":\"22.10.0\",\"date\":\"2024-10-16\",\"lts\":false,\"security\":false,\"v8\":\"12.4.254.21\"},{\"name\":\"nodejs\",\"version\":\"22.11.0\",\"date\":\"2024-10-29\",\"lts\":\"Jod\",\"security\":false,\"v8\":\"12.4.254.21\"},{\"name\":\"nodejs\",\"version\":\"22.12.0\",\"date\":\"2024-12-02\",\"lts\":\"Jod\",\"security\":false,\"v8\":\"12.4.254.21\"},{\"name\":\"nodejs\",\"version\":\"22.13.0\",\"date\":\"2025-01-06\",\"lts\":\"Jod\",\"security\":false,\"v8\":\"12.4.254.21\"},{\"name\":\"nodejs\",\"version\":\"22.14.0\",\"date\":\"2025-02-11\",\"lts\":\"Jod\",\"security\":false,\"v8\":\"12.4.254.21\"},{\"name\":\"nodejs\",\"version\":\"22.15.0\",\"date\":\"2025-04-22\",\"lts\":\"Jod\",\"security\":false,\"v8\":\"12.4.254.21\"},{\"name\":\"nodejs\",\"version\":\"22.16.0\",\"date\":\"2025-05-20\",\"lts\":\"Jod\",\"security\":false,\"v8\":\"12.4.254.21\"},{\"name\":\"nodejs\",\"version\":\"22.17.0\",\"date\":\"2025-06-24\",\"lts\":\"Jod\",\"security\":false,\"v8\":\"12.4.254.21\"},{\"name\":\"nodejs\",\"version\":\"22.18.0\",\"date\":\"2025-07-31\",\"lts\":\"Jod\",\"security\":false,\"v8\":\"12.4.254.21\"},{\"name\":\"nodejs\",\"version\":\"22.19.0\",\"date\":\"2025-08-28\",\"lts\":\"Jod\",\"security\":false,\"v8\":\"12.4.254.21\"},{\"name\":\"nodejs\",\"version\":\"22.20.0\",\"date\":\"2025-09-24\",\"lts\":\"Jod\",\"security\":false,\"v8\":\"12.4.254.21\"},{\"name\":\"nodejs\",\"version\":\"22.21.0\",\"date\":\"2025-10-20\",\"lts\":\"Jod\",\"security\":false,\"v8\":\"12.4.254.21\"},{\"name\":\"nodejs\",\"version\":\"22.22.0\",\"date\":\"2026-01-12\",\"lts\":\"Jod\",\"security\":true,\"v8\":\"12.4.254.21\"},{\"name\":\"nodejs\",\"version\":\"22.23.0\",\"date\":\"2026-06-17\",\"lts\":\"Jod\",\"security\":true,\"v8\":\"12.4.254.21\"},{\"name\":\"nodejs\",\"version\":\"23.0.0\",\"date\":\"2024-10-16\",\"lts\":false,\"security\":false,\"v8\":\"12.9.202.26\"},{\"name\":\"nodejs\",\"version\":\"23.1.0\",\"date\":\"2024-10-24\",\"lts\":false,\"security\":false,\"v8\":\"12.9.202.28\"},{\"name\":\"nodejs\",\"version\":\"23.2.0\",\"date\":\"2024-11-11\",\"lts\":false,\"security\":false,\"v8\":\"12.9.202.28\"},{\"name\":\"nodejs\",\"version\":\"23.3.0\",\"date\":\"2024-11-20\",\"lts\":false,\"security\":false,\"v8\":\"12.9.202.28\"},{\"name\":\"nodejs\",\"version\":\"23.4.0\",\"date\":\"2024-12-10\",\"lts\":false,\"security\":false,\"v8\":\"12.9.202.28\"},{\"name\":\"nodejs\",\"version\":\"23.5.0\",\"date\":\"2024-12-19\",\"lts\":false,\"security\":false,\"v8\":\"12.9.202.28\"},{\"name\":\"nodejs\",\"version\":\"23.6.0\",\"date\":\"2025-01-07\",\"lts\":false,\"security\":false,\"v8\":\"12.9.202.28\"},{\"name\":\"nodejs\",\"version\":\"23.7.0\",\"date\":\"2025-01-30\",\"lts\":false,\"security\":false,\"v8\":\"12.9.202.28\"},{\"name\":\"nodejs\",\"version\":\"23.8.0\",\"date\":\"2025-02-13\",\"lts\":false,\"security\":false,\"v8\":\"12.9.202.28\"},{\"name\":\"nodejs\",\"version\":\"23.9.0\",\"date\":\"2025-02-26\",\"lts\":false,\"security\":false,\"v8\":\"12.9.202.28\"},{\"name\":\"nodejs\",\"version\":\"23.10.0\",\"date\":\"2025-03-13\",\"lts\":false,\"security\":false,\"v8\":\"12.9.202.28\"},{\"name\":\"nodejs\",\"version\":\"23.11.0\",\"date\":\"2025-04-01\",\"lts\":false,\"security\":false,\"v8\":\"12.9.202.28\"},{\"name\":\"nodejs\",\"version\":\"24.0.0\",\"date\":\"2025-05-06\",\"lts\":false,\"security\":false,\"v8\":\"13.6.233.8\"},{\"name\":\"nodejs\",\"version\":\"24.1.0\",\"date\":\"2025-05-20\",\"lts\":false,\"security\":false,\"v8\":\"13.6.233.10\"},{\"name\":\"nodejs\",\"version\":\"24.2.0\",\"date\":\"2025-06-09\",\"lts\":false,\"security\":false,\"v8\":\"13.6.233.10\"},{\"name\":\"nodejs\",\"version\":\"24.3.0\",\"date\":\"2025-06-24\",\"lts\":false,\"security\":false,\"v8\":\"13.6.233.10\"},{\"name\":\"nodejs\",\"version\":\"24.4.0\",\"date\":\"2025-07-09\",\"lts\":false,\"security\":false,\"v8\":\"13.6.233.10\"},{\"name\":\"nodejs\",\"version\":\"24.5.0\",\"date\":\"2025-07-31\",\"lts\":false,\"security\":false,\"v8\":\"13.6.233.10\"},{\"name\":\"nodejs\",\"version\":\"24.6.0\",\"date\":\"2025-08-14\",\"lts\":false,\"security\":false,\"v8\":\"13.6.233.10\"},{\"name\":\"nodejs\",\"version\":\"24.7.0\",\"date\":\"2025-08-27\",\"lts\":false,\"security\":false,\"v8\":\"13.6.233.10\"},{\"name\":\"nodejs\",\"version\":\"24.8.0\",\"date\":\"2025-09-10\",\"lts\":false,\"security\":false,\"v8\":\"13.6.233.10\"},{\"name\":\"nodejs\",\"version\":\"24.9.0\",\"date\":\"2025-09-25\",\"lts\":false,\"security\":false,\"v8\":\"13.6.233.10\"},{\"name\":\"nodejs\",\"version\":\"24.10.0\",\"date\":\"2025-10-08\",\"lts\":false,\"security\":false,\"v8\":\"13.6.233.10\"},{\"name\":\"nodejs\",\"version\":\"24.11.0\",\"date\":\"2025-10-28\",\"lts\":\"Krypton\",\"security\":false,\"v8\":\"13.6.233.10\"},{\"name\":\"nodejs\",\"version\":\"24.12.0\",\"date\":\"2025-12-10\",\"lts\":\"Krypton\",\"security\":false,\"v8\":\"13.6.233.17\"},{\"name\":\"nodejs\",\"version\":\"24.13.0\",\"date\":\"2026-01-12\",\"lts\":\"Krypton\",\"security\":true,\"v8\":\"13.6.233.17\"},{\"name\":\"nodejs\",\"version\":\"24.14.0\",\"date\":\"2026-02-24\",\"lts\":\"Krypton\",\"security\":false,\"v8\":\"13.6.233.17\"},{\"name\":\"nodejs\",\"version\":\"24.15.0\",\"date\":\"2026-04-15\",\"lts\":\"Krypton\",\"security\":false,\"v8\":\"13.6.233.17\"},{\"name\":\"nodejs\",\"version\":\"24.16.0\",\"date\":\"2026-05-21\",\"lts\":\"Krypton\",\"security\":false,\"v8\":\"13.6.233.17\"},{\"name\":\"nodejs\",\"version\":\"24.17.0\",\"date\":\"2026-06-17\",\"lts\":\"Krypton\",\"security\":true,\"v8\":\"13.6.233.17\"},{\"name\":\"nodejs\",\"version\":\"24.18.0\",\"date\":\"2026-06-23\",\"lts\":\"Krypton\",\"security\":false,\"v8\":\"13.6.233.17\"},{\"name\":\"nodejs\",\"version\":\"24.19.0\",\"date\":\"2026-08-03\",\"lts\":\"Krypton\",\"security\":false,\"v8\":\"13.6.233.17\"},{\"name\":\"nodejs\",\"version\":\"24.20.0\",\"date\":\"2026-08-26\",\"lts\":\"Krypton\",\"security\":false,\"v8\":\"13.6.233.17\"},{\"name\":\"nodejs\",\"version\":\"25.0.0\",\"date\":\"2025-10-15\",\"lts\":false,\"security\":false,\"v8\":\"14.1.146.11\"},{\"name\":\"nodejs\",\"version\":\"25.1.0\",\"date\":\"2025-10-28\",\"lts\":false,\"security\":false,\"v8\":\"14.1.146.11\"},{\"name\":\"nodejs\",\"version\":\"25.2.0\",\"date\":\"2025-11-11\",\"lts\":false,\"security\":false,\"v8\":\"14.1.146.11\"},{\"name\":\"nodejs\",\"version\":\"25.3.0\",\"date\":\"2026-01-12\",\"lts\":false,\"security\":true,\"v8\":\"14.1.146.11\"},{\"name\":\"nodejs\",\"version\":\"25.4.0\",\"date\":\"2026-01-19\",\"lts\":false,\"security\":false,\"v8\":\"14.1.146.11\"},{\"name\":\"nodejs\",\"version\":\"25.5.0\",\"date\":\"2026-01-26\",\"lts\":false,\"security\":false,\"v8\":\"14.1.146.11\"},{\"name\":\"nodejs\",\"version\":\"25.6.0\",\"date\":\"2026-02-02\",\"lts\":false,\"security\":false,\"v8\":\"14.1.146.11\"},{\"name\":\"nodejs\",\"version\":\"25.7.0\",\"date\":\"2026-02-24\",\"lts\":false,\"security\":false,\"v8\":\"14.1.146.11\"},{\"name\":\"nodejs\",\"version\":\"25.8.0\",\"date\":\"2026-03-03\",\"lts\":false,\"security\":false,\"v8\":\"14.1.146.11\"},{\"name\":\"nodejs\",\"version\":\"25.9.0\",\"date\":\"2026-03-31\",\"lts\":false,\"security\":false,\"v8\":\"14.1.146.11\"},{\"name\":\"nodejs\",\"version\":\"26.0.0\",\"date\":\"2026-05-05\",\"lts\":false,\"security\":false,\"v8\":\"14.6.202.33\"},{\"name\":\"nodejs\",\"version\":\"26.1.0\",\"date\":\"2026-05-06\",\"lts\":false,\"security\":false,\"v8\":\"14.6.202.34\"},{\"name\":\"nodejs\",\"version\":\"26.2.0\",\"date\":\"2026-05-20\",\"lts\":false,\"security\":false,\"v8\":\"14.6.202.34\"},{\"name\":\"nodejs\",\"version\":\"26.3.0\",\"date\":\"2026-06-01\",\"lts\":false,\"security\":false,\"v8\":\"14.6.202.34\"},{\"name\":\"nodejs\",\"version\":\"26.4.0\",\"date\":\"2026-06-24\",\"lts\":false,\"security\":false,\"v8\":\"14.6.202.34\"},{\"name\":\"nodejs\",\"version\":\"26.5.0\",\"date\":\"2026-07-08\",\"lts\":false,\"security\":false,\"v8\":\"14.6.202.34\"},{\"name\":\"nodejs\",\"version\":\"26.6.0\",\"date\":\"2026-08-03\",\"lts\":false,\"security\":false,\"v8\":\"14.6.202.34\"},{\"name\":\"nodejs\",\"version\":\"26.7.0\",\"date\":\"2026-08-05\",\"lts\":false,\"security\":false,\"v8\":\"14.6.202.34\"},{\"name\":\"nodejs\",\"version\":\"26.8.0\",\"date\":\"2026-08-25\",\"lts\":false,\"security\":false,\"v8\":\"14.6.202.34\"}]");


var $87aaf62f5e035055$export$ac5be7df5fa52a3c;
'use strict';
var $edbba1c0bab79d6e$export$804348712f697b1b;

$edbba1c0bab79d6e$export$804348712f697b1b = (parcelRequire("3x1R5"));


var $87aaf62f5e035055$require$browsers = $edbba1c0bab79d6e$export$804348712f697b1b;
var $7bc55b293d284941$export$e0222f875ebd697e;

$7bc55b293d284941$export$e0222f875ebd697e = (parcelRequire("k2mMc"));


var $87aaf62f5e035055$require$versions = $7bc55b293d284941$export$e0222f875ebd697e;
var $f6932f884a325670$exports = {};
$f6932f884a325670$exports = {
    A: {
        A: {
            L: 0,
            D: 0,
            E: 0,
            F: 0,
            A: 0,
            B: 0.266336,
            AD: 0
        },
        B: "ms",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "AD",
            "L",
            "D",
            "E",
            "F",
            "A",
            "B",
            "",
            "",
            ""
        ],
        E: "IE",
        F: {
            AD: 962323200,
            L: 998870400,
            D: 1161129600,
            E: 1237420800,
            F: 1300060800,
            A: 1346716800,
            B: 1381968000
        }
    },
    B: {
        A: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0.179088,
            "4": 0.18368,
            "5": 0,
            "6": 0.009184,
            "7": 0,
            "8": 0,
            "9": 0,
            C: 0,
            M: 0,
            N: 0,
            G: 0,
            O: 0,
            P: 0,
            Q: 0,
            R: 0,
            H: 0,
            S: 0,
            T: 0,
            U: 0,
            V: 0,
            W: 0,
            X: 0,
            Y: 0,
            Z: 0,
            a: 0,
            b: 0,
            c: 0.009184,
            d: 0,
            e: 0,
            f: 0,
            g: 0,
            h: 0,
            i: 0,
            j: 0,
            k: 0,
            l: 0,
            m: 0,
            n: 0,
            o: 0,
            p: 0,
            q: 0,
            r: 0,
            s: 0,
            t: 0.027552,
            u: 0,
            v: 0,
            w: 0,
            x: 0,
            y: 0.004592,
            z: 0,
            AB: 0,
            BB: 0,
            NB: 0,
            OB: 0,
            PB: 0,
            CB: 0.013776,
            QB: 0,
            RB: 0.004592,
            SB: 0.004592,
            TB: 0.009184,
            UB: 0.004592,
            VB: 0.004592,
            WB: 0.009184,
            XB: 0.009184,
            YB: 0.009184,
            ZB: 0.009184,
            aB: 0.009184,
            bB: 0.013776,
            cB: 0.013776,
            dB: 0.013776,
            eB: 0.018368,
            fB: 0.059696,
            gB: 0.055104,
            hB: 0.821968,
            iB: 3.58635,
            I: 0.004592
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "C",
            "M",
            "N",
            "G",
            "O",
            "P",
            "Q",
            "R",
            "H",
            "S",
            "T",
            "U",
            "V",
            "W",
            "X",
            "Y",
            "Z",
            "a",
            "b",
            "c",
            "d",
            "e",
            "f",
            "g",
            "h",
            "i",
            "j",
            "k",
            "l",
            "m",
            "n",
            "o",
            "p",
            "q",
            "r",
            "s",
            "t",
            "u",
            "v",
            "w",
            "x",
            "y",
            "z",
            "0",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "AB",
            "BB",
            "NB",
            "OB",
            "PB",
            "CB",
            "QB",
            "RB",
            "SB",
            "TB",
            "UB",
            "VB",
            "WB",
            "XB",
            "YB",
            "ZB",
            "aB",
            "bB",
            "cB",
            "dB",
            "eB",
            "fB",
            "gB",
            "hB",
            "iB",
            "I",
            "",
            "",
            ""
        ],
        E: "Edge",
        F: {
            "0": 1692576000,
            "1": 1694649600,
            "2": 1697155200,
            "3": 1698969600,
            "4": 1701993600,
            "5": 1706227200,
            "6": 1708732800,
            "7": 1711152000,
            "8": 1713398400,
            "9": 1715990400,
            C: 1438128000,
            M: 1447286400,
            N: 1470096000,
            G: 1491868800,
            O: 1508198400,
            P: 1525046400,
            Q: 1542067200,
            R: 1579046400,
            H: 1581033600,
            S: 1586736000,
            T: 1590019200,
            U: 1594857600,
            V: 1598486400,
            W: 1602201600,
            X: 1605830400,
            Y: 1611360000,
            Z: 1614816000,
            a: 1618358400,
            b: 1622073600,
            c: 1626912000,
            d: 1630627200,
            e: 1632441600,
            f: 1634774400,
            g: 1637539200,
            h: 1641427200,
            i: 1643932800,
            j: 1646265600,
            k: 1649635200,
            l: 1651190400,
            m: 1653955200,
            n: 1655942400,
            o: 1659657600,
            p: 1661990400,
            q: 1664755200,
            r: 1666915200,
            s: 1670198400,
            t: 1673481600,
            u: 1675900800,
            v: 1678665600,
            w: 1680825600,
            x: 1683158400,
            y: 1685664000,
            z: 1689897600,
            AB: 1718841600,
            BB: 1721865600,
            NB: 1724371200,
            OB: 1726704000,
            PB: 1729123200,
            CB: 1731542400,
            QB: 1737417600,
            RB: 1740614400,
            SB: 1741219200,
            TB: 1743984000,
            UB: 1746316800,
            VB: 1748476800,
            WB: 1750896000,
            XB: 1754611200,
            YB: 1756944000,
            ZB: 1759363200,
            aB: 1761868800,
            bB: 1764806400,
            cB: 1768780800,
            dB: 1770854400,
            eB: 1773446400,
            fB: 1775692800,
            gB: 1778112000,
            hB: 1780531200,
            iB: 1782950400,
            I: 1785369600
        },
        D: {
            C: "ms",
            M: "ms",
            N: "ms",
            G: "ms",
            O: "ms",
            P: "ms",
            Q: "ms"
        }
    },
    C: {
        A: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0.174496,
            "5": 0.348992,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0.059696,
            BD: 0,
            cC: 0,
            J: 0,
            jB: 0.009184,
            L: 0,
            D: 0,
            E: 0,
            F: 0,
            A: 0,
            B: 0,
            C: 0,
            M: 0,
            N: 0,
            G: 0,
            O: 0,
            P: 0,
            Q: 0,
            kB: 0,
            DB: 0,
            EB: 0,
            FB: 0,
            GB: 0,
            HB: 0,
            IB: 0,
            JB: 0,
            K: 0,
            KB: 0,
            LB: 0,
            MB: 0,
            lB: 0,
            mB: 0,
            nB: 0,
            oB: 0,
            pB: 0,
            qB: 0,
            rB: 0,
            sB: 0,
            tB: 0,
            uB: 0,
            vB: 0,
            wB: 0,
            xB: 0,
            yB: 0,
            zB: 0,
            "0B": 0,
            "1B": 0,
            "2B": 0,
            "3B": 0,
            "4B": 0,
            "5B": 0,
            "6B": 0.004592,
            "7B": 0,
            "8B": 0,
            "9B": 0,
            AC: 0,
            BC: 0,
            CC: 0,
            dC: 0,
            DC: 0,
            eC: 0,
            EC: 0,
            FC: 0,
            GC: 0,
            HC: 0,
            IC: 0,
            JC: 0,
            KC: 0,
            LC: 0,
            MC: 0,
            NC: 0,
            OC: 0,
            PC: 0,
            QC: 0,
            RC: 0,
            SC: 0,
            TC: 0,
            UC: 0.004592,
            R: 0,
            H: 0,
            S: 0,
            fC: 0,
            T: 0,
            U: 0,
            V: 0,
            W: 0,
            X: 0,
            Y: 0,
            Z: 0,
            a: 0,
            b: 0,
            c: 0,
            d: 0,
            e: 0,
            f: 0,
            g: 0,
            h: 0,
            i: 0,
            j: 0,
            k: 0,
            l: 0,
            m: 0,
            n: 0,
            o: 0,
            p: 0,
            q: 0,
            r: 0,
            s: 0,
            t: 0,
            u: 0,
            v: 0,
            w: 0,
            x: 0.004592,
            y: 0,
            z: 0.119392,
            AB: 0.059696,
            BB: 0.064288,
            NB: 0.050512,
            OB: 0.036736,
            PB: 0.059696,
            CB: 0.064288,
            QB: 0.059696,
            RB: 0.06888,
            SB: 0.041328,
            TB: 0.13776,
            UB: 0.078064,
            VB: 0,
            WB: 0,
            XB: 0,
            YB: 0.06888,
            ZB: 0,
            aB: 0,
            bB: 0,
            cB: 0,
            dB: 0,
            eB: 0.004592,
            fB: 0.009184,
            gB: 0.009184,
            hB: 0.009184,
            iB: 0.027552,
            I: 0.036736,
            gC: 0.982688,
            VC: 0.29848,
            hC: 0,
            CD: 0,
            DD: 0,
            ED: 0,
            FD: 0,
            GD: 0
        },
        B: "moz",
        C: [
            "BD",
            "cC",
            "FD",
            "GD",
            "J",
            "jB",
            "L",
            "D",
            "E",
            "F",
            "A",
            "B",
            "C",
            "M",
            "N",
            "G",
            "O",
            "P",
            "Q",
            "kB",
            "DB",
            "EB",
            "FB",
            "GB",
            "HB",
            "IB",
            "JB",
            "K",
            "KB",
            "LB",
            "MB",
            "lB",
            "mB",
            "nB",
            "oB",
            "pB",
            "qB",
            "rB",
            "sB",
            "tB",
            "uB",
            "vB",
            "wB",
            "xB",
            "yB",
            "zB",
            "0B",
            "1B",
            "2B",
            "3B",
            "4B",
            "5B",
            "6B",
            "7B",
            "8B",
            "9B",
            "AC",
            "BC",
            "CC",
            "dC",
            "DC",
            "eC",
            "EC",
            "FC",
            "GC",
            "HC",
            "IC",
            "JC",
            "KC",
            "LC",
            "MC",
            "NC",
            "OC",
            "PC",
            "QC",
            "RC",
            "SC",
            "TC",
            "UC",
            "R",
            "H",
            "S",
            "fC",
            "T",
            "U",
            "V",
            "W",
            "X",
            "Y",
            "Z",
            "a",
            "b",
            "c",
            "d",
            "e",
            "f",
            "g",
            "h",
            "i",
            "j",
            "k",
            "l",
            "m",
            "n",
            "o",
            "p",
            "q",
            "r",
            "s",
            "t",
            "u",
            "v",
            "w",
            "x",
            "y",
            "z",
            "0",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "AB",
            "BB",
            "NB",
            "OB",
            "PB",
            "CB",
            "QB",
            "RB",
            "SB",
            "TB",
            "UB",
            "VB",
            "WB",
            "XB",
            "YB",
            "ZB",
            "aB",
            "bB",
            "cB",
            "dB",
            "eB",
            "fB",
            "gB",
            "hB",
            "iB",
            "I",
            "gC",
            "VC",
            "hC",
            "CD",
            "DD",
            "ED"
        ],
        E: "Firefox",
        F: {
            "0": 1690848000,
            "1": 1693267200,
            "2": 1695686400,
            "3": 1698105600,
            "4": 1700524800,
            "5": 1702944000,
            "6": 1705968000,
            "7": 1708387200,
            "8": 1710806400,
            "9": 1713225600,
            BD: 1161648000,
            cC: 1213660800,
            FD: 1246320000,
            GD: 1264032000,
            J: 1300752000,
            jB: 1308614400,
            L: 1313452800,
            D: 1317081600,
            E: 1317081600,
            F: 1320710400,
            A: 1324339200,
            B: 1327968000,
            C: 1331596800,
            M: 1335225600,
            N: 1338854400,
            G: 1342483200,
            O: 1346112000,
            P: 1349740800,
            Q: 1353628800,
            kB: 1357603200,
            DB: 1361232000,
            EB: 1364860800,
            FB: 1368489600,
            GB: 1372118400,
            HB: 1375747200,
            IB: 1379376000,
            JB: 1386633600,
            K: 1391472000,
            KB: 1395100800,
            LB: 1398729600,
            MB: 1402358400,
            lB: 1405987200,
            mB: 1409616000,
            nB: 1413244800,
            oB: 1417392000,
            pB: 1421107200,
            qB: 1424736000,
            rB: 1428278400,
            sB: 1431475200,
            tB: 1435881600,
            uB: 1439251200,
            vB: 1442880000,
            wB: 1446508800,
            xB: 1450137600,
            yB: 1453852800,
            zB: 1457395200,
            "0B": 1461628800,
            "1B": 1465257600,
            "2B": 1470096000,
            "3B": 1474329600,
            "4B": 1479168000,
            "5B": 1485216000,
            "6B": 1488844800,
            "7B": 1492560000,
            "8B": 1497312000,
            "9B": 1502150400,
            AC: 1506556800,
            BC: 1510617600,
            CC: 1516665600,
            dC: 1520985600,
            DC: 1525824000,
            eC: 1529971200,
            EC: 1536105600,
            FC: 1540252800,
            GC: 1544486400,
            HC: 1548720000,
            IC: 1552953600,
            JC: 1558396800,
            KC: 1562630400,
            LC: 1567468800,
            MC: 1571788800,
            NC: 1575331200,
            OC: 1578355200,
            PC: 1581379200,
            QC: 1583798400,
            RC: 1586304000,
            SC: 1588636800,
            TC: 1591056000,
            UC: 1593475200,
            R: 1595894400,
            H: 1598313600,
            S: 1600732800,
            fC: 1603152000,
            T: 1605571200,
            U: 1607990400,
            V: 1611619200,
            W: 1614038400,
            X: 1616457600,
            Y: 1618790400,
            Z: 1622505600,
            a: 1626134400,
            b: 1628553600,
            c: 1630972800,
            d: 1633392000,
            e: 1635811200,
            f: 1638835200,
            g: 1641859200,
            h: 1644364800,
            i: 1646697600,
            j: 1649116800,
            k: 1651536000,
            l: 1653955200,
            m: 1656374400,
            n: 1658793600,
            o: 1661212800,
            p: 1663632000,
            q: 1666051200,
            r: 1668470400,
            s: 1670889600,
            t: 1673913600,
            u: 1676332800,
            v: 1678752000,
            w: 1681171200,
            x: 1683590400,
            y: 1686009600,
            z: 1688428800,
            AB: 1715644800,
            BB: 1718064000,
            NB: 1720483200,
            OB: 1722902400,
            PB: 1725321600,
            CB: 1727740800,
            QB: 1730160000,
            RB: 1732579200,
            SB: 1736208000,
            TB: 1738627200,
            UB: 1741046400,
            VB: 1743465600,
            WB: 1745884800,
            XB: 1748304000,
            YB: 1750723200,
            ZB: 1753142400,
            aB: 1755561600,
            bB: 1757980800,
            cB: 1760400000,
            dB: 1762819200,
            eB: 1765238400,
            fB: 1768262400,
            gB: 1771891200,
            hB: 1774310400,
            iB: 1776729600,
            I: 1779148800,
            gC: 1781568000,
            VC: 1784592000,
            hC: 1787011200,
            CD: null,
            DD: null,
            ED: null
        }
    },
    D: {
        A: {
            "0": 0.20664,
            "1": 0.09184,
            "2": 0.211232,
            "3": 0.36736,
            "4": 0.509712,
            "5": 0.013776,
            "6": 0.036736,
            "7": 0.018368,
            "8": 0.174496,
            "9": 0.087248,
            J: 0,
            jB: 0,
            L: 0,
            D: 0,
            E: 0,
            F: 0,
            A: 0,
            B: 0,
            C: 0,
            M: 0,
            N: 0,
            G: 0,
            O: 0,
            P: 0,
            Q: 0,
            kB: 0,
            DB: 0,
            EB: 0,
            FB: 0,
            GB: 0,
            HB: 0,
            IB: 0,
            JB: 0,
            K: 0,
            KB: 0,
            LB: 0,
            MB: 0,
            lB: 0,
            mB: 0,
            nB: 0,
            oB: 0,
            pB: 0,
            qB: 0,
            rB: 0,
            sB: 0,
            tB: 0.02296,
            uB: 0.02296,
            vB: 0.02296,
            wB: 0.02296,
            xB: 0.02296,
            yB: 0.02296,
            zB: 0.02296,
            "0B": 0.02296,
            "1B": 0.02296,
            "2B": 0.027552,
            "3B": 0.027552,
            "4B": 0.02296,
            "5B": 0.02296,
            "6B": 0.027552,
            "7B": 0.02296,
            "8B": 0.02296,
            "9B": 0.02296,
            AC: 0.02296,
            BC: 0.02296,
            CC: 0.02296,
            dC: 0.02296,
            DC: 0.02296,
            eC: 0,
            EC: 0,
            FC: 0,
            GC: 0,
            HC: 0,
            IC: 0,
            JC: 0,
            KC: 0,
            LC: 0.009184,
            MC: 0.06888,
            NC: 0,
            OC: 0,
            PC: 0,
            QC: 0,
            RC: 0,
            SC: 0,
            TC: 0,
            UC: 0,
            R: 0.018368,
            H: 0,
            S: 0,
            T: 0,
            U: 0,
            V: 0,
            W: 0.004592,
            X: 0.02296,
            Y: 0,
            Z: 0,
            a: 0,
            b: 0.009184,
            c: 0,
            d: 0.009184,
            e: 0,
            f: 0,
            g: 0,
            h: 0.004592,
            i: 0.02296,
            j: 0.004592,
            k: 0,
            l: 0.009184,
            m: 0.009184,
            n: 0.146944,
            o: 0.087248,
            p: 0.087248,
            q: 0.09184,
            r: 0.09184,
            s: 0.096432,
            t: 0.583184,
            u: 0.09184,
            v: 0.101024,
            w: 0.09184,
            x: 0,
            y: 0.018368,
            z: 0.009184,
            AB: 0.036736,
            BB: 0.013776,
            NB: 0.064288,
            OB: 0.013776,
            PB: 0.027552,
            CB: 0.270928,
            QB: 0.073472,
            RB: 0.211232,
            SB: 0.04592,
            TB: 0.036736,
            UB: 0.247968,
            VB: 0.073472,
            WB: 0.123984,
            XB: 0.188272,
            YB: 0.036736,
            ZB: 0.04592,
            aB: 0.257152,
            bB: 0.073472,
            cB: 0.101024,
            dB: 0.904624,
            eB: 0.110208,
            fB: 0.220416,
            gB: 0.716352,
            hB: 5.04202,
            iB: 9.15645,
            I: 0.142352,
            gC: 0.009184,
            VC: 0,
            hC: 0
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "J",
            "jB",
            "L",
            "D",
            "E",
            "F",
            "A",
            "B",
            "C",
            "M",
            "N",
            "G",
            "O",
            "P",
            "Q",
            "kB",
            "DB",
            "EB",
            "FB",
            "GB",
            "HB",
            "IB",
            "JB",
            "K",
            "KB",
            "LB",
            "MB",
            "lB",
            "mB",
            "nB",
            "oB",
            "pB",
            "qB",
            "rB",
            "sB",
            "tB",
            "uB",
            "vB",
            "wB",
            "xB",
            "yB",
            "zB",
            "0B",
            "1B",
            "2B",
            "3B",
            "4B",
            "5B",
            "6B",
            "7B",
            "8B",
            "9B",
            "AC",
            "BC",
            "CC",
            "dC",
            "DC",
            "eC",
            "EC",
            "FC",
            "GC",
            "HC",
            "IC",
            "JC",
            "KC",
            "LC",
            "MC",
            "NC",
            "OC",
            "PC",
            "QC",
            "RC",
            "SC",
            "TC",
            "UC",
            "R",
            "H",
            "S",
            "T",
            "U",
            "V",
            "W",
            "X",
            "Y",
            "Z",
            "a",
            "b",
            "c",
            "d",
            "e",
            "f",
            "g",
            "h",
            "i",
            "j",
            "k",
            "l",
            "m",
            "n",
            "o",
            "p",
            "q",
            "r",
            "s",
            "t",
            "u",
            "v",
            "w",
            "x",
            "y",
            "z",
            "0",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "AB",
            "BB",
            "NB",
            "OB",
            "PB",
            "CB",
            "QB",
            "RB",
            "SB",
            "TB",
            "UB",
            "VB",
            "WB",
            "XB",
            "YB",
            "ZB",
            "aB",
            "bB",
            "cB",
            "dB",
            "eB",
            "fB",
            "gB",
            "hB",
            "iB",
            "I",
            "gC",
            "VC",
            "hC"
        ],
        E: "Chrome",
        F: {
            "0": 1692057600,
            "1": 1694476800,
            "2": 1696896000,
            "3": 1698710400,
            "4": 1701993600,
            "5": 1705968000,
            "6": 1708387200,
            "7": 1710806400,
            "8": 1713225600,
            "9": 1715644800,
            J: 1264377600,
            jB: 1274745600,
            L: 1283385600,
            D: 1287619200,
            E: 1291248000,
            F: 1296777600,
            A: 1299542400,
            B: 1303862400,
            C: 1307404800,
            M: 1312243200,
            N: 1316131200,
            G: 1316131200,
            O: 1319500800,
            P: 1323734400,
            Q: 1328659200,
            kB: 1332892800,
            DB: 1337040000,
            EB: 1340668800,
            FB: 1343692800,
            GB: 1348531200,
            HB: 1352246400,
            IB: 1357862400,
            JB: 1361404800,
            K: 1364428800,
            KB: 1369094400,
            LB: 1374105600,
            MB: 1376956800,
            lB: 1384214400,
            mB: 1389657600,
            nB: 1392940800,
            oB: 1397001600,
            pB: 1400544000,
            qB: 1405468800,
            rB: 1409011200,
            sB: 1412640000,
            tB: 1416268800,
            uB: 1421798400,
            vB: 1425513600,
            wB: 1429401600,
            xB: 1432080000,
            yB: 1437523200,
            zB: 1441152000,
            "0B": 1444780800,
            "1B": 1449014400,
            "2B": 1453248000,
            "3B": 1456963200,
            "4B": 1460592000,
            "5B": 1464134400,
            "6B": 1469059200,
            "7B": 1472601600,
            "8B": 1476230400,
            "9B": 1480550400,
            AC: 1485302400,
            BC: 1489017600,
            CC: 1492560000,
            dC: 1496707200,
            DC: 1500940800,
            eC: 1504569600,
            EC: 1508198400,
            FC: 1512518400,
            GC: 1516752000,
            HC: 1520294400,
            IC: 1523923200,
            JC: 1527552000,
            KC: 1532390400,
            LC: 1536019200,
            MC: 1539648000,
            NC: 1543968000,
            OC: 1548720000,
            PC: 1552348800,
            QC: 1555977600,
            RC: 1559606400,
            SC: 1564444800,
            TC: 1568073600,
            UC: 1571702400,
            R: 1575936000,
            H: 1580860800,
            S: 1586304000,
            T: 1589846400,
            U: 1594684800,
            V: 1598313600,
            W: 1601942400,
            X: 1605571200,
            Y: 1611014400,
            Z: 1614556800,
            a: 1618272000,
            b: 1621987200,
            c: 1626739200,
            d: 1630368000,
            e: 1632268800,
            f: 1634601600,
            g: 1637020800,
            h: 1641340800,
            i: 1643673600,
            j: 1646092800,
            k: 1648512000,
            l: 1650931200,
            m: 1653350400,
            n: 1655769600,
            o: 1659398400,
            p: 1661817600,
            q: 1664236800,
            r: 1666656000,
            s: 1669680000,
            t: 1673308800,
            u: 1675728000,
            v: 1678147200,
            w: 1680566400,
            x: 1682985600,
            y: 1685404800,
            z: 1689724800,
            AB: 1718064000,
            BB: 1721174400,
            NB: 1724112000,
            OB: 1726531200,
            PB: 1728950400,
            CB: 1731369600,
            QB: 1736812800,
            RB: 1738627200,
            SB: 1741046400,
            TB: 1743465600,
            UB: 1745884800,
            VB: 1748304000,
            WB: 1750723200,
            XB: 1754352000,
            YB: 1756771200,
            ZB: 1759190400,
            aB: 1761609600,
            bB: 1764633600,
            cB: 1768262400,
            dB: 1770681600,
            eB: 1773100800,
            fB: 1775520000,
            gB: 1777939200,
            hB: 1780358400,
            iB: 1782777600,
            I: 1785196800,
            gC: null,
            VC: null,
            hC: null
        }
    },
    E: {
        A: {
            J: 0,
            jB: 0,
            L: 0,
            D: 0,
            E: 0,
            F: 0,
            A: 0,
            B: 0,
            C: 0,
            M: 0,
            N: 0.004592,
            G: 0,
            K: 0.009184,
            HD: 0,
            iC: 0,
            ID: 0,
            JD: 0,
            KD: 0,
            LD: 0,
            jC: 0,
            WC: 0,
            XC: 0,
            MD: 0.013776,
            ND: 0.018368,
            OD: 0,
            kC: 0,
            lC: 0,
            YC: 0,
            PD: 0.064288,
            ZC: 0,
            mC: 0.004592,
            nC: 0.004592,
            oC: 0.009184,
            pC: 0.004592,
            qC: 0.009184,
            QD: 0.105616,
            aC: 0.009184,
            rC: 0.087248,
            sC: 0.009184,
            tC: 0.009184,
            uC: 0.018368,
            vC: 0.036736,
            RD: 0.133168,
            bC: 0.004592,
            wC: 0.013776,
            xC: 0.009184,
            yC: 0.027552,
            zC: 0.009184,
            "0C": 0.293888,
            "1C": 0.013776,
            "2C": 0.013776,
            "3C": 0.055104,
            "4C": 0.078064,
            "5C": 0.050512,
            "6C": 1.35005,
            "7C": 0,
            SD: 0
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "HD",
            "iC",
            "J",
            "jB",
            "ID",
            "L",
            "JD",
            "D",
            "KD",
            "E",
            "F",
            "LD",
            "A",
            "jC",
            "B",
            "WC",
            "C",
            "XC",
            "M",
            "MD",
            "N",
            "ND",
            "G",
            "OD",
            "kC",
            "lC",
            "YC",
            "PD",
            "ZC",
            "mC",
            "nC",
            "oC",
            "pC",
            "qC",
            "QD",
            "aC",
            "rC",
            "sC",
            "tC",
            "uC",
            "vC",
            "RD",
            "bC",
            "wC",
            "xC",
            "yC",
            "zC",
            "0C",
            "1C",
            "2C",
            "3C",
            "4C",
            "5C",
            "6C",
            "7C",
            "K",
            "SD",
            ""
        ],
        E: "Safari",
        F: {
            HD: 1205798400,
            iC: 1226534400,
            J: 1244419200,
            jB: 1275868800,
            ID: 1311120000,
            L: 1343174400,
            JD: 1382400000,
            D: 1382400000,
            KD: 1410998400,
            E: 1413417600,
            F: 1443657600,
            LD: 1458518400,
            A: 1474329600,
            jC: 1490572800,
            B: 1505779200,
            WC: 1522281600,
            C: 1537142400,
            XC: 1553472000,
            M: 1568851200,
            MD: 1585008000,
            N: 1600214400,
            ND: 1619395200,
            G: 1632096000,
            OD: 1635292800,
            kC: 1639353600,
            lC: 1647216000,
            YC: 1652745600,
            PD: 1658275200,
            ZC: 1662940800,
            mC: 1666569600,
            nC: 1670889600,
            oC: 1674432000,
            pC: 1679875200,
            qC: 1684368000,
            QD: 1690156800,
            aC: 1695686400,
            rC: 1698192000,
            sC: 1702252800,
            tC: 1705881600,
            uC: 1709596800,
            vC: 1715558400,
            RD: 1722211200,
            bC: 1726444800,
            wC: 1730073600,
            xC: 1733875200,
            yC: 1737936000,
            zC: 1743379200,
            "0C": 1747008000,
            "1C": 1757894400,
            "2C": 1762128000,
            "3C": 1762041600,
            "4C": 1770854400,
            "5C": 1774310400,
            "6C": 1778457600,
            "7C": 1785110400,
            K: null,
            SD: null
        }
    },
    F: {
        A: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            F: 0,
            B: 0,
            C: 0,
            G: 0,
            O: 0,
            P: 0,
            Q: 0,
            kB: 0,
            DB: 0,
            EB: 0,
            FB: 0,
            GB: 0,
            HB: 0,
            IB: 0,
            JB: 0,
            K: 0,
            KB: 0,
            LB: 0,
            MB: 0,
            lB: 0,
            mB: 0,
            nB: 0,
            oB: 0,
            pB: 0,
            qB: 0,
            rB: 0,
            sB: 0,
            tB: 0,
            uB: 0,
            vB: 0,
            wB: 0,
            xB: 0,
            yB: 0,
            zB: 0,
            "0B": 0.004592,
            "1B": 0,
            "2B": 0,
            "3B": 0,
            "4B": 0,
            "5B": 0,
            "6B": 0,
            "7B": 0,
            "8B": 0,
            "9B": 0,
            AC: 0,
            BC: 0,
            CC: 0,
            DC: 0,
            EC: 0,
            FC: 0,
            GC: 0,
            HC: 0,
            IC: 0,
            JC: 0,
            KC: 0,
            LC: 0,
            MC: 0,
            NC: 0,
            OC: 0,
            PC: 0,
            QC: 0,
            RC: 0,
            SC: 0,
            TC: 0,
            UC: 0,
            R: 0,
            H: 0,
            S: 0,
            fC: 0,
            T: 0,
            U: 0,
            V: 0,
            W: 0,
            X: 0,
            Y: 0,
            Z: 0,
            a: 0,
            b: 0,
            c: 0,
            d: 0,
            e: 0,
            f: 0.027552,
            g: 0,
            h: 0,
            i: 0.004592,
            j: 0.02296,
            k: 0.128576,
            l: 0,
            m: 0,
            n: 0,
            o: 0,
            p: 0,
            q: 0,
            r: 0,
            s: 0,
            t: 0,
            u: 0,
            v: 0,
            w: 0,
            x: 0,
            y: 0,
            z: 0,
            AB: 0,
            BB: 0,
            CB: 0.059696,
            TD: 0,
            UD: 0,
            VD: 0,
            WD: 0,
            WC: 0,
            "8C": 0,
            XD: 0,
            XC: 0
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "F",
            "TD",
            "UD",
            "VD",
            "WD",
            "B",
            "WC",
            "8C",
            "XD",
            "C",
            "XC",
            "G",
            "O",
            "P",
            "Q",
            "kB",
            "DB",
            "EB",
            "FB",
            "GB",
            "HB",
            "IB",
            "JB",
            "K",
            "KB",
            "LB",
            "MB",
            "lB",
            "mB",
            "nB",
            "oB",
            "pB",
            "qB",
            "rB",
            "sB",
            "tB",
            "uB",
            "vB",
            "wB",
            "xB",
            "yB",
            "zB",
            "0B",
            "1B",
            "2B",
            "3B",
            "4B",
            "5B",
            "6B",
            "7B",
            "8B",
            "9B",
            "AC",
            "BC",
            "CC",
            "DC",
            "EC",
            "FC",
            "GC",
            "HC",
            "IC",
            "JC",
            "KC",
            "LC",
            "MC",
            "NC",
            "OC",
            "PC",
            "QC",
            "RC",
            "SC",
            "TC",
            "UC",
            "R",
            "H",
            "S",
            "fC",
            "T",
            "U",
            "V",
            "W",
            "X",
            "Y",
            "Z",
            "a",
            "b",
            "c",
            "d",
            "e",
            "f",
            "g",
            "h",
            "i",
            "j",
            "k",
            "l",
            "m",
            "n",
            "o",
            "p",
            "q",
            "r",
            "s",
            "t",
            "u",
            "v",
            "w",
            "x",
            "y",
            "z",
            "0",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "AB",
            "BB",
            "CB",
            "",
            "",
            ""
        ],
        E: "Opera",
        F: {
            "0": 1736294400,
            "1": 1739404800,
            "2": 1744675200,
            "3": 1747094400,
            "4": 1751414400,
            "5": 1756339200,
            "6": 1757548800,
            "7": 1761609600,
            "8": 1762992000,
            "9": 1764806400,
            F: 1150761600,
            TD: 1223424000,
            UD: 1251763200,
            VD: 1267488000,
            WD: 1277942400,
            B: 1292457600,
            WC: 1302566400,
            "8C": 1309219200,
            XD: 1323129600,
            C: 1323129600,
            XC: 1352073600,
            G: 1372723200,
            O: 1377561600,
            P: 1381104000,
            Q: 1386288000,
            kB: 1390867200,
            DB: 1393891200,
            EB: 1399334400,
            FB: 1401753600,
            GB: 1405987200,
            HB: 1409616000,
            IB: 1413331200,
            JB: 1417132800,
            K: 1422316800,
            KB: 1425945600,
            LB: 1430179200,
            MB: 1433808000,
            lB: 1438646400,
            mB: 1442448000,
            nB: 1445904000,
            oB: 1449100800,
            pB: 1454371200,
            qB: 1457308800,
            rB: 1462320000,
            sB: 1465344000,
            tB: 1470096000,
            uB: 1474329600,
            vB: 1477267200,
            wB: 1481587200,
            xB: 1486425600,
            yB: 1490054400,
            zB: 1494374400,
            "0B": 1498003200,
            "1B": 1502236800,
            "2B": 1506470400,
            "3B": 1510099200,
            "4B": 1515024000,
            "5B": 1517961600,
            "6B": 1521676800,
            "7B": 1525910400,
            "8B": 1530144000,
            "9B": 1534982400,
            AC: 1537833600,
            BC: 1543363200,
            CC: 1548201600,
            DC: 1554768000,
            EC: 1561593600,
            FC: 1566259200,
            GC: 1570406400,
            HC: 1573689600,
            IC: 1578441600,
            JC: 1583971200,
            KC: 1587513600,
            LC: 1592956800,
            MC: 1595894400,
            NC: 1600128000,
            OC: 1603238400,
            PC: 1613520000,
            QC: 1612224000,
            RC: 1616544000,
            SC: 1619568000,
            TC: 1623715200,
            UC: 1627948800,
            R: 1631577600,
            H: 1633392000,
            S: 1635984000,
            fC: 1638403200,
            T: 1642550400,
            U: 1644969600,
            V: 1647993600,
            W: 1650412800,
            X: 1652745600,
            Y: 1654646400,
            Z: 1657152000,
            a: 1660780800,
            b: 1663113600,
            c: 1668816000,
            d: 1668643200,
            e: 1671062400,
            f: 1675209600,
            g: 1677024000,
            h: 1679529600,
            i: 1681948800,
            j: 1684195200,
            k: 1687219200,
            l: 1690329600,
            m: 1692748800,
            n: 1696204800,
            o: 1699920000,
            p: 1699920000,
            q: 1702944000,
            r: 1707264000,
            s: 1710115200,
            t: 1711497600,
            u: 1716336000,
            v: 1719273600,
            w: 1721088000,
            x: 1724284800,
            y: 1727222400,
            z: 1732665600,
            AB: 1769990400,
            BB: 1772064000,
            CB: 1776124800
        },
        D: {
            F: "o",
            B: "o",
            C: "o",
            TD: "o",
            UD: "o",
            VD: "o",
            WD: "o",
            WC: "o",
            "8C": "o",
            XD: "o",
            XC: "o"
        }
    },
    G: {
        A: {
            E: 0,
            iC: 0,
            YD: 0,
            "9C": 0.00137471,
            ZD: 0,
            aD: 0,
            bD: 0.00274943,
            cD: 0,
            dD: 0.00137471,
            eD: 0,
            fD: 0,
            gD: 0.0137471,
            hD: 0.14572,
            iD: 0.00274943,
            jD: 0,
            kD: 0.0426161,
            lD: 0,
            mD: 0.00137471,
            nD: 0,
            oD: 0.00274943,
            pD: 0.00824828,
            qD: 0.00962299,
            rD: 0.0123724,
            kC: 0.00687357,
            lC: 0.00962299,
            YC: 0.0109977,
            sD: 0.230952,
            ZC: 0.019246,
            mC: 0.0329931,
            nC: 0.0178713,
            oC: 0.0371173,
            pC: 0.00824828,
            qC: 0.0137471,
            tD: 0.306561,
            aC: 0.0137471,
            rC: 0.0178713,
            sC: 0.0164966,
            tC: 0.0233701,
            uC: 0.0357426,
            vC: 0.0728598,
            uD: 0.178713,
            bC: 0.0412414,
            wC: 0.0783587,
            xC: 0.0426161,
            yC: 0.123724,
            zC: 0.0563633,
            "0C": 1.96309,
            "1C": 0.118225,
            "2C": 0.123724,
            "3C": 0.343678,
            "4C": 0.400042,
            "5C": 0.339554,
            "6C": 8.79954,
            "7C": 0
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "iC",
            "YD",
            "9C",
            "ZD",
            "aD",
            "bD",
            "E",
            "cD",
            "dD",
            "eD",
            "fD",
            "gD",
            "hD",
            "iD",
            "jD",
            "kD",
            "lD",
            "mD",
            "nD",
            "oD",
            "pD",
            "qD",
            "rD",
            "kC",
            "lC",
            "YC",
            "sD",
            "ZC",
            "mC",
            "nC",
            "oC",
            "pC",
            "qC",
            "tD",
            "aC",
            "rC",
            "sC",
            "tC",
            "uC",
            "vC",
            "uD",
            "bC",
            "wC",
            "xC",
            "yC",
            "zC",
            "0C",
            "1C",
            "2C",
            "3C",
            "4C",
            "5C",
            "6C",
            "7C",
            "",
            "",
            ""
        ],
        E: "Safari on iOS",
        F: {
            iC: 1270252800,
            YD: 1283904000,
            "9C": 1299628800,
            ZD: 1331078400,
            aD: 1359331200,
            bD: 1394409600,
            E: 1410912000,
            cD: 1413763200,
            dD: 1442361600,
            eD: 1458518400,
            fD: 1473724800,
            gD: 1490572800,
            hD: 1505779200,
            iD: 1522281600,
            jD: 1537142400,
            kD: 1553472000,
            lD: 1568851200,
            mD: 1572220800,
            nD: 1580169600,
            oD: 1585008000,
            pD: 1600214400,
            qD: 1619395200,
            rD: 1632096000,
            kC: 1639353600,
            lC: 1647216000,
            YC: 1652659200,
            sD: 1658275200,
            ZC: 1662940800,
            mC: 1666569600,
            nC: 1670889600,
            oC: 1674432000,
            pC: 1679875200,
            qC: 1684368000,
            tD: 1690156800,
            aC: 1694995200,
            rC: 1698192000,
            sC: 1702252800,
            tC: 1705881600,
            uC: 1709596800,
            vC: 1715558400,
            uD: 1722211200,
            bC: 1726444800,
            wC: 1730073600,
            xC: 1733875200,
            yC: 1737936000,
            zC: 1743379200,
            "0C": 1747008000,
            "1C": 1757894400,
            "2C": 1762128000,
            "3C": 1765497600,
            "4C": 1770854400,
            "5C": 1774310400,
            "6C": 1778457600,
            "7C": 1785110400
        }
    },
    H: {
        A: {
            vD: 0
        },
        B: "o",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "vD",
            "",
            "",
            ""
        ],
        E: "Opera Mini",
        F: {
            vD: 1426464000
        }
    },
    I: {
        A: {
            cC: 0,
            J: 0,
            I: 0.0324156,
            wD: 0,
            xD: 0,
            yD: 0,
            zD: 0.0000032448,
            "9C": 0,
            "0D": 0,
            "1D": 0.0000129792
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "wD",
            "xD",
            "yD",
            "cC",
            "J",
            "zD",
            "9C",
            "0D",
            "1D",
            "I",
            "",
            "",
            ""
        ],
        E: "Android Browser",
        F: {
            wD: 1256515200,
            xD: 1274313600,
            yD: 1291593600,
            cC: 1298332800,
            J: 1318896000,
            zD: 1341792000,
            "9C": 1374624000,
            "0D": 1386547200,
            "1D": 1401667200,
            I: 1784073600
        }
    },
    J: {
        A: {
            D: 0,
            A: 0
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "D",
            "A",
            "",
            "",
            ""
        ],
        E: "Blackberry Browser",
        F: {
            D: 1325376000,
            A: 1359504000
        }
    },
    K: {
        A: {
            A: 0,
            B: 0,
            C: 0,
            H: 0.978848,
            WC: 0,
            "8C": 0,
            XC: 0
        },
        B: "o",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "A",
            "B",
            "WC",
            "8C",
            "C",
            "XC",
            "H",
            "",
            "",
            ""
        ],
        E: "Opera Mobile",
        F: {
            A: 1287100800,
            B: 1300752000,
            WC: 1314835200,
            "8C": 1318291200,
            C: 1330300800,
            XC: 1349740800,
            H: 1709769600
        },
        D: {
            H: "webkit"
        }
    },
    L: {
        A: {
            I: 46.3251
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "I",
            "",
            "",
            ""
        ],
        E: "Chrome for Android",
        F: {
            I: 1784073600
        }
    },
    M: {
        A: {
            VC: 0.362336
        },
        B: "moz",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "VC",
            "",
            "",
            ""
        ],
        E: "Firefox for Android",
        F: {
            VC: 1784592000
        }
    },
    N: {
        A: {
            A: 0,
            B: 0
        },
        B: "ms",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "A",
            "B",
            "",
            "",
            ""
        ],
        E: "IE Mobile",
        F: {
            A: 1340150400,
            B: 1353456000
        }
    },
    O: {
        A: {
            YC: 0.681408
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "YC",
            "",
            "",
            ""
        ],
        E: "UC Browser for Android",
        F: {
            YC: 1710115200
        },
        D: {
            YC: "webkit"
        }
    },
    P: {
        A: {
            J: 0,
            DB: 0,
            EB: 0.00684278,
            FB: 0.00684278,
            GB: 0.00684278,
            HB: 0.00684278,
            IB: 0.0136856,
            JB: 0.0273711,
            K: 0.0205283,
            KB: 0.0547422,
            LB: 0.102642,
            MB: 1.088,
            "2D": 0,
            "3D": 0,
            "4D": 0.00684278,
            "5D": 0,
            "6D": 0,
            jC: 0,
            "7D": 0,
            "8D": 0,
            "9D": 0,
            AE: 0,
            BE: 0,
            ZC: 0,
            aC: 0,
            bC: 0,
            CE: 0
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "J",
            "2D",
            "3D",
            "4D",
            "5D",
            "6D",
            "jC",
            "7D",
            "8D",
            "9D",
            "AE",
            "BE",
            "ZC",
            "aC",
            "bC",
            "CE",
            "DB",
            "EB",
            "FB",
            "GB",
            "HB",
            "IB",
            "JB",
            "K",
            "KB",
            "LB",
            "MB",
            "",
            "",
            ""
        ],
        E: "Samsung Internet",
        F: {
            J: 1461024000,
            "2D": 1481846400,
            "3D": 1509408000,
            "4D": 1528329600,
            "5D": 1546128000,
            "6D": 1554163200,
            jC: 1567900800,
            "7D": 1582588800,
            "8D": 1593475200,
            "9D": 1605657600,
            AE: 1618531200,
            BE: 1629072000,
            ZC: 1640736000,
            aC: 1651708800,
            bC: 1659657600,
            CE: 1667260800,
            DB: 1677369600,
            EB: 1684454400,
            FB: 1689292800,
            GB: 1697587200,
            HB: 1711497600,
            IB: 1715126400,
            JB: 1717718400,
            K: 1725667200,
            KB: 1746057600,
            LB: 1761264000,
            MB: 1779235200
        }
    },
    Q: {
        A: {
            DE: 0.097344
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "DE",
            "",
            "",
            ""
        ],
        E: "QQ Browser",
        F: {
            DE: 1710288000
        }
    },
    R: {
        A: {
            EE: 0
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "EE",
            "",
            "",
            ""
        ],
        E: "Baidu Browser",
        F: {
            EE: 1710201600
        }
    },
    S: {
        A: {
            FE: 0.005408,
            GE: 0
        },
        B: "moz",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "FE",
            "GE",
            "",
            "",
            ""
        ],
        E: "KaiOS Browser",
        F: {
            FE: 1527811200,
            GE: 1631664000
        }
    }
};


function $87aaf62f5e035055$var$unpackBrowserVersions(versionsData) {
    return Object.keys(versionsData).reduce(function(usage, version) {
        usage[$87aaf62f5e035055$require$versions[version]] = versionsData[version];
        return usage;
    }, {});
}
$87aaf62f5e035055$export$ac5be7df5fa52a3c = Object.keys($f6932f884a325670$exports).reduce(function(map, key) {
    var versionsData = $f6932f884a325670$exports[key];
    map[$87aaf62f5e035055$require$browsers[key]] = Object.keys(versionsData).reduce(function(data, entry) {
        if (entry === 'A') data.usage_global = $87aaf62f5e035055$var$unpackBrowserVersions(versionsData[entry]);
        else if (entry === 'C') data.versions = versionsData[entry].reduce(function(list, version) {
            if (version === '') list.push(null);
            else list.push($87aaf62f5e035055$require$versions[version]);
            return list;
        }, []);
        else if (entry === 'D') data.prefix_exceptions = $87aaf62f5e035055$var$unpackBrowserVersions(versionsData[entry]);
        else if (entry === 'E') data.browser = versionsData[entry];
        else if (entry === 'F') data.release_date = Object.keys(versionsData[entry]).reduce(function(map2, key2) {
            map2[$87aaf62f5e035055$require$versions[key2]] = versionsData[entry][key2];
            return map2;
        }, {});
        else // entry is B
        data.prefix = versionsData[entry];
        return data;
    }, {});
    return map;
}, {});


var $d9eea3283bc93203$require$agents = $87aaf62f5e035055$export$ac5be7df5fa52a3c;
var $b4154b7ae680d931$exports = {};
$b4154b7ae680d931$exports = {
    "0.20": "39",
    "0.21": "41",
    "0.22": "41",
    "0.23": "41",
    "0.24": "41",
    "0.25": "42",
    "0.26": "42",
    "0.27": "43",
    "0.28": "43",
    "0.29": "43",
    "0.30": "44",
    "0.31": "45",
    "0.32": "45",
    "0.33": "45",
    "0.34": "45",
    "0.35": "45",
    "0.36": "47",
    "0.37": "49",
    "1.0": "49",
    "1.1": "50",
    "1.2": "51",
    "1.3": "52",
    "1.4": "53",
    "1.5": "54",
    "1.6": "56",
    "1.7": "58",
    "1.8": "59",
    "2.0": "61",
    "2.1": "61",
    "3.0": "66",
    "3.1": "66",
    "4.0": "69",
    "4.1": "69",
    "4.2": "69",
    "5.0": "73",
    "6.0": "76",
    "6.1": "76",
    "7.0": "78",
    "7.1": "78",
    "7.2": "78",
    "7.3": "78",
    "8.0": "80",
    "8.1": "80",
    "8.2": "80",
    "8.3": "80",
    "8.4": "80",
    "8.5": "80",
    "9.0": "83",
    "9.1": "83",
    "9.2": "83",
    "9.3": "83",
    "9.4": "83",
    "10.0": "85",
    "10.1": "85",
    "10.2": "85",
    "10.3": "85",
    "10.4": "85",
    "11.0": "87",
    "11.1": "87",
    "11.2": "87",
    "11.3": "87",
    "11.4": "87",
    "11.5": "87",
    "12.0": "89",
    "12.1": "89",
    "12.2": "89",
    "13.0": "91",
    "13.1": "91",
    "13.2": "91",
    "13.3": "91",
    "13.4": "91",
    "13.5": "91",
    "13.6": "91",
    "14.0": "93",
    "14.1": "93",
    "14.2": "93",
    "15.0": "94",
    "15.1": "94",
    "15.2": "94",
    "15.3": "94",
    "15.4": "94",
    "15.5": "94",
    "16.0": "96",
    "16.1": "96",
    "16.2": "96",
    "17.0": "98",
    "17.1": "98",
    "17.2": "98",
    "17.3": "98",
    "17.4": "98",
    "18.0": "100",
    "18.1": "100",
    "18.2": "100",
    "18.3": "100",
    "19.0": "102",
    "19.1": "102",
    "20.0": "104",
    "20.1": "104",
    "20.2": "104",
    "20.3": "104",
    "21.0": "106",
    "21.1": "106",
    "21.2": "106",
    "21.3": "106",
    "21.4": "106",
    "22.0": "108",
    "22.1": "108",
    "22.2": "108",
    "22.3": "108",
    "23.0": "110",
    "23.1": "110",
    "23.2": "110",
    "23.3": "110",
    "24.0": "112",
    "24.1": "112",
    "24.2": "112",
    "24.3": "112",
    "24.4": "112",
    "24.5": "112",
    "24.6": "112",
    "24.7": "112",
    "24.8": "112",
    "25.0": "114",
    "25.1": "114",
    "25.2": "114",
    "25.3": "114",
    "25.4": "114",
    "25.5": "114",
    "25.6": "114",
    "25.7": "114",
    "25.8": "114",
    "25.9": "114",
    "26.0": "116",
    "26.1": "116",
    "26.2": "116",
    "26.3": "116",
    "26.4": "116",
    "26.5": "116",
    "26.6": "116",
    "27.0": "118",
    "27.1": "118",
    "27.2": "118",
    "27.3": "118",
    "28.0": "120",
    "28.1": "120",
    "28.2": "120",
    "28.3": "120",
    "29.0": "122",
    "29.1": "122",
    "29.2": "122",
    "29.3": "122",
    "29.4": "122",
    "30.0": "124",
    "30.1": "124",
    "30.2": "124",
    "30.3": "124",
    "30.4": "124",
    "30.5": "124",
    "31.0": "126",
    "31.1": "126",
    "31.2": "126",
    "31.3": "126",
    "31.4": "126",
    "31.5": "126",
    "31.6": "126",
    "31.7": "126",
    "32.0": "128",
    "32.1": "128",
    "32.2": "128",
    "32.3": "128",
    "33.0": "130",
    "33.1": "130",
    "33.2": "130",
    "33.3": "130",
    "33.4": "130",
    "34.0": "132",
    "34.1": "132",
    "34.2": "132",
    "34.3": "132",
    "34.4": "132",
    "34.5": "132",
    "35.0": "134",
    "35.1": "134",
    "35.2": "134",
    "35.3": "134",
    "35.4": "134",
    "35.5": "134",
    "35.6": "134",
    "35.7": "134",
    "36.0": "136",
    "36.1": "136",
    "36.2": "136",
    "36.3": "136",
    "36.4": "136",
    "36.5": "136",
    "36.6": "136",
    "36.7": "136",
    "36.8": "136",
    "36.9": "136",
    "37.0": "138",
    "37.1": "138",
    "37.2": "138",
    "37.3": "138",
    "37.4": "138",
    "37.5": "138",
    "37.6": "138",
    "37.7": "138",
    "37.8": "138",
    "37.9": "138",
    "37.10": "138",
    "38.0": "140",
    "38.1": "140",
    "38.2": "140",
    "38.3": "140",
    "38.4": "140",
    "38.5": "140",
    "38.6": "140",
    "38.7": "140",
    "38.8": "140",
    "39.0": "142",
    "39.1": "142",
    "39.2": "142",
    "39.3": "142",
    "39.4": "142",
    "39.5": "142",
    "39.6": "142",
    "39.7": "142",
    "39.8": "142",
    "40.0": "144",
    "40.1": "144",
    "40.2": "144",
    "40.3": "144",
    "40.4": "144",
    "40.5": "144",
    "40.6": "144",
    "40.7": "144",
    "40.8": "144",
    "40.9": "144",
    "40.10": "144",
    "41.0": "146",
    "41.1": "146",
    "41.2": "146",
    "41.3": "146",
    "41.4": "146",
    "41.5": "146",
    "41.6": "146",
    "41.7": "146",
    "41.8": "146",
    "41.9": "146",
    "41.10": "146",
    "42.0": "148",
    "42.1": "148",
    "42.2": "148",
    "42.3": "148",
    "42.4": "148",
    "42.5": "148",
    "42.6": "148",
    "42.7": "148",
    "42.8": "148",
    "42.9": "148",
    "42.10": "148",
    "42.11": "148",
    "43.0": "150",
    "43.1": "150",
    "43.2": "150",
    "43.3": "150",
    "43.4": "150",
    "43.5": "150",
    "43.6": "150",
    "44.0": "152",
    "44.1": "152",
    "44.2": "152",
    "45.0": "155"
};


var $4efe932a0e00e9fe$exports = {};
$4efe932a0e00e9fe$exports = JSON.parse("{\"v0.8\":{\"start\":\"2012-06-25\",\"end\":\"2014-07-31\"},\"v0.10\":{\"start\":\"2013-03-11\",\"end\":\"2016-10-31\"},\"v0.12\":{\"start\":\"2015-02-06\",\"end\":\"2016-12-31\"},\"v4\":{\"start\":\"2015-09-08\",\"lts\":\"2015-10-12\",\"maintenance\":\"2017-04-01\",\"end\":\"2018-04-30\",\"codename\":\"Argon\"},\"v5\":{\"start\":\"2015-10-29\",\"maintenance\":\"2016-04-30\",\"end\":\"2016-06-30\"},\"v6\":{\"start\":\"2016-04-26\",\"lts\":\"2016-10-18\",\"maintenance\":\"2018-04-30\",\"end\":\"2019-04-30\",\"codename\":\"Boron\"},\"v7\":{\"start\":\"2016-10-25\",\"maintenance\":\"2017-04-30\",\"end\":\"2017-06-30\"},\"v8\":{\"start\":\"2017-05-30\",\"lts\":\"2017-10-31\",\"maintenance\":\"2019-01-01\",\"end\":\"2019-12-31\",\"codename\":\"Carbon\"},\"v9\":{\"start\":\"2017-10-01\",\"maintenance\":\"2018-04-01\",\"end\":\"2018-06-30\"},\"v10\":{\"start\":\"2018-04-24\",\"lts\":\"2018-10-30\",\"maintenance\":\"2020-05-19\",\"end\":\"2021-04-30\",\"codename\":\"Dubnium\"},\"v11\":{\"start\":\"2018-10-23\",\"maintenance\":\"2019-04-22\",\"end\":\"2019-06-01\"},\"v12\":{\"start\":\"2019-04-23\",\"lts\":\"2019-10-21\",\"maintenance\":\"2020-11-30\",\"end\":\"2022-04-30\",\"codename\":\"Erbium\"},\"v13\":{\"start\":\"2019-10-22\",\"maintenance\":\"2020-04-01\",\"end\":\"2020-06-01\"},\"v14\":{\"start\":\"2020-04-21\",\"lts\":\"2020-10-27\",\"maintenance\":\"2021-10-19\",\"end\":\"2023-04-30\",\"codename\":\"Fermium\"},\"v15\":{\"start\":\"2020-10-20\",\"maintenance\":\"2021-04-01\",\"end\":\"2021-06-01\"},\"v16\":{\"start\":\"2021-04-20\",\"lts\":\"2021-10-26\",\"maintenance\":\"2022-10-18\",\"end\":\"2023-09-11\",\"codename\":\"Gallium\"},\"v17\":{\"start\":\"2021-10-19\",\"maintenance\":\"2022-04-01\",\"end\":\"2022-06-01\"},\"v18\":{\"start\":\"2022-04-19\",\"lts\":\"2022-10-25\",\"maintenance\":\"2023-10-18\",\"end\":\"2025-04-30\",\"codename\":\"Hydrogen\"},\"v19\":{\"start\":\"2022-10-18\",\"maintenance\":\"2023-04-01\",\"end\":\"2023-06-01\"},\"v20\":{\"start\":\"2023-04-18\",\"lts\":\"2023-10-24\",\"maintenance\":\"2024-10-22\",\"end\":\"2026-04-30\",\"codename\":\"Iron\"},\"v21\":{\"start\":\"2023-10-17\",\"maintenance\":\"2024-04-01\",\"end\":\"2024-06-01\"},\"v22\":{\"start\":\"2024-04-24\",\"lts\":\"2024-10-29\",\"maintenance\":\"2025-10-21\",\"end\":\"2027-04-30\",\"codename\":\"Jod\"},\"v23\":{\"start\":\"2024-10-16\",\"maintenance\":\"2025-04-01\",\"end\":\"2025-06-01\"},\"v24\":{\"start\":\"2025-05-06\",\"lts\":\"2025-10-28\",\"maintenance\":\"2026-10-20\",\"end\":\"2028-04-30\",\"codename\":\"Krypton\"},\"v25\":{\"start\":\"2025-10-15\",\"maintenance\":\"2026-04-01\",\"end\":\"2026-06-01\"},\"v26\":{\"start\":\"2026-05-05\",\"lts\":\"2026-10-28\",\"maintenance\":\"2027-10-20\",\"end\":\"2029-04-30\",\"codename\":\"\"},\"v27\":{\"alpha\":\"2026-10-28\",\"start\":\"2027-04-22\",\"maintenance\":\"2027-10-20\",\"end\":\"2030-04-30\",\"codename\":\"\"}}");



var $BMbiM = parcelRequire("BMbiM");
var $040711a52d9f0b35$exports = {};
function $040711a52d9f0b35$var$BrowserslistError(message) {
    this.name = 'BrowserslistError';
    this.message = message;
    this.browserslist = true;
    if (Error.captureStackTrace) Error.captureStackTrace(this, $040711a52d9f0b35$var$BrowserslistError);
}
$040711a52d9f0b35$var$BrowserslistError.prototype = Error.prototype;
$040711a52d9f0b35$exports = $040711a52d9f0b35$var$BrowserslistError;


var $340071140e5bd8fe$exports = {};

function $340071140e5bd8fe$var$noop() {}
$340071140e5bd8fe$exports = {
    loadQueries: function loadQueries() {
        throw new $040711a52d9f0b35$exports('Sharable configs are not supported in client-side build of Browserslist');
    },
    getStat: function getStat(opts) {
        return opts.stats;
    },
    loadConfig: function loadConfig(opts) {
        if (opts.config) throw new $040711a52d9f0b35$exports('Browserslist config are not supported in client-side build');
    },
    loadCountry: function loadCountry() {
        throw new $040711a52d9f0b35$exports("Country statistics are not supported in client-side build of Browserslist");
    },
    loadFeature: function loadFeature() {
        throw new $040711a52d9f0b35$exports('Supports queries are not available in client-side build of Browserslist');
    },
    currentNode: function currentNode(resolve, context) {
        return resolve([
            'maintained node versions'
        ], context)[0];
    },
    parseConfig: $340071140e5bd8fe$var$noop,
    readConfig: $340071140e5bd8fe$var$noop,
    findConfig: $340071140e5bd8fe$var$noop,
    findConfigFile: $340071140e5bd8fe$var$noop,
    clearCaches: $340071140e5bd8fe$var$noop,
    oldDataWarning: $340071140e5bd8fe$var$noop,
    env: {}
};


var $9080d7a0ef2c9c32$exports = {};
var $9080d7a0ef2c9c32$var$SPACE = /\s/;
function $9080d7a0ef2c9c32$var$flatten(array) {
    if (!Array.isArray(array)) return [
        array
    ];
    // Iterative flatten: `reduce`+`concat` copies the accumulator on every step,
    // which is O(n²) once a query resolves to many nodes.
    var result = [];
    var stack = [
        array
    ];
    while(stack.length){
        var item = stack.pop();
        if (Array.isArray(item)) for(var i = item.length - 1; i >= 0; i--)stack.push(item[i]);
        else result.push(item);
    }
    return result;
}
function $9080d7a0ef2c9c32$var$matchQuery(all, query) {
    var node = {
        query: query
    };
    if (query.indexOf('not ') === 0) {
        node.not = true;
        query = query.slice(4);
    }
    for(var name in all){
        var type = all[name];
        var match = query.match(type.regexp);
        if (match) {
            node.type = name;
            for(var i = 0; i < type.matches.length; i++)node[type.matches[i]] = match[i + 1];
            return node;
        }
    }
    node.type = 'unknown';
    return node;
}
function $9080d7a0ef2c9c32$var$pushClause(all, qs, text, compose) {
    var node = $9080d7a0ef2c9c32$var$matchQuery(all, text.trim());
    node.compose = compose;
    qs.push(node);
}
// Splits a query block into clauses on the `\s+and\s+`, `\s+or\s+` and `,\s*`
// delimiters in a single left-to-right pass. The previous implementation grew
// a suffix one character at a time and re-tested anchored `\s+…` regexps at
// every length, which backtracks across whitespace runs and is O(n²) — a
// small padded query could freeze the event loop for tens of seconds.
function $9080d7a0ef2c9c32$var$parseBlock(all, block, qs) {
    if (block.length === 0) return;
    var len = block.length;
    var clauseStart = 0;
    // Compose for the clause currently being read; the leftmost clause is `or`.
    var compose = 'or';
    var i = 0;
    while(i < len){
        var ch = block[i];
        if (ch === ',') {
            // `,\s*` delimiter. A delimiter at the very start (i === 0) has no left
            // clause — the original never emits one there.
            if (i !== 0) $9080d7a0ef2c9c32$var$pushClause(all, qs, block.slice(clauseStart, i), compose);
            i++;
            while(i < len && $9080d7a0ef2c9c32$var$SPACE.test(block[i]))i++;
            compose = 'or';
            clauseStart = i;
            continue;
        }
        if ($9080d7a0ef2c9c32$var$SPACE.test(ch)) {
            // Possible `\s+and\s+` or `\s+or\s+`. Scan the whitespace run once
            // (linear, no backtracking), then check the following keyword.
            var q = i;
            while(q < len && $9080d7a0ef2c9c32$var$SPACE.test(block[q]))q++;
            if (q + 3 < len && (block[q] === 'a' || block[q] === 'A') && (block[q + 1] === 'n' || block[q + 1] === 'N') && (block[q + 2] === 'd' || block[q + 2] === 'D') && $9080d7a0ef2c9c32$var$SPACE.test(block[q + 3])) {
                // The leading `\s+` of `\s+and\s+` absorbs whitespace at the block
                // start, so a delimiter at i === 0 has no left clause.
                if (i !== 0) $9080d7a0ef2c9c32$var$pushClause(all, qs, block.slice(clauseStart, i), compose);
                var afterAnd = q + 3;
                while(afterAnd < len && $9080d7a0ef2c9c32$var$SPACE.test(block[afterAnd]))afterAnd++;
                compose = 'and';
                i = afterAnd;
                clauseStart = afterAnd;
                continue;
            } else if (q + 2 < len && (block[q] === 'o' || block[q] === 'O') && (block[q + 1] === 'r' || block[q + 1] === 'R') && $9080d7a0ef2c9c32$var$SPACE.test(block[q + 2])) {
                if (i !== 0) $9080d7a0ef2c9c32$var$pushClause(all, qs, block.slice(clauseStart, i), compose);
                var afterOr = q + 2;
                while(afterOr < len && $9080d7a0ef2c9c32$var$SPACE.test(block[afterOr]))afterOr++;
                compose = 'or';
                i = afterOr;
                clauseStart = afterOr;
                continue;
            } else {
                // Whitespace inside a clause; skip the run and keep reading.
                i = q;
                continue;
            }
        }
        i++;
    }
    $9080d7a0ef2c9c32$var$pushClause(all, qs, block.slice(clauseStart), compose);
}
$9080d7a0ef2c9c32$exports = function parse(all, queries) {
    if (!Array.isArray(queries)) queries = [
        queries
    ];
    return $9080d7a0ef2c9c32$var$flatten(queries.map(function(block) {
        var qs = [];
        $9080d7a0ef2c9c32$var$parseBlock(all, block, qs);
        return qs;
    }));
};


var $d9eea3283bc93203$var$YEAR = 365.259641 * 86400000;
var $d9eea3283bc93203$var$ANDROID_EVERGREEN_FIRST = '37';
var $d9eea3283bc93203$var$OP_MOB_BLINK_FIRST = 14;
var $d9eea3283bc93203$var$FIREFOX_ESR_VERSION = '140';
// Helpers
function $d9eea3283bc93203$var$isVersionsMatch(versionA, versionB) {
    return (versionA + '.').indexOf(versionB + '.') === 0;
}
function $d9eea3283bc93203$var$isEolReleased(name) {
    var version = name.slice(1);
    return $d9eea3283bc93203$var$browserslist.nodeVersions.some(function(i) {
        return $d9eea3283bc93203$var$isVersionsMatch(i, version);
    });
}
function $d9eea3283bc93203$var$normalize(versions) {
    return versions.filter(function(version) {
        return typeof version === 'string';
    });
}
function $d9eea3283bc93203$var$normalizeElectron(version) {
    var versionToUse = version;
    if (version.split('.').length === 3) versionToUse = version.split('.').slice(0, -1).join('.');
    return versionToUse;
}
function $d9eea3283bc93203$var$nameMapper(name) {
    return function mapName(version) {
        return name + ' ' + version;
    };
}
function $d9eea3283bc93203$var$getMajor(version) {
    return parseInt(version.split('.')[0]);
}
function $d9eea3283bc93203$var$getMajorVersions(released, number) {
    if (released.length === 0) return [];
    var majorVersions = $d9eea3283bc93203$var$uniq(released.map($d9eea3283bc93203$var$getMajor));
    var minimum = majorVersions[majorVersions.length - number];
    if (!minimum) return released;
    var selected = [];
    for(var i = released.length - 1; i >= 0; i--){
        if (minimum > $d9eea3283bc93203$var$getMajor(released[i])) break;
        selected.unshift(released[i]);
    }
    return selected;
}
function $d9eea3283bc93203$var$uniq(array) {
    var filtered = [];
    for(var i = 0; i < array.length; i++)if (filtered.indexOf(array[i]) === -1) filtered.push(array[i]);
    return filtered;
}
function $d9eea3283bc93203$var$fillUsage(result, name, data) {
    for(var i in data)result[name + ' ' + i] = data[i];
}
function $d9eea3283bc93203$var$generateFilter(sign, version) {
    if (sign === '>') return function(v) {
        return parseLatestFloat(v) > parseLatestFloat(version);
    };
    else if (sign === '>=') return function(v) {
        return parseLatestFloat(v) >= parseLatestFloat(version);
    };
    else if (sign === '<') return function(v) {
        return parseFloat(v) < parseFloat(version);
    };
    else return function(v) {
        return parseFloat(v) <= parseFloat(version);
    };
    function parseLatestFloat(v) {
        return parseFloat(v.split('-')[1] || v);
    }
}
function $d9eea3283bc93203$var$generateSemverFilter(sign, version) {
    version = version.split('.').map($d9eea3283bc93203$var$parseSimpleInt);
    version[1] = version[1] || 0;
    version[2] = version[2] || 0;
    if (sign === '>') return function(v) {
        v = v.split('.').map($d9eea3283bc93203$var$parseSimpleInt);
        return $d9eea3283bc93203$var$compareSemver(v, version) > 0;
    };
    else if (sign === '>=') return function(v) {
        v = v.split('.').map($d9eea3283bc93203$var$parseSimpleInt);
        return $d9eea3283bc93203$var$compareSemver(v, version) >= 0;
    };
    else if (sign === '<') return function(v) {
        v = v.split('.').map($d9eea3283bc93203$var$parseSimpleInt);
        return $d9eea3283bc93203$var$compareSemver(version, v) > 0;
    };
    else return function(v) {
        v = v.split('.').map($d9eea3283bc93203$var$parseSimpleInt);
        return $d9eea3283bc93203$var$compareSemver(version, v) >= 0;
    };
}
function $d9eea3283bc93203$var$parseSimpleInt(x) {
    return parseInt(x);
}
function $d9eea3283bc93203$var$compare(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}
function $d9eea3283bc93203$var$compareSemver(a, b) {
    return $d9eea3283bc93203$var$compare(parseInt(a[0]), parseInt(b[0])) || $d9eea3283bc93203$var$compare(parseInt(a[1] || '0'), parseInt(b[1] || '0')) || $d9eea3283bc93203$var$compare(parseInt(a[2] || '0'), parseInt(b[2] || '0'));
}
// this follows the npm-like semver behavior
function $d9eea3283bc93203$var$semverFilterLoose(operator, range) {
    range = range.split('.').map($d9eea3283bc93203$var$parseSimpleInt);
    if (typeof range[1] === 'undefined') range[1] = 'x';
    // ignore any patch version because we only return minor versions
    // range[2] = 'x'
    switch(operator){
        case '<=':
            return function(version) {
                version = version.split('.').map($d9eea3283bc93203$var$parseSimpleInt);
                return $d9eea3283bc93203$var$compareSemverLoose(version, range) <= 0;
            };
        case '>=':
        default:
            return function(version) {
                version = version.split('.').map($d9eea3283bc93203$var$parseSimpleInt);
                return $d9eea3283bc93203$var$compareSemverLoose(version, range) >= 0;
            };
    }
}
// this follows the npm-like semver behavior
function $d9eea3283bc93203$var$compareSemverLoose(version, range) {
    if (version[0] !== range[0]) return version[0] < range[0] ? -1 : 1;
    if (range[1] === 'x') return 0;
    if (version[1] !== range[1]) return version[1] < range[1] ? -1 : 1;
    return 0;
}
function $d9eea3283bc93203$var$resolveVersion(data, version) {
    if (data.versions.indexOf(version) !== -1) return version;
    else if ($d9eea3283bc93203$var$browserslist.versionAliases[data.name][version]) return $d9eea3283bc93203$var$browserslist.versionAliases[data.name][version];
    else return false;
}
function $d9eea3283bc93203$var$normalizeVersion(data, version) {
    var resolved = $d9eea3283bc93203$var$resolveVersion(data, version);
    if (resolved) return resolved;
    else if (data.versions.length === 1) return data.versions[0];
    else return false;
}
function $d9eea3283bc93203$var$filterByYear(since, context) {
    since = since / 1000;
    return Object.keys($d9eea3283bc93203$require$agents).reduce(function(selected, name) {
        var data = $d9eea3283bc93203$var$byName(name, context);
        if (!data) return selected;
        var versions = Object.keys(data.releaseDate).filter(function(v) {
            var date = data.releaseDate[v];
            return date !== null && date >= since;
        });
        return selected.concat(versions.map($d9eea3283bc93203$var$nameMapper(data.name)));
    }, []);
}
function $d9eea3283bc93203$var$cloneData(data) {
    return {
        name: data.name,
        versions: data.versions,
        released: data.released,
        releaseDate: data.releaseDate
    };
}
function $d9eea3283bc93203$var$byName(name, context) {
    name = name.toLowerCase();
    name = $d9eea3283bc93203$var$browserslist.aliases[name] || name;
    if (context.mobileToDesktop && $d9eea3283bc93203$var$browserslist.desktopNames[name]) {
        var desktop = $d9eea3283bc93203$var$browserslist.data[$d9eea3283bc93203$var$browserslist.desktopNames[name]];
        if (name === 'android') return $d9eea3283bc93203$var$normalizeAndroidData($d9eea3283bc93203$var$cloneData($d9eea3283bc93203$var$browserslist.data[name]), desktop);
        else {
            var cloned = $d9eea3283bc93203$var$cloneData(desktop);
            cloned.name = name;
            return cloned;
        }
    }
    return $d9eea3283bc93203$var$browserslist.data[name];
}
function $d9eea3283bc93203$var$normalizeAndroidVersions(androidVersions, chromeVersions) {
    var iFirstEvergreen = chromeVersions.indexOf($d9eea3283bc93203$var$ANDROID_EVERGREEN_FIRST);
    return androidVersions.filter(function(version) {
        return /^(?:[2-4]\.|[34]$)/.test(version);
    }).concat(chromeVersions.slice(iFirstEvergreen));
}
var $d9eea3283bc93203$var$DANGEROUS_KEYS = [
    '__proto__',
    'constructor',
    'prototype'
];
function $d9eea3283bc93203$var$copyObject(obj) {
    var copy = {};
    for(var key in obj)if ($d9eea3283bc93203$var$DANGEROUS_KEYS.indexOf(key) === -1) copy[key] = obj[key];
    return copy;
}
function $d9eea3283bc93203$var$normalizeAndroidData(android, chrome) {
    android.released = $d9eea3283bc93203$var$normalizeAndroidVersions(android.released, chrome.released);
    android.versions = $d9eea3283bc93203$var$normalizeAndroidVersions(android.versions, chrome.versions);
    android.releaseDate = $d9eea3283bc93203$var$copyObject(android.releaseDate);
    android.released.forEach(function(v) {
        if (android.releaseDate[v] === undefined) android.releaseDate[v] = chrome.releaseDate[v];
    });
    return android;
}
function $d9eea3283bc93203$var$checkName(name, context) {
    var data = $d9eea3283bc93203$var$byName(name, context);
    if (!data) throw new $040711a52d9f0b35$exports('Unknown browser ' + name);
    return data;
}
function $d9eea3283bc93203$var$unknownQuery(query) {
    return new $040711a52d9f0b35$exports('Unknown browser query `' + query + '`. ' + 'Maybe you are using old Browserslist or made typo in query.');
}
// Adjusts last X versions queries for some mobile browsers,
// where caniuse data jumps from a legacy version to the latest
function $d9eea3283bc93203$var$filterJumps(list, name, nVersions, context) {
    var jump = 1;
    switch(name){
        case 'android':
            if (context.mobileToDesktop) return list;
            var released = $d9eea3283bc93203$var$browserslist.data.chrome.released;
            jump = released.length - released.indexOf($d9eea3283bc93203$var$ANDROID_EVERGREEN_FIRST);
            break;
        case 'op_mob':
            var latest = $d9eea3283bc93203$var$browserslist.data.op_mob.released.slice(-1)[0];
            jump = $d9eea3283bc93203$var$getMajor(latest) - $d9eea3283bc93203$var$OP_MOB_BLINK_FIRST + 1;
            break;
        default:
            return list;
    }
    if (nVersions <= jump) return list.slice(-1);
    return list.slice(jump - 1 - nVersions);
}
function $d9eea3283bc93203$var$isSupported(flags, withPartial) {
    return typeof flags === 'string' && (flags.indexOf('y') >= 0 || withPartial && flags.indexOf('a') >= 0);
}
function $d9eea3283bc93203$var$resolve(queries, context) {
    return $d9eea3283bc93203$var$parseQueries(queries).reduce(function(result, node, index) {
        if (node.not && index === 0) throw new $040711a52d9f0b35$exports("Write any browsers query (for instance, `defaults`) before `" + node.query + '`');
        var type = $d9eea3283bc93203$var$QUERIES[node.type];
        var array = type.select.call($d9eea3283bc93203$var$browserslist, context, node).map(function(j) {
            var parts = j.split(' ');
            if (parts[1] === '0') return parts[0] + ' ' + $d9eea3283bc93203$var$byName(parts[0], context).versions[0];
            else return j;
        });
        if (node.compose === 'and') {
            if (node.not) return result.filter(function(j) {
                return array.indexOf(j) === -1;
            });
            else return result.filter(function(j) {
                return array.indexOf(j) !== -1;
            });
        } else {
            if (node.not) {
                var filter = {};
                array.forEach(function(j) {
                    filter[j] = true;
                });
                return result.filter(function(j) {
                    return !filter[j];
                });
            }
            for(var i = 0; i < array.length; i++)result.push(array[i]);
            return result;
        }
    }, []);
}
function $d9eea3283bc93203$var$prepareOpts(opts) {
    if (typeof opts === 'undefined') opts = {};
    if (typeof opts.path === 'undefined') opts.path = $BMbiM.resolve ? $BMbiM.resolve('.') : '.';
    return opts;
}
function $d9eea3283bc93203$var$prepareQueries(queries, opts) {
    if (typeof queries === 'undefined' || queries === null) {
        var config = $d9eea3283bc93203$var$browserslist.loadConfig(opts);
        if (config) queries = config;
        else queries = $d9eea3283bc93203$var$browserslist.defaults;
    }
    return queries;
}
function $d9eea3283bc93203$var$checkQueries(queries) {
    if (!(typeof queries === 'string' || Array.isArray(queries))) throw new $040711a52d9f0b35$exports('Browser queries must be an array or string. Got ' + (typeof queries === "undefined" ? "undefined" : (0, $2bfPH._)(queries)) + '.');
}
var $d9eea3283bc93203$var$CACHE_MAX_ENTRIES = 500;
function $d9eea3283bc93203$var$boundedCacheSet(map, key, value) {
    if (map.size >= $d9eea3283bc93203$var$CACHE_MAX_ENTRIES) map.delete(map.keys().next().value);
    map.set(key, value);
}
var $d9eea3283bc93203$var$cache = new Map();
var $d9eea3283bc93203$var$parseCache = new Map();
function $d9eea3283bc93203$var$browserslist(queries, opts) {
    opts = $d9eea3283bc93203$var$prepareOpts(opts);
    queries = $d9eea3283bc93203$var$prepareQueries(queries, opts);
    $d9eea3283bc93203$var$checkQueries(queries);
    var needsPath = $d9eea3283bc93203$var$parseQueries(queries).some(function(node) {
        return $d9eea3283bc93203$var$QUERIES[node.type].needsPath;
    });
    var context = {
        ignoreUnknownVersions: opts.ignoreUnknownVersions,
        dangerousExtend: opts.dangerousExtend,
        throwOnMissing: opts.throwOnMissing,
        mobileToDesktop: opts.mobileToDesktop,
        env: opts.env
    };
    // Removing to avoid using context.path without marking query as needsPath
    if (needsPath) context.path = opts.path;
    $340071140e5bd8fe$exports.oldDataWarning($d9eea3283bc93203$var$browserslist.data);
    var stats = $340071140e5bd8fe$exports.getStat(opts, $d9eea3283bc93203$var$browserslist.data);
    if (stats) {
        context.customUsage = {};
        for(var browser in stats)$d9eea3283bc93203$var$fillUsage(context.customUsage, browser, stats[browser]);
    }
    var cacheKey = JSON.stringify([
        queries,
        context
    ]);
    if ($d9eea3283bc93203$var$cache.has(cacheKey)) return $d9eea3283bc93203$var$cache.get(cacheKey);
    var result = $d9eea3283bc93203$var$uniq($d9eea3283bc93203$var$resolve(queries, context)).sort(function(name1, name2) {
        name1 = name1.split(' ');
        name2 = name2.split(' ');
        if (name1[0] === name2[0]) {
            // assumptions on caniuse data
            // 1) version ranges never overlaps
            // 2) if version is not a range, it never contains `-`
            var version1 = name1[1].split('-')[0];
            var version2 = name2[1].split('-')[0];
            return $d9eea3283bc93203$var$compareSemver(version2.split('.'), version1.split('.'));
        } else return $d9eea3283bc93203$var$compare(name1[0], name2[0]);
    });
    if (!$340071140e5bd8fe$exports.env.BROWSERSLIST_DISABLE_CACHE) $d9eea3283bc93203$var$boundedCacheSet($d9eea3283bc93203$var$cache, cacheKey, result);
    return result;
}
function $d9eea3283bc93203$var$parseQueries(queries) {
    var cacheKey = JSON.stringify(queries);
    if ($d9eea3283bc93203$var$parseCache.has(cacheKey)) return $d9eea3283bc93203$var$parseCache.get(cacheKey);
    var result = $9080d7a0ef2c9c32$exports($d9eea3283bc93203$var$QUERIES, queries);
    if (!$340071140e5bd8fe$exports.env.BROWSERSLIST_DISABLE_CACHE) $d9eea3283bc93203$var$boundedCacheSet($d9eea3283bc93203$var$parseCache, cacheKey, result);
    return result;
}
function $d9eea3283bc93203$var$loadCustomUsage(context, config) {
    var stats = $340071140e5bd8fe$exports.loadStat(context, config, $d9eea3283bc93203$var$browserslist.data);
    if (stats) {
        context.customUsage = {};
        for(var browser in stats)$d9eea3283bc93203$var$fillUsage(context.customUsage, browser, stats[browser]);
    }
    if (!context.customUsage) throw new $040711a52d9f0b35$exports('Custom usage statistics was not provided');
    return context.customUsage;
}
$d9eea3283bc93203$var$browserslist.parse = function(queries, opts) {
    opts = $d9eea3283bc93203$var$prepareOpts(opts);
    queries = $d9eea3283bc93203$var$prepareQueries(queries, opts);
    $d9eea3283bc93203$var$checkQueries(queries);
    return $d9eea3283bc93203$var$parseQueries(queries);
};
// Will be filled by Can I Use data below
$d9eea3283bc93203$var$browserslist.cache = {};
$d9eea3283bc93203$var$browserslist.data = {};
$d9eea3283bc93203$var$browserslist.usage = {
    global: {},
    custom: null
};
// Default browsers query
$d9eea3283bc93203$var$browserslist.defaults = [
    '> 0.5%',
    'last 2 versions',
    'Firefox ESR',
    'not dead'
];
// Browser names aliases
$d9eea3283bc93203$var$browserslist.aliases = {
    fx: 'firefox',
    ff: 'firefox',
    ios: 'ios_saf',
    explorer: 'ie',
    blackberry: 'bb',
    explorermobile: 'ie_mob',
    operamini: 'op_mini',
    operamobile: 'op_mob',
    chromeandroid: 'and_chr',
    firefoxandroid: 'and_ff',
    ucandroid: 'and_uc',
    qqandroid: 'and_qq'
};
// Can I Use only provides a few versions for some browsers (e.g. and_chr).
// Fallback to a similar browser for unknown versions
// Note op_mob is not included as its chromium versions are not in sync with Opera desktop
$d9eea3283bc93203$var$browserslist.desktopNames = {
    and_chr: 'chrome',
    and_ff: 'firefox',
    ie_mob: 'ie',
    android: 'chrome' // has extra processing logic
};
// Aliases to work with joined versions like `ios_saf 7.0-7.1`
$d9eea3283bc93203$var$browserslist.versionAliases = {};
$d9eea3283bc93203$var$browserslist.clearCaches = $340071140e5bd8fe$exports.clearCaches;
$d9eea3283bc93203$var$browserslist.parseConfig = $340071140e5bd8fe$exports.parseConfig;
$d9eea3283bc93203$var$browserslist.readConfig = $340071140e5bd8fe$exports.readConfig;
$d9eea3283bc93203$var$browserslist.findConfigFile = $340071140e5bd8fe$exports.findConfigFile;
$d9eea3283bc93203$var$browserslist.findConfig = $340071140e5bd8fe$exports.findConfig;
$d9eea3283bc93203$var$browserslist.loadConfig = $340071140e5bd8fe$exports.loadConfig;
$d9eea3283bc93203$var$browserslist.coverage = function(browsers, stats) {
    var data;
    if (typeof stats === 'undefined') data = $d9eea3283bc93203$var$browserslist.usage.global;
    else if (stats === 'my stats') {
        var opts = {};
        opts.path = $BMbiM.resolve ? $BMbiM.resolve('.') : '.';
        var customStats = $340071140e5bd8fe$exports.getStat(opts);
        if (!customStats) throw new $040711a52d9f0b35$exports('Custom usage statistics was not provided');
        data = {};
        for(var browser in customStats)$d9eea3283bc93203$var$fillUsage(data, browser, customStats[browser]);
    } else if (typeof stats === 'string') {
        if (stats.length > 2) stats = stats.toLowerCase();
        else stats = stats.toUpperCase();
        $340071140e5bd8fe$exports.loadCountry($d9eea3283bc93203$var$browserslist.usage, stats, $d9eea3283bc93203$var$browserslist.data);
        data = $d9eea3283bc93203$var$browserslist.usage[stats];
    } else {
        if ('dataByBrowser' in stats) stats = stats.dataByBrowser;
        data = {};
        for(var name in stats)for(var version in stats[name])data[name + ' ' + version] = stats[name][version];
    }
    return browsers.reduce(function(all, i) {
        var usage = data[i];
        if (usage === undefined) usage = data[i.replace(/ \S+$/, ' 0')];
        return all + (usage || 0);
    }, 0);
};
function $d9eea3283bc93203$var$nodeQuery(context, node) {
    var matched = $d9eea3283bc93203$var$browserslist.nodeVersions.filter(function(i) {
        return $d9eea3283bc93203$var$isVersionsMatch(i, node.version);
    });
    if (matched.length === 0) {
        if (context.ignoreUnknownVersions) return [];
        else throw new $040711a52d9f0b35$exports('Unknown version ' + node.version + ' of Node.js');
    }
    return [
        'node ' + matched[matched.length - 1]
    ];
}
function $d9eea3283bc93203$var$sinceQuery(context, node) {
    var year = parseInt(node.year);
    var month = parseInt(node.month || '01') - 1;
    var day = parseInt(node.day || '01');
    return $d9eea3283bc93203$var$filterByYear(Date.UTC(year, month, day, 0, 0, 0), context);
}
function $d9eea3283bc93203$var$bbmTransform(bbmVersions) {
    var browsers = {
        chrome: 'chrome',
        chrome_android: 'and_chr',
        edge: 'edge',
        firefox: 'firefox',
        firefox_android: 'and_ff',
        safari: 'safari',
        safari_ios: 'ios_saf',
        webview_android: 'android',
        samsunginternet_android: 'samsung',
        opera_android: 'op_mob',
        opera: 'opera',
        qq_android: 'and_qq',
        uc_android: 'and_uc',
        kai_os: 'kaios'
    };
    return bbmVersions.filter(function(version) {
        return Object.keys(browsers).indexOf(version.browser) !== -1;
    }).map(function(version) {
        return browsers[version.browser] + ' >= ' + version.version;
    });
}
function $d9eea3283bc93203$var$coverQuery(context, node) {
    var coverage = parseFloat(node.coverage);
    var usage = $d9eea3283bc93203$var$browserslist.usage.global;
    if (node.place) {
        if (node.place.match(/^my\s+stats$/i)) {
            if (!context.customUsage) throw new $040711a52d9f0b35$exports('Custom usage statistics was not provided');
            usage = context.customUsage;
        } else {
            var place;
            if (node.place.length === 2) place = node.place.toUpperCase();
            else place = node.place.toLowerCase();
            $340071140e5bd8fe$exports.loadCountry($d9eea3283bc93203$var$browserslist.usage, place, $d9eea3283bc93203$var$browserslist.data);
            usage = $d9eea3283bc93203$var$browserslist.usage[place];
        }
    } else if (node.config) usage = $d9eea3283bc93203$var$loadCustomUsage(context, node.config);
    var versions = Object.keys(usage).sort(function(a, b) {
        return usage[b] - usage[a];
    });
    var covered = 0;
    var result = [];
    var version;
    for(var i = 0; i < versions.length; i++){
        version = versions[i];
        if (usage[version] === 0) break;
        covered += usage[version];
        result.push(version);
        if (covered >= coverage) break;
    }
    return result;
}
var $d9eea3283bc93203$var$QUERIES = {
    last_major_versions: {
        matches: [
            'versions'
        ],
        regexp: /^last\s+(\d+)\s+major\s+versions?$/i,
        select: function select(context, node) {
            return Object.keys($d9eea3283bc93203$require$agents).reduce(function(selected, name) {
                var data = $d9eea3283bc93203$var$byName(name, context);
                if (!data) return selected;
                var list = $d9eea3283bc93203$var$getMajorVersions(data.released, node.versions);
                list = list.map($d9eea3283bc93203$var$nameMapper(data.name));
                list = $d9eea3283bc93203$var$filterJumps(list, data.name, node.versions, context);
                return selected.concat(list);
            }, []);
        }
    },
    last_versions: {
        matches: [
            'versions'
        ],
        regexp: /^last\s+(\d+)\s+versions?$/i,
        select: function select(context, node) {
            return Object.keys($d9eea3283bc93203$require$agents).reduce(function(selected, name) {
                var data = $d9eea3283bc93203$var$byName(name, context);
                if (!data) return selected;
                var list = data.released.slice(-node.versions);
                list = list.map($d9eea3283bc93203$var$nameMapper(data.name));
                list = $d9eea3283bc93203$var$filterJumps(list, data.name, node.versions, context);
                return selected.concat(list);
            }, []);
        }
    },
    last_electron_major_versions: {
        matches: [
            'versions'
        ],
        regexp: /^last\s+(\d+)\s+electron\s+major\s+versions?$/i,
        select: function select(context, node) {
            var validVersions = $d9eea3283bc93203$var$getMajorVersions(Object.keys($b4154b7ae680d931$exports), node.versions);
            return validVersions.map(function(i) {
                return 'chrome ' + $b4154b7ae680d931$exports[i];
            });
        }
    },
    last_node_major_versions: {
        matches: [
            'versions'
        ],
        regexp: /^last\s+(\d+)\s+node\s+major\s+versions?$/i,
        select: function select(context, node) {
            return $d9eea3283bc93203$var$getMajorVersions($d9eea3283bc93203$var$browserslist.nodeVersions, node.versions).map(function(version) {
                return 'node ' + version;
            });
        }
    },
    last_browser_major_versions: {
        matches: [
            'versions',
            'browser'
        ],
        regexp: /^last\s+(\d+)\s+(\w+)\s+major\s+versions?$/i,
        select: function select(context, node) {
            var data = $d9eea3283bc93203$var$checkName(node.browser, context);
            var validVersions = $d9eea3283bc93203$var$getMajorVersions(data.released, node.versions);
            var list = validVersions.map($d9eea3283bc93203$var$nameMapper(data.name));
            list = $d9eea3283bc93203$var$filterJumps(list, data.name, node.versions, context);
            return list;
        }
    },
    last_electron_versions: {
        matches: [
            'versions'
        ],
        regexp: /^last\s+(\d+)\s+electron\s+versions?$/i,
        select: function select(context, node) {
            return Object.keys($b4154b7ae680d931$exports).slice(-node.versions).map(function(i) {
                return 'chrome ' + $b4154b7ae680d931$exports[i];
            });
        }
    },
    last_node_versions: {
        matches: [
            'versions'
        ],
        regexp: /^last\s+(\d+)\s+node\s+versions?$/i,
        select: function select(context, node) {
            return $d9eea3283bc93203$var$browserslist.nodeVersions.slice(-node.versions).map(function(version) {
                return 'node ' + version;
            });
        }
    },
    last_browser_versions: {
        matches: [
            'versions',
            'browser'
        ],
        regexp: /^last\s+(\d+)\s+(\w+)\s+versions?$/i,
        select: function select(context, node) {
            var data = $d9eea3283bc93203$var$checkName(node.browser, context);
            var list = data.released.slice(-node.versions).map($d9eea3283bc93203$var$nameMapper(data.name));
            list = $d9eea3283bc93203$var$filterJumps(list, data.name, node.versions, context);
            return list;
        }
    },
    unreleased_versions: {
        matches: [],
        regexp: /^unreleased\s+versions$/i,
        select: function select(context) {
            return Object.keys($d9eea3283bc93203$require$agents).reduce(function(selected, name) {
                var data = $d9eea3283bc93203$var$byName(name, context);
                if (!data) return selected;
                var list = data.versions.filter(function(v) {
                    return data.released.indexOf(v) === -1;
                });
                list = list.map($d9eea3283bc93203$var$nameMapper(data.name));
                return selected.concat(list);
            }, []);
        }
    },
    unreleased_electron_versions: {
        matches: [],
        regexp: /^unreleased\s+electron\s+versions?$/i,
        select: function select() {
            return [];
        }
    },
    unreleased_browser_versions: {
        matches: [
            'browser'
        ],
        regexp: /^unreleased\s+(\w+)\s+versions?$/i,
        select: function select(context, node) {
            var data = $d9eea3283bc93203$var$checkName(node.browser, context);
            return data.versions.filter(function(v) {
                return data.released.indexOf(v) === -1;
            }).map($d9eea3283bc93203$var$nameMapper(data.name));
        }
    },
    last_years: {
        matches: [
            'years'
        ],
        regexp: /^last\s+((\d+\.)?\d+)\s+years?$/i,
        select: function select(context, node) {
            return $d9eea3283bc93203$var$filterByYear(Date.now() - $d9eea3283bc93203$var$YEAR * node.years, context);
        }
    },
    since_y: {
        matches: [
            'year'
        ],
        regexp: /^since (\d+)$/i,
        select: $d9eea3283bc93203$var$sinceQuery
    },
    since_y_m: {
        matches: [
            'year',
            'month'
        ],
        regexp: /^since (\d+)-(\d+)$/i,
        select: $d9eea3283bc93203$var$sinceQuery
    },
    since_y_m_d: {
        matches: [
            'year',
            'month',
            'day'
        ],
        regexp: /^since (\d+)-(\d+)-(\d+)$/i,
        select: $d9eea3283bc93203$var$sinceQuery
    },
    baseline: {
        matches: [
            'year',
            'availability',
            'date',
            'downstream',
            'kaios'
        ],
        // Matches:
        //   baseline 2024
        //   baseline newly available
        //   baseline widely available
        //   baseline widely available on 2024-06-01
        //   ...with downstream
        //   ...including kaios
        regexp: /^baseline\s+(?!\s)(?:(\d+)|(newly|widely)\s+(?!\s)available(?:\s+(?!\s)on\s+(?!\s)(\d{4}-\d{2}-\d{2}))?)?(\s+(?!\s)with\s+(?!\s)downstream)?(\s+(?!\s)including\s+(?!\s)kaios)?$/i,
        select: function select(context, node) {
            var availability = node.availability && node.availability.toLowerCase();
            if (availability === 'newly' && node.date) throw new $040711a52d9f0b35$exports('Using newly available with a date is not supported, please use "widely available on YYYY-MM-DD" and add 30 months to the date you specified.');
            var options = {
                includeDownstreamBrowsers: !!node.downstream,
                includeKaiOS: !!node.kaios,
                suppressWarnings: true
            };
            if (node.year) options.targetYear = node.year;
            else if (node.date) options.widelyAvailableOnDate = node.date;
            else if (availability === 'newly') options.widelyAvailableOnDate = new Date().setMonth(new Date().getMonth() + 30);
            var baselineVersions;
            if (options.includeKaiOS && !options.includeDownstreamBrowsers) {
                // baseline-browser-mapping counts KaiOS as a downstream browser and
                // refuses to return it alone, so take KaiOS from the downstream list
                // and everything else from the core one
                options.includeDownstreamBrowsers = true;
                var downstream = $d2e30b95e37327a0$export$bd0bfd2513508520(options);
                options.includeDownstreamBrowsers = false;
                options.includeKaiOS = false;
                baselineVersions = $d2e30b95e37327a0$export$bd0bfd2513508520(options).concat(downstream.filter(function(version) {
                    return version.browser === 'kai_os';
                }));
            } else baselineVersions = $d2e30b95e37327a0$export$bd0bfd2513508520(options);
            return $d9eea3283bc93203$var$resolve($d9eea3283bc93203$var$bbmTransform(baselineVersions), context);
        }
    },
    popularity: {
        matches: [
            'sign',
            'popularity'
        ],
        regexp: /^(>=?|<=?)\s*(\d+|\d+\.\d+|\.\d+)%$/,
        select: function select(context, node) {
            var popularity = parseFloat(node.popularity);
            var usage = $d9eea3283bc93203$var$browserslist.usage.global;
            return Object.keys(usage).reduce(function(result, version) {
                if (node.sign === '>') {
                    if (usage[version] > popularity) result.push(version);
                } else if (node.sign === '<') {
                    if (usage[version] < popularity) result.push(version);
                } else if (node.sign === '<=') {
                    if (usage[version] <= popularity) result.push(version);
                } else if (usage[version] >= popularity) result.push(version);
                return result;
            }, []);
        }
    },
    popularity_in_my_stats: {
        matches: [
            'sign',
            'popularity'
        ],
        regexp: /^(>=?|<=?)\s*(\d+|\d+\.\d+|\.\d+)%\s+in\s+my\s+stats$/,
        select: function select(context, node) {
            var popularity = parseFloat(node.popularity);
            if (!context.customUsage) throw new $040711a52d9f0b35$exports('Custom usage statistics was not provided');
            var usage = context.customUsage;
            return Object.keys(usage).reduce(function(result, version) {
                var percentage = usage[version];
                if (percentage == null) return result;
                if (node.sign === '>') {
                    if (percentage > popularity) result.push(version);
                } else if (node.sign === '<') {
                    if (percentage < popularity) result.push(version);
                } else if (node.sign === '<=') {
                    if (percentage <= popularity) result.push(version);
                } else if (percentage >= popularity) result.push(version);
                return result;
            }, []);
        }
    },
    popularity_in_config_stats: {
        matches: [
            'sign',
            'popularity',
            'config'
        ],
        regexp: /^(>=?|<=?)\s*(\d+|\d+\.\d+|\.\d+)%\s+in\s+(\S+)\s+stats$/,
        select: function select(context, node) {
            var popularity = parseFloat(node.popularity);
            var usage = $d9eea3283bc93203$var$loadCustomUsage(context, node.config);
            return Object.keys(usage).reduce(function(result, version) {
                var percentage = usage[version];
                if (percentage == null) return result;
                if (node.sign === '>') {
                    if (percentage > popularity) result.push(version);
                } else if (node.sign === '<') {
                    if (percentage < popularity) result.push(version);
                } else if (node.sign === '<=') {
                    if (percentage <= popularity) result.push(version);
                } else if (percentage >= popularity) result.push(version);
                return result;
            }, []);
        }
    },
    popularity_in_place: {
        matches: [
            'sign',
            'popularity',
            'place'
        ],
        regexp: /^(>=?|<=?)\s*(\d+|\d+\.\d+|\.\d+)%\s+in\s+((alt-)?\w\w)$/,
        select: function select(context, node) {
            var popularity = parseFloat(node.popularity);
            var place = node.place;
            if (place.length === 2) place = place.toUpperCase();
            else place = place.toLowerCase();
            $340071140e5bd8fe$exports.loadCountry($d9eea3283bc93203$var$browserslist.usage, place, $d9eea3283bc93203$var$browserslist.data);
            var usage = $d9eea3283bc93203$var$browserslist.usage[place];
            return Object.keys(usage).reduce(function(result, version) {
                var percentage = usage[version];
                if (percentage == null) return result;
                if (node.sign === '>') {
                    if (percentage > popularity) result.push(version);
                } else if (node.sign === '<') {
                    if (percentage < popularity) result.push(version);
                } else if (node.sign === '<=') {
                    if (percentage <= popularity) result.push(version);
                } else if (percentage >= popularity) result.push(version);
                return result;
            }, []);
        }
    },
    cover: {
        matches: [
            'coverage'
        ],
        regexp: /^cover\s+(\d+|\d+\.\d+|\.\d+)%$/i,
        select: $d9eea3283bc93203$var$coverQuery
    },
    cover_in: {
        matches: [
            'coverage',
            'place'
        ],
        regexp: /^cover\s+(\d+|\d+\.\d+|\.\d+)%\s+in\s+(my\s+stats|(alt-)?\w\w)$/i,
        select: $d9eea3283bc93203$var$coverQuery
    },
    cover_config: {
        matches: [
            'coverage',
            'config'
        ],
        regexp: /^cover\s+(\d+|\d+\.\d+|\.\d+)%\s+in\s+(\S+)\s+stats$/i,
        select: $d9eea3283bc93203$var$coverQuery
    },
    supports: {
        matches: [
            'supportType',
            'feature'
        ],
        regexp: /^(?:(fully|partially)\s+)?supports\s+([\w-]+)$/,
        select: function select(context, node) {
            $340071140e5bd8fe$exports.loadFeature($d9eea3283bc93203$var$browserslist.cache, node.feature);
            var withPartial = node.supportType !== 'fully';
            var features = $d9eea3283bc93203$var$browserslist.cache[node.feature];
            var result = [];
            for(var name in features){
                var data = $d9eea3283bc93203$var$byName(name, context);
                // Only check desktop when latest released mobile has support
                var iMax = data.released.length - 1;
                while(iMax >= 0){
                    if (data.released[iMax] in features[name]) break;
                    iMax--;
                }
                var checkDesktop = context.mobileToDesktop && name in $d9eea3283bc93203$var$browserslist.desktopNames && $d9eea3283bc93203$var$isSupported(features[name][data.released[iMax]], withPartial);
                data.versions.forEach(function(version) {
                    var flags = features[name][version];
                    if (flags === undefined && checkDesktop) flags = features[$d9eea3283bc93203$var$browserslist.desktopNames[name]][version];
                    if ($d9eea3283bc93203$var$isSupported(flags, withPartial)) result.push(name + ' ' + version);
                });
            }
            return result;
        }
    },
    electron_range: {
        matches: [
            'from',
            'to'
        ],
        regexp: /^electron\s+([\d.]+)\s*-\s*([\d.]+)$/i,
        select: function select(context, node) {
            var fromToUse = $d9eea3283bc93203$var$normalizeElectron(node.from);
            var toToUse = $d9eea3283bc93203$var$normalizeElectron(node.to);
            var from = parseFloat(node.from);
            var to = parseFloat(node.to);
            if (!$b4154b7ae680d931$exports[fromToUse]) throw new $040711a52d9f0b35$exports('Unknown version ' + from + ' of electron');
            if (!$b4154b7ae680d931$exports[toToUse]) throw new $040711a52d9f0b35$exports('Unknown version ' + to + ' of electron');
            return Object.keys($b4154b7ae680d931$exports).filter($d9eea3283bc93203$var$semverFilterLoose('>=', node.from)).filter($d9eea3283bc93203$var$semverFilterLoose('<=', node.to)).map(function(i) {
                return 'chrome ' + $b4154b7ae680d931$exports[i];
            });
        }
    },
    node_range: {
        matches: [
            'from',
            'to'
        ],
        regexp: /^node\s+([\d.]+)\s*-\s*([\d.]+)$/i,
        select: function select(context, node) {
            return $d9eea3283bc93203$var$browserslist.nodeVersions.filter($d9eea3283bc93203$var$semverFilterLoose('>=', node.from)).filter($d9eea3283bc93203$var$semverFilterLoose('<=', node.to)).map(function(v) {
                return 'node ' + v;
            });
        }
    },
    browser_range: {
        matches: [
            'browser',
            'from',
            'to'
        ],
        regexp: /^(\w+)\s+([\d.]+)\s*-\s*([\d.]+)$/i,
        select: function select(context, node) {
            var data = $d9eea3283bc93203$var$checkName(node.browser, context);
            var from = parseFloat($d9eea3283bc93203$var$normalizeVersion(data, node.from) || node.from);
            var to = parseFloat($d9eea3283bc93203$var$normalizeVersion(data, node.to) || node.to);
            function filter(v) {
                var parsed = parseFloat(v);
                return parsed >= from && parsed <= to;
            }
            return data.released.filter(filter).map($d9eea3283bc93203$var$nameMapper(data.name));
        }
    },
    electron_ray: {
        matches: [
            'sign',
            'version'
        ],
        regexp: /^electron\s*(>=?|<=?)\s*([\d.]+)$/i,
        select: function select(context, node) {
            var versionToUse = $d9eea3283bc93203$var$normalizeElectron(node.version);
            return Object.keys($b4154b7ae680d931$exports).filter($d9eea3283bc93203$var$generateFilter(node.sign, versionToUse)).map(function(i) {
                return 'chrome ' + $b4154b7ae680d931$exports[i];
            });
        }
    },
    node_ray: {
        matches: [
            'sign',
            'version'
        ],
        regexp: /^node\s*(>=?|<=?)\s*([\d.]+)$/i,
        select: function select(context, node) {
            return $d9eea3283bc93203$var$browserslist.nodeVersions.filter($d9eea3283bc93203$var$generateSemverFilter(node.sign, node.version)).map(function(v) {
                return 'node ' + v;
            });
        }
    },
    browser_ray: {
        matches: [
            'browser',
            'sign',
            'version'
        ],
        regexp: /^(\w+)\s*(>=?|<=?)\s*([\d.]+|esr)$/i,
        select: function select(context, node) {
            var version = node.version;
            var data = $d9eea3283bc93203$var$checkName(node.browser, context);
            var alias = $d9eea3283bc93203$var$browserslist.versionAliases[data.name][version.toLowerCase()];
            if (alias) version = alias;
            if (!/[\d.]+/.test(version)) throw new $040711a52d9f0b35$exports('Unknown version ' + version + ' of ' + node.browser);
            return data.released.filter($d9eea3283bc93203$var$generateFilter(node.sign, version)).map(function(v) {
                return data.name + ' ' + v;
            });
        }
    },
    firefox_esr: {
        matches: [],
        regexp: /^(firefox|ff|fx)\s+esr$/i,
        select: function select() {
            return [
                'firefox ' + $d9eea3283bc93203$var$FIREFOX_ESR_VERSION
            ];
        }
    },
    opera_mini_all: {
        matches: [],
        regexp: /(operamini|op_mini)\s+all/i,
        select: function select() {
            return [
                'op_mini all'
            ];
        }
    },
    electron_version: {
        matches: [
            'version'
        ],
        regexp: /^electron\s+([\d.]+)$/i,
        select: function select(context, node) {
            var versionToUse = $d9eea3283bc93203$var$normalizeElectron(node.version);
            var chrome = $b4154b7ae680d931$exports[versionToUse];
            if (!chrome) throw new $040711a52d9f0b35$exports('Unknown version ' + node.version + ' of electron');
            return [
                'chrome ' + chrome
            ];
        }
    },
    node_major_version: {
        matches: [
            'version'
        ],
        regexp: /^node\s+(\d+)$/i,
        select: $d9eea3283bc93203$var$nodeQuery
    },
    node_minor_version: {
        matches: [
            'version'
        ],
        regexp: /^node\s+(\d+\.\d+)$/i,
        select: $d9eea3283bc93203$var$nodeQuery
    },
    node_patch_version: {
        matches: [
            'version'
        ],
        regexp: /^node\s+(\d+\.\d+\.\d+)$/i,
        select: $d9eea3283bc93203$var$nodeQuery
    },
    current_node: {
        matches: [],
        regexp: /^current\s+node$/i,
        select: function select(context) {
            return [
                $340071140e5bd8fe$exports.currentNode($d9eea3283bc93203$var$resolve, context)
            ];
        }
    },
    maintained_node: {
        matches: [],
        regexp: /^maintained\s+node\s+versions$/i,
        select: function select(context) {
            var now = Date.now();
            var queries = Object.keys($4efe932a0e00e9fe$exports).filter(function(key) {
                return now < Date.parse($4efe932a0e00e9fe$exports[key].end) && now > Date.parse($4efe932a0e00e9fe$exports[key].start) && $d9eea3283bc93203$var$isEolReleased(key);
            }).map(function(key) {
                return 'node ' + key.slice(1);
            });
            return $d9eea3283bc93203$var$resolve(queries, context);
        }
    },
    phantomjs_1_9: {
        matches: [],
        regexp: /^phantomjs\s+1.9$/i,
        select: function select() {
            return [
                'safari 5'
            ];
        }
    },
    phantomjs_2_1: {
        matches: [],
        regexp: /^phantomjs\s+2.1$/i,
        select: function select() {
            return [
                'safari 6'
            ];
        }
    },
    browser_version: {
        matches: [
            'browser',
            'version'
        ],
        regexp: /^(\w+)\s+(tp|[\d.]+)$/i,
        select: function select(context, node) {
            var version = node.version;
            if (/^tp$/i.test(version)) version = 'TP';
            var data = $d9eea3283bc93203$var$checkName(node.browser, context);
            var alias = $d9eea3283bc93203$var$normalizeVersion(data, version);
            if (alias) version = alias;
            else {
                if (version.indexOf('.') === -1) alias = version + '.0';
                else alias = version.replace(/\.0$/, '');
                alias = $d9eea3283bc93203$var$normalizeVersion(data, alias);
                if (alias) version = alias;
                else if (context.ignoreUnknownVersions) return [];
                else throw new $040711a52d9f0b35$exports('Unknown version ' + version + ' of ' + node.browser);
            }
            return [
                data.name + ' ' + version
            ];
        }
    },
    browserslist_config: {
        matches: [],
        regexp: /^browserslist config$/i,
        needsPath: true,
        select: function select(context) {
            return $d9eea3283bc93203$var$browserslist(undefined, context);
        }
    },
    extends: {
        matches: [
            'config'
        ],
        regexp: /^extends (.+)$/i,
        needsPath: true,
        select: function select(context, node) {
            return $d9eea3283bc93203$var$resolve($340071140e5bd8fe$exports.loadQueries(context, node.config), context);
        }
    },
    defaults: {
        matches: [],
        regexp: /^defaults$/i,
        select: function select(context) {
            return $d9eea3283bc93203$var$resolve($d9eea3283bc93203$var$browserslist.defaults, context);
        }
    },
    dead: {
        matches: [],
        regexp: /^dead$/i,
        select: function select(context) {
            var dead = [
                'Baidu >= 0',
                'ie <= 11',
                'ie_mob <= 11',
                'bb <= 10',
                'op_mob <= 12.1',
                'samsung 4'
            ];
            return $d9eea3283bc93203$var$resolve(dead, context);
        }
    },
    unknown: {
        matches: [],
        regexp: /^(\w+)$/i,
        select: function select(context, node) {
            if ($d9eea3283bc93203$var$byName(node.query, context)) throw new $040711a52d9f0b35$exports('Specify versions in Browserslist query for browser ' + node.query);
            else throw $d9eea3283bc93203$var$unknownQuery(node.query);
        }
    }
};
(function() {
    for(var name in $d9eea3283bc93203$require$agents){
        var browser = $d9eea3283bc93203$require$agents[name];
        $d9eea3283bc93203$var$browserslist.data[name] = {
            name: name,
            versions: $d9eea3283bc93203$var$normalize($d9eea3283bc93203$require$agents[name].versions),
            released: $d9eea3283bc93203$var$normalize($d9eea3283bc93203$require$agents[name].versions.slice(0, -3)),
            releaseDate: $d9eea3283bc93203$require$agents[name].release_date
        };
        $d9eea3283bc93203$var$fillUsage($d9eea3283bc93203$var$browserslist.usage.global, name, browser.usage_global);
        $d9eea3283bc93203$var$browserslist.versionAliases[name] = {};
        for(var i = 0; i < browser.versions.length; i++){
            var full = browser.versions[i];
            if (!full) continue;
            if (full.indexOf('-') !== -1) {
                var interval = full.split('-');
                for(var j = 0; j < interval.length; j++)$d9eea3283bc93203$var$browserslist.versionAliases[name][interval[j]] = full;
            }
        }
    }
    $d9eea3283bc93203$var$browserslist.nodeVersions = $a8fce34ed20f3bbb$exports.map(function(release) {
        return release.version;
    });
})();
$d9eea3283bc93203$var$browserslist.versionAliases.firefox.esr = $d9eea3283bc93203$var$FIREFOX_ESR_VERSION;
$d9eea3283bc93203$exports = $d9eea3283bc93203$var$browserslist;



var $d35bff39a532d6a8$require$agents = $87aaf62f5e035055$export$ac5be7df5fa52a3c;

var $eSZyB = parcelRequire("eSZyB");
var $ea2b86d4fd154896$exports = {};

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $21h22 = parcelRequire("21h22");


var $ea2b86d4fd154896$require$agents = $87aaf62f5e035055$export$ac5be7df5fa52a3c;

var $kUXlT = parcelRequire("kUXlT");
var $ea2b86d4fd154896$var$Browsers = /*#__PURE__*/ function() {
    "use strict";
    function Browsers(data, requirements, options, browserslistOpts) {
        (0, $gd0sY._)(this, Browsers);
        this.data = data;
        this.options = options || {};
        this.browserslistOpts = browserslistOpts || {};
        this.selected = this.parse(requirements);
    }
    (0, $7cSld._)(Browsers, [
        {
            /**
   * Is browser is selected by requirements
   */ key: "isSelected",
            value: function isSelected(browser) {
                return this.selected.includes(browser);
            }
        },
        {
            /**
   * Return browsers selected by requirements
   */ key: "parse",
            value: function parse(requirements) {
                var opts = {};
                for(var i in this.browserslistOpts)opts[i] = this.browserslistOpts[i];
                opts.path = this.options.from;
                return $d9eea3283bc93203$exports(requirements, opts);
            }
        },
        {
            /**
   * Return prefix for selected browser
   */ key: "prefix",
            value: function prefix(browser) {
                var _browser_split = (0, $21h22._)(browser.split(' '), 2), name = _browser_split[0], version = _browser_split[1];
                var data = this.data[name];
                var prefix = data.prefix_exceptions && data.prefix_exceptions[version];
                if (!prefix) prefix = data.prefix;
                return "-".concat(prefix, "-");
            }
        }
    ], [
        {
            key: "prefixes",
            value: /**
   * Return all prefixes for default browser data
   */ function prefixes() {
                if (this.prefixesCache) return this.prefixesCache;
                this.prefixesCache = [];
                for(var name in $ea2b86d4fd154896$require$agents)this.prefixesCache.push("-".concat($ea2b86d4fd154896$require$agents[name].prefix, "-"));
                this.prefixesCache = $kUXlT.uniq(this.prefixesCache).sort(function(a, b) {
                    return b.length - a.length;
                });
                return this.prefixesCache;
            }
        },
        {
            key: "withPrefix",
            value: /**
   * Check is value contain any possible prefix
   */ function withPrefix(value) {
                if (!this.prefixesRegexp) this.prefixesRegexp = new RegExp(this.prefixes().join('|'));
                return this.prefixesRegexp.test(value);
            }
        }
    ]);
    return Browsers;
}();
$ea2b86d4fd154896$exports = $ea2b86d4fd154896$var$Browsers;


var $77d8edc20cc2c324$exports = {};

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $21h22 = parcelRequire("21h22");
var $94d58ff1b5a11e04$exports = {};
$94d58ff1b5a11e04$exports = {
    prefix: function(prop) {
        var match = prop.match(/^(-\w+-)/);
        if (match) return match[0];
        return '';
    },
    unprefixed: function(prop) {
        return prop.replace(/^-\w+-/, '');
    }
};


var $8a1dfa5624408614$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");
var $d3c4c5bfd4b3aa67$exports = {};

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $2bfPH = parcelRequire("2bfPH");



var $kUXlT = parcelRequire("kUXlT");
/**
 * Recursively clone objects
 */ function $d3c4c5bfd4b3aa67$var$clone(obj, parent) {
    var cloned = new obj.constructor();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(obj || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var i = _step.value;
            var value = obj[i];
            if (i === 'parent' && (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) === 'object') {
                if (parent) cloned[i] = parent;
            } else if (i === 'source' || i === null) cloned[i] = value;
            else if (Array.isArray(value)) cloned[i] = value.map(function(x) {
                return $d3c4c5bfd4b3aa67$var$clone(x, cloned);
            });
            else if (i !== '_autoprefixerPrefix' && i !== '_autoprefixerValues' && i !== 'proxyCache') {
                if ((typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) === 'object' && value !== null) value = $d3c4c5bfd4b3aa67$var$clone(value, cloned);
                cloned[i] = value;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return cloned;
}
var $d3c4c5bfd4b3aa67$var$Prefixer = /*#__PURE__*/ function() {
    "use strict";
    function Prefixer(name, prefixes, all) {
        (0, $gd0sY._)(this, Prefixer);
        this.prefixes = prefixes;
        this.name = name;
        this.all = all;
    }
    (0, $7cSld._)(Prefixer, [
        {
            /**
   * Shortcut for Prefixer.clone
   */ key: "clone",
            value: function clone(node, overrides) {
                return Prefixer.clone(node, overrides);
            }
        },
        {
            /**
   * Find prefix in node parents
   */ key: "parentPrefix",
            value: function parentPrefix(node) {
                var prefix;
                if (typeof node._autoprefixerPrefix !== 'undefined') prefix = node._autoprefixerPrefix;
                else if (node.type === 'decl' && node.prop[0] === '-') prefix = $94d58ff1b5a11e04$exports.prefix(node.prop);
                else if (node.type === 'root') prefix = false;
                else if (node.type === 'rule' && node.selector.includes(':-') && /:(-\w+-)/.test(node.selector)) prefix = node.selector.match(/:(-\w+-)/)[1];
                else if (node.type === 'atrule' && node.name[0] === '-') prefix = $94d58ff1b5a11e04$exports.prefix(node.name);
                else prefix = this.parentPrefix(node.parent);
                if (!$ea2b86d4fd154896$exports.prefixes().includes(prefix)) prefix = false;
                node._autoprefixerPrefix = prefix;
                return node._autoprefixerPrefix;
            }
        },
        {
            /**
   * Clone node with prefixes
   */ key: "process",
            value: function process(node, result) {
                if (!this.check(node)) return undefined;
                var parent = this.parentPrefix(node);
                var prefixes = this.prefixes.filter(function(prefix) {
                    return !parent || parent === $kUXlT.removeNote(prefix);
                });
                var added = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = prefixes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var prefix = _step.value;
                        if (this.add(node, prefix, added.concat([
                            prefix
                        ]), result)) added.push(prefix);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return added;
            }
        }
    ], [
        {
            key: "clone",
            value: /**
   * Clone node and clean autprefixer custom caches
   */ function clone1(node, overrides) {
                var cloned = $d3c4c5bfd4b3aa67$var$clone(node);
                for(var name in overrides)cloned[name] = overrides[name];
                return cloned;
            }
        },
        {
            key: "hack",
            value: /**
   * Add hack to selected names
   */ function hack(klass) {
                var _this = this;
                if (!this.hacks) this.hacks = {};
                return klass.names.map(function(name) {
                    _this.hacks[name] = klass;
                    return _this.hacks[name];
                });
            }
        },
        {
            key: "load",
            value: /**
   * Load hacks for some names
   */ function load(name, prefixes, all) {
                var Klass = this.hacks && this.hacks[name];
                if (Klass) return new Klass(name, prefixes, all);
                else return new this(name, prefixes, all);
            }
        }
    ]);
    return Prefixer;
}();
$d3c4c5bfd4b3aa67$exports = $d3c4c5bfd4b3aa67$var$Prefixer;




var $kUXlT = parcelRequire("kUXlT");
var $8a1dfa5624408614$var$Declaration = /*#__PURE__*/ function(Prefixer) {
    "use strict";
    (0, $NBk0Y._)(Declaration, Prefixer);
    function Declaration() {
        (0, $gd0sY._)(this, Declaration);
        return (0, $8xMIM._)(this, Declaration, arguments);
    }
    (0, $7cSld._)(Declaration, [
        {
            /**
   * Clone and add prefixes for declaration
   */ key: "add",
            value: function add(decl, prefix, prefixes, result) {
                var prefixed = this.prefixed(decl.prop, prefix);
                if (this.isAlready(decl, prefixed) || this.otherPrefixes(decl.value, prefix)) return undefined;
                return this.insert(decl, prefix, prefixes, result);
            }
        },
        {
            /**
   * Calculate indentation to create visual cascade
   */ key: "calcBefore",
            value: function calcBefore(prefixes, decl) {
                var prefix = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : '';
                var max = this.maxPrefixed(prefixes, decl);
                var diff = max - $kUXlT.removeNote(prefix).length;
                var before = decl.raw('before');
                if (diff > 0) before += Array(diff).fill(' ').join('');
                return before;
            }
        },
        {
            /**
   * Always true, because we already get prefixer by property name
   */ key: "check",
            value: function check() {
                return true;
            }
        },
        {
            /**
   * Clone and insert new declaration
   */ key: "insert",
            value: function insert(decl, prefix, prefixes) {
                var cloned = this.set(this.clone(decl), prefix);
                if (!cloned) return undefined;
                var already = decl.parent.some(function(i) {
                    return i.prop === cloned.prop && i.value === cloned.value;
                });
                if (already) return undefined;
                if (this.needCascade(decl)) cloned.raws.before = this.calcBefore(prefixes, decl, prefix);
                return decl.parent.insertBefore(decl, cloned);
            }
        },
        {
            /**
   * Did this declaration has this prefix above
   */ key: "isAlready",
            value: function isAlready(decl, prefixed) {
                var already = this.all.group(decl).up(function(i) {
                    return i.prop === prefixed;
                });
                if (!already) already = this.all.group(decl).down(function(i) {
                    return i.prop === prefixed;
                });
                return already;
            }
        },
        {
            /**
   * Return maximum length of possible prefixed property
   */ key: "maxPrefixed",
            value: function maxPrefixed(prefixes, decl) {
                if (decl._autoprefixerMax) return decl._autoprefixerMax;
                var max = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = prefixes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var prefix = _step.value;
                        prefix = $kUXlT.removeNote(prefix);
                        if (prefix.length > max) max = prefix.length;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                decl._autoprefixerMax = max;
                return decl._autoprefixerMax;
            }
        },
        {
            /**
   * Should we use visual cascade for prefixes
   */ key: "needCascade",
            value: function needCascade(decl) {
                if (!decl._autoprefixerCascade) decl._autoprefixerCascade = this.all.options.cascade !== false && decl.raw('before').includes('\n');
                return decl._autoprefixerCascade;
            }
        },
        {
            /**
   * Return unprefixed version of property
   */ key: "normalize",
            value: function normalize(prop) {
                return prop;
            }
        },
        {
            /**
   * Return list of prefixed properties to clean old prefixes
   */ key: "old",
            value: function old(prop, prefix) {
                return [
                    this.prefixed(prop, prefix)
                ];
            }
        },
        {
            /**
   * Check `value`, that it contain other prefixes, rather than `prefix`
   */ key: "otherPrefixes",
            value: function otherPrefixes(value, prefix) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = $ea2b86d4fd154896$exports.prefixes()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var other = _step.value;
                        if (other === prefix) continue;
                        if (value.includes(other)) return value.replace(/var\([^)]+\)/, '').includes(other);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return false;
            }
        },
        {
            /**
   * Return prefixed version of property
   */ key: "prefixed",
            value: function prefixed(prop, prefix) {
                return prefix + prop;
            }
        },
        {
            /**
   * Add spaces for visual cascade
   */ key: "process",
            value: function process(decl, result) {
                if (!this.needCascade(decl)) {
                    (0, $bl6Nv._)((0, $7GsX9._)(Declaration.prototype), "process", this).call(this, decl, result);
                    return;
                }
                var prefixes = (0, $bl6Nv._)((0, $7GsX9._)(Declaration.prototype), "process", this).call(this, decl, result);
                if (!prefixes || !prefixes.length) return;
                this.restoreBefore(decl);
                decl.raws.before = this.calcBefore(prefixes, decl);
            }
        },
        {
            /**
   * Remove visual cascade
   */ key: "restoreBefore",
            value: function restoreBefore(decl) {
                var lines = decl.raw('before').split('\n');
                var min = lines[lines.length - 1];
                this.all.group(decl).up(function(prefixed) {
                    var array = prefixed.raw('before').split('\n');
                    var last = array[array.length - 1];
                    if (last.length < min.length) min = last;
                });
                lines[lines.length - 1] = min;
                decl.raws.before = lines.join('\n');
            }
        },
        {
            /**
   * Set prefix to declaration
   */ key: "set",
            value: function set(decl, prefix) {
                decl.prop = this.prefixed(decl.prop, prefix);
                return decl;
            }
        }
    ]);
    return Declaration;
}($d3c4c5bfd4b3aa67$exports);
$8a1dfa5624408614$exports = $8a1dfa5624408614$var$Declaration;


var $f7746ff206f0fa3f$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $NBk0Y = parcelRequire("NBk0Y");
var $82004dee1a3a030d$exports = {};

var $2bfPH = parcelRequire("2bfPH");
/**
 * @license Fraction.js v4.3.7 31/08/2023
 * https://www.xarg.org/2014/03/rational-numbers-in-javascript/
 *
 * Copyright (c) 2023, Robert Eisele (robert@raw.org)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 **/ /**
 *
 * This class offers the possibility to calculate fractions.
 * You can pass a fraction in different formats. Either as array, as double, as string or as an integer.
 *
 * Array/Object form
 * [ 0 => <numerator>, 1 => <denominator> ]
 * [ n => <numerator>, d => <denominator> ]
 *
 * Integer form
 * - Single integer value
 *
 * Double form
 * - Single double value
 *
 * String form
 * 123.456 - a simple double
 * 123/456 - a string fraction
 * 123.'456' - a double with repeating decimal places
 * 123.(456) - synonym
 * 123.45'6' - a double with repeating last place
 * 123.45(6) - synonym
 *
 * Example:
 *
 * var f = new Fraction("9.4'31'");
 * f.mul([-4, 3]).div(4.9);
 *
 */ (function(root) {
    "use strict";
    // Maximum search depth for cyclic rational numbers. 2000 should be more than enough.
    // Example: 1/7 = 0.(142857) has 6 repeating decimal places.
    // If MAX_CYCLE_LEN gets reduced, long cycles will not be detected and toString() only gets the first 10 digits
    var MAX_CYCLE_LEN = 2000;
    // Parsed data to avoid calling "new" all the time
    var P = {
        "s": 1,
        "n": 0,
        "d": 1
    };
    function assign(n, s) {
        if (isNaN(n = parseInt(n, 10))) throw InvalidParameter();
        return n * s;
    }
    // Creates a new Fraction internally without the need of the bulky constructor
    function newFraction(n, d) {
        if (d === 0) throw DivisionByZero();
        var f = Object.create(Fraction.prototype);
        f["s"] = n < 0 ? -1 : 1;
        n = n < 0 ? -n : n;
        var a = gcd(n, d);
        f["n"] = n / a;
        f["d"] = d / a;
        return f;
    }
    function factorize(num) {
        var factors = {};
        var n = num;
        var i = 2;
        var s = 4;
        while(s <= n){
            while(n % i === 0){
                n /= i;
                factors[i] = (factors[i] || 0) + 1;
            }
            s += 1 + 2 * i++;
        }
        if (n !== num) {
            if (n > 1) factors[n] = (factors[n] || 0) + 1;
        } else factors[num] = (factors[num] || 0) + 1;
        return factors;
    }
    var parse = function parse(p1, p2) {
        var n = 0, d = 1, s = 1;
        var v = 0, w = 0, x = 0, y = 1, z = 1;
        var A = 0, B = 1;
        var C = 1, D = 1;
        var N = 10000000;
        var M;
        if (p1 === undefined || p1 === null) ;
        else if (p2 !== undefined) {
            n = p1;
            d = p2;
            s = n * d;
            if (n % 1 !== 0 || d % 1 !== 0) throw NonIntegerParameter();
        } else switch(typeof p1 === "undefined" ? "undefined" : (0, $2bfPH._)(p1)){
            case "object":
                if ("d" in p1 && "n" in p1) {
                    n = p1["n"];
                    d = p1["d"];
                    if ("s" in p1) n *= p1["s"];
                } else if (0 in p1) {
                    n = p1[0];
                    if (1 in p1) d = p1[1];
                } else throw InvalidParameter();
                s = n * d;
                break;
            case "number":
                if (p1 < 0) {
                    s = p1;
                    p1 = -p1;
                }
                if (p1 % 1 === 0) n = p1;
                else if (p1 > 0) {
                    if (p1 >= 1) {
                        z = Math.pow(10, Math.floor(1 + Math.log(p1) / Math.LN10));
                        p1 /= z;
                    }
                    // Using Farey Sequences
                    // http://www.johndcook.com/blog/2010/10/20/best-rational-approximation/
                    while(B <= N && D <= N){
                        M = (A + C) / (B + D);
                        if (p1 === M) {
                            if (B + D <= N) {
                                n = A + C;
                                d = B + D;
                            } else if (D > B) {
                                n = C;
                                d = D;
                            } else {
                                n = A;
                                d = B;
                            }
                            break;
                        } else {
                            if (p1 > M) {
                                A += C;
                                B += D;
                            } else {
                                C += A;
                                D += B;
                            }
                            if (B > N) {
                                n = C;
                                d = D;
                            } else {
                                n = A;
                                d = B;
                            }
                        }
                    }
                    n *= z;
                } else if (isNaN(p1) || isNaN(p2)) d = n = NaN;
                break;
            case "string":
                B = p1.match(/\d+|./g);
                if (B === null) throw InvalidParameter();
                if (B[A] === '-') {
                    s = -1;
                    A++;
                } else if (B[A] === '+') A++;
                if (B.length === A + 1) w = assign(B[A++], s);
                else if (B[A + 1] === '.' || B[A] === '.') {
                    if (B[A] !== '.') v = assign(B[A++], s);
                    A++;
                    // Check for decimal places
                    if (A + 1 === B.length || B[A + 1] === '(' && B[A + 3] === ')' || B[A + 1] === "'" && B[A + 3] === "'") {
                        w = assign(B[A], s);
                        y = Math.pow(10, B[A].length);
                        A++;
                    }
                    // Check for repeating places
                    if (B[A] === '(' && B[A + 2] === ')' || B[A] === "'" && B[A + 2] === "'") {
                        x = assign(B[A + 1], s);
                        z = Math.pow(10, B[A + 1].length) - 1;
                        A += 3;
                    }
                } else if (B[A + 1] === '/' || B[A + 1] === ':') {
                    w = assign(B[A], s);
                    y = assign(B[A + 2], 1);
                    A += 3;
                } else if (B[A + 3] === '/' && B[A + 1] === ' ') {
                    v = assign(B[A], s);
                    w = assign(B[A + 2], s);
                    y = assign(B[A + 4], 1);
                    A += 5;
                }
                if (B.length <= A) {
                    d = y * z;
                    s = /* void */ n = x + d * v + z * w;
                    break;
                }
            default:
                throw InvalidParameter();
        }
        if (d === 0) throw DivisionByZero();
        P["s"] = s < 0 ? -1 : 1;
        P["n"] = Math.abs(n);
        P["d"] = Math.abs(d);
    };
    function modpow(b, e, m) {
        var r = 1;
        for(; e > 0; b = b * b % m, e >>= 1)if (e & 1) r = r * b % m;
        return r;
    }
    function cycleLen(n, d) {
        for(; d % 2 === 0; d /= 2);
        for(; d % 5 === 0; d /= 5);
        if (d === 1) return 0;
        // If we would like to compute really large numbers quicker, we could make use of Fermat's little theorem:
        // 10^(d-1) % d == 1
        // However, we don't need such large numbers and MAX_CYCLE_LEN should be the capstone,
        // as we want to translate the numbers to strings.
        var rem = 10 % d;
        var t = 1;
        for(; rem !== 1; t++){
            rem = rem * 10 % d;
            if (t > MAX_CYCLE_LEN) return 0; // Returning 0 here means that we don't print it as a cyclic number. It's likely that the answer is `d-1`
        }
        return t;
    }
    function cycleStart(n, d, len) {
        var rem1 = 1;
        var rem2 = modpow(10, len, d);
        for(var t = 0; t < 300; t++){
            // Solve 10^s == 10^(s+t) (mod d)
            if (rem1 === rem2) return t;
            rem1 = rem1 * 10 % d;
            rem2 = rem2 * 10 % d;
        }
        return 0;
    }
    function gcd(a, b) {
        if (!a) return b;
        if (!b) return a;
        while(true){
            a %= b;
            if (!a) return b;
            b %= a;
            if (!b) return a;
        }
    }
    /**
   * Module constructor
   *
   * @constructor
   * @param {number|Fraction=} a
   * @param {number=} b
   */ function Fraction(a, b) {
        parse(a, b);
        if (this instanceof Fraction) {
            a = gcd(P["d"], P["n"]); // Abuse variable a
            this["s"] = P["s"];
            this["n"] = P["n"] / a;
            this["d"] = P["d"] / a;
        } else return newFraction(P['s'] * P['n'], P['d']);
    }
    var DivisionByZero = function DivisionByZero() {
        return new Error("Division by Zero");
    };
    var InvalidParameter = function InvalidParameter() {
        return new Error("Invalid argument");
    };
    var NonIntegerParameter = function NonIntegerParameter() {
        return new Error("Parameters must be integer");
    };
    Fraction.prototype = {
        "s": 1,
        "n": 0,
        "d": 1,
        /**
     * Calculates the absolute value
     *
     * Ex: new Fraction(-4).abs() => 4
     **/ "abs": function() {
            return newFraction(this["n"], this["d"]);
        },
        /**
     * Inverts the sign of the current fraction
     *
     * Ex: new Fraction(-4).neg() => 4
     **/ "neg": function() {
            return newFraction(-this["s"] * this["n"], this["d"]);
        },
        /**
     * Adds two rational numbers
     *
     * Ex: new Fraction({n: 2, d: 3}).add("14.9") => 467 / 30
     **/ "add": function(a, b) {
            parse(a, b);
            return newFraction(this["s"] * this["n"] * P["d"] + P["s"] * this["d"] * P["n"], this["d"] * P["d"]);
        },
        /**
     * Subtracts two rational numbers
     *
     * Ex: new Fraction({n: 2, d: 3}).add("14.9") => -427 / 30
     **/ "sub": function(a, b) {
            parse(a, b);
            return newFraction(this["s"] * this["n"] * P["d"] - P["s"] * this["d"] * P["n"], this["d"] * P["d"]);
        },
        /**
     * Multiplies two rational numbers
     *
     * Ex: new Fraction("-17.(345)").mul(3) => 5776 / 111
     **/ "mul": function(a, b) {
            parse(a, b);
            return newFraction(this["s"] * P["s"] * this["n"] * P["n"], this["d"] * P["d"]);
        },
        /**
     * Divides two rational numbers
     *
     * Ex: new Fraction("-17.(345)").inverse().div(3)
     **/ "div": function(a, b) {
            parse(a, b);
            return newFraction(this["s"] * P["s"] * this["n"] * P["d"], this["d"] * P["n"]);
        },
        /**
     * Clones the actual object
     *
     * Ex: new Fraction("-17.(345)").clone()
     **/ "clone": function() {
            return newFraction(this['s'] * this['n'], this['d']);
        },
        /**
     * Calculates the modulo of two rational numbers - a more precise fmod
     *
     * Ex: new Fraction('4.(3)').mod([7, 8]) => (13/3) % (7/8) = (5/6)
     **/ "mod": function(a, b) {
            if (isNaN(this['n']) || isNaN(this['d'])) return new Fraction(NaN);
            if (a === undefined) return newFraction(this["s"] * this["n"] % this["d"], 1);
            parse(a, b);
            if (0 === P["n"] && 0 === this["d"]) throw DivisionByZero();
            /*
       * First silly attempt, kinda slow
       *
       return that["sub"]({
       "n": num["n"] * Math.floor((this.n / this.d) / (num.n / num.d)),
       "d": num["d"],
       "s": this["s"]
       });*/ /*
       * New attempt: a1 / b1 = a2 / b2 * q + r
       * => b2 * a1 = a2 * b1 * q + b1 * b2 * r
       * => (b2 * a1 % a2 * b1) / (b1 * b2)
       */ return newFraction(this["s"] * (P["d"] * this["n"]) % (P["n"] * this["d"]), P["d"] * this["d"]);
        },
        /**
     * Calculates the fractional gcd of two rational numbers
     *
     * Ex: new Fraction(5,8).gcd(3,7) => 1/56
     */ "gcd": function(a, b) {
            parse(a, b);
            // gcd(a / b, c / d) = gcd(a, c) / lcm(b, d)
            return newFraction(gcd(P["n"], this["n"]) * gcd(P["d"], this["d"]), P["d"] * this["d"]);
        },
        /**
     * Calculates the fractional lcm of two rational numbers
     *
     * Ex: new Fraction(5,8).lcm(3,7) => 15
     */ "lcm": function(a, b) {
            parse(a, b);
            // lcm(a / b, c / d) = lcm(a, c) / gcd(b, d)
            if (P["n"] === 0 && this["n"] === 0) return newFraction(0, 1);
            return newFraction(P["n"] * this["n"], gcd(P["n"], this["n"]) * gcd(P["d"], this["d"]));
        },
        /**
     * Calculates the ceil of a rational number
     *
     * Ex: new Fraction('4.(3)').ceil() => (5 / 1)
     **/ "ceil": function(places) {
            places = Math.pow(10, places || 0);
            if (isNaN(this["n"]) || isNaN(this["d"])) return new Fraction(NaN);
            return newFraction(Math.ceil(places * this["s"] * this["n"] / this["d"]), places);
        },
        /**
     * Calculates the floor of a rational number
     *
     * Ex: new Fraction('4.(3)').floor() => (4 / 1)
     **/ "floor": function(places) {
            places = Math.pow(10, places || 0);
            if (isNaN(this["n"]) || isNaN(this["d"])) return new Fraction(NaN);
            return newFraction(Math.floor(places * this["s"] * this["n"] / this["d"]), places);
        },
        /**
     * Rounds a rational numbers
     *
     * Ex: new Fraction('4.(3)').round() => (4 / 1)
     **/ "round": function(places) {
            places = Math.pow(10, places || 0);
            if (isNaN(this["n"]) || isNaN(this["d"])) return new Fraction(NaN);
            return newFraction(Math.round(places * this["s"] * this["n"] / this["d"]), places);
        },
        /**
     * Rounds a rational number to a multiple of another rational number
     *
     * Ex: new Fraction('0.9').roundTo("1/8") => 7 / 8
     **/ "roundTo": function(a, b) {
            /*
      k * x/y ≤ a/b < (k+1) * x/y
      ⇔ k ≤ a/b / (x/y) < (k+1)
      ⇔ k = floor(a/b * y/x)
      */ parse(a, b);
            return newFraction(this['s'] * Math.round(this['n'] * P['d'] / (this['d'] * P['n'])) * P['n'], P['d']);
        },
        /**
     * Gets the inverse of the fraction, means numerator and denominator are exchanged
     *
     * Ex: new Fraction([-3, 4]).inverse() => -4 / 3
     **/ "inverse": function() {
            return newFraction(this["s"] * this["d"], this["n"]);
        },
        /**
     * Calculates the fraction to some rational exponent, if possible
     *
     * Ex: new Fraction(-1,2).pow(-3) => -8
     */ "pow": function(a, b) {
            parse(a, b);
            // Trivial case when exp is an integer
            if (P['d'] === 1) {
                if (P['s'] < 0) return newFraction(Math.pow(this['s'] * this["d"], P['n']), Math.pow(this["n"], P['n']));
                else return newFraction(Math.pow(this['s'] * this["n"], P['n']), Math.pow(this["d"], P['n']));
            }
            // Negative roots become complex
            //     (-a/b)^(c/d) = x
            // <=> (-1)^(c/d) * (a/b)^(c/d) = x
            // <=> (cos(pi) + i*sin(pi))^(c/d) * (a/b)^(c/d) = x         # rotate 1 by 180°
            // <=> (cos(c*pi/d) + i*sin(c*pi/d)) * (a/b)^(c/d) = x       # DeMoivre's formula in Q ( https://proofwiki.org/wiki/De_Moivre%27s_Formula/Rational_Index )
            // From which follows that only for c=0 the root is non-complex. c/d is a reduced fraction, so that sin(c/dpi)=0 occurs for d=1, which is handled by our trivial case.
            if (this['s'] < 0) return null;
            // Now prime factor n and d
            var N = factorize(this['n']);
            var D = factorize(this['d']);
            // Exponentiate and take root for n and d individually
            var n = 1;
            var d = 1;
            for(var k in N){
                if (k === '1') continue;
                if (k === '0') {
                    n = 0;
                    break;
                }
                N[k] *= P['n'];
                if (N[k] % P['d'] === 0) N[k] /= P['d'];
                else return null;
                n *= Math.pow(k, N[k]);
            }
            for(var k in D){
                if (k === '1') continue;
                D[k] *= P['n'];
                if (D[k] % P['d'] === 0) D[k] /= P['d'];
                else return null;
                d *= Math.pow(k, D[k]);
            }
            if (P['s'] < 0) return newFraction(d, n);
            return newFraction(n, d);
        },
        /**
     * Check if two rational numbers are the same
     *
     * Ex: new Fraction(19.6).equals([98, 5]);
     **/ "equals": function(a, b) {
            parse(a, b);
            return this["s"] * this["n"] * P["d"] === P["s"] * P["n"] * this["d"]; // Same as compare() === 0
        },
        /**
     * Check if two rational numbers are the same
     *
     * Ex: new Fraction(19.6).equals([98, 5]);
     **/ "compare": function(a, b) {
            parse(a, b);
            var t = this["s"] * this["n"] * P["d"] - P["s"] * P["n"] * this["d"];
            return (0 < t) - (t < 0);
        },
        "simplify": function(eps) {
            if (isNaN(this['n']) || isNaN(this['d'])) return this;
            eps = eps || 0.001;
            var thisABS = this['abs']();
            var cont = thisABS['toContinued']();
            for(var i = 1; i < cont.length; i++){
                var s = newFraction(cont[i - 1], 1);
                for(var k = i - 2; k >= 0; k--)s = s['inverse']()['add'](cont[k]);
                if (Math.abs(s['sub'](thisABS).valueOf()) < eps) return s['mul'](this['s']);
            }
            return this;
        },
        /**
     * Check if two rational numbers are divisible
     *
     * Ex: new Fraction(19.6).divisible(1.5);
     */ "divisible": function(a, b) {
            parse(a, b);
            return !(!(P["n"] * this["d"]) || this["n"] * P["d"] % (P["n"] * this["d"]));
        },
        /**
     * Returns a decimal representation of the fraction
     *
     * Ex: new Fraction("100.'91823'").valueOf() => 100.91823918239183
     **/ 'valueOf': function() {
            return this["s"] * this["n"] / this["d"];
        },
        /**
     * Returns a string-fraction representation of a Fraction object
     *
     * Ex: new Fraction("1.'3'").toFraction(true) => "4 1/3"
     **/ 'toFraction': function(excludeWhole) {
            var whole, str = "";
            var n = this["n"];
            var d = this["d"];
            if (this["s"] < 0) str += '-';
            if (d === 1) str += n;
            else {
                if (excludeWhole && (whole = Math.floor(n / d)) > 0) {
                    str += whole;
                    str += " ";
                    n %= d;
                }
                str += n;
                str += '/';
                str += d;
            }
            return str;
        },
        /**
     * Returns a latex representation of a Fraction object
     *
     * Ex: new Fraction("1.'3'").toLatex() => "\frac{4}{3}"
     **/ 'toLatex': function(excludeWhole) {
            var whole, str = "";
            var n = this["n"];
            var d = this["d"];
            if (this["s"] < 0) str += '-';
            if (d === 1) str += n;
            else {
                if (excludeWhole && (whole = Math.floor(n / d)) > 0) {
                    str += whole;
                    n %= d;
                }
                str += "\\frac{";
                str += n;
                str += '}{';
                str += d;
                str += '}';
            }
            return str;
        },
        /**
     * Returns an array of continued fraction elements
     *
     * Ex: new Fraction("7/8").toContinued() => [0,1,7]
     */ 'toContinued': function() {
            var t;
            var a = this['n'];
            var b = this['d'];
            var res = [];
            if (isNaN(a) || isNaN(b)) return res;
            do {
                res.push(Math.floor(a / b));
                t = a % b;
                a = b;
                b = t;
            }while (a !== 1);
            return res;
        },
        /**
     * Creates a string representation of a fraction with all digits
     *
     * Ex: new Fraction("100.'91823'").toString() => "100.(91823)"
     **/ 'toString': function(dec) {
            var N = this["n"];
            var D = this["d"];
            if (isNaN(N) || isNaN(D)) return "NaN";
            dec = dec || 15; // 15 = decimal places when no repetation
            var cycLen = cycleLen(N, D); // Cycle length
            var cycOff = cycleStart(N, D, cycLen); // Cycle start
            var str = this['s'] < 0 ? "-" : "";
            str += N / D | 0;
            N %= D;
            N *= 10;
            if (N) str += ".";
            if (cycLen) {
                for(var i = cycOff; i--;){
                    str += N / D | 0;
                    N %= D;
                    N *= 10;
                }
                str += "(";
                for(var i = cycLen; i--;){
                    str += N / D | 0;
                    N %= D;
                    N *= 10;
                }
                str += ")";
            } else for(var i = dec; N && i--;){
                str += N / D | 0;
                N %= D;
                N *= 10;
            }
            return str;
        }
    };
    Object.defineProperty($82004dee1a3a030d$exports, "__esModule", {
        'value': true
    });
    $82004dee1a3a030d$exports['default'] = Fraction;
    $82004dee1a3a030d$exports = Fraction;
})(undefined);




var $kUXlT = parcelRequire("kUXlT");
var $f7746ff206f0fa3f$var$REGEXP = /(min|max)-resolution\s*:\s*\d*\.?\d+(dppx|dpcm|dpi|x)/gi;
var $f7746ff206f0fa3f$var$SPLIT = /(min|max)-resolution(\s*:\s*)(\d*\.?\d+)(dppx|dpcm|dpi|x)/i;
var $f7746ff206f0fa3f$var$Resolution = /*#__PURE__*/ function(Prefixer) {
    "use strict";
    (0, $NBk0Y._)(Resolution, Prefixer);
    function Resolution() {
        (0, $gd0sY._)(this, Resolution);
        return (0, $8xMIM._)(this, Resolution, arguments);
    }
    (0, $7cSld._)(Resolution, [
        {
            /**
   * Remove prefixed queries
   */ key: "clean",
            value: function clean(rule) {
                var _this = this;
                if (!this.bad) {
                    this.bad = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this.prefixes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var prefix = _step.value;
                            this.bad.push(this.prefixName(prefix, 'min'));
                            this.bad.push(this.prefixName(prefix, 'max'));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                rule.params = $kUXlT.editList(rule.params, function(queries) {
                    return queries.filter(function(query) {
                        return _this.bad.every(function(i) {
                            return !query.includes(i);
                        });
                    });
                });
            }
        },
        {
            /**
   * Return prefixed query name
   */ key: "prefixName",
            value: function prefixName(prefix, name) {
                if (prefix === '-moz-') return name + '--moz-device-pixel-ratio';
                else return prefix + name + '-device-pixel-ratio';
            }
        },
        {
            /**
   * Return prefixed query
   */ key: "prefixQuery",
            value: function prefixQuery(prefix, name, colon, value, units) {
                value = new $82004dee1a3a030d$exports(value);
                // 1dpcm = 2.54dpi
                // 1dppx = 96dpi
                if (units === 'dpi') value = value.div(96);
                else if (units === 'dpcm') value = value.mul(2.54).div(96);
                value = value.simplify();
                if (prefix === '-o-') value = value.n + '/' + value.d;
                return this.prefixName(prefix, name) + colon + value;
            }
        },
        {
            /**
   * Add prefixed queries
   */ key: "process",
            value: function process(rule) {
                var _this = this;
                var parent = this.parentPrefix(rule);
                var prefixes = parent ? [
                    parent
                ] : this.prefixes;
                rule.params = $kUXlT.editList(rule.params, function(origin, prefixed) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = origin[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var query = _step.value;
                            if (!query.includes('min-resolution') && !query.includes('max-resolution')) {
                                prefixed.push(query);
                                continue;
                            }
                            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                var _loop = function() {
                                    var prefix = _step1.value;
                                    var processed = query.replace($f7746ff206f0fa3f$var$REGEXP, function(str) {
                                        var parts = str.match($f7746ff206f0fa3f$var$SPLIT);
                                        return _this.prefixQuery(prefix, parts[1], parts[2], parts[3], parts[4]);
                                    });
                                    prefixed.push(processed);
                                };
                                for(var _iterator1 = prefixes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop();
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                            prefixed.push(query);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return $kUXlT.uniq(prefixed);
                });
            }
        }
    ]);
    return Resolution;
}($d3c4c5bfd4b3aa67$exports);
$f7746ff206f0fa3f$exports = $f7746ff206f0fa3f$var$Resolution;


var $5a51962e2608793a$exports = {};

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $21h22 = parcelRequire("21h22");

var $9HfAZ = parcelRequire("9HfAZ");
var $5a51962e2608793a$require$list = $9HfAZ.list;
var $ab01bb1e82e8e99f$exports = {};
var $ab0f8849a8c73974$exports = {};
var $ab0f8849a8c73974$var$openParentheses = "(".charCodeAt(0);
var $ab0f8849a8c73974$var$closeParentheses = ")".charCodeAt(0);
var $ab0f8849a8c73974$var$singleQuote = "'".charCodeAt(0);
var $ab0f8849a8c73974$var$doubleQuote = '"'.charCodeAt(0);
var $ab0f8849a8c73974$var$backslash = "\\".charCodeAt(0);
var $ab0f8849a8c73974$var$slash = "/".charCodeAt(0);
var $ab0f8849a8c73974$var$comma = ",".charCodeAt(0);
var $ab0f8849a8c73974$var$colon = ":".charCodeAt(0);
var $ab0f8849a8c73974$var$star = "*".charCodeAt(0);
var $ab0f8849a8c73974$var$uLower = "u".charCodeAt(0);
var $ab0f8849a8c73974$var$uUpper = "U".charCodeAt(0);
var $ab0f8849a8c73974$var$plus = "+".charCodeAt(0);
var $ab0f8849a8c73974$var$isUnicodeRange = /^[a-f0-9?-]+$/i;
$ab0f8849a8c73974$exports = function(input) {
    var tokens = [];
    var value = input;
    var next, quote, prev, token, escape, escapePos, whitespacePos, parenthesesOpenPos;
    var pos = 0;
    var code = value.charCodeAt(pos);
    var max = value.length;
    var stack = [
        {
            nodes: tokens
        }
    ];
    var balanced = 0;
    var parent;
    var name = "";
    var before = "";
    var after = "";
    while(pos < max){
        // Whitespaces
        if (code <= 32) {
            next = pos;
            do {
                next += 1;
                code = value.charCodeAt(next);
            }while (code <= 32);
            token = value.slice(pos, next);
            prev = tokens[tokens.length - 1];
            if (code === $ab0f8849a8c73974$var$closeParentheses && balanced) after = token;
            else if (prev && prev.type === "div") {
                prev.after = token;
                prev.sourceEndIndex += token.length;
            } else if (code === $ab0f8849a8c73974$var$comma || code === $ab0f8849a8c73974$var$colon || code === $ab0f8849a8c73974$var$slash && value.charCodeAt(next + 1) !== $ab0f8849a8c73974$var$star && (!parent || parent && parent.type === "function" && parent.value !== "calc")) before = token;
            else tokens.push({
                type: "space",
                sourceIndex: pos,
                sourceEndIndex: next,
                value: token
            });
            pos = next;
        // Quotes
        } else if (code === $ab0f8849a8c73974$var$singleQuote || code === $ab0f8849a8c73974$var$doubleQuote) {
            next = pos;
            quote = code === $ab0f8849a8c73974$var$singleQuote ? "'" : '"';
            token = {
                type: "string",
                sourceIndex: pos,
                quote: quote
            };
            do {
                escape = false;
                next = value.indexOf(quote, next + 1);
                if (~next) {
                    escapePos = next;
                    while(value.charCodeAt(escapePos - 1) === $ab0f8849a8c73974$var$backslash){
                        escapePos -= 1;
                        escape = !escape;
                    }
                } else {
                    value += quote;
                    next = value.length - 1;
                    token.unclosed = true;
                }
            }while (escape);
            token.value = value.slice(pos + 1, next);
            token.sourceEndIndex = token.unclosed ? next : next + 1;
            tokens.push(token);
            pos = next + 1;
            code = value.charCodeAt(pos);
        // Comments
        } else if (code === $ab0f8849a8c73974$var$slash && value.charCodeAt(pos + 1) === $ab0f8849a8c73974$var$star) {
            next = value.indexOf("*/", pos);
            token = {
                type: "comment",
                sourceIndex: pos,
                sourceEndIndex: next + 2
            };
            if (next === -1) {
                token.unclosed = true;
                next = value.length;
                token.sourceEndIndex = next;
            }
            token.value = value.slice(pos + 2, next);
            tokens.push(token);
            pos = next + 2;
            code = value.charCodeAt(pos);
        // Operation within calc
        } else if ((code === $ab0f8849a8c73974$var$slash || code === $ab0f8849a8c73974$var$star) && parent && parent.type === "function" && parent.value === "calc") {
            token = value[pos];
            tokens.push({
                type: "word",
                sourceIndex: pos - before.length,
                sourceEndIndex: pos + token.length,
                value: token
            });
            pos += 1;
            code = value.charCodeAt(pos);
        // Dividers
        } else if (code === $ab0f8849a8c73974$var$slash || code === $ab0f8849a8c73974$var$comma || code === $ab0f8849a8c73974$var$colon) {
            token = value[pos];
            tokens.push({
                type: "div",
                sourceIndex: pos - before.length,
                sourceEndIndex: pos + token.length,
                value: token,
                before: before,
                after: ""
            });
            before = "";
            pos += 1;
            code = value.charCodeAt(pos);
        // Open parentheses
        } else if ($ab0f8849a8c73974$var$openParentheses === code) {
            // Whitespaces after open parentheses
            next = pos;
            do {
                next += 1;
                code = value.charCodeAt(next);
            }while (code <= 32);
            parenthesesOpenPos = pos;
            token = {
                type: "function",
                sourceIndex: pos - name.length,
                value: name,
                before: value.slice(parenthesesOpenPos + 1, next)
            };
            pos = next;
            if (name === "url" && code !== $ab0f8849a8c73974$var$singleQuote && code !== $ab0f8849a8c73974$var$doubleQuote) {
                next -= 1;
                do {
                    escape = false;
                    next = value.indexOf(")", next + 1);
                    if (~next) {
                        escapePos = next;
                        while(value.charCodeAt(escapePos - 1) === $ab0f8849a8c73974$var$backslash){
                            escapePos -= 1;
                            escape = !escape;
                        }
                    } else {
                        value += ")";
                        next = value.length - 1;
                        token.unclosed = true;
                    }
                }while (escape);
                // Whitespaces before closed
                whitespacePos = next;
                do {
                    whitespacePos -= 1;
                    code = value.charCodeAt(whitespacePos);
                }while (code <= 32);
                if (parenthesesOpenPos < whitespacePos) {
                    if (pos !== whitespacePos + 1) token.nodes = [
                        {
                            type: "word",
                            sourceIndex: pos,
                            sourceEndIndex: whitespacePos + 1,
                            value: value.slice(pos, whitespacePos + 1)
                        }
                    ];
                    else token.nodes = [];
                    if (token.unclosed && whitespacePos + 1 !== next) {
                        token.after = "";
                        token.nodes.push({
                            type: "space",
                            sourceIndex: whitespacePos + 1,
                            sourceEndIndex: next,
                            value: value.slice(whitespacePos + 1, next)
                        });
                    } else {
                        token.after = value.slice(whitespacePos + 1, next);
                        token.sourceEndIndex = next;
                    }
                } else {
                    token.after = "";
                    token.nodes = [];
                }
                pos = next + 1;
                token.sourceEndIndex = token.unclosed ? next : pos;
                code = value.charCodeAt(pos);
                tokens.push(token);
            } else {
                balanced += 1;
                token.after = "";
                token.sourceEndIndex = pos + 1;
                tokens.push(token);
                stack.push(token);
                tokens = token.nodes = [];
                parent = token;
            }
            name = "";
        // Close parentheses
        } else if ($ab0f8849a8c73974$var$closeParentheses === code && balanced) {
            pos += 1;
            code = value.charCodeAt(pos);
            parent.after = after;
            parent.sourceEndIndex += after.length;
            after = "";
            balanced -= 1;
            stack[stack.length - 1].sourceEndIndex = pos;
            stack.pop();
            parent = stack[balanced];
            tokens = parent.nodes;
        // Words
        } else {
            next = pos;
            do {
                if (code === $ab0f8849a8c73974$var$backslash) next += 1;
                next += 1;
                code = value.charCodeAt(next);
            }while (next < max && !(code <= 32 || code === $ab0f8849a8c73974$var$singleQuote || code === $ab0f8849a8c73974$var$doubleQuote || code === $ab0f8849a8c73974$var$comma || code === $ab0f8849a8c73974$var$colon || code === $ab0f8849a8c73974$var$slash || code === $ab0f8849a8c73974$var$openParentheses || code === $ab0f8849a8c73974$var$star && parent && parent.type === "function" && parent.value === "calc" || code === $ab0f8849a8c73974$var$slash && parent.type === "function" && parent.value === "calc" || code === $ab0f8849a8c73974$var$closeParentheses && balanced));
            token = value.slice(pos, next);
            if ($ab0f8849a8c73974$var$openParentheses === code) name = token;
            else if (($ab0f8849a8c73974$var$uLower === token.charCodeAt(0) || $ab0f8849a8c73974$var$uUpper === token.charCodeAt(0)) && $ab0f8849a8c73974$var$plus === token.charCodeAt(1) && $ab0f8849a8c73974$var$isUnicodeRange.test(token.slice(2))) tokens.push({
                type: "unicode-range",
                sourceIndex: pos,
                sourceEndIndex: next,
                value: token
            });
            else tokens.push({
                type: "word",
                sourceIndex: pos,
                sourceEndIndex: next,
                value: token
            });
            pos = next;
        }
    }
    for(pos = stack.length - 1; pos; pos -= 1){
        stack[pos].unclosed = true;
        stack[pos].sourceEndIndex = value.length;
    }
    return stack[0].nodes;
};


var $c791444c096993d2$exports = {};
$c791444c096993d2$exports = function walk(nodes, cb, bubble) {
    var i, max, node, result;
    for(i = 0, max = nodes.length; i < max; i += 1){
        node = nodes[i];
        if (!bubble) result = cb(node, i, nodes);
        if (result !== false && node.type === "function" && Array.isArray(node.nodes)) walk(node.nodes, cb, bubble);
        if (bubble) cb(node, i, nodes);
    }
};


var $42d3657c92bd3836$exports = {};
function $42d3657c92bd3836$var$stringifyNode(node, custom) {
    var type = node.type;
    var value = node.value;
    var buf;
    var customResult;
    if (custom && (customResult = custom(node)) !== undefined) return customResult;
    else if (type === "word" || type === "space") return value;
    else if (type === "string") {
        buf = node.quote || "";
        return buf + value + (node.unclosed ? "" : buf);
    } else if (type === "comment") return "/*" + value + (node.unclosed ? "" : "*/");
    else if (type === "div") return (node.before || "") + value + (node.after || "");
    else if (Array.isArray(node.nodes)) {
        buf = $42d3657c92bd3836$var$stringify(node.nodes, custom);
        if (type !== "function") return buf;
        return value + "(" + (node.before || "") + buf + (node.after || "") + (node.unclosed ? "" : ")");
    }
    return value;
}
function $42d3657c92bd3836$var$stringify(nodes, custom) {
    var result, i;
    if (Array.isArray(nodes)) {
        result = "";
        for(i = nodes.length - 1; ~i; i -= 1)result = $42d3657c92bd3836$var$stringifyNode(nodes[i], custom) + result;
        return result;
    }
    return $42d3657c92bd3836$var$stringifyNode(nodes, custom);
}
$42d3657c92bd3836$exports = $42d3657c92bd3836$var$stringify;


function $ab01bb1e82e8e99f$var$ValueParser(value) {
    if (this instanceof $ab01bb1e82e8e99f$var$ValueParser) {
        this.nodes = $ab0f8849a8c73974$exports(value);
        return this;
    }
    return new $ab01bb1e82e8e99f$var$ValueParser(value);
}
$ab01bb1e82e8e99f$var$ValueParser.prototype.toString = function() {
    return Array.isArray(this.nodes) ? $42d3657c92bd3836$exports(this.nodes) : "";
};
$ab01bb1e82e8e99f$var$ValueParser.prototype.walk = function(cb, bubble) {
    $c791444c096993d2$exports(this.nodes, cb, bubble);
    return this;
};

$ab01bb1e82e8e99f$var$ValueParser.unit = (parcelRequire("78xzh"));
$ab01bb1e82e8e99f$var$ValueParser.walk = $c791444c096993d2$exports;
$ab01bb1e82e8e99f$var$ValueParser.stringify = $42d3657c92bd3836$exports;
$ab01bb1e82e8e99f$exports = $ab01bb1e82e8e99f$var$ValueParser;




var $5a51962e2608793a$var$Transition = /*#__PURE__*/ function() {
    "use strict";
    function Transition(prefixes) {
        (0, $gd0sY._)(this, Transition);
        this.props = [
            'transition',
            'transition-property'
        ];
        this.prefixes = prefixes;
    }
    (0, $7cSld._)(Transition, [
        {
            /**
   * Process transition and add prefixes for all necessary properties
   */ key: "add",
            value: function add(decl, result) {
                var _this = this;
                var prefix, prop;
                var add = this.prefixes.add[decl.prop];
                var vendorPrefixes = this.ruleVendorPrefixes(decl);
                var declPrefixes = vendorPrefixes || add && add.prefixes || [];
                var params = this.parse(decl.value);
                var names = params.map(function(i) {
                    return _this.findProp(i);
                });
                var added = [];
                if (names.some(function(i) {
                    return i[0] === '-';
                })) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = params[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var param = _step.value;
                        prop = this.findProp(param);
                        if (prop[0] === '-') continue;
                        var prefixer = this.prefixes.add[prop];
                        if (!prefixer || !prefixer.prefixes) continue;
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = prefixer.prefixes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                prefix = _step1.value;
                                if (vendorPrefixes && !vendorPrefixes.some(function(p) {
                                    return prefix.includes(p);
                                })) continue;
                                var prefixed = this.prefixes.prefixed(prop, prefix);
                                if (prefixed !== '-ms-transform' && !names.includes(prefixed)) {
                                    if (!this.disabled(prop, prefix)) added.push(this.clone(prop, prefixed, param));
                                }
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                params = params.concat(added);
                var value = this.stringify(params);
                var webkitClean = this.stringify(this.cleanFromUnprefixed(params, '-webkit-'));
                if (declPrefixes.includes('-webkit-')) this.cloneBefore(decl, "-webkit-".concat(decl.prop), webkitClean);
                this.cloneBefore(decl, decl.prop, webkitClean);
                if (declPrefixes.includes('-o-')) {
                    var operaClean = this.stringify(this.cleanFromUnprefixed(params, '-o-'));
                    this.cloneBefore(decl, "-o-".concat(decl.prop), operaClean);
                }
                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                try {
                    for(var _iterator2 = declPrefixes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        prefix = _step2.value;
                        if (prefix !== '-webkit-' && prefix !== '-o-') {
                            var prefixValue = this.stringify(this.cleanOtherPrefixes(params, prefix));
                            this.cloneBefore(decl, prefix + decl.prop, prefixValue);
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
                if (value !== decl.value && !this.already(decl, decl.prop, value)) {
                    this.checkForWarning(result, decl);
                    decl.cloneBefore();
                    decl.value = value;
                }
            }
        },
        {
            /**
   * Does we already have this declaration
   */ key: "already",
            value: function already(decl, prop, value) {
                return decl.parent.some(function(i) {
                    return i.prop === prop && i.value === value;
                });
            }
        },
        {
            /**
   * Show transition-property warning
   */ key: "checkForWarning",
            value: function checkForWarning(result, decl) {
                var _this = this;
                if (decl.prop !== 'transition-property') return;
                var isPrefixed = false;
                var hasAssociatedProp = false;
                decl.parent.each(function(i) {
                    if (i.type !== 'decl') return undefined;
                    if (i.prop.indexOf('transition-') !== 0) return undefined;
                    var values = $5a51962e2608793a$require$list.comma(i.value);
                    // check if current Rule's transition-property comma separated value list needs prefixes
                    if (i.prop === 'transition-property') {
                        values.forEach(function(value) {
                            var lookup = _this.prefixes.add[value];
                            if (lookup && lookup.prefixes && lookup.prefixes.length > 0) isPrefixed = true;
                        });
                        return undefined;
                    }
                    // check if another transition-* prop in current Rule has comma separated value list
                    hasAssociatedProp = hasAssociatedProp || values.length > 1;
                    return false;
                });
                if (isPrefixed && hasAssociatedProp) decl.warn(result, "Replace transition-property to transition, because Autoprefixer could not support any cases of transition-property and other transition-*");
            }
        },
        {
            /**
   * Remove all non-webkit prefixes and unprefixed params if we have prefixed
   */ key: "cleanFromUnprefixed",
            value: function cleanFromUnprefixed(params, prefix) {
                var _this = this;
                var remove = params.map(function(i) {
                    return _this.findProp(i);
                }).filter(function(i) {
                    return i.slice(0, prefix.length) === prefix;
                }).map(function(i) {
                    return _this.prefixes.unprefixed(i);
                });
                var result = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = params[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var param = _step.value;
                        var prop = this.findProp(param);
                        var p = $94d58ff1b5a11e04$exports.prefix(prop);
                        if (!remove.includes(prop) && (p === prefix || p === '')) result.push(param);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return result;
            }
        },
        {
            key: "cleanOtherPrefixes",
            value: function cleanOtherPrefixes(params, prefix) {
                var _this = this;
                return params.filter(function(param) {
                    var current = $94d58ff1b5a11e04$exports.prefix(_this.findProp(param));
                    return current === '' || current === prefix;
                });
            }
        },
        {
            /**
   * Return new param array with different name
   */ key: "clone",
            value: function clone(origin, name, param) {
                var result = [];
                var changed = false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = param[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        if (!changed && i.type === 'word' && i.value === origin) {
                            result.push({
                                type: 'word',
                                value: name
                            });
                            changed = true;
                        } else result.push(i);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return result;
            }
        },
        {
            /**
   * Add declaration if it is not exist
   */ key: "cloneBefore",
            value: function cloneBefore(decl, prop, value) {
                if (!this.already(decl, prop, value)) decl.cloneBefore({
                    prop: prop,
                    value: value
                });
            }
        },
        {
            /**
   * Check property for disabled by option
   */ key: "disabled",
            value: function disabled(prop, prefix) {
                var other = [
                    'order',
                    'justify-content',
                    'align-self',
                    'align-content'
                ];
                if (prop.includes('flex') || other.includes(prop)) {
                    if (this.prefixes.options.flexbox === false) return true;
                    if (this.prefixes.options.flexbox === 'no-2009') return prefix.includes('2009');
                }
                return undefined;
            }
        },
        {
            /**
   * Find or create separator
   */ key: "div",
            value: function div(params) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator = params[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                        var param = _step.value;
                        try {
                            for(var _iterator1 = param[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                var node = _step1.value;
                                if (node.type === 'div' && node.value === ',') return node;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return {
                    after: ' ',
                    type: 'div',
                    value: ','
                };
            }
        },
        {
            /**
   * Find property name
   */ key: "findProp",
            value: function findProp(param) {
                var prop = param[0].value;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (/^\d/.test(prop)) try {
                    for(var _iterator = param.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $21h22._)(_step.value, 2), i = _step_value[0], token = _step_value[1];
                        if (i !== 0 && token.type === 'word') return token.value;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return prop;
            }
        },
        {
            /**
   * Parse properties list to array
   */ key: "parse",
            value: function parse(value) {
                var ast = $ab01bb1e82e8e99f$exports(value);
                var result = [];
                var param = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = ast.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        param.push(node);
                        if (node.type === 'div' && node.value === ',') {
                            result.push(param);
                            param = [];
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                result.push(param);
                return result.filter(function(i) {
                    return i.length > 0;
                });
            }
        },
        {
            /**
   * Process transition and remove all unnecessary properties
   */ key: "remove",
            value: function remove(decl) {
                var _this = this;
                var params = this.parse(decl.value);
                params = params.filter(function(i) {
                    var prop = _this.prefixes.remove[_this.findProp(i)];
                    return !prop || !prop.remove;
                });
                var value = this.stringify(params);
                if (decl.value === value) return;
                if (params.length === 0) {
                    decl.remove();
                    return;
                }
                var double = decl.parent.some(function(i) {
                    return i.prop === decl.prop && i.value === value;
                });
                var smaller = decl.parent.some(function(i) {
                    return i !== decl && i.prop === decl.prop && i.value.length > value.length;
                });
                if (double || smaller) {
                    decl.remove();
                    return;
                }
                decl.value = value;
            }
        },
        {
            /**
   * Check if transition prop is inside vendor specific rule
   */ key: "ruleVendorPrefixes",
            value: function ruleVendorPrefixes(decl) {
                var parent = decl.parent;
                if (parent.type !== 'rule') return false;
                else if (!parent.selector.includes(':-')) return false;
                var selectors = $ea2b86d4fd154896$exports.prefixes().filter(function(s) {
                    return parent.selector.includes(':' + s);
                });
                return selectors.length > 0 ? selectors : false;
            }
        },
        {
            /**
   * Return properties string from array
   */ key: "stringify",
            value: function stringify(params) {
                if (params.length === 0) return '';
                var nodes = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = params[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var param = _step.value;
                        if (param[param.length - 1].type !== 'div') param.push(this.div(params));
                        nodes = nodes.concat(param);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (nodes[0].type === 'div') nodes = nodes.slice(1);
                if (nodes[nodes.length - 1].type === 'div') nodes = nodes.slice(0, -1);
                return $ab01bb1e82e8e99f$exports.stringify({
                    nodes: nodes
                });
            }
        }
    ]);
    return Transition;
}();
$5a51962e2608793a$exports = $5a51962e2608793a$var$Transition;


var $2375cb058cd26159$exports = {};

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $56181cada244c6df$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $NBk0Y = parcelRequire("NBk0Y");

var $779b0bcb8318089d$exports = {};

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $kUXlT = parcelRequire("kUXlT");
var $779b0bcb8318089d$var$OldValue = /*#__PURE__*/ function() {
    "use strict";
    function OldValue(unprefixed, prefixed, string, regexp) {
        (0, $gd0sY._)(this, OldValue);
        this.unprefixed = unprefixed;
        this.prefixed = prefixed;
        this.string = string || prefixed;
        this.regexp = regexp || $kUXlT.regexp(prefixed);
    }
    (0, $7cSld._)(OldValue, [
        {
            /**
   * Check, that value contain old value
   */ key: "check",
            value: function check(value) {
                if (value.includes(this.string)) return !!value.match(this.regexp);
                return false;
            }
        }
    ]);
    return OldValue;
}();
$779b0bcb8318089d$exports = $779b0bcb8318089d$var$OldValue;




var $kUXlT = parcelRequire("kUXlT");
var $56181cada244c6df$var$Value = /*#__PURE__*/ function(Prefixer) {
    "use strict";
    (0, $NBk0Y._)(Value, Prefixer);
    function Value() {
        (0, $gd0sY._)(this, Value);
        return (0, $8xMIM._)(this, Value, arguments);
    }
    (0, $7cSld._)(Value, [
        {
            /**
   * Save values with next prefixed token
   */ key: "add",
            value: function add(decl, prefix) {
                if (!decl._autoprefixerValues) decl._autoprefixerValues = {};
                var value = decl._autoprefixerValues[prefix] || this.value(decl);
                var before;
                do {
                    before = value;
                    value = this.replace(value, prefix);
                    if (value === false) return;
                }while (value !== before);
                decl._autoprefixerValues[prefix] = value;
            }
        },
        {
            /**
   * Is declaration need to be prefixed
   */ key: "check",
            value: function check(decl) {
                var value = decl.value;
                if (!value.includes(this.name)) return false;
                return !!value.match(this.regexp());
            }
        },
        {
            /**
   * Return function to fast find prefixed value
   */ key: "old",
            value: function old(prefix) {
                return new $779b0bcb8318089d$exports(this.name, prefix + this.name);
            }
        },
        {
            /**
   * Lazy regexp loading
   */ key: "regexp",
            value: function regexp() {
                return this.regexpCache || (this.regexpCache = $kUXlT.regexp(this.name));
            }
        },
        {
            /**
   * Add prefix to values in string
   */ key: "replace",
            value: function replace(string, prefix) {
                return string.replace(this.regexp(), "$1".concat(prefix, "$2"));
            }
        },
        {
            /**
   * Get value with comments if it was not changed
   */ key: "value",
            value: function value(decl) {
                if (decl.raws.value && decl.raws.value.value === decl.value) return decl.raws.value.raw;
                else return decl.value;
            }
        }
    ], [
        {
            key: "save",
            value: /**
   * Clone decl for each prefixed values
   */ function save(prefixes, decl) {
                var _this, _loop = function(prefix) {
                    var value = decl._autoprefixerValues[prefix];
                    if (value === decl.value) return "continue";
                    var item = void 0;
                    var propPrefix = $94d58ff1b5a11e04$exports.prefix(prop);
                    if (propPrefix === '-pie-') return "continue";
                    if (propPrefix === prefix) {
                        item = decl.value = value;
                        result.push(item);
                        return "continue";
                    }
                    var prefixed = prefixes.prefixed(prop, prefix);
                    var rule = decl.parent;
                    if (!rule.every(function(i) {
                        return i.prop !== prefixed;
                    })) {
                        result.push(item);
                        return "continue";
                    }
                    var trimmed = value.replace(/\s+/, ' ');
                    var already = rule.some(function(i) {
                        return i.prop === decl.prop && i.value.replace(/\s+/, ' ') === trimmed;
                    });
                    if (already) {
                        result.push(item);
                        return "continue";
                    }
                    var cloned = _this.clone(decl, {
                        value: value
                    });
                    item = decl.parent.insertBefore(decl, cloned);
                    result.push(item);
                };
                var prop = decl.prop;
                var result = [];
                for(var prefix in decl._autoprefixerValues)_this = this, _loop(prefix);
                return result;
            }
        }
    ]);
    return Value;
}($d3c4c5bfd4b3aa67$exports);
$56181cada244c6df$exports = $56181cada244c6df$var$Value;



var $21h22 = parcelRequire("21h22");

var $6zk1M = parcelRequire("6zk1M");
var $81b9427ee4e9e73f$export$d73ee8ef04f5226a;
var $81b9427ee4e9e73f$export$98e6a39c04603d36;
var $81b9427ee4e9e73f$export$f892fd5d935fdd16;
// Track transforms
var $81b9427ee4e9e73f$export$d0fff51f151b796a;
var $81b9427ee4e9e73f$export$3a1067fc3c14d315;
var $81b9427ee4e9e73f$export$32dc7ad492354f65;
var $81b9427ee4e9e73f$export$2e2dbd43b49fd373;
/**
 * insert prefixed grid-area declarations
 * @param  {Root}  css css root
 * @param  {Function} isDisabled check if the rule is disabled
 * @return {void}
 */ var $81b9427ee4e9e73f$export$85c52ef974811a4b;
/**
 * Warn user if grid area identifiers are not found
 * @param  {Object} areas
 * @param  {Declaration} decl
 * @param  {Result} result
 * @return {void}
 */ var $81b9427ee4e9e73f$export$ebd18cfd7527d7cf;
/**
 * compare selectors with grid-area rule and grid-template rule
 * show warning if grid-template selector is not found
 * (this function used for grid-area rule)
 * @param  {Declaration} decl
 * @param  {Result} result
 * @return {void}
 */ var $81b9427ee4e9e73f$export$d92f4f61cfc83220;
/**
 * warn user if both grid-area and grid-(row|column)
 * declarations are present in the same rule
 * @param  {Declaration} decl
 * @param  {Result} result
 * @return {void}
 */ var $81b9427ee4e9e73f$export$4da30c78ee34dafc;
// Gap utils
var $81b9427ee4e9e73f$export$3e6031d7369213a8;
/**
 * inherit grid gap values from the closest rule above
 * with the same selector
 * @param  {Declaration} decl
 * @param  {Object} gap gap values
 * @return {Object | Boolean} return gap values or false (if not found)
 */ var $81b9427ee4e9e73f$export$4c8a39d0988ac794;
var $81b9427ee4e9e73f$export$6547a7a859533ca5;
var $81b9427ee4e9e73f$export$60905d0ce9e8730b;


var $9HfAZ = parcelRequire("9HfAZ");
var $81b9427ee4e9e73f$require$list = $9HfAZ.list;

var $kUXlT = parcelRequire("kUXlT");
var $81b9427ee4e9e73f$require$uniq = $kUXlT.uniq;

var $kUXlT = parcelRequire("kUXlT");
var $81b9427ee4e9e73f$require$escapeRegexp = $kUXlT.escapeRegexp;

var $kUXlT = parcelRequire("kUXlT");
var $81b9427ee4e9e73f$require$splitSelector = $kUXlT.splitSelector;
function $81b9427ee4e9e73f$var$convert(value) {
    if (value && value.length === 2 && value[0] === 'span' && parseInt(value[1], 10) > 0) return [
        false,
        parseInt(value[1], 10)
    ];
    if (value && value.length === 1 && parseInt(value[0], 10) > 0) return [
        parseInt(value[0], 10),
        false
    ];
    return [
        false,
        false
    ];
}
$81b9427ee4e9e73f$export$d73ee8ef04f5226a = $81b9427ee4e9e73f$var$translate;
function $81b9427ee4e9e73f$var$translate(values, startIndex, endIndex) {
    var startValue = values[startIndex];
    var endValue = values[endIndex];
    if (!startValue) return [
        false,
        false
    ];
    var _convert = (0, $21h22._)($81b9427ee4e9e73f$var$convert(startValue), 2), start = _convert[0], spanStart = _convert[1];
    var _convert1 = (0, $21h22._)($81b9427ee4e9e73f$var$convert(endValue), 2), end = _convert1[0], spanEnd = _convert1[1];
    if (start && !endValue) return [
        start,
        false
    ];
    if (spanStart && end) return [
        end - spanStart,
        spanStart
    ];
    if (start && spanEnd) return [
        start,
        spanEnd
    ];
    if (start && end) return [
        start,
        end - start
    ];
    return [
        false,
        false
    ];
}
$81b9427ee4e9e73f$export$98e6a39c04603d36 = $81b9427ee4e9e73f$var$parse;
function $81b9427ee4e9e73f$var$parse(decl) {
    var node = $ab01bb1e82e8e99f$exports(decl.value);
    var values = [];
    var current = 0;
    values[current] = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = node.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var i = _step.value;
            if (i.type === 'div') {
                current += 1;
                values[current] = [];
            } else if (i.type === 'word') values[current].push(i.value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return values;
}
$81b9427ee4e9e73f$export$f892fd5d935fdd16 = $81b9427ee4e9e73f$var$insertDecl;
function $81b9427ee4e9e73f$var$insertDecl(decl, prop, value) {
    if (value && !decl.parent.some(function(i) {
        return i.prop === "-ms-".concat(prop);
    })) decl.cloneBefore({
        prop: "-ms-".concat(prop),
        value: value.toString()
    });
}
$81b9427ee4e9e73f$export$d0fff51f151b796a = $81b9427ee4e9e73f$var$prefixTrackProp;
function $81b9427ee4e9e73f$var$prefixTrackProp(param) {
    var prefix = param.prefix, prop = param.prop;
    return prefix + prop.replace('template-', '');
}
function $81b9427ee4e9e73f$var$transformRepeat(param, param1) {
    var nodes = param.nodes, gap = param1.gap;
    var _nodes_reduce = nodes.reduce(function(result, node) {
        if (node.type === 'div' && node.value === ',') result.key = 'size';
        else result[result.key].push($ab01bb1e82e8e99f$exports.stringify(node));
        return result;
    }, {
        count: [],
        key: 'count',
        size: []
    }), count = _nodes_reduce.count, size = _nodes_reduce.size;
    // insert gap values
    if (gap) {
        var _loop = function(i) {
            size.forEach(function(item, index) {
                if (index > 0 || i > 1) val.push(gap);
                val.push(item);
            });
        };
        size = size.filter(function(i) {
            return i.trim();
        });
        var val = [];
        for(var i = 1; i <= count; i++)_loop(i);
        return val.join(' ');
    }
    return "(".concat(size.join(''), ")[").concat(count.join(''), "]");
}
$81b9427ee4e9e73f$export$3a1067fc3c14d315 = $81b9427ee4e9e73f$var$prefixTrackValue;
function $81b9427ee4e9e73f$var$prefixTrackValue(param) {
    var gap = param.gap, value = param.value;
    var result = $ab01bb1e82e8e99f$exports(value).nodes.reduce(function(nodes, node) {
        if (node.type === 'function' && node.value === 'repeat') return nodes.concat({
            type: 'word',
            value: $81b9427ee4e9e73f$var$transformRepeat(node, {
                gap: gap
            })
        });
        if (gap && node.type === 'space') return nodes.concat({
            type: 'space',
            value: ' '
        }, {
            type: 'word',
            value: gap
        }, node);
        return nodes.concat(node);
    }, []);
    return $ab01bb1e82e8e99f$exports.stringify(result);
}
// Parse grid-template-areas
var $81b9427ee4e9e73f$var$DOTS = /^\.+$/;
function $81b9427ee4e9e73f$var$track(start, end) {
    return {
        end: end,
        span: end - start,
        start: start
    };
}
function $81b9427ee4e9e73f$var$getColumns(line) {
    return line.trim().split(/\s+/g);
}
$81b9427ee4e9e73f$export$32dc7ad492354f65 = $81b9427ee4e9e73f$var$parseGridAreas;
function $81b9427ee4e9e73f$var$parseGridAreas(param) {
    var gap = param.gap, rows = param.rows;
    return rows.reduce(function(areas, line, rowIndex) {
        if (gap.row) rowIndex *= 2;
        if (line.trim() === '') return areas;
        $81b9427ee4e9e73f$var$getColumns(line).forEach(function(area, columnIndex) {
            if ($81b9427ee4e9e73f$var$DOTS.test(area)) return;
            if (gap.column) columnIndex *= 2;
            if (typeof areas[area] === 'undefined') areas[area] = {
                column: $81b9427ee4e9e73f$var$track(columnIndex + 1, columnIndex + 2),
                row: $81b9427ee4e9e73f$var$track(rowIndex + 1, rowIndex + 2)
            };
            else {
                var _areas_area = areas[area], column = _areas_area.column, row = _areas_area.row;
                column.start = Math.min(column.start, columnIndex + 1);
                column.end = Math.max(column.end, columnIndex + 2);
                column.span = column.end - column.start;
                row.start = Math.min(row.start, rowIndex + 1);
                row.end = Math.max(row.end, rowIndex + 2);
                row.span = row.end - row.start;
            }
        });
        return areas;
    }, {});
}
// Parse grid-template
function $81b9427ee4e9e73f$var$testTrack(node) {
    return node.type === 'word' && /^\[.+]$/.test(node.value);
}
function $81b9427ee4e9e73f$var$verifyRowSize(result) {
    if (result.areas.length > result.rows.length) result.rows.push('auto');
    return result;
}
$81b9427ee4e9e73f$export$2e2dbd43b49fd373 = $81b9427ee4e9e73f$var$parseTemplate;
function $81b9427ee4e9e73f$var$parseTemplate(param) {
    var decl = param.decl, gap = param.gap;
    var gridTemplate = $ab01bb1e82e8e99f$exports(decl.value).nodes.reduce(function(result, node) {
        var type = node.type, value = node.value;
        if ($81b9427ee4e9e73f$var$testTrack(node) || type === 'space') return result;
        // area
        if (type === 'string') {
            result = $81b9427ee4e9e73f$var$verifyRowSize(result);
            result.areas.push(value);
        }
        // values and function
        if (type === 'word' || type === 'function') result[result.key].push($ab01bb1e82e8e99f$exports.stringify(node));
        // divider(/)
        if (type === 'div' && value === '/') {
            result.key = 'columns';
            result = $81b9427ee4e9e73f$var$verifyRowSize(result);
        }
        return result;
    }, {
        areas: [],
        columns: [],
        key: 'rows',
        rows: []
    });
    return {
        areas: $81b9427ee4e9e73f$var$parseGridAreas({
            gap: gap,
            rows: gridTemplate.areas
        }),
        columns: $81b9427ee4e9e73f$var$prefixTrackValue({
            gap: gap.column,
            value: gridTemplate.columns.join(' ')
        }),
        rows: $81b9427ee4e9e73f$var$prefixTrackValue({
            gap: gap.row,
            value: gridTemplate.rows.join(' ')
        })
    };
}
// Insert parsed grid areas
/**
 * Get an array of -ms- prefixed props and values
 * @param  {Object} [area] area object with column and row data
 * @param  {Boolean} [addRowSpan] should we add grid-column-row value?
 * @param  {Boolean} [addColumnSpan] should we add grid-column-span value?
 * @return {Array<Object>}
 */ function $81b9427ee4e9e73f$var$getMSDecls(area) {
    var addRowSpan = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, addColumnSpan = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var result = [
        {
            prop: '-ms-grid-row',
            value: String(area.row.start)
        }
    ];
    if (area.row.span > 1 || addRowSpan) result.push({
        prop: '-ms-grid-row-span',
        value: String(area.row.span)
    });
    result.push({
        prop: '-ms-grid-column',
        value: String(area.column.start)
    });
    if (area.column.span > 1 || addColumnSpan) result.push({
        prop: '-ms-grid-column-span',
        value: String(area.column.span)
    });
    return result;
}
function $81b9427ee4e9e73f$var$getParentMedia(parent) {
    if (parent.type === 'atrule' && parent.name === 'media') return parent;
    if (!parent.parent) return false;
    return $81b9427ee4e9e73f$var$getParentMedia(parent.parent);
}
/**
 * change selectors for rules with duplicate grid-areas.
 * @param  {Array<Rule>} rules
 * @param  {Array<String>} templateSelectors
 * @return {Array<Rule>} rules with changed selectors
 */ function $81b9427ee4e9e73f$var$changeDuplicateAreaSelectors(ruleSelectors, templateSelectors) {
    ruleSelectors = ruleSelectors.map(function(selector) {
        var selectorBySpace = $81b9427ee4e9e73f$require$list.space(selector);
        var selectorByComma = $81b9427ee4e9e73f$require$list.comma(selector);
        if (selectorBySpace.length > selectorByComma.length) selector = selectorBySpace.slice(-1).join('');
        return selector;
    });
    return ruleSelectors.map(function(ruleSelector) {
        var newSelector = templateSelectors.map(function(tplSelector, index) {
            var space = index === 0 ? '' : ' ';
            return "".concat(space).concat(tplSelector, " > ").concat(ruleSelector);
        });
        return newSelector;
    });
}
/**
 * check if selector of rules are equal
 * @param  {Rule} ruleA
 * @param  {Rule} ruleB
 * @return {Boolean}
 */ function $81b9427ee4e9e73f$var$selectorsEqual(ruleA, ruleB) {
    return ruleA.selectors.some(function(sel) {
        return ruleB.selectors.includes(sel);
    });
}
/**
 * Parse data from all grid-template(-areas) declarations
 * @param  {Root} css css root
 * @return {Object} parsed data
 */ function $81b9427ee4e9e73f$var$parseGridTemplatesData(css) {
    var parsed = [];
    // we walk through every grid-template(-areas) declaration and store
    // data with the same area names inside the item
    css.walkDecls(/grid-template(-areas)?$/, function(d) {
        var rule = d.parent;
        var media = $81b9427ee4e9e73f$var$getParentMedia(rule);
        var gap = $81b9427ee4e9e73f$var$getGridGap(d);
        var inheritedGap = $81b9427ee4e9e73f$var$inheritGridGap(d, gap);
        var areas = $81b9427ee4e9e73f$var$parseTemplate({
            decl: d,
            gap: inheritedGap || gap
        }).areas;
        var areaNames = Object.keys(areas);
        // skip node if it doesn't have areas
        if (areaNames.length === 0) return true;
        // check parsed array for item that include the same area names
        // return index of that item
        var index = parsed.reduce(function(acc, param, idx) {
            var allAreas = param.allAreas;
            var hasAreas = allAreas && areaNames.some(function(area) {
                return allAreas.includes(area);
            });
            return hasAreas ? idx : acc;
        }, null);
        if (index !== null) {
            // index is found, add the grid-template data to that item
            var _parsed_index = parsed[index], allAreas = _parsed_index.allAreas, rules = _parsed_index.rules;
            // check if rule has no duplicate area names
            var hasNoDuplicates = rules.some(function(r) {
                return r.hasDuplicates === false && $81b9427ee4e9e73f$var$selectorsEqual(r, rule);
            });
            var duplicatesFound = false;
            // check need to gather all duplicate area names
            var duplicateAreaNames = rules.reduce(function(acc, r) {
                if (!r.params && $81b9427ee4e9e73f$var$selectorsEqual(r, rule)) {
                    duplicatesFound = true;
                    return r.duplicateAreaNames;
                }
                if (!duplicatesFound) areaNames.forEach(function(name) {
                    if (r.areas[name]) acc.push(name);
                });
                return $81b9427ee4e9e73f$require$uniq(acc);
            }, []);
            // update grid-row/column-span values for areas with duplicate
            // area names. @see #1084 and #1146
            rules.forEach(function(r) {
                areaNames.forEach(function(name) {
                    var area = r.areas[name];
                    if (area && area.row.span !== areas[name].row.span) areas[name].row.updateSpan = true;
                    if (area && area.column.span !== areas[name].column.span) areas[name].column.updateSpan = true;
                });
            });
            parsed[index].allAreas = $81b9427ee4e9e73f$require$uniq((0, $6zk1M._)(allAreas).concat((0, $6zk1M._)(areaNames)));
            parsed[index].rules.push({
                areas: areas,
                duplicateAreaNames: duplicateAreaNames,
                hasDuplicates: !hasNoDuplicates,
                node: rule,
                params: media.params,
                selectors: rule.selectors
            });
        } else // index is NOT found, push the new item to the parsed array
        parsed.push({
            allAreas: areaNames,
            areasCount: 0,
            rules: [
                {
                    areas: areas,
                    duplicateAreaNames: [],
                    duplicateRules: [],
                    hasDuplicates: false,
                    node: rule,
                    params: media.params,
                    selectors: rule.selectors
                }
            ]
        });
        return undefined;
    });
    return parsed;
}
$81b9427ee4e9e73f$export$85c52ef974811a4b = $81b9427ee4e9e73f$var$insertAreas;
function $81b9427ee4e9e73f$var$insertAreas(css, isDisabled) {
    // parse grid-template declarations
    var gridTemplatesData = $81b9427ee4e9e73f$var$parseGridTemplatesData(css);
    // return undefined if no declarations found
    if (gridTemplatesData.length === 0) return undefined;
    // we need to store the rules that we will insert later
    var rulesToInsert = {};
    css.walkDecls('grid-area', function(gridArea) {
        var gridAreaRule = gridArea.parent;
        var hasPrefixedRow = gridAreaRule.first.prop === '-ms-grid-row';
        var gridAreaMedia = $81b9427ee4e9e73f$var$getParentMedia(gridAreaRule);
        if (isDisabled(gridArea)) return undefined;
        var gridAreaRuleIndex = css.index(gridAreaMedia || gridAreaRule);
        var value = gridArea.value;
        // found the data that matches grid-area identifier
        var data = gridTemplatesData.filter(function(d) {
            return d.allAreas.includes(value);
        })[0];
        if (!data) return true;
        var lastArea = data.allAreas[data.allAreas.length - 1];
        var selectorBySpace = $81b9427ee4e9e73f$require$list.space(gridAreaRule.selector);
        var selectorByComma = $81b9427ee4e9e73f$require$list.comma(gridAreaRule.selector);
        var selectorIsComplex = selectorBySpace.length > 1 && selectorBySpace.length > selectorByComma.length;
        // prevent doubling of prefixes
        if (hasPrefixedRow) return false;
        // create the empty object with the key as the last area name
        // e.g if we have templates with "a b c" values, "c" will be the last area
        if (!rulesToInsert[lastArea]) rulesToInsert[lastArea] = {};
        var lastRuleIsSet = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var rule = _step.value;
                var area = rule.areas[value];
                var hasDuplicateName = rule.duplicateAreaNames.includes(value);
                // if we can't find the area name, update lastRule and continue
                if (!area) {
                    var lastRule = rulesToInsert[lastArea].lastRule;
                    var lastRuleIndex = void 0;
                    if (lastRule) lastRuleIndex = css.index(lastRule);
                    else /* c8 ignore next 2 */ lastRuleIndex = -1;
                    if (gridAreaRuleIndex > lastRuleIndex) rulesToInsert[lastArea].lastRule = gridAreaMedia || gridAreaRule;
                    return "continue";
                }
                // for grid-templates inside media rule we need to create empty
                // array to push prefixed grid-area rules later
                if (rule.params && !rulesToInsert[lastArea][rule.params]) rulesToInsert[lastArea][rule.params] = [];
                if ((!rule.hasDuplicates || !hasDuplicateName) && !rule.params) {
                    // grid-template has no duplicates and not inside media rule
                    $81b9427ee4e9e73f$var$getMSDecls(area, false, false).reverse().forEach(function(i) {
                        return gridAreaRule.prepend(Object.assign(i, {
                            raws: {
                                between: gridArea.raws.between
                            }
                        }));
                    });
                    rulesToInsert[lastArea].lastRule = gridAreaRule;
                    lastRuleIsSet = true;
                } else if (rule.hasDuplicates && !rule.params && !selectorIsComplex) {
                    // grid-template has duplicates and not inside media rule
                    var cloned = gridAreaRule.clone();
                    cloned.removeAll();
                    $81b9427ee4e9e73f$var$getMSDecls(area, area.row.updateSpan, area.column.updateSpan).reverse().forEach(function(i) {
                        return cloned.prepend(Object.assign(i, {
                            raws: {
                                between: gridArea.raws.between
                            }
                        }));
                    });
                    cloned.selectors = $81b9427ee4e9e73f$var$changeDuplicateAreaSelectors(cloned.selectors, rule.selectors);
                    if (rulesToInsert[lastArea].lastRule) rulesToInsert[lastArea].lastRule.after(cloned);
                    rulesToInsert[lastArea].lastRule = cloned;
                    lastRuleIsSet = true;
                } else if (rule.hasDuplicates && !rule.params && selectorIsComplex && gridAreaRule.selector.includes(rule.selectors[0])) {
                    // grid-template has duplicates and not inside media rule
                    // and the selector is complex
                    gridAreaRule.walkDecls(/-ms-grid-(row|column)/, function(d) {
                        return d.remove();
                    });
                    $81b9427ee4e9e73f$var$getMSDecls(area, area.row.updateSpan, area.column.updateSpan).reverse().forEach(function(i) {
                        return gridAreaRule.prepend(Object.assign(i, {
                            raws: {
                                between: gridArea.raws.between
                            }
                        }));
                    });
                } else if (rule.params) {
                    // grid-template is inside media rule
                    // if we're inside media rule, we need to store prefixed rules
                    // inside rulesToInsert object to be able to preserve the order of media
                    // rules and merge them easily
                    var cloned1 = gridAreaRule.clone();
                    cloned1.removeAll();
                    $81b9427ee4e9e73f$var$getMSDecls(area, area.row.updateSpan, area.column.updateSpan).reverse().forEach(function(i) {
                        return cloned1.prepend(Object.assign(i, {
                            raws: {
                                between: gridArea.raws.between
                            }
                        }));
                    });
                    if (rule.hasDuplicates && hasDuplicateName) cloned1.selectors = $81b9427ee4e9e73f$var$changeDuplicateAreaSelectors(cloned1.selectors, rule.selectors);
                    cloned1.raws = rule.node.raws;
                    if (css.index(rule.node.parent) > gridAreaRuleIndex) // append the prefixed rules right inside media rule
                    // with grid-template
                    rule.node.parent.append(cloned1);
                    else // store the rule to insert later
                    rulesToInsert[lastArea][rule.params].push(cloned1);
                    // set new rule as last rule ONLY if we didn't set lastRule for
                    // this grid-area before
                    if (!lastRuleIsSet) rulesToInsert[lastArea].lastRule = gridAreaMedia || gridAreaRule;
                }
            };
            // walk through every grid-template rule data
            for(var _iterator = data.rules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return undefined;
    });
    // append stored rules inside the media rules
    Object.keys(rulesToInsert).forEach(function(area) {
        var data = rulesToInsert[area];
        var lastRule = data.lastRule;
        Object.keys(data).reverse().filter(function(p) {
            return p !== 'lastRule';
        }).forEach(function(params) {
            if (data[params].length > 0 && lastRule) {
                lastRule.after({
                    name: 'media',
                    params: params
                });
                lastRule.next().append(data[params]);
            }
        });
    });
    return undefined;
}
$81b9427ee4e9e73f$export$ebd18cfd7527d7cf = $81b9427ee4e9e73f$var$warnMissedAreas;
function $81b9427ee4e9e73f$var$warnMissedAreas(areas, decl, result) {
    var missed = Object.keys(areas);
    decl.root().walkDecls('grid-area', function(gridArea) {
        missed = missed.filter(function(e) {
            return e !== gridArea.value;
        });
    });
    if (missed.length > 0) decl.warn(result, 'Can not find grid areas: ' + missed.join(', '));
    return undefined;
}
$81b9427ee4e9e73f$export$d92f4f61cfc83220 = $81b9427ee4e9e73f$var$warnTemplateSelectorNotFound;
function $81b9427ee4e9e73f$var$warnTemplateSelectorNotFound(decl, result) {
    var rule = decl.parent;
    var root = decl.root();
    var duplicatesFound = false;
    // slice selector array. Remove the last part (for comparison)
    var slicedSelectorArr = $81b9427ee4e9e73f$require$list.space(rule.selector).filter(function(str) {
        return str !== '>';
    }).slice(0, -1);
    // we need to compare only if selector is complex.
    // e.g '.grid-cell' is simple, but '.parent > .grid-cell' is complex
    if (slicedSelectorArr.length > 0) {
        var gridTemplateFound = false;
        var foundAreaSelector = null;
        root.walkDecls(/grid-template(-areas)?$/, function(d) {
            var parent = d.parent;
            var templateSelectors = parent.selectors;
            var areas = $81b9427ee4e9e73f$var$parseTemplate({
                decl: d,
                gap: $81b9427ee4e9e73f$var$getGridGap(d)
            }).areas;
            var hasArea = areas[decl.value];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                // find the the matching selectors
                for(var _iterator = templateSelectors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var tplSelector = _step.value;
                    if (gridTemplateFound) break;
                    var tplSelectorArr = $81b9427ee4e9e73f$require$list.space(tplSelector).filter(function(str) {
                        return str !== '>';
                    });
                    gridTemplateFound = tplSelectorArr.every(function(item, idx) {
                        return item === slicedSelectorArr[idx];
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (gridTemplateFound || !hasArea) return true;
            if (!foundAreaSelector) foundAreaSelector = parent.selector;
            // if we found the duplicate area with different selector
            if (foundAreaSelector && foundAreaSelector !== parent.selector) duplicatesFound = true;
            return undefined;
        });
        // warn user if we didn't find template
        if (!gridTemplateFound && duplicatesFound) decl.warn(result, 'Autoprefixer cannot find a grid-template ' + 'containing the duplicate grid-area "'.concat(decl.value, '" ') + "with full selector matching: ".concat(slicedSelectorArr.join(' ')));
    }
}
$81b9427ee4e9e73f$export$4da30c78ee34dafc = $81b9427ee4e9e73f$var$warnIfGridRowColumnExists;
function $81b9427ee4e9e73f$var$warnIfGridRowColumnExists(decl, result) {
    var rule = decl.parent;
    var decls = [];
    rule.walkDecls(/^grid-(row|column)/, function(d) {
        if (!d.prop.endsWith('-end') && !d.value.startsWith('span') && !d.prop.endsWith('-gap')) decls.push(d);
    });
    if (decls.length > 0) decls.forEach(function(d) {
        d.warn(result, 'You already have a grid-area declaration present in the rule. ' + "You should use either grid-area or ".concat(d.prop, ", not both"));
    });
    return undefined;
}
$81b9427ee4e9e73f$export$3e6031d7369213a8 = $81b9427ee4e9e73f$var$getGridGap;
function $81b9427ee4e9e73f$var$getGridGap(decl) {
    var gap = {};
    // try to find gap
    var testGap = /^(grid-)?((row|column)-)?gap$/;
    decl.parent.walkDecls(testGap, function(param) {
        var prop = param.prop, value = param.value;
        if (/^(grid-)?gap$/.test(prop)) {
            var _parser_nodes = (0, $21h22._)($ab01bb1e82e8e99f$exports(value).nodes, 3), row = _parser_nodes[0], column = _parser_nodes[2];
            gap.row = row && $ab01bb1e82e8e99f$exports.stringify(row);
            gap.column = column ? $ab01bb1e82e8e99f$exports.stringify(column) : gap.row;
        }
        if (/^(grid-)?row-gap$/.test(prop)) gap.row = value;
        if (/^(grid-)?column-gap$/.test(prop)) gap.column = value;
    });
    return gap;
}
/**
 * parse media parameters (for example 'min-width: 500px')
 * @param  {String} params parameter to parse
 * @return {}
 */ function $81b9427ee4e9e73f$var$parseMediaParams(params) {
    if (!params) return [];
    var parsed = $ab01bb1e82e8e99f$exports(params);
    var prop;
    var value;
    parsed.walk(function(node) {
        if (node.type === 'word' && /min|max/g.test(node.value)) prop = node.value;
        else if (node.value.includes('px')) value = parseInt(node.value.replace(/\D/g, ''));
    });
    return [
        prop,
        value
    ];
}
/**
 * Compare the selectors and decide if we
 * need to inherit gap from compared selector or not.
 * @type {String} selA
 * @type {String} selB
 * @return {Boolean}
 */ function $81b9427ee4e9e73f$var$shouldInheritGap(selA, selB) {
    var result;
    // get arrays of selector split in 3-deep array
    var splitSelectorArrA = $81b9427ee4e9e73f$require$splitSelector(selA);
    var splitSelectorArrB = $81b9427ee4e9e73f$require$splitSelector(selB);
    if (splitSelectorArrA[0].length < splitSelectorArrB[0].length) // abort if selectorA has lower descendant specificity then selectorB
    // (e.g '.grid' and '.hello .world .grid')
    return false;
    else if (splitSelectorArrA[0].length > splitSelectorArrB[0].length) {
        // if selectorA has higher descendant specificity then selectorB
        // (e.g '.foo .bar .grid' and '.grid')
        var idx = splitSelectorArrA[0].reduce(function(res, param, index) {
            var _param = (0, $21h22._)(param, 1), item = _param[0];
            var firstSelectorPart = splitSelectorArrB[0][0][0];
            if (item === firstSelectorPart) return index;
            return false;
        }, false);
        if (idx) result = splitSelectorArrB[0].every(function(arr, index) {
            return arr.every(function(part, innerIndex) {
                return(// because selectorA has more space elements, we need to slice
                // selectorA array by 'idx' number to compare them
                splitSelectorArrA[0].slice(idx)[index][innerIndex] === part);
            });
        });
    } else // if selectorA has the same descendant specificity as selectorB
    // this condition covers cases such as: '.grid.foo.bar' and '.grid'
    result = splitSelectorArrB.some(function(byCommaArr) {
        return byCommaArr.every(function(bySpaceArr, index) {
            return bySpaceArr.every(function(part, innerIndex) {
                return splitSelectorArrA[0][index][innerIndex] === part;
            });
        });
    });
    return result;
}
$81b9427ee4e9e73f$export$4c8a39d0988ac794 = $81b9427ee4e9e73f$var$inheritGridGap;
function $81b9427ee4e9e73f$var$inheritGridGap(decl, gap) {
    var rule = decl.parent;
    var mediaRule = $81b9427ee4e9e73f$var$getParentMedia(rule);
    var root = rule.root();
    // get an array of selector split in 3-deep array
    var splitSelectorArr = $81b9427ee4e9e73f$require$splitSelector(rule.selector);
    // abort if the rule already has gaps
    if (Object.keys(gap).length > 0) return false;
    // e.g ['min-width']
    var _parseMediaParams = (0, $21h22._)($81b9427ee4e9e73f$var$parseMediaParams(mediaRule.params), 1), prop = _parseMediaParams[0];
    var lastBySpace = splitSelectorArr[0];
    // get escaped value from the selector
    // if we have '.grid-2.foo.bar' selector, will be '\.grid\-2'
    var escaped = $81b9427ee4e9e73f$require$escapeRegexp(lastBySpace[lastBySpace.length - 1][0]);
    var regexp = new RegExp("(".concat(escaped, "$)|(").concat(escaped, "[,.])"));
    // find the closest rule with the same selector
    var closestRuleGap;
    root.walkRules(regexp, function(r) {
        var gridGap;
        // abort if are checking the same rule
        if (rule.toString() === r.toString()) return false;
        // find grid-gap values
        r.walkDecls('grid-gap', function(d) {
            return gridGap = $81b9427ee4e9e73f$var$getGridGap(d);
        });
        // skip rule without gaps
        if (!gridGap || Object.keys(gridGap).length === 0) return true;
        // skip rules that should not be inherited from
        if (!$81b9427ee4e9e73f$var$shouldInheritGap(rule.selector, r.selector)) return true;
        var media = $81b9427ee4e9e73f$var$getParentMedia(r);
        if (media) {
            // if we are inside media, we need to check that media props match
            // e.g ('min-width' === 'min-width')
            var propToCompare = $81b9427ee4e9e73f$var$parseMediaParams(media.params)[0];
            if (propToCompare === prop) {
                closestRuleGap = gridGap;
                return true;
            }
        } else {
            closestRuleGap = gridGap;
            return true;
        }
        return undefined;
    });
    // if we find the closest gap object
    if (closestRuleGap && Object.keys(closestRuleGap).length > 0) return closestRuleGap;
    return false;
}
$81b9427ee4e9e73f$export$6547a7a859533ca5 = $81b9427ee4e9e73f$var$warnGridGap;
function $81b9427ee4e9e73f$var$warnGridGap(param) {
    var decl = param.decl, gap = param.gap, hasColumns = param.hasColumns, result = param.result;
    var hasBothGaps = gap.row && gap.column;
    if (!hasColumns && (hasBothGaps || gap.column && !gap.row)) {
        delete gap.column;
        decl.warn(result, 'Can not implement grid-gap without grid-template-columns');
    }
}
/**
 * normalize the grid-template-rows/columns values
 * @param  {String} str grid-template-rows/columns value
 * @return {Array} normalized array with values
 * @example
 * let normalized = normalizeRowColumn('1fr repeat(2, 20px 50px) 1fr')
 * normalized // <= ['1fr', '20px', '50px', '20px', '50px', '1fr']
 */ function $81b9427ee4e9e73f$var$normalizeRowColumn(str) {
    var normalized = $ab01bb1e82e8e99f$exports(str).nodes.reduce(function(result, node) {
        if (node.type === 'function' && node.value === 'repeat') {
            var key = 'count';
            var _node_nodes_reduce = (0, $21h22._)(node.nodes.reduce(function(acc, n) {
                if (n.type === 'word' && key === 'count') {
                    acc[0] = Math.abs(parseInt(n.value));
                    return acc;
                }
                if (n.type === 'div' && n.value === ',') {
                    key = 'value';
                    return acc;
                }
                if (key === 'value') acc[1] += $ab01bb1e82e8e99f$exports.stringify(n);
                return acc;
            }, [
                0,
                ''
            ]), 2), count = _node_nodes_reduce[0], value = _node_nodes_reduce[1];
            if (count) for(var i = 0; i < count; i++)result.push(value);
            return result;
        }
        if (node.type === 'space') return result;
        return result.concat($ab01bb1e82e8e99f$exports.stringify(node));
    }, []);
    return normalized;
}
$81b9427ee4e9e73f$export$60905d0ce9e8730b = $81b9427ee4e9e73f$var$autoplaceGridItems;
/**
 * Autoplace grid items
 * @param {Declaration} decl
 * @param {Result} result
 * @param {Object} gap gap values
 * @param {String} autoflowValue grid-auto-flow value
 * @return {void}
 * @see https://github.com/postcss/autoprefixer/issues/1148
 */ function $81b9427ee4e9e73f$var$autoplaceGridItems(decl, result, gap) {
    var autoflowValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 'row';
    var parent = decl.parent;
    var rowDecl = parent.nodes.find(function(i) {
        return i.prop === 'grid-template-rows';
    });
    var rows = $81b9427ee4e9e73f$var$normalizeRowColumn(rowDecl.value);
    var columns = $81b9427ee4e9e73f$var$normalizeRowColumn(decl.value);
    // Build array of area names with dummy values. If we have 3 columns and
    // 2 rows, filledRows will be equal to ['1 2 3', '4 5 6']
    var filledRows = rows.map(function(_, rowIndex) {
        return Array.from({
            length: columns.length
        }, function(v, k) {
            return k + rowIndex * columns.length + 1;
        }).join(' ');
    });
    var areas = $81b9427ee4e9e73f$var$parseGridAreas({
        gap: gap,
        rows: filledRows
    });
    var keys = Object.keys(areas);
    var items = keys.map(function(i) {
        return areas[i];
    });
    // Change the order of cells if grid-auto-flow value is 'column'
    if (autoflowValue.includes('column')) items = items.sort(function(a, b) {
        return a.column.start - b.column.start;
    });
    // Insert new rules
    items.reverse().forEach(function(item, index) {
        var column = item.column, row = item.row;
        var nodeSelector = parent.selectors.map(function(sel) {
            return sel + " > *:nth-child(".concat(keys.length - index, ")");
        }).join(', ');
        // create new rule
        var node = parent.clone().removeAll();
        // change rule selector
        node.selector = nodeSelector;
        // insert prefixed row/column values
        node.append({
            prop: '-ms-grid-row',
            value: row.start
        });
        node.append({
            prop: '-ms-grid-column',
            value: column.start
        });
        // insert rule
        parent.after(node);
    });
    return undefined;
}


var $2375cb058cd26159$require$insertAreas = $81b9427ee4e9e73f$export$85c52ef974811a4b;
var $2375cb058cd26159$var$OLD_LINEAR = /(^|[^-])linear-gradient\(\s*(top|left|right|bottom)/i;
var $2375cb058cd26159$var$OLD_RADIAL = /(^|[^-])radial-gradient\(\s*\d+(\w*|%)\s+\d+(\w*|%)\s*,/i;
var $2375cb058cd26159$var$IGNORE_NEXT = /(!\s*)?autoprefixer:\s*ignore\s+next/i;
var $2375cb058cd26159$var$GRID_REGEX = /(!\s*)?autoprefixer\s*grid:\s*(on|off|(no-)?autoplace)/i;
var $2375cb058cd26159$var$SIZES = [
    'width',
    'height',
    'min-width',
    'max-width',
    'min-height',
    'max-height',
    'inline-size',
    'min-inline-size',
    'max-inline-size',
    'block-size',
    'min-block-size',
    'max-block-size'
];
function $2375cb058cd26159$var$hasGridTemplate(decl) {
    return decl.parent.some(function(i) {
        return i.prop === 'grid-template' || i.prop === 'grid-template-areas';
    });
}
function $2375cb058cd26159$var$hasRowsAndColumns(decl) {
    var hasRows = decl.parent.some(function(i) {
        return i.prop === 'grid-template-rows';
    });
    var hasColumns = decl.parent.some(function(i) {
        return i.prop === 'grid-template-columns';
    });
    return hasRows && hasColumns;
}
var $2375cb058cd26159$var$Processor = /*#__PURE__*/ function() {
    "use strict";
    function Processor(prefixes) {
        (0, $gd0sY._)(this, Processor);
        this.prefixes = prefixes;
    }
    (0, $7cSld._)(Processor, [
        {
            /**
   * Add necessary prefixes
   */ key: "add",
            value: function add(css, result) {
                var _this = this;
                // At-rules
                var resolution = this.prefixes.add['@resolution'];
                var keyframes = this.prefixes.add['@keyframes'];
                var viewport = this.prefixes.add['@viewport'];
                var supports = this.prefixes.add['@supports'];
                css.walkAtRules(function(rule) {
                    if (rule.name === 'keyframes') {
                        if (!_this.disabled(rule, result)) return keyframes && keyframes.process(rule);
                    } else if (rule.name === 'viewport') {
                        if (!_this.disabled(rule, result)) return viewport && viewport.process(rule);
                    } else if (rule.name === 'supports') {
                        if (_this.prefixes.options.supports !== false && !_this.disabled(rule, result)) return supports.process(rule);
                    } else if (rule.name === 'media' && rule.params.includes('-resolution')) {
                        if (!_this.disabled(rule, result)) return resolution && resolution.process(rule);
                    }
                    return undefined;
                });
                // Selectors
                css.walkRules(function(rule) {
                    if (_this.disabled(rule, result)) return undefined;
                    return _this.prefixes.add.selectors.map(function(selector) {
                        return selector.process(rule, result);
                    });
                });
                function insideGrid(decl) {
                    return decl.parent.nodes.some(function(node) {
                        if (node.type !== 'decl') return false;
                        var displayGrid = node.prop === 'display' && /(inline-)?grid/.test(node.value);
                        var gridTemplate = node.prop.startsWith('grid-template');
                        var gridGap = /^grid-([A-z]+-)?gap/.test(node.prop);
                        return displayGrid || gridTemplate || gridGap;
                    });
                }
                function insideFlex(decl) {
                    return decl.parent.some(function(node) {
                        return node.prop === 'display' && /(inline-)?flex/.test(node.value);
                    });
                }
                var gridPrefixes = this.gridStatus(css, result) && this.prefixes.add['grid-area'] && this.prefixes.add['grid-area'].prefixes;
                css.walkDecls(function(decl) {
                    if (_this.disabledDecl(decl, result)) return undefined;
                    var parent = decl.parent;
                    var prop = decl.prop;
                    var value = decl.value;
                    if (prop === 'color-adjust') {
                        if (parent.every(function(i) {
                            return i.prop !== 'print-color-adjust';
                        })) result.warn("Replace color-adjust to print-color-adjust. The color-adjust shorthand is currently deprecated.", {
                            node: decl
                        });
                    } else if (prop === 'grid-row-span') {
                        result.warn('grid-row-span is not part of final Grid Layout. Use grid-row.', {
                            node: decl
                        });
                        return undefined;
                    } else if (prop === 'grid-column-span') {
                        result.warn('grid-column-span is not part of final Grid Layout. Use grid-column.', {
                            node: decl
                        });
                        return undefined;
                    } else if (prop === 'display' && value === 'box') {
                        result.warn("You should write display: flex by final spec instead of display: box", {
                            node: decl
                        });
                        return undefined;
                    } else if (prop === 'text-emphasis-position') {
                        if (value === 'under' || value === 'over') result.warn("You should use 2 values for text-emphasis-position For example, `under left` instead of just `under`.", {
                            node: decl
                        });
                    } else if (/^(align|justify|place)-(items|content)$/.test(prop) && insideFlex(decl)) {
                        if (value === 'start' || value === 'end') result.warn("".concat(value, " value has mixed support, consider using ") + "flex-".concat(value, " instead"), {
                            node: decl
                        });
                    } else if (prop === 'text-decoration-skip' && value === 'ink') result.warn("Replace text-decoration-skip: ink to text-decoration-skip-ink: auto, because spec had been changed", {
                        node: decl
                    });
                    else {
                        if (gridPrefixes && _this.gridStatus(decl, result)) {
                            if (decl.value === 'subgrid') result.warn('IE does not support subgrid', {
                                node: decl
                            });
                            if (/^(align|justify|place)-items$/.test(prop) && insideGrid(decl)) {
                                var fixed = prop.replace('-items', '-self');
                                result.warn("IE does not support ".concat(prop, " on grid containers. ") + "Try using ".concat(fixed, " on child elements instead: ") + "".concat(decl.parent.selector, " > * { ").concat(fixed, ": ").concat(decl.value, " }"), {
                                    node: decl
                                });
                            } else if (/^(align|justify|place)-content$/.test(prop) && insideGrid(decl)) result.warn("IE does not support ".concat(decl.prop, " on grid containers"), {
                                node: decl
                            });
                            else if (prop === 'display' && decl.value === 'contents') {
                                result.warn("Please do not use display: contents; if you have grid setting enabled", {
                                    node: decl
                                });
                                return undefined;
                            } else if (decl.prop === 'grid-gap') {
                                var status = _this.gridStatus(decl, result);
                                if (status === 'autoplace' && !$2375cb058cd26159$var$hasRowsAndColumns(decl) && !$2375cb058cd26159$var$hasGridTemplate(decl)) result.warn("grid-gap only works if grid-template(-areas) is being used or both rows and columns have been declared and cells have not been manually placed inside the explicit grid", {
                                    node: decl
                                });
                                else if ((status === true || status === 'no-autoplace') && !$2375cb058cd26159$var$hasGridTemplate(decl)) result.warn('grid-gap only works if grid-template(-areas) is being used', {
                                    node: decl
                                });
                            } else if (prop === 'grid-auto-columns') {
                                result.warn('grid-auto-columns is not supported by IE', {
                                    node: decl
                                });
                                return undefined;
                            } else if (prop === 'grid-auto-rows') {
                                result.warn('grid-auto-rows is not supported by IE', {
                                    node: decl
                                });
                                return undefined;
                            } else if (prop === 'grid-auto-flow') {
                                var hasRows = parent.some(function(i) {
                                    return i.prop === 'grid-template-rows';
                                });
                                var hasCols = parent.some(function(i) {
                                    return i.prop === 'grid-template-columns';
                                });
                                if ($2375cb058cd26159$var$hasGridTemplate(decl)) result.warn('grid-auto-flow is not supported by IE', {
                                    node: decl
                                });
                                else if (value.includes('dense')) result.warn('grid-auto-flow: dense is not supported by IE', {
                                    node: decl
                                });
                                else if (!hasRows && !hasCols) result.warn("grid-auto-flow works only if grid-template-rows and grid-template-columns are present in the same rule", {
                                    node: decl
                                });
                                return undefined;
                            } else if (value.includes('auto-fit')) {
                                result.warn('auto-fit value is not supported by IE', {
                                    node: decl,
                                    word: 'auto-fit'
                                });
                                return undefined;
                            } else if (value.includes('auto-fill')) {
                                result.warn('auto-fill value is not supported by IE', {
                                    node: decl,
                                    word: 'auto-fill'
                                });
                                return undefined;
                            } else if (prop.startsWith('grid-template') && value.includes('[')) result.warn("Autoprefixer currently does not support line names. Try using grid-template-areas instead.", {
                                node: decl,
                                word: '['
                            });
                        }
                        if (value.includes('radial-gradient')) {
                            if ($2375cb058cd26159$var$OLD_RADIAL.test(decl.value)) result.warn("Gradient has outdated direction syntax. New syntax is like `closest-side at 0 0` instead of `0 0, closest-side`.", {
                                node: decl
                            });
                            else {
                                var ast = $ab01bb1e82e8e99f$exports(value);
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = ast.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var i = _step.value;
                                        if (i.type === 'function' && i.value === 'radial-gradient') {
                                            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                            try {
                                                for(var _iterator1 = i.nodes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                                    var word = _step1.value;
                                                    if (word.type === 'word') {
                                                        if (word.value === 'cover') result.warn("Gradient has outdated direction syntax. Replace `cover` to `farthest-corner`.", {
                                                            node: decl
                                                        });
                                                        else if (word.value === 'contain') result.warn("Gradient has outdated direction syntax. Replace `contain` to `closest-side`.", {
                                                            node: decl
                                                        });
                                                    }
                                                }
                                            } catch (err) {
                                                _didIteratorError1 = true;
                                                _iteratorError1 = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                        _iterator1.return();
                                                    }
                                                } finally{
                                                    if (_didIteratorError1) {
                                                        throw _iteratorError1;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                        }
                        if (value.includes('linear-gradient')) {
                            if ($2375cb058cd26159$var$OLD_LINEAR.test(value)) result.warn("Gradient has outdated direction syntax. New syntax is like `to left` instead of `right`.", {
                                node: decl
                            });
                        }
                    }
                    if ($2375cb058cd26159$var$SIZES.includes(decl.prop)) {
                        if (!decl.value.includes('-fill-available')) {
                            if (decl.value.includes('fill-available')) result.warn("Replace fill-available to stretch, because spec had been changed", {
                                node: decl
                            });
                            else if (decl.value.includes('fill')) {
                                var ast1 = $ab01bb1e82e8e99f$exports(value);
                                if (ast1.nodes.some(function(i) {
                                    return i.type === 'word' && i.value === 'fill';
                                })) result.warn('Replace fill to stretch, because spec had been changed', {
                                    node: decl
                                });
                            }
                        }
                    }
                    var prefixer;
                    if (decl.prop === 'transition' || decl.prop === 'transition-property') // Transition
                    return _this.prefixes.transition.add(decl, result);
                    else if (decl.prop === 'align-self') {
                        // align-self flexbox or grid
                        var display = _this.displayType(decl);
                        if (display !== 'grid' && _this.prefixes.options.flexbox !== false) {
                            prefixer = _this.prefixes.add['align-self'];
                            if (prefixer && prefixer.prefixes) prefixer.process(decl);
                        }
                        if (_this.gridStatus(decl, result) !== false) {
                            prefixer = _this.prefixes.add['grid-row-align'];
                            if (prefixer && prefixer.prefixes) return prefixer.process(decl, result);
                        }
                    } else if (decl.prop === 'justify-self') // justify-self flexbox or grid
                    {
                        if (_this.gridStatus(decl, result) !== false) {
                            prefixer = _this.prefixes.add['grid-column-align'];
                            if (prefixer && prefixer.prefixes) return prefixer.process(decl, result);
                        }
                    } else if (decl.prop === 'place-self') {
                        prefixer = _this.prefixes.add['place-self'];
                        if (prefixer && prefixer.prefixes && _this.gridStatus(decl, result) !== false) return prefixer.process(decl, result);
                    } else {
                        // Properties
                        prefixer = _this.prefixes.add[decl.prop];
                        if (prefixer && prefixer.prefixes) return prefixer.process(decl, result);
                    }
                    return undefined;
                });
                // Insert grid-area prefixes. We need to be able to store the different
                // rules as a data and hack API is not enough for this
                if (this.gridStatus(css, result)) $2375cb058cd26159$require$insertAreas(css, this.disabled);
                // Values
                return css.walkDecls(function(decl) {
                    if (_this.disabledValue(decl, result)) return;
                    var unprefixed = _this.prefixes.unprefixed(decl.prop);
                    var list = _this.prefixes.values('add', unprefixed);
                    if (Array.isArray(list)) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var value = _step.value;
                                if (value.process) value.process(decl, result);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                    $56181cada244c6df$exports.save(_this.prefixes, decl);
                });
            }
        },
        {
            /**
   * Check for control comment and global options
   */ key: "disabled",
            value: function disabled(node, result) {
                if (!node) return false;
                if (node._autoprefixerDisabled !== undefined) return node._autoprefixerDisabled;
                if (node.parent) {
                    var p = node.prev();
                    if (p && p.type === 'comment' && $2375cb058cd26159$var$IGNORE_NEXT.test(p.text)) {
                        node._autoprefixerDisabled = true;
                        node._autoprefixerSelfDisabled = true;
                        return true;
                    }
                }
                var value = null;
                if (node.nodes) {
                    var status;
                    node.each(function(i) {
                        if (i.type !== 'comment') return;
                        if (/(!\s*)?autoprefixer:\s*(off|on)/i.test(i.text)) {
                            if (typeof status !== 'undefined') result.warn("Second Autoprefixer control comment was ignored. Autoprefixer applies control comment to whole block, not to next rules.", {
                                node: i
                            });
                            else status = /on/i.test(i.text);
                        }
                    });
                    if (status !== undefined) value = !status;
                }
                if (!node.nodes || value === null) {
                    if (node.parent) {
                        var isParentDisabled = this.disabled(node.parent, result);
                        if (node.parent._autoprefixerSelfDisabled === true) value = false;
                        else value = isParentDisabled;
                    } else value = false;
                }
                node._autoprefixerDisabled = value;
                return value;
            }
        },
        {
            /**
   * Check for grid/flexbox options.
   */ key: "disabledDecl",
            value: function disabledDecl(node, result) {
                if (node.type === 'decl' && this.gridStatus(node, result) === false) {
                    if (node.prop.includes('grid') || node.prop === 'justify-items') return true;
                }
                if (node.type === 'decl' && this.prefixes.options.flexbox === false) {
                    var other = [
                        'order',
                        'justify-content',
                        'align-items',
                        'align-content'
                    ];
                    if (node.prop.includes('flex') || other.includes(node.prop)) return true;
                }
                return this.disabled(node, result);
            }
        },
        {
            /**
   * Check for grid/flexbox options.
   */ key: "disabledValue",
            value: function disabledValue(node, result) {
                if (this.gridStatus(node, result) === false && node.type === 'decl') {
                    if (node.prop === 'display' && node.value.includes('grid')) return true;
                }
                if (this.prefixes.options.flexbox === false && node.type === 'decl') {
                    if (node.prop === 'display' && node.value.includes('flex')) return true;
                }
                if (node.type === 'decl' && node.prop === 'content') return true;
                return this.disabled(node, result);
            }
        },
        {
            /**
   * Is it flebox or grid rule
   */ key: "displayType",
            value: function displayType(decl) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = decl.parent.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        if (i.prop !== 'display') continue;
                        if (i.value.includes('flex')) return 'flex';
                        if (i.value.includes('grid')) return 'grid';
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return false;
            }
        },
        {
            /**
   * Set grid option via control comment
   */ key: "gridStatus",
            value: function gridStatus(node, result) {
                if (!node) return false;
                if (node._autoprefixerGridStatus !== undefined) return node._autoprefixerGridStatus;
                var value = null;
                if (node.nodes) {
                    var status;
                    node.each(function(i) {
                        if (i.type !== 'comment') return;
                        if ($2375cb058cd26159$var$GRID_REGEX.test(i.text)) {
                            var hasAutoplace = /:\s*autoplace/i.test(i.text);
                            var noAutoplace = /no-autoplace/i.test(i.text);
                            if (typeof status !== 'undefined') result.warn("Second Autoprefixer grid control comment was ignored. Autoprefixer applies control comments to the whole block, not to the next rules.", {
                                node: i
                            });
                            else if (hasAutoplace) status = 'autoplace';
                            else if (noAutoplace) status = true;
                            else status = /on/i.test(i.text);
                        }
                    });
                    if (status !== undefined) value = status;
                }
                if (node.type === 'atrule' && node.name === 'supports') {
                    var params = node.params;
                    if (params.includes('grid') && params.includes('auto')) value = false;
                }
                if (!node.nodes || value === null) {
                    if (node.parent) {
                        var isParentGrid = this.gridStatus(node.parent, result);
                        if (node.parent._autoprefixerSelfDisabled === true) value = false;
                        else value = isParentGrid;
                    } else if (typeof this.prefixes.options.grid !== 'undefined') value = this.prefixes.options.grid;
                    else value = false;
                }
                node._autoprefixerGridStatus = value;
                return value;
            }
        },
        {
            /**
   * Normalize spaces in cascade declaration group
   */ key: "reduceSpaces",
            value: function reduceSpaces(decl) {
                var stop = false;
                this.prefixes.group(decl).up(function() {
                    stop = true;
                    return true;
                });
                if (stop) return;
                var parts = decl.raw('before').split('\n');
                var prevMin = parts[parts.length - 1].length;
                var diff = false;
                this.prefixes.group(decl).down(function(other) {
                    parts = other.raw('before').split('\n');
                    var last = parts.length - 1;
                    if (parts[last].length > prevMin) {
                        if (diff === false) diff = parts[last].length - prevMin;
                        parts[last] = parts[last].slice(0, -diff);
                        other.raws.before = parts.join('\n');
                    }
                });
            }
        },
        {
            /**
   * Remove unnecessary pefixes
   */ key: "remove",
            value: function remove(css, result) {
                var _this = this;
                // At-rules
                var resolution = this.prefixes.remove['@resolution'];
                css.walkAtRules(function(rule, i) {
                    if (_this.prefixes.remove["@".concat(rule.name)]) {
                        if (!_this.disabled(rule, result)) rule.parent.removeChild(i);
                    } else if (rule.name === 'media' && rule.params.includes('-resolution') && resolution) resolution.clean(rule);
                });
                // Selectors
                css.walkRules(function(rule, i) {
                    if (_this.disabled(rule, result)) return;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = _this.prefixes.remove.selectors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var checker = _step.value;
                            if (checker.check(rule)) {
                                rule.parent.removeChild(i);
                                return;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                });
                return css.walkDecls(function(decl, i) {
                    if (_this.disabled(decl, result)) return;
                    var rule = decl.parent;
                    var unprefixed = _this.prefixes.unprefixed(decl.prop);
                    // Transition
                    if (decl.prop === 'transition' || decl.prop === 'transition-property') _this.prefixes.transition.remove(decl);
                    // Properties
                    if (_this.prefixes.remove[decl.prop] && _this.prefixes.remove[decl.prop].remove) {
                        var notHack = _this.prefixes.group(decl).down(function(other) {
                            return _this.prefixes.normalize(other.prop) === unprefixed;
                        });
                        if (unprefixed === 'flex-flow') notHack = true;
                        if (decl.prop === '-webkit-box-orient') {
                            var hacks = {
                                'flex-direction': true,
                                'flex-flow': true
                            };
                            if (!decl.parent.some(function(j) {
                                return hacks[j.prop];
                            })) return;
                        }
                        if (notHack && !_this.withHackValue(decl)) {
                            if (decl.raw('before').includes('\n')) _this.reduceSpaces(decl);
                            rule.removeChild(i);
                            return;
                        }
                    }
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        // Values
                        for(var _iterator = _this.prefixes.values('remove', unprefixed)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var checker = _step.value;
                            if (!checker.check) continue;
                            if (!checker.check(decl.value)) continue;
                            unprefixed = checker.unprefixed;
                            var notHack1 = _this.prefixes.group(decl).down(function(other) {
                                return other.value.includes(unprefixed);
                            });
                            if (notHack1) {
                                rule.removeChild(i);
                                return;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                });
            }
        },
        {
            /**
   * Some rare old values, which is not in standard
   */ key: "withHackValue",
            value: function withHackValue(decl) {
                return decl.prop === '-webkit-background-clip' && decl.value === 'text';
            }
        }
    ]);
    return Processor;
}();
$2375cb058cd26159$exports = $2375cb058cd26159$var$Processor;


var $a71b3b39412ff195$exports = {};

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $21h22 = parcelRequire("21h22");

var $2bfPH = parcelRequire("2bfPH");
var $60ec01baac3d0319$exports = {};
$60ec01baac3d0319$exports = {
    A: {
        A: {
            "2": "_E"
        },
        B: {
            "1": "_J"
        },
        C: {
            "1": "_RI",
            "2": "_CF"
        },
        D: {
            "1": "_gO",
            "2": "_lJ"
        },
        E: {
            "1": "_PB",
            "2": "_TB"
        },
        F: {
            "1": "_xF",
            "2": "_WE"
        },
        G: {
            "1": "_p",
            "2": "_2"
        },
        H: {
            "1": "vD"
        },
        I: {
            "1": "_X",
            "2": "_W"
        },
        J: {
            "2": "_B"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "2": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_F"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "_C"
        }
    },
    B: 4,
    C: "CSS Feature Queries",
    D: true
};


var $4fda570b3fd0830f$exports = {};
'use strict';
var $277ed23eed744b16$exports = {};
$277ed23eed744b16$exports = {
    1: 'ls',
    2: 'rec',
    3: 'pr',
    4: 'cr',
    5: 'wd',
    6: 'other',
    7: 'unoff' // Unofficial, Editor's Draft or W3C "Note"
};


var $901cbcc32836e132$exports = {};
$901cbcc32836e132$exports = {
    y: 1,
    n: 2,
    a: 4,
    p: 8,
    u: 16,
    x: 32,
    d: 64
};



var $4fda570b3fd0830f$require$browsers = $edbba1c0bab79d6e$export$804348712f697b1b;

var $4fda570b3fd0830f$require$versions = $7bc55b293d284941$export$e0222f875ebd697e;
var $69b596ef3d7f1377$export$3b9f80dd42b72157;

$69b596ef3d7f1377$export$3b9f80dd42b72157 = (parcelRequire("9JzRC"));


var $4fda570b3fd0830f$require$versionGroups = $69b596ef3d7f1377$export$3b9f80dd42b72157;
var $4fda570b3fd0830f$var$MATH2LOG = Math.log(2);
var $4fda570b3fd0830f$var$groupCache = {};
function $4fda570b3fd0830f$var$expandKey(key) {
    var cached = $4fda570b3fd0830f$var$groupCache[key];
    if (cached === undefined) cached = $4fda570b3fd0830f$var$groupCache[key] = $4fda570b3fd0830f$var$expandGroups($4fda570b3fd0830f$require$versionGroups[key], []);
    return cached;
}
function $4fda570b3fd0830f$var$expandGroups(value, out) {
    var start = 0;
    for(var i = 0, len = value.length; i <= len; i++)if (i === len || value.charCodeAt(i) === 32) {
        if (i > start) {
            if (value.charCodeAt(start) === 95) {
                var group = $4fda570b3fd0830f$var$expandKey(value.slice(start + 1, i));
                for(var j = 0; j < group.length; j++)out.push(group[j]);
            } else out.push(value.slice(start, i));
        }
        start = i + 1;
    }
    return out;
}
function $4fda570b3fd0830f$var$unpackSupport(cipher) {
    // bit flags
    var stats = Object.keys($901cbcc32836e132$exports).reduce(function(list, support) {
        if (cipher & $901cbcc32836e132$exports[support]) list.push(support);
        return list;
    }, []);
    // notes
    var notes = cipher >> 7;
    var notesArray = [];
    while(notes){
        var note = Math.floor(Math.log(notes) / $4fda570b3fd0830f$var$MATH2LOG) + 1;
        notesArray.unshift("#".concat(note));
        notes -= Math.pow(2, note - 1);
    }
    return stats.concat(notesArray).join(' ');
}
function $4fda570b3fd0830f$var$unpackFeature(packed) {
    var unpacked = {
        status: $277ed23eed744b16$exports[packed.B],
        title: packed.C,
        shown: packed.D
    };
    unpacked.stats = Object.keys(packed.A).reduce(function(browserStats, key) {
        var browser = packed.A[key];
        browserStats[$4fda570b3fd0830f$require$browsers[key]] = Object.keys(browser).reduce(function(stats, support) {
            var packedVersions = $4fda570b3fd0830f$var$expandGroups(browser[support], []);
            var unpacked2 = $4fda570b3fd0830f$var$unpackSupport(support);
            packedVersions.forEach(function(v) {
                return stats[$4fda570b3fd0830f$require$versions[v]] = unpacked2;
            });
            return stats;
        }, {});
        return browserStats;
    }, {});
    return unpacked;
}
$4fda570b3fd0830f$exports = $4fda570b3fd0830f$var$unpackFeature;
$4fda570b3fd0830f$exports.default = $4fda570b3fd0830f$var$unpackFeature;



var $9HfAZ = parcelRequire("9HfAZ");
var $a71b3b39412ff195$require$parse = $9HfAZ.parse;

var $ea0a310f2792c151$exports = {};

var $2bfPH = parcelRequire("2bfPH");
function $ea0a310f2792c151$var$last(array) {
    return array[array.length - 1];
}
var $ea0a310f2792c151$var$brackets = {
    /**
   * Parse string to nodes tree
   */ parse: function(str) {
        var current = [
            ''
        ];
        var stack = [
            current
        ];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = str[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var sym = _step.value;
                if (sym === '(') {
                    current = [
                        ''
                    ];
                    $ea0a310f2792c151$var$last(stack).push(current);
                    stack.push(current);
                    continue;
                }
                if (sym === ')') {
                    stack.pop();
                    current = $ea0a310f2792c151$var$last(stack);
                    current.push('');
                    continue;
                }
                current[current.length - 1] += sym;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return stack[0];
    },
    /**
   * Generate output string by nodes tree
   */ stringify: function(ast) {
        var result = '';
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = ast[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var i = _step.value;
                if ((typeof i === "undefined" ? "undefined" : (0, $2bfPH._)(i)) === 'object') {
                    result += "(".concat($ea0a310f2792c151$var$brackets.stringify(i), ")");
                    continue;
                }
                result += i;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return result;
    }
};
$ea0a310f2792c151$exports = $ea0a310f2792c151$var$brackets;




var $kUXlT = parcelRequire("kUXlT");
var $a71b3b39412ff195$var$data = $4fda570b3fd0830f$exports($60ec01baac3d0319$exports);
var $a71b3b39412ff195$var$supported = [];
for(var $a71b3b39412ff195$var$browser in $a71b3b39412ff195$var$data.stats){
    var $a71b3b39412ff195$var$versions = $a71b3b39412ff195$var$data.stats[$a71b3b39412ff195$var$browser];
    for(var $a71b3b39412ff195$var$version in $a71b3b39412ff195$var$versions){
        var $a71b3b39412ff195$var$support = $a71b3b39412ff195$var$versions[$a71b3b39412ff195$var$version];
        if (/y/.test($a71b3b39412ff195$var$support)) $a71b3b39412ff195$var$supported.push($a71b3b39412ff195$var$browser + ' ' + $a71b3b39412ff195$var$version);
    }
}
var $a71b3b39412ff195$var$Supports = /*#__PURE__*/ function() {
    "use strict";
    function Supports(Prefixes, all) {
        (0, $gd0sY._)(this, Supports);
        this.Prefixes = Prefixes;
        this.all = all;
    }
    (0, $7cSld._)(Supports, [
        {
            /**
   * Add prefixes
   */ key: "add",
            value: function add(nodes, all) {
                var _this = this;
                return nodes.map(function(i) {
                    if (_this.isProp(i)) {
                        var prefixed = _this.prefixed(i[0]);
                        if (prefixed.length > 1) return _this.convert(prefixed);
                        return i;
                    }
                    if ((typeof i === "undefined" ? "undefined" : (0, $2bfPH._)(i)) === 'object') return _this.add(i, all);
                    return i;
                });
            }
        },
        {
            /**
   * Clean brackets with one child
   */ key: "cleanBrackets",
            value: function cleanBrackets(nodes) {
                var _this = this;
                return nodes.map(function(i) {
                    if ((typeof i === "undefined" ? "undefined" : (0, $2bfPH._)(i)) !== 'object') return i;
                    if (i.length === 1 && (0, $2bfPH._)(i[0]) === 'object') return _this.cleanBrackets(i[0]);
                    return _this.cleanBrackets(i);
                });
            }
        },
        {
            /**
   * Add " or " between properties and convert it to brackets format
   */ key: "convert",
            value: function convert(progress) {
                var result = [
                    ''
                ];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = progress[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        result.push([
                            "".concat(i.prop, ": ").concat(i.value)
                        ]);
                        result.push(' or ');
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                result[result.length - 1] = '';
                return result;
            }
        },
        {
            /**
   * Check global options
   */ key: "disabled",
            value: function disabled(node) {
                if (!this.all.options.grid) {
                    if (node.prop === 'display' && node.value.includes('grid')) return true;
                    if (node.prop.includes('grid') || node.prop === 'justify-items') return true;
                }
                if (this.all.options.flexbox === false) {
                    if (node.prop === 'display' && node.value.includes('flex')) return true;
                    var other = [
                        'order',
                        'justify-content',
                        'align-items',
                        'align-content'
                    ];
                    if (node.prop.includes('flex') || other.includes(node.prop)) return true;
                }
                return false;
            }
        },
        {
            /**
   * Return true if prefixed property has no unprefixed
   */ key: "isHack",
            value: function isHack(all, unprefixed) {
                var check = new RegExp("(\\(|\\s)".concat($kUXlT.escapeRegexp(unprefixed), ":"));
                return !check.test(all);
            }
        },
        {
            /**
   * Return true if brackets node is "not" word
   */ key: "isNot",
            value: function isNot(node) {
                return typeof node === 'string' && /not\s*/i.test(node);
            }
        },
        {
            /**
   * Return true if brackets node is "or" word
   */ key: "isOr",
            value: function isOr(node) {
                return typeof node === 'string' && /\s*or\s*/i.test(node);
            }
        },
        {
            /**
   * Return true if brackets node is (prop: value)
   */ key: "isProp",
            value: function isProp(node) {
                return (typeof node === "undefined" ? "undefined" : (0, $2bfPH._)(node)) === 'object' && node.length === 1 && typeof node[0] === 'string';
            }
        },
        {
            /**
   * Compress value functions into a string nodes
   */ key: "normalize",
            value: function normalize(nodes) {
                var _this = this;
                if ((typeof nodes === "undefined" ? "undefined" : (0, $2bfPH._)(nodes)) !== 'object') return nodes;
                nodes = nodes.filter(function(i) {
                    return i !== '';
                });
                if (typeof nodes[0] === 'string') {
                    var firstNode = nodes[0].trim();
                    if (firstNode.includes(':') || firstNode === 'selector' || firstNode === 'not selector') return [
                        $ea0a310f2792c151$exports.stringify(nodes)
                    ];
                }
                return nodes.map(function(i) {
                    return _this.normalize(i);
                });
            }
        },
        {
            /**
   * Parse string into declaration property and value
   */ key: "parse",
            value: function parse(str) {
                var parts = str.split(':');
                var prop = parts[0];
                var value = parts[1];
                if (!value) value = '';
                return [
                    prop.trim(),
                    value.trim()
                ];
            }
        },
        {
            /**
   * Return array of Declaration with all necessary prefixes
   */ key: "prefixed",
            value: function prefixed(str) {
                var rule = this.virtual(str);
                if (this.disabled(rule.first)) return rule.nodes;
                var result = {
                    warn: function() {
                        return null;
                    }
                };
                var prefixer = this.prefixer().add[rule.first.prop];
                prefixer && prefixer.process && prefixer.process(rule.first, result);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = rule.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var decl = _step.value;
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = this.prefixer().values('add', rule.first.prop)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var value = _step1.value;
                                value.process(decl);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        $56181cada244c6df$exports.save(this.all, decl);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return rule.nodes;
            }
        },
        {
            /**
   * Return prefixer only with @supports supported browsers
   */ key: "prefixer",
            value: function prefixer() {
                if (this.prefixerCache) return this.prefixerCache;
                var filtered = this.all.browsers.selected.filter(function(i) {
                    return $a71b3b39412ff195$var$supported.includes(i);
                });
                var browsers = new $ea2b86d4fd154896$exports(this.all.browsers.data, filtered, this.all.options);
                this.prefixerCache = new this.Prefixes(this.all.data, browsers, this.all.options);
                return this.prefixerCache;
            }
        },
        {
            /**
   * Add prefixed declaration
   */ key: "process",
            value: function process(rule) {
                var ast = $ea0a310f2792c151$exports.parse(rule.params);
                ast = this.normalize(ast);
                ast = this.remove(ast, rule.params);
                ast = this.add(ast, rule.params);
                ast = this.cleanBrackets(ast);
                rule.params = $ea0a310f2792c151$exports.stringify(ast);
            }
        },
        {
            /**
   * Remove all unnecessary prefixes
   */ key: "remove",
            value: function remove(nodes, all) {
                var i = 0;
                while(i < nodes.length){
                    if (!this.isNot(nodes[i - 1]) && this.isProp(nodes[i]) && this.isOr(nodes[i + 1])) {
                        if (this.toRemove(nodes[i][0], all)) {
                            nodes.splice(i, 2);
                            continue;
                        }
                        i += 2;
                        continue;
                    }
                    if ((0, $2bfPH._)(nodes[i]) === 'object') nodes[i] = this.remove(nodes[i], all);
                    i += 1;
                }
                return nodes;
            }
        },
        {
            /**
   * Return true if we need to remove node
   */ key: "toRemove",
            value: function toRemove(str, all) {
                var _this_parse = (0, $21h22._)(this.parse(str), 2), prop = _this_parse[0], value = _this_parse[1];
                var unprefixed = this.all.unprefixed(prop);
                var cleaner = this.all.cleaner();
                if (cleaner.remove[prop] && cleaner.remove[prop].remove && !this.isHack(all, unprefixed)) return true;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = cleaner.values('remove', unprefixed)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var checker = _step.value;
                        if (checker.check(value)) return true;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return false;
            }
        },
        {
            /**
   * Create virtual rule to process it by prefixer
   */ key: "virtual",
            value: function virtual(str) {
                var _this_parse = (0, $21h22._)(this.parse(str), 2), prop = _this_parse[0], value = _this_parse[1];
                var rule = $a71b3b39412ff195$require$parse('a{}').first;
                rule.append({
                    prop: prop,
                    raws: {
                        before: ''
                    },
                    value: value
                });
                return rule;
            }
        }
    ]);
    return Supports;
}();
$a71b3b39412ff195$exports = $a71b3b39412ff195$var$Supports;



var $9f31103710b4d9bb$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $NBk0Y = parcelRequire("NBk0Y");

var $9HfAZ = parcelRequire("9HfAZ");
var $9f31103710b4d9bb$require$list = $9HfAZ.list;
var $bcb4e312e30a5212$exports = {};

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $21h22 = parcelRequire("21h22");
var $bcb4e312e30a5212$var$OldSelector = /*#__PURE__*/ function() {
    "use strict";
    function OldSelector(selector, prefix) {
        (0, $gd0sY._)(this, OldSelector);
        this.prefix = prefix;
        this.prefixed = selector.prefixed(this.prefix);
        this.regexp = selector.regexp(this.prefix);
        this.prefixeds = selector.possible().map(function(x) {
            return [
                selector.prefixed(x),
                selector.regexp(x)
            ];
        });
        this.unprefixed = selector.name;
        this.nameRegexp = selector.regexp();
    }
    (0, $7cSld._)(OldSelector, [
        {
            /**
   * Does rule contain an unnecessary prefixed selector
   */ key: "check",
            value: function check(rule) {
                if (!rule.selector.includes(this.prefixed)) return false;
                if (!rule.selector.match(this.regexp)) return false;
                if (this.isHack(rule)) return false;
                return true;
            }
        },
        {
            /**
   * Is rule a hack without unprefixed version bottom
   */ key: "isHack",
            value: function isHack(rule) {
                var index = rule.parent.index(rule) + 1;
                var rules = rule.parent.nodes;
                while(index < rules.length){
                    var before = rules[index].selector;
                    if (!before) return true;
                    if (before.includes(this.unprefixed) && before.match(this.nameRegexp)) return false;
                    var some = false;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this.prefixeds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $21h22._)(_step.value, 2), string = _step_value[0], regexp = _step_value[1];
                            if (before.includes(string) && before.match(regexp)) {
                                some = true;
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (!some) return true;
                    index += 1;
                }
                return true;
            }
        }
    ]);
    return OldSelector;
}();
$bcb4e312e30a5212$exports = $bcb4e312e30a5212$var$OldSelector;





var $kUXlT = parcelRequire("kUXlT");
var $9f31103710b4d9bb$var$Selector = /*#__PURE__*/ function(Prefixer) {
    "use strict";
    (0, $NBk0Y._)(Selector, Prefixer);
    function Selector(name, prefixes, all) {
        (0, $gd0sY._)(this, Selector);
        var _this;
        _this = (0, $8xMIM._)(this, Selector, [
            name,
            prefixes,
            all
        ]);
        _this.regexpCache = new Map();
        return _this;
    }
    (0, $7cSld._)(Selector, [
        {
            /**
   * Clone and add prefixes for at-rule
   */ key: "add",
            value: function add(rule, prefix) {
                var prefixeds = this.prefixeds(rule);
                if (this.already(rule, prefixeds, prefix)) return;
                var cloned = this.clone(rule, {
                    selector: prefixeds[this.name][prefix]
                });
                rule.parent.insertBefore(rule, cloned);
            }
        },
        {
            /**
   * Is rule already prefixed before
   */ key: "already",
            value: function already(rule, prefixeds, prefix) {
                var index = rule.parent.index(rule) - 1;
                while(index >= 0){
                    var before = rule.parent.nodes[index];
                    if (before.type !== 'rule') return false;
                    var some = false;
                    for(var key in prefixeds[this.name]){
                        var prefixed = prefixeds[this.name][key];
                        if (before.selector === prefixed) {
                            if (prefix === key) return true;
                            else {
                                some = true;
                                break;
                            }
                        }
                    }
                    if (!some) return false;
                    index -= 1;
                }
                return false;
            }
        },
        {
            /**
   * Is rule selectors need to be prefixed
   */ key: "check",
            value: function check(rule) {
                if (rule.selector.includes(this.name)) return !!rule.selector.match(this.regexp());
                return false;
            }
        },
        {
            /**
   * Return function to fast find prefixed selector
   */ key: "old",
            value: function old(prefix) {
                return new $bcb4e312e30a5212$exports(this, prefix);
            }
        },
        {
            /**
   * All possible prefixes
   */ key: "possible",
            value: function possible() {
                return $ea2b86d4fd154896$exports.prefixes();
            }
        },
        {
            /**
   * Return prefixed version of selector
   */ key: "prefixed",
            value: function prefixed(prefix) {
                return this.name.replace(/^(\W*)/, "$1".concat(prefix));
            }
        },
        {
            /**
   * Return all possible selector prefixes
   */ key: "prefixeds",
            value: function prefixeds(rule) {
                var _this = this;
                if (rule._autoprefixerPrefixeds) {
                    if (rule._autoprefixerPrefixeds[this.name]) return rule._autoprefixerPrefixeds;
                } else rule._autoprefixerPrefixeds = {};
                var prefixeds = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (rule.selector.includes(',')) {
                    var ruleParts = $9f31103710b4d9bb$require$list.comma(rule.selector);
                    var toProcess = ruleParts.filter(function(el) {
                        return el.includes(_this.name);
                    });
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        var _loop = function() {
                            var prefix = _step.value;
                            prefixeds[prefix] = toProcess.map(function(el) {
                                return _this.replace(el, prefix);
                            }).join(', ');
                        };
                        for(var _iterator = this.possible()[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true)_loop();
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                } else try {
                    for(var _iterator1 = this.possible()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                        var prefix = _step1.value;
                        prefixeds[prefix] = this.replace(rule.selector, prefix);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                rule._autoprefixerPrefixeds[this.name] = prefixeds;
                return rule._autoprefixerPrefixeds;
            }
        },
        {
            /**
   * Lazy loadRegExp for name
   */ key: "regexp",
            value: function regexp(prefix) {
                if (!this.regexpCache.has(prefix)) {
                    var name = prefix ? this.prefixed(prefix) : this.name;
                    this.regexpCache.set(prefix, new RegExp("(^|[^:\"'=])".concat($kUXlT.escapeRegexp(name)), 'gi'));
                }
                return this.regexpCache.get(prefix);
            }
        },
        {
            /**
   * Replace selectors by prefixed one
   */ key: "replace",
            value: function replace(selector, prefix) {
                return selector.replace(this.regexp(), "$1".concat(this.prefixed(prefix)));
            }
        }
    ]);
    return Selector;
}($d3c4c5bfd4b3aa67$exports);
$9f31103710b4d9bb$exports = $9f31103710b4d9bb$var$Selector;


var $a2f40f00934e75d0$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $NBk0Y = parcelRequire("NBk0Y");

var $a2f40f00934e75d0$var$AtRule = /*#__PURE__*/ function(Prefixer) {
    "use strict";
    (0, $NBk0Y._)(AtRule, Prefixer);
    function AtRule() {
        (0, $gd0sY._)(this, AtRule);
        return (0, $8xMIM._)(this, AtRule, arguments);
    }
    (0, $7cSld._)(AtRule, [
        {
            /**
   * Clone and add prefixes for at-rule
   */ key: "add",
            value: function add(rule, prefix) {
                var prefixed = prefix + rule.name;
                var already = rule.parent.some(function(i) {
                    return i.name === prefixed && i.params === rule.params;
                });
                if (already) return undefined;
                var cloned = this.clone(rule, {
                    name: prefixed
                });
                return rule.parent.insertBefore(rule, cloned);
            }
        },
        {
            /**
   * Clone node with prefixes
   */ key: "process",
            value: function process(node) {
                var parent = this.parentPrefix(node);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.prefixes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var prefix = _step.value;
                        if (!parent || parent === prefix) this.add(node, prefix);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ]);
    return AtRule;
}($d3c4c5bfd4b3aa67$exports);
$a2f40f00934e75d0$exports = $a2f40f00934e75d0$var$AtRule;




var $kUXlT = parcelRequire("kUXlT");
var $6732067c6a2054e9$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $NBk0Y = parcelRequire("NBk0Y");

var $6732067c6a2054e9$var$Fullscreen = /*#__PURE__*/ function(Selector) {
    "use strict";
    (0, $NBk0Y._)(Fullscreen, Selector);
    function Fullscreen() {
        (0, $gd0sY._)(this, Fullscreen);
        return (0, $8xMIM._)(this, Fullscreen, arguments);
    }
    (0, $7cSld._)(Fullscreen, [
        {
            /**
   * Return different selectors depend on prefix
   */ key: "prefixed",
            value: function prefixed(prefix) {
                if (prefix === '-webkit-') return ':-webkit-full-screen';
                if (prefix === '-moz-') return ':-moz-full-screen';
                return ":".concat(prefix, "fullscreen");
            }
        }
    ]);
    return Fullscreen;
}($9f31103710b4d9bb$exports);
$6732067c6a2054e9$var$Fullscreen.names = [
    ':fullscreen'
];
$6732067c6a2054e9$exports = $6732067c6a2054e9$var$Fullscreen;


var $8e625ba5d471e5f7$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $8e625ba5d471e5f7$var$Placeholder = /*#__PURE__*/ function(Selector) {
    "use strict";
    (0, $NBk0Y._)(Placeholder, Selector);
    function Placeholder() {
        (0, $gd0sY._)(this, Placeholder);
        return (0, $8xMIM._)(this, Placeholder, arguments);
    }
    (0, $7cSld._)(Placeholder, [
        {
            /**
   * Add old mozilla to possible prefixes
   */ key: "possible",
            value: function possible() {
                return (0, $bl6Nv._)((0, $7GsX9._)(Placeholder.prototype), "possible", this).call(this).concat([
                    '-moz- old',
                    '-ms- old'
                ]);
            }
        },
        {
            /**
   * Return different selectors depend on prefix
   */ key: "prefixed",
            value: function prefixed(prefix) {
                if (prefix === '-webkit-') return '::-webkit-input-placeholder';
                if (prefix === '-ms-') return '::-ms-input-placeholder';
                if (prefix === '-ms- old') return ':-ms-input-placeholder';
                if (prefix === '-moz- old') return ':-moz-placeholder';
                return "::".concat(prefix, "placeholder");
            }
        }
    ]);
    return Placeholder;
}($9f31103710b4d9bb$exports);
$8e625ba5d471e5f7$var$Placeholder.names = [
    '::placeholder'
];
$8e625ba5d471e5f7$exports = $8e625ba5d471e5f7$var$Placeholder;


var $7c082376409caaa5$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $NBk0Y = parcelRequire("NBk0Y");

var $7c082376409caaa5$var$PlaceholderShown = /*#__PURE__*/ function(Selector) {
    "use strict";
    (0, $NBk0Y._)(PlaceholderShown, Selector);
    function PlaceholderShown() {
        (0, $gd0sY._)(this, PlaceholderShown);
        return (0, $8xMIM._)(this, PlaceholderShown, arguments);
    }
    (0, $7cSld._)(PlaceholderShown, [
        {
            /**
   * Return different selectors depend on prefix
   */ key: "prefixed",
            value: function prefixed(prefix) {
                if (prefix === '-ms-') return ':-ms-input-placeholder';
                return ":".concat(prefix, "placeholder-shown");
            }
        }
    ]);
    return PlaceholderShown;
}($9f31103710b4d9bb$exports);
$7c082376409caaa5$var$PlaceholderShown.names = [
    ':placeholder-shown'
];
$7c082376409caaa5$exports = $7c082376409caaa5$var$PlaceholderShown;


var $b156425e822aa8a2$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $NBk0Y = parcelRequire("NBk0Y");


var $kUXlT = parcelRequire("kUXlT");
var $b156425e822aa8a2$var$FileSelectorButton = /*#__PURE__*/ function(Selector) {
    "use strict";
    (0, $NBk0Y._)(FileSelectorButton, Selector);
    function FileSelectorButton(name, prefixes, all) {
        (0, $gd0sY._)(this, FileSelectorButton);
        var _this;
        _this = (0, $8xMIM._)(this, FileSelectorButton, [
            name,
            prefixes,
            all
        ]);
        if (_this.prefixes) _this.prefixes = $kUXlT.uniq(_this.prefixes.map(function() {
            return '-webkit-';
        }));
        return _this;
    }
    (0, $7cSld._)(FileSelectorButton, [
        {
            /**
   * Return different selectors depend on prefix
   */ key: "prefixed",
            value: function prefixed(prefix) {
                if (prefix === '-webkit-') return '::-webkit-file-upload-button';
                return "::".concat(prefix, "file-selector-button");
            }
        }
    ]);
    return FileSelectorButton;
}($9f31103710b4d9bb$exports);
$b156425e822aa8a2$var$FileSelectorButton.names = [
    '::file-selector-button'
];
$b156425e822aa8a2$exports = $b156425e822aa8a2$var$FileSelectorButton;


var $a1cf2ca7108eb247$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $21h22 = parcelRequire("21h22");

var $9HfAZ = parcelRequire("9HfAZ");
var $a1cf2ca7108eb247$require$list = $9HfAZ.list;
var $10265dcab8e82ebe$exports = {};
/**
 * Return flexbox spec versions by prefix
 */ $10265dcab8e82ebe$exports = function(prefix) {
    var spec;
    if (prefix === '-webkit- 2009' || prefix === '-moz-') spec = 2009;
    else if (prefix === '-ms-') spec = 2012;
    else if (prefix === '-webkit-') spec = 'final';
    if (prefix === '-webkit- 2009') prefix = '-webkit-';
    return [
        spec,
        prefix
    ];
};



var $a1cf2ca7108eb247$var$Flex = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(Flex, Declaration);
    function Flex() {
        (0, $gd0sY._)(this, Flex);
        return (0, $8xMIM._)(this, Flex, arguments);
    }
    (0, $7cSld._)(Flex, [
        {
            /**
   * Return property name by final spec
   */ key: "normalize",
            value: function normalize() {
                return 'flex';
            }
        },
        {
            /**
   * Change property name for 2009 spec
   */ key: "prefixed",
            value: function prefixed(prop, prefix) {
                var spec;
                var ref;
                ref = (0, $21h22._)($10265dcab8e82ebe$exports(prefix), 2), spec = ref[0], prefix = ref[1], ref;
                if (spec === 2009) return prefix + 'box-flex';
                return (0, $bl6Nv._)((0, $7GsX9._)(Flex.prototype), "prefixed", this).call(this, prop, prefix);
            }
        },
        {
            /**
   * Spec 2009 supports only first argument
   * Spec 2012 disallows unitless basis
   */ key: "set",
            value: function set(decl, prefix) {
                var spec = $10265dcab8e82ebe$exports(prefix)[0];
                if (spec === 2009) {
                    decl.value = $a1cf2ca7108eb247$require$list.space(decl.value)[0];
                    decl.value = Flex.oldValues[decl.value] || decl.value;
                    return (0, $bl6Nv._)((0, $7GsX9._)(Flex.prototype), "set", this).call(this, decl, prefix);
                }
                if (spec === 2012) {
                    var components = $a1cf2ca7108eb247$require$list.space(decl.value);
                    if (components.length === 3 && components[2] === '0') decl.value = components.slice(0, 2).concat('0px').join(' ');
                }
                return (0, $bl6Nv._)((0, $7GsX9._)(Flex.prototype), "set", this).call(this, decl, prefix);
            }
        }
    ]);
    return Flex;
}($8a1dfa5624408614$exports);
$a1cf2ca7108eb247$var$Flex.names = [
    'flex',
    'box-flex'
];
$a1cf2ca7108eb247$var$Flex.oldValues = {
    auto: '1',
    none: '0'
};
$a1cf2ca7108eb247$exports = $a1cf2ca7108eb247$var$Flex;


var $2f23323476dd0ba5$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $21h22 = parcelRequire("21h22");


var $2f23323476dd0ba5$var$Order = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(Order, Declaration);
    function Order() {
        (0, $gd0sY._)(this, Order);
        return (0, $8xMIM._)(this, Order, arguments);
    }
    (0, $7cSld._)(Order, [
        {
            /**
   * Return property name by final spec
   */ key: "normalize",
            value: function normalize() {
                return 'order';
            }
        },
        {
            /**
   * Change property name for 2009 and 2012 specs
   */ key: "prefixed",
            value: function prefixed(prop, prefix) {
                var spec;
                var ref;
                ref = (0, $21h22._)($10265dcab8e82ebe$exports(prefix), 2), spec = ref[0], prefix = ref[1], ref;
                if (spec === 2009) return prefix + 'box-ordinal-group';
                if (spec === 2012) return prefix + 'flex-order';
                return (0, $bl6Nv._)((0, $7GsX9._)(Order.prototype), "prefixed", this).call(this, prop, prefix);
            }
        },
        {
            /**
   * Fix value for 2009 spec
   */ key: "set",
            value: function set(decl, prefix) {
                var spec = $10265dcab8e82ebe$exports(prefix)[0];
                if (spec === 2009 && /\d/.test(decl.value)) {
                    decl.value = (parseInt(decl.value) + 1).toString();
                    return (0, $bl6Nv._)((0, $7GsX9._)(Order.prototype), "set", this).call(this, decl, prefix);
                }
                return (0, $bl6Nv._)((0, $7GsX9._)(Order.prototype), "set", this).call(this, decl, prefix);
            }
        }
    ]);
    return Order;
}($8a1dfa5624408614$exports);
$2f23323476dd0ba5$var$Order.names = [
    'order',
    'flex-order',
    'box-ordinal-group'
];
$2f23323476dd0ba5$exports = $2f23323476dd0ba5$var$Order;


var $ec6cca6f69603464$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $NBk0Y = parcelRequire("NBk0Y");

var $ec6cca6f69603464$var$Filter = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(Filter, Declaration);
    function Filter() {
        (0, $gd0sY._)(this, Filter);
        return (0, $8xMIM._)(this, Filter, arguments);
    }
    (0, $7cSld._)(Filter, [
        {
            /**
   * Check is it Internet Explorer filter
   */ key: "check",
            value: function check(decl) {
                var v = decl.value;
                return !v.toLowerCase().includes('alpha(') && !v.includes('DXImageTransform.Microsoft') && !v.includes('data:image/svg+xml');
            }
        }
    ]);
    return Filter;
}($8a1dfa5624408614$exports);
$ec6cca6f69603464$var$Filter.names = [
    'filter'
];
$ec6cca6f69603464$exports = $ec6cca6f69603464$var$Filter;


var $d61dae07a41516e2$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");


var $kUXlT = parcelRequire("kUXlT");
var $d61dae07a41516e2$require$isPureNumber = $kUXlT.isPureNumber;
var $d61dae07a41516e2$var$GridEnd = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(GridEnd, Declaration);
    function GridEnd() {
        (0, $gd0sY._)(this, GridEnd);
        return (0, $8xMIM._)(this, GridEnd, arguments);
    }
    (0, $7cSld._)(GridEnd, [
        {
            /**
   * Change repeating syntax for IE
   */ key: "insert",
            value: function insert(decl, prefix, prefixes, result) {
                if (prefix !== '-ms-') return (0, $bl6Nv._)((0, $7GsX9._)(GridEnd.prototype), "insert", this).call(this, decl, prefix, prefixes);
                var clonedDecl = this.clone(decl);
                var startProp = decl.prop.replace(/end$/, 'start');
                var spanProp = prefix + decl.prop.replace(/end$/, 'span');
                if (decl.parent.some(function(i) {
                    return i.prop === spanProp;
                })) return undefined;
                clonedDecl.prop = spanProp;
                if (decl.value.includes('span')) clonedDecl.value = decl.value.replace(/span\s/i, '');
                else {
                    var startDecl;
                    decl.parent.walkDecls(startProp, function(d) {
                        startDecl = d;
                    });
                    if (startDecl) {
                        if ($d61dae07a41516e2$require$isPureNumber(startDecl.value)) {
                            var value = Number(decl.value) - Number(startDecl.value) + '';
                            clonedDecl.value = value;
                        } else return undefined;
                    } else decl.warn(result, "Can not prefix ".concat(decl.prop, " (").concat(startProp, " is not found)"));
                }
                decl.cloneBefore(clonedDecl);
                return undefined;
            }
        }
    ]);
    return GridEnd;
}($8a1dfa5624408614$exports);
$d61dae07a41516e2$var$GridEnd.names = [
    'grid-row-end',
    'grid-column-end'
];
$d61dae07a41516e2$exports = $d61dae07a41516e2$var$GridEnd;


var $16f05f1b825e5a03$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $NBk0Y = parcelRequire("NBk0Y");

var $16f05f1b825e5a03$var$Animation = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(Animation, Declaration);
    function Animation() {
        (0, $gd0sY._)(this, Animation);
        return (0, $8xMIM._)(this, Animation, arguments);
    }
    (0, $7cSld._)(Animation, [
        {
            /**
   * Don’t add prefixes for modern values.
   */ key: "check",
            value: function check(decl) {
                return !decl.value.split(/\s+/).some(function(i) {
                    var lower = i.toLowerCase();
                    return lower === 'reverse' || lower === 'alternate-reverse';
                });
            }
        }
    ]);
    return Animation;
}($8a1dfa5624408614$exports);
$16f05f1b825e5a03$var$Animation.names = [
    'animation',
    'animation-direction'
];
$16f05f1b825e5a03$exports = $16f05f1b825e5a03$var$Animation;


var $d7bb3f8b910fc429$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $21h22 = parcelRequire("21h22");


var $d7bb3f8b910fc429$var$FlexFlow = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(FlexFlow, Declaration);
    function FlexFlow() {
        (0, $gd0sY._)(this, FlexFlow);
        return (0, $8xMIM._)(this, FlexFlow, arguments);
    }
    (0, $7cSld._)(FlexFlow, [
        {
            /**
   * Use two properties for 2009 spec
   */ key: "insert",
            value: function insert(decl, prefix, prefixes) {
                var spec;
                var ref;
                ref = (0, $21h22._)($10265dcab8e82ebe$exports(prefix), 2), spec = ref[0], prefix = ref[1], ref;
                if (spec !== 2009) return (0, $bl6Nv._)((0, $7GsX9._)(FlexFlow.prototype), "insert", this).call(this, decl, prefix, prefixes);
                var values = decl.value.split(/\s+/).filter(function(i) {
                    return i !== 'wrap' && i !== 'nowrap' && 'wrap-reverse';
                });
                if (values.length === 0) return undefined;
                var already = decl.parent.some(function(i) {
                    return i.prop === prefix + 'box-orient' || i.prop === prefix + 'box-direction';
                });
                if (already) return undefined;
                var value = values[0];
                var orient = value.includes('row') ? 'horizontal' : 'vertical';
                var dir = value.includes('reverse') ? 'reverse' : 'normal';
                var cloned = this.clone(decl);
                cloned.prop = prefix + 'box-orient';
                cloned.value = orient;
                if (this.needCascade(decl)) cloned.raws.before = this.calcBefore(prefixes, decl, prefix);
                decl.parent.insertBefore(decl, cloned);
                cloned = this.clone(decl);
                cloned.prop = prefix + 'box-direction';
                cloned.value = dir;
                if (this.needCascade(decl)) cloned.raws.before = this.calcBefore(prefixes, decl, prefix);
                return decl.parent.insertBefore(decl, cloned);
            }
        }
    ]);
    return FlexFlow;
}($8a1dfa5624408614$exports);
$d7bb3f8b910fc429$var$FlexFlow.names = [
    'flex-flow',
    'box-direction',
    'box-orient'
];
$d7bb3f8b910fc429$exports = $d7bb3f8b910fc429$var$FlexFlow;


var $11281d7fce740793$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $21h22 = parcelRequire("21h22");


var $11281d7fce740793$var$Flex = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(Flex, Declaration);
    function Flex() {
        (0, $gd0sY._)(this, Flex);
        return (0, $8xMIM._)(this, Flex, arguments);
    }
    (0, $7cSld._)(Flex, [
        {
            /**
   * Return property name by final spec
   */ key: "normalize",
            value: function normalize() {
                return 'flex';
            }
        },
        {
            /**
   * Return flex property for 2009 and 2012 specs
   */ key: "prefixed",
            value: function prefixed(prop, prefix) {
                var spec;
                var ref;
                ref = (0, $21h22._)($10265dcab8e82ebe$exports(prefix), 2), spec = ref[0], prefix = ref[1], ref;
                if (spec === 2009) return prefix + 'box-flex';
                if (spec === 2012) return prefix + 'flex-positive';
                return (0, $bl6Nv._)((0, $7GsX9._)(Flex.prototype), "prefixed", this).call(this, prop, prefix);
            }
        }
    ]);
    return Flex;
}($8a1dfa5624408614$exports);
$11281d7fce740793$var$Flex.names = [
    'flex-grow',
    'flex-positive'
];
$11281d7fce740793$exports = $11281d7fce740793$var$Flex;


var $7ea5e5e894cc2b50$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");


var $7ea5e5e894cc2b50$var$FlexWrap = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(FlexWrap, Declaration);
    function FlexWrap() {
        (0, $gd0sY._)(this, FlexWrap);
        return (0, $8xMIM._)(this, FlexWrap, arguments);
    }
    (0, $7cSld._)(FlexWrap, [
        {
            /**
   * Don't add prefix for 2009 spec
   */ key: "set",
            value: function set(decl, prefix) {
                var spec = $10265dcab8e82ebe$exports(prefix)[0];
                if (spec !== 2009) return (0, $bl6Nv._)((0, $7GsX9._)(FlexWrap.prototype), "set", this).call(this, decl, prefix);
                return undefined;
            }
        }
    ]);
    return FlexWrap;
}($8a1dfa5624408614$exports);
$7ea5e5e894cc2b50$var$FlexWrap.names = [
    'flex-wrap'
];
$7ea5e5e894cc2b50$exports = $7ea5e5e894cc2b50$var$FlexWrap;


var $50db457fff8cda0e$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $21h22 = parcelRequire("21h22");


var $50db457fff8cda0e$var$GridArea = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(GridArea, Declaration);
    function GridArea() {
        (0, $gd0sY._)(this, GridArea);
        return (0, $8xMIM._)(this, GridArea, arguments);
    }
    (0, $7cSld._)(GridArea, [
        {
            /**
   * Translate grid-area to separate -ms- prefixed properties
   */ key: "insert",
            value: function insert(decl, prefix, prefixes, result) {
                if (prefix !== '-ms-') return (0, $bl6Nv._)((0, $7GsX9._)(GridArea.prototype), "insert", this).call(this, decl, prefix, prefixes);
                var values = $81b9427ee4e9e73f$export$98e6a39c04603d36(decl);
                var _utils_translate = (0, $21h22._)($81b9427ee4e9e73f$export$d73ee8ef04f5226a(values, 0, 2), 2), rowStart = _utils_translate[0], rowSpan = _utils_translate[1];
                var _utils_translate1 = (0, $21h22._)($81b9427ee4e9e73f$export$d73ee8ef04f5226a(values, 1, 3), 2), columnStart = _utils_translate1[0], columnSpan = _utils_translate1[1];
                [
                    [
                        'grid-row',
                        rowStart
                    ],
                    [
                        'grid-row-span',
                        rowSpan
                    ],
                    [
                        'grid-column',
                        columnStart
                    ],
                    [
                        'grid-column-span',
                        columnSpan
                    ]
                ].forEach(function(param) {
                    var _param = (0, $21h22._)(param, 2), prop = _param[0], value = _param[1];
                    $81b9427ee4e9e73f$export$f892fd5d935fdd16(decl, prop, value);
                });
                $81b9427ee4e9e73f$export$d92f4f61cfc83220(decl, result);
                $81b9427ee4e9e73f$export$4da30c78ee34dafc(decl, result);
                return undefined;
            }
        }
    ]);
    return GridArea;
}($8a1dfa5624408614$exports);
$50db457fff8cda0e$var$GridArea.names = [
    'grid-area'
];
$50db457fff8cda0e$exports = $50db457fff8cda0e$var$GridArea;


var $81c31f513704f4c1$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $21h22 = parcelRequire("21h22");


var $81c31f513704f4c1$var$PlaceSelf = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(PlaceSelf, Declaration);
    function PlaceSelf() {
        (0, $gd0sY._)(this, PlaceSelf);
        return (0, $8xMIM._)(this, PlaceSelf, arguments);
    }
    (0, $7cSld._)(PlaceSelf, [
        {
            /**
   * Translate place-self to separate -ms- prefixed properties
   */ key: "insert",
            value: function insert(decl, prefix, prefixes) {
                if (prefix !== '-ms-') return (0, $bl6Nv._)((0, $7GsX9._)(PlaceSelf.prototype), "insert", this).call(this, decl, prefix, prefixes);
                // prevent doubling of prefixes
                if (decl.parent.some(function(i) {
                    return i.prop === '-ms-grid-row-align';
                })) return undefined;
                var _utils_parse = (0, $21h22._)($81b9427ee4e9e73f$export$98e6a39c04603d36(decl), 1), _utils_parse_ = (0, $21h22._)(_utils_parse[0], 2), first = _utils_parse_[0], second = _utils_parse_[1];
                if (second) {
                    $81b9427ee4e9e73f$export$f892fd5d935fdd16(decl, 'grid-row-align', first);
                    $81b9427ee4e9e73f$export$f892fd5d935fdd16(decl, 'grid-column-align', second);
                } else {
                    $81b9427ee4e9e73f$export$f892fd5d935fdd16(decl, 'grid-row-align', first);
                    $81b9427ee4e9e73f$export$f892fd5d935fdd16(decl, 'grid-column-align', first);
                }
                return undefined;
            }
        }
    ]);
    return PlaceSelf;
}($8a1dfa5624408614$exports);
$81c31f513704f4c1$var$PlaceSelf.names = [
    'place-self'
];
$81c31f513704f4c1$exports = $81c31f513704f4c1$var$PlaceSelf;


var $8da2249594cde3a2$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $8da2249594cde3a2$var$GridStart = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(GridStart, Declaration);
    function GridStart() {
        (0, $gd0sY._)(this, GridStart);
        return (0, $8xMIM._)(this, GridStart, arguments);
    }
    (0, $7cSld._)(GridStart, [
        {
            /**
   * Do not add prefix for unsupported value in IE
   */ key: "check",
            value: function check(decl) {
                var value = decl.value;
                return !value.includes('/') && !value.includes('span');
            }
        },
        {
            /**
   * Return a final spec property
   */ key: "normalize",
            value: function normalize(prop) {
                return prop.replace('-start', '');
            }
        },
        {
            /**
   * Change property name for IE
   */ key: "prefixed",
            value: function prefixed(prop, prefix) {
                var result = (0, $bl6Nv._)((0, $7GsX9._)(GridStart.prototype), "prefixed", this).call(this, prop, prefix);
                if (prefix === '-ms-') result = result.replace('-start', '');
                return result;
            }
        }
    ]);
    return GridStart;
}($8a1dfa5624408614$exports);
$8da2249594cde3a2$var$GridStart.names = [
    'grid-row-start',
    'grid-column-start'
];
$8da2249594cde3a2$exports = $8da2249594cde3a2$var$GridStart;


var $3ca109fe10f7a338$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $21h22 = parcelRequire("21h22");


var $3ca109fe10f7a338$var$AlignSelf = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(AlignSelf, Declaration);
    function AlignSelf() {
        (0, $gd0sY._)(this, AlignSelf);
        return (0, $8xMIM._)(this, AlignSelf, arguments);
    }
    (0, $7cSld._)(AlignSelf, [
        {
            key: "check",
            value: function check(decl) {
                return decl.parent && !decl.parent.some(function(i) {
                    return i.prop && i.prop.startsWith('grid-');
                });
            }
        },
        {
            /**
   * Return property name by final spec
   */ key: "normalize",
            value: function normalize() {
                return 'align-self';
            }
        },
        {
            /**
   * Change property name for 2012 specs
   */ key: "prefixed",
            value: function prefixed(prop, prefix) {
                var spec;
                var ref;
                ref = (0, $21h22._)($10265dcab8e82ebe$exports(prefix), 2), spec = ref[0], prefix = ref[1], ref;
                if (spec === 2012) return prefix + 'flex-item-align';
                return (0, $bl6Nv._)((0, $7GsX9._)(AlignSelf.prototype), "prefixed", this).call(this, prop, prefix);
            }
        },
        {
            /**
   * Change value for 2012 spec and ignore prefix for 2009
   */ key: "set",
            value: function set(decl, prefix) {
                var spec = $10265dcab8e82ebe$exports(prefix)[0];
                if (spec === 2012) {
                    decl.value = AlignSelf.oldValues[decl.value] || decl.value;
                    return (0, $bl6Nv._)((0, $7GsX9._)(AlignSelf.prototype), "set", this).call(this, decl, prefix);
                }
                if (spec === 'final') return (0, $bl6Nv._)((0, $7GsX9._)(AlignSelf.prototype), "set", this).call(this, decl, prefix);
                return undefined;
            }
        }
    ]);
    return AlignSelf;
}($8a1dfa5624408614$exports);
$3ca109fe10f7a338$var$AlignSelf.names = [
    'align-self',
    'flex-item-align'
];
$3ca109fe10f7a338$var$AlignSelf.oldValues = {
    'flex-end': 'end',
    'flex-start': 'start'
};
$3ca109fe10f7a338$exports = $3ca109fe10f7a338$var$AlignSelf;


var $7fd7aecb11781db0$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $NBk0Y = parcelRequire("NBk0Y");


var $kUXlT = parcelRequire("kUXlT");
var $7fd7aecb11781db0$var$Appearance = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(Appearance, Declaration);
    function Appearance(name, prefixes, all) {
        (0, $gd0sY._)(this, Appearance);
        var _this;
        _this = (0, $8xMIM._)(this, Appearance, [
            name,
            prefixes,
            all
        ]);
        if (_this.prefixes) _this.prefixes = $kUXlT.uniq(_this.prefixes.map(function(i) {
            if (i === '-ms-') return '-webkit-';
            return i;
        }));
        return _this;
    }
    return Appearance;
}($8a1dfa5624408614$exports);
$7fd7aecb11781db0$var$Appearance.names = [
    'appearance'
];
$7fd7aecb11781db0$exports = $7fd7aecb11781db0$var$Appearance;


var $4ec5c8c0149a8671$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $21h22 = parcelRequire("21h22");


var $4ec5c8c0149a8671$var$FlexBasis = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(FlexBasis, Declaration);
    function FlexBasis() {
        (0, $gd0sY._)(this, FlexBasis);
        return (0, $8xMIM._)(this, FlexBasis, arguments);
    }
    (0, $7cSld._)(FlexBasis, [
        {
            /**
   * Return property name by final spec
   */ key: "normalize",
            value: function normalize() {
                return 'flex-basis';
            }
        },
        {
            /**
   * Return flex property for 2012 spec
   */ key: "prefixed",
            value: function prefixed(prop, prefix) {
                var spec;
                var ref;
                ref = (0, $21h22._)($10265dcab8e82ebe$exports(prefix), 2), spec = ref[0], prefix = ref[1], ref;
                if (spec === 2012) return prefix + 'flex-preferred-size';
                return (0, $bl6Nv._)((0, $7GsX9._)(FlexBasis.prototype), "prefixed", this).call(this, prop, prefix);
            }
        },
        {
            /**
   * Ignore 2009 spec and use flex property for 2012
   */ key: "set",
            value: function set(decl, prefix) {
                var spec;
                var ref;
                ref = (0, $21h22._)($10265dcab8e82ebe$exports(prefix), 2), spec = ref[0], prefix = ref[1], ref;
                if (spec === 2012 || spec === 'final') return (0, $bl6Nv._)((0, $7GsX9._)(FlexBasis.prototype), "set", this).call(this, decl, prefix);
                return undefined;
            }
        }
    ]);
    return FlexBasis;
}($8a1dfa5624408614$exports);
$4ec5c8c0149a8671$var$FlexBasis.names = [
    'flex-basis',
    'flex-preferred-size'
];
$4ec5c8c0149a8671$exports = $4ec5c8c0149a8671$var$FlexBasis;


var $42a505bd8ea07153$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $42a505bd8ea07153$var$MaskBorder = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(MaskBorder, Declaration);
    function MaskBorder() {
        (0, $gd0sY._)(this, MaskBorder);
        return (0, $8xMIM._)(this, MaskBorder, arguments);
    }
    (0, $7cSld._)(MaskBorder, [
        {
            /**
   * Return property name by final spec
   */ key: "normalize",
            value: function normalize() {
                return this.name.replace('box-image', 'border');
            }
        },
        {
            /**
   * Return flex property for 2012 spec
   */ key: "prefixed",
            value: function prefixed(prop, prefix) {
                var result = (0, $bl6Nv._)((0, $7GsX9._)(MaskBorder.prototype), "prefixed", this).call(this, prop, prefix);
                if (prefix === '-webkit-') result = result.replace('border', 'box-image');
                return result;
            }
        }
    ]);
    return MaskBorder;
}($8a1dfa5624408614$exports);
$42a505bd8ea07153$var$MaskBorder.names = [
    'mask-border',
    'mask-border-source',
    'mask-border-slice',
    'mask-border-width',
    'mask-border-outset',
    'mask-border-repeat',
    'mask-box-image',
    'mask-box-image-source',
    'mask-box-image-slice',
    'mask-box-image-width',
    'mask-box-image-outset',
    'mask-box-image-repeat'
];
$42a505bd8ea07153$exports = $42a505bd8ea07153$var$MaskBorder;


var $f5c04291cf55e453$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $NBk0Y = parcelRequire("NBk0Y");

var $f5c04291cf55e453$var$MaskComposite = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(MaskComposite, Declaration);
    function MaskComposite() {
        (0, $gd0sY._)(this, MaskComposite);
        return (0, $8xMIM._)(this, MaskComposite, arguments);
    }
    (0, $7cSld._)(MaskComposite, [
        {
            /**
   * Prefix mask-composite for webkit
   */ key: "insert",
            value: function insert(decl, prefix, prefixes) {
                var isCompositeProp = decl.prop === 'mask-composite';
                var compositeValues;
                if (isCompositeProp) compositeValues = decl.value.split(',');
                else compositeValues = decl.value.match(MaskComposite.regexp) || [];
                compositeValues = compositeValues.map(function(el) {
                    return el.trim();
                }).filter(function(el) {
                    return el;
                });
                var hasCompositeValues = compositeValues.length;
                var compositeDecl;
                if (hasCompositeValues) {
                    compositeDecl = this.clone(decl);
                    compositeDecl.value = compositeValues.map(function(value) {
                        return MaskComposite.oldValues[value] || value;
                    }).join(', ');
                    if (compositeValues.includes('intersect')) compositeDecl.value += ', xor';
                    compositeDecl.prop = prefix + 'mask-composite';
                }
                if (isCompositeProp) {
                    if (!hasCompositeValues) return undefined;
                    if (this.needCascade(decl)) compositeDecl.raws.before = this.calcBefore(prefixes, decl, prefix);
                    return decl.parent.insertBefore(decl, compositeDecl);
                }
                var cloned = this.clone(decl);
                cloned.prop = prefix + cloned.prop;
                if (hasCompositeValues) cloned.value = cloned.value.replace(MaskComposite.regexp, '');
                if (this.needCascade(decl)) cloned.raws.before = this.calcBefore(prefixes, decl, prefix);
                decl.parent.insertBefore(decl, cloned);
                if (!hasCompositeValues) return decl;
                if (this.needCascade(decl)) compositeDecl.raws.before = this.calcBefore(prefixes, decl, prefix);
                return decl.parent.insertBefore(decl, compositeDecl);
            }
        }
    ]);
    return MaskComposite;
}($8a1dfa5624408614$exports);
$f5c04291cf55e453$var$MaskComposite.names = [
    'mask',
    'mask-composite'
];
$f5c04291cf55e453$var$MaskComposite.oldValues = {
    add: 'source-over',
    exclude: 'xor',
    intersect: 'source-in',
    subtract: 'source-out'
};
$f5c04291cf55e453$var$MaskComposite.regexp = new RegExp("\\s+(".concat(Object.keys($f5c04291cf55e453$var$MaskComposite.oldValues).join('|'), ")\\b(?!\\))\\s*(?=[,])"), 'ig');
$f5c04291cf55e453$exports = $f5c04291cf55e453$var$MaskComposite;


var $e844ab2b08215939$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $21h22 = parcelRequire("21h22");


var $e844ab2b08215939$var$AlignItems = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(AlignItems, Declaration);
    function AlignItems() {
        (0, $gd0sY._)(this, AlignItems);
        return (0, $8xMIM._)(this, AlignItems, arguments);
    }
    (0, $7cSld._)(AlignItems, [
        {
            /**
   * Return property name by final spec
   */ key: "normalize",
            value: function normalize() {
                return 'align-items';
            }
        },
        {
            /**
   * Change property name for 2009 and 2012 specs
   */ key: "prefixed",
            value: function prefixed(prop, prefix) {
                var spec;
                var ref;
                ref = (0, $21h22._)($10265dcab8e82ebe$exports(prefix), 2), spec = ref[0], prefix = ref[1], ref;
                if (spec === 2009) return prefix + 'box-align';
                if (spec === 2012) return prefix + 'flex-align';
                return (0, $bl6Nv._)((0, $7GsX9._)(AlignItems.prototype), "prefixed", this).call(this, prop, prefix);
            }
        },
        {
            /**
   * Change value for 2009 and 2012 specs
   */ key: "set",
            value: function set(decl, prefix) {
                var spec = $10265dcab8e82ebe$exports(prefix)[0];
                if (spec === 2009 || spec === 2012) decl.value = AlignItems.oldValues[decl.value] || decl.value;
                return (0, $bl6Nv._)((0, $7GsX9._)(AlignItems.prototype), "set", this).call(this, decl, prefix);
            }
        }
    ]);
    return AlignItems;
}($8a1dfa5624408614$exports);
$e844ab2b08215939$var$AlignItems.names = [
    'align-items',
    'flex-align',
    'box-align'
];
$e844ab2b08215939$var$AlignItems.oldValues = {
    'flex-end': 'end',
    'flex-start': 'start'
};
$e844ab2b08215939$exports = $e844ab2b08215939$var$AlignItems;


var $d2e215b019503064$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $d2e215b019503064$var$UserSelect = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(UserSelect, Declaration);
    function UserSelect() {
        (0, $gd0sY._)(this, UserSelect);
        return (0, $8xMIM._)(this, UserSelect, arguments);
    }
    (0, $7cSld._)(UserSelect, [
        {
            /**
   * Avoid prefixing all in IE
   */ key: "insert",
            value: function insert(decl, prefix, prefixes) {
                if (decl.value === 'all' && prefix === '-ms-') return undefined;
                else return (0, $bl6Nv._)((0, $7GsX9._)(UserSelect.prototype), "insert", this).call(this, decl, prefix, prefixes);
            }
        },
        {
            /**
   * Change prefixed value for IE
   */ key: "set",
            value: function set(decl, prefix) {
                if (prefix === '-ms-' && decl.value === 'contain') decl.value = 'element';
                return (0, $bl6Nv._)((0, $7GsX9._)(UserSelect.prototype), "set", this).call(this, decl, prefix);
            }
        }
    ]);
    return UserSelect;
}($8a1dfa5624408614$exports);
$d2e215b019503064$var$UserSelect.names = [
    'user-select'
];
$d2e215b019503064$exports = $d2e215b019503064$var$UserSelect;


var $9fcf91cf85f860f5$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $21h22 = parcelRequire("21h22");


var $9fcf91cf85f860f5$var$FlexShrink = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(FlexShrink, Declaration);
    function FlexShrink() {
        (0, $gd0sY._)(this, FlexShrink);
        return (0, $8xMIM._)(this, FlexShrink, arguments);
    }
    (0, $7cSld._)(FlexShrink, [
        {
            /**
   * Return property name by final spec
   */ key: "normalize",
            value: function normalize() {
                return 'flex-shrink';
            }
        },
        {
            /**
   * Return flex property for 2012 spec
   */ key: "prefixed",
            value: function prefixed(prop, prefix) {
                var spec;
                var ref;
                ref = (0, $21h22._)($10265dcab8e82ebe$exports(prefix), 2), spec = ref[0], prefix = ref[1], ref;
                if (spec === 2012) return prefix + 'flex-negative';
                return (0, $bl6Nv._)((0, $7GsX9._)(FlexShrink.prototype), "prefixed", this).call(this, prop, prefix);
            }
        },
        {
            /**
   * Ignore 2009 spec and use flex property for 2012
   */ key: "set",
            value: function set(decl, prefix) {
                var spec;
                var ref;
                ref = (0, $21h22._)($10265dcab8e82ebe$exports(prefix), 2), spec = ref[0], prefix = ref[1], ref;
                if (spec === 2012 || spec === 'final') return (0, $bl6Nv._)((0, $7GsX9._)(FlexShrink.prototype), "set", this).call(this, decl, prefix);
                return undefined;
            }
        }
    ]);
    return FlexShrink;
}($8a1dfa5624408614$exports);
$9fcf91cf85f860f5$var$FlexShrink.names = [
    'flex-shrink',
    'flex-negative'
];
$9fcf91cf85f860f5$exports = $9fcf91cf85f860f5$var$FlexShrink;


var $a3d3e116096f4ae3$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $a3d3e116096f4ae3$var$BreakProps = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(BreakProps, Declaration);
    function BreakProps() {
        (0, $gd0sY._)(this, BreakProps);
        return (0, $8xMIM._)(this, BreakProps, arguments);
    }
    (0, $7cSld._)(BreakProps, [
        {
            /**
   * Don’t prefix some values
   */ key: "insert",
            value: function insert(decl, prefix, prefixes) {
                if (decl.prop !== 'break-inside') return (0, $bl6Nv._)((0, $7GsX9._)(BreakProps.prototype), "insert", this).call(this, decl, prefix, prefixes);
                if (/region/i.test(decl.value) || /page/i.test(decl.value)) return undefined;
                return (0, $bl6Nv._)((0, $7GsX9._)(BreakProps.prototype), "insert", this).call(this, decl, prefix, prefixes);
            }
        },
        {
            /**
   * Return property name by final spec
   */ key: "normalize",
            value: function normalize(prop) {
                if (prop.includes('inside')) return 'break-inside';
                if (prop.includes('before')) return 'break-before';
                return 'break-after';
            }
        },
        {
            /**
   * Change name for -webkit- and -moz- prefix
   */ key: "prefixed",
            value: function prefixed(prop, prefix) {
                return "".concat(prefix, "column-").concat(prop);
            }
        },
        {
            /**
   * Change prefixed value for avoid-column and avoid-page
   */ key: "set",
            value: function set(decl, prefix) {
                if (decl.prop === 'break-inside' && decl.value === 'avoid-column' || decl.value === 'avoid-page') decl.value = 'avoid';
                return (0, $bl6Nv._)((0, $7GsX9._)(BreakProps.prototype), "set", this).call(this, decl, prefix);
            }
        }
    ]);
    return BreakProps;
}($8a1dfa5624408614$exports);
$a3d3e116096f4ae3$var$BreakProps.names = [
    'break-inside',
    'page-break-inside',
    'column-break-inside',
    'break-before',
    'page-break-before',
    'column-break-before',
    'break-after',
    'page-break-after',
    'column-break-after'
];
$a3d3e116096f4ae3$exports = $a3d3e116096f4ae3$var$BreakProps;


var $83398130b9c9739d$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $83398130b9c9739d$var$WritingMode = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(WritingMode, Declaration);
    function WritingMode() {
        (0, $gd0sY._)(this, WritingMode);
        return (0, $8xMIM._)(this, WritingMode, arguments);
    }
    (0, $7cSld._)(WritingMode, [
        {
            key: "insert",
            value: function insert(decl, prefix, prefixes) {
                if (prefix === '-ms-') {
                    var cloned = this.set(this.clone(decl), prefix);
                    if (this.needCascade(decl)) cloned.raws.before = this.calcBefore(prefixes, decl, prefix);
                    var direction = 'ltr';
                    decl.parent.nodes.forEach(function(i) {
                        if (i.prop === 'direction') {
                            if (i.value === 'rtl' || i.value === 'ltr') direction = i.value;
                        }
                    });
                    cloned.value = WritingMode.msValues[direction][decl.value] || decl.value;
                    return decl.parent.insertBefore(decl, cloned);
                }
                return (0, $bl6Nv._)((0, $7GsX9._)(WritingMode.prototype), "insert", this).call(this, decl, prefix, prefixes);
            }
        }
    ]);
    return WritingMode;
}($8a1dfa5624408614$exports);
$83398130b9c9739d$var$WritingMode.names = [
    'writing-mode'
];
$83398130b9c9739d$var$WritingMode.msValues = {
    ltr: {
        'horizontal-tb': 'lr-tb',
        'vertical-lr': 'tb-lr',
        'vertical-rl': 'tb-rl'
    },
    rtl: {
        'horizontal-tb': 'rl-tb',
        'vertical-lr': 'bt-lr',
        'vertical-rl': 'bt-rl'
    }
};
$83398130b9c9739d$exports = $83398130b9c9739d$var$WritingMode;


var $c88f857ba6975838$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $c88f857ba6975838$var$BorderImage = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(BorderImage, Declaration);
    function BorderImage() {
        (0, $gd0sY._)(this, BorderImage);
        return (0, $8xMIM._)(this, BorderImage, arguments);
    }
    (0, $7cSld._)(BorderImage, [
        {
            /**
   * Remove fill parameter for prefixed declarations
   */ key: "set",
            value: function set(decl, prefix) {
                decl.value = decl.value.replace(/\s+fill(\s)/, '$1');
                return (0, $bl6Nv._)((0, $7GsX9._)(BorderImage.prototype), "set", this).call(this, decl, prefix);
            }
        }
    ]);
    return BorderImage;
}($8a1dfa5624408614$exports);
$c88f857ba6975838$var$BorderImage.names = [
    'border-image'
];
$c88f857ba6975838$exports = $c88f857ba6975838$var$BorderImage;


var $cc2e7602c1335dd1$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $21h22 = parcelRequire("21h22");


var $cc2e7602c1335dd1$var$AlignContent = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(AlignContent, Declaration);
    function AlignContent() {
        (0, $gd0sY._)(this, AlignContent);
        return (0, $8xMIM._)(this, AlignContent, arguments);
    }
    (0, $7cSld._)(AlignContent, [
        {
            /**
   * Return property name by final spec
   */ key: "normalize",
            value: function normalize() {
                return 'align-content';
            }
        },
        {
            /**
   * Change property name for 2012 spec
   */ key: "prefixed",
            value: function prefixed(prop, prefix) {
                var spec;
                var ref;
                ref = (0, $21h22._)($10265dcab8e82ebe$exports(prefix), 2), spec = ref[0], prefix = ref[1], ref;
                if (spec === 2012) return prefix + 'flex-line-pack';
                return (0, $bl6Nv._)((0, $7GsX9._)(AlignContent.prototype), "prefixed", this).call(this, prop, prefix);
            }
        },
        {
            /**
   * Change value for 2012 spec and ignore prefix for 2009
   */ key: "set",
            value: function set(decl, prefix) {
                var spec = $10265dcab8e82ebe$exports(prefix)[0];
                if (spec === 2012) {
                    decl.value = AlignContent.oldValues[decl.value] || decl.value;
                    return (0, $bl6Nv._)((0, $7GsX9._)(AlignContent.prototype), "set", this).call(this, decl, prefix);
                }
                if (spec === 'final') return (0, $bl6Nv._)((0, $7GsX9._)(AlignContent.prototype), "set", this).call(this, decl, prefix);
                return undefined;
            }
        }
    ]);
    return AlignContent;
}($8a1dfa5624408614$exports);
$cc2e7602c1335dd1$var$AlignContent.names = [
    'align-content',
    'flex-line-pack'
];
$cc2e7602c1335dd1$var$AlignContent.oldValues = {
    'flex-end': 'end',
    'flex-start': 'start',
    'space-around': 'distribute',
    'space-between': 'justify'
};
$cc2e7602c1335dd1$exports = $cc2e7602c1335dd1$var$AlignContent;


var $1837c036d480078f$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $1837c036d480078f$var$BorderRadius = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(BorderRadius, Declaration);
    function BorderRadius() {
        (0, $gd0sY._)(this, BorderRadius);
        return (0, $8xMIM._)(this, BorderRadius, arguments);
    }
    (0, $7cSld._)(BorderRadius, [
        {
            /**
   * Return unprefixed version of property
   */ key: "normalize",
            value: function normalize(prop) {
                return BorderRadius.toNormal[prop] || prop;
            }
        },
        {
            /**
   * Change syntax, when add Mozilla prefix
   */ key: "prefixed",
            value: function prefixed(prop, prefix) {
                if (prefix === '-moz-') return prefix + (BorderRadius.toMozilla[prop] || prop);
                return (0, $bl6Nv._)((0, $7GsX9._)(BorderRadius.prototype), "prefixed", this).call(this, prop, prefix);
            }
        }
    ]);
    return BorderRadius;
}($8a1dfa5624408614$exports);
$1837c036d480078f$var$BorderRadius.names = [
    'border-radius'
];
$1837c036d480078f$var$BorderRadius.toMozilla = {};
$1837c036d480078f$var$BorderRadius.toNormal = {};
for(var $1837c036d480078f$var$_i = 0, $1837c036d480078f$var$_iter = [
    'top',
    'bottom'
]; $1837c036d480078f$var$_i < $1837c036d480078f$var$_iter.length; $1837c036d480078f$var$_i++){
    var $1837c036d480078f$var$ver = $1837c036d480078f$var$_iter[$1837c036d480078f$var$_i];
    for(var $1837c036d480078f$var$_i1 = 0, $1837c036d480078f$var$_iter1 = [
        'left',
        'right'
    ]; $1837c036d480078f$var$_i1 < $1837c036d480078f$var$_iter1.length; $1837c036d480078f$var$_i1++){
        var $1837c036d480078f$var$hor = $1837c036d480078f$var$_iter1[$1837c036d480078f$var$_i1];
        var $1837c036d480078f$var$normal = "border-".concat($1837c036d480078f$var$ver, "-").concat($1837c036d480078f$var$hor, "-radius");
        var $1837c036d480078f$var$mozilla = "border-radius-".concat($1837c036d480078f$var$ver).concat($1837c036d480078f$var$hor);
        $1837c036d480078f$var$BorderRadius.names.push($1837c036d480078f$var$normal);
        $1837c036d480078f$var$BorderRadius.names.push($1837c036d480078f$var$mozilla);
        $1837c036d480078f$var$BorderRadius.toMozilla[$1837c036d480078f$var$normal] = $1837c036d480078f$var$mozilla;
        $1837c036d480078f$var$BorderRadius.toNormal[$1837c036d480078f$var$mozilla] = $1837c036d480078f$var$normal;
    }
}
$1837c036d480078f$exports = $1837c036d480078f$var$BorderRadius;


var $fc6d4a00b27c581a$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $NBk0Y = parcelRequire("NBk0Y");

var $fc6d4a00b27c581a$var$BlockLogical = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(BlockLogical, Declaration);
    function BlockLogical() {
        (0, $gd0sY._)(this, BlockLogical);
        return (0, $8xMIM._)(this, BlockLogical, arguments);
    }
    (0, $7cSld._)(BlockLogical, [
        {
            /**
   * Return property name by spec
   */ key: "normalize",
            value: function normalize(prop) {
                if (prop.includes('-before')) return prop.replace('-before', '-block-start');
                return prop.replace('-after', '-block-end');
            }
        },
        {
            /**
   * Use old syntax for -moz- and -webkit-
   */ key: "prefixed",
            value: function prefixed(prop, prefix) {
                if (prop.includes('-start')) return prefix + prop.replace('-block-start', '-before');
                return prefix + prop.replace('-block-end', '-after');
            }
        }
    ]);
    return BlockLogical;
}($8a1dfa5624408614$exports);
$fc6d4a00b27c581a$var$BlockLogical.names = [
    'border-block-start',
    'border-block-end',
    'margin-block-start',
    'margin-block-end',
    'padding-block-start',
    'padding-block-end',
    'border-before',
    'border-after',
    'margin-before',
    'margin-after',
    'padding-before',
    'padding-after'
];
$fc6d4a00b27c581a$exports = $fc6d4a00b27c581a$var$BlockLogical;


var $cfd00806a02bf618$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");


var $cfd00806a02bf618$var$getGridGap = $81b9427ee4e9e73f$export$3e6031d7369213a8, $cfd00806a02bf618$var$inheritGridGap = $81b9427ee4e9e73f$export$4c8a39d0988ac794, $cfd00806a02bf618$var$parseTemplate = $81b9427ee4e9e73f$export$2e2dbd43b49fd373, $cfd00806a02bf618$var$warnGridGap = $81b9427ee4e9e73f$export$6547a7a859533ca5, $cfd00806a02bf618$var$warnMissedAreas = $81b9427ee4e9e73f$export$ebd18cfd7527d7cf;
var $cfd00806a02bf618$var$GridTemplate = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(GridTemplate, Declaration);
    function GridTemplate() {
        (0, $gd0sY._)(this, GridTemplate);
        return (0, $8xMIM._)(this, GridTemplate, arguments);
    }
    (0, $7cSld._)(GridTemplate, [
        {
            /**
   * Translate grid-template to separate -ms- prefixed properties
   */ key: "insert",
            value: function insert(decl, prefix, prefixes, result) {
                if (prefix !== '-ms-') return (0, $bl6Nv._)((0, $7GsX9._)(GridTemplate.prototype), "insert", this).call(this, decl, prefix, prefixes);
                if (decl.parent.some(function(i) {
                    return i.prop === '-ms-grid-rows';
                })) return undefined;
                var gap = $cfd00806a02bf618$var$getGridGap(decl);
                /**
     * we must insert inherited gap values in some cases:
     * if we are inside media query && if we have no grid-gap value
     */ var inheritedGap = $cfd00806a02bf618$var$inheritGridGap(decl, gap);
                var _parseTemplate = $cfd00806a02bf618$var$parseTemplate({
                    decl: decl,
                    gap: inheritedGap || gap
                }), areas = _parseTemplate.areas, columns = _parseTemplate.columns, rows = _parseTemplate.rows;
                var hasAreas = Object.keys(areas).length > 0;
                var hasRows = Boolean(rows);
                var hasColumns = Boolean(columns);
                $cfd00806a02bf618$var$warnGridGap({
                    decl: decl,
                    gap: gap,
                    hasColumns: hasColumns,
                    result: result
                });
                $cfd00806a02bf618$var$warnMissedAreas(areas, decl, result);
                if (hasRows && hasColumns || hasAreas) decl.cloneBefore({
                    prop: '-ms-grid-rows',
                    raws: {},
                    value: rows
                });
                if (hasColumns) decl.cloneBefore({
                    prop: '-ms-grid-columns',
                    raws: {},
                    value: columns
                });
                return decl;
            }
        }
    ]);
    return GridTemplate;
}($8a1dfa5624408614$exports);
$cfd00806a02bf618$var$GridTemplate.names = [
    'grid-template'
];
$cfd00806a02bf618$exports = $cfd00806a02bf618$var$GridTemplate;


var $cb1981e0c3a4ad67$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $NBk0Y = parcelRequire("NBk0Y");

var $cb1981e0c3a4ad67$var$InlineLogical = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(InlineLogical, Declaration);
    function InlineLogical() {
        (0, $gd0sY._)(this, InlineLogical);
        return (0, $8xMIM._)(this, InlineLogical, arguments);
    }
    (0, $7cSld._)(InlineLogical, [
        {
            /**
   * Return property name by spec
   */ key: "normalize",
            value: function normalize(prop) {
                return prop.replace(/(margin|padding|border)-(start|end)/, '$1-inline-$2');
            }
        },
        {
            /**
   * Use old syntax for -moz- and -webkit-
   */ key: "prefixed",
            value: function prefixed(prop, prefix) {
                return prefix + prop.replace('-inline', '');
            }
        }
    ]);
    return InlineLogical;
}($8a1dfa5624408614$exports);
$cb1981e0c3a4ad67$var$InlineLogical.names = [
    'border-inline-start',
    'border-inline-end',
    'margin-inline-start',
    'margin-inline-end',
    'padding-inline-start',
    'padding-inline-end',
    'border-start',
    'border-end',
    'margin-start',
    'margin-end',
    'padding-start',
    'padding-end'
];
$cb1981e0c3a4ad67$exports = $cb1981e0c3a4ad67$var$InlineLogical;


var $2ecf366a663d0dd0$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $NBk0Y = parcelRequire("NBk0Y");

var $2ecf366a663d0dd0$var$GridRowAlign = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(GridRowAlign, Declaration);
    function GridRowAlign() {
        (0, $gd0sY._)(this, GridRowAlign);
        return (0, $8xMIM._)(this, GridRowAlign, arguments);
    }
    (0, $7cSld._)(GridRowAlign, [
        {
            /**
   * Do not prefix flexbox values
   */ key: "check",
            value: function check(decl) {
                return !decl.value.includes('flex-') && decl.value !== 'baseline';
            }
        },
        {
            /**
   * Change IE property back
   */ key: "normalize",
            value: function normalize() {
                return 'align-self';
            }
        },
        {
            /**
   * Change property name for IE
   */ key: "prefixed",
            value: function prefixed(prop, prefix) {
                return prefix + 'grid-row-align';
            }
        }
    ]);
    return GridRowAlign;
}($8a1dfa5624408614$exports);
$2ecf366a663d0dd0$var$GridRowAlign.names = [
    'grid-row-align'
];
$2ecf366a663d0dd0$exports = $2ecf366a663d0dd0$var$GridRowAlign;


var $e57c255aa3b78e44$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $e57c255aa3b78e44$var$TransformDecl = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(TransformDecl, Declaration);
    function TransformDecl() {
        (0, $gd0sY._)(this, TransformDecl);
        return (0, $8xMIM._)(this, TransformDecl, arguments);
    }
    (0, $7cSld._)(TransformDecl, [
        {
            /**
   * Is transform contain 3D commands
   */ key: "contain3d",
            value: function contain3d(decl) {
                if (decl.prop === 'transform-origin') return false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = TransformDecl.functions3d[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var func = _step.value;
                        if (decl.value.includes("".concat(func, "("))) return true;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return false;
            }
        },
        {
            /**
   * Don't add prefix for IE in keyframes
   */ key: "insert",
            value: function insert(decl, prefix, prefixes) {
                if (prefix === '-ms-') {
                    if (!this.contain3d(decl) && !this.keyframeParents(decl)) return (0, $bl6Nv._)((0, $7GsX9._)(TransformDecl.prototype), "insert", this).call(this, decl, prefix, prefixes);
                } else if (prefix === '-o-') {
                    if (!this.contain3d(decl)) return (0, $bl6Nv._)((0, $7GsX9._)(TransformDecl.prototype), "insert", this).call(this, decl, prefix, prefixes);
                } else return (0, $bl6Nv._)((0, $7GsX9._)(TransformDecl.prototype), "insert", this).call(this, decl, prefix, prefixes);
                return undefined;
            }
        },
        {
            /**
   * Recursively check all parents for @keyframes
   */ key: "keyframeParents",
            value: function keyframeParents(decl) {
                var parent = decl.parent;
                while(parent){
                    if (parent.type === 'atrule' && parent.name === 'keyframes') return true;
                    parent = parent.parent;
                }
                return false;
            }
        },
        {
            /**
   * Replace rotateZ to rotate for IE 9
   */ key: "set",
            value: function set(decl, prefix) {
                decl = (0, $bl6Nv._)((0, $7GsX9._)(TransformDecl.prototype), "set", this).call(this, decl, prefix);
                if (prefix === '-ms-') decl.value = decl.value.replace(/rotatez/gi, 'rotate');
                return decl;
            }
        }
    ]);
    return TransformDecl;
}($8a1dfa5624408614$exports);
$e57c255aa3b78e44$var$TransformDecl.names = [
    'transform',
    'transform-origin'
];
$e57c255aa3b78e44$var$TransformDecl.functions3d = [
    'matrix3d',
    'translate3d',
    'translateZ',
    'scale3d',
    'scaleZ',
    'rotate3d',
    'rotateX',
    'rotateY',
    'perspective'
];
$e57c255aa3b78e44$exports = $e57c255aa3b78e44$var$TransformDecl;


var $3e39c7160360b906$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $21h22 = parcelRequire("21h22");


var $3e39c7160360b906$var$FlexDirection = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(FlexDirection, Declaration);
    function FlexDirection() {
        (0, $gd0sY._)(this, FlexDirection);
        return (0, $8xMIM._)(this, FlexDirection, arguments);
    }
    (0, $7cSld._)(FlexDirection, [
        {
            /**
   * Use two properties for 2009 spec
   */ key: "insert",
            value: function insert(decl, prefix, prefixes) {
                var spec;
                var ref;
                ref = (0, $21h22._)($10265dcab8e82ebe$exports(prefix), 2), spec = ref[0], prefix = ref[1], ref;
                if (spec !== 2009) return (0, $bl6Nv._)((0, $7GsX9._)(FlexDirection.prototype), "insert", this).call(this, decl, prefix, prefixes);
                var already = decl.parent.some(function(i) {
                    return i.prop === prefix + 'box-orient' || i.prop === prefix + 'box-direction';
                });
                if (already) return undefined;
                var v = decl.value;
                var orient, dir;
                if (v === 'inherit' || v === 'initial' || v === 'unset') {
                    orient = v;
                    dir = v;
                } else {
                    orient = v.includes('row') ? 'horizontal' : 'vertical';
                    dir = v.includes('reverse') ? 'reverse' : 'normal';
                }
                var cloned = this.clone(decl);
                cloned.prop = prefix + 'box-orient';
                cloned.value = orient;
                if (this.needCascade(decl)) cloned.raws.before = this.calcBefore(prefixes, decl, prefix);
                decl.parent.insertBefore(decl, cloned);
                cloned = this.clone(decl);
                cloned.prop = prefix + 'box-direction';
                cloned.value = dir;
                if (this.needCascade(decl)) cloned.raws.before = this.calcBefore(prefixes, decl, prefix);
                return decl.parent.insertBefore(decl, cloned);
            }
        },
        {
            /**
   * Return property name by final spec
   */ key: "normalize",
            value: function normalize() {
                return 'flex-direction';
            }
        },
        {
            /**
   * Clean two properties for 2009 spec
   */ key: "old",
            value: function old(prop, prefix) {
                var spec;
                var ref;
                ref = (0, $21h22._)($10265dcab8e82ebe$exports(prefix), 2), spec = ref[0], prefix = ref[1], ref;
                if (spec === 2009) return [
                    prefix + 'box-orient',
                    prefix + 'box-direction'
                ];
                else return (0, $bl6Nv._)((0, $7GsX9._)(FlexDirection.prototype), "old", this).call(this, prop, prefix);
            }
        }
    ]);
    return FlexDirection;
}($8a1dfa5624408614$exports);
$3e39c7160360b906$var$FlexDirection.names = [
    'flex-direction',
    'box-direction',
    'box-orient'
];
$3e39c7160360b906$exports = $3e39c7160360b906$var$FlexDirection;


var $f5cdd405f24fd95d$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $f5cdd405f24fd95d$var$ImageRendering = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(ImageRendering, Declaration);
    function ImageRendering() {
        (0, $gd0sY._)(this, ImageRendering);
        return (0, $8xMIM._)(this, ImageRendering, arguments);
    }
    (0, $7cSld._)(ImageRendering, [
        {
            /**
   * Add hack only for crisp-edges
   */ key: "check",
            value: function check(decl) {
                return decl.value === 'pixelated';
            }
        },
        {
            /**
   * Return property name by spec
   */ key: "normalize",
            value: function normalize() {
                return 'image-rendering';
            }
        },
        {
            /**
   * Change property name for IE
   */ key: "prefixed",
            value: function prefixed(prop, prefix) {
                if (prefix === '-ms-') return '-ms-interpolation-mode';
                return (0, $bl6Nv._)((0, $7GsX9._)(ImageRendering.prototype), "prefixed", this).call(this, prop, prefix);
            }
        },
        {
            /**
   * Warn on old value
   */ key: "process",
            value: function process(node, result) {
                return (0, $bl6Nv._)((0, $7GsX9._)(ImageRendering.prototype), "process", this).call(this, node, result);
            }
        },
        {
            /**
   * Change property and value for IE
   */ key: "set",
            value: function set(decl, prefix) {
                if (prefix !== '-ms-') return (0, $bl6Nv._)((0, $7GsX9._)(ImageRendering.prototype), "set", this).call(this, decl, prefix);
                decl.prop = '-ms-interpolation-mode';
                decl.value = 'nearest-neighbor';
                return decl;
            }
        }
    ]);
    return ImageRendering;
}($8a1dfa5624408614$exports);
$f5cdd405f24fd95d$var$ImageRendering.names = [
    'image-rendering',
    'interpolation-mode'
];
$f5cdd405f24fd95d$exports = $f5cdd405f24fd95d$var$ImageRendering;


var $15028f88f91265c8$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $NBk0Y = parcelRequire("NBk0Y");


var $kUXlT = parcelRequire("kUXlT");
var $15028f88f91265c8$var$BackdropFilter = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(BackdropFilter, Declaration);
    function BackdropFilter(name, prefixes, all) {
        (0, $gd0sY._)(this, BackdropFilter);
        var _this;
        _this = (0, $8xMIM._)(this, BackdropFilter, [
            name,
            prefixes,
            all
        ]);
        if (_this.prefixes) _this.prefixes = $kUXlT.uniq(_this.prefixes.map(function(i) {
            return i === '-ms-' ? '-webkit-' : i;
        }));
        return _this;
    }
    return BackdropFilter;
}($8a1dfa5624408614$exports);
$15028f88f91265c8$var$BackdropFilter.names = [
    'backdrop-filter'
];
$15028f88f91265c8$exports = $15028f88f91265c8$var$BackdropFilter;


var $30834727ffb66c02$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $NBk0Y = parcelRequire("NBk0Y");


var $kUXlT = parcelRequire("kUXlT");
var $30834727ffb66c02$var$BackgroundClip = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(BackgroundClip, Declaration);
    function BackgroundClip(name, prefixes, all) {
        (0, $gd0sY._)(this, BackgroundClip);
        var _this;
        _this = (0, $8xMIM._)(this, BackgroundClip, [
            name,
            prefixes,
            all
        ]);
        if (_this.prefixes) _this.prefixes = $kUXlT.uniq(_this.prefixes.map(function(i) {
            return i === '-ms-' ? '-webkit-' : i;
        }));
        return _this;
    }
    (0, $7cSld._)(BackgroundClip, [
        {
            key: "check",
            value: function check(decl) {
                return decl.value.toLowerCase() === 'text';
            }
        }
    ]);
    return BackgroundClip;
}($8a1dfa5624408614$exports);
$30834727ffb66c02$var$BackgroundClip.names = [
    'background-clip'
];
$30834727ffb66c02$exports = $30834727ffb66c02$var$BackgroundClip;


var $fcf8a5e417be46f0$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $NBk0Y = parcelRequire("NBk0Y");

var $fcf8a5e417be46f0$var$BASIC = [
    'none',
    'underline',
    'overline',
    'line-through',
    'blink',
    'inherit',
    'initial',
    'unset'
];
var $fcf8a5e417be46f0$var$TextDecoration = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(TextDecoration, Declaration);
    function TextDecoration() {
        (0, $gd0sY._)(this, TextDecoration);
        return (0, $8xMIM._)(this, TextDecoration, arguments);
    }
    (0, $7cSld._)(TextDecoration, [
        {
            /**
   * Do not add prefixes for basic values.
   */ key: "check",
            value: function check(decl) {
                return decl.value.split(/\s+/).some(function(i) {
                    return !$fcf8a5e417be46f0$var$BASIC.includes(i);
                });
            }
        }
    ]);
    return TextDecoration;
}($8a1dfa5624408614$exports);
$fcf8a5e417be46f0$var$TextDecoration.names = [
    'text-decoration'
];
$fcf8a5e417be46f0$exports = $fcf8a5e417be46f0$var$TextDecoration;


var $e02aeea6c1e7ce53$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $21h22 = parcelRequire("21h22");


var $e02aeea6c1e7ce53$var$JustifyContent = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(JustifyContent, Declaration);
    function JustifyContent() {
        (0, $gd0sY._)(this, JustifyContent);
        return (0, $8xMIM._)(this, JustifyContent, arguments);
    }
    (0, $7cSld._)(JustifyContent, [
        {
            /**
   * Return property name by final spec
   */ key: "normalize",
            value: function normalize() {
                return 'justify-content';
            }
        },
        {
            /**
   * Change property name for 2009 and 2012 specs
   */ key: "prefixed",
            value: function prefixed(prop, prefix) {
                var spec;
                var ref;
                ref = (0, $21h22._)($10265dcab8e82ebe$exports(prefix), 2), spec = ref[0], prefix = ref[1], ref;
                if (spec === 2009) return prefix + 'box-pack';
                if (spec === 2012) return prefix + 'flex-pack';
                return (0, $bl6Nv._)((0, $7GsX9._)(JustifyContent.prototype), "prefixed", this).call(this, prop, prefix);
            }
        },
        {
            /**
   * Change value for 2009 and 2012 specs
   */ key: "set",
            value: function set(decl, prefix) {
                var spec = $10265dcab8e82ebe$exports(prefix)[0];
                if (spec === 2009 || spec === 2012) {
                    var value = JustifyContent.oldValues[decl.value] || decl.value;
                    decl.value = value;
                    if (spec !== 2009 || value !== 'distribute') return (0, $bl6Nv._)((0, $7GsX9._)(JustifyContent.prototype), "set", this).call(this, decl, prefix);
                } else if (spec === 'final') return (0, $bl6Nv._)((0, $7GsX9._)(JustifyContent.prototype), "set", this).call(this, decl, prefix);
                return undefined;
            }
        }
    ]);
    return JustifyContent;
}($8a1dfa5624408614$exports);
$e02aeea6c1e7ce53$var$JustifyContent.names = [
    'justify-content',
    'flex-pack',
    'box-pack'
];
$e02aeea6c1e7ce53$var$JustifyContent.oldValues = {
    'flex-end': 'end',
    'flex-start': 'start',
    'space-around': 'distribute',
    'space-between': 'justify'
};
$e02aeea6c1e7ce53$exports = $e02aeea6c1e7ce53$var$JustifyContent;


var $e95159d7fcd32236$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $e95159d7fcd32236$var$BackgroundSize = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(BackgroundSize, Declaration);
    function BackgroundSize() {
        (0, $gd0sY._)(this, BackgroundSize);
        return (0, $8xMIM._)(this, BackgroundSize, arguments);
    }
    (0, $7cSld._)(BackgroundSize, [
        {
            /**
   * Duplication parameter for -webkit- browsers
   */ key: "set",
            value: function set(decl, prefix) {
                var value = decl.value.toLowerCase();
                if (prefix === '-webkit-' && !value.includes(' ') && value !== 'contain' && value !== 'cover') decl.value = decl.value + ' ' + decl.value;
                return (0, $bl6Nv._)((0, $7GsX9._)(BackgroundSize.prototype), "set", this).call(this, decl, prefix);
            }
        }
    ]);
    return BackgroundSize;
}($8a1dfa5624408614$exports);
$e95159d7fcd32236$var$BackgroundSize.names = [
    'background-size'
];
$e95159d7fcd32236$exports = $e95159d7fcd32236$var$BackgroundSize;


var $c3d4535d6074c1f1$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $21h22 = parcelRequire("21h22");


var $c3d4535d6074c1f1$var$GridRowColumn = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(GridRowColumn, Declaration);
    function GridRowColumn() {
        (0, $gd0sY._)(this, GridRowColumn);
        return (0, $8xMIM._)(this, GridRowColumn, arguments);
    }
    (0, $7cSld._)(GridRowColumn, [
        {
            /**
   * Translate grid-row / grid-column to separate -ms- prefixed properties
   */ key: "insert",
            value: function insert(decl, prefix, prefixes) {
                if (prefix !== '-ms-') return (0, $bl6Nv._)((0, $7GsX9._)(GridRowColumn.prototype), "insert", this).call(this, decl, prefix, prefixes);
                var values = $81b9427ee4e9e73f$export$98e6a39c04603d36(decl);
                var _utils_translate = (0, $21h22._)($81b9427ee4e9e73f$export$d73ee8ef04f5226a(values, 0, 1), 2), start = _utils_translate[0], span = _utils_translate[1];
                var hasStartValueSpan = values[0] && values[0].includes('span');
                if (hasStartValueSpan) span = values[0].join('').replace(/\D/g, '');
                [
                    [
                        decl.prop,
                        start
                    ],
                    [
                        "".concat(decl.prop, "-span"),
                        span
                    ]
                ].forEach(function(param) {
                    var _param = (0, $21h22._)(param, 2), prop = _param[0], value = _param[1];
                    $81b9427ee4e9e73f$export$f892fd5d935fdd16(decl, prop, value);
                });
                return undefined;
            }
        }
    ]);
    return GridRowColumn;
}($8a1dfa5624408614$exports);
$c3d4535d6074c1f1$var$GridRowColumn.names = [
    'grid-row',
    'grid-column'
];
$c3d4535d6074c1f1$exports = $c3d4535d6074c1f1$var$GridRowColumn;


var $72eb77e83958a843$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");


var $72eb77e83958a843$var$autoplaceGridItems = $81b9427ee4e9e73f$export$60905d0ce9e8730b, $72eb77e83958a843$var$getGridGap = $81b9427ee4e9e73f$export$3e6031d7369213a8, $72eb77e83958a843$var$inheritGridGap = $81b9427ee4e9e73f$export$4c8a39d0988ac794, $72eb77e83958a843$var$prefixTrackProp = $81b9427ee4e9e73f$export$d0fff51f151b796a, $72eb77e83958a843$var$prefixTrackValue = $81b9427ee4e9e73f$export$3a1067fc3c14d315;

var $72eb77e83958a843$var$GridRowsColumns = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(GridRowsColumns, Declaration);
    function GridRowsColumns() {
        (0, $gd0sY._)(this, GridRowsColumns);
        return (0, $8xMIM._)(this, GridRowsColumns, arguments);
    }
    (0, $7cSld._)(GridRowsColumns, [
        {
            key: "insert",
            value: function insert(decl, prefix, prefixes, result) {
                if (prefix !== '-ms-') return (0, $bl6Nv._)((0, $7GsX9._)(GridRowsColumns.prototype), "insert", this).call(this, decl, prefix, prefixes);
                var parent = decl.parent, prop = decl.prop, value = decl.value;
                var isRowProp = prop.includes('rows');
                var isColumnProp = prop.includes('columns');
                var hasGridTemplate = parent.some(function(i) {
                    return i.prop === 'grid-template' || i.prop === 'grid-template-areas';
                });
                /**
     * Not to prefix rows declaration if grid-template(-areas) is present
     */ if (hasGridTemplate && isRowProp) return false;
                var processor = new $2375cb058cd26159$exports({
                    options: {}
                });
                var status = processor.gridStatus(parent, result);
                var gap = $72eb77e83958a843$var$getGridGap(decl);
                gap = $72eb77e83958a843$var$inheritGridGap(decl, gap) || gap;
                var gapValue = isRowProp ? gap.row : gap.column;
                if ((status === 'no-autoplace' || status === true) && !hasGridTemplate) gapValue = null;
                var prefixValue = $72eb77e83958a843$var$prefixTrackValue({
                    gap: gapValue,
                    value: value
                });
                /**
     * Insert prefixes
     */ decl.cloneBefore({
                    prop: $72eb77e83958a843$var$prefixTrackProp({
                        prefix: prefix,
                        prop: prop
                    }),
                    value: prefixValue
                });
                var autoflow = parent.nodes.find(function(i) {
                    return i.prop === 'grid-auto-flow';
                });
                var autoflowValue = 'row';
                if (autoflow && !processor.disabled(autoflow, result)) autoflowValue = autoflow.value.trim();
                if (status === 'autoplace') {
                    /**
       * Show warning if grid-template-rows decl is not found
       */ var rowDecl = parent.nodes.find(function(i) {
                        return i.prop === 'grid-template-rows';
                    });
                    if (!rowDecl && hasGridTemplate) return undefined;
                    else if (!rowDecl && !hasGridTemplate) {
                        decl.warn(result, 'Autoplacement does not work without grid-template-rows property');
                        return undefined;
                    }
                    /**
       * Show warning if grid-template-columns decl is not found
       */ var columnDecl = parent.nodes.find(function(i) {
                        return i.prop === 'grid-template-columns';
                    });
                    if (!columnDecl && !hasGridTemplate) decl.warn(result, 'Autoplacement does not work without grid-template-columns property');
                    /**
       * Autoplace grid items
       */ if (isColumnProp && !hasGridTemplate) $72eb77e83958a843$var$autoplaceGridItems(decl, result, gap, autoflowValue);
                }
                return undefined;
            }
        },
        {
            /**
   * Change IE property back
   */ key: "normalize",
            value: function normalize(prop) {
                return prop.replace(/^grid-(rows|columns)/, 'grid-template-$1');
            }
        },
        {
            /**
   * Change property name for IE
   */ key: "prefixed",
            value: function prefixed(prop, prefix) {
                if (prefix === '-ms-') return $72eb77e83958a843$var$prefixTrackProp({
                    prefix: prefix,
                    prop: prop
                });
                return (0, $bl6Nv._)((0, $7GsX9._)(GridRowsColumns.prototype), "prefixed", this).call(this, prop, prefix);
            }
        }
    ]);
    return GridRowsColumns;
}($8a1dfa5624408614$exports);
$72eb77e83958a843$var$GridRowsColumns.names = [
    'grid-template-rows',
    'grid-template-columns',
    'grid-rows',
    'grid-columns'
];
$72eb77e83958a843$exports = $72eb77e83958a843$var$GridRowsColumns;


var $ee7d5c207943bfcf$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $NBk0Y = parcelRequire("NBk0Y");

var $ee7d5c207943bfcf$var$GridColumnAlign = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(GridColumnAlign, Declaration);
    function GridColumnAlign() {
        (0, $gd0sY._)(this, GridColumnAlign);
        return (0, $8xMIM._)(this, GridColumnAlign, arguments);
    }
    (0, $7cSld._)(GridColumnAlign, [
        {
            /**
   * Do not prefix flexbox values
   */ key: "check",
            value: function check(decl) {
                return !decl.value.includes('flex-') && decl.value !== 'baseline';
            }
        },
        {
            /**
   * Change IE property back
   */ key: "normalize",
            value: function normalize() {
                return 'justify-self';
            }
        },
        {
            /**
   * Change property name for IE
   */ key: "prefixed",
            value: function prefixed(prop, prefix) {
                return prefix + 'grid-column-align';
            }
        }
    ]);
    return GridColumnAlign;
}($8a1dfa5624408614$exports);
$ee7d5c207943bfcf$var$GridColumnAlign.names = [
    'grid-column-align'
];
$ee7d5c207943bfcf$exports = $ee7d5c207943bfcf$var$GridColumnAlign;


var $f065a9c40e380175$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $NBk0Y = parcelRequire("NBk0Y");

var $f065a9c40e380175$var$PrintColorAdjust = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(PrintColorAdjust, Declaration);
    function PrintColorAdjust() {
        (0, $gd0sY._)(this, PrintColorAdjust);
        return (0, $8xMIM._)(this, PrintColorAdjust, arguments);
    }
    (0, $7cSld._)(PrintColorAdjust, [
        {
            /**
   * Return property name by spec
   */ key: "normalize",
            value: function normalize() {
                return 'print-color-adjust';
            }
        },
        {
            /**
   * Change property name for WebKit-based browsers
   */ key: "prefixed",
            value: function prefixed(prop, prefix) {
                if (prefix === '-moz-') return 'color-adjust';
                else return prefix + 'print-color-adjust';
            }
        }
    ]);
    return PrintColorAdjust;
}($8a1dfa5624408614$exports);
$f065a9c40e380175$var$PrintColorAdjust.names = [
    'print-color-adjust',
    'color-adjust'
];
$f065a9c40e380175$exports = $f065a9c40e380175$var$PrintColorAdjust;


var $4c6bf5806d24e022$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $4c6bf5806d24e022$var$OverscrollBehavior = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(OverscrollBehavior, Declaration);
    function OverscrollBehavior() {
        (0, $gd0sY._)(this, OverscrollBehavior);
        return (0, $8xMIM._)(this, OverscrollBehavior, arguments);
    }
    (0, $7cSld._)(OverscrollBehavior, [
        {
            /**
   * Return property name by spec
   */ key: "normalize",
            value: function normalize() {
                return 'overscroll-behavior';
            }
        },
        {
            /**
   * Change property name for IE
   */ key: "prefixed",
            value: function prefixed(prop, prefix) {
                return prefix + 'scroll-chaining';
            }
        },
        {
            /**
   * Change value for IE
   */ key: "set",
            value: function set(decl, prefix) {
                if (decl.value === 'auto') decl.value = 'chained';
                else if (decl.value === 'none' || decl.value === 'contain') decl.value = 'none';
                return (0, $bl6Nv._)((0, $7GsX9._)(OverscrollBehavior.prototype), "set", this).call(this, decl, prefix);
            }
        }
    ]);
    return OverscrollBehavior;
}($8a1dfa5624408614$exports);
$4c6bf5806d24e022$var$OverscrollBehavior.names = [
    'overscroll-behavior',
    'scroll-chaining'
];
$4c6bf5806d24e022$exports = $4c6bf5806d24e022$var$OverscrollBehavior;


var $2ea9de8465bc334b$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");


var $2ea9de8465bc334b$var$getGridGap = $81b9427ee4e9e73f$export$3e6031d7369213a8, $2ea9de8465bc334b$var$inheritGridGap = $81b9427ee4e9e73f$export$4c8a39d0988ac794, $2ea9de8465bc334b$var$parseGridAreas = $81b9427ee4e9e73f$export$32dc7ad492354f65, $2ea9de8465bc334b$var$prefixTrackProp = $81b9427ee4e9e73f$export$d0fff51f151b796a, $2ea9de8465bc334b$var$prefixTrackValue = $81b9427ee4e9e73f$export$3a1067fc3c14d315, $2ea9de8465bc334b$var$warnGridGap = $81b9427ee4e9e73f$export$6547a7a859533ca5, $2ea9de8465bc334b$var$warnMissedAreas = $81b9427ee4e9e73f$export$ebd18cfd7527d7cf;
function $2ea9de8465bc334b$var$getGridRows(tpl) {
    return tpl.trim().slice(1, -1).split(/["']\s*["']?/g);
}
var $2ea9de8465bc334b$var$GridTemplateAreas = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(GridTemplateAreas, Declaration);
    function GridTemplateAreas() {
        (0, $gd0sY._)(this, GridTemplateAreas);
        return (0, $8xMIM._)(this, GridTemplateAreas, arguments);
    }
    (0, $7cSld._)(GridTemplateAreas, [
        {
            /**
   * Translate grid-template-areas to separate -ms- prefixed properties
   */ key: "insert",
            value: function insert(decl, prefix, prefixes, result) {
                if (prefix !== '-ms-') return (0, $bl6Nv._)((0, $7GsX9._)(GridTemplateAreas.prototype), "insert", this).call(this, decl, prefix, prefixes);
                var hasColumns = false;
                var hasRows = false;
                var parent = decl.parent;
                var gap = $2ea9de8465bc334b$var$getGridGap(decl);
                gap = $2ea9de8465bc334b$var$inheritGridGap(decl, gap) || gap;
                // remove already prefixed rows
                // to prevent doubling prefixes
                parent.walkDecls(/-ms-grid-rows/, function(i) {
                    return i.remove();
                });
                // add empty tracks to rows
                parent.walkDecls(/grid-template-(rows|columns)/, function(trackDecl) {
                    if (trackDecl.prop === 'grid-template-rows') {
                        hasRows = true;
                        var prop = trackDecl.prop, value = trackDecl.value;
                        trackDecl.cloneBefore({
                            prop: $2ea9de8465bc334b$var$prefixTrackProp({
                                prefix: prefix,
                                prop: prop
                            }),
                            value: $2ea9de8465bc334b$var$prefixTrackValue({
                                gap: gap.row,
                                value: value
                            })
                        });
                    } else hasColumns = true;
                });
                var gridRows = $2ea9de8465bc334b$var$getGridRows(decl.value);
                if (hasColumns && !hasRows && gap.row && gridRows.length > 1) decl.cloneBefore({
                    prop: '-ms-grid-rows',
                    raws: {},
                    value: $2ea9de8465bc334b$var$prefixTrackValue({
                        gap: gap.row,
                        value: "repeat(".concat(gridRows.length, ", auto)")
                    })
                });
                // warnings
                $2ea9de8465bc334b$var$warnGridGap({
                    decl: decl,
                    gap: gap,
                    hasColumns: hasColumns,
                    result: result
                });
                var areas = $2ea9de8465bc334b$var$parseGridAreas({
                    gap: gap,
                    rows: gridRows
                });
                $2ea9de8465bc334b$var$warnMissedAreas(areas, decl, result);
                return decl;
            }
        }
    ]);
    return GridTemplateAreas;
}($8a1dfa5624408614$exports);
$2ea9de8465bc334b$var$GridTemplateAreas.names = [
    'grid-template-areas'
];
$2ea9de8465bc334b$exports = $2ea9de8465bc334b$var$GridTemplateAreas;


var $d8e0d13f26030a64$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $d8e0d13f26030a64$var$TextEmphasisPosition = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(TextEmphasisPosition, Declaration);
    function TextEmphasisPosition() {
        (0, $gd0sY._)(this, TextEmphasisPosition);
        return (0, $8xMIM._)(this, TextEmphasisPosition, arguments);
    }
    (0, $7cSld._)(TextEmphasisPosition, [
        {
            key: "set",
            value: function set(decl, prefix) {
                if (prefix === '-webkit-') decl.value = decl.value.replace(/\s*(right|left)\s*/i, '');
                return (0, $bl6Nv._)((0, $7GsX9._)(TextEmphasisPosition.prototype), "set", this).call(this, decl, prefix);
            }
        }
    ]);
    return TextEmphasisPosition;
}($8a1dfa5624408614$exports);
$d8e0d13f26030a64$var$TextEmphasisPosition.names = [
    'text-emphasis-position'
];
$d8e0d13f26030a64$exports = $d8e0d13f26030a64$var$TextEmphasisPosition;


var $8bfcbf2ff04a8a36$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $8bfcbf2ff04a8a36$var$TextDecorationSkipInk = /*#__PURE__*/ function(Declaration) {
    "use strict";
    (0, $NBk0Y._)(TextDecorationSkipInk, Declaration);
    function TextDecorationSkipInk() {
        (0, $gd0sY._)(this, TextDecorationSkipInk);
        return (0, $8xMIM._)(this, TextDecorationSkipInk, arguments);
    }
    (0, $7cSld._)(TextDecorationSkipInk, [
        {
            /**
   * Change prefix for ink value
   */ key: "set",
            value: function set(decl, prefix) {
                if (decl.prop === 'text-decoration-skip-ink' && decl.value === 'auto') {
                    decl.prop = prefix + 'text-decoration-skip';
                    decl.value = 'ink';
                    return decl;
                } else return (0, $bl6Nv._)((0, $7GsX9._)(TextDecorationSkipInk.prototype), "set", this).call(this, decl, prefix);
            }
        }
    ]);
    return TextDecorationSkipInk;
}($8a1dfa5624408614$exports);
$8bfcbf2ff04a8a36$var$TextDecorationSkipInk.names = [
    'text-decoration-skip-ink',
    'text-decoration-skip'
];
$8bfcbf2ff04a8a36$exports = $8bfcbf2ff04a8a36$var$TextDecorationSkipInk;


var $af6a01203929e375$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $6zk1M = parcelRequire("6zk1M");

var $9d2d7638558e01a8$exports = {};
'use strict';
$9d2d7638558e01a8$exports = {
    wrap: $9d2d7638558e01a8$var$wrapRange,
    limit: $9d2d7638558e01a8$var$limitRange,
    validate: $9d2d7638558e01a8$var$validateRange,
    test: $9d2d7638558e01a8$var$testRange,
    curry: $9d2d7638558e01a8$var$curry,
    name: $9d2d7638558e01a8$var$name
};
function $9d2d7638558e01a8$var$wrapRange(min, max, value) {
    var maxLessMin = max - min;
    return ((value - min) % maxLessMin + maxLessMin) % maxLessMin + min;
}
function $9d2d7638558e01a8$var$limitRange(min, max, value) {
    return Math.max(min, Math.min(max, value));
}
function $9d2d7638558e01a8$var$validateRange(min, max, value, minExclusive, maxExclusive) {
    if (!$9d2d7638558e01a8$var$testRange(min, max, value, minExclusive, maxExclusive)) throw new Error(value + ' is outside of range [' + min + ',' + max + ')');
    return value;
}
function $9d2d7638558e01a8$var$testRange(min, max, value, minExclusive, maxExclusive) {
    return !(value < min || value > max || maxExclusive && value === max || minExclusive && value === min);
}
function $9d2d7638558e01a8$var$name(min, max, minExcl, maxExcl) {
    return (minExcl ? '(' : '[') + min + ',' + max + (maxExcl ? ')' : ']');
}
function $9d2d7638558e01a8$var$curry(min, max, minExclusive, maxExclusive) {
    var boundNameFn = $9d2d7638558e01a8$var$name.bind(null, min, max, minExclusive, maxExclusive);
    return {
        wrap: $9d2d7638558e01a8$var$wrapRange.bind(null, min, max),
        limit: $9d2d7638558e01a8$var$limitRange.bind(null, min, max),
        validate: function validate(value) {
            return $9d2d7638558e01a8$var$validateRange(min, max, value, minExclusive, maxExclusive);
        },
        test: function test(value) {
            return $9d2d7638558e01a8$var$testRange(min, max, value, minExclusive, maxExclusive);
        },
        toString: boundNameFn,
        name: boundNameFn
    };
}





var $kUXlT = parcelRequire("kUXlT");
var $af6a01203929e375$var$IS_DIRECTION = /top|left|right|bottom/gi;
var $af6a01203929e375$var$Gradient = /*#__PURE__*/ function(Value) {
    "use strict";
    (0, $NBk0Y._)(Gradient, Value);
    function Gradient() {
        (0, $gd0sY._)(this, Gradient);
        return (0, $8xMIM._)(this, Gradient, arguments);
    }
    (0, $7cSld._)(Gradient, [
        {
            /**
   * Do not add non-webkit prefixes for list-style and object
   */ key: "add",
            value: function add(decl, prefix) {
                var p = decl.prop;
                if (p.includes('mask')) {
                    if (prefix === '-webkit-' || prefix === '-webkit- old') return (0, $bl6Nv._)((0, $7GsX9._)(Gradient.prototype), "add", this).call(this, decl, prefix);
                } else if (p === 'list-style' || p === 'list-style-image' || p === 'content') {
                    if (prefix === '-webkit-' || prefix === '-webkit- old') return (0, $bl6Nv._)((0, $7GsX9._)(Gradient.prototype), "add", this).call(this, decl, prefix);
                } else return (0, $bl6Nv._)((0, $7GsX9._)(Gradient.prototype), "add", this).call(this, decl, prefix);
                return undefined;
            }
        },
        {
            /**
   * Get div token from exists parameters
   */ key: "cloneDiv",
            value: function cloneDiv(params) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = params[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        if (i.type === 'div' && i.value === ',') return i;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    after: ' ',
                    type: 'div',
                    value: ','
                };
            }
        },
        {
            /**
   * Change colors syntax to old webkit
   */ key: "colorStops",
            value: function colorStops(params) {
                var result = [];
                for(var i = 0; i < params.length; i++){
                    var pos = void 0;
                    var param = params[i];
                    var item = void 0;
                    if (i === 0) continue;
                    var color = $ab01bb1e82e8e99f$exports.stringify(param[0]);
                    if (param[1] && param[1].type === 'word') pos = param[1].value;
                    else if (param[2] && param[2].type === 'word') pos = param[2].value;
                    var stop = void 0;
                    if (i === 1 && (!pos || pos === '0%')) stop = "from(".concat(color, ")");
                    else if (i === params.length - 1 && (!pos || pos === '100%')) stop = "to(".concat(color, ")");
                    else if (pos) stop = "color-stop(".concat(pos, ", ").concat(color, ")");
                    else stop = "color-stop(".concat(color, ")");
                    var div = param[param.length - 1];
                    params[i] = [
                        {
                            type: 'word',
                            value: stop
                        }
                    ];
                    if (div.type === 'div' && div.value === ',') item = params[i].push(div);
                    result.push(item);
                }
                return result;
            }
        },
        {
            /**
   * Change new direction to old
   */ key: "convertDirection",
            value: function convertDirection(params) {
                if (params.length > 0) {
                    if (params[0].value === 'to') this.fixDirection(params);
                    else if (params[0].value.includes('deg')) this.fixAngle(params);
                    else if (this.isRadial(params)) this.fixRadial(params);
                }
                return params;
            }
        },
        {
            /**
   * Add 90 degrees
   */ key: "fixAngle",
            value: function fixAngle(params) {
                var first = params[0].value;
                first = parseFloat(first);
                first = Math.abs(450 - first) % 360;
                first = this.roundFloat(first, 3);
                params[0].value = "".concat(first, "deg");
            }
        },
        {
            /**
   * Replace `to top left` to `bottom right`
   */ key: "fixDirection",
            value: function fixDirection(params) {
                params.splice(0, 2);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = params[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var param = _step.value;
                        if (param.type === 'div') break;
                        if (param.type === 'word') param.value = this.revertDirection(param.value);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
   * Fix radial direction syntax
   */ key: "fixRadial",
            value: function fixRadial(params) {
                var _params;
                var first = [];
                var second = [];
                var a, b, c, i, next;
                for(i = 0; i < params.length - 2; i++){
                    a = params[i];
                    b = params[i + 1];
                    c = params[i + 2];
                    if (a.type === 'space' && b.value === 'at' && c.type === 'space') {
                        next = i + 3;
                        break;
                    } else first.push(a);
                }
                var div;
                for(i = next; i < params.length; i++)if (params[i].type === 'div') {
                    div = params[i];
                    break;
                } else second.push(params[i]);
                (_params = params).splice.apply(_params, [
                    0,
                    i
                ].concat((0, $6zk1M._)(second), [
                    div
                ], (0, $6zk1M._)(first)));
            }
        },
        {
            /**
   * Look for at word
   */ key: "isRadial",
            value: function isRadial(params) {
                var state = 'before';
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = params[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var param = _step.value;
                        if (state === 'before' && param.type === 'space') state = 'at';
                        else if (state === 'at' && param.value === 'at') state = 'after';
                        else if (state === 'after' && param.type === 'space') return true;
                        else if (param.type === 'div') break;
                        else state = 'before';
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return false;
            }
        },
        {
            /**
   * Replace old direction to new
   */ key: "newDirection",
            value: function newDirection(params) {
                if (params[0].value === 'to') return params;
                $af6a01203929e375$var$IS_DIRECTION.lastIndex = 0 // reset search index of global regexp
                ;
                if (!$af6a01203929e375$var$IS_DIRECTION.test(params[0].value)) return params;
                params.unshift({
                    type: 'word',
                    value: 'to'
                }, {
                    type: 'space',
                    value: ' '
                });
                for(var i = 2; i < params.length; i++){
                    if (params[i].type === 'div') break;
                    if (params[i].type === 'word') params[i].value = this.revertDirection(params[i].value);
                }
                return params;
            }
        },
        {
            /**
   * Normalize angle
   */ key: "normalize",
            value: function normalize(nodes, gradientName) {
                if (!nodes[0]) return nodes;
                if (/-?\d+(.\d+)?grad/.test(nodes[0].value)) nodes[0].value = this.normalizeUnit(nodes[0].value, 400);
                else if (/-?\d+(.\d+)?rad/.test(nodes[0].value)) nodes[0].value = this.normalizeUnit(nodes[0].value, 2 * Math.PI);
                else if (/-?\d+(.\d+)?turn/.test(nodes[0].value)) nodes[0].value = this.normalizeUnit(nodes[0].value, 1);
                else if (nodes[0].value.includes('deg')) {
                    var num = parseFloat(nodes[0].value);
                    num = $9d2d7638558e01a8$exports.wrap(0, 360, num);
                    nodes[0].value = "".concat(num, "deg");
                }
                if (gradientName === 'linear-gradient' || gradientName === 'repeating-linear-gradient') {
                    var direction = nodes[0].value;
                    // Unitless zero for `<angle>` values are allowed in CSS gradients and transforms.
                    // Spec: https://github.com/w3c/csswg-drafts/commit/602789171429b2231223ab1e5acf8f7f11652eb3
                    if (direction === '0deg' || direction === '0') nodes = this.replaceFirst(nodes, 'to', ' ', 'top');
                    else if (direction === '90deg') nodes = this.replaceFirst(nodes, 'to', ' ', 'right');
                    else if (direction === '180deg') nodes = this.replaceFirst(nodes, 'to', ' ', 'bottom') // default value
                    ;
                    else if (direction === '270deg') nodes = this.replaceFirst(nodes, 'to', ' ', 'left');
                }
                return nodes;
            }
        },
        {
            /**
   * Convert angle unit to deg
   */ key: "normalizeUnit",
            value: function normalizeUnit(str, full) {
                var num = parseFloat(str);
                var deg = num / full * 360;
                return "".concat(deg, "deg");
            }
        },
        {
            /**
   * Remove old WebKit gradient too
   */ key: "old",
            value: function old(prefix) {
                if (prefix === '-webkit-') {
                    var type;
                    if (this.name === 'linear-gradient') type = 'linear';
                    else if (this.name === 'repeating-linear-gradient') type = 'repeating-linear';
                    else if (this.name === 'repeating-radial-gradient') type = 'repeating-radial';
                    else type = 'radial';
                    var string = '-gradient';
                    var regexp = $kUXlT.regexp("-webkit-(".concat(type, "-gradient|gradient\\(\\s*").concat(type, ")"), false);
                    return new $779b0bcb8318089d$exports(this.name, prefix + this.name, string, regexp);
                } else return (0, $bl6Nv._)((0, $7GsX9._)(Gradient.prototype), "old", this).call(this, prefix);
            }
        },
        {
            /**
   * Change direction syntax to old webkit
   */ key: "oldDirection",
            value: function oldDirection(params) {
                var div = this.cloneDiv(params[0]);
                if (params[0][0].value !== 'to') return params.unshift([
                    {
                        type: 'word',
                        value: Gradient.oldDirections.bottom
                    },
                    div
                ]);
                else {
                    var words = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = params[0].slice(2)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var node = _step.value;
                            if (node.type === 'word') words.push(node.value.toLowerCase());
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    words = words.join(' ');
                    var old = Gradient.oldDirections[words] || words;
                    params[0] = [
                        {
                            type: 'word',
                            value: old
                        },
                        div
                    ];
                    return params[0];
                }
            }
        },
        {
            /**
   * Convert to old webkit syntax
   */ key: "oldWebkit",
            value: function oldWebkit(node) {
                var nodes = node.nodes;
                var string = $ab01bb1e82e8e99f$exports.stringify(node.nodes);
                if (this.name !== 'linear-gradient') return false;
                if (nodes[0] && nodes[0].value.includes('deg')) return false;
                if (string.includes('px') || string.includes('-corner') || string.includes('-side')) return false;
                var params = [
                    []
                ];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        params[params.length - 1].push(i);
                        if (i.type === 'div' && i.value === ',') params.push([]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.oldDirection(params);
                this.colorStops(params);
                node.nodes = [];
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = params[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var param = _step1.value;
                        node.nodes = node.nodes.concat(param);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                node.nodes.unshift({
                    type: 'word',
                    value: 'linear'
                }, this.cloneDiv(node.nodes));
                node.value = '-webkit-gradient';
                return true;
            }
        },
        {
            /**
   * Change degrees for webkit prefix
   */ key: "replace",
            value: function replace(string, prefix) {
                var ast = $ab01bb1e82e8e99f$exports(string);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = ast.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        var gradientName = this.name // gradient name
                        ;
                        if (node.type === 'function' && node.value === gradientName) {
                            node.nodes = this.newDirection(node.nodes);
                            node.nodes = this.normalize(node.nodes, gradientName);
                            if (prefix === '-webkit- old') {
                                var changes = this.oldWebkit(node);
                                if (!changes) return false;
                            } else {
                                node.nodes = this.convertDirection(node.nodes);
                                node.value = prefix + node.value;
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return ast.toString();
            }
        },
        {
            /**
   * Replace first token
   */ key: "replaceFirst",
            value: function replaceFirst(params) {
                for(var _len = arguments.length, words = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    words[_key - 1] = arguments[_key];
                }
                var prefix = words.map(function(i) {
                    if (i === ' ') return {
                        type: 'space',
                        value: i
                    };
                    return {
                        type: 'word',
                        value: i
                    };
                });
                return prefix.concat(params.slice(1));
            }
        },
        {
            key: "revertDirection",
            value: function revertDirection(word) {
                return Gradient.directions[word.toLowerCase()] || word;
            }
        },
        {
            /**
   * Round float and save digits under dot
   */ key: "roundFloat",
            value: function roundFloat(float, digits) {
                return parseFloat(float.toFixed(digits));
            }
        }
    ]);
    return Gradient;
}($56181cada244c6df$exports);
$af6a01203929e375$var$Gradient.names = [
    'linear-gradient',
    'repeating-linear-gradient',
    'radial-gradient',
    'repeating-radial-gradient'
];
$af6a01203929e375$var$Gradient.directions = {
    bottom: 'top',
    left: 'right',
    right: 'left',
    top: 'bottom' // default value
};
// Direction to replace
$af6a01203929e375$var$Gradient.oldDirections = {
    'bottom': 'left top, left bottom',
    'bottom left': 'right top, left bottom',
    'bottom right': 'left top, right bottom',
    'left': 'right top, left top',
    'left bottom': 'right top, left bottom',
    'left top': 'right bottom, left top',
    'right': 'left top, right top',
    'right bottom': 'left top, right bottom',
    'right top': 'left bottom, right top',
    'top': 'left bottom, left top',
    'top left': 'right bottom, left top',
    'top right': 'left bottom, right top'
};
$af6a01203929e375$exports = $af6a01203929e375$var$Gradient;


var $b18a7d617270ee9c$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");


function $b18a7d617270ee9c$var$regexp(name) {
    return new RegExp("(^|[\\s,(])(".concat(name, "($|[\\s),]))"), 'gi');
}
var $b18a7d617270ee9c$var$Intrinsic = /*#__PURE__*/ function(Value) {
    "use strict";
    (0, $NBk0Y._)(Intrinsic, Value);
    function Intrinsic() {
        (0, $gd0sY._)(this, Intrinsic);
        return (0, $8xMIM._)(this, Intrinsic, arguments);
    }
    (0, $7cSld._)(Intrinsic, [
        {
            key: "add",
            value: function add(decl, prefix) {
                if (decl.prop.includes('grid') && prefix !== '-webkit-') return undefined;
                return (0, $bl6Nv._)((0, $7GsX9._)(Intrinsic.prototype), "add", this).call(this, decl, prefix);
            }
        },
        {
            key: "isStretch",
            value: function isStretch() {
                return this.name === 'stretch' || this.name === 'fill' || this.name === 'fill-available';
            }
        },
        {
            key: "old",
            value: function old(prefix) {
                var prefixed = prefix + this.name;
                if (this.isStretch()) {
                    if (prefix === '-moz-') prefixed = '-moz-available';
                    else if (prefix === '-webkit-') prefixed = '-webkit-fill-available';
                }
                return new $779b0bcb8318089d$exports(this.name, prefixed, prefixed, $b18a7d617270ee9c$var$regexp(prefixed));
            }
        },
        {
            key: "regexp",
            value: function regexp1() {
                if (!this.regexpCache) this.regexpCache = $b18a7d617270ee9c$var$regexp(this.name);
                return this.regexpCache;
            }
        },
        {
            key: "replace",
            value: function replace(string, prefix) {
                if (prefix === '-moz-' && this.isStretch()) return string.replace(this.regexp(), '$1-moz-available$3');
                if (prefix === '-webkit-' && this.isStretch()) return string.replace(this.regexp(), '$1-webkit-fill-available$3');
                return (0, $bl6Nv._)((0, $7GsX9._)(Intrinsic.prototype), "replace", this).call(this, string, prefix);
            }
        }
    ]);
    return Intrinsic;
}($56181cada244c6df$exports);
$b18a7d617270ee9c$var$Intrinsic.names = [
    'max-content',
    'min-content',
    'fit-content',
    'fill',
    'fill-available',
    'stretch'
];
$b18a7d617270ee9c$exports = $b18a7d617270ee9c$var$Intrinsic;


var $8204e3736c48de96$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");


var $8204e3736c48de96$var$Pixelated = /*#__PURE__*/ function(Value) {
    "use strict";
    (0, $NBk0Y._)(Pixelated, Value);
    function Pixelated() {
        (0, $gd0sY._)(this, Pixelated);
        return (0, $8xMIM._)(this, Pixelated, arguments);
    }
    (0, $7cSld._)(Pixelated, [
        {
            /**
   * Different name for WebKit and Firefox
   */ key: "old",
            value: function old(prefix) {
                if (prefix === '-webkit-') return new $779b0bcb8318089d$exports(this.name, '-webkit-optimize-contrast');
                if (prefix === '-moz-') return new $779b0bcb8318089d$exports(this.name, '-moz-crisp-edges');
                return (0, $bl6Nv._)((0, $7GsX9._)(Pixelated.prototype), "old", this).call(this, prefix);
            }
        },
        {
            /**
   * Use non-standard name for WebKit and Firefox
   */ key: "replace",
            value: function replace(string, prefix) {
                if (prefix === '-webkit-') return string.replace(this.regexp(), '$1-webkit-optimize-contrast');
                if (prefix === '-moz-') return string.replace(this.regexp(), '$1-moz-crisp-edges');
                return (0, $bl6Nv._)((0, $7GsX9._)(Pixelated.prototype), "replace", this).call(this, string, prefix);
            }
        }
    ]);
    return Pixelated;
}($56181cada244c6df$exports);
$8204e3736c48de96$var$Pixelated.names = [
    'pixelated'
];
$8204e3736c48de96$exports = $8204e3736c48de96$var$Pixelated;


var $ede8b9d5d10a3a71$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $bl6Nv = parcelRequire("bl6Nv");

var $7GsX9 = parcelRequire("7GsX9");

var $NBk0Y = parcelRequire("NBk0Y");

var $ede8b9d5d10a3a71$var$ImageSet = /*#__PURE__*/ function(Value) {
    "use strict";
    (0, $NBk0Y._)(ImageSet, Value);
    function ImageSet() {
        (0, $gd0sY._)(this, ImageSet);
        return (0, $8xMIM._)(this, ImageSet, arguments);
    }
    (0, $7cSld._)(ImageSet, [
        {
            /**
   * Use non-standard name for WebKit and Firefox
   */ key: "replace",
            value: function replace(string, prefix) {
                var fixed = (0, $bl6Nv._)((0, $7GsX9._)(ImageSet.prototype), "replace", this).call(this, string, prefix);
                if (prefix === '-webkit-') fixed = fixed.replace(/("[^"]+"|'[^']+')(\s+\d+\w)/gi, 'url($1)$2');
                return fixed;
            }
        }
    ]);
    return ImageSet;
}($56181cada244c6df$exports);
$ede8b9d5d10a3a71$var$ImageSet.names = [
    'image-set'
];
$ede8b9d5d10a3a71$exports = $ede8b9d5d10a3a71$var$ImageSet;


var $5a0d0f61b038fb6e$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $NBk0Y = parcelRequire("NBk0Y");

var $9HfAZ = parcelRequire("9HfAZ");
var $5a0d0f61b038fb6e$require$list = $9HfAZ.list;

var $5a0d0f61b038fb6e$var$CrossFade = /*#__PURE__*/ function(Value) {
    "use strict";
    (0, $NBk0Y._)(CrossFade, Value);
    function CrossFade() {
        (0, $gd0sY._)(this, CrossFade);
        return (0, $8xMIM._)(this, CrossFade, arguments);
    }
    (0, $7cSld._)(CrossFade, [
        {
            key: "replace",
            value: function replace(string, prefix) {
                var _this = this;
                return $5a0d0f61b038fb6e$require$list.space(string).map(function(value) {
                    if (value.slice(0, +_this.name.length + 1) !== _this.name + '(') return value;
                    var close = value.lastIndexOf(')');
                    var after = value.slice(close + 1);
                    var args = value.slice(_this.name.length + 1, close);
                    if (prefix === '-webkit-') {
                        var match = args.match(/\d*.?\d+%?/);
                        if (match) {
                            args = args.slice(match[0].length).trim();
                            args += ", ".concat(match[0]);
                        } else args += ', 0.5';
                    }
                    return prefix + _this.name + '(' + args + ')' + after;
                }).join(' ');
            }
        }
    ]);
    return CrossFade;
}($56181cada244c6df$exports);
$5a0d0f61b038fb6e$var$CrossFade.names = [
    'cross-fade'
];
$5a0d0f61b038fb6e$exports = $5a0d0f61b038fb6e$var$CrossFade;


var $52fbc31c406a0a99$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $NBk0Y = parcelRequire("NBk0Y");

var $21h22 = parcelRequire("21h22");



var $52fbc31c406a0a99$var$DisplayFlex = /*#__PURE__*/ function(Value) {
    "use strict";
    (0, $NBk0Y._)(DisplayFlex, Value);
    function DisplayFlex(name, prefixes) {
        (0, $gd0sY._)(this, DisplayFlex);
        var _this;
        _this = (0, $8xMIM._)(this, DisplayFlex, [
            name,
            prefixes
        ]);
        if (name === 'display-flex') _this.name = 'flex';
        return _this;
    }
    (0, $7cSld._)(DisplayFlex, [
        {
            /**
   * Faster check for flex value
   */ key: "check",
            value: function check(decl) {
                return decl.prop === 'display' && decl.value === this.name;
            }
        },
        {
            /**
   * Change value for old specs
   */ key: "old",
            value: function old(prefix) {
                var prefixed = this.prefixed(prefix);
                if (!prefixed) return undefined;
                return new $779b0bcb8318089d$exports(this.name, prefixed);
            }
        },
        {
            /**
   * Return value by spec
   */ key: "prefixed",
            value: function prefixed(prefix) {
                var spec, value;
                var ref;
                ref = (0, $21h22._)($10265dcab8e82ebe$exports(prefix), 2), spec = ref[0], prefix = ref[1], ref;
                if (spec === 2009) {
                    if (this.name === 'flex') value = 'box';
                    else value = 'inline-box';
                } else if (spec === 2012) {
                    if (this.name === 'flex') value = 'flexbox';
                    else value = 'inline-flexbox';
                } else if (spec === 'final') value = this.name;
                return prefix + value;
            }
        },
        {
            /**
   * Add prefix to value depend on flebox spec version
   */ key: "replace",
            value: function replace(string, prefix) {
                return this.prefixed(prefix);
            }
        }
    ]);
    return DisplayFlex;
}($56181cada244c6df$exports);
$52fbc31c406a0a99$var$DisplayFlex.names = [
    'display-flex',
    'inline-flex'
];
$52fbc31c406a0a99$exports = $52fbc31c406a0a99$var$DisplayFlex;


var $72052dd7687f8e23$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $NBk0Y = parcelRequire("NBk0Y");

var $72052dd7687f8e23$var$DisplayGrid = /*#__PURE__*/ function(Value) {
    "use strict";
    (0, $NBk0Y._)(DisplayGrid, Value);
    function DisplayGrid(name, prefixes) {
        (0, $gd0sY._)(this, DisplayGrid);
        var _this;
        _this = (0, $8xMIM._)(this, DisplayGrid, [
            name,
            prefixes
        ]);
        if (name === 'display-grid') _this.name = 'grid';
        return _this;
    }
    (0, $7cSld._)(DisplayGrid, [
        {
            /**
   * Faster check for flex value
   */ key: "check",
            value: function check(decl) {
                return decl.prop === 'display' && decl.value === this.name;
            }
        }
    ]);
    return DisplayGrid;
}($56181cada244c6df$exports);
$72052dd7687f8e23$var$DisplayGrid.names = [
    'display-grid',
    'inline-grid'
];
$72052dd7687f8e23$exports = $72052dd7687f8e23$var$DisplayGrid;


var $878c064f472aad85$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $NBk0Y = parcelRequire("NBk0Y");

var $878c064f472aad85$var$FilterValue = /*#__PURE__*/ function(Value) {
    "use strict";
    (0, $NBk0Y._)(FilterValue, Value);
    function FilterValue(name, prefixes) {
        (0, $gd0sY._)(this, FilterValue);
        var _this;
        _this = (0, $8xMIM._)(this, FilterValue, [
            name,
            prefixes
        ]);
        if (name === 'filter-function') _this.name = 'filter';
        return _this;
    }
    return FilterValue;
}($56181cada244c6df$exports);
$878c064f472aad85$var$FilterValue.names = [
    'filter',
    'filter-function'
];
$878c064f472aad85$exports = $878c064f472aad85$var$FilterValue;


var $1d45a80ea2b1f889$exports = {};

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $NBk0Y = parcelRequire("NBk0Y");


var $kUXlT = parcelRequire("kUXlT");
var $1d45a80ea2b1f889$var$Autofill = /*#__PURE__*/ function(Selector) {
    "use strict";
    (0, $NBk0Y._)(Autofill, Selector);
    function Autofill(name, prefixes, all) {
        (0, $gd0sY._)(this, Autofill);
        var _this;
        _this = (0, $8xMIM._)(this, Autofill, [
            name,
            prefixes,
            all
        ]);
        if (_this.prefixes) _this.prefixes = $kUXlT.uniq(_this.prefixes.map(function() {
            return '-webkit-';
        }));
        return _this;
    }
    (0, $7cSld._)(Autofill, [
        {
            /**
   * Return different selectors depend on prefix
   */ key: "prefixed",
            value: function prefixed(prefix) {
                if (prefix === '-webkit-') return ':-webkit-autofill';
                return ":".concat(prefix, "autofill");
            }
        }
    ]);
    return Autofill;
}($9f31103710b4d9bb$exports);
$1d45a80ea2b1f889$var$Autofill.names = [
    ':autofill'
];
$1d45a80ea2b1f889$exports = $1d45a80ea2b1f889$var$Autofill;


$9f31103710b4d9bb$exports.hack($1d45a80ea2b1f889$exports);
$9f31103710b4d9bb$exports.hack($6732067c6a2054e9$exports);
$9f31103710b4d9bb$exports.hack($8e625ba5d471e5f7$exports);
$9f31103710b4d9bb$exports.hack($7c082376409caaa5$exports);
$9f31103710b4d9bb$exports.hack($b156425e822aa8a2$exports);
$8a1dfa5624408614$exports.hack($a1cf2ca7108eb247$exports);
$8a1dfa5624408614$exports.hack($2f23323476dd0ba5$exports);
$8a1dfa5624408614$exports.hack($ec6cca6f69603464$exports);
$8a1dfa5624408614$exports.hack($d61dae07a41516e2$exports);
$8a1dfa5624408614$exports.hack($16f05f1b825e5a03$exports);
$8a1dfa5624408614$exports.hack($d7bb3f8b910fc429$exports);
$8a1dfa5624408614$exports.hack($11281d7fce740793$exports);
$8a1dfa5624408614$exports.hack($7ea5e5e894cc2b50$exports);
$8a1dfa5624408614$exports.hack($50db457fff8cda0e$exports);
$8a1dfa5624408614$exports.hack($81c31f513704f4c1$exports);
$8a1dfa5624408614$exports.hack($8da2249594cde3a2$exports);
$8a1dfa5624408614$exports.hack($3ca109fe10f7a338$exports);
$8a1dfa5624408614$exports.hack($7fd7aecb11781db0$exports);
$8a1dfa5624408614$exports.hack($4ec5c8c0149a8671$exports);
$8a1dfa5624408614$exports.hack($42a505bd8ea07153$exports);
$8a1dfa5624408614$exports.hack($f5c04291cf55e453$exports);
$8a1dfa5624408614$exports.hack($e844ab2b08215939$exports);
$8a1dfa5624408614$exports.hack($d2e215b019503064$exports);
$8a1dfa5624408614$exports.hack($9fcf91cf85f860f5$exports);
$8a1dfa5624408614$exports.hack($a3d3e116096f4ae3$exports);
$8a1dfa5624408614$exports.hack($83398130b9c9739d$exports);
$8a1dfa5624408614$exports.hack($c88f857ba6975838$exports);
$8a1dfa5624408614$exports.hack($cc2e7602c1335dd1$exports);
$8a1dfa5624408614$exports.hack($1837c036d480078f$exports);
$8a1dfa5624408614$exports.hack($fc6d4a00b27c581a$exports);
$8a1dfa5624408614$exports.hack($cfd00806a02bf618$exports);
$8a1dfa5624408614$exports.hack($cb1981e0c3a4ad67$exports);
$8a1dfa5624408614$exports.hack($2ecf366a663d0dd0$exports);
$8a1dfa5624408614$exports.hack($e57c255aa3b78e44$exports);
$8a1dfa5624408614$exports.hack($3e39c7160360b906$exports);
$8a1dfa5624408614$exports.hack($f5cdd405f24fd95d$exports);
$8a1dfa5624408614$exports.hack($15028f88f91265c8$exports);
$8a1dfa5624408614$exports.hack($30834727ffb66c02$exports);
$8a1dfa5624408614$exports.hack($fcf8a5e417be46f0$exports);
$8a1dfa5624408614$exports.hack($e02aeea6c1e7ce53$exports);
$8a1dfa5624408614$exports.hack($e95159d7fcd32236$exports);
$8a1dfa5624408614$exports.hack($c3d4535d6074c1f1$exports);
$8a1dfa5624408614$exports.hack($72eb77e83958a843$exports);
$8a1dfa5624408614$exports.hack($ee7d5c207943bfcf$exports);
$8a1dfa5624408614$exports.hack($4c6bf5806d24e022$exports);
$8a1dfa5624408614$exports.hack($2ea9de8465bc334b$exports);
$8a1dfa5624408614$exports.hack($f065a9c40e380175$exports);
$8a1dfa5624408614$exports.hack($d8e0d13f26030a64$exports);
$8a1dfa5624408614$exports.hack($8bfcbf2ff04a8a36$exports);
$56181cada244c6df$exports.hack($af6a01203929e375$exports);
$56181cada244c6df$exports.hack($b18a7d617270ee9c$exports);
$56181cada244c6df$exports.hack($8204e3736c48de96$exports);
$56181cada244c6df$exports.hack($ede8b9d5d10a3a71$exports);
$56181cada244c6df$exports.hack($5a0d0f61b038fb6e$exports);
$56181cada244c6df$exports.hack($52fbc31c406a0a99$exports);
$56181cada244c6df$exports.hack($72052dd7687f8e23$exports);
$56181cada244c6df$exports.hack($878c064f472aad85$exports);
var $77d8edc20cc2c324$var$declsCache = new Map();
var $77d8edc20cc2c324$var$Prefixes = /*#__PURE__*/ function() {
    "use strict";
    function Prefixes(data, browsers) {
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        (0, $gd0sY._)(this, Prefixes);
        this.data = data;
        this.browsers = browsers;
        this.options = options;
        var ref;
        ref = (0, $21h22._)(this.preprocess(this.select(this.data)), 2), this.add = ref[0], this.remove = ref[1], ref;
        this.transition = new $5a51962e2608793a$exports(this);
        this.processor = new $2375cb058cd26159$exports(this);
    }
    (0, $7cSld._)(Prefixes, [
        {
            /**
   * Return clone instance to remove all prefixes
   */ key: "cleaner",
            value: function cleaner() {
                if (this.cleanerCache) return this.cleanerCache;
                if (this.browsers.selected.length) {
                    var empty = new $ea2b86d4fd154896$exports(this.browsers.data, []);
                    this.cleanerCache = new Prefixes(this.data, empty, this.options);
                } else return this;
                return this.cleanerCache;
            }
        },
        {
            /**
   * Declaration loader with caching
   */ key: "decl",
            value: function decl(prop) {
                if (!$77d8edc20cc2c324$var$declsCache.has(prop)) $77d8edc20cc2c324$var$declsCache.set(prop, $8a1dfa5624408614$exports.load(prop));
                return $77d8edc20cc2c324$var$declsCache.get(prop);
            }
        },
        {
            /**
   * Group declaration by unprefixed property to check them
   */ key: "group",
            value: function group(decl) {
                var _this = this;
                var rule = decl.parent;
                var index = rule.index(decl);
                var length = rule.nodes.length;
                var unprefixed = this.unprefixed(decl.prop);
                var checker = function(step, callback) {
                    index += step;
                    while(index >= 0 && index < length){
                        var other = rule.nodes[index];
                        if (other.type === 'decl') {
                            if (step === -1 && other.prop === unprefixed) {
                                if (!$ea2b86d4fd154896$exports.withPrefix(other.value)) break;
                            }
                            if (_this.unprefixed(other.prop) !== unprefixed) break;
                            else if (callback(other) === true) return true;
                            if (step === 1 && other.prop === unprefixed) {
                                if (!$ea2b86d4fd154896$exports.withPrefix(other.value)) break;
                            }
                        }
                        index += step;
                    }
                    return false;
                };
                return {
                    down: function(callback) {
                        return checker(1, callback);
                    },
                    up: function(callback) {
                        return checker(-1, callback);
                    }
                };
            }
        },
        {
            /**
   * Normalize prefix for remover
   */ key: "normalize",
            value: function normalize(prop) {
                return this.decl(prop).normalize(prop);
            }
        },
        {
            /**
   * Return prefixed version of property
   */ key: "prefixed",
            value: function prefixed(prop, prefix) {
                prop = $94d58ff1b5a11e04$exports.unprefixed(prop);
                return this.decl(prop).prefixed(prop, prefix);
            }
        },
        {
            /**
   * Cache prefixes data to fast CSS processing
   */ key: "preprocess",
            value: function preprocess(selected) {
                var add = {
                    '@supports': new $a71b3b39412ff195$exports(Prefixes, this),
                    'selectors': []
                };
                for(var name in selected.add){
                    var prefixes = selected.add[name];
                    if (name === '@keyframes' || name === '@viewport') add[name] = new $a2f40f00934e75d0$exports(name, prefixes, this);
                    else if (name === '@resolution') add[name] = new $f7746ff206f0fa3f$exports(name, prefixes, this);
                    else if (this.data[name].selector) add.selectors.push($9f31103710b4d9bb$exports.load(name, prefixes, this));
                    else {
                        var props = this.data[name].props;
                        if (props) {
                            var value = $56181cada244c6df$exports.load(name, prefixes, this);
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = props[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var prop = _step.value;
                                    if (!add[prop]) add[prop] = {
                                        values: []
                                    };
                                    add[prop].values.push(value);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        } else {
                            var values = add[name] && add[name].values || [];
                            add[name] = $8a1dfa5624408614$exports.load(name, prefixes, this);
                            add[name].values = values;
                        }
                    }
                }
                var remove = {
                    selectors: []
                };
                for(var name1 in selected.remove){
                    var prefixes1 = selected.remove[name1];
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    if (this.data[name1].selector) {
                        var selector = $9f31103710b4d9bb$exports.load(name1, prefixes1);
                        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                        try {
                            for(var _iterator1 = prefixes1[Symbol.iterator](), _step1; !(_iteratorNormalCompletion2 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion2 = true){
                                var prefix = _step1.value;
                                remove.selectors.push(selector.old(prefix));
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    } else if (name1 === '@keyframes' || name1 === '@viewport') try {
                        for(var _iterator2 = prefixes1[Symbol.iterator](), _step2; !(_iteratorNormalCompletion1 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion1 = true){
                            var prefix1 = _step2.value;
                            var prefixed = "@".concat(prefix1).concat(name1.slice(1));
                            remove[prefixed] = {
                                remove: true
                            };
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    else if (name1 === '@resolution') remove[name1] = new $f7746ff206f0fa3f$exports(name1, prefixes1, this);
                    else {
                        var props1 = this.data[name1].props;
                        var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                        if (props1) {
                            var value1 = $56181cada244c6df$exports.load(name1, [], this);
                            var _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
                            try {
                                for(var _iterator3 = prefixes1[Symbol.iterator](), _step3; !(_iteratorNormalCompletion4 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion4 = true){
                                    var prefix2 = _step3.value;
                                    var old = value1.old(prefix2);
                                    var _iteratorNormalCompletion5 = true, _didIteratorError5 = false, _iteratorError5 = undefined;
                                    if (old) try {
                                        for(var _iterator4 = props1[Symbol.iterator](), _step4; !(_iteratorNormalCompletion5 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion5 = true){
                                            var prop1 = _step4.value;
                                            if (!remove[prop1]) remove[prop1] = {};
                                            if (!remove[prop1].values) remove[prop1].values = [];
                                            remove[prop1].values.push(old);
                                        }
                                    } catch (err) {
                                        _didIteratorError5 = true;
                                        _iteratorError5 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion5 && _iterator4.return != null) {
                                                _iterator4.return();
                                            }
                                        } finally{
                                            if (_didIteratorError5) {
                                                throw _iteratorError5;
                                            }
                                        }
                                    }
                                }
                            } catch (err) {
                                _didIteratorError4 = true;
                                _iteratorError4 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion4 && _iterator3.return != null) {
                                        _iterator3.return();
                                    }
                                } finally{
                                    if (_didIteratorError4) {
                                        throw _iteratorError4;
                                    }
                                }
                            }
                        } else try {
                            for(var _iterator5 = prefixes1[Symbol.iterator](), _step5; !(_iteratorNormalCompletion3 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion3 = true){
                                var p = _step5.value;
                                var olds = this.decl(name1).old(name1, p);
                                if (name1 === 'align-self') {
                                    var a = add[name1] && add[name1].prefixes;
                                    if (a) {
                                        if (p === '-webkit- 2009' && a.includes('-webkit-')) continue;
                                        else if (p === '-webkit-' && a.includes('-webkit- 2009')) continue;
                                    }
                                }
                                var _iteratorNormalCompletion6 = true, _didIteratorError6 = false, _iteratorError6 = undefined;
                                try {
                                    for(var _iterator6 = olds[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true){
                                        var prefixed1 = _step6.value;
                                        if (!remove[prefixed1]) remove[prefixed1] = {};
                                        remove[prefixed1].remove = true;
                                    }
                                } catch (err) {
                                    _didIteratorError6 = true;
                                    _iteratorError6 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
                                            _iterator6.return();
                                        }
                                    } finally{
                                        if (_didIteratorError6) {
                                            throw _iteratorError6;
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator5.return != null) {
                                    _iterator5.return();
                                }
                            } finally{
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }
                    }
                }
                return [
                    add,
                    remove
                ];
            }
        },
        {
            /**
   * Select prefixes from data, which is necessary for selected browsers
   */ key: "select",
            value: function select(list) {
                var _this, _loop = function(name) {
                    var data = list[name];
                    var add = data.browsers.map(function(i) {
                        var params = i.split(' ');
                        return {
                            browser: "".concat(params[0], " ").concat(params[1]),
                            note: params[2]
                        };
                    });
                    var notes = add.filter(function(i) {
                        return i.note;
                    }).map(function(i) {
                        return "".concat(_this1.browsers.prefix(i.browser), " ").concat(i.note);
                    });
                    notes = $kUXlT.uniq(notes);
                    add = add.filter(function(i) {
                        return _this1.browsers.isSelected(i.browser);
                    }).map(function(i) {
                        var prefix = _this1.browsers.prefix(i.browser);
                        if (i.note) return "".concat(prefix, " ").concat(i.note);
                        else return prefix;
                    });
                    add = _this.sort($kUXlT.uniq(add));
                    if (_this.options.flexbox === 'no-2009') add = add.filter(function(i) {
                        return !i.includes('2009');
                    });
                    var all = data.browsers.map(function(i) {
                        return _this1.browsers.prefix(i);
                    });
                    if (data.mistakes) all = all.concat(data.mistakes);
                    all = all.concat(notes);
                    all = $kUXlT.uniq(all);
                    if (add.length) {
                        selected.add[name] = add;
                        if (add.length < all.length) selected.remove[name] = all.filter(function(i) {
                            return !add.includes(i);
                        });
                    } else selected.remove[name] = all;
                };
                var _this1 = this;
                var selected = {
                    add: {},
                    remove: {}
                };
                for(var name in list)_this = this, _loop(name);
                return selected;
            }
        },
        {
            /**
   * Sort vendor prefixes
   */ key: "sort",
            value: function sort(prefixes) {
                return prefixes.sort(function(a, b) {
                    var aLength = $kUXlT.removeNote(a).length;
                    var bLength = $kUXlT.removeNote(b).length;
                    if (aLength === bLength) return b.length - a.length;
                    else return bLength - aLength;
                });
            }
        },
        {
            /**
   * Return unprefixed version of property
   */ key: "unprefixed",
            value: function unprefixed(prop) {
                var value = this.normalize($94d58ff1b5a11e04$exports.unprefixed(prop));
                if (value === 'flex-direction') value = 'flex-flow';
                return value;
            }
        },
        {
            /**
   * Return values, which must be prefixed in selected property
   */ key: "values",
            value: function values(type, prop) {
                var data = this[type];
                var global = data['*'] && data['*'].values;
                var values = data[prop] && data[prop].values;
                if (global && values) return $kUXlT.uniq(global.concat(values));
                else return global || values || [];
            }
        }
    ]);
    return Prefixes;
}();
$77d8edc20cc2c324$exports = $77d8edc20cc2c324$var$Prefixes;


var $3cefe5e4555b2e46$exports = {};

function $3cefe5e4555b2e46$var$browsersSort(a, b) {
    a = a.split(' ');
    b = b.split(' ');
    if (a[0] > b[0]) return 1;
    else if (a[0] < b[0]) return -1;
    else return Math.sign(parseFloat(a[1]) - parseFloat(b[1]));
}
// Convert Can I Use data
function $3cefe5e4555b2e46$var$f(data, opts, callback) {
    data = $4fda570b3fd0830f$exports(data);
    var ref;
    if (!callback) ref = [
        opts,
        {}
    ], callback = ref[0], opts = ref[1], ref;
    var match = opts.match || /\sx($|\s)/;
    var need = [];
    for(var browser in data.stats){
        var versions = data.stats[browser];
        for(var version in versions){
            var support = versions[version];
            if (support.match(match)) need.push(browser + ' ' + version);
        }
    }
    callback(need.sort($3cefe5e4555b2e46$var$browsersSort));
}
// Add data for all properties
var $3cefe5e4555b2e46$var$result = {};
function $3cefe5e4555b2e46$var$prefix(names, data) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = names[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var name = _step.value;
            $3cefe5e4555b2e46$var$result[name] = Object.assign({}, data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $3cefe5e4555b2e46$var$add(names, data) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = names[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var name = _step.value;
            $3cefe5e4555b2e46$var$result[name].browsers = $3cefe5e4555b2e46$var$result[name].browsers.concat(data.browsers).sort($3cefe5e4555b2e46$var$browsersSort);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
$3cefe5e4555b2e46$exports = $3cefe5e4555b2e46$var$result;
var $25d3b31a7f401f77$exports = {};
$25d3b31a7f401f77$exports = {
    A: {
        A: {
            "1": "_V",
            "2": "_c"
        },
        B: {
            "1": "_J"
        },
        C: {
            "1": "_GF",
            "257": "_kL",
            "289": "cC _L",
            "292": "BD"
        },
        D: {
            "1": "_0D",
            "33": "J"
        },
        E: {
            "1": "jB _6C",
            "33": "_i",
            "129": "_iG JD"
        },
        F: {
            "1": "_aD",
            "2": "_eB"
        },
        G: {
            "1": "_dB",
            "33": "iC"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "_9Q",
            "33": "wD"
        },
        J: {
            "1": "_B"
        },
        K: {
            "1": "_BB",
            "2": "A"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "1": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_F"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "GE",
            "257": "FE"
        }
    },
    B: 4,
    C: "CSS3 Border-radius (rounded corners)",
    D: true
};


$3cefe5e4555b2e46$var$f($25d3b31a7f401f77$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'border-radius',
        'border-top-left-radius',
        'border-top-right-radius',
        'border-bottom-right-radius',
        'border-bottom-left-radius'
    ], {
        browsers: browsers,
        feature: 'border-radius',
        mistakes: [
            '-khtml-',
            '-ms-',
            '-o-'
        ]
    });
});
var $223d748f357a6528$exports = {};
$223d748f357a6528$exports = {
    A: {
        A: {
            "1": "_V",
            "2": "_c"
        },
        B: {
            "1": "_J"
        },
        C: {
            "1": "_x",
            "2": "_g",
            "33": "_L"
        },
        D: {
            "1": "_4O",
            "33": "_RC"
        },
        E: {
            "1": "_XB",
            "33": "jB",
            "164": "_i"
        },
        F: {
            "1": "_aD",
            "2": "_eB"
        },
        G: {
            "1": "_r",
            "33": "_HG",
            "164": "iC"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "_QE",
            "164": "_KB"
        },
        J: {
            "1": "A",
            "33": "D"
        },
        K: {
            "1": "_BB",
            "2": "A"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "1": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_F"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "_C"
        }
    },
    B: 4,
    C: "CSS3 Box-shadow",
    D: true
};


$3cefe5e4555b2e46$var$f($223d748f357a6528$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'box-shadow'
    ], {
        browsers: browsers,
        feature: 'css-boxshadow',
        mistakes: [
            '-khtml-'
        ]
    });
});
var $2104d046f0567b37$exports = {};
$2104d046f0567b37$exports = {
    A: {
        A: {
            "1": "_A",
            "2": "_Z"
        },
        B: {
            "1": "_J"
        },
        C: {
            "1": "_FI",
            "2": "_g J _L",
            "33": "_9I G"
        },
        D: {
            "1": "_ZQ",
            "33": "_LE"
        },
        E: {
            "1": "_PB",
            "2": "_e",
            "33": "_FB _UJ",
            "292": "_4"
        },
        F: {
            "1": "_QO XC",
            "2": "_vD",
            "33": "C _8I"
        },
        G: {
            "1": "_p",
            "33": "_QD",
            "164": "_1"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "33": "_NL",
            "164": "_KB"
        },
        J: {
            "33": "_B"
        },
        K: {
            "1": "_YB",
            "2": "_bB"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "1": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_F"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "_C"
        }
    },
    B: 5,
    C: "CSS Animation",
    D: true
};


$3cefe5e4555b2e46$var$f($2104d046f0567b37$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'animation',
        'animation-name',
        'animation-duration',
        'animation-delay',
        'animation-direction',
        'animation-fill-mode',
        'animation-iteration-count',
        'animation-play-state',
        'animation-timing-function',
        '@keyframes'
    ], {
        browsers: browsers,
        feature: 'css-animation',
        mistakes: [
            '-khtml-',
            '-ms-'
        ]
    });
});
var $fea06f76288de899$exports = {};
$fea06f76288de899$exports = {
    A: {
        A: {
            "1": "_A",
            "2": "_Z"
        },
        B: {
            "1": "_J"
        },
        C: {
            "1": "_FI",
            "2": "_f",
            "33": "_9I G",
            "164": "J"
        },
        D: {
            "1": "_IF",
            "33": "_jJ"
        },
        E: {
            "1": "_iB",
            "33": "_iG",
            "164": "_3"
        },
        F: {
            "1": "_xF",
            "2": "_eB",
            "33": "C",
            "164": "B _0Q"
        },
        G: {
            "1": "_z",
            "33": "aD",
            "164": "_1"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "_X",
            "33": "_W"
        },
        J: {
            "1": "A",
            "33": "D"
        },
        K: {
            "1": "_YB",
            "33": "C",
            "164": "_fB"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "1": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_F"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "_C"
        }
    },
    B: 5,
    C: "CSS3 Transitions",
    D: true
};


$3cefe5e4555b2e46$var$f($fea06f76288de899$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'transition',
        'transition-property',
        'transition-duration',
        'transition-delay',
        'transition-timing-function'
    ], {
        browsers: browsers,
        feature: 'css-transitions',
        mistakes: [
            '-khtml-',
            '-ms-'
        ]
    });
});
var $32ea83515b2a159c$exports = {};
$32ea83515b2a159c$exports = {
    A: {
        A: {
            "2": "AD",
            "8": "_FB",
            "129": "_A",
            "161": "F"
        },
        B: {
            "1": "_8C",
            "129": "_ZB"
        },
        C: {
            "1": "_FI",
            "2": "_g",
            "33": "_DC _L"
        },
        D: {
            "1": "_2H",
            "33": "_5E"
        },
        E: {
            "1": "_PB",
            "33": "_TB"
        },
        F: {
            "1": "_GM XC",
            "2": "_eB",
            "33": "_5 _0B _0Q"
        },
        G: {
            "1": "_p",
            "33": "_2"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "33": "_G"
        },
        J: {
            "33": "_B"
        },
        K: {
            "1": "_BB",
            "2": "A"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "1": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_F"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "_C"
        }
    },
    B: 4,
    C: "CSS3 2D Transforms",
    D: true
};


$3cefe5e4555b2e46$var$f($32ea83515b2a159c$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'transform',
        'transform-origin'
    ], {
        browsers: browsers,
        feature: 'transforms2d'
    });
});
var $2f183f8a80d47534$exports = {};
$2f183f8a80d47534$exports = {
    A: {
        A: {
            "2": "_Z",
            "132": "_A"
        },
        B: {
            "1": "_J"
        },
        C: {
            "1": "_FI",
            "2": "_RK",
            "33": "_FO"
        },
        D: {
            "1": "_2H",
            "2": "_MG",
            "33": "_v _LG"
        },
        E: {
            "1": "_uC",
            "2": "_e",
            "33": "_QG _UJ",
            "257": "_V _3B LD _XN"
        },
        F: {
            "1": "_GM",
            "2": "_T",
            "33": "_0B"
        },
        G: {
            "1": "_5B",
            "33": "_2",
            "257": "_YR _YG"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "2": "_l",
            "33": "_pJ"
        },
        J: {
            "33": "_B"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "132": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_F"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "_C"
        }
    },
    B: 5,
    C: "CSS3 3D Transforms",
    D: true
};


$3cefe5e4555b2e46$var$f($2f183f8a80d47534$exports, function(browsers) {
    $3cefe5e4555b2e46$var$prefix([
        'perspective',
        'perspective-origin'
    ], {
        browsers: browsers,
        feature: 'transforms3d'
    });
    return $3cefe5e4555b2e46$var$prefix([
        'transform-style'
    ], {
        browsers: browsers,
        feature: 'transforms3d',
        mistakes: [
            '-ms-',
            '-o-'
        ]
    });
});
$3cefe5e4555b2e46$var$f($2f183f8a80d47534$exports, {
    match: /y\sx|y\s#2/
}, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'backface-visibility'
    ], {
        browsers: browsers,
        feature: 'transforms3d',
        mistakes: [
            '-ms-',
            '-o-'
        ]
    });
});
var $e8836b4aa05f1f01$exports = {};
$e8836b4aa05f1f01$exports = {
    A: {
        A: {
            "1": "_A",
            "2": "_Z"
        },
        B: {
            "1": "_J"
        },
        C: {
            "1": "_8E",
            "2": "_LC",
            "260": "_1L _5D",
            "292": "_DC GD"
        },
        D: {
            "1": "_IF",
            "33": "_lD _UF",
            "548": "_RC"
        },
        E: {
            "1": "_uC",
            "2": "_e",
            "260": "_xR _7Q",
            "292": "_iG",
            "804": "_4"
        },
        F: {
            "1": "_xF",
            "2": "_OD",
            "33": "C XD",
            "164": "_sB"
        },
        G: {
            "1": "_5B",
            "260": "_TC _YR _YG",
            "292": "_wC",
            "804": "_d"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "_X",
            "33": "_oF",
            "548": "_KB"
        },
        J: {
            "1": "A",
            "548": "D"
        },
        K: {
            "1": "_YB",
            "2": "_A",
            "33": "C",
            "164": "_sB"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "1": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_F"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "_C"
        }
    },
    B: 4,
    C: "CSS Gradients",
    D: true
};


$3cefe5e4555b2e46$var$f($e8836b4aa05f1f01$exports, {
    match: /y\sx/
}, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'linear-gradient',
        'repeating-linear-gradient',
        'radial-gradient',
        'repeating-radial-gradient'
    ], {
        browsers: browsers,
        feature: 'css-gradients',
        mistakes: [
            '-ms-'
        ],
        props: [
            'background',
            'background-image',
            'border-image',
            'mask',
            'list-style',
            'list-style-image',
            'content',
            'mask-image'
        ]
    });
});
$3cefe5e4555b2e46$var$f($e8836b4aa05f1f01$exports, {
    match: /a\sx/
}, function(browsers) {
    browsers = browsers.map(function(i) {
        if (/firefox|op/.test(i)) return i;
        else return "".concat(i, " old");
    });
    return $3cefe5e4555b2e46$var$add([
        'linear-gradient',
        'repeating-linear-gradient',
        'radial-gradient',
        'repeating-radial-gradient'
    ], {
        browsers: browsers,
        feature: 'css-gradients'
    });
});
var $2942371652d73322$exports = {};
$2942371652d73322$exports = {
    A: {
        A: {
            "1": "_JC",
            "8": "_GB"
        },
        B: {
            "1": "_J"
        },
        C: {
            "1": "_7F",
            "33": "_1D"
        },
        D: {
            "1": "_4O",
            "33": "_RC"
        },
        E: {
            "1": "_XB",
            "33": "_3"
        },
        F: {
            "1": "_nB",
            "2": "F"
        },
        G: {
            "1": "_r",
            "33": "_d"
        },
        H: {
            "1": "vD"
        },
        I: {
            "1": "_QE",
            "33": "_KB"
        },
        J: {
            "1": "A",
            "33": "D"
        },
        K: {
            "1": "_N"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "1": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_F"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "_C"
        }
    },
    B: 5,
    C: "CSS3 Box-sizing",
    D: true
};


$3cefe5e4555b2e46$var$f($2942371652d73322$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'box-sizing'
    ], {
        browsers: browsers,
        feature: 'css3-boxsizing'
    });
});
var $242c554607a83ea2$exports = {};
$242c554607a83ea2$exports = {
    A: {
        A: {
            "2": "_E"
        },
        B: {
            "1": "_K",
            "1028": "_hQ",
            "1346": "C"
        },
        C: {
            "1": "_RO",
            "2": "_LC",
            "196": "oB",
            "516": "_yN GD"
        },
        D: {
            "1": "_fR",
            "2": "_jL",
            "33": "_ML _NE _kE"
        },
        E: {
            "1": "_ND",
            "2": "_s",
            "33": "_OC _sE"
        },
        F: {
            "1": "_JM",
            "2": "_T",
            "33": "_KD _eD"
        },
        G: {
            "1": "_kG",
            "2": "_1",
            "33": "_QD dD"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "2": "_W",
            "33": "_w"
        },
        J: {
            "2": "D",
            "33": "A"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "2": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_wB",
            "33": "_1B"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "_C"
        }
    },
    B: 5,
    C: "CSS Filter Effects",
    D: true
};


$3cefe5e4555b2e46$var$f($242c554607a83ea2$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'filter'
    ], {
        browsers: browsers,
        feature: 'css-filters'
    });
});
var $1b8b353e2eff7a89$exports = {};
$1b8b353e2eff7a89$exports = {
    A: {
        A: {
            "2": "_E"
        },
        B: {
            "2": "_J"
        },
        C: {
            "2": "_S"
        },
        D: {
            "2": "_Q"
        },
        E: {
            "1": "_ND",
            "2": "_TB",
            "33": "F"
        },
        F: {
            "2": "_b"
        },
        G: {
            "1": "_8",
            "2": "_2",
            "33": "_eC"
        },
        H: {
            "2": "vD"
        },
        I: {
            "2": "_O"
        },
        J: {
            "2": "_B"
        },
        K: {
            "2": "_N"
        },
        L: {
            "2": "I"
        },
        M: {
            "2": "VC"
        },
        N: {
            "2": "_A"
        },
        O: {
            "2": "YC"
        },
        P: {
            "2": "_F"
        },
        Q: {
            "2": "DE"
        },
        R: {
            "2": "EE"
        },
        S: {
            "2": "_C"
        }
    },
    B: 5,
    C: "CSS filter() function",
    D: true
};


$3cefe5e4555b2e46$var$f($1b8b353e2eff7a89$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'filter-function'
    ], {
        browsers: browsers,
        feature: 'css-filter-function',
        props: [
            'background',
            'background-image',
            'border-image',
            'mask',
            'list-style',
            'list-style-image',
            'content',
            'mask-image'
        ]
    });
});
var $ca1e692c717007f8$exports = {};
$ca1e692c717007f8$exports = {
    A: {
        A: {
            "2": "_E"
        },
        B: {
            "1": "_K",
            "2": "_ZB",
            "257": "_8B"
        },
        C: {
            "1": "_H _cI _cH _t",
            "2": "_m _yL _L",
            "578": "_fT _JD _xP"
        },
        D: {
            "1": "_H _eK _vH",
            "2": "_xN",
            "194": "_QC _ID _UG"
        },
        E: {
            "1": "_dN",
            "2": "_TB",
            "33": "_V _3B LD _qL"
        },
        F: {
            "1": "_8F",
            "2": "_8O",
            "194": "_jE _bC _vN _rB"
        },
        G: {
            "1": "_gD",
            "2": "_2",
            "33": "_IK"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "2": "_G"
        },
        J: {
            "2": "_B"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "2": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_cJ",
            "2": "J",
            "194": "_rI jC 7D"
        },
        Q: {
            "2": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "2": "_C"
        }
    },
    B: 7,
    C: "CSS Backdrop Filter",
    D: true
};


$3cefe5e4555b2e46$var$f($ca1e692c717007f8$exports, {
    match: /y\sx|y\s#2/
}, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'backdrop-filter'
    ], {
        browsers: browsers,
        feature: 'css-backdrop-filter'
    });
});
var $a3342b4a6298f4c5$exports = {};
$a3342b4a6298f4c5$exports = {
    A: {
        A: {
            "2": "_E"
        },
        B: {
            "2": "_J"
        },
        C: {
            "33": "_x",
            "164": "_f"
        },
        D: {
            "2": "_Q"
        },
        E: {
            "2": "_R"
        },
        F: {
            "2": "_b"
        },
        G: {
            "2": "_M"
        },
        H: {
            "2": "vD"
        },
        I: {
            "2": "_O"
        },
        J: {
            "2": "_B"
        },
        K: {
            "2": "_N"
        },
        L: {
            "2": "I"
        },
        M: {
            "33": "VC"
        },
        N: {
            "2": "_A"
        },
        O: {
            "2": "YC"
        },
        P: {
            "2": "_F"
        },
        Q: {
            "2": "DE"
        },
        R: {
            "2": "EE"
        },
        S: {
            "33": "_C"
        }
    },
    B: 5,
    C: "CSS element() function",
    D: true
};


$3cefe5e4555b2e46$var$f($a3342b4a6298f4c5$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'element'
    ], {
        browsers: browsers,
        feature: 'css-element-function',
        props: [
            'background',
            'background-image',
            'border-image',
            'mask',
            'list-style',
            'list-style-image',
            'content',
            'mask-image'
        ]
    });
});
var $cb01f4fd948f5b7b$exports = {};
$cb01f4fd948f5b7b$exports = {
    A: {
        A: {
            "1": "_A",
            "2": "_Z"
        },
        B: {
            "1": "_I",
            "516": "_K"
        },
        C: {
            "132": "_lC _kD _qD",
            "164": "_2J",
            "516": "_GJ _JD _MB b",
            "1028": "_H c _aO"
        },
        D: {
            "420": "_kL",
            "516": "_4L"
        },
        E: {
            "1": "_LB",
            "132": "F LD",
            "164": "_QJ KD",
            "420": "_XC"
        },
        F: {
            "1": "_FQ",
            "2": "_OD",
            "420": "_LG qB",
            "516": "_hO"
        },
        G: {
            "1": "_8",
            "132": "_eC",
            "164": "_TC",
            "420": "_o"
        },
        H: {
            "1": "vD"
        },
        I: {
            "420": "_G",
            "516": "I"
        },
        J: {
            "420": "_B"
        },
        K: {
            "1": "_KL",
            "2": "_A",
            "516": "H"
        },
        L: {
            "516": "I"
        },
        M: {
            "1028": "VC"
        },
        N: {
            "1": "_A"
        },
        O: {
            "516": "YC"
        },
        P: {
            "420": "J",
            "516": "_U"
        },
        Q: {
            "516": "DE"
        },
        R: {
            "516": "EE"
        },
        S: {
            "164": "_C"
        }
    },
    B: 4,
    C: "CSS3 Multiple column layout",
    D: true
};


$3cefe5e4555b2e46$var$f($cb01f4fd948f5b7b$exports, function(browsers) {
    $3cefe5e4555b2e46$var$prefix([
        'columns',
        'column-width',
        'column-gap',
        'column-rule',
        'column-rule-color',
        'column-rule-width',
        'column-count',
        'column-rule-style',
        'column-span',
        'column-fill'
    ], {
        browsers: browsers,
        feature: 'multicolumn'
    });
    var noff = browsers.filter(function(i) {
        return !/firefox/.test(i);
    });
    $3cefe5e4555b2e46$var$prefix([
        'break-before',
        'break-after',
        'break-inside'
    ], {
        browsers: noff,
        feature: 'multicolumn'
    });
});
var $34282cf645ecf051$exports = {};
$34282cf645ecf051$exports = {
    A: {
        A: {
            "2": "_Z",
            "33": "_A"
        },
        B: {
            "1": "_K",
            "33": "_I"
        },
        C: {
            "1": "_tO",
            "33": "_m _FE _L"
        },
        D: {
            "1": "_EM",
            "33": "_vJ"
        },
        E: {
            "33": "_R"
        },
        F: {
            "1": "_JO",
            "2": "_T",
            "33": "_bH"
        },
        G: {
            "33": "_M"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "33": "_G"
        },
        J: {
            "33": "_B"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "33": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_gB",
            "33": "_qC"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "GE",
            "33": "FE"
        }
    },
    B: 5,
    C: "CSS user-select: none",
    D: true
};


$3cefe5e4555b2e46$var$f($34282cf645ecf051$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'user-select'
    ], {
        browsers: browsers,
        feature: 'user-select-none',
        mistakes: [
            '-khtml-'
        ]
    });
});
var $0239a8dfd5f91538$exports = {};
$0239a8dfd5f91538$exports = {
    A: {
        A: {
            "2": "_Z",
            "1028": "B",
            "1316": "A"
        },
        B: {
            "1": "_J"
        },
        C: {
            "1": "_pR",
            "164": "_CF",
            "516": "_eT _LQ"
        },
        D: {
            "1": "_WR",
            "33": "_bN _CG",
            "164": "_uF"
        },
        E: {
            "1": "_PB",
            "33": "_QJ _sE",
            "164": "_3C"
        },
        F: {
            "1": "_3J XC",
            "2": "_WE",
            "33": "_9B"
        },
        G: {
            "1": "_p",
            "33": "_TC",
            "164": "_o"
        },
        H: {
            "1": "vD"
        },
        I: {
            "1": "_X",
            "164": "_W"
        },
        J: {
            "1": "A",
            "164": "D"
        },
        K: {
            "1": "_YB",
            "2": "_bB"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "1": "B",
            "292": "A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_F"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "_C"
        }
    },
    B: 4,
    C: "CSS Flexible Box Layout Module",
    D: true
};


$3cefe5e4555b2e46$var$f($0239a8dfd5f91538$exports, {
    match: /a\sx/
}, function(browsers) {
    browsers = browsers.map(function(i) {
        if (/ie|firefox/.test(i)) return i;
        else return "".concat(i, " 2009");
    });
    $3cefe5e4555b2e46$var$prefix([
        'display-flex',
        'inline-flex'
    ], {
        browsers: browsers,
        feature: 'flexbox',
        props: [
            'display'
        ]
    });
    $3cefe5e4555b2e46$var$prefix([
        'flex',
        'flex-grow',
        'flex-shrink',
        'flex-basis'
    ], {
        browsers: browsers,
        feature: 'flexbox'
    });
    $3cefe5e4555b2e46$var$prefix([
        'flex-direction',
        'flex-wrap',
        'flex-flow',
        'justify-content',
        'order',
        'align-items',
        'align-self',
        'align-content'
    ], {
        browsers: browsers,
        feature: 'flexbox'
    });
});
$3cefe5e4555b2e46$var$f($0239a8dfd5f91538$exports, {
    match: /y\sx/
}, function(browsers) {
    $3cefe5e4555b2e46$var$add([
        'display-flex',
        'inline-flex'
    ], {
        browsers: browsers,
        feature: 'flexbox'
    });
    $3cefe5e4555b2e46$var$add([
        'flex',
        'flex-grow',
        'flex-shrink',
        'flex-basis'
    ], {
        browsers: browsers,
        feature: 'flexbox'
    });
    $3cefe5e4555b2e46$var$add([
        'flex-direction',
        'flex-wrap',
        'flex-flow',
        'justify-content',
        'order',
        'align-items',
        'align-self',
        'align-content'
    ], {
        browsers: browsers,
        feature: 'flexbox'
    });
});
var $d5bc86009b15cf44$exports = {};
$d5bc86009b15cf44$exports = {
    A: {
        A: {
            "2": "_c",
            "260": "F",
            "516": "_A"
        },
        B: {
            "1": "_J"
        },
        C: {
            "1": "_FI",
            "2": "_f",
            "33": "_DC"
        },
        D: {
            "1": "_IF",
            "2": "_gL",
            "33": "_RJ IB"
        },
        E: {
            "1": "_iB",
            "2": "_s",
            "33": "L"
        },
        F: {
            "1": "_a",
            "2": "_T"
        },
        G: {
            "1": "_z",
            "2": "_1",
            "33": "aD"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "2": "_W",
            "132": "_w"
        },
        J: {
            "1": "A",
            "2": "D"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "1": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_F"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "_C"
        }
    },
    B: 4,
    C: "calc() as CSS unit value",
    D: true
};


$3cefe5e4555b2e46$var$f($d5bc86009b15cf44$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'calc'
    ], {
        browsers: browsers,
        feature: 'calc',
        props: [
            '*'
        ]
    });
});
var $db3d7cc1293a7a06$exports = {};
$db3d7cc1293a7a06$exports = {
    A: {
        A: {
            "1": "_V",
            "2": "_c"
        },
        B: {
            "1": "_J"
        },
        C: {
            "1": "_x",
            "2": "_LC",
            "36": "GD"
        },
        D: {
            "1": "_WD",
            "516": "_Y"
        },
        E: {
            "1": "_6C",
            "772": "_XC"
        },
        F: {
            "1": "_aD",
            "2": "_lB",
            "36": "UD"
        },
        G: {
            "1": "_z",
            "4": "_d aD",
            "516": "ZD"
        },
        H: {
            "132": "vD"
        },
        I: {
            "1": "_X",
            "36": "wD",
            "516": "_BF",
            "548": "_UQ"
        },
        J: {
            "1": "_B"
        },
        K: {
            "1": "_N"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "1": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_F"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "_C"
        }
    },
    B: 4,
    C: "CSS3 Background-image options",
    D: true
};


$3cefe5e4555b2e46$var$f($db3d7cc1293a7a06$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'background-origin',
        'background-size'
    ], {
        browsers: browsers,
        feature: 'background-img-opts'
    });
});
var $edafee426239728b$exports = {};
$edafee426239728b$exports = {
    A: {
        A: {
            "2": "_E"
        },
        B: {
            "1": "_UB",
            "33": "_v",
            "129": "_GI",
            "161": "_NC _wH"
        },
        C: {
            "1": "_wD",
            "2": "_VM"
        },
        D: {
            "129": "_3G",
            "161": "_NC _yG"
        },
        E: {
            "2": "HD",
            "129": "K YC PD _uE",
            "388": "_9I G _SD _XN lC",
            "420": "_IQ"
        },
        F: {
            "2": "_T",
            "129": "_QK",
            "161": "_sC _BL"
        },
        G: {
            "129": "YC _CU",
            "388": "_YE lC"
        },
        H: {
            "2": "vD"
        },
        I: {
            "16": "_KB",
            "129": "I",
            "161": "_NL"
        },
        J: {
            "161": "_B"
        },
        K: {
            "16": "_D",
            "129": "H"
        },
        L: {
            "129": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "2": "_A"
        },
        O: {
            "161": "YC"
        },
        P: {
            "1": "_NB",
            "161": "_OM"
        },
        Q: {
            "161": "DE"
        },
        R: {
            "161": "EE"
        },
        S: {
            "1": "_C"
        }
    },
    B: 7,
    C: "Background-clip: text",
    D: true
};


$3cefe5e4555b2e46$var$f($edafee426239728b$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'background-clip'
    ], {
        browsers: browsers,
        feature: 'background-clip-text'
    });
});
var $fc5b6546027110e1$exports = {};
$fc5b6546027110e1$exports = {
    A: {
        A: {
            "1": "_A",
            "2": "_Z"
        },
        B: {
            "1": "_J"
        },
        C: {
            "1": "_QI",
            "2": "_f",
            "33": "_uK",
            "164": "_Y"
        },
        D: {
            "1": "_5F",
            "2": "_DC",
            "33": "_4B _uN",
            "292": "_EO DB"
        },
        E: {
            "1": "_ND",
            "2": "_gC _e _sE",
            "4": "_vB ID"
        },
        F: {
            "1": "_PI",
            "2": "_T",
            "33": "_bF"
        },
        G: {
            "1": "_kG",
            "2": "_TC dD",
            "4": "_o"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "2": "_W",
            "33": "_w"
        },
        J: {
            "2": "D",
            "33": "A"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "2": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_U",
            "33": "J"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "_C"
        }
    },
    B: 2,
    C: "CSS font-feature-settings",
    D: true
};


$3cefe5e4555b2e46$var$f($fc5b6546027110e1$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'font-feature-settings',
        'font-variant-ligatures',
        'font-language-override'
    ], {
        browsers: browsers,
        feature: 'font-feature'
    });
});
var $8f9efc4a1745ef8a$exports = {};
$8f9efc4a1745ef8a$exports = {
    A: {
        A: {
            "2": "_E"
        },
        B: {
            "1": "_K",
            "2": "_I"
        },
        C: {
            "1": "_QI",
            "2": "_LS",
            "194": "_WF _LH"
        },
        D: {
            "1": "_nO",
            "2": "_iJ",
            "33": "_qB _OQ"
        },
        E: {
            "1": "_ND",
            "2": "_XC",
            "33": "_gC KD"
        },
        F: {
            "1": "_nR",
            "2": "_h G _P",
            "33": "_EO"
        },
        G: {
            "1": "_VJ",
            "2": "_DB",
            "33": "_jC _3O"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "_VD",
            "2": "_W",
            "33": "0D"
        },
        J: {
            "2": "D",
            "33": "A"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "2": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_F"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "_C"
        }
    },
    B: 4,
    C: "CSS3 font-kerning",
    D: true
};


$3cefe5e4555b2e46$var$f($8f9efc4a1745ef8a$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'font-kerning'
    ], {
        browsers: browsers,
        feature: 'font-kerning'
    });
});
var $ef61c68e6122b454$exports = {};
$ef61c68e6122b454$exports = {
    A: {
        A: {
            "1": "B",
            "2": "_y"
        },
        B: {
            "1": "_zD",
            "129": "_JB"
        },
        C: {
            "1": "_GF",
            "2": "_g",
            "260": "_ZG",
            "804": "_Y _L"
        },
        D: {
            "1": "_MK",
            "260": "_TE",
            "388": "MB _NE",
            "1412": "_8I",
            "1956": "_Y"
        },
        E: {
            "1": "_uC",
            "129": "_FO LD _XN",
            "1412": "_OC _sE",
            "1956": "_s"
        },
        F: {
            "1": "_VL",
            "2": "_eB",
            "260": "_QF",
            "388": "_KD",
            "1796": "_nI",
            "1828": "_5 _tE"
        },
        G: {
            "1": "_5B",
            "129": "eD _BE _nL _YG",
            "1412": "_QD dD",
            "1956": "_1"
        },
        H: {
            "1828": "vD"
        },
        I: {
            "1": "I",
            "388": "_w",
            "1956": "_W"
        },
        J: {
            "1412": "A",
            "1924": "D"
        },
        K: {
            "1": "H",
            "2": "A",
            "1828": "_YD"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "1": "B",
            "2": "A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_wB",
            "260": "_SH",
            "388": "J"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "GE",
            "260": "FE"
        }
    },
    B: 4,
    C: "CSS3 Border images",
    D: true
};


$3cefe5e4555b2e46$var$f($ef61c68e6122b454$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'border-image'
    ], {
        browsers: browsers,
        feature: 'border-image'
    });
});
var $e091f193b1e9bb91$exports = {};
$e091f193b1e9bb91$exports = {
    A: {
        A: {
            "1": "_V",
            "2": "_c"
        },
        B: {
            "1": "_J"
        },
        C: {
            "1": "_TL",
            "33": "_m _L"
        },
        D: {
            "1": "_Q"
        },
        E: {
            "1": "_R"
        },
        F: {
            "1": "_nB",
            "2": "F"
        },
        G: {
            "2": "_M"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "_X",
            "2": "_W"
        },
        J: {
            "1": "A",
            "2": "D"
        },
        K: {
            "1": "_EQ _TQ",
            "16": "_A WC"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "1": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_F"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "GE",
            "33": "FE"
        }
    },
    B: 5,
    C: "::selection CSS pseudo-element",
    D: true
};


$3cefe5e4555b2e46$var$f($e091f193b1e9bb91$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        '::selection'
    ], {
        browsers: browsers,
        feature: 'css-selection',
        selector: true
    });
});
var $35bed2261ae17ac0$exports = {};
$35bed2261ae17ac0$exports = {
    A: {
        A: {
            "2": "_E"
        },
        B: {
            "1": "_K",
            "36": "_I"
        },
        C: {
            "1": "_pF",
            "33": "_hC _NE",
            "130": "_uL"
        },
        D: {
            "1": "_qF",
            "36": "_jF"
        },
        E: {
            "1": "_HB",
            "2": "_i",
            "36": "jB _DI"
        },
        F: {
            "1": "_HF",
            "2": "_T",
            "36": "_8D xB"
        },
        G: {
            "1": "_9",
            "2": "_rC",
            "36": "_qO _AF"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "36": "_G"
        },
        J: {
            "36": "_B"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "36": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_wB",
            "36": "_1B"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "GE",
            "33": "FE"
        }
    },
    B: 5,
    C: "::placeholder CSS pseudo-element",
    D: true
};


$3cefe5e4555b2e46$var$f($35bed2261ae17ac0$exports, function(browsers) {
    $3cefe5e4555b2e46$var$prefix([
        '::placeholder'
    ], {
        browsers: browsers.concat([
            'ie 10 old',
            'ie 11 old',
            'firefox 18 old'
        ]),
        feature: 'css-placeholder',
        selector: true
    });
});
var $11df3d220dd205d4$exports = {};
$11df3d220dd205d4$exports = {
    A: {
        A: {
            "2": "_Z",
            "292": "_A"
        },
        B: {
            "1": "_K",
            "2": "_I"
        },
        C: {
            "1": "_pF",
            "2": "_f",
            "164": "_GC"
        },
        D: {
            "1": "_eO",
            "2": "_xN"
        },
        E: {
            "1": "_PB",
            "2": "_TB"
        },
        F: {
            "1": "_SO",
            "2": "_8O"
        },
        G: {
            "1": "_p",
            "2": "_2"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "2": "_G"
        },
        J: {
            "2": "_B"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "2": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_U",
            "2": "J"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "GE",
            "164": "FE"
        }
    },
    B: 5,
    C: ":placeholder-shown CSS pseudo-class",
    D: true
};


$3cefe5e4555b2e46$var$f($11df3d220dd205d4$exports, function(browsers) {
    $3cefe5e4555b2e46$var$prefix([
        ':placeholder-shown'
    ], {
        browsers: browsers,
        feature: 'css-placeholder-shown',
        selector: true
    });
});
var $59c26eb74a23cd8f$exports = {};
$59c26eb74a23cd8f$exports = {
    A: {
        A: {
            "2": "_Z",
            "33": "_A"
        },
        B: {
            "1": "_vO",
            "33": "_I",
            "132": "_mG _JF",
            "260": "Y _dI _xH"
        },
        C: {
            "1": "_aQ",
            "2": "_1C",
            "33": "_dC _8D"
        },
        D: {
            "1": "_uO",
            "2": "_BO",
            "132": "_kD _cC _OR"
        },
        E: {
            "1": "_2D",
            "2": "_3",
            "33": "_gJ _SD _JG _gF"
        },
        F: {
            "1": "_bO",
            "2": "_MM",
            "132": "wB _mE _qI _MB"
        },
        G: {
            "1": "_VE",
            "2": "_rC",
            "33": "_qO _AL _mH"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "2": "_G"
        },
        J: {
            "2": "_B"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "2": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_gB",
            "2": "J",
            "132": "2D"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "_C"
        }
    },
    B: 4,
    C: "CSS Hyphenation",
    D: true
};


$3cefe5e4555b2e46$var$f($59c26eb74a23cd8f$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'hyphens'
    ], {
        browsers: browsers,
        feature: 'css-hyphens'
    });
});
var $95c0c9a4037d1aa5$exports = {};
$95c0c9a4037d1aa5$exports = {
    A: {
        A: {
            "2": "_y",
            "548": "B"
        },
        B: {
            "1": "_K",
            "516": "_I"
        },
        C: {
            "1": "_hR",
            "2": "_RK",
            "676": "_lD _ZH",
            "1700": "_QC _ID _rB"
        },
        D: {
            "1": "_MN _iC",
            "2": "_Y",
            "676": "_aC",
            "804": "_EB _wE _nD"
        },
        E: {
            "1": "_RE",
            "2": "_3",
            "548": "_nP _qE",
            "676": "ID",
            "804": "_gJ _7Q"
        },
        F: {
            "1": "_8F XC",
            "2": "_WE",
            "804": "_PJ _rB"
        },
        G: {
            "2": "_JI",
            "2052": "_VJ"
        },
        H: {
            "2": "vD"
        },
        I: {
            "2": "_O"
        },
        J: {
            "2": "D",
            "292": "A"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "2": "A",
            "548": "B"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_9E",
            "804": "_MD"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "_C"
        }
    },
    B: 1,
    C: "Fullscreen API",
    D: true
};


$3cefe5e4555b2e46$var$f($95c0c9a4037d1aa5$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        ':fullscreen'
    ], {
        browsers: browsers,
        feature: 'fullscreen',
        selector: true
    });
});
var $cef6ac752a148c8d$exports = {};
$cef6ac752a148c8d$exports = {
    A: {
        D: {
            "1": "_UI",
            "2": "_hL",
            "33": "_5I qB"
        },
        L: {
            "1": "I"
        },
        B: {
            "1": "_K",
            "33": "_I"
        },
        C: {
            "1": "_HM",
            "2": "_tL"
        },
        M: {
            "1": "VC"
        },
        A: {
            "2": "_y",
            "33": "B"
        },
        F: {
            "1": "_6G",
            "2": "_8Q",
            "33": "_KQ GB"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        E: {
            "1": "_AT _PE",
            "2": "_BH SD"
        },
        G: {
            "1": "_5B",
            "2": "_YE"
        },
        P: {
            "1": "_F"
        },
        I: {
            "1": "I",
            "2": "_W",
            "33": "_w"
        }
    },
    B: 6,
    C: "CSS ::backdrop pseudo-element",
    D: undefined
};


$3cefe5e4555b2e46$var$f($cef6ac752a148c8d$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        '::backdrop'
    ], {
        browsers: browsers,
        feature: 'backdrop',
        selector: true
    });
});
var $2ff3b385e4a09691$exports = {};
$2ff3b385e4a09691$exports = {
    A: {
        D: {
            "1": "_3H",
            "33": "_u _pD"
        },
        L: {
            "1": "I"
        },
        B: {
            "1": "_4H",
            "33": "_0 _pD"
        },
        C: {
            "1": "_H _SQ",
            "2": "_m _cC _L"
        },
        M: {
            "1": "VC"
        },
        A: {
            "2": "_Z",
            "33": "_A"
        },
        F: {
            "1": "_gQ",
            "2": "_T",
            "33": "_PJ _eG"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        E: {
            "1": "_UH _CE _PE",
            "2": "SD",
            "33": "_hF"
        },
        G: {
            "1": "_IE",
            "33": "_VF"
        },
        P: {
            "1": "_rF",
            "33": "_kF"
        },
        I: {
            "1": "I",
            "2": "_W",
            "33": "_w"
        }
    },
    B: 6,
    C: "::file-selector-button CSS pseudo-element",
    D: undefined
};


$3cefe5e4555b2e46$var$f($2ff3b385e4a09691$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        '::file-selector-button'
    ], {
        browsers: browsers,
        feature: 'file-selector-button',
        selector: true
    });
});
var $57b18274d8044775$exports = {};
$57b18274d8044775$exports = {
    A: {
        D: {
            "1": "_5H _q",
            "33": "_u _6F"
        },
        L: {
            "1": "I"
        },
        B: {
            "1": "_5H _j",
            "2": "_I",
            "33": "_IB _6F"
        },
        C: {
            "2": "_S"
        },
        M: {
            "2": "VC"
        },
        A: {
            "2": "_E"
        },
        F: {
            "1": "_dQ _ME",
            "2": "_T",
            "33": "_sC _4J"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        E: {
            "1": "_LU _PE",
            "2": "SD",
            "33": "_MI"
        },
        G: {
            "1": "_dE",
            "33": "_2F"
        },
        P: {
            "1": "_4B",
            "33": "_OL"
        },
        I: {
            "1": "I",
            "2": "_W",
            "33": "_w"
        }
    },
    B: 6,
    C: ":autofill CSS pseudo-class",
    D: undefined
};


$3cefe5e4555b2e46$var$f($57b18274d8044775$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        ':autofill'
    ], {
        browsers: browsers,
        feature: 'css-autofill',
        selector: true
    });
});
var $d72d7c745b79ef43$exports = {};
$d72d7c745b79ef43$exports = {
    A: {
        A: {
            "2": "_E"
        },
        B: {
            "1": "_K",
            "2": "_I"
        },
        C: {
            "1": "_tP _t",
            "2": "_f",
            "33": "_iE _kD _VB _MB",
            "164": "_AO"
        },
        D: {
            "1": "_KJ _JE",
            "2": "_uF",
            "132": "_4B _8G vB"
        },
        E: {
            "1": "_cE",
            "2": "_3C",
            "132": "_gC _qJ _yB _pL"
        },
        F: {
            "1": "_NO",
            "2": "_2G",
            "132": "_tK",
            "164": "_5 _7K"
        },
        G: {
            "1": "_RD",
            "2": "_o",
            "132": "_TC _DJ _RH"
        },
        H: {
            "164": "vD"
        },
        I: {
            "1": "I",
            "2": "_W",
            "132": "_w"
        },
        J: {
            "132": "_B"
        },
        K: {
            "1": "H",
            "2": "A",
            "164": "_YD"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "2": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_F"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "164": "_C"
        }
    },
    B: 4,
    C: "CSS3 tab-size",
    D: true
};


$3cefe5e4555b2e46$var$f($d72d7c745b79ef43$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'tab-size'
    ], {
        browsers: browsers,
        feature: 'css3-tabsize'
    });
});
var $999dee5e50344192$exports = {};
$999dee5e50344192$exports = {
    A: {
        A: {
            "2": "_E"
        },
        B: {
            "2": "_I",
            "1025": "_WN _xJ",
            "1537": "_IB _7G"
        },
        C: {
            "2": "BD",
            "932": "_qP _qQ",
            "2308": "_lO"
        },
        D: {
            "2": "_iL",
            "545": "_zB _7D _uD",
            "1025": "_WN _0L",
            "1537": "_pH _ID _cC _7G"
        },
        E: {
            "1": "_0C",
            "2": "_3C",
            "516": "_9R",
            "548": "_5R",
            "676": "_QJ _sE"
        },
        F: {
            "2": "_T",
            "513": "oB",
            "545": "_cG",
            "1025": "_SL _ME",
            "1537": "nB _PQ _mE _qI _YF"
        },
        G: {
            "1": "_jB",
            "2": "_o",
            "516": "_hN",
            "548": "_ZR",
            "676": "_TC"
        },
        H: {
            "2": "vD"
        },
        I: {
            "2": "_W",
            "545": "_w",
            "1025": "I"
        },
        J: {
            "2": "D",
            "545": "A"
        },
        K: {
            "2": "_D",
            "1025": "H"
        },
        L: {
            "1025": "I"
        },
        M: {
            "2308": "VC"
        },
        N: {
            "2": "_A"
        },
        O: {
            "1537": "YC"
        },
        P: {
            "545": "J",
            "1025": "_kQ",
            "1537": "_rI _zQ _gS"
        },
        Q: {
            "1537": "DE"
        },
        R: {
            "1537": "EE"
        },
        S: {
            "932": "FE",
            "2308": "GE"
        }
    },
    B: 5,
    C: "Intrinsic & Extrinsic Sizing",
    D: true
};


var $3cefe5e4555b2e46$var$sizeProps = [
    'width',
    'min-width',
    'max-width',
    'height',
    'min-height',
    'max-height',
    'inline-size',
    'min-inline-size',
    'max-inline-size',
    'block-size',
    'min-block-size',
    'max-block-size',
    'grid',
    'grid-template',
    'grid-template-rows',
    'grid-template-columns',
    'grid-auto-columns',
    'grid-auto-rows'
];
$3cefe5e4555b2e46$var$f($999dee5e50344192$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'max-content',
        'min-content'
    ], {
        browsers: browsers,
        feature: 'intrinsic-width',
        props: $3cefe5e4555b2e46$var$sizeProps
    });
});
$3cefe5e4555b2e46$var$f($999dee5e50344192$exports, {
    match: /x|\s#4/
}, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'fill',
        'fill-available'
    ], {
        browsers: browsers,
        feature: 'intrinsic-width',
        props: $3cefe5e4555b2e46$var$sizeProps
    });
});
$3cefe5e4555b2e46$var$f($999dee5e50344192$exports, {
    match: /x|\s#5/
}, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'fit-content'
    ], {
        browsers: browsers,
        feature: 'intrinsic-width',
        props: $3cefe5e4555b2e46$var$sizeProps
    });
});
var $278572cee85df735$exports = {};
$278572cee85df735$exports = {
    A: {
        D: {
            "1": "_NP _dK _KE",
            "2": "_iL",
            "33": "_aG _vG _DL VB"
        },
        L: {
            "1": "I"
        },
        B: {
            "1": "_NP _dK _hE",
            "2": "_I",
            "33": "_kN _DL VB"
        },
        C: {
            "2": "_bR _L",
            "33": "_JH _mJ"
        },
        M: {
            "33": "VC"
        },
        A: {
            "2": "_E"
        },
        F: {
            "1": "6 _XG CB",
            "2": "_T",
            "33": "_sD 5 _sC _UC"
        },
        K: {
            "2": "_D",
            "33": "H"
        },
        E: {
            "1": "K",
            "2": "_XC SD",
            "33": "_xR _lF _cU"
        },
        G: {
            "2": "_o",
            "33": "_z"
        },
        P: {
            "2": "J",
            "33": "_U"
        },
        I: {
            "1": "I",
            "2": "_W",
            "33": "_w"
        }
    },
    B: 6,
    C: "width: stretch property",
    D: undefined
};


$3cefe5e4555b2e46$var$f($278572cee85df735$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'stretch'
    ], {
        browsers: browsers,
        feature: 'css-width-stretch',
        props: $3cefe5e4555b2e46$var$sizeProps
    });
});
var $00afa58e66c681b3$exports = {};
$00afa58e66c681b3$exports = {
    A: {
        A: {
            "2": "_E"
        },
        B: {
            "1": "_J"
        },
        C: {
            "1": "_4M _kB",
            "33": "_LS"
        },
        D: {
            "1": "_UI",
            "33": "_CK"
        },
        E: {
            "1": "_PB",
            "33": "_TB"
        },
        F: {
            "1": "_yM _WF _uB _3I",
            "2": "_5C",
            "33": "_1M"
        },
        G: {
            "2": "_M"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "2": "_G"
        },
        J: {
            "33": "_B"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        L: {
            "1": "I"
        },
        M: {
            "2": "VC"
        },
        N: {
            "2": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "2": "_F"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "2": "_C"
        }
    },
    B: 2,
    C: "CSS3 Cursors: zoom-in & zoom-out",
    D: true
};


$3cefe5e4555b2e46$var$f($00afa58e66c681b3$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'zoom-in',
        'zoom-out'
    ], {
        browsers: browsers,
        feature: 'css3-cursors-newer',
        props: [
            'cursor'
        ]
    });
});
var $7fa958e09d41f13d$exports = {};
$7fa958e09d41f13d$exports = {
    A: {
        A: {
            "2": "_E"
        },
        B: {
            "1": "_SE",
            "2": "_v"
        },
        C: {
            "1": "_1R",
            "33": "_OS"
        },
        D: {
            "1": "_VN _iC",
            "33": "_6 _EF"
        },
        E: {
            "1": "_oB",
            "33": "_pB"
        },
        F: {
            "1": "_yM _6I _3I",
            "2": "_5C",
            "33": "_iD _fD"
        },
        G: {
            "2": "_M"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "2": "_G"
        },
        J: {
            "33": "_B"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        L: {
            "1": "I"
        },
        M: {
            "2": "VC"
        },
        N: {
            "2": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "2": "_F"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "2": "_C"
        }
    },
    B: 2,
    C: "CSS grab & grabbing cursors",
    D: true
};


$3cefe5e4555b2e46$var$f($7fa958e09d41f13d$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'grab',
        'grabbing'
    ], {
        browsers: browsers,
        feature: 'css3-cursors-grab',
        props: [
            'cursor'
        ]
    });
});
var $19383248367bbe97$exports = {};
$19383248367bbe97$exports = {
    A: {
        A: {
            "2": "_E"
        },
        B: {
            "1": "_lR",
            "2": "_3B",
            "1028": "_IB _MB",
            "4100": "_GE"
        },
        C: {
            "1": "_9P _tB",
            "2": "_BP",
            "194": "_zK lB",
            "516": "_5I _bC _mE"
        },
        D: {
            "1": "_mR",
            "2": "_hJ _AJ _fJ",
            "322": "_CC _eJ _lC 9B",
            "1028": "AC _RG _cC _MB"
        },
        E: {
            "1": "_ZE",
            "2": "_3C",
            "33": "_gT _lF _pL",
            "2084": "D JD"
        },
        F: {
            "1": "_2P _4K",
            "2": "_XO",
            "322": "tB uB vB",
            "1028": "wB _vN _HL"
        },
        G: {
            "1": "_UE",
            "2": "_1",
            "33": "_yJ kD",
            "2084": "aD bD"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "2": "_G"
        },
        J: {
            "2": "_B"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "2": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_gB",
            "2": "_qC"
        },
        Q: {
            "1028": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "GE",
            "516": "FE"
        }
    },
    B: 5,
    C: "CSS position:sticky",
    D: true
};


$3cefe5e4555b2e46$var$f($19383248367bbe97$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'sticky'
    ], {
        browsers: browsers,
        feature: 'css-sticky',
        props: [
            'position'
        ]
    });
});
var $9d48e17744c6f792$exports = {};
$9d48e17744c6f792$exports = {
    A: {
        A: {
            "1": "B",
            "2": "_Z",
            "164": "A"
        },
        B: {
            "1": "_J"
        },
        C: {
            "1": "_9P _tB",
            "2": "_1C",
            "8": "_dC _bH",
            "328": "_YC _mE"
        },
        D: {
            "1": "_WL",
            "2": "_iL",
            "8": "_zB _KO",
            "584": "_lC"
        },
        E: {
            "1": "_ZE",
            "2": "_3C",
            "8": "_gC _DE _yB _GD",
            "1096": "XC"
        },
        F: {
            "1": "_TI",
            "2": "_T",
            "8": "_KD sB",
            "584": "tB uB vB"
        },
        G: {
            "1": "_XP _RD",
            "8": "_DF",
            "6148": "lD"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "8": "_G"
        },
        J: {
            "8": "_B"
        },
        K: {
            "1": "H",
            "2": "A",
            "8": "_YD"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "1": "B",
            "36": "A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_gB",
            "2": "2D",
            "8": "J"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "GE",
            "328": "FE"
        }
    },
    B: 2,
    C: "Pointer events",
    D: true
};


$3cefe5e4555b2e46$var$f($9d48e17744c6f792$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'touch-action'
    ], {
        browsers: browsers,
        feature: 'pointer'
    });
});
var $b337acf585db3c55$exports = {};
$b337acf585db3c55$exports = {
    A: {
        A: {
            "2": "_E"
        },
        B: {
            "2": "_I",
            "2052": "_K"
        },
        C: {
            "2": "_1C",
            "1028": "_8E",
            "1060": "_tQ"
        },
        D: {
            "2": "_jJ",
            "226": "_zK _NE _3E",
            "2052": "_qF"
        },
        E: {
            "2": "_4C",
            "772": "_FF",
            "804": "_1O",
            "1316": "KD"
        },
        F: {
            "2": "_TK",
            "226": "_PQ xB",
            "2052": "_HF"
        },
        G: {
            "2": "_DB",
            "292": "_7B"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "2": "_G"
        },
        J: {
            "2": "_B"
        },
        K: {
            "2": "_D",
            "2052": "H"
        },
        L: {
            "2052": "I"
        },
        M: {
            "1028": "VC"
        },
        N: {
            "2": "_A"
        },
        O: {
            "2052": "YC"
        },
        P: {
            "2": "_1B",
            "2052": "_wB"
        },
        Q: {
            "2052": "DE"
        },
        R: {
            "2052": "EE"
        },
        S: {
            "1028": "_C"
        }
    },
    B: 4,
    C: "text-decoration styling",
    D: true
};


$3cefe5e4555b2e46$var$f($b337acf585db3c55$exports, {
    match: /x.*#[235]/
}, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'text-decoration-skip',
        'text-decoration-skip-ink'
    ], {
        browsers: browsers,
        feature: 'text-decoration'
    });
});
var $b59055076a42f5ab$exports = {};
$b59055076a42f5ab$exports = {
    A: {
        D: {
            "1": "_qF",
            "2": "_jF"
        },
        L: {
            "1": "I"
        },
        B: {
            "1": "_K",
            "2": "_I"
        },
        C: {
            "1": "_IM",
            "2": "_1C"
        },
        M: {
            "1": "VC"
        },
        A: {
            "2": "_E"
        },
        F: {
            "1": "_HF",
            "2": "_XI"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        E: {
            "1": "K _iM _FG",
            "2": "_yR",
            "33": "_kH G LD _qL _wQ"
        },
        G: {
            "1": "_iM _FG",
            "2": "_DB",
            "33": "_jC _IK _wQ"
        },
        P: {
            "1": "_wB",
            "2": "_1B"
        },
        I: {
            "1": "I",
            "2": "_G"
        }
    },
    B: 6,
    C: "text-decoration shorthand property",
    D: undefined
};


$3cefe5e4555b2e46$var$f($b59055076a42f5ab$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'text-decoration'
    ], {
        browsers: browsers,
        feature: 'text-decoration'
    });
});
var $9e7153d15bd36482$exports = {};
$9e7153d15bd36482$exports = {
    A: {
        D: {
            "1": "_qF",
            "2": "_jF"
        },
        L: {
            "1": "I"
        },
        B: {
            "1": "_K",
            "2": "_I"
        },
        C: {
            "1": "_8E",
            "2": "_1C",
            "33": "_tQ"
        },
        M: {
            "1": "VC"
        },
        A: {
            "2": "_E"
        },
        F: {
            "1": "_HF",
            "2": "_XI"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        E: {
            "1": "_4I _sI _PE",
            "2": "_yR",
            "33": "_1O"
        },
        G: {
            "1": "_kC",
            "2": "_DB",
            "33": "_yJ"
        },
        P: {
            "1": "_wB",
            "2": "_1B"
        },
        I: {
            "1": "I",
            "2": "_G"
        }
    },
    B: 6,
    C: "text-decoration-color property",
    D: undefined
};


$3cefe5e4555b2e46$var$f($9e7153d15bd36482$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'text-decoration-color'
    ], {
        browsers: browsers,
        feature: 'text-decoration'
    });
});
var $5f62b9f0f0707000$exports = {};
$5f62b9f0f0707000$exports = {
    A: {
        D: {
            "1": "_qF",
            "2": "_jF"
        },
        L: {
            "1": "I"
        },
        B: {
            "1": "_K",
            "2": "_I"
        },
        C: {
            "1": "_8E",
            "2": "_1C",
            "33": "_tQ"
        },
        M: {
            "1": "VC"
        },
        A: {
            "2": "_E"
        },
        F: {
            "1": "_HF",
            "2": "_XI"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        E: {
            "1": "_4I _sI _PE",
            "2": "_yR",
            "33": "_1O"
        },
        G: {
            "1": "_kC",
            "2": "_DB",
            "33": "_yJ"
        },
        P: {
            "1": "_wB",
            "2": "_1B"
        },
        I: {
            "1": "I",
            "2": "_G"
        }
    },
    B: 6,
    C: "text-decoration-line property",
    D: undefined
};


$3cefe5e4555b2e46$var$f($5f62b9f0f0707000$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'text-decoration-line'
    ], {
        browsers: browsers,
        feature: 'text-decoration'
    });
});
var $3f10f8bfebe78ce6$exports = {};
$3f10f8bfebe78ce6$exports = {
    A: {
        D: {
            "1": "_qF",
            "2": "_jF"
        },
        L: {
            "1": "I"
        },
        B: {
            "1": "_K",
            "2": "_I"
        },
        C: {
            "1": "_8E",
            "2": "_1C",
            "33": "_tQ"
        },
        M: {
            "1": "VC"
        },
        A: {
            "2": "_E"
        },
        F: {
            "1": "_HF",
            "2": "_XI"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        E: {
            "1": "_4I _sI _PE",
            "2": "_yR",
            "33": "_1O"
        },
        G: {
            "1": "_kC",
            "2": "_DB",
            "33": "_yJ"
        },
        P: {
            "1": "_wB",
            "2": "_1B"
        },
        I: {
            "1": "I",
            "2": "_G"
        }
    },
    B: 6,
    C: "text-decoration-style property",
    D: undefined
};


$3cefe5e4555b2e46$var$f($3f10f8bfebe78ce6$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'text-decoration-style'
    ], {
        browsers: browsers,
        feature: 'text-decoration'
    });
});
var $e795069d4dbd0983$exports = {};
$e795069d4dbd0983$exports = {
    A: {
        A: {
            "2": "_E"
        },
        B: {
            "1": "_K",
            "33": "_I"
        },
        C: {
            "2": "_S"
        },
        D: {
            "1": "_EM",
            "2": "_jJ _jH _NE _VG",
            "258": "JB"
        },
        E: {
            "2": "_qM _e _cP",
            "258": "ID"
        },
        F: {
            "1": "_H xB _NG _PD",
            "2": "_gH yB _P"
        },
        G: {
            "2": "_d",
            "33": "_r"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "2": "_G"
        },
        J: {
            "2": "_B"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        L: {
            "1": "I"
        },
        M: {
            "33": "VC"
        },
        N: {
            "161": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_U",
            "2": "J"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "2": "_C"
        }
    },
    B: 7,
    C: "CSS text-size-adjust",
    D: true
};


$3cefe5e4555b2e46$var$f($e795069d4dbd0983$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'text-size-adjust'
    ], {
        browsers: browsers,
        feature: 'text-size-adjust'
    });
});
var $6a61a704d9b7cf6f$exports = {};
$6a61a704d9b7cf6f$exports = {
    A: {
        A: {
            "2": "_E"
        },
        B: {
            "1": "_GI",
            "2": "_ZB",
            "164": "_NC _wH",
            "3138": "P",
            "12292": "Q"
        },
        C: {
            "1": "_FM",
            "2": "_g",
            "260": "_GC _UU"
        },
        D: {
            "1": "_3G",
            "164": "_NC _yG"
        },
        E: {
            "1": "_uC",
            "2": "_e",
            "164": "_DC _SD _XN"
        },
        F: {
            "1": "_QK",
            "2": "_T",
            "164": "_sC _BL"
        },
        G: {
            "1": "_5B",
            "164": "_YE"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "164": "_w",
            "676": "_W"
        },
        J: {
            "164": "_B"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "2": "_A"
        },
        O: {
            "164": "YC"
        },
        P: {
            "1": "_NB",
            "164": "_OM"
        },
        Q: {
            "164": "DE"
        },
        R: {
            "164": "EE"
        },
        S: {
            "1": "GE",
            "260": "FE"
        }
    },
    B: 4,
    C: "CSS Masks",
    D: true
};


$3cefe5e4555b2e46$var$f($6a61a704d9b7cf6f$exports, function(browsers) {
    $3cefe5e4555b2e46$var$prefix([
        'mask-clip',
        'mask-composite',
        'mask-image',
        'mask-origin',
        'mask-repeat',
        'mask-border-repeat',
        'mask-border-source'
    ], {
        browsers: browsers,
        feature: 'css-masks'
    });
    $3cefe5e4555b2e46$var$prefix([
        'mask',
        'mask-position',
        'mask-size',
        'mask-border',
        'mask-border-outset',
        'mask-border-width',
        'mask-border-slice'
    ], {
        browsers: browsers,
        feature: 'css-masks'
    });
});
var $cb713beaede0e925$exports = {};
$cb713beaede0e925$exports = {
    A: {
        A: {
            "2": "_E"
        },
        B: {
            "2": "_1F",
            "260": "_K",
            "3138": "Q"
        },
        C: {
            "1": "_DN _7I",
            "2": "_g",
            "132": "_Y _dT",
            "644": "_QC _VG"
        },
        D: {
            "2": "_tF",
            "260": "_WL",
            "292": "_WF _LO"
        },
        E: {
            "2": "_XC",
            "260": "_cE",
            "292": "_gC _qJ _lF _pL"
        },
        F: {
            "2": "_T",
            "260": "_TI",
            "292": "_bH vB"
        },
        G: {
            "2": "_o",
            "260": "_UE",
            "292": "_TC _DJ kD"
        },
        H: {
            "2": "vD"
        },
        I: {
            "2": "_W",
            "260": "I",
            "292": "_w"
        },
        J: {
            "2": "_B"
        },
        K: {
            "2": "_D",
            "260": "H"
        },
        L: {
            "260": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "2": "_A"
        },
        O: {
            "260": "YC"
        },
        P: {
            "260": "_gB",
            "292": "_qC"
        },
        Q: {
            "260": "DE"
        },
        R: {
            "260": "EE"
        },
        S: {
            "1": "GE",
            "644": "FE"
        }
    },
    B: 4,
    C: "CSS clip-path property (for HTML)",
    D: true
};


$3cefe5e4555b2e46$var$f($cb713beaede0e925$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'clip-path'
    ], {
        browsers: browsers,
        feature: 'css-clip-path'
    });
});
var $119ade37400b6c7c$exports = {};
$119ade37400b6c7c$exports = {
    A: {
        A: {
            "2": "_E"
        },
        B: {
            "1": "_dJ _hE",
            "2": "_I",
            "164": "_kN _dL"
        },
        C: {
            "1": "_OO",
            "2": "_DP"
        },
        D: {
            "1": "_dJ _KE",
            "2": "_iL",
            "164": "_aG _vG _dL"
        },
        E: {
            "2": "_3C",
            "164": "_iB"
        },
        F: {
            "1": "_H _fE CB",
            "2": "_pC",
            "129": "_5 _tE",
            "164": "_sC _UC"
        },
        G: {
            "2": "_o",
            "164": "_z"
        },
        H: {
            "132": "vD"
        },
        I: {
            "1": "I",
            "2": "_W",
            "164": "_w"
        },
        J: {
            "2": "D",
            "164": "A"
        },
        K: {
            "2": "A",
            "129": "_YD",
            "164": "H"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "2": "_A"
        },
        O: {
            "164": "YC"
        },
        P: {
            "164": "_F"
        },
        Q: {
            "164": "DE"
        },
        R: {
            "164": "EE"
        },
        S: {
            "1": "_C"
        }
    },
    B: 4,
    C: "CSS box-decoration-break",
    D: true
};


$3cefe5e4555b2e46$var$f($119ade37400b6c7c$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'box-decoration-break'
    ], {
        browsers: browsers,
        feature: 'css-boxdecorationbreak'
    });
});
var $63886cf05204cec8$exports = {};
$63886cf05204cec8$exports = {
    A: {
        A: {
            "2": "_E"
        },
        B: {
            "1": "_K",
            "2": "_3B",
            "260": "_GE"
        },
        C: {
            "1": "_8E",
            "2": "_WI"
        },
        D: {
            "1": "_PO",
            "2": "_hL"
        },
        E: {
            "1": "_LB",
            "2": "_4C",
            "132": "_iQ"
        },
        F: {
            "1": "_nN",
            "2": "F _UB _jK VD",
            "33": "_5 _7K"
        },
        G: {
            "1": "_8",
            "2": "_DB",
            "132": "_jC _eC"
        },
        H: {
            "33": "vD"
        },
        I: {
            "1": "_VD",
            "2": "_xG"
        },
        J: {
            "2": "_B"
        },
        K: {
            "1": "H",
            "2": "A",
            "33": "_YD"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "2": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_F"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "_C"
        }
    },
    B: 4,
    C: "CSS3 object-fit/object-position",
    D: true
};


$3cefe5e4555b2e46$var$f($63886cf05204cec8$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'object-fit',
        'object-position'
    ], {
        browsers: browsers,
        feature: 'object-fit'
    });
});
var $8de22fe543f0eb5f$exports = {};
$8de22fe543f0eb5f$exports = {
    A: {
        A: {
            "2": "_E"
        },
        B: {
            "1": "_K",
            "2": "_I"
        },
        C: {
            "1": "_TL",
            "2": "_NR",
            "322": "_ID"
        },
        D: {
            "1": "_UI",
            "2": "_yN",
            "194": "_jE qB"
        },
        E: {
            "1": "_HB",
            "2": "_4C",
            "33": "_6H _lF"
        },
        F: {
            "1": "_6G",
            "2": "_SK"
        },
        G: {
            "1": "_9",
            "2": "_DB",
            "33": "_jC _AF"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "2": "_G"
        },
        J: {
            "2": "_B"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "2": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_F"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "GE",
            "2": "FE"
        }
    },
    B: 4,
    C: "CSS Shapes Level 1",
    D: true
};


$3cefe5e4555b2e46$var$f($8de22fe543f0eb5f$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'shape-margin',
        'shape-outside',
        'shape-image-threshold'
    ], {
        browsers: browsers,
        feature: 'css-shapes'
    });
});
var $d801c2a10af25a56$exports = {};
$d801c2a10af25a56$exports = {
    A: {
        A: {
            "1": "_PC",
            "2": "AD"
        },
        B: {
            "1": "_J"
        },
        C: {
            "1": "_XL _IC",
            "8": "_g _vB _L"
        },
        D: {
            "1": "_Q"
        },
        E: {
            "1": "_R"
        },
        F: {
            "1": "_zJ",
            "33": "_pC"
        },
        G: {
            "1": "_M"
        },
        H: {
            "1": "vD"
        },
        I: {
            "1": "_O"
        },
        J: {
            "1": "_B"
        },
        K: {
            "1": "_YB",
            "33": "_bB"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "1": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_F"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "_C"
        }
    },
    B: 2,
    C: "CSS3 Text-overflow",
    D: true
};


$3cefe5e4555b2e46$var$f($d801c2a10af25a56$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'text-overflow'
    ], {
        browsers: browsers,
        feature: 'text-overflow'
    });
});
var $253ef41f01c0580a$exports = {};
$253ef41f01c0580a$exports = {
    A: {
        A: {
            "2": "_Z",
            "164": "_A"
        },
        B: {
            "66": "_K",
            "164": "_I"
        },
        C: {
            "2": "_S"
        },
        D: {
            "2": "_iJ",
            "66": "_WR"
        },
        E: {
            "2": "_R"
        },
        F: {
            "2": "_5O",
            "66": "_JM"
        },
        G: {
            "2": "_M"
        },
        H: {
            "292": "vD"
        },
        I: {
            "2": "_O"
        },
        J: {
            "2": "_B"
        },
        K: {
            "2": "A H",
            "292": "_YD"
        },
        L: {
            "2": "I"
        },
        M: {
            "2": "VC"
        },
        N: {
            "164": "_A"
        },
        O: {
            "2": "YC"
        },
        P: {
            "2": "_F"
        },
        Q: {
            "66": "DE"
        },
        R: {
            "2": "EE"
        },
        S: {
            "2": "_C"
        }
    },
    B: 5,
    C: "CSS Device Adaptation",
    D: true
};


$3cefe5e4555b2e46$var$f($253ef41f01c0580a$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        '@viewport'
    ], {
        browsers: browsers,
        feature: 'css-deviceadaptation'
    });
});
var $12faa4f494acf7c0$exports = {};
$12faa4f494acf7c0$exports = {
    A: {
        A: {
            "2": "_c",
            "132": "_V"
        },
        B: {
            "1": "_K",
            "1028": "_I"
        },
        C: {
            "1": "_TL",
            "2": "_g",
            "260": "_DC _L",
            "1028": "_1L _wE"
        },
        D: {
            "1": "_VN _iC",
            "548": "_iJ",
            "1028": "_qB _wE _EF"
        },
        E: {
            "1": "_0C",
            "2": "_e",
            "548": "_DC _SD _JG"
        },
        F: {
            "1": "_H _6I XC",
            "2": "F",
            "548": "_5 _EJ",
            "1028": "_iD _fD"
        },
        G: {
            "1": "_jB",
            "16": "iC",
            "548": "_PR _AL"
        },
        H: {
            "132": "vD"
        },
        I: {
            "1": "I",
            "16": "_k",
            "548": "_mL",
            "1028": "_w"
        },
        J: {
            "548": "_B"
        },
        K: {
            "1": "_YB",
            "548": "_bB"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "132": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_9E",
            "1028": "_MD"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "_C"
        }
    },
    B: 4,
    C: "Media Queries: resolution feature",
    D: true
};


$3cefe5e4555b2e46$var$f($12faa4f494acf7c0$exports, {
    match: /( x($| )|a #2)/
}, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        '@resolution'
    ], {
        browsers: browsers,
        feature: 'css-media-resolution'
    });
});
var $90dfb19167c63325$exports = {};
$90dfb19167c63325$exports = {
    A: {
        A: {
            "132": "_E"
        },
        B: {
            "1": "_K",
            "4": "_I"
        },
        C: {
            "1": "_wD",
            "2": "_g _MG _L",
            "33": "_v _vK"
        },
        D: {
            "1": "_eO",
            "2": "_uQ",
            "322": "_PQ _MH"
        },
        E: {
            "1": "_0C",
            "2": "_HE"
        },
        F: {
            "1": "_SO",
            "2": "_KS",
            "578": "_zB _LH"
        },
        G: {
            "1": "_jB",
            "2": "_xC"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "2": "_G"
        },
        J: {
            "2": "_B"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "132": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_U",
            "2": "J"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "GE",
            "33": "FE"
        }
    },
    B: 4,
    C: "CSS3 text-align-last",
    D: true
};


$3cefe5e4555b2e46$var$f($90dfb19167c63325$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'text-align-last'
    ], {
        browsers: browsers,
        feature: 'css-text-align-last'
    });
});
var $282df07ec9ce0fac$exports = {};
$282df07ec9ce0fac$exports = {
    A: {
        A: {
            "2": "_CQ",
            "2340": "_sJ"
        },
        B: {
            "2": "_I",
            "1025": "_K"
        },
        C: {
            "1": "_H _aO",
            "2": "_LC",
            "513": "_GJ _JD _fF",
            "545": "_4Q GD"
        },
        D: {
            "1": "_hI _pE",
            "2": "_XD",
            "1025": "_2M _rL _IL _IH"
        },
        E: {
            "1": "_LB",
            "2": "_s",
            "164": "L",
            "4644": "_gC _yB"
        },
        F: {
            "2": "_uM _9M _TH _sB",
            "545": "_LL",
            "1025": "_fO"
        },
        G: {
            "1": "_8",
            "2": "_d",
            "4260": "_wC",
            "4644": "_TC _eC"
        },
        H: {
            "2": "vD"
        },
        I: {
            "2": "_G",
            "1025": "I"
        },
        J: {
            "2": "D",
            "4260": "A"
        },
        K: {
            "2": "_fB",
            "545": "_JL",
            "1025": "H"
        },
        L: {
            "1025": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "2340": "_A"
        },
        O: {
            "1025": "YC"
        },
        P: {
            "1025": "_F"
        },
        Q: {
            "1025": "DE"
        },
        R: {
            "1025": "EE"
        },
        S: {
            "1": "GE",
            "4097": "FE"
        }
    },
    B: 4,
    C: "Crisp edges/pixelated images",
    D: true
};


$3cefe5e4555b2e46$var$f($282df07ec9ce0fac$exports, {
    match: /y x|a x #1/
}, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'pixelated'
    ], {
        browsers: browsers,
        feature: 'css-crisp-edges',
        props: [
            'image-rendering'
        ]
    });
});
$3cefe5e4555b2e46$var$f($282df07ec9ce0fac$exports, {
    match: /a x #2/
}, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'image-rendering'
    ], {
        browsers: browsers,
        feature: 'css-crisp-edges'
    });
});
var $4bb71431048ef952$exports = {};
$4bb71431048ef952$exports = {
    A: {
        A: {
            "2": "_E"
        },
        B: {
            "1": "_4H",
            "2": "_I",
            "1028": "_1P",
            "1540": "_mG W"
        },
        C: {
            "1": "_lO",
            "2": "BD",
            "164": "cC _XD _L",
            "1540": "_YC _fC _AD"
        },
        D: {
            "1": "_3H",
            "292": "_2Q",
            "1028": "_1P",
            "1540": "_gK _fL W"
        },
        E: {
            "1": "_eE",
            "292": "_TD",
            "1540": "_AC _AE",
            "3076": "ND"
        },
        F: {
            "1": "_aJ",
            "2": "_T",
            "292": "_iD _TE",
            "1028": "_DG",
            "1540": "AC _dM DC _lE"
        },
        G: {
            "1": "_dE",
            "292": "_LD",
            "1540": "_oI",
            "3076": "qD"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "292": "_G"
        },
        J: {
            "292": "_B"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "2": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_rF",
            "292": "_MD",
            "1540": "_zQ"
        },
        Q: {
            "1540": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "GE",
            "1540": "FE"
        }
    },
    B: 5,
    C: "CSS Logical Properties",
    D: true
};


$3cefe5e4555b2e46$var$f($4bb71431048ef952$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'border-inline-start',
        'border-inline-end',
        'margin-inline-start',
        'margin-inline-end',
        'padding-inline-start',
        'padding-inline-end'
    ], {
        browsers: browsers,
        feature: 'css-logical-props'
    });
});
$3cefe5e4555b2e46$var$f($4bb71431048ef952$exports, {
    match: /x\s#2/
}, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'border-block-start',
        'border-block-end',
        'margin-block-start',
        'margin-block-end',
        'padding-block-start',
        'padding-block-end'
    ], {
        browsers: browsers,
        feature: 'css-logical-props'
    });
});
var $381c089860ffc1a2$exports = {};
$381c089860ffc1a2$exports = {
    A: {
        A: {
            "2": "_E"
        },
        B: {
            "1": "_2R",
            "33": "T",
            "164": "_IB",
            "388": "_I"
        },
        C: {
            "1": "_WJ _SQ",
            "164": "_QQ _yD",
            "676": "_MS"
        },
        D: {
            "1": "_3R",
            "33": "T",
            "164": "_u"
        },
        E: {
            "1": "_uC",
            "164": "_BH"
        },
        F: {
            "1": "_bJ",
            "2": "_T",
            "33": "MC _QP",
            "164": "_PJ _yL"
        },
        G: {
            "1": "_5B",
            "164": "_YE"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "164": "_G"
        },
        J: {
            "164": "_B"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "2": "A",
            "388": "B"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_tD",
            "164": "_XE"
        },
        Q: {
            "164": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "GE",
            "164": "FE"
        }
    },
    B: 5,
    C: "CSS Appearance",
    D: true
};


$3cefe5e4555b2e46$var$f($381c089860ffc1a2$exports, {
    match: /#2|x/
}, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'appearance'
    ], {
        browsers: browsers,
        feature: 'css-appearance'
    });
});
var $6d7c6d1f276d59cd$exports = {};
$6d7c6d1f276d59cd$exports = {
    A: {
        A: {
            "2": "_Z",
            "6308": "A",
            "6436": "B"
        },
        B: {
            "1": "_K",
            "6436": "_I"
        },
        C: {
            "1": "_7R",
            "2": "_PN sB _L",
            "2052": "_oH _fC _EF"
        },
        D: {
            "1": "_sO",
            "2": "_1Q",
            "8258": "_TP"
        },
        E: {
            "1": "_oB",
            "2": "_TB",
            "3108": "_5R"
        },
        F: {
            "1": "_8F",
            "2": "_XK",
            "8258": "8B _eL _rB"
        },
        G: {
            "1": "_AB",
            "2": "_2",
            "3108": "_HD"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "2": "_G"
        },
        J: {
            "2": "_B"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "2": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_9E",
            "2": "_MD"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "GE",
            "2052": "FE"
        }
    },
    B: 4,
    C: "CSS Scroll Snap",
    D: true
};


$3cefe5e4555b2e46$var$f($6d7c6d1f276d59cd$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'scroll-snap-type',
        'scroll-snap-coordinate',
        'scroll-snap-destination',
        'scroll-snap-points-x',
        'scroll-snap-points-y'
    ], {
        browsers: browsers,
        feature: 'css-snappoints'
    });
});
var $362c65694daa826f$exports = {};
$362c65694daa826f$exports = {
    A: {
        A: {
            "2": "_Z",
            "420": "_A"
        },
        B: {
            "2": "_K",
            "420": "_I"
        },
        C: {
            "2": "_S"
        },
        D: {
            "2": "_H _Y pB _TG",
            "36": "_UB",
            "66": "_hC _7H"
        },
        E: {
            "2": "_vB _rK _VH _xS",
            "33": "_sJ _6Q"
        },
        F: {
            "2": "_b"
        },
        G: {
            "2": "_o _KC",
            "33": "_TC _iT"
        },
        H: {
            "2": "vD"
        },
        I: {
            "2": "_O"
        },
        J: {
            "2": "_B"
        },
        K: {
            "2": "_N"
        },
        L: {
            "2": "I"
        },
        M: {
            "2": "VC"
        },
        N: {
            "420": "_A"
        },
        O: {
            "2": "YC"
        },
        P: {
            "2": "_F"
        },
        Q: {
            "2": "DE"
        },
        R: {
            "2": "EE"
        },
        S: {
            "2": "_C"
        }
    },
    B: 5,
    C: "CSS Regions",
    D: true
};


$3cefe5e4555b2e46$var$f($362c65694daa826f$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'flow-into',
        'flow-from',
        'region-fragment'
    ], {
        browsers: browsers,
        feature: 'css-regions'
    });
});
var $b11badaf27d03c01$exports = {};
$b11badaf27d03c01$exports = {
    A: {
        A: {
            "2": "_E"
        },
        B: {
            "1": "_rR",
            "2": "_I",
            "164": "_IB _DR",
            "2049": "x"
        },
        C: {
            "1": "_wO",
            "2": "_aB _oD _L",
            "66": "_JF",
            "2305": "_dI _cK _AG",
            "2820": "Y"
        },
        D: {
            "1": "_sR",
            "2": "_uF",
            "164": "_4B _vG _DR",
            "2049": "x"
        },
        E: {
            "1": "_2D",
            "2": "_s",
            "132": "_qJ _OE",
            "164": "_OC _yB",
            "1540": "_sH _CE _gF"
        },
        F: {
            "1": "_GS",
            "2": "_T",
            "164": "_sC _5N",
            "2049": "j"
        },
        G: {
            "1": "_VE",
            "2": "_1",
            "132": "_BE _IG _9K",
            "164": "_QD _eC",
            "1540": "_hN _mH"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "2": "_W",
            "164": "_w"
        },
        J: {
            "2": "D",
            "164": "A"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "2": "_A"
        },
        O: {
            "164": "YC"
        },
        P: {
            "1": "_CC",
            "164": "_OK"
        },
        Q: {
            "164": "DE"
        },
        R: {
            "164": "EE"
        },
        S: {
            "2": "_C"
        }
    },
    B: 5,
    C: "CSS image-set",
    D: true
};


$3cefe5e4555b2e46$var$f($b11badaf27d03c01$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'image-set'
    ], {
        browsers: browsers,
        feature: 'css-image-set',
        props: [
            'background',
            'background-image',
            'border-image',
            'cursor',
            'mask',
            'mask-image',
            'list-style',
            'list-style-image',
            'content'
        ]
    });
});
var $1ecd5c66543397ec$exports = {};
$1ecd5c66543397ec$exports = {
    A: {
        A: {
            "132": "_E"
        },
        B: {
            "1": "_J"
        },
        C: {
            "1": "_8L",
            "2": "_WI",
            "322": "_tN"
        },
        D: {
            "1": "_5F",
            "2": "_vB",
            "16": "D",
            "33": "_kH _CJ"
        },
        E: {
            "1": "_oB",
            "2": "_i",
            "16": "jB",
            "33": "_DI jC"
        },
        F: {
            "1": "_PI",
            "2": "_T",
            "33": "_bF"
        },
        G: {
            "1": "_AB",
            "16": "_d",
            "33": "_rD _HD"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "2": "_l",
            "33": "_pJ"
        },
        J: {
            "33": "_B"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "36": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_U",
            "33": "J"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "_C"
        }
    },
    B: 2,
    C: "CSS writing-mode property",
    D: true
};


$3cefe5e4555b2e46$var$f($1ecd5c66543397ec$exports, {
    match: /a|x/
}, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'writing-mode'
    ], {
        browsers: browsers,
        feature: 'css-writing-mode'
    });
});
var $34815d60da1f4f81$exports = {};
$34815d60da1f4f81$exports = {
    A: {
        A: {
            "2": "_E"
        },
        B: {
            "2": "_I",
            "33": "_K"
        },
        C: {
            "2": "_S"
        },
        D: {
            "2": "_wN",
            "33": "_jP _xL"
        },
        E: {
            "1": "_LB",
            "2": "_3",
            "33": "_OC _SD"
        },
        F: {
            "2": "_T",
            "33": "_a"
        },
        G: {
            "1": "_8",
            "2": "_d",
            "33": "_rD _eC"
        },
        H: {
            "2": "vD"
        },
        I: {
            "2": "_W",
            "33": "_X"
        },
        J: {
            "2": "_B"
        },
        K: {
            "2": "_D",
            "33": "H"
        },
        L: {
            "33": "I"
        },
        M: {
            "2": "VC"
        },
        N: {
            "2": "_A"
        },
        O: {
            "33": "YC"
        },
        P: {
            "33": "_F"
        },
        Q: {
            "33": "DE"
        },
        R: {
            "33": "EE"
        },
        S: {
            "2": "_C"
        }
    },
    B: 4,
    C: "CSS Cross-Fade Function",
    D: true
};


$3cefe5e4555b2e46$var$f($34815d60da1f4f81$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'cross-fade'
    ], {
        browsers: browsers,
        feature: 'css-cross-fade',
        props: [
            'background',
            'background-image',
            'border-image',
            'mask',
            'list-style',
            'list-style-image',
            'content',
            'mask-image'
        ]
    });
});
var $8559cdde07fa752c$exports = {};
$8559cdde07fa752c$exports = {
    A: {
        A: {
            "2": "_E"
        },
        B: {
            "1": "_xD",
            "2": "C"
        },
        C: {
            "1": "_yO",
            "16": "BD",
            "33": "_qP _6R"
        },
        D: {
            "1": "_2H",
            "16": "_Y",
            "132": "_LG"
        },
        E: {
            "1": "_PB",
            "16": "_e",
            "132": "_QG _UJ"
        },
        F: {
            "1": "_GM",
            "16": "_JR",
            "132": "C _0B _PL"
        },
        G: {
            "1": "_p",
            "16": "_rC",
            "132": "_qO"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "16": "_k",
            "132": "_1N"
        },
        J: {
            "1": "A",
            "132": "D"
        },
        K: {
            "1": "H",
            "2": "_A WC",
            "132": "C _TQ"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "2": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_F"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "GE",
            "33": "FE"
        }
    },
    B: 1,
    C: "CSS :read-only and :read-write selectors",
    D: true
};


$3cefe5e4555b2e46$var$f($8559cdde07fa752c$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        ':read-only',
        ':read-write'
    ], {
        browsers: browsers,
        feature: 'css-read-only-write',
        selector: true
    });
});
var $69126869faaafff0$exports = {};
$69126869faaafff0$exports = {
    A: {
        A: {
            "2": "_E"
        },
        B: {
            "1": "_qN _j",
            "2": "_I",
            "164": "_IB _5N"
        },
        C: {
            "1": "_ZJ _0E",
            "2": "_IJ _ZC _L",
            "322": "zB"
        },
        D: {
            "1": "_qN _q",
            "2": "_rG",
            "164": "_NB _vG _5N"
        },
        E: {
            "1": "_VI",
            "2": "_3C",
            "164": "D JD"
        },
        F: {
            "1": "_oG _IR",
            "2": "_T",
            "164": "_sC _oD"
        },
        G: {
            "1": "_z",
            "2": "_o"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "2": "_W",
            "164": "_w"
        },
        J: {
            "2": "D",
            "164": "A"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "2": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_jQ",
            "164": "_0O"
        },
        Q: {
            "164": "DE"
        },
        R: {
            "164": "EE"
        },
        S: {
            "1": "_C"
        }
    },
    B: 4,
    C: "text-emphasis styling",
    D: true
};


$3cefe5e4555b2e46$var$f($69126869faaafff0$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'text-emphasis',
        'text-emphasis-position',
        'text-emphasis-style',
        'text-emphasis-color'
    ], {
        browsers: browsers,
        feature: 'text-emphasis'
    });
});
var $cf32448403b5cbcc$exports = {};
$cf32448403b5cbcc$exports = {
    A: {
        A: {
            "2": "_c",
            "8": "F",
            "292": "_A"
        },
        B: {
            "1": "_aE",
            "292": "_3B"
        },
        C: {
            "1": "_DN _7I",
            "2": "_uL",
            "8": "_hC _lH _eD",
            "584": "_2I _fJ",
            "1025": "_RQ"
        },
        D: {
            "1": "_QM",
            "2": "_rG",
            "8": "_CG",
            "200": "_qB _NE _3E",
            "1025": "BC"
        },
        E: {
            "1": "_HB",
            "2": "_s",
            "8": "_1E _yB"
        },
        F: {
            "1": "_HF",
            "2": "_UK",
            "200": "_OG _sQ"
        },
        G: {
            "1": "_9",
            "2": "_1",
            "8": "_QD _AF"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "2": "_0N zD",
            "8": "_gN"
        },
        J: {
            "2": "_B"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "292": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_gB",
            "2": "2D",
            "8": "J"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "_C"
        }
    },
    B: 4,
    C: "CSS Grid Layout (level 1)",
    D: true
};


$3cefe5e4555b2e46$var$f($cf32448403b5cbcc$exports, function(browsers) {
    $3cefe5e4555b2e46$var$prefix([
        'display-grid',
        'inline-grid'
    ], {
        browsers: browsers,
        feature: 'css-grid',
        props: [
            'display'
        ]
    });
    $3cefe5e4555b2e46$var$prefix([
        'grid-template-columns',
        'grid-template-rows',
        'grid-row-start',
        'grid-column-start',
        'grid-row-end',
        'grid-column-end',
        'grid-row',
        'grid-column',
        'grid-area',
        'grid-template',
        'grid-template-areas',
        'place-self'
    ], {
        browsers: browsers,
        feature: 'css-grid'
    });
});
$3cefe5e4555b2e46$var$f($cf32448403b5cbcc$exports, {
    match: /a x/
}, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'grid-column-align',
        'grid-row-align'
    ], {
        browsers: browsers,
        feature: 'css-grid'
    });
});
var $2c05164737681b55$exports = {};
$2c05164737681b55$exports = {
    A: {
        A: {
            "2": "_GB",
            "161": "_JC"
        },
        B: {
            "2": "_K",
            "161": "_I"
        },
        C: {
            "2": "_S"
        },
        D: {
            "2": "_Q"
        },
        E: {
            "2": "_R"
        },
        F: {
            "2": "_b"
        },
        G: {
            "2": "_M"
        },
        H: {
            "2": "vD"
        },
        I: {
            "2": "_O"
        },
        J: {
            "2": "_B"
        },
        K: {
            "2": "_N"
        },
        L: {
            "2": "I"
        },
        M: {
            "2": "VC"
        },
        N: {
            "16": "_A"
        },
        O: {
            "2": "YC"
        },
        P: {
            "2": "_F"
        },
        Q: {
            "2": "DE"
        },
        R: {
            "2": "EE"
        },
        S: {
            "2": "_C"
        }
    },
    B: 5,
    C: "CSS Text 4 text-spacing",
    D: false
};


$3cefe5e4555b2e46$var$f($2c05164737681b55$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'text-spacing'
    ], {
        browsers: browsers,
        feature: 'css-text-spacing'
    });
});
var $576cc5f16429365d$exports = {};
$576cc5f16429365d$exports = {
    A: {
        A: {
            "2": "_E"
        },
        B: {
            "1": "_K",
            "2": "_I"
        },
        C: {
            "1": "_GF",
            "16": "BD",
            "33": "cC _kL _L"
        },
        D: {
            "1": "_RM",
            "16": "_Y",
            "33": "_RF _qD"
        },
        E: {
            "1": "_PB",
            "16": "_3C",
            "33": "_QJ _sE"
        },
        F: {
            "1": "_SI",
            "2": "_T",
            "33": "_BR"
        },
        G: {
            "1": "_p",
            "16": "_1",
            "33": "_QD"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "16": "_W",
            "33": "_w"
        },
        J: {
            "16": "_B"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "2": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_sF",
            "16": "J",
            "33": "_oJ 5D"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "GE",
            "33": "FE"
        }
    },
    B: 5,
    C: "CSS :any-link selector",
    D: true
};


$3cefe5e4555b2e46$var$f($576cc5f16429365d$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        ':any-link'
    ], {
        browsers: browsers,
        feature: 'css-any-link',
        selector: true
    });
});
var $c6b7eded51b34eb9$exports = {};
$c6b7eded51b34eb9$exports = {
    A: {
        D: {
            "1": "_5F",
            "2": "_DC",
            "33": "_1L _uN"
        },
        L: {
            "1": "I"
        },
        B: {
            "1": "_K",
            "2": "_I"
        },
        C: {
            "1": "_GF",
            "2": "_RK",
            "33": "_lD _ZG"
        },
        M: {
            "1": "VC"
        },
        A: {
            "2": "_E"
        },
        F: {
            "1": "_PI",
            "2": "_T",
            "33": "_bF"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        E: {
            "1": "_zI _UN _PE",
            "2": "_s SD",
            "33": "_1E _6Q"
        },
        G: {
            "1": "_AB",
            "2": "_1",
            "33": "_QD _HD"
        },
        P: {
            "1": "_U",
            "2": "J"
        },
        I: {
            "1": "I",
            "2": "_G"
        }
    },
    B: 6,
    C: "isolate from unicode-bidi",
    D: undefined
};


$3cefe5e4555b2e46$var$f($c6b7eded51b34eb9$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'isolate'
    ], {
        browsers: browsers,
        feature: 'css-unicode-bidi',
        props: [
            'unicode-bidi'
        ]
    });
});
var $97d59ac5a6e8cbe9$exports = {};
$97d59ac5a6e8cbe9$exports = {
    A: {
        D: {
            "1": "_5F",
            "2": "_8H"
        },
        L: {
            "1": "I"
        },
        B: {
            "1": "_K",
            "2": "_I"
        },
        C: {
            "1": "_GF",
            "2": "_RK",
            "33": "_lD _ZG"
        },
        M: {
            "1": "VC"
        },
        A: {
            "2": "_E"
        },
        F: {
            "1": "_PI",
            "2": "_TK"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        E: {
            "1": "_zI _UN _PE",
            "2": "_s SD",
            "33": "_1E _6Q"
        },
        G: {
            "1": "_AB",
            "2": "_1",
            "33": "_QD _HD"
        },
        P: {
            "1": "_U",
            "2": "J"
        },
        I: {
            "1": "I",
            "2": "_G"
        }
    },
    B: 6,
    C: "plaintext from unicode-bidi",
    D: undefined
};


$3cefe5e4555b2e46$var$f($97d59ac5a6e8cbe9$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'plaintext'
    ], {
        browsers: browsers,
        feature: 'css-unicode-bidi',
        props: [
            'unicode-bidi'
        ]
    });
});
var $74e700ff9edec1c1$exports = {};
$74e700ff9edec1c1$exports = {
    A: {
        D: {
            "1": "_5F",
            "2": "_8H"
        },
        L: {
            "1": "I"
        },
        B: {
            "1": "_K",
            "2": "_I"
        },
        C: {
            "1": "_GF",
            "2": "_3N",
            "33": "_iN _zO"
        },
        M: {
            "1": "VC"
        },
        A: {
            "2": "_E"
        },
        F: {
            "1": "_PI",
            "2": "_TK"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        E: {
            "1": "_zI _UN _PE",
            "2": "_XC SD",
            "33": "_gC A _dR"
        },
        G: {
            "1": "_AB",
            "2": "_o",
            "33": "_TC _HD"
        },
        P: {
            "1": "_U",
            "2": "J"
        },
        I: {
            "1": "I",
            "2": "_G"
        }
    },
    B: 6,
    C: "isolate-override from unicode-bidi",
    D: undefined
};


$3cefe5e4555b2e46$var$f($74e700ff9edec1c1$exports, {
    match: /y x/
}, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'isolate-override'
    ], {
        browsers: browsers,
        feature: 'css-unicode-bidi',
        props: [
            'unicode-bidi'
        ]
    });
});
var $a270a5ac8f38f881$exports = {};
$a270a5ac8f38f881$exports = {
    A: {
        A: {
            "2": "_Z",
            "132": "_A"
        },
        B: {
            "1": "_K",
            "132": "_1F",
            "516": "Q"
        },
        C: {
            "1": "_9P _tB",
            "2": "_sL _L"
        },
        D: {
            "1": "_RM",
            "2": "_2N",
            "260": "FC GC"
        },
        E: {
            "1": "_0C",
            "2": "_hF",
            "1090": "G _CE"
        },
        F: {
            "1": "_SI",
            "2": "_9O",
            "260": "4B 5B"
        },
        G: {
            "1": "_jB",
            "2": "_VF",
            "1090": "_lK"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "2": "_G"
        },
        J: {
            "2": "_B"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "132": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_xB",
            "2": "_nC"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "GE",
            "2": "FE"
        }
    },
    B: 5,
    C: "CSS overscroll-behavior",
    D: true
};


$3cefe5e4555b2e46$var$f($a270a5ac8f38f881$exports, {
    match: /a #1/
}, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'overscroll-behavior'
    ], {
        browsers: browsers,
        feature: 'css-overscroll-behavior'
    });
});
var $5a24efe9733cfe26$exports = {};
$5a24efe9733cfe26$exports = {
    A: {
        A: {
            "2": "_E"
        },
        B: {
            "1": "_K",
            "2": "_I"
        },
        C: {
            "1": "_8L",
            "2": "_PM",
            "194": "_kI"
        },
        D: {
            "1": "_5F",
            "2": "_8H"
        },
        E: {
            "1": "_7L",
            "2": "_SB",
            "16": "A",
            "33": "_5 M _OE"
        },
        F: {
            "1": "_PI",
            "2": "_TK"
        },
        G: {
            "1": "_8",
            "2": "_OB"
        },
        H: {
            "2": "vD"
        },
        I: {
            "1": "I",
            "2": "_G"
        },
        J: {
            "2": "_B"
        },
        K: {
            "1": "H",
            "2": "_D"
        },
        L: {
            "1": "I"
        },
        M: {
            "1": "VC"
        },
        N: {
            "2": "_A"
        },
        O: {
            "1": "YC"
        },
        P: {
            "1": "_U",
            "2": "J"
        },
        Q: {
            "1": "DE"
        },
        R: {
            "1": "EE"
        },
        S: {
            "1": "_C"
        }
    },
    B: 2,
    C: "CSS text-orientation",
    D: true
};


$3cefe5e4555b2e46$var$f($5a24efe9733cfe26$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'text-orientation'
    ], {
        browsers: browsers,
        feature: 'css-text-orientation'
    });
});
var $bfe927dc5cebcd01$exports = {};
$bfe927dc5cebcd01$exports = {
    A: {
        D: {
            "1": "UB _nQ",
            "2": "_wN",
            "33": "_jP _hC _vG _3K _fI TB"
        },
        L: {
            "1": "I"
        },
        B: {
            "1": "UB _mQ",
            "2": "_I",
            "33": "_kN _3K _fI TB"
        },
        C: {
            "1": "_yH _dG",
            "2": "_WK",
            "33": "_0M _ID _VB _5G"
        },
        M: {
            "1": "VC"
        },
        A: {
            "2": "_E"
        },
        F: {
            "1": "_qH CB",
            "2": "_T",
            "33": "_sD _sC _UC"
        },
        K: {
            "2": "_D",
            "33": "H"
        },
        E: {
            "1": "_AT _PE",
            "2": "_s SD",
            "33": "_gJ _7Q"
        },
        G: {
            "1": "_5B",
            "2": "_1",
            "33": "_QD _YR _YG"
        },
        P: {
            "1": "_qB",
            "33": "_NN _CG _vE"
        },
        I: {
            "1": "I",
            "2": "_W",
            "33": "_w"
        }
    },
    B: 6,
    C: "print-color-adjust property",
    D: undefined
};


$3cefe5e4555b2e46$var$f($bfe927dc5cebcd01$exports, function(browsers) {
    return $3cefe5e4555b2e46$var$prefix([
        'print-color-adjust',
        'color-adjust'
    ], {
        browsers: browsers,
        feature: 'css-print-color-adjust'
    });
});


var $ba7797ad5f9394dd$exports = {};

function $ba7797ad5f9394dd$var$capitalize(str) {
    return str.slice(0, 1).toUpperCase() + str.slice(1);
}
var $ba7797ad5f9394dd$var$NAMES = {
    and_chr: 'Chrome for Android',
    and_ff: 'Firefox for Android',
    and_qq: 'QQ Browser',
    and_uc: 'UC for Android',
    baidu: 'Baidu Browser',
    ie: 'IE',
    ie_mob: 'IE Mobile',
    ios_saf: 'iOS Safari',
    kaios: 'KaiOS Browser',
    op_mini: 'Opera Mini',
    op_mob: 'Opera Mobile',
    samsung: 'Samsung Internet'
};
function $ba7797ad5f9394dd$var$prefix(name, prefixes, note) {
    var out = "  ".concat(name);
    if (note) out += ' *';
    out += ': ';
    out += prefixes.map(function(i) {
        return i.replace(/^-(.*)-$/g, '$1');
    }).join(', ');
    out += '\n';
    return out;
}
$ba7797ad5f9394dd$exports = function(prefixes) {
    if (prefixes.browsers.selected.length === 0) return 'No browsers selected';
    var versions = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = prefixes.browsers.selected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var browser = _step.value;
            var parts = browser.split(' ');
            var name = parts[0];
            var version = parts[1];
            name = $ba7797ad5f9394dd$var$NAMES[name] || $ba7797ad5f9394dd$var$capitalize(name);
            if (versions[name]) versions[name].push(version);
            else versions[name] = [
                version
            ];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var out = 'Browsers:\n';
    for(var browser1 in versions){
        var list = versions[browser1];
        list = list.sort(function(a, b) {
            return parseFloat(b) - parseFloat(a);
        });
        out += "  ".concat(browser1, ": ").concat(list.join(', '), "\n");
    }
    var coverage = $d9eea3283bc93203$exports.coverage(prefixes.browsers.selected);
    var round = Math.round(coverage * 100) / 100.0;
    out += "\nThese browsers account for ".concat(round, "% of all users globally\n");
    var atrules = [];
    for(var name1 in prefixes.add){
        var data = prefixes.add[name1];
        if (name1[0] === '@' && data.prefixes) atrules.push($ba7797ad5f9394dd$var$prefix(name1, data.prefixes));
    }
    if (atrules.length > 0) out += "\nAt-Rules:\n".concat(atrules.sort().join(''));
    var selectors = [];
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = prefixes.add.selectors[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var selector = _step1.value;
            if (selector.prefixes) selectors.push($ba7797ad5f9394dd$var$prefix(selector.name, selector.prefixes));
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    if (selectors.length > 0) out += "\nSelectors:\n".concat(selectors.sort().join(''));
    var values = [];
    var props = [];
    var hadGrid = false;
    for(var name2 in prefixes.add){
        var data1 = prefixes.add[name2];
        if (name2[0] !== '@' && data1.prefixes) {
            var grid = name2.indexOf('grid-') === 0;
            if (grid) hadGrid = true;
            props.push($ba7797ad5f9394dd$var$prefix(name2, data1.prefixes, grid));
        }
        if (!Array.isArray(data1.values)) continue;
        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
        try {
            for(var _iterator2 = data1.values[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                var value = _step2.value;
                var grid1 = value.name.includes('grid');
                if (grid1) hadGrid = true;
                var string = $ba7797ad5f9394dd$var$prefix(value.name, value.prefixes, grid1);
                if (!values.includes(string)) values.push(string);
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                    _iterator2.return();
                }
            } finally{
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
    }
    if (props.length > 0) out += "\nProperties:\n".concat(props.sort().join(''));
    if (values.length > 0) out += "\nValues:\n".concat(values.sort().join(''));
    if (hadGrid) out += '\n* - Prefixes will be added only on grid: true option.\n';
    if (!atrules.length && !selectors.length && !props.length && !values.length) out += "\nAwesome! Your browsers don't require any vendor prefixes.\nNow you can remove Autoprefixer from build steps.";
    return out;
};


var $d35bff39a532d6a8$var$autoprefixerData = {
    browsers: $d35bff39a532d6a8$require$agents,
    prefixes: $3cefe5e4555b2e46$exports
};
var $d35bff39a532d6a8$var$WARNING = "\n  Replace Autoprefixer `browsers` option to Browserslist config.\n  Use `browserslist` key in `package.json` or `.browserslistrc` file.\n\n  Using `browsers` option can cause errors. Browserslist config can\n  be used for Babel, Autoprefixer, postcss-normalize and other tools.\n\n  If you really need to use option, rename it to `overrideBrowserslist`.\n\n  Learn more at:\n  https://github.com/browserslist/browserslist#readme\n  https://twitter.com/browserslist\n\n";
function $d35bff39a532d6a8$var$isPlainObject(obj) {
    return Object.prototype.toString.apply(obj) === '[object Object]';
}
var $d35bff39a532d6a8$var$cache = new Map();
function $d35bff39a532d6a8$var$timeCapsule(result, prefixes) {
    if (prefixes.browsers.selected.length === 0) return;
    if (prefixes.add.selectors.length > 0) return;
    if (Object.keys(prefixes.add).length > 2) return;
    /* c8 ignore next 11 */ result.warn("Autoprefixer target browsers do not need any prefixes.You do not need Autoprefixer anymore.\nCheck your Browserslist config to be sure that your targets are set up correctly.\n\n  Learn more at:\n  https://github.com/postcss/autoprefixer#readme\n  https://github.com/browserslist/browserslist#readme\n\n");
}
$d35bff39a532d6a8$exports = $d35bff39a532d6a8$var$plugin;
function $d35bff39a532d6a8$var$plugin() {
    for(var _len = arguments.length, reqs = new Array(_len), _key = 0; _key < _len; _key++){
        reqs[_key] = arguments[_key];
    }
    var options;
    if (reqs.length === 1 && $d35bff39a532d6a8$var$isPlainObject(reqs[0])) {
        options = reqs[0];
        reqs = undefined;
    } else if (reqs.length === 0 || reqs.length === 1 && !reqs[0]) reqs = undefined;
    else if (reqs.length <= 2 && (Array.isArray(reqs[0]) || !reqs[0])) {
        options = reqs[1];
        reqs = reqs[0];
    } else if ((0, $2bfPH._)(reqs[reqs.length - 1]) === 'object') options = reqs.pop();
    if (!options) options = {};
    if (options.browser) throw new Error('Change `browser` option to `overrideBrowserslist` in Autoprefixer');
    else if (options.browserslist) throw new Error('Change `browserslist` option to `overrideBrowserslist` in Autoprefixer');
    if (options.overrideBrowserslist) reqs = options.overrideBrowserslist;
    else if (options.browsers) {
        if (typeof console !== 'undefined' && console.warn) console.warn($eSZyB.red($d35bff39a532d6a8$var$WARNING.replace(/`[^`]+`/g, function(i) {
            return $eSZyB.yellow(i.slice(1, -1));
        })));
        reqs = options.browsers;
    }
    var brwlstOpts = {
        env: options.env,
        ignoreUnknownVersions: options.ignoreUnknownVersions,
        stats: options.stats
    };
    function loadPrefixes(opts) {
        var d = $d35bff39a532d6a8$var$autoprefixerData;
        var browsers = new $ea2b86d4fd154896$exports(d.browsers, reqs, opts, brwlstOpts);
        var key = browsers.selected.join(', ') + JSON.stringify(options);
        if (!$d35bff39a532d6a8$var$cache.has(key)) $d35bff39a532d6a8$var$cache.set(key, new $77d8edc20cc2c324$exports(d.prefixes, browsers, options));
        return $d35bff39a532d6a8$var$cache.get(key);
    }
    return {
        browsers: reqs,
        info: function(opts) {
            opts = opts || {};
            opts.from = opts.from || $40761280b577a31b$exports.cwd();
            return $ba7797ad5f9394dd$exports(loadPrefixes(opts));
        },
        options: options,
        postcssPlugin: 'autoprefixer',
        prepare: function(result) {
            var prefixes = loadPrefixes({
                env: options.env,
                from: result.opts.from
            });
            return {
                OnceExit: function(root) {
                    $d35bff39a532d6a8$var$timeCapsule(result, prefixes);
                    if (options.remove !== false) prefixes.processor.remove(root, result);
                    if (options.add !== false) prefixes.processor.add(root, result);
                }
            };
        }
    };
}
$d35bff39a532d6a8$var$plugin.postcss = true;
/**
 * Autoprefixer data
 */ $d35bff39a532d6a8$var$plugin.data = $d35bff39a532d6a8$var$autoprefixerData;
/**
 * Autoprefixer default browsers
 */ $d35bff39a532d6a8$var$plugin.defaults = $d9eea3283bc93203$exports.defaults;
/**
 * Inspect with default Autoprefixer
 */ $d35bff39a532d6a8$var$plugin.info = function() {
    return $d35bff39a532d6a8$var$plugin().info();
};


var $103cf55905497108$export$2ae08b153b2a1e07 = function(id, name) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var res, url, link, err, _err_response, errorData, _, e;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        7
                    ]);
                    return [
                        4,
                        (0, $00bae815612f32bf$export$2e2bcd8739ae039)({
                            method: 'GET',
                            url: "/api/v1/recordings/".concat(id),
                            responseType: 'blob' // important
                        })
                    ];
                case 1:
                    res = _state.sent();
                    //console.log(res);
                    url = (0, (/*@__PURE__*/$parcel$interopDefault($979b1f5a2e975a61$exports))).createObjectURL(new Blob([
                        res.data
                    ]));
                    link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', name); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    return [
                        3,
                        7
                    ];
                case 2:
                    err = _state.sent();
                    errorData = (_err_response = err.response) === null || _err_response === void 0 ? void 0 : _err_response.data;
                    if (!(errorData instanceof Blob)) return [
                        3,
                        6
                    ];
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        5,
                        ,
                        6
                    ]);
                    _ = JSON.parse;
                    return [
                        4,
                        errorData.text()
                    ];
                case 4:
                    errorData = _.apply(JSON, [
                        _state.sent()
                    ]);
                    return [
                        3,
                        6
                    ];
                case 5:
                    e = _state.sent();
                    errorData = null;
                    return [
                        3,
                        6
                    ];
                case 6:
                    (0, $d27a3e42620f11b8$export$de026b00723010c1)('error', (errorData === null || errorData === void 0 ? void 0 : errorData.message) || "Optagelsen kunne ikke hentes. Pr\xf8v igen.");
                    return [
                        3,
                        7
                    ];
                case 7:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $103cf55905497108$export$35f11b90ddcccfb3 = function(id, el) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var res, _el_closest, err;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0, $00bae815612f32bf$export$2e2bcd8739ae039)({
                            method: 'DELETE',
                            url: "/api/v1/recordings/".concat(id)
                        })
                    ];
                case 1:
                    res = _state.sent();
                    if (res.status === 204) {
                        ;
                        (0, $d27a3e42620f11b8$export$de026b00723010c1)('success', 'Optagelsen er slettet.');
                        (_el_closest = el.closest('.card--wrapper')) === null || _el_closest === void 0 ? void 0 : _el_closest.remove();
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    (0, $d27a3e42620f11b8$export$de026b00723010c1)('error', err.response.data.message);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $103cf55905497108$export$d2b84e7419355b93 = function(id, el) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var data, res, err;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    (0, $d27a3e42620f11b8$export$de026b00723010c1)('success', 'Optagelsen transkriberes ...');
                    data = {
                        transcribe: true
                    };
                    if (options) data.options = options;
                    return [
                        4,
                        (0, $00bae815612f32bf$export$2e2bcd8739ae039)({
                            method: 'PATCH',
                            url: "/api/v1/recordings/".concat(id),
                            data: data
                        })
                    ];
                case 1:
                    res = _state.sent();
                    if (res.data.status === 'success') {
                        (0, $d27a3e42620f11b8$export$de026b00723010c1)('success', 'Optagelsen er transskriberet.');
                        console.log('res.data', res.data);
                        el.querySelector('.card__footer-text').textContent = res.data.data.data.transcription.text;
                        el.querySelector('.card__footer-text').setAttribute('id', "transcription-text-".concat(id));
                        el.querySelector('.btn--download-transcription').classList.remove('hidden');
                    } else (0, $d27a3e42620f11b8$export$de026b00723010c1)('error', res.data.message);
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    (0, $d27a3e42620f11b8$export$de026b00723010c1)('error', err.response.data.message);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $103cf55905497108$export$6a420613022c2a5d = function(id, hubspotOwnerId) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var res, err;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0, $00bae815612f32bf$export$2e2bcd8739ae039)({
                            method: 'PATCH',
                            url: "/api/v1/users/".concat(id),
                            data: {
                                hubspotOwnerId: hubspotOwnerId
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    if (res.data.status === 'success') (0, $d27a3e42620f11b8$export$de026b00723010c1)('success', 'Brugeren blev synkroniseret med Hubspot.');
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    (0, $d27a3e42620f11b8$export$de026b00723010c1)('error', err.response.data.message);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $103cf55905497108$export$c56bd83b3342fb14 = function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var res, err;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0, $00bae815612f32bf$export$2e2bcd8739ae039)({
                            method: 'GET',
                            url: "/api/v1/users/dbandmyfone"
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    err = _state.sent();
                    (0, $d27a3e42620f11b8$export$de026b00723010c1)('error', err.response.data.message);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $103cf55905497108$export$3493b8991d49f558 = function(user) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var res, err;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0, $00bae815612f32bf$export$2e2bcd8739ae039)({
                            method: 'POST',
                            url: "/api/v1/users/",
                            data: (0, $9Jpjh._)((0, $lvTkn._)({}, user), {
                                myfoneSync: true
                            })
                        })
                    ];
                case 1:
                    res = _state.sent();
                    if (res.data.status === 'success') (0, $d27a3e42620f11b8$export$de026b00723010c1)('success', "".concat(user.name, " blev oprettet."));
                    if (res.data.status === 'error') {
                        console.log(res.data.errors);
                        (0, $d27a3e42620f11b8$export$de026b00723010c1)('error', res.data.errors);
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    (0, $d27a3e42620f11b8$export$de026b00723010c1)('error', err.response.data.message);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $103cf55905497108$export$e3ac7a5d19605772 = function(filter, id) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var res, err;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0, $00bae815612f32bf$export$2e2bcd8739ae039)({
                            method: 'PATCH',
                            url: "/api/v1/users/".concat(id),
                            data: filter
                        })
                    ];
                case 1:
                    res = _state.sent();
                    if (res.data.status === 'success') (0, $d27a3e42620f11b8$export$de026b00723010c1)('success', "".concat(filter.name, " blev opdateret."));
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    (0, $d27a3e42620f11b8$export$de026b00723010c1)('error', err.response.data.message);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $103cf55905497108$export$3f67de4b1a00bf9e = function(data) {
    var showSuccess = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var res, err;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    console.log('createSms sending...', data);
                    return [
                        4,
                        (0, $00bae815612f32bf$export$2e2bcd8739ae039)({
                            method: 'POST',
                            url: "/api/v1/smsMessage/",
                            data: data
                        })
                    ];
                case 1:
                    res = _state.sent();
                    console.log('createSms, created:', res.data);
                    if (res.data.status === 'succes') {
                        if (showSuccess) (0, $d27a3e42620f11b8$export$de026b00723010c1)('success', "SMS'en blev oprettet.");
                        return [
                            2,
                            res.data.data.data
                        ];
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    (0, $d27a3e42620f11b8$export$de026b00723010c1)('error', err.response.data.message);
                    return [
                        2,
                        {
                            data: null
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $103cf55905497108$export$112478a1ac27ad98 = function(data, id) {
    var showSuccess = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var res, err;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    console.log('updateSms saving...', data, id);
                    return [
                        4,
                        (0, $00bae815612f32bf$export$2e2bcd8739ae039)({
                            method: 'PATCH',
                            url: "/api/v1/smsMessage/".concat(id),
                            data: data
                        })
                    ];
                case 1:
                    res = _state.sent();
                    console.log('updateSms, saved:', res.data);
                    if (res.data.status === 'success') {
                        if (showSuccess) (0, $d27a3e42620f11b8$export$de026b00723010c1)('success', "SMS'en blev gemt.");
                        return [
                            2,
                            true
                        ];
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    (0, $d27a3e42620f11b8$export$de026b00723010c1)('error', err.response.data.message);
                    return [
                        2,
                        false
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};



var $1Mz1E = parcelRequire("1Mz1E");

var $iLZuz = parcelRequire("iLZuz");



var $f07f35e2bd84b233$export$f558026a994b6051 = function(data, type) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var url, res, _res_data_data, err;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    switch(type){
                        case "brugerdata":
                            url = "/api/v1/users/updateMe";
                            break;
                        case "password":
                            url = "/api/v1/users/updateMyPassword";
                            break;
                        case "firmadata":
                            url = "/api/v1/companies/updateMyCompany";
                            break;
                        default:
                            break;
                    }
                    return [
                        4,
                        (0, $00bae815612f32bf$export$2e2bcd8739ae039)({
                            method: "PATCH",
                            url: url,
                            data: data
                        })
                    ];
                case 1:
                    res = _state.sent();
                    if (res.data.status === "success") {
                        ;
                        if ((_res_data_data = res.data.data) === null || _res_data_data === void 0 ? void 0 : _res_data_data.requiresMicrosoft) {
                            location.assign('/login');
                            return [
                                2
                            ];
                        }
                        (0, $d27a3e42620f11b8$export$de026b00723010c1)("success", "Opdaterede ".concat(type.toUpperCase()));
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    (0, $d27a3e42620f11b8$export$de026b00723010c1)("error", err.response.data.message);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $f07f35e2bd84b233$export$7ee41a6c2a96e8aa = function(path, data, id) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var url, res, updated, err, _err_response_data, _err_response;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    if (data.sms) data.smsApiToken = prompt("Copy-paste API-token til sms gatewayen her. Kontakt Teleplan hvis du ikk har f\xe5et en API-token til sms gatewayen");
                    url = "/api/v1/".concat(path, "/").concat(id);
                    return [
                        4,
                        (0, $00bae815612f32bf$export$2e2bcd8739ae039)({
                            method: "PATCH",
                            url: url,
                            data: data
                        })
                    ];
                case 1:
                    res = _state.sent();
                    if (res.data.status === "success") {
                        updated = path == "users" ? "bruger." : "firma.";
                        (0, $d27a3e42620f11b8$export$de026b00723010c1)("success", "Opdaterede ".concat(updated));
                        return [
                            2,
                            true
                        ];
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    (0, $d27a3e42620f11b8$export$de026b00723010c1)("error", ((_err_response = err.response) === null || _err_response === void 0 ? void 0 : (_err_response_data = _err_response.data) === null || _err_response_data === void 0 ? void 0 : _err_response_data.message) || 'Indstillingen kunne ikke gemmes.');
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2,
                        false
                    ];
            }
        });
    })();
};
var $f07f35e2bd84b233$export$dc726c8e334dd814 = function(data, token) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var url, res, err;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    url = "/api/v1/users/resetPassword/".concat(token);
                    return [
                        4,
                        (0, $00bae815612f32bf$export$2e2bcd8739ae039)({
                            method: "PATCH",
                            url: url,
                            data: data
                        })
                    ];
                case 1:
                    res = _state.sent();
                    if (res.data.status === "success") (0, $d27a3e42620f11b8$export$de026b00723010c1)("success", "Password opdateret");
                    (0, (/*@__PURE__*/$parcel$interopDefault($7874bf713c9acb54$exports)))(function() {
                        var _res_data_data;
                        location.assign(((_res_data_data = res.data.data) === null || _res_data_data === void 0 ? void 0 : _res_data_data.requiresMicrosoft) ? '/login' : '/');
                    }, 2000);
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    (0, $d27a3e42620f11b8$export$de026b00723010c1)("error", err.response.data.message);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $f07f35e2bd84b233$export$9cccb11c9f863cbb = function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var res, err, _err_response_data, _err_response;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0, $00bae815612f32bf$export$2e2bcd8739ae039)({
                            method: "PATCH",
                            url: "/api/v1/users/auth/microsoft/enforce"
                        })
                    ];
                case 1:
                    res = _state.sent();
                    if (res.data.status === "success") {
                        (0, $d27a3e42620f11b8$export$de026b00723010c1)("success", "SSO indstillinger opdateret");
                        (0, (/*@__PURE__*/$parcel$interopDefault($7874bf713c9acb54$exports)))(function() {
                            location.reload();
                        }, 1000);
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    (0, $d27a3e42620f11b8$export$de026b00723010c1)("error", ((_err_response = err.response) === null || _err_response === void 0 ? void 0 : (_err_response_data = _err_response.data) === null || _err_response_data === void 0 ? void 0 : _err_response_data.message) || "Kunne ikke \xe6ndre SSO");
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $f07f35e2bd84b233$export$d65c7973c6998f41 = function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var res, err, _err_response_data, _err_response;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0, $00bae815612f32bf$export$2e2bcd8739ae039)({
                            method: "DELETE",
                            url: "/api/v1/users/auth/microsoft/disconnect"
                        })
                    ];
                case 1:
                    res = _state.sent();
                    if (res.data.status === "success") {
                        (0, $d27a3e42620f11b8$export$de026b00723010c1)("success", "SSO er fjernet");
                        (0, (/*@__PURE__*/$parcel$interopDefault($7874bf713c9acb54$exports)))(function() {
                            location.assign('/login');
                        }, 1000);
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    (0, $d27a3e42620f11b8$export$de026b00723010c1)("error", ((_err_response = err.response) === null || _err_response === void 0 ? void 0 : (_err_response_data = _err_response.data) === null || _err_response_data === void 0 ? void 0 : _err_response_data.message) || "Kunne ikke fjerne SSO");
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};


parcelRequire("iwMEh");
var $f0b7eaf727814c3f$export$c326e7c3504a7e73 = function(recording) {
    var div = document.createElement('DIV');
    var localNumber;
    if (recording.user && recording.user.name) localNumber = '<div class="card__data name" title="Navn"><span class="user__photo-and-name"><img class="user__photo" src="/img/users/'.concat(recording.user.photo ? recording.user.photo : 'default.jpg', '" alt="foto"><div class="user__name">').concat(recording.user.name, '</div></span></div><div class="card__data localNumber" title="Lokalnummer" data-sort="localNumber"><span>').concat(recording.localNumber, "</span></div>");
    else localNumber = "<div class='card__data local-number'>                 <svg class='card__icon'>                   <use xlink:href='/img/icons.svg#icon-user'></use>                 </svg>                 <span>".concat(recording.localNumber, "</span>               </div>");
    div.innerHTML = "<div class='card--wrapper'>           <div class='card'>             <div class='card__details'>               <div class='card__data date'  data-date='".concat(recording.date, "'>                 <svg class='card__icon'>                   <use xlink:href='/img/icons.svg#icon-calendar'></use>                 </svg>                 <span>").concat(recording.date, "</span>               </div>               <div                 class='card__data duration'                 title='Optagelsens l\xe6ngde i timer:minutter:sekunder'                 data-duration='").concat(recording.duration, "'               >                 <svg class='card__icon'>                   <use xlink:href='/img/icons.svg#icon-watch'></use>                 </svg>                 <span>").concat(recording.duration ? recording.duration : '-', "</span>               </div>               <div class='card__data external-phone-number'>                 <svg class='card__icon'>                   <use xlink:href='/img/icons.svg#icon-phone-").concat(recording.direction, "'></use>                 </svg>                 <span>").concat(recording.phoneNumberExternal, "</span>               </div>               ").concat(localNumber, "               <div class='card__data buttons'>                 <a                   class='btn btn--red btn--small tiny btn--delete'                   href='#delete'                   data-id='").concat(recording.id, "'                   title='Slet optagelsen permanent!'                 >                   <svg class='card__icon'>                     <use xlink:href='/img/icons.svg#icon-x-circle'></use>                   </svg>                 </a>                 <a                   class='btn btn--green btn--small tiny btn--download'                   href='#download'                   data-name='").concat(recording.name, "'                   data-id='").concat(recording.id, "'                   title='Download optagelsen'                 >                   <svg class='card__icon'>                     <use xlink:href='/img/icons.svg#icon-download'></use>                   </svg>                 </a>                 <a                   class='btn btn--green btn--small tiny btn--info'                   href='#details'                   title='Flere detaljer om opkaldet'                 >                   <svg class='card__icon'>                     <use xlink:href='/img/icons.svg#icon-info'></use>                   </svg>                 </a>               </div>             </div>             <div class='card__footer--wrapper' style='height: 0px;'>               <div class='card__footer'>                 <p class='card__note'>                   <span class='card__footer-value'>Note</span>{' '}                   <span class='card__footer-text'>                     recording.note{' '}                     <span class='card__note__edit'>                       <svg class='card__icon'>                         <use xlink:href='/img/icons.svg#icon-edit'></use>                       </svg>                     </span>                   </span>                 </p>                 <p class='card__log'>                   <span class='card__footer-value'></span>{' '}                   <span class='card__footer-text'>                     ... her kommer log over tilgange til filen                     <span class='card__log__expand'>                       <svg class='card__icon'>                         <use xlink:href='/img/icons.svg#icon-chevron-down'></use>                       </svg>                     </span>                   </span>                 </p>               </div>             </div>           </div>         </div>       \"");
    return div.firstChild;
};
var $f0b7eaf727814c3f$export$b55ff6af9a14d779 = function(users) {
    var div = document.createElement('DIV');
    div.innerHTML = "";
};


var $d27a3e42620f11b8$export$d810fd4f41d42216 = new Event('submit', {
    cancelable: true // see https://stackoverflow.com/questions/49587933/firefox-doesnt-preventing-dispatched-submit-event
});
var $d27a3e42620f11b8$export$516836c6a9dfc573 = function() {
    var el = document.querySelector('.alert');
    if (el) el.parentElement.removeChild(el);
};
var $d27a3e42620f11b8$export$89e12c5b50f7529d = function(url) {
    var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    (0, (/*@__PURE__*/$parcel$interopDefault($7874bf713c9acb54$exports)))(function() {
        window.location.assign(url);
    }, delay);
};
var $d27a3e42620f11b8$var$saveDocumentToFile = function(doc, name) {
    (0, $94db4f2abf87558b$export$b9ec4b114aa40074).toBlob(doc).then(function(blob) {
        (0, $027784accdf3eedc$exports.saveAs)(blob, "".concat(name, ".docx"));
    });
};
var $d27a3e42620f11b8$var$downloadDocx = function(id, name) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var text, textArray, paragraphs, doc;
        return (0, $iLZuz._)(this, function(_state) {
            text = document.getElementById(id).innerHTML;
            // find all newlines, and split the text into an array
            // then create a new paragraph for each line
            textArray = text.split(/\r?\n/);
            paragraphs = [];
            (0, (/*@__PURE__*/$parcel$interopDefault($eb0af92fb0d106cc$exports)))(textArray).call(textArray, function(line) {
                paragraphs.push(new (0, $94db4f2abf87558b$export$358a232cca1ab2ac)({
                    children: [
                        new (0, $94db4f2abf87558b$export$84d920a4f7ee9ae2)(line)
                    ]
                }));
            });
            doc = new (0, $94db4f2abf87558b$export$b34a105447964f9f)({
                sections: [
                    {
                        properties: {},
                        children: paragraphs
                    }
                ]
            });
            // doc.createParagraph(document.getElementById(id).innerHTML);
            $d27a3e42620f11b8$var$saveDocumentToFile(doc, name);
            return [
                2
            ];
        });
    })();
};
var $d27a3e42620f11b8$export$de026b00723010c1 = function(type, msg) {
    $d27a3e42620f11b8$export$516836c6a9dfc573();
    var markup = '<div class="alert alert--'.concat(type, '">').concat(msg, "</div>");
    document.querySelector('body').insertAdjacentHTML('afterbegin', markup);
    (0, (/*@__PURE__*/$parcel$interopDefault($7874bf713c9acb54$exports)))($d27a3e42620f11b8$export$516836c6a9dfc573, 5000);
};
var $d27a3e42620f11b8$export$e03c1c3201ee8bb7 = function(element) {
    var hidden = element.classList.contains('hidden');
    if (hidden) element.classList.remove('hidden');
    else element.classList.add('hidden');
};
var $d27a3e42620f11b8$export$e9466f5bf01e21a7 = function(el) {
    el;
};
var $d27a3e42620f11b8$export$41a2bf03e866e697 = function(wrapper, content) {
    var open = wrapper.classList.contains('open');
    if (open) {
        wrapper.style.height = '0px';
        wrapper.classList.remove('open');
    } else {
        var height = content.getBoundingClientRect().height;
        wrapper.style.height = "".concat(height, "px");
        wrapper.classList.add('open');
    }
};
// https://stackoverflow.com/questions/494143/creating-a-new-dom-element-from-an-html-string-using-built-in-dom-methods-or-pro/35385518#35385518
function $d27a3e42620f11b8$var$htmlToElement(html) {
    var template = document.createElement('template');
    html = (0, (/*@__PURE__*/$parcel$interopDefault($20e5c9c200d6533f$exports)))(html).call(html); // Never return a text node of whitespace as the result
    template.innerHTML = html;
    return template.content.firstChild;
}
var $d27a3e42620f11b8$var$timeConverter = function(duration) {
    if (duration) {
        var hours = Math.floor(duration / 3600);
        var minutes = Math.floor((duration - hours * 3600) / 60);
        var seconds = duration - hours * 3600 - minutes * 60;
        if (hours < 10) hours = "0".concat(hours);
        else hours = "".concat(hours);
        if (minutes < 10) minutes = "0".concat(minutes);
        if (seconds < 10) seconds = "0".concat(seconds);
        return "".concat(hours, ":").concat(minutes, ":").concat(seconds);
    }
    return '';
};
var $d27a3e42620f11b8$export$b8c8eb070a2f16c1 = function(card) {
    // hide footer
    var footer = card.querySelector('.card__footer--wrapper');
    if (footer) footer.style.height = '0px';
    if (!card.classList.contains('noAppMatch')) {
        var dateCard = card.querySelector('.card__data.date');
        var durationCard = card.querySelector('.card__data.duration');
        var deleteBtn = card.querySelector('a.btn--delete');
        var downloadBtn = card.querySelector('a.btn--download');
        var infoBtn = card.querySelector('a.btn--info');
        var transcribeBtn = card.querySelector('a.btn--transcribe');
        var transcribeWithOptionsBtn = card.querySelector('a.btn--transcribe-with-options');
        var downloadTranscriptionBtn = card.querySelector('a.btn--download-transcription');
        // set date to local timezone and format to dd-mm-yyyy hh:mm:ss
        if (dateCard) {
            var date = new Date(dateCard.dataset.date);
            dateCard.innerHTML = date.toLocaleString('da-DK', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });
        }
        // change duration to hours:minutes:seconds
        if (durationCard) durationCard.querySelector('span').innerHTML = $d27a3e42620f11b8$var$timeConverter(durationCard.dataset.duration);
        // attach click eventlistener
        if (infoBtn) infoBtn.addEventListener('click', function() {
            $d27a3e42620f11b8$export$41a2bf03e866e697(card.querySelector('.card__footer--wrapper'), card.querySelector('.card__footer'));
        });
        if (downloadBtn) downloadBtn.addEventListener('click', function() {
            (0, $103cf55905497108$export$2ae08b153b2a1e07)(downloadBtn.dataset.id, downloadBtn.dataset.name);
        });
        if (deleteBtn) deleteBtn.addEventListener('click', function() {
            if (confirm("Er du sikker p\xe5 at du vil slette optagelsen ".concat(deleteBtn.dataset.id))) (0, $103cf55905497108$export$35f11b90ddcccfb3)(deleteBtn.dataset.id, card);
        });
        if (transcribeBtn) transcribeBtn.addEventListener('click', function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                return (0, $iLZuz._)(this, function(_state) {
                    (0, $103cf55905497108$export$d2b84e7419355b93)(transcribeBtn.dataset.id, card);
                    return [
                        2
                    ];
                });
            })();
        });
        if (transcribeWithOptionsBtn) transcribeWithOptionsBtn.addEventListener('click', function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                var language;
                return (0, $iLZuz._)(this, function(_state) {
                    language = document.getElementById("transcribe-language-".concat(transcribeWithOptionsBtn.dataset.id)).value;
                    (0, $103cf55905497108$export$d2b84e7419355b93)(transcribeWithOptionsBtn.dataset.id, card, {
                        language: language
                    });
                    return [
                        2
                    ];
                });
            })();
        });
        if (downloadTranscriptionBtn) downloadTranscriptionBtn.addEventListener('click', function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                return (0, $iLZuz._)(this, function(_state) {
                    $d27a3e42620f11b8$var$downloadDocx("transcription-text-".concat(downloadTranscriptionBtn.dataset.id), downloadTranscriptionBtn.dataset.name);
                    return [
                        2
                    ];
                });
            })();
        });
        // add clickevents for checkboxes
        var usersOrCompanies = document.querySelector('.card-container.users') ? 'users' : document.querySelector('.card-container.companies') ? 'companies' : false;
        if (usersOrCompanies && !card.closest('.sync-preview')) {
            var _context;
            var checkBoxes = card.querySelectorAll('.checkbox input');
            (0, (/*@__PURE__*/$parcel$interopDefault($eb0af92fb0d106cc$exports)))(_context = (0, (/*@__PURE__*/$parcel$interopDefault($09d1114e8c0ab763$exports)))(checkBoxes)).call(_context, function(checkBox) {
                checkBox.addEventListener('click', function(e) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                        var data, value, saved;
                        return (0, $iLZuz._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    data = {};
                                    value = checkBox.checked;
                                    if (checkBox.value == 'role') value = value ? 'admin' : 'user';
                                    data[checkBox.value] = value;
                                    checkBox.disabled = true;
                                    return [
                                        4,
                                        (0, $f07f35e2bd84b233$export$7ee41a6c2a96e8aa)(usersOrCompanies, data, checkBox.dataset.id)
                                    ];
                                case 1:
                                    saved = _state.sent();
                                    if (!saved) checkBox.checked = !checkBox.checked;
                                    checkBox.disabled = false;
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                });
            });
            // if there's a select element for transcribe-recordings, add eventlistener for when a new value is selected, and save the new value to the database
            var transcribeRecordings = card.querySelector('.transcribe-recordings');
            if (transcribeRecordings) transcribeRecordings.addEventListener('change', function(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                    var data;
                    return (0, $iLZuz._)(this, function(_state) {
                        data = {};
                        data.transcribeRecordings = transcribeRecordings.value;
                        (0, $103cf55905497108$export$e3ac7a5d19605772)(data, transcribeRecordings.dataset.id);
                        return [
                            2
                        ];
                    });
                })();
            });
        }
    }
    // if we are on user administration page, check if are syncing from myfone
    var classList = [
        'fullMatch',
        'partialMatch',
        'emailMatch',
        'noAppMatch',
        'noMyfoneMatch',
        'noMatch',
        'noMyfoneHubspotMatch'
    ];
    (0, (/*@__PURE__*/$parcel$interopDefault($da0d08deac01b774$exports)))(classList).call(classList, function(className) {
        //console.log("hello classlist", className);
        if (card.classList.contains(className)) //console.log("hello if", className);
        $d27a3e42620f11b8$var$syncready(card, className);
    });
};
var $d27a3e42620f11b8$export$4b1c754fc92202eb = function(fn) {
    // see if DOM is already available
    if (document.readyState === 'complete' || document.readyState === 'interactive') // call on next available tick
    (0, (/*@__PURE__*/$parcel$interopDefault($7874bf713c9acb54$exports)))(fn, 1);
    else document.addEventListener('DOMContentLoaded', fn);
};
// delay is used by keyup event below so we don't search before finished typing
function $d27a3e42620f11b8$var$delay(fn, ms) {
    var timer = 0;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _$_bindInstanceProperty;
        clearTimeout(timer);
        timer = (0, (/*@__PURE__*/$parcel$interopDefault($7874bf713c9acb54$exports)))((_$_bindInstanceProperty = (0, (/*@__PURE__*/$parcel$interopDefault($8760b36c3cf09caa$exports)))(fn)).call.apply(_$_bindInstanceProperty, [
            fn,
            this
        ].concat((0, $6zk1M._)(args))), ms || 0);
    };
}
var $d27a3e42620f11b8$export$20cc75d7679d6e0e = undefined;
var $d27a3e42620f11b8$export$4527fa85896780ab = function(element, phoneNumber, localNumber, searchForm) {
    $d27a3e42620f11b8$export$20cc75d7679d6e0e = new (0, (/*@__PURE__*/$parcel$interopDefault($49596b6f343a09f1$exports)))({
        element: element,
        lang: 'da-DK',
        singleMode: false,
        showWeekNumbers: true,
        firstDay: 1,
        resetButton: function() {
            var btn = document.createElement('button');
            btn.innerText = 'Clear';
            btn.addEventListener('click', function(evt) {
                evt.preventDefault();
                // set page to 1
                document.getElementById('page').value = 1;
                //search
                searchForm.dispatchEvent($d27a3e42620f11b8$export$d810fd4f41d42216);
                $d27a3e42620f11b8$export$20cc75d7679d6e0e.hide();
            });
            return btn;
        }
    }).on('selected', function() {
        // set page to 1
        document.getElementById('page').value = 1;
        //search
        searchForm.dispatchEvent($d27a3e42620f11b8$export$d810fd4f41d42216);
    });
    phoneNumber.addEventListener('keyup', $d27a3e42620f11b8$var$delay(function(e) {
        // set page to 1
        document.getElementById('page').value = 1;
        // search
        searchForm.dispatchEvent($d27a3e42620f11b8$export$d810fd4f41d42216);
    }, 1500));
    localNumber.addEventListener('keyup', $d27a3e42620f11b8$var$delay(function(e) {
        if (e.target.value.length >= 3 || e.target.value.length === 0) {
            // set page to 1
            document.getElementById('page').value = 1;
            // search
            searchForm.dispatchEvent($d27a3e42620f11b8$export$d810fd4f41d42216);
        }
    }, 1500));
};
var $d27a3e42620f11b8$export$d76128d007d19019 = function(phoneNumber, localNumber, startDate, endDate) {
    var page = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1;
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var _context2, params, startDateTime, endDateTime, sortElements, sortArray, url, userId, res, err;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    console.log(startDate, endDate);
                    params = {};
                    if (startDate) {
                        startDateTime = new Date(startDate.dateInstance);
                        endDateTime = new Date(endDate.dateInstance);
                        // Adjusting endDateTime to include the whole day
                        endDateTime.setHours(endDateTime.getHours() + 24);
                        params['date[gte]'] = startDateTime;
                        params['date[lte]'] = endDateTime;
                    }
                    if (phoneNumber) params['phoneNumber[regex]'] = phoneNumber;
                    if (localNumber) params.localNumber = localNumber;
                    // get sort params
                    sortElements = document.querySelectorAll('.header--sort .active');
                    //console.log(sortElements);
                    sortArray = (0, (/*@__PURE__*/$parcel$interopDefault($3a47f8c3e8d7e9c8$exports)))(_context2 = (0, (/*@__PURE__*/$parcel$interopDefault($09d1114e8c0ab763$exports)))(sortElements)).call(_context2, function(el) {
                        return (0, (/*@__PURE__*/$parcel$interopDefault($3253481c11effcc0$exports)))(el.dataset);
                    });
                    //console.log(sortArray);
                    params.sort = sortArray.toString();
                    url = '/api/v1/recordings';
                    if (document.getElementById('own-recordings')) {
                        userId = document.getElementById('own-recordings').value;
                        url = "/api/v1/users/".concat(userId, "/recordings");
                    }
                    // paging
                    if (page > 1) params.page = page;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, $00bae815612f32bf$export$2e2bcd8739ae039).get(url, {
                            params: params
                        })
                    ];
                case 2:
                    res = _state.sent();
                    console.log(res);
                    if (res.data.status === 'success') return [
                        2,
                        res.data
                    ];
                    return [
                        3,
                        4
                    ];
                case 3:
                    err = _state.sent();
                    $d27a3e42620f11b8$export$de026b00723010c1('error', err.response.data.message);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $d27a3e42620f11b8$export$827a6c17a85f6d1a = function(template, docs) {
    var recordings = document.querySelector('.card-container.recordings');
    var page = document.getElementById('page').value;
    document.getElementById('recordings-footer').innerHTML = '';
    if (docs.results > 0) {
        var _context3;
        if (page == 1) recordings.innerHTML = '';
        (0, (/*@__PURE__*/$parcel$interopDefault($eb0af92fb0d106cc$exports)))(_context3 = docs.data.data).call(_context3, function(element) {
            recordings.appendChild((0, $f0b7eaf727814c3f$export$c326e7c3504a7e73)(element));
            $d27a3e42620f11b8$export$41a2bf03e866e697(recordings.lastChild, recordings.lastChild.querySelector('.card'));
            $d27a3e42620f11b8$export$b8c8eb070a2f16c1(recordings.lastChild);
        });
    } else {
        if (page > 1) document.getElementById('page').value--; // we are still at same page, nothing more/new was found
        if (page == 1) recordings.innerHTML = "<p>Vi fandt ingen optagelser med de givne s\xf8gekriterier.</p>";
        else {
            // add message about no more results to footer
            var message = "<p>S\xe5 kunne vi ikke finde flere optagelser :)</p>";
            document.getElementById('recordings-footer').innerHTML = message;
        }
    }
    console.log('view updated');
};
var $d27a3e42620f11b8$export$49ef59c1a7c9ec28 = function(state) {
    var spinner = document.querySelector('.spinner');
    if (state == 'on' && !spinner.classList.contains('active')) spinner.classList.add('active');
    if (state == 'off') spinner.classList.remove('active');
};
var $d27a3e42620f11b8$export$fb1a2c61837ac070 = function(element, searchForm) {
    var intersectionObserver = new IntersectionObserver(function(entries) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var index, entry;
            return (0, $iLZuz._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = 0;
                        _state.label = 1;
                    case 1:
                        if (!(index < entries.length)) return [
                            3,
                            5
                        ];
                        entry = entries[index];
                        if (!(entry.isIntersecting && !entry.target.classList.contains('visible'))) return [
                            3,
                            3
                        ];
                        // count page one up
                        //console.log("loading more..");
                        document.getElementById('page').value++;
                        // add class visible
                        entry.target.classList.add('visible');
                        // search - the submit eventhandler detects through page > 1 that it should load the next 100 conversations
                        return [
                            4,
                            searchForm.dispatchEvent($d27a3e42620f11b8$export$d810fd4f41d42216)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        entry.target.classList.remove('visible');
                        _state.label = 4;
                    case 4:
                        index++;
                        return [
                            3,
                            1
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })();
    });
    // start observing
    intersectionObserver.observe(element);
};
var $d27a3e42620f11b8$export$9918b9617a5ef559 = function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var _context4, html, users, container;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $103cf55905497108$export$c56bd83b3342fb14)()
                    ];
                case 1:
                    html = _state.sent();
                    if (!html) return [
                        2
                    ];
                    users = $d27a3e42620f11b8$var$htmlToElement(html);
                    container = document.querySelector('.card-container.users');
                    container.replaceWith(users);
                    (0, (/*@__PURE__*/$parcel$interopDefault($eb0af92fb0d106cc$exports)))(_context4 = users.querySelectorAll('.card')).call(_context4, function(card) {
                        $d27a3e42620f11b8$export$b8c8eb070a2f16c1(card);
                    });
                    return [
                        2
                    ];
            }
        });
    })();
};
var $d27a3e42620f11b8$export$ce7c2a3613458a89 = function(id, sender) {
    var parent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var sms, isNew, createdSms, errorReplyTextElement, errorReplySms, errorReplyId, createdErrorReply, answers, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, answer, i, newSms, createdReply, replyId, err, message;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    sms = {
                        text: document.getElementById("smstext-".concat(id)).value,
                        sender: sender
                    };
                    // check if this is the top most parent sms (parent = null)
                    if (parent == 0 || parent == null) // set name
                    sms.name = document.getElementById("name-".concat(id)).value;
                    // if id is a valid timestamp, it's a new sms, if not we have the sms (object)id
                    isNew = false;
                    if (!(id == 'newSms')) return [
                        3,
                        2
                    ];
                    isNew = true;
                    return [
                        4,
                        (0, $103cf55905497108$export$3f67de4b1a00bf9e)(sms)
                    ];
                case 1:
                    createdSms = _state.sent();
                    console.log(createdSms);
                    id = createdSms.id;
                    _state.label = 2;
                case 2:
                    // check for minDuration
                    if (document.getElementById("minduration-".concat(id))) sms.minDuration = document.getElementById("minduration-".concat(id)).value;
                    // check for lostCallSms
                    if (document.querySelector("[id^='lostcallsms-']")) sms.lostCallSms = {
                        active: document.querySelector("[id^='lostcallsms-']").checked
                    };
                    // check for ivRChoice
                    if (document.querySelector("[id^='ivrchoice-']")) {
                        sms.ivrChoice = {
                            active: document.querySelector("[id^='ivrchoice-']").checked
                        };
                        if (sms.ivrChoice.active) {
                            sms.ivrChoice.digit = document.getElementById("digit-".concat(id)).value;
                            sms.ivrChoice.sendSmsIfDigit = document.getElementById("sendsmsifdigit-".concat(id)).checked;
                        }
                    }
                    if (!document.getElementById("twowaysms-".concat(id))) return [
                        3,
                        16
                    ];
                    sms.twoWaySms = {
                        active: document.getElementById("twowaysms-".concat(id)).checked,
                        answers: [],
                        replies: []
                    };
                    if (!document.getElementById("add-errorreply-".concat(id))) return [
                        3,
                        6
                    ];
                    sms.twoWaySms.errorReply = {
                        active: document.getElementById("add-errorreply-".concat(id)).checked
                    };
                    if (!sms.twoWaySms.errorReply.active) return [
                        3,
                        6
                    ];
                    errorReplyTextElement = document.getElementById("errorreplytext-".concat(id));
                    errorReplySms = {
                        text: errorReplyTextElement.value,
                        sender: sender,
                        parent: {
                            message: id,
                            replyToParent: true
                        }
                    };
                    if (!errorReplyTextElement.dataset.errorreplyid) return [
                        3,
                        3
                    ];
                    (0, $103cf55905497108$export$112478a1ac27ad98)(errorReplySms, errorReplyTextElement.dataset.errorreplyid);
                    errorReplyId = errorReplyTextElement.dataset.errorreplyid;
                    return [
                        3,
                        5
                    ];
                case 3:
                    return [
                        4,
                        (0, $103cf55905497108$export$3f67de4b1a00bf9e)(errorReplySms)
                    ];
                case 4:
                    createdErrorReply = _state.sent();
                    errorReplyId = createdErrorReply.data.id;
                    _state.label = 5;
                case 5:
                    sms.twoWaySms.errorReply.message = errorReplyId;
                    _state.label = 6;
                case 6:
                    answers = (0, (/*@__PURE__*/$parcel$interopDefault($09d1114e8c0ab763$exports)))(document.querySelectorAll('[id^="answer-'.concat(id, '-"]')));
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 7;
                case 7:
                    _state.trys.push([
                        7,
                        14,
                        15,
                        16
                    ]);
                    _iterator = answers[Symbol.iterator]();
                    _state.label = 8;
                case 8:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        13
                    ];
                    answer = _step.value;
                    i = answer.id.split('-')[2];
                    console.log('i:', i);
                    sms.twoWaySms.answers[i] = answer.value;
                    if (!document.getElementById("reply-".concat(id, "-").concat(i))) return [
                        3,
                        12
                    ];
                    sms.twoWaySms.replies[i] = {
                        active: document.getElementById("reply-".concat(id, "-").concat(i)).checked
                    };
                    if (!sms.twoWaySms.replies[i].active) return [
                        3,
                        12
                    ];
                    if (!document.getElementById("newreply-".concat(id, "-").concat(i))) return [
                        3,
                        10
                    ];
                    newSms = {
                        text: document.getElementById("newreply-".concat(id, "-").concat(i)).value,
                        sender: sender,
                        parent: {
                            message: id
                        }
                    };
                    return [
                        4,
                        (0, $103cf55905497108$export$3f67de4b1a00bf9e)(newSms)
                    ];
                case 9:
                    createdReply = _state.sent();
                    sms.twoWaySms.replies[i].message = createdReply.data.id;
                    return [
                        3,
                        12
                    ];
                case 10:
                    replyId = document.getElementById("reply-".concat(id, "-").concat(i)).closest('.form__group').nextElementSibling.firstChild.id.split('-')[2];
                    return [
                        4,
                        $d27a3e42620f11b8$export$ce7c2a3613458a89(replyId, sender, id)
                    ];
                case 11:
                    _state.sent();
                    sms.twoWaySms.replies[i].message = replyId;
                    _state.label = 12;
                case 12:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        8
                    ];
                case 13:
                    return [
                        3,
                        16
                    ];
                case 14:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 15:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        4,
                        (0, $103cf55905497108$export$112478a1ac27ad98)(sms, id)
                    ];
                case 17:
                    _state.sent();
                    if (parent == 0 || parent == null) {
                        message = 'SMS opdateret';
                        if (isNew) {
                            message = 'SMS oprettet';
                            $d27a3e42620f11b8$export$de026b00723010c1('success', message);
                            $d27a3e42620f11b8$export$89e12c5b50f7529d("/sms/".concat(id), 3000);
                        }
                        $d27a3e42620f11b8$export$de026b00723010c1('success', message);
                    }
                    return [
                        2
                    ];
            }
        });
    })();
};
var $d27a3e42620f11b8$export$527010a204c46227 = function(selectElement) {
    var selectedOption = selectElement.options[selectElement.selectedIndex];
    var selectedValue = selectedOption.value;
    return selectedValue;
};
var $d27a3e42620f11b8$var$syncready = function(card, className) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var button, syncUserBtn;
        return (0, $iLZuz._)(this, function(_state) {
            button = card.querySelector('.btn--myfone-action');
            if (button && !button.dataset.bound) {
                button.dataset.bound = 'true';
                button.addEventListener('click', function(event) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                        var _card_querySelector, action, _context5, settings, response, plan, deleting, text, error, _error_response_data, _error_response;
                        return (0, $iLZuz._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    event.preventDefault();
                                    if (button.disabled) return [
                                        2
                                    ];
                                    action = button.dataset.action || ((_card_querySelector = card.querySelector('.myfone-action')) === null || _card_querySelector === void 0 ? void 0 : _card_querySelector.value);
                                    if (!action) return [
                                        2,
                                        $d27a3e42620f11b8$export$de026b00723010c1('error', "V\xe6lg f\xf8rst hvad der skal ske med brugeren.")
                                    ];
                                    button.disabled = true;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        5,
                                        6,
                                        7
                                    ]);
                                    settings = {};
                                    (0, (/*@__PURE__*/$parcel$interopDefault($eb0af92fb0d106cc$exports)))(_context5 = card.querySelectorAll('.checkbox input')).call(_context5, function(input) {
                                        settings[input.value] = input.value === 'role' ? input.checked ? 'admin' : 'user' : input.checked;
                                    });
                                    return [
                                        4,
                                        (0, $00bae815612f32bf$export$2e2bcd8739ae039).post('/api/v1/users/myfone-sync/preview', (0, $9Jpjh._)((0, $lvTkn._)({}, JSON.parse(button.dataset.sync)), {
                                            action: action,
                                            settings: settings
                                        }))
                                    ];
                                case 2:
                                    response = _state.sent();
                                    plan = response.data.data;
                                    deleting = (0, (/*@__PURE__*/$parcel$interopDefault($b5cefcb8c642b94d$exports)))(action).call(action, '-delete');
                                    text = "".concat(plan.oldName || plan.newName, ": ").concat(plan.oldEmail || plan.newEmail, "\n");
                                    if (plan.oldName && plan.newName) text += "Myfone: ".concat(plan.newName, ", ").concat(plan.newEmail, "\n");
                                    if (action === 'sync' || action === 'merge') text += 'Synkroniser telefoner og afdeling med Myfone?';
                                    else if (action === 'create') text += "Opret brugeren som ".concat(plan.role === 'admin' ? 'administrator' : 'almindelig bruger', ", ").concat(plan.active ? 'aktiv' : 'inaktiv', "?");
                                    else {
                                        text += "".concat(plan.recordings, " optagelser og ").concat(plan.calls, " samtaleposter.\n");
                                        text += deleting ? 'Samtaler og optagelser for den tidligere bruger slettes permanent. Dette kan ikke fortrydes.\n' : "Tidligere optagelser bevares kun for admins og f\xf8lger firmaets opbevaringsperiode.\n";
                                        if ((0, (/*@__PURE__*/$parcel$interopDefault($0f601913c0a3e0d3$exports)))(action).call(action, 'replace-')) text += "Den nye bruger oprettes inaktiv uden administratorrettigheder. Aktiv\xe9r vedkommende bagefter.\n";
                                        if (action === 'update') text += "Den opdaterede bruger er ".concat(plan.active ? 'aktiv' : 'inaktiv', " uden administratorrettigheder, f\xe5r ny identitet og skal genforbinde personlige integrationer.\n");
                                        text += "Udf\xf8r handlingen?";
                                    }
                                    if (!window.confirm(text)) return [
                                        3,
                                        4
                                    ];
                                    return [
                                        4,
                                        $d27a3e42620f11b8$export$72303ec7efe50298(plan.id)
                                    ];
                                case 3:
                                    _state.sent();
                                    _state.label = 4;
                                case 4:
                                    return [
                                        3,
                                        7
                                    ];
                                case 5:
                                    error = _state.sent();
                                    $d27a3e42620f11b8$export$de026b00723010c1('error', ((_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.message) || 'Handlingen blev afbrudt. Hent listen igen eller se afbrudte handlinger under Administrer brugere.');
                                    return [
                                        3,
                                        7
                                    ];
                                case 6:
                                    button.disabled = false;
                                    return [
                                        7
                                    ];
                                case 7:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                });
                return [
                    2
                ];
            }
            if (className === 'noMyfoneHubspotMatch') {
                syncUserBtn = card.querySelector('.btn--sync-user');
                syncUserBtn.addEventListener('click', function(event) {
                    event.preventDefault();
                    (0, $103cf55905497108$export$6a420613022c2a5d)(syncUserBtn.dataset.user, card.querySelector('.sync-hubspot-user').value);
                });
            }
            return [
                2
            ];
        });
    })();
};
var $d27a3e42620f11b8$export$72303ec7efe50298 = function(id) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $00bae815612f32bf$export$2e2bcd8739ae039).post("/api/v1/users/myfone-sync/".concat(id, "/execute"))
                    ];
                case 1:
                    _state.sent();
                    window.location.reload();
                    return [
                        2
                    ];
            }
        });
    })();
};
var $d27a3e42620f11b8$export$7a6edd6200baeed7 = function(id, index) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var params, res, oldAnswerBtn, err;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    params = {
                        id: id,
                        index: index
                    };
                    return [
                        4,
                        (0, $00bae815612f32bf$export$2e2bcd8739ae039).get('/api/v1/smsMessage/getanswerform', {
                            params: params
                        })
                    ];
                case 1:
                    res = _state.sent();
                    console.log('addAnswer response: ', res);
                    if (res.status === 200) {
                        oldAnswerBtn = document.querySelector(".add-answer-".concat(id, "-").concat(index - 1));
                        oldAnswerBtn.insertAdjacentHTML('afterend', res.data);
                        oldAnswerBtn.remove();
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    console.log(err);
                    $d27a3e42620f11b8$export$de026b00723010c1('error', err.response.data.message);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};


var $dc96e9075d99b764$export$596d806903d1f59e = function(email, password) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var res, err;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0, $00bae815612f32bf$export$2e2bcd8739ae039)({
                            method: "POST",
                            url: "/api/v1/users/login",
                            data: {
                                email: email,
                                password: password
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    if (res.data.status === "success") {
                        (0, $d27a3e42620f11b8$export$de026b00723010c1)("success", "Logged in successfully!");
                        (0, (/*@__PURE__*/$parcel$interopDefault($7874bf713c9acb54$exports)))(function() {
                            location.assign("/");
                        }, 1500);
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    (0, $d27a3e42620f11b8$export$de026b00723010c1)("error", err.response.data.message);
                    if (err.response.data.message === "Forkert email eller password") document.querySelector(".forgot-password").classList.add("active");
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $dc96e9075d99b764$export$a0973bcfe11b05c9 = function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var res, err;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0, $00bae815612f32bf$export$2e2bcd8739ae039)({
                            method: "GET",
                            url: "/api/v1/users/logout"
                        })
                    ];
                case 1:
                    res = _state.sent();
                    if (res.data.status === "success") // location.reload(true); // reload true makes shure the user get the new cookie
                    location.href = "/";
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    (0, $d27a3e42620f11b8$export$de026b00723010c1)("error", "Error logging out - please try again.");
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $dc96e9075d99b764$export$66791fb2cfeec3e = function(email) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var res, err;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0, $00bae815612f32bf$export$2e2bcd8739ae039)({
                            method: "POST",
                            url: "/api/v1/users/forgotpassword",
                            data: {
                                email: email
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    if (res.data.status === "success") {
                        console.log(res.data);
                        (0, $d27a3e42620f11b8$export$de026b00723010c1)("success", res.data.message);
                        (0, (/*@__PURE__*/$parcel$interopDefault($7874bf713c9acb54$exports)))(function() {
                            location.assign("/");
                        }, 2000);
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    (0, $d27a3e42620f11b8$export$de026b00723010c1)("error", err.response.data.message);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $dc96e9075d99b764$export$185802fd694ee1f5 = function(company, user) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var resCompany, resUser, err, err1;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        6,
                        ,
                        7
                    ]);
                    return [
                        4,
                        (0, $00bae815612f32bf$export$2e2bcd8739ae039)({
                            method: "POST",
                            url: "/api/v1/companies",
                            data: company
                        })
                    ];
                case 1:
                    resCompany = _state.sent();
                    if (!(resCompany.data.status === "success")) return [
                        3,
                        5
                    ];
                    (0, $d27a3e42620f11b8$export$de026b00723010c1)("success", "".concat(resCompany.data.data.name, " er oprettet."));
                    if (!user) return [
                        3,
                        5
                    ];
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    user.companyId = resCompany.data.data.id;
                    return [
                        4,
                        (0, $00bae815612f32bf$export$2e2bcd8739ae039)({
                            method: "POST",
                            url: "/api/v1/users",
                            data: user
                        })
                    ];
                case 3:
                    resUser = _state.sent();
                    if (resUser.data.status === "success") {
                        (0, $d27a3e42620f11b8$export$de026b00723010c1)("success", "S\xe5dan.<br>Der er sendt instrukser per mail til ".concat(resUser.data.data.name));
                        (0, (/*@__PURE__*/$parcel$interopDefault($7874bf713c9acb54$exports)))(function() {
                            location.assign("/me");
                        }, 2000);
                    }
                    return [
                        3,
                        5
                    ];
                case 4:
                    err = _state.sent();
                    (0, $d27a3e42620f11b8$export$de026b00723010c1)("error", err.response.data.message);
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        3,
                        7
                    ];
                case 6:
                    err1 = _state.sent();
                    (0, $d27a3e42620f11b8$export$de026b00723010c1)("error", err1.response.data.message);
                    return [
                        3,
                        7
                    ];
                case 7:
                    return [
                        2
                    ];
            }
        });
    })();
};





var $501c1314c4933c14$var$_context0;
if (document.body.dataset.platformContext === 'admin') (0, $00bae815612f32bf$export$2e2bcd8739ae039).defaults.headers.common['X-Platform-Context'] = 'admin';
(0, $72f582fa7c15ef93$export$c86512ceef10c086)();
// DOM ELEMENTS
var $501c1314c4933c14$var$loginForm = document.querySelector(".form--login");
var $501c1314c4933c14$var$messages = document.querySelectorAll("#messages span");
var $501c1314c4933c14$var$createForm = document.querySelector(".form--create");
var $501c1314c4933c14$var$logOutBtn = document.querySelector(".nav__el--logout");
var $501c1314c4933c14$var$cards = document.querySelectorAll(".card--wrapper");
var $501c1314c4933c14$var$datePicker = document.getElementById("datepicker"); //- Datepicker https://wakirin.github.io/Litepicker/
var $501c1314c4933c14$var$phoneNumber = document.getElementById("phone-number");
var $501c1314c4933c14$var$localNumber = document.getElementById("local-number");
var $501c1314c4933c14$var$searchForm = document.querySelector(".form--search");
var $501c1314c4933c14$var$sortElements = document.querySelectorAll(".header--sort .card__data:not(.filler)");
var $501c1314c4933c14$var$pageCount = document.getElementById("page");
var $501c1314c4933c14$var$updateDataForm = document.querySelector(".form-user-data");
var $501c1314c4933c14$var$smsSettingsForm = document.querySelector(".form-user-sms-settings");
var $501c1314c4933c14$var$smsEditForm = document.querySelector(".form-sms-edit");
var $501c1314c4933c14$var$dentalsuite = document.querySelectorAll(".btn--dentalsuite-save");
var $501c1314c4933c14$var$syncHubspotUsersBtn = document.querySelector(".btn--new-hubspot-users");
var $501c1314c4933c14$var$syncHubspotBtn = document.querySelector(".btn--hubspot-sync");
var $501c1314c4933c14$var$hubspotSettings = document.querySelector(".hubspot-settings");
var $501c1314c4933c14$var$syncMyfoneUsersBtn = document.querySelector(".btn--new-myfone-users");
var $501c1314c4933c14$var$salesforceInstallBtn = document.querySelector(".btn--install-salesforce");
var $501c1314c4933c14$var$salesforceUninstallBtn = document.querySelector(".btn--uninstall-salesforce");
var $501c1314c4933c14$var$hubspotInstallBtn = document.querySelector(".btn--install-hubspot");
var $501c1314c4933c14$var$hubspotUninstallBtn = document.querySelector(".btn--hubspot-uninstall");
var $501c1314c4933c14$var$updateCompanyDataForm = document.querySelector(".form-company-data");
var $501c1314c4933c14$var$userPasswordForm = document.querySelector(".form-user-password");
var $501c1314c4933c14$var$resetPasswordForm = document.querySelector(".form-user-password--reset");
var $501c1314c4933c14$var$forgotPasswordForm = document.querySelector(".form-user-password--forgot");
var $501c1314c4933c14$var$checkEmailBtn = document.getElementById("checkEmailBtn");
var $501c1314c4933c14$var$emailInput = document.getElementById("email");
var $501c1314c4933c14$var$passwordSection = document.getElementById("passwordSection");
var $501c1314c4933c14$var$ssoSection = document.getElementById("ssoSection");
var $501c1314c4933c14$var$usePasswordBtn = document.getElementById("usePasswordBtn");
if ($501c1314c4933c14$var$checkEmailBtn) {
    $501c1314c4933c14$var$checkEmailBtn.addEventListener("click", function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var email, res, _res_data_data, ssoEnabled, enforceSSO, err;
            return (0, $iLZuz._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Tjek om e-mail er udfyldt korrekt via browserens indbyggede validering
                        if (!$501c1314c4933c14$var$emailInput.checkValidity()) {
                            $501c1314c4933c14$var$emailInput.reportValidity();
                            return [
                                2
                            ];
                        }
                        email = $501c1314c4933c14$var$emailInput.value;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        // Skift tekst på knappen imens vi venter på backend
                        $501c1314c4933c14$var$checkEmailBtn.textContent = "Tjekker...";
                        $501c1314c4933c14$var$checkEmailBtn.disabled = true;
                        return [
                            4,
                            (0, $00bae815612f32bf$export$2e2bcd8739ae039).post("/api/v1/users/check-login-method", {
                                email: email
                            })
                        ];
                    case 2:
                        res = _state.sent();
                        _res_data_data = res.data.data, ssoEnabled = _res_data_data.ssoEnabled, enforceSSO = _res_data_data.enforceSSO;
                        // Skjul "Næste" knappen uanset resultatet
                        $501c1314c4933c14$var$checkEmailBtn.style.display = "none";
                        if (ssoEnabled) {
                            // Vis Microsoft knappen
                            $501c1314c4933c14$var$ssoSection.style.display = "block";
                            // Vis kun "Brug adgangskode i stedet" hvis admin IKKE har tvunget SSO
                            if (enforceSSO) $501c1314c4933c14$var$usePasswordBtn.style.display = "none";
                            else $501c1314c4933c14$var$usePasswordBtn.style.display = "inline-block";
                        } else // Vis det almindelige adgangskode felt og log ind knap
                        $501c1314c4933c14$var$passwordSection.style.display = "block";
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        console.error("Kunne ikke tjekke login metode:", err);
                        // Fallback ved netværksfejl: Vis adgangskodefeltet så de ikke strander
                        $501c1314c4933c14$var$checkEmailBtn.style.display = "none";
                        $501c1314c4933c14$var$passwordSection.style.display = "block";
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    });
    if ($501c1314c4933c14$var$emailInput) $501c1314c4933c14$var$emailInput.addEventListener("keydown", function(e) {
        if (e.key === "Enter" && $501c1314c4933c14$var$checkEmailBtn.style.display !== "none") {
            e.preventDefault();
            $501c1314c4933c14$var$checkEmailBtn.click();
        }
    });
}
// Hvis brugeren har SSO som mulighed, men klikker på "Brug adgangskode i stedet"
if ($501c1314c4933c14$var$usePasswordBtn) $501c1314c4933c14$var$usePasswordBtn.addEventListener("click", function(e) {
    e.preventDefault();
    $501c1314c4933c14$var$ssoSection.style.display = "none";
    $501c1314c4933c14$var$passwordSection.style.display = "block";
});
// VALUES
// DELEGATION
if ($501c1314c4933c14$var$cards) {
    var $501c1314c4933c14$var$_context;
    (0, (/*@__PURE__*/$parcel$interopDefault($eb0af92fb0d106cc$exports)))($501c1314c4933c14$var$_context = (0, (/*@__PURE__*/$parcel$interopDefault($09d1114e8c0ab763$exports)))($501c1314c4933c14$var$cards)).call($501c1314c4933c14$var$_context, function(card) {
        if (document.querySelector(".users--hubspot")) card = card.querySelector(".card");
        (0, $d27a3e42620f11b8$export$4b1c754fc92202eb)((0, $d27a3e42620f11b8$export$b8c8eb070a2f16c1)(card));
    });
    if ($501c1314c4933c14$var$datePicker) (0, $d27a3e42620f11b8$export$4527fa85896780ab)($501c1314c4933c14$var$datePicker, $501c1314c4933c14$var$phoneNumber, $501c1314c4933c14$var$localNumber, $501c1314c4933c14$var$searchForm);
}
if ($501c1314c4933c14$var$loginForm) $501c1314c4933c14$var$loginForm.addEventListener("submit", function(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var email, password;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    e.preventDefault();
                    email = document.getElementById("email").value;
                    password = document.getElementById("password").value;
                    return [
                        4,
                        (0, $dc96e9075d99b764$export$596d806903d1f59e)(email, password)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
});
if ($501c1314c4933c14$var$messages) {
    var $501c1314c4933c14$var$_context2;
    (0, (/*@__PURE__*/$parcel$interopDefault($eb0af92fb0d106cc$exports)))($501c1314c4933c14$var$_context2 = (0, (/*@__PURE__*/$parcel$interopDefault($09d1114e8c0ab763$exports)))($501c1314c4933c14$var$messages)).call($501c1314c4933c14$var$_context2, function(element) {
        (0, $d27a3e42620f11b8$export$de026b00723010c1)(element.dataset.type, element.dataset.msg);
    });
}
if ($501c1314c4933c14$var$hubspotSettings) {
    var $501c1314c4933c14$var$_context3;
    var $501c1314c4933c14$var$checkBoxes = $501c1314c4933c14$var$hubspotSettings.querySelectorAll(".checkbox input");
    (0, (/*@__PURE__*/$parcel$interopDefault($eb0af92fb0d106cc$exports)))($501c1314c4933c14$var$_context3 = (0, (/*@__PURE__*/$parcel$interopDefault($09d1114e8c0ab763$exports)))($501c1314c4933c14$var$checkBoxes)).call($501c1314c4933c14$var$_context3, function(checkBox) {
        checkBox.addEventListener("click", function(e) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                var data, value;
                return (0, $iLZuz._)(this, function(_state) {
                    data = {};
                    value = checkBox.checked;
                    data[checkBox.value] = value;
                    console.log("data", data);
                    (0, $f07f35e2bd84b233$export$f558026a994b6051)(data, "firmadata");
                    return [
                        2
                    ];
                });
            })();
        });
    });
}
if ($501c1314c4933c14$var$dentalsuite) {
    var $501c1314c4933c14$var$_context4;
    (0, (/*@__PURE__*/$parcel$interopDefault($eb0af92fb0d106cc$exports)))($501c1314c4933c14$var$_context4 = (0, (/*@__PURE__*/$parcel$interopDefault($09d1114e8c0ab763$exports)))($501c1314c4933c14$var$dentalsuite)).call($501c1314c4933c14$var$_context4, function(dentalsuiteBtn) {
        // get data-department from form
        var department = dentalsuiteBtn.dataset.department;
        // keep only relevant options in phone select, based on localnumber select
        document.getElementById("localnumber-".concat(department)).addEventListener("change", function() {
            var phoneSelect = document.getElementById("phone-".concat(department));
            var options = phoneSelect.getElementsByTagName("option");
            for(var i = 0; i < options.length; i++)if (options[i].getAttribute("data-localnumber") != this.value) {
                options[i].style.display = "none";
                // if options[i] is selected, deselect it
                if (options[i].selected) options[i].selected = false;
            } else {
                options[i].style.display = "block";
                if (options[i].getAttribute("value") == "0000") // disable 0000 option
                options[i].disabled = true;
            }
        });
        dentalsuiteBtn.addEventListener("click", function(e) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                return (0, $iLZuz._)(this, function(_state) {
                    e.preventDefault();
                    // safe clinic input fields
                    (0, $f07f35e2bd84b233$export$f558026a994b6051)({
                        clinic: {
                            department: department,
                            ipAddress: document.getElementById("ipaddress-".concat(department)).value,
                            localNumber: document.getElementById("localnumber-".concat(department)).value,
                            phone: document.getElementById("phone-".concat(department)).value,
                            port: document.getElementById("port-".concat(department)).value,
                            username: document.getElementById("username-".concat(department)).value,
                            password: document.getElementById("password-".concat(department)).value
                        }
                    }, "firmadata");
                    return [
                        2
                    ];
                });
            })();
        });
    });
}
if ($501c1314c4933c14$var$searchForm) $501c1314c4933c14$var$searchForm.addEventListener("submit", function(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var phoneNumberValue, localNumberValue, page, startDate, endDate, recordings;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    e.preventDefault();
                    e.stopPropagation();
                    (0, $d27a3e42620f11b8$export$49ef59c1a7c9ec28)("on");
                    phoneNumberValue = document.getElementById("phone-number").value;
                    localNumberValue = document.getElementById("local-number").value;
                    page = document.getElementById("page").value;
                    startDate = (0, $d27a3e42620f11b8$export$20cc75d7679d6e0e).getStartDate();
                    endDate = (0, $d27a3e42620f11b8$export$20cc75d7679d6e0e).getEndDate();
                    console.log("phoneNumberValue", phoneNumberValue, "localNumberValue", localNumberValue, "startDate", startDate, "endDate", endDate, "page", page);
                    return [
                        4,
                        (0, $d27a3e42620f11b8$export$d76128d007d19019)(phoneNumberValue, localNumberValue, startDate, endDate, page)
                    ];
                case 1:
                    recordings = _state.sent();
                    (0, $d27a3e42620f11b8$export$827a6c17a85f6d1a)("recordings", recordings);
                    (0, $d27a3e42620f11b8$export$49ef59c1a7c9ec28)("off");
                    return [
                        2
                    ];
            }
        });
    })();
});
// if pageCount is on the page, we need to detect when we reach the bottom
// and then load the next batch of recordings
if ($501c1314c4933c14$var$pageCount) (0, $d27a3e42620f11b8$export$fb1a2c61837ac070)(document.getElementById("recordings-footer"), $501c1314c4933c14$var$searchForm);
if ($501c1314c4933c14$var$sortElements) {
    var $501c1314c4933c14$var$_context5;
    (0, (/*@__PURE__*/$parcel$interopDefault($eb0af92fb0d106cc$exports)))($501c1314c4933c14$var$_context5 = (0, (/*@__PURE__*/$parcel$interopDefault($09d1114e8c0ab763$exports)))($501c1314c4933c14$var$sortElements)).call($501c1314c4933c14$var$_context5, function(element) {
        element.addEventListener("click", function(e) {
            // remove all active and add active to as this if it's not allready
            // if it is, remove dash if it has it, else remove active
            e.preventDefault();
            var dSet = (0, (/*@__PURE__*/$parcel$interopDefault($3253481c11effcc0$exports)))(element.dataset);
            var dash = "-";
            if (element.classList.contains("active")) {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($0f601913c0a3e0d3$exports)))(dSet).call(dSet, dash)) {
                    dSet = dSet.substr(1);
                    dash = "";
                }
                if (element.classList.contains("asc")) element.classList.remove("asc");
                else element.classList.add("asc");
            } else {
                var _context6;
                var allElements = document.querySelectorAll(".header--sort .card__data.active");
                (0, (/*@__PURE__*/$parcel$interopDefault($eb0af92fb0d106cc$exports)))(_context6 = (0, (/*@__PURE__*/$parcel$interopDefault($09d1114e8c0ab763$exports)))(allElements)).call(_context6, function(el) {
                    var _context7;
                    el.classList.remove("active");
                    el.classList.remove("asc");
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($0f601913c0a3e0d3$exports)))(_context7 = (0, (/*@__PURE__*/$parcel$interopDefault($3253481c11effcc0$exports)))(el.dataset)).call(_context7, "-")) el.dataset.sort = (0, (/*@__PURE__*/$parcel$interopDefault($3253481c11effcc0$exports)))(el.dataset).substr(1);
                });
                element.classList.add("active");
            }
            element.dataset.sort = "".concat(dash).concat(dSet);
            // set page to 1
            document.getElementById("page").value = 1;
            // and then call submit on the searcForm
            $501c1314c4933c14$var$searchForm.dispatchEvent((0, $d27a3e42620f11b8$export$d810fd4f41d42216));
        });
    });
}
// if (signupForm) {
//   signupForm.addEventListener("submit", async (e) => {
//     e.preventDefault();
//     const name = document.getElementById("name").value;
//     const email = document.getElementById("email").value;
//     await signup(name, email);
//   });
// }
if ($501c1314c4933c14$var$createForm) $501c1314c4933c14$var$createForm.addEventListener("submit", function(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var user, name, email, company, keepRecordings, recordings;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    e.preventDefault();
                    user = false;
                    if (!document.getElementById("company-only").checked) {
                        name = document.getElementById("name").value;
                        email = document.getElementById("email").value;
                        user = {
                            name: name,
                            email: email
                        };
                    }
                    company = new FormData();
                    company.append("name", document.getElementById("company-name").value);
                    company.append("email", document.getElementById("company-email").value);
                    company.append("address", document.getElementById("company-address").value);
                    company.append("zip", document.getElementById("company-zip").value);
                    company.append("city", document.getElementById("company-city").value);
                    if (document.getElementById("keep-recordings")) {
                        keepRecordings = document.getElementById("keep-recordings").checked;
                        if (keepRecordings) {
                            recordings = (0, (/*@__PURE__*/$parcel$interopDefault($f6a213ca3eebef7b$exports)))({
                                deleteAfter: document.getElementById("delete-after").value,
                                keepRecordings: keepRecordings ? "yes" : "no"
                            });
                            company.append("recordings", recordings);
                        }
                    }
                    company.append("logo", document.getElementById("logo").files[0]);
                    if (document.getElementById("pbxId")) {
                        company.append("pbxId", document.getElementById("pbxId").value);
                        company.append("flexfoneApiKey", document.getElementById("flexfoneApiKey").value);
                    }
                    return [
                        4,
                        (0, $dc96e9075d99b764$export$185802fd694ee1f5)(company, user)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
});
if ($501c1314c4933c14$var$logOutBtn) $501c1314c4933c14$var$logOutBtn.addEventListener("click", (0, $dc96e9075d99b764$export$a0973bcfe11b05c9));
if ($501c1314c4933c14$var$updateDataForm) $501c1314c4933c14$var$updateDataForm.addEventListener("submit", function(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var form;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    e.preventDefault();
                    form = new FormData();
                    form.append("name", document.getElementById("name").value);
                    form.append("email", document.getElementById("email").value);
                    form.append("photo", document.getElementById("photo").files[0]);
                    return [
                        4,
                        (0, $f07f35e2bd84b233$export$f558026a994b6051)(form, "brugerdata")
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
});
if ($501c1314c4933c14$var$updateCompanyDataForm) $501c1314c4933c14$var$updateCompanyDataForm.addEventListener("submit", function(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var form, keepRecordings, recordings;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    e.preventDefault();
                    form = new FormData();
                    form.append("name", document.getElementById("company-name").value);
                    form.append("email", document.getElementById("company-email").value);
                    form.append("logo", document.getElementById("logo").files[0]);
                    keepRecordings = document.getElementById("keep-recordings").value;
                    if (keepRecordings !== "no") {
                        recordings = (0, (/*@__PURE__*/$parcel$interopDefault($f6a213ca3eebef7b$exports)))({
                            deleteAfter: document.getElementById("delete-after").value,
                            keepRecordings: keepRecordings
                        });
                        form.append("recordings", recordings);
                    }
                    form.append("expireCallsAfter", document.getElementById("calls-expires-after").value);
                    form.append("jwtCookieExpiresIn", document.getElementById("cookie-expires-in").value);
                    form.append("jwtExpiresIn", "".concat(document.getElementById("cookie-expires-in").value, "d"));
                    return [
                        4,
                        (0, $f07f35e2bd84b233$export$f558026a994b6051)(form, "firmadata")
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
});
// Standalone Microsoft SSO settings handlers (outside of forms)
var $501c1314c4933c14$var$activateSsoBtn = document.getElementById("activateSsoBtn");
if ($501c1314c4933c14$var$activateSsoBtn) $501c1314c4933c14$var$activateSsoBtn.addEventListener("click", function() {
    window.location.assign("/api/v1/users/auth/microsoft/admin-setup");
});
var $501c1314c4933c14$var$toggleEnforceBtn = document.getElementById("toggleEnforceBtn");
if ($501c1314c4933c14$var$toggleEnforceBtn) $501c1314c4933c14$var$toggleEnforceBtn.addEventListener("click", function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $f07f35e2bd84b233$export$9cccb11c9f863cbb)()
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
});
var $501c1314c4933c14$var$disconnectSsoBtn = document.getElementById("disconnectSsoBtn");
if ($501c1314c4933c14$var$disconnectSsoBtn) $501c1314c4933c14$var$disconnectSsoBtn.addEventListener("click", function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!confirm("Er du sikker? SSO sl\xe5s fra, og alle medarbejdere logges ud. De skal logge ind igen med adgangskode.")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0, $f07f35e2bd84b233$export$d65c7973c6998f41)()
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    })();
});
// Show alert from URL parameters if redirected with ?success= or ?error=
var $501c1314c4933c14$var$urlParams = new (0, (/*@__PURE__*/$parcel$interopDefault($168312580b27ea53$exports)))(window.location.search);
if ($501c1314c4933c14$var$urlParams.has("success")) (0, $d27a3e42620f11b8$export$de026b00723010c1)("success", $501c1314c4933c14$var$urlParams.get("success"));
if ($501c1314c4933c14$var$urlParams.has("error")) (0, $d27a3e42620f11b8$export$de026b00723010c1)("error", $501c1314c4933c14$var$urlParams.get("error"));
if ($501c1314c4933c14$var$smsSettingsForm) $501c1314c4933c14$var$smsSettingsForm.addEventListener("submit", function(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var form, sms;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    e.preventDefault();
                    form = new FormData();
                    sms = (0, (/*@__PURE__*/$parcel$interopDefault($f6a213ca3eebef7b$exports)))({
                        sender: document.getElementById("sender").value,
                        class: document.getElementById("sms-class").value,
                        deleteAfter: document.getElementById("delete-sms-after").value
                    });
                    form.append("sms", sms);
                    return [
                        4,
                        (0, $f07f35e2bd84b233$export$f558026a994b6051)(form, "firmadata")
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
});
if ($501c1314c4933c14$var$smsEditForm) {
    var $501c1314c4933c14$var$_context8, $501c1314c4933c14$var$_context9;
    // tastevalg, tovejsSms, "send sms ved dette svar" og error-reply skal toggle hidden ved click
    var $501c1314c4933c14$var$togglers = $501c1314c4933c14$var$smsEditForm.querySelectorAll("[id^='ivrchoice-'], [id^='twowaysms-'], [id^='reply-'], [id^='add-errorreply-']");
    (0, (/*@__PURE__*/$parcel$interopDefault($eb0af92fb0d106cc$exports)))($501c1314c4933c14$var$_context8 = (0, (/*@__PURE__*/$parcel$interopDefault($09d1114e8c0ab763$exports)))($501c1314c4933c14$var$togglers)).call($501c1314c4933c14$var$_context8, function(element) {
        element.addEventListener("click", function(e) {
            (0, $d27a3e42620f11b8$export$e03c1c3201ee8bb7)(element.closest(".form__group").nextElementSibling);
        });
    });
    var $501c1314c4933c14$var$addAnswerBtns = $501c1314c4933c14$var$smsEditForm.querySelectorAll("[class^='add-answer-'");
    (0, (/*@__PURE__*/$parcel$interopDefault($eb0af92fb0d106cc$exports)))($501c1314c4933c14$var$_context9 = (0, (/*@__PURE__*/$parcel$interopDefault($09d1114e8c0ab763$exports)))($501c1314c4933c14$var$addAnswerBtns)).call($501c1314c4933c14$var$_context9, function(answerBtn) {
        var index = +answerBtn.dataset.index + 1;
        answerBtn.addEventListener("click", function(e) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                return (0, $iLZuz._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            e.preventDefault();
                            return [
                                4,
                                (0, $d27a3e42620f11b8$export$7a6edd6200baeed7)(answerBtn.dataset.smsid, index)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })();
        });
    });
    $501c1314c4933c14$var$smsEditForm.addEventListener("submit", function(e) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var id, parent, sender;
            return (0, $iLZuz._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        id = e.submitter.dataset.id;
                        parent = document.getElementById("parent-".concat(id)).value;
                        sender = document.querySelector("[id^='sender-']").value;
                        if (sender == "alpha") sender = {
                            alphaOrShort: "alpha"
                        };
                        else sender = {
                            alphaOrShort: "short",
                            index: sender
                        };
                        console.log(id, parent, sender);
                        return [
                            4,
                            (0, $d27a3e42620f11b8$export$ce7c2a3613458a89)(id, sender, parent)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    });
}
if ($501c1314c4933c14$var$userPasswordForm) $501c1314c4933c14$var$userPasswordForm.addEventListener("submit", function(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var passwordCurrent, password, passwordConfirm;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    e.preventDefault();
                    document.querySelector(".btn--save-password").textContent = "Updating...";
                    passwordCurrent = document.getElementById("password-current").value;
                    password = document.getElementById("password").value;
                    passwordConfirm = document.getElementById("password-confirm").value;
                    return [
                        4,
                        (0, $f07f35e2bd84b233$export$f558026a994b6051)({
                            passwordCurrent: passwordCurrent,
                            password: password,
                            passwordConfirm: passwordConfirm
                        }, "password")
                    ];
                case 1:
                    _state.sent();
                    document.getElementById("password-current").value = "";
                    document.getElementById("password").value = "";
                    document.getElementById("password-confirm").value = "";
                    document.querySelector(".btn--save-password").textContent = "Save password";
                    return [
                        2
                    ];
            }
        });
    })();
});
if ($501c1314c4933c14$var$resetPasswordForm) $501c1314c4933c14$var$resetPasswordForm.addEventListener("submit", function(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var password, passwordConfirm, token;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    e.preventDefault();
                    document.querySelector(".btn--save-password").textContent = "Opdaterer...";
                    password = document.getElementById("password").value;
                    passwordConfirm = document.getElementById("password-confirm").value;
                    token = document.getElementById("token").value;
                    return [
                        4,
                        (0, $f07f35e2bd84b233$export$dc726c8e334dd814)({
                            password: password,
                            passwordConfirm: passwordConfirm
                        }, token)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
});
if ($501c1314c4933c14$var$forgotPasswordForm) $501c1314c4933c14$var$forgotPasswordForm.addEventListener("submit", function(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var email;
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    e.preventDefault();
                    email = document.getElementById("email").value;
                    return [
                        4,
                        (0, $dc96e9075d99b764$export$66791fb2cfeec3e)(email)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
});
if ($501c1314c4933c14$var$syncMyfoneUsersBtn) $501c1314c4933c14$var$syncMyfoneUsersBtn.addEventListener("click", function(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        return (0, $iLZuz._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    e.preventDefault();
                    return [
                        4,
                        (0, $d27a3e42620f11b8$export$9918b9617a5ef559)()
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
});
if ($501c1314c4933c14$var$salesforceInstallBtn) $501c1314c4933c14$var$salesforceInstallBtn.addEventListener("click", function(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        return (0, $iLZuz._)(this, function(_state) {
            e.preventDefault();
            location.assign("/salesforce/install");
            return [
                2
            ];
        });
    })();
});
if ($501c1314c4933c14$var$salesforceUninstallBtn) $501c1314c4933c14$var$salesforceUninstallBtn.addEventListener("click", function(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        return (0, $iLZuz._)(this, function(_state) {
            e.preventDefault();
            location.assign("/salesforce/uninstall");
            return [
                2
            ];
        });
    })();
});
if ($501c1314c4933c14$var$hubspotInstallBtn) $501c1314c4933c14$var$hubspotInstallBtn.addEventListener("click", function(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        return (0, $iLZuz._)(this, function(_state) {
            e.preventDefault();
            location.assign("/hubspot/install");
            return [
                2
            ];
        });
    })();
});
if ($501c1314c4933c14$var$syncHubspotUsersBtn) $501c1314c4933c14$var$syncHubspotUsersBtn.addEventListener("click", function(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        return (0, $iLZuz._)(this, function(_state) {
            e.preventDefault();
            location.assign("/hubspot/sync/owners");
            return [
                2
            ];
        });
    })();
});
if ($501c1314c4933c14$var$syncHubspotBtn) $501c1314c4933c14$var$syncHubspotBtn.addEventListener("click", function(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        return (0, $iLZuz._)(this, function(_state) {
            e.preventDefault();
            location.assign("/hubspot/sync");
            return [
                2
            ];
        });
    })();
});
if ($501c1314c4933c14$var$hubspotUninstallBtn) $501c1314c4933c14$var$hubspotUninstallBtn.addEventListener("click", function(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        return (0, $iLZuz._)(this, function(_state) {
            e.preventDefault();
            location.assign("/hubspot/uninstall");
            return [
                2
            ];
        });
    })();
});
// Failed retirements preserve their exact operation and can be safely resumed.
(0, (/*@__PURE__*/$parcel$interopDefault($eb0af92fb0d106cc$exports)))($501c1314c4933c14$var$_context0 = document.querySelectorAll('[data-resume-myfone]')).call($501c1314c4933c14$var$_context0, function(button) {
    button.addEventListener('click', function(event) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var error, _error_response_data, _error_response;
            return (0, $iLZuz._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        if (!window.confirm("Genoptag den tidligere bekr\xe6ftede bruger\xe6ndring? Eventuel permanent sletning forts\xe6tter.")) return [
                            2
                        ];
                        button.disabled = true;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0, $d27a3e42620f11b8$export$72303ec7efe50298)(button.dataset.resumeMyfone)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        (0, $d27a3e42620f11b8$export$de026b00723010c1)('error', ((_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.message) || "Handlingen kunne ikke genoptages. Pr\xf8v igen senere.");
                        button.disabled = false;
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    });
});

})();
//# sourceMappingURL=index.js.map
